const programs = [
    {
        "id":1,
        "name":"None \/ Not Specified (In The Case That New Students Have Not Yet Chosen A Field Of Study) | ไม่มี \/ ไม่ระบุ (ในกรณีที่นักศึกษาเข้าใหม่ยังไม่ได้เลือกสาขาวิชา) | 无\/未指定（新生尚未选择学习领域的情况）"
    },
    {
        "id":2,
        "name":"1 (Thai Program)  :  Law | กฎหมาย | 法律"
    },
    {
        "id":3,
        "name":"2 (Thai Program)  :  Land And Property Law | กฎหมายการที่ดินและทรัพย์สิน | 土地和财产法"
    },
    {
        "id":4,
        "name":"3 (Thai Program)  :  Intellectual Property Law, International Business And Arbitration | กฎหมายทรัพย์สินทางปัญญาธุรกิจการค้าระหว่างประเทศและอนุญาโตตุลาการ | 知识产权法、国际商务和仲裁"
    },
    {
        "id":5,
        "name":"4 (Thai Program)  :  Business Law | กฎหมายธุรกิจ | 商业法"
    },
    {
        "id":6,
        "name":"5 (Thai Program)  :  International Business Law | กฎหมายธุรกิจระหว่างประเทศ | 国际商法"
    },
    {
        "id":7,
        "name":"6 (Thai Program)  :  Public Law | กฎหมายมหาชน | 公法"
    },
    {
        "id":8,
        "name":"7 (Thai Program)  :  International Law | กฎหมายระหว่างประเทศ | 国际法"
    },
    {
        "id":9,
        "name":"8 (Thai Program)  :  Criminal Law | กฎหมายอาญา | 刑法"
    },
    {
        "id":10,
        "name":"9 (Thai Program)  :  Islamic Law | กฎหมายอิสลาม | 伊斯兰教法"
    },
    {
        "id":11,
        "name":"10 (Thai Program)  :  Economic Law | กฎหมายเศรษฐกิจ | 经济法"
    },
    {
        "id":12,
        "name":"11 (Thai Program)  :  Private Law | กฎหมายเอกชน | 私法"
    },
    {
        "id":13,
        "name":"12 (Thai Program)  :  With Tourism | กับการท่องเที่ยว | 与旅游业"
    },
    {
        "id":14,
        "name":"13 (English Program)  :  Business | ธุรกิจ | 商业"
    },
    {
        "id":15,
        "name":"14 (Thai Program)  :  Physical Therapy | กายภาพบำบัด | 物理治疗"
    },
    {
        "id":16,
        "name":"15 (Thai Program)  :  Physical Therapy Clinic | กายภาพบำบัดคลินิก | 物理治疗诊所"
    },
    {
        "id":17,
        "name":"16 (Thai Program)  :  Physical Therapy With Manipulation, Bending, And Pulling | กายภาพบำบัดด้วยการจัด ดัด ดึง | 物理治疗包括操纵、弯曲和拉扯"
    },
    {
        "id":18,
        "name":"17 (Thai Program)  :  Anatomy | กายวิภาคศาสตร์ | 解剖学"
    },
    {
        "id":19,
        "name":"18 (Thai Program)  :  Veterinary Anatomy | กายวิภาคศาสตร์ทางสัตวแพทย์ | 兽医解剖学"
    },
    {
        "id":20,
        "name":"19 (Thai Program)  :  Prosthetics | กายอุปกรณ์ | 假肢"
    },
    {
        "id":21,
        "name":"20 (Thai Program)  :  Broadcasting | การกระจายเสียง | 广播"
    },
    {
        "id":22,
        "name":"21 (Thai Program)  :  Public Health Consumer Protection | การคุ้มครองผู้บริโภคด้านสาธารณสุข | 公共卫生消费者保护"
    },
    {
        "id":23,
        "name":"22 (Thai Program)  :  Health Consumer Protection | การคุ้มครองผู้บริโภคด้านสุขภาพ | 健康消费者保护"
    },
    {
        "id":24,
        "name":"23 (Thai Program)  :  Public Health Consumer Protection | การคุ้มครองผู้บริโภคทางสาธารณสุข | 公共卫生消费者保护"
    },
    {
        "id":25,
        "name":"24 (Thai Program)  :  Management | การจัดการ | 管理"
    },
    {
        "id":26,
        "name":"25 (Thai Program)  :  Air Freight Management | การจัดการการขนส่งสินค้าทางอากาศ | 空运管理"
    },
    {
        "id":27,
        "name":"26 (Thai Program)  :  Transportation And Logistics Management | การจัดการการขนส่งและโลจิสติกส์ | 运输与物流管理"
    },
    {
        "id":28,
        "name":"27 (Thai Program)  :  Marketing Management | การจัดการการตลาด | 营销管理"
    },
    {
        "id":29,
        "name":"28 (Thai Program)  :  Tourism Management | การจัดการการท่องเที่ยว | 旅游管理"
    },
    {
        "id":30,
        "name":"29 (Thai Program)  :  Tourism Management For Environmental Conservation | การจัดการการท่องเที่ยวเพื่ออนุรักษ์สิ่งแวดล้อม | 环境保护的旅游管理"
    },
    {
        "id":31,
        "name":"30 (Thai Program)  :  Tourism And Hospitality Management | การจัดการการท่องเที่ยวและการโรงแรม | 旅游和酒店管理"
    },
    {
        "id":32,
        "name":"31 (Thai Program)  :  Production Management | การจัดการการผลิต | 生产管理"
    },
    {
        "id":33,
        "name":"32 (Thai Program)  :  Crop Production Management | การจัดการการผลิตพืช | 农作物生产管理"
    },
    {
        "id":34,
        "name":"33 (Thai Program)  :  Animal Production Management | การจัดการการผลิตสัตว์ | 畜牧生产管理"
    },
    {
        "id":35,
        "name":"34 (Thai Program)  :  Rural Development Management | การจัดการการพัฒนาชนบท | 农村发展管理"
    },
    {
        "id":36,
        "name":"35 (Thai Program)  :  Social Development Management | การจัดการการพัฒนาสังคม | 社会发展管理"
    },
    {
        "id":37,
        "name":"36 (Thai Program)  :  Hotel And Tourism Management | การจัดการการโรงแรมและการท่องเที่ยว | 酒店及旅游管理"
    },
    {
        "id":38,
        "name":"37 (Thai Program)  :  International Shipping Management | การจัดการขนส่งระหว่างประเทศ | 国际航运管理"
    },
    {
        "id":39,
        "name":"38 (Thai Program)  :  Quality Management | การจัดการคุณภาพ | 质量管理"
    },
    {
        "id":40,
        "name":"39 (Thai Program)  :  Construction Management | การจัดการงานก่อสร้าง | 施工管理"
    },
    {
        "id":41,
        "name":"40 (Thai Program)  :  Public Works Management | การจัดการงานสาธารณะ | 公共工程管理"
    },
    {
        "id":42,
        "name":"41 (Thai Program)  :  Archives And Document Management | การจัดการจดหมายเหตุและเอกสาร | 档案和文件管理"
    },
    {
        "id":43,
        "name":"42 (Thai Program)  :  Aeronautics Science | วิทยาการการบิน | 航空科学"
    },
    {
        "id":44,
        "name":"43 (Thai Program)  :  Community Management | การจัดการชุมชน | 社区管理"
    },
    {
        "id":45,
        "name":"44 (Thai Program)  :  Production And Operations Management | การจัดการด้านการผลิตและดำเนินงาน | 生产运营管理"
    },
    {
        "id":46,
        "name":"45 (Thai Program)  :  Market Management | การจัดการตลาด | 市场管理"
    },
    {
        "id":47,
        "name":"46 (Thai Program)  :  Resource Management | การจัดการทรัพยากร | 资源管理"
    },
    {
        "id":48,
        "name":"47 (Thai Program)  :  Agricultural And Environmental Resource Management | การจัดการทรัพยากรการเกษตรและสิ่งแวดล้อม | 农业和环境资源管理"
    },
    {
        "id":49,
        "name":"48 (Thai Program)  :  Biological Resource Management | การจัดการทรัพยากรชีวภาพ | 生物资源管理"
    },
    {
        "id":50,
        "name":"49 (Thai Program)  :  Soil Resource Management | การจัดการทรัพยากรดิน | 土壤资源管理"
    },
    {
        "id":51,
        "name":"50 (English Program)  :  Business Administration | บริหารธุรกิจ | 商业管理"
    },
    {
        "id":52,
        "name":"51 (English Program)  :  Business Computer | คอมพิวเตอร์ธุรกิจ | 商用电脑"
    },
    {
        "id":53,
        "name":"52 (Thai Program)  :  Forest Resource Management | การจัดการทรัพยากรป่าไม้ | 森林资源管理"
    },
    {
        "id":54,
        "name":"53 (Thai Program)  :  Human Resource Management | การจัดการทรัพยากรมนุษย์ | 人力资源管理"
    },
    {
        "id":55,
        "name":"54 (Thai Program)  :  General Management | การจัดการทั่วไป | 综合管理"
    },
    {
        "id":56,
        "name":"55 (Thai Program)  :  Sports Management | การจัดการทางการกีฬา | 体育管理"
    },
    {
        "id":57,
        "name":"56 (Thai Program)  :  Cultural Management | การจัดการทางวัฒนธรรม | 文化管理"
    },
    {
        "id":58,
        "name":"57 (Thai Program)  :  Engineering Management | การจัดการทางวิศวกรรม | 工程管理"
    },
    {
        "id":59,
        "name":"58 (Thai Program)  :  Tourism Management | การจัดการท่องเที่ยว | 旅游管理"
    },
    {
        "id":60,
        "name":"59 (Thai Program)  :  Airport Management | การจัดการท่าอากาศยาน | 机场管理"
    },
    {
        "id":61,
        "name":"60 (Thai Program)  :  Business Management | การจัดการธุรกิจ | 企业管理"
    },
    {
        "id":62,
        "name":"61 (Thai Program)  :  Tourism Business Management | การจัดการธุรกิจการท่องเที่ยว | 旅游企业管理"
    },
    {
        "id":63,
        "name":"62 (Thai Program)  :  General Business Management | การจัดการธุรกิจทั่วไป | 一般企业管理"
    },
    {
        "id":64,
        "name":"63 (English Program)  :  Business Data Analysis | การวิเคราะห์ข้อมูลธุรกิจ | 商业数据分析"
    },
    {
        "id":65,
        "name":"64 (Thai Program)  :  International Business Management | การจัดการธุรกิจระหว่างประเทศ | 国际商业管理"
    },
    {
        "id":66,
        "name":"65 (Thai Program)  :  Agribusiness And Food Industry Management | การจัดการธุรกิจเกษตรและอุตสาหกรรมอาหาร | 农业企业和食品工业管理"
    },
    {
        "id":67,
        "name":"66 (Thai Program)  :  Recreation Management | การจัดการนันทนาการ | 康乐管理"
    },
    {
        "id":68,
        "name":"67 (Thai Program)  :  Fisheries Management | การจัดการประมง | 渔业管理"
    },
    {
        "id":69,
        "name":"68 (English Program)  :  Business Information System | ระบบสารสนเทศทางธุรกิจ | 商业信息系统"
    },
    {
        "id":70,
        "name":"69 (Thai Program)  :  Forest Management | การจัดการป่าไม้ | 森林管理"
    },
    {
        "id":71,
        "name":"70 (Thai Program)  :  Health Product Management | การจัดการผลิตภัณฑ์สุขภาพ | 保健品管理"
    },
    {
        "id":72,
        "name":"71 (Thai Program)  :  City ​​Planning Management | การจัดการผังเมือง | 城市规划管理"
    },
    {
        "id":73,
        "name":"72 (English Program)  :  Business Information Technology | เทคโนโลยีสารสนเทศทางธุรกิจ | 商业信息技术"
    },
    {
        "id":74,
        "name":"73 (Thai Program)  :  Managing Humans And The Environment | การจัดการมนุษย์กับสิ่งแวดล้อม | 管理人类和环境"
    },
    {
        "id":75,
        "name":"74 (Thai Program)  :  Architectural Heritage Management | การจัดการมรดกทางสถาปัตยกรรม | 建筑遗产管理"
    },
    {
        "id":76,
        "name":"75 (Thai Program)  :  Architectural Heritage Management And Tourism | การจัดการมรดกทางสถาปัตยกรรมกับการท่องเที่ยว | 建筑遗产管理和旅游"
    },
    {
        "id":77,
        "name":"76 (Thai Program)  :  Information System Management | การจัดการระบบสารสนเทศ | 信息系统管理"
    },
    {
        "id":78,
        "name":"77 (Thai Program)  :  Basin Management | การจัดการลุ่มน้ำ | 流域管理"
    },
    {
        "id":79,
        "name":"78 (Thai Program)  :  Pest Management | การจัดการศัตรูพืช | 害虫管理"
    },
    {
        "id":80,
        "name":"79 (Thai Program)  :  Information Management | การจัดการสารสนเทศ | 信息管理"
    },
    {
        "id":81,
        "name":"80 (Thai Program)  :  Environmental Information And Resource Management | การจัดการสารสนเทศสิ่งแวดล้อมและทรัพยากร | 环境信息和资源管理"
    },
    {
        "id":82,
        "name":"81 (Thai Program)  :  Office Management | การจัดการสำนักงาน | 办公室管理"
    },
    {
        "id":83,
        "name":"82 (Thai Program)  :  Management For Executives | การจัดการสำหรับนักบริหาร | 高管管理"
    },
    {
        "id":84,
        "name":"83 (Thai Program)  :  Environmental Management | การจัดการสิ่งแวดล้อม | 环境管理"
    },
    {
        "id":85,
        "name":"84 (Thai Program)  :  Horticultural Environmental Management | การจัดการสิ่งแวดล้อมพืชสวน | 园艺环境管理"
    },
    {
        "id":86,
        "name":"85 (Thai Program)  :  Industrial Environmental Management | การจัดการสิ่งแวดล้อมอุตสาหกรรม | 工业环境管理"
    },
    {
        "id":87,
        "name":"86 (Thai Program)  :  Organizational And Human Resource Management | การจัดการองค์การและทรัพยากรมนุษย์ | 组织和人力资源管理"
    },
    {
        "id":88,
        "name":"87 (Thai Program)  :  Training Management | การจัดการอบรม | 培训管理"
    },
    {
        "id":89,
        "name":"88 (Thai Program)  :  Higher Education Management | การจัดการอุดมศึกษา | 高等教育管理"
    },
    {
        "id":90,
        "name":"89 (Thai Program)  :  Industrial Management | การจัดการอุตสาหกรรม | 工业管理"
    },
    {
        "id":91,
        "name":"90 (Thai Program)  :  Tourism Industry Management | การจัดการอุตสาหกรรมการท่องเที่ยว | 旅游产业管理"
    },
    {
        "id":92,
        "name":"91 (Thai Program)  :  Textile Industry Management | การจัดการอุตสาหกรรมสิ่งทอ | 纺织行业管理"
    },
    {
        "id":93,
        "name":"92 (Thai Program)  :  Agricultural Industry Management | การจัดการอุตสาหกรรมเกษตร | 农业产业管理"
    },
    {
        "id":94,
        "name":"93 (English Program)  :  Business Management | การจัดการธุรกิจ | 企业管理"
    },
    {
        "id":95,
        "name":"94 (English Program)  :  Ceramic Technology | เทคโนโลยีเซรามิก | 陶瓷技术"
    },
    {
        "id":96,
        "name":"95 (English Program)  :  Ceramics | เซรามิกส์ | 陶瓷"
    },
    {
        "id":97,
        "name":"96 (Thai Program)  :  Agro-Industrial Technology Management | การจัดการเทคโนโลยีอุตสาหกรรมเกษตร | 农产品加工业技术管理"
    },
    {
        "id":98,
        "name":"97 (Thai Program)  :  Learning Management | การจัดการเรียนรู้ | 学习管理"
    },
    {
        "id":99,
        "name":"98 (English Program)  :  Chemical Biology | ชีววิทยาเคมี | 化学生物学"
    },
    {
        "id":100,
        "name":"99 (Thai Program)  :  International Hotel And Tourism Management | การจัดการโรงแรมและการท่องเที่ยวนานาชาติ | 国际酒店及旅游管理"
    },
    {
        "id":101,
        "name":"100 (Thai Program)  :  Hotel And Tourism Management | การจัดการโรงแรมและท่องเที่ยว | 酒店及旅游管理"
    },
    {
        "id":102,
        "name":"101 (Thai Program)  :  Marketing | การตลาด | 营销"
    },
    {
        "id":103,
        "name":"102 (English Program)  :  Chemical Engineering | วิศวกรรมเคมี | 化工"
    },
    {
        "id":104,
        "name":"103 (Thai Program)  :  Electronic Marketing | การตลาดอิเล็กทรอนิกส์ | 电子营销"
    },
    {
        "id":105,
        "name":"104 (Thai Program)  :  Costing | การต้นทุน | 成本核算"
    },
    {
        "id":106,
        "name":"105 (Thai Program)  :  Photography | การถ่ายภาพ | 摄影"
    },
    {
        "id":107,
        "name":"106 (Thai Program)  :  Educational Testing And Measurement | การทดสอบและวัดผลการศึกษา | 教育测试和测量"
    },
    {
        "id":108,
        "name":"107 (Thai Program)  :  Travel | การท่องเที่ยว | 旅行"
    },
    {
        "id":109,
        "name":"108 (Thai Program)  :  Ecotourism And Service Sector Management | การท่องเที่ยวเชิงอนุรักษ์และการจัดการภาคบริการ | 生态旅游和服务业管理"
    },
    {
        "id":110,
        "name":"109 (Thai Program)  :  Tourism And Hotels | การท่องเที่ยวและโรงแรม | 旅游和酒店"
    },
    {
        "id":111,
        "name":"110 (Thai Program)  :  Banking And Finance | การธนาคารและการเงิน | 银行与金融"
    },
    {
        "id":112,
        "name":"111 (Thai Program)  :  Pharmaceutical Care | การบริบาลทางเภสัชกรรม | 药学服务"
    },
    {
        "id":113,
        "name":"112 (Thai Program)  :  International Transport Administration | การบริหารการขนส่งระหว่างประเทศ | 国际运输管理局"
    },
    {
        "id":114,
        "name":"113 (English Program)  :  Chemical Technology | เทคโนโลยีเคมี | 化学技术"
    },
    {
        "id":115,
        "name":"114 (Thai Program)  :  Operations Management | การบริหารการปฏิบัติการ | 运营管理"
    },
    {
        "id":116,
        "name":"115 (Thai Program)  :  Nursing Administration | การบริหารการพยาบาล | 护理管理"
    },
    {
        "id":117,
        "name":"116 (Thai Program)  :  Development Management | การบริหารการพัฒนา | 开发管理"
    },
    {
        "id":118,
        "name":"117 (Thai Program)  :  Educational Administration | การบริหารการศึกษา | 教育行政"
    },
    {
        "id":119,
        "name":"118 (English Program)  :  Civil Technology | เทคโนโลยีโยธา | 民用技术"
    },
    {
        "id":120,
        "name":"119 (English Program)  :  Clinical Epidemiology | ระบาดวิทยาทางคลินิก | 临床流行病学"
    },
    {
        "id":121,
        "name":"120 (Thai Program)  :  Financial Management | การบริหารการเงิน | 财务管理"
    },
    {
        "id":122,
        "name":"121 (Thai Program)  :  Financial And Fiscal Management | การบริหารการเงินและการคลัง | 财务及财政管理"
    },
    {
        "id":123,
        "name":"122 (Thai Program)  :  Management Of Cultural Activities | การบริหารกิจกรรมด้านวัฒนธรรม | 文化活动管理"
    },
    {
        "id":124,
        "name":"123 (Thai Program)  :  Construction Management | การบริหารงานก่อสร้าง | 施工管理"
    },
    {
        "id":125,
        "name":"124 (Thai Program)  :  Treasury Management | การบริหารงานคลัง | 资金管理"
    },
    {
        "id":126,
        "name":"125 (English Program)  :  Communication Arts | ศิลปะการสื่อสาร | 传播艺术"
    },
    {
        "id":127,
        "name":"126 (Thai Program)  :  Personnel Management | การบริหารงานบุคคล | 人事管理"
    },
    {
        "id":128,
        "name":"127 (Thai Program)  :  Community Development Administration | การบริหารงานพัฒนาชุมชน | 社区发展管理"
    },
    {
        "id":129,
        "name":"128 (English Program)  :  Communication Design | การออกแบบการสื่อสาร | 通讯设计"
    },
    {
        "id":130,
        "name":"129 (Thai Program)  :  Administration Of Justice | การบริหารงานยุติธรรม | 司法行政"
    },
    {
        "id":131,
        "name":"130 (Thai Program)  :  Cultural Administration | การบริหารงานวัฒนธรรม | 文化行政"
    },
    {
        "id":132,
        "name":"131 (Thai Program)  :  Engineering Administration | การบริหารงานวิศวกรรม | 工程管理"
    },
    {
        "id":133,
        "name":"132 (Thai Program)  :  Cooperative Administration | การบริหารงานสหกรณ์ | 合作管理"
    },
    {
        "id":134,
        "name":"133 (Thai Program)  :  Sports Management | การบริหารจัดการกีฬา | 体育管理"
    },
    {
        "id":135,
        "name":"134 (Thai Program)  :  Educational Management | การบริหารจัดการด้านการศึกษา | 教育管理"
    },
    {
        "id":136,
        "name":"135 (Thai Program)  :  Forest Resource Management | การบริหารทรัพยากรป่าไม้ | 森林资源管理"
    },
    {
        "id":137,
        "name":"136 (Thai Program)  :  Human Resource Management | การบริหารทรัพยากรมนุษย์ | 人力资源管理"
    },
    {
        "id":138,
        "name":"137 (Thai Program)  :  Human Resource And Organizational Management | การบริหารทรัพยากรมนุษย์และองค์การ | 人力资源和组织管理"
    },
    {
        "id":139,
        "name":"138 (English Program)  :  Community Development | การพัฒนาชุมชน | 社区发展"
    },
    {
        "id":140,
        "name":"139 (Thai Program)  :  General Administration | การบริหารทั่วไป | 一般行政管理"
    },
    {
        "id":141,
        "name":"140 (Thai Program)  :  Local Administration | การบริหารท้องถิ่น | 地方行政部门"
    },
    {
        "id":142,
        "name":"141 (English Program)  :  Community Development Administration | การบริหารการพัฒนาชุมชน | 社区发展管理"
    },
    {
        "id":143,
        "name":"142 (Thai Program)  :  International Business Administration | การบริหารธุรกิจระหว่างประเทศ | 国际工商管理"
    },
    {
        "id":144,
        "name":"143 (Thai Program)  :  Agricultural Business Administration | การบริหารธุรกิจเกษตร | 农业工商管理"
    },
    {
        "id":145,
        "name":"144 (Thai Program)  :  Health Service Administration | การบริหารบริการสุขภาพ | 卫生服务管理"
    },
    {
        "id":146,
        "name":"145 (Thai Program)  :  Public Administration | การบริหารรัฐกิจ | 公共行政"
    },
    {
        "id":147,
        "name":"146 (Thai Program)  :  Public Health Administration | การบริหารสาธารณสุข | 公共卫生管理"
    },
    {
        "id":148,
        "name":"147 (English Program)  :  Community Health | สุขภาพชุมชน | 社区健康"
    },
    {
        "id":149,
        "name":"148 (Thai Program)  :  Primary Health Care Administration | การบริหารสาธารณสุขมูลฐาน | 初级卫生保健管理"
    },
    {
        "id":150,
        "name":"149 (Thai Program)  :  Mass Media Management | การบริหารสื่อสารมวลชน | 大众传媒管理"
    },
    {
        "id":151,
        "name":"150 (Thai Program)  :  Clinical Laboratory Management | การบริหารห้องปฏิบัติการคลินิก | 临床实验室管理"
    },
    {
        "id":152,
        "name":"151 (Thai Program)  :  Organizational Management | การบริหารองค์การ | 组织管理"
    },
    {
        "id":153,
        "name":"152 (Thai Program)  :  Vocational Education Administration | การบริหารอาชีวศึกษา | 职业教育管理"
    },
    {
        "id":154,
        "name":"153 (English Program)  :  Computational Science | วิทยาศาสตร์คอมพิวเตอร์ | 计算科学"
    },
    {
        "id":155,
        "name":"154 (Thai Program)  :  Tourism Industry Management | การบริหารอุตสาหกรรมการท่องเที่ยว | 旅游产业管理"
    },
    {
        "id":156,
        "name":"155 (Thai Program)  :  Travel Industry Management | การบริหารอุตสาหกรรมเดินทาง | 旅游行业管理"
    },
    {
        "id":157,
        "name":"156 (Thai Program)  :  Technology Management | การบริหารเทคโนโลยี | 技术管理"
    },
    {
        "id":158,
        "name":"157 (Thai Program)  :  Project And Policy Management | การบริหารโครงการและนโยบาย | 项目和政策管理"
    },
    {
        "id":159,
        "name":"158 (Thai Program)  :  Telecommunications Management | การบริหารโทรคมนาคม | 电信管理"
    },
    {
        "id":160,
        "name":"159 (English Program)  :  Computer Education | การศึกษาคอมพิวเตอร์ | 计算机教育"
    },
    {
        "id":161,
        "name":"160 (Thai Program)  :  Hospital Administration | การบริหารโรงพยาบาล | 医院管理"
    },
    {
        "id":162,
        "name":"161 (Thai Program)  :  Hotel Management | การบริหารโรงแรม | 酒店管理"
    },
    {
        "id":163,
        "name":"162 (English Program)  :  Computer Information Systems | ระบบสารสนเทศคอมพิวเตอร์ | 计算机信息系统"
    },
    {
        "id":164,
        "name":"163 (Thai Program)  :  Management Accounting | การบัญชีบริหาร | 管理会计"
    },
    {
        "id":165,
        "name":"164 (Thai Program)  :  Management Accounting | การบัญชีเพื่อการบริหาร | 管理会计"
    },
    {
        "id":166,
        "name":"165 (Thai Program)  :  Accounting And Taxation | การบัญชีและการภาษีอากร | 会计和税务"
    },
    {
        "id":167,
        "name":"166 (Thai Program)  :  Governance | การปกครอง | 治理"
    },
    {
        "id":168,
        "name":"167 (English Program)  :  Computer Science | วิทยาศาสตร์คอมพิวเตอร์ | 计算机科学"
    },
    {
        "id":169,
        "name":"168 (Thai Program)  :  Comparative Governance | การปกครองเปรียบเทียบ | 比较治理"
    },
    {
        "id":170,
        "name":"169 (Thai Program)  :  Early Childhood Education | การปฐมวัยศึกษา | 幼儿教育"
    },
    {
        "id":171,
        "name":"170 (Thai Program)  :  Educational Quality Assurance | การประกันคุณภาพการศึกษา | 教育质量保障"
    },
    {
        "id":172,
        "name":"171 (Thai Program)  :  Quality Assurance Of Agro-Industrial Products | การประกันคุณภาพผลิตภัณฑ์อุตสาหกรรมเกษตร | 农工产品的质量保证"
    },
    {
        "id":173,
        "name":"172 (Thai Program)  :  Insurance | การประกันภัย | 保险"
    },
    {
        "id":174,
        "name":"173 (English Program)  :  Computer Science-Statistics | วิทยาศาสตร์คอมพิวเตอร์-สถิติ | 计算机科学-统计学"
    },
    {
        "id":175,
        "name":"174 (Thai Program)  :  Public Relations | การประชาสัมพันธ์ | 公共关系"
    },
    {
        "id":176,
        "name":"175 (Thai Program)  :  Primary Education | การประถมศึกษา | 初等教育"
    },
    {
        "id":177,
        "name":"176 (Thai Program)  :  Composition | การประพันธ์เพลง | 作品"
    },
    {
        "id":178,
        "name":"177 (English Program)  :  Construction Engineering | วิศวกรรมก่อสร้าง | 建筑工程"
    },
    {
        "id":179,
        "name":"178 (English Program)  :  Construction Engineering And Management | วิศวกรรมก่อสร้างและการจัดการ | 建筑工程与管理"
    },
    {
        "id":180,
        "name":"179 (Thai Program)  :  Educational Assessment | การประเมินการศึกษา | 教育评估"
    },
    {
        "id":181,
        "name":"180 (Thai Program)  :  Assessment Of Risks In Terms Of | การประเมินความเสี่ยงทางด้าน | 风险评估"
    },
    {
        "id":182,
        "name":"181 (Thai Program)  :  Property Valuation | การประเมินราคาทรัพย์สิน | 物业估价"
    },
    {
        "id":183,
        "name":"182 (Thai Program)  :  Animal Breeding | การปรับปรุงพันธุ์สัตว์ | 动物饲养"
    },
    {
        "id":184,
        "name":"183 (Thai Program)  :  Animal Production | การผลิตสัตว์ | 动物生产"
    },
    {
        "id":185,
        "name":"184 (Thai Program)  :  Sports Training | การฝึกกีฬา | 运动训练"
    },
    {
        "id":186,
        "name":"185 (Thai Program)  :  Nursing | การพยาบาล | 护理"
    },
    {
        "id":187,
        "name":"186 (English Program)  :  Construction Management | การจัดการการก่อสร้าง | 施工管理"
    },
    {
        "id":188,
        "name":"187 (Thai Program)  :  Pediatric Nursing | การพยาบาลกุมารเวชศาสตร์ | 儿科护理"
    },
    {
        "id":189,
        "name":"188 (Thai Program)  :  Family Nursing | การพยาบาลครอบครัว | 家庭护理"
    },
    {
        "id":190,
        "name":"189 (Thai Program)  :  Psychiatric And Mental Health Nursing | การพยาบาลจิตเวชและสุขภาพจิต | 精神科和心理健康护理"
    },
    {
        "id":191,
        "name":"190 (Thai Program)  :  Community Nursing | การพยาบาลชุมชน | 社区护理"
    },
    {
        "id":192,
        "name":"191 (Thai Program)  :  Infection Control Nursing | การพยาบาลด้านการควบคุมการติดเชื้อ | 感染控制护理"
    },
    {
        "id":193,
        "name":"192 (Thai Program)  :  Nursing Care For Parents And Children | การพยาบาลบิดามารดาและเด็ก | 父母和孩子的护理"
    },
    {
        "id":194,
        "name":"193 (Thai Program)  :  Elderly Nursing | การพยาบาลผู้สูงอายุ | 老年护理"
    },
    {
        "id":195,
        "name":"194 (Thai Program)  :  Adult Nursing | การพยาบาลผู้ใหญ่ | 成人护理"
    },
    {
        "id":196,
        "name":"195 (Thai Program)  :  Nursing Mothers And Newborns | การพยาบาลมารดาและทารกแรกเกิด | 哺乳期母亲和新生儿"
    },
    {
        "id":197,
        "name":"196 (English Program)  :  Consumer Protection In Public Health | การคุ้มครองผู้บริโภคในด้านสาธารณสุข | 公共卫生领域的消费者保护"
    },
    {
        "id":198,
        "name":"197 (Thai Program)  :  Nursing Studies | การพยาบาลศึกษา | 护理研究"
    },
    {
        "id":199,
        "name":"198 (Thai Program)  :  Women'S Nursing | การพยาบาลสตรี | 妇女护理"
    },
    {
        "id":200,
        "name":"199 (Thai Program)  :  Public Health Nursing | การพยาบาลสาธารณสุข | 公共卫生护理"
    },
    {
        "id":201,
        "name":"200 (Thai Program)  :  Public Health Nursing Practice | การพยาบาลสาธารณสุขเวชปฏิบัติ | 公共卫生护理实践"
    },
    {
        "id":202,
        "name":"201 (Thai Program)  :  Mental Health And Psychiatric Nursing | การพยาบาลสุขภาพจิตและจิตเวช | 心理健康与精神科护理"
    },
    {
        "id":203,
        "name":"202 (Thai Program)  :  Community Health Nursing | การพยาบาลอนามัยชุมชน | 社区健康护理"
    },
    {
        "id":204,
        "name":"203 (Thai Program)  :  Occupational Health Nursing | การพยาบาลอาชีวอนามัย | 职业健康护理"
    },
    {
        "id":205,
        "name":"204 (Thai Program)  :  Pediatric Nursing | การพยาบาลเด็ก | 儿科护理"
    },
    {
        "id":206,
        "name":"205 (Thai Program)  :  Maternal And Child Nursing | การพยาบาลแม่และเด็ก | 母婴护理"
    },
    {
        "id":207,
        "name":"206 (Thai Program)  :  Nursing And Midwifery | การพยาบาลและผดุงครรภ์ | 护理和助产学"
    },
    {
        "id":208,
        "name":"207 (Thai Program)  :  Family And Social Development | การพัฒนาครอบครัวและสังคม | 家庭和社会发展"
    },
    {
        "id":209,
        "name":"208 (Thai Program)  :  Community Development | การพัฒนาชุมชน | 社区发展"
    },
    {
        "id":210,
        "name":"209 (Thai Program)  :  Urban Development | การพัฒนาชุมชนเมือง | 城市发展"
    },
    {
        "id":211,
        "name":"210 (Thai Program)  :  Software Development | การพัฒนาซอฟต์แวร์ | 软件开发"
    },
    {
        "id":212,
        "name":"211 (Thai Program)  :  Business Software Development | การพัฒนาซอฟต์แวร์ด้านธุรกิจ | 商业软件开发"
    },
    {
        "id":213,
        "name":"212 (Thai Program)  :  Human Resource And Organizational Development | การพัฒนาทรัพยากรมนุษย์และองค์การ | 人力资源和组织发展"
    },
    {
        "id":214,
        "name":"213 (Thai Program)  :  Regional And Local Development | การพัฒนาภูมิภาคและท้องถิ่น | 区域和地方发展"
    },
    {
        "id":215,
        "name":"214 (Thai Program)  :  Public Health System Development | การพัฒนาระบบสาธารณสุข | 公共卫生系统发展"
    },
    {
        "id":216,
        "name":"215 (Thai Program)  :  Information System Development | การพัฒนาระบบสารสนเทศ | 信息系统开发"
    },
    {
        "id":217,
        "name":"216 (Thai Program)  :  Social Development | การพัฒนาสังคม | 社会发展"
    },
    {
        "id":218,
        "name":"217 (Thai Program)  :  Health Development | การพัฒนาสุขภาพ | 健康发展"
    },
    {
        "id":219,
        "name":"218 (Thai Program)  :  Curriculum And Teaching Development | การพัฒนาหลักสูตรและการเรียนการสอน | 课程与教学发展"
    },
    {
        "id":220,
        "name":"219 (Thai Program)  :  Sustainable Development | การพัฒนาอย่างยั่งยืน | 可持续发展"
    },
    {
        "id":221,
        "name":"220 (Thai Program)  :  Printing | การพิมพ์ | 印刷"
    },
    {
        "id":222,
        "name":"221 (Thai Program)  :  Film And Still Photography | การภาพยนตร์และภาพนิ่ง | 电影和静态摄影"
    },
    {
        "id":223,
        "name":"222 (Thai Program)  :  Secondary Education | การมัธยมศึกษา | 中等教育"
    },
    {
        "id":224,
        "name":"223 (Thai Program)  :  International Affairs | การระหว่างประเทศ | 国际事务"
    },
    {
        "id":225,
        "name":"224 (Thai Program)  :  International Affairs And Diplomacy | การระหว่างประเทศและการทูต | 国际事务和外交"
    },
    {
        "id":226,
        "name":"225 (Thai Program)  :  Security | การรักษาความปลอดภัย | 安全"
    },
    {
        "id":227,
        "name":"226 (Thai Program)  :  Remote Sensing | การรับรู้จากระยะไกล | 遥感"
    },
    {
        "id":228,
        "name":"227 (Thai Program)  :  Remote Sensing And Systems | การรับรู้จากระยะไกลและระบบ | 遥感和系统"
    },
    {
        "id":229,
        "name":"228 (Thai Program)  :  Performance | การละคอน | 表现"
    },
    {
        "id":230,
        "name":"229 (Thai Program)  :  Educational Measurement | การวัดผลการศึกษา | 教育测量"
    },
    {
        "id":231,
        "name":"230 (Thai Program)  :  Educational Measurement And Research | การวัดผลและวิจัยการศึกษา | 教育测量与研究"
    },
    {
        "id":232,
        "name":"231 (Thai Program)  :  Educational Measurement And Evaluation | การวัดและประเมินผลการศึกษา | 教育测量与评价"
    },
    {
        "id":233,
        "name":"232 (English Program)  :  Convention And Event Management | อนุสัญญาและการจัดการเหตุการณ์ | 会议及活动管理"
    },
    {
        "id":234,
        "name":"233 (English Program)  :  Counseling And Guidance | การให้คำปรึกษาและคำแนะนำ | 咨询和指导"
    },
    {
        "id":235,
        "name":"234 (English Program)  :  Counseling Psychology | จิตวิทยาการให้คำปรึกษา | 咨询心理学"
    },
    {
        "id":236,
        "name":"235 (Thai Program)  :  Community Planning | การวางผังชุมชน | 社区规划"
    },
    {
        "id":237,
        "name":"236 (Thai Program)  :  Urban Planning | การวางผังเมือง | 城市规划"
    },
    {
        "id":238,
        "name":"237 (Thai Program)  :  Urban Planning And Environment | การวางผังเมืองและสภาพแวดล้อม | 城市规划与环境"
    },
    {
        "id":239,
        "name":"238 (Thai Program)  :  Urban And Environmental Planning | การวางแผนชุมชนเมืองและสภาพแวดล้อม | 城市与环境规划"
    },
    {
        "id":240,
        "name":"239 (Thai Program)  :  Sector Planning | การวางแผนภาค | 部门规划"
    },
    {
        "id":241,
        "name":"240 (Thai Program)  :  Regional And City Planning | การวางแผนภาคและเมือง | 区域和城市规划"
    },
    {
        "id":242,
        "name":"241 (English Program)  :  Creative Crafts Design | การออกแบบงานฝีมือที่สร้างสรรค์ | 创意工艺品设计"
    },
    {
        "id":243,
        "name":"242 (Thai Program)  :  Environmental Planning For Community And Rural Development | การวางแผนสิ่งแวดล้อมเพื่อพัฒนาชุมชนและชนบท | 社区和农村发展的环境规划"
    },
    {
        "id":244,
        "name":"243 (Thai Program)  :  Economic Planning | การวางแผนเศรษฐกิจ | 经济规划"
    },
    {
        "id":245,
        "name":"244 (Thai Program)  :  Planning And Managing Tourism For Environmental Conservation | การวางแผนและการจัดการการท่องเที่ยวเพื่ออนุรักษ์สิ่งแวดล้อม | 规划和管理旅游业以保护环境"
    },
    {
        "id":246,
        "name":"245 (Thai Program)  :  Project Planning And Evaluation | การวางแผนและประเมินผลโครงการ | 项目规划与评估"
    },
    {
        "id":247,
        "name":"246 (Thai Program)  :  Rural Planning And Development | การวางแผนและพัฒนาชนบท | 乡村规划与发展"
    },
    {
        "id":248,
        "name":"247 (Thai Program)  :  Educational Research | การวิจัยการศึกษา | 教育研究"
    },
    {
        "id":249,
        "name":"248 (Thai Program)  :  Operational Research | การวิจัยดำเนินงาน | 运筹学"
    },
    {
        "id":250,
        "name":"249 (Thai Program)  :  Dentistry Research | การวิจัยทางทันตแพทยศาสตร์ | 牙科研究"
    },
    {
        "id":251,
        "name":"250 (Thai Program)  :  Behavioral Science Research And Personal Development | การวิจัยทางพฤติกรรมศาสตร์กับการ-พัฒนาบุคคล | 行为科学研究和个人发展"
    },
    {
        "id":252,
        "name":"251 (Thai Program)  :  Social Research | การวิจัยทางสังคม | 社会研究"
    },
    {
        "id":253,
        "name":"252 (Thai Program)  :  Applied Behavioral Science Research | การวิจัยพฤติกรรมศาสตร์ประยุกต์ | 应用行为科学研究"
    },
    {
        "id":254,
        "name":"253 (English Program)  :  Criminal Justice Administration | การบริหารความยุติธรรมทางอาญา | 刑事司法行政"
    },
    {
        "id":255,
        "name":"254 (Thai Program)  :  Educational Research And Development | การวิจัยและพัฒนาการศึกษา | 教育研究与发展"
    },
    {
        "id":256,
        "name":"255 (Thai Program)  :  Local Research And Development | การวิจัยและพัฒนาท้องถิ่น | 本地研究与开发"
    },
    {
        "id":257,
        "name":"256 (Thai Program)  :  Health System Research And Development | การวิจัยและพัฒนาระบบสาธารณสุข | 卫生系统研究与开发"
    },
    {
        "id":258,
        "name":"257 (Thai Program)  :  Social Research And Development | การวิจัยและพัฒนาสังคม | 社会研究与发展"
    },
    {
        "id":259,
        "name":"258 (Thai Program)  :  Curriculum Research And Development | การวิจัยและพัฒนาหลักสูตร | 课程研发"
    },
    {
        "id":260,
        "name":"259 (Thai Program)  :  Urban Research And Development | การวิจัยและพัฒนาเมือง | 城市研究与发展"
    },
    {
        "id":261,
        "name":"260 (Thai Program)  :  Educational Research And Statistics | การวิจัยและสถิติทางการศึกษา | 教育研究与统计"
    },
    {
        "id":262,
        "name":"261 (Thai Program)  :  Project Analysis And Evaluation | การวิเคราะห์และประเมินโครงการ | 项目分析与评估"
    },
    {
        "id":263,
        "name":"262 (Thai Program)  :  Social Analysis And Planning | การวิเคราะห์และวางแผนทางสังคม | 社会分析与规划"
    },
    {
        "id":264,
        "name":"263 (Thai Program)  :  Mathematics Education | การศึกษาคณิตศาสตร์ | 数学教育"
    },
    {
        "id":265,
        "name":"264 (Thai Program)  :  Rural Education | การศึกษาชนบท | 农村教育"
    },
    {
        "id":266,
        "name":"265 (Thai Program)  :  Non-Formal Education | การศึกษานอกระบบ | 非正规教育"
    },
    {
        "id":267,
        "name":"266 (English Program)  :  Cultural Management | การจัดการวัฒนธรรม | 文化管理"
    },
    {
        "id":268,
        "name":"267 (English Program)  :  Curriculum Research And Development | การวิจัยและพัฒนาหลักสูตร | 课程研究与开发"
    },
    {
        "id":269,
        "name":"268 (Thai Program)  :  Non-Formal Education | การศึกษานอกระบบโรงเรียน | 非正规教育"
    },
    {
        "id":270,
        "name":"269 (English Program)  :  Dance And Drama | การเต้นรำและละคร | 舞蹈和戏剧"
    },
    {
        "id":271,
        "name":"270 (Thai Program)  :  Non-Formal Education (Compulsory) | การศึกษานอกระบบโรงเรียน (บังคับ) | 非正规教育（义务教育）"
    },
    {
        "id":272,
        "name":"271 (English Program)  :  Dental Public Health | ทันตสาธารณสุข | 牙科公共卫生"
    },
    {
        "id":273,
        "name":"272 (Thai Program)  :  Adult Education | การศึกษาผู้ใหญ่ | 成人教育"
    },
    {
        "id":274,
        "name":"273 (Thai Program)  :  Adult And Continuing Education | การศึกษาผู้ใหญ่และการศึกษาต่อเนื่อง | 成人和继续教育"
    },
    {
        "id":275,
        "name":"274 (Thai Program)  :  Special Education | การศึกษาพิเศษ | 特殊教育"
    },
    {
        "id":276,
        "name":"275 (Thai Program)  :  Science Education | การศึกษาวิทยาศาสตร์ | 科学教育"
    },
    {
        "id":277,
        "name":"276 (Thai Program)  :  Education For Local Development | การศึกษาเพื่อการพัฒนาท้องถิ่น | 教育促进地方发展"
    },
    {
        "id":278,
        "name":"277 (Thai Program)  :  Education For Human Resource Development | การศึกษาเพื่อพัฒนาทรัพยากรมนุษย์ | 人力资源开发教育"
    },
    {
        "id":279,
        "name":"278 (Thai Program)  :  Teaching | การสอน | 教学"
    },
    {
        "id":280,
        "name":"279 (Thai Program)  :  Teaching Mathematics | การสอนคณิตศาสตร์ | 数学教学"
    },
    {
        "id":281,
        "name":"280 (Thai Program)  :  Teaching Biology | การสอนชีววิทยา | 生物学教学"
    },
    {
        "id":282,
        "name":"281 (English Program)  :  Development Administration | การบริหารการพัฒนา | 发展管理局"
    },
    {
        "id":283,
        "name":"282 (Thai Program)  :  Teaching Physics | การสอนฟิสิกส์ | 物理教学"
    },
    {
        "id":284,
        "name":"283 (English Program)  :  Development Communication | การสื่อสารเพื่อการพัฒนา | 发展交流"
    },
    {
        "id":285,
        "name":"284 (English Program)  :  Development Economics | เศรษฐศาสตร์การพัฒนา | 发展经济学"
    },
    {
        "id":286,
        "name":"285 (Thai Program)  :  Teaching English As A Foreign Language | การสอนภาษาอังกฤษเป็นภาษาต่างประเทศ | 英语作为外语教学"
    },
    {
        "id":287,
        "name":"286 (English Program)  :  Development Education | การศึกษาเพื่อการพัฒนา | 发展教育"
    },
    {
        "id":288,
        "name":"287 (English Program)  :  Drama | ละคร | 戏剧"
    },
    {
        "id":289,
        "name":"288 (Thai Program)  :  Teaching Thai Language | การสอนภาษาไทย | 泰语教学"
    },
    {
        "id":290,
        "name":"289 (English Program)  :  Early Childhood Education | การศึกษาปฐมวัย | 幼儿教育"
    },
    {
        "id":291,
        "name":"290 (Thai Program)  :  Teaching Thai As A Foreign Language | การสอนภาษาไทยในฐานะภาษาต่างประเทศ | 泰语作为外语教学"
    },
    {
        "id":292,
        "name":"291 (Thai Program)  :  Teaching Science | การสอนวิทยาศาสตร์ | 教学科学"
    },
    {
        "id":293,
        "name":"292 (Thai Program)  :  Teaching Science At The Basic Education Level | การสอนวิทยาศาสตร์ระดับการศึกษาขั้นพื้นฐาน | 基础教育层面的科学教学"
    },
    {
        "id":294,
        "name":"293 (Thai Program)  :  Teaching Science And Mathematics | การสอนวิทยาศาสตร์และคณิตศาสตร์ | 教授科学和数学"
    },
    {
        "id":295,
        "name":"294 (Thai Program)  :  Teaching Social Studies | การสอนสังคมศึกษา | 教授社会研究"
    },
    {
        "id":296,
        "name":"295 (Thai Program)  :  Teaching Social Studies At The Secondary Level | การสอนสังคมศึกษาระดับมัธยมศึกษา | 在中学教授社会研究"
    },
    {
        "id":297,
        "name":"296 (Thai Program)  :  Teaching Chemistry | การสอนเคมี | 化学教学"
    },
    {
        "id":298,
        "name":"297 (Thai Program)  :  Auditing | การสอบบัญชี | 审计"
    },
    {
        "id":299,
        "name":"298 (Thai Program)  :  Public Health | การสาธารณสุข | 公共卫生"
    },
    {
        "id":300,
        "name":"299 (Thai Program)  :  Public And Private Communications | การสื่อสารภาครัฐและเอกชน | 公共和私人通信"
    },
    {
        "id":301,
        "name":"300 (Thai Program)  :  Mass Communication | การสื่อสารมวลชน | 大众传播"
    },
    {
        "id":302,
        "name":"301 (Thai Program)  :  Communication For Development | การสื่อสารเพื่อการพัฒนา | 沟通促进发展"
    },
    {
        "id":303,
        "name":"302 (English Program)  :  Education | การศึกษา | 教育"
    },
    {
        "id":304,
        "name":"303 (Thai Program)  :  Health Promotion | การส่งเสริมสุขภาพ | 健康促进"
    },
    {
        "id":305,
        "name":"304 (English Program)  :  Educational Administration | การบริหารการศึกษา | 教育行政"
    },
    {
        "id":306,
        "name":"305 (Thai Program)  :  Design | การออกแบบ | 设计"
    },
    {
        "id":307,
        "name":"306 (Thai Program)  :  Urban Design | การออกแบบชุมชนเมือง | 城市设计"
    },
    {
        "id":308,
        "name":"307 (Thai Program)  :  Visual Arts Design | การออกแบบทัศนศิลป์ | 视觉艺术设计"
    },
    {
        "id":309,
        "name":"308 (English Program)  :  Educational Management | การจัดการการศึกษา | 教育管理"
    },
    {
        "id":310,
        "name":"309 (English Program)  :  Educational Measurement | การวัดผลทางการศึกษา | 教育测量"
    },
    {
        "id":311,
        "name":"310 (Thai Program)  :  Packaging Design | การออกแบบบรรจุภัณฑ์ | 包装设计"
    },
    {
        "id":312,
        "name":"311 (Thai Program)  :  Product Design | การออกแบบผลิตภัณฑ์ | 产品设计"
    },
    {
        "id":313,
        "name":"312 (Thai Program)  :  Interior Design | การออกแบบภายใน | 室内设计"
    },
    {
        "id":314,
        "name":"313 (Thai Program)  :  Industrial Design | การออกแบบอุตสาหกรรม | 工业设计"
    },
    {
        "id":315,
        "name":"314 (Thai Program)  :  Jewelry Design | การออกแบบเครื่องประดับ | 珠宝设计"
    },
    {
        "id":316,
        "name":"315 (Thai Program)  :  Food | การอาหาร | 食物"
    },
    {
        "id":317,
        "name":"316 (Thai Program)  :  Higher Education Management | การจัดการการอุดมศึกษา | 高等教育管理"
    },
    {
        "id":318,
        "name":"317 (Thai Program)  :  Agriculture | การเกษตร | 农业"
    },
    {
        "id":319,
        "name":"318 (Thai Program)  :  Finance | การเงิน | 金融"
    },
    {
        "id":320,
        "name":"319 (English Program)  :  Educational Research | การวิจัยทางการศึกษา | 教育研究"
    },
    {
        "id":321,
        "name":"320 (English Program)  :  Educational Research And Evaluation | การวิจัยและการประเมินผลการศึกษา | 教育研究与评估"
    },
    {
        "id":322,
        "name":"321 (Thai Program)  :  Fertility And Population Planning | การเจริญพันธุ์และวางแผนประชากร | 生育率和人口规划"
    },
    {
        "id":323,
        "name":"322 (Thai Program)  :  Travel And Tourism | การเดินทางและท่องเที่ยว | 旅行和旅游"
    },
    {
        "id":324,
        "name":"323 (Thai Program)  :  Entrepreneurship | การเป็นผู้ประกอบการ | 创业精神"
    },
    {
        "id":325,
        "name":"324 (Thai Program)  :  Aquaculture | การเพาะเลี้ยงสัตว์น้ำ | 水产养殖"
    },
    {
        "id":326,
        "name":"325 (Thai Program)  :  Politics And Government | การเมืองการปกครอง | 政治与政府"
    },
    {
        "id":327,
        "name":"326 (English Program)  :  Educational Technology | เทคโนโลยีการศึกษา | 教育技术"
    },
    {
        "id":328,
        "name":"327 (Thai Program)  :  Politics And Government | การเมืองและการปกครอง | 政治与政府"
    },
    {
        "id":329,
        "name":"328 (Thai Program)  :  Self-Reliant English Learning | การเรียนรู้ภาษาอังกฤษแบบพึ่งตนเอง | 自力更生的英语学习"
    },
    {
        "id":330,
        "name":"329 (English Program)  :  E-Learning Methodology | วิธีการเรียนรู้ทางอิเล็กทรอนิกส์ | 电子学习方法"
    },
    {
        "id":331,
        "name":"330 (Thai Program)  :  Guidance | การแนะแนว | 指导"
    },
    {
        "id":332,
        "name":"331 (Thai Program)  :  Guidance And Counseling | การแนะแนวและให้คำปรึกษา | 指导和咨询"
    },
    {
        "id":333,
        "name":"332 (Thai Program)  :  Translation | การแปล | 翻译"
    },
    {
        "id":334,
        "name":"333 (Thai Program)  :  French-Thai Translation | การแปลภาษาฝรั่งเศส-ไทย | 法语-泰语翻译"
    },
    {
        "id":335,
        "name":"334 (Thai Program)  :  Thai And French Translation | การแปลภาษาไทยและภาษาฝรั่งเศส | 泰语和法语翻译"
    },
    {
        "id":336,
        "name":"335 (Thai Program)  :  Thai And English Translation | การแปลภาษาไทยและภาษาอังกฤษ | 泰语和英语翻译"
    },
    {
        "id":337,
        "name":"336 (Thai Program)  :  Translation And Interpreting | การแปลและการล่าม | 笔译和口译"
    },
    {
        "id":338,
        "name":"337 (Thai Program)  :  Applied Thai Traditional Medicine | การแพทย์แผนไทยประยุกต์ | 应用泰国传统医学"
    },
    {
        "id":339,
        "name":"338 (English Program)  :  Electrical Engineering | วิศวกรรมไฟฟ้า | 电气工程"
    },
    {
        "id":340,
        "name":"339 (Thai Program)  :  Advertising | การโฆษณา | 广告"
    },
    {
        "id":341,
        "name":"340 (Thai Program)  :  Advertising And Public Relations | การโฆษณาและการประชาสัมพันธ์ | 广告和公共关系"
    },
    {
        "id":342,
        "name":"341 (English Program)  :  Electrical Power | พลังงานไฟฟ้า | 电力"
    },
    {
        "id":343,
        "name":"342 (English Program)  :  Electrical Power Technology | เทคโนโลยีพลังงานไฟฟ้า | 电力技术"
    },
    {
        "id":344,
        "name":"343 (Thai Program)  :  Hospitality | การโรงแรม | 款待"
    },
    {
        "id":345,
        "name":"344 (English Program)  :  Electrical Technology | เทคโนโลยีไฟฟ้า | 电气技术"
    },
    {
        "id":346,
        "name":"345 (English Program)  :  Electronic Business | ธุรกิจอิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":347,
        "name":"346 (Thai Program)  :  Land Use And Management | การใช้ที่ดินและการจัดการ | 土地利用与管理"
    },
    {
        "id":348,
        "name":"347 (Thai Program)  :  Sustainable Land Use And Resource Management | การใช้ที่ดินและการจัดการทรัพยากรอย่างยั่งยืน | 可持续土地利用和资源管理"
    },
    {
        "id":349,
        "name":"348 (Thai Program)  :  Counseling And Guidance | การให้คำปรึกษาและการแนะแนว | 咨询和指导"
    },
    {
        "id":350,
        "name":"349 (Thai Program)  :  Occupational Therapy | กิจกรรมบำบัด | 职业治疗"
    },
    {
        "id":351,
        "name":"350 (Thai Program)  :  Entomology | กีฏวิทยา | 昆虫学"
    },
    {
        "id":352,
        "name":"351 (Thai Program)  :  Entomology And Environment | กีฏวิทยาและสิ่งแวดล้อม | 昆虫学与环境"
    },
    {
        "id":353,
        "name":"352 (Thai Program)  :  Pediatric Surgery | กุมารศัลยศาสตร์ | 小儿外科"
    },
    {
        "id":354,
        "name":"353 (Thai Program)  :  Pediatrics | กุมารเวชศาสตร์ | 儿科"
    },
    {
        "id":355,
        "name":"354 (Thai Program)  :  Tropical Pediatrics | กุมารเวชศาสตร์เขตร้อน | 热带儿科"
    },
    {
        "id":356,
        "name":"355 (Thai Program)  :  Construct | ก่อสร้าง | 构造"
    },
    {
        "id":357,
        "name":"356 (Thai Program)  :  Math-Science | คณิต-วิทยาศาสตร์ | 数学科学"
    },
    {
        "id":358,
        "name":"357 (Thai Program)  :  Mathematics | คณิตศาสตร์ | 数学"
    },
    {
        "id":359,
        "name":"358 (English Program)  :  Electronics And Computer | อิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子和计算机"
    },
    {
        "id":360,
        "name":"359 (Thai Program)  :  Mathematics In Terms Of Grouping And Optimization Methods | คณิตศาสตร์ทางด้านวิธีจัดหมู่และการหาค่าเหมาะที่สุด | 分组和优化方法方面的数学"
    },
    {
        "id":361,
        "name":"360 (Thai Program)  :  Applied Mathematics | คณิตศาสตร์ประยุกต์ | 应用数学"
    },
    {
        "id":362,
        "name":"361 (Thai Program)  :  Mathematics Studies | คณิตศาสตร์ศึกษา | 数学研究"
    },
    {
        "id":363,
        "name":"362 (Thai Program)  :  Islamic Education | ครุศาสตร์อิสลาม | 伊斯兰教育"
    },
    {
        "id":364,
        "name":"363 (Thai Program)  :  Agricultural Education | ครุศาสตร์เกษตร | 农业教育"
    },
    {
        "id":365,
        "name":"364 (Thai Program)  :  Technology Education | ครุศาสตร์เทคโนโลยี | 科技教育"
    },
    {
        "id":366,
        "name":"365 (Thai Program)  :  Teacher | ครู | 老师"
    },
    {
        "id":367,
        "name":"366 (Thai Program)  :  Communication Disorders | ความผิดปกติของการสื่อความหมาย | 沟通障碍"
    },
    {
        "id":368,
        "name":"367 (Thai Program)  :  Communication Disorders – Audiology | ความผิดปกติของการสื่อความหมาย – โสตสัมผัสวิทยา | 沟通障碍 – 听力学"
    },
    {
        "id":369,
        "name":"368 (Thai Program)  :  International Relations | ความสัมพันธ์ระหว่างประเทศ | 国际关系"
    },
    {
        "id":370,
        "name":"369 (Thai Program)  :  International Relations And Politics | ความสัมพันธ์ระหว่างประเทศและการเมือง | 国际关系与政治"
    },
    {
        "id":371,
        "name":"370 (Thai Program)  :  Home Economics | คหกรรมศาสตร์ | 家政"
    },
    {
        "id":372,
        "name":"371 (English Program)  :  Electronics Technology | เทคโนโลยีอิเล็กทรอนิกส์ | 电子技术"
    },
    {
        "id":373,
        "name":"372 (English Program)  :  Elementary Education | การศึกษาระดับประถมศึกษา | 基础教育"
    },
    {
        "id":374,
        "name":"373 (Thai Program)  :  General Home Economics – Craft Business | คหกรรมศาสตร์ทั่วไป – ธุรกิจงานประดิษฐ์ | 一般家政 - 手工艺业务"
    },
    {
        "id":375,
        "name":"374 (Thai Program)  :  Home Economics Studies | คหกรรมศาสตร์ศึกษา | 家政学研究"
    },
    {
        "id":376,
        "name":"375 (English Program)  :  Engineering | วิศวกรรม | 工程"
    },
    {
        "id":377,
        "name":"376 (Thai Program)  :  Computer | คอมพิวเตอร์ | 电脑"
    },
    {
        "id":378,
        "name":"377 (Thai Program)  :  Education Computer | คอมพิวเตอร์การศึกษา | 教育计算机"
    },
    {
        "id":379,
        "name":"378 (English Program)  :  Engineering Management | การจัดการทางวิศวกรรม | 工程管理"
    },
    {
        "id":380,
        "name":"379 (English Program)  :  Engineering Or Technology | วิศวกรรมหรือเทคโนโลยี | 工程或技术"
    },
    {
        "id":381,
        "name":"380 (Thai Program)  :  Computer Studies | คอมพิวเตอร์ศึกษา | 计算机研究"
    },
    {
        "id":382,
        "name":"381 (Thai Program)  :  Computer And Information Technology | คอมพิวเตอร์และเทคโนโลยีสารสนเทศ | 计算机与信息技术"
    },
    {
        "id":383,
        "name":"382 (Thai Program)  :  International Music | คีตศิลปสากล | 国际音乐"
    },
    {
        "id":384,
        "name":"383 (Thai Program)  :  Thai Music | คีตศิลปไทย | 泰国音乐"
    },
    {
        "id":385,
        "name":"384 (Thai Program)  :  Rehabilitation Services For The Disabled | งานบริการฟื้นฟูสมรรถภาพคนพิการ | 残疾人康复服务"
    },
    {
        "id":386,
        "name":"385 (Thai Program)  :  General Information Work | งานสารสนเทศทั่วไป | 一般信息工作"
    },
    {
        "id":387,
        "name":"386 (Thai Program)  :  Office Information Work | งานสารสนเทศสำนักงาน | 办公信息化工作"
    },
    {
        "id":388,
        "name":"387 (Thai Program)  :  Office Work | งานสำนักงาน | 办公室工作"
    },
    {
        "id":389,
        "name":"388 (Thai Program)  :  Ethical Studies | จริยศาสตร์ศึกษา | 伦理学研究"
    },
    {
        "id":390,
        "name":"389 (Thai Program)  :  Moral Education | จริยศึกษา | 道德教育"
    },
    {
        "id":391,
        "name":"390 (Thai Program)  :  Ophthalmology | จักษุวิทยา | 眼科"
    },
    {
        "id":392,
        "name":"391 (English Program)  :  English | ภาษาอังกฤษ | 英语"
    },
    {
        "id":393,
        "name":"392 (Thai Program)  :  Eastern Language Inscriptions | จารึกภาษาตะวันออก | 东方文字铭文"
    },
    {
        "id":394,
        "name":"393 (Thai Program)  :  Thai Inscription | จารึกภาษาไทย | 泰文铭文"
    },
    {
        "id":395,
        "name":"394 (Thai Program)  :  Painting | จิตรกรรม | 绘画"
    },
    {
        "id":396,
        "name":"395 (Thai Program)  :  Psychology | จิตวิทยา | 心理学"
    },
    {
        "id":397,
        "name":"396 (Thai Program)  :  Experimental Psychology | จิตวิทยาการทดลอง | 实验心理学"
    },
    {
        "id":398,
        "name":"397 (Thai Program)  :  Counseling Psychology | จิตวิทยาการปรึกษา | 咨询心理学"
    },
    {
        "id":399,
        "name":"398 (Thai Program)  :  Counseling And Guidance Psychology | จิตวิทยาการปรึกษาและการแนะแนว | 咨询与指导心理学"
    },
    {
        "id":400,
        "name":"399 (Thai Program)  :  Counseling And Guidance Psychology | จิตวิทยาการปรึกษาและแนะแนว | 咨询与指导心理学"
    },
    {
        "id":401,
        "name":"400 (Thai Program)  :  Educational Psychology | จิตวิทยาการศึกษา | 教育心理学"
    },
    {
        "id":402,
        "name":"401 (Thai Program)  :  Educational Psychology And Guidance | จิตวิทยาการศึกษาและการแนะแนว | 教育心理学与指导"
    },
    {
        "id":403,
        "name":"402 (Thai Program)  :  Guidance Psychology | จิตวิทยาการแนะแนว | 指导心理学"
    },
    {
        "id":404,
        "name":"403 (Thai Program)  :  Counseling Psychology | จิตวิทยาการให้คำปรึกษา | 咨询心理学"
    },
    {
        "id":405,
        "name":"404 (Thai Program)  :  Psychology Of Counseling And Guidance Services | จิตวิทยาการให้บริการปรึกษาและแนะแนว | 心理咨询与指导服务"
    },
    {
        "id":406,
        "name":"405 (Thai Program)  :  Clinical Psychology | จิตวิทยาคลินิก | 临床心理学"
    },
    {
        "id":407,
        "name":"406 (Thai Program)  :  Clinical And Community Psychology | จิตวิทยาคลินิกและชุมชน | 临床和社区心理学"
    },
    {
        "id":408,
        "name":"407 (Thai Program)  :  Community Psychology | จิตวิทยาชุมชน | 社区心理学"
    },
    {
        "id":409,
        "name":"408 (Thai Program)  :  Developmental Psychology | จิตวิทยาพัฒนาการ | 发展心理学"
    },
    {
        "id":410,
        "name":"409 (Thai Program)  :  Social Psychology | จิตวิทยาสังคม | 社会心理学"
    },
    {
        "id":411,
        "name":"410 (Thai Program)  :  Organizational Psychology | จิตวิทยาองค์การ | 组织心理学"
    },
    {
        "id":412,
        "name":"411 (Thai Program)  :  Industrial Psychology | จิตวิทยาอุตสาหกรรม | 工业心理学"
    },
    {
        "id":413,
        "name":"412 (Thai Program)  :  Industrial And Organizational Psychology | จิตวิทยาอุตสาหกรรมและองค์การ | 工业与组织心理学"
    },
    {
        "id":414,
        "name":"413 (Thai Program)  :  Psychology And Guidance | จิตวิทยาและการแนะแนว | 心理学与指导"
    },
    {
        "id":415,
        "name":"414 (Thai Program)  :  School Psychology | จิตวิทยาโรงเรียน | 学校心理学"
    },
    {
        "id":416,
        "name":"415 (Thai Program)  :  Counseling Psychology | จิตวิทยาให้คำปรึกษา | 咨询心理学"
    },
    {
        "id":417,
        "name":"416 (Thai Program)  :  Psychiatry | จิตเวชศาสตร์ | 精神病学"
    },
    {
        "id":418,
        "name":"417 (English Program)  :  English For Business Communication | ภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจ | 商务交流英语"
    },
    {
        "id":419,
        "name":"418 (English Program)  :  English For Communication | ภาษาอังกฤษเพื่อการสื่อสาร | 交流英语"
    },
    {
        "id":420,
        "name":"419 (Thai Program)  :  Chinese Studies | จีนศึกษา | 中国研究"
    },
    {
        "id":421,
        "name":"420 (Thai Program)  :  Microbiology | จุลชีววิทยา | 微生物学"
    },
    {
        "id":422,
        "name":"421 (Thai Program)  :  Medical Microbiology | จุลชีววิทยาการแพทย์ | 医学微生物学"
    },
    {
        "id":423,
        "name":"422 (Thai Program)  :  Clinical Microbiology | จุลชีววิทยาคลินิก | 临床微生物学"
    },
    {
        "id":424,
        "name":"423 (Thai Program)  :  Medical Microbiology | จุลชีววิทยาทางการแพทย์ | 医学微生物学"
    },
    {
        "id":425,
        "name":"424 (Thai Program)  :  Industrial Microbiology | จุลชีววิทยาทางอุตสาหกรรม | 工业微生物学"
    },
    {
        "id":426,
        "name":"425 (Thai Program)  :  Applied Microbiology | จุลชีววิทยาประยุกต์ | 应用微生物学"
    },
    {
        "id":427,
        "name":"426 (Thai Program)  :  Industrial Microbiology | จุลชีววิทยาอุตสาหกรรม | 工业微生物学"
    },
    {
        "id":428,
        "name":"427 (Thai Program)  :  Clinical Microscopy | จุลทรรศนศาสตร์คลินิก | 临床显微镜"
    },
    {
        "id":429,
        "name":"428 (Thai Program)  :  Medicine Nickname | ฉายาเวชศาสตร์ | 医学昵称"
    },
    {
        "id":430,
        "name":"429 (Thai Program)  :  Rural Studies And Development | ชนบทศึกษาและการพัฒนา | 农村研究与发展"
    },
    {
        "id":431,
        "name":"430 (Thai Program)  :  Public Health Autopsy | ชันสูตรสาธารณสุข | 公共卫生尸检"
    },
    {
        "id":432,
        "name":"431 (Thai Program)  :  Biology | ชีววิทยา | 生物学"
    },
    {
        "id":433,
        "name":"432 (Thai Program)  :  Cellular And Molecular Biology | ชีววิทยาของเซลล์และโมเลกุล | 细胞和分子生物学"
    },
    {
        "id":434,
        "name":"433 (Thai Program)  :  Oral Biology | ชีววิทยาช่องปาก | 口腔生物学"
    },
    {
        "id":435,
        "name":"434 (Thai Program)  :  Fishery Biology | ชีววิทยาประมง | 渔业生物学"
    },
    {
        "id":436,
        "name":"435 (Thai Program)  :  Applied Biology | ชีววิทยาประยุกต์ | 应用生物学"
    },
    {
        "id":437,
        "name":"436 (Thai Program)  :  Forest Biology | ชีววิทยาป่าไม้ | 森林生物学"
    },
    {
        "id":438,
        "name":"437 (Thai Program)  :  Biology Studies | ชีววิทยาศึกษา | 生物学研究"
    },
    {
        "id":439,
        "name":"438 (Thai Program)  :  Environmental Biology | ชีววิทยาสภาวะแวดล้อม | 环境生物学"
    },
    {
        "id":440,
        "name":"439 (Thai Program)  :  Environmental Biology | ชีววิทยาสิ่งแวดล้อม | 环境生物学"
    },
    {
        "id":441,
        "name":"440 (Thai Program)  :  Conservation Biology | ชีววิทยาเชิงอนุรักษ์ | 保护生物学"
    },
    {
        "id":442,
        "name":"441 (Thai Program)  :  Biostatistics | ชีวสถิติ | 生物统计学"
    },
    {
        "id":443,
        "name":"442 (Thai Program)  :  Bioinformatics And Systems Biology | ชีวสารสนเทศและชีววิทยาระบบ | 生物信息学和系统生物学"
    },
    {
        "id":444,
        "name":"443 (Thai Program)  :  Biochemistry | ชีวเคมี | 生物化学"
    },
    {
        "id":445,
        "name":"444 (Thai Program)  :  Medical Biochemistry | ชีวเคมีทางการแพทย์ | 医学生物化学"
    },
    {
        "id":446,
        "name":"445 (Thai Program)  :  Biochemistry And Biochemistry Technology | ชีวเคมีและชีวเคมีเทคโนโลยี | 生物化学与生物化学技术"
    },
    {
        "id":447,
        "name":"446 (Thai Program)  :  Biopharmaceutical | ชีวเภสัช | 生物制药"
    },
    {
        "id":448,
        "name":"447 (Thai Program)  :  Biopharmaceutical | ชีวเภสัชกรรม | 生物制药"
    },
    {
        "id":449,
        "name":"448 (Thai Program)  :  Biomedical | ชีวเวชศาสตร์ | 生物医学"
    },
    {
        "id":450,
        "name":"449 (English Program)  :  English For International Communication | ภาษาอังกฤษเพื่อการสื่อสารระหว่างประเทศ | 国际交流英语"
    },
    {
        "id":451,
        "name":"450 (Thai Program)  :  Biomedical Chemistry | ชีวเวชเคมี | 生物医学化学"
    },
    {
        "id":452,
        "name":"451 (Thai Program)  :  Tradesman | ช่าง | 零售商"
    },
    {
        "id":453,
        "name":"452 (Thai Program)  :  Factory Mechanic | ช่างกลโรงงาน | 工厂机械师"
    },
    {
        "id":454,
        "name":"453 (Thai Program)  :  Construction Worker | ช่างก่อสร้าง | 建筑工人"
    },
    {
        "id":455,
        "name":"454 (Thai Program)  :  Dental Technician | ช่างทันตกรรม | 牙科技师"
    },
    {
        "id":456,
        "name":"455 (Thai Program)  :  Pipe Fitter And Brazing | ช่างท่อและประสาน | 管道安装和钎焊"
    },
    {
        "id":457,
        "name":"456 (English Program)  :  English For Specific Purposes | ภาษาอังกฤษเพื่อวัตถุประสงค์เฉพาะ | 特定用途英语"
    },
    {
        "id":458,
        "name":"457 (Thai Program)  :  Electronic Technician | ช่างอิเล็กทรอนิกส์ | 电子技术员"
    },
    {
        "id":459,
        "name":"458 (Thai Program)  :  Electronic Technician (Measurement And Control Tools) | ช่างอิเล็กทรอนิกส์ (เครื่องมือวัดและควบคุม) | 电子技术员（测量和控制工具）"
    },
    {
        "id":460,
        "name":"459 (Thai Program)  :  Industrial Technician | ช่างอุตสาหกรรม | 工业技术员"
    },
    {
        "id":461,
        "name":"460 (Thai Program)  :  Medical Equipment Technician | ช่างอุปกรณ์การแพทย์ | 医疗设备技术员"
    },
    {
        "id":462,
        "name":"461 (Thai Program)  :  Mechanical Draftsman | ช่างเขียนแบบเครื่องกล | 机械制图员"
    },
    {
        "id":463,
        "name":"462 (Thai Program)  :  Industrial Mechanic | ช่างเครื่องกลอุตสาหกรรม | 工业机械师"
    },
    {
        "id":464,
        "name":"463 (Thai Program)  :  Woodworking Machinery Technician | ช่างเครื่องจักรกลงานไม้ | 木工机械技术员"
    },
    {
        "id":465,
        "name":"464 (Thai Program)  :  Refrigeration And Air Conditioning Technician | ช่างเครื่องทำความเย็นและปรับอากาศ | 制冷空调技术员"
    },
    {
        "id":466,
        "name":"465 (Thai Program)  :  Furniture And Decorator | ช่างเครื่องเรือนและตกแต่ง | 家具及装饰师"
    },
    {
        "id":467,
        "name":"466 (Thai Program)  :  Civil Technology Technician | ช่างเทคโนโลยีโยธา | 土木技术技术员"
    },
    {
        "id":468,
        "name":"467 (Thai Program)  :  Electrician | ช่างไฟฟ้า | 电工"
    },
    {
        "id":469,
        "name":"468 (Thai Program)  :  Industrial Electrician | ช่างไฟฟ้าอุตสาหกรรม | 工业电工"
    },
    {
        "id":470,
        "name":"469 (Thai Program)  :  Japanese Studies | ญี่ปุ่นศึกษา | 日本研究"
    },
    {
        "id":471,
        "name":"470 (Thai Program)  :  Music | ดนตรี | 音乐"
    },
    {
        "id":472,
        "name":"471 (Thai Program)  :  Ethnomusicology | ดนตรีชาติพันธุ์วิทยา | 民族音乐学"
    },
    {
        "id":473,
        "name":"472 (Thai Program)  :  Western Music | ดนตรีตะวันตก | 西方音乐"
    },
    {
        "id":474,
        "name":"473 (Thai Program)  :  Music Education | ดนตรีศึกษา | 音乐教育"
    },
    {
        "id":475,
        "name":"474 (English Program)  :  Enterpreneurship | การเป็นผู้ประกอบการ | 创业精神"
    },
    {
        "id":476,
        "name":"475 (Thai Program)  :  International Music | ดนตรีสากล | 国际音乐"
    },
    {
        "id":477,
        "name":"476 (English Program)  :  Entrepreneurship | ผู้ประกอบการ | 创业精神"
    },
    {
        "id":478,
        "name":"477 (Thai Program)  :  Jazz Music | ดนตรีแจ๊ส | 爵士乐"
    },
    {
        "id":479,
        "name":"478 (Thai Program)  :  Thai Music | ดนตรีไทย | 泰国音乐"
    },
    {
        "id":480,
        "name":"479 (Thai Program)  :  Music | ดุริยางคศาสตร์ | 音乐"
    },
    {
        "id":481,
        "name":"480 (English Program)  :  Environmental Biology | ชีววิทยาสิ่งแวดล้อม | 环境生物学"
    },
    {
        "id":482,
        "name":"481 (Thai Program)  :  International Music | ดุริยางคศาสตร์สากล | 国际音乐"
    },
    {
        "id":483,
        "name":"482 (English Program)  :  Environmental Science | วิทยาศาสตร์สิ่งแวดล้อม | 环境科学"
    },
    {
        "id":484,
        "name":"483 (Thai Program)  :  Thai Music | ดุริยางคศาสตร์ไทย | 泰国音乐"
    },
    {
        "id":485,
        "name":"484 (Thai Program)  :  Music | ดุริยางคศิลป์ | 音乐"
    },
    {
        "id":486,
        "name":"485 (English Program)  :  Epidemiology | ระบาดวิทยา | 流行病学"
    },
    {
        "id":487,
        "name":"486 (Thai Program)  :  Thai Music | ดุริยางคศิลป์ไทย | 泰国音乐"
    },
    {
        "id":488,
        "name":"487 (Thai Program)  :  Musical Studies | ดุริยางคศึกษา | 音乐研究"
    },
    {
        "id":489,
        "name":"488 (Thai Program)  :  International Music | ดุริยางค์สากล | 国际音乐"
    },
    {
        "id":490,
        "name":"489 (Thai Program)  :  Thai Music | ดุริยางค์ไทย | 泰国音乐"
    },
    {
        "id":491,
        "name":"490 (Thai Program)  :  Dermatology | ตจวิทยา | 皮肤科"
    },
    {
        "id":492,
        "name":"491 (Thai Program)  :  Agricultural And Environmental Resources | ทรัพยากรการเกษตรและสิ่งแวดล้อม | 农业和环境资源"
    },
    {
        "id":493,
        "name":"492 (Thai Program)  :  Sustainable Natural Resources | ทรัพยากรธรรมชาติอย่างยั่งยืน | 可持续自然资源"
    },
    {
        "id":494,
        "name":"493 (Thai Program)  :  Human Resources | ทรัพยากรมนุษย์ | 人力资源"
    },
    {
        "id":495,
        "name":"494 (Thai Program)  :  Biological Agricultural Resources | ทรัพยากรเกษตรชีวภาพ | 生物农业资源"
    },
    {
        "id":496,
        "name":"495 (Thai Program)  :  Art Theory | ทฤษฎีศิลป์ | 艺术理论"
    },
    {
        "id":497,
        "name":"496 (Thai Program)  :  Economic Theory | ทฤษฎีเศรษฐศาสตร์ | 经济理论"
    },
    {
        "id":498,
        "name":"497 (Thai Program)  :  Political Science Theories And Techniques | ทฤษฎีและเทคนิคทางรัฐศาสตร์ | 政治学理论与技术"
    },
    {
        "id":499,
        "name":"498 (Thai Program)  :  Orthodontics | ทันตกรรมจัดฟัน | 正畸学"
    },
    {
        "id":500,
        "name":"499 (Thai Program)  :  General Dentistry | ทันตกรรมทั่วไป | 普通牙科"
    },
    {
        "id":501,
        "name":"500 (English Program)  :  Ethical Studies | การศึกษาด้านจริยธรรม | 伦理学研究"
    },
    {
        "id":502,
        "name":"501 (Thai Program)  :  Dental Chewing | ทันตกรรมบดเคี้ยว | 牙齿咀嚼"
    },
    {
        "id":503,
        "name":"502 (Thai Program)  :  Prosthetic Dentistry | ทันตกรรมประดิษฐ์ | 修复牙科"
    },
    {
        "id":504,
        "name":"503 (English Program)  :  Ethnomusicology | ชาติพันธุ์วิทยา | 民族音乐学"
    },
    {
        "id":505,
        "name":"504 (Thai Program)  :  Preventive Dentistry | ทันตกรรมป้องกัน | 预防性牙科"
    },
    {
        "id":506,
        "name":"505 (English Program)  :  Exercise And Sport | การออกกำลังกายและการกีฬา | 锻炼和运动"
    },
    {
        "id":507,
        "name":"506 (Thai Program)  :  Pediatric Dentistry | ทันตกรรมสำหรับเด็ก | 儿童牙科"
    },
    {
        "id":508,
        "name":"507 (Thai Program)  :  Operative Dentistry | ทันตกรรมหัตถการ | 牙科手术"
    },
    {
        "id":509,
        "name":"508 (Thai Program)  :  Dental Biomaterials Science | ทันตชีววัสดุศาสตร์ | 牙科生物材料科学"
    },
    {
        "id":510,
        "name":"509 (Thai Program)  :  Dental Radiology | ทันตรังสีวิทยา | 牙科放射学"
    },
    {
        "id":511,
        "name":"510 (Thai Program)  :  Dental Public Health | ทันตสาธารณสุข | 牙科公共卫生"
    },
    {
        "id":512,
        "name":"511 (Thai Program)  :  Community Dental Public Health | ทันตสาธารณสุขชุมชน | 社区牙科公共卫生"
    },
    {
        "id":513,
        "name":"512 (Thai Program)  :  Dental Public Health | ทันตสาธารณสุขศาสตร์ | 牙科公共卫生"
    },
    {
        "id":514,
        "name":"513 (English Program)  :  Exercise And Sport Studies | การออกกำลังกายและการศึกษาด้านกีฬา | 锻炼和运动研究"
    },
    {
        "id":515,
        "name":"514 (Thai Program)  :  Dentistry | ทันตแพทยศาสตร์ | 牙科"
    },
    {
        "id":516,
        "name":"515 (English Program)  :  Family And Child Development | การพัฒนาครอบครัวและเด็ก | 家庭和儿童发展"
    },
    {
        "id":517,
        "name":"516 (English Program)  :  Fashion And Textile Design | การออกแบบแฟชั่นและสิ่งทอ | 时装及纺织品设计"
    },
    {
        "id":518,
        "name":"517 (Thai Program)  :  Geophysics | ธรณีฟิสิกส์ | 地球物理学"
    },
    {
        "id":519,
        "name":"518 (Thai Program)  :  Applied Geophysics | ธรณีฟิสิกส์ประยุกต์ | 应用地球物理学"
    },
    {
        "id":520,
        "name":"519 (Thai Program)  :  Geology | ธรณีวิทยา | 地质学"
    },
    {
        "id":521,
        "name":"520 (Thai Program)  :  Dhamma | ธรรมนิเทศ | 正法"
    },
    {
        "id":522,
        "name":"521 (Thai Program)  :  Electronic Transactions | ธุรกรรมอิเล็กทรอนิกส์ | 电子交易"
    },
    {
        "id":523,
        "name":"522 (Thai Program)  :  Business | ธุรกิจ | 商业"
    },
    {
        "id":524,
        "name":"523 (Thai Program)  :  Tourism Business | ธุรกิจการท่องเที่ยว | 旅游业务"
    },
    {
        "id":525,
        "name":"524 (Thai Program)  :  Agricultural Business | ธุรกิจการเกษตร | 农业业务"
    },
    {
        "id":526,
        "name":"525 (Thai Program)  :  Hotel Business | ธุรกิจการโรงแรม | 酒店业务"
    },
    {
        "id":527,
        "name":"526 (Thai Program)  :  Maritime Business | ธุรกิจพาณิชยนาวี | 海事业务"
    },
    {
        "id":528,
        "name":"527 (Thai Program)  :  International Business | ธุรกิจระหว่างประเทศ | 国际业务"
    },
    {
        "id":529,
        "name":"528 (Thai Program)  :  Business Studies | ธุรกิจศึกษา | 商业研究"
    },
    {
        "id":530,
        "name":"529 (Thai Program)  :  Real Estate Business | ธุรกิจอสังหาริมทรัพย์ | 房地产业务"
    },
    {
        "id":531,
        "name":"530 (Thai Program)  :  Gems And Jewelry Business | ธุรกิจอัญมณีและเครื่องประดับ | 宝石和珠宝业务"
    },
    {
        "id":532,
        "name":"531 (Thai Program)  :  Food Business | ธุรกิจอาหาร | 食品事业"
    },
    {
        "id":533,
        "name":"532 (Thai Program)  :  Industrial Business | ธุรกิจอุตสาหกรรม | 工业企业"
    },
    {
        "id":534,
        "name":"533 (Thai Program)  :  Agricultural Business | ธุรกิจเกษตร | 农业业务"
    },
    {
        "id":535,
        "name":"534 (Thai Program)  :  Creative Arts | นฤมิตศิลป์ | 创意艺术"
    },
    {
        "id":536,
        "name":"535 (Thai Program)  :  Recreation | นันทนาการ | 娱乐"
    },
    {
        "id":537,
        "name":"536 (English Program)  :  Fashion Design | การออกแบบแฟชั่น | 时装设计"
    },
    {
        "id":538,
        "name":"537 (Thai Program)  :  Dance | นาฏยศิลป์ | 舞蹈"
    },
    {
        "id":539,
        "name":"538 (English Program)  :  Finance | การเงิน | 金融"
    },
    {
        "id":540,
        "name":"539 (Thai Program)  :  Thai Dance | นาฏยศิลป์ไทย | 泰国舞蹈"
    },
    {
        "id":541,
        "name":"540 (Thai Program)  :  Dance | นาฏศาสตร์ | 舞蹈"
    },
    {
        "id":542,
        "name":"541 (Thai Program)  :  International Dance | นาฏศิลปสากล | 国际舞蹈"
    },
    {
        "id":543,
        "name":"542 (Thai Program)  :  Thai Dance Studies | นาฏศิลป์ไทยศึกษา | 泰国舞蹈研究"
    },
    {
        "id":544,
        "name":"543 (Thai Program)  :  Dance | นาฏศิลป์ | 舞蹈"
    },
    {
        "id":545,
        "name":"544 (English Program)  :  Financial Economics | เศรษฐศาสตร์การเงิน | 金融经济学"
    },
    {
        "id":546,
        "name":"545 (Thai Program)  :  Dance And Drama | นาฏศิลป์และการละคร | 舞蹈和戏剧"
    },
    {
        "id":547,
        "name":"546 (Thai Program)  :  Thai Dance | นาฏศิลป์ไทย | 泰国舞蹈"
    },
    {
        "id":548,
        "name":"547 (Thai Program)  :  Jurisprudence | นิติศาสตร์ | 法理学"
    },
    {
        "id":549,
        "name":"548 (Thai Program)  :  Forensic Medicine | นิติเวชวิทยา | 法医学"
    },
    {
        "id":550,
        "name":"549 (Thai Program)  :  Forensic Medicine | นิติเวชศาสตร์ | 法医学"
    },
    {
        "id":551,
        "name":"550 (English Program)  :  Fine And Applied Arts | วิจิตรศิลป์และศิลปะประยุกต์ | 美术与应用艺术"
    },
    {
        "id":552,
        "name":"551 (Thai Program)  :  Nuclear Technology | นิวเคลียร์เทคโนโลยี | 核技术"
    },
    {
        "id":553,
        "name":"552 (Thai Program)  :  Educational Supervision And Curriculum Development | นิเทศการศึกษาและพัฒนาหลักสูตร | 教育监督和课程开发"
    },
    {
        "id":554,
        "name":"553 (Thai Program)  :  Communication Arts | นิเทศศาสตร์ | 传播艺术"
    },
    {
        "id":555,
        "name":"554 (English Program)  :  Fine And Applied Arts (Communication Arts) | วิจิตรศิลป์และศิลปะประยุกต์ (ศิลปะการสื่อสาร) | 美术与应用艺术（传播艺术）"
    },
    {
        "id":556,
        "name":"555 (English Program)  :  Fine Arts | วิจิตรศิลป์ | 美术"
    },
    {
        "id":557,
        "name":"556 (Thai Program)  :  Developmental Communication Arts | นิเทศศาสตร์พัฒนาการ | 发展传播艺术"
    },
    {
        "id":558,
        "name":"557 (English Program)  :  Fisheries | การประมง | 渔业"
    },
    {
        "id":559,
        "name":"558 (Thai Program)  :  Communication Arts | นิเทศศิลป์ | 传播艺术"
    },
    {
        "id":560,
        "name":"559 (Thai Program)  :  Ecology | นิเวศวิทยา | 生态"
    },
    {
        "id":561,
        "name":"560 (Thai Program)  :  Environmental Ecology | นิเวศวิทยาสิ่งแวดล้อม | 环境生态学"
    },
    {
        "id":562,
        "name":"561 (Thai Program)  :  Public Policy | นโยบายสาธารณะ | 公共政策"
    },
    {
        "id":563,
        "name":"562 (Thai Program)  :  Communication Policy And Planning | นโยบายและการวางแผนการสื่อสาร | 传播政策和规划"
    },
    {
        "id":564,
        "name":"563 (Thai Program)  :  Social Policy And Planning | นโยบายและการวางแผนสังคม | 社会政策和规划"
    },
    {
        "id":565,
        "name":"564 (Thai Program)  :  Librarianship | บรรณารักษศาสตร์ | 图书馆管理"
    },
    {
        "id":566,
        "name":"565 (Thai Program)  :  Library And Information Science | บรรณารักษศาสตร์และสารนิเทศศาสตร์ | 图书情报学"
    },
    {
        "id":567,
        "name":"566 (Thai Program)  :  Library And Information Science | บรรณารักษศาสตร์และสารสนเทศศาสตร์ | 图书情报学"
    },
    {
        "id":568,
        "name":"567 (Thai Program)  :  Librarian And Information Science | บรรณารักษ์และสารนิเทศศาสตร์ | 图书馆员和信息科学"
    },
    {
        "id":569,
        "name":"568 (Thai Program)  :  Academic Support Services For Blind Or Low Vision People | บริการสนับสนุนทางวิชาการสำหรับคนตาบอดหรือคนสายตาเลือนลาง | 为盲人或弱视人士提供学术支持服务"
    },
    {
        "id":570,
        "name":"569 (English Program)  :  Food Engineering | วิศวกรรมอาหาร | 食品工程"
    },
    {
        "id":571,
        "name":"570 (Thai Program)  :  Administer Medical And Public Health Law | บริหารกฎหมายการแพทย์และสาธารณสุข | 管理医疗和公共卫生法"
    },
    {
        "id":572,
        "name":"571 (Thai Program)  :  Development Management | บริหารการพัฒนา | 开发管理"
    },
    {
        "id":573,
        "name":"572 (Thai Program)  :  Community Development Management | บริหารการพัฒนาชุมชน | 社区发展管理"
    },
    {
        "id":574,
        "name":"573 (Thai Program)  :  Educational Administration | บริหารการศึกษา | 教育行政"
    },
    {
        "id":575,
        "name":"574 (English Program)  :  Food Industry And Service | อุตสาหกรรมอาหารและการบริการ | 食品工业和服务"
    },
    {
        "id":576,
        "name":"575 (Thai Program)  :  Agricultural And Forestry Management | บริหารการเกษตรและป่าไม้ | 农林管理"
    },
    {
        "id":577,
        "name":"576 (Thai Program)  :  Administration Of Justice | บริหารงานยุติธรรม | 司法行政"
    },
    {
        "id":578,
        "name":"577 (Thai Program)  :  Business Administration | บริหารธุรกิจ | 商业管理"
    },
    {
        "id":579,
        "name":"578 (English Program)  :  Food Process Engineering | วิศวกรรมกระบวนการอาหาร | 食品加工工程"
    },
    {
        "id":580,
        "name":"579 (Thai Program)  :  Agricultural Business Administration | บริหารธุรกิจการเกษตร | 农业工商管理"
    },
    {
        "id":581,
        "name":"580 (English Program)  :  Food Product Development | การพัฒนาผลิตภัณฑ์อาหาร | 食品开发"
    },
    {
        "id":582,
        "name":"581 (Thai Program)  :  Public Administration | บริหารรัฐกิจ | 公共行政"
    },
    {
        "id":583,
        "name":"582 (Thai Program)  :  Public Health Administration | บริหารสาธารณสุข | 公共卫生管理"
    },
    {
        "id":584,
        "name":"583 (English Program)  :  Food Science And Technology | วิทยาศาสตร์การอาหารและเทคโนโลยี | 食品科学与技术"
    },
    {
        "id":585,
        "name":"584 (Thai Program)  :  Administration Of Vocational And Technical Education | บริหารอาชีวะและเทคนิคศึกษา | 职业技术教育管理"
    },
    {
        "id":586,
        "name":"585 (English Program)  :  Food Service Industry | อุตสาหกรรมบริการอาหาร | 食品服务业"
    },
    {
        "id":587,
        "name":"586 (Thai Program)  :  Industrial And Operational Management | บริหารอุตสาหการและปฏิบัติการ | 工业和运营管理"
    },
    {
        "id":588,
        "name":"587 (Thai Program)  :  Information Technology Management | บริหารเทคโนโลยีสารสนเทศ | 信息技术管理"
    },
    {
        "id":589,
        "name":"588 (Thai Program)  :  Pharmaceutical Administration | บริหารเภสัชกิจ | 药品管理"
    },
    {
        "id":590,
        "name":"589 (Thai Program)  :  Hospital Management | บริหารโรงพยาบาล | 医院管理"
    },
    {
        "id":591,
        "name":"590 (Thai Program)  :  Volunteer Graduate | บัณฑิตอาสาสมัคร | 志愿者毕业生"
    },
    {
        "id":592,
        "name":"591 (Thai Program)  :  Rural Development Volunteer Graduate | บัณฑิตอาสาสมัครพัฒนาชนบท | 农村发展志愿者毕业生"
    },
    {
        "id":593,
        "name":"592 (Thai Program)  :  Bali Sanskrit | บาลีสันสกฤต | 巴厘岛梵语"
    },
    {
        "id":594,
        "name":"593 (Thai Program)  :  Pali Buddhism | บาลีพุทธศาสตร์ | 巴利语佛教"
    },
    {
        "id":595,
        "name":"594 (Thai Program)  :  Oral And Facial Reconstruction | บูรณะช่องปากและใบหน้า | 口腔和面部重建"
    },
    {
        "id":596,
        "name":"595 (Thai Program)  :  Home And Community | บ้านและชุมชน | 家庭和社区"
    },
    {
        "id":597,
        "name":"596 (Thai Program)  :  Agronomy | ปฐพีวิทยา | 农艺学"
    },
    {
        "id":598,
        "name":"597 (Thai Program)  :  Soil Science | ปฐพีศาสตร์ | 土壤科学"
    },
    {
        "id":599,
        "name":"598 (English Program)  :  Food Technology | เทคโนโลยีอาหาร | 食品科技"
    },
    {
        "id":600,
        "name":"599 (Thai Program)  :  Soil Science And Conservation | ปฐพีศาสตร์และอนุรักษศาสตร์ | 土壤科学与保护"
    },
    {
        "id":601,
        "name":"600 (Thai Program)  :  Early Childhood Education | ปฐมวัยศึกษา | 幼儿教育"
    },
    {
        "id":602,
        "name":"601 (Thai Program)  :  Parasitology | ปรสิตวิทยา | 寄生虫学"
    },
    {
        "id":603,
        "name":"602 (Thai Program)  :  Medical Parasitology | ปรสิตวิทยาทางการแพทย์ | 医学寄生虫学"
    },
    {
        "id":604,
        "name":"603 (Thai Program)  :  Insurance | ประกันภัย | 保险"
    },
    {
        "id":605,
        "name":"604 (Thai Program)  :  Population, Resources And Environment | ประชากร ทรัพยากร และสิ่งแวดล้อม | 人口、资源和环境"
    },
    {
        "id":606,
        "name":"605 (English Program)  :  Foreign Language Teaching | การสอนภาษาต่างประเทศ | 外语教学"
    },
    {
        "id":607,
        "name":"606 (Thai Program)  :  Demography | ประชากรศาสตร์ | 人口统计学"
    },
    {
        "id":608,
        "name":"607 (Thai Program)  :  Study Population | ประชากรศึกษา | 研究人群"
    },
    {
        "id":609,
        "name":"608 (Thai Program)  :  Population And Development | ประชากรและการพัฒนา | 人口与发展"
    },
    {
        "id":610,
        "name":"609 (Thai Program)  :  Population And Education | ประชากรและการศึกษา | 人口与教育"
    },
    {
        "id":611,
        "name":"610 (Thai Program)  :  Population And Agriculture | ประชากรและการเกษตร | 人口与农业"
    },
    {
        "id":612,
        "name":"611 (Thai Program)  :  Population And Human Resources | ประชากรและทรัพยากรมนุษย์ | 人口与人力资源"
    },
    {
        "id":613,
        "name":"612 (Thai Program)  :  Population And Health | ประชากรและสุขภาพ | 人口与健康"
    },
    {
        "id":614,
        "name":"613 (Thai Program)  :  Sculpture | ประติมากรรม | 雕塑"
    },
    {
        "id":615,
        "name":"614 (Thai Program)  :  Primary Education | ประถมศึกษา | 初等教育"
    },
    {
        "id":616,
        "name":"615 (English Program)  :  Forensic Science | นิติวิทยาศาสตร์ | 法医学"
    },
    {
        "id":617,
        "name":"616 (Thai Program)  :  Fishing | ประมง | 钓鱼"
    },
    {
        "id":618,
        "name":"617 (Thai Program)  :  Freshwater Fishing | ประมงน้ำจืด | 淡水捕鱼"
    },
    {
        "id":619,
        "name":"618 (Thai Program)  :  Applied Arts Education | ประยุกตศิลปศึกษา | 应用艺术教育"
    },
    {
        "id":620,
        "name":"619 (Thai Program)  :  History | ประวัติศาสตร์ | 历史"
    },
    {
        "id":621,
        "name":"620 (English Program)  :  Game Design And Multimedia | การออกแบบเกมและมัลติมีเดีย | 游戏设计和多媒体"
    },
    {
        "id":622,
        "name":"621 (Thai Program)  :  Art History | ประวัติศาสตร์ศิลปะ | 艺术史"
    },
    {
        "id":623,
        "name":"622 (Thai Program)  :  Thai Art History | ประวัติศาสตร์ศิลปะไทย | 泰国艺术史"
    },
    {
        "id":624,
        "name":"623 (Thai Program)  :  Architectural History | ประวัติศาสตร์สถาปัตยกรรม | 建筑史"
    },
    {
        "id":625,
        "name":"624 (Thai Program)  :  Economic History | ประวัติศาสตร์เศรษฐกิจ | 经济史"
    },
    {
        "id":626,
        "name":"625 (Thai Program)  :  Southeast Asian History | ประวัติศาสตร์เอเชียตะวันออกเฉียงใต้ | 东南亚历史"
    },
    {
        "id":627,
        "name":"626 (Thai Program)  :  Neurology | ประสาทวิทยา | 神经病学"
    },
    {
        "id":628,
        "name":"627 (Thai Program)  :  Neuroscience | ประสาทวิทยาศาสตร์ | 神经科学"
    },
    {
        "id":629,
        "name":"628 (Thai Program)  :  Clinical Preventive Medicine Neurology | ประสาทวิทยาเวชศาสตร์ป้องกันคลินิก | 临床预防医学神经病学"
    },
    {
        "id":630,
        "name":"629 (Thai Program)  :  Neurosurgery | ประสาทศัลยศาสตร์ | 神经外科"
    },
    {
        "id":631,
        "name":"630 (Thai Program)  :  Philosophy | ปรัชญา | 哲学"
    },
    {
        "id":632,
        "name":"631 (Thai Program)  :  Philosophy And Religion | ปรัชญาและศาสนา | 哲学与宗教"
    },
    {
        "id":633,
        "name":"632 (English Program)  :  General Administration | การบริหารงานทั่วไป | 一般行政"
    },
    {
        "id":634,
        "name":"633 (English Program)  :  General Management | การจัดการทั่วไป | 一般管理"
    },
    {
        "id":635,
        "name":"634 (Thai Program)  :  Periodontics | ปริทันตวิทยา | 牙周病学"
    },
    {
        "id":636,
        "name":"635 (Thai Program)  :  Periodontics | ปริทันตศาสตร์ | 牙周病学"
    },
    {
        "id":637,
        "name":"636 (Thai Program)  :  Petrochemical | ปิโตรเคมี | 石化"
    },
    {
        "id":638,
        "name":"637 (English Program)  :  Government | รัฐบาล | 政府"
    },
    {
        "id":639,
        "name":"638 (Thai Program)  :  Petrochemicals And Polymer Materials | ปิโตรเคมีและวัสดุพอลิเมอร์ | 石油化工及高分子材料"
    },
    {
        "id":640,
        "name":"639 (Thai Program)  :  Petrochemical And Polymer Science | ปิโตรเคมีและวิทยาศาสตร์พอลิเมอร์ | 石油化学与高分子科学"
    },
    {
        "id":641,
        "name":"640 (Thai Program)  :  Petrochemicals And Hydrocarbon Chemistry | ปิโตรเคมีและเคมีของไฮโดรคาร์บอน | 石油化工和碳氢化合物化学"
    },
    {
        "id":642,
        "name":"641 (Thai Program)  :  Midwife | ผดุงครรภ์ | 助产士"
    },
    {
        "id":643,
        "name":"642 (Thai Program)  :  Biological Production | ผลิตกรรมชีวภาพ | 生物生产"
    },
    {
        "id":644,
        "name":"643 (Thai Program)  :  Fishery Products | ผลิตภัณฑ์ประมง | 水产品"
    },
    {
        "id":645,
        "name":"644 (Thai Program)  :  Dental Assistant | ผู้ช่วยทันตแพทย์ | 牙科助理"
    },
    {
        "id":646,
        "name":"645 (Thai Program)  :  Nursing Assistant | ผู้ช่วยพยาบาล | 护理助理"
    },
    {
        "id":647,
        "name":"646 (English Program)  :  Graphic Arts | ศิลปะกราฟิก | 平面艺术"
    },
    {
        "id":648,
        "name":"647 (Thai Program)  :  Radiologic Technology Assistant | ผู้ช่วยรังสีเทคนิค | 放射技术助理"
    },
    {
        "id":649,
        "name":"648 (English Program)  :  Health Education | สุขศึกษา | 健康教育"
    },
    {
        "id":650,
        "name":"649 (Thai Program)  :  Cloth And Clothing | ผ้าและเครื่องแต่งกาย | 布料和服装"
    },
    {
        "id":651,
        "name":"650 (Thai Program)  :  French Studies | ฝรั่งเศสศึกษา | 法国研究"
    },
    {
        "id":652,
        "name":"651 (Thai Program)  :  Medical Science Employee (1St Year) | พนักงานวิทยาศาสตร์การแพทย์ (ปีที่ 1) | 医学科学职员（第一年）"
    },
    {
        "id":653,
        "name":"652 (Thai Program)  :  Medical Science Employee (2Nd Year) | พนักงานวิทยาศาสตร์การแพทย์ (ปีที่ 2) | 医学科学职员（第2年）"
    },
    {
        "id":654,
        "name":"653 (English Program)  :  Health Informatics | สารสนเทศด้านสุขภาพ | 健康信息学"
    },
    {
        "id":655,
        "name":"654 (English Program)  :  Health Promotion | การส่งเสริมสุขภาพ | 健康促进"
    },
    {
        "id":656,
        "name":"655 (Thai Program)  :  Salesperson | พนักงานเซลส์วิทยา | 营业员"
    },
    {
        "id":657,
        "name":"656 (Thai Program)  :  Rehabilitation Medicine Staff | พนักงานเวชกรรมฟื้นฟู | 康复医学科人员"
    },
    {
        "id":658,
        "name":"657 (Thai Program)  :  Burmese Studies | พม่าศึกษา | 缅甸研究"
    },
    {
        "id":659,
        "name":"658 (Thai Program)  :  Pathobiology | พยาธิชีววิทยา | 病理生物学"
    },
    {
        "id":660,
        "name":"659 (Thai Program)  :  Veterinary Pathobiology | พยาธิชีววิทยาทางสัตวแพทย์ | 兽医病理学"
    },
    {
        "id":661,
        "name":"660 (Thai Program)  :  Pathology | พยาธิวิทยา | 病理"
    },
    {
        "id":662,
        "name":"661 (Thai Program)  :  Anatomical Pathology | พยาธิวิทยากายวิภาค | 解剖病理学"
    },
    {
        "id":663,
        "name":"662 (Thai Program)  :  Clinical Pathology | พยาธิวิทยาคลินิก | 临床病理学"
    },
    {
        "id":664,
        "name":"663 (Thai Program)  :  General Pathology | พยาธิวิทยาทั่วไป | 一般病理学"
    },
    {
        "id":665,
        "name":"664 (Thai Program)  :  Veterinary Pathology | พยาธิวิทยาทางสัตวแพทย์ | 兽医病理学"
    },
    {
        "id":666,
        "name":"665 (Thai Program)  :  Nursing Science | พยาบาลศาสตร์ | 护理学"
    },
    {
        "id":667,
        "name":"666 (English Program)  :  Health Science | วิทยาศาสตร์สุขภาพ | 健康科学"
    },
    {
        "id":668,
        "name":"667 (Thai Program)  :  Nursing Studies | พยาบาลศึกษา | 护理研究"
    },
    {
        "id":669,
        "name":"668 (Thai Program)  :  Public Health Nurse | พยาบาลสาธารณสุข | 公共卫生护士"
    },
    {
        "id":670,
        "name":"669 (Thai Program)  :  Practical Nurse | พยาบาลเวชปฏิบัติ | 实习护士"
    },
    {
        "id":671,
        "name":"670 (Thai Program)  :  Nurses And Midwives | พยาบาลและผดุงครรภ์ | 护士和助产士"
    },
    {
        "id":672,
        "name":"671 (English Program)  :  Health Technology Management | การจัดการเทคโนโลยีด้านสุขภาพ | 健康技术管理"
    },
    {
        "id":673,
        "name":"672 (Thai Program)  :  Buddhism | พระพุทธศาสนา | 佛教"
    },
    {
        "id":674,
        "name":"673 (Thai Program)  :  Abhidhamma | พระอภิธรรม | 阿毗达磨"
    },
    {
        "id":675,
        "name":"674 (English Program)  :  Higher Education | อุดมศึกษา | 高等教育"
    },
    {
        "id":676,
        "name":"675 (Thai Program)  :  Botany | พฤกษศาสตร์ | 植物学"
    },
    {
        "id":677,
        "name":"676 (Thai Program)  :  Phruek Setthakit | พฤกษ์เศรษฐกิจ | 普鲁克·塞塔吉特"
    },
    {
        "id":678,
        "name":"677 (Thai Program)  :  Gymnastics | พลศึกษา | 体操"
    },
    {
        "id":679,
        "name":"678 (Thai Program)  :  Renewable Energy | พลังงานทดแทน | 可再生能源"
    },
    {
        "id":680,
        "name":"679 (Thai Program)  :  Development | พัฒนศาสตร์ | 发展"
    },
    {
        "id":681,
        "name":"680 (Thai Program)  :  Development Studies | พัฒนศึกษา | 发展研究"
    },
    {
        "id":682,
        "name":"681 (Thai Program)  :  Development Studies | พัฒนศึกษาศาสตร์ | 发展研究"
    },
    {
        "id":683,
        "name":"682 (Thai Program)  :  Family And Child Development | พัฒนาการครอบครัวและเด็ก | 家庭与儿童发展"
    },
    {
        "id":684,
        "name":"683 (Thai Program)  :  Tourism Development | พัฒนาการท่องเที่ยว | 旅游开发"
    },
    {
        "id":685,
        "name":"684 (Thai Program)  :  Human Development | พัฒนาการมนุษย์ | 人类发展"
    },
    {
        "id":686,
        "name":"685 (Thai Program)  :  Agricultural Development | พัฒนาการเกษตร | 农业发展"
    },
    {
        "id":687,
        "name":"686 (Thai Program)  :  Child And Family Development | พัฒนาการเด็กและครอบครัว | 儿童和家庭发展"
    },
    {
        "id":688,
        "name":"687 (Thai Program)  :  Rural Development Studies | พัฒนาชนบทศึกษา | 农村发展研究"
    },
    {
        "id":689,
        "name":"688 (Thai Program)  :  Community Development | พัฒนาชุมชน | 社区发展"
    },
    {
        "id":690,
        "name":"689 (English Program)  :  Law | กฎ | 法律"
    },
    {
        "id":691,
        "name":"690 (Thai Program)  :  Develop Agricultural Industrial Products | พัฒนาผลิตภัณฑ์อุตสาหกรรมเกษตร | 发展农业工业产品"
    },
    {
        "id":692,
        "name":"691 (English Program)  :  Land And Property Law | กฎหมายที่ดินและทรัพย์สิน | 土地和财产法"
    },
    {
        "id":693,
        "name":"692 (Thai Program)  :  Human And Social Development | พัฒนามนุษย์และสังคม | 人类和社会发展"
    },
    {
        "id":694,
        "name":"693 (Thai Program)  :  Develop Public Health Information Systems | พัฒนาระบบสารสนเทศสาธารณสุข | 发展公共卫生信息系统"
    },
    {
        "id":695,
        "name":"694 (Thai Program)  :  Social Development | พัฒนาสังคม | 社会发展"
    },
    {
        "id":696,
        "name":"695 (Thai Program)  :  Genetic Engineering | พันธุวิศวกรรม | 基因工程"
    },
    {
        "id":697,
        "name":"696 (Thai Program)  :  Genetics | พันธุศาสตร์ | 遗传学"
    },
    {
        "id":698,
        "name":"697 (Thai Program)  :  Maritime Commerce | พาณิชยนาวี | 海上贸易"
    },
    {
        "id":699,
        "name":"698 (Thai Program)  :  Toxicology | พิษวิทยา | 毒理学"
    },
    {
        "id":700,
        "name":"699 (Thai Program)  :  Vegetables | พืชผัก | 蔬菜"
    },
    {
        "id":701,
        "name":"700 (Thai Program)  :  Plant Science | พืชศาสตร์ | 植物科学"
    },
    {
        "id":702,
        "name":"701 (Thai Program)  :  Plant Science – Horticulture | พืชศาสตร์ – พืชสวน | 植物科学 - 园艺"
    },
    {
        "id":703,
        "name":"702 (Thai Program)  :  Plant Science – Agronomy | พืชศาสตร์ – พืชไร่นา | 植物科学 - 农学"
    },
    {
        "id":704,
        "name":"703 (Thai Program)  :  Horticulture | พืชสวน | 园艺"
    },
    {
        "id":705,
        "name":"704 (Thai Program)  :  Ornamental Garden Plants | พืชสวนประดับ | 园林观赏植物"
    },
    {
        "id":706,
        "name":"705 (Thai Program)  :  Field Crops | พืชไร่ | 大田作物"
    },
    {
        "id":707,
        "name":"706 (Thai Program)  :  Agronomy | พืชไร่นา | 农艺学"
    },
    {
        "id":708,
        "name":"707 (Thai Program)  :  Basic Education | พื้นฐานการศึกษา | 基础教育"
    },
    {
        "id":709,
        "name":"708 (English Program)  :  Intellectual Property, Internationaltrade And Arbitration | ทรัพย์สินทางปัญญา การค้าระหว่างประเทศ และการอนุญาโตตุลาการ | 知识产权、国际贸易和仲裁"
    },
    {
        "id":710,
        "name":"709 (Thai Program)  :  Study Area | พื้นที่ศึกษา | 研究区"
    },
    {
        "id":711,
        "name":"710 (Thai Program)  :  Buddhist Psychology | พุทธจิตวิทยา | 佛教心理学"
    },
    {
        "id":712,
        "name":"711 (English Program)  :  Business Law | กฎหมายธุรกิจ | 商业法"
    },
    {
        "id":713,
        "name":"712 (Thai Program)  :  Buddhist Studies | พุทธศาสนศึกษา | 佛学研究"
    },
    {
        "id":714,
        "name":"713 (Thai Program)  :  Buddhism And Philosophy | พุทธศาสนาและปรัชญา | 佛教与哲学"
    },
    {
        "id":715,
        "name":"714 (Thai Program)  :  Buddhist Studies | พุทธศาสน์ศึกษา | 佛学研究"
    },
    {
        "id":716,
        "name":"715 (English Program)  :  International Trade Law | กฎหมายการค้าระหว่างประเทศ | 国际贸易法"
    },
    {
        "id":717,
        "name":"716 (Thai Program)  :  Physics | ฟิสิกส์ | 物理"
    },
    {
        "id":718,
        "name":"717 (Thai Program)  :  Medical Physics | ฟิสิกส์การแพทย์ | 医学物理学"
    },
    {
        "id":719,
        "name":"718 (Thai Program)  :  Applied Physics | ฟิสิกส์ประยุกต์ | 应用物理"
    },
    {
        "id":720,
        "name":"719 (Thai Program)  :  Applied Physics - Scientific And Industrial Instruments | ฟิสิกส์ประยุกต์ - เครื่องมือวิทยาศาสตร์และอุตสาหกรรม | 应用物理 - 科学和工业仪器"
    },
    {
        "id":721,
        "name":"720 (Thai Program)  :  Polymer Physics | ฟิสิกส์พอลิเมอร์ | 高分子物理学"
    },
    {
        "id":722,
        "name":"721 (Thai Program)  :  Physics Education | ฟิสิกส์ศึกษา | 物理教育"
    },
    {
        "id":723,
        "name":"722 (Thai Program)  :  Electronic Physics | ฟิสิกส์อิเล็กทรอนิกส์ | 电子物理学"
    },
    {
        "id":724,
        "name":"723 (Thai Program)  :  Industrial Physics And Medical Devices | ฟิสิกส์อุตสาหกรรมและอุปกรณ์การแพทย์ | 工业物理和医​​疗设备"
    },
    {
        "id":725,
        "name":"724 (Thai Program)  :  Physics Instrumentation | ฟิสิกส์เครื่องมือวัด | 物理仪器"
    },
    {
        "id":726,
        "name":"725 (Thai Program)  :  Chemical Physics | ฟิสิกส์เชิงเคมี | 化学物理"
    },
    {
        "id":727,
        "name":"726 (English Program)  :  Public Law | กฎหมายมหาชน | 公法"
    },
    {
        "id":728,
        "name":"727 (Thai Program)  :  Photo Print | ภาพพิมพ์ | 照片打印"
    },
    {
        "id":729,
        "name":"728 (Thai Program)  :  Movies | ภาพยนตร์ | 电影"
    },
    {
        "id":730,
        "name":"729 (Thai Program)  :  Movies And Videos | ภาพยนต์และวิดีโอ | 电影和视频"
    },
    {
        "id":731,
        "name":"730 (Thai Program)  :  Chinese | ภาษาจีน | 中国人"
    },
    {
        "id":732,
        "name":"731 (Thai Program)  :  Mandarin | ภาษาจีนกลาง | 普通话"
    },
    {
        "id":733,
        "name":"732 (Thai Program)  :  Basic Chinese For Communication | ภาษาจีนพื้นฐานเพื่อการสื่อสาร | 基础汉语沟通"
    },
    {
        "id":734,
        "name":"733 (Thai Program)  :  Japanese | ภาษาญี่ปุ่น | 日本人"
    },
    {
        "id":735,
        "name":"734 (English Program)  :  International Law | กฎหมายระหว่างประเทศ | 国际法"
    },
    {
        "id":736,
        "name":"735 (Thai Program)  :  Business Japanese | ภาษาญี่ปุ่นธุรกิจ | 商务日语"
    },
    {
        "id":737,
        "name":"736 (Thai Program)  :  Eastern Language | ภาษาตะวันออก | 东方语言"
    },
    {
        "id":738,
        "name":"737 (Thai Program)  :  Pali Language | ภาษาบาลี | 巴利语"
    },
    {
        "id":739,
        "name":"738 (Thai Program)  :  Pali And Sanskrit | ภาษาบาลีและสันสกฤต | 巴利文和梵文"
    },
    {
        "id":740,
        "name":"739 (Thai Program)  :  Current Language | ภาษาปัจจุบัน | 当前语言"
    },
    {
        "id":741,
        "name":"740 (Thai Program)  :  French Language | ภาษาฝรั่งเศส | 法语"
    },
    {
        "id":742,
        "name":"741 (Thai Program)  :  Business French | ภาษาฝรั่งเศสธุรกิจ | 商务法语"
    },
    {
        "id":743,
        "name":"742 (Thai Program)  :  Malay Language | ภาษามลายู | 马来语"
    },
    {
        "id":744,
        "name":"743 (English Program)  :  Criminal Law | กฎหมายอาญา | 刑法"
    },
    {
        "id":745,
        "name":"744 (Thai Program)  :  Thai Sign Language | ภาษามือไทย | 泰国手语"
    },
    {
        "id":746,
        "name":"745 (Thai Program)  :  Russian Language | ภาษารัสเซีย | 俄语"
    },
    {
        "id":747,
        "name":"746 (Thai Program)  :  Linguistics | ภาษาศาสตร์ | 语言学"
    },
    {
        "id":748,
        "name":"747 (Thai Program)  :  Educational Linguistics | ภาษาศาสตร์การศึกษา | 教育语言学"
    },
    {
        "id":749,
        "name":"748 (Thai Program)  :  Applied Linguistics | ภาษาศาสตร์ประยุกต์ | 应用语言学"
    },
    {
        "id":750,
        "name":"749 (Thai Program)  :  Applied Linguistics (Self-Reliant English Learning) | ภาษาศาสตร์ประยุกต์ (การเรียนรู้ภาษาอังกฤษแบบพึ่งตนเอง) | 应用语言学（自力更生的英语学习）"
    },
    {
        "id":751,
        "name":"750 (Thai Program)  :  Applied Linguistics-English For Science And Technology | ภาศาสตร์ประยุกต์-ภาษาอังกฤษเพื่อวิทยาศาสตร์และเทคโนโลยี | 应用语言学-科技英语"
    },
    {
        "id":752,
        "name":"751 (Thai Program)  :  Applied Linguistics In Teaching | ภาษาศาสตร์ประยุกต์ด้านการสอน | 教学中的应用语言学"
    },
    {
        "id":753,
        "name":"752 (Thai Program)  :  Communication Linguistics | ภาษาศาสตร์เพื่อการสื่อสาร | 交际语言学"
    },
    {
        "id":754,
        "name":"753 (Thai Program)  :  Linguistics And Southeast Asian Languages | ภาษาศาสตร์และภาษาเอเชียอาคเนย์ | 语言学和东南亚语言"
    },
    {
        "id":755,
        "name":"754 (Thai Program)  :  Sanskrit Language | ภาษาสันสกฤต | 梵语"
    },
    {
        "id":756,
        "name":"755 (Thai Program)  :  Spanish | ภาษาสเปน | 西班牙语"
    },
    {
        "id":757,
        "name":"756 (English Program)  :  Islamic Law | กฎหมายอิสลาม | 伊斯兰教法"
    },
    {
        "id":758,
        "name":"757 (Thai Program)  :  English | ภาษาอังกฤษ | 英语"
    },
    {
        "id":759,
        "name":"758 (Thai Program)  :  Business English | ภาษาอังกฤษธุรกิจ | 商务英语"
    },
    {
        "id":760,
        "name":"759 (Thai Program)  :  Business English For International Communication | ภาษาอังกฤษธุรกิจเพื่อการสื่อสารนานาชาติ | 国际交流商务英语"
    },
    {
        "id":761,
        "name":"760 (Thai Program)  :  English Studies | ภาษาอังกฤษศึกษา | 英语研究"
    },
    {
        "id":762,
        "name":"761 (English Program)  :  Economic Law | กฎหมายเศรษฐกิจ | 经济法"
    },
    {
        "id":763,
        "name":"762 (Thai Program)  :  Special English | ภาษาอังกฤษเฉพาะกิจ | 特殊英语"
    },
    {
        "id":764,
        "name":"763 (Thai Program)  :  English Is An International Language. | ภาษาอังกฤษเป็นภาษานานาชาติ | 英语是一种国际语言。"
    },
    {
        "id":765,
        "name":"764 (English Program)  :  Private Law | กฎหมายเอกชน | 私法"
    },
    {
        "id":766,
        "name":"765 (English Program)  :  Management And Tourism | การจัดการและการท่องเที่ยว | 管理与旅游"
    },
    {
        "id":767,
        "name":"766 (Thai Program)  :  English For International Communication | ภาษาอังกฤษเพื่อการสื่อสารสากล | 国际交流英语"
    },
    {
        "id":768,
        "name":"767 (Thai Program)  :  English For Business Communication | ภาษาอังกฤษเพื่อการสื่อสารเชิงธุรกิจ | 商务沟通英语"
    },
    {
        "id":769,
        "name":"768 (Thai Program)  :  English For Business And Industry | ภาษาอังกฤษเพื่อธุรกิจและอุตสาหกรรม | 商业和工业英语"
    },
    {
        "id":770,
        "name":"769 (Thai Program)  :  English For Specific Purposes | ภาษาอังกฤษเพื่อวัตถุประสงค์เฉพาะ | 特定目的英语"
    },
    {
        "id":771,
        "name":"770 (Thai Program)  :  English For Careers | ภาษาอังกฤษเพื่ออาชีพ | 职业英语"
    },
    {
        "id":772,
        "name":"771 (Thai Program)  :  English And Communication | ภาษาอังกฤษและการสื่อสาร | 英语与交流"
    },
    {
        "id":773,
        "name":"772 (Thai Program)  :  Arabic Language | ภาษาอาหรับ | 阿拉伯语"
    },
    {
        "id":774,
        "name":"773 (Thai Program)  :  Italian Language | ภาษาอิตาเลียน | 意大利语"
    },
    {
        "id":775,
        "name":"774 (Thai Program)  :  Korean Language | ภาษาเกาหลี | 朝鲜语"
    },
    {
        "id":776,
        "name":"775 (Thai Program)  :  Khmer Language | ภาษาเขมร | 高棉语"
    },
    {
        "id":777,
        "name":"776 (Thai Program)  :  Professional Language | ภาษาเพื่ออาชีพ | 专业语言"
    },
    {
        "id":778,
        "name":"777 (Thai Program)  :  German Language | ภาษาเยอรมัน | 德语"
    },
    {
        "id":779,
        "name":"778 (Thai Program)  :  German For International Communication | ภาษาเยอรมันเพื่อการสื่อสารสากล | 国际交流德语"
    },
    {
        "id":780,
        "name":"779 (Thai Program)  :  German As A Foreign Language | ภาษาเยอรมันในฐานะภาษาต่างประเทศ | 德语作为外语"
    },
    {
        "id":781,
        "name":"780 (Thai Program)  :  Language And Communication | ภาษาและการสื่อสาร | 语言与沟通"
    },
    {
        "id":782,
        "name":"781 (Thai Program)  :  Lanna Language And Literature | ภาษาและวรรณกรรมล้านนา | 兰纳语言和文学"
    },
    {
        "id":783,
        "name":"782 (Thai Program)  :  Japanese Language And Literature | ภาษาและวรรณคดีญี่ปุ่น | 日本语言文学"
    },
    {
        "id":784,
        "name":"783 (Thai Program)  :  French Language And Literature | ภาษาและวรรณคดีฝรั่งเศส | 法语语言和文学"
    },
    {
        "id":785,
        "name":"784 (Thai Program)  :  English Language And Literature | ภาษาและวรรณคดีอังกฤษ | 英语语言和文学"
    },
    {
        "id":786,
        "name":"785 (Thai Program)  :  Thai Language And Literature | ภาษาและวรรณคดีไทย | 泰国语言和文学"
    },
    {
        "id":787,
        "name":"786 (Thai Program)  :  Language And Culture For Communication And Development | ภาษาและวัฒนธรรมเพื่อการสื่อสารและการพัฒนา | 语言和文化促进交流和发展"
    },
    {
        "id":788,
        "name":"787 (Thai Program)  :  Thai Language | ภาษาไทย | 泰语"
    },
    {
        "id":789,
        "name":"788 (English Program)  :  Physical Therapy | กายภาพบำบัด | 物理治疗"
    },
    {
        "id":790,
        "name":"789 (English Program)  :  Physiotherapy | กายภาพบำบัด | 理疗"
    },
    {
        "id":791,
        "name":"790 (Thai Program)  :  Regional Studies | ภูมิภาคศึกษา | 区域研究"
    },
    {
        "id":792,
        "name":"791 (Thai Program)  :  Geography | ภูมิศาสตร์ | 地理"
    },
    {
        "id":793,
        "name":"792 (Thai Program)  :  Physical And Environmental Geography | ภูมิศาสตร์กายภาพและสิ่งแวดล้อม | 自然与环境地理学"
    },
    {
        "id":794,
        "name":"793 (Thai Program)  :  Geography Of Human Settlement Planning | ภูมิศาสตร์การวางแผนการตั้งถิ่นฐานมนุษย์ | 人居环境规划地理学"
    },
    {
        "id":795,
        "name":"794 (Thai Program)  :  Human Geography | ภูมิศาสตร์มนุษย์ | 人文地理学"
    },
    {
        "id":796,
        "name":"795 (Thai Program)  :  Industrial Geography | ภูมิศาสตร์อุตสาหกรรม | 工业地理学"
    },
    {
        "id":797,
        "name":"796 (Thai Program)  :  Landscape Architecture | ภูมิสถาปัตยกรรม | 景观设计"
    },
    {
        "id":798,
        "name":"797 (Thai Program)  :  Malay Studies | มลายูศึกษา | 马来研究"
    },
    {
        "id":799,
        "name":"798 (Thai Program)  :  Secondary Education | มัธยมศึกษา | 中等教育"
    },
    {
        "id":800,
        "name":"799 (Thai Program)  :  Metrology | มาตรวิทยา | 计量学"
    },
    {
        "id":801,
        "name":"800 (English Program)  :  Clinical Physical Therapy | กายภาพบำบัดทางคลินิก | 临床物理治疗"
    },
    {
        "id":802,
        "name":"801 (Thai Program)  :  Industrial Metrology | มาตรวิทยาทางอุตสาหกรรม | 工业计量"
    },
    {
        "id":803,
        "name":"802 (Thai Program)  :  Anthropology | มานุษยดุริยางควิทยา | 人类学"
    },
    {
        "id":804,
        "name":"803 (Thai Program)  :  Anthropology | มานุษยวิทยา | 人类学"
    },
    {
        "id":805,
        "name":"804 (Thai Program)  :  Applied Anthropology | มานุษยวิทยาประยุกต์ | 应用人类学"
    },
    {
        "id":806,
        "name":"805 (Thai Program)  :  Development Strategy | ยุทธศาสตร์การพัฒนา | 发展战略"
    },
    {
        "id":807,
        "name":"806 (Thai Program)  :  European Studies | ยุโรปศึกษา | 欧洲研究"
    },
    {
        "id":808,
        "name":"807 (English Program)  :  Manipulative Physical Therapy | กายภาพบำบัดแบบบิดเบือน | 手法物理治疗"
    },
    {
        "id":809,
        "name":"808 (English Program)  :  Anatomy | กายวิภาคศาสตร์ | 解剖学"
    },
    {
        "id":810,
        "name":"809 (English Program)  :  Veterinary Anatomy | กายวิภาคศาสตร์ทางสัตวแพทย์ | 兽医解剖学"
    },
    {
        "id":811,
        "name":"810 (Thai Program)  :  Decision Support System | ระบบสนับสนุนการตัดสินใจ | 决策支持系统"
    },
    {
        "id":812,
        "name":"811 (Thai Program)  :  Information System | ระบบสารสนเทศ | 信息系统"
    },
    {
        "id":813,
        "name":"812 (English Program)  :  Prosthetics And Orthotics | กายอุปกรณ์และกายอุปกรณ์ | 假肢和矫形器"
    },
    {
        "id":814,
        "name":"813 (Thai Program)  :  Computer Information System | ระบบสารสนเทศคอมพิวเตอร์ | 计算机信息系统"
    },
    {
        "id":815,
        "name":"814 (Thai Program)  :  Management Information System | ระบบสารสนเทศทางการจัดการ | 管理信息系统"
    },
    {
        "id":816,
        "name":"815 (Thai Program)  :  Accounting Information System | ระบบสารสนเทศทางการบัญชี | 会计信息系统"
    },
    {
        "id":817,
        "name":"816 (Thai Program)  :  Applied Information Systems | ระบบสารสนเทศประยุกต์ | 应用信息系统"
    },
    {
        "id":818,
        "name":"817 (Thai Program)  :  Engineering Spatial Information System | ระบบสารสนเทศปริภูมิทางวิศวกรรม | 工程空间信息系统"
    },
    {
        "id":819,
        "name":"818 (Thai Program)  :  Geographic Information System | ระบบสารสนเทศภูมิศาสตร์ | 地理信息系统"
    },
    {
        "id":820,
        "name":"819 (English Program)  :  Health Consumer Protection | การคุ้มครองผู้บริโภคด้านสุขภาพ | 健康消费者保护"
    },
    {
        "id":821,
        "name":"820 (English Program)  :  Air Cargo Management | การจัดการสินค้าทางอากาศ | 航空货运管理"
    },
    {
        "id":822,
        "name":"821 (Thai Program)  :  Health Systems And Policies | ระบบและนโยบายสุขภาพ | 卫生系统和政策"
    },
    {
        "id":823,
        "name":"822 (Thai Program)  :  Epidemiology | ระบาดวิทยา | 流行病学"
    },
    {
        "id":824,
        "name":"823 (Thai Program)  :  Applied Radiation And Isotopes | รังสีประยุกต์และไอโซโทป | 应用辐射和同位素"
    },
    {
        "id":825,
        "name":"824 (English Program)  :  Transport And Logistics Management | การจัดการขนส่งและโลจิสติกส์ | 运输和物流管理"
    },
    {
        "id":826,
        "name":"825 (Thai Program)  :  Radiology | รังสีวิทยา | 放射学"
    },
    {
        "id":827,
        "name":"826 (Thai Program)  :  Oral And Maxillofacial Radiology | รังสีวิทยาช่องปากและแม็กซิลโลเฟเชียล | 口腔颌面放射学"
    },
    {
        "id":828,
        "name":"827 (Thai Program)  :  Oral And Facial Radiology | รังสีวิทยาช่องปากและใบหน้า | 口腔和面部放射学"
    },
    {
        "id":829,
        "name":"828 (Thai Program)  :  Nuclear Medicine Radiology | รังสีวิทยารักษาเวชศาสตร์นิวเคลียร์ | 核医学放射学"
    },
    {
        "id":830,
        "name":"829 (Thai Program)  :  Diagnostic Radiology | รังสีวินิจฉัย | 诊断放射学"
    },
    {
        "id":831,
        "name":"830 (English Program)  :  Ecotourism Management | การจัดการการท่องเที่ยวเชิงนิเวศ | 生态旅游管理"
    },
    {
        "id":832,
        "name":"831 (English Program)  :  Crop Production Management | การจัดการการผลิตพืชผล | 农作物生产管理"
    },
    {
        "id":833,
        "name":"832 (Thai Program)  :  Radiological Technology | รังสีเทคนิค | 放射技术"
    },
    {
        "id":834,
        "name":"833 (English Program)  :  Animal Production Management | การจัดการการผลิตสัตว์ | 动物生产管理"
    },
    {
        "id":835,
        "name":"834 (English Program)  :  Rural Development Management | การจัดการพัฒนาชนบท | 农村发展管理"
    },
    {
        "id":836,
        "name":"835 (Thai Program)  :  Public Administration | รัฐประศาสนศาสตร์ | 公共行政"
    },
    {
        "id":837,
        "name":"836 (English Program)  :  Social Development Management | การจัดการพัฒนาสังคม | 社会发展管理"
    },
    {
        "id":838,
        "name":"837 (Thai Program)  :  Political Science | รัฐศาสตร์ | 政治学"
    },
    {
        "id":839,
        "name":"838 (Thai Program)  :  Political Science (Government) | รัฐศาสตร์ (การปกครอง) | 政治学（政府）"
    },
    {
        "id":840,
        "name":"839 (English Program)  :  International Transportation Management | การจัดการการขนส่งระหว่างประเทศ | 国际运输管理"
    },
    {
        "id":841,
        "name":"840 (Thai Program)  :  Political Science And Government | รัฐศาสตร์การปกครอง | 政治学与政府"
    },
    {
        "id":842,
        "name":"841 (Thai Program)  :  Product Cycle | วนผลิตภัณฑ์ | 产品周期"
    },
    {
        "id":843,
        "name":"842 (Thai Program)  :  Forestry Science | วนวัฒนวิทยา | 林业科学"
    },
    {
        "id":844,
        "name":"843 (Thai Program)  :  Forestry | วนศาสตร์ | 林业"
    },
    {
        "id":845,
        "name":"844 (Thai Program)  :  Community Forestry | วนศาสตร์ชุมชน | 社区林业"
    },
    {
        "id":846,
        "name":"845 (English Program)  :  Quality Management | การจัดการคุณภาพ | 质量管理"
    },
    {
        "id":847,
        "name":"846 (Thai Program)  :  Tropical Forestry | วนศาสตร์เขตร้อน | 热带林业"
    },
    {
        "id":848,
        "name":"847 (Thai Program)  :  Children'S Literature | วรรณกรรมสำหรับเด็ก | 儿童文学"
    },
    {
        "id":849,
        "name":"848 (Thai Program)  :  English Literature | วรรณคดีอังกฤษ | 英国文学"
    },
    {
        "id":850,
        "name":"849 (Thai Program)  :  Comparative Literature | วรรณคดีเปรียบเทียบ | 比较文学"
    },
    {
        "id":851,
        "name":"850 (Thai Program)  :  Literature And Comparative Literature | วรรณคดีและวรรณคดีเปรียบเทียบ | 文学与比较文学"
    },
    {
        "id":852,
        "name":"851 (Thai Program)  :  Thai Literature | วรรณคดีไทย | 泰国文学"
    },
    {
        "id":853,
        "name":"852 (English Program)  :  Archives And Records Management | จดหมายเหตุและการจัดการบันทึก | 档案和记录管理"
    },
    {
        "id":854,
        "name":"853 (English Program)  :  Air Traffic Management | การจัดการจราจรทางอากาศ | 空中交通管理"
    },
    {
        "id":855,
        "name":"854 (Thai Program)  :  Cultural Studies | วัฒนธรรมศึกษา | 文化研究"
    },
    {
        "id":856,
        "name":"855 (Thai Program)  :  Educational Measures | วัดผลการศึกษา | 教育措施"
    },
    {
        "id":857,
        "name":"856 (Thai Program)  :  Materials Science | วัสดุศาสตร์ | 材料科学"
    },
    {
        "id":858,
        "name":"857 (Thai Program)  :  Materials Science (Gems And Jewelry) | วัสดุศาสตร์ (อัญมณีและเครื่องประดับ) | 材料科学（宝石和珠宝）"
    },
    {
        "id":859,
        "name":"858 (Thai Program)  :  Materials Science-Gem Technology | วัสดุศาสตร์-เทคโนโลยีอัญมณี | 材料科学-宝石科技"
    },
    {
        "id":860,
        "name":"859 (Thai Program)  :  Rhetoric | วาทวิทยา | 修辞"
    },
    {
        "id":861,
        "name":"860 (Thai Program)  :  Rhetoric (Correction Of Speech Impairments) | วาทวิทยา (การแก้ไขความบกพร่องทางการพูด) | 修辞学（纠正言语障碍）"
    },
    {
        "id":862,
        "name":"861 (Thai Program)  :  Rhetoric And Performance Communication | วาทวิทยาและสื่อสารการแสดง | 修辞与表演沟通"
    },
    {
        "id":863,
        "name":"862 (Thai Program)  :  Journalism | วารสารศาสตร์ | 新闻学"
    },
    {
        "id":864,
        "name":"863 (Thai Program)  :  Journalism And Public Relations | วารสารศาสตร์และการประชาสัมพันธ์ | 新闻与公共关系"
    },
    {
        "id":865,
        "name":"864 (Thai Program)  :  Information Journal | วารสารสนเทศ | 信息杂志"
    },
    {
        "id":866,
        "name":"865 (Thai Program)  :  Aquatic Science | วาริชศาสตร์ | 水生科学"
    },
    {
        "id":867,
        "name":"866 (English Program)  :  Education For Human Resource Development | การศึกษาเพื่อการพัฒนาทรัพยากรมนุษย์ | 人力资源开发教育"
    },
    {
        "id":868,
        "name":"867 (Thai Program)  :  Educational Research | วิจัยการศึกษา | 教育研究"
    },
    {
        "id":869,
        "name":"868 (Thai Program)  :  Reproductive Health Population Research | วิจัยประชากรอนามัยเจริญพันธุ์ | 人口生殖健康研究"
    },
    {
        "id":870,
        "name":"869 (Thai Program)  :  Population Research And Family Planning | วิจัยประชากรและการวางแผนครอบครัว | 人口研究和计划生育"
    },
    {
        "id":871,
        "name":"870 (Thai Program)  :  Population And Social Research | วิจัยประชากรและสังคม | 人口与社会研究"
    },
    {
        "id":872,
        "name":"871 (Thai Program)  :  Research Farming Systems | วิจัยระบบการทำฟาร์ม | 研究农业系统"
    },
    {
        "id":873,
        "name":"872 (Thai Program)  :  Mass Communication Research | วิจัยสื่อสารมวลชน | 大众传播研究"
    },
    {
        "id":874,
        "name":"873 (Thai Program)  :  Educational Research And Evaluation | วิจัยและประเมินผลการศึกษา | 教育研究与评估"
    },
    {
        "id":875,
        "name":"874 (Thai Program)  :  Research And Develop Curriculum | วิจัยและพัฒนาหลักสูตร | 研究和开发课程"
    },
    {
        "id":876,
        "name":"875 (Thai Program)  :  Research And Development Of Pharmaceuticals | วิจัยและพัฒนาเภสัชภัณฑ์ | 药品研发"
    },
    {
        "id":877,
        "name":"876 (Thai Program)  :  Research And Education Statistics | วิจัยและสถิติการศึกษา | 研究和教育统计"
    },
    {
        "id":878,
        "name":"877 (Thai Program)  :  Fine Arts | วิจิตรศิลป์ | 美术"
    },
    {
        "id":879,
        "name":"878 (Thai Program)  :  Accounting Profession | วิชาชีพการบัญชี | 会计专业"
    },
    {
        "id":880,
        "name":"879 (English Program)  :  Community Management | การจัดการชุมชน | 社区管理"
    },
    {
        "id":881,
        "name":"880 (Thai Program)  :  Teaching Profession | วิชาชีพครู | 教学职业"
    },
    {
        "id":882,
        "name":"881 (English Program)  :  Production And Operation Management | การจัดการการผลิตและการดำเนินงาน | 生产经营管理"
    },
    {
        "id":883,
        "name":"882 (Thai Program)  :  Science Teacher Profession | วิชาชีพครูวิทยาศาสตร์ | 科学教师职业"
    },
    {
        "id":884,
        "name":"883 (English Program)  :  Agricultural Resources And Environment Management | การจัดการทรัพยากรเกษตรและสิ่งแวดล้อม | 农业资源与环境管理"
    },
    {
        "id":885,
        "name":"884 (Thai Program)  :  General Education Subjects | วิชาศึกษาทั่วไป | 通识教育科目"
    },
    {
        "id":886,
        "name":"885 (Thai Program)  :  Computational Science | วิทยาการคณนา | 计算科学"
    },
    {
        "id":887,
        "name":"886 (Thai Program)  :  Computer Science | วิทยาการคอมพิวเตอร์ | 计算机科学"
    },
    {
        "id":888,
        "name":"887 (Thai Program)  :  Applied Computer Science | วิทยาการคอมพิวเตอร์ประยุกต์ | 应用计算机科学"
    },
    {
        "id":889,
        "name":"888 (Thai Program)  :  Applied Computer Science - Multimedia | วิทยาการคอมพิวเตอร์ประยุกต์ - มัลติมิเดีย | 应用计算机科学-多媒体"
    },
    {
        "id":890,
        "name":"889 (Thai Program)  :  Computer Science And Information Technology | วิทยาการคอมพิวเตอร์และเทคโนโลยีสารสนเทศ | 计算机科学与信息技术"
    },
    {
        "id":891,
        "name":"890 (Thai Program)  :  Management Science | วิทยาการจัดการ | 管理科学"
    },
    {
        "id":892,
        "name":"891 (Thai Program)  :  Industrial Management Science | วิทยาการจัดการอุตสาหกรรม | 工业管理科学"
    },
    {
        "id":893,
        "name":"892 (Thai Program)  :  Insurance Science | วิทยาการประกันภัย | 保险科学"
    },
    {
        "id":894,
        "name":"893 (Thai Program)  :  Epidemiology | วิทยาการระบาด | 流行病学"
    },
    {
        "id":895,
        "name":"894 (Thai Program)  :  Clinical Epidemiology | วิทยาการระบาดคลินิก | 临床流行病学"
    },
    {
        "id":896,
        "name":"895 (Thai Program)  :  Medical Epidemiology | วิทยาการระบาดทางการแพทย์ | 医学流行病学"
    },
    {
        "id":897,
        "name":"896 (Thai Program)  :  Animal Reproductive Science | วิทยาการสืบพันธุ์สัตว์ | 动物生殖科学"
    },
    {
        "id":898,
        "name":"897 (Thai Program)  :  Post-Harvest Technology | วิทยาการหลังการเก็บเกี่ยว | 采后技术"
    },
    {
        "id":899,
        "name":"898 (Thai Program)  :  Robotics And Automation | วิทยาการหุ่นยนต์และระบบอัตโนมัติ | 机器人与自动化"
    },
    {
        "id":900,
        "name":"899 (Thai Program)  :  Nautical Science | วิทยาการเดินเรือ | 航海科学"
    },
    {
        "id":901,
        "name":"900 (Thai Program)  :  Polymer Science And Engineering | วิทยาการและวิศวกรรมพอลิเมอร์ | 高分子科学与工程"
    },
    {
        "id":902,
        "name":"901 (Thai Program)  :  Medical Laboratory Science | วิทยาปฏิบัติการทางการแพทย์ | 医学实验室科学"
    },
    {
        "id":903,
        "name":"902 (Thai Program)  :  Immunology | วิทยาภูมิคุ้มกัน | 免疫学"
    },
    {
        "id":904,
        "name":"903 (Thai Program)  :  Clinical Immunology | วิทยาภูมิคุ้มกันคลินิก | 临床免疫学"
    },
    {
        "id":905,
        "name":"904 (Thai Program)  :  Science | วิทยาศาสตร์ | 科学"
    },
    {
        "id":906,
        "name":"905 (Thai Program)  :  Science - Mathematics | วิทยาศาสตร์ - คณิตศาสตร์ | 科学 - 数学"
    },
    {
        "id":907,
        "name":"906 (Thai Program)  :  General Science And Biology | วิทยาศาสตร์ทั่วไปและชีววิทยา | 普通科学和生物学"
    },
    {
        "id":908,
        "name":"907 (Thai Program)  :  Science - Physics | วิทยาศาสตร์ - ฟิสิกส์ | 科学-物理"
    },
    {
        "id":909,
        "name":"908 (Thai Program)  :  General Science And Chemistry | วิทยาศาสตร์ทั่วไปและเคมี | 普通科学和化学"
    },
    {
        "id":910,
        "name":"909 (English Program)  :  Soil Resources Management | การจัดการทรัพยากรดิน | 土壤资源管理"
    },
    {
        "id":911,
        "name":"910 (English Program)  :  Environmental And Natural Resource Management | การจัดการทรัพยากรสิ่งแวดล้อมและธรรมชาติ | 环境和自然资源管理"
    },
    {
        "id":912,
        "name":"911 (English Program)  :  Forest Resources Management | การจัดการทรัพยากรป่าไม้ | 森林资源管理"
    },
    {
        "id":913,
        "name":"912 (English Program)  :  Airport Management | การจัดการสนามบิน | 机场管理"
    },
    {
        "id":914,
        "name":"913 (English Program)  :  Tourist Business Management | การจัดการธุรกิจท่องเที่ยว | 旅游商业管理"
    },
    {
        "id":915,
        "name":"914 (English Program)  :  General Business Management | การจัดการธุรกิจทั่วไป | 一般商业管理"
    },
    {
        "id":916,
        "name":"915 (Thai Program)  :  Science - Agriculture | วิทยาศาสตร์ - เกษตร | 科学-农业"
    },
    {
        "id":917,
        "name":"916 (English Program)  :  International Business Management | การจัดการธุรกิจระหว่างประเทศ | 国际商务管理"
    },
    {
        "id":918,
        "name":"917 (Thai Program)  :  Biological Physical Science | วิทยาศาสตร์กายภาพชีวภาพ | 生物物理科学"
    },
    {
        "id":919,
        "name":"918 (English Program)  :  Agribusiness And Food Industry Management | การจัดการธุรกิจการเกษตรและอุตสาหกรรมอาหาร | 农业企业和食品工业管理"
    },
    {
        "id":920,
        "name":"919 (Thai Program)  :  Sports Science | วิทยาศาสตร์การกีฬา | 运动科学"
    },
    {
        "id":921,
        "name":"920 (English Program)  :  Fisheries Management | การจัดการประมง | 渔业管理"
    },
    {
        "id":922,
        "name":"921 (Thai Program)  :  Sports Science – Sports Training And Management | วิทยาศาสตร์การกีฬา – การฝึกและการจัดการกีฬา | 运动科学——运动训练与管理"
    },
    {
        "id":923,
        "name":"922 (Thai Program)  :  Blood Service Science | วิทยาศาสตร์การบริการโลหิต | 血液服务科学"
    },
    {
        "id":924,
        "name":"923 (Thai Program)  :  Fisheries Science | วิทยาศาสตร์การประมง | 水产科学"
    },
    {
        "id":925,
        "name":"924 (Thai Program)  :  Veterinary Science | วิทยาศาสตร์การสัตวแพทย์ | 兽医学"
    },
    {
        "id":926,
        "name":"925 (Thai Program)  :  Exercise And Sports Science | วิทยาศาสตร์การออกกำลังกายและการกีฬา | 运动与运动科学"
    },
    {
        "id":927,
        "name":"926 (Thai Program)  :  Food Science | วิทยาศาสตร์การอาหาร | 食品科学"
    },
    {
        "id":928,
        "name":"927 (English Program)  :  Forest Management | การจัดการป่าไม้ | 森林管理"
    },
    {
        "id":929,
        "name":"928 (Thai Program)  :  Food Science And Nutrition | วิทยาศาสตร์การอาหารและโภชนาการ | 食品科学与营养"
    },
    {
        "id":930,
        "name":"929 (Thai Program)  :  Agricultural Science | วิทยาศาสตร์การเกษตร | 农业科学"
    },
    {
        "id":931,
        "name":"930 (Thai Program)  :  Aquaculture Science | วิทยาศาสตร์การเพาะเลี้ยงสัตว์น้ำ | 水产养殖科学"
    },
    {
        "id":932,
        "name":"931 (Thai Program)  :  Medical Science | วิทยาศาสตร์การแพทย์ | 医学"
    },
    {
        "id":933,
        "name":"932 (Thai Program)  :  Clinical Science | วิทยาศาสตร์คลินิก | 临床科学"
    },
    {
        "id":934,
        "name":"933 (Thai Program)  :  Safety Science | วิทยาศาสตร์ความปลอดภัย | 安全科学"
    },
    {
        "id":935,
        "name":"934 (Thai Program)  :  Computer Science | วิทยาศาสตร์คอมพิวเตอร์ | 计算机科学"
    },
    {
        "id":936,
        "name":"935 (Thai Program)  :  Biophysical Science | วิทยาศาสตร์ชีวฟิสิกส์ | 生物物理科学"
    },
    {
        "id":937,
        "name":"936 (English Program)  :  Health Product Management | การจัดการผลิตภัณฑ์เพื่อสุขภาพ | 保健品管理"
    },
    {
        "id":938,
        "name":"937 (English Program)  :  Urban Planning Management | การจัดการการวางผังเมือง | 城市规划管理"
    },
    {
        "id":939,
        "name":"938 (Thai Program)  :  Biological Sciences | วิทยาศาสตร์ชีวภาพ | 生物科学"
    },
    {
        "id":940,
        "name":"939 (Thai Program)  :  Forest Biological Science | วิทยาศาสตร์ชีวภาพป่าไม้ | 森林生物科学"
    },
    {
        "id":941,
        "name":"940 (Thai Program)  :  Biostatistics Science | วิทยาศาสตร์ชีวสถิติ | 生物统计学科学"
    },
    {
        "id":942,
        "name":"941 (English Program)  :  Man And Environment Management | การจัดการมนุษย์และสิ่งแวดล้อม | 人与环境管理"
    },
    {
        "id":943,
        "name":"942 (Thai Program)  :  Marine Science | วิทยาศาสตร์ทางทะเล | 海洋科学"
    },
    {
        "id":944,
        "name":"943 (Thai Program)  :  Polymer Science | วิทยาศาสตร์พอลิเมอร์ | 高分子科学"
    },
    {
        "id":945,
        "name":"944 (Thai Program)  :  Applied Polymer Science And Textile Technology | วิทยาศาสตร์พอลิเมอร์ประยุกต์และเทคโนโลยีสิ่งทอ | 应用高分子科学与纺织技术"
    },
    {
        "id":946,
        "name":"945 (Thai Program)  :  Earth Science | วิทยาศาสตร์พื้นพิภพ | 地球科学"
    },
    {
        "id":947,
        "name":"946 (Thai Program)  :  Macromolecular Science | วิทยาศาสตร์มหโมเลกุล | 高分子科学"
    },
    {
        "id":948,
        "name":"947 (Thai Program)  :  Radiation Science | วิทยาศาสตร์รังสี | 放射科学"
    },
    {
        "id":949,
        "name":"948 (Thai Program)  :  Science Studies | วิทยาศาสตร์ศึกษา | 科学研究"
    },
    {
        "id":950,
        "name":"949 (Thai Program)  :  Science Studies – Biology | วิทยาศาสตร์ศึกษา – ชีววิทยา | 科学研究——生物学"
    },
    {
        "id":951,
        "name":"950 (Thai Program)  :  Science Education – Physics | วิทยาศาสตร์ศึกษา – ฟิสิกส์ | 科学教育——物理"
    },
    {
        "id":952,
        "name":"951 (Thai Program)  :  Environmental Science | วิทยาศาสตร์สิ่งแวดล้อม | 环境科学"
    },
    {
        "id":953,
        "name":"952 (Thai Program)  :  Health Sciences | วิทยาศาสตร์สุขภาพ | 健康科学"
    },
    {
        "id":954,
        "name":"953 (English Program)  :  Architectural Heritage | มรดกทางสถาปัตยกรรม | 建筑遗产"
    },
    {
        "id":955,
        "name":"954 (Thai Program)  :  Health Sciences – Child Health Promotion | วิทยาศาสตร์สุขภาพ – การส่งเสริมสุขภาพเด็ก | 健康科学 – 儿童健康促进"
    },
    {
        "id":956,
        "name":"955 (Thai Program)  :  Oral Health Science | วิทยาศาสตร์สุขภาพช่องปาก | 口腔健康科学"
    },
    {
        "id":957,
        "name":"956 (English Program)  :  Architectural Heritage Management And Tourism | การจัดการมรดกทางสถาปัตยกรรมและการท่องเที่ยว | 建筑遗产管理和旅游"
    },
    {
        "id":958,
        "name":"957 (Thai Program)  :  Animal Health Science | วิทยาศาสตร์สุขภาพสัตว์ | 动物健康科学"
    },
    {
        "id":959,
        "name":"958 (Thai Program)  :  Sanitary Science | วิทยาศาสตร์สุขาภิบาล | 卫生科学"
    },
    {
        "id":960,
        "name":"959 (Thai Program)  :  Environmental Health Science | วิทยาศาสตร์อนามัยสิ่งแวดล้อม | 环境健康科学"
    },
    {
        "id":961,
        "name":"960 (English Program)  :  Information Systems Management | การจัดการระบบสารสนเทศ | 信息系统管理"
    },
    {
        "id":962,
        "name":"961 (Thai Program)  :  Computational Science | วิทยาศาสตร์เชิงคำนวณ | 计算科学"
    },
    {
        "id":963,
        "name":"962 (English Program)  :  Watershed Management | การจัดการลุ่มน้ำ | 流域管理"
    },
    {
        "id":964,
        "name":"963 (Thai Program)  :  Materials Science And Engineering | วิทยาศาสตร์และวิศวกรรมวัสดุ | 材料科学与工程"
    },
    {
        "id":965,
        "name":"964 (Thai Program)  :  Science And Technology | วิทยาศาสตร์และเทคโนโลยี | 科学技术"
    },
    {
        "id":966,
        "name":"965 (Thai Program)  :  Food Science And Technology | วิทยาศาสตร์และเทคโนโลยีการอาหาร | 食品科学与技术"
    },
    {
        "id":967,
        "name":"966 (English Program)  :  Pest Management | การจัดการสัตว์รบกวน | 害虫防治"
    },
    {
        "id":968,
        "name":"967 (Thai Program)  :  Wood Science And Technology | วิทยาศาสตร์และเทคโนโลยีทางไม้ | 木材科学与技术"
    },
    {
        "id":969,
        "name":"968 (English Program)  :  Information Management On Environmental And Resources | การจัดการสารสนเทศด้านสิ่งแวดล้อมและทรัพยากร | 环境与资源信息管理"
    },
    {
        "id":970,
        "name":"969 (Thai Program)  :  Polymer Science And Technology | วิทยาศาสตร์และเทคโนโลยีพอลิเมอร์ | 高分子科学与技术"
    },
    {
        "id":971,
        "name":"970 (Thai Program)  :  Textile Science And Technology | วิทยาศาสตร์และเทคโนโลยีสิ่งทอ | 纺织科学与技术"
    },
    {
        "id":972,
        "name":"971 (Thai Program)  :  Environmental Science And Technology | วิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม | 环境科学与技术"
    },
    {
        "id":973,
        "name":"972 (Thai Program)  :  Endodontics | วิทยาเอนโดดอนต์ | 牙髓病学"
    },
    {
        "id":974,
        "name":"973 (Thai Program)  :  Endodontics | วิทยาเอ็นโดดอนต์ | 牙髓病学"
    },
    {
        "id":975,
        "name":"974 (Thai Program)  :  Radio And Television | วิทยุและโทรทัศน์ | 广播电视"
    },
    {
        "id":976,
        "name":"975 (Thai Program)  :  Research Methodology | วิธีวิทยาการวิจัย | 研究方法"
    },
    {
        "id":977,
        "name":"976 (Thai Program)  :  Educational Research Methods | วิธีวิทยาการวิจัยการศึกษา | 教育研究方法"
    },
    {
        "id":978,
        "name":"977 (Thai Program)  :  Process Engineering | วิศวกรรมกระบวนการ | 过程工程"
    },
    {
        "id":979,
        "name":"978 (Thai Program)  :  Food Process Engineering | วิศวกรรมกระบวนการอาหาร | 食品加工工程"
    },
    {
        "id":980,
        "name":"979 (Thai Program)  :  Construction Engineering | วิศวกรรมการก่อสร้าง | 建筑工程"
    },
    {
        "id":981,
        "name":"980 (English Program)  :  Management For Executive | การจัดการสำหรับผู้บริหาร | 行政管理"
    },
    {
        "id":982,
        "name":"981 (Thai Program)  :  Industrial Management Engineering | วิศวกรรมการจัดการอุตสาหกรรม | 工业管理工程"
    },
    {
        "id":983,
        "name":"982 (Thai Program)  :  Aerospace Engineering | วิศวกรรมการบินและอวกาศ | 航空航天工程"
    },
    {
        "id":984,
        "name":"983 (Thai Program)  :  Aerospace Engineering | วิศวกรรมการบินและอวกาศยาน | 航空航天工程"
    },
    {
        "id":985,
        "name":"984 (English Program)  :  Environmental Management | การจัดการสิ่งแวดล้อม | 环境管理"
    },
    {
        "id":986,
        "name":"985 (Thai Program)  :  Production Engineering | วิศวกรรมการผลิต | 生产工程"
    },
    {
        "id":987,
        "name":"986 (Thai Program)  :  Instrumentation Engineering | วิศวกรรมการวัดคุม | 仪器仪表工程"
    },
    {
        "id":988,
        "name":"987 (English Program)  :  Environmental Horticulture Management | การจัดการพืชสวนสิ่งแวดล้อม | 环境园艺管理"
    },
    {
        "id":989,
        "name":"988 (Thai Program)  :  Food Engineering | วิศวกรรมการอาหาร | 食品工程"
    },
    {
        "id":990,
        "name":"989 (Thai Program)  :  Welding Engineering | วิศวกรรมการเชื่อม | 焊接工程"
    },
    {
        "id":991,
        "name":"990 (Thai Program)  :  Material Handling Engineering | วิศวกรรมขนถ่ายวัสดุ | 物料搬运工程"
    },
    {
        "id":992,
        "name":"991 (Thai Program)  :  Transportation Engineering | วิศวกรรมขนส่ง | 交通工程"
    },
    {
        "id":993,
        "name":"992 (Thai Program)  :  Safety Engineering | วิศวกรรมความปลอดภัย | 安全工程"
    },
    {
        "id":994,
        "name":"993 (Thai Program)  :  Precision Engineering | วิศวกรรมความเที่ยงตรง | 精密工程"
    },
    {
        "id":995,
        "name":"994 (Thai Program)  :  Computer Engineering | วิศวกรรมคอมพิวเตอร์ | 计算机工程"
    },
    {
        "id":996,
        "name":"995 (Thai Program)  :  Irrigation Engineering | วิศวกรรมชลประทาน | 灌溉工程"
    },
    {
        "id":997,
        "name":"996 (Thai Program)  :  Biomedical Engineering | วิศวกรรมชีวการแพทย์ | 生物医学工程"
    },
    {
        "id":998,
        "name":"997 (Thai Program)  :  Software Engineering | วิศวกรรมซอฟต์แวร์ | 软件工程"
    },
    {
        "id":999,
        "name":"998 (Thai Program)  :  Soil And Water Engineering | วิศวกรรมดินและน้ำ | 土壤与水工程"
    },
    {
        "id":1000,
        "name":"999 (Thai Program)  :  Shipbuilding And Ship Mechanical Engineering | วิศวกรรมต่อเรือและเครื่องกลเรือ | 造船及船舶机械工程"
    },
    {
        "id":1001,
        "name":"1000 (Thai Program)  :  Mineral Resources Engineering | วิศวกรรมทรัพยากรธรณี | 矿产资源工程"
    },
    {
        "id":1002,
        "name":"1001 (Thai Program)  :  Water Resources Engineering | วิศวกรรมทรัพยากรน้ำ | 水资源工程"
    },
    {
        "id":1003,
        "name":"1002 (Thai Program)  :  Water Resources Engineering | วิศวกรรมทรัพยากรแหล่งน้ำ | 水资源工程"
    },
    {
        "id":1004,
        "name":"1003 (Thai Program)  :  Nuclear Engineering | วิศวกรรมนิวเคลียร์ | 核工程"
    },
    {
        "id":1005,
        "name":"1004 (Thai Program)  :  Petrochemical Engineering | วิศวกรรมปิโตรเคมี | 石油化工工程"
    },
    {
        "id":1006,
        "name":"1005 (Thai Program)  :  Petroleum Engineering | วิศวกรรมปิโตรเลียม | 石油工程"
    },
    {
        "id":1007,
        "name":"1006 (Thai Program)  :  Forest Engineering | วิศวกรรมป่าไม้ | 森林工程"
    },
    {
        "id":1008,
        "name":"1007 (Thai Program)  :  Energy Engineering | วิศวกรรมพลังงาน | 能源工程"
    },
    {
        "id":1009,
        "name":"1008 (Thai Program)  :  Engineering Plastics | วิศวกรรมพลาสติก | 工程塑料"
    },
    {
        "id":1010,
        "name":"1009 (Thai Program)  :  Polymer Engineering | วิศวกรรมพอลิเมอร์ | 高分子工程"
    },
    {
        "id":1011,
        "name":"1010 (English Program)  :  Industrial Environment Management | การจัดการสิ่งแวดล้อมอุตสาหกรรม | 工业环境管理"
    },
    {
        "id":1012,
        "name":"1011 (Thai Program)  :  Production Systems Engineering | วิศวกรรมระบบการผลิต | 生产系统工程"
    },
    {
        "id":1013,
        "name":"1012 (Thai Program)  :  Control System Engineering | วิศวกรรมระบบควบคุม | 控制系统工程"
    },
    {
        "id":1014,
        "name":"1013 (Thai Program)  :  Control And Instrumentation Engineering | วิศวกรรมระบบควบคุมและเครื่องมือวัด | 控制与仪表工程"
    },
    {
        "id":1015,
        "name":"1014 (Thai Program)  :  Building Systems Engineering | วิศวกรรมระบบสิ่งก่อสร้าง | 建筑系统工程"
    },
    {
        "id":1016,
        "name":"1015 (Thai Program)  :  Instrumentation Systems Engineering | วิศวกรรมระบบเครื่องมือวัด | 仪器仪表系统工程"
    },
    {
        "id":1017,
        "name":"1016 (Thai Program)  :  Materials Engineering | วิศวกรรมวัสดุ | 材料工程"
    },
    {
        "id":1018,
        "name":"1017 (Thai Program)  :  National Defense Engineering And Technology | วิศวกรรมและเทคโนโลยีการป้องกันประเทศ | 国防工程技术"
    },
    {
        "id":1019,
        "name":"1018 (Thai Program)  :  Engineering Or Technology | วิศวกรรมศาสตร์หรือเทคโนโลยี | 工程或技术"
    },
    {
        "id":1020,
        "name":"1019 (Thai Program)  :  Information Engineering | วิศวกรรมสารสนเทศ | 信息工程"
    },
    {
        "id":1021,
        "name":"1020 (Thai Program)  :  Survey Engineering | วิศวกรรมสำรวจ | 测量工程"
    },
    {
        "id":1022,
        "name":"1021 (English Program)  :  Training Management | การจัดการฝึกอบรม | 培训管理"
    },
    {
        "id":1023,
        "name":"1022 (Thai Program)  :  Textile Engineering | วิศวกรรมสิ่งทอ | 纺织工程"
    },
    {
        "id":1024,
        "name":"1023 (Thai Program)  :  Environmental Engineering | วิศวกรรมสิ่งแวดล้อม | 环境工程"
    },
    {
        "id":1025,
        "name":"1024 (Thai Program)  :  Post-Harvest Engineering And Processing | วิศวกรรมหลังการเก็บเกี่ยวและแปรสภาพ | 收获后工程和加工"
    },
    {
        "id":1026,
        "name":"1025 (Thai Program)  :  Food Engineering | วิศวกรรมอาหาร | 食品工程"
    },
    {
        "id":1027,
        "name":"1026 (Thai Program)  :  Electronic Engineering | วิศวกรรมอิเล็กทรอนิกส์ | 电子工程"
    },
    {
        "id":1028,
        "name":"1027 (English Program)  :  Higher Education Management | การจัดการการศึกษาระดับอุดมศึกษา | 高等教育管理"
    },
    {
        "id":1029,
        "name":"1028 (Thai Program)  :  Mechanical Electronic Engineering | วิศวกรรมอิเล็กทรอนิกส์เชิงกล | 机械电子工程"
    },
    {
        "id":1030,
        "name":"1029 (Thai Program)  :  Electronics And Telecommunications Engineering | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม | 电子与电信工程"
    },
    {
        "id":1031,
        "name":"1030 (English Program)  :  Tourism Industry Management | การจัดการอุตสาหกรรมการท่องเที่ยว | 旅游产业管理"
    },
    {
        "id":1032,
        "name":"1031 (English Program)  :  Textile Management | การจัดการสิ่งทอ | 纺织管理"
    },
    {
        "id":1033,
        "name":"1032 (Thai Program)  :  Industrial Engineering | วิศวกรรมอุตสาหการ | 工业工程"
    },
    {
        "id":1034,
        "name":"1033 (Thai Program)  :  Agricultural Engineering | วิศวกรรมเกษตร | 农业工程"
    },
    {
        "id":1035,
        "name":"1034 (Thai Program)  :  Chemical Engineering | วิศวกรรมเคมี | 化工"
    },
    {
        "id":1036,
        "name":"1035 (Thai Program)  :  Textile Chemical Engineering | วิศวกรรมเคมีสิ่งทอ | 纺织化学工程"
    },
    {
        "id":1037,
        "name":"1036 (Thai Program)  :  Chemical And Biological Engineering | วิศวกรรมเคมีและชีวภาพ | 化学与生物工程"
    },
    {
        "id":1038,
        "name":"1037 (Thai Program)  :  Mechanical Engineering | วิศวกรรมเครื่องกล | 机械工业"
    },
    {
        "id":1039,
        "name":"1038 (Thai Program)  :  Mechanical Engineering, Manufacturing Field | วิศวกรรมเครื่องกล สาขาการผลิต | 机械工程、制造领域"
    },
    {
        "id":1040,
        "name":"1039 (Thai Program)  :  Ship Mechanical Engineering | วิศวกรรมเครื่องกลเรือ | 船舶机械工程"
    },
    {
        "id":1041,
        "name":"1040 (Thai Program)  :  Agricultural Machinery Engineering | วิศวกรรมเครื่องจักรกลเกษตร | 农业机械工程"
    },
    {
        "id":1042,
        "name":"1041 (Thai Program)  :  Apparel Engineering | วิศวกรรมเครื่องนุ่งห่ม | 服装工程"
    },
    {
        "id":1043,
        "name":"1042 (Thai Program)  :  Engineering Tools | วิศวกรรมเครื่องมือ | 工程工具"
    },
    {
        "id":1044,
        "name":"1043 (Thai Program)  :  Ceramic Engineering | วิศวกรรมเซรามิก | 陶瓷工程"
    },
    {
        "id":1045,
        "name":"1044 (Thai Program)  :  Geotechnical Engineering | วิศวกรรมเทคนิคธรณี | 岩土工程"
    },
    {
        "id":1046,
        "name":"1045 (Thai Program)  :  Mechatronics Engineering | วิศวกรรมเมคคาทรอนิกส์ | 机电工程"
    },
    {
        "id":1047,
        "name":"1046 (English Program)  :  Agro-Industry Management | การจัดการอุตสาหกรรมเกษตร | 农业产业管理"
    },
    {
        "id":1048,
        "name":"1047 (Thai Program)  :  Ship Engineering | วิศวกรรมเรือ | 船舶工程"
    },
    {
        "id":1049,
        "name":"1048 (Thai Program)  :  Synthetic Fiber Engineering | วิศวกรรมเส้นใยสังเคราะห์ | 合成纤维工程"
    },
    {
        "id":1050,
        "name":"1049 (Thai Program)  :  Mining Engineering | วิศวกรรมเหมืองแร่ | 采矿工程"
    },
    {
        "id":1051,
        "name":"1050 (Thai Program)  :  Mining Engineering And Metallurgy | วิศวกรรมเหมืองแร่และโลหะวิทยา | 采矿工程与冶金"
    },
    {
        "id":1052,
        "name":"1051 (Thai Program)  :  Food Processing Engineering | วิศวกรรมแปรรูปอาหาร | 食品加工工程"
    },
    {
        "id":1053,
        "name":"1052 (Thai Program)  :  Engineering And Construction Management | วิศวกรรมและการบริหารการก่อสร้าง | 工程和施工管理"
    },
    {
        "id":1054,
        "name":"1053 (Thai Program)  :  Water Resources Engineering | วิศวกรรมแหล่งน้ำ | 水资源工程"
    },
    {
        "id":1055,
        "name":"1054 (English Program)  :  Agro-Industry Technology | เทคโนโลยีอุตสาหกรรมเกษตร | 农产品工业技术"
    },
    {
        "id":1056,
        "name":"1055 (English Program)  :  Management Of Information Technology | การจัดการเทคโนโลยีสารสนเทศ | 信息技术管理"
    },
    {
        "id":1057,
        "name":"1056 (English Program)  :  Agro-Industry Technology Management | การจัดการเทคโนโลยีอุตสาหกรรมเกษตร | 农业产业技术管理"
    },
    {
        "id":1058,
        "name":"1057 (Thai Program)  :  Civil Engineering | วิศวกรรมโยธา | 土木工程"
    },
    {
        "id":1059,
        "name":"1058 (Thai Program)  :  Civil Engineering, Building Systems Branch | วิศวกรรมโยธา สาขาระบบอาคาร | 土木工程、建筑系统分部"
    },
    {
        "id":1060,
        "name":"1059 (Thai Program)  :  Civil Engineering, Rural Engineering Branch | วิศวกรรมโยธา สาขาวิศวกรรมชนบท | 土木工程、农村工程分院"
    },
    {
        "id":1061,
        "name":"1060 (Thai Program)  :  Metallurgical Engineering | วิศวกรรมโลหการ | 冶金工程"
    },
    {
        "id":1062,
        "name":"1061 (Thai Program)  :  Metallurgical And Materials Engineering | วิศวกรรมโลหการและวัสดุ | 冶金与材料工程"
    },
    {
        "id":1063,
        "name":"1062 (Thai Program)  :  Electrical Engineering | วิศวกรรมไฟฟ้า | 电气工程"
    },
    {
        "id":1064,
        "name":"1063 (Thai Program)  :  Electrical Engineering - Instrumentation | วิศวกรรมไฟฟ้า - การวัดคุม | 电气工程-仪器仪表"
    },
    {
        "id":1065,
        "name":"1064 (Thai Program)  :  Electrical-Electronic Engineering | วิศวกรรมไฟฟ้า - อิเล็กทรอนิกส์ | 电气电子工程"
    },
    {
        "id":1066,
        "name":"1065 (Thai Program)  :  Electrical Engineering - Telecommunications | วิศวกรรมไฟฟ้า - โทรคมนาคม | 电气工程-电信"
    },
    {
        "id":1067,
        "name":"1066 (Thai Program)  :  Electrical Engineering - Electrical Power | วิศวกรรมไฟฟ้า - ไฟฟ้ากำลัง | 电气工程 - 电力"
    },
    {
        "id":1068,
        "name":"1067 (Thai Program)  :  Electrical Communication Engineering | วิศวกรรมไฟฟ้าสื่อสาร | 电气通讯工程"
    },
    {
        "id":1069,
        "name":"1068 (Thai Program)  :  Electrical Mechanical Engineering Manufacturing | วิศวกรรมไฟฟ้าเครื่องกลการผลิต | 机电工程制造"
    },
    {
        "id":1070,
        "name":"1069 (Thai Program)  :  Electrical And Computer Engineering | วิศวกรรมไฟฟ้าและคอมพิวเตอร์ | 电气与计算机工程"
    },
    {
        "id":1071,
        "name":"1070 (Thai Program)  :  Electrical And Systems Engineering | วิศวกรรมไฟฟ้าและระบบ | 电气和系统工程"
    },
    {
        "id":1072,
        "name":"1071 (Thai Program)  :  Microelectronics Engineering | วิศวกรรมไมโครอิเล็กทรอนิกส์ | 微电子工程"
    },
    {
        "id":1073,
        "name":"1072 (Thai Program)  :  Anesthesia Nurse | วิสัญญีพยาบาล | 麻醉护士"
    },
    {
        "id":1074,
        "name":"1073 (Thai Program)  :  Anesthesiology | วิสัญญีวิทยา | 麻醉学"
    },
    {
        "id":1075,
        "name":"1074 (English Program)  :  International Tourism And Hotel Management | การท่องเที่ยวระหว่างประเทศและการจัดการโรงแรม | 国际旅游和酒店管理"
    },
    {
        "id":1076,
        "name":"1075 (Thai Program)  :  International Business (China) | วิเทศธุรกิจ (จีน) | 国际商务（中国）"
    },
    {
        "id":1077,
        "name":"1076 (Thai Program)  :  Surgery | ศัลยศาสตร์ | 外科手术"
    },
    {
        "id":1078,
        "name":"1077 (Thai Program)  :  Oral Surgery | ศัลยศาสตร์ช่องปาก | 口腔外科"
    },
    {
        "id":1079,
        "name":"1078 (Thai Program)  :  Oral And Maxillofacial Surgery | ศัลยศาสตร์ช่องปากและแม็กซิลโลเฟเชียล | 口腔颌面外科"
    },
    {
        "id":1080,
        "name":"1079 (English Program)  :  Electronic Marketing | การตลาดอิเล็กทรอนิกส์ | 电子营销"
    },
    {
        "id":1081,
        "name":"1080 (Thai Program)  :  Plastic Surgery | ศัลยศาสตร์ตกแต่ง | 整形外科"
    },
    {
        "id":1082,
        "name":"1081 (Thai Program)  :  Thoracic Surgery | ศัลยศาสตร์ทรวงอก | 胸外科"
    },
    {
        "id":1083,
        "name":"1082 (Thai Program)  :  Rectal Surgery | ศัลยศาสตร์ทวารหนัก | 直肠手术"
    },
    {
        "id":1084,
        "name":"1083 (Thai Program)  :  Veterinary Surgery | ศัลยศาสตร์ทางสัตวแพทย์ | 兽医外科"
    },
    {
        "id":1085,
        "name":"1084 (Thai Program)  :  Eurosurgery | ศัลยศาสตร์ยูโรวิทยา | 欧洲外科"
    },
    {
        "id":1086,
        "name":"1085 (Thai Program)  :  Orthopedic Surgery | ศัลยศาสตร์ออร์โธปิดิกส์ | 骨科手术"
    },
    {
        "id":1087,
        "name":"1086 (English Program)  :  Costing | ต้นทุน | 成本计算"
    },
    {
        "id":1088,
        "name":"1087 (English Program)  :  Testing And Measurement | การทดสอบและการวัด | 测试和测量"
    },
    {
        "id":1089,
        "name":"1088 (Thai Program)  :  Computer Science | ศาสตร์คอมพิวเตอร์ | 计算机科学"
    },
    {
        "id":1090,
        "name":"1089 (Thai Program)  :  Religious Studies | ศาสนศึกษา | 宗教研究"
    },
    {
        "id":1091,
        "name":"1090 (Thai Program)  :  Religion | ศาสนา | 宗教"
    },
    {
        "id":1092,
        "name":"1091 (Thai Program)  :  Comparative Religion | ศาสนาเปรียบเทียบ | 比较宗教"
    },
    {
        "id":1093,
        "name":"1092 (Thai Program)  :  Religion And Philosophy | ศาสนาและปรัชญา | 宗教与哲学"
    },
    {
        "id":1094,
        "name":"1093 (English Program)  :  Ecotourism And Hospitality Management | การท่องเที่ยวเชิงนิเวศและการจัดการการต้อนรับ | 生态旅游和酒店管理"
    },
    {
        "id":1095,
        "name":"1094 (Thai Program)  :  Fine Arts | ศิลปกรรม | 美术"
    },
    {
        "id":1096,
        "name":"1095 (Thai Program)  :  Dramatic Arts | ศิลปการละคร | 戏剧艺术"
    },
    {
        "id":1097,
        "name":"1096 (Thai Program)  :  Communication Arts And Advertising | ศิลปการสื่อสารและการโฆษณา | 传播艺术与广告"
    },
    {
        "id":1098,
        "name":"1097 (Thai Program)  :  Applied Arts | ศิลปประยุกต์ | 应用艺术"
    },
    {
        "id":1099,
        "name":"1098 (Thai Program)  :  Art Education | ศิลปศึกษา | 艺术教育"
    },
    {
        "id":1100,
        "name":"1099 (English Program)  :  Banking And Finance | การธนาคารและการเงิน | 银行与金融"
    },
    {
        "id":1101,
        "name":"1100 (English Program)  :  International Transport Management | การจัดการขนส่งระหว่างประเทศ | 国际运输管理"
    },
    {
        "id":1102,
        "name":"1101 (Thai Program)  :  Arts And Crafts | ศิลปหัตถกรรม | 工艺品"
    },
    {
        "id":1103,
        "name":"1102 (Thai Program)  :  Industrial Arts | ศิลปอุตสาหกรรม | 工艺美术"
    },
    {
        "id":1104,
        "name":"1103 (English Program)  :  Government Administration | การบริหารราชการ | 政府行政"
    },
    {
        "id":1105,
        "name":"1104 (Thai Program)  :  Art | ศิลปะ | 艺术"
    },
    {
        "id":1106,
        "name":"1105 (Thai Program)  :  Photography Art | ศิลปะการถ่ายภาพ | 摄影艺术"
    },
    {
        "id":1107,
        "name":"1106 (Thai Program)  :  Typographic Art | ศิลปะการพิมพ์ | 印刷艺术"
    },
    {
        "id":1108,
        "name":"1107 (Thai Program)  :  The Art Of Cloth Design | ศิลปะการออกแบบพัสตราภรณ์ | 布料设计的艺术"
    },
    {
        "id":1109,
        "name":"1108 (Thai Program)  :  Performing Arts | ศิลปะการแสดง | 表演艺术"
    },
    {
        "id":1110,
        "name":"1109 (Thai Program)  :  Artificial Arts | ศิลปะประดิษฐ์ | 人工艺术"
    },
    {
        "id":1111,
        "name":"1110 (Thai Program)  :  Applied Arts | ศิลปะประยุกต์ | 应用艺术"
    },
    {
        "id":1112,
        "name":"1111 (Thai Program)  :  Graphic Art | ศิลปะภาพพิมพ์ | 图形艺术"
    },
    {
        "id":1113,
        "name":"1112 (Thai Program)  :  Thai Art | ศิลปไทย | 泰国艺术"
    },
    {
        "id":1114,
        "name":"1113 (English Program)  :  Nursing Administration | การบริหารการพยาบาล | 护理管理"
    },
    {
        "id":1115,
        "name":"1114 (Thai Program)  :  Education - Home Economics | ศึกษาศาสตร์-คหกรรมศาสตร์ | 教育-家政"
    },
    {
        "id":1116,
        "name":"1115 (Thai Program)  :  Educational Science-Physical Education | ศึกษาศาสตร์-พลศึกษา | 教育科学-体育"
    },
    {
        "id":1117,
        "name":"1116 (Thai Program)  :  Education - Agriculture | ศึกษาศาสตร์-เกษตร | 教育-农业"
    },
    {
        "id":1118,
        "name":"1117 (Thai Program)  :  Study Science For Community Development | ศึกษาศาสตร์เพื่อพัฒนาชุมชน | 研究科学促进社区发展"
    },
    {
        "id":1119,
        "name":"1118 (Thai Program)  :  Women'S Studies | สตรีศึกษา | 妇女研究"
    },
    {
        "id":1120,
        "name":"1119 (Thai Program)  :  Architecture | สถาปัตยกรรม | 建筑学"
    },
    {
        "id":1121,
        "name":"1120 (Thai Program)  :  Interior Architecture | สถาปัตยกรรมภายใน | 室内建筑"
    },
    {
        "id":1122,
        "name":"1121 (Thai Program)  :  Architecture | สถาปัตยกรรมศาสตร์ | 建筑学"
    },
    {
        "id":1123,
        "name":"1122 (Thai Program)  :  Tropical Architecture | สถาปัตยกรรมเขตร้อน | 热带建筑"
    },
    {
        "id":1124,
        "name":"1123 (Thai Program)  :  Urban And Community Architecture | สถาปัตยกรรมเมืองและชุมชน | 城市和社区建筑"
    },
    {
        "id":1125,
        "name":"1124 (Thai Program)  :  Thai Architecture | สถาปัตยกรรมไทย | 泰国建筑"
    },
    {
        "id":1126,
        "name":"1125 (Thai Program)  :  Statistics | สถิติ | 统计数据"
    },
    {
        "id":1127,
        "name":"1126 (Thai Program)  :  Education Statistics | สถิติการศึกษา | 教育统计"
    },
    {
        "id":1128,
        "name":"1127 (Thai Program)  :  Mathematics Statistics | สถิติคณิตศาสตร์ | 数学统计"
    },
    {
        "id":1129,
        "name":"1128 (Thai Program)  :  Applied Statistics | สถิติประยุกต์ | 应用统计学"
    },
    {
        "id":1130,
        "name":"1129 (Thai Program)  :  Statistics | สถิติศาสตร์ | 统计数据"
    },
    {
        "id":1131,
        "name":"1130 (Thai Program)  :  Physiology | สรีรวิทยา | 生理"
    },
    {
        "id":1132,
        "name":"1131 (Thai Program)  :  Animal Physiology | สรีรวิทยาการสัตว์ | 动物生理学"
    },
    {
        "id":1133,
        "name":"1132 (Thai Program)  :  Physiology Of Exercise | สรีรวิทยาของการออกกำลังกาย | 运动生理学"
    },
    {
        "id":1134,
        "name":"1133 (Thai Program)  :  Medical Physiology | สรีรวิทยาทางการแพทย์ | 医学生理学"
    },
    {
        "id":1135,
        "name":"1134 (Thai Program)  :  Animal Physiology | สรีรวิทยาทางสัตว์ | 动物生理学"
    },
    {
        "id":1136,
        "name":"1135 (Thai Program)  :  Promote Health | สร้างเสริมสุขภาพ | 促进健康"
    },
    {
        "id":1137,
        "name":"1136 (Thai Program)  :  Labor Welfare | สวัสดิการแรงงงาน | 劳工福利"
    },
    {
        "id":1138,
        "name":"1137 (Thai Program)  :  Cooperative | สหกรณ์ | 合作社"
    },
    {
        "id":1139,
        "name":"1138 (Thai Program)  :  Interdisciplinary | สหวิทยาการ | 跨学科的"
    },
    {
        "id":1140,
        "name":"1139 (Thai Program)  :  Interdisciplinary Social Sciences | สหวิทยาการสังคมศาสตร์ | 跨学科社会科学"
    },
    {
        "id":1141,
        "name":"1140 (Thai Program)  :  Sociology | สังคมวิทยา | 社会学"
    },
    {
        "id":1142,
        "name":"1141 (Thai Program)  :  Development Sociology | สังคมวิทยาการพัฒนา | 发展社会学"
    },
    {
        "id":1143,
        "name":"1142 (Thai Program)  :  Applied Sociology | สังคมวิทยาประยุกต์ | 应用社会学"
    },
    {
        "id":1144,
        "name":"1143 (Thai Program)  :  Sociology And Anthropology | สังคมวิทยาและมนุษยวิทยา | 社会学和人类学"
    },
    {
        "id":1145,
        "name":"1144 (Thai Program)  :  Sociology And Anthropology | สังคมวิทยาและมานุษยวิทยา | 社会学和人类学"
    },
    {
        "id":1146,
        "name":"1145 (Thai Program)  :  Development Social Sciences | สังคมศาสตร์การพัฒนา | 发展社会科学"
    },
    {
        "id":1147,
        "name":"1146 (Thai Program)  :  Social Sciences, Medicine And Public Health | สังคมศาสตร์การแพทย์และสาธารณสุข | 社会科学、医学和公共卫生"
    },
    {
        "id":1148,
        "name":"1147 (Thai Program)  :  Health Social Sciences | สังคมศาสตร์สุขภาพ | 健康社会科学"
    },
    {
        "id":1149,
        "name":"1148 (Thai Program)  :  Social Science For Development | สังคมศาสตร์เพื่อการพัฒนา | 社会科学促进发展"
    },
    {
        "id":1150,
        "name":"1149 (Thai Program)  :  Social Studies | สังคมศึกษา | 社会研究"
    },
    {
        "id":1151,
        "name":"1150 (English Program)  :  Financial And Fiscal Management | การจัดการทางการเงินและการคลัง | 财务和财政管理"
    },
    {
        "id":1152,
        "name":"1151 (English Program)  :  Cultural Activities Management | การจัดการกิจกรรมทางวัฒนธรรม | 文化活动管理"
    },
    {
        "id":1153,
        "name":"1152 (Thai Program)  :  Educational Social Work | สังคมสงเคราะห์ทางการศึกษา | 教育社会工作"
    },
    {
        "id":1154,
        "name":"1153 (Thai Program)  :  Medical Social Work | สังคมสงเคราะห์ทางการแพทย์ | 医疗社会工作"
    },
    {
        "id":1155,
        "name":"1154 (Thai Program)  :  Social Work | สังคมสงเคราะห์ศาสตร์ | 社会工作"
    },
    {
        "id":1156,
        "name":"1155 (Thai Program)  :  Social Work In The Justice Process | สังคมสงเคราะห์ในกระบวนการยุติธรรม | 司法过程中的社会工作"
    },
    {
        "id":1157,
        "name":"1156 (Thai Program)  :  Thai Musical Arts | สังคีตศิลป์ไทย | 泰国音乐艺术"
    },
    {
        "id":1158,
        "name":"1157 (Thai Program)  :  Animal Husbandry | สัตวบาล | 畜牧业"
    },
    {
        "id":1159,
        "name":"1158 (English Program)  :  Financial Administration | การบริหารการเงิน | 财务管理"
    },
    {
        "id":1160,
        "name":"1159 (Thai Program)  :  Animal Conservation | สัตวรักษ์ | 动物保护"
    },
    {
        "id":1161,
        "name":"1160 (Thai Program)  :  Zoology | สัตววิทยา | 动物学"
    },
    {
        "id":1162,
        "name":"1161 (Thai Program)  :  Animal Science | สัตวศาสตร์ | 动物科学"
    },
    {
        "id":1163,
        "name":"1162 (Thai Program)  :  Veterinary Medicine | สัตวแพทยศาสตร์ | 兽医学"
    },
    {
        "id":1164,
        "name":"1163 (Thai Program)  :  Public Health Veterinarian | สัตวแพทยสาธารณสุข | 公共卫生兽医"
    },
    {
        "id":1165,
        "name":"1164 (Thai Program)  :  Poultry | สัตว์ปีก | 家禽"
    },
    {
        "id":1166,
        "name":"1165 (Thai Program)  :  Community Public Health | สาธารณสุขชุมชน | 社区公共卫生"
    },
    {
        "id":1167,
        "name":"1166 (Thai Program)  :  Public Health | สาธารณสุขศาสตร์ | 公共卫生"
    },
    {
        "id":1168,
        "name":"1167 (English Program)  :  Personnel Administration | การบริหารงานบุคคล | 人事管理"
    },
    {
        "id":1169,
        "name":"1168 (Thai Program)  :  Information Science | สารนิเทศศาสตร์ | 信息科学"
    },
    {
        "id":1170,
        "name":"1169 (Thai Program)  :  Information Studies | สารนิเทศศึกษา | 信息研究"
    },
    {
        "id":1171,
        "name":"1170 (Thai Program)  :  General Information | สารสนเทศทั่วไป | 一般信息"
    },
    {
        "id":1172,
        "name":"1171 (Thai Program)  :  Health Information | สารสนเทศทางสุขภาพ | 健康信息"
    },
    {
        "id":1173,
        "name":"1172 (Thai Program)  :  Geographic Information | สารสนเทศภูมิศาตร์ | 地理信息"
    },
    {
        "id":1174,
        "name":"1173 (Thai Program)  :  Information Science | สารสนเทศศาสตร์ | 信息科学"
    },
    {
        "id":1175,
        "name":"1174 (Thai Program)  :  Information Science And Library Science | สารสนเทศศาสตร์และบรรณารักษศาสตร์ | 信息科学与图书馆学"
    },
    {
        "id":1176,
        "name":"1175 (Thai Program)  :  Information Studies | สารสนเทศศึกษา | 信息研究"
    },
    {
        "id":1177,
        "name":"1176 (Thai Program)  :  Office Information | สารสนเทศสำนักงาน | 办公信息"
    },
    {
        "id":1178,
        "name":"1177 (Thai Program)  :  Human Rights | สิทธิมนุษยชน | 人权"
    },
    {
        "id":1179,
        "name":"1178 (Thai Program)  :  Textiles | สิ่งทอ | 纺织品"
    },
    {
        "id":1180,
        "name":"1179 (Thai Program)  :  Environment | สิ่งแวดล้อม | 环境"
    },
    {
        "id":1181,
        "name":"1180 (Thai Program)  :  Environmental Studies | สิ่งแวดล้อมศึกษา | 环境研究"
    },
    {
        "id":1182,
        "name":"1181 (Thai Program)  :  Environment And Resource Studies | สิ่งแวดล้อมและทรัพยากรศาสตร์ | 环境与资源研究"
    },
    {
        "id":1183,
        "name":"1182 (Thai Program)  :  Communication Of Performance | สื่อสารการแสดง | 绩效沟通"
    },
    {
        "id":1184,
        "name":"1183 (Thai Program)  :  Developmental Communication | สื่อสารพัฒนาการ | 发展性沟通"
    },
    {
        "id":1185,
        "name":"1184 (Thai Program)  :  Mass Communication | สื่อสารมวลชน | 大众传播"
    },
    {
        "id":1186,
        "name":"1185 (Thai Program)  :  Mental Health | สุขภาพจิต | 心理健康"
    },
    {
        "id":1187,
        "name":"1186 (Thai Program)  :  Mental Health And Psychiatric Nursing | สุขภาพจิตและการพยาบาลจิตเวช | 心理健康与精神科护理"
    },
    {
        "id":1188,
        "name":"1187 (Thai Program)  :  Mental Health And Psychiatry Nursing | สุขภาพจิตและการพยาบาลจิตเวชศาสตร์ | 心理健康和精神病学护理"
    },
    {
        "id":1189,
        "name":"1188 (Thai Program)  :  Industrial Hygiene And Safety | สุขศาสตร์อุตสาหกรรมและความปลอดภัย | 工业卫生与安全"
    },
    {
        "id":1190,
        "name":"1189 (Thai Program)  :  Health Education | สุขศึกษา | 健康教育"
    },
    {
        "id":1191,
        "name":"1190 (Thai Program)  :  Health Education And Behavioral Sciences | สุขศึกษาและพฤติกรรมศาสตร์ | 健康教育与行为科学"
    },
    {
        "id":1192,
        "name":"1191 (Thai Program)  :  Health Education And Health Behavior | สุขศึกษาและพฤติกรรมสุขภาพ | 健康教育与健康行为"
    },
    {
        "id":1193,
        "name":"1192 (Thai Program)  :  Environmental Sanitation | สุขาภิบาลสิ่งแวดล้อม | 环境卫生"
    },
    {
        "id":1194,
        "name":"1193 (Thai Program)  :  Food Sanitation | สุขาภิบาลอาหาร | 食品卫生"
    },
    {
        "id":1195,
        "name":"1194 (Thai Program)  :  Obstetrics-Gynecology | สูติศาสตร์-นรีเวชวิทยา | 妇产科"
    },
    {
        "id":1196,
        "name":"1195 (English Program)  :  Personnel Management | การบริหารงานบุคคล | 人事管理"
    },
    {
        "id":1197,
        "name":"1196 (English Program)  :  Judicial Administration | การบริหารงานตุลาการ | 司法行政"
    },
    {
        "id":1198,
        "name":"1197 (English Program)  :  Co-Operative Administration | การบริหารสหกรณ์ | 合作管理"
    },
    {
        "id":1199,
        "name":"1198 (Thai Program)  :  Obstetrics And Gynecology | สูติศาสตร์และนรีเวชศาสตร์ | 妇产科"
    },
    {
        "id":1200,
        "name":"1199 (Thai Program)  :  Promote Forestry And The Environment | ส่งเสริมการป่าไม้และสิ่งแวดล้อม | 促进林业和环境"
    },
    {
        "id":1201,
        "name":"1200 (Thai Program)  :  Promote Agriculture | ส่งเสริมการเกษตร | 促进农业"
    },
    {
        "id":1202,
        "name":"1201 (Thai Program)  :  Promote Agriculture And Cooperatives | ส่งเสริมการเกษตรและสหกรณ์ | 促进农业和合作社"
    },
    {
        "id":1203,
        "name":"1202 (Thai Program)  :  Agricultural Promotion And Communication | ส่งเสริมและนิเทศศาสตร์เกษตร | 农业推广与交流"
    },
    {
        "id":1204,
        "name":"1203 (Thai Program)  :  Promote And Disseminate Agriculture | ส่งเสริมและเผยแพร่การเกษตร | 推广和传播农业"
    },
    {
        "id":1205,
        "name":"1204 (Thai Program)  :  Curriculum And Supervision | หลักสูตรและการนิเทศ | 课程与督导"
    },
    {
        "id":1206,
        "name":"1205 (Thai Program)  :  Curriculum And Teaching | หลักสูตรและการสอน | 课程与教学"
    },
    {
        "id":1207,
        "name":"1206 (Thai Program)  :  Vocational Education Curriculum And Teaching | หลักสูตรและการสอนอาชีวศึกษา | 职业教育课程与教学"
    },
    {
        "id":1208,
        "name":"1207 (English Program)  :  Forest Resource Administration | การบริหารทรัพยากรป่าไม้ | 森林资源管理局"
    },
    {
        "id":1209,
        "name":"1208 (Thai Program)  :  Handicraft | หัตถกรรม | 手工业"
    },
    {
        "id":1210,
        "name":"1209 (Thai Program)  :  Deaf Studies | หูหนวกศึกษา | 聋人研究"
    },
    {
        "id":1211,
        "name":"1210 (Thai Program)  :  School Library | ห้องสมุดโรงเรียน | 学校图书馆"
    },
    {
        "id":1212,
        "name":"1211 (Thai Program)  :  Social Organization And Development | องค์การทางสังคมกับการพัฒนา | 社会组织与发展"
    },
    {
        "id":1213,
        "name":"1212 (Thai Program)  :  Molecular Biology | อณูชีววิทยา | 分子生物学"
    },
    {
        "id":1214,
        "name":"1213 (Thai Program)  :  Molecular Genetics And Genetic Engineering | อณูพันธุศาสตร์และพันธุวิศวกรรมศาสตร์ | 分子遗传学和基因工程"
    },
    {
        "id":1215,
        "name":"1214 (Thai Program)  :  Family Health | อนามัยครอบครัว | 家庭健康"
    },
    {
        "id":1216,
        "name":"1215 (Thai Program)  :  Community Health | อนามัยชุมชน | 社区健康"
    },
    {
        "id":1217,
        "name":"1216 (Thai Program)  :  Environmental Health | อนามัยสิ่งแวดล้อม | 环境健康"
    },
    {
        "id":1218,
        "name":"1217 (Thai Program)  :  Kindergarten Education | อนุบาลศึกษา | 幼儿园教育"
    },
    {
        "id":1219,
        "name":"1218 (Thai Program)  :  Urban Design | ออกแบบชุมชนเมือง | 城市设计"
    },
    {
        "id":1220,
        "name":"1219 (Thai Program)  :  Visual Arts Design | ออกแบบทัศนศิลป์ | 视觉艺术设计"
    },
    {
        "id":1221,
        "name":"1220 (English Program)  :  Human Resource And Organization Management | การจัดการทรัพยากรมนุษย์และองค์กร | 人力资源和组织管理"
    },
    {
        "id":1222,
        "name":"1221 (Thai Program)  :  Visual Communication Design | ออกแบบนิเทศศิลป์ | 视觉传达设计"
    },
    {
        "id":1223,
        "name":"1222 (Thai Program)  :  Packaging Design | ออกแบบบรรจุภัณฑ์ | 包装设计"
    },
    {
        "id":1224,
        "name":"1223 (Thai Program)  :  Applied Art Design | ออกแบบประยุกต์ศิลป์ | 应用艺术设计"
    },
    {
        "id":1225,
        "name":"1224 (Thai Program)  :  Product Design | ออกแบบผลิตภัณฑ์ | 产品设计"
    },
    {
        "id":1226,
        "name":"1225 (Thai Program)  :  Industrial Product Design | ออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计"
    },
    {
        "id":1227,
        "name":"1226 (English Program)  :  International Business Administration | การบริหารธุรกิจระหว่างประเทศ | 国际商务管理"
    },
    {
        "id":1228,
        "name":"1227 (Thai Program)  :  Commercial Art Design | ออกแบบพาณิชยศิลป์ | 商业艺术设计"
    },
    {
        "id":1229,
        "name":"1228 (Thai Program)  :  Interior Design | ออกแบบภายใน | 室内设计"
    },
    {
        "id":1230,
        "name":"1229 (Thai Program)  :  Textile Design | ออกแบบสิ่งทอ | 纺织品设计"
    },
    {
        "id":1231,
        "name":"1230 (Thai Program)  :  Industrial Design | ออกแบบอุตสาหกรรม | 工业设计"
    },
    {
        "id":1232,
        "name":"1231 (Thai Program)  :  Jewelry Design | ออกแบบเครื่องประดับ | 珠宝设计"
    },
    {
        "id":1233,
        "name":"1232 (Thai Program)  :  Furniture Design | ออกแบบเครื่องเรือน | 家具设计"
    },
    {
        "id":1234,
        "name":"1233 (Thai Program)  :  Ceramic Design | ออกแบบเซรามิก | 陶瓷设计"
    },
    {
        "id":1235,
        "name":"1234 (Thai Program)  :  Orthopedic | ออร์โทปิดิกส์ | 骨科"
    },
    {
        "id":1236,
        "name":"1235 (Thai Program)  :  England | อังกฤษ | 英格兰"
    },
    {
        "id":1237,
        "name":"1236 (Thai Program)  :  Gemology | อัญมณีวิทยา | 宝石学"
    },
    {
        "id":1238,
        "name":"1237 (Thai Program)  :  Gems And Jewelry | อัญมณีและเครื่องประดับ | 宝石和珠宝"
    },
    {
        "id":1239,
        "name":"1238 (Thai Program)  :  Criminology, Justice Administration And Society | อาชญาวิทยา การบริหารงานยุติธรรมและสังคม | 犯罪学、司法行政和社会"
    },
    {
        "id":1240,
        "name":"1239 (Thai Program)  :  Criminology And Justice | อาชญาวิทยาและงานยุติธรรม | 犯罪学与司法"
    },
    {
        "id":1241,
        "name":"1240 (Thai Program)  :  Vocational Education | อาชีวศึกษา | 职业教育"
    },
    {
        "id":1242,
        "name":"1241 (Thai Program)  :  Occupational Health | อาชีวอนามัย | 职业健康"
    },
    {
        "id":1243,
        "name":"1242 (Thai Program)  :  Occupational Health And Safety | อาชีวอนามัยและความปลอดภัย | 职业健康与安全"
    },
    {
        "id":1244,
        "name":"1243 (Thai Program)  :  Occupational Medicine | อาชีวเวชศาสตร์ | 职业医学"
    },
    {
        "id":1245,
        "name":"1244 (English Program)  :  Agribusiness Administration | การบริหารธุรกิจการเกษตร | 农业企业管理局"
    },
    {
        "id":1246,
        "name":"1245 (Thai Program)  :  Medicine | อายุรศาสตร์ | 药品"
    },
    {
        "id":1247,
        "name":"1246 (Thai Program)  :  Poultry Internal Medicine | อายุรศาสตร์สัตว์ปีก | 家禽内科"
    },
    {
        "id":1248,
        "name":"1247 (Thai Program)  :  Tropical Internal Medicine | อายุรศาสตร์เขตร้อน | 热带内科"
    },
    {
        "id":1249,
        "name":"1248 (Thai Program)  :  Clinical Tropical Internal Medicine | อายุรศาสตร์เขตร้อนคลินิก | 临床热带内科"
    },
    {
        "id":1250,
        "name":"1249 (Thai Program)  :  Animal Food | อาหารสัตว์ | 动物食品"
    },
    {
        "id":1251,
        "name":"1250 (Thai Program)  :  Food Chemistry And Medical Nutrition | อาหารเคมีและโภชนศาสตร์ทางการแพทย์ | 食品化学与医学营养"
    },
    {
        "id":1252,
        "name":"1251 (Thai Program)  :  Food And Nutrition | อาหารและโภชนาการ | 食物与营养"
    },
    {
        "id":1253,
        "name":"1252 (Thai Program)  :  Food And Nutrition For Development | อาหารและโภชนาการเพื่อการพัฒนา | 粮食和营养促进发展"
    },
    {
        "id":1254,
        "name":"1253 (Thai Program)  :  Islamic Studies | อิสลามศึกษา | 伊斯兰研究"
    },
    {
        "id":1255,
        "name":"1254 (English Program)  :  Health Care Management | การจัดการดูแลสุขภาพ | 医疗保健管理"
    },
    {
        "id":1256,
        "name":"1255 (Thai Program)  :  Electronics And Computers | อิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子和计算机"
    },
    {
        "id":1257,
        "name":"1256 (Thai Program)  :  Higher Education | อุดมศึกษา | 高等教育"
    },
    {
        "id":1258,
        "name":"1257 (English Program)  :  Primary Health Care Management | การจัดการดูแลสุขภาพเบื้องต้น | 初级卫生保健管理"
    },
    {
        "id":1259,
        "name":"1258 (Thai Program)  :  Tourism Industry | อุตสาหกรรมท่องเที่ยว | 旅游业"
    },
    {
        "id":1260,
        "name":"1259 (Thai Program)  :  Fishing Industry | อุตสาหกรรมประมง | 渔业"
    },
    {
        "id":1261,
        "name":"1260 (English Program)  :  Mass Communication Administration | การบริหารสื่อสารมวลชน | 大众传播管理局"
    },
    {
        "id":1262,
        "name":"1261 (Thai Program)  :  Industrial Arts | อุตสาหกรรมศิลป์ | 工艺美术"
    },
    {
        "id":1263,
        "name":"1262 (Thai Program)  :  Industrial Arts Studies | อุตสาหกรรมศิลป์ศึกษา | 工业艺术研究"
    },
    {
        "id":1264,
        "name":"1263 (Thai Program)  :  Industrial Studies | อุตสาหกรรมศึกษา | 工业研究"
    },
    {
        "id":1265,
        "name":"1264 (English Program)  :  Clinical Laboratory Administration | การบริหารห้องปฏิบัติการทางคลินิก | 临床实验室管理"
    },
    {
        "id":1266,
        "name":"1265 (English Program)  :  Organization And Management | องค์กรและการจัดการ | 组织与管理"
    },
    {
        "id":1267,
        "name":"1266 (English Program)  :  Vocational Education Administration | การบริหารอาชีวศึกษา | 职业教育管理局"
    },
    {
        "id":1268,
        "name":"1267 (English Program)  :  Project Management And Policy | การบริหารโครงการและนโยบาย | 项目管理和政策"
    },
    {
        "id":1269,
        "name":"1268 (Thai Program)  :  Parks And Recreation | อุทยานและนันทนาการ | 公园和休闲"
    },
    {
        "id":1270,
        "name":"1269 (Thai Program)  :  Medical Equipment | อุปกรณ์การแพทย์ | 医疗设备"
    },
    {
        "id":1271,
        "name":"1270 (Thai Program)  :  Biomedical Equipment | อุปกรณ์ชีวการแพทย์ | 生物医学设备"
    },
    {
        "id":1272,
        "name":"1271 (Thai Program)  :  Autopsy Medicine Equipment | อุปกรณ์เวชศาสตร์ชันสูตร | 尸检医学设备"
    },
    {
        "id":1273,
        "name":"1272 (Thai Program)  :  American Studies (American Literature) | อเมริกันศึกษา (วรรณคดีอเมริกัน) | 美国研究（美国文学）"
    },
    {
        "id":1274,
        "name":"1273 (Thai Program)  :  Agriculture | เกษตรกรรม | 农业"
    },
    {
        "id":1275,
        "name":"1274 (English Program)  :  Telecommunications Management | การจัดการโทรคมนาคม | 电信管理"
    },
    {
        "id":1276,
        "name":"1275 (Thai Program)  :  Agricultural Science | เกษตรกลวิธาน | 农业科学"
    },
    {
        "id":1277,
        "name":"1276 (Thai Program)  :  Integrated Agriculture | เกษตรผสมผสาน | 综合农业"
    },
    {
        "id":1278,
        "name":"1277 (Thai Program)  :  Agriculture | เกษตรศาสตร์ | 农业"
    },
    {
        "id":1279,
        "name":"1278 (Thai Program)  :  Systematic Agriculture | เกษตรศาสตร์เชิงระบบ | 系统农业"
    },
    {
        "id":1280,
        "name":"1279 (Thai Program)  :  Agricultural Studies | เกษตรศึกษา | 农业研究"
    },
    {
        "id":1281,
        "name":"1280 (Thai Program)  :  Tropical Agriculture | เกษตรเขตร้อน | 热带农业"
    },
    {
        "id":1282,
        "name":"1281 (Thai Program)  :  Systematic Agriculture | เกษตรเชิงระบบ | 系统农业"
    },
    {
        "id":1283,
        "name":"1282 (Thai Program)  :  Agriculture And Environmental Studies | เกษตรและสิ่งแวดล้อมศึกษา | 农业与环境研究"
    },
    {
        "id":1284,
        "name":"1283 (Thai Program)  :  Chemical | เคมี | 化学"
    },
    {
        "id":1285,
        "name":"1284 (English Program)  :  Hospital Administration | การบริหารโรงพยาบาล | 医院行政"
    },
    {
        "id":1286,
        "name":"1285 (Thai Program)  :  Chemistry-Biology | เคมี-ชีววิทยา | 化学-生物学"
    },
    {
        "id":1287,
        "name":"1286 (Thai Program)  :  Agricultural Chemistry | เคมีการเกษตร | 农业化学"
    },
    {
        "id":1288,
        "name":"1287 (Thai Program)  :  Clinical Chemistry | เคมีคลินิก | 临床化学"
    },
    {
        "id":1289,
        "name":"1288 (English Program)  :  Accounting And Taxation | การบัญชีและภาษี | 会计和税务"
    },
    {
        "id":1290,
        "name":"1289 (Thai Program)  :  Biology Chemistry | เคมีชีววิทยา | 生物化学"
    },
    {
        "id":1291,
        "name":"1290 (Thai Program)  :  Environmental Resource Chemistry | เคมีทรัพยากรสิ่งแวดล้อม | 环境资源化学"
    },
    {
        "id":1292,
        "name":"1291 (Thai Program)  :  Practical Chemistry | เคมีปฏิบัติ | 实用化学"
    },
    {
        "id":1293,
        "name":"1292 (Thai Program)  :  Applied Chemistry | เคมีประยุกต์ | 应用化学"
    },
    {
        "id":1294,
        "name":"1293 (Thai Program)  :  Physical Chemistry | เคมีฟิสิกัล | 物理化学"
    },
    {
        "id":1295,
        "name":"1294 (Thai Program)  :  Engineering Chemistry | เคมีวิศวกรรม | 工程化学"
    },
    {
        "id":1296,
        "name":"1295 (Thai Program)  :  Analytical Chemistry | เคมีวิเคราะห์ | 分析化学"
    },
    {
        "id":1297,
        "name":"1296 (Thai Program)  :  Analytical Chemistry And Applied Inorganic Chemistry | เคมีวิเคราะห์และเคมีอนินทรีย์ประยุกต์ | 分析化学与应用无机化学"
    },
    {
        "id":1298,
        "name":"1297 (English Program)  :  Local Government | รัฐบาลท้องถิ่น | 地方政府"
    },
    {
        "id":1299,
        "name":"1298 (English Program)  :  Governments And Politics | รัฐบาลและการเมือง | 政府和政治"
    },
    {
        "id":1300,
        "name":"1299 (English Program)  :  Educational Quality Assurance | การประกันคุณภาพการศึกษา | 教育质量保证"
    },
    {
        "id":1301,
        "name":"1300 (Thai Program)  :  Environmental Chemistry | เคมีสิ่งแวดล้อม | 环境化学"
    },
    {
        "id":1302,
        "name":"1301 (Thai Program)  :  Inorganic Chemistry | เคมีอนินทรีย์ | 无机化学"
    },
    {
        "id":1303,
        "name":"1302 (Thai Program)  :  Organic Chemistry | เคมีอินทรีย์ | 有机化学"
    },
    {
        "id":1304,
        "name":"1303 (Thai Program)  :  Industrial Chemistry | เคมีอุตสาหกรรม | 工业化学"
    },
    {
        "id":1305,
        "name":"1304 (Thai Program)  :  Industrial Chemistry – Analytical Instruments | เคมีอุตสาหกรรม – เครื่องมือวิเคราะห์ | 工业化学 - 分析仪器"
    },
    {
        "id":1306,
        "name":"1305 (Thai Program)  :  Physical Chemistry | เคมีเชิงฟิสิกส์ | 物理化学"
    },
    {
        "id":1307,
        "name":"1306 (Thai Program)  :  Technical Chemistry | เคมีเทคนิค | 技术化学"
    },
    {
        "id":1308,
        "name":"1307 (English Program)  :  Quality Assurance Of Agro-Industrial Products | การประกันคุณภาพผลิตภัณฑ์อุตสาหกรรมเกษตร | 农工业产品的质量保证"
    },
    {
        "id":1309,
        "name":"1308 (English Program)  :  Public Relations | ประชาสัมพันธ์ | 公共关系"
    },
    {
        "id":1310,
        "name":"1309 (English Program)  :  Music Composition | องค์ประกอบของดนตรี | 音乐创作"
    },
    {
        "id":1311,
        "name":"1310 (Thai Program)  :  Agricultural Machinery | เครื่องจักรกลเกษตร | 农业机械"
    },
    {
        "id":1312,
        "name":"1311 (Thai Program)  :  Earthenware | เครื่องปั้นดินเผา | 陶器"
    },
    {
        "id":1313,
        "name":"1312 (Thai Program)  :  Leather Goods | เครื่องหนัง | 皮革制品"
    },
    {
        "id":1314,
        "name":"1313 (Thai Program)  :  Porcelain | เครื่องเคลือบดินเผา | 瓷"
    },
    {
        "id":1315,
        "name":"1314 (Thai Program)  :  Industrial Furniture | เครื่องเรือนอุตสาหกรรม | 工业家具"
    },
    {
        "id":1316,
        "name":"1315 (Thai Program)  :  Metal Utensils And Jewelry | เครื่องโลหะและรูปพรรณอัญมณี | 金属器皿和珠宝"
    },
    {
        "id":1317,
        "name":"1316 (Thai Program)  :  Housing | เคหการ | 住房"
    },
    {
        "id":1318,
        "name":"1317 (Thai Program)  :  Medical Science Officer (1St Year) | เจ้าหน้าที่วิทยาศาสตร์การแพทย์ (ปีที่ 1) | 医学科学官（第一年）"
    },
    {
        "id":1319,
        "name":"1318 (Thai Program)  :  Medical Science Officer (2Nd Year) | เจ้าหน้าที่วิทยาศาสตร์การแพทย์ (ปีที่ 2) | 医学科学官（第2年）"
    },
    {
        "id":1320,
        "name":"1319 (Thai Program)  :  Ceramics | เซรามิกส์ | 陶瓷"
    },
    {
        "id":1321,
        "name":"1320 (English Program)  :  Educational Evaluation | การประเมินการศึกษา | 教育评价"
    },
    {
        "id":1322,
        "name":"1321 (Thai Program)  :  Medical Cytology | เซลล์วิทยาการแพทย์ | 医学细胞学"
    },
    {
        "id":1323,
        "name":"1322 (Thai Program)  :  Prosthetic Techniques | เทคนิคกายอุปกรณ์ | 假肢技术"
    },
    {
        "id":1324,
        "name":"1323 (Thai Program)  :  Veterinary Technology | เทคนิคการสัตวแพทย์ | 兽医技术"
    },
    {
        "id":1325,
        "name":"1324 (Thai Program)  :  Agricultural Techniques | เทคนิคการเกษตร | 农业技术"
    },
    {
        "id":1326,
        "name":"1325 (Thai Program)  :  Medical Technology | เทคนิคการแพทย์ | 医疗技术"
    },
    {
        "id":1327,
        "name":"1326 (Thai Program)  :  Technical Studies | เทคนิคศึกษา | 技术研究"
    },
    {
        "id":1328,
        "name":"1327 (Thai Program)  :  Metal Forming Technology | เทคโนโลยีการขึ้นรูปโลหะ | 金属成形技术"
    },
    {
        "id":1329,
        "name":"1328 (Thai Program)  :  Management Technology | เทคโนโลยีการจัดการ | 管理技术"
    },
    {
        "id":1330,
        "name":"1329 (Thai Program)  :  Marine And Coastal Resource Management Technology | เทคโนโลยีการจัดการทรัพยากรทะเลและชายฝั่ง | 海洋和沿海资源管理技术"
    },
    {
        "id":1331,
        "name":"1330 (English Program)  :  Environmental Risk Assessment | การประเมินความเสี่ยงด้านสิ่งแวดล้อม | 环境风险评估"
    },
    {
        "id":1332,
        "name":"1331 (Thai Program)  :  Energy Management Technology | เทคโนโลยีการจัดการพลังงาน | 能源管理技术"
    },
    {
        "id":1333,
        "name":"1332 (Thai Program)  :  Information System Management Technology | เทคโนโลยีการจัดการระบบสารสนเทศ | 信息系统管理技术"
    },
    {
        "id":1334,
        "name":"1333 (English Program)  :  Property Valuation | การประเมินมูลค่าทรัพย์สิน | 物业估价"
    },
    {
        "id":1335,
        "name":"1334 (Thai Program)  :  Pest Management Technology | เทคโนโลยีการจัดการศัตรูพืช | 害虫防治技术"
    },
    {
        "id":1336,
        "name":"1335 (Thai Program)  :  Industrial Management Technology | เทคโนโลยีการจัดการอุตสาหกรรม | 工业管理技术"
    },
    {
        "id":1337,
        "name":"1336 (Thai Program)  :  Photography And Film Technology | เทคโนโลยีการถ่ายภาพและภาพยนตร์ | 摄影和电影技术"
    },
    {
        "id":1338,
        "name":"1337 (Thai Program)  :  Packaging Technology | เทคโนโลยีการบรรจุ | 封装技术"
    },
    {
        "id":1339,
        "name":"1338 (Thai Program)  :  Administrative Technology | เทคโนโลยีการบริหาร | 行政技术"
    },
    {
        "id":1340,
        "name":"1339 (Thai Program)  :  Environmental Management Technology | เทคโนโลยีการบริหารสิ่งแวดล้อม | 环境管理技术"
    },
    {
        "id":1341,
        "name":"1340 (Thai Program)  :  Fishing Technology | เทคโนโลยีการประมง | 捕捞技术"
    },
    {
        "id":1342,
        "name":"1341 (English Program)  :  Animal Breeding | การปรับปรุงพันธุ์สัตว์ | 动物饲养"
    },
    {
        "id":1343,
        "name":"1342 (Thai Program)  :  Production Technology | เทคโนโลยีการผลิต | 生产技术"
    },
    {
        "id":1344,
        "name":"1343 (English Program)  :  Animal Production | การผลิตสัตว์ | 动物生产"
    },
    {
        "id":1345,
        "name":"1344 (Thai Program)  :  Plant Production Technology | เทคโนโลยีการผลิตพืช | 植物生产技术"
    },
    {
        "id":1346,
        "name":"1345 (Thai Program)  :  Animal Production Technology | เทคโนโลยีการผลิตสัตว์ | 畜牧生产技术"
    },
    {
        "id":1347,
        "name":"1346 (English Program)  :  Sport Coaching | การฝึกสอนกีฬา | 运动教练"
    },
    {
        "id":1348,
        "name":"1347 (Thai Program)  :  Aquatic Animal Production Technology | เทคโนโลยีการผลิตสัตว์น้ำ | 水产动物生产技术"
    },
    {
        "id":1349,
        "name":"1348 (Thai Program)  :  Pig Production Technology | เทคโนโลยีการผลิตสุกร | 生猪生产技术"
    },
    {
        "id":1350,
        "name":"1349 (Thai Program)  :  Product Development Technology | เทคโนโลยีการพัฒนาผลิตภัณฑ์ | 产品开发技术"
    },
    {
        "id":1351,
        "name":"1350 (Thai Program)  :  Printing Technology | เทคโนโลยีการพิมพ์ | 印刷技术"
    },
    {
        "id":1352,
        "name":"1351 (English Program)  :  Nursing | การพยาบาล | 护理"
    },
    {
        "id":1353,
        "name":"1352 (Thai Program)  :  Printing And Media Technology | เทคโนโลยีการพิมพ์และสื่อสิ่งพิมพ์ | 印刷和媒体技术"
    },
    {
        "id":1354,
        "name":"1353 (English Program)  :  Family Nursing | การพยาบาลครอบครัว | 家庭护理"
    },
    {
        "id":1355,
        "name":"1354 (Thai Program)  :  Rubber Technology | เทคโนโลยีการยาง | 橡胶技术"
    },
    {
        "id":1356,
        "name":"1355 (Thai Program)  :  Industrial Measurement Technology | เทคโนโลยีการวัดคุมทางอุตสาหกรรม | 工业测量技术"
    },
    {
        "id":1357,
        "name":"1356 (Thai Program)  :  Educational Measurement Technology | เทคโนโลยีการวัดทางการศึกษา | 教育测量技术"
    },
    {
        "id":1358,
        "name":"1357 (Thai Program)  :  Educational Measurement And Evaluation Technology | เทคโนโลยีการวัดและประเมินผลการศึกษา | 教育测量与评价技术"
    },
    {
        "id":1359,
        "name":"1358 (Thai Program)  :  Environmental Planning Technology For Rural Development | เทคโนโลยีการวางแผนสิ่งแวดล้อมเพื่อพัฒนาชนบท | 农村发展环境规划技术"
    },
    {
        "id":1360,
        "name":"1359 (Thai Program)  :  Educational Technology | เทคโนโลยีการศึกษา | 教育技术"
    },
    {
        "id":1361,
        "name":"1360 (Thai Program)  :  Vocational And Technical Education Technology | เทคโนโลยีการศึกษาทางการอาชีวะและเทคนิคศึกษา | 职业技术教育技术"
    },
    {
        "id":1362,
        "name":"1361 (Thai Program)  :  Communication And Information Technology | เทคโนโลยีการสื่อสารและสารสนเทศ | 通信和信息技术"
    },
    {
        "id":1363,
        "name":"1362 (Thai Program)  :  Fermentation Technology | เทคโนโลยีการหมัก | 发酵技术"
    },
    {
        "id":1364,
        "name":"1363 (Thai Program)  :  Food Technology | เทคโนโลยีการอาหาร | 食品技术"
    },
    {
        "id":1365,
        "name":"1364 (Thai Program)  :  Food Technology And Nutrition | เทคโนโลยีการอาหารและโภชนาการ | 食品技术和营养"
    },
    {
        "id":1366,
        "name":"1365 (Thai Program)  :  Agricultural Technology | เทคโนโลยีการเกษตร | 农业技术"
    },
    {
        "id":1367,
        "name":"1366 (Thai Program)  :  Agricultural Technology - Animal Production | เทคโนโลยีการเกษตร - การผลิตสัตว์ | 农业技术 - 动物生产"
    },
    {
        "id":1368,
        "name":"1367 (Thai Program)  :  Agricultural Technology – Crop Production | เทคโนโลยีการเกษตร – การผลิตพืช | 农业技术 - 农作物生产"
    },
    {
        "id":1369,
        "name":"1368 (Thai Program)  :  Welding Technology | เทคโนโลยีการเชื่อม | 焊接技术"
    },
    {
        "id":1370,
        "name":"1369 (Thai Program)  :  Animal Breeding Technology | เทคโนโลยีการเพาะขยายพันธุ์สัตว์ | 动物养殖技术"
    },
    {
        "id":1371,
        "name":"1370 (Thai Program)  :  Marine Shrimp Farming Technology | เทคโนโลยีการเพาะเลี้ยงกุ้งทะเล | 海虾养殖技术"
    },
    {
        "id":1372,
        "name":"1371 (Thai Program)  :  Advertising And Public Relations Technology | เทคโนโลยีการโฆษณาและประชาสัมพันธ์ | 广告和公共关系技术"
    },
    {
        "id":1373,
        "name":"1372 (Thai Program)  :  Television And Radio Broadcasting Technology | เทคโนโลยีการโทรทัศน์และวิทยุกระจายเสียง | 电视和广播技术"
    },
    {
        "id":1374,
        "name":"1373 (Thai Program)  :  Material Handling Technology | เทคโนโลยีขนถ่ายวัสดุ | 物料搬运技术"
    },
    {
        "id":1375,
        "name":"1374 (Thai Program)  :  Sugar Technology | เทคโนโลยีของน้ำตาล | 制糖技术"
    },
    {
        "id":1376,
        "name":"1375 (Thai Program)  :  Computer Technology | เทคโนโลยีคอมพิวเตอร์ | 计算机技术"
    },
    {
        "id":1377,
        "name":"1376 (Thai Program)  :  Industrial Computer Technology | เทคโนโลยีคอมพิวเตอร์อุตสาหกรรม | 工业计算机技术"
    },
    {
        "id":1378,
        "name":"1377 (Thai Program)  :  Computer Technology For Education | เทคโนโลยีคอมพิวเตอร์เพื่อการศึกษา | 教育计算机技术"
    },
    {
        "id":1379,
        "name":"1378 (Thai Program)  :  Rural Technology | เทคโนโลยีชนบท | 农村技术"
    },
    {
        "id":1380,
        "name":"1379 (Thai Program)  :  Biotechnology | เทคโนโลยีชีวภาพ | 生物技术"
    },
    {
        "id":1381,
        "name":"1380 (Thai Program)  :  Agricultural Biotechnology | เทคโนโลยีชีวภาพทางการเกษตร | 农业生物技术"
    },
    {
        "id":1382,
        "name":"1381 (Thai Program)  :  Agro-Industrial Biotechnology | เทคโนโลยีชีวภาพทางอุตสาหกรรมเกษตร | 农工生物技术"
    },
    {
        "id":1383,
        "name":"1382 (Thai Program)  :  Biotechnology In Plant Pathology | เทคโนโลยีชีวภาพทางโรคพืช | 植物病理学中的生物技术"
    },
    {
        "id":1384,
        "name":"1383 (English Program)  :  Psychiatric-Mental Health Nursing | การพยาบาลสุขภาพจิต-จิต | 精神心理健康护理"
    },
    {
        "id":1385,
        "name":"1384 (Thai Program)  :  Agricultural Biotechnology | เทคโนโลยีชีวภาพเกษตร | 农业生物技术"
    },
    {
        "id":1386,
        "name":"1385 (Thai Program)  :  Biochemical Technology | เทคโนโลยีชีวเคมี | 生化技术"
    },
    {
        "id":1387,
        "name":"1386 (Thai Program)  :  Dental Technology | เทคโนโลยีทันตกรรม | 牙科技术"
    },
    {
        "id":1388,
        "name":"1387 (Thai Program)  :  Chemical And Physical Process Technology | เทคโนโลยีทางกระบวนการเคมีและฟิสิกส์ | 化学和物理工艺技术"
    },
    {
        "id":1389,
        "name":"1388 (Thai Program)  :  Educational Technology | เทคโนโลยีทางการศึกษา | 教育技术"
    },
    {
        "id":1390,
        "name":"1389 (English Program)  :  Community Nursing | การพยาบาลชุมชน | 社区护理"
    },
    {
        "id":1391,
        "name":"1390 (Thai Program)  :  Marine Technology | เทคโนโลยีทางทะเล | 海洋技术"
    },
    {
        "id":1392,
        "name":"1391 (Thai Program)  :  Imaging Technology | เทคโนโลยีทางภาพ | 影像技术"
    },
    {
        "id":1393,
        "name":"1392 (Thai Program)  :  Imaging And Printing Technology | เทคโนโลยีทางภาพและการพิมพ์ | 成像和打印技术"
    },
    {
        "id":1394,
        "name":"1393 (Thai Program)  :  Food Technology | เทคโนโลยีทางอาหาร | 食品技术"
    },
    {
        "id":1395,
        "name":"1394 (Thai Program)  :  Suitable Technology For The Development Of Resources And The Environment | เทคโนโลยีที่เหมาะสม เพื่อการพัฒนาทรัพยากรและสิ่งแวดล้อม | 合适的技术为了资源和环境的开发"
    },
    {
        "id":1396,
        "name":"1395 (Thai Program)  :  Geotechnology | เทคโนโลยีธรณี | 地质技术"
    },
    {
        "id":1397,
        "name":"1396 (Thai Program)  :  Petrochemical Technology | เทคโนโลยีปิโตรเคมี | 石油化工技术"
    },
    {
        "id":1398,
        "name":"1397 (Thai Program)  :  Petroleum Technology | เทคโนโลยีปิโตรเลียม | 石油技术"
    },
    {
        "id":1399,
        "name":"1398 (Thai Program)  :  Fishery Product Technology | เทคโนโลยีผลิตภัณฑ์ประมง | 水产品技术"
    },
    {
        "id":1400,
        "name":"1399 (Thai Program)  :  Textile Product Technology | เทคโนโลยีผลิตภัณฑ์สิ่งทอ | 纺织产品技术"
    },
    {
        "id":1401,
        "name":"1400 (Thai Program)  :  Industrial Product Technology | เทคโนโลยีผลิตภัณฑ์อุตสาหกรรม | 工业产品技术"
    },
    {
        "id":1402,
        "name":"1401 (Thai Program)  :  Energy Technology | เทคโนโลยีพลังงาน | 能源技术"
    },
    {
        "id":1403,
        "name":"1402 (Thai Program)  :  Polymer Technology | เทคโนโลยีพอลิเมอร์ | 聚合物技术"
    },
    {
        "id":1404,
        "name":"1403 (Thai Program)  :  Landscape Technology | เทคโนโลยีภูมิทัศน์ | 景观技术"
    },
    {
        "id":1405,
        "name":"1404 (Thai Program)  :  Geotechnology | เทคโนโลยีภูมิศาสตร์ | 地质技术"
    },
    {
        "id":1406,
        "name":"1405 (English Program)  :  Infection Control Nursing | การพยาบาลควบคุมการติดเชื้อ | 感染控制护理"
    },
    {
        "id":1407,
        "name":"1406 (Thai Program)  :  Multimedia Technology | เทคโนโลยีมัลติมีเดีย | 多媒体技术"
    },
    {
        "id":1408,
        "name":"1407 (Thai Program)  :  Rubber Technology | เทคโนโลยียาง | 橡胶技术"
    },
    {
        "id":1409,
        "name":"1408 (Thai Program)  :  Rubber And Polymer Technology | เทคโนโลยียางและพอลิเมอร์ | 橡胶和聚合物技术"
    },
    {
        "id":1410,
        "name":"1409 (Thai Program)  :  Material Technology | เทคโนโลยีวัสดุ | 材料技术"
    },
    {
        "id":1411,
        "name":"1410 (Thai Program)  :  Materials Technology | เทคโนโลยีวัสดุภัณฑ์ | 材料技术"
    },
    {
        "id":1412,
        "name":"1411 (Thai Program)  :  Educational Research Technology | เทคโนโลยีวิจัยการศึกษา | 教育研究技术"
    },
    {
        "id":1413,
        "name":"1412 (Thai Program)  :  Refrigeration And Air Conditioning Engineering Technology | เทคโนโลยีวิศวกรรมการทำความเย็นและการปรับอากาศ | 制冷空调工程技术"
    },
    {
        "id":1414,
        "name":"1413 (Thai Program)  :  Engineering Technology, Mechanical Design And Production | เทคโนโลยีวิศวกรรมการออกแบบและผลิตเครื่องจักรกล | 工程技术、机械设计与生产"
    },
    {
        "id":1415,
        "name":"1414 (Thai Program)  :  Welding Engineering Technology | เทคโนโลยีวิศวกรรมการเชื่อม | 焊接工程技术"
    },
    {
        "id":1416,
        "name":"1415 (Thai Program)  :  Automotive Engineering Technology | เทคโนโลยีวิศวกรรมยานยนต์ | 汽车工程技术"
    },
    {
        "id":1417,
        "name":"1416 (Thai Program)  :  Electronic Engineering Technology | เทคโนโลยีวิศวกรรมอิเล็กทรอนิกส์ | 电子工程技术"
    },
    {
        "id":1418,
        "name":"1417 (Thai Program)  :  Power Electronics Engineering Technology | เทคโนโลยีวิศวกรรมอิเล็กทรอนิกส์กำลัง | 电力电子工程技术"
    },
    {
        "id":1419,
        "name":"1418 (Thai Program)  :  Engineering Technology Tools | เทคโนโลยีวิศวกรรมเครื่องมือ | 工程技术工具"
    },
    {
        "id":1420,
        "name":"1419 (Thai Program)  :  Civil Engineering Technology | เทคโนโลยีวิศวกรรมโยธา | 土木工程技术"
    },
    {
        "id":1421,
        "name":"1420 (Thai Program)  :  Wood Engineering Technology | เทคโนโลยีวิศวกรรมไม้ | 木材工程技术"
    },
    {
        "id":1422,
        "name":"1421 (Thai Program)  :  Industrial Arts Technology | เทคโนโลยีศิลปอุตสาหกรรม | 工艺技术"
    },
    {
        "id":1423,
        "name":"1422 (Thai Program)  :  Architectural Technology | เทคโนโลยีสถาปัตยกรรม | 建筑技术"
    },
    {
        "id":1424,
        "name":"1423 (Thai Program)  :  Information Technology | เทคโนโลยีสารสนเทศ | 信息技术"
    },
    {
        "id":1425,
        "name":"1424 (English Program)  :  Parent-Child Nursing | การพยาบาลพ่อแม่และลูก | 亲子护理"
    },
    {
        "id":1426,
        "name":"1425 (Thai Program)  :  Business Information Technology | เทคโนโลยีสารสนเทศทางธุรกิจ | 商业信息技术"
    },
    {
        "id":1427,
        "name":"1426 (Thai Program)  :  Statistical Information Technology | เทคโนโลยีสารสนเทศทางสถิติ | 统计信息技术"
    },
    {
        "id":1428,
        "name":"1427 (Thai Program)  :  Business Information Technology | เทคโนโลยีสารสนเทศธุรกิจ | 商业信息技术"
    },
    {
        "id":1429,
        "name":"1428 (Thai Program)  :  Statistical Information Technology | เทคโนโลยีสารสนเทศสถิติ | 统计信息技术"
    },
    {
        "id":1430,
        "name":"1429 (Thai Program)  :  Information Technology For Business | เทคโนโลยีสารสนเทศเพื่อธุรกิจ | 商业信息技术"
    },
    {
        "id":1431,
        "name":"1430 (Thai Program)  :  Information Technology For Industry | เทคโนโลยีสารสนเทศเพื่ออุตสาหกรรม | 工业信息技术"
    },
    {
        "id":1432,
        "name":"1431 (Thai Program)  :  Information Technology And Management | เทคโนโลยีสารสนเทศและการจัดการ | 信息技术与管理"
    },
    {
        "id":1433,
        "name":"1432 (English Program)  :  Gerontological Nursing | การพยาบาลผู้สูงอายุ | 老年护理"
    },
    {
        "id":1434,
        "name":"1433 (Thai Program)  :  Environmental Technology | เทคโนโลยีสิ่งแวดล้อม | 环保技术"
    },
    {
        "id":1435,
        "name":"1434 (English Program)  :  Adult Nursing | การพยาบาลผู้ใหญ่ | 成人护理"
    },
    {
        "id":1436,
        "name":"1435 (Thai Program)  :  Educational Communication Technology | เทคโนโลยีสื่อสารการศึกษา | 教育传播技术"
    },
    {
        "id":1437,
        "name":"1436 (Thai Program)  :  Mass Communication Technology | เทคโนโลยีสื่อสารมวลชน | 大众传播技术"
    },
    {
        "id":1438,
        "name":"1437 (Thai Program)  :  Post-Harvest Technology | เทคโนโลยีหลังการเก็บเกี่ยว | 收获后技术"
    },
    {
        "id":1439,
        "name":"1438 (Thai Program)  :  Post-Harvest Technology And Packaging | เทคโนโลยีหลังการเก็บเกี่ยวและบรรจุภัณฑ์ | 采后技术和包装"
    },
    {
        "id":1440,
        "name":"1439 (Thai Program)  :  Cardio-Thoracic Technology | เทคโนโลยีหัวใจและทรวงอก | 心胸技术"
    },
    {
        "id":1441,
        "name":"1440 (Thai Program)  :  Gem Technology | เทคโนโลยีอัญมณี | 宝石技术"
    },
    {
        "id":1442,
        "name":"1441 (Thai Program)  :  Building Technology | เทคโนโลยีอาคาร | 建筑技术"
    },
    {
        "id":1443,
        "name":"1442 (Thai Program)  :  Food Technology | เทคโนโลยีอาหาร | 食品技术"
    },
    {
        "id":1444,
        "name":"1443 (Thai Program)  :  Internet And Information Technology | เทคโนโลยีอินเทอร์เน็ตและสารสนเทศ | 互联网与信息技术"
    },
    {
        "id":1445,
        "name":"1444 (English Program)  :  Marternity And Newborn Nursing | การคลอดบุตรและการพยาบาลทารกแรกเกิด | 产妇和新生儿护理"
    },
    {
        "id":1446,
        "name":"1445 (English Program)  :  Nursing Care Of Women | การดูแลพยาบาลสตรี | 女性护理"
    },
    {
        "id":1447,
        "name":"1446 (English Program)  :  Public Health Nursing Practitioner | ผู้ปฏิบัติการพยาบาลสาธารณสุข | 公共卫生护理从业者"
    },
    {
        "id":1448,
        "name":"1447 (Thai Program)  :  Power Electronics Technology | เทคโนโลยีอิเล็กทรอนิกส์กำลัง | 电力电子技术"
    },
    {
        "id":1449,
        "name":"1448 (Thai Program)  :  Thermal Technology | เทคโนโลยีอุณหภาพ | 热技术"
    },
    {
        "id":1450,
        "name":"1449 (English Program)  :  Community Health Nursing | การพยาบาลสุขภาพชุมชน | 社区健康护理"
    },
    {
        "id":1451,
        "name":"1450 (Thai Program)  :  Industrial Technology | เทคโนโลยีอุตสาหกรรม | 工业技术"
    },
    {
        "id":1452,
        "name":"1451 (Thai Program)  :  Industrial Technology Studies | เทคโนโลยีอุตสาหกรรมศึกษา | 工业技术研究"
    },
    {
        "id":1453,
        "name":"1452 (English Program)  :  Occupational Health Nursing | การพยาบาลอาชีวอนามัย | 职业健康护理"
    },
    {
        "id":1454,
        "name":"1453 (Thai Program)  :  Agro-Industrial Technology | เทคโนโลยีอุตสาหกรรมเกษตร | 农工技术"
    },
    {
        "id":1455,
        "name":"1454 (Thai Program)  :  Ceramic Industry Technology | เทคโนโลยีอุตสาหกรรมเซรามิก | 陶瓷工业技术"
    },
    {
        "id":1456,
        "name":"1455 (Thai Program)  :  Industrial Technology | เทคโนโลยีอุตสาหการ | 工业技术"
    },
    {
        "id":1457,
        "name":"1456 (Thai Program)  :  Textile Chemical Technology | เทคโนโลยีเคมีสิ่งทอ | 纺织化学技术"
    },
    {
        "id":1458,
        "name":"1457 (Thai Program)  :  Mechanical Technology | เทคโนโลยีเครื่องกล | 机械技术"
    },
    {
        "id":1459,
        "name":"1458 (Thai Program)  :  Agricultural Machinery Technology | เทคโนโลยีเครื่องจักรกลเกษตร | 农业机械技术"
    },
    {
        "id":1460,
        "name":"1459 (Thai Program)  :  Power Engine Technology | เทคโนโลยีเครื่องต้นกำลัง | 动力发动机技术"
    },
    {
        "id":1461,
        "name":"1460 (Thai Program)  :  Jewelry And Gem Technology | เทคโนโลยีเครื่องประดับและอัญมณี | 珠宝和宝石技术"
    },
    {
        "id":1462,
        "name":"1461 (Thai Program)  :  Ceramic Technology | เทคโนโลยีเซรามิก | 陶瓷技术"
    },
    {
        "id":1463,
        "name":"1462 (English Program)  :  Maternal And Child Nursing | การพยาบาลมารดาและเด็ก | 母婴护理"
    },
    {
        "id":1464,
        "name":"1463 (Thai Program)  :  Technology Technical Studies | เทคโนโลยีเทคนิคศึกษา | 技术 技术研究"
    },
    {
        "id":1465,
        "name":"1464 (Thai Program)  :  Technology For Rural Development | เทคโนโลยีเพื่อการพัฒนาชนบท | 农村发展技术"
    },
    {
        "id":1466,
        "name":"1465 (Thai Program)  :  Pharmaceutical Technology | เทคโนโลยีเภสัชกรรม | 制药技术"
    },
    {
        "id":1467,
        "name":"1466 (Thai Program)  :  Seed Technology | เทคโนโลยีเมล็ดพันธุ์ | 种子技术"
    },
    {
        "id":1468,
        "name":"1467 (Thai Program)  :  Pulp And Paper Technology | เทคโนโลยีเยื่อและกระดาษ | 制浆造纸技术"
    },
    {
        "id":1469,
        "name":"1468 (Thai Program)  :  Laser Technology | เทคโนโลยีเลเซอร์ | 激光技术"
    },
    {
        "id":1470,
        "name":"1469 (Thai Program)  :  Clothing Technology | เทคโนโลยีเสื้อผ้า | 服装技术"
    },
    {
        "id":1471,
        "name":"1470 (Thai Program)  :  Mining Technology | เทคโนโลยีเหมืองแร่ | 采矿技术"
    },
    {
        "id":1472,
        "name":"1471 (Thai Program)  :  Jewelry Mold Technology | เทคโนโลยีแม่พิมพ์เครื่องประดับ | 珠宝首饰模具技术"
    },
    {
        "id":1473,
        "name":"1472 (Thai Program)  :  Electrical Industry Technology And Management | เทคโนโลยีและการจัดการอุตสาหกรรมไฟฟ้า | 电气工业技术与管理"
    },
    {
        "id":1474,
        "name":"1473 (Thai Program)  :  Educational Technology And Innovation | เทคโนโลยีและนวัตกรรมการศึกษา | 教育技术与创新"
    },
    {
        "id":1475,
        "name":"1474 (English Program)  :  Family And Social Development | การพัฒนาครอบครัวและสังคม | 家庭和社会发展"
    },
    {
        "id":1476,
        "name":"1475 (English Program)  :  Urban Community Development | การพัฒนาชุมชนเมือง | 城市社区发展"
    },
    {
        "id":1477,
        "name":"1476 (English Program)  :  Software Development | การพัฒนาซอฟต์แวร์ | 软件开发"
    },
    {
        "id":1478,
        "name":"1477 (Thai Program)  :  Structural Technology | เทคโนโลยีโครงสร้าง | 结构技术"
    },
    {
        "id":1479,
        "name":"1478 (Thai Program)  :  Telecommunications Technology | เทคโนโลยีโทรคมนาคม | 电信技术"
    },
    {
        "id":1480,
        "name":"1479 (English Program)  :  Business Software Development | การพัฒนาซอฟต์แวร์ธุรกิจ | 商业软件开发"
    },
    {
        "id":1481,
        "name":"1480 (Thai Program)  :  Civil Technology | เทคโนโลยีโยธา | 民用技术"
    },
    {
        "id":1482,
        "name":"1481 (Thai Program)  :  Electrical Technology | เทคโนโลยีไฟฟ้า | 电气技术"
    },
    {
        "id":1483,
        "name":"1482 (English Program)  :  Human Resource And Organization Development | การพัฒนาทรัพยากรมนุษย์และองค์กร | 人力资源和组织发展"
    },
    {
        "id":1484,
        "name":"1483 (Thai Program)  :  Sexology | เพศศาสตร์ | 性学"
    },
    {
        "id":1485,
        "name":"1484 (Thai Program)  :  Aquaculture | เพาะเลี้ยงสัตว์น้ำ | 水产养殖"
    },
    {
        "id":1486,
        "name":"1485 (Thai Program)  :  Aquaculture – Fisheries Engineering | เพาะเลี้ยงสัตว์น้ำ – วิศวกรรมประมง | 水产养殖-渔业工程"
    },
    {
        "id":1487,
        "name":"1486 (Thai Program)  :  Pharmacy | เภสัชกรรม | 药店"
    },
    {
        "id":1488,
        "name":"1487 (English Program)  :  Regional And Local Development | การพัฒนาระดับภูมิภาคและระดับท้องถิ่น | 区域和地方发展"
    },
    {
        "id":1489,
        "name":"1488 (Thai Program)  :  Clinical Pharmacy | เภสัชกรรมคลินิก | 临床药学"
    },
    {
        "id":1490,
        "name":"1489 (English Program)  :  Health Systems Development | การพัฒนาระบบสุขภาพ | 卫生系统发展"
    },
    {
        "id":1491,
        "name":"1490 (Thai Program)  :  Clinical And Administrative Pharmacy | เภสัชกรรมคลินิกและการบริหาร | 临床和行政药学"
    },
    {
        "id":1492,
        "name":"1491 (Thai Program)  :  Community Pharmacy | เภสัชกรรมชุมชน | 社区药房"
    },
    {
        "id":1493,
        "name":"1492 (Thai Program)  :  Hospital Pharmacy | เภสัชกรรมโรงพยาบาล | 医院药房"
    },
    {
        "id":1494,
        "name":"1493 (Thai Program)  :  Pharmacy, Hospitals And Clinics | เภสัชกรรมโรงพยาบาลและคลินิก | 药房、医院和诊所"
    },
    {
        "id":1495,
        "name":"1494 (Thai Program)  :  Pharmacy | เภสัชการ | 药店"
    },
    {
        "id":1496,
        "name":"1495 (Thai Program)  :  Pharmaceutical Care | เภสัชบริบาลศาสตร์ | 药学服务"
    },
    {
        "id":1497,
        "name":"1496 (Thai Program)  :  Pharmaceutical Botany | เภสัชพฤกษศาสตร์ | 药用植物学"
    },
    {
        "id":1498,
        "name":"1497 (Thai Program)  :  Pharmaceuticals | เภสัชภัณฑ์ | 药品"
    },
    {
        "id":1499,
        "name":"1498 (Thai Program)  :  Pharmacology | เภสัชวิทยา | 药理"
    },
    {
        "id":1500,
        "name":"1499 (Thai Program)  :  Veterinary Pharmacology | เภสัชวิทยาทางสัตวแพทยศาสตร์ | 兽医药理学"
    },
    {
        "id":1501,
        "name":"1500 (Thai Program)  :  Pharmacognosy | เภสัชวินิจฉัย | 生药学"
    },
    {
        "id":1502,
        "name":"1501 (Thai Program)  :  Pharmacognosy And Pharmaceutical Chemistry | เภสัชวินิจฉัยและเภสัชเคมี | 生药学和药物化学"
    },
    {
        "id":1503,
        "name":"1502 (English Program)  :  Information System Development | การพัฒนาระบบสารสนเทศ | 信息系统开发"
    },
    {
        "id":1504,
        "name":"1503 (English Program)  :  Health Development | การพัฒนาสุขภาพ | 健康发展"
    },
    {
        "id":1505,
        "name":"1504 (English Program)  :  Curriculum And Instructional Development | หลักสูตรและการพัฒนาการเรียนการสอน | 课程和教学发展"
    },
    {
        "id":1506,
        "name":"1505 (Thai Program)  :  Biopharmaceuticals | เภสัชศาสตร์ชีวภาพ | 生物制药"
    },
    {
        "id":1507,
        "name":"1506 (English Program)  :  Sustainable Development | การพัฒนาที่ยั่งยืน | 可持续发展"
    },
    {
        "id":1508,
        "name":"1507 (Thai Program)  :  Social And Administrative Pharmacy | เภสัชศาสตร์สังคมและการบริหาร | 社会与行政药学"
    },
    {
        "id":1509,
        "name":"1508 (Thai Program)  :  Social And Administrative Pharmacy | เภสัชศาสตร์สังคมและบริหาร | 社会与行政药学"
    },
    {
        "id":1510,
        "name":"1509 (Thai Program)  :  Industrial Pharmacy | เภสัชอุตสาหกรรม | 工业药剂"
    },
    {
        "id":1511,
        "name":"1510 (Thai Program)  :  Pharmaceutical Chemistry | เภสัชเคมี | 药物化学"
    },
    {
        "id":1512,
        "name":"1511 (Thai Program)  :  Pharmaceutical Chemicals And Natural Products | เภสัชเคมีและผลิตภัณฑ์ธรรมชาติ | 医药化学品和天然产物"
    },
    {
        "id":1513,
        "name":"1512 (Thai Program)  :  Pharmaceutical Chemistry And Phytochemistry | เภสัชเคมีและพฤกษเคมี | 药物化学和植物化学"
    },
    {
        "id":1514,
        "name":"1513 (Thai Program)  :  Pharmacognosy | เภสัชเวท | 生药学"
    },
    {
        "id":1515,
        "name":"1514 (English Program)  :  Printing | การพิมพ์ | 印刷"
    },
    {
        "id":1516,
        "name":"1515 (English Program)  :  Motion Pictures And Still Photography | ภาพเคลื่อนไหวและภาพนิ่ง | 动态图片和静态摄影"
    },
    {
        "id":1517,
        "name":"1516 (Thai Program)  :  Medical News | เวชนิทัศน์ | 医学新闻"
    },
    {
        "id":1518,
        "name":"1517 (Thai Program)  :  Medical Practice | เวชปฏิบัติ | 医疗实践"
    },
    {
        "id":1519,
        "name":"1518 (Thai Program)  :  General Practice | เวชปฏิบัติทั่วไป | 一般做法"
    },
    {
        "id":1520,
        "name":"1519 (Thai Program)  :  General \/ Family Practice | เวชปฏิบัติทั่วไป \/ ครอบครัว | 一般\/家庭诊所"
    },
    {
        "id":1521,
        "name":"1520 (Thai Program)  :  Medical Records | เวชระเบียน | 医疗记录"
    },
    {
        "id":1522,
        "name":"1521 (Thai Program)  :  Sports Medicine | เวชศาสตร์การกีฬา | 运动医学"
    },
    {
        "id":1523,
        "name":"1522 (Thai Program)  :  Blood Banking Medicine | เวชศาสตร์การธนาคารเลือด | 血库医学"
    },
    {
        "id":1524,
        "name":"1523 (Thai Program)  :  Family Medicine | เวชศาสตร์ครอบครัว | 家庭医学"
    },
    {
        "id":1525,
        "name":"1524 (Thai Program)  :  Community Medicine | เวชศาสตร์ชุมชน | 社区医学"
    },
    {
        "id":1526,
        "name":"1525 (Thai Program)  :  Oral Medicine | เวชศาสตร์ช่องปาก | 口服药"
    },
    {
        "id":1527,
        "name":"1526 (Thai Program)  :  General Medicine And Emergency Medicine | เวชศาสตร์ทั่วไปและเวชศาสตร์ฉุกเฉิน | 全科医学和急诊医学"
    },
    {
        "id":1528,
        "name":"1527 (Thai Program)  :  Preventive Medicine | เวชศาสตร์ป้องกัน | 预防医学"
    },
    {
        "id":1529,
        "name":"1528 (Thai Program)  :  Clinical Preventive Medicine | เวชศาสตร์ป้องกันคลินิก | 临床预防医学"
    },
    {
        "id":1530,
        "name":"1529 (Thai Program)  :  Rehabilitation Medicine | เวชศาสตร์ฟื้นฟู | 康复医学"
    },
    {
        "id":1531,
        "name":"1530 (English Program)  :  International Affairs And Diplomacy | กิจการระหว่างประเทศและการทูต | 国际事务和外交"
    },
    {
        "id":1532,
        "name":"1531 (Thai Program)  :  Tropical Medicine And Hygiene | เวชศาสตร์เขตร้อนและสุขวิทยา | 热带医学和卫生"
    },
    {
        "id":1533,
        "name":"1532 (Thai Program)  :  International Economy | เศรษฐกิจระหว่างประเทศ | 国际经济"
    },
    {
        "id":1534,
        "name":"1533 (Thai Program)  :  Econometrics | เศรษฐมิติ | 计量经济学"
    },
    {
        "id":1535,
        "name":"1534 (Thai Program)  :  Economics | เศรษฐศาสตร์ | 经济学"
    },
    {
        "id":1536,
        "name":"1535 (Thai Program)  :  Fiscal Economics | เศรษฐศาสตร์การคลัง | 财政经济学"
    },
    {
        "id":1537,
        "name":"1536 (English Program)  :  Security Operation | การดำเนินการรักษาความปลอดภัย | 安全运营"
    },
    {
        "id":1538,
        "name":"1537 (Thai Program)  :  Development Economics | เศรษฐศาสตร์การพัฒนา | 发展经济学"
    },
    {
        "id":1539,
        "name":"1538 (Thai Program)  :  Educational Economics | เศรษฐศาสตร์การศึกษา | 教育经济学"
    },
    {
        "id":1540,
        "name":"1539 (Thai Program)  :  Agricultural Economics | เศรษฐศาสตร์การเกษตร | 农业经济学"
    },
    {
        "id":1541,
        "name":"1540 (English Program)  :  Remote Sensing | การรับรู้ระยะไกล | 遥感"
    },
    {
        "id":1542,
        "name":"1541 (Thai Program)  :  Political Economy | เศรษฐศาสตร์การเมือง | 政治经济学"
    },
    {
        "id":1543,
        "name":"1542 (Thai Program)  :  Natural Resources And Environmental Economics | เศรษฐศาสตร์ทรัพยากรธรรมชาติและสิ่งแวดล้อม | 自然资源与环境经济学"
    },
    {
        "id":1544,
        "name":"1543 (Thai Program)  :  Human Resource Economics | เศรษฐศาสตร์ทรัพยากรมนุษย์ | 人力资源经济学"
    },
    {
        "id":1545,
        "name":"1544 (Thai Program)  :  Business Economics | เศรษฐศาสตร์ธุรกิจ | 商业经济学"
    },
    {
        "id":1546,
        "name":"1545 (Thai Program)  :  Business Economics And Management | เศรษฐศาสตร์ธุรกิจและการจัดการ | 商业经济与管理"
    },
    {
        "id":1547,
        "name":"1546 (Thai Program)  :  Population Economics And Human Resources | เศรษฐศาสตร์ประชากรและมนุษย์ทรัพยากร | 人口经济与人力资源"
    },
    {
        "id":1548,
        "name":"1547 (Thai Program)  :  International Economics | เศรษฐศาสตร์ระหว่างประเทศ | 国际经济"
    },
    {
        "id":1549,
        "name":"1548 (Thai Program)  :  Cooperative Economics | เศรษฐศาสตร์สหกรณ์ | 合作经济"
    },
    {
        "id":1550,
        "name":"1549 (English Program)  :  Remote Sensing And Geographic | การรับรู้ระยะไกลและภูมิศาสตร์ | 遥感与地理"
    },
    {
        "id":1551,
        "name":"1550 (English Program)  :  Educational Measurement And Research | การวัดผลและการวิจัยทางการศึกษา | 教育测量与研究"
    },
    {
        "id":1552,
        "name":"1551 (Thai Program)  :  Health Economics | เศรษฐศาสตร์สาธารณสุข | 卫生经济学"
    },
    {
        "id":1553,
        "name":"1552 (Thai Program)  :  Environmental Economics | เศรษฐศาสตร์สิ่งแวดล้อม | 环境经济学"
    },
    {
        "id":1554,
        "name":"1553 (Thai Program)  :  Environmental And Natural Resources Economics | เศรษฐศาสตร์สิ่งแวดล้อมและทรัพยากรธรรมชาติ | 环境与自然资源经济学"
    },
    {
        "id":1555,
        "name":"1554 (Thai Program)  :  Industrial Economics | เศรษฐศาสตร์อุตสาหกรรม | 产业经济学"
    },
    {
        "id":1556,
        "name":"1555 (Thai Program)  :  Industrial And Labor Economics | เศรษฐศาสตร์อุตสาหกรรมและแรงงาน | 产业与劳动经济学"
    },
    {
        "id":1557,
        "name":"1556 (Thai Program)  :  Agricultural Economics | เศรษฐศาสตร์เกษตร | 农业经济学"
    },
    {
        "id":1558,
        "name":"1557 (Thai Program)  :  Quantitative Economics | เศรษฐศาสตร์เชิงปริมาณ | 数量经济学"
    },
    {
        "id":1559,
        "name":"1558 (Thai Program)  :  Labor Economics And Management | เศรษฐศาสตร์แรงงานและการจัดการ | 劳动经济与管理"
    },
    {
        "id":1560,
        "name":"1559 (Thai Program)  :  Economics And Management In Islam | เศรษฐศาสตร์และการจัดการในอิสลาม | 伊斯兰教经济与管理"
    },
    {
        "id":1561,
        "name":"1560 (Thai Program)  :  International Economics And Finance | เศรษฐศาสตร์และการเงินระหว่างประเทศ | 国际经济与金融"
    },
    {
        "id":1562,
        "name":"1561 (Thai Program)  :  Southeast Asian Studies | เอเชียตะวันออกเฉียงใต้ศึกษา | 东南亚研究"
    },
    {
        "id":1563,
        "name":"1562 (Thai Program)  :  Southeast Asian Studies | เอเชียอาคเนย์ศึกษา | 东南亚研究"
    },
    {
        "id":1564,
        "name":"1563 (Thai Program)  :  Maps And Geographic Information Systems | แผนที่และระบบสารสนเทศภูมิศาสตร์ | 地图和地理信息系统"
    },
    {
        "id":1565,
        "name":"1564 (Thai Program)  :  Maps And Geographic Technology | แผนที่และเทคโนโลยีภูมิศาสตร์ | 地图和地理技术"
    },
    {
        "id":1566,
        "name":"1565 (Thai Program)  :  Medicine | แพทยศาสตร์ | 药品"
    },
    {
        "id":1567,
        "name":"1566 (Thai Program)  :  Medicine (Rural) | แพทยศาสตร์ (ชนบท) | 医学（农村）"
    },
    {
        "id":1568,
        "name":"1567 (Thai Program)  :  Medicine (New Style) | แพทยศาสตร์ (แนวใหม่) | 医学（新式）"
    },
    {
        "id":1569,
        "name":"1568 (Thai Program)  :  Thai Traditional Medicine | แพทย์แผนไทย | 泰国传统医学"
    },
    {
        "id":1570,
        "name":"1569 (Thai Program)  :  Labor Relations With Development | แรงงานสัมพันธ์กับการพัฒนา | 劳动关系与发展"
    },
    {
        "id":1571,
        "name":"1570 (Thai Program)  :  Dairy Cattle And Beef Cattle | โคนมและโคเนื้อ | 奶牛和肉牛"
    },
    {
        "id":1572,
        "name":"1571 (Thai Program)  :  Archeology | โบราณคดี | 考古学"
    },
    {
        "id":1573,
        "name":"1572 (Thai Program)  :  Prehistoric Archeology | โบราณคดีสมัยก่อนประวัติศาสตร์ | 史前考古学"
    },
    {
        "id":1574,
        "name":"1573 (Thai Program)  :  Historical Archeology | โบราณคดีสมัยประวัติศาสตร์ | 历史考古学"
    },
    {
        "id":1575,
        "name":"1574 (Thai Program)  :  Nutrition Therapy | โภชนบำบัด | 营养治疗"
    },
    {
        "id":1576,
        "name":"1575 (English Program)  :  Educational Measurement And Evaluation | การวัดผลและการประเมินการศึกษา | 教育测量与评估"
    },
    {
        "id":1577,
        "name":"1576 (Thai Program)  :  Nutrition | โภชนวิทยา | 营养"
    },
    {
        "id":1578,
        "name":"1577 (Thai Program)  :  Nutrition | โภชนศาสตร์ | 营养"
    },
    {
        "id":1579,
        "name":"1578 (Thai Program)  :  Nutrition Studies | โภชนศาสตร์ศึกษา | 营养研究"
    },
    {
        "id":1580,
        "name":"1579 (Thai Program)  :  Community Nutrition | โภชนาการชุมชน | 社区营养"
    },
    {
        "id":1581,
        "name":"1580 (Thai Program)  :  Public Health Nutrition | โภชนาการสาธารณสุข | 公共卫生营养"
    },
    {
        "id":1582,
        "name":"1581 (Thai Program)  :  Civil | โยธา | 民用"
    },
    {
        "id":1583,
        "name":"1582 (English Program)  :  Community Planning | การวางแผนชุมชน | 社区规划"
    },
    {
        "id":1584,
        "name":"1583 (Thai Program)  :  Infectious Disease | โรคติดเชื้อ | 传染病"
    },
    {
        "id":1585,
        "name":"1584 (Thai Program)  :  Plant Diseases | โรคพืช | 植物病害"
    },
    {
        "id":1586,
        "name":"1585 (Thai Program)  :  Plant Pathology | โรคพืชวิทยา | 植物病理学"
    },
    {
        "id":1587,
        "name":"1586 (Thai Program)  :  Aquatic Animal Disease | โรคสัตว์น้ำ | 水产动物疾病"
    },
    {
        "id":1588,
        "name":"1587 (Thai Program)  :  Pet Disease | โรคสัตว์เลี้ยง | 宠物疾病"
    },
    {
        "id":1589,
        "name":"1588 (Thai Program)  :  Digital Health Management Innovation | นวัตกรรมการจัดการสุขภาพดิจิทัล | 数字化健康管理创新"
    },
    {
        "id":1590,
        "name":"1589 (Thai Program)  :  Disease And Health Management In Dairy Farms | โรคและการจัดการสุขภาพในฟาร์มโคนม | 奶牛场疾病与健康管理"
    },
    {
        "id":1591,
        "name":"1590 (Thai Program)  :  World Science | โลกศาสตร์ | 世界科学"
    },
    {
        "id":1592,
        "name":"1591 (Thai Program)  :  Metal | โลหะ | 金属"
    },
    {
        "id":1593,
        "name":"1592 (Thai Program)  :  Hematology | โลหิตวิทยา | 血液学"
    },
    {
        "id":1594,
        "name":"1593 (Thai Program)  :  Otolaryngology (Otolaryngology) | โสต นาสิก ลาริงซ์วิทยา | 耳鼻喉科（耳鼻喉科）"
    },
    {
        "id":1595,
        "name":"1594 (English Program)  :  Urban Planning | การวางผังเมือง | 城市规划"
    },
    {
        "id":1596,
        "name":"1595 (Thai Program)  :  Otolaryngology | โสต ศอ นาสิกวิทยา | 耳鼻喉科"
    },
    {
        "id":1597,
        "name":"1596 (Thai Program)  :  Audiovisual Education | โสตทัศนศึกษา | 视听教育"
    },
    {
        "id":1598,
        "name":"1597 (Thai Program)  :  Thai Case Study | ไทยคดีศึกษา | 泰国案例研究"
    },
    {
        "id":1599,
        "name":"1598 (Thai Program)  :  Thai Studies | ไทยศึกษา | 泰国研究"
    },
    {
        "id":1600,
        "name":"1599 (Thai Program)  :  Thai Studies For Development | ไทยศึกษาเพื่อการพัฒนา | 泰国发展研究"
    },
    {
        "id":1601,
        "name":"1600 (English Program)  :  Regional Planning | การวางแผนระดับภูมิภาค | 区域规划"
    },
    {
        "id":1602,
        "name":"1601 (English Program)  :  Regional And Urban Planning | การวางแผนระดับภูมิภาคและเมือง | 区域和城市规划"
    },
    {
        "id":1603,
        "name":"1602 (English Program)  :  Environmental Planning For Community And Rural Development | การวางแผนสิ่งแวดล้อมเพื่อการพัฒนาชุมชนและชนบท | 社区和农村发展的环境规划"
    },
    {
        "id":1604,
        "name":"1603 (Thai Program)  :  Fruit Trees | ไม้ผล | 果树"
    },
    {
        "id":1605,
        "name":"1604 (Thai Program)  :  Fabrics And Clothing - Clothing Business | ผ้าและเครื่องแต่งกาย-ธุรกิจเสื้อผ้า | 面料和服装——服装业务"
    },
    {
        "id":1606,
        "name":"1605 (Thai Program)  :  Furniture Technology And Design | เทคโนโลยีเครื่องเรือนและการออกแบบ | 家具技术与设计"
    },
    {
        "id":1607,
        "name":"1606 (Thai Program)  :  Furniture Industry Technology | เทคโนโลยีอุตสาหกรรมเครื่องเรือน | 家具行业技术"
    },
    {
        "id":1608,
        "name":"1607 (Thai Program)  :  Industrial Engineering-Production Design | วิศวกรรมอุตสาหการ-ออกแบบการผลิต | 工业工程-生产设计"
    },
    {
        "id":1609,
        "name":"1608 (Thai Program)  :  Industrial Engineering-Machine Tools | วิศวกรรมอุตสาหการ-เครื่องมือกล | 工业工程-机床"
    },
    {
        "id":1610,
        "name":"1609 (Thai Program)  :  Industrial Engineering-Welding | วิศวกรรมอุตสาหการ-เชื่อมประกอบ | 工业工程-焊接"
    },
    {
        "id":1611,
        "name":"1610 (Thai Program)  :  Industrial Engineering - Design Drawing | วิศวกรรมอุตสาหการ-เขียนแบบออกแบบ | 工业工程-设计图"
    },
    {
        "id":1612,
        "name":"1611 (Thai Program)  :  Marketing-Export Marketing | การตลาด-การตลาดส่งออก | 营销-出口营销"
    },
    {
        "id":1613,
        "name":"1612 (Thai Program)  :  International Transportation | การขนส่งระหว่างประเทศ | 国际运输"
    },
    {
        "id":1614,
        "name":"1613 (Thai Program)  :  Business Computing | การคอมพิวเตอร์ธุรกิจ | 商业计算"
    },
    {
        "id":1615,
        "name":"1614 (Thai Program)  :  International Trade | การค้าระหว่างประเทศ | 国际贸易"
    },
    {
        "id":1616,
        "name":"1615 (Thai Program)  :  Banking Finance | การเงินการธนาคาร | 银行金融"
    },
    {
        "id":1617,
        "name":"1616 (Thai Program)  :  International Finance And Banking | การเงินและการธนาคารระหว่างประเทศ | 国际金融与银行"
    },
    {
        "id":1618,
        "name":"1617 (Thai Program)  :  Finance And Investment | การเงินและการลงทุน | 金融投资"
    },
    {
        "id":1619,
        "name":"1618 (Thai Program)  :  Tourism And Hospitality Industry Management | การจัดการการท่องเที่ยวและอุตสาหกรรมการบริการ | 旅游与酒店业管理"
    },
    {
        "id":1620,
        "name":"1619 (Thai Program)  :  Nursing Management | การจัดการการพยาบาล | 护理管理"
    },
    {
        "id":1621,
        "name":"1620 (Thai Program)  :  Electronic Commerce Management | การจัดการการพาณิชย์อิเล็กทรอนิกส์ | 电子商务管理"
    },
    {
        "id":1622,
        "name":"1621 (English Program)  :  Economic Planning | การวางแผนเศรษฐกิจ | 经济规划"
    },
    {
        "id":1623,
        "name":"1622 (Thai Program)  :  Management Of Social Welfare Projects | การจัดการโครงการสวัสดิการสังคม | 社会福利项目管理"
    },
    {
        "id":1624,
        "name":"1623 (Thai Program)  :  Advertising Management | การจัดการโฆษณา | 广告管理"
    },
    {
        "id":1625,
        "name":"1624 (Thai Program)  :  Computer Management And Engineering | การจัดการงานคอมพิวเตอร์และวิศวกรรม | 计算机管理与工程"
    },
    {
        "id":1626,
        "name":"1625 (Thai Program)  :  Engineering Management | การจัดการงานวิศวกรรม | 工程管理"
    },
    {
        "id":1627,
        "name":"1626 (Thai Program)  :  Engineering And Technology Management | การจัดการงานวิศวกรรมและเทคโนโลยี | 工程技术管理"
    },
    {
        "id":1628,
        "name":"1627 (Thai Program)  :  Computer And Information Resource Management | การจัดการทรัพยากรคอมพิวเตอร์และสารสนเทศ | 计算机和信息资源管理"
    },
    {
        "id":1629,
        "name":"1628 (Thai Program)  :  Human Resource Management | การจัดการทรัพยากรบุคคล | 人力资源管理"
    },
    {
        "id":1630,
        "name":"1629 (Thai Program)  :  Telecommunications Management | การจัดการโทรคมนาคม | 电信管理"
    },
    {
        "id":1631,
        "name":"1630 (Thai Program)  :  Labor Management And Social Welfare | การจัดการแรงงานและสวัสดิการสังคม | 劳动管理和社会福利"
    },
    {
        "id":1632,
        "name":"1631 (English Program)  :  Ecotourism Planning And Management | การวางแผนและการจัดการการท่องเที่ยวเชิงนิเวศ | 生态旅游规划与管理"
    },
    {
        "id":1633,
        "name":"1632 (Thai Program)  :  Information Management | การจัดการสารนิเทศ | 信息管理"
    },
    {
        "id":1634,
        "name":"1633 (Thai Program)  :  Computer Information Management | การจัดการสารสนเทศคอมพิวเตอร์ | 计算机信息管理"
    },
    {
        "id":1635,
        "name":"1634 (Thai Program)  :  Health Management | การจัดการสุขภาพ | 健康管理"
    },
    {
        "id":1636,
        "name":"1635 (Thai Program)  :  Organizational Management | การจัดการองค์การ | 组织管理"
    },
    {
        "id":1637,
        "name":"1636 (Thai Program)  :  Manufacturing Industry Management | การจัดการอุตสาหกรรมการผลิต | 制造业管理"
    },
    {
        "id":1638,
        "name":"1637 (Thai Program)  :  Industry And Technology Management | การจัดการอุตสาหกรรมและเทคโนโลยี | 工业和技术管理"
    },
    {
        "id":1639,
        "name":"1638 (Thai Program)  :  Industrial Management | การจัดการอุตสาหการ | 工业管理"
    },
    {
        "id":1640,
        "name":"1639 (English Program)  :  Project Planning And Evaluation | การวางแผนและประเมินผลโครงการ | 项目规划和评估"
    },
    {
        "id":1641,
        "name":"1640 (Thai Program)  :  Tourism And Hospitality Industry | การท่องเที่ยวและอุตสาหกรรมการบริการ | 旅游及酒店业"
    },
    {
        "id":1642,
        "name":"1641 (Thai Program)  :  Marketing Management | การบริหารการตลาด | 营销管理"
    },
    {
        "id":1643,
        "name":"1642 (Thai Program)  :  Tourism And Hotel Management | การบริหารการท่องเที่ยวและการโรงแรม | 旅游及酒店管理"
    },
    {
        "id":1644,
        "name":"1643 (Thai Program)  :  Hotel And Tourism Management | การบริหารการโรงแรมและการท่องเที่ยว | 酒店及旅游管理"
    },
    {
        "id":1645,
        "name":"1644 (Thai Program)  :  Communication Management | การบริหารการสื่อสาร | 沟通管理"
    },
    {
        "id":1646,
        "name":"1645 (Thai Program)  :  Office Administration | การบริหารสำนักงาน | 办公室行政"
    },
    {
        "id":1647,
        "name":"1646 (Thai Program)  :  Industrial Administration | การบริหารอุตสาหกรรม | 工业管理"
    },
    {
        "id":1648,
        "name":"1647 (Thai Program)  :  Management Accounting | การบัญชีเพื่อการจัดการ | 管理会计"
    },
    {
        "id":1649,
        "name":"1648 (Thai Program)  :  Business Operations | การประกอบการธุรกิจ | 商业运作"
    },
    {
        "id":1650,
        "name":"1649 (Thai Program)  :  Life Insurance | การประกันชีวิต | 人寿保险"
    },
    {
        "id":1651,
        "name":"1650 (Thai Program)  :  General Insurance | การประกันภัยทั่วไป | 一般保险"
    },
    {
        "id":1652,
        "name":"1651 (Thai Program)  :  Public Relations And Advertising | การประชาสัมพันธ์และการโฆษณา | 公共关系和广告"
    },
    {
        "id":1653,
        "name":"1652 (Thai Program)  :  Eastern Medicine | การแพทย์แผนตะวันออก | 东方医学"
    },
    {
        "id":1654,
        "name":"1653 (Thai Program)  :  Film And Video | การภาพยนตร์และวีดิทัศน์ | 电影和视频"
    },
    {
        "id":1655,
        "name":"1654 (Thai Program)  :  Taxation | การภาษีอากร | 税收"
    },
    {
        "id":1656,
        "name":"1655 (Thai Program)  :  Bilingual Education | การศึกษาระบบสองภาษา | 双语教育"
    },
    {
        "id":1657,
        "name":"1656 (English Program)  :  Rural Planning And Development | การวางแผนและการพัฒนาชนบท | 农村规划与发展"
    },
    {
        "id":1658,
        "name":"1657 (Thai Program)  :  Computer Information | การสารสนเทศคอมพิวเตอร์ | 计算机信息"
    },
    {
        "id":1659,
        "name":"1658 (Thai Program)  :  Communication | การสื่อสาร | 沟通"
    },
    {
        "id":1660,
        "name":"1659 (Thai Program)  :  Marketing Communications | การสื่อสารการตลาด | 营销传播"
    },
    {
        "id":1661,
        "name":"1660 (Thai Program)  :  Media Communication | การสื่อสารด้วยสื่อ | 媒体传播"
    },
    {
        "id":1662,
        "name":"1661 (Thai Program)  :  Business Communication | การสื่อสารธุรกิจ | 商务沟通"
    },
    {
        "id":1663,
        "name":"1662 (Thai Program)  :  International Business Communication | การสื่อสารธุรกิจระหว่างประเทศ | 国际商务沟通"
    },
    {
        "id":1664,
        "name":"1663 (Thai Program)  :  Interpersonal Communication | การสื่อสารระหว่างบุคคล | 人际交往"
    },
    {
        "id":1665,
        "name":"1664 (Thai Program)  :  Journalism | การหนังสือพิมพ์ | 新闻学"
    },
    {
        "id":1666,
        "name":"1665 (Thai Program)  :  Preserving And Restoring Architecture And Communities | การอนุรักษ์และฟื้นฟูสถาปัตยกรรมและชุมชน | 保护和恢复建筑和社区"
    },
    {
        "id":1667,
        "name":"1666 (Thai Program)  :  Urban And Rural Community Design | การออกแบบชุมชนเมืองและชนบท | 城乡社区设计"
    },
    {
        "id":1668,
        "name":"1667 (English Program)  :  Operations Research | การวิจัยปฏิบัติการ | 运营研究"
    },
    {
        "id":1669,
        "name":"1668 (Thai Program)  :  Product And Packaging Design | การออกแบบผลิตภัณฑ์และบรรจุภัณฑ์ | 产品及包装设计"
    },
    {
        "id":1670,
        "name":"1669 (Thai Program)  :  Computational Mathematics | คณิตศาสตร์เชิงคอมพิวเตอร์ | 计算数学"
    },
    {
        "id":1671,
        "name":"1670 (Thai Program)  :  Christian Studies | คริสตศาสนศึกษา | 基督教研究"
    },
    {
        "id":1672,
        "name":"1671 (Thai Program)  :  Computer Multimedia Games | คอมพิวเตอร์เกมส์มัลติมีเดีย | 电脑多媒体游戏"
    },
    {
        "id":1673,
        "name":"1672 (Thai Program)  :  Computers For Architectural Design | คอมพิวเตอร์เพื่อการออกแบบสถาปัตยกรรม | 建筑设计计算机"
    },
    {
        "id":1674,
        "name":"1673 (Thai Program)  :  Computers And Statistics | คอมพิวเตอร์และสถิติ | 计算机和统计"
    },
    {
        "id":1675,
        "name":"1674 (Thai Program)  :  Computer Art | คอมพิวเตอร์อาร์ต | 电脑艺术"
    },
    {
        "id":1676,
        "name":"1675 (Thai Program)  :  Telecommunications And Computer Networks | โครงข่ายโทรคมนาคมและคอมพิวเตอร์ | 电信和计算机网络"
    },
    {
        "id":1677,
        "name":"1676 (Thai Program)  :  China In The Global Economy | จีนในระบบเศรษฐกิจโลก | 全球经济中的中国"
    },
    {
        "id":1678,
        "name":"1677 (Thai Program)  :  Music | ดุริยศิลป์ | 音乐"
    },
    {
        "id":1679,
        "name":"1678 (Thai Program)  :  Computer Resources And Information Management | ทรัพยากรคอมพิวเตอร์และการจัดการสารสนเทศ | 计算机资源和信息管理"
    },
    {
        "id":1680,
        "name":"1679 (Thai Program)  :  Human Resources | ทรัพยากรบุคคล | 人力资源"
    },
    {
        "id":1681,
        "name":"1680 (Thai Program)  :  Sports Technology-Health And Management | เทคโนโลยีการกีฬา-สุขภาพและการจัดการ | 运动技术-健康与管理"
    },
    {
        "id":1682,
        "name":"1681 (Thai Program)  :  Industrial Biotechnology | เทคโนโลยีชีวภาพอุตสาหกรรม | 工业生物技术"
    },
    {
        "id":1683,
        "name":"1682 (Thai Program)  :  Information Technology | เทคโนโลยีสนเทศศาสตร์ | 信息技术"
    },
    {
        "id":1684,
        "name":"1683 (Thai Program)  :  Social Technology | เทคโนโลยีสังคม | 社会技术"
    },
    {
        "id":1685,
        "name":"1684 (Thai Program)  :  Food Industry Technology | เทคโนโลยีอุตสาหกรรมอาหาร | 食品工业技术"
    },
    {
        "id":1686,
        "name":"1685 (Thai Program)  :  Hotel And Tourism Business | ธุรกิจการโรงแรมและการท่องเที่ยว | 酒店及旅游业务"
    },
    {
        "id":1687,
        "name":"1686 (Thai Program)  :  Music Business | ธุรกิจดนตรี | 音乐事业"
    },
    {
        "id":1688,
        "name":"1687 (Thai Program)  :  Resource And Environmental Policy And Management | นโยบายและการจัดการทรัพยากรและสิ่งแวดล้อม | 资源环境政策与管理"
    },
    {
        "id":1689,
        "name":"1688 (Thai Program)  :  Science Policy And Planning | นโยบายและการวางแผนวิทยาศาสตร์ | 科学政策与规划"
    },
    {
        "id":1690,
        "name":"1689 (English Program)  :  Dental Research | การวิจัยทางทันตกรรม | 牙科研究"
    },
    {
        "id":1691,
        "name":"1690 (Thai Program)  :  Business Administration And Environment | บริหารธุรกิจและสิ่งแวดล้อม | 工商管理与环境"
    },
    {
        "id":1692,
        "name":"1691 (English Program)  :  Behavioral Science Research And Development Of Individuals | การวิจัยวิทยาศาสตร์พฤติกรรมศาสตร์และการพัฒนาบุคคล | 个人行为科学研究与发展"
    },
    {
        "id":1693,
        "name":"1692 (Thai Program)  :  Public Administration | บริหารสาธารณะ | 公共行政"
    },
    {
        "id":1694,
        "name":"1693 (Thai Program)  :  Account | บัญชี | 帐户"
    },
    {
        "id":1695,
        "name":"1694 (Thai Program)  :  Financial Accounting | บัญชีการเงิน | 财务会计"
    },
    {
        "id":1696,
        "name":"1695 (Thai Program)  :  Cost Accounting | บัญชีต้นทุน | 成本会计"
    },
    {
        "id":1697,
        "name":"1696 (Thai Program)  :  Social History | ประวัติศาสตร์สังคม | 社会史"
    },
    {
        "id":1698,
        "name":"1697 (Thai Program)  :  Philosophy, Politics And Economics | ปรัชญา การเมือง และเศรษฐศาสตร์ | 哲学、政治学和经济学"
    },
    {
        "id":1699,
        "name":"1698 (Thai Program)  :  Philosophy And Religious Studies | ปรัชญาและศาสนศึกษา | 哲学与宗教研究"
    },
    {
        "id":1700,
        "name":"1699 (Thai Program)  :  Social, Business And Political Leaders | ผู้นำทางสังคม ธุรกิจ และการเมือง | 社会、商业和政治领袖"
    },
    {
        "id":1701,
        "name":"1700 (Thai Program)  :  Nurse | พยาบาล | 护士"
    },
    {
        "id":1702,
        "name":"1701 (Thai Program)  :  Behavioral And Social Sciences (Psychology) | พฤติกรรมศาสตร์และสังคมศาสตร์(จิตวิทยา) | 行为与社会科学（心理学）"
    },
    {
        "id":1703,
        "name":"1702 (English Program)  :  Applied Behavioral Science Research | การวิจัยวิทยาศาสตร์พฤติกรรมประยุกต์ | 应用行为科学研究"
    },
    {
        "id":1704,
        "name":"1703 (Thai Program)  :  Electronic Commerce | พาณิชย์อิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":1705,
        "name":"1704 (Thai Program)  :  Fashion Design | แฟชั่นดีไซน์ | 时装设计"
    },
    {
        "id":1706,
        "name":"1705 (Thai Program)  :  Business Chinese | ภาษาจีนธุรกิจ | 商务汉语"
    },
    {
        "id":1707,
        "name":"1706 (English Program)  :  Educational Research And Development | การวิจัยและพัฒนาการศึกษา | 教育研究与发展"
    },
    {
        "id":1708,
        "name":"1707 (English Program)  :  Community Research And Development | การวิจัยและพัฒนาชุมชน | 社区研究与开发"
    },
    {
        "id":1709,
        "name":"1708 (Thai Program)  :  English For Communication | ภาษาอังกฤษเพื่อการสิ่อสาร | 沟通英语"
    },
    {
        "id":1710,
        "name":"1709 (English Program)  :  Health System Research And Development | การวิจัยและพัฒนาระบบสุขภาพ | 卫生系统研究与开发"
    },
    {
        "id":1711,
        "name":"1710 (Thai Program)  :  English For Business And Technology | ภาษาอังกฤษเพื่อธุรกิจและเทคโนโลยี | 商业和技术英语"
    },
    {
        "id":1712,
        "name":"1711 (Thai Program)  :  English Business Communication | ภาษาอังกฤษสื่อสารธุรกิจ | 英语商务沟通"
    },
    {
        "id":1713,
        "name":"1712 (Thai Program)  :  Humanities | มนุษยศาสตร์ | 人文学科"
    },
    {
        "id":1714,
        "name":"1713 (Thai Program)  :  Multimedia | มัลติมีเดีย | 多媒体"
    },
    {
        "id":1715,
        "name":"1714 (Thai Program)  :  Information Management System | ระบบการจัดการสารสนเทศ | 信息管理系统"
    },
    {
        "id":1716,
        "name":"1715 (Thai Program)  :  Information Systems And Management | ระบบและการจัดการสารสนเทศ | 信息系统和管理"
    },
    {
        "id":1717,
        "name":"1716 (Thai Program)  :  Management Information System | ระบบสารสนเทศการจัดการ | 管理信息系统"
    },
    {
        "id":1718,
        "name":"1717 (Thai Program)  :  Business Information System | ระบบสารสนเทศธุรกิจ | 商业信息系统"
    },
    {
        "id":1719,
        "name":"1718 (English Program)  :  Social Research And Development | การวิจัยและพัฒนาทางสังคม | 社会研究与发展"
    },
    {
        "id":1720,
        "name":"1719 (Thai Program)  :  Wideband Communication System | ระบบสื่อสารแถบความถี่กว้าง | 宽带通信系统"
    },
    {
        "id":1721,
        "name":"1720 (Thai Program)  :  Literature And Language (Professional English Writing) | วรรณคดีและภาษา(การเขียนภาษาอังกฤษเชิงวิชาชีพ) | 文学与语言（专业英语写作）"
    },
    {
        "id":1722,
        "name":"1721 (Thai Program)  :  Music Science | วิทยาการดนตรี | 音乐科学"
    },
    {
        "id":1723,
        "name":"1722 (Thai Program)  :  Telecommunications Science | วิทยาการโทรคมนาคม | 电信科学"
    },
    {
        "id":1724,
        "name":"1723 (Thai Program)  :  Information Science | วิทยาการสารสนเทศ | 信息科学"
    },
    {
        "id":1725,
        "name":"1724 (Thai Program)  :  Computer Information Science | วิทยาการสารสนเทศคอมพิวเตอร์ | 计算机信息科学"
    },
    {
        "id":1726,
        "name":"1725 (Thai Program)  :  Information Science | วิทยาการสารสนเทศศาสตร์ | 信息科学"
    },
    {
        "id":1727,
        "name":"1726 (Thai Program)  :  Biomedical Science | วิทยาศาสตร์ชีวการแพทย์ | 生物医学科学"
    },
    {
        "id":1728,
        "name":"1727 (Thai Program)  :  Basic Science | วิทยาศาสตร์พื้นฐาน | 基础科学"
    },
    {
        "id":1729,
        "name":"1728 (Thai Program)  :  Radio Broadcasting | วิทยุกระจายเสียง | 无线电广播"
    },
    {
        "id":1730,
        "name":"1729 (English Program)  :  Urban Research And Development | การวิจัยและพัฒนาเมือง | 城市研究与发展"
    },
    {
        "id":1731,
        "name":"1730 (Thai Program)  :  International Affairs | วิเทศกิจ | 国际事务"
    },
    {
        "id":1732,
        "name":"1731 (Thai Program)  :  Construction Engineering | วิศวกรรมก่อสร้าง | 建筑工程"
    },
    {
        "id":1733,
        "name":"1732 (Thai Program)  :  Electrical Power Engineering | วิศวกรรมไฟฟ้ากำลัง | 电力工程"
    },
    {
        "id":1734,
        "name":"1733 (Thai Program)  :  Information Systems Engineering | วิศวกรรมระบบสารสนเทศ | 信息系统工程"
    },
    {
        "id":1735,
        "name":"1734 (Thai Program)  :  Logistics Engineering | วิศวกรรมโลจิสติกส์ | 物流工程"
    },
    {
        "id":1736,
        "name":"1735 (English Program)  :  Educational Research And Statistics | การวิจัยและสถิติทางการศึกษา | 教育研究和统计"
    },
    {
        "id":1737,
        "name":"1736 (English Program)  :  Project Analysis And Appraisal | การวิเคราะห์และประเมินโครงการ | 项目分析与评估"
    },
    {
        "id":1738,
        "name":"1737 (Thai Program)  :  Photography Art | ศิลปภาพถ่าย | 摄影艺术"
    },
    {
        "id":1739,
        "name":"1738 (Thai Program)  :  Liberal Arts | ศิลปศาสตร์ | 文科"
    },
    {
        "id":1740,
        "name":"1739 (Thai Program)  :  Basic Liberal Arts | ศิลปศาสตร์พื้นฐาน | 基础文科"
    },
    {
        "id":1741,
        "name":"1740 (Thai Program)  :  Financial Economics | เศรษฐศาสตร์การเงิน | 金融经济学"
    },
    {
        "id":1742,
        "name":"1741 (Thai Program)  :  Social Welfare | สวัสดิการสังคม | 社会福利"
    },
    {
        "id":1743,
        "name":"1742 (Thai Program)  :  Social Science | สังคมศาสตร์ | 社会科学"
    },
    {
        "id":1744,
        "name":"1743 (Thai Program)  :  Information | สารนิเทศ | 信息"
    },
    {
        "id":1745,
        "name":"1744 (Thai Program)  :  Information | สารสนเทศ | 信息"
    },
    {
        "id":1746,
        "name":"1745 (Thai Program)  :  Interior Design | ออกแบบตกแต่งภายใน | 室内设计"
    },
    {
        "id":1747,
        "name":"1746 (English Program)  :  Social Analysis And Planning | การวิเคราะห์และการวางแผนทางสังคม | 社会分析与规划"
    },
    {
        "id":1748,
        "name":"1747 (Thai Program)  :  English For Business And Technology | อังกฤษเพื่อธุรกิจและเทคโนโลยี | 商业和技术英语"
    },
    {
        "id":1749,
        "name":"1748 (Thai Program)  :  Power Electronics | อิเล็กทรอนิกส์กำลัง | 电力电子"
    },
    {
        "id":1750,
        "name":"1749 (Thai Program)  :  Service Industry | อุตสาหกรรมบริการ | 服务业"
    },
    {
        "id":1751,
        "name":"1750 (Thai Program)  :  Mechatronics | เมคคาทรอนิกส์ | 机电一体化"
    },
    {
        "id":1752,
        "name":"1751 (Thai Program)  :  Network And Mobile Technology | เทคโนโลยีเครือข่ายและโมไบล์ | 网络和移动技术"
    },
    {
        "id":1753,
        "name":"1752 (Thai Program)  :  System Management | การบริหารจัดการระบบ | 系统管理"
    },
    {
        "id":1754,
        "name":"1753 (Thai Program)  :  Digital Arts | ดิจิทัลอาร์ตส์ | 数字艺术"
    },
    {
        "id":1755,
        "name":"1754 (Thai Program)  :  Building Resource Management | การบริหารทรัพยากรอาคาร | 建筑资源管理"
    },
    {
        "id":1756,
        "name":"1755 (Thai Program)  :  Community Nursing Practice | การพยาบาลเวชปฏิบัติชุมชน | 社区护理实践"
    },
    {
        "id":1757,
        "name":"1756 (Thai Program)  :  Project Management And Evaluation | การจัดการและการประเมินโครงการ | 项目管理与评估"
    },
    {
        "id":1758,
        "name":"1757 (English Program)  :  Rural Education | การศึกษาในชนบท | 农村教育"
    },
    {
        "id":1759,
        "name":"1758 (Thai Program)  :  Conservation Of Biodiversity And Ecotourism | การอนุรักษ์ความหลากหลายทางชีวภาพ และการท่องเที่ยวเชิงนิเวศ | 保护生物多样性和生态旅游"
    },
    {
        "id":1760,
        "name":"1759 (Thai Program)  :  Marketing And Electronic Commerce | การตลาดและการพานิชย์อิเล็คทรอนิกส์ | 营销和电子商务"
    },
    {
        "id":1761,
        "name":"1760 (Thai Program)  :  Innovative Media Design | การออกแบบสื่อนวัตกรรม | 创新媒体设计"
    },
    {
        "id":1762,
        "name":"1761 (Thai Program)  :  Space And Geoinformatics Technology | เทคโนโลยีอวกาศและภูมิสารสนเทศ | 空间和地理信息技术"
    },
    {
        "id":1763,
        "name":"1762 (Thai Program)  :  Information Science | วิทยาศาสตร์สนเทศ | 信息科学"
    },
    {
        "id":1764,
        "name":"1763 (Thai Program)  :  Foreign Language | ภาษาต่างประเทศ | 外语"
    },
    {
        "id":1765,
        "name":"1764 (Thai Program)  :  Information For Communication | สารสนเทศเพื่อการสื่อสาร | 通讯信息"
    },
    {
        "id":1766,
        "name":"1765 (Thai Program)  :  Production Design | ออกแบบการผลิต | 生产设计"
    },
    {
        "id":1767,
        "name":"1766 (Thai Program)  :  Architectural Techniques | เทคนิคสถาปัตยกรรม | 建筑技术"
    },
    {
        "id":1768,
        "name":"1767 (Thai Program)  :  Computer Information Systems-Software Development | ระบบสารสนเทศทางคอมพิวเตอร์-พัฒนาซอฟท์แวร์ | 计算机信息系统-软件开发"
    },
    {
        "id":1769,
        "name":"1768 (Thai Program)  :  Computer Information Systems - Information System Management | ระบบสารสนเทศทางคอมพิวเตอร์-การจัดการระบบสารสนเทศ | 计算机信息系统-信息系统管理"
    },
    {
        "id":1770,
        "name":"1769 (Thai Program)  :  Medical Informatics | สารสนเทศการแพทย์ | 医学信息学"
    },
    {
        "id":1771,
        "name":"1770 (Thai Program)  :  Investment Information | สารสนเทศการลงทุน | 投资信息"
    },
    {
        "id":1772,
        "name":"1771 (Thai Program)  :  Tool And Mold Maker | ช่างผลิตเครื่องมือและแม่พิมพ์ | 工具和模具制造商"
    },
    {
        "id":1773,
        "name":"1772 (Thai Program)  :  Maintenance Of Machinery | ซ่อมบำรุงเครื่องจักร | 机械维修"
    },
    {
        "id":1774,
        "name":"1773 (Thai Program)  :  Automatic Machinery | เครื่องจักรกลอัตโนมัติ | 自动机械"
    },
    {
        "id":1775,
        "name":"1774 (Thai Program)  :  Industrial Techniques | เทคนิคอุตสาหกรรม | 工业技术"
    },
    {
        "id":1776,
        "name":"1775 (Thai Program)  :  Gemstone Mold | แม่พิมพ์อัญมณี | 宝石模具"
    },
    {
        "id":1777,
        "name":"1776 (Thai Program)  :  Computer Techniques | เทคนิคคอมพิวเตอร์ | 计算机技术"
    },
    {
        "id":1778,
        "name":"1777 (Thai Program)  :  Fabrics And Clothing-Fashion Design | ผ้าและเครื่องแต่งกาย-ออกแบบแฟชั่น | 面料与服装-时装设计"
    },
    {
        "id":1779,
        "name":"1778 (Thai Program)  :  Food And Nutrition-Product Development | อาหารและโภชนา-พัฒนาผลิตภัณฑ์ | 食品和营养产品开发"
    },
    {
        "id":1780,
        "name":"1779 (Thai Program)  :  Home Economics Studies - General Home Economics | คหกรรมศาสตร์ศึกษา-คหกรรมศาสตร์ทั่วไป | 家政学研究 - 一般家政学"
    },
    {
        "id":1781,
        "name":"1780 (Thai Program)  :  Computer System And Network Management | การบริหารระบบคอมพิวเตอร์และเครือข่าย | 计算机系统与网络管理"
    },
    {
        "id":1782,
        "name":"1781 (Thai Program)  :  Computer Graphics And Multimedia | คอมพิวเตอร์กราฟฟิกส์และมัลติมีเดีย | 计算机图形学和多媒体"
    },
    {
        "id":1783,
        "name":"1782 (Thai Program)  :  Multimedia And Internet Systems | มัลติมีเดียและระบบอินเทอร์เน็ต | 多媒体和互联网系统"
    },
    {
        "id":1784,
        "name":"1783 (Thai Program)  :  Intellectual Property And Information Technology Law | กฎหมายทรัพย์สินทางปัญญาและเทคโนโลยีสารสนเทศ | 知识产权和信息技术法"
    },
    {
        "id":1785,
        "name":"1784 (Thai Program)  :  International Business Law And Electronic Transactions | กฎหมายธุรกิจระหว่างประเทศและธุรกรรมทางอิเล็กทรอนิกส์ | 国际商法和电子交易"
    },
    {
        "id":1786,
        "name":"1785 (Thai Program)  :  Sustainable Land Use And Natural Resource Management | การใช้ที่ดินและการจัดการทรัพยากรธรรมชาติอย่างยั่งยืน | 可持续土地利用和自然资源管理"
    },
    {
        "id":1787,
        "name":"1786 (Thai Program)  :  Environmental Risk Assessment | การประเมินความเสี่ยงทางด้านสิ่งแวดล้อมฯ | 环境风险评估"
    },
    {
        "id":1788,
        "name":"1787 (Thai Program)  :  Elderly Care | การบริบาลผู้สูงอายุ | 老年护理"
    },
    {
        "id":1789,
        "name":"1788 (Thai Program)  :  Media Design | การออกแบบสื่อ | 媒体设计"
    },
    {
        "id":1790,
        "name":"1789 (Thai Program)  :  Biodiversity And Ethnobiology | ความหลากหลายทางชีวภาพและชีววิทยาชาติพันธุ์ | 生物多样性和民族生物学"
    },
    {
        "id":1791,
        "name":"1790 (Thai Program)  :  Industrial And Organizational Psychology | จิตวิทยาอุตสาหกรรมและองค์กร | 工业和组织心理学"
    },
    {
        "id":1792,
        "name":"1791 (Thai Program)  :  Restorative Dentistry | ทันตกรรมบูรณะ | 修复牙科"
    },
    {
        "id":1793,
        "name":"1792 (Thai Program)  :  Petroleum Geosciences | ธรณีศาสตร์ปิโตรเลียม | 石油地球科学"
    },
    {
        "id":1794,
        "name":"1793 (Thai Program)  :  Library And Information Science | บรรณรักษศาสตร์และสารนิเทศศาสตร์ | 图书情报学"
    },
    {
        "id":1795,
        "name":"1794 (Thai Program)  :  Business Administration For Executives | บริหารธุรกิจสำหรับผู้บริหาร | 高管工商管理"
    },
    {
        "id":1796,
        "name":"1795 (English Program)  :  Nonformal Education (Requirement) | การศึกษานอกระบบ (ข้อกำหนด) | 非正规教育（要求）"
    },
    {
        "id":1797,
        "name":"1796 (Thai Program)  :  Movement Science And Exercise | วิทยาศาสตร์การเคลื่อนไหว และการออกกำลังกาย | 运动科学和锻炼"
    },
    {
        "id":1798,
        "name":"1797 (Thai Program)  :  Pharmaceutical Science | วิทยาศาสตร์เภสัชกรรม | 药学"
    },
    {
        "id":1799,
        "name":"1798 (Thai Program)  :  Engineering | วิศวกรรมศาสตร์ | 工程"
    },
    {
        "id":1800,
        "name":"1799 (Thai Program)  :  Public Health Veterinarian | สัตวแพทย์สาธารณสุข | 公共卫生兽医"
    },
    {
        "id":1801,
        "name":"1800 (Thai Program)  :  Media Art And Media Design | สื่อศิลปะและการออกแบบสื่อ | 媒体艺术和媒体设计"
    },
    {
        "id":1802,
        "name":"1801 (Thai Program)  :  Health Education And Health Promotion | สุขศึกษาและการส่งเสริมสุขภาพ | 健康教育和健康促进"
    },
    {
        "id":1803,
        "name":"1802 (Thai Program)  :  Obstetrics And Gynecology | สูติศาสตร์และนรีเวชวิทยา | 妇产科"
    },
    {
        "id":1804,
        "name":"1803 (Thai Program)  :  Industry | อุตสาหกรรม | 行业"
    },
    {
        "id":1805,
        "name":"1804 (Thai Program)  :  Retail Trade | การค้าปลีก | 零售贸易"
    },
    {
        "id":1806,
        "name":"1805 (Thai Program)  :  Theology | เทววิทยา | 神学"
    },
    {
        "id":1807,
        "name":"1806 (Thai Program)  :  Medical Science(Radiological Technology) | วิทยาศาสตร์การแพทย์(รังสีเทคนิค) | 医学（放射技术）"
    },
    {
        "id":1808,
        "name":"1807 (Thai Program)  :  Special Medical Science (Radiological Technology) | วิทยาศาสตร์การแพทย์(รังสีเทคนิค) เฉพาะกิจ | 特殊医学（放射技术）"
    },
    {
        "id":1809,
        "name":"1808 (Thai Program)  :  Triam Udom Music | เตรียมอุดมดนตรี | 特里阿姆乌多姆音乐"
    },
    {
        "id":1810,
        "name":"1809 (Thai Program)  :  Public Health Science | วิทยาศาสตร์สาธารณสุข | 公共卫生科学"
    },
    {
        "id":1811,
        "name":"1810 (Thai Program)  :  Information And Communication Technology (International) | เทคโนโลยีสารสนเทศและการสื่อสาร(นานาชาติ) | 信息与通信技术（国际）"
    },
    {
        "id":1812,
        "name":"1811 (Thai Program)  :  Geology | ธรณีศาสตร์ | 地质学"
    },
    {
        "id":1813,
        "name":"1812 (Thai Program)  :  Thai Music And Eastern Music | ดนตรีไทยและดนตรีตะวันออก | 泰国音乐和东方音乐"
    },
    {
        "id":1814,
        "name":"1813 (Thai Program)  :  Practical Music | ดนตรีปฏิบัติ | 实用音乐"
    },
    {
        "id":1815,
        "name":"1814 (Thai Program)  :  Music Technology Industry | อุตสาหกรรมเทคโนโลยีดนตรี | 音乐科技产业"
    },
    {
        "id":1816,
        "name":"1815 (Thai Program)  :  Popular Music | ดนตรีสมัยนิยม | 流行音乐"
    },
    {
        "id":1817,
        "name":"1816 (English Program)  :  Adult Education | การศึกษาสำหรับผู้ใหญ่ | 成人教育"
    },
    {
        "id":1818,
        "name":"1817 (English Program)  :  Adult And Continuing Education | การศึกษาสำหรับผู้ใหญ่และต่อเนื่อง | 成人和继续教育"
    },
    {
        "id":1819,
        "name":"1818 (Thai Program)  :  Occupational-Specific English | ภาษาอังกฤษเฉพาะอาชีพ | 职业专用英语"
    },
    {
        "id":1820,
        "name":"1819 (Thai Program)  :  Information Work | งานสารสนเทศ | 信息工作"
    },
    {
        "id":1821,
        "name":"1820 (Thai Program)  :  Hotel And Restaurant | การโรงแรมและภัตตาคาร | 酒店及餐厅"
    },
    {
        "id":1822,
        "name":"1821 (Thai Program)  :  International Relations And Comparative Politics | ความสัมพันธ์ระหว่างประเทศและการเมืองการปกครองเปรียบเทียบ | 国际关系与比较政治"
    },
    {
        "id":1823,
        "name":"1822 (Thai Program)  :  Political Communication | การสื่อสารการเมือง | 政治沟通"
    },
    {
        "id":1824,
        "name":"1823 (Thai Program)  :  Communication, Tourism And Entertainment | การสื่อสารการท่องเที่ยวและบันเทิง | 通讯、旅游、娱乐"
    },
    {
        "id":1825,
        "name":"1824 (Thai Program)  :  Fashion And Textile Design | การออกแบบแฟชั่นและสิ่งทอ | 时装及纺织品设计"
    },
    {
        "id":1826,
        "name":"1825 (Thai Program)  :  Service Industry Management | การจัดการอุตสาหกรรมการบริการ | 服务业管理"
    },
    {
        "id":1827,
        "name":"1826 (Thai Program)  :  Health Services | การบริการสุขภาพ | 卫生服务"
    },
    {
        "id":1828,
        "name":"1827 (Thai Program)  :  Advanced Software Technology | เทคโนโลยีซอฟต์แวร์ขั้นสูง | 先进的软件技术"
    },
    {
        "id":1829,
        "name":"1828 (Thai Program)  :  Multimedia Technology And Animation | เทคโนโลยีมัลติมีเดียและการสร้างภาพเคลื่อนไหว | 多媒体技术与动画"
    },
    {
        "id":1830,
        "name":"1829 (Thai Program)  :  Advanced Information Technology | เทคโนโลยีสารสนเทศขั้นสูง | 先进的信息技术"
    },
    {
        "id":1831,
        "name":"1830 (Thai Program)  :  Health Care Worker | นักบริการสุขภาพ | 医护人员"
    },
    {
        "id":1832,
        "name":"1831 (Thai Program)  :  Product Development | พัฒนาผลิตภัณฑ์ | 产品开发"
    },
    {
        "id":1833,
        "name":"1832 (English Program)  :  Pharmacy Program (International) | โครงการเภสัชกรรม (นานาชาติ) | 药学课程（国际）"
    },
    {
        "id":1834,
        "name":"1833 (Thai Program)  :  Construction Project Management | การจัดการโครงการก่อสร้าง | 建设项目管理"
    },
    {
        "id":1835,
        "name":"1834 (Thai Program)  :  Hotel Management | การจัดการโรงแรม | 酒店管理"
    },
    {
        "id":1836,
        "name":"1835 (Thai Program)  :  Lifelong Education | การศึกษาตลอดชีวิต | 终身教育"
    },
    {
        "id":1837,
        "name":"1836 (Thai Program)  :  Lifelong Education And Human Development | การศึกษาตลอดชีวิตและการพัฒนามนุษย์ | 终身教育与人类发展"
    },
    {
        "id":1838,
        "name":"1837 (English Program)  :  Special Education | การศึกษาพิเศษ | 特殊教育"
    },
    {
        "id":1839,
        "name":"1838 (Thai Program)  :  Conservation Of Paintings | การอนุรักษ์ภาพจิตรกรรม | 绘画的保护"
    },
    {
        "id":1840,
        "name":"1839 (Thai Program)  :  Multimedia Design | การออกแบบมัลติมีเดีย | 多媒体设计"
    },
    {
        "id":1841,
        "name":"1840 (Thai Program)  :  Khmer Studies | เขมรศึกษา | 高棉研究"
    },
    {
        "id":1842,
        "name":"1841 (Thai Program)  :  Mathematics And Information Technology | คณิตศาสตร์และเทคโนโลยีสารสนเทศ | 数学与信息技术"
    },
    {
        "id":1843,
        "name":"1842 (Thai Program)  :  Chemistry Studies | เคมีศึกษา | 化学研究"
    },
    {
        "id":1844,
        "name":"1843 (Thai Program)  :  Special Education Psychology | จิตวิทยาการศึกษาพิเศษ | 特殊教育心理学"
    },
    {
        "id":1845,
        "name":"1844 (Thai Program)  :  Commercial Music | ดนตรีเชิงพาณิชย์ | 商业音乐"
    },
    {
        "id":1846,
        "name":"1845 (Thai Program)  :  Information Technology For Design | เทคโนโลยีสารสนเทศเพื่อการออกแบบ | 设计信息技术"
    },
    {
        "id":1847,
        "name":"1846 (Thai Program)  :  Historical Studies | ประวัติศาสตร์ศึกษา | 历史研究"
    },
    {
        "id":1848,
        "name":"1847 (Thai Program)  :  Develop Food Products | พัฒนาผลิตภัณฑ์อาหาร | 开发食品产品"
    },
    {
        "id":1849,
        "name":"1848 (Thai Program)  :  Pharmaceutical Science | วิทยาการทางเภสัชศาสตร์ | 药学"
    },
    {
        "id":1850,
        "name":"1849 (Thai Program)  :  Materials Science And Engineering | วิทยาการและวิศวกรรมวัสดุ | 材料科学与工程"
    },
    {
        "id":1851,
        "name":"1850 (Thai Program)  :  Social Science And Health System Management | วิทยาการสังคมและการจัดการระบบสุขภาพ | 社会科学与卫生系统管理"
    },
    {
        "id":1852,
        "name":"1851 (Thai Program)  :  Vernacular Architecture | สถาปัตยกรรมพื้นถิ่น | 乡土建筑"
    },
    {
        "id":1853,
        "name":"1852 (Thai Program)  :  Asian Studies | เอเชียศึกษา | 亚洲研究"
    },
    {
        "id":1854,
        "name":"1853 (English Program)  :  Education For Locality Development | การศึกษาเพื่อการพัฒนาท้องถิ่น | 地方发展教育"
    },
    {
        "id":1855,
        "name":"1854 (Thai Program)  :  Chinese Medicine | การแพทย์แผนจีน | 中医"
    },
    {
        "id":1856,
        "name":"1855 (Thai Program)  :  Buddhist Language And Literature | ภาษาและวรรณคดีพุทธศาสนา | 佛教语言与文学"
    },
    {
        "id":1857,
        "name":"1856 (Thai Program)  :  Integrated Development | พัฒนบูรณาการศาสตร์ | 综合开发"
    },
    {
        "id":1858,
        "name":"1857 (Thai Program)  :  Pharmaceuticals And Natural Products | เภสัชภัณฑ์และผลิตภัณฑ์ธรรมชาติ | 药物和天然产物"
    },
    {
        "id":1859,
        "name":"1858 (Thai Program)  :  Vietnamese Language And Literature | ภาษาและวรรณคดีเวียดนาม | 越南语言和文学"
    },
    {
        "id":1860,
        "name":"1859 (Thai Program)  :  Village And Urban Community Fund Project Management | การบริหารจัดการโครงการกองทุนหมู่บ้านและชุมชนเมือง | 村镇社区基金项目管理"
    },
    {
        "id":1861,
        "name":"1860 (Thai Program)  :  Agricultural Information Technology And Rural Development | เทคโนโลยีสารสนเทศการเกษตรและพัฒนาชนบท | 农业信息技术与农村发展"
    },
    {
        "id":1862,
        "name":"1861 (Thai Program)  :  Manage Property Valuation | บริหารการประเมินค่าทรัพย์สิน | 管理财产估价"
    },
    {
        "id":1863,
        "name":"1862 (Thai Program)  :  Integrated Marketing Communications | การสื่อสารการตลาดแบบบูรณาการ | 整合营销传播"
    },
    {
        "id":1864,
        "name":"1863 (Thai Program)  :  General Insurance | การประกันวินาศภัย | 一般保险"
    },
    {
        "id":1865,
        "name":"1864 (Thai Program)  :  Marine And Air Insurance | การประกันภัยทางทะเลและทางเครื่องบิน | 海运和空运保险"
    },
    {
        "id":1866,
        "name":"1865 (Thai Program)  :  Personal Insurance | การประกันภัยส่วนบุคคล | 个人保险"
    },
    {
        "id":1867,
        "name":"1866 (Thai Program)  :  Actuarial Science | คณิตศาสตร์ประกันภัย | 精算学"
    },
    {
        "id":1868,
        "name":"1867 (Thai Program)  :  Business Insurance | ประกันภัยธุรกิจ | 商业保险"
    },
    {
        "id":1869,
        "name":"1868 (Thai Program)  :  Insurance Management | การจัดการประกันภัย | 保险管理"
    },
    {
        "id":1870,
        "name":"1869 (Thai Program)  :  Business German | ภาษาเยอรมันธุรกิจ | 商务德语"
    },
    {
        "id":1871,
        "name":"1870 (Thai Program)  :  Musical Performance | การแสดงดนตรี | 音乐表演"
    },
    {
        "id":1872,
        "name":"1871 (Thai Program)  :  Professional Music | ดนตรีระดับวิชาชีพ | 专业音乐"
    },
    {
        "id":1873,
        "name":"1872 (Thai Program)  :  Contemporary Music Composition And Production | การประพันธ์และการผลิตดนตรียุคปัจจุบัน | 当代音乐创作与制作"
    },
    {
        "id":1874,
        "name":"1873 (Thai Program)  :  Data Management And Analysis | การจัดการและการวิเคราะห์ข้อมูล | 数据管理与分析"
    },
    {
        "id":1875,
        "name":"1874 (Thai Program)  :  Industrial Automation And Power Electronics | ระบบอัตโนมัติอุตสาหกรรมและอิเล็กทรอนิกส์กำลัง | 工业自动化和电力电子"
    },
    {
        "id":1876,
        "name":"1875 (Thai Program)  :  Maritime Industry Management | การจัดการอุตสาหกรรมพาณิชยนาวี | 航运业管理"
    },
    {
        "id":1877,
        "name":"1876 (Thai Program)  :  Local Administration | การบริหารงานท้องถิ่น | 地方行政部门"
    },
    {
        "id":1878,
        "name":"1877 (Thai Program)  :  Arts And Culture Administration | การบริหารศิลปะและวัฒนธรรม | 艺术文化管理局"
    },
    {
        "id":1879,
        "name":"1878 (English Program)  :  Teaching Mathematics | การสอนคณิตศาสตร์ | 数学教学"
    },
    {
        "id":1880,
        "name":"1879 (Thai Program)  :  Education And Social Development | การศึกษาและการพัฒนาสังคม | 教育与社会发展"
    },
    {
        "id":1881,
        "name":"1880 (Thai Program)  :  Teaching Music Education | การสอนดุริยางคศึกษา | 音乐教育教学"
    },
    {
        "id":1882,
        "name":"1881 (English Program)  :  Teaching Biology | การสอนชีววิทยา | 生物学教学"
    },
    {
        "id":1883,
        "name":"1882 (Thai Program)  :  Teaching Japanese | การสอนภาษาญี่ปุ่น | 日语教学"
    },
    {
        "id":1884,
        "name":"1883 (Thai Program)  :  Teaching Social Studies, Religion And Culture | การสอนสังคมศึกษา ศาสนา และวัฒนธรรม | 教授社会研究、宗教和文化"
    },
    {
        "id":1885,
        "name":"1884 (Thai Program)  :  Teaching Health And Physical Education | การสอนสุขศึกษาและพลศึกษา | 健康与体育教学"
    },
    {
        "id":1886,
        "name":"1885 (Thai Program)  :  Sports Journalism | สื่อสารมวลชนทางกีฬา | 体育新闻"
    },
    {
        "id":1887,
        "name":"1886 (Thai Program)  :  Handicraft Design | ออกแบบหัตถศิลป์ | 工艺品设计"
    },
    {
        "id":1888,
        "name":"1887 (Thai Program)  :  Food And Service Industry | อุตสาหกรรมอาหารและบริการ | 食品及服务业"
    },
    {
        "id":1889,
        "name":"1888 (Thai Program)  :  Geography And Geoinformatics | ภูมิศาสตร์และภูมิสารสนเทศ | 地理和地理信息学"
    },
    {
        "id":1890,
        "name":"1889 (Thai Program)  :  Computer Technology For Architecture | เทคโนโลยีคอมพิวเตอร์เพื่องานสถาปัตยกรรม | 建筑计算机技术"
    },
    {
        "id":1891,
        "name":"1890 (Thai Program)  :  Hotel And Accommodation Business Management | การจัดการโรงแรมและธุรกิจที่พัก | 酒店及住宿业经营管理"
    },
    {
        "id":1892,
        "name":"1891 (English Program)  :  Teaching Of Buddhism | การสอนพระพุทธศาสนา | 佛法教学"
    },
    {
        "id":1893,
        "name":"1892 (Thai Program)  :  Hotel And Tourism Management | การจัดการโรงแรมและการท่องเที่ยว | 酒店及旅游管理"
    },
    {
        "id":1894,
        "name":"1893 (Thai Program)  :  Mathematics - Educational Measurement | คณิตศาสตร์-การวัดผลการศึกษา | 数学-教育测量"
    },
    {
        "id":1895,
        "name":"1894 (Thai Program)  :  Computer Film Technology | เทคโนโลยีภาพยนตร์คอมพิวเตอร์ | 电脑电影技术"
    },
    {
        "id":1896,
        "name":"1895 (Thai Program)  :  Construction Management | บริหารงานก่อสร้าง | 施工管理"
    },
    {
        "id":1897,
        "name":"1896 (Thai Program)  :  Agricultural Information | สารสนเทศการเกษตร | 农业资讯"
    },
    {
        "id":1898,
        "name":"1897 (Thai Program)  :  Geospatial Technology | เทคโนโลยีภูมิสารสนเทศ | 地理空间技术"
    },
    {
        "id":1899,
        "name":"1898 (Thai Program)  :  Political Economy And Management | เศรษฐศาสตร์การเมืองและการบริหารจัดการ | 政治经济与管理"
    },
    {
        "id":1900,
        "name":"1899 (Thai Program)  :  Resource Management For Security | การจัดการทรัพยากรเพื่อความมั่นคง | 安全资源管理"
    },
    {
        "id":1901,
        "name":"1900 (Thai Program)  :  Management Of Small And Medium Enterprises | การจัดการวิสาหกิจขนาดกลางและขนาดย่อม | 中小企业管理"
    },
    {
        "id":1902,
        "name":"1901 (Thai Program)  :  Business Finance | การเงินธุรกิจ | 商业金融"
    },
    {
        "id":1903,
        "name":"1902 (Thai Program)  :  Thai Language For Foreigners | ภาษาไทยสำหรับชาวต่างประเทศ | 外国人泰语"
    },
    {
        "id":1904,
        "name":"1903 (Thai Program)  :  Vipassana Meditation | วิปัสสนาภาวนา | 内观禅修"
    },
    {
        "id":1905,
        "name":"1904 (Thai Program)  :  Mahayana Studies | มหายานศึกษา | 大乘研究"
    },
    {
        "id":1906,
        "name":"1905 (Thai Program)  :  Pali And Sanskrit Language And Literature | ภาษาและวรรณคดีบาลีและสันสกฤต | 巴利语和梵语语言和文学"
    },
    {
        "id":1907,
        "name":"1906 (Thai Program)  :  Buddhist Philosophy | ปรัชญาพุทธศาสนา | 佛教哲学"
    },
    {
        "id":1908,
        "name":"1907 (Thai Program)  :  Information And Communication Technology Management | การจัดการเทคโนโลยีสารสนเทศและการสื่อสาร | 信息和通信技术管理"
    },
    {
        "id":1909,
        "name":"1908 (Thai Program)  :  Communication Business Management | การจัดการธุรกิจการสื่อสาร | 通讯业务管理"
    },
    {
        "id":1910,
        "name":"1909 (Thai Program)  :  Entertainment Business Management | การจัดการธุรกิจบันเทิง | 娱乐事业管理"
    },
    {
        "id":1911,
        "name":"1910 (Thai Program)  :  Logistics Management | การจัดการโลจิสติกส์ | 物流管理"
    },
    {
        "id":1912,
        "name":"1911 (Thai Program)  :  Food Industry Management | การจัดการอุตสาหกรรมอาหาร | 食品工业管理"
    },
    {
        "id":1913,
        "name":"1912 (Thai Program)  :  Entrepreneurship | การประกอบการ | 创业精神"
    },
    {
        "id":1914,
        "name":"1913 (Thai Program)  :  Financial Mathematics | คณิตศาสตร์การเงิน | 金融数学"
    },
    {
        "id":1915,
        "name":"1914 (Thai Program)  :  Marketing Communication Arts | นิเทศศาสตร์การตลาด | 营销传播艺术"
    },
    {
        "id":1916,
        "name":"1915 (Thai Program)  :  Thai Language For Business Communication | ภาษาไทยเพื่อการสื่อสารธุรกิจ | 泰语用于商务沟通"
    },
    {
        "id":1917,
        "name":"1916 (Thai Program)  :  English For Business Communication | ภาษาอังกฤษเพื่อการสื่อสารธุรกิจ | 商务沟通英语"
    },
    {
        "id":1918,
        "name":"1917 (Thai Program)  :  International Business Economics | เศรษฐศาสตร์ธุรกิจระหว่างประเทศ | 国际商业经济学"
    },
    {
        "id":1919,
        "name":"1918 (Thai Program)  :  Information Science | สนเทศศาสตร์ | 信息科学"
    },
    {
        "id":1920,
        "name":"1919 (English Program)  :  Teaching Physics | การสอนฟิสิกส์ | 物理教学"
    },
    {
        "id":1921,
        "name":"1920 (Thai Program)  :  Health Service Management | การจัดการบริการสุขภาพ | 健康服务管理"
    },
    {
        "id":1922,
        "name":"1921 (Thai Program)  :  Public And Private Management | การจัดการภาครัฐและเอกชน | 公共和私人管理"
    },
    {
        "id":1923,
        "name":"1922 (Thai Program)  :  Education Management | การจัดการการศึกษา | 教育管理"
    },
    {
        "id":1924,
        "name":"1923 (Thai Program)  :  English Is A Second Language. | ภาษาอังกฤษเป็นภาษาที่สอง | 英语是第二语言。"
    },
    {
        "id":1925,
        "name":"1924 (Thai Program)  :  Mass Communication Management | การจัดการสื่อสารมวลชน | 大众传播管理"
    },
    {
        "id":1926,
        "name":"1925 (Thai Program)  :  Industrial Science | วิทยาศาสตร์อุตสาหกรรม | 工业科学"
    },
    {
        "id":1927,
        "name":"1926 (Thai Program)  :  Industry And Technology Studies | อุตสาหกรรมและเทคโนโลยีศึกษา | 工业与技术研究"
    },
    {
        "id":1928,
        "name":"1927 (Thai Program)  :  Multimedia Journal | วารสารสื่อประสม | 多媒体期刊"
    },
    {
        "id":1929,
        "name":"1928 (Thai Program)  :  Retail Business Management | การบริหารธุรกิจค้าปลีก | 零售业务管理"
    },
    {
        "id":1930,
        "name":"1929 (Thai Program)  :  Entrepreneur | ผู้ประกอบการ | 企业家"
    },
    {
        "id":1931,
        "name":"1930 (Thai Program)  :  Language For Business Communication | ภาษาเพื่อการสื่อสารธุรกิจ | 商务沟通语言"
    },
    {
        "id":1932,
        "name":"1931 (Thai Program)  :  Accounting (E-Learning) | บัญชี (E-LEARNING) | 会计（电子学习）"
    },
    {
        "id":1933,
        "name":"1932 (Thai Program)  :  Computer Animation | คอมพิวเตอร์แอนิเมชั่น | 电脑动画"
    },
    {
        "id":1934,
        "name":"1933 (Thai Program)  :  Food Industry Systems | ระบบอุตสาหกรรมอาหาร | 食品工业系统"
    },
    {
        "id":1935,
        "name":"1934 (Thai Program)  :  English Language And Translation | ภาษาอังกฤษและการแปล | 英语语言和翻译"
    },
    {
        "id":1936,
        "name":"1935 (Thai Program)  :  Business Publicity | การประชาสัมพันธ์ธุรกิจ | 企业宣传"
    },
    {
        "id":1937,
        "name":"1936 (Thai Program)  :  Hi-Tech Management | การจัดการ HI-TECH | 高科技管理"
    },
    {
        "id":1938,
        "name":"1937 (Thai Program)  :  Chinese Business | ธุรกิจจีน | 中国商业"
    },
    {
        "id":1939,
        "name":"1938 (Thai Program)  :  Electronic Office Management | การบริหารสำนักงานอิเล็กทรอนิกส์ | 电子化办公管理"
    },
    {
        "id":1940,
        "name":"1939 (Thai Program)  :  Measurement And Research | การวัดผลและการวิจัย | 测量和研究"
    },
    {
        "id":1941,
        "name":"1940 (Thai Program)  :  Industry And Educational Technology | อุตสาหกรรมและเทคโนโลยีการศึกษา | 工业和教育技术"
    },
    {
        "id":1942,
        "name":"1941 (Thai Program)  :  Construction Industry Technology | เทคโนโลยีอุตสาหกรรมก่อสร้าง | 建筑行业技术"
    },
    {
        "id":1943,
        "name":"1942 (Thai Program)  :  Architectural Industrial Technology | เทคโนโลยีอุตสาหกรรมสถาปัตยกรรม | 建筑工业技术"
    },
    {
        "id":1944,
        "name":"1943 (Thai Program)  :  Space Technology Management | การจัดการเทคโนโลยีอวกาศ | 空间技术管理"
    },
    {
        "id":1945,
        "name":"1944 (Thai Program)  :  Risk Management | การจัดการความเสี่ยง | 风险管理"
    },
    {
        "id":1946,
        "name":"1945 (Thai Program)  :  Social Science Development | พัฒนสังคมศาสตร์ | 社会科学发展"
    },
    {
        "id":1947,
        "name":"1946 (Thai Program)  :  Teaching French | การสอนภาษาฝรั่งเศส | 法语教学"
    },
    {
        "id":1948,
        "name":"1947 (Thai Program)  :  Teaching Science-Chemistry | การสอนวิทยาศาสตร์-เคมี | 科学化学教学"
    },
    {
        "id":1949,
        "name":"1948 (Thai Program)  :  Teaching Science-Biology | การสอนวิทยาศาสตร์-ชีววิทยา | 科学生物学教学"
    },
    {
        "id":1950,
        "name":"1949 (Thai Program)  :  Teaching Science-Physics | การสอนวิทยาศาสตร์-ฟิสิกส์ | 科学物理教学"
    },
    {
        "id":1951,
        "name":"1950 (Thai Program)  :  Teaching Science-Computer Science | การสอนวิทยาศาสตร์-วิทยาการคอมพิวเตอร์ | 科学教学-计算机科学"
    },
    {
        "id":1952,
        "name":"1951 (Thai Program)  :  Teaching Science-General Science | การสอนวิทยาศาสตร์-วิทยาศาสตร์ทั่วไป | 科学教学——普通科学"
    },
    {
        "id":1953,
        "name":"1952 (Thai Program)  :  Teaching Science-Environmental Science | การสอนวิทยาศาสตร์-วิทยาศาสตร์สิ่งแวดล้อม | 科学教学-环境科学"
    },
    {
        "id":1954,
        "name":"1953 (Thai Program)  :  Home Economics Studies | คหกรรมศาสตรศึกษา | 家政学研究"
    },
    {
        "id":1955,
        "name":"1954 (Thai Program)  :  Vocational Education Development | พัฒนอาชีวศึกษา | 职业教育发展"
    },
    {
        "id":1956,
        "name":"1955 (Thai Program)  :  Aviation Technology | เทคโนโลยีการบิน | 航空技术"
    },
    {
        "id":1957,
        "name":"1956 (Thai Program)  :  Aerospace Engineering And Business Administration | วิศวกรรมการบินและอวกาศ และบริหารธุรกิจ | 航空航天工程和工商管理"
    },
    {
        "id":1958,
        "name":"1957 (Thai Program)  :  Software Engineering And Knowledge | วิศวกรรมซอฟต์แวร์และความรู้ | 软件工程和知识"
    },
    {
        "id":1959,
        "name":"1958 (Thai Program)  :  Civil Engineering-Water Resources | วิศวกรรมโยธา-ทรัพยากรน้ำ | 土木工程-水资源"
    },
    {
        "id":1960,
        "name":"1959 (Thai Program)  :  Industrial Production Technology | เทคโนโลยีการผลิตทางอุตสาหกรรม | 工业生产技术"
    },
    {
        "id":1961,
        "name":"1960 (Thai Program)  :  Mechanical Engineering And Manufacturing | วิศวกรรมเครื่องกลและการผลิต | 机械工程与制造"
    },
    {
        "id":1962,
        "name":"1961 (Thai Program)  :  Infrastructure Engineering And Administration | วิศวกรรมโครงสร้างพื้นฐานและการบริหาร | 基础设施工程与管理"
    },
    {
        "id":1963,
        "name":"1962 (Thai Program)  :  Civil And Environmental Engineering | วิศวกรรมโยธาและสิ่งแวดล้อม | 土木与环境工程"
    },
    {
        "id":1964,
        "name":"1963 (Thai Program)  :  Surveying Engineering And Geographic Information | วิศวกรรมสำรวจและสารสนเทศภูมิศาสตร์ | 测绘工程与地理信息"
    },
    {
        "id":1965,
        "name":"1964 (Thai Program)  :  Flight Management | การจัดการการบิน | 飞行管理"
    },
    {
        "id":1966,
        "name":"1965 (Thai Program)  :  Engineering Management | การจัดการวิศวกรรม | 工程管理"
    },
    {
        "id":1967,
        "name":"1966 (Thai Program)  :  Maintenance Management Engineering | วิศวกรรมการจัดการซ่อมบำรุง | 维修管理工程"
    },
    {
        "id":1968,
        "name":"1967 (Thai Program)  :  Fire Protection Engineering | วิศวกรรมป้องกันอัคคีภัย | 消防工程"
    },
    {
        "id":1969,
        "name":"1968 (Thai Program)  :  Environmental Technology And Management | เทคโนโลยีและการจัดการสิ่งแวดล้อม | 环境技术与管理"
    },
    {
        "id":1970,
        "name":"1969 (Thai Program)  :  Plant Breeding | การปรับปรุงพันธุ์พืช | 植物育种"
    },
    {
        "id":1971,
        "name":"1970 (Thai Program)  :  Animal Nutrition And Feed Technology | โภชนศาสตร์และเทคโนโลยีอาหารสัตว์ | 动物营养和饲料技术"
    },
    {
        "id":1972,
        "name":"1971 (Thai Program)  :  Food Safety | ความปลอดภัยของอาหาร | 食品安全"
    },
    {
        "id":1973,
        "name":"1972 (Thai Program)  :  Tropical Agriculture And International Trade | เกษตรเขตร้อน และการค้าระหว่างประเทศ | 热带农业和国际贸易"
    },
    {
        "id":1974,
        "name":"1973 (Thai Program)  :  Sustainable Agriculture | เกษตรยั่งยืน | 可持续农业"
    },
    {
        "id":1975,
        "name":"1974 (Thai Program)  :  Agricultural Information Technology | เทคโนโลยีสารสนเทศทางการเกษตร | 农业信息化"
    },
    {
        "id":1976,
        "name":"1975 (Thai Program)  :  Agricultural Research And Development | วิจัยและพัฒนาการเกษตร | 农业研究与开发"
    },
    {
        "id":1977,
        "name":"1976 (Thai Program)  :  Agricultural Science | วิทยาศาสตร์เกษตร | 农业科学"
    },
    {
        "id":1978,
        "name":"1977 (Thai Program)  :  Basin And Environmental Management | การจัดการลุ่มน้ำและสิ่งแวดล้อม | 流域与环境管理"
    },
    {
        "id":1979,
        "name":"1978 (Thai Program)  :  Forestry-Community Forestry And Sociology And Anthropology | วนศาสตร์-วนศาสตร์ชุมชนและสังคมวิทยาและมานุษยวิทยา | 林业-社区林业与社会学和人类学"
    },
    {
        "id":1980,
        "name":"1979 (Thai Program)  :  Building Innovation | นวัตกรรมอาคาร | 建设创新"
    },
    {
        "id":1981,
        "name":"1980 (Thai Program)  :  Veterinary Microbiology | จุลชีววิทยาทางสัตวแพทย์ | 兽医微生物学"
    },
    {
        "id":1982,
        "name":"1981 (Thai Program)  :  Veterinary Parasitology | ปรสิตวิทยาทางสัตวแพทย์ | 兽医寄生虫学"
    },
    {
        "id":1983,
        "name":"1982 (Thai Program)  :  Veterinary Pharmacy And Toxicology | เภสัชและพิษวิทยาทางสัตวแพทย์ | 兽医药学和毒理学"
    },
    {
        "id":1984,
        "name":"1983 (Thai Program)  :  Eye Science | วิทยาศาสตร์สายตา | 眼科学"
    },
    {
        "id":1985,
        "name":"1984 (Thai Program)  :  New Media | สื่อใหม่ | 新媒体"
    },
    {
        "id":1986,
        "name":"1985 (Thai Program)  :  Ecotourism | การท่องเที่ยวเชิงนิเวศ | 生态旅游"
    },
    {
        "id":1987,
        "name":"1986 (Thai Program)  :  Dramatic Arts | ศิลปะการละคร | 戏剧艺术"
    },
    {
        "id":1988,
        "name":"1987 (Thai Program)  :  Mathematics Information | คณิตศาสตร์สารสนเทศ | 数学资料"
    },
    {
        "id":1989,
        "name":"1988 (Thai Program)  :  Occupational Safety And Health Technology | เทคโนโลยีความปลอดภัยและอาชีวอนามัย | 职业安全卫生技术"
    },
    {
        "id":1990,
        "name":"1989 (English Program)  :  Teaching Thai | การสอนภาษาไทย | 泰语教学"
    },
    {
        "id":1991,
        "name":"1990 (Thai Program)  :  Graphic And Multimedia Design | ออกแบบกราฟิกและมัลติมีเดีย | 图形和多媒体设计"
    },
    {
        "id":1992,
        "name":"1991 (Thai Program)  :  Automotive | ยานยนต์ | 汽车"
    },
    {
        "id":1993,
        "name":"1992 (Thai Program)  :  Machine Tools | เครื่องมือกล | 机床"
    },
    {
        "id":1994,
        "name":"1993 (English Program)  :  Teaching Thai As A Foreign Language | การสอนภาษาไทยเป็นภาษาต่างประเทศ | 泰语作为外语教学"
    },
    {
        "id":1995,
        "name":"1994 (English Program)  :  Teaching Sciences | การสอนวิทยาศาสตร์ | 科学教学"
    },
    {
        "id":1996,
        "name":"1995 (English Program)  :  Science Teaching Specialized In Elementary And Secondary Education | การสอนวิทยาศาสตร์เฉพาะทางในระดับประถมศึกษาและมัธยมศึกษา | 中小学教育科学教学"
    },
    {
        "id":1997,
        "name":"1996 (Thai Program)  :  Construction | การก่อสร้าง | 建造"
    },
    {
        "id":1998,
        "name":"1997 (Thai Program)  :  Sales | การขาย | 销售量"
    },
    {
        "id":1999,
        "name":"1998 (English Program)  :  Teaching Of Science And Mathematics | การสอนวิทยาศาสตร์และคณิตศาสตร์ | 科学和数学教学"
    },
    {
        "id":2000,
        "name":"1999 (Thai Program)  :  Metal Techniques | เทคนิคโลหะ | 金属技术"
    },
    {
        "id":2001,
        "name":"2000 (Thai Program)  :  Landscape Architecture | ภูมิสถาปัตยกรรมศาสตร์ | 景观设计"
    },
    {
        "id":2002,
        "name":"2001 (English Program)  :  Teaching Social Studies | การสอนสังคมศึกษา | 教授社会研究"
    },
    {
        "id":2003,
        "name":"2002 (English Program)  :  Teaching Of Social Studies At The Secondary School Level | การสอนสังคมศึกษาในระดับมัธยมศึกษา | 中学社会研究教学"
    },
    {
        "id":2004,
        "name":"2003 (Thai Program)  :  Agricultural Promotion And Communication | การส่งเสริมและสื่อสารการเกษตร | 农业推广与交流"
    },
    {
        "id":2005,
        "name":"2004 (Thai Program)  :  Architecture(Architecture) | สถาปัตยกรรมศาสตร์(สถาปัตยกรรม) | 建筑学（建筑学）"
    },
    {
        "id":2006,
        "name":"2005 (Thai Program)  :  Architecture (Community Planning Design) | สถาปัตยกรรมศาสตร์(ออกแบบผังชุมชน) | 建筑（社区规划设计）"
    },
    {
        "id":2007,
        "name":"2006 (English Program)  :  Teaching Chemistry | การสอนวิชาเคมี | 化学教学"
    },
    {
        "id":2008,
        "name":"2007 (Thai Program)  :  Health Business Management Technology | เทคโนโลยีการจัดการธุรกิจสุขภาพ | 健康企业管理技术"
    },
    {
        "id":2009,
        "name":"2008 (Thai Program)  :  City ​​Administration And Development | การบริหารและพัฒนาเมือง | 城市管理和发展"
    },
    {
        "id":2010,
        "name":"2009 (English Program)  :  Auditing | การตรวจสอบ | 审计"
    },
    {
        "id":2011,
        "name":"2010 (Thai Program)  :  General Home Economics | คหกรรมศาสตร์ทั่วไป | 普通家政"
    },
    {
        "id":2012,
        "name":"2011 (Thai Program)  :  Industrial Technician Construction Technician Branch | ช่างอุตสาหกรรม แขนงช่างก่อสร้าง | 工业技术员施工技术员分会"
    },
    {
        "id":2013,
        "name":"2012 (Thai Program)  :  Industrial Technician Electrical Technician Branch | ช่างอุตสาหกรรม แขนงช่างไฟฟ้า | 工业技术员电气技师分会"
    },
    {
        "id":2014,
        "name":"2013 (Thai Program)  :  Industrial Technician, Automotive Mechanic Branch | ช่างอุตสาหกรรม แขนงช่างยนต์ | 工业技术员、汽车机械师"
    },
    {
        "id":2015,
        "name":"2014 (Thai Program)  :  Industrial Technician, Metal Technician Branch | ช่างอุตสาหกรรม แขนงช่างโลหะ | 工业技术员、金属技术员分会"
    },
    {
        "id":2016,
        "name":"2015 (Thai Program)  :  Industrial Technician Architectural Technical Branch | ช่างอุตสาหกรรม แขนงเทคนิคสถาปัตยกรรม | 工业技术员建筑技术分会"
    },
    {
        "id":2017,
        "name":"2016 (Thai Program)  :  Music Education (Thai Music) | ดนตรีศึกษา(ดนตรีไทย) | 音乐教育（泰国音乐）"
    },
    {
        "id":2018,
        "name":"2017 (Thai Program)  :  Music Education (International) | ดนตรีศึกษา(สากล) | 音乐教育（国际）"
    },
    {
        "id":2019,
        "name":"2018 (Thai Program)  :  Fine Arts (Communication Design) | ศิลปกรรม (ออกแบบนิเทศศิลป์) | 美术（传播设计）"
    },
    {
        "id":2020,
        "name":"2019 (Thai Program)  :  Business Administration Quality Management Field | การบริหารธุรกิจ แขนงวิชาการจัดการคุณภาพ | 商业管理质量管理领域"
    },
    {
        "id":2021,
        "name":"2020 (Thai Program)  :  Business Administration Marketing Field | การบริหารธุรกิจ แขนงวิชาการตลาด | 商业管理营销领域"
    },
    {
        "id":2022,
        "name":"2021 (Thai Program)  :  Business Administration Field Of Study: Human Resource Management | การบริหารธุรกิจ แขนงวิชาการบริหารทรัพยากรมนุษย์ | 商业管理研究领域: 人力资源管理"
    },
    {
        "id":2023,
        "name":"2022 (Thai Program)  :  Business Administration Accounting Field | การบริหารธุรกิจ แขนงวิชาการบัญชี | 商业管理会计领域"
    },
    {
        "id":2024,
        "name":"2023 (Thai Program)  :  Business Administration Business Computer Major | การบริหารธุรกิจ แขนงวิชาคอมพิวเตอร์ธุรกิจ | 商业管理商务计算机专业"
    },
    {
        "id":2025,
        "name":"2024 (Thai Program)  :  Business Administration Service Business Field | การบริหารธุรกิจ แขนงวิชาธุรกิจบริการ | 商业管理服务业务领域"
    },
    {
        "id":2026,
        "name":"2025 (Thai Program)  :  Communication Arts, Department Of Advertising | นิเทศศาสตร์ แขนงวิชาการโฆษณา | 传播艺术、广告系"
    },
    {
        "id":2027,
        "name":"2026 (Thai Program)  :  Communication Arts, Field Of Public Relations | นิเทศศาสตร์ แขนงวิชาการประชาสัมพันธ์ | 传播艺术、公共关系领域"
    },
    {
        "id":2028,
        "name":"2027 (Thai Program)  :  Communication Arts, Journalism Field | นิเทศศาสตร์ แขนงวิชาวารสารศาสตร์ | 传播艺术、新闻学领域"
    },
    {
        "id":2029,
        "name":"2028 (Thai Program)  :  Communication Arts, Radio And Television Major | นิเทศศาสตร์ แขนงวิชาวิทยุและโทรทัศน์ | 传播艺术、广播电视专业"
    },
    {
        "id":2030,
        "name":"2029 (Thai Program)  :  Business Economics International Business Major | เศรษฐศาสตร์ธุรกิจ แขนงวิชาธุรกิจระหว่างประเทศ | 商业经济学国际商务专业"
    },
    {
        "id":2031,
        "name":"2030 (Thai Program)  :  Business Economics, Business, Finance And Banking Subjects | เศรษฐศาสตร์ธุรกิจแขนงวิชาธุรกิจการเงินการธนาคาร | 商业经济学、商业、金融和银行科目"
    },
    {
        "id":2032,
        "name":"2031 (Thai Program)  :  Business Economics Field Of Study: Tourism Business | เศรษฐศาสตร์ธุรกิจ แขนงวิชาธุรกิจการท่องเที่ยว | 商业经济学研究领域: 旅游商业"
    },
    {
        "id":2033,
        "name":"2032 (Thai Program)  :  Tourism Industry (Travel Business) | อุตสาหกรรมท่องเที่ยว(ธุรกิจท่องเที่ยว) | 旅游业（旅游业务）"
    },
    {
        "id":2034,
        "name":"2033 (Thai Program)  :  Tourism Industry (Hotel Business) | อุตสาหกรรมท่องเที่ยว(ธุรกิจโรงแรม) | 旅游业（酒店业）"
    },
    {
        "id":2035,
        "name":"2034 (Thai Program)  :  Industrial Technology Construction Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีก่อสร้าง | 工业技术建筑技术分会"
    },
    {
        "id":2036,
        "name":"2035 (Thai Program)  :  Industrial Technology Industrial Management Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีการจัดการอุตสาหกรรม | 工业技术工业管理技术分会"
    },
    {
        "id":2037,
        "name":"2036 (Thai Program)  :  Industrial Technology Production Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีการผลิต | 工业技术生产技术分公司"
    },
    {
        "id":2038,
        "name":"2037 (Thai Program)  :  Industrial Technology Industrial Computer Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีคอมพิวเตอร์อุตสาหกรรม | 工业技术工业计算机技术分会"
    },
    {
        "id":2039,
        "name":"2038 (Thai Program)  :  Industrial Technology Mechanical Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีเครื่องกล | 工业技术机械技术分会"
    },
    {
        "id":2040,
        "name":"2039 (Thai Program)  :  Industrial Technology Industrial Electrical Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีไฟฟ้าอุตสาหกรรม | 工业技术工业电气技术分会"
    },
    {
        "id":2041,
        "name":"2040 (Thai Program)  :  Industrial Technology Interior Architectural Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีสถาปัตยกรรมภายใน | 工业技术室内建筑技术分会"
    },
    {
        "id":2042,
        "name":"2041 (Thai Program)  :  Industrial Technology Architectural Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีสถาปัตยกรรม | 工业技术建筑技术分会"
    },
    {
        "id":2043,
        "name":"2042 (Thai Program)  :  Industrial Technology Industrial Product Design Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业技术工业产品设计技术分会"
    },
    {
        "id":2044,
        "name":"2043 (Thai Program)  :  Industrial Technology Electronic Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีอิเล็กทรอนิกส์ | 工业技术电子技术分会"
    },
    {
        "id":2045,
        "name":"2044 (Thai Program)  :  Ceramics Technology | เทคโนโลยีเซรามิกส์ | 陶瓷技术"
    },
    {
        "id":2046,
        "name":"2045 (Thai Program)  :  Mathematics Education | คณิตศาสตรศึกษา | 数学教育"
    },
    {
        "id":2047,
        "name":"2046 (Thai Program)  :  Learning Management | การจัดการการเรียนรู้ | 学习管理"
    },
    {
        "id":2048,
        "name":"2047 (Thai Program)  :  Project Management And Project Evaluation | การจัดการโครงการและการประเมินโครงการ | 项目管理和项目评估"
    },
    {
        "id":2049,
        "name":"2048 (Thai Program)  :  Science Education | วิทยาศาสตรศึกษา | 科学教育"
    },
    {
        "id":2050,
        "name":"2049 (Thai Program)  :  Business Innovation Management | การจัดการนวัตกรรมทางธุรกิจ | 业务创新管理"
    },
    {
        "id":2051,
        "name":"2050 (Thai Program)  :  Enterprise Management | การจัดการวิสาหกิจ | 企业管理"
    },
    {
        "id":2052,
        "name":"2051 (Thai Program)  :  Public And Private Sector Management | การจัดการภาครัฐและภาคเอกชน | 公共和私营部门管理"
    },
    {
        "id":2053,
        "name":"2052 (Thai Program)  :  Early Childhood Education Management | การจัดการการปฐมวัยศึกษา | 幼儿教育管理"
    },
    {
        "id":2054,
        "name":"2053 (Thai Program)  :  Logistics And Supply Chain Management | การจัดการลอจิสติกส์และโซ่อุปทาน | 物流和供应链管理"
    },
    {
        "id":2055,
        "name":"2054 (Thai Program)  :  Modern Management And Information Technology | การจัดการสมัยใหม่และเทคโนโลยีสารสนเทศ | 现代管理和信息技术"
    },
    {
        "id":2056,
        "name":"2055 (Thai Program)  :  Animation | แอนนิเมชัน | 动画片"
    },
    {
        "id":2057,
        "name":"2056 (Thai Program)  :  Marine Product Technology | เทคโนโลยีผลิตภัณฑ์ทางทะเล | 海洋产品技术"
    },
    {
        "id":2058,
        "name":"2057 (Thai Program)  :  Aviation Management | การบริหารการบิน | 航空管理"
    },
    {
        "id":2059,
        "name":"2058 (Thai Program)  :  Handicraft Design | การออกแบบหัตถศิลป์ | 工艺品设计"
    },
    {
        "id":2060,
        "name":"2059 (Thai Program)  :  Costume Design | การออกแบบเครื่องแต่งกาย | 服装设计"
    },
    {
        "id":2061,
        "name":"2060 (Thai Program)  :  Innovation In Organizing Conferences And Exhibitions | นวัตกรรมการจัดประชุมและนิทรรศการ | 创新会议展览组织方式"
    },
    {
        "id":2062,
        "name":"2061 (Thai Program)  :  Retail Management | การจัดการการค้าปลีก | 零售管理"
    },
    {
        "id":2063,
        "name":"2062 (Thai Program)  :  Tourism And Hospitality Management | การจัดการการท่องเที่ยวและการบริการ | 旅游和酒店管理"
    },
    {
        "id":2064,
        "name":"2063 (Thai Program)  :  Soil And Environmental Resource Management | การจัดการทรัพยากรดินและสิ่งแวดล้อม | 土壤与环境资源管理"
    },
    {
        "id":2065,
        "name":"2064 (English Program)  :  Communication Management For Public And Business | การจัดการการสื่อสารเพื่อสาธารณะและธุรกิจ | 公众和企业的通信管理"
    },
    {
        "id":2066,
        "name":"2065 (Thai Program)  :  Agricultural Technology Management | การจัดการเทคโนโลยีการเกษตร | 农业技术管理"
    },
    {
        "id":2067,
        "name":"2066 (Thai Program)  :  Production Technology And Information Management | การจัดการเทคโนโลยีการผลิตและสารสนเทศ | 生产技术与信息管理"
    },
    {
        "id":2068,
        "name":"2067 (Thai Program)  :  Assistive Technology Management | การจัดการเทคโนโลยีสิ่งอำนวยความสะดวก | 辅助技术管理"
    },
    {
        "id":2069,
        "name":"2068 (Thai Program)  :  Aviation Business Management | การจัดการธุรกิจด้านการบิน | 航空业务管理"
    },
    {
        "id":2070,
        "name":"2069 (English Program)  :  Communication For Development | การสื่อสารเพื่อการพัฒนา | 沟通促进发展"
    },
    {
        "id":2071,
        "name":"2070 (Thai Program)  :  Power Management | การจัดการพลังงาน | 电源管理"
    },
    {
        "id":2072,
        "name":"2071 (Thai Program)  :  Electronic Commerce Management | การจัดการพาณิชย์อิเล็กทรอนิกส์ | 电子商务管理"
    },
    {
        "id":2073,
        "name":"2072 (Thai Program)  :  Hotel Management (Resort And Spa) | การจัดการโรงแรม (รีสอร์ทและสปา) | 酒店管理（度假村和水疗中心）"
    },
    {
        "id":2074,
        "name":"2073 (Thai Program)  :  Hotel And Accommodation Management | การจัดการโรงแรมและที่พัก | 酒店及住宿管理"
    },
    {
        "id":2075,
        "name":"2074 (English Program)  :  Agricultural Extension | การขยายสาขาเกษตรกรรม | 农业推广"
    },
    {
        "id":2076,
        "name":"2075 (Thai Program)  :  Tourism And Hospitality Industry Management | การจัดการอุตสาหกรรมการท่องเที่ยวและการโรงแรม | 旅游与酒店业管理"
    },
    {
        "id":2077,
        "name":"2076 (Thai Program)  :  Hospitality And Tourism | การบริการและการท่องเที่ยว | 酒店业和旅游业"
    },
    {
        "id":2078,
        "name":"2077 (Thai Program)  :  Industrial Administration | การบริหารงานอุตสาหกรรม | 工业管理"
    },
    {
        "id":2079,
        "name":"2078 (Thai Program)  :  Golf Management | การบริหารจัดการกอล์ฟ | 高尔夫管理"
    },
    {
        "id":2080,
        "name":"2079 (Thai Program)  :  Property Management | การบริหารทรัพย์สิน | 物业管理"
    },
    {
        "id":2081,
        "name":"2080 (Thai Program)  :  Public Administration And Public Affairs | การบริหารรัฐกิจและกิจการสาธารณะ | 公共行政和公共事务"
    },
    {
        "id":2082,
        "name":"2081 (Thai Program)  :  Urban Administration And Development | การบริหารและพัฒนาผังเมือง | 城市管理与发展"
    },
    {
        "id":2083,
        "name":"2082 (Thai Program)  :  Entrepreneurship And Management | การประกอบการและการจัดการ | 创业与管理"
    },
    {
        "id":2084,
        "name":"2083 (Thai Program)  :  Business Operations In Science And Technology | การประกอบธุรกิจทางวิทยาศาสตร์และเทคโนโลยี | 科技领域的商业运作"
    },
    {
        "id":2085,
        "name":"2084 (English Program)  :  Design | ออกแบบ | 设计"
    },
    {
        "id":2086,
        "name":"2085 (Thai Program)  :  Teaching General Science | การสอนวิทยาศาสตร์ทั่วไป | 教授普通科学"
    },
    {
        "id":2087,
        "name":"2086 (Thai Program)  :  Integrated Communication | การสื่อสารบูรณาการ | 整合传播"
    },
    {
        "id":2088,
        "name":"2087 (Thai Program)  :  Brand Communication | การสื่อสารแบรนด์ | 品牌传播"
    },
    {
        "id":2089,
        "name":"2088 (Thai Program)  :  Computer Graphics Design | การออกแบบคอมพิวเตอร์กราฟฟิก | 计算机图形设计"
    },
    {
        "id":2090,
        "name":"2089 (Thai Program)  :  Interactive Design And Game Development | การออกแบบเชิงโต้ตอบและการพัฒนาเกม | 交互设计和游戏开发"
    },
    {
        "id":2091,
        "name":"2090 (Thai Program)  :  Visual Design – Fashion Design | การออกแบบทัศนศิลป์ – การออกแบบแฟชั่น | 视觉设计——时装设计"
    },
    {
        "id":2092,
        "name":"2091 (Thai Program)  :  Visual Design – Communication Design | การออกแบบทัศนศิลป์ – การออกแบบสื่อสาร | 视觉设计 – 传达设计"
    },
    {
        "id":2093,
        "name":"2092 (Thai Program)  :  Visual Design – Jewelry Art | การออกแบบทัศนศิลป์ – ศิลปะเครื่องประดับ | 视觉设计——珠宝艺术"
    },
    {
        "id":2094,
        "name":"2093 (Thai Program)  :  Industrial Product Design | การออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计"
    },
    {
        "id":2095,
        "name":"2094 (Thai Program)  :  Fashion Design | การออกแบบแฟชั่น | 时装设计"
    },
    {
        "id":2096,
        "name":"2095 (Thai Program)  :  Print Media Design | การออกแบบสื่อสิ่งพิมพ์ | 印刷媒体设计"
    },
    {
        "id":2097,
        "name":"2096 (Thai Program)  :  Food And Service Business | การอาหารและธุรกิจการบริการ | 食品及服务业"
    },
    {
        "id":2098,
        "name":"2097 (Thai Program)  :  Mathematics And Information | คณิตศาสตร์และสารสนเทศ | 数学与信息"
    },
    {
        "id":2099,
        "name":"2098 (Thai Program)  :  Design Education | ครุศาสตร์การออกแบบ | 设计教育"
    },
    {
        "id":2100,
        "name":"2099 (Thai Program)  :  Engineering Education | ครุศาสตร์วิศวกรรม | 工程教育"
    },
    {
        "id":2101,
        "name":"2100 (Thai Program)  :  Internal Environment Education | ครุศาสตร์สภาพแวดล้อมภายใน | 内部环境教育"
    },
    {
        "id":2102,
        "name":"2101 (Thai Program)  :  Computer And Cyber Security | ความมั่นคงคอมพิวเตอร์และไซเบอร์ | 计算机和网络安全"
    },
    {
        "id":2103,
        "name":"2102 (Thai Program)  :  Computer Graphics | คอมพิวเตอร์กราฟิก | 计算机图形学"
    },
    {
        "id":2104,
        "name":"2103 (Thai Program)  :  Applied Computers | คอมพิวเตอร์ประยุกต์ | 应用计算机"
    },
    {
        "id":2105,
        "name":"2104 (Thai Program)  :  Computer Product Design | คอมพิวเตอร์ออกแบบผลิตภัณฑ์ | 计算机产品设计"
    },
    {
        "id":2106,
        "name":"2105 (Thai Program)  :  Industrial And Environmental Chemistry | เคมีอุตสาหกรรมและสิ่งแวดล้อม | 工业和环境化学"
    },
    {
        "id":2107,
        "name":"2106 (English Program)  :  Food And Catering | อาหารและการจัดเลี้ยง | 食品和餐饮"
    },
    {
        "id":2108,
        "name":"2107 (Thai Program)  :  Civil Engineer | ช่างโยธา | 土木工程师"
    },
    {
        "id":2109,
        "name":"2108 (Thai Program)  :  Ethnographic Study Of Particles In The Mekong Basin | ชาติพันธุ์ศึกษาอนุภาคลุ่มน้ำโขง | 湄公河流域颗粒物的民族志研究"
    },
    {
        "id":2110,
        "name":"2109 (Thai Program)  :  Electrical Installation | ติดตั้งไฟฟ้า | 电气装置"
    },
    {
        "id":2111,
        "name":"2110 (Thai Program)  :  Land And Environmental Resources | ทรัพยากรที่ดินและสิ่งแวดล้อม | 土地和环境资源"
    },
    {
        "id":2112,
        "name":"2111 (Thai Program)  :  Optometry | ทัศนมาตรศาสตร์ | 验光"
    },
    {
        "id":2113,
        "name":"2112 (Thai Program)  :  Visual Arts – Ceramics | ทัศนศิลป์ – เซรามิกส์ | 视觉艺术 – 陶瓷"
    },
    {
        "id":2114,
        "name":"2113 (Thai Program)  :  Visual Arts – Imaginary Art | ทัศนศิลป์ – ศิลปะจินตทัศน์ | 视觉艺术——想象艺术"
    },
    {
        "id":2115,
        "name":"2114 (Thai Program)  :  Industrial Welding Techniques | เทคนิคการเชื่อมอุตสาหกรรม | 工业焊接技术"
    },
    {
        "id":2116,
        "name":"2115 (Thai Program)  :  Production Techniques | เทคนิคการผลิต | 生产技术"
    },
    {
        "id":2117,
        "name":"2116 (Thai Program)  :  Printing Techniques | เทคนิคการพิมพ์ | 印刷技术"
    },
    {
        "id":2118,
        "name":"2117 (Thai Program)  :  Automotive Techniques | เทคนิคยานยนต์ | 汽车技术"
    },
    {
        "id":2119,
        "name":"2118 (English Program)  :  Finance And Banking | การเงินและการธนาคาร | 金融与银行"
    },
    {
        "id":2120,
        "name":"2119 (Thai Program)  :  Construction Technology | เทคโนโลยีก่อสร้าง | 施工技术"
    },
    {
        "id":2121,
        "name":"2120 (Thai Program)  :  Industrial Business Management Technology | เทคโนโลยีการจัดการธุรกิจอุตสาหกรรม | 工业企业管理技术"
    },
    {
        "id":2122,
        "name":"2121 (Thai Program)  :  Gaming And Multimedia Technology | เทคโนโลยีเกมและมัลติมีเดีย | 游戏和多媒体技术"
    },
    {
        "id":2123,
        "name":"2122 (Thai Program)  :  Office Computer Technology | เทคโนโลยีคอมพิวเตอร์สำนักงาน | 办公计算机技术"
    },
    {
        "id":2124,
        "name":"2123 (Thai Program)  :  Electronic Computer Technology | เทคโนโลยีคอมพิวเตอร์อิเล็กทรอนิกส์ | 电子计算机技术"
    },
    {
        "id":2125,
        "name":"2124 (Thai Program)  :  Furniture And Interior Decoration Technology | เทคโนโลยีเครื่องเรือนและการตกแต่งภายใน | 家具及室内装饰技术"
    },
    {
        "id":2126,
        "name":"2125 (Thai Program)  :  Music Technology | เทคโนโลยีดนตรี | 音乐技术"
    },
    {
        "id":2127,
        "name":"2126 (Thai Program)  :  Medical Technology | เทคโนโลยีทางการแพทย์ | 医疗技术"
    },
    {
        "id":2128,
        "name":"2127 (English Program)  :  Human Reproduction And Population Planning | การสืบพันธุ์ของมนุษย์และการวางแผนประชากร | 人类生殖和人口规划"
    },
    {
        "id":2129,
        "name":"2128 (Thai Program)  :  Electrical Power Technology | เทคโนโลยีไฟฟ้ากำลัง | 电力技术"
    },
    {
        "id":2130,
        "name":"2129 (Thai Program)  :  Industrial Electrical Technology | เทคโนโลยีไฟฟ้าอุตสาหกรรม | 工业电气技术"
    },
    {
        "id":2131,
        "name":"2130 (English Program)  :  Resource Based English Language Learning | การเรียนรู้ภาษาอังกฤษตามทรัพยากร | 基于资源的英语学习"
    },
    {
        "id":2132,
        "name":"2131 (Thai Program)  :  Information Technology | เทคโนโลยีวารสารสนเทศ | 信息技术"
    },
    {
        "id":2133,
        "name":"2132 (Thai Program)  :  Production Engineering Technology | เทคโนโลยีวิศวกรรมการผลิต | 生产工程技术"
    },
    {
        "id":2134,
        "name":"2133 (Thai Program)  :  Environmental Information Technology | เทคโนโลยีสารสนเทศสิ่งแวดล้อม | 环境信息技术"
    },
    {
        "id":2135,
        "name":"2134 (Thai Program)  :  Industrial Product Design Technology | เทคโนโลยีออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计技术"
    },
    {
        "id":2136,
        "name":"2135 (Thai Program)  :  Food And Nutrition Technology | เทคโนโลยีอาหารและโภชนาการ | 食品与营养技术"
    },
    {
        "id":2137,
        "name":"2136 (Thai Program)  :  Electronic Technology And Telecommunications | เทคโนโลยีอิเล็กทรอนิกส์และโทรคมนาคม | 电子技术和电信"
    },
    {
        "id":2138,
        "name":"2137 (Thai Program)  :  Service Business | ธุรกิจบริการ | 服务业"
    },
    {
        "id":2139,
        "name":"2138 (Thai Program)  :  Pilot | นักบิน | 飞行员"
    },
    {
        "id":2140,
        "name":"2139 (Thai Program)  :  Dance Music | นาฎยคีตศิลป์ | 舞曲"
    },
    {
        "id":2141,
        "name":"2140 (Thai Program)  :  Agricultural Communication Arts | นิเทศศาสตร์เกษตร | 农业传播艺术"
    },
    {
        "id":2142,
        "name":"2141 (Thai Program)  :  Physical Education-Technology, Sports Reporter | พลศึกษา-เทคโนโลยีผู้สื่อข่าวกีฬา | 体育技术、体育记者"
    },
    {
        "id":2143,
        "name":"2142 (Thai Program)  :  Physical Education And Recreation | พลศึกษาและนันทนาการ | 体育和娱乐"
    },
    {
        "id":2144,
        "name":"2143 (Thai Program)  :  Physical Education And Health Education | พลศึกษาและสุขศึกษา | 体育与健康教育"
    },
    {
        "id":2145,
        "name":"2144 (Thai Program)  :  Applied Thai Traditional Medicine | แพทย์แผนไทยประยุกต์ | 应用泰国传统医学"
    },
    {
        "id":2146,
        "name":"2145 (Thai Program)  :  Applied Physics – Energy | ฟิสิกส์ประยุกต์ – พลังงาน | 应用物理-能源"
    },
    {
        "id":2147,
        "name":"2146 (Thai Program)  :  Industrial Physics | ฟิสิกส์อุตสาหกรรม | 工业物理学"
    },
    {
        "id":2148,
        "name":"2147 (Thai Program)  :  Electrical Communication | ไฟฟ้าสื่อสาร | 电气通讯"
    },
    {
        "id":2149,
        "name":"2148 (Thai Program)  :  Industrial Electricity | ไฟฟ้าอุตสาหกรรม | 工业用电"
    },
    {
        "id":2150,
        "name":"2149 (Thai Program)  :  Film And Digital | ภาพยนตร์และดิจิตอล | 电影和数字"
    },
    {
        "id":2151,
        "name":"2150 (Thai Program)  :  Thai Language For Careers | ภาษาไทยเพื่ออาชีพ | 泰语职业"
    },
    {
        "id":2152,
        "name":"2151 (Thai Program)  :  Thai Studies | ภาษาไทยศึกษา | 泰国研究"
    },
    {
        "id":2153,
        "name":"2152 (Thai Program)  :  French For Communication | ภาษาฝรั่งเศสเพื่อการสื่อสาร | 交流法语"
    },
    {
        "id":2154,
        "name":"2153 (English Program)  :  Secretarial Sciences | เลขานุการคณะวิทยาศาสตร์ | 秘书科学"
    },
    {
        "id":2155,
        "name":"2154 (English Program)  :  Guidance | คำแนะนำ | 指导"
    },
    {
        "id":2156,
        "name":"2155 (Thai Program)  :  Vietnamese Language | ภาษาเวียดนาม | 越南语"
    },
    {
        "id":2157,
        "name":"2156 (English Program)  :  Guidance And Counseling | การแนะแนวและการให้คำปรึกษา | 指导和咨询"
    },
    {
        "id":2158,
        "name":"2157 (Thai Program)  :  Geoinformatics For Development | ภูมิสารสนเทศเพื่อการพัฒนา | 地理信息学促进发展"
    },
    {
        "id":2159,
        "name":"2158 (English Program)  :  Translation | การแปล | 翻译"
    },
    {
        "id":2160,
        "name":"2159 (Thai Program)  :  Business Information System | ระบบสารสนเทศทางธุรกิจ | 商业信息系统"
    },
    {
        "id":2161,
        "name":"2160 (Thai Program)  :  Secretary | เลขานุการ | 秘书"
    },
    {
        "id":2162,
        "name":"2161 (Thai Program)  :  Logistics | โลจิสติกส์ | 后勤"
    },
    {
        "id":2163,
        "name":"2162 (Thai Program)  :  International Culture For Tourism | วัฒนธรรมนานาชาติเพื่อการท่องเที่ยว | 国际旅游文化"
    },
    {
        "id":2164,
        "name":"2163 (Thai Program)  :  Materials And Nanotechnology | วัสดุและนาโนเทคโนโลยี | 材料与纳米技术"
    },
    {
        "id":2165,
        "name":"2164 (Thai Program)  :  Multimedia Journalism | วารสารศาสตร์สื่อประสม | 多媒体新闻学"
    },
    {
        "id":2166,
        "name":"2165 (Thai Program)  :  Computer Science-Mathematics | วิทยาการคอมพิวเตอร์-คณิตศาสตร์ | 计算机科学-数学"
    },
    {
        "id":2167,
        "name":"2166 (Thai Program)  :  Computer Science-Applied Statistics | วิทยาการคอมพิวเตอร์-สถิติประยุกต์ | 计算机科学-应用统计学"
    },
    {
        "id":2168,
        "name":"2167 (Thai Program)  :  Food Technology Science | วิทยาศาสตร์เทคโนโลยีการอาหาร | 食品技术科学"
    },
    {
        "id":2169,
        "name":"2168 (Thai Program)  :  Food Science And Technology | วิทยาศาสตร์และเทคโนโลยีทางอาหาร | 食品科学与技术"
    },
    {
        "id":2170,
        "name":"2169 (Thai Program)  :  Radio - Television | วิทยุ - โทรทัศน์ | 广播电视"
    },
    {
        "id":2171,
        "name":"2170 (Thai Program)  :  Broadcasting Radio And Television | วิทยุกระจายเสียงและวิทยุโทรทัศน์ | 广播电视"
    },
    {
        "id":2172,
        "name":"2171 (Thai Program)  :  Safety Management Engineering | วิศวกรรมการจัดการความปลอดภัย | 安全管理工程"
    },
    {
        "id":2173,
        "name":"2172 (Thai Program)  :  Aircraft Maintenance Engineering | วิศวกรรมการซ่อมบำรุงอากาศยาน | 飞机维修工程"
    },
    {
        "id":2174,
        "name":"2173 (Thai Program)  :  Communication And Information Engineering | วิศวกรรมการสื่อสารและสารสนเทศ | 通信与信息工程"
    },
    {
        "id":2175,
        "name":"2174 (Thai Program)  :  Computer Animation And Game Engineering | วิศวกรรมคอมพิวเตอร์แอนิเมชันและเกม | 计算机动画和游戏工程"
    },
    {
        "id":2176,
        "name":"2175 (English Program)  :  French-Thai Translation | การแปลภาษาฝรั่งเศส-ไทย | 法语-泰语翻译"
    },
    {
        "id":2177,
        "name":"2176 (Thai Program)  :  Mechatronics And Robotics Engineering | วิศวกรรมเมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人工程"
    },
    {
        "id":2178,
        "name":"2177 (Thai Program)  :  Fine Arts Studies – Music Studies-Thai Music | ศิลปกรรมศาสตร์ศึกษา – ดนตรีศึกษา-ดนตรีไทย | 美术研究-音乐研究-泰国音乐"
    },
    {
        "id":2179,
        "name":"2178 (Thai Program)  :  Fine Arts Studies – Music Studies-International Music | ศิลปกรรมศาสตร์ศึกษา – ดนตรีศึกษา-ดนตรีสากล | 美术研究-音乐研究-国际音乐"
    },
    {
        "id":2180,
        "name":"2179 (Thai Program)  :  Fine Arts Studies – Visual Arts Studies | ศิลปกรรมศาสตร์ศึกษา – ทัศนศิลป์ศึกษา | 美术研究 - 视觉艺术研究"
    },
    {
        "id":2181,
        "name":"2180 (Thai Program)  :  Fine Arts Studies – Performing Arts Studies | ศิลปกรรมศาสตร์ศึกษา – ศิลปะการแสดงศึกษา | 美术研究 - 表演艺术研究"
    },
    {
        "id":2182,
        "name":"2181 (Thai Program)  :  Art Of Music | ศิลปะการดนตรี | 音乐艺术"
    },
    {
        "id":2183,
        "name":"2182 (Thai Program)  :  Performing Arts – Acting And Directing | ศิลปะการแสดง – การแสดงและกำกับการแสดง | 表演艺术——表演和导演"
    },
    {
        "id":2184,
        "name":"2183 (Thai Program)  :  Performing Arts – Designing For Performance | ศิลปะการแสดง – การออกแบบเพื่อการแสดง | 表演艺术——为表演而设计"
    },
    {
        "id":2185,
        "name":"2184 (Thai Program)  :  Performing Arts – Thai Dance | ศิลปะการแสดง – นาฏศิลป์ไทย | 表演艺术 – 泰国舞蹈"
    },
    {
        "id":2186,
        "name":"2185 (Thai Program)  :  Performing Arts – International Dance | ศิลปะการแสดง – นาฏศิลป์สากล | 表演艺术 – 国际舞蹈"
    },
    {
        "id":2187,
        "name":"2186 (Thai Program)  :  Applied Performing Arts | ศิลปะการแสดงประยุกต์ | 应用表演艺术"
    },
    {
        "id":2188,
        "name":"2187 (Thai Program)  :  Education | ศึกษาศาสตร์ | 教育"
    },
    {
        "id":2189,
        "name":"2188 (Thai Program)  :  Monetary And Fiscal Economics | เศรษฐศาสตร์การเงินและการคลัง | 货币和财政经济学"
    },
    {
        "id":2190,
        "name":"2189 (Thai Program)  :  Financial And Banking Economics | เศรษฐศาสตร์การเงินและการธนาคาร | 金融与银行经济学"
    },
    {
        "id":2191,
        "name":"2190 (Thai Program)  :  Promote And Communicate Agriculture | ส่งเสริมและสื่อสารการเกษตร | 推广和交流农业"
    },
    {
        "id":2192,
        "name":"2191 (Thai Program)  :  Business And Insurance Statistics | สถิติธุรกิจและการประกันภัย | 商业和保险统计"
    },
    {
        "id":2193,
        "name":"2192 (English Program)  :  Thai And French Translation | การแปลภาษาไทยและภาษาฝรั่งเศส | 泰语和法语翻译"
    },
    {
        "id":2194,
        "name":"2193 (Thai Program)  :  Animal Science And Agricultural Technology | สัตวศาสตร์และเทคโนโลยีการเกษตร | 动物科学与农业技术"
    },
    {
        "id":2195,
        "name":"2194 (English Program)  :  Thai And English Translation | การแปลภาษาไทยและภาษาอังกฤษ | 泰语和英语翻译"
    },
    {
        "id":2196,
        "name":"2195 (Thai Program)  :  Surveying And Geoinformatics | สำรวจและภูมิสารสนเทศ | 测量和地理信息学"
    },
    {
        "id":2197,
        "name":"2196 (Thai Program)  :  Creative Media | สื่อนฤมิต | 创意媒体"
    },
    {
        "id":2198,
        "name":"2197 (Thai Program)  :  Tourism Communication | สื่อสารการท่องเที่ยว | 旅游传播"
    },
    {
        "id":2199,
        "name":"2198 (Thai Program)  :  Communication, Performance And Modern Media | สื่อสารการแสดงและสื่อสมัยใหม่ | 传播、表演和现代媒体"
    },
    {
        "id":2200,
        "name":"2199 (Thai Program)  :  Principles Of Islam | หลักการศาสนาอิสลาม | 伊斯兰教的原则"
    },
    {
        "id":2201,
        "name":"2200 (Thai Program)  :  Costume Design | ออกแบบเครื่องแต่งกาย | 服装设计"
    },
    {
        "id":2202,
        "name":"2201 (Thai Program)  :  Fashion Design | ออกแบบแฟชั่น | 时装设计"
    },
    {
        "id":2203,
        "name":"2202 (Thai Program)  :  Construction Industry | อุตสาหกรรมก่อสร้าง | 建筑业"
    },
    {
        "id":2204,
        "name":"2203 (Thai Program)  :  Mechanical Industry | อุตสาหกรรมเครื่องกล | 机械行业"
    },
    {
        "id":2205,
        "name":"2204 (English Program)  :  Translation And Interpretation | การแปลและการตีความ | 翻译和口译"
    },
    {
        "id":2206,
        "name":"2205 (Thai Program)  :  Electrical Industry | อุตสาหกรรมไฟฟ้า | 电气工业"
    },
    {
        "id":2207,
        "name":"2206 (Thai Program)  :  Electronic Industry | อุตสาหกรรมอิเล็กทรอนิกส์ | 电子工业"
    },
    {
        "id":2208,
        "name":"2207 (Thai Program)  :  Industrial Industry | อุตสาหกรรมอุตสาหการ | 工业工业"
    },
    {
        "id":2209,
        "name":"2208 (English Program)  :  English Studies | การศึกษาภาษาอังกฤษ | 英语学习"
    },
    {
        "id":2210,
        "name":"2209 (English Program)  :  Individual Based Program | โปรแกรมเฉพาะบุคคล | 基于个人的计划"
    },
    {
        "id":2211,
        "name":"2210 (Thai Program)  :  Management – ​​Industrial Management 1 | การจัดการ – การจัดการอุตสาหกรรม 1 | 管理-​​工业管理1"
    },
    {
        "id":2212,
        "name":"2211 (Thai Program)  :  Management – ​​Industrial Management 2 | การจัดการ – การจัดการอุตสาหกรรม 2 | 管理——工业管理2"
    },
    {
        "id":2213,
        "name":"2212 (Thai Program)  :  Management-Human Resource Management | การจัดการ-การจัดการทรัพยากรมนุษย์ | 管理-人力资源管理"
    },
    {
        "id":2214,
        "name":"2213 (Thai Program)  :  Management-General Management | การจัดการ-การจัดการทั่วไป | 管理-综合管理"
    },
    {
        "id":2215,
        "name":"2214 (Thai Program)  :  Management-Office Management | การจัดการ-การจัดการสำนักงาน | 管理-办公室管理"
    },
    {
        "id":2216,
        "name":"2215 (Thai Program)  :  Management-Industrial Management | การจัดการ-การจัดการอุตสาหกรรม | 管理-工业管理"
    },
    {
        "id":2217,
        "name":"2216 (Thai Program)  :  Communication Management | การจัดการการสื่อสาร | 沟通管理"
    },
    {
        "id":2218,
        "name":"2217 (Thai Program)  :  Industrial Management | การจัดการงานอุตสาหกรรม | 工业管理"
    },
    {
        "id":2219,
        "name":"2218 (Thai Program)  :  Agricultural Business Management | การจัดการธุรกิจเกษตร | 农业经营管理"
    },
    {
        "id":2220,
        "name":"2219 (Thai Program)  :  Business Management, Risk And Service Industries | การจัดการธุรกิจความเสี่ยงและอุตสาหกรรมบริการ | 商业管理、风险和服务行业"
    },
    {
        "id":2221,
        "name":"2220 (Thai Program)  :  International Service Business Management | การจัดการธุรกิจบริการระหว่างประเทศ | 国际服务业经营管理"
    },
    {
        "id":2222,
        "name":"2221 (Thai Program)  :  Service Management | การจัดการบริการ | 服务管理"
    },
    {
        "id":2223,
        "name":"2222 (Thai Program)  :  International Logistics Management | การจัดการโลจิสติกส์ระหว่างประเทศ | 国际物流管理"
    },
    {
        "id":2224,
        "name":"2223 (Thai Program)  :  Architecture Management | การจัดการสถาปัตยกรรม | 架构管理"
    },
    {
        "id":2225,
        "name":"2224 (Thai Program)  :  Real Estate Management | การจัดการอสังหาริมทรัพย์ | 房地产管理"
    },
    {
        "id":2226,
        "name":"2225 (Thai Program)  :  Building Management | การจัดการอาคาร | 大厦管理"
    },
    {
        "id":2227,
        "name":"2226 (Thai Program)  :  Rubber Industry Management | การจัดการอุตสาหกรรมยาง | 橡胶行业管理"
    },
    {
        "id":2228,
        "name":"2227 (Thai Program)  :  Marketing-Marketing Management | การตลาด-การบริหารการตลาด | 营销-营销管理"
    },
    {
        "id":2229,
        "name":"2228 (Thai Program)  :  Marketing-Marketing Communication | การตลาด-การสื่อสารการตลาด | 营销-营销传播"
    },
    {
        "id":2230,
        "name":"2229 (Thai Program)  :  Sustainable Tourism | การท่องเที่ยวอย่างยั่งยืน | 可持续旅游"
    },
    {
        "id":2231,
        "name":"2230 (Thai Program)  :  Accounting-Financial Accounting | การบัญชี-การบัญชีการเงิน | 会计-财务会计"
    },
    {
        "id":2232,
        "name":"2231 (Thai Program)  :  Accounting - Management Accounting | การบัญชี-การบัญชีบริหาร | 会计 - 管理会计"
    },
    {
        "id":2233,
        "name":"2232 (Thai Program)  :  Television Production | การผลิตโทรทัศน์ | 电视制作"
    },
    {
        "id":2234,
        "name":"2233 (Thai Program)  :  Crop Production For Urban Communities | การผลิตพืชเพื่อชุมชนเมือง | 城市社区的农作物生产"
    },
    {
        "id":2235,
        "name":"2234 (Thai Program)  :  Film Production | การผลิตภาพยนตร์ | 电影制作"
    },
    {
        "id":2236,
        "name":"2235 (Thai Program)  :  Animation Production | การผลิตแอนิเมชั่น | 动画制作"
    },
    {
        "id":2237,
        "name":"2236 (Thai Program)  :  Software Development | การพัฒนาซอฟท์แวร์ | 软件开发"
    },
    {
        "id":2238,
        "name":"2237 (Thai Program)  :  Electronic Commerce | การพาณิชย์อิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":2239,
        "name":"2238 (Thai Program)  :  Thai Traditional Medicine | การแพทย์แผนไทย | 泰国传统医学"
    },
    {
        "id":2240,
        "name":"2239 (Thai Program)  :  Teaching English | การสอนภาษาอังกฤษ | 英语教学"
    },
    {
        "id":2241,
        "name":"2240 (Thai Program)  :  Marketing Communications For Development | การสื่อสารการตลาดเพื่อการพัฒนา | 营销传播促进发展"
    },
    {
        "id":2242,
        "name":"2241 (Thai Program)  :  Communication Through New Media | การสื่อสารผ่านสื่อใหม่ | 通过新媒体进行沟通"
    },
    {
        "id":2243,
        "name":"2242 (Thai Program)  :  English Communication | การสื่อสารภาษาอังกฤษ | 英语交流"
    },
    {
        "id":2244,
        "name":"2243 (Thai Program)  :  Visual Design - Product Design | การออกแบบทัศนศิลป์ - การออกแบบผลิตภัณฑ์ | 视觉设计-产品设计"
    },
    {
        "id":2245,
        "name":"2244 (Thai Program)  :  Tropical Agriculture And Environment | เกษตรเขตร้อนและสิ่งแวดล้อม | 热带农业与环境"
    },
    {
        "id":2246,
        "name":"2245 (Thai Program)  :  Natural Agriculture | เกษตรธรรมชาติ | 自然农业"
    },
    {
        "id":2247,
        "name":"2246 (Thai Program)  :  Agriculture, Forestry | เกษตรป่าไม้ | 农业、林业"
    },
    {
        "id":2248,
        "name":"2247 (Thai Program)  :  Agricultural Studies - Agronomy | เกษตรศึกษา- พืชไร่นา | 农业研究 - 农学"
    },
    {
        "id":2249,
        "name":"2248 (Thai Program)  :  Agricultural Studies - Horticulture | เกษตรศึกษา- พืชสวน | 农业研究 - 园艺"
    },
    {
        "id":2250,
        "name":"2249 (Thai Program)  :  Agricultural Studies-Fisheries | เกษตรศึกษา-ประมง | 农业研究-渔业"
    },
    {
        "id":2251,
        "name":"2250 (Thai Program)  :  Agricultural Studies-Animal Science | เกษตรศึกษา-สัตว์ศาสตร์ | 农业研究-动物科学"
    },
    {
        "id":2252,
        "name":"2251 (Thai Program)  :  Home Economics Studies – Home Economics General Studies | คหกรรมศาสตร์ศึกษา – คหกรรมศาสตร์ศึกษาทั่วไป | 家政学 – 家政常识"
    },
    {
        "id":2253,
        "name":"2252 (Thai Program)  :  Home Economics Studies – Food And Nutrition | คหกรรมศาสตร์ศึกษา – อาหารและโภชนาการ | 家政学研究 - 食品与营养"
    },
    {
        "id":2254,
        "name":"2253 (Thai Program)  :  Home Economics Studies - Craft Business | คหกรรมศาสตร์ศึกษา-ธุรกิจงานประดิษฐ์ | 家政学-手工艺商业"
    },
    {
        "id":2255,
        "name":"2254 (Thai Program)  :  Home Economics Studies-Fabric And Apparel | คหกรรมศาสตร์ศึกษา-ผ้าและเครื่องแต่งกาย | 家政学-面料与服装"
    },
    {
        "id":2256,
        "name":"2255 (Thai Program)  :  Thai Painting | จิตรกรรมไทย | 泰国画"
    },
    {
        "id":2257,
        "name":"2256 (Thai Program)  :  Agricultural Mechanic | ช่างกลเกษตร | 农业机械师"
    },
    {
        "id":2258,
        "name":"2257 (Thai Program)  :  Factory Mechanic-Automatic Machinery | ช่างกลโรงงาน-เครื่องจักรกลอัตโนมัติ | 工厂机械师-自动机械"
    },
    {
        "id":2259,
        "name":"2258 (Thai Program)  :  Factory Mechanic - Machinery Maintenance | ช่างกลโรงงาน-ซ่อมบำรุงเครื่องจักร | 工厂机械师 - 机械维修"
    },
    {
        "id":2260,
        "name":"2259 (Thai Program)  :  Mechanical Technician | ช่างเครื่องกล | 机械技术员"
    },
    {
        "id":2261,
        "name":"2260 (Thai Program)  :  Heavy Machinery Mechanic | ช่างจักรกลหนัก | 重型机械技工"
    },
    {
        "id":2262,
        "name":"2261 (Thai Program)  :  Computer Technician | ช่างเทคนิคคอมพิวเตอร์ | 计算机技术员"
    },
    {
        "id":2263,
        "name":"2262 (Thai Program)  :  Architectural Technician | ช่างเทคนิคสถาปัตยกรรม | 建筑技术员"
    },
    {
        "id":2264,
        "name":"2263 (Thai Program)  :  Electrician - Air Conditioning Refrigeration | ช่างไฟฟ้า – การทำความเย็นปรับอากาศ | 电工-空调制冷"
    },
    {
        "id":2265,
        "name":"2264 (Thai Program)  :  Power Electrician | ช่างไฟฟ้ากำลัง | 电力电工"
    },
    {
        "id":2266,
        "name":"2265 (Thai Program)  :  Mold And Jeweler | ช่างแม่พิมพ์และอัญมณี | 模具和珠宝商"
    },
    {
        "id":2267,
        "name":"2266 (Thai Program)  :  Metal Worker | ช่างโลหะ | 金属工人"
    },
    {
        "id":2268,
        "name":"2267 (Thai Program)  :  Surveyor | ช่างสำรวจ | 测量员"
    },
    {
        "id":2269,
        "name":"2268 (Thai Program)  :  Middle Eastern Studies | ตะวันออกกลางศึกษา | 中东研究"
    },
    {
        "id":2270,
        "name":"2269 (Thai Program)  :  Agricultural Technology (Plant Production Technology) | เทคโนโลยีการเกษตร (ด้านเทคโนโลยีการผลิตพืช) | 农业技术（植物生产技术）"
    },
    {
        "id":2271,
        "name":"2270 (Thai Program)  :  Agricultural Technology (Animal Feed Technology) | เทคโนโลยีการเกษตร (ด้านเทคโนโลยีอาหารสัตว์) | 农业技术（动物饲料技术）"
    },
    {
        "id":2272,
        "name":"2271 (Thai Program)  :  Bonding Technology | เทคโนโลยีการเชื่อมประสาน | 粘合技术"
    },
    {
        "id":2273,
        "name":"2272 (Thai Program)  :  Fishing Technology (Coastal Aquaculture) | เทคโนโลยีการประมง (ด้านการเพาะเลี้ยงสัตว์น้ำชายฝั่ง) | 捕捞技术（沿海水产养殖）"
    },
    {
        "id":2274,
        "name":"2273 (Thai Program)  :  Fishing Technology (Fishery Products) | เทคโนโลยีการประมง (ด้านผลิตภัณฑ์ประมง) | 捕捞技术（水产品）"
    },
    {
        "id":2275,
        "name":"2274 (Thai Program)  :  Photography And Film Technology | เทคโนโลยีถ่ายภาพและภาพยนตร์ | 摄影和电影技术"
    },
    {
        "id":2276,
        "name":"2275 (Thai Program)  :  Bioprocessing Technology | เทคโนโลยีแปรรูปชีวภาพ | 生物加工技术"
    },
    {
        "id":2277,
        "name":"2276 (Thai Program)  :  Logistics Technology And Transportation Management | เทคโนโลยีโลจิสติกส์และการจัดการระบบขนส่ง | 物流技术与运输管理"
    },
    {
        "id":2278,
        "name":"2277 (Thai Program)  :  Polymer Engineering Technology | เทคโนโลยีวิศวกรรมพอลิเมอร์ | 高分子工程技术"
    },
    {
        "id":2279,
        "name":"2278 (Thai Program)  :  Information Technology And Educational Evaluation | เทคโนโลยีสารสนเทศและการประเมินผลการศึกษา | 信息技术与教育评估"
    },
    {
        "id":2280,
        "name":"2279 (Thai Program)  :  Information And Communication Technology For Management | เทคโนโลยีสารสนเทศและการสื่อสารเพื่อการจัดการ | 管理信息和通信技术"
    },
    {
        "id":2281,
        "name":"2280 (Thai Program)  :  Industrial Technology Department Of Electronics And Computer Technology | เทคโนโลยีอุตสาหกรรม แขนงวิชาเทคโนโลยีอิเล็กทรอนิกส์และคอมพิวเตอร์ | 工业技术电子与计算机技术系"
    },
    {
        "id":2282,
        "name":"2281 (Thai Program)  :  Industrial Technology (Telecommunications Technology) | เทคโนโลยีอุตสาหกรรม(เทคโนโลยีโทรคมนาคม) | 工业技术（电信技术）"
    },
    {
        "id":2283,
        "name":"2282 (Thai Program)  :  Information Technology Business | ธุรกิจเทคโนโลยีสารสนเทศ | 信息技术业务"
    },
    {
        "id":2284,
        "name":"2283 (Thai Program)  :  Business Studies-Accounting | ธุรกิจศึกษา-การบัญชี | 商业研究-会计"
    },
    {
        "id":2285,
        "name":"2284 (Thai Program)  :  Business Studies-Secretariat | ธุรกิจศึกษา-การเลขานุการ | 商业研究秘书处"
    },
    {
        "id":2286,
        "name":"2285 (Thai Program)  :  Business Studies-Computer | ธุรกิจศึกษา-คอมพิวเตอร์ | 商业研究-计算机"
    },
    {
        "id":2287,
        "name":"2286 (Thai Program)  :  Electronic Business | ธุรกิจอิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":2288,
        "name":"2287 (Thai Program)  :  Innovation In Media Design And Media Production | นวัตกรรมการออกแบบสื่อและการผลิตสื่อ | 媒体设计和媒体制作的创新"
    },
    {
        "id":2289,
        "name":"2288 (Thai Program)  :  Social Innovation | นวัตกรรมสังคม | 社会创新"
    },
    {
        "id":2290,
        "name":"2289 (Thai Program)  :  Dance And Performing Arts | นาฎศิลป์และศิลปะการแสดง | 舞蹈和表演艺术"
    },
    {
        "id":2291,
        "name":"2290 (English Program)  :  Applied Thai Traditional Medicine | การแพทย์แผนไทยประยุกต์ | 应用泰国传统医学"
    },
    {
        "id":2292,
        "name":"2291 (Thai Program)  :  Management Management | บริหารการจัดการ | 管理管理"
    },
    {
        "id":2293,
        "name":"2292 (Thai Program)  :  Home Economics Management | บริหารคหกรรม | 家政管理"
    },
    {
        "id":2294,
        "name":"2293 (Thai Program)  :  Home Economics Administration | บริหารคหกรรมศาสตร์ | 家政管理"
    },
    {
        "id":2295,
        "name":"2294 (Thai Program)  :  Accounting-Auditing | บัญชี-การสอบบัญชี | 会计审计"
    },
    {
        "id":2296,
        "name":"2295 (Thai Program)  :  Thai Sculpture | ประติมากรรมไทย | 泰国雕塑"
    },
    {
        "id":2297,
        "name":"2296 (Thai Program)  :  Fabrics And Clothing - Clothing Industry | ผ้าและเครื่องแต่งกาย-อุตสาหกรรมเครื่องแต่งกาย | 面料和服装——服装行业"
    },
    {
        "id":2298,
        "name":"2297 (Thai Program)  :  Music Expert | ผู้เชี่ยวชาญทางดนตรี | 音乐专家"
    },
    {
        "id":2299,
        "name":"2298 (Thai Program)  :  Family And Child Development-Early Childhood Education | พัฒนาการครอบครัวและเด็ก-การศึกษาปฐมวัย | 家庭与儿童发展-幼儿教育"
    },
    {
        "id":2300,
        "name":"2299 (Thai Program)  :  Plant Science – Field Crops | พืชศาสตร์ – พืชไร่ | 植物科学 – 大田作物"
    },
    {
        "id":2301,
        "name":"2300 (Thai Program)  :  Buddhist History And Cultural Studies | พุทธประวัติและวัฒนธรรมศึกษา | 佛教历史与文化研究"
    },
    {
        "id":2302,
        "name":"2301 (Thai Program)  :  Chinese For Communication | ภาษาจีนเพื่อการสื่อสาร | 汉语交流"
    },
    {
        "id":2303,
        "name":"2302 (Thai Program)  :  Language For Community Development | ภาษาเพื่อการพัฒนาชุมชน | 社区发展语言"
    },
    {
        "id":2304,
        "name":"2303 (Thai Program)  :  English – American Studies | ภาษาอังกฤษ – อเมริกันศึกษา | 英语-美国研究"
    },
    {
        "id":2305,
        "name":"2304 (Thai Program)  :  English For Business Communication | ภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจ | 商务沟通英语"
    },
    {
        "id":2306,
        "name":"2305 (Thai Program)  :  Tourism Geography And History | ภูมิศาสตร์และประวัติศาสตร์เชิงท่องเที่ยว | 旅游地理和历史"
    },
    {
        "id":2307,
        "name":"2306 (Thai Program)  :  Food Nutrition And Dietetics | โภชนาการอาหารและการกำหนดอาหาร | 食品营养与饮食学"
    },
    {
        "id":2308,
        "name":"2307 (Thai Program)  :  Flowering Plants | ไม้ดอก | 开花植物"
    },
    {
        "id":2309,
        "name":"2308 (Thai Program)  :  Instrumentation And Control Systems | ระบบเครื่องมือวัดและการควบคุม | 仪表和控制系统"
    },
    {
        "id":2310,
        "name":"2309 (Thai Program)  :  Computer Information System | ระบบสารสนเทศทางคอมพิวเตอร์ | 计算机信息系统"
    },
    {
        "id":2311,
        "name":"2310 (Thai Program)  :  Computer Information Systems - Business Computers | ระบบสารสนเทศทางคอมพิวเตอร์-คอมพิวเตอร์ธุรกิจ | 计算机信息系统-商用计算机"
    },
    {
        "id":2312,
        "name":"2311 (Thai Program)  :  Russian Studies | รัสเซียศึกษา | 俄罗斯研究"
    },
    {
        "id":2313,
        "name":"2312 (Thai Program)  :  Journalism And Mass Communication | วารสารศาสตร์ และสื่อสารมวลชน | 新闻与大众传播"
    },
    {
        "id":2314,
        "name":"2313 (Thai Program)  :  Production Science And Animal Health | วิทยาการผลิตและสุขภาพสัตว์ | 生产科学和动物健康"
    },
    {
        "id":2315,
        "name":"2314 (Thai Program)  :  Communication Engineering | วิศวกรรมการสื่อสาร | 通信工程"
    },
    {
        "id":2316,
        "name":"2315 (Thai Program)  :  Automotive Design And Manufacturing Engineering | วิศวกรรมการออกแบบและการผลิตยานยนต์ | 汽车设计与制造工程"
    },
    {
        "id":2317,
        "name":"2316 (Thai Program)  :  Nano Engineering | วิศวกรรมนาโน | 纳米工程"
    },
    {
        "id":2318,
        "name":"2317 (Thai Program)  :  Electrical And Electronic Engineering | วิศวกรรมไฟฟ้าและอิเล็กทรอนิกส์ | 电气与电子工程"
    },
    {
        "id":2319,
        "name":"2318 (Thai Program)  :  Electronics And Telecommunications Engineering – Telecommunications | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม – โทรคมนาคม | 电子与电信工程 - 电信"
    },
    {
        "id":2320,
        "name":"2319 (Thai Program)  :  Industrial Engineering-Management | วิศวกรรมอุตสาหการ-การจัดการ | 工业工程-管理"
    },
    {
        "id":2321,
        "name":"2320 (Thai Program)  :  Industrial Engineering-Production | วิศวกรรมอุตสาหการ-การผลิต | 工业工程-生产"
    },
    {
        "id":2322,
        "name":"2321 (Thai Program)  :  Industrial Design Art | ศิลปะการออกแบบหัตถอุตสาหกรรม | 工业设计艺术"
    },
    {
        "id":2323,
        "name":"2322 (Thai Program)  :  Thai Art | ศิลปะไทย | 泰国艺术"
    },
    {
        "id":2324,
        "name":"2323 (Thai Program)  :  Agricultural Economics And Agribusiness | เศรษฐศาสตร์การเกษตรและธุรกิจการเกษตร | 农业经济学和农业综合企业"
    },
    {
        "id":2325,
        "name":"2324 (Thai Program)  :  Theoretical Economics | เศรษฐศาสตร์ทฤษฎี | 理论经济学"
    },
    {
        "id":2326,
        "name":"2325 (Thai Program)  :  Analytical Quantitative Economics | เศรษฐศาสตร์ปริมาณวิเคราะห์ | 分析数量经济学"
    },
    {
        "id":2327,
        "name":"2326 (English Program)  :  Advertising | การโฆษณา | 广告"
    },
    {
        "id":2328,
        "name":"2327 (Thai Program)  :  Labor Economics And Human Resource Management | เศรษศาสตร์แรงงานและการจัดการทรัพยากรมนุษย์ | 劳动经济学与人力资源管理"
    },
    {
        "id":2329,
        "name":"2328 (Thai Program)  :  Economics-Business Economics | เศรษฐศาสตร์-เศรษฐศาสตร์ธุรกิจ | 经济学-商业经济学"
    },
    {
        "id":2330,
        "name":"2329 (Thai Program)  :  Public Economics | เศรษฐศาสตร์สาธารณะ | 公共经济学"
    },
    {
        "id":2331,
        "name":"2330 (Thai Program)  :  Promotion And Agricultural Business | ส่งเสริมและธุรกิจเกษตร | 推广及农业业务"
    },
    {
        "id":2332,
        "name":"2331 (Thai Program)  :  Promote And Develop Agriculture | ส่งเสริมและพัฒนาการเกษตร | 促进和发展农业"
    },
    {
        "id":2333,
        "name":"2332 (Thai Program)  :  Urban Architecture | สถาปัตยกรรมผังเมือง | 城市建筑"
    },
    {
        "id":2334,
        "name":"2333 (Thai Program)  :  Social Work And Social Welfare | สังคมสงเคราะห์ศาสตร์และสวัสดิการสังคม | 社会工作和社会福利"
    },
    {
        "id":2335,
        "name":"2334 (Thai Program)  :  Large Animals | สัตว์ใหญ่ | 大型动物"
    },
    {
        "id":2336,
        "name":"2335 (English Program)  :  Hospitality | การต้อนรับ | 热情好客"
    },
    {
        "id":2337,
        "name":"2336 (Thai Program)  :  Visual Communication Design - Photographic Art | ออกแบบนิเทศศิลป์-ศิลปะการถ่ายภาพ | 视觉传达设计-摄影艺术"
    },
    {
        "id":2338,
        "name":"2337 (Thai Program)  :  Food And Nutrition-Food Business | อาหารและโภชนาการ-ธุรกิจอาหาร | 食品与营养-食品事业"
    },
    {
        "id":2339,
        "name":"2338 (Thai Program)  :  Computer Electronics | อิเล็กทรอนิกส์คอมพิวเตอร์ | 计算机电子产品"
    },
    {
        "id":2340,
        "name":"2339 (Thai Program)  :  Electronic Communications | อิเล็กทรอนิกส์สื่อสาร | 电子通讯"
    },
    {
        "id":2341,
        "name":"2340 (Thai Program)  :  Tourism Industry (Airline Business Branch) | อุตสาหกรรมท่องเที่ยว (แขนงธุรกิจการบิน) | 旅游业（航空业务分公司）"
    },
    {
        "id":2342,
        "name":"2341 (Thai Program)  :  Marketing – International Marketing | การตลาด – การตลาดระหว่างประเทศ | 营销 – 国际营销"
    },
    {
        "id":2343,
        "name":"2342 (Thai Program)  :  Sports Coaching | การฝึกสอนกีฬา | 体育教练"
    },
    {
        "id":2344,
        "name":"2343 (Thai Program)  :  Promoting Children'S Health | การส่งเสริมสุขภาพเด็ก | 促进儿童健康"
    },
    {
        "id":2345,
        "name":"2344 (English Program)  :  Hotel Studies | การศึกษาการโรงแรม | 酒店研究"
    },
    {
        "id":2346,
        "name":"2345 (Thai Program)  :  Health Business | ธุรกิจสุขภาพ | 健康事业"
    },
    {
        "id":2347,
        "name":"2346 (Thai Program)  :  Commercial Recreation And Tourism | นันทนาการเชิงพานิชย์และท่องเที่ยว | 商业休闲和旅游"
    },
    {
        "id":2348,
        "name":"2347 (Thai Program)  :  Therapeutic Recreation | นันทนาการบำบัด | 治疗性休闲"
    },
    {
        "id":2349,
        "name":"2348 (Thai Program)  :  Recreation Management | บริหารนันทนาการ | 康乐管理"
    },
    {
        "id":2350,
        "name":"2349 (Thai Program)  :  Recreation Leader | ผู้นำนันทนาการ | 康乐领袖"
    },
    {
        "id":2351,
        "name":"2350 (Thai Program)  :  Physical Education For People With Disabilities | พลศึกษาสำหรับคนพิการ | 残疾人体育教育"
    },
    {
        "id":2352,
        "name":"2351 (Thai Program)  :  Food Science And Technology | วิทยาศาสตร์และเทคโนโลยีอาหาร | 食品科学与技术"
    },
    {
        "id":2353,
        "name":"2352 (Thai Program)  :  Electronics And Telecommunications Engineering – Electronics | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม – อิเล็กทรอนิกส์ | 电子与电信工程 - 电子"
    },
    {
        "id":2354,
        "name":"2353 (Thai Program)  :  Sports Communication | สื่อสารการกีฬา | 体育传播"
    },
    {
        "id":2355,
        "name":"2354 (Thai Program)  :  Maintenance Of Flight Instrumentation | การบำรุงรักษาเครื่องวัดประกอบการบิน | 飞行仪表的维护"
    },
    {
        "id":2356,
        "name":"2355 (Thai Program)  :  Sports Management | การจัดการกีฬา | 体育管理"
    },
    {
        "id":2357,
        "name":"2356 (Thai Program)  :  Hospital Management | การบริหารจัดการโรงพยาบาล | 医院管理"
    },
    {
        "id":2358,
        "name":"2357 (Thai Program)  :  Maintenance Of Communication Tools | การบำรุงรักษาเครื่องมือสื่อสาร | 通讯工具的维护"
    },
    {
        "id":2359,
        "name":"2358 (Thai Program)  :  Aircraft Maintenance | การบำรุงรักษาอากาศยาน | 飞机维修"
    },
    {
        "id":2360,
        "name":"2359 (Thai Program)  :  Crop Production And Management For Urban Communities | การผลิตและการจัดการพืชเพื่อชุมชนเมือง | 城市社区的作物生产和管理"
    },
    {
        "id":2361,
        "name":"2360 (English Program)  :  Hotel Work | งานโรงแรม | 酒店工作"
    },
    {
        "id":2362,
        "name":"2361 (Thai Program)  :  Public Administration (Organizational Administration) | รัฐประศาสนศาสตร์(การบริหารองค์การ) | 公共管理（组织管理）"
    },
    {
        "id":2363,
        "name":"2362 (Thai Program)  :  Public Administration(Local Government) | รัฐประศาสนศาสตร์(การปกครองท้องถิ่น) | 公共行政（地方政府）"
    },
    {
        "id":2364,
        "name":"2363 (English Program)  :  Sustainable Use And Natural | การใช้งานอย่างยั่งยืนและเป็นธรรมชาติ | 可持续利用和自然"
    },
    {
        "id":2365,
        "name":"2364 (Thai Program)  :  Hydrographic Engineering | วิศวกรรมอุทกศาสตร์ | 水文工程"
    },
    {
        "id":2366,
        "name":"2365 (Thai Program)  :  Fine Arts (Music) | ศิลปกรรม(ดนตรี) | 美术（音乐）"
    },
    {
        "id":2367,
        "name":"2366 (Thai Program)  :  Industry And Management | อุตสาหกรรมและการจัดการ | 工业与管理"
    },
    {
        "id":2368,
        "name":"2367 (Thai Program)  :  Diplomacy And Foreign Affairs | การฑูตและการต่างประเทศ | 外交与外交"
    },
    {
        "id":2369,
        "name":"2368 (Thai Program)  :  Entrepreneurship Management | การจัดการการประกอบการ | 创业管理"
    },
    {
        "id":2370,
        "name":"2369 (Thai Program)  :  Environmental And Local Resource Management | การจัดการสิ่งแวดล้อมและทรัพยากรท้องถิ่น | 环境和当地资源管理"
    },
    {
        "id":2371,
        "name":"2370 (English Program)  :  Occupational Therapy | อาชีวบำบัด | 职业治疗"
    },
    {
        "id":2372,
        "name":"2371 (Thai Program)  :  Human Rights Studies | สิทธิมนุษยชนศึกษา | 人权研究"
    },
    {
        "id":2373,
        "name":"2372 (Thai Program)  :  Food And Service Industry | อุตสาหกรรมอาหารและการบริการ | 食品及服务业"
    },
    {
        "id":2374,
        "name":"2373 (Thai Program)  :  International Theology | เทวศาสตร์นานาชาติ | 国际神学"
    },
    {
        "id":2375,
        "name":"2374 (Thai Program)  :  Theology | ศาสนศาสตร์ | 神学"
    },
    {
        "id":2376,
        "name":"2375 (Thai Program)  :  Pharmacy Techniques | เทคนิคเภสัชกรรม | 药剂技术"
    },
    {
        "id":2377,
        "name":"2376 (Thai Program)  :  Writer | ช่างเขียน | 作家"
    },
    {
        "id":2378,
        "name":"2377 (Thai Program)  :  Thai Music And Music Studies | ดนตรีคีตศิลป์ไทยศึกษา | 泰国音乐和音乐研究"
    },
    {
        "id":2379,
        "name":"2378 (Thai Program)  :  International Music Studies | ดนตรีคีตศิลป์สากลศึกษา | 国际音乐研究"
    },
    {
        "id":2380,
        "name":"2379 (Thai Program)  :  Thai Dance Studies | นาฎศิลป์ไทยศึกษา | 泰国舞蹈研究"
    },
    {
        "id":2381,
        "name":"2380 (Thai Program)  :  International Dance Studies | นาฎศิลป์สากลศึกษา | 国际舞蹈研究"
    },
    {
        "id":2382,
        "name":"2381 (Thai Program)  :  Civil Engineering - Irrigation | วิศวกรรมโยธา - ชลประทาน | 土木工程 - 灌溉"
    },
    {
        "id":2383,
        "name":"2382 (Thai Program)  :  Education | ครุศาสตร์ | 教育"
    },
    {
        "id":2384,
        "name":"2383 (Thai Program)  :  Mathematics-Science | คณิตศาสตร์-วิทยาศาสตร์ | 数学科学"
    },
    {
        "id":2385,
        "name":"2384 (Thai Program)  :  Teaching The Pariyatthamma | การสอนพระปริยัติธรรม | 教导Pariyathamma"
    },
    {
        "id":2386,
        "name":"2385 (English Program)  :  Entomology | กีฏวิทยา | 昆虫学"
    },
    {
        "id":2387,
        "name":"2386 (Thai Program)  :  Administration | การบริหาร | 行政"
    },
    {
        "id":2388,
        "name":"2387 (Thai Program)  :  Thai Language Typing | พิมพ์ดีดภาษาไทย | 泰语打字"
    },
    {
        "id":2389,
        "name":"2388 (English Program)  :  Applie Lingnistics | ใช้ภาษาศาสตร์ | 应用语言学"
    },
    {
        "id":2390,
        "name":"2389 (Thai Program)  :  Hospital Business | ธุรกิจสถานพยาบาล | 医院业务"
    },
    {
        "id":2391,
        "name":"2390 (Thai Program)  :  Secondary Education Major | มัธยมศึกษาเอกหัตถศึกษา | 中等教育专业"
    },
    {
        "id":2392,
        "name":"2391 (Thai Program)  :  Fabrics And Fibers | ผ้าและเส้นใย | 织物和纤维"
    },
    {
        "id":2393,
        "name":"2392 (Thai Program)  :  Business Administration - Management | บริหารธุรกิจ - การจัดการ | 工商管理 - 管理"
    },
    {
        "id":2394,
        "name":"2393 (Thai Program)  :  Accounting For Planning And Control | การบัญชีเพื่อวางแผนและควบคุม | 计划和控制会计"
    },
    {
        "id":2395,
        "name":"2394 (Thai Program)  :  Decorative Arts | มัณฑนศิลป์ | 装饰艺术"
    },
    {
        "id":2396,
        "name":"2395 (Thai Program)  :  Garment Industry Management | การจัดการอุตสาหกรรมเครื่องนุ่งห่ม | 服装行业管理"
    },
    {
        "id":2397,
        "name":"2396 (English Program)  :  Water And Wastewater Engineering | วิศวกรรมน้ำและน้ำเสีย | 水和废水工程"
    },
    {
        "id":2398,
        "name":"2397 (Thai Program)  :  International Sculpture | ประติมากรรมสากล | 国际雕塑"
    },
    {
        "id":2399,
        "name":"2398 (Thai Program)  :  Apparel Industry | อุตสาหกรรมเครื่องแต่งกาย | 服装行业"
    },
    {
        "id":2400,
        "name":"2399 (Thai Program)  :  Educational Technology And Innovation | เทคโนโลยีและนวัตกรรมทางการศึกษา | 教育技术与创新"
    },
    {
        "id":2401,
        "name":"2400 (Thai Program)  :  English For Science And Technology | ภาษาอังกฤษเพื่อวิทยาศาสตร์และเทคโนโลยี | 科技英语"
    },
    {
        "id":2402,
        "name":"2401 (Thai Program)  :  Human Resource Development For Industrial Businesses | การพัฒนาทรัพยากรมนุษย์เพื่อธุรกิจอุตสาหกรรม | 工业企业的人力资源开发"
    },
    {
        "id":2403,
        "name":"2402 (Thai Program)  :  English For International Communication | ภาษาอังกฤษเพื่อการสื่อสารระหว่างประเทศ | 国际交流英语"
    },
    {
        "id":2404,
        "name":"2403 (Thai Program)  :  Mechatronics Engineering Technology | เทคโนโลยีวิศวกรรมแมคคาทรอนิกส์ | 机电一体化工程技术"
    },
    {
        "id":2405,
        "name":"2404 (Thai Program)  :  Translation For Education And Business | การแปลเพื่อการศึกษาและธุรกิจ | 教育和商业翻译"
    },
    {
        "id":2406,
        "name":"2405 (English Program)  :  Entomology And Environment | กีฏวิทยาและสิ่งแวดล้อม | 昆虫学与环境"
    },
    {
        "id":2407,
        "name":"2406 (Thai Program)  :  Software Systems Engineering | วิศวกรรมระบบซอฟต์แวร์ | 软件系统工程"
    },
    {
        "id":2408,
        "name":"2407 (Thai Program)  :  Chemical And Process Engineering | วิศวกรรมเคมีและกระบวนการ | 化学与过程工程"
    },
    {
        "id":2409,
        "name":"2408 (Thai Program)  :  Bio-Industrial Technology | เทคโนโลยีอุตสาหกรรมชีวภาพ | 生物产业技术"
    },
    {
        "id":2410,
        "name":"2409 (Thai Program)  :  Agro-Industrial Technology And Management | เทคโนโลยีอุตสาหกรรมเกษตรและการจัดการ | 农业工业技术与管理"
    },
    {
        "id":2411,
        "name":"2410 (Thai Program)  :  Civil Engineering Administration | การบริหารงานวิศวกรรมโยธา | 土木工程管理局"
    },
    {
        "id":2412,
        "name":"2411 (Thai Program)  :  Industrial Automation And Power Electronics | ระบบอุตสาหกรรมอัตโนมัติและอิเล็กทรอนิกส์กำลัง | 工业自动化和电力电子"
    },
    {
        "id":2413,
        "name":"2412 (Thai Program)  :  Tax Law | กฎหมายภาษีอากร | 税法"
    },
    {
        "id":2414,
        "name":"2413 (English Program)  :  Pediatrics Surgery | ศัลยกรรมกุมารเวชศาสตร์ | 儿科外科"
    },
    {
        "id":2415,
        "name":"2414 (Thai Program)  :  Organizational Development | การพัฒนาองค์การ | 组织发展"
    },
    {
        "id":2416,
        "name":"2415 (Thai Program)  :  E-Learning Management | การจัดการ E-LEARNING | 电子学习管理"
    },
    {
        "id":2417,
        "name":"2416 (Thai Program)  :  Information And Communication Technology E-Learning | เทคโนโลยีสารสนเทศและการสื่อสาร E-LEARNING | 信息和通信技术电子学习"
    },
    {
        "id":2418,
        "name":"2417 (Thai Program)  :  Electronic Learning Science E-Learning | วิทยาการเรียนทางอิเล็กทรอนิกส์ E-LEARNING | 电子学习科学 E-Learning"
    },
    {
        "id":2419,
        "name":"2418 (Thai Program)  :  Electronic Learning Science | วิทยาการเรียนทางอิเล็กทรอนิกส์ | 电子学习科学"
    },
    {
        "id":2420,
        "name":"2419 (English Program)  :  Pediatrics | กุมารเวชศาสตร์ | 儿科"
    },
    {
        "id":2421,
        "name":"2420 (Thai Program)  :  Early Childhood Education | การศึกษาปฐมวัย | 幼儿教育"
    },
    {
        "id":2422,
        "name":"2421 (Thai Program)  :  Town Planning | การผังเมือง | 城市规划"
    },
    {
        "id":2423,
        "name":"2422 (Thai Program)  :  Architecture | วิชาสถาปัตยกรรม | 建筑学"
    },
    {
        "id":2424,
        "name":"2423 (Thai Program)  :  Electrical Studies | ไฟฟ้าศึกษา | 电气研究"
    },
    {
        "id":2425,
        "name":"2424 (Thai Program)  :  Research And Develop Educational Teaching Techniques | วิจัยและพัฒนาการสอนเทคนิคศึกษา | 研究和开发教育教学技术"
    },
    {
        "id":2426,
        "name":"2425 (Thai Program)  :  Materials And Metallurgical Engineering | วิศวกรรมวัสดุและโลหการ | 材料与冶金工程"
    },
    {
        "id":2427,
        "name":"2426 (Thai Program)  :  Bioprocessing Technology | เทคโนโลยีการแปรรูปชีวภาพ | 生物加工技术"
    },
    {
        "id":2428,
        "name":"2427 (English Program)  :  Tropical Pediatrics | กุมารเวชเขตร้อน | 热带儿科"
    },
    {
        "id":2429,
        "name":"2428 (English Program)  :  Construction | การก่อสร้าง | 建造"
    },
    {
        "id":2430,
        "name":"2429 (Thai Program)  :  Teaching | ทางการสอน | 教学"
    },
    {
        "id":2431,
        "name":"2430 (Thai Program)  :  Information Science | วิทยาศาสตรสนเทศ | 信息科学"
    },
    {
        "id":2432,
        "name":"2431 (English Program)  :  Math-Science | คณิตศาสตร์-วิทยาศาสตร์ | 数学科学"
    },
    {
        "id":2433,
        "name":"2432 (English Program)  :  Mathematics | คณิตศาสตร์ | 数学"
    },
    {
        "id":2434,
        "name":"2433 (Thai Program)  :  Natural Resource And Environmental Management | การจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม | 自然资源和环境管理"
    },
    {
        "id":2435,
        "name":"2434 (Thai Program)  :  Medical Education | แพทยศาสตรศึกษา | 医学教育"
    },
    {
        "id":2436,
        "name":"2435 (Thai Program)  :  Folklore | คติชนวิทยา | 民俗学"
    },
    {
        "id":2437,
        "name":"2436 (Thai Program)  :  Fishing | การประมง | 钓鱼"
    },
    {
        "id":2438,
        "name":"2437 (Thai Program)  :  Medical Social Sciences And Public Health | สังคมศาสตรการแพทย์และสาธารณสุข | 医学社会科学与公共卫生"
    },
    {
        "id":2439,
        "name":"2438 (Thai Program)  :  Pharmacy | เภสัชศาสตร์ | 药店"
    },
    {
        "id":2440,
        "name":"2439 (English Program)  :  Combinatorics And Optimization | การผสมผสานและการเพิ่มประสิทธิภาพ | 组合和优化"
    },
    {
        "id":2441,
        "name":"2440 (Thai Program)  :  Educational Technology And Communications | เทคโนโลยีและสื่อสารการศึกษา | 教育技术与通信"
    },
    {
        "id":2442,
        "name":"2441 (English Program)  :  Applied Mathematics | คณิตศาสตร์ประยุกต์ | 应用数学"
    },
    {
        "id":2443,
        "name":"2442 (Thai Program)  :  Natural Resources And Environment | ทรัพยากรธรรมชาติและสิ่งแวดล้อม | 自然资源与环境"
    },
    {
        "id":2444,
        "name":"2443 (English Program)  :  Islamic Education | การศึกษาอิสลาม | 伊斯兰教育"
    },
    {
        "id":2445,
        "name":"2444 (Thai Program)  :  Manufacturing And Automation Systems Engineering | วิศวกรรมระบบการผลิตและอัตโนมัติ | 制造与自动化系统工程"
    },
    {
        "id":2446,
        "name":"2445 (English Program)  :  Technology Education | การศึกษาเทคโนโลยี | 科技教育"
    },
    {
        "id":2447,
        "name":"2446 (Thai Program)  :  Social Research | การวิจัยสังคม | 社会研究"
    },
    {
        "id":2448,
        "name":"2447 (Thai Program)  :  Veterinary Education Clinic | คลินิกศึกษาทางสัตวแพทย์ | 兽医教育诊所"
    },
    {
        "id":2449,
        "name":"2448 (Thai Program)  :  Educational Research And Evaluation | การวิจัยและประเมินทางการศึกษา | 教育研究与评估"
    },
    {
        "id":2450,
        "name":"2449 (Thai Program)  :  Parks, Recreation And Tourism | อุทยาน นันทนาการ และการท่องเที่ยว | 公园、休闲和旅游"
    },
    {
        "id":2451,
        "name":"2450 (Thai Program)  :  Veterinary Epidemiology | ระบาดวิทยาทางสัตวแพทย์ | 兽医流行病学"
    },
    {
        "id":2452,
        "name":"2451 (Thai Program)  :  Maritime Science | วิทยาศาสตร์การเดินเรือ | 海事科学"
    },
    {
        "id":2453,
        "name":"2452 (Thai Program)  :  Training And Development | การฝึกอบรมและการพัฒนา | 培训与发展"
    },
    {
        "id":2454,
        "name":"2453 (Thai Program)  :  Project Analysis | การวิเคราะห์โครงการ | 项目分析"
    },
    {
        "id":2455,
        "name":"2454 (Thai Program)  :  Decision Making And Management Technology | เทคโนโลยีการตัดสินใจและการจัดการ | 决策与管理技术"
    },
    {
        "id":2456,
        "name":"2455 (Thai Program)  :  Public Policy And Project Management | นโยบายสาธารณะและการบริหารโครงการ | 公共政策和项目管理"
    },
    {
        "id":2457,
        "name":"2456 (Thai Program)  :  Economics Business Finance | เศรษฐศาสตร์ธุรกิจการเงิน | 经济商业金融"
    },
    {
        "id":2458,
        "name":"2457 (Thai Program)  :  Biological Industry Management | การจัดการอุตสาหกรรมชีวภาพ | 生物产业管理"
    },
    {
        "id":2459,
        "name":"2458 (English Program)  :  Communication Disorders | ความผิดปกติของการสื่อสาร | 沟通障碍"
    },
    {
        "id":2460,
        "name":"2459 (Thai Program)  :  Teaching System Design | การออกแบบระบบการเรียนการสอน | 教学系统设计"
    },
    {
        "id":2461,
        "name":"2460 (Thai Program)  :  Health Education And Welfare Education | สุขศึกษาและสวัสดิศึกษา | 健康教育和福利教育"
    },
    {
        "id":2462,
        "name":"2461 (Thai Program)  :  Physical Education And Sports Science | พลศึกษาและวิทยาศาสตร์การกีฬา | 体育与运动科学"
    },
    {
        "id":2463,
        "name":"2462 (Thai Program)  :  Primary Education - Counseling And Guidance Psychology | การประถมศึกษา-จิตวิทยาการปรึกษาและการแนะแนว | 初等教育 - 咨询和指导心理学"
    },
    {
        "id":2464,
        "name":"2463 (Thai Program)  :  Physics-Mathematics | ฟิสิกส์-คณิตศาสตร์ | 物理-数学"
    },
    {
        "id":2465,
        "name":"2464 (Thai Program)  :  Thai Language And Communication | ภาษาไทยกับการสื่อสาร | 泰语和交流"
    },
    {
        "id":2466,
        "name":"2465 (Thai Program)  :  Agricultural Technology (Animal Feed Technology) | เทคโนโลยีการเกษตร(เทคโนโลยีอาหารสัตว์) | 农业技术（动物饲料技术）"
    },
    {
        "id":2467,
        "name":"2466 (Thai Program)  :  Agricultural Technology (Plant Production Technology) | เทคโนโลยีการเกษตร(เทคโนโลยีการผลิตพืช) | 农业技术（植物生产技术）"
    },
    {
        "id":2468,
        "name":"2467 (Thai Program)  :  Teaching Islamic Studies | การสอนอิสลามศึกษา | 教授伊斯兰研究"
    },
    {
        "id":2469,
        "name":"2468 (Thai Program)  :  Islamic Studies(Arabic Language Program) | อิสลามศึกษา(โปรแกรมภาษาอาหรับ) | 伊斯兰研究（阿拉伯语课程）"
    },
    {
        "id":2470,
        "name":"2469 (Thai Program)  :  Political Science(Government) | รัฐศาสตร์(การปกครอง) | 政治学（政府）"
    },
    {
        "id":2471,
        "name":"2470 (English Program)  :  Corporate Finance | การเงินองค์กร | 企业融资"
    },
    {
        "id":2472,
        "name":"2471 (Thai Program)  :  Leadership In Educational Administration | ภาวะผู้นำทางการบริหารการศึกษา | 教育行政领导"
    },
    {
        "id":2473,
        "name":"2472 (English Program)  :  Communication Disorders - Audiology | ความผิดปกติของการสื่อสาร - โสตวิทยา | 沟通障碍 - 听力学"
    },
    {
        "id":2474,
        "name":"2473 (Thai Program)  :  Nonprofit Organization Management | การจัดการองค์การที่ไม่แสวงหากำไร | 非营利组织管理"
    },
    {
        "id":2475,
        "name":"2474 (Thai Program)  :  Electronic Business Operations | การประกอบธุรกิจอิเล็กทรอนิกส์ | 电子商务运营"
    },
    {
        "id":2476,
        "name":"2475 (Thai Program)  :  Labor Economics And Human Capital | เศรษฐศาสตร์แรงงานและทุนมนุษย์ | 劳动经济学和人力资本"
    },
    {
        "id":2477,
        "name":"2476 (Thai Program)  :  Labor Management Economics | เศรษฐศาสตร์การจัดการแรงงาน | 劳动管理经济学"
    },
    {
        "id":2478,
        "name":"2477 (Thai Program)  :  Educational Leadership | ภาวะผู้นำทางการศึกษา | 教育领导力"
    },
    {
        "id":2479,
        "name":"2478 (Thai Program)  :  Public Administration And Business Administration | รัฐประศาสนศาสตร์และบริหารธุรกิจ | 公共管理和工商管理"
    },
    {
        "id":2480,
        "name":"2479 (Thai Program)  :  Special Education Teacher Psychology | จิตวิทยาครูการศึกษาพิเศษ | 特殊教育教师心理学"
    },
    {
        "id":2481,
        "name":"2480 (Thai Program)  :  Optics | ทัศนศาสตร์ | 光学"
    },
    {
        "id":2482,
        "name":"2481 (Thai Program)  :  Golf Services | การบริการกอล์ฟ | 高尔夫服务"
    },
    {
        "id":2483,
        "name":"2482 (Thai Program)  :  Business And Management English | ภาษาอังกฤษธุรกิจและการจัดการ | 商业与管理英语"
    },
    {
        "id":2484,
        "name":"2483 (Thai Program)  :  Natural Resources And Environmental Law | กฎหมายทรัพยากรธรรมชาติและสิ่งแวดล้อม | 自然资源和环境法"
    },
    {
        "id":2485,
        "name":"2484 (English Program)  :  International Relations | ความสัมพันธ์ระหว่างประเทศ | 国际关系"
    },
    {
        "id":2486,
        "name":"2485 (Thai Program)  :  Public Administration | การบริหารจัดการสาธารณะ | 公共行政"
    },
    {
        "id":2487,
        "name":"2486 (Thai Program)  :  Labor Development And Social Welfare | พัฒนาแรงงานและสวัสดิการสังคม | 劳动力发展和社会福利"
    },
    {
        "id":2488,
        "name":"2487 (Thai Program)  :  Social Welfare Administration And Policy | การบริหารและนโยบายสวัสดิการสังคม | 社会福利管理与政策"
    },
    {
        "id":2489,
        "name":"2488 (English Program)  :  International Relations And Comparative | ความสัมพันธ์ระหว่างประเทศและการเปรียบเทียบ | 国际关系与比较"
    },
    {
        "id":2490,
        "name":"2489 (English Program)  :  Agricultural & Extension Education | การเกษตรและการศึกษาต่อขยาย | 农业及推广教育"
    },
    {
        "id":2491,
        "name":"2490 (English Program)  :  Alimentation Nutrition | โภชนาการอาหาร | 营养营养"
    },
    {
        "id":2492,
        "name":"2491 (English Program)  :  Artamd Cvatts | อาร์ตามด์ Cvatts | Artamd Cvatt"
    },
    {
        "id":2493,
        "name":"2492 (English Program)  :  Child Development | พัฒนาการของเด็ก | 儿童发展"
    },
    {
        "id":2494,
        "name":"2493 (English Program)  :  Computing And Information Technology | เทคโนโลยีคอมพิวเตอร์และสารสนเทศ | 计算与信息技术"
    },
    {
        "id":2495,
        "name":"2494 (English Program)  :  Development Commumication | การสื่อสารเพื่อการพัฒนา | 发展交流"
    },
    {
        "id":2496,
        "name":"2495 (English Program)  :  Development Studies | การศึกษาการพัฒนา | 发展研究"
    },
    {
        "id":2497,
        "name":"2496 (English Program)  :  Docter De Troisieme Cyele | หมอไซลีคนที่สาม | 德·特鲁西姆·赛勒博士"
    },
    {
        "id":2498,
        "name":"2497 (English Program)  :  Docteur En Droit | นิติศาสตร์บัณฑิต | 法学博士"
    },
    {
        "id":2499,
        "name":"2498 (English Program)  :  Early Childhood Development | พัฒนาการเด็กปฐมวัย | 儿童早期发展"
    },
    {
        "id":2500,
        "name":"2499 (English Program)  :  Economics And Economic History | เศรษฐศาสตร์และประวัติศาสตร์เศรษฐกิจ | 经济学和经济史"
    },
    {
        "id":2501,
        "name":"2500 (English Program)  :  Educational Media | สื่อการศึกษา | 教育媒体"
    },
    {
        "id":2502,
        "name":"2501 (English Program)  :  Educational Media And Technology | สื่อและเทคโนโลยีการศึกษา | 教育媒体和技术"
    },
    {
        "id":2503,
        "name":"2502 (English Program)  :  Extension Education | การศึกษาต่อยอด | 延伸教育"
    },
    {
        "id":2504,
        "name":"2503 (English Program)  :  Family Relation And Child Development | ความสัมพันธ์ทางครอบครัวและการพัฒนาเด็ก | 家庭关系与儿童发展"
    },
    {
        "id":2505,
        "name":"2504 (English Program)  :  Family Social Science | สังคมศาสตร์ครอบครัว | 家庭社会科学"
    },
    {
        "id":2506,
        "name":"2505 (English Program)  :  Family&Child Ecology | นิเวศวิทยาของครอบครัวและเด็ก | 家庭&儿童生态"
    },
    {
        "id":2507,
        "name":"2506 (English Program)  :  General Business | ธุรกิจทั่วไป | 一般业务"
    },
    {
        "id":2508,
        "name":"2507 (English Program)  :  Government Local,Aministration Locate | หน่วยงานราชการในท้องถิ่น ที่ตั้งหน่วยงาน | 政府所在地、政府所在地"
    },
    {
        "id":2509,
        "name":"2508 (English Program)  :  Graphic Arsts System | ระบบศิลปะกราฟิก | 图形艺术系统"
    },
    {
        "id":2510,
        "name":"2509 (English Program)  :  Health Promotion Education | การศึกษาส่งเสริมสุขภาพ | 健康促进教育"
    },
    {
        "id":2511,
        "name":"2510 (English Program)  :  Higher And Adult Education | การศึกษาระดับสูงและผู้ใหญ่ | 高等教育和成人教育"
    },
    {
        "id":2512,
        "name":"2511 (English Program)  :  Higher Education Adiministration | การบริหารการศึกษาระดับอุดมศึกษา | 高等教育管理局"
    },
    {
        "id":2513,
        "name":"2512 (English Program)  :  Hospitality & Tourism | การต้อนรับและการท่องเที่ยว | 酒店及旅游业"
    },
    {
        "id":2514,
        "name":"2513 (English Program)  :  Human Sciences | วิทยาศาสตร์มนุษย์ | 人文科学"
    },
    {
        "id":2515,
        "name":"2514 (English Program)  :  Human Settlements Development | การพัฒนาการตั้งถิ่นฐานของมนุษย์ | 人类住区发展"
    },
    {
        "id":2516,
        "name":"2515 (English Program)  :  International Human Rights Law | กฎหมายสิทธิมนุษยชนระหว่างประเทศ | 国际人权法"
    },
    {
        "id":2517,
        "name":"2516 (English Program)  :  Marter Of Business Systems | เครื่องหมายของระบบธุรกิจ | 商业系统市场"
    },
    {
        "id":2518,
        "name":"2517 (English Program)  :  Nonformal Education | การศึกษานอกระบบ | 非正规教育"
    },
    {
        "id":2519,
        "name":"2518 (English Program)  :  Packaging | บรรจุภัณฑ์ | 包装"
    },
    {
        "id":2520,
        "name":"2519 (English Program)  :  Plant Beeding | การให้ปุ๋ยพืช | 植物种植"
    },
    {
        "id":2521,
        "name":"2520 (English Program)  :  Public And Private Management Program | โปรแกรมการจัดการภาครัฐและเอกชน | 公共和私人管理计划"
    },
    {
        "id":2522,
        "name":"2521 (English Program)  :  Public Health Education | การศึกษาด้านสาธารณสุข | 公众健康教育"
    },
    {
        "id":2523,
        "name":"2522 (English Program)  :  Publishing | การเผยแพร่ | 出版"
    },
    {
        "id":2524,
        "name":"2523 (English Program)  :  Rural Development | การพัฒนาชนบท | 农村发展"
    },
    {
        "id":2525,
        "name":"2524 (English Program)  :  Sciences Politiques | รัฐศาสตร์ | 科学政治"
    },
    {
        "id":2526,
        "name":"2525 (English Program)  :  Social And Preventive Medicine And Nutrition | การแพทย์ทางสังคมและการป้องกันและโภชนาการ | 社会和预防医学及营养"
    },
    {
        "id":2527,
        "name":"2526 (English Program)  :  Social Studies Education | การศึกษาสังคมศึกษา | 社会研究教育"
    },
    {
        "id":2528,
        "name":"2527 (English Program)  :  Teaching English Overseas | การสอนภาษาอังกฤษในต่างประเทศ | 海外英语教学"
    },
    {
        "id":2529,
        "name":"2528 (English Program)  :  Telecommunications | โทรคมนาคม | 电信"
    },
    {
        "id":2530,
        "name":"2529 (English Program)  :  Vocational-Technical Education | อาชีวศึกษา-เทคนิค | 职业技术教育"
    },
    {
        "id":2531,
        "name":"2530 (Thai Program)  :  International Trade Law | กฎหมายการค้าระหว่างประเทศ | 国际贸易法"
    },
    {
        "id":2532,
        "name":"2531 (Thai Program)  :  Personnel Management | การจัดการงานบุคคล | 人事管理"
    },
    {
        "id":2533,
        "name":"2533 (Thai Program)  :  General Management Field Of Study: Human Resource Management | การจัดการทั่วไป แขนงวิชาการบริหารทรัพยากรมนุษย์ | 综合管理研究领域: 人力资源管理"
    },
    {
        "id":2534,
        "name":"2534 (Thai Program)  :  General Management Accounting | การจัดการทั่วไป บัญชี | 一般管理会计"
    },
    {
        "id":2535,
        "name":"2535 (Thai Program)  :  Organizational Management And Administration | การจัดการและการบริหารองค์การ | 组织管理和行政"
    },
    {
        "id":2536,
        "name":"2536 (Thai Program)  :  Banking And Financial Business | การธนาคารและธุรกิจการเงิน | 银行及金融业务"
    },
    {
        "id":2537,
        "name":"2537 (Thai Program)  :  Educational Services | การบริการการศึกษา | 教育服务"
    },
    {
        "id":2538,
        "name":"2538 (Thai Program)  :  General Administration | การบริหารงานทั่วไป | 一般行政管理"
    },
    {
        "id":2539,
        "name":"2539 (Thai Program)  :  Rural Community Development Management | การบริหารพัฒนาชุมชนชนบท | 农村社区发展管理"
    },
    {
        "id":2540,
        "name":"2540 (Thai Program)  :  School Administration | การบริหารโรงเรียน | 学校行政"
    },
    {
        "id":2541,
        "name":"2541 (Thai Program)  :  Social Administration | การบริหารสังคม | 社会管理"
    },
    {
        "id":2542,
        "name":"2542 (Thai Program)  :  Educational Evaluation | การประเมินผลการศึกษา | 教育评价"
    },
    {
        "id":2543,
        "name":"2543 (Thai Program)  :  Production Of English Teaching Media | การผลิตสื่อการเรียนการสอนภาษาอังกฤษ | 英语教学媒体制作"
    },
    {
        "id":2544,
        "name":"2544 (English Program)  :  Home Economics | คหกรรมศาสตร์ | 家庭经济"
    },
    {
        "id":2545,
        "name":"2545 (Thai Program)  :  City ​​Planning | การวางแผนเมือง | 城市规划"
    },
    {
        "id":2546,
        "name":"2546 (Thai Program)  :  Non-Formal Education | การศึกษานอกโรงเรียน | 非正规教育"
    },
    {
        "id":2547,
        "name":"2547 (Thai Program)  :  Cooperative | การสหกรณ์ | 合作社"
    },
    {
        "id":2548,
        "name":"2548 (Thai Program)  :  Kindergarten Education | การอนุบาลศึกษา | 幼儿园教育"
    },
    {
        "id":2549,
        "name":"2549 (Thai Program)  :  Home Economics | คหกรรม | 家政"
    },
    {
        "id":2550,
        "name":"2550 (Thai Program)  :  Drink | เครื่องดื่ม | 喝"
    },
    {
        "id":2551,
        "name":"2551 (Thai Program)  :  Weaving-Dyeing Machine | เครื่องทอ-ย้อม | 织染机"
    },
    {
        "id":2552,
        "name":"2552 (Thai Program)  :  Advertising And Public Relations | โฆษณาและประชาสัมพันธ์ | 广告和公共关系"
    },
    {
        "id":2553,
        "name":"2553 (Thai Program)  :  Installation And Control Work | งานติดตั้งและการควบคุม | 安装及控制工作"
    },
    {
        "id":2554,
        "name":"2554 (Thai Program)  :  International Painting | จิตรกรรมสากล | 国际绘画"
    },
    {
        "id":2555,
        "name":"2555 (Thai Program)  :  Clinical Psychology | จิตวิทยาคลินิค | 临床心理学"
    },
    {
        "id":2556,
        "name":"2556 (Thai Program)  :  Tool And Control Technician | ช่างเครื่องมือและควบคุมฯ | 工具和控制技术人员"
    },
    {
        "id":2557,
        "name":"2557 (Thai Program)  :  Housewares Technician | ช่างเคหภัณฑ์ | 家庭用品技师"
    },
    {
        "id":2558,
        "name":"2558 (Thai Program)  :  Production Technician | ช่างเทคนิคการผลิต | 生产技术员"
    },
    {
        "id":2559,
        "name":"2559 (Thai Program)  :  Metal Technician | ช่างเทคนิคโลหะ | 金属技师"
    },
    {
        "id":2560,
        "name":"2560 (Thai Program)  :  Power Electrician Installation And Control Work | ช่างไฟฟ้ากำลัง งานติดตั้งและควบคุม | 电力电工安装及控制工作"
    },
    {
        "id":2561,
        "name":"2561 (Thai Program)  :  Electrician - Electrical Power | ช่างไฟฟ้า-ไฟฟ้ากำลัง | 电工-电力"
    },
    {
        "id":2562,
        "name":"2562 (Thai Program)  :  Electronic Electrician | ช่างไฟฟ้าอิเล็กทรอนิกส์ | 电子电工"
    },
    {
        "id":2563,
        "name":"2563 (Thai Program)  :  Car Assembly Repair | ซ่อมประกอบรถยนต์ | 汽车总成维修"
    },
    {
        "id":2564,
        "name":"2564 (Thai Program)  :  Fine Arts Career Techniques | เทคนิคการอาชีพศิลปกรรม | 美术职业技巧"
    },
    {
        "id":2565,
        "name":"2565 (Thai Program)  :  Educational Technology And Educational Innovation | เทคโนโลยีการศึกษาและนวัตกรรมทางการศึกษา | 教育技术与教育创新"
    },
    {
        "id":2566,
        "name":"2566 (Thai Program)  :  Electronic Technology | เทคโนโลยีอิเลคทรอนิคส์ | 电子技术"
    },
    {
        "id":2567,
        "name":"2567 (Thai Program)  :  Manufacturing Industry Technology | เทคโนโลยีอุตสาหกรรมการผลิต | 制造业技术"
    },
    {
        "id":2568,
        "name":"2568 (Thai Program)  :  Electronic Industry Technology | เทคโนโลยีอุตสาหกรรมอิเล็กทรอนิกส์ | 电子工业技术"
    },
    {
        "id":2569,
        "name":"2569 (Thai Program)  :  Education-Marketing Business | ธุรกิจการศึกษา-การตลาด | 教育营销业务"
    },
    {
        "id":2570,
        "name":"2570 (Thai Program)  :  General Business | ธุรกิจทั่วไป | 一般业务"
    },
    {
        "id":2571,
        "name":"2571 (Thai Program)  :  Business Studies-Accounting | ธุรกิจศึกษา-บัญชี | 商业研究-会计"
    },
    {
        "id":2572,
        "name":"2572 (Thai Program)  :  Developmental Communication Arts | นิเทศศาสตรพัฒนาการ | 发展传播艺术"
    },
    {
        "id":2573,
        "name":"2573 (Thai Program)  :  Thai Barrister At Law | เนติบัณฑิตไทย | 泰国大律师"
    },
    {
        "id":2574,
        "name":"2574 (Thai Program)  :  Librarianship | บรรณารักษ์ศาสตร์ | 图书馆管理"
    },
    {
        "id":2575,
        "name":"2575 (Thai Program)  :  Librarianship And Information Science | บรรณารักษ์ศาสตร์และสารนิเทศศาสตร์ | 图书馆学与信息科学"
    },
    {
        "id":2576,
        "name":"2576 (Thai Program)  :  Financial Management | บริหารการเงิน | 财务管理"
    },
    {
        "id":2577,
        "name":"2577 (Thai Program)  :  Market Management | บริหารการจัดการตลาด | 市场管理"
    },
    {
        "id":2578,
        "name":"2578 (Thai Program)  :  Manage Projects And Policies | บริหารโครงการและนโยบาย | 管理项目和政策"
    },
    {
        "id":2579,
        "name":"2579 (Thai Program)  :  Personnel Management | บริหารงานบุคคล | 人事管理"
    },
    {
        "id":2580,
        "name":"2580 (Thai Program)  :  Business Administration-Computer | บริหารธุรกิจ-คอมพิวเตอร์ | 工商管理-计算机"
    },
    {
        "id":2581,
        "name":"2581 (Thai Program)  :  Organizational Administration And Management | บริหารองค์การและการจัดการ | 组织行政和管理"
    },
    {
        "id":2582,
        "name":"2582 (Thai Program)  :  Economic Development | พัฒนาการเศรษฐกิจ | 经济发展"
    },
    {
        "id":2583,
        "name":"2583 (Thai Program)  :  Commerce | พาณิชยกรรม | 商业"
    },
    {
        "id":2584,
        "name":"2584 (Thai Program)  :  Crops | พืชกรรม | 农作物"
    },
    {
        "id":2585,
        "name":"2585 (Thai Program)  :  Electrical-Communication | ไฟฟ้า-สื่อสาร | 电气-通讯"
    },
    {
        "id":2586,
        "name":"2586 (Thai Program)  :  Language-Society | ภาษา-สังคม | 语言社会"
    },
    {
        "id":2587,
        "name":"2587 (Thai Program)  :  Geography Map | ภูมิศาสตร์แผนที่ | 地理地图"
    },
    {
        "id":2588,
        "name":"2588 (Thai Program)  :  Secondary Education-Thai Language Teaching | มัธยมศึกษา-การสอนภาษาไทย | 中等教育-泰语教学"
    },
    {
        "id":2589,
        "name":"2589 (Thai Program)  :  Science-Math | วิทย์-คณิต | 科学数学"
    },
    {
        "id":2590,
        "name":"2590 (Thai Program)  :  General Science | วิทยาศาตร์ทั่วไป | 普通科学"
    },
    {
        "id":2591,
        "name":"2591 (Thai Program)  :  Science-Biology | วิทยาศาสตร์-ชีววิทยา | 科学-生物学"
    },
    {
        "id":2592,
        "name":"2592 (Thai Program)  :  Science Technology | วิทยาศาสตร์เทคโนโลยี | 科学技术"
    },
    {
        "id":2593,
        "name":"2593 (Thai Program)  :  Physics Science | วิทยาศาสตร์ฟิสิกส์ | 物理科学"
    },
    {
        "id":2594,
        "name":"2594 (Thai Program)  :  Radio Broadcasting Television | วิทยุกระจายเสียงวิทยุโทรทัศน์ | 无线电广播电视"
    },
    {
        "id":2595,
        "name":"2595 (Thai Program)  :  Radio-Telecommunications | วิทยุ-โทรคมนาคม | 无线电通讯"
    },
    {
        "id":2596,
        "name":"2596 (Thai Program)  :  Radio-Television | วิทยุ-โทรทัศน์ | 广播电视"
    },
    {
        "id":2597,
        "name":"2597 (Thai Program)  :  Civil Engineering And Infrastructure | วิศวกรรมโยธาและโครงสร้างพื้นฐาน | 土木工程和基础设施"
    },
    {
        "id":2598,
        "name":"2598 (Thai Program)  :  Electrical-Electronic Engineering | วิศวกรรมไฟฟ้า-อิเล็กทรอนิกส์ | 电气电子工程"
    },
    {
        "id":2599,
        "name":"2599 (Thai Program)  :  Civil Engineering-Construction | วิศวกรรมโยธา-ก่อสร้าง | 土木工程-建筑"
    },
    {
        "id":2600,
        "name":"2600 (Thai Program)  :  Fine Arts And Design | ศิลปกรรมและการออกแบบ | 美术与设计"
    },
    {
        "id":2601,
        "name":"2601 (Thai Program)  :  Fine Arts | ศิลปกรรมศาสตร์ | 美术"
    },
    {
        "id":2602,
        "name":"2602 (Thai Program)  :  Arts And Education | ศิลปคึกษา | 艺术与教育"
    },
    {
        "id":2603,
        "name":"2603 (Thai Program)  :  Arts-Language | ศิลป์-ภาษา | 艺术语言"
    },
    {
        "id":2604,
        "name":"2604 (Thai Program)  :  Arts-Industry | ศิลป์-อุตสาหกรรม | 艺术产业"
    },
    {
        "id":2605,
        "name":"2605 (Thai Program)  :  Study Agriculture | ศึกษาการเกษตร | 学习农业"
    },
    {
        "id":2606,
        "name":"2606 (Thai Program)  :  Study Agriculture | ศึกษาศาสตร์เกษตร | 研究农业"
    },
    {
        "id":2607,
        "name":"2607 (Thai Program)  :  Business And Government Economics | เศรษฐศาสตร์ธุรกิจและภาครัฐ | 商业和政府经济学"
    },
    {
        "id":2608,
        "name":"2608 (Thai Program)  :  Asean Studies For Sustainable Development | อาเซียนศึกษาเพื่อการพัฒนาอย่างยั่งยืน | 东盟可持续发展研究"
    },
    {
        "id":2609,
        "name":"2609 (Thai Program)  :  Economics And Cooperatives | เศรษฐศาสตร์และสหกรณ์ | 经济与合作社"
    },
    {
        "id":2610,
        "name":"2610 (Thai Program)  :  Social-Health | สังคม-พลานามัย | 社会健康"
    },
    {
        "id":2611,
        "name":"2611 (Thai Program)  :  Social Work In The Justice Process | สังคมสงเคราะห์ในขบวนการยุติธรรม | 司法过程中的社会工作"
    },
    {
        "id":2612,
        "name":"2612 (Thai Program)  :  Public Health, Infectious Diseases | สาธารณสุขศาสตร์ โรคติดเชื้อ | 公共卫生、传染病"
    },
    {
        "id":2613,
        "name":"2613 (Thai Program)  :  General Education | สามัญศึกษา | 普通教育"
    },
    {
        "id":2614,
        "name":"2614 (Thai Program)  :  Applied Arts Design | ออกแบบศิลปประยุกต์ | 应用艺术设计"
    },
    {
        "id":2615,
        "name":"2615 (Thai Program)  :  Business English | อังกฤษธุรกิจ | 商务英语"
    },
    {
        "id":2616,
        "name":"2616 (Thai Program)  :  Electronics | อิเล็คทรอนิคส์ | 电子产品"
    },
    {
        "id":2617,
        "name":"2617 (Thai Program)  :  Electronics-Communications | อิเลคทรอนิคส์-สื่อสาร | 电子通讯"
    },
    {
        "id":2618,
        "name":"2618 (Thai Program)  :  Bio-Innovation | ชีวนวัตกรรม | 生物创新"
    },
    {
        "id":2619,
        "name":"2619 (Thai Program)  :  Industry | อุตสาหการ | 行业"
    },
    {
        "id":2620,
        "name":"2620 (Thai Program)  :  Innovation Management | การจัดการนวัตกรรม | 创新管理"
    },
    {
        "id":2621,
        "name":"2621 (Thai Program)  :  Home Economics For Community Development | คหกรรมศาสตร์เพื่อพัฒนาชุมชน | 家政促进社区发展"
    },
    {
        "id":2622,
        "name":"2622 (Thai Program)  :  International Trade Negotiations | การเจรจาการค้าระหว่างประเทศ | 国际贸易谈判"
    },
    {
        "id":2623,
        "name":"2623 (Thai Program)  :  Lobbying | การล็อบบี้ | 游说"
    },
    {
        "id":2624,
        "name":"2624 (Thai Program)  :  Forensic Science | นิติวิทยาศาสตร์ | 法医学"
    },
    {
        "id":2625,
        "name":"2625 (Thai Program)  :  Health System Management | การจัดการระบบสุขภาพ | 卫生系统管理"
    },
    {
        "id":2626,
        "name":"2626 (Thai Program)  :  Technology And Innovation Management | การจัดการเทคโนโลยีและนวัตกรรม | 技术与创新管理"
    },
    {
        "id":2627,
        "name":"2627 (Thai Program)  :  Development Of Industrial Competitiveness | การพัฒนาความสามารถทางการแข่งขันเชิงอุตสาหกรรม | 产业竞争力发展"
    },
    {
        "id":2628,
        "name":"2628 (Thai Program)  :  Quality Engineering | วิศวกรรมคุณภาพ | 品质工程"
    },
    {
        "id":2629,
        "name":"2629 (Thai Program)  :  Integrated Design And Production | การออกแบบและผลิตแบบบูรณาการ | 一体化设计、生产"
    },
    {
        "id":2630,
        "name":"2630 (Thai Program)  :  Human-Centered Design | การออกแบบโดยเน้นมนุษย์เป็นศูนย์กลาง | 以人为本的设计"
    },
    {
        "id":2631,
        "name":"2631 (Thai Program)  :  Polymer Process Engineering | วิศวกรรมกระบวนการขึ้นรูปพอลิเมอร์ | 聚合物加工工程"
    },
    {
        "id":2632,
        "name":"2632 (Thai Program)  :  Production And Systems Engineering | วิศวรรมการผลิตและระบบ | 生产和系统工程"
    },
    {
        "id":2633,
        "name":"2633 (English Program)  :  Individual Based Program | โปรแกรมเฉพาะบุคคล | 基于个人的计划"
    },
    {
        "id":2634,
        "name":"2634 (Thai Program)  :  Innovation In Learning Technology | นวัตกรรมการเรียนรู้ทางเทคโนโลยี | 学习技术创新"
    },
    {
        "id":2635,
        "name":"2635 (English Program)  :  Media Ecology | นิเวศวิทยาของสื่อ | 媒体生态"
    },
    {
        "id":2636,
        "name":"2636 (English Program)  :  Non-Western Civilizations | อารยธรรมที่ไม่ใช่ตะวันตก | 非西方文明"
    },
    {
        "id":2637,
        "name":"2637 (English Program)  :  Reading Education | การศึกษาการอ่าน | 阅读教育"
    },
    {
        "id":2638,
        "name":"2638 (English Program)  :  Rural Sociology | สังคมวิทยาชนบท | 农村社会学"
    },
    {
        "id":2639,
        "name":"2639 (English Program)  :  School Principalship | ผู้อำนวยการโรงเรียน | 学校校长"
    },
    {
        "id":2640,
        "name":"2640 (English Program)  :  Teaching Practical Arts | การสอนศิลปะการปฏิบัติ | 实用艺术教学"
    },
    {
        "id":2641,
        "name":"2641 (Thai Program)  :  Foreign Affairs | การต่างประเทศ | 外交事务"
    },
    {
        "id":2642,
        "name":"2642 (Thai Program)  :  Foreign Affairs And Diplomacy | การต่างประเทศและการฑูต | 外交事务"
    },
    {
        "id":2643,
        "name":"2643 (Thai Program)  :  Public Economic Management | การบริหารเศรษฐกิจสาธารณะ | 公共经济管理"
    },
    {
        "id":2644,
        "name":"2644 (Thai Program)  :  Western Language Inscriptions | จารึกภาษาตะวันตก | 西文铭文"
    },
    {
        "id":2645,
        "name":"2645 (Thai Program)  :  Typist | ช่างพิมพ์ | 打字员"
    },
    {
        "id":2646,
        "name":"2646 (Thai Program)  :  Photographer | ช่างภาพ | 摄影师"
    },
    {
        "id":2647,
        "name":"2647 (Thai Program)  :  Radio And Telecommunications Technician | ช่างวิทยุและโทรคมนาคม | 无线电和电信技术员"
    },
    {
        "id":2648,
        "name":"2648 (Thai Program)  :  Arts And Craftsman | ช่างศิลปหัตถกรรม | 艺术与工匠"
    },
    {
        "id":2649,
        "name":"2649 (Thai Program)  :  Leather Industry Technician | ช่างอุตสาหกรรมหนัง | 皮革工业技术员"
    },
    {
        "id":2650,
        "name":"2650 (Thai Program)  :  Equipment Technician\/Equipment Technician | ช่างเคหภัณฑ์\/ช่างครุภัณฑ์ | 设备技术员\/设备技术员"
    },
    {
        "id":2651,
        "name":"2651 (Thai Program)  :  Welder And Sheet Metal | ช่างเชื่อมและโลหะแผ่น | 焊工和钣金"
    },
    {
        "id":2652,
        "name":"2652 (Thai Program)  :  Industrial Technician | ช่างเทคนิคอุตสาหกรรม | 工业技术员"
    },
    {
        "id":2653,
        "name":"2653 (Thai Program)  :  Literature | อักษรศาสตร์ | 文学"
    },
    {
        "id":2654,
        "name":"2654 (Thai Program)  :  Art Teaching | การสอนศิลปะ | 艺术教学"
    },
    {
        "id":2655,
        "name":"2655 (Thai Program)  :  Teaching Dance Sangeet | การสอนนาฏสังคีต | 桑吉特舞蹈教学"
    },
    {
        "id":2656,
        "name":"2656 (Thai Program)  :  Teaching Foreign Languages | การสอนภาษาต่างประเทศ | 外语教学"
    },
    {
        "id":2657,
        "name":"2657 (Thai Program)  :  Research, Measurement And Statistical Studies | วิจัย วัดผลและสถิติศึกษา | 研究、测量和统计研究"
    },
    {
        "id":2658,
        "name":"2658 (Thai Program)  :  Exercise And Sports Studies | การออกกำลังกายและกีฬาศึกษา | 锻炼和体育研究"
    },
    {
        "id":2659,
        "name":"2659 (Thai Program)  :  Human Resource Development (Communication Skills) | การพัฒนาทรัพยากรมนุษย์ (ทักษะการติดต่อสื่อสาร) | 人力资源开发（沟通技巧）"
    },
    {
        "id":2660,
        "name":"2660 (English Program)  :  General Home Economics | เศรษฐศาสตร์บ้านทั่วไป | 一般家庭经济学"
    },
    {
        "id":2661,
        "name":"2661 (English Program)  :  Tesol & Bilingual Education | Tesol และการศึกษาสองภาษา | Tesol 和双语教育"
    },
    {
        "id":2662,
        "name":"2662 (English Program)  :  Agricultural And Forest Engineering | วิศวกรรมเกษตรและป่าไม้ | 农业与林业工程"
    },
    {
        "id":2663,
        "name":"2663 (English Program)  :  Agricultural Mechanics | กลศาสตร์การเกษตร | 农业机械"
    },
    {
        "id":2664,
        "name":"2664 (English Program)  :  Animal Breeding And Animal Production | การปรับปรุงพันธุ์สัตว์และการผลิตสัตว์ | 动物育种和动物生产"
    },
    {
        "id":2665,
        "name":"2665 (English Program)  :  Animal Reproduction | การสืบพันธุ์ของสัตว์ | 动物繁殖"
    },
    {
        "id":2666,
        "name":"2666 (English Program)  :  Applied Biosciences And Biotechnology | วิทยาศาสตร์ชีวภาพประยุกต์และเทคโนโลยีชีวภาพ | 应用生物科学和生物技术"
    },
    {
        "id":2667,
        "name":"2667 (English Program)  :  Aquaculture And Aquatic Resources Management | การเพาะเลี้ยงสัตว์น้ำและการจัดการทรัพยากรทางน้ำ | 水产养殖和水生资源管理"
    },
    {
        "id":2668,
        "name":"2668 (English Program)  :  Aquatic Biosciences | ชีววิทยาศาสตร์ทางน้ำ | 水生生物科学"
    },
    {
        "id":2669,
        "name":"2669 (English Program)  :  Basin Evolution And Dynamics | วิวัฒนาการและไดนามิกของลุ่มน้ำ | 盆地演化和动力学"
    },
    {
        "id":2670,
        "name":"2670 (English Program)  :  Biotechnology And Bioprocess Engineering | เทคโนโลยีชีวภาพและวิศวกรรมกระบวนการชีวภาพ | 生物技术和生物工艺工程"
    },
    {
        "id":2671,
        "name":"2671 (English Program)  :  General Home Economics-Art And Craft Business | เศรษฐศาสตร์บ้านทั่วไป-ธุรกิจศิลปะและงานฝีมือ | 一般家庭经济学-艺术和手工艺业务"
    },
    {
        "id":2672,
        "name":"2672 (English Program)  :  Chemistry And Chemical Engineering | เคมีและวิศวกรรมเคมี | 化学与化学工程"
    },
    {
        "id":2673,
        "name":"2673 (English Program)  :  Continuing Education | การศึกษาต่อเนื่อง | 继续教育"
    },
    {
        "id":2674,
        "name":"2674 (English Program)  :  Crop And Soil Sciences | วิทยาศาสตร์พืชและดิน | 作物和土壤科学"
    },
    {
        "id":2675,
        "name":"2675 (English Program)  :  Dairy Production And Nutrition | การผลิตนมและโภชนาการ | 乳制品生产和营养"
    },
    {
        "id":2676,
        "name":"2676 (English Program)  :  Der Fachbereich Physikalische Chemie | ภาควิชาเคมีกายภาพ | 物理化学"
    },
    {
        "id":2677,
        "name":"2677 (English Program)  :  Doktor Der Naturwissenschaften | แพทยศาสตร์บัณฑิต | 自然科学博士"
    },
    {
        "id":2678,
        "name":"2678 (English Program)  :  Droit | ขวา | 所有权"
    },
    {
        "id":2679,
        "name":"2679 (English Program)  :  Ecological Entomology | กีฏวิทยานิเวศวิทยา | 生态昆虫学"
    },
    {
        "id":2680,
        "name":"2680 (Thai Program)  :  Study | การศึกษา | 学习"
    },
    {
        "id":2681,
        "name":"2681 (English Program)  :  Energy And Environment | พลังงานและสิ่งแวดล้อม | 能源与环境"
    },
    {
        "id":2682,
        "name":"2682 (English Program)  :  Engineering In Biotechnology | วิศวกรรมศาสตร์ในเทคโนโลยีชีวภาพ | 生物技术工程"
    },
    {
        "id":2683,
        "name":"2683 (English Program)  :  Engineering Systems And Technology | ระบบวิศวกรรมและเทคโนโลยี | 工程系统和技术"
    },
    {
        "id":2684,
        "name":"2684 (English Program)  :  English As A Foreign Language | ภาษาอังกฤษเป็นภาษาต่างประเทศ | 英语作为外语"
    },
    {
        "id":2685,
        "name":"2685 (English Program)  :  English Language Studies And Methods | การศึกษาและวิธีการภาษาอังกฤษ | 英语语言研究和方法"
    },
    {
        "id":2686,
        "name":"2686 (English Program)  :  Enviromental Planning | การวางแผนสิ่งแวดล้อม | 环境规划"
    },
    {
        "id":2687,
        "name":"2687 (English Program)  :  Environmental Technology & Management | เทคโนโลยีและการจัดการสิ่งแวดล้อม | 环境技术与管理"
    },
    {
        "id":2688,
        "name":"2688 (English Program)  :  Food Engineering And Bioprocess Technology | วิศวกรรมอาหารและเทคโนโลยีกระบวนการทางชีวภาพ | 食品工程和生物加工技术"
    },
    {
        "id":2689,
        "name":"2689 (English Program)  :  Food Processing | การแปรรูปอาหาร | 食品加工"
    },
    {
        "id":2690,
        "name":"2690 (English Program)  :  Foreign Language Education | การศึกษาภาษาต่างประเทศ | 外语教育"
    },
    {
        "id":2691,
        "name":"2691 (English Program)  :  Fuel Science | วิทยาศาสตร์เชื้อเพลิง | 燃料科学"
    },
    {
        "id":2692,
        "name":"2692 (English Program)  :  Geological Engineering | วิศวกรรมธรณีวิทยา | 地质工程"
    },
    {
        "id":2693,
        "name":"2693 (English Program)  :  Geologie | ธรณีวิทยา | 地质学"
    },
    {
        "id":2694,
        "name":"2694 (English Program)  :  Industrial-Organization Phychology | สรีรวิทยาขององค์การอุตสาหกรรม | 产业组织心理学"
    },
    {
        "id":2695,
        "name":"2695 (English Program)  :  Instructional Systems And Library Science | ระบบการเรียนการสอนและวิทยาศาสตร์ห้องสมุด | 教学系统和图书馆学"
    },
    {
        "id":2696,
        "name":"2696 (English Program)  :  Interactive Multimedia | มัลติมีเดียแบบโต้ตอบ | 互动多媒体"
    },
    {
        "id":2697,
        "name":"2697 (English Program)  :  Intermediate Energy Nuclear Physics | ฟิสิกส์นิวเคลียร์พลังงานระดับกลาง | 中能核物理"
    },
    {
        "id":2698,
        "name":"2698 (English Program)  :  Language And Linguistics | ภาษาและภาษาศาสตร์ | 语言和语言学"
    },
    {
        "id":2699,
        "name":"2699 (English Program)  :  Media And Culture | สื่อและวัฒนธรรม | 媒体与文化"
    },
    {
        "id":2700,
        "name":"2700 (English Program)  :  Microbiology And Immunology | จุลชีววิทยาและภูมิคุ้มกันวิทยา | 微生物学和免疫学"
    },
    {
        "id":2701,
        "name":"2701 (English Program)  :  Mineral Processing | การแปรรูปแร่ | 选矿"
    },
    {
        "id":2702,
        "name":"2702 (English Program)  :  Molecular Microbiology And Immunology | อณูจุลชีววิทยาและภูมิคุ้มกันวิทยา | 分子微生物学和免疫学"
    },
    {
        "id":2703,
        "name":"2703 (English Program)  :  Natural Science | วิทยาศาสตร์ธรรมชาติ | 自然科学"
    },
    {
        "id":2704,
        "name":"2704 (English Program)  :  Nuclear Physics | ฟิสิกส์นิวเคลียร์ | 核物理"
    },
    {
        "id":2705,
        "name":"2705 (English Program)  :  Pharmacology And Toxicology | เภสัชวิทยาและพิษวิทยา | 药理学和毒理学"
    },
    {
        "id":2706,
        "name":"2706 (English Program)  :  Phonetics | สัทศาสตร์ | 语音学"
    },
    {
        "id":2707,
        "name":"2707 (English Program)  :  Physic And Math | ฟิสิกส์และคณิตศาสตร์ | 物理和数学"
    },
    {
        "id":2708,
        "name":"2708 (English Program)  :  Physical Science | วิทยาศาสตร์กายภาพ | 物理科学"
    },
    {
        "id":2709,
        "name":"2709 (English Program)  :  Plant Virology | ไวรัสวิทยาพืช | 植物病毒学"
    },
    {
        "id":2710,
        "name":"2710 (English Program)  :  Quaternary Geology | ธรณีวิทยาควอเตอร์นารี | 第四纪地质"
    },
    {
        "id":2711,
        "name":"2711 (English Program)  :  Reading | การอ่าน | 阅读"
    },
    {
        "id":2712,
        "name":"2712 (English Program)  :  Second Language Education | การศึกษาภาษาที่สอง | 第二语言教育"
    },
    {
        "id":2713,
        "name":"2713 (English Program)  :  Soil Engineering | วิศวกรรมดิน | 土壤工程"
    },
    {
        "id":2714,
        "name":"2714 (English Program)  :  Soil Microbiology | จุลชีววิทยาของดิน | 土壤微生物学"
    },
    {
        "id":2715,
        "name":"2715 (English Program)  :  System Analysis, Control And Processing Information | การวิเคราะห์ระบบ การควบคุม และการประมวลผลข้อมูล | 系统分析、控制和处理信息"
    },
    {
        "id":2716,
        "name":"2716 (English Program)  :  Teaching English To Speakers Of Other Languages | การสอนภาษาอังกฤษแก่ผู้พูดภาษาอื่น | 向其他语言的人教授英语"
    },
    {
        "id":2717,
        "name":"2717 (English Program)  :  Teaching Of English As A Second Language | การสอนภาษาอังกฤษเป็นภาษาที่สอง | 英语作为第二语言的教学"
    },
    {
        "id":2718,
        "name":"2718 (English Program)  :  The Science And Engineering Of Materials | วิทยาศาสตร์และวิศวกรรมวัสดุ | 材料科学与工程"
    },
    {
        "id":2719,
        "name":"2719 (English Program)  :  Theoretical And Computational Chemistry | เคมีเชิงทฤษฎีและเชิงคำนวณ | 理论与计算化学"
    },
    {
        "id":2720,
        "name":"2720 (Thai Program)  :  Metal Mechanic | ช่างกลโลหะ | 金属机械师"
    },
    {
        "id":2721,
        "name":"2721 (Thai Program)  :  Civil Draftsman | ช่างเขียนแบบโยธา | 民事绘图员"
    },
    {
        "id":2722,
        "name":"2722 (Thai Program)  :  Mechanical Engineering Drafting Techniques | เทคนิคเขียนแบบวิศวกรรมเครื่องกล | 机械工程制图技术"
    },
    {
        "id":2723,
        "name":"2723 (Thai Program)  :  Textile Chemistry Techniques | เทคนิคเคมีสิ่งทอ | 纺织化学技术"
    },
    {
        "id":2724,
        "name":"2724 (Thai Program)  :  English Language And English Literature | ภาษาอังกฤษและวรรณคดีอังกฤษ | 英语语言和英国文学"
    },
    {
        "id":2725,
        "name":"2725 (Thai Program)  :  Science\/Health Education | วิทยาศาสตร์\/สุขศึกษา | 科学\/健康教育"
    },
    {
        "id":2726,
        "name":"2726 (Thai Program)  :  Structural Engineering | วิศวกรรมโครงสร้าง | 结构工程"
    },
    {
        "id":2727,
        "name":"2727 (Thai Program)  :  Automotive Industry | อุตสาหกรรมยานยนต์ | 汽车工业"
    },
    {
        "id":2728,
        "name":"2728 (English Program)  :  Home Economics For Community Development | เศรษฐศาสตร์บ้านเพื่อการพัฒนาชุมชน | 家庭经济促进社区发展"
    },
    {
        "id":2729,
        "name":"2729 (English Program)  :  Economics And Finance | เศรษฐศาสตร์และการเงิน | 经济与金融"
    },
    {
        "id":2730,
        "name":"2730 (English Program)  :  Education And English As A Second Language | การศึกษาและภาษาอังกฤษเป็นภาษาที่สอง | 教育和英语作为第二语言"
    },
    {
        "id":2731,
        "name":"2731 (English Program)  :  Electrical Engineering In Communications | วิศวกรรมไฟฟ้าสาขาการสื่อสาร | 通信电气工程"
    },
    {
        "id":2732,
        "name":"2732 (English Program)  :  Engineering Business Management Zwith Distinection | การจัดการธุรกิจทางวิศวกรรมที่มีความโดดเด่น | 工程商业管理 Zwith 荣誉"
    },
    {
        "id":2733,
        "name":"2733 (English Program)  :  Engineering In The Electrical Engineering | วิศวกรรมศาสตร์ในสาขาวิศวกรรมไฟฟ้า | 电气工程中的工程"
    },
    {
        "id":2734,
        "name":"2734 (English Program)  :  Film And Television Studies (Humanities) | การศึกษาภาพยนตร์และโทรทัศน์ (มนุษยศาสตร์) | 影视研究（人文）"
    },
    {
        "id":2735,
        "name":"2735 (English Program)  :  General | ทั่วไป | 一般的"
    },
    {
        "id":2736,
        "name":"2736 (English Program)  :  Geography | ภูมิศาสตร์ | 地理"
    },
    {
        "id":2737,
        "name":"2737 (English Program)  :  German Language And Literature | ภาษาเยอรมันและวรรณคดี | 德语语言和文学"
    },
    {
        "id":2738,
        "name":"2738 (English Program)  :  Hotel & Restaurant Management | การจัดการโรงแรมและร้านอาหาร | 酒店及餐厅管理"
    },
    {
        "id":2739,
        "name":"2739 (English Program)  :  Illustration | ภาพประกอบ | 插图"
    },
    {
        "id":2740,
        "name":"2740 (English Program)  :  Industrial Engineering And Management | วิศวกรรมอุตสาหการและการจัดการ | 工业工程与管理"
    },
    {
        "id":2741,
        "name":"2741 (English Program)  :  Instructional Media Technology | เทคโนโลยีสื่อการเรียนการสอน | 教学媒体技术"
    },
    {
        "id":2742,
        "name":"2742 (English Program)  :  Instructional Design And Technology | การออกแบบการเรียนการสอนและเทคโนโลยี | 教学设计和技术"
    },
    {
        "id":2743,
        "name":"2743 (English Program)  :  Integrated Marketing Communication | การสื่อสารการตลาดแบบบูรณาการ | 整合营销传播"
    },
    {
        "id":2744,
        "name":"2744 (English Program)  :  International Business\/Marketing | ธุรกิจระหว่างประเทศ\/การตลาด | 国际商务\/营销"
    },
    {
        "id":2745,
        "name":"2745 (English Program)  :  International Communication | การสื่อสารระหว่างประเทศ | 国际交流"
    },
    {
        "id":2746,
        "name":"2746 (English Program)  :  International Hotel Management | การจัดการโรงแรมระดับนานาชาติ | 国际酒店管理"
    },
    {
        "id":2747,
        "name":"2747 (English Program)  :  International Management | การจัดการระหว่างประเทศ | 国际管理"
    },
    {
        "id":2748,
        "name":"2748 (English Program)  :  Japanese Language Studies | การศึกษาภาษาญี่ปุ่น | 日语学习"
    },
    {
        "id":2749,
        "name":"2749 (English Program)  :  Japanese Liguistics And Literature | อักษรศาสตร์และวรรณคดีญี่ปุ่น | 日本语言学和文学"
    },
    {
        "id":2750,
        "name":"2750 (English Program)  :  Japanese Linguistics | ภาษาศาสตร์ภาษาญี่ปุ่น | 日语语言学"
    },
    {
        "id":2751,
        "name":"2751 (English Program)  :  Journalism Studies (Communication) | การศึกษาวารสารศาสตร์ (การสื่อสาร) | 新闻学（传播学）"
    },
    {
        "id":2752,
        "name":"2752 (English Program)  :  Language Arts Policy Studies | การศึกษานโยบายศิลปะภาษา | 语言艺术政策研究"
    },
    {
        "id":2753,
        "name":"2753 (English Program)  :  Languages And Cultures Of South East Asia And The Islands | ภาษาและวัฒนธรรมของเอเชียตะวันออกเฉียงใต้และหมู่เกาะต่างๆ | 东南亚和岛屿的语言和文化"
    },
    {
        "id":2754,
        "name":"2754 (English Program)  :  Laws In Banking Law And Financial Law | กฎหมายในกฎหมายการธนาคารและกฎหมายการเงิน | 银行法和金融法中的法律"
    },
    {
        "id":2755,
        "name":"2755 (English Program)  :  Leadership | ความเป็นผู้นำ | 领导"
    },
    {
        "id":2756,
        "name":"2756 (English Program)  :  Liberal Arts And Humanities | ศิลปศาสตร์และมนุษยศาสตร์ | 文科和人文学科"
    },
    {
        "id":2757,
        "name":"2757 (English Program)  :  Major Center For International Studies | ศูนย์การศึกษานานาชาติที่สำคัญ | 主要国际研究中心"
    },
    {
        "id":2758,
        "name":"2758 (English Program)  :  Management Communication | การสื่อสารการจัดการ | 管理沟通"
    },
    {
        "id":2759,
        "name":"2759 (English Program)  :  Management In Public Administration | การจัดการในการบริหารราชการ | 公共行政管理"
    },
    {
        "id":2760,
        "name":"2760 (Thai Program)  :  Management Information System | ระบบสารสนเทศเพื่อการจัดการ | 管理信息系统"
    },
    {
        "id":2761,
        "name":"2761 (English Program)  :  Manufacturing Engineering And Operations Management | วิศวกรรมการผลิตและการจัดการการดำเนินงาน | 制造工程和运营管理"
    },
    {
        "id":2762,
        "name":"2762 (English Program)  :  Marketing And Management | การตลาดและการจัดการ | 营销与管理"
    },
    {
        "id":2763,
        "name":"2763 (English Program)  :  Mass Communications | การสื่อสารมวลชน | 大众传播"
    },
    {
        "id":2764,
        "name":"2764 (English Program)  :  Mass Communicaton Research | การวิจัยการสื่อสารมวลชน | 大众传播研究"
    },
    {
        "id":2765,
        "name":"2765 (English Program)  :  Master Of Arts In English Language Studies And Methods | ศิลปศาสตรมหาบัณฑิตในการศึกษาภาษาอังกฤษและวิธีการ | 英语语言研究与方法文学硕士"
    },
    {
        "id":2766,
        "name":"2766 (English Program)  :  Media And Communication | สื่อและการสื่อสาร | 媒体与传播"
    },
    {
        "id":2767,
        "name":"2767 (English Program)  :  Mobile Satellite Communication | การสื่อสารผ่านดาวเทียมเคลื่อนที่ | 移动卫星通信"
    },
    {
        "id":2768,
        "name":"2768 (English Program)  :  Modern Chinese | จีนสมัยใหม่ | 现代汉语"
    },
    {
        "id":2769,
        "name":"2769 (English Program)  :  Multimedia Communication | การสื่อสารมัลติมีเดีย | 多媒体通讯"
    },
    {
        "id":2770,
        "name":"2770 (English Program)  :  Philosophy In Information Systems | ปรัชญาในระบบสารสนเทศ | 信息系统哲学"
    },
    {
        "id":2771,
        "name":"2771 (English Program)  :  Policy And Management | นโยบายและการจัดการ | 政策与管理"
    },
    {
        "id":2772,
        "name":"2772 (English Program)  :  Post-Harvest And Food Process Engineering | วิศวกรรมหลังการเก็บเกี่ยวและกระบวนการอาหาร | 收获后和食品加工工程"
    },
    {
        "id":2773,
        "name":"2773 (English Program)  :  Production And Operations Management | การจัดการการผลิตและการปฏิบัติการ | 生产运营管理"
    },
    {
        "id":2774,
        "name":"2774 (English Program)  :  Remote Sensing And Geographic Information Systems | การรับรู้ระยะไกลและระบบสารสนเทศทางภูมิศาสตร์ | 遥感和地理信息系统"
    },
    {
        "id":2775,
        "name":"2775 (Thai Program)  :  Teaching English As A Second Language | การสอนภาษาอังกฤษเป็นภาษาที่สอง | 英语作为第二语言教学"
    },
    {
        "id":2776,
        "name":"2776 (English Program)  :  Teaching Japanese As A Second Language | การสอนภาษาญี่ปุ่นเป็นภาษาที่สอง | 日语作为第二语言教学"
    },
    {
        "id":2777,
        "name":"2777 (English Program)  :  Teching English | ภาษาอังกฤษทางเทคนิค | 技术英语"
    },
    {
        "id":2778,
        "name":"2778 (English Program)  :  Technical Communication & Information Design | การสื่อสารทางเทคนิคและการออกแบบข้อมูล | 技术交流和信息设计"
    },
    {
        "id":2779,
        "name":"2779 (English Program)  :  Account Information System | ระบบข้อมูลบัญชี | 账户信息系统"
    },
    {
        "id":2780,
        "name":"2780 (English Program)  :  Accounting, Mis, Economics | การบัญชี, Mis, เศรษฐศาสตร์ | 会计、管理信息系统、经济学"
    },
    {
        "id":2781,
        "name":"2781 (English Program)  :  Applied Statistic And Research Method:Measurement | สถิติประยุกต์และวิธีการวิจัย: การวัด | 应用统计和研究方法：测量"
    },
    {
        "id":2782,
        "name":"2782 (English Program)  :  Arts Department Of Literature | สาขาวิชาวรรณคดี | 文学艺术系"
    },
    {
        "id":2783,
        "name":"2783 (English Program)  :  Chinese Language And Chinese Alphabet | ภาษาจีนและตัวอักษรจีน | 汉语和汉语拼音"
    },
    {
        "id":2784,
        "name":"2784 (English Program)  :  Chinese Language And Philology | ภาษาจีนและปรัชญา | 汉语言文字学"
    },
    {
        "id":2785,
        "name":"2785 (English Program)  :  Chinese Linguistics & Literature | ภาษาศาสตร์และวรรณคดีจีน | 中国语言学与文学"
    },
    {
        "id":2786,
        "name":"2786 (English Program)  :  Commerce In Business | การค้าขายในธุรกิจ | 商业中的商业"
    },
    {
        "id":2787,
        "name":"2787 (English Program)  :  Comparative Culture | วัฒนธรรมเปรียบเทียบ | 比较文化"
    },
    {
        "id":2788,
        "name":"2788 (English Program)  :  Computer Integrated Manufacturing | การผลิตแบบครบวงจรด้วยคอมพิวเตอร์ | 计算机集成制造"
    },
    {
        "id":2789,
        "name":"2789 (English Program)  :  Computer Science And Technology | วิทยาศาสตร์คอมพิวเตอร์และเทคโนโลยี | 计算机科学与技术"
    },
    {
        "id":2790,
        "name":"2790 (English Program)  :  Coomunication Education | การศึกษาด้านการสื่อสาร | 通讯教育"
    },
    {
        "id":2791,
        "name":"2791 (English Program)  :  E-Commerce | อีคอมเมิร์ซ | 电子商务"
    },
    {
        "id":2792,
        "name":"2792 (Thai Program)  :  Financial And Banking Laws | กฎหมายด้านการเงินการธนาคาร | 金融和银行法"
    },
    {
        "id":2793,
        "name":"2793 (Thai Program)  :  Intellectual Law | กฎหมายทางปัญญา | 智力法"
    },
    {
        "id":2794,
        "name":"2794 (Thai Program)  :  Public International Law | กฎหมายระหว่างประเทศ ภาคมหาชน | 国际公法"
    },
    {
        "id":2795,
        "name":"2795 (Thai Program)  :  Traffic And Transportation | การจราจรและการขนส่ง | 交通运输"
    },
    {
        "id":2796,
        "name":"2796 (Thai Program)  :  Financial Management | การจัดการด้านการเงิน | 财务管理"
    },
    {
        "id":2797,
        "name":"2797 (Thai Program)  :  Information And Systems Management | การจัดการสารสนเทศและระบบ | 信息和系统管理"
    },
    {
        "id":2798,
        "name":"2798 (Thai Program)  :  Financial Accounting | การบัญชีการเงิน | 财务会计"
    },
    {
        "id":2799,
        "name":"2799 (Thai Program)  :  Cost Accounting | การบัญชีต้นทุน | 成本会计"
    },
    {
        "id":2800,
        "name":"2800 (Thai Program)  :  General Accounting | การบัญชีทั่วไป | 一般会计"
    },
    {
        "id":2801,
        "name":"2801 (Thai Program)  :  Accounting For Planning And Control | การบัญชีเพื่อการวางแผนและควบคุม | 计划和控制会计"
    },
    {
        "id":2802,
        "name":"2802 (Thai Program)  :  Sports Training And Management | การฝึกและการจัดการกีฬา | 体育训练与管理"
    },
    {
        "id":2803,
        "name":"2803 (Thai Program)  :  Computer Science | คอมพิวเตอร์ศาสตร์ | 计算机科学"
    },
    {
        "id":2804,
        "name":"2804 (Thai Program)  :  Guidance And Counseling Psychology | จิตวิทยาการแนะแนวและให้คำปรึกษา | 指导与咨询心理学"
    },
    {
        "id":2805,
        "name":"2805 (Thai Program)  :  Guidance Psychology | จิตวิทยาแนะแนว | 辅导心理学"
    },
    {
        "id":2806,
        "name":"2806 (Thai Program)  :  Electronics Technician | ช่างอิเล็คทรอนิกส์ | 电子技术员"
    },
    {
        "id":2807,
        "name":"2807 (Thai Program)  :  Food Technology | เทคโนโลยีทางการอาหาร | 食品技术"
    },
    {
        "id":2808,
        "name":"2808 (Thai Program)  :  Construction Industry Technology | เทคโนโลยีอุตสาหกรรมการก่อสร้าง | 建筑行业技术"
    },
    {
        "id":2809,
        "name":"2809 (Thai Program)  :  Telecommunications | โทรคมนาคม | 电信"
    },
    {
        "id":2810,
        "name":"2810 (Thai Program)  :  Jurisprudence, Field Of International Law | นิติศาสตร์ แขนงวิชากฎหมายระหว่างประเทศ | 法理学、国际法领域"
    },
    {
        "id":2811,
        "name":"2811 (Thai Program)  :  Communication Arts, Advertising | นิเทศศาสตร์ การโฆษณา | 传播艺术、广告"
    },
    {
        "id":2812,
        "name":"2812 (Thai Program)  :  Librarian | บรรณารักษ์ | 图书管理员"
    },
    {
        "id":2813,
        "name":"2813 (Thai Program)  :  Human Resource Management | บริหารทรัพยากรมนุษย์ | 人力资源管理"
    },
    {
        "id":2814,
        "name":"2814 (Thai Program)  :  General Administration | บริหารทั่วไป | 一般行政管理"
    },
    {
        "id":2815,
        "name":"2815 (Thai Program)  :  International Business Administration | บริหารธุรกิจระหว่างประเทศ | 国际工商管理"
    },
    {
        "id":2816,
        "name":"2816 (Thai Program)  :  Management Accounting | บัญชีบริหาร | 管理会计"
    },
    {
        "id":2817,
        "name":"2817 (Thai Program)  :  Management Accounting | บัญชีเพื่อการจัดการ | 管理会计"
    },
    {
        "id":2818,
        "name":"2818 (Thai Program)  :  Personnel | บุคลากร | 人员"
    },
    {
        "id":2819,
        "name":"2819 (Thai Program)  :  Population And Development(Population And Workforce Planning) | ประชากรและการพัฒนา(ประชากรและการวางแผนกำลังคน) | 人口与发展（人口与劳动力规划）"
    },
    {
        "id":2820,
        "name":"2820 (Thai Program)  :  Comparative Religious Philosophy | ปรัชญาศาสนาเปรียบเทียบ | 比较宗教哲学"
    },
    {
        "id":2821,
        "name":"2821 (Thai Program)  :  Communication Arts (Journalism) | นิเทศศาสตร์ (วารสารศาสตร์) | 传播艺术（新闻学）"
    },
    {
        "id":2822,
        "name":"2822 (Thai Program)  :  Economic Development-Financial Economics | พัฒนาการเศรษฐกิจ-เศรษฐศาสตร์การเงิน | 经济发展-金融经济学"
    },
    {
        "id":2823,
        "name":"2823 (Thai Program)  :  Economic Development-Project Analysis And Evaluation | พัฒนาการเศรษฐกิจ-วิเคราะห์และประเมินโครงการ | 经济发展-项目分析与评价"
    },
    {
        "id":2824,
        "name":"2824 (Thai Program)  :  Economic Development-International Economy | พัฒนาการเศรษฐกิจ-เศรษฐกิจระหว่างประเทศ | 经济发展-国际经济"
    },
    {
        "id":2825,
        "name":"2825 (Thai Program)  :  Economic Development-International Economics | พัฒนาการเศรษฐกิจ-เศรษฐศาสตร์ระหว่างประเทศ | 经济发展-国际经济学"
    },
    {
        "id":2826,
        "name":"2826 (Thai Program)  :  Educational Museum | พิพิธภัณฑ์ศึกษา | 教育博物馆"
    },
    {
        "id":2827,
        "name":"2827 (Thai Program)  :  Language And Culture For Communication | ภาษาและวัฒนธรรมเพื่อการสื่อสาร | 沟通的语言和文化"
    },
    {
        "id":2828,
        "name":"2828 (Thai Program)  :  Applied Linguistics (English Teaching) | ภาษาศาสตร์ประยุกต์ (ด้านการสอนภาษาอังกฤษ) | 应用语言学（英语教学）"
    },
    {
        "id":2829,
        "name":"2829 (Thai Program)  :  Control Systems And Measuring Instruments | ระบบควบคุมและเครื่องมือวัด | 控制系统和测量仪器"
    },
    {
        "id":2830,
        "name":"2830 (Thai Program)  :  Chinese Literature | วรรณคดีจีน | 中国文学"
    },
    {
        "id":2831,
        "name":"2831 (Thai Program)  :  Analyze And Evaluate Projects | วิเคราะห์และประเมินโครงการ | 分析和评估项目"
    },
    {
        "id":2832,
        "name":"2832 (Thai Program)  :  Science-Mathematics | วิทยาศาสตร์-คณิตศาสตร์ | 科学数学"
    },
    {
        "id":2833,
        "name":"2833 (Thai Program)  :  Fine Arts (Design, Commercial Arts) | ศิลปกรรม (ออกแบบพาณิชย์ศิลป์) | 美术（设计、商业艺术）"
    },
    {
        "id":2834,
        "name":"2834 (Thai Program)  :  Communication Arts | ศิลปะการสื่อสารฯ | 传播艺术"
    },
    {
        "id":2835,
        "name":"2835 (Thai Program)  :  Educational Science-Teaching | ศึกษาศาสตร์-การสอน | 教育科学教学"
    },
    {
        "id":2836,
        "name":"2836 (Thai Program)  :  International Economy, Finance | เศรษฐกิจระหว่างประเทศ, การเงิน | 国际经济、金融"
    },
    {
        "id":2837,
        "name":"2837 (Thai Program)  :  International Trade Economics | เศรษฐศาสตร์การค้าระหว่างประเทศ | 国际贸易经济学"
    },
    {
        "id":2838,
        "name":"2838 (Thai Program)  :  Development Economics And International Economics | เศรษฐศาสตร์การพัฒนาและเศรษฐศาสตร์ระหว่างประเทศ | 发展经济学和国际经济学"
    },
    {
        "id":2839,
        "name":"2839 (Thai Program)  :  English-French | อังกฤษ-ฝรั่งเศส | 英语-法语"
    },
    {
        "id":2840,
        "name":"2840 (English Program)  :  Acoustics | อะคูสติก | 声学"
    },
    {
        "id":2841,
        "name":"2841 (English Program)  :  Administration Of Justice | การบริหารงานยุติธรรม | 司法行政"
    },
    {
        "id":2842,
        "name":"2842 (English Program)  :  Administrative Leadership | ความเป็นผู้นำด้านการบริหาร | 行政领导"
    },
    {
        "id":2843,
        "name":"2843 (English Program)  :  Adult And Continuting Education | การศึกษาสำหรับผู้ใหญ่และต่อเนื่อง | 成人和继续教育"
    },
    {
        "id":2844,
        "name":"2844 (English Program)  :  Advanced Architectural Studies | การศึกษาสถาปัตยกรรมขั้นสูง | 高级建筑研究"
    },
    {
        "id":2845,
        "name":"2845 (English Program)  :  Agrarian Studies | การศึกษาเกษตรกรรม | 土地研究"
    },
    {
        "id":2846,
        "name":"2846 (English Program)  :  Agriculture And Forest Technology | การเกษตรและเทคโนโลยีป่าไม้ | 农业和森林技术"
    },
    {
        "id":2847,
        "name":"2847 (English Program)  :  Agronomy (Soil Science) | พืชไร่ (วิทยาศาสตร์ดิน) | 农学（土壤科学）"
    },
    {
        "id":2848,
        "name":"2848 (English Program)  :  American Literature | วรรณกรรมอเมริกัน | 美国文学"
    },
    {
        "id":2849,
        "name":"2850 (English Program)  :  Appied Mathematics | คณิตศาสตร์ประยุกต์ | 应用数学"
    },
    {
        "id":2850,
        "name":"2851 (English Program)  :  Architectural Engineering | วิศวกรรมสถาปัตยกรรม | 建筑工程"
    },
    {
        "id":2851,
        "name":"2852 (English Program)  :  Argricultural And Rural Development | การพัฒนาทางการเกษตรและชนบท | 农业农村发展"
    },
    {
        "id":2852,
        "name":"2853 (English Program)  :  Biological Mechanisms And Function | กลไกและหน้าที่ทางชีวภาพ | 生物学机制和功能"
    },
    {
        "id":2853,
        "name":"2854 (English Program)  :  Biology (Protozoology) | ชีววิทยา (โปรโตสัตววิทยา) | 生物学（原生动物学）"
    },
    {
        "id":2854,
        "name":"2855 (English Program)  :  Botany\/Plant Taxonomy | อนุกรมวิธานพฤกษศาสตร์\/พืช | 植物学\/植物分类学"
    },
    {
        "id":2855,
        "name":"2856 (English Program)  :  Building Performence And Diagnostics | การสร้างประสิทธิภาพและการวินิจฉัย | 构建性能和诊断"
    },
    {
        "id":2856,
        "name":"2857 (English Program)  :  Ceramic | เซรามิค | 陶瓷制品"
    },
    {
        "id":2857,
        "name":"2858 (English Program)  :  Child Clinical Psychology | จิตวิทยาคลินิกเด็ก | 儿童临床心理学"
    },
    {
        "id":2858,
        "name":"2859 (English Program)  :  Clinical Biochemistry | ชีวเคมีคลินิก | 临床生物化学"
    },
    {
        "id":2859,
        "name":"2860 (English Program)  :  Computing And Information Science | วิทยาศาสตร์คอมพิวเตอร์และสารสนเทศ | 计算与信息科学"
    },
    {
        "id":2860,
        "name":"2861 (English Program)  :  Computer | คอมพิวเตอร์ | 电脑"
    },
    {
        "id":2861,
        "name":"2862 (English Program)  :  Construction\/Structural Engineering | การก่อสร้าง\/วิศวกรรมโครงสร้าง | 建筑\/结构工程"
    },
    {
        "id":2862,
        "name":"2863 (English Program)  :  Computer And Information Technology | คอมพิวเตอร์และเทคโนโลยีสารสนเทศ | 计算机与信息技术"
    },
    {
        "id":2863,
        "name":"2864 (English Program)  :  Division Of Sciences And Engineering | สาขาวิชาวิทยาศาสตร์และวิศวกรรมศาสตร์ | 科学与工程部"
    },
    {
        "id":2864,
        "name":"2865 (English Program)  :  Education Supervision | การกำกับดูแลการศึกษา | 教育督导"
    },
    {
        "id":2865,
        "name":"2866 (English Program)  :  Educational And Counseling Psychology | จิตวิทยาการศึกษาและการให้คำปรึกษา | 教育和咨询心理学"
    },
    {
        "id":2866,
        "name":"2867 (English Program)  :  Energy Chimistry | เคมีวิทยาพลังงาน | 能源化学"
    },
    {
        "id":2867,
        "name":"2868 (English Program)  :  Environmental Technology And Management | เทคโนโลยีและการจัดการสิ่งแวดล้อม | 环境技术与管理"
    },
    {
        "id":2868,
        "name":"2869 (English Program)  :  Environmental Design In Architecture | การออกแบบสิ่งแวดล้อมในสถาปัตยกรรม | 建筑环境设计"
    },
    {
        "id":2869,
        "name":"2870 (English Program)  :  Etudes De L'Extreme-Orient | การศึกษาตะวันออกไกล | 极端东方练习曲"
    },
    {
        "id":2870,
        "name":"2871 (English Program)  :  Genral Curriculum & Instruction | หลักสูตรทั่วไปและการสอน | 一般课程和指导"
    },
    {
        "id":2871,
        "name":"2872 (English Program)  :  Western Vocal Music | ดนตรีเสียงตะวันตก | 西方声乐"
    },
    {
        "id":2872,
        "name":"2873 (English Program)  :  Histoire De L' Art Et De L' Archeclogie | ประวัติศาสตร์ศิลปะและโบราณคดี | 艺术与考古史"
    },
    {
        "id":2873,
        "name":"2874 (English Program)  :  Histoire Et Semiology Du Texte Et De L' Image | ประวัติและสัญวิทยาของข้อความและภาพ | 文本与图像的历史与符号学"
    },
    {
        "id":2874,
        "name":"2875 (English Program)  :  History Of Art, Southeast Asian Art | ประวัติศาสตร์ศิลปะ ศิลปะเอเชียตะวันออกเฉียงใต้ | 艺术史、东南亚艺术"
    },
    {
        "id":2875,
        "name":"2876 (English Program)  :  Thai Vocal Music | ดนตรีไทย | 泰国声乐"
    },
    {
        "id":2876,
        "name":"2877 (English Program)  :  Rehabilitation Service For Persons With Disabilities | บริการฟื้นฟูสมรรถภาพสำหรับคนพิการ | 残疾人康复服务"
    },
    {
        "id":2877,
        "name":"2878 (English Program)  :  Human Resource Management And Coaching | การจัดการทรัพยากรมนุษย์และการฝึกสอน | 人力资源管理和辅导"
    },
    {
        "id":2878,
        "name":"2879 (English Program)  :  Industrial Design Studios | สตูดิโอออกแบบอุตสาหกรรม | 工业设计工作室"
    },
    {
        "id":2879,
        "name":"2880 (English Program)  :  General Information Work | งานข้อมูลทั่วไป | 一般信息工作"
    },
    {
        "id":2880,
        "name":"2881 (English Program)  :  Instrument | อุปกรณ์ | 乐器"
    },
    {
        "id":2881,
        "name":"2882 (English Program)  :  Japanese Language Education | การศึกษาภาษาญี่ปุ่น | 日语教育"
    },
    {
        "id":2882,
        "name":"2883 (English Program)  :  Japanese Literature | วรรณคดีญี่ปุ่น | 日本文学"
    },
    {
        "id":2883,
        "name":"2884 (English Program)  :  Jewellery Art & Design | ศิลปะและการออกแบบเครื่องประดับ | 珠宝艺术与设计"
    },
    {
        "id":2884,
        "name":"2885 (English Program)  :  Labor And Development | แรงงานและการพัฒนา | 劳工与发展"
    },
    {
        "id":2885,
        "name":"2886 (English Program)  :  Lettres Modernes | ตัวอักษรสมัยใหม่ | 现代文学"
    },
    {
        "id":2886,
        "name":"2887 (English Program)  :  Linguistique Applique | ภาษาศาสตร์ประยุกต์ | 语言贴花"
    },
    {
        "id":2887,
        "name":"2888 (English Program)  :  Litteratures Et Societes | วรรณคดีและสังคม | 文学与社团"
    },
    {
        "id":2888,
        "name":"2889 (English Program)  :  Littrature Francaise | วรรณคดีฝรั่งเศส | 法国文学"
    },
    {
        "id":2889,
        "name":"2890 (English Program)  :  Medicinal Chemistry | เคมีการแพทย์ | 药物化学"
    },
    {
        "id":2890,
        "name":"2891 (English Program)  :  Molecular And Cell Biology | ชีววิทยาระดับโมเลกุลและเซลล์ | 分子和细胞生物学"
    },
    {
        "id":2891,
        "name":"2892 (English Program)  :  Organo - Metalic Chemistry | ออร์กาโน - เคมีโลหะ | 有机-金属化学"
    },
    {
        "id":2892,
        "name":"2893 (English Program)  :  Office Information Work | งานข้อมูลสำนักงาน | 办公室信息工作"
    },
    {
        "id":2893,
        "name":"2894 (English Program)  :  Office Work | งานสำนักงาน | 办公室工作"
    },
    {
        "id":2894,
        "name":"2895 (English Program)  :  Pharmacokinetics | เภสัชจลนศาสตร์ | 药代动力学"
    },
    {
        "id":2895,
        "name":"2896 (English Program)  :  Physical Pharmacy | เภสัชกายภาพ | 物理药剂"
    },
    {
        "id":2896,
        "name":"2897 (English Program)  :  Physicochimie Des Materiaux | ฟิสิกส์เคมีของวัสดุ | 材料物理化学"
    },
    {
        "id":2897,
        "name":"2898 (English Program)  :  Piano | เปียโน | 钢琴"
    },
    {
        "id":2898,
        "name":"2899 (English Program)  :  Planning | การวางแผน | 规划"
    },
    {
        "id":2899,
        "name":"2900 (English Program)  :  Politics And Development Strategies | การเมืองและยุทธศาสตร์การพัฒนา | 政治与发展战略"
    },
    {
        "id":2900,
        "name":"2901 (English Program)  :  Polymer | โพลีเมอร์ | 聚合物"
    },
    {
        "id":2901,
        "name":"2902 (English Program)  :  Reading And Language Studies | การอ่านและการศึกษาภาษา | 阅读和语言学习"
    },
    {
        "id":2902,
        "name":"2903 (English Program)  :  Salar Energy | พลังงานซาลาร์ | 萨拉能源"
    },
    {
        "id":2903,
        "name":"2904 (English Program)  :  Sanskit - Thai Literature | สันสกฤต - วรรณคดีไทย | Sanskit - 泰国文学"
    },
    {
        "id":2904,
        "name":"2905 (English Program)  :  School Guidance & Counseling | การแนะแนวโรงเรียนและการให้คำปรึกษา | 学校指导和咨询"
    },
    {
        "id":2905,
        "name":"2906 (English Program)  :  Solid State Physics | ฟิสิกส์สถานะของแข็ง | 固态物理"
    },
    {
        "id":2906,
        "name":"2907 (English Program)  :  Theory And Composition | ทฤษฎีและองค์ประกอบ | 理论与构成"
    },
    {
        "id":2907,
        "name":"2908 (English Program)  :  Toursium Planning And Development | การวางแผนและการพัฒนาทัวร์เซียม | 旅游规划与开发"
    },
    {
        "id":2908,
        "name":"2909 (English Program)  :  Urban Technology And Environmental Planning | เทคโนโลยีเมืองและการวางแผนสิ่งแวดล้อม | 城市技术与环境规划"
    },
    {
        "id":2909,
        "name":"2910 (English Program)  :  Violin | ไวโอลิน | 小提琴"
    },
    {
        "id":2910,
        "name":"2911 (Thai Program)  :  Civil Drafting | การเขียนแบบโยธา | 民事起草"
    },
    {
        "id":2911,
        "name":"2912 (Thai Program)  :  International Management | การจัดการระหว่างประเทศ | 国际化管理"
    },
    {
        "id":2912,
        "name":"2913 (Thai Program)  :  Resource Management And Conservation | การจัดการและการอนุรักษ์ทรัพยากร | 资源管理和保护"
    },
    {
        "id":2913,
        "name":"2914 (Thai Program)  :  Business Administration And Management | การบริหารธุรกิจและการจัดการ | 工商管理"
    },
    {
        "id":2914,
        "name":"2915 (Thai Program)  :  Network Administration | การบริหารระบบเครือข่าย | 网络管理"
    },
    {
        "id":2915,
        "name":"2916 (Thai Program)  :  Commercial Art Design | การออกแบบพาณิชยศิลป์ | 商业艺术设计"
    },
    {
        "id":2916,
        "name":"2917 (Thai Program)  :  Housing Material Design And Production | การออกแบบและผลิตวัสดุตัวเรือน | 外壳材料设计与生产"
    },
    {
        "id":2917,
        "name":"2918 (Thai Program)  :  Architectural Design | การออกแบบสถาปัตยกรรม | 建筑设计"
    },
    {
        "id":2918,
        "name":"2919 (Thai Program)  :  Textile Design | การออกแบบสิ่งทอ | 纺织品设计"
    },
    {
        "id":2919,
        "name":"2920 (Thai Program)  :  Pottery Artist | ช่างเคลือบดินเผา | 陶艺家"
    },
    {
        "id":2920,
        "name":"2921 (Thai Program)  :  Welder And Solder | ช่างเชื่อมและประสาน | 焊工和焊锡"
    },
    {
        "id":2921,
        "name":"2922 (Thai Program)  :  Harvesting Technology | เทคโนโลยีการเก็บเกี่ยว | 收获技术"
    },
    {
        "id":2922,
        "name":"2923 (Thai Program)  :  Technology And Innovation | เทคโนโลยีและนวัตกรรม | 技术与创新"
    },
    {
        "id":2923,
        "name":"2924 (Thai Program)  :  Agricultural Industry Technology | เทคโนโลยีอุตสาหกรรมการเกษตร | 农业产业技术"
    },
    {
        "id":2924,
        "name":"2925 (Thai Program)  :  Industrial-Electronic Technology | เทคโนโลยีอุตสาหกรรม-อิเลคทรอนิกส์ | 工业电子技术"
    },
    {
        "id":2925,
        "name":"2926 (Thai Program)  :  Social Policy And Planning | นโยบายและการวางแผนทางสังคม | 社会政策和规划"
    },
    {
        "id":2926,
        "name":"2927 (Thai Program)  :  Public Policy And Personnel Management | นโยบายสาธารณะและการบริหารงานบุคคล | 公共政策和人事管理"
    },
    {
        "id":2927,
        "name":"2928 (Thai Program)  :  Dance | นาฏยศาสตร์ | 舞蹈"
    },
    {
        "id":2928,
        "name":"2929 (Thai Program)  :  Eastern History | ประวัติศาสตร์ตะวันออก | 东方历史"
    },
    {
        "id":2929,
        "name":"2930 (Thai Program)  :  Medieval Indian History | ประวัติศาสตร์อินเดียสมัยกลาง | 中世纪印度历史"
    },
    {
        "id":2930,
        "name":"2931 (Thai Program)  :  Southeast Asian History | ประวัติศาสตร์เอเซียอาคเนย์ | 东南亚历史"
    },
    {
        "id":2931,
        "name":"2932 (Thai Program)  :  Process Agricultural Products | แปรรูปผลิตภัณฑ์การเกษตร | 加工农产品"
    },
    {
        "id":2932,
        "name":"2933 (Thai Program)  :  Current France And France And The European Union | ฝรั่งเศสปัจจุบันและฝรั่งเศสกับสหภาพยุโรป | 当前的法国和法国与欧盟"
    },
    {
        "id":2933,
        "name":"2934 (Thai Program)  :  Educational Development | พัฒนาศึกษาศาสตร์ | 教育发展"
    },
    {
        "id":2934,
        "name":"2935 (Thai Program)  :  Literature | วรรณคดี | 文学"
    },
    {
        "id":2935,
        "name":"2936 (Thai Program)  :  American Literature | วรรณคดีอเมริกัน | 美国文学"
    },
    {
        "id":2936,
        "name":"2937 (Thai Program)  :  Aesthetics | สุนทรียศาสตร์ | 美学"
    },
    {
        "id":2937,
        "name":"2938 (Thai Program)  :  Organic Chemistry | อินทรีย์เคมี | 有机化学"
    },
    {
        "id":2938,
        "name":"2939 (Thai Program)  :  Labor And Welfare Development | พัฒนาแรงงานและสวัสดิการ | 劳工及福利发展"
    },
    {
        "id":2939,
        "name":"2940 (Thai Program)  :  Health Management Technology | เทคโนโลยีการจัดการสุขภาพ | 健康管理技术"
    },
    {
        "id":2940,
        "name":"2941 (Thai Program)  :  Agricultural Management Technology | เทคโนโลยีการจัดการการเกษตร | 农业管理技术"
    },
    {
        "id":2941,
        "name":"2942 (English Program)  :  Biblical Studies | การศึกษาพระคัมภีร์ | 圣经研究"
    },
    {
        "id":2942,
        "name":"2943 (English Program)  :  Linguistics And English As A Foreign Language | ภาษาศาสตร์และภาษาอังกฤษเป็นภาษาต่างประเทศ | 语言学和英语作为外语"
    },
    {
        "id":2943,
        "name":"2944 (English Program)  :  Applied Computer Science And Technology Telecommunications | วิทยาศาสตร์คอมพิวเตอร์ประยุกต์และเทคโนโลยีโทรคมนาคม | 应用计算机科学与技术 电信"
    },
    {
        "id":2944,
        "name":"2945 (English Program)  :  Bioorganic Chemistry | เคมีชีวภาพ | 生物有机化学"
    },
    {
        "id":2945,
        "name":"2946 (English Program)  :  Creation And Leadership Of Ner Enterprises | การสร้างและความเป็นผู้นำขององค์กร Ner | Ner企业的创建和领导"
    },
    {
        "id":2946,
        "name":"2947 (English Program)  :  Environmental And Natural Resources Law And Policy | กฎหมายและนโยบายสิ่งแวดล้อมและทรัพยากรธรรมชาติ | 环境和自然资源法律和政策"
    },
    {
        "id":2947,
        "name":"2948 (English Program)  :  Finance And Marketing | การเงินและการตลาด | 财务和营销"
    },
    {
        "id":2948,
        "name":"2949 (English Program)  :  Genetics And Developmental Biology | พันธุศาสตร์และชีววิทยาพัฒนาการ | 遗传学和发育生物学"
    },
    {
        "id":2949,
        "name":"2950 (English Program)  :  Human And Cultural Studies | การศึกษามนุษย์และวัฒนธรรม | 人类与文化研究"
    },
    {
        "id":2950,
        "name":"2951 (Thai Program)  :  Science And Technology Management | การจัดการวิทยาศาสตร์และเทคโนโลยี | 科技管理"
    },
    {
        "id":2951,
        "name":"2952 (English Program)  :  Civil Engineering (Structures) | วิศวกรรมโยธา (โครงสร้าง) | 土木工程（结构）"
    },
    {
        "id":2952,
        "name":"2953 (English Program)  :  Curriculum Studies | หลักสูตรการศึกษา | 课程研究"
    },
    {
        "id":2953,
        "name":"2954 (English Program)  :  Finance And Accounting | การเงินและการบัญชี | 财会"
    },
    {
        "id":2954,
        "name":"2955 (English Program)  :  Gene Science | ยีนวิทยาศาสตร์ | 基因科学"
    },
    {
        "id":2955,
        "name":"2956 (English Program)  :  India Language | ภาษาอินเดีย | 印度语言"
    },
    {
        "id":2956,
        "name":"2957 (English Program)  :  International Culture | วัฒนธรรมนานาชาติ | 国际文化"
    },
    {
        "id":2957,
        "name":"2958 (English Program)  :  International Environmental Law | กฎหมายสิ่งแวดล้อมระหว่างประเทศ | 国际环境法"
    },
    {
        "id":2958,
        "name":"2959 (English Program)  :  Linguistics And Applied Linguistics | ภาษาศาสตร์และภาษาศาสตร์ประยุกต์ | 语言学与应用语言学"
    },
    {
        "id":2959,
        "name":"2960 (English Program)  :  Logistics | โลจิสติกส์ | 后勤"
    },
    {
        "id":2960,
        "name":"2961 (English Program)  :  Management Economics | เศรษฐศาสตร์การจัดการ | 管理经济学"
    },
    {
        "id":2961,
        "name":"2962 (English Program)  :  Plant Nutrition | โภชนาการของพืช | 植物营养"
    },
    {
        "id":2962,
        "name":"2963 (English Program)  :  Psychobiology | จิตวิทยา | 心理生物学"
    },
    {
        "id":2963,
        "name":"2964 (English Program)  :  Political And Justice Studies | การศึกษาทางการเมืองและความยุติธรรม | 政治和司法研究"
    },
    {
        "id":2964,
        "name":"2965 (English Program)  :  Post Harvest Techology | เทคโนโลยีหลังการเก็บเกี่ยว | 收获后技术"
    },
    {
        "id":2965,
        "name":"2966 (English Program)  :  Pubic System Studies | การศึกษาระบบสาธารณะ | 公共系统研究"
    },
    {
        "id":2966,
        "name":"2967 (English Program)  :  Social And Political Thought | ความคิดทางสังคมและการเมือง | 社会和政治思想"
    },
    {
        "id":2967,
        "name":"2968 (English Program)  :  Tourism Planning And Development | การวางแผนและพัฒนาการท่องเที่ยว | 旅游规划与开发"
    },
    {
        "id":2968,
        "name":"2969 (English Program)  :  Training And Human Resources Development | การฝึกอบรมและการพัฒนาทรัพยากรมนุษย์ | 培训和人力资源开发"
    },
    {
        "id":2969,
        "name":"2970 (English Program)  :  Applied Science | วิทยาศาสตร์ประยุกต์ | 应用科学"
    },
    {
        "id":2970,
        "name":"2971 (Thai Program)  :  Exercise Science | วิทยาศาสตร์การออกกำลังกาย | 运动科学"
    },
    {
        "id":2971,
        "name":"2972 (Thai Program)  :  Musicology | ดนตรีวิทยา | 音乐学"
    },
    {
        "id":2972,
        "name":"2973 (Thai Program)  :  Radiation Therapy For The Nervous System | รังสีร่วมรักษาระบบประสาท | 神经系统放射治疗"
    },
    {
        "id":2973,
        "name":"2974 (Thai Program)  :  Addiction Science | วิทยาการเสพติด | 成瘾科学"
    },
    {
        "id":2974,
        "name":"2975 (Thai Program)  :  Plant Science | วิทยาการพืช | 植物科学"
    },
    {
        "id":2975,
        "name":"2976 (Thai Program)  :  Science And Technology Studies | วิทยาศาสตร์และเทคโนโลยีศึกษา | 科学技术研究"
    },
    {
        "id":2976,
        "name":"2977 (Thai Program)  :  Health Business Management | การจัดการธุรกิจสุขภาพ | 健康商业管理"
    },
    {
        "id":2977,
        "name":"2978 (Thai Program)  :  Computer Art And Design | คอมพิวเตอร์ศิลปะและการออกแบบ | 计算机艺术与设计"
    },
    {
        "id":2978,
        "name":"2979 (Thai Program)  :  Finance And Accounting | การเงินและการบัญชี | 财会"
    },
    {
        "id":2979,
        "name":"2980 (Thai Program)  :  Community Development And Administration | การพัฒนาและบริหารชุมชน | 社区发展和管理"
    },
    {
        "id":2980,
        "name":"2981 (English Program)  :  Opthalmology | จักษุวิทยา | 眼科"
    },
    {
        "id":2981,
        "name":"2982 (Thai Program)  :  Industrial Technology (Industrial Electrical Department) | เทคโนโลยีอุตสาหกรรม(แขนงวิชาไฟฟ้าอุตสาหกรรม) | 工业技术（工业电气系）"
    },
    {
        "id":2982,
        "name":"2983 (Thai Program)  :  Thai Language For Education | ภาษาไทยเพื่อการศึกษา | 泰语教育"
    },
    {
        "id":2983,
        "name":"2984 (Thai Program)  :  Security Management Innovation | นวัตกรรมการจัดการความมั่นคง | 安全管理创新"
    },
    {
        "id":2984,
        "name":"2985 (Thai Program)  :  Digital Business Entrepreneur | ผู้ประกอบการธุรกิจดิจิตอล | 数字商业企业家"
    },
    {
        "id":2985,
        "name":"2986 (Thai Program)  :  Industrial Technology (Industrial Computer Technology) | เทคโนโลยีอุตสาหกรรม(เทคโนโลยีคอมพิวเตอร์อุตสาหกรรม) | 工业技术（工业计算机技术）"
    },
    {
        "id":2986,
        "name":"2987 (Thai Program)  :  Industrial Technology (Architecture) | เทคโนโลยีอุตสาหกรรม(แขนงวิชาสถาปัตยกรรม) | 工业技术（建筑）"
    },
    {
        "id":2987,
        "name":"2988 (Thai Program)  :  Industrial Technology (Industrial Management Technology Branch) | เทคโนโลยีอุตสาหกรรม(แขนงเทคโนโลยีการจัดการอุตสาหกรรม) | 工业技术（工业管理技术分院）"
    },
    {
        "id":2988,
        "name":"2989 (Thai Program)  :  Environmental Science (General Environmental Subject) | วิทยาศาสตร์สิ่งแวดล้อม(แขนงวิชาสิ่งแวดล้อมทั่วไป) | 环境科学（普通环境学科）"
    },
    {
        "id":2989,
        "name":"2990 (Thai Program)  :  Health Sciences (Child Health Promotion) | วิทยาศาสตร์สุขภาพ(การส่งเสริมสุขภาพเด็ก) | 健康科学（儿童健康促进）"
    },
    {
        "id":2990,
        "name":"2991 (Thai Program)  :  Industrial Technology (Construction Technology) | เทคโนโลยีอุตสาหกรรม(แขนงวิชาเทคโนโลยีก่อสร้าง) | 工业技术（建筑技术）"
    },
    {
        "id":2991,
        "name":"2992 (Thai Program)  :  Music (Field Of International Music) | ดนตรี(แขนงวิชาดนตรีสากล) | 音乐（国际音乐领域）"
    },
    {
        "id":2992,
        "name":"2993 (Thai Program)  :  Innovation Management For Business Development | การจัดการนวัตกรรมเพื่อการพัฒนาธุรกิจ | 创新管理促进业务发展"
    },
    {
        "id":2993,
        "name":"2994 (Thai Program)  :  Regional Development Strategy | ยุทธศาสตร์การพัฒนาภูมิภาค | 区域发展战略"
    },
    {
        "id":2994,
        "name":"2995 (Thai Program)  :  Social Research And Development (Health Culture Field) | วิจัยและพัฒนาสังคม (แขนงวิชาวัฒนธรรมสุขภาพ) | 社会研究与发展（健康文化领域）"
    },
    {
        "id":2995,
        "name":"2996 (Thai Program)  :  Folk Medicine And Alternative Medicine | การแพทย์พื้นบ้านและการแพทย์ทางเลือก | 民间医学和替代医学"
    },
    {
        "id":2996,
        "name":"2997 (Thai Program)  :  Educational Research And Evaluation | การวิจัยและประเมินผลการศึกษา | 教育研究与评估"
    },
    {
        "id":2997,
        "name":"2998 (Thai Program)  :  Research And Development Of Traditional Thai Pharmaceuticals | การวิจัยและพัฒนาเภสัชกรรมแผนไทย | 泰国传统药物的研究与开发"
    },
    {
        "id":2998,
        "name":"2999 (Thai Program)  :  Maritime And International Trade Law | กฎหมายพาณิชยนาวีและการค้าระหว่างประเทศ | 海事和国际贸易法"
    },
    {
        "id":2999,
        "name":"3000 (Thai Program)  :  Tourism Sociology | สังคมวิทยาการท่องเที่ยว | 旅游社会学"
    },
    {
        "id":3000,
        "name":"3001 (Thai Program)  :  Cultural Resource Management | การจัดการทรัพยากรวัฒนธรรม | 文化资源管理"
    },
    {
        "id":3001,
        "name":"3002 (Thai Program)  :  Royal Goldsmith | ช่างทองหลวง | 皇家金匠"
    },
    {
        "id":3002,
        "name":"3003 (Thai Program)  :  Environmental Public Health | สาธารณสุขศาสตร์สิ่งแวดล้อม | 环境公共卫生"
    },
    {
        "id":3003,
        "name":"3004 (Thai Program)  :  Anatomy And Structural Biology | กายวิภาคศาสตร์และชีววิทยาโครงสร้าง | 解剖学和结构生物学"
    },
    {
        "id":3004,
        "name":"3005 (Thai Program)  :  Music And Performance | ดนตรีและการแสดง | 音乐与表演"
    },
    {
        "id":3005,
        "name":"3006 (Thai Program)  :  Technology | เทคโนโลยี | 技术"
    },
    {
        "id":3006,
        "name":"3007 (Thai Program)  :  Automotive Mechanic Techniques | เทคนิคช่างยนต์ | 汽车机械技术"
    },
    {
        "id":3007,
        "name":"3008 (Thai Program)  :  Knowledge Management | การจัดการความรู้ | 知识管理"
    },
    {
        "id":3008,
        "name":"3009 (Thai Program)  :  Media For Advertising And Marketing | สื่อเพื่อการโฆษณาและการตลาด | 广告和营销媒体"
    },
    {
        "id":3009,
        "name":"3010 (Thai Program)  :  Crop Protection | อารักขาพืช | 作物保护"
    },
    {
        "id":3010,
        "name":"3011 (Thai Program)  :  Teaching Thai Sign Language | การสอนภาษามือไทย | 泰语手语教学"
    },
    {
        "id":3011,
        "name":"3012 (Thai Program)  :  Infectious Diseases And Epidemiology | โรคติดเชื้อและวิทยาการระบาด | 传染病和流行病学"
    },
    {
        "id":3012,
        "name":"3013 (Thai Program)  :  Sustainable Environmental Planning | การวางแผนสิ่งแวดล้อมที่ยั่งยืน | 可持续环境规划"
    },
    {
        "id":3013,
        "name":"3014 (Thai Program)  :  Industrial And Environmental Ecology | นิเวศวิทยาอุตสาหกรรมและสิ่งแวดล้อม | 工业与环境生态学"
    },
    {
        "id":3014,
        "name":"3015 (Thai Program)  :  Natural Resource Management | การจัดการทรัพยากรธรรมชาติ | 自然资源管理"
    },
    {
        "id":3015,
        "name":"3016 (Thai Program)  :  Pharmaceutical Botany Science | วิทยาการพฤกษเภสัชภัณฑ์ | 药用植物学"
    },
    {
        "id":3016,
        "name":"3017 (Thai Program)  :  Maternal-Newborn Nursing And Women'S Health | การพยาบาลมารดา-ทารกแรกเกิดและสุขภาพสตรี | 母婴护理与妇女健康"
    },
    {
        "id":3017,
        "name":"3018 (Thai Program)  :  Maxillofacial Fabrication | การประดิษฐ์ใบหน้าขากรรไกร | 颌面制造"
    },
    {
        "id":3018,
        "name":"3019 (Thai Program)  :  Pediatric Dentistry | ทันตกรรมเด็ก | 儿童牙科"
    },
    {
        "id":3019,
        "name":"3020 (Thai Program)  :  Clinical Medicine | การแพทย์คลินิก | 临床医学"
    },
    {
        "id":3020,
        "name":"3021 (Thai Program)  :  Oral Rehabilitation | การฟื้นฟูสภาพช่องปาก | 口腔康复"
    },
    {
        "id":3021,
        "name":"3022 (Thai Program)  :  Prosthetic Dentistrydentistry Implants | ทันตกรรมประดิษฐ์ทันตกรรมรากเทียม | 假牙牙科植入物"
    },
    {
        "id":3022,
        "name":"3023 (English Program)  :  Food And Nutrition Toxicology | พิษวิทยาด้านอาหารและโภชนาการ | 食品和营养毒理学"
    },
    {
        "id":3023,
        "name":"3024 (Thai Program)  :  Otolaryngology And Laryngology | โสต ศอ นาสิก ลาริงซ์วิทยา | 耳鼻喉科和喉科"
    },
    {
        "id":3024,
        "name":"3025 (Thai Program)  :  Human Rights And Peace Studies | สิทธิมนุษยชนและสันติศึกษา | 人权与和平研究"
    },
    {
        "id":3025,
        "name":"3026 (Thai Program)  :  Tropical Internal Medicine And Hygiene | อายุรศาสตร์เขตร้อนและสุขวิทยา | 热带内科和卫生学"
    },
    {
        "id":3026,
        "name":"3027 (Thai Program)  :  Clinical Tropical Pediatrics | กุมารเวชศาสตร์เขตร้อนคลินิก | 临床热带儿科"
    },
    {
        "id":3027,
        "name":"3028 (Thai Program)  :  International Hotel Management | การจัดการการโรงแรมแบบสากล | 国际酒店管理"
    },
    {
        "id":3028,
        "name":"3029 (Thai Program)  :  Silpa Dance Music | ศิลปนาฎดุริยางค์ | 西尔帕舞曲"
    },
    {
        "id":3029,
        "name":"3030 (Thai Program)  :  Computer For Design | คอมพิวเตอร์เพื่อการออกแบบ | 计算机设计"
    },
    {
        "id":3030,
        "name":"3031 (English Program)  :  Anthropologie Sociale Et Ethnologie | มานุษยวิทยาสังคมและชาติพันธุ์วิทยา | 社会人类学与民族学"
    },
    {
        "id":3031,
        "name":"3032 (English Program)  :  English Language In Literary Studies With Distinction | ภาษาอังกฤษในการศึกษาวรรณกรรมที่มีความโดดเด่น | 文学研究中的英语语言表现出色"
    },
    {
        "id":3032,
        "name":"3033 (English Program)  :  Farm Animal Medicine And Production | ยาและการผลิตสัตว์ในฟาร์ม | 农场动物药物和生产"
    },
    {
        "id":3033,
        "name":"3034 (English Program)  :  Foreign And Second Language Education | การศึกษาภาษาต่างประเทศและภาษาที่สอง | 外语和第二语言教育"
    },
    {
        "id":3034,
        "name":"3035 (English Program)  :  In English And Applied Linguistics | ในภาษาอังกฤษและภาษาศาสตร์ประยุกต์ | 英语和应用语言学"
    },
    {
        "id":3035,
        "name":"3036 (English Program)  :  Inorganic And Materials Chemistry | เคมีอนินทรีย์และวัสดุ | 无机与材料化学"
    },
    {
        "id":3036,
        "name":"3037 (English Program)  :  Malay Language And Literature | ภาษามลายูและวรรณคดี | 马来语言和文学"
    },
    {
        "id":3037,
        "name":"3038 (English Program)  :  Media Technology For Teaching English As Foreign Language | เทคโนโลยีสื่อสำหรับการสอนภาษาอังกฤษเป็นภาษาต่างประเทศ | 英语作为外语教学的媒体技术"
    },
    {
        "id":3038,
        "name":"3039 (English Program)  :  Natural Resources | ทรัพยากรธรรมชาติ | 自然资源"
    },
    {
        "id":3039,
        "name":"3040 (English Program)  :  Traditional Malay Literature | วรรณกรรมมาเลย์แบบดั้งเดิม | 马来传统文学"
    },
    {
        "id":3040,
        "name":"3041 (Thai Program)  :  Law For Development | กฎหมายเพื่อการพัฒนา | 发展法"
    },
    {
        "id":3041,
        "name":"3042 (Thai Program)  :  Project Management | การบริหารโครงการ | 项目管理"
    },
    {
        "id":3042,
        "name":"3043 (Thai Program)  :  Secondary Education - Social Studies Teaching Methods | การมัธยมศึกษา-วิธีสอนสังคมศึกษา | 中等教育 - 社会研究教学方法"
    },
    {
        "id":3043,
        "name":"3044 (Thai Program)  :  Marine Biology | ชีววิทยาทางทะเล | 海洋生物学"
    },
    {
        "id":3044,
        "name":"3045 (Thai Program)  :  Develop Social Analysis And Social Planning | พัฒนาสังคมวิเคราะห์และการวางแผนทางสังคม | 开展社会分析和社会规划"
    },
    {
        "id":3045,
        "name":"3046 (Thai Program)  :  Biological Sciences-Biology | วิทยาศาสตร์ชีวภาพ-ชีววิทยา | 生物科学-生物学"
    },
    {
        "id":3046,
        "name":"3047 (Thai Program)  :  Theology-Islam | ศาสนวิทยา-อิสลาม | 神学-伊斯兰教"
    },
    {
        "id":3047,
        "name":"3048 (Thai Program)  :  Medical Sociology | สังคมวิทยาการแพทย์ | 医学社会学"
    },
    {
        "id":3048,
        "name":"3049 (Thai Program)  :  Accounting Information | สารสนเทศทางการบัญชี | 会计信息"
    },
    {
        "id":3049,
        "name":"3050 (English Program)  :  Oriental Epigraphy | วรรณกรรมตะวันออก | 东方金石学"
    },
    {
        "id":3050,
        "name":"3051 (Thai Program)  :  Higher Education And Teacher Training-Chemistry | อุดมศึกษาและการฝึกหัดครู-เคมี | 高等教育和教师培训-化学"
    },
    {
        "id":3051,
        "name":"3052 (Thai Program)  :  Higher Education And Teacher Training-Biology | อุดมศึกษาและการฝึกหัดครู-ชีววิทยา | 高等教育和教师培训-生物学"
    },
    {
        "id":3052,
        "name":"3053 (Thai Program)  :  Higher Education And Teacher Training-Thai Language | อุดมศึกษาและการฝึกหัดครู-ภาษาไทย | 高等教育和教师培训-泰语"
    },
    {
        "id":3053,
        "name":"3054 (Thai Program)  :  Molecular Medicine | เวชศาสตร์ระดับโมเลกุล | 分子医学"
    },
    {
        "id":3054,
        "name":"3055 (Thai Program)  :  Television Media Production | การผลิตสื่อโทรทัศน์ | 电视媒体制作"
    },
    {
        "id":3055,
        "name":"3056 (Thai Program)  :  Developmental Economics | เศรษฐศาสตร์พัฒนาการ | 发展经济学"
    },
    {
        "id":3056,
        "name":"3057 (Thai Program)  :  Advanced Adult Nursing | การพยาบาลผู้ใหญ่ขั้นสูง | 高级成人护理"
    },
    {
        "id":3057,
        "name":"3058 (Thai Program)  :  Family Practice Nursing | การพยาบาลเวชปฏิบัติครอบครัว | 家庭实践护理"
    },
    {
        "id":3058,
        "name":"3059 (Thai Program)  :  Community Development Economics | เศรษฐศาสตร์พัฒนาชุมชน | 社区发展经济学"
    },
    {
        "id":3059,
        "name":"3060 (Thai Program)  :  Modern Business Management | การจัดการธุรกิจสมัยใหม่ | 现代企业管理"
    },
    {
        "id":3060,
        "name":"3061 (Thai Program)  :  International Hospitality Business Management | การจัดการธุรกิจการบริการระหว่างประเทศ | 国际酒店业务管理"
    },
    {
        "id":3061,
        "name":"3062 (Thai Program)  :  Information And Communication Engineering | วิศวกรรมสารสนเทศและการสื่อสาร | 信息与通信工程"
    },
    {
        "id":3062,
        "name":"3063 (Thai Program)  :  Local Government | การปกครองท้องถิ่น | 当地政府"
    },
    {
        "id":3063,
        "name":"3064 (Thai Program)  :  Automobile Technology | เทคโนโลยีรถยนต์ | 汽车技术"
    },
    {
        "id":3064,
        "name":"3065 (Thai Program)  :  Fine Arts And Applied Arts | วิจิตรศิลป์และประยุกต์ศิลป์ | 美术与应用艺术"
    },
    {
        "id":3065,
        "name":"3066 (Thai Program)  :  Service Business Management | การจัดการธุรกิจบริการ | 服务业管理"
    },
    {
        "id":3066,
        "name":"3067 (Thai Program)  :  Renewable Energy Engineering | วิศวกรรมพลังงานทดแทน | 可再生能源工程"
    },
    {
        "id":3067,
        "name":"3068 (Thai Program)  :  Electronic Business Management | การจัดการธุรกิจอิเล็กทรอนิกส์ | 电子商务管理"
    },
    {
        "id":3068,
        "name":"3069 (Thai Program)  :  Innovation And Entrepreneurship | นวัตกรรมและการเป็นผู้ประกอบการ | 创新创业"
    },
    {
        "id":3069,
        "name":"3070 (Thai Program)  :  Integrated Political Communication | การสื่อสารการเมืองบูรณาการ | 综合政治传播"
    },
    {
        "id":3070,
        "name":"3071 (Thai Program)  :  Educational Information And Communication Technology | เทคโนโลยีสารสนเทศและสื่อสารการศึกษา | 教育信息与通信技术"
    },
    {
        "id":3071,
        "name":"3072 (Thai Program)  :  Aviation Electronics | อิเล็กทรอนิกส์การบิน | 航空电子"
    },
    {
        "id":3072,
        "name":"3073 (Thai Program)  :  Local Government And Development | การปกครองและพัฒนาท้องถิ่น | 地方政府与发展"
    },
    {
        "id":3073,
        "name":"3074 (Thai Program)  :  Teaching Buddhism | การสอนพระพุทธศาสนา | 传授佛法"
    },
    {
        "id":3074,
        "name":"3075 (Thai Program)  :  Computer Science-Statistics | วิทยาการคอมพิวเตอร์-สถิติ | 计算机科学-统计学"
    },
    {
        "id":3075,
        "name":"3076 (Thai Program)  :  Electronics | อิเล็กทรอนิกส์ | 电子产品"
    },
    {
        "id":3076,
        "name":"3077 (Thai Program)  :  Electrical Power | ไฟฟ้ากำลัง | 电力"
    },
    {
        "id":3077,
        "name":"3078 (Thai Program)  :  Game And Multimedia Design | ออกแบบเกมและมัลติมีเดีย | 游戏和多媒体设计"
    },
    {
        "id":3078,
        "name":"3079 (Thai Program)  :  Audit And Internal Audit | สอบบัญชีและตรวจสอบภายใน | 审计和内部审计"
    },
    {
        "id":3079,
        "name":"3080 (Thai Program)  :  Small And Medium Sized Businesses | ธุรกิจขนาดกลางและขนาดย่อม | 中小型企业"
    },
    {
        "id":3080,
        "name":"3081 (Thai Program)  :  Pollution Management And Control | การจัดการและควบคุมมลพิษ | 污染管理与控制"
    },
    {
        "id":3081,
        "name":"3082 (Thai Program)  :  Mathematics Information Studies | คณิตศาสตร์ศึกษาสารสนเทศ | 数学信息研究"
    },
    {
        "id":3082,
        "name":"3083 (Thai Program)  :  Environmental Management Technology | เทคโนโลยีการจัดการสิ่งแวดล้อม | 环境管理技术"
    },
    {
        "id":3083,
        "name":"3084 (Thai Program)  :  Assessment Science | วิทยาการประเมิน | 评估科学"
    },
    {
        "id":3084,
        "name":"3085 (Thai Program)  :  Pharmaceutical Enterprise Management | การจัดการองค์กรเภสัชกรรม | 医药企业管理"
    },
    {
        "id":3085,
        "name":"3086 (Thai Program)  :  Innovative Design | นวัตกรรมการออกแบบ | 创新设计"
    },
    {
        "id":3086,
        "name":"3087 (Thai Program)  :  Arts And Culture Research | ศิลปวัฒนธรรมวิจัย | 艺术与文化研究"
    },
    {
        "id":3087,
        "name":"3088 (English Program)  :  Student Personnel And Guidance | บุคลากรนักเรียนและการแนะแนว | 学生人员和指导"
    },
    {
        "id":3088,
        "name":"3089 (English Program)  :  Population Policy | นโยบายด้านประชากร | 人口政策"
    },
    {
        "id":3089,
        "name":"3090 (English Program)  :  Emotionally Disturb Child | เด็กที่รบกวนจิตใจ | 情绪困扰的孩子"
    },
    {
        "id":3090,
        "name":"3091 (English Program)  :  Agricultural Machinery And Managemrnt | เครื่องจักรการเกษตรและการจัดการ | 农业机械与管理"
    },
    {
        "id":3091,
        "name":"3092 (English Program)  :  Interdiscipline | สหวิทยาการ | 跨学科"
    },
    {
        "id":3092,
        "name":"3093 (English Program)  :  Choreography | การออกแบบท่าเต้น | 编舞"
    },
    {
        "id":3093,
        "name":"3094 (English Program)  :  Piano Performance | การแสดงเปียโน | 钢琴演奏"
    },
    {
        "id":3094,
        "name":"3095 (English Program)  :  Sport Psychology | จิตวิทยาการกีฬา | 运动心理学"
    },
    {
        "id":3095,
        "name":"3096 (English Program)  :  Dental Materials Science | วิทยาศาสตร์วัสดุทันตกรรม | 牙科材料科学"
    },
    {
        "id":3096,
        "name":"3097 (English Program)  :  Water Resources Development | การพัฒนาทรัพยากรน้ำ | 水资源开发"
    },
    {
        "id":3097,
        "name":"3098 (English Program)  :  Adhesive Restorative Dentistry | ทันตกรรมบูรณะแบบมีกาว | 粘合修复牙科"
    },
    {
        "id":3098,
        "name":"3099 (English Program)  :  Dental Science | วิทยาศาสตร์ทันตกรรม | 牙科科学"
    },
    {
        "id":3099,
        "name":"3100 (English Program)  :  Human Development And Family Studies | การพัฒนามนุษย์และการศึกษาครอบครัว | 人类发展与家庭研究"
    },
    {
        "id":3100,
        "name":"3101 (English Program)  :  Fishery Science | วิทยาศาสตร์การประมง | 渔业科学"
    },
    {
        "id":3101,
        "name":"3102 (English Program)  :  Secondary School Administration | การบริหารโรงเรียนระดับมัธยมศึกษา | 中学行政"
    },
    {
        "id":3102,
        "name":"3103 (English Program)  :  Secondary School Supervision | การควบคุมดูแลโรงเรียนมัธยมศึกษา | 中学督导"
    },
    {
        "id":3103,
        "name":"3104 (English Program)  :  Production Et Traitement Des Matieref | การผลิตและการแปรรูปวัสดุ | 材料的生产和训练"
    },
    {
        "id":3104,
        "name":"3105 (English Program)  :  Cell Biology | ชีววิทยาของเซลล์ | 细胞生物学"
    },
    {
        "id":3105,
        "name":"3106 (English Program)  :  Chimie Industrielle | เคมีอุตสาหกรรม | 化学工业"
    },
    {
        "id":3106,
        "name":"3107 (English Program)  :  Pharmakologie | เภสัชวิทยา | 药理学"
    },
    {
        "id":3107,
        "name":"3108 (English Program)  :  Instruction And Learning | การเรียนการสอนและการเรียนรู้ | 指导和学习"
    },
    {
        "id":3108,
        "name":"3109 (English Program)  :  Administration & Supervision | การบริหารและการกำกับดูแล | 管理与监督"
    },
    {
        "id":3109,
        "name":"3110 (English Program)  :  Mathematics Education And Computer | การศึกษาคณิตศาสตร์และคอมพิวเตอร์ | 数学教育和计算机"
    },
    {
        "id":3110,
        "name":"3111 (English Program)  :  International And Development Education | การศึกษาระหว่างประเทศและการพัฒนา | 国际与发展教育"
    },
    {
        "id":3111,
        "name":"3112 (English Program)  :  Counseling Education | การศึกษาการให้คำปรึกษา | 辅导教育"
    },
    {
        "id":3112,
        "name":"3113 (English Program)  :  Administrative And Policy Studies | การศึกษาด้านการบริหารและนโยบาย | 行政和政策研究"
    },
    {
        "id":3113,
        "name":"3114 (English Program)  :  Instructional Systems Technology | เทคโนโลยีระบบการเรียนการสอน | 教学系统技术"
    },
    {
        "id":3114,
        "name":"3115 (Thai Program)  :  Energy And Environmental Management Technology | เทคโนโลยีการจัดการพลังงานและสิ่งแวดล้อม | 能源与环境管理技术"
    },
    {
        "id":3115,
        "name":"3116 (Thai Program)  :  Industrial Development | การพัฒนางานอุตสาหกรรม | 产业发展"
    },
    {
        "id":3116,
        "name":"3117 (Thai Program)  :  Design Ceramics | ออกแบบเซรามิกส์ | 设计陶瓷"
    },
    {
        "id":3117,
        "name":"3118 (Thai Program)  :  Mechatronics Engineering | วิศวกรรมแมคคาทรอนิกส์ | 机电工程"
    },
    {
        "id":3118,
        "name":"3119 (Thai Program)  :  Management | การบริหารจัดการ | 管理"
    },
    {
        "id":3119,
        "name":"3120 (Thai Program)  :  Organizational And Human Resource Management | การบริหารองค์การและทรัพยากรมนุษย์ | 组织和人力资源管理"
    },
    {
        "id":3120,
        "name":"3121 (Thai Program)  :  Radio Broadcasting Radio, Television And Movies | วิทยุกระจายเสียง วิทยุโทรทัศน์ และภาพยนตร์ | 无线电广播广播、电视和电影"
    },
    {
        "id":3121,
        "name":"3122 (Thai Program)  :  Tourism And Hospitality | การท่องเที่ยวและการโรงแรม | 旅游与酒店业"
    },
    {
        "id":3122,
        "name":"3123 (Thai Program)  :  Interior Design | การออกแบบตกแต่งภายใน | 室内设计"
    },
    {
        "id":3123,
        "name":"3124 (Thai Program)  :  Visual Communication Design | การออกแบบนิเทศศิลป์ | 视觉传达设计"
    },
    {
        "id":3124,
        "name":"3125 (Thai Program)  :  Entrepreneurship | ความเป็นผู้ประกอบการ | 创业精神"
    },
    {
        "id":3125,
        "name":"3126 (Thai Program)  :  Social Innovation Management | การจัดการนวัตกรรมสังคม | 社会创新管理"
    },
    {
        "id":3126,
        "name":"3127 (Thai Program)  :  Warich Engineering | วาริชวิศวกรรม | 华里奇工程公司"
    },
    {
        "id":3127,
        "name":"3128 (Thai Program)  :  Agricultural Machinery And Mechatronics | เครื่องจักรกลและเมคคาทรอนิกส์เกษตร | 农业机械及机电一体化"
    },
    {
        "id":3128,
        "name":"3129 (Thai Program)  :  Human And Community Resource Development | การพัฒนาทรัพยากรมนุษย์และชุมชน | 人力和社区资源开发"
    },
    {
        "id":3129,
        "name":"3130 (Thai Program)  :  Marketing Communications | สื่อสารการตลาด | 营销传播"
    },
    {
        "id":3130,
        "name":"3131 (Thai Program)  :  Music, International Music Field | ดนตรี แขนงวิชาดนตรีสากล | 音乐、国际音乐领域"
    },
    {
        "id":3131,
        "name":"3132 (Thai Program)  :  Fine Arts, Department Of Visual Communication Design | ศิลปกรรม แขนงวิชาออกแบบนิเทศศิลป์ | 美术视觉传达设计系"
    },
    {
        "id":3132,
        "name":"3133 (Thai Program)  :  Industrial Product Design Furniture Product Design Branch | ออกแบบผลิตภัณฑ์อุตสาหกรรม แขนงออกแบบผลิตภัณฑ์เฟอร์นิเจอร์ | 工业产品设计家具产品设计分院"
    },
    {
        "id":3133,
        "name":"3134 (Thai Program)  :  Agriculture, Field Of Agricultural Technology | เกษตรศาสตร์ แขนงวิชาเทคโนโลยีการเกษตร | 农业、农业技术领域"
    },
    {
        "id":3134,
        "name":"3135 (Thai Program)  :  Agriculture, Field Of Plant Science | เกษตรศาสตร์ แขนงวิชาพืชศาสตร์ | 农业、植物科学领域"
    },
    {
        "id":3135,
        "name":"3136 (Thai Program)  :  Agriculture, Animal Husbandry Major | เกษตรศาสตร์ แขนงวิชาสัตวบาล | 农牧业专业"
    },
    {
        "id":3136,
        "name":"3137 (Thai Program)  :  Agriculture, Aquaculture Branch | เกษตรศาสตร์ แขนงการเพาะเลี้ยงสัตว์น้ำ | 农业、水产养殖分会"
    },
    {
        "id":3137,
        "name":"3138 (Thai Program)  :  Integrated Tourism Management | การจัดการท่องเที่ยวเชิงบูรณาการ | 旅游综合管理"
    },
    {
        "id":3138,
        "name":"3139 (Thai Program)  :  Science And Biotechnology | วิทยาศาสตร์และเทคโนโลยีชีวภาพ | 科学与生物技术"
    },
    {
        "id":3139,
        "name":"3140 (Thai Program)  :  Technology And Production Management | การจัดการเทคโนโลยีและการผลิต | 技术与生产管理"
    },
    {
        "id":3140,
        "name":"3141 (Thai Program)  :  Economics Of Managing Small And Medium-Sized Enterprises | เศรษฐศาสตร์การจัดการวิสาหกิจขนาดกลางและขนาดย่อม | 中小企业管理经济学"
    },
    {
        "id":3141,
        "name":"3142 (Thai Program)  :  Service Industry | อุตสาหกรรมการบริการ | 服务业"
    },
    {
        "id":3142,
        "name":"3143 (Thai Program)  :  English-Thai | ภาษาอังกฤษ-ภาษาไทย | 英语-泰语"
    },
    {
        "id":3143,
        "name":"3144 (Thai Program)  :  Chinese Language Application | การประยุกต์ใช้ภาษาจีน | 中文申请"
    },
    {
        "id":3144,
        "name":"3145 (Thai Program)  :  Folk Art, Music And Performance | ศิลปะดนตรีและการแสดงพื้นบ้าน | 民间艺术、音乐和表演"
    },
    {
        "id":3145,
        "name":"3146 (Thai Program)  :  Buddhist Management | การจัดการเชิงพุทธ | 佛教管理"
    },
    {
        "id":3146,
        "name":"3147 (Thai Program)  :  Information Technology System | ระบบเทคโนโลยีสารสนเทศ | 信息技术系统"
    },
    {
        "id":3147,
        "name":"3148 (Thai Program)  :  Metallurgical Technology | เทคโนโลยีโลหการ | 冶金技术"
    },
    {
        "id":3148,
        "name":"3149 (Thai Program)  :  Community Studies | ชุมชนศึกษา | 社区研究"
    },
    {
        "id":3149,
        "name":"3150 (Thai Program)  :  Management In Islam | การจัดการในอิสลาม | 伊斯兰教的管理"
    },
    {
        "id":3150,
        "name":"3151 (Thai Program)  :  Hotel And Restaurant Management | การจัดการโรงแรมและภัตตาคาร | 酒店及餐厅管理"
    },
    {
        "id":3151,
        "name":"3152 (Thai Program)  :  Engineering Physics | ฟิสิกส์วิศวกรรม | 工程物理"
    },
    {
        "id":3152,
        "name":"3153 (Thai Program)  :  What A Group Of People. | ช่างสิปปหมู่ | 多么一群人啊。"
    },
    {
        "id":3153,
        "name":"3154 (Thai Program)  :  Sufficiency Economy According To The Royal Initiative | เศรษฐกิจพอเพียงตามแนวพระราชดำริ | 根据皇家倡议的自给自足经济"
    },
    {
        "id":3154,
        "name":"3155 (Thai Program)  :  Marketing-General Marketing | การตลาด-การตลาดทั่วไป | 营销-一般营销"
    },
    {
        "id":3155,
        "name":"3156 (Thai Program)  :  Food Service Industry | อุตสาหกรรมบริการอาหาร | 食品服务业"
    },
    {
        "id":3156,
        "name":"3157 (Thai Program)  :  Home Economics Business Administration | การบริหารธุรกิจคหกรรมศาสตร์ | 家政工商管理"
    },
    {
        "id":3157,
        "name":"3158 (Thai Program)  :  Fashion Design, Fabric And Clothing | ออกแบบแฟชั่นผ้าและเครื่องแต่งกาย | 时装设计、面料和服装"
    },
    {
        "id":3158,
        "name":"3159 (Thai Program)  :  Fashion Product Management Technology | เทคโนโลยีการจัดการสินค้าแฟชั่น | 时尚产品管理技术"
    },
    {
        "id":3159,
        "name":"3160 (Thai Program)  :  Textile Product Design | ออกแบบผลิตภัณฑ์สิ่งทอ | 纺织产品设计"
    },
    {
        "id":3160,
        "name":"3161 (Thai Program)  :  Fashion And Textile Design | ออกแบบแฟชั่นและสิ่งทอ | 时装和纺织品设计"
    },
    {
        "id":3161,
        "name":"3162 (Thai Program)  :  Business Communication | นิเทศศาสตร์ธุรกิจ | 商务沟通"
    },
    {
        "id":3162,
        "name":"3163 (Thai Program)  :  Pet Management Science | วิทยาการการจัดการสัตว์เลี้ยง | 宠物管理科学"
    },
    {
        "id":3163,
        "name":"3164 (Thai Program)  :  Geographic Information System Technology | เทคโนโลยีระบบสารสนเทศภูมิศาสตร์ | 地理信息系统技术"
    },
    {
        "id":3164,
        "name":"3165 (Thai Program)  :  Multimedia And Animation Technology | เทคโนโลยีมัลติมีเดียและแอนนิเมชัน | 多媒体和动画技术"
    },
    {
        "id":3165,
        "name":"3166 (Thai Program)  :  Electrical Engineering - Computer | วิศวกรรมไฟฟ้า - คอมพิวเตอร์ | 电气工程 - 计算机"
    },
    {
        "id":3166,
        "name":"3167 (Thai Program)  :  Business Administration (Community Business Management) | การบริหารธุรกิจ (การจัดการธุรกิจชุมชน) | 商业管理（社区商业管理）"
    },
    {
        "id":3167,
        "name":"3168 (Thai Program)  :  Veterinary Medicine | สัตวเวชศาสตร์ | 兽医学"
    },
    {
        "id":3168,
        "name":"3169 (Thai Program)  :  Buddhism | พุทธศาสนา | 佛教"
    },
    {
        "id":3169,
        "name":"3170 (Thai Program)  :  Interdisciplinary Local Administration | สหวิทยาการการบริหารท้องถิ่น | 跨学科地方行政"
    },
    {
        "id":3170,
        "name":"3171 (Thai Program)  :  Lanna Medicine | การแพทย์ล้านนา | 兰纳医学"
    },
    {
        "id":3171,
        "name":"3172 (Thai Program)  :  Sufficiency Economy Philosophy | ปรัชญาเศรษฐกิจพอเพียง | 自给自足经济理念"
    },
    {
        "id":3172,
        "name":"3173 (Thai Program)  :  Basic Education Mathematics Major | การศึกษาขั้นพื้นฐาน เอกคณิตศาสตร์ | 基础教育数学专业"
    },
    {
        "id":3173,
        "name":"3174 (Thai Program)  :  Basic Education, Major In Physical Education | การศึกษาขั้นพื้นฐาน เอกพลศึกษา | 基础教育、体育专业"
    },
    {
        "id":3174,
        "name":"3175 (Thai Program)  :  Basic Education English Major | การศึกษาขั้นพื้นฐาน เอกภาษาอังกฤษ | 基础教育英语专业"
    },
    {
        "id":3175,
        "name":"3176 (Thai Program)  :  Basic Education Science Major | การศึกษาขั้นพื้นฐาน เอกวิทยาศาสตร์ | 基础教育理科专业"
    },
    {
        "id":3176,
        "name":"3177 (Thai Program)  :  Basic Education, Majoring In Fine Arts | การศึกษาขั้นพื้นฐาน เอกศิลปกรรม | 基础教育，美术专业"
    },
    {
        "id":3177,
        "name":"3178 (Thai Program)  :  Basic Education, Majoring In Chinese Language | การศึกษาขั้นพื้นฐาน เอกภาษาจีน | 基础教育，汉语言专业"
    },
    {
        "id":3178,
        "name":"3179 (Thai Program)  :  Basic Education, Majoring In Thai Language | การศึกษาขั้นพื้นฐาน เอกภาษาไทย | 基础教育，泰语专业"
    },
    {
        "id":3179,
        "name":"3180 (Thai Program)  :  Basic Education Social Studies Major | การศึกษาขั้นพื้นฐาน เอกสังคมศึกษา | 基础教育社会研究专业"
    },
    {
        "id":3180,
        "name":"3181 (Thai Program)  :  Basic Education Primary Education Major | การศึกษาขั้นพื้นฐาน เอกการประถมศึกษา | 基础教育初等教育专业"
    },
    {
        "id":3181,
        "name":"3182 (Thai Program)  :  Chemical Technology | เทคโนโลยีเคมี | 化学技术"
    },
    {
        "id":3182,
        "name":"3183 (Thai Program)  :  Electrical And Electronic Technology | เทคโนโลยีไฟฟ้าและอิเล็กทรอนิกส์ | 电气电子技术"
    },
    {
        "id":3183,
        "name":"3184 (Thai Program)  :  Automotive Industry Technology And Parts | เทคโนโลยีอุตสาหกรรมยานยนต์และชิ้นส่วน | 汽车工业技术及零部件"
    },
    {
        "id":3184,
        "name":"3185 (Thai Program)  :  Jurisprudence And Human Rights Studies | นิติศาสตร์และสิทธิมนุษยชนศึกษา | 法理学和人权研究"
    },
    {
        "id":3185,
        "name":"3186 (English Program)  :  Thai Epigraphy | อักษรวิจิตรไทย | 泰国金石学"
    },
    {
        "id":3186,
        "name":"3187 (English Program)  :  Painting | จิตรกรรม | 绘画"
    },
    {
        "id":3187,
        "name":"3188 (Thai Program)  :  Environmental And Resource Management | การจัดการสิ่งแวดล้อมและทรัพยากร | 环境和资源管理"
    },
    {
        "id":3188,
        "name":"3189 (Thai Program)  :  Human Rights And Development | สิทธิมนุษยชนและการพัฒนา | 人权与发展"
    },
    {
        "id":3189,
        "name":"3190 (Thai Program)  :  Computer Control | คอมพิวเตอร์ควบคุม | 电脑控制"
    },
    {
        "id":3190,
        "name":"3191 (Thai Program)  :  Architectural Design Computer | คอมพิวเตอร์ออกแบบสถาปัตยกรรม | 建筑设计计算机"
    },
    {
        "id":3191,
        "name":"3192 (Thai Program)  :  Computer Graphics And Typography | กราฟฟิกคอมพิวเตอร์และการพิมพ์ | 计算机图形学和排版"
    },
    {
        "id":3192,
        "name":"3193 (Thai Program)  :  Product Management And E-Commerce | การจัดการผลิตภัณฑ์และพาณิชย์อิเล็กทรอนิกส์ | 产品管理和电子商务"
    },
    {
        "id":3193,
        "name":"3194 (Thai Program)  :  Computer And Biomedical Engineering | วิศวกรรมคอมพิวเตอร์และชีวการแพทย์ | 计算机与生物医学工程"
    },
    {
        "id":3194,
        "name":"3195 (Thai Program)  :  English For Professional Purposes | ภาษาอังกฤษเพื่อวิชาชีพ | 专业英语"
    },
    {
        "id":3195,
        "name":"3196 (Thai Program)  :  Computer Aided Design | คอมพิวเตอร์ช่วยออกแบบ | 计算机辅助设计"
    },
    {
        "id":3196,
        "name":"3197 (Thai Program)  :  Communication Arts-Digital Media | นิเทศศาสตร์-สื่อดิจิตอล | 传播艺术-数字媒体"
    },
    {
        "id":3197,
        "name":"3198 (Thai Program)  :  Communication Arts Technology | เทคโนโลยีนิเทศศิลป์ | 传播艺术技术"
    },
    {
        "id":3198,
        "name":"3199 (Thai Program)  :  Accounting Profession | วิชาชีพทางการบัญชี | 会计专业"
    },
    {
        "id":3199,
        "name":"3200 (Thai Program)  :  Analytical Science | วิทยาศาสตร์การวิเคราะห์ | 分析科学"
    },
    {
        "id":3200,
        "name":"3201 (Thai Program)  :  Textiles And Clothing | สิ่งทอและเครื่องนุ่งห่ม | 纺织品和服装"
    },
    {
        "id":3201,
        "name":"3202 (Thai Program)  :  Security Management | การจัดการความมั่นคงปลอดภัย | 安全管理"
    },
    {
        "id":3202,
        "name":"3203 (Thai Program)  :  Chinese For Tourism And Hospitality | ภาษาจีนเพื่อการท่องเที่ยวและการโรงแรม | 旅游与酒店汉语"
    },
    {
        "id":3203,
        "name":"3204 (Thai Program)  :  Business Ownership | การเป็นเจ้าของธุรกิจ | 企业所有权"
    },
    {
        "id":3204,
        "name":"3205 (Thai Program)  :  Entertainment Business Management And Production | การบริหารธุรกิจบันเทิงและการผลิต | 娱乐业务管理和制作"
    },
    {
        "id":3205,
        "name":"3206 (Thai Program)  :  Thai Language For Communication | ภาษาไทยเพื่อการสื่อสาร | 泰语用于交流"
    },
    {
        "id":3206,
        "name":"3207 (Thai Program)  :  English Travel Business | ภาษาอังกฤษธุรกิจท่องเที่ยว | 英语旅游业务"
    },
    {
        "id":3207,
        "name":"3208 (Thai Program)  :  Statistics And Computers | สถิติและคอมพิวเตอร์ | 统计和计算机"
    },
    {
        "id":3208,
        "name":"3209 (Thai Program)  :  Business Information | สารสนเทศทางธุรกิจ | 商业信息"
    },
    {
        "id":3209,
        "name":"3210 (Thai Program)  :  Food And Service Science | วิทยาการอาหารและบริการ | 食品与服务科学"
    },
    {
        "id":3210,
        "name":"3211 (Thai Program)  :  Civil Engineering And Technology | วิศวกรรมโยธาและเทคโนโลยี | 土木工程与技术"
    },
    {
        "id":3211,
        "name":"3212 (Thai Program)  :  English For Business And Industrial Communication | ภาษาอังกฤษเพื่อการสื่อสารเชิงธุรกิจและอุตสาหกรรม | 商业和工业交流英语"
    },
    {
        "id":3212,
        "name":"3213 (Thai Program)  :  Interdisciplinary Industry | สหวิทยาการอุตสาหกรรม | 跨学科产业"
    },
    {
        "id":3213,
        "name":"3214 (Thai Program)  :  Food Enterprise | วิสาหกิจการอาหาร | 食品企业"
    },
    {
        "id":3214,
        "name":"3215 (Thai Program)  :  Sports Science Exercise | วิทยาศาสตร์การกีฬาการออกกำลังกาย | 体育科学锻炼"
    },
    {
        "id":3215,
        "name":"3216 (Thai Program)  :  Medical Education Technology | เทคโนโลยีการศึกษาแพทยศาสตร์ | 医学教育技术"
    },
    {
        "id":3216,
        "name":"3217 (Thai Program)  :  Advanced Midwifery | การผดุงครรภ์ขั้นสูง | 先进助产术"
    },
    {
        "id":3217,
        "name":"3218 (Thai Program)  :  Computer Network | เครือข่ายคอมพิวเตอร์ | 计算机网络"
    },
    {
        "id":3218,
        "name":"3219 (Thai Program)  :  Mathematics And Economics | คณิตศาสตร์และเศรษฐกิจ | 数学与经济学"
    },
    {
        "id":3219,
        "name":"3220 (Thai Program)  :  Industrial Technology Production Technology Field | เทคโนโลยีอุตสาหกรรม แขนงวิชาเทคโนโลยีการผลิต | 工业技术生产技术领域"
    },
    {
        "id":3220,
        "name":"3221 (Thai Program)  :  Industrial Technology Field Of Study: Construction Industry Technology | เทคโนโลยีอุตสาหกรรม แขนงวิชาเทคโนโลยีอุตสาหกรรมก่อสร้าง | 工业技术研究领域: 建筑工业技术"
    },
    {
        "id":3221,
        "name":"3222 (Thai Program)  :  Industrial Technology Department Of Industrial Electrical Technology | เทคโนโลยีอุตสาหกรรม แขนงวิชาเทคโนโลยีไฟฟ้าอุตสาหกรรม | 工业技术工业电气技术系"
    },
    {
        "id":3222,
        "name":"3223 (Thai Program)  :  Industrial Technology Department Of Computer Electronics Technology | เทคโนโลยีอุตสาหกรรม แขนงวิชาเทคโนโลยีอิเล็กทรอนิกส์คอมพิวเตอร์ | 工业技术计算机电子技术系"
    },
    {
        "id":3223,
        "name":"3224 (Thai Program)  :  Data Analysis Management And Information Technology | การจัดการวิเคราะห์ข้อมูลและเทคโนโลยีข้อมูล | 数据分析管理与信息技术"
    },
    {
        "id":3224,
        "name":"3225 (Thai Program)  :  Business Economics Field Of Study: Quantitative Business Analysis | เศรษฐศาสตร์ธุรกิจ แขนงวิชาการวิเคราะห์เชิงปริมาณทางธุรกิจ | 商业经济学研究领域： 定量商业分析"
    },
    {
        "id":3225,
        "name":"3226 (Thai Program)  :  Applied Biology Biology Field | ชีววิทยาประยุกต์ แขนงวิชาชีววิทยา | 应用生物学生物领域"
    },
    {
        "id":3226,
        "name":"3227 (Thai Program)  :  Environmental Science Field Of Study: Environmental Pollution | วิทยาศาสตร์สิ่งแวดล้อม แขนงวิชามลพิษสิ่งแวดล้อม | 环境科学研究领域：环境污染"
    },
    {
        "id":3227,
        "name":"3228 (Thai Program)  :  Business Management And English | การจัดการธุรกิจและภาษาอังกฤษ | 商业管理和英语"
    },
    {
        "id":3228,
        "name":"3229 (Thai Program)  :  Interdisciplinary Studies For Local Development | สหวิทยาการเพื่อการพัฒนาท้องถิ่น | 地方发展的跨学科研究"
    },
    {
        "id":3229,
        "name":"3230 (Thai Program)  :  Retail Business Management | การจัดการธุรกิจค้าปลีก | 零售业务管理"
    },
    {
        "id":3230,
        "name":"3231 (Thai Program)  :  Food Business Management | การจัดการธุรกิจอาหาร | 食品企业管理"
    },
    {
        "id":3231,
        "name":"3232 (Thai Program)  :  Digital Media Design | การออกแบบสื่อดิจิทัล | 数字媒体设计"
    },
    {
        "id":3232,
        "name":"3233 (Thai Program)  :  Multimedia Animation | มัลติมีเดียแอนิเมชัน | 多媒体动画"
    },
    {
        "id":3233,
        "name":"3234 (English Program)  :  Psychology | จิตวิทยา | 心理学"
    },
    {
        "id":3234,
        "name":"3235 (Thai Program)  :  Thai Language And Culture | ภาษาและวัฒนธรรมไทย | 泰国语言和文化"
    },
    {
        "id":3235,
        "name":"3236 (Thai Program)  :  Food Service Industry | อุตสาหกรรมการบริการอาหาร | 食品服务业"
    },
    {
        "id":3236,
        "name":"3237 (Thai Program)  :  Business Administration, General Management Subject | การบริหารธุรกิจแขนงวิชาการจัดการทั่วไป | 工商管理、综合管理学科"
    },
    {
        "id":3237,
        "name":"3238 (Thai Program)  :  Business Administration In The Field Of Finance And Banking | การบริหารธุรกิจแขนงวิชาการเงินการธนาคาร | 金融和银行领域的工商管理"
    },
    {
        "id":3238,
        "name":"3239 (Thai Program)  :  Industrial Technology-Industry | เทคโนโลยีอุตสาหกรรม-อุตสาหกรรม | 工业技术-工业"
    },
    {
        "id":3239,
        "name":"3240 (Thai Program)  :  Industrial-Civil Technology | เทคโนโลยีอุตสาหกรรม-โยธา | 工业与民用技术"
    },
    {
        "id":3240,
        "name":"3241 (Thai Program)  :  Bioproduct Science | วิทยาศาสตร์ชีวผลิตภัณฑ์ | 生物产品科学"
    },
    {
        "id":3241,
        "name":"3242 (Thai Program)  :  Wanwat Technology | เทคโนโลยีวนวัฒน์ | 万瓦科技"
    },
    {
        "id":3242,
        "name":"3243 (Thai Program)  :  Forest Conservation | อนุรักษ์ป่าไม้ | 森林保护"
    },
    {
        "id":3243,
        "name":"3244 (Thai Program)  :  Southeast Asian Studies | เอเซียตะวันออกเฉียงใต้ศึกษา | 东南亚研究"
    },
    {
        "id":3244,
        "name":"3245 (Thai Program)  :  Built Environment | สิ่งแวดล้อมสรรค์สร้าง | 建成环境"
    },
    {
        "id":3245,
        "name":"3246 (Thai Program)  :  Integrated Chemical Engineering | วิศวกรรมเคมีบูรณาการ | 综合化学工程"
    },
    {
        "id":3246,
        "name":"3247 (Thai Program)  :  Interactive And Multimedia Design | การออกแบบสื่อปฏิสัมพันธ์และมัลติมีเดีย | 互动和多媒体设计"
    },
    {
        "id":3247,
        "name":"3248 (Thai Program)  :  Cyber ​​Business Management | การจัดการธุรกิจไซเบอร์ | 网络业务管理"
    },
    {
        "id":3248,
        "name":"3249 (Thai Program)  :  Computers For Communication | คอมพิวเตอร์เพื่อสารสื่อสาร | 通讯用计算机"
    },
    {
        "id":3249,
        "name":"3250 (Thai Program)  :  Social Communication Innovation | นวัตกรรมสื่อสารสังคม | 社交传播创新"
    },
    {
        "id":3250,
        "name":"3251 (Thai Program)  :  Bachelor Of Technology | เทคโนโลยีบัณฑิต | 技术学士"
    },
    {
        "id":3251,
        "name":"3252 (Thai Program)  :  Sports And Recreation Management | การจัดการกีฬาและนันทนาการ | 体育和娱乐管理"
    },
    {
        "id":3252,
        "name":"3253 (Thai Program)  :  Management Innovation | นวัตกรรมการจัดการ | 管理创新"
    },
    {
        "id":3253,
        "name":"3254 (Thai Program)  :  Buddhist Studies | พุทธศาสตรศึกษา | 佛学研究"
    },
    {
        "id":3254,
        "name":"3255 (Thai Program)  :  Industrial And Logistics Management | การจัดการอุตสาหกรรมและโลจิสติกส์ | 工业和物流管理"
    },
    {
        "id":3255,
        "name":"3256 (Thai Program)  :  Investment And Financial Risk Management | การลงทุนและการจัดการความเสี่ยงทางการเงิน | 投资与金融风险管理"
    },
    {
        "id":3256,
        "name":"3257 (English Program)  :  Experimental Psychology | จิตวิทยาเชิงทดลอง | 实验心理学"
    },
    {
        "id":3257,
        "name":"3258 (Thai Program)  :  Mechatronics | แมคคาทรอนิกส์ | 机电一体化"
    },
    {
        "id":3258,
        "name":"3259 (Thai Program)  :  Integrated Mathematics Science | วิทยาศาสตร์คณิตศาสตร์บูรณาการ | 综合数学科学"
    },
    {
        "id":3259,
        "name":"3260 (Thai Program)  :  Promote Agriculture And Rural Development | ส่งเสริมการเกษตรและพัฒนาชนบท | 促进农业农村发展"
    },
    {
        "id":3260,
        "name":"3261 (Thai Program)  :  Soil Science And Natural Resources Management | ปฐพีศาสตร์และการจัดการทรัพยากรธรรมชาติ | 土壤科学与自然资源管理"
    },
    {
        "id":3261,
        "name":"3262 (Thai Program)  :  Pharmacy Management | การจัดการเภสัชกรรม | 药房管理"
    },
    {
        "id":3262,
        "name":"3263 (Thai Program)  :  Clinical Epidemiology | ระบาดวิทยาคลินิก | 临床流行病学"
    },
    {
        "id":3263,
        "name":"3264 (Thai Program)  :  Orthopedic | ออร์โธปิดิกส์ | 骨科"
    },
    {
        "id":3264,
        "name":"3265 (Thai Program)  :  Medical Radiation Science | วิทยาศาสตร์รังสีการแพทย์ | 医学放射科学"
    },
    {
        "id":3265,
        "name":"3266 (Thai Program)  :  Communication Studies | การสื่อสารศึกษา | 传播学"
    },
    {
        "id":3266,
        "name":"3267 (Thai Program)  :  Media Art And Media Design | สื่อศิลปะและการออกแบบสื่อ | 媒体艺术和媒体设计"
    },
    {
        "id":3267,
        "name":"3268 (Thai Program)  :  Photography Art | ศิลปการถ่ายภาพ | 摄影艺术"
    },
    {
        "id":3268,
        "name":"3269 (English Program)  :  Counseling Psychology And Guidance | จิตวิทยาการให้คำปรึกษาและการแนะแนว | 心理咨询与指导"
    },
    {
        "id":3269,
        "name":"3270 (Thai Program)  :  Integrated Communication Arts | นิเทศศาสตร์บูรณาการ | 综合传播艺术"
    },
    {
        "id":3270,
        "name":"3271 (Thai Program)  :  Biological Chemistry | เคมีชีวภาพ | 生物化学"
    },
    {
        "id":3271,
        "name":"3272 (Thai Program)  :  Applied Biological Sciences | วิทยาศาสตร์ชีวภาพประยุกต์ | 应用生物科学"
    },
    {
        "id":3272,
        "name":"3273 (Thai Program)  :  Environmental Toxicology | พิษวิทยาสิ่งแวดล้อม | 环境毒理学"
    },
    {
        "id":3273,
        "name":"3274 (Thai Program)  :  Agricultural And Food Engineering | วิศวกรรมเกษตรและอาหาร | 农业与食品工程"
    },
    {
        "id":3274,
        "name":"3275 (Thai Program)  :  Construction Engineering And Management | วิศวกรรมก่อสร้างและการจัดการ | 建筑工程与管理"
    },
    {
        "id":3275,
        "name":"3276 (Thai Program)  :  Interdisciplinary Biodiversity Management | สหวิทยาการจัดการความหลากหลายทางชีวภาพ | 跨学科生物多样性管理"
    },
    {
        "id":3276,
        "name":"3277 (Thai Program)  :  Educational Innovation Research | การวิจัยนวัตกรรมการศึกษา | 教育创新研究"
    },
    {
        "id":3277,
        "name":"3278 (Thai Program)  :  Veterinary Internal Medicine | อายุรศาสตร์สัตวแพทย์ | 兽医内科"
    },
    {
        "id":3278,
        "name":"3279 (Thai Program)  :  Technology Business And Innovation Management | ธุรกิจเทคโนโลยีและการจัดการนวัตกรรม | 科技业务与创新管理"
    },
    {
        "id":3279,
        "name":"3280 (Thai Program)  :  Biomedical Engineering | วิศวกรรมชีวเวช | 生物医学工程"
    },
    {
        "id":3280,
        "name":"3281 (Thai Program)  :  Nano Science And Technology | วิทยาศาสตร์นาโนและเทคโนโลยี | 纳米科学与技术"
    },
    {
        "id":3281,
        "name":"3282 (English Program)  :  Educational Psychology | จิตวิทยาการศึกษา | 教育心理学"
    },
    {
        "id":3282,
        "name":"3283 (Thai Program)  :  Pediatric Blood Disease\/Oncology | กุมารเวชศาสตร์โรคเลือด\/มะเร็งวิทยา | 儿科血液疾病\/肿瘤学"
    },
    {
        "id":3283,
        "name":"3284 (Thai Program)  :  Civil Engineering Infrastructure | โครงสร้างพื้นฐานทางวิศวกรรมโยธา | 土木工程基础设施"
    },
    {
        "id":3284,
        "name":"3285 (Thai Program)  :  Japanese Is A Foreign Language. | ภาษาญี่ปุ่นเป็นภาษาต่างประเทศ | 日语是一门外语。"
    },
    {
        "id":3285,
        "name":"3286 (Thai Program)  :  Nuclear Medicine | เวชศาสตร์นิวเคลียร์ | 核医学"
    },
    {
        "id":3286,
        "name":"3287 (Thai Program)  :  French For The Business World | ภาษาฝรั่งเศสสู่โลกธุรกิจ | 商业法语"
    },
    {
        "id":3287,
        "name":"3288 (Thai Program)  :  Fuel Technology | เทคโนโลยีเชื้อเพลิง | 燃料技术"
    },
    {
        "id":3288,
        "name":"3289 (English Program)  :  Educational Psychology And Guidance | จิตวิทยาการศึกษาและการแนะแนว | 教育心理学与指导"
    },
    {
        "id":3289,
        "name":"3290 (Thai Program)  :  Corporate Governance | การกำกับดูแลกิจการ | 公司治理"
    },
    {
        "id":3290,
        "name":"3291 (Thai Program)  :  Logistics And Supply Chain Management | การจัดการโลจิสติกส์และซัพพลายเชน | 物流和供应链管理"
    },
    {
        "id":3291,
        "name":"3292 (Thai Program)  :  Mold Engineering | วิศวกรรมแม่พิมพ์ | 模具工程"
    },
    {
        "id":3292,
        "name":"3293 (Thai Program)  :  Teaching Chinese As A Foreign Language | การสอนภาษาจีนในฐานะภาษาต่างประเทศ | 对外汉语教学"
    },
    {
        "id":3293,
        "name":"3294 (Thai Program)  :  Folk Music And Performance | ดนตรีและการแสดงพื้นเมือง | 民间音乐和表演"
    },
    {
        "id":3294,
        "name":"3295 (Thai Program)  :  Design, Industrial Product Design Branch | การออกแบบ แขนงออกแบบผลิตภัณฑ์อุตสาหกรรม | 设计、工业产品设计分院"
    },
    {
        "id":3295,
        "name":"3296 (Thai Program)  :  Design, Computer Graphics Field | การออกแบบ แขนงคอมพิวเตอร์กราฟิก | 设计、计算机图形学领域"
    },
    {
        "id":3296,
        "name":"3297 (Thai Program)  :  Design: Packaging Design Branch | การออกแบบ แขนงออกแบบบรรจุภัณฑ์ | 设计：包装设计分公司"
    },
    {
        "id":3297,
        "name":"3298 (Thai Program)  :  Administrative Science | บริหารศาสตร์ | 行政科学"
    },
    {
        "id":3298,
        "name":"3299 (Thai Program)  :  Filming | การภาพยนตร์ | 拍摄"
    },
    {
        "id":3299,
        "name":"3300 (Thai Program)  :  Pharmacology And Biomolecular Sciences | เภสัชวิทยาและวิทยาศาสตร์ชีวโมเลกุล | 药理学和生物分子科学"
    },
    {
        "id":3300,
        "name":"3301 (Thai Program)  :  Strategic Management | การบริหารเชิงกลยุทธ์ | 战略管理"
    },
    {
        "id":3301,
        "name":"3302 (Thai Program)  :  Classical Music | ดนตรีคลาสสิค | 古典音乐"
    },
    {
        "id":3302,
        "name":"3303 (Thai Program)  :  Computer And Network Engineering | วิศวกรรมคอมพิวเตอร์และเครือข่าย | 计算机与网络工程"
    },
    {
        "id":3303,
        "name":"3304 (Thai Program)  :  Telecommunications And Electronics Engineering | วิศวกรรมโทรคมนาคมและอิเล็กทรอนิกส์ | 电信与电子工程"
    },
    {
        "id":3304,
        "name":"3305 (Thai Program)  :  Agricultural Chemistry | เกษตรเคมี | 农业化学"
    },
    {
        "id":3305,
        "name":"3306 (Thai Program)  :  Agricultural Product Processing Engineering | วิศวกรรมการแปรรูปผลผลิตเกษตร | 农产品加工工程"
    },
    {
        "id":3306,
        "name":"3307 (Thai Program)  :  Sustainable Social Landscape Development | การพัฒนาภูมิสังคมอย่างยั่งยืน | 可持续的社会景观发展"
    },
    {
        "id":3307,
        "name":"3308 (Thai Program)  :  Recreation And Tourism Management | การจัดการนันทนาการและการท่องเที่ยว | 休闲旅游管理"
    },
    {
        "id":3308,
        "name":"3309 (Thai Program)  :  Materials Science (Rubber Industry) | วัสดุศาสตร์(อุตสาหกรรมยาง) | 材料科学（橡胶工业）"
    },
    {
        "id":3309,
        "name":"3310 (Thai Program)  :  Conflict Management | การจัดการความขัดแย้ง | 冲突管理"
    },
    {
        "id":3310,
        "name":"3311 (Thai Program)  :  Design And Planning | การออกแบบและวางแผน | 设计与规划"
    },
    {
        "id":3311,
        "name":"3312 (Thai Program)  :  Electronics And Computer Systems Engineering | วิศวกรรมอิเล็กทรอนิกส์และระบบคอมพิวเตอร์ | 电子与计算机系统工程"
    },
    {
        "id":3312,
        "name":"3313 (Thai Program)  :  Programming And Web Security | การโปรแกรมและการรักษาความปลอดภัยบนเว็บ | 编程和网络安全"
    },
    {
        "id":3313,
        "name":"3314 (Thai Program)  :  Tourism In The Sufficiency Economy Dimension | การท่องเที่ยวในมิติเศรษฐกิจพอเพียง | 自给自足经济维度中的旅游业"
    },
    {
        "id":3314,
        "name":"3315 (Thai Program)  :  Strategic Information System Management | การจัดการระบบสารสนเทศเชิงกลยุทธ์ | 战略信息系统管理"
    },
    {
        "id":3315,
        "name":"3316 (English Program)  :  Microwave Physics | ฟิสิกส์ไมโครเวฟ | 微波物理"
    },
    {
        "id":3316,
        "name":"3317 (English Program)  :  Cognitive Science And Computational Modeling | วิทยาศาสตร์เกี่ยวกับความรู้ความเข้าใจและแบบจำลองทางคอมพิวเตอร์ | 认知科学和计算模型"
    },
    {
        "id":3317,
        "name":"3318 (English Program)  :  Rural And Regional Development Planning | การวางแผนพัฒนาชนบทและภูมิภาค | 农村和区域发展规划"
    },
    {
        "id":3318,
        "name":"3319 (English Program)  :  Communication And Computing | การสื่อสารและคอมพิวเตอร์ | 通信和计算"
    },
    {
        "id":3319,
        "name":"3320 (English Program)  :  Heat Transfer | การถ่ายเทความร้อน | 热传递"
    },
    {
        "id":3320,
        "name":"3321 (Thai Program)  :  Biotechnology Management | การจัดการเทคโนโลยีชีวภาพ | 生物技术管理"
    },
    {
        "id":3321,
        "name":"3322 (English Program)  :  Financial And Marketing Management | การจัดการทางการเงินและการตลาด | 财务和营销管理"
    },
    {
        "id":3322,
        "name":"3323 (English Program)  :  Environmental Technology And Biotechnology | เทคโนโลยีสิ่งแวดล้อมและเทคโนโลยีชีวภาพ | 环境技术和生物技术"
    },
    {
        "id":3323,
        "name":"3324 (Thai Program)  :  Research And Evaluate Education | วิจัยและประเมินการศึกษา | 研究和评估教育"
    },
    {
        "id":3324,
        "name":"3325 (Thai Program)  :  Educational Quality Management | การจัดการคุณภาพการศึกษา | 教育质量管理"
    },
    {
        "id":3325,
        "name":"3326 (Thai Program)  :  Mathematics-Educational Research And Evaluation | คณิตศาสตร์-วิจัยและประเมินการศึกษา | 数学-教育研究与评估"
    },
    {
        "id":3326,
        "name":"3327 (Thai Program)  :  Information Technology Management | การจัดการเทคโนโลยีสารสนเทศ | 信息技术管理"
    },
    {
        "id":3327,
        "name":"3328 (Thai Program)  :  Justice And Social Administration | การบริหารงานยุติธรรมและสังคม | 司法和社会管理"
    },
    {
        "id":3328,
        "name":"3329 (Thai Program)  :  Packaging Technology | เทคโนโลยีบรรจุภัณฑ์ | 包装技术"
    },
    {
        "id":3329,
        "name":"3330 (Thai Program)  :  Biomedical Electronics | อิเล็กทรอนิกส์ชีวการแพทย์ | 生物医学电子学"
    },
    {
        "id":3330,
        "name":"3331 (Thai Program)  :  Food Preparation And Service Technology | เทคโนโลยีการจัดและบริการอาหาร | 食品制备和服务技术"
    },
    {
        "id":3331,
        "name":"3332 (Thai Program)  :  Agricultural Business Administration | บริหารธุรกิจเกษตร | 农业工商管理"
    },
    {
        "id":3332,
        "name":"3333 (Thai Program)  :  Interdisciplinary Research For Design | สหวิทยาการการวิจัยเพื่อการออกแบบ | 设计的跨学科研究"
    },
    {
        "id":3333,
        "name":"3334 (Thai Program)  :  Multimedia And Internet Engineering | วิศวกรรมมัลติมีเดียและระบบอินเทอร์เน็ต | 多媒体与互联网工程"
    },
    {
        "id":3334,
        "name":"3335 (Thai Program)  :  Strategic Logistics Management | การจัดการโลจิสติกส์เชิงยุทธศาสตร์ | 战略物流管理"
    },
    {
        "id":3335,
        "name":"3336 (Thai Program)  :  Business English Communication | การสื่อสารภาษาอังกฤษเชิงธุรกิจ | 商务英语沟通"
    },
    {
        "id":3336,
        "name":"3337 (Thai Program)  :  Development Economics | เศรษฐศาสตร์พัฒนา | 发展经济学"
    },
    {
        "id":3337,
        "name":"3338 (English Program)  :  Financial Management | การจัดการทางการเงิน | 财务管理"
    },
    {
        "id":3338,
        "name":"3339 (English Program)  :  Innovation Management | การจัดการนวัตกรรม | 创新管理"
    },
    {
        "id":3339,
        "name":"3340 (English Program)  :  Management And Strategy | การจัดการและกลยุทธ์ | 管理与策略"
    },
    {
        "id":3340,
        "name":"3341 (Thai Program)  :  Management To Create New Business | การจัดการเพื่อสร้างธุรกิจใหม่ | 管理创造新业务"
    },
    {
        "id":3341,
        "name":"3342 (English Program)  :  Nursing Management | การจัดการพยาบาล | 护理管理"
    },
    {
        "id":3342,
        "name":"3343 (English Program)  :  Public Sector Management | การจัดการภาครัฐ | 公共部门管理"
    },
    {
        "id":3343,
        "name":"3344 (English Program)  :  Chemical And Biochemical Engineering | วิศวกรรมเคมีและชีวเคมี | 化学与生化工程"
    },
    {
        "id":3344,
        "name":"3345 (English Program)  :  Metallurgy And Materials | โลหะวิทยาและวัสดุ | 冶金与材料"
    },
    {
        "id":3345,
        "name":"3346 (English Program)  :  Organic Synthesis | การสังเคราะห์สารอินทรีย์ | 有机合成"
    },
    {
        "id":3346,
        "name":"3347 (English Program)  :  Urban And Environmental Engineering | วิศวกรรมเมืองและสิ่งแวดล้อม | 城市与环境工程"
    },
    {
        "id":3347,
        "name":"3348 (Thai Program)  :  Educational Leadership And Innovation | ภาวะผู้นำและนวัตกรรมทางการศึกษา | 教育领导与创新"
    },
    {
        "id":3348,
        "name":"3349 (Thai Program)  :  Organizing Science And Technology Teaching | การจัดการเรียนการสอนวิทยาศาสตร์และเทคโนโลยี | 组织科技教学"
    },
    {
        "id":3349,
        "name":"3350 (Thai Program)  :  Industrial Production Management | การจัดการผลิตทางอุตสาหกรรม | 工业生产管理"
    },
    {
        "id":3350,
        "name":"3351 (Thai Program)  :  Language For Development | ภาษาเพื่อการพัฒนา | 语言促进发展"
    },
    {
        "id":3351,
        "name":"3352 (Thai Program)  :  Information And Computer Management | การจัดการสารสนเทศและคอมพิวเตอร์ | 信息和计算机管理"
    },
    {
        "id":3352,
        "name":"3353 (Thai Program)  :  Molecular Biology And Bioinformatics | ชีววิทยาโมเลกุลและชีวสารสนเทศ | 分子生物学和生物信息学"
    },
    {
        "id":3353,
        "name":"3354 (English Program)  :  Chinese Word Literature | วรรณกรรมคำจีน | 中文文字文学"
    },
    {
        "id":3354,
        "name":"3355 (English Program)  :  Human Environmental Science | วิทยาศาสตร์สิ่งแวดล้อมของมนุษย์ | 人类环境科学"
    },
    {
        "id":3355,
        "name":"3356 (English Program)  :  International Marketing | การตลาดระหว่างประเทศ | 国际营销"
    },
    {
        "id":3356,
        "name":"3357 (English Program)  :  Hospitality Business | ธุรกิจการบริการ | 酒店业务"
    },
    {
        "id":3357,
        "name":"3358 (English Program)  :  Strategy And Nulticultural Management | กลยุทธ์และการจัดการวัฒนธรรม | 战略和文化管理"
    },
    {
        "id":3358,
        "name":"3359 (English Program)  :  3D Animation\/Digital Effects | แอนิเมชัน 3 มิติ\/เอฟเฟ็กต์ดิจิทัล | 3D 动画\/数字效果"
    },
    {
        "id":3359,
        "name":"3360 (Thai Program)  :  Business Administration (Ceo) | บริหารธุรกิจ (CEO) | 工商管理（首席执行官）"
    },
    {
        "id":3360,
        "name":"3361 (Thai Program)  :  Automotive Industry Management | การจัดการอุตสาหกรรมยานยนต์ | 汽车行业管理"
    },
    {
        "id":3361,
        "name":"3362 (Thai Program)  :  Public Management | การจัดการสาธารณะ | 公共管理"
    },
    {
        "id":3362,
        "name":"3363 (Thai Program)  :  Thai Dance | นาฏกรรมไทย | 泰国舞蹈"
    },
    {
        "id":3363,
        "name":"3364 (Thai Program)  :  Thai Luk Krung Music | ดนตรีไทยลูกกรุง | 泰禄恭音乐"
    },
    {
        "id":3364,
        "name":"3365 (Thai Program)  :  Thai Country Music | ดนตรีไทยลูกทุ่ง | 泰国乡村音乐"
    },
    {
        "id":3365,
        "name":"3366 (Thai Program)  :  Finance And Banking | การเงินและการธนาคาร | 金融与银行"
    },
    {
        "id":3366,
        "name":"3367 (Thai Program)  :  Physical Education (Other Minor Subjects) | พลศึกษา (วิชาโทอื่นๆ) | 体育（其他辅修科目）"
    },
    {
        "id":3367,
        "name":"3368 (Thai Program)  :  Psychology Of Counseling And Guidance Services | จิตวิทยาการบริการปรึกษาและแนะแนว | 心理咨询与指导服务"
    },
    {
        "id":3368,
        "name":"3369 (Thai Program)  :  Educational Development | การพัฒนาการศึกษา | 教育发展"
    },
    {
        "id":3369,
        "name":"3370 (Thai Program)  :  Geographic Information For Local Development | สารสนเทศภูมิศาสตร์เพื่อการพัฒนาท้องถิ่น | 促进地方发展的地理信息"
    },
    {
        "id":3370,
        "name":"3371 (Thai Program)  :  Special Education Administration | การบริหารการศึกษาพิเศษ | 特殊教育管理"
    },
    {
        "id":3371,
        "name":"3372 (English Program)  :  Audio-Visual | ภาพและเสียง | 视听"
    },
    {
        "id":3372,
        "name":"3373 (English Program)  :  Business Education And Management | การศึกษาและการจัดการธุรกิจ | 商业教育与管理"
    },
    {
        "id":3373,
        "name":"3374 (English Program)  :  Children Literature | วรรณกรรมเด็ก | 儿童文学"
    },
    {
        "id":3374,
        "name":"3375 (English Program)  :  Children Literature'S Studies | การศึกษาวรรณกรรมเด็ก | 儿童文学研究"
    },
    {
        "id":3375,
        "name":"3376 (English Program)  :  Computer Engineering Management | การจัดการวิศวกรรมคอมพิวเตอร์ | 计算机工程管理"
    },
    {
        "id":3376,
        "name":"3377 (English Program)  :  Early Childhood | วัยเด็กตอนต้น | 幼儿期"
    },
    {
        "id":3377,
        "name":"3378 (English Program)  :  Educational Policy Studies | การศึกษานโยบายการศึกษา | 教育政策研究"
    },
    {
        "id":3378,
        "name":"3379 (English Program)  :  Engineering Materials | วัสดุทางวิศวกรรม | 工程材料"
    },
    {
        "id":3379,
        "name":"3380 (English Program)  :  English Language | ภาษาอังกฤษ | 英语"
    },
    {
        "id":3380,
        "name":"3381 (English Program)  :  General Administrative Leadership | ภาวะผู้นำการบริหารทั่วไป | 一般行政领导"
    },
    {
        "id":3381,
        "name":"3382 (English Program)  :  General Purposes | วัตถุประสงค์ทั่วไป | 一般用途"
    },
    {
        "id":3382,
        "name":"3383 (English Program)  :  Health And Safety Education | การศึกษาด้านสุขภาพและความปลอดภัย | 健康安全教育"
    },
    {
        "id":3383,
        "name":"3384 (English Program)  :  Industrial Education Management | การจัดการศึกษาอุตสาหกรรม | 工业教育管理"
    },
    {
        "id":3384,
        "name":"3385 (English Program)  :  International Trade And Finance | การค้าระหว่างประเทศและการเงิน | 国际贸易与金融"
    },
    {
        "id":3385,
        "name":"3386 (English Program)  :  Linguistics And English Language Teaching | ภาษาศาสตร์และการสอนภาษาอังกฤษ | 语言学和英语教学"
    },
    {
        "id":3386,
        "name":"3387 (English Program)  :  Measurement Evaluation & Research Design | การประเมินการวัดและการออกแบบการวิจัย | 测量评估与研究设计"
    },
    {
        "id":3387,
        "name":"3388 (English Program)  :  Molecular Reproductive Biology | ชีววิทยาการเจริญพันธุ์ระดับโมเลกุล | 分子生殖生物学"
    },
    {
        "id":3388,
        "name":"3389 (English Program)  :  Oral And Craniofacioal Sciences | วิทยาศาสตร์ช่องปากและกะโหลกศีรษะ | 口腔和颅面科学"
    },
    {
        "id":3389,
        "name":"3390 (English Program)  :  Pharmacology And Toxicology Of Nutrition | เภสัชวิทยาและพิษวิทยาของโภชนาการ | 营养药理学和毒理学"
    },
    {
        "id":3390,
        "name":"3391 (English Program)  :  Pharmazie | เภสัชกรรม | 制药业"
    },
    {
        "id":3391,
        "name":"3392 (English Program)  :  Physiology And Pharmacology | สรีรวิทยาและเภสัชวิทยา | 生理学和药理学"
    },
    {
        "id":3392,
        "name":"3393 (English Program)  :  Statistical Theory And Applications | ทฤษฎีทางสถิติและการประยุกต์ | 统计理论与应用"
    },
    {
        "id":3393,
        "name":"3394 (English Program)  :  Teaching Of English | การสอนภาษาอังกฤษ | 英语教学"
    },
    {
        "id":3394,
        "name":"3395 (English Program)  :  Teaching Of English As A Foreign Language | การสอนภาษาอังกฤษเป็นภาษาต่างประเทศ | 英语作为外语的教学"
    },
    {
        "id":3395,
        "name":"3396 (English Program)  :  The Department Of Education | กรมสามัญศึกษา | 教育部"
    },
    {
        "id":3396,
        "name":"3397 (English Program)  :  Veterinary Biosciences | ชีววิทยาศาสตร์ทางสัตวแพทย์ | 兽医生物科学"
    },
    {
        "id":3397,
        "name":"3398 (English Program)  :  Women'S Studies | การศึกษาของผู้หญิง | 女性研究"
    },
    {
        "id":3398,
        "name":"3399 (Thai Program)  :  Physical And Occupational Therapy | กายภาพและกิจกรรมบำบัด | 物理和职业治疗"
    },
    {
        "id":3399,
        "name":"3400 (Thai Program)  :  Finance And Finance | การเงิน และการคลัง | 金融与金融"
    },
    {
        "id":3400,
        "name":"3402 (Thai Program)  :  Financial Management | การจัดการการเงิน | 财务管理"
    },
    {
        "id":3401,
        "name":"3403 (Thai Program)  :  Marketing And Sales | การตลาดและการขาย | 营销和销售"
    },
    {
        "id":3402,
        "name":"3404 (Thai Program)  :  Photography And Cinematography | การถ่ายรูปและการถ่ายภาพยนตร์ | 摄影和电影摄影"
    },
    {
        "id":3403,
        "name":"3405 (Thai Program)  :  Career Guidance | การแนะแนวอาชีพ | 职业指导"
    },
    {
        "id":3404,
        "name":"3406 (Thai Program)  :  Educational Administration And Community Studies | การบริหารการศึกษาและการชุมชนศึกษา | 教育行政和社区研究"
    },
    {
        "id":3405,
        "name":"3407 (Thai Program)  :  Industrial Education Administration | การบริหารการศึกษาอุตสาหกรรม | 工业教育管理局"
    },
    {
        "id":3406,
        "name":"3408 (Thai Program)  :  News Management | การบริหารข่าวสาร | 新闻管理"
    },
    {
        "id":3407,
        "name":"3409 (Thai Program)  :  Administration Focuses On The Library Aspect. | การบริหารเน้นด้านห้องสมุด | 管理重点是图书馆方面。"
    },
    {
        "id":3408,
        "name":"3410 (Thai Program)  :  Educational Administration And Planning | การบริหารและวางแผนการศึกษา | 教育行政与规划"
    },
    {
        "id":3409,
        "name":"3411 (Thai Program)  :  Institutional Administration | การบริหารสถาบัน | 机构管理"
    },
    {
        "id":3410,
        "name":"3412 (Thai Program)  :  Higher Education Administration | การบริหารอุดมศึกษา | 高等教育管理"
    },
    {
        "id":3411,
        "name":"3413 (Thai Program)  :  Local Government And Administration | การปกครองและการบริหารท้องถิ่น | 地方政府和行政部门"
    },
    {
        "id":3412,
        "name":"3414 (Thai Program)  :  Data Processing By Computer | การประมวลผลข้อมูลด้วยเครื่องคอมพิวเตอร์ | 计算机数据处理"
    },
    {
        "id":3413,
        "name":"3415 (Thai Program)  :  Midwifery | การผดุงครรภ์ | 助产士"
    },
    {
        "id":3414,
        "name":"3416 (Thai Program)  :  General Teacher Training | การฝึกหัดครูทั่วไป | 一般教师培训"
    },
    {
        "id":3415,
        "name":"3417 (Thai Program)  :  Psychiatric Nursing | การพยาบาลจิตเวช | 精神科护理"
    },
    {
        "id":3416,
        "name":"3418 (Thai Program)  :  Nursing And Midwifery | การพยาบาลและการผดุงครรภ์ | 护理和助产学"
    },
    {
        "id":3417,
        "name":"3419 (Thai Program)  :  Development Of Specialized Education | การพัฒนาการศึกษาเฉพาะด้าน | 发展专门教育"
    },
    {
        "id":3418,
        "name":"3420 (Thai Program)  :  International Affairs And Diplomacy | การระหว่างประเทศและการฑูต | 国际事务和外交"
    },
    {
        "id":3419,
        "name":"3421 (Thai Program)  :  Educational Measurement And Statistics | การวัดผลการศึกษาและสถิติ | 教育测量与统计"
    },
    {
        "id":3420,
        "name":"3422 (Thai Program)  :  Planning | การวางแผน | 规划"
    },
    {
        "id":3421,
        "name":"3423 (Thai Program)  :  Food And Nutrition Consumer Research | การวิจัยผู้บริโภคอาหารและโภชนาการ | 食品与营养消费者研究"
    },
    {
        "id":3422,
        "name":"3424 (Thai Program)  :  Behavioral Science Research | การวิจัยพฤติกรรมศาสตร์ | 行为科学研究"
    },
    {
        "id":3423,
        "name":"3425 (Thai Program)  :  Preschool Education | การศึกษาก่อนวัยเรียน | 幼儿教育"
    },
    {
        "id":3424,
        "name":"3426 (Thai Program)  :  Education Of Intelligent Children | การศึกษาเด็กปัญญาเลิศ | 智力儿童的教育"
    },
    {
        "id":3425,
        "name":"3427 (Thai Program)  :  Education Of Mentally Retarded Children | การศึกษาเด็กปัญญาอ่อน | 弱智儿童的教育"
    },
    {
        "id":3426,
        "name":"3428 (Thai Program)  :  Regional Cultural Studies | การศึกษาวัฒนธรรมภูมิภาค | 地域文化研究"
    },
    {
        "id":3427,
        "name":"3429 (Thai Program)  :  Environmental Studies | การศึกษาสิ่งแวดล้อม | 环境研究"
    },
    {
        "id":3428,
        "name":"3430 (Thai Program)  :  Teaching Korean | การสอนภาษาเกาหลี | 韩语教学"
    },
    {
        "id":3429,
        "name":"3431 (Thai Program)  :  Teaching German | การสอนภาษาเยอรมัน | 德语教学"
    },
    {
        "id":3430,
        "name":"3432 (Thai Program)  :  Community Design | การออกแบบชุมชน | 社区设计"
    },
    {
        "id":3431,
        "name":"3433 (Thai Program)  :  Vocational Electrical And Electronics | การอาชีวะไฟฟ้าและอิเลคทรอนิคส์ | 职业电气和电子"
    },
    {
        "id":3432,
        "name":"3434 (Thai Program)  :  Metal Vocational | การอาชีวะโลหะ | 金属职业"
    },
    {
        "id":3433,
        "name":"3435 (Thai Program)  :  Higher Education And Teacher Training | การอุดมศึกษาและฝึกหัดครู | 高等教育和教师培训"
    },
    {
        "id":3434,
        "name":"3436 (Thai Program)  :  Agriculture, Forestry And Fisheries | เกษตรศาสตร์ วนศาสตร์ และการประมง | 农林渔业"
    },
    {
        "id":3435,
        "name":"3437 (Thai Program)  :  Agricultural Studies, Horticulture | เกษตรศึกษาพืชสวน | 农业研究、园艺"
    },
    {
        "id":3436,
        "name":"3438 (Thai Program)  :  Mathematics-Chemistry | คณิตศาสตร์-เคมี | 数学-化学"
    },
    {
        "id":3437,
        "name":"3439 (Thai Program)  :  General Legal Knowledge | ความรู้เกี่ยวกับกฎหมายทั่วไป | 一般法律知识"
    },
    {
        "id":3438,
        "name":"3440 (Thai Program)  :  Physical Chemistry | เคมีกายภาพ | 物理化学"
    },
    {
        "id":3439,
        "name":"3441 (Thai Program)  :  Laboratory Chemistry-Petrochemicals | เคมีปฏิบัติการ-ปิโตรเคมี | 实验室化学-石油化工"
    },
    {
        "id":3440,
        "name":"3442 (Thai Program)  :  Textile Chemistry | เคมีสิ่งทอ | 纺织化学"
    },
    {
        "id":3441,
        "name":"3443 (Thai Program)  :  Industrial Machinery | เครื่องกลอุตสาหกรรม | 工业机械"
    },
    {
        "id":3442,
        "name":"3444 (Thai Program)  :  Home Economics | เคหเศรษฐศาสตร์ | 家政"
    },
    {
        "id":3443,
        "name":"3445 (Thai Program)  :  Psychology-Mathematics | จิตตศาสตร์-คณิตศาสตร์ | 心理学-数学"
    },
    {
        "id":3444,
        "name":"3446 (Thai Program)  :  Educational Guidance Psychology | จิตวิทยาการแนะแนวการศึกษา | 教育指导心理学"
    },
    {
        "id":3445,
        "name":"3447 (Thai Program)  :  Psychiatry | จิตเวช | 精神病学"
    },
    {
        "id":3446,
        "name":"3448 (Thai Program)  :  Child And Adolescent Psychiatry | จิตเวชศาสตร์เด็กและวัยรุ่น | 儿童和青少年精神病学"
    },
    {
        "id":3447,
        "name":"3449 (Thai Program)  :  Craftsman | ช่างฝีมือ | 工匠"
    },
    {
        "id":3448,
        "name":"3450 (Thai Program)  :  Biomedical | ชีวภาพการแพทย์ | 生物医学"
    },
    {
        "id":3449,
        "name":"3451 (Thai Program)  :  Music (Thai) | ดุริยาศาสตร์(ไทย) | 音乐（泰语）"
    },
    {
        "id":3450,
        "name":"3452 (Thai Program)  :  Dentistry | ทันตกรรม | 牙科"
    },
    {
        "id":3451,
        "name":"3453 (Thai Program)  :  Visual Arts - Modern Art | ทัศนศิลป์ - ศิลปะสมัยใหม่ | 视觉艺术 - 现代艺术"
    },
    {
        "id":3452,
        "name":"3454 (Thai Program)  :  Visual Arts-Painting | ทัศนศิลป์-จิตรกรรม | 视觉艺术-绘画"
    },
    {
        "id":3453,
        "name":"3455 (Thai Program)  :  English Language Career Techniques | เทคนิคการอาชีพภาษาอังกฤษบริการ | 英语语言职业技巧"
    },
    {
        "id":3454,
        "name":"3456 (Thai Program)  :  Fishery Engineering Techniques | เทคนิควิศวกรรมประมง | 渔业工程技术"
    },
    {
        "id":3455,
        "name":"3457 (Thai Program)  :  Forestry And Agricultural Engineering Techniques | เทคนิควิศวกรรมป่าไม้และเกษตร | 林业和农业工程技术"
    },
    {
        "id":3456,
        "name":"3458 (Thai Program)  :  Civil Engineering Techniques | เทคนิควิศวกรรมโยธา | 土木工程技术"
    },
    {
        "id":3457,
        "name":"3459 (Thai Program)  :  Textile Techniques | เทคนิคสิ่งทอ | 纺织技术"
    },
    {
        "id":3458,
        "name":"3460 (Thai Program)  :  Administrative And Environmental Technology | เทคโนโลยีการบริหารและสิ่งแวดล้อม | 行政和环境技术"
    },
    {
        "id":3459,
        "name":"3461 (Thai Program)  :  Community Technology | เทคโนโลยีชุมชน | 社区技术"
    },
    {
        "id":3460,
        "name":"3462 (Thai Program)  :  Technology And Cultural Studies | เทคโนโลยีและวัฒนธรรมศึกษา | 技术与文化研究"
    },
    {
        "id":3461,
        "name":"3463 (Thai Program)  :  Product Cycle Technology | เทคโนโลยีวนผลิตภัณฑ์ | 产品周期技术"
    },
    {
        "id":3462,
        "name":"3464 (Thai Program)  :  Post-Harvest Technology And Food Engineering | เทคโนโลยีหลังการเก็บเกี่ยวและวิศวกรรมอาหาร | 收获后技术和食品工程"
    },
    {
        "id":3463,
        "name":"3465 (Thai Program)  :  Electronic Technology | เทคโนโลยีอิเลคโทรนิคส์ | 电子技术"
    },
    {
        "id":3464,
        "name":"3466 (Thai Program)  :  Thai Studies (Emphasis On Human Studies) | ไทยคดีศึกษา(เน้นทางมนุษย์) | 泰国研究（强调人类研究）"
    },
    {
        "id":3465,
        "name":"3467 (Thai Program)  :  Thai Studies (Social Focus) | ไทยคดีศึกษา(เน้นทางสังคม) | 泰国研究（社会焦点）"
    },
    {
        "id":3466,
        "name":"3468 (Thai Program)  :  Business Studies(Accounting) | ธรุกิจศึกษา(การบัญชี) | 商业研究（会计）"
    },
    {
        "id":3467,
        "name":"3469 (Thai Program)  :  Business Studies(Marketing) | ธุรกิจศึกษา(การตลาด) | 商业研究（市场营销）"
    },
    {
        "id":3468,
        "name":"3470 (Thai Program)  :  International Dance | นาฏศิลป์สากล | 国际舞蹈"
    },
    {
        "id":3469,
        "name":"3471 (Thai Program)  :  Nuclear Physics | นิวเคลียร์ฟิสิกส์ | 核物理"
    },
    {
        "id":3470,
        "name":"3472 (Thai Program)  :  Business Administration And Commerce (Business Studies) | บริหารธุรกิจและพาณิชยศาสตร์(ธุรกิจศึกษา) | 工商管理和商业（商业研究）"
    },
    {
        "id":3471,
        "name":"3473 (Thai Program)  :  Administration And Management | บริหารและการจัดการ | 行政及管理"
    },
    {
        "id":3472,
        "name":"3474 (English Program)  :  Guidance Psychology | จิตวิทยาการแนะแนว | 指导心理学"
    },
    {
        "id":3473,
        "name":"3475 (Thai Program)  :  Population And Development | ประชากรและพัฒนา | 人口与发展"
    },
    {
        "id":3474,
        "name":"3476 (Thai Program)  :  History And Philosophy Of Art | ประวัติและปรัชญาศิลปะ | 艺术史与艺术哲学"
    },
    {
        "id":3475,
        "name":"3477 (Thai Program)  :  History (Thai) | ประวัติศาสตร์ (ไทย) | 历史（泰语）"
    },
    {
        "id":3476,
        "name":"3478 (Thai Program)  :  History (Asia) | ประวัติศาสตร์ (เอเซีย) | 历史（亚洲）"
    },
    {
        "id":3477,
        "name":"3479 (Thai Program)  :  Eastern Philosophy | ปรัชญาตะวันออก | 东方哲学"
    },
    {
        "id":3478,
        "name":"3480 (Thai Program)  :  Mobile Nurse | พยาบาลเคลื่อนที่ | 流动护士"
    },
    {
        "id":3479,
        "name":"3481 (Thai Program)  :  Advanced Nursing And Midwifery | พยาบาลศาสตร์และผดุงครรภ์ชั้นสูง | 高级护理和助产士"
    },
    {
        "id":3480,
        "name":"3482 (Thai Program)  :  Develop Curriculum | พัฒนาหลักสูตร | 开发课程"
    },
    {
        "id":3481,
        "name":"3483 (Thai Program)  :  Commerce | พาณิชย์กรรม | 商业"
    },
    {
        "id":3482,
        "name":"3484 (Thai Program)  :  Medicine And Related Subjects | แพทยศาสตร์ และวิชาที่เกี่ยวข้อง | 医学及相关学科"
    },
    {
        "id":3483,
        "name":"3485 (Thai Program)  :  Business Language | ภาษาธุรกิจ | 商务语言"
    },
    {
        "id":3484,
        "name":"3486 (Thai Program)  :  Language And Literature | ภาษาและวรรณคดี | 语言文学"
    },
    {
        "id":3485,
        "name":"3487 (Thai Program)  :  German Language And Literature | ภาษาและวรรณคดีเยอรมัน | 德语语言和文学"
    },
    {
        "id":3486,
        "name":"3488 (Thai Program)  :  Linguistics (Southeast Asia) | ภาษาศาสตร์(เอเชียอาคเนย์) | 语言学（东南亚）"
    },
    {
        "id":3487,
        "name":"3489 (Thai Program)  :  Geography(Science) | ภูมิศาสตร์(วิทย์) | 地理（理科）"
    },
    {
        "id":3488,
        "name":"3490 (Thai Program)  :  Geography (Arts) | ภูมิศาสตร์(ศิลป) | 地理（艺术）"
    },
    {
        "id":3489,
        "name":"3491 (Thai Program)  :  Pharmacy - Industrial Pharmacy | เภสัชการ - เภสัชอุตสาหกรรม | 药房 - 工业药房"
    },
    {
        "id":3490,
        "name":"3492 (Thai Program)  :  Humanities, Religion And Theology | มนุษยศาสตร์ ศาสนา และเทววิทยา | 人文、宗教和神学"
    },
    {
        "id":3491,
        "name":"3493 (Thai Program)  :  Gynecological Oncology | มะเร็งวิทยานรีเวช | 妇科肿瘤科"
    },
    {
        "id":3492,
        "name":"3494 (Thai Program)  :  Mold | แม่พิมพ์ | 模具"
    },
    {
        "id":3493,
        "name":"3495 (Thai Program)  :  General Radiology | รังสีวิทยาทั่วไป | 普通放射学"
    },
    {
        "id":3494,
        "name":"3496 (Thai Program)  :  Diagnostic Radiology | รังสีวิทยาวินิจฉัย | 诊断放射学"
    },
    {
        "id":3495,
        "name":"3497 (Thai Program)  :  Mineralogy | แร่วิทยา | 矿物学"
    },
    {
        "id":3496,
        "name":"3498 (Thai Program)  :  Karmic Numbers And Painting | เลขกรรมและจิตรกรรม | 业力数字与绘画"
    },
    {
        "id":3497,
        "name":"3499 (Thai Program)  :  Nursing Research, Evaluation And Administration | วิจัยประเมินผลและการบริหารการพยาบาล | 护理研究、评估和管理"
    },
    {
        "id":3498,
        "name":"3500 (Thai Program)  :  Fine And Applied Arts | วิจิตรศิลป์และประยุกต์ | 美术与应用艺术"
    },
    {
        "id":3499,
        "name":"3501 (Thai Program)  :  Teacher Training Subjects Emphasize Vocational Education. | วิชาการฝึกหัดครูเน้นด้านอาชีวศึกษา | 教师培训科目强调职业教育。"
    },
    {
        "id":3500,
        "name":"3502 (Thai Program)  :  General Subjects In Agriculture | วิชาทั่วไปด้านเกษตรศาสตร์ | 农业普通科目"
    },
    {
        "id":3501,
        "name":"3503 (Thai Program)  :  General Subjects In Mathematics | วิชาทั่วไปด้านคณิตศาสตร์ | 数学一般科目"
    },
    {
        "id":3502,
        "name":"3504 (Thai Program)  :  Secretarial Subjects | วิชาเลขานุการ | 秘书科目"
    },
    {
        "id":3503,
        "name":"3505 (Thai Program)  :  Science (Chemistry) | วิทย์(เคมี) | 科学（化学）"
    },
    {
        "id":3504,
        "name":"3506 (Thai Program)  :  Science(Biology) | วิทย์(ชีววิทยา) | 科学（生物学）"
    },
    {
        "id":3505,
        "name":"3507 (Thai Program)  :  Science(Physics) | วิทย์(ฟิสิกส์) | 科学（物理）"
    },
    {
        "id":3506,
        "name":"3508 (Thai Program)  :  Actuarial Insurance Calculation Science | วิทยาการคำนวณประกันคณิตศาสตร์ประกันภัย | 保险精算计算科学"
    },
    {
        "id":3507,
        "name":"3509 (Thai Program)  :  Oral Disease Diagnosis | วิทยาการวินิจฉัยโรคช่องปาก | 口腔疾病诊断"
    },
    {
        "id":3508,
        "name":"3510 (Thai Program)  :  Natural Science | วิทยาศาสตร์ธรรมชาติ | 自然科学"
    },
    {
        "id":3509,
        "name":"3511 (Thai Program)  :  Clinical Medical Science | วิทยาศาสตร์การแพทย์คลินิก | 临床医学"
    },
    {
        "id":3510,
        "name":"3512 (Thai Program)  :  General Management Science | วิทยาศาสตร์จัดการทั่วไป | 一般管理科学"
    },
    {
        "id":3511,
        "name":"3513 (Thai Program)  :  Applied Polymer Science And Technology | วิทยาศาสตร์พอลิเมอร์ประยุกต์และเทคโนโยี | 应用高分子科学与技术"
    },
    {
        "id":3512,
        "name":"3514 (Thai Program)  :  Basic Nursing Science | วิทยาศาสตร์พื้นฐานการพยาบาล | 护理基础科学"
    },
    {
        "id":3513,
        "name":"3515 (Thai Program)  :  Fisheries Science And Technology | วิทยาศาสตร์และเทคโนโลยีการประมง | 水产科技"
    },
    {
        "id":3514,
        "name":"3516 (Thai Program)  :  Environmental Science | วิทยาศาสตร์สภาวะแวดล้อม | 环境科学"
    },
    {
        "id":3515,
        "name":"3517 (Thai Program)  :  Chemical Engineering And Materials Techniques | วิศวกรรมเคมีและเทคนิควัสดุ | 化学工程与材料技术"
    },
    {
        "id":3516,
        "name":"3518 (Thai Program)  :  Electronic And Electrical Engineering | วิศวกรรมอิเล็กทรอนิกส์และไฟฟ้า | 电子电气工程"
    },
    {
        "id":3517,
        "name":"3519 (Thai Program)  :  Reproductive Medicine | เวชศาสตร์การเจริญพันธุ์ | 生殖医学"
    },
    {
        "id":3518,
        "name":"3520 (Thai Program)  :  Tropical Medicine | เวชศาสตร์เขตร้อน | 热带医学"
    },
    {
        "id":3519,
        "name":"3521 (Thai Program)  :  Surgery And Medical Specialties | ศัลยศาสตร์และการแพทย์เฉพาะทาง | 外科和医学专业"
    },
    {
        "id":3520,
        "name":"3522 (Thai Program)  :  Religion And Theology | ศาสนาและเทววิทยา | 宗教与神学"
    },
    {
        "id":3521,
        "name":"3523 (Thai Program)  :  Household Art | ศิลปะการเรือน | 家居艺术"
    },
    {
        "id":3522,
        "name":"3524 (Thai Program)  :  Education - Physical Education | ศึกษาศาสตร์ - พลศึกษา | 教育-体育"
    },
    {
        "id":3523,
        "name":"3525 (Thai Program)  :  Education And Teacher Training | ศึกษาศาสตร์และการฝึกหัดครู | 教育和教师培训"
    },
    {
        "id":3524,
        "name":"3526 (Thai Program)  :  Managerial Economics | เศรษฐศาสตร์การจัดการ | 管理经济学"
    },
    {
        "id":3525,
        "name":"3527 (Thai Program)  :  Applied Economics | เศรษฐศาสตร์ประยุกต์ | 应用经济学"
    },
    {
        "id":3526,
        "name":"3528 (Thai Program)  :  Sky Oceanography And Chemistry | สมุทรศาสตร์สกายะและเคมี | 天空海洋学和化学"
    },
    {
        "id":3527,
        "name":"3529 (Thai Program)  :  Physiology And Pharmacology | สรีรวิทยาและเภสัชวิทยา | 生理学和药理学"
    },
    {
        "id":3528,
        "name":"3530 (Thai Program)  :  Community Development Society | สังคมพัฒนาชุมชน | 社区发展协会"
    },
    {
        "id":3529,
        "name":"3531 (Thai Program)  :  Tropical Health Innovation | นวัตกรรมสุขภาพเขตร้อน | 热带健康创新"
    },
    {
        "id":3530,
        "name":"3532 (Thai Program)  :  Course In Using Land Vehicles | หลักสูตรการใช้ยานยนต์ทางบก | 陆地车辆使用课程"
    },
    {
        "id":3531,
        "name":"3533 (Thai Program)  :  Hygiene And Public Health | อนามัยและสาธารณสุขศาสตร์ | 卫生和公共卫生"
    },
    {
        "id":3532,
        "name":"3534 (Thai Program)  :  Inorganic Chemistry | อนินทรีย์เคมี | 无机化学"
    },
    {
        "id":3533,
        "name":"3535 (Thai Program)  :  Visual Arts Design - Jewelry Art | ออกแบบทัศนศิลป์-ศิลปะเครื่องประดับ | 视觉艺术设计——珠宝艺术"
    },
    {
        "id":3534,
        "name":"3536 (Thai Program)  :  Communication Design | ออกแบบสื่อสาร | 传达设计"
    },
    {
        "id":3535,
        "name":"3537 (Thai Program)  :  Endocrinology And Metabolism | อายุรศาสตร์ต่อมไร้ท่อและเมตะบอลิซึม | 内分泌与代谢"
    },
    {
        "id":3536,
        "name":"3538 (Thai Program)  :  Internal Medicine, Rheumatology And Rheumatology | อายุรศาสตร์โรคข้อและรูมาติซั่ม | 内科、风湿科、风湿科"
    },
    {
        "id":3537,
        "name":"3539 (Thai Program)  :  Infectious Disease Internal Medicine | อายุรศาสตร์โรคติดเชื้อ | 传染病内科"
    },
    {
        "id":3538,
        "name":"3540 (Thai Program)  :  Kidney Internal Medicine | อายุรศาสตร์โรคไต | 肾内科"
    },
    {
        "id":3539,
        "name":"3541 (Thai Program)  :  Cardiology | อายุรศาสตร์โรคหัวใจ | 心脏病学"
    },
    {
        "id":3540,
        "name":"3542 (Thai Program)  :  Ancient India And Asian Studies | อินเดียโบราณและการศึกษาเอเชีย | 古印度和亚洲研究"
    },
    {
        "id":3541,
        "name":"3543 (Thai Program)  :  Electronics | อิเลคโทรนิคส์ | 电子产品"
    },
    {
        "id":3542,
        "name":"3544 (Thai Program)  :  Industrial-Design Industrial Products | อุตสาหกรรม-ออกแบบ ผลิตภัณฑ์อุตสาหกรรม | 工业设计工业产品"
    },
    {
        "id":3543,
        "name":"3545 (Thai Program)  :  Advanced Nursing | การพยาบาลขั้นสูง | 高级护理"
    },
    {
        "id":3544,
        "name":"3546 (Thai Program)  :  Electrical And Information Engineering | วิศวกรรมไฟฟ้าและสารสนเทศ | 电气与信息工程"
    },
    {
        "id":3545,
        "name":"3547 (Thai Program)  :  Entrepreneurial Management | การจัดการเป็นผู้ประกอบการ | 创业管理"
    },
    {
        "id":3546,
        "name":"3548 (Thai Program)  :  Development Of The Primary Service System | การพัฒนาระบบบริการปฐมภูมิ | 基层服务体系建设"
    },
    {
        "id":3547,
        "name":"3549 (Thai Program)  :  Leader In Education And Human Resource Development | ผู้นำทางการศึกษาและการพัฒนาทรัพยากรมนุษย์ | 教育和人力资源开发的领导者"
    },
    {
        "id":3548,
        "name":"3550 (Thai Program)  :  Mekong Basin Region And Salween Studies | ภูมิภาคลุ่มน้ำโขงและสาละวินศึกษา | 湄公河流域地区和萨尔温江研究"
    },
    {
        "id":3549,
        "name":"3551 (Thai Program)  :  Applied Management | การจัดการประยุกต์ | 应用管理"
    },
    {
        "id":3550,
        "name":"3552 (Thai Program)  :  Research For Administration And Management | การวิจัยเพื่อการบริหารและการจัดการ | 行政和管理研究"
    },
    {
        "id":3551,
        "name":"3553 (Thai Program)  :  Insurance Science And Risk Management | วิทยาการประกันภัยและการบริหารความเสี่ยง | 保险科学与风险管理"
    },
    {
        "id":3552,
        "name":"3554 (Thai Program)  :  Contemplative Education And Learning Towards Change | จิตตปัญญาศึกษาและการเรียนรู้สู่การเปลี่ยนแปลง | 沉思教育和学习变革"
    },
    {
        "id":3553,
        "name":"3555 (Thai Program)  :  Agriculture, Agricultural Extension Subject | เกษตรศาสตร์ แขนงวิชาส่งเสริมการเกษตร | 农业、农业推广学科"
    },
    {
        "id":3554,
        "name":"3556 (Thai Program)  :  Agriculture, Branch Of Fruit Trees | เกษตรศาสตร์ แขนงวิชาไม้ผล | 农业，果树分支"
    },
    {
        "id":3555,
        "name":"3557 (Thai Program)  :  Agriculture, Beef Cattle, Dairy Cattle | เกษตรศาสตร์ แขนงวิชาโคเนื้อ โคนม | 农业、肉牛、奶牛"
    },
    {
        "id":3556,
        "name":"3558 (Thai Program)  :  Hospitality And Tourism Management | การจัดการการบริการและการท่องเที่ยว | 酒店和旅游管理"
    },
    {
        "id":3557,
        "name":"3559 (Thai Program)  :  Tropical Agricultural Resource Management | การจัดการทรัพยากรเกษตรเขตร้อน | 热带农业资源管理"
    },
    {
        "id":3558,
        "name":"3560 (Thai Program)  :  Health Service Business Management | การจัดการธุรกิจบริการสุขภาพ | 健康服务企业管理"
    },
    {
        "id":3559,
        "name":"3561 (Thai Program)  :  Maharishi Vedic Science | มหาริชีเวทศาสตร์ | 玛赫西吠陀科学"
    },
    {
        "id":3560,
        "name":"3562 (Thai Program)  :  Human Resource Development | การพัฒนาทรัพยากรมนุษย์ | 人力资源开发"
    },
    {
        "id":3561,
        "name":"3563 (Thai Program)  :  Administrative Administration | การบริหารการปกครอง | 行政管理"
    },
    {
        "id":3562,
        "name":"3564 (Thai Program)  :  Culture And Development | วัฒนธรรมและการพัฒนา | 文化与发展"
    },
    {
        "id":3563,
        "name":"3565 (Thai Program)  :  Government Organization Management | การบริหารองค์การภาครัฐ | 政府组织管理"
    },
    {
        "id":3564,
        "name":"3566 (Thai Program)  :  Local Government Administration | การบริหารการปกครองท้องถิ่น | 地方政府行政"
    },
    {
        "id":3565,
        "name":"3567 (Thai Program)  :  Business Analysis And Modeling | การวิเคราะห์และการสร้างตัวแบบธุรกิจ | 业务分析和建模"
    },
    {
        "id":3566,
        "name":"3568 (Thai Program)  :  Educational Administration And Educational Leadership | การบริหารการศึกษาและผู้นำทางการศึกษา | 教育行政和教育领导"
    },
    {
        "id":3567,
        "name":"3569 (Thai Program)  :  Business Information Technology | เทคโนโลยีสารสนเทศเชิงธุรกิจ | 商业信息技术"
    },
    {
        "id":3568,
        "name":"3570 (Thai Program)  :  Management | ทางการจัดการ | 管理"
    },
    {
        "id":3569,
        "name":"3571 (Thai Program)  :  Auto Mechanic | ช่างยนต์ | 汽车修理"
    },
    {
        "id":3570,
        "name":"3572 (English Program)  :  Clinical Psychology | จิตวิทยาคลินิก | 临床心理学"
    },
    {
        "id":3571,
        "name":"3573 (Thai Program)  :  Automotive Engineering | วิศวกรรมยานยนต์ | 汽车工程"
    },
    {
        "id":3572,
        "name":"3574 (Thai Program)  :  Automotive Technology | เทคโนโลยียานยนต์ | 汽车技术"
    },
    {
        "id":3573,
        "name":"3575 (Thai Program)  :  Hospitality And Tourism | การโรงแรมและการท่องเที่ยว | 酒店及旅游"
    },
    {
        "id":3574,
        "name":"3576 (Thai Program)  :  Newspapers And Publications | หนังสือพิมพ์และสิ่งพิมพ์ | 报纸和出版物"
    },
    {
        "id":3575,
        "name":"3577 (Thai Program)  :  Digital Media | สื่อดิจิทัล | 数字媒体"
    },
    {
        "id":3576,
        "name":"3578 (Thai Program)  :  Chemical Oceanography | สมุทรศาสตร์เคมี | 化学海洋学"
    },
    {
        "id":3577,
        "name":"3579 (English Program)  :  Integrater Water Resources | ทรัพยากรน้ำแบบบูรณาการ | 整合水资源"
    },
    {
        "id":3578,
        "name":"3580 (English Program)  :  Conducting | การดำเนินการ | 指挥"
    },
    {
        "id":3579,
        "name":"3581 (Thai Program)  :  Medical Anthropology | มานุษยวิทยาการแพทย์ | 医学人类学"
    },
    {
        "id":3580,
        "name":"3582 (English Program)  :  Skills Development | การพัฒนาทักษะ | 技能发展"
    },
    {
        "id":3581,
        "name":"3583 (Thai Program)  :  Commerce | พณิชยกรรม | 商业"
    },
    {
        "id":3582,
        "name":"3584 (Thai Program)  :  Measuring Tools | เครื่องมือวัด | 测量工具"
    },
    {
        "id":3583,
        "name":"3585 (Thai Program)  :  Medical Statistics | เวชสถิติ | 医疗统计"
    },
    {
        "id":3584,
        "name":"3586 (Thai Program)  :  Health And Beauty Science | วิทยาศาสตร์สุขภาพและความงาม | 健康与美容科学"
    },
    {
        "id":3585,
        "name":"3587 (Thai Program)  :  Holistic Education | การศึกษาแบบองค์รวม | 全人教育"
    },
    {
        "id":3586,
        "name":"3588 (Thai Program)  :  Architecture For The Community And Environment | สถาปัตยกรรมเพื่อชุมชนและสิ่งแวดล้อม | 社区和环境的建筑"
    },
    {
        "id":3587,
        "name":"3589 (English Program)  :  Chinese Language And Literature | ภาษาและวรรณคดีจีน | 汉语言文学"
    },
    {
        "id":3588,
        "name":"3590 (English Program)  :  Film Studies | การศึกษาภาพยนตร์ | 电影研究"
    },
    {
        "id":3589,
        "name":"3591 (English Program)  :  Forest Genetics | พันธุศาสตร์ป่าไม้ | 森林遗传学"
    },
    {
        "id":3590,
        "name":"3592 (English Program)  :  Chinese Medicine | การแพทย์แผนจีน | 中医"
    },
    {
        "id":3591,
        "name":"3593 (English Program)  :  Medical Mycology | วิทยาวิทยาการแพทย์ | 医学真菌学"
    },
    {
        "id":3592,
        "name":"3594 (English Program)  :  Multilingual And Multicultural Education | การศึกษาพหุภาษาและพหุวัฒนธรรม | 多语言和多元文化教育"
    },
    {
        "id":3593,
        "name":"3595 (English Program)  :  Research In Education And Psychology | การวิจัยทางการศึกษาและจิตวิทยา | 教育和心理学研究"
    },
    {
        "id":3594,
        "name":"3596 (English Program)  :  Bioresource Engineering | วิศวกรรมทรัพยากรชีวภาพ | 生物资源工程"
    },
    {
        "id":3595,
        "name":"3597 (English Program)  :  Health And Higher Education | สุขภาพและการศึกษาระดับอุดมศึกษา | 健康与高等教育"
    },
    {
        "id":3596,
        "name":"3598 (English Program)  :  Religion And American Studies | ศาสนาและการศึกษาอเมริกัน | 宗教与美国研究"
    },
    {
        "id":3597,
        "name":"3599 (English Program)  :  Advance Information Technology | เทคโนโลยีสารสนเทศขั้นสูง | 先进的信息技术"
    },
    {
        "id":3598,
        "name":"3600 (Thai Program)  :  Civil Engineering And Systems Management | การบริหารงานวิศวกรรมโยธาและงานระบบ | 土木工程和系统管理"
    },
    {
        "id":3599,
        "name":"3601 (English Program)  :  Music Theory | ทฤษฎีดนตรี | 乐理"
    },
    {
        "id":3600,
        "name":"3602 (English Program)  :  Human Development And Family Science | การพัฒนามนุษย์และวิทยาศาสตร์ครอบครัว | 人类发展与家庭科学"
    },
    {
        "id":3601,
        "name":"3603 (Thai Program)  :  Education And Learning Management | การจัดการการศึกษาและการเรียนรู้ | 教育和学习管理"
    },
    {
        "id":3602,
        "name":"3604 (Thai Program)  :  Hospitality And Tourism Industry Management | การจัดการอุตสาหกรรมบริการและการท่องเที่ยว | 酒店及旅游业管理"
    },
    {
        "id":3603,
        "name":"3605 (Thai Program)  :  Cinema - Video | การภาพยนตร์ - วิดิทัศน์ | 电影院 - 视频"
    },
    {
        "id":3604,
        "name":"3606 (Thai Program)  :  Muay Thai Studies | มวยไทยศึกษา | 泰拳研究"
    },
    {
        "id":3605,
        "name":"3607 (Thai Program)  :  Agricultural Produce Management And Packaging Technology | เทคโนโลยีการจัดการผลิตผลเกษตรและการบรรจุ | 农产品管理与包装技术"
    },
    {
        "id":3606,
        "name":"3608 (Thai Program)  :  Chemistry For Teachers | เคมีสำหรับครู | 教师化学"
    },
    {
        "id":3607,
        "name":"3609 (Thai Program)  :  Biology For Teachers | ชีววิทยาสำหรับครู | 教师生物学"
    },
    {
        "id":3608,
        "name":"3610 (Thai Program)  :  Special Education Curriculum And Instruction | หลักสูตรและการสอนการศึกษาพิเศษ | 特殊教育课程与教学"
    },
    {
        "id":3609,
        "name":"3611 (Thai Program)  :  Pets | สัตว์เลี้ยง | 宠物"
    },
    {
        "id":3610,
        "name":"3612 (Thai Program)  :  Integrated Engineering Management | การจัดการวิศวกรรมแบบบูรณาการ | 综合工程管理"
    },
    {
        "id":3611,
        "name":"3613 (Thai Program)  :  English-Thai Translation | การแปลภาษาอังกฤษ-ไทย | 英泰翻译"
    },
    {
        "id":3612,
        "name":"3614 (Thai Program)  :  Developmental Communication | การสื่อสารพัฒนาการ | 发展性沟通"
    },
    {
        "id":3613,
        "name":"3615 (Thai Program)  :  Clinical Laboratory Science | วิทยาศาสตร์ปฏิบัติการคลินิก | 临床检验科学"
    },
    {
        "id":3614,
        "name":"3616 (Thai Program)  :  Modern And Contemporary Chinese Literature | วรรณคดีจีนสมัยใหม่และร่วมสมัย | 中国现当代文学"
    },
    {
        "id":3615,
        "name":"3617 (Thai Program)  :  Aviation | การบิน | 航空"
    },
    {
        "id":3616,
        "name":"3618 (Thai Program)  :  Media And Entertainment Management | การจัดการสื่อและบันเทิง | 媒体和娱乐管理"
    },
    {
        "id":3617,
        "name":"3619 (Thai Program)  :  Organizational Development Management | การบริหารการพัฒนาองค์การ | 组织发展管理"
    },
    {
        "id":3618,
        "name":"3620 (Thai Program)  :  Multimedia Computer | คอมพิวเตอร์มัลติมีเดีย | 多媒体计算机"
    },
    {
        "id":3619,
        "name":"3621 (Thai Program)  :  Vietnamese Studies | เวียดนามศึกษา | 越南研究"
    },
    {
        "id":3620,
        "name":"3622 (Thai Program)  :  Nutrition And Food Safety Management | โภชนาการและการจัดการความปลอดภัยในอาหาร | 营养与食品安全管理"
    },
    {
        "id":3621,
        "name":"3623 (Thai Program)  :  Tai Suksa | ไทศึกษา | 泰苏克萨"
    },
    {
        "id":3622,
        "name":"3624 (Thai Program)  :  Strategic Management | การจัดการเชิงกลยุทธ์ | 战略管理"
    },
    {
        "id":3623,
        "name":"3625 (Thai Program)  :  Technology And Electronic Commerce Management | การจัดการเทคโนโลยีและพาณิชย์อิเล็กทรอนิกส์ | 技术与电子商务管理"
    },
    {
        "id":3624,
        "name":"3626 (Thai Program)  :  Management Of Learning Resources | การจัดการแหล่งการเรียนรู้ | 学习资源管理"
    },
    {
        "id":3625,
        "name":"3627 (Thai Program)  :  Sports And Health Management | การจัดการกีฬาและสุขภาพ | 运动与健康管理"
    },
    {
        "id":3626,
        "name":"3628 (Thai Program)  :  Tourism And Hotel Management | การจัดการท่องเที่ยวและการโรงแรม | 旅游及酒店管理"
    },
    {
        "id":3627,
        "name":"3629 (Thai Program)  :  Elderly Health Management | การจัดการสุขภาพผู้สูงอายุ | 老年人健康管理"
    },
    {
        "id":3628,
        "name":"3630 (Thai Program)  :  Educational Administration And Development | การบริหารและพัฒนาการศึกษา | 教育行政与发展"
    },
    {
        "id":3629,
        "name":"3631 (Thai Program)  :  Environmental Management | การบริหารจัดการสิ่งแวดล้อม | 环境管理"
    },
    {
        "id":3630,
        "name":"3632 (Thai Program)  :  Biodiversity | ความหลากหลายทางชีวภาพ | 生物多样性"
    },
    {
        "id":3631,
        "name":"3633 (Thai Program)  :  Landscape Innovation And Management | นวัตกรรมภูมิทัศน์และการจัดการ | 景观创新与管理"
    },
    {
        "id":3632,
        "name":"3634 (Thai Program)  :  Paleontology | บรรพชีวินวิทยา | 古生物学"
    },
    {
        "id":3633,
        "name":"3635 (Thai Program)  :  Pharmaceutical Care | บริบาลเภสัชกรรม | 药学服务"
    },
    {
        "id":3634,
        "name":"3636 (Thai Program)  :  Public Administration And Public Affairs | บริหารรัฐกิจและกิจการสาธารณะ | 公共行政和公共事务"
    },
    {
        "id":3635,
        "name":"3637 (Thai Program)  :  Language For Creating Print Media | ภาษาเพื่อการสร้างสรรค์งานสื่อสิ่งพิมพ์ | 创建印刷媒体的语言"
    },
    {
        "id":3636,
        "name":"3638 (Thai Program)  :  Thai As A Foreign Language | ภาษาไทยในฐานะภาษาต่างประเทศ | 泰语作为外语"
    },
    {
        "id":3637,
        "name":"3639 (Thai Program)  :  Lao Language | ภาษาลาว | 老挝语"
    },
    {
        "id":3638,
        "name":"3640 (Thai Program)  :  English For Communication | ภาษาอังกฤษเพื่อการสื่อสาร | 沟通英语"
    },
    {
        "id":3639,
        "name":"3641 (Thai Program)  :  Geoinformatics | ภูมิสารสนเทศ | 地理信息学"
    },
    {
        "id":3640,
        "name":"3642 (Thai Program)  :  Lao Studies | ลาวศึกษา | 老挝研究"
    },
    {
        "id":3641,
        "name":"3643 (Thai Program)  :  Cultural Studies | วัฒนธรรมศาสตร์ | 文化研究"
    },
    {
        "id":3642,
        "name":"3644 (Thai Program)  :  General Science | วิทยาศาสตร์ทั่วไป | 普通科学"
    },
    {
        "id":3643,
        "name":"3645 (Thai Program)  :  Mechatronics Engineering | วิศวกรรมเมคาทรอนิกส์ | 机电工程"
    },
    {
        "id":3644,
        "name":"3646 (Thai Program)  :  Civil Engineering (Rural Engineering) | วิศวกรรมโยธา (วิศวกรรมชนบท) | 土木工程（农村工程）"
    },
    {
        "id":3645,
        "name":"3647 (Thai Program)  :  Building Systems Engineering | วิศวกรรมระบบอาคาร | 建筑系统工程"
    },
    {
        "id":3646,
        "name":"3648 (Thai Program)  :  Herbs And Natural Products | สมุนไพรและผลิตภัณฑ์ธรรมชาติ | 草药和天然产品"
    },
    {
        "id":3647,
        "name":"3649 (Thai Program)  :  Organizational And Management Development | การพัฒนาองค์การและการจัดการ | 组织和管理发展"
    },
    {
        "id":3648,
        "name":"3650 (Thai Program)  :  Teacher Education | ครุศึกษา | 教师教育"
    },
    {
        "id":3649,
        "name":"3651 (Thai Program)  :  Business Data Analysis | การวิเคราะห์ข้อมูลเชิงธุรกิจ | 业务数据分析"
    },
    {
        "id":3650,
        "name":"3652 (Thai Program)  :  Supply Chain Management | การจัดการโซ่อุปทาน | 供应链管理"
    },
    {
        "id":3651,
        "name":"3653 (Thai Program)  :  Internet Technology And Electronic Commerce | เทคโนโลยีอินเทอร์เน็ตและพาณิชย์อิเล็กทรอนิกส์ | 互联网技术与电子商务"
    },
    {
        "id":3652,
        "name":"3654 (Thai Program)  :  Family Psychology | จิตวิทยาครอบครัว | 家庭心理学"
    },
    {
        "id":3653,
        "name":"3655 (Thai Program)  :  Food Biotechnology | เทคโนโลยีชีวภาพทางอาหาร | 食品生物技术"
    },
    {
        "id":3654,
        "name":"3656 (Thai Program)  :  Applied Professional Education | การศึกษาวิชาชีพเชิงประยุกต์ | 应用型职业教育"
    },
    {
        "id":3655,
        "name":"3657 (Thai Program)  :  Chinese For Economy And Trade | ภาษาจีนเพื่อเศรษฐกิจและการค้า | 经济贸易汉语"
    },
    {
        "id":3656,
        "name":"3658 (Thai Program)  :  Forest And Environmental Resource Management | การบริหารทรัพยากรป่าไม้และสิ่งแวดล้อม | 森林和环境资源管理"
    },
    {
        "id":3657,
        "name":"3659 (Thai Program)  :  Quality Information Technology | เทคโนโลยีสารสนเทศคุณภาพ | 质量信息技术"
    },
    {
        "id":3658,
        "name":"3660 (Thai Program)  :  Educational Measurement, Evaluation And Research | การวัดประเมินและวิจัยทางการศึกษา | 教育测量、评估与研究"
    },
    {
        "id":3659,
        "name":"3661 (Thai Program)  :  Research To Improve Health | วิจัยเพื่อพัฒนาสุขภาพ | 研究改善健康"
    },
    {
        "id":3660,
        "name":"3662 (Thai Program)  :  Business Thai | ภาษาไทยธุรกิจ | 商务泰语"
    },
    {
        "id":3661,
        "name":"3663 (Thai Program)  :  Food And Nutrition Business | ธุรกิจอาหารและโภชนาการ | 食品及营养品业务"
    },
    {
        "id":3662,
        "name":"3664 (Thai Program)  :  Innovation And Computer Studies | นวัตกรรมและคอมพิวเตอร์ศึกษา | 创新与计算机研究"
    },
    {
        "id":3663,
        "name":"3665 (Thai Program)  :  Business Administration (Human Resource Management) | บริหารธุรกิจ (การจัดการทรัพยากรมนุษย์) | 工商管理（人力资源管理）"
    },
    {
        "id":3664,
        "name":"3666 (Thai Program)  :  Public Administration (Public Administration) | รัฐประศาสนศาสตร์ (การบริหารจัดการภาครัฐ) | 公共行政（公共行政）"
    },
    {
        "id":3665,
        "name":"3667 (Thai Program)  :  Public Administration (Administration Of Justice And Law) | รัฐประศาสนศาสตร์ (การบริหารงานยุติธรรมและกฎหมาย) | 公共行政（司法和法律行政）"
    },
    {
        "id":3666,
        "name":"3668 (Thai Program)  :  Agriculture (Agricultural And Environmental Resource Management) | เกษตรศาสตร์ (การจัดการทรัพยากรเกษตรและสิ่งแวดล้อม) | 农业（农业和环境资源管理）"
    },
    {
        "id":3667,
        "name":"3669 (Thai Program)  :  Agriculture (Information Technology And Agricultural Services) | เกษตรศาสตร์ (เทคโนโลยีสารสนเทศและการบริการทางการเกษตร) | 农业（信息技术和农业服务）"
    },
    {
        "id":3668,
        "name":"3670 (Thai Program)  :  Agriculture (Agricultural And Food Business Management) | เกษตรศาสตร์ (การจัดการธุรกิจเกษตรและอาหาร) | 农业（农业和食品企业管理）"
    },
    {
        "id":3669,
        "name":"3671 (Thai Program)  :  Agriculture (Agricultural Tourism) | เกษตรศาสตร์ (การท่องเที่ยวเกษตร) | 农业（农业旅游）"
    },
    {
        "id":3670,
        "name":"3672 (Thai Program)  :  Organizing Conferences And Events | การจัดการประชุมและงานมหกรรม | 组织会议和活动"
    },
    {
        "id":3671,
        "name":"3673 (Thai Program)  :  Kitchen And Restaurant Management | การจัดการครัวและภัตตาคาร | 厨房及餐厅管理"
    },
    {
        "id":3672,
        "name":"3674 (Thai Program)  :  Resort And Spa Management | การจัดการรีสอร์ทและสปา | 度假村和水疗中心管理"
    },
    {
        "id":3673,
        "name":"3675 (Thai Program)  :  Exercise And Sports | การออกกำลังกายและการกีฬา | 锻炼和运动"
    },
    {
        "id":3674,
        "name":"3676 (Thai Program)  :  Beauty Technology | เทคโนโลยีความงาม | 美容技术"
    },
    {
        "id":3675,
        "name":"3677 (Thai Program)  :  Food Industry | อุตสาหกรรมงานอาหาร | 食品行业"
    },
    {
        "id":3676,
        "name":"3678 (Thai Program)  :  Creative Invention Technology | เทคโนโลยีงานประดิษฐ์สร้างสรรค์ | 创意发明技术"
    },
    {
        "id":3677,
        "name":"3679 (Thai Program)  :  Organization Of Early Childhood Education Institutions | การจัดสถานศึกษาปฐมวัย | 幼儿教育机构的组织"
    },
    {
        "id":3678,
        "name":"3680 (Thai Program)  :  Biochemistry And Molecular Biology | ชีวเคมีและชีววิทยาโมเลกุล | 生物化学和分子生物学"
    },
    {
        "id":3679,
        "name":"3681 (Thai Program)  :  Information And Communications Technology For Embedded Systems | เทคโนโลยีสารสนเทศและการสื่อสารสำหรับระบบฝังตัว | 嵌入式系统的信息和通信技术"
    },
    {
        "id":3680,
        "name":"3682 (Thai Program)  :  Engineering Technology | เทคโนโลยีวิศวกรรม | 工程技术"
    },
    {
        "id":3681,
        "name":"3683 (Thai Program)  :  Logistics Engineering And Supply Chain Systems | วิศวกรรมโลจิสติกส์และระบบห่วงโซ่อุปทาน | 物流工程与供应链系统"
    },
    {
        "id":3682,
        "name":"3684 (Thai Program)  :  Computers For Architectural Design | คอมพิวเตอร์เพื่อการออกแบบทางสถาปัตยกรรม | 建筑设计计算机"
    },
    {
        "id":3683,
        "name":"3685 (Thai Program)  :  Public Health System And Environment Management | การจัดการระบบสาธารณสุขและสิ่งแวดล้อม | 公共卫生系统和环境管理"
    },
    {
        "id":3684,
        "name":"3686 (Thai Program)  :  Fiscal Management | การจัดการการคลัง | 财政管理"
    },
    {
        "id":3685,
        "name":"3687 (Thai Program)  :  Mechanical Management And City Planning | การจัดการงานช่างและผังเมือง | 机械管理和城市规划"
    },
    {
        "id":3686,
        "name":"3688 (Thai Program)  :  Home Economics Business | ธุรกิจคหกรรมศาสตร์ | 家政业务"
    },
    {
        "id":3687,
        "name":"3689 (Thai Program)  :  Local Environmental Management | การจัดการสิ่งแวดล้อมท้องถิ่น | 当地环境管理"
    },
    {
        "id":3688,
        "name":"3690 (Thai Program)  :  Curriculum And Learning Innovation | นวัตกรรมหลักสูตรและการเรียนรู้ | 课程与学习创新"
    },
    {
        "id":3689,
        "name":"3691 (Thai Program)  :  Tool And Mold Production Technology | เทคโนโลยีการผลิตเครื่องมือและแม่พิมพ์ | 工模具生产技术"
    },
    {
        "id":3690,
        "name":"3692 (Thai Program)  :  Counseling And Guidance Psychology | จิตวิทยาการให้คำปรึกษาและการแนะแนว | 咨询与指导心理学"
    },
    {
        "id":3691,
        "name":"3693 (Thai Program)  :  Infrastructure Management And Urban Development Planning | การจัดการโครงสร้างพื้นฐานและการวางแผนพัฒนาเมือง | 基础设施管理和城市发展规划"
    },
    {
        "id":3692,
        "name":"3694 (Thai Program)  :  Tourism Industry | อุตสาหกรรมการท่องเที่ยว | 旅游业"
    },
    {
        "id":3693,
        "name":"3695 (Thai Program)  :  Information Technology, Service Science | เทคโนโลยีสารสนเทศวิทยาการบริการ | 信息技术、服务科学"
    },
    {
        "id":3694,
        "name":"3696 (Thai Program)  :  Physical Education And Health Promotion | พลศึกษาและการส่งเสริมสุขภาพ | 体育教育和健康促进"
    },
    {
        "id":3695,
        "name":"3697 (Thai Program)  :  Digital Art | ดิจิทัลอาร์ต | 数字艺术"
    },
    {
        "id":3696,
        "name":"3698 (Thai Program)  :  Tourism Service Industry | อุตสาหกรรมการบริการเพื่อการท่องเที่ยว | 旅游服务业"
    },
    {
        "id":3697,
        "name":"3699 (Thai Program)  :  Hospital Management | การจัดการโรงพยาบาล | 医院管理"
    },
    {
        "id":3698,
        "name":"3700 (Thai Program)  :  Fine Arts In Music Education | ศิลปกรรม แขนงวิชาดนตรีศึกษา | 音乐教育中的美术"
    },
    {
        "id":3699,
        "name":"3701 (Thai Program)  :  Computer And Multimedia Engineering | วิศวกรรมคอมพิวเตอร์และมัลติมีเดีย | 计算机与多媒体工程"
    },
    {
        "id":3700,
        "name":"3702 (Thai Program)  :  Telecommunications Engineering | วิศวกรรมโทรคมนาคม | 电讯工程"
    },
    {
        "id":3701,
        "name":"3703 (Thai Program)  :  Electrical And Energy Engineering | วิศวกรรมไฟฟ้าและพลังงาน | 电气与能源工程"
    },
    {
        "id":3702,
        "name":"3704 (Thai Program)  :  Public Policy And Strategic Management | นโยบายสาธารณะและการจัดการเชิงกลยุทธ์ | 公共政策和战略管理"
    },
    {
        "id":3703,
        "name":"3705 (Thai Program)  :  Human Capital Management | การจัดการทุนมนุษย์ | 人力资本管理"
    },
    {
        "id":3704,
        "name":"3706 (Thai Program)  :  Economics And Human Capital | เศรษฐศาสตร์และทุนมนุษย์ | 经济与人力资本"
    },
    {
        "id":3705,
        "name":"3707 (Thai Program)  :  Bilingual Education | การศึกษาทวิภาษา | 双语教育"
    },
    {
        "id":3706,
        "name":"3708 (Thai Program)  :  Business Data Analysis | การวิเคราะห์ข้อมูลธุรกิจ | 业务数据分析"
    },
    {
        "id":3707,
        "name":"3709 (Thai Program)  :  Computer Multimedia Games | คอมพิวเตอร์เกมมัลติมีเดีย | 电脑多媒体游戏"
    },
    {
        "id":3708,
        "name":"3710 (Thai Program)  :  Internal Audit | การตรวจสอบภายใน | 内部审计"
    },
    {
        "id":3709,
        "name":"3711 (Thai Program)  :  Globalization Of Financial Education | โลกาภิวัฒน์ทางการเงินศึกษา | 金融教育全球化"
    },
    {
        "id":3710,
        "name":"3712 (Thai Program)  :  Aircraft Engineering | วิศวกรรมอากาศยาน | 飞机工程"
    },
    {
        "id":3711,
        "name":"3713 (Thai Program)  :  Construction Engineering Technology | เทคโนโลยีวิศวกรรมการก่อสร้าง | 建筑工程技术"
    },
    {
        "id":3712,
        "name":"3714 (Thai Program)  :  Urban And Industrial Environmental Management | การจัดการสิ่งแวดล้อมเมืองและอุตสาหกรรม | 城市和工业环境管理"
    },
    {
        "id":3713,
        "name":"3715 (Thai Program)  :  Safety Science | วิทยาการความปลอดภัย | 安全科学"
    },
    {
        "id":3714,
        "name":"3716 (Thai Program)  :  Cosmetic Science | วิทยาศาสตร์เครื่องสำอาง | 美容科学"
    },
    {
        "id":3715,
        "name":"3717 (Thai Program)  :  Designing Shows And Exhibitions | การออกแบบงานแสดงและนิทรรศการ | 设计表演和展览"
    },
    {
        "id":3716,
        "name":"3718 (Thai Program)  :  Modern Analysis And Assessment | การวิเคราะห์และการประเมินสมัยใหม่ | 现代分析与评估"
    },
    {
        "id":3717,
        "name":"3719 (Thai Program)  :  Tourism And Service Industries | อุตสาหกรรมท่องเที่ยวและบริการ | 旅游及服务业"
    },
    {
        "id":3718,
        "name":"3720 (Thai Program)  :  Media Art | มีเดียอาร์ต | 媒体艺术"
    },
    {
        "id":3719,
        "name":"3721 (Thai Program)  :  Media Technology | เทคโนโลยีมีเดีย | 媒体技术"
    },
    {
        "id":3720,
        "name":"3722 (Thai Program)  :  Japanese Business Administration | บริหารธุรกิจญี่ปุ่น | 日本企业管理"
    },
    {
        "id":3721,
        "name":"3723 (Thai Program)  :  Teaching English To Speakers Of Other Languages | การสอนภาษาอังกฤษสำหรับผู้พูดภาษาอื่น | 向说其他语言的人教授英语"
    },
    {
        "id":3722,
        "name":"3724 (Thai Program)  :  Multimedia And Graphic Design | มัลติมีเดียและกราฟิกดีไซน์ | 多媒体和图形设计"
    },
    {
        "id":3723,
        "name":"3725 (Thai Program)  :  Bioprocess Engineering | วิศวกรรมกระบวนการชีวภาพ | 生物过程工程"
    },
    {
        "id":3724,
        "name":"3726 (Thai Program)  :  Advanced Materials And Nanotechnology | วัสดุขั้นสูงและนาโนเทคโนโลยี | 先进材料和纳米技术"
    },
    {
        "id":3725,
        "name":"3727 (Thai Program)  :  Management And Logistics Engineering | วิศวกรรมการจัดการและโลจิสติกส์ | 管理与物流工程"
    },
    {
        "id":3726,
        "name":"3728 (Thai Program)  :  Environmental Science And Natural Resources | วิทยาการสิ่งแวดล้อมและทรัพยากรธรรมชาติ | 环境科学与自然资源"
    },
    {
        "id":3727,
        "name":"3729 (Thai Program)  :  Learning Management Strategy | ยุทธศาสตร์การจัดการการเรียนรู้ | 学习管理策略"
    },
    {
        "id":3728,
        "name":"3730 (Thai Program)  :  Language And Intercultural Communication | ภาษาและการสื่อสารระหว่างวัฒนธรรม | 语言和跨文化交流"
    },
    {
        "id":3729,
        "name":"3731 (Thai Program)  :  French For Cultural Tourism | ภาษาฝรั่งเศสเพื่อการท่องเที่ยวเชิงวัฒนธรรม | 文化旅游法语"
    },
    {
        "id":3730,
        "name":"3732 (Thai Program)  :  Computer And Information Science | วิทยาการคอมพิวเตอร์และสารสนเทศ | 计算机与信息科学"
    },
    {
        "id":3731,
        "name":"3733 (Thai Program)  :  Cultural Studies For Tourism | วัฒนธรรมศึกษาเพื่อการท่องเที่ยว | 旅游文化研究"
    },
    {
        "id":3732,
        "name":"3734 (Thai Program)  :  Biological Resource Development Science | วิทยาการพัฒนาทรัพยากรชีวภาพ | 生物资源开发科学"
    },
    {
        "id":3733,
        "name":"3735 (Thai Program)  :  Agriculture (Plant Science) | เกษตรศาสตร์ (พืชศาสตร์) | 农业（植物科学）"
    },
    {
        "id":3734,
        "name":"3736 (Thai Program)  :  Business Administration (Marketing) | บริหารธุรกิจ (การตลาด) | 工商管理（市场营销）"
    },
    {
        "id":3735,
        "name":"3737 (Thai Program)  :  Business Administration (Business Computer) | บริหารธุรกิจ (คอมพิวเตอร์ธุรกิจ) | 工商管理（商业计算机）"
    },
    {
        "id":3736,
        "name":"3738 (Thai Program)  :  Business Administration (General Management) | บริหารธุรกิจ (การจัดการทั่วไป) | 工商管理（综合管理）"
    },
    {
        "id":3737,
        "name":"3739 (Thai Program)  :  Business Administration (Industrial Management) | บริหารธุรกิจ (การจัดการงานอุตสาหกรรม) | 工商管理（工业管理）"
    },
    {
        "id":3738,
        "name":"3740 (Thai Program)  :  Business Administration (International Business) | บริหารธุรกิจ (ธุรกิจระหว่างประเทศ) | 工商管理（国际商务）"
    },
    {
        "id":3739,
        "name":"3741 (Thai Program)  :  Border Trade | การค้าชายแดน | 边境贸易"
    },
    {
        "id":3740,
        "name":"3742 (Thai Program)  :  Halal Food Business | ธุรกิจอาหารฮาลาล | 清真食品业务"
    },
    {
        "id":3741,
        "name":"3743 (Thai Program)  :  Indochina Trade | การค้าอินโดจีน | 印度支那贸易"
    },
    {
        "id":3742,
        "name":"3744 (Thai Program)  :  Accounting | การบัญชี | 会计"
    },
    {
        "id":3743,
        "name":"3745 (Thai Program)  :  Information And Communication Technology | เทคโนโลยีสารสนเทศและการสื่อสาร | 信息和通信技术"
    },
    {
        "id":3744,
        "name":"3746 (Thai Program)  :  Buddhism | พุทธศาสตร์ | 佛教"
    },
    {
        "id":3745,
        "name":"3747 (Thai Program)  :  Promoting The Health Of The Elderly | การส่งเสริมสุขภาพผู้สูงอายุ | 促进老年人健康"
    },
    {
        "id":3746,
        "name":"3748 (Thai Program)  :  Islamic Studies For Development | อิสลามศึกษาเพื่อการพัฒนา | 伊斯兰发展研究"
    },
    {
        "id":3747,
        "name":"3749 (Thai Program)  :  Innovation And Digital Business | นวัตกรรมและธุรกิจดิจิทัล | 创新和数字化业务"
    },
    {
        "id":3748,
        "name":"3750 (Thai Program)  :  Entrepreneurship And Innovation | ภาวะผู้ประกอบการและนวัตกรรม | 创业创新"
    },
    {
        "id":3749,
        "name":"3751 (Thai Program)  :  Human Capital And Organizational Management | ทุนมนุษย์และการจัดการองค์กร | 人力资本和组织管理"
    },
    {
        "id":3750,
        "name":"3752 (Thai Program)  :  Korean Studies | เกาหลีศึกษา | 韩国研究"
    },
    {
        "id":3751,
        "name":"3753 (Thai Program)  :  Environment, Development And Sustainability | สิ่งแวดล้อม การพัฒนา และความยั่งยืน | 环境、发展和可持续性"
    },
    {
        "id":3752,
        "name":"3754 (Thai Program)  :  Language And Culture | ภาษาและวัฒนธรรม | 语言与文化"
    },
    {
        "id":3753,
        "name":"3755 (Thai Program)  :  Quantitative Finance | การเงินเชิงปริมาณ | 量化金融"
    },
    {
        "id":3754,
        "name":"3756 (Thai Program)  :  Health Research And Management | การวิจัยและการจัดการด้านสุขภาพ | 健康研究与管理"
    },
    {
        "id":3755,
        "name":"3757 (Thai Program)  :  Applied Veterinary Anatomy | กายวิภาคศาสตร์ประยุกต์ทางสัตวแพทย์ | 应用兽医解剖学"
    },
    {
        "id":3756,
        "name":"3758 (Thai Program)  :  Cosmetic Restorative Dentistry And Dental Implants | ทันตกรรมบูรณะเพื่อความสวยงามและทันตกรรมรากเทียม | 美容修复牙科和种植牙"
    },
    {
        "id":3757,
        "name":"3759 (Thai Program)  :  Restoring The Entire Tooth | การฟื้นฟูสภาพฟันทั้งปาก | 恢复整个牙齿"
    },
    {
        "id":3758,
        "name":"3760 (Thai Program)  :  Electronics And Computers | อิเลคทรอนิกส์และคอมพิวเตอร์ | 电子和计算机"
    },
    {
        "id":3759,
        "name":"3761 (Thai Program)  :  Cyber ​​Security Risk Management | การจัดการความเสี่ยงความมั่นคงทางไซเบอร์ | 网络安全风险管理"
    },
    {
        "id":3760,
        "name":"3762 (Thai Program)  :  Industrial Technology Civil Technology Branch | เทคโนโลยีอุตสาหกรรม แขนงเทคโนโลยีโยธา | 工业技术民用技术分会"
    },
    {
        "id":3761,
        "name":"3763 (Thai Program)  :  Multimedia And Animation Technology | เทคโนโลยีมัลติมีเดียและแอนิเมชัน | 多媒体和动画技术"
    },
    {
        "id":3762,
        "name":"3764 (Thai Program)  :  Fine Arts, Communication Design Department | ศิลปกรรม แขนงออกแบบนิเทศศิลป์ | 美术系、传达设计系"
    },
    {
        "id":3763,
        "name":"3765 (Thai Program)  :  Teaching Chinese | การสอนภาษาจีน | 汉语教学"
    },
    {
        "id":3764,
        "name":"3766 (Thai Program)  :  Highland Agriculture | เกษตรที่สูง | 高原农业"
    },
    {
        "id":3765,
        "name":"3767 (Thai Program)  :  Logistics Engineering And Management | วิศวกรรมโลจิสติกส์และการจัดการ | 物流工程与管理"
    },
    {
        "id":3766,
        "name":"3768 (Thai Program)  :  Visual Arts | ทัศนศิลป์ | 视觉艺术"
    },
    {
        "id":3767,
        "name":"3769 (Thai Program)  :  Western Music | ดุริยางคศิลป์ตะวันตก | 西方音乐"
    },
    {
        "id":3768,
        "name":"3770 (Thai Program)  :  Chinese Is A Foreign Language. | ภาษาจีนเป็นภาษาต่างประเทศ | 汉语是一门外语。"
    },
    {
        "id":3769,
        "name":"3771 (Thai Program)  :  Fashion Business | ธุรกิจแฟชั่น | 时尚商业"
    },
    {
        "id":3770,
        "name":"3772 (Thai Program)  :  Organic Farming | เกษตรอินทรีย์ | 有机农业"
    },
    {
        "id":3771,
        "name":"3773 (Thai Program)  :  Tourism And Service Management | การจัดการท่องเที่ยวและบริการ | 旅游与服务管理"
    },
    {
        "id":3772,
        "name":"3774 (Thai Program)  :  Performance Art | ศิลปะการจัดการแสดง | 行为艺术"
    },
    {
        "id":3773,
        "name":"3775 (Thai Program)  :  Mold Design Engineering Technology | เทคโนโลยีวิศวกรรมการออกแบบแม่พิมพ์ | 模具设计工程技术"
    },
    {
        "id":3774,
        "name":"3776 (Thai Program)  :  Craftsmanship | หัตถศิลป์ | 工艺"
    },
    {
        "id":3775,
        "name":"3777 (Thai Program)  :  Electrical Engineering Technology | เทคโนโลยีวิศวกรรมไฟฟ้า | 电气工程技术"
    },
    {
        "id":3776,
        "name":"3778 (Thai Program)  :  Animation And Games | แอนิเมชันและเกม | 动画和游戏"
    },
    {
        "id":3777,
        "name":"3779 (Thai Program)  :  Applied Communication | การสื่อสารประยุกต์ | 应用传播"
    },
    {
        "id":3778,
        "name":"3780 (Thai Program)  :  Social Development Management | การบริหารการพัฒนาสังคม | 社会发展管理"
    },
    {
        "id":3779,
        "name":"3781 (Thai Program)  :  Health Insurance Finance And Administration | การคลังและการบริหารหลักประกันสุขภาพ | 健康保险财务与管理"
    },
    {
        "id":3780,
        "name":"3782 (Thai Program)  :  Music And Dance Science | วิทยาการดนตรีและนาฏศิลป์ | 音乐与舞蹈科学"
    },
    {
        "id":3781,
        "name":"3783 (Thai Program)  :  Sports Science And Technology | วิทยาศาสตร์และเทคโนโลยีการกีฬา | 体育科学与技术"
    },
    {
        "id":3782,
        "name":"3784 (Thai Program)  :  Management Engineering | วิศวกรรมการจัดการ | 管理工程"
    },
    {
        "id":3783,
        "name":"3785 (Thai Program)  :  Product And Packaging Design | ออกแบบผลิตภัณฑ์และบรรจุภัณฑ์ | 产品及包装设计"
    },
    {
        "id":3784,
        "name":"3786 (Thai Program)  :  English - Comparative Literature | ภาษาอังกฤษ - วรรณคดีเปรียบเทียบ | 英语-比较文学"
    },
    {
        "id":3785,
        "name":"3787 (Thai Program)  :  Porcelain Design | ออกแบบเครื่องเคลือบดินเผา | 瓷器设计"
    },
    {
        "id":3786,
        "name":"3788 (English Program)  :  Behavioral Science | พฤติกรรมศาสตร์ | 行为科学"
    },
    {
        "id":3787,
        "name":"3789 (Thai Program)  :  Automated Office Management | การจัดการสำนักงานอัตโนมัติ | 自动化办公管理"
    },
    {
        "id":3788,
        "name":"3790 (Thai Program)  :  Multimedia And Animation Technology | มัลติมีเดียและแอนิเมชันเทคโนโลยี | 多媒体和动画技术"
    },
    {
        "id":3789,
        "name":"3791 (Thai Program)  :  Teaching Mathematics And Science | การสอนคณิตศาสตร์และวิทยาศาสตร์ | 教授数学和科学"
    },
    {
        "id":3790,
        "name":"3792 (Thai Program)  :  International Resource And Environmental Management | การจัดการทรัพยากรและสิ่งแวดล้อมระหว่างประเทศ | 国际资源与环境管理"
    },
    {
        "id":3791,
        "name":"3793 (Thai Program)  :  Nanoscience And Nanotechnology | นาโนวิทยาและนาโนเทคโนโลยี | 纳米科学与纳米技术"
    },
    {
        "id":3792,
        "name":"3794 (Thai Program)  :  Local Government Administration | การบริหารการปกครองท้องที่ | 地方政府行政"
    },
    {
        "id":3793,
        "name":"3795 (Thai Program)  :  Agricultural Management | การจัดการการเกษตร | 农业管理"
    },
    {
        "id":3794,
        "name":"3796 (Thai Program)  :  Agricultural Resource Management | การจัดการทรัพยากรเกษตร | 农业资源管理"
    },
    {
        "id":3795,
        "name":"3797 (Thai Program)  :  Applied Statistics And Information Technology | สถิติประยุกต์และเทคโนโลยีสารสนเทศ | 应用统计和信息技术"
    },
    {
        "id":3796,
        "name":"3798 (Thai Program)  :  Oceanography | สมุทรศาสตร์ | 海洋学"
    },
    {
        "id":3797,
        "name":"3799 (Thai Program)  :  Logistics Technology | เทคโนโลยีโลจิสติกส์ | 物流技术"
    },
    {
        "id":3798,
        "name":"3800 (Thai Program)  :  Network Engineering | วิศวกรรมเครือข่าย | 网络工程"
    },
    {
        "id":3799,
        "name":"3801 (Thai Program)  :  Commerce | พณิชยการ | 商业"
    },
    {
        "id":3800,
        "name":"3802 (Thai Program)  :  Mechanical | เครื่องกล | 机械的"
    },
    {
        "id":3801,
        "name":"3803 (Thai Program)  :  Metallurgy | โลหะการ | 冶金"
    },
    {
        "id":3802,
        "name":"3804 (Thai Program)  :  Electrical And Electronics | ไฟฟ้าและอิเล็กทรอนิกส์ | 电气和电子"
    },
    {
        "id":3803,
        "name":"3805 (Thai Program)  :  Business Computer | คอมพิวเตอร์ธุรกิจ | 商务电脑"
    },
    {
        "id":3804,
        "name":"3806 (English Program)  :  Agricultural | การเกษตร | 农业"
    },
    {
        "id":3805,
        "name":"3807 (Thai Program)  :  Agricultural Engineering | วิศวกรรมการเกษตร | 农业工程"
    },
    {
        "id":3806,
        "name":"3808 (Thai Program)  :  Agricultural Education | คุรุศาสตร์เกษตร | 农业教育"
    },
    {
        "id":3807,
        "name":"3809 (Thai Program)  :  Agricultural Industry | อุตสาหกรรมเกษตร | 农业工业"
    },
    {
        "id":3808,
        "name":"3810 (English Program)  :  Animal Functional Anatomy | กายวิภาคศาสตร์การทำงานของสัตว์ | 动物功能解剖学"
    },
    {
        "id":3809,
        "name":"3811 (English Program)  :  Animal Physiology And Nutrition | สรีรวิทยาและโภชนาการของสัตว์ | 动物生理学和营养"
    },
    {
        "id":3810,
        "name":"3812 (Thai Program)  :  Applied Biochemistry | ชีวเคมีประยุกต์ | 应用生物化学"
    },
    {
        "id":3811,
        "name":"3813 (English Program)  :  Applied Bioscience | วิทยาศาสตร์ชีวภาพประยุกต์ | 应用生物科学"
    },
    {
        "id":3812,
        "name":"3814 (English Program)  :  Applied Science For Electronics And Materials | วิทยาศาสตร์ประยุกต์สำหรับอิเล็กทรอนิกส์และวัสดุ | 电子与材料应用科学"
    },
    {
        "id":3813,
        "name":"3815 (Thai Program)  :  Biological Engineering | วิศวกรรมชีวภาพ | 生物工程"
    },
    {
        "id":3814,
        "name":"3816 (English Program)  :  Cell And Gene Biotechnology | เทคโนโลยีชีวภาพของเซลล์และยีน | 细胞和基因生物技术"
    },
    {
        "id":3815,
        "name":"3817 (English Program)  :  Crop Science | วิทยาศาสตร์พืชผล | 作物科学"
    },
    {
        "id":3816,
        "name":"3818 (English Program)  :  Dairy Science | วิทยาศาสตร์ผลิตภัณฑ์นม | 乳品科学"
    },
    {
        "id":3817,
        "name":"3819 (English Program)  :  Doctor Rerum Naturalium Technicarum | แพทย์เฉพาะทางเทคนิคธรรมชาติ | Doctor Rerum Naturalium 技术"
    },
    {
        "id":3818,
        "name":"3820 (English Program)  :  Entrepreneurship And Small Business Management | ผู้ประกอบการและการจัดการธุรกิจขนาดเล็ก | 创业和小企业管理"
    },
    {
        "id":3819,
        "name":"3821 (Thai Program)  :  Food Toxicology | พิษวิทยาทางอาหาร | 食品毒理学"
    },
    {
        "id":3820,
        "name":"3822 (Thai Program)  :  Forest Ecology | นิเวศวิทยาป่าไม้ | 森林生态学"
    },
    {
        "id":3821,
        "name":"3823 (Thai Program)  :  General Agricultural Science | วิทยาศาสตร์การเกษตรทั่วไป | 普通农业科学"
    },
    {
        "id":3822,
        "name":"3824 (Thai Program)  :  Genetics And Cell Biology | พันธุศาสตร์และชีววิทยาของเซลล์ | 遗传学和细胞生物学"
    },
    {
        "id":3823,
        "name":"3825 (English Program)  :  Genie Des Procedes | วิศวกรรมกระบวนการ | 收益精灵"
    },
    {
        "id":3824,
        "name":"3826 (English Program)  :  Horticulture Science | วิทยาศาสตร์พืชสวน | 园艺科学"
    },
    {
        "id":3825,
        "name":"3827 (Thai Program)  :  International Development | การพัฒนาระหว่างประเทศ | 国际化发展"
    },
    {
        "id":3826,
        "name":"3828 (Thai Program)  :  International Finance | การเงินระหว่างประเทศ | 国际金融"
    },
    {
        "id":3827,
        "name":"3829 (Thai Program)  :  Irrigation | ชลประทาน | 灌溉"
    },
    {
        "id":3828,
        "name":"3830 (Thai Program)  :  Language Studies | ภาษาศึกษา | 语言研究"
    },
    {
        "id":3829,
        "name":"3831 (Thai Program)  :  Marine Fisheries Science | วิทยาศาสตร์การประมงทางทะเล | 海洋渔业科学"
    },
    {
        "id":3830,
        "name":"3832 (English Program)  :  International Hospitality And Hotel Management | การต้อนรับระหว่างประเทศและการจัดการโรงแรม | 国际款待和酒店管理"
    },
    {
        "id":3831,
        "name":"3833 (Thai Program)  :  Modern Chinese | ภาษาจีนสมัยใหม่ | 现代汉语"
    },
    {
        "id":3832,
        "name":"3834 (Thai Program)  :  Raology | ราวิทยา | 拉学"
    },
    {
        "id":3833,
        "name":"3835 (Thai Program)  :  Natural Resources Economics | เศรษฐศาสตร์ทรัพยากรธรรมชาติ | 自然资源经济学"
    },
    {
        "id":3834,
        "name":"3836 (Thai Program)  :  Soil And Plant Science | วิทยาศาสตร์ทางดินและพืช | 土壤和植物科学"
    },
    {
        "id":3835,
        "name":"3837 (English Program)  :  Postharvest Physiology And Molecular Biology | สรีรวิทยาหลังการเก็บเกี่ยวและอณูชีววิทยา | 采后生理学和分子生物学"
    },
    {
        "id":3836,
        "name":"3838 (Thai Program)  :  Resource Economics | เศรษฐศาสตร์ทรัพยากร | 资源经济学"
    },
    {
        "id":3837,
        "name":"3839 (Thai Program)  :  Soil Science And Land Assessment | วิทยาศาสตร์ทางดินและประเมินที่ดิน | 土壤科学与土地评估"
    },
    {
        "id":3838,
        "name":"3840 (Thai Program)  :  Special English Teaching | การสอนภาษาอังกฤษเฉพาะกิจ | 特色英语教学"
    },
    {
        "id":3839,
        "name":"3841 (Thai Program)  :  Science Techniques | เทคนิควิทยาศาสตร์ | 科学技术"
    },
    {
        "id":3840,
        "name":"3842 (Thai Program)  :  Criminal Law And Criminal Justice | กฎหมายอาญาและกระบวนการยุติธรรมทางอาญา | 刑法和刑事司法"
    },
    {
        "id":3841,
        "name":"3843 (Thai Program)  :  Management Of Social And Cultural Resources | การจัดการทรัพยากรทางสังคมและวัฒนธรรม | 社会文化资源管理"
    },
    {
        "id":3842,
        "name":"3844 (Thai Program)  :  Social Development Management | การจัดการพัฒนาสังคม | 社会发展管理"
    },
    {
        "id":3843,
        "name":"3845 (Thai Program)  :  Project Management And Evaluation | การบริหารและประเมินโครงการ | 项目管理与评估"
    },
    {
        "id":3844,
        "name":"3846 (Thai Program)  :  Educational Measurement And Evaluation | การวัดผลและการประเมินผลการศึกษา | 教育测量与评价"
    },
    {
        "id":3845,
        "name":"3847 (Thai Program)  :  Education And Guidance | การศึกษาและการแนะแนว | 教育指导"
    },
    {
        "id":3846,
        "name":"3848 (Thai Program)  :  Teaching English As A Foreign Language | การสอนภาษาอังกฤษในฐานะภาษาต่างประเทศ | 英语作为外语教学"
    },
    {
        "id":3847,
        "name":"3849 (Thai Program)  :  Welder | ช่างเชื่อมโลหะ | 焊机"
    },
    {
        "id":3848,
        "name":"3850 (Thai Program)  :  Educational Technology And Media | เทคโนโลยีและสื่อการศึกษา | 教育技术和媒体"
    },
    {
        "id":3849,
        "name":"3851 (Thai Program)  :  Herbal Technology | เทคโนโลยีสมุนไพร | 草药技术"
    },
    {
        "id":3850,
        "name":"3852 (Thai Program)  :  Business Administration And Agricultural Marketing | บริหารธุรกิจและการตลาดการเกษตร | 工商管理和农业营销"
    },
    {
        "id":3851,
        "name":"3853 (Thai Program)  :  Toxicology And Nutrition For Food Safety | พิษวิทยาและโภชนาการเพื่ออาหารปลอดภัย | 食品安全毒理学和营养"
    },
    {
        "id":3852,
        "name":"3854 (Thai Program)  :  Computational Science | วิทยาศาสตร์คำนวณ | 计算科学"
    },
    {
        "id":3853,
        "name":"3855 (Thai Program)  :  Technology And Design Innovation | เทคโนโลยีและนวัตกรรมการออกแบบ | 技术与设计创新"
    },
    {
        "id":3854,
        "name":"3856 (Thai Program)  :  Management Of Ornamental Horticulture Plants | การจัดการพืชสวนประดับ | 观赏园艺植物的管理"
    },
    {
        "id":3855,
        "name":"3857 (Thai Program)  :  Industrial Technology Management | การจัดการเทคโนโลยีอุตสาหกรรม | 工业技术管理"
    },
    {
        "id":3856,
        "name":"3858 (Thai Program)  :  Clothing Business | ธุรกิจเสื้อผ้า | 服装业务"
    },
    {
        "id":3857,
        "name":"3859 (Thai Program)  :  Fashion And Clothing Technology | แฟชั่นและเทคโนโลยีเสื้อผ้า | 时尚与服装技术"
    },
    {
        "id":3858,
        "name":"3860 (Thai Program)  :  Food Product Development | การพัฒนาผลิตภัณฑ์อาหาร | 食品开发"
    },
    {
        "id":3859,
        "name":"3861 (Thai Program)  :  Development Of Thai Wisdom Products | การพัฒนาผลิตภัณฑ์ภูมิปัญญาไทย | 泰国智慧产品开发"
    },
    {
        "id":3860,
        "name":"3862 (Thai Program)  :  Tourism And Services | การท่องเที่ยวและการบริการ | 旅游和服务"
    },
    {
        "id":3861,
        "name":"3863 (Thai Program)  :  Food Safety Technology And Management | เทคโนโลยีและการจัดการความปลอดภัยของอาหาร | 食品安全技术与管理"
    },
    {
        "id":3862,
        "name":"3864 (Thai Program)  :  Social Work And Social Development | สังคมสงเคราะห์ศาสตร์และการพัฒนาสังคม | 社会工作和社会发展"
    },
    {
        "id":3863,
        "name":"3865 (Thai Program)  :  Educational Management | การบริหารจัดการการศึกษา | 教育管理"
    },
    {
        "id":3864,
        "name":"3866 (Thai Program)  :  Gemology | อัญมณีศาสตร์ | 宝石学"
    },
    {
        "id":3865,
        "name":"3867 (Thai Program)  :  Business Administration | การบริหารธุรกิจ | 商业管理"
    },
    {
        "id":3866,
        "name":"3868 (English Program)  :  Information And Control Engineering | วิศวกรรมสารสนเทศและการควบคุม | 信息与控制工程"
    },
    {
        "id":3867,
        "name":"3869 (English Program)  :  The Teacher As Consellor And Education Development Studies | ครูในฐานะผู้ให้คำปรึกษาและการศึกษาเพื่อการพัฒนาการศึกษา | 教师作为辅导员与教育发展研究"
    },
    {
        "id":3868,
        "name":"3870 (English Program)  :  Agriculture And Food Engineering | เกษตรและวิศวกรรมอาหาร | 农业与食品工程"
    },
    {
        "id":3869,
        "name":"3871 (English Program)  :  Applied Bioscience And Biotechnology | ชีววิทยาศาสตร์ประยุกต์และเทคโนโลยีชีวภาพ | 应用生物科学和生物技术"
    },
    {
        "id":3870,
        "name":"3872 (English Program)  :  Applied Economics | เศรษฐศาสตร์ประยุกต์ | 应用经济学"
    },
    {
        "id":3871,
        "name":"3873 (English Program)  :  Applied English Studies | การศึกษาภาษาอังกฤษประยุกต์ | 应用英语研究"
    },
    {
        "id":3872,
        "name":"3874 (Thai Program)  :  Applied Psychology | จิตวิทยาประยุกต์ | 应用心理学"
    },
    {
        "id":3873,
        "name":"3875 (English Program)  :  Bioengineering | วิศวกรรมชีวภาพ | 生物工程"
    },
    {
        "id":3874,
        "name":"3876 (English Program)  :  British And American Studies | การศึกษาของอังกฤษและอเมริกัน | 英国和美国研究"
    },
    {
        "id":3875,
        "name":"3877 (English Program)  :  Building Performance And Diagnostics | การสร้างประสิทธิภาพและการวินิจฉัย | 构建性能和诊断"
    },
    {
        "id":3876,
        "name":"3878 (English Program)  :  Building Studies | การศึกษาอาคาร | 建筑研究"
    },
    {
        "id":3877,
        "name":"3879 (English Program)  :  Business Associate | ผู้ร่วมธุรกิจ | 商业伙伴"
    },
    {
        "id":3878,
        "name":"3880 (English Program)  :  Ceramic And Materials Science And Engineering | วิทยาศาสตร์และวิศวกรรมเซรามิกและวัสดุ | 陶瓷与材料科学与工程"
    },
    {
        "id":3879,
        "name":"3881 (English Program)  :  Chemical Engineering And Applied Chemistry | วิศวกรรมเคมีและเคมีประยุกต์ | 化学工程与应用化学"
    },
    {
        "id":3880,
        "name":"3882 (English Program)  :  Chemical Engineering And Petroleum Refining | วิศวกรรมเคมีและการกลั่นปิโตรเลียม | 化学工程和石油炼制"
    },
    {
        "id":3881,
        "name":"3883 (English Program)  :  Chemical System Engineering | วิศวกรรมระบบเคมี | 化学系统工程"
    },
    {
        "id":3882,
        "name":"3884 (English Program)  :  Control Science And Dynamical Systems | วิทยาศาสตร์การควบคุมและระบบไดนามิก | 控制科学和动力学系统"
    },
    {
        "id":3883,
        "name":"3885 (English Program)  :  Design, Construction And Planning | การออกแบบ การก่อสร้าง และการวางแผน | 设计、施工和规划"
    },
    {
        "id":3884,
        "name":"3886 (English Program)  :  Divesion Of Mathematics And Information Sciences | สาขาวิชาคณิตศาสตร์และสารสนเทศศาสตร์ | 数学与信息科学系"
    },
    {
        "id":3885,
        "name":"3887 (English Program)  :  Electrical Engineering And Electronics | วิศวกรรมไฟฟ้าและอิเล็กทรอนิกส์ | 电气工程和电子"
    },
    {
        "id":3886,
        "name":"3888 (English Program)  :  Engineering Global Environmental Science And Engineering | วิศวกรรมศาสตร์สิ่งแวดล้อมและวิศวกรรมศาสตร์ระดับโลก | 工程全球环境科学与工程"
    },
    {
        "id":3887,
        "name":"3889 (English Program)  :  Engineering Mechanics | กลศาสตร์วิศวกรรม | 工程力学"
    },
    {
        "id":3888,
        "name":"3890 (English Program)  :  Engineering Science | วิทยาศาสตร์วิศวกรรมศาสตร์ | 工程科学"
    },
    {
        "id":3889,
        "name":"3891 (English Program)  :  English As An International Language (Eil) | ภาษาอังกฤษเป็นภาษาสากล (Eil) | 英语作为国际语言（Eil）"
    },
    {
        "id":3890,
        "name":"3892 (English Program)  :  English Language And Linguistics | ภาษาอังกฤษและภาษาศาสตร์ | 英语语言学"
    },
    {
        "id":3891,
        "name":"3893 (English Program)  :  Enironmental Science | วิทยาศาสตร์สิ่งแวดล้อม | 环境科学"
    },
    {
        "id":3892,
        "name":"3894 (English Program)  :  Environment Technology And Management | เทคโนโลยีและการจัดการสิ่งแวดล้อม | 环境技术与管理"
    },
    {
        "id":3893,
        "name":"3895 (English Program)  :  Environmental Design | การออกแบบสิ่งแวดล้อม | 环境设计"
    },
    {
        "id":3894,
        "name":"3896 (English Program)  :  Environmental Design And Engineering | การออกแบบสิ่งแวดล้อมและวิศวกรรม | 环境设计与工程"
    },
    {
        "id":3895,
        "name":"3897 (English Program)  :  Environmental Engineering And Management | วิศวกรรมสิ่งแวดล้อมและการจัดการ | 环境工程与管理"
    },
    {
        "id":3896,
        "name":"3898 (English Program)  :  Environmental Toxicology, Technology & Management | พิษวิทยาสิ่งแวดล้อม เทคโนโลยี และการจัดการ | 环境毒理学、技术与管理"
    },
    {
        "id":3897,
        "name":"3899 (English Program)  :  Food Fermentation | การหมักอาหาร | 食品发酵"
    },
    {
        "id":3898,
        "name":"3900 (English Program)  :  Graphic Design | การออกแบบกราฟิก | 平面设计"
    },
    {
        "id":3899,
        "name":"3901 (English Program)  :  Histories And Theories Of Architecture | ประวัติศาสตร์และทฤษฎีสถาปัตยกรรม | 建筑历史和理论"
    },
    {
        "id":3900,
        "name":"3902 (English Program)  :  Horticultural Sciences | วิทยาศาสตร์พืชสวน | 园艺科学"
    },
    {
        "id":3901,
        "name":"3903 (English Program)  :  Human-Social Information Sciences | วิทยาศาสตร์สารสนเทศมนุษย์และสังคม | 人类社会信息科学"
    },
    {
        "id":3902,
        "name":"3904 (English Program)  :  Interdisciplinary | สหวิทยาการ | 跨学科"
    },
    {
        "id":3903,
        "name":"3905 (English Program)  :  Marine, Estuarin And Environmental | ทางทะเล ปากแม่น้ำ และสิ่งแวดล้อม | 海洋、河口和环境"
    },
    {
        "id":3904,
        "name":"3906 (English Program)  :  Marketing Communications | การสื่อสารการตลาด | 营销传播"
    },
    {
        "id":3905,
        "name":"3907 (English Program)  :  Material Science Technology | เทคโนโลยีวิทยาศาสตร์วัสดุ | 材料科学技术"
    },
    {
        "id":3906,
        "name":"3908 (English Program)  :  Materials Engineering And Materials Design | วิศวกรรมวัสดุและการออกแบบวัสดุ | 材料工程和材料设计"
    },
    {
        "id":3907,
        "name":"3909 (English Program)  :  Materials Processing Engineering | วิศวกรรมการแปรรูปวัสดุ | 材料加工工程"
    },
    {
        "id":3908,
        "name":"3910 (English Program)  :  Mechanical And Aero Engineering | วิศวกรรมเครื่องกลและการบิน | 机械和航空工程"
    },
    {
        "id":3909,
        "name":"3911 (English Program)  :  Metallurgical And Material Engineering | วิศวกรรมโลหการและวัสดุ | 冶金与材料工程"
    },
    {
        "id":3910,
        "name":"3912 (English Program)  :  Meteorology | อุตุนิยมวิทยา | 气象"
    },
    {
        "id":3911,
        "name":"3913 (English Program)  :  Photographic Science And Printing Technology | วิทยาศาสตร์การถ่ายภาพและเทคโนโลยีการพิมพ์ | 摄影科学与印刷技术"
    },
    {
        "id":3912,
        "name":"3914 (English Program)  :  Polymer Chemistry | เคมีโพลีเมอร์ | 高分子化学"
    },
    {
        "id":3913,
        "name":"3915 (English Program)  :  Postharvest | หลังเก็บเกี่ยว | 采后"
    },
    {
        "id":3914,
        "name":"3916 (English Program)  :  Process Integration | การบูรณาการกระบวนการ | 流程整合"
    },
    {
        "id":3915,
        "name":"3917 (English Program)  :  Production And Processing Of Vegetal Raw Materials | การผลิตและการแปรรูปวัตถุดิบจากพืช | 植物原料的生产和加工"
    },
    {
        "id":3916,
        "name":"3918 (English Program)  :  Public Policy Management | การจัดการนโยบายสาธารณะ | 公共政策管理"
    },
    {
        "id":3917,
        "name":"3919 (English Program)  :  Satellite Communications Engineering | วิศวกรรมการสื่อสารผ่านดาวเทียม | 卫星通信工程"
    },
    {
        "id":3918,
        "name":"3920 (English Program)  :  Silver Medal | เหรียญเงิน | 银牌"
    },
    {
        "id":3919,
        "name":"3921 (English Program)  :  Soil Engineer | วิศวกรดิน | 土壤工程师"
    },
    {
        "id":3920,
        "name":"3922 (English Program)  :  Structural Engineering And Construction | วิศวกรรมโครงสร้างและการก่อสร้าง | 结构工程与施工"
    },
    {
        "id":3921,
        "name":"3923 (English Program)  :  Sustainable Energy Engineering | วิศวกรรมพลังงานที่ยั่งยืน | 可持续能源工程"
    },
    {
        "id":3922,
        "name":"3924 (English Program)  :  Technical Change And Industrial Strategy | การเปลี่ยนแปลงทางเทคนิคและกลยุทธ์ทางอุตสาหกรรม | 技术变革与产业战略"
    },
    {
        "id":3923,
        "name":"3925 (English Program)  :  The Built Environment | สภาพแวดล้อมที่สร้างขึ้น | 建筑环境"
    },
    {
        "id":3924,
        "name":"3926 (English Program)  :  Thermodynamics | เทอร์โมไดนามิกส์ | 热力学"
    },
    {
        "id":3925,
        "name":"3927 (English Program)  :  Three Dimensional Design | การออกแบบสามมิติ | 三维设计"
    },
    {
        "id":3926,
        "name":"3928 (English Program)  :  Training And Human Resource Management | การฝึกอบรมและการจัดการทรัพยากรมนุษย์ | 培训和人力资源管理"
    },
    {
        "id":3927,
        "name":"3929 (Thai Program)  :  Intellectual Property Law | กฎหมายทรัพย์สินทางปัญญา | 知识产权法"
    },
    {
        "id":3928,
        "name":"3930 (Thai Program)  :  Technology Management | การจัดการเทคโนโลยี | 技术管理"
    },
    {
        "id":3929,
        "name":"3931 (Thai Program)  :  Project Management And Evaluation | การจัดการและประเมินโครงการ | 项目管理与评估"
    },
    {
        "id":3930,
        "name":"3932 (Thai Program)  :  Secretarial Work | การเลขานุการ | 秘书工作"
    },
    {
        "id":3931,
        "name":"3933 (Thai Program)  :  Mechanical Education | ครุศาสตร์เครื่องกล | 机械教育"
    },
    {
        "id":3932,
        "name":"3934 (Thai Program)  :  Welder | ช่างเชื่อม | 焊机"
    },
    {
        "id":3933,
        "name":"3935 (Thai Program)  :  Weld | เชื่อมประสาน | 焊接"
    },
    {
        "id":3934,
        "name":"3936 (Thai Program)  :  Theory And Design | ทฤษฎีและการออกแบบ | 理论与设计"
    },
    {
        "id":3935,
        "name":"3937 (Thai Program)  :  Appropriate Technology For Resource Development | เทคโนโลยีที่เหมาะสมเพื่อการพัฒนาทรัพยากร | 资源开发的适当技术"
    },
    {
        "id":3936,
        "name":"3938 (Thai Program)  :  Computer Information Technology | เทคโนโลยีสารสนเทศคอมพิวเตอร์ | 计算机信息技术"
    },
    {
        "id":3937,
        "name":"3939 (Thai Program)  :  Electronic Technology | เทคโนโลยีอิเล็กทรอนิกส์ | 电子技术"
    },
    {
        "id":3938,
        "name":"3940 (Thai Program)  :  Computer Business Administration | บริหารธุรกิจคอมพิวเตอร์ | 计算机工商管理"
    },
    {
        "id":3939,
        "name":"3941 (Thai Program)  :  Public Relations | ประชาสัมพันธ์ | 公共关系"
    },
    {
        "id":3940,
        "name":"3942 (Thai Program)  :  Artificial Intelligence | ปัญญาประดิษฐ์ | 人工智能"
    },
    {
        "id":3941,
        "name":"3943 (Thai Program)  :  Pure Physics | ฟิสิกส์บริสุทธิ์ | 纯物理学"
    },
    {
        "id":3942,
        "name":"3944 (Thai Program)  :  Electricity | ไฟฟ้า | 电"
    },
    {
        "id":3943,
        "name":"3945 (Thai Program)  :  Applied Linguistics In English Language Teaching | ภาษาศาสตร์ประยุกต์ด้านการสอนภาษาอังกฤษ | 英语教学中的应用语言学"
    },
    {
        "id":3944,
        "name":"3946 (Thai Program)  :  Biochemical Engineering | วิศวกรรมขีวเคมี | 生化工程"
    },
    {
        "id":3945,
        "name":"3947 (Thai Program)  :  Engineering Tools And Materials | วิศวกรรมเครื่องมือและวัสดุ | 工程工具和材料"
    },
    {
        "id":3946,
        "name":"3948 (Thai Program)  :  Welding Engineering | วิศวกรรมงานเชื่อม | 焊接工程"
    },
    {
        "id":3947,
        "name":"3949 (Thai Program)  :  Systems Engineering | วิศวกรรมระบบ | 系统工程"
    },
    {
        "id":3948,
        "name":"3950 (Thai Program)  :  Sanitary Engineering | วิศวกรรมสุขาภิบาล | 卫浴工程"
    },
    {
        "id":3949,
        "name":"3951 (Thai Program)  :  Energy Economics And Policy | เศรษฐศาสตร์พลังงานและนโยบาย | 能源经济与政策"
    },
    {
        "id":3950,
        "name":"3952 (Thai Program)  :  Plant Physiology | สรีรวิทยาพืช | 植物生理学"
    },
    {
        "id":3951,
        "name":"3953 (Thai Program)  :  Community And Environmental Resource Development | การพัฒนาทรัพยากรชุมชนและสิ่งแวดล้อม | 社区和环境资源开发"
    },
    {
        "id":3952,
        "name":"3954 (English Program)  :  De Etudes Approfondies | การศึกษาเชิงลึก | 练习曲"
    },
    {
        "id":3953,
        "name":"3955 (English Program)  :  Design For The Environment | การออกแบบเพื่อสิ่งแวดล้อม | 环保设计"
    },
    {
        "id":3954,
        "name":"3956 (English Program)  :  Educational Communication And Technology | การสื่อสารและเทคโนโลยีการศึกษา | 教育传播与技术"
    },
    {
        "id":3955,
        "name":"3957 (English Program)  :  English As An International Languge | ภาษาอังกฤษเป็นภาษาสากล | 英语作为一种国际语言"
    },
    {
        "id":3956,
        "name":"3958 (English Program)  :  Ethnic Theory And Policy Of Marxism Speciality | ทฤษฎีชาติพันธุ์และนโยบายพิเศษของลัทธิมาร์กซิสม์ | 马克思主义民族理论与政策专业"
    },
    {
        "id":3957,
        "name":"3959 (English Program)  :  Etudes Indienes | การศึกษาอินเดีย | 印度练习曲"
    },
    {
        "id":3958,
        "name":"3960 (English Program)  :  Foreign Chinese Speciality | อาหารพิเศษของจีนจากต่างประเทศ | 外国 中餐 特色菜"
    },
    {
        "id":3959,
        "name":"3961 (English Program)  :  German Linguistics | ภาษาศาสตร์เยอรมัน | 德语语言学"
    },
    {
        "id":3960,
        "name":"3962 (English Program)  :  History Of Art And\/Or Archaeology | ประวัติศาสตร์ศิลปะและ\/หรือโบราณคดี | 艺术史和\/或考古学"
    },
    {
        "id":3961,
        "name":"3963 (English Program)  :  Hospitality Organization | องค์กรด้านการบริการ | 酒店组织"
    },
    {
        "id":3962,
        "name":"3964 (English Program)  :  Hydrology | อุทกวิทยา | 水文学"
    },
    {
        "id":3963,
        "name":"3965 (English Program)  :  Inter Affairs | กิจการระหว่างประเทศ | 国际事务"
    },
    {
        "id":3964,
        "name":"3966 (English Program)  :  International Marketing Management | การจัดการการตลาดระหว่างประเทศ | 国际营销管理"
    },
    {
        "id":3965,
        "name":"3967 (English Program)  :  Irish Studies And History | การศึกษาและประวัติศาสตร์ของชาวไอริช | 爱尔兰研究和历史"
    },
    {
        "id":3966,
        "name":"3968 (English Program)  :  Korean Literatur | วรรณกรรมเกาหลี | 韩国文学"
    },
    {
        "id":3967,
        "name":"3969 (English Program)  :  Lettres Sciences Humaines | จดหมายวิทยาศาสตร์ของมนุษย์ | 人文科学信件"
    },
    {
        "id":3968,
        "name":"3970 (English Program)  :  Maitrise Langues E'Trangeres Applioue'Es, Spe'Cialite' | ภาษาไมตรีและใบสมัครต่างประเทศ พิเศษ | Maitrise Langues E'Trangeres Applioue'Es, Spe'Cialite'"
    },
    {
        "id":3969,
        "name":"3971 (English Program)  :  Materials Science & Engineering | วัสดุศาสตร์และวิศวกรรมศาสตร์ | 材料科学与工程"
    },
    {
        "id":3970,
        "name":"3972 (English Program)  :  Modern And Contemporay Chinese History | ประวัติศาสตร์จีนสมัยใหม่และร่วมสมัย | 中国近现代史"
    },
    {
        "id":3971,
        "name":"3973 (English Program)  :  Second Class Honours(1St Division) | เกียรตินิยมอันดับสอง(ดิวิชั่น 1) | 二等荣誉（第一组）"
    },
    {
        "id":3972,
        "name":"3974 (English Program)  :  Social Pedagogiche Hulpverlening | การสอนสังคมแบบพลิกผัน | 许尔普维莱宁社会教育"
    },
    {
        "id":3973,
        "name":"3975 (English Program)  :  Sociology And Anthropology Of Travel And Tourism | สังคมวิทยาและมานุษยวิทยาการท่องเที่ยวและการท่องเที่ยว | 旅游社会学和人类学"
    },
    {
        "id":3974,
        "name":"3976 (English Program)  :  Tourism Planning | การวางแผนการท่องเที่ยว | 旅游规划"
    },
    {
        "id":3975,
        "name":"3977 (Thai Program)  :  Management, Economics And Social Sciences | การบริหารเศรษฐศาสตร์และสังคมศาสตร์ | 管理学、经济学和社会科学"
    },
    {
        "id":3976,
        "name":"3978 (Thai Program)  :  Developmental Communication Arts | นิเทศศาสตร์การพัฒนาการ | 发展传播艺术"
    },
    {
        "id":3977,
        "name":"3979 (Thai Program)  :  Chinese Literature From The Near And Present Periods | วรรณกรรมจีนยุคใกล้และยุคปัจจุบัน | 中国近现代文学"
    },
    {
        "id":3978,
        "name":"3980 (English Program)  :  Art Studio | สตูดิโอศิลปะ | 艺术工作室"
    },
    {
        "id":3979,
        "name":"3981 (English Program)  :  Astronomy | ดาราศาสตร์ | 天文学"
    },
    {
        "id":3980,
        "name":"3982 (English Program)  :  Business Analysis | การวิเคราะห์ธุรกิจ | 业务分析"
    },
    {
        "id":3981,
        "name":"3983 (English Program)  :  Clarinet Performance | ประสิทธิภาพของคลาริเน็ต | 单簧管演奏"
    },
    {
        "id":3982,
        "name":"3984 (English Program)  :  Composition | องค์ประกอบ | 作品"
    },
    {
        "id":3983,
        "name":"3985 (Thai Program)  :  Energy Management Engineering | วิศวกรรมการจัดการพลังงาน | 能源管理工程"
    },
    {
        "id":3984,
        "name":"3986 (Thai Program)  :  Applied Electrical Engineering | วิศวกรรมไฟฟ้าประยุกต์ | 应用电气工程"
    },
    {
        "id":3985,
        "name":"3987 (Thai Program)  :  Asian Studies And Tourism | เอเชียศึกษาและการท่องเที่ยว | 亚洲研究和旅游"
    },
    {
        "id":3986,
        "name":"3988 (Thai Program)  :  Computer Multimedia Architecture | คอมพิวเตอร์มัลติมีเดียสถาปัตยกรรม | 计算机多媒体体系结构"
    },
    {
        "id":3987,
        "name":"3989 (Thai Program)  :  Mathematics And Computer Studies | คณิตศาสตร์และคอมพิวเตอร์ศึกษา | 数学和计算机研究"
    },
    {
        "id":3988,
        "name":"3990 (Thai Program)  :  Teaching English As An International Language | การสอนภาษาอังกฤษเป็นภาษานานาชาติ | 将英语作为国际语言进行教学"
    },
    {
        "id":3989,
        "name":"3991 (Thai Program)  :  Management Of The Service And Tourism Industry | การจัดการอุตสาหกรรมบริการและท่องเที่ยว | 服务业和旅游业管理"
    },
    {
        "id":3990,
        "name":"3992 (Thai Program)  :  Brand Communication | การสื่อสารตรา | 品牌传播"
    },
    {
        "id":3991,
        "name":"3993 (Thai Program)  :  Health Informatics | สนเทศศาสตร์ทางสุขภาพ | 健康信息学"
    },
    {
        "id":3992,
        "name":"3994 (Thai Program)  :  Home Economics Administration | การบริหารงานคหกรรมศาสตร์ | 家政管理"
    },
    {
        "id":3993,
        "name":"3995 (English Program)  :  Clinical And Community Psychology | จิตวิทยาคลินิกและชุมชน | 临床和社区心理学"
    },
    {
        "id":3994,
        "name":"3996 (English Program)  :  Community Psychology | จิตวิทยาชุมชน | 社区心理学"
    },
    {
        "id":3995,
        "name":"3997 (Thai Program)  :  English-Chinese | ภาษาอังกฤษ-ภาษาจีน | 英汉"
    },
    {
        "id":3996,
        "name":"3998 (Thai Program)  :  Curriculum And Learning Management | การจัดการหลักสูตรและการเรียนรู้ | 课程和学习管理"
    },
    {
        "id":3997,
        "name":"3999 (Thai Program)  :  Conference And Expo Management | การจัดการการประชุมและงานมหกรรม | 会议及展览管理"
    },
    {
        "id":3998,
        "name":"4000 (Thai Program)  :  Integrating Social Welfare Policies | บูรณาการนโยบายสวัสดิการสังคม | 整合社会福利政策"
    },
    {
        "id":3999,
        "name":"4001 (Thai Program)  :  Thai Language For Communication For Foreigners | ภาษาไทยเพื่อการสื่อสารสำหรับชาวต่างชาติ | 适合外国人交流的泰语"
    },
    {
        "id":4000,
        "name":"4002 (Thai Program)  :  Business And Computer Studies | ธุรกิจและคอมพิวเตอร์ศึกษา | 商业和计算机研究"
    },
    {
        "id":4001,
        "name":"4003 (Thai Program)  :  Agricultural Resources | ทรัพยากรเกษตร | 农业资源"
    },
    {
        "id":4002,
        "name":"4004 (Thai Program)  :  Veterinary Biological Sciences | วิทยาศาสตร์ชีวภาพทางสัตวแพทย์ | 兽医生物科学"
    },
    {
        "id":4003,
        "name":"4005 (Thai Program)  :  Applied Food Science And Hospitality | วิทยาศาสตร์อาหารประยุกต์และการบริการ | 应用食品科学与酒店管理"
    },
    {
        "id":4004,
        "name":"4006 (Thai Program)  :  Mathematics And Statistics | คณิตศาสตร์และสถิติ | 数学与统计学"
    },
    {
        "id":4005,
        "name":"4007 (Thai Program)  :  Business Administration (Finance) | บริหารธุรกิจ(การเงิน) | 工商管理（金融）"
    },
    {
        "id":4006,
        "name":"4008 (Thai Program)  :  Philosophy And Ethics | ปรัชญาและจริยศาสตร์ | 哲学与伦理"
    },
    {
        "id":4007,
        "name":"4009 (Thai Program)  :  Industrial Crop Production | การผลิตพืชอุตสาหกรรม | 工业作物生产"
    },
    {
        "id":4008,
        "name":"4010 (Thai Program)  :  Homeopathy | โฮมีโอพาธีย์ | 顺势疗法"
    },
    {
        "id":4009,
        "name":"4011 (Thai Program)  :  Design Art | ศิลปะการออกแบบ | 设计艺术"
    },
    {
        "id":4010,
        "name":"4012 (Thai Program)  :  Health And Beauty | สุขภาพและความงาม | 健康与美丽"
    },
    {
        "id":4011,
        "name":"4013 (Thai Program)  :  Sustainable Tourism Management | การจัดการการท่องเที่ยวอย่างยั่งยืน | 可持续旅游管理"
    },
    {
        "id":4012,
        "name":"4014 (Thai Program)  :  Mathematics And Teaching Technology | คณิตศาสตร์และเทคโนโลยีการสอน | 数学与教学技术"
    },
    {
        "id":4013,
        "name":"4015 (Thai Program)  :  Civil Engineering And Construction Management | วิศวกรรมโยธาและการบริหารงานก่อสร้าง | 土木工程与施工管理"
    },
    {
        "id":4014,
        "name":"4016 (Thai Program)  :  Culture For Tourism | วัฒนธรรมเพื่อการท่องเที่ยว | 旅游文化"
    },
    {
        "id":4015,
        "name":"4017 (Thai Program)  :  Accounting And Finance | การบัญชีและการเงิน | 会计与金融"
    },
    {
        "id":4016,
        "name":"4018 (Thai Program)  :  Design Innovative Visual Arts | ออกแบบนวัตกรรมทัศนศิลป์ | 设计创新视觉艺术"
    },
    {
        "id":4017,
        "name":"4019 (Thai Program)  :  Integrating Health And Beauty | บูรณาการสุขภาพและความงาม | 健康与美丽融为一体"
    },
    {
        "id":4018,
        "name":"4020 (Thai Program)  :  Tourism Business Management | การจัดการธุรกิจท่องเที่ยว | 旅游企业管理"
    },
    {
        "id":4019,
        "name":"4021 (Thai Program)  :  Performance Communication | การสื่อสารการแสดง | 绩效沟通"
    },
    {
        "id":4020,
        "name":"4022 (Thai Program)  :  Electronic Learning Methods | วิธีวิทยาการเรียนทางอิเล็กทรอนิกส์ | 电子学习方法"
    },
    {
        "id":4021,
        "name":"4023 (Thai Program)  :  Thai Language For Communication For Foreigners | ภาษาไทยเพื่อการสื่อสารสำหรับชาวต่างประเทศ | 适合外国人交流的泰语"
    },
    {
        "id":4022,
        "name":"4024 (Thai Program)  :  Restaurant And Accommodation Business | ธุรกิจภัตตาคารและที่พัก | 餐饮及住宿业"
    },
    {
        "id":4023,
        "name":"4025 (Thai Program)  :  Aviation Business | ธุรกิจการบิน | 航空业务"
    },
    {
        "id":4024,
        "name":"4026 (Thai Program)  :  Financial Engineering | วิศวกรรมการเงิน | 金融工程"
    },
    {
        "id":4025,
        "name":"4027 (Thai Program)  :  Computer Graphics And Animation | คอมพิวเตอร์กราฟิกส์และเอนิเมชัน | 计算机图形学和动画"
    },
    {
        "id":4026,
        "name":"4028 (Thai Program)  :  Logistics And Supply Chain Management | การจัดการโลจิสติกส์และโซ่อุปทาน | 物流和供应链管理"
    },
    {
        "id":4027,
        "name":"4029 (Thai Program)  :  Visual Arts And Design | ทัศนศิลป์และการออกแบบ | 视觉艺术与设计"
    },
    {
        "id":4028,
        "name":"4030 (Thai Program)  :  Graphic Design | กราฟิกดีไซน์ | 平面设计"
    },
    {
        "id":4029,
        "name":"4031 (Thai Program)  :  Innovation Management For Development | การบริหารนวัตกรรมเพื่อการพัฒนา | 创新管理促进发展"
    },
    {
        "id":4030,
        "name":"4032 (Thai Program)  :  Thai Language For Business Communication | ภาษาไทยเพื่อการสื่อสารทางธุรกิจ | 泰语用于商务沟通"
    },
    {
        "id":4031,
        "name":"4033 (Thai Program)  :  Geoinformatics | ภูมิสารสนเทศศาสตร์ | 地理信息学"
    },
    {
        "id":4032,
        "name":"4034 (Thai Program)  :  Professional English | ภาษาอังกฤษเชิงวิชาชีพ | 专业英语"
    },
    {
        "id":4033,
        "name":"4035 (Thai Program)  :  Investment Analysis And Management | การวิเคราะห์และจัดการการลงทุน | 投资分析与管理"
    },
    {
        "id":4034,
        "name":"4036 (English Program)  :  Developmental Psychology | จิตวิทยาการพัฒนา | 发展心理学"
    },
    {
        "id":4035,
        "name":"4037 (English Program)  :  Social Psychology | จิตวิทยาสังคม | 社会心理学"
    },
    {
        "id":4036,
        "name":"4038 (English Program)  :  Organizational Psychology | จิตวิทยาองค์กร | 组织心理学"
    },
    {
        "id":4037,
        "name":"4039 (English Program)  :  Industrial Psychology | จิตวิทยาอุตสาหกรรม | 工业心理学"
    },
    {
        "id":4038,
        "name":"4040 (English Program)  :  Industrial And Organizational Psychology | จิตวิทยาอุตสาหกรรมและองค์กร | 工业和组织心理学"
    },
    {
        "id":4039,
        "name":"4041 (English Program)  :  Psychology And Guidance | จิตวิทยาและการแนะแนว | 心理与指导"
    },
    {
        "id":4040,
        "name":"4042 (English Program)  :  School Psychology | จิตวิทยาโรงเรียน | 学校心理学"
    },
    {
        "id":4041,
        "name":"4043 (English Program)  :  Psychiatry | จิตเวชศาสตร์ | 精神病学"
    },
    {
        "id":4042,
        "name":"4044 (English Program)  :  Chinese Studies | การศึกษาภาษาจีน | 中国研究"
    },
    {
        "id":4043,
        "name":"4045 (English Program)  :  Microbiology | จุลชีววิทยา | 微生物学"
    },
    {
        "id":4044,
        "name":"4046 (English Program)  :  Clinical Microbiology | จุลชีววิทยาคลินิก | 临床微生物学"
    },
    {
        "id":4045,
        "name":"4047 (English Program)  :  Applied Microbiology | จุลชีววิทยาประยุกต์ | 应用微生物学"
    },
    {
        "id":4046,
        "name":"4048 (English Program)  :  Clinical Microscopy | กล้องจุลทรรศน์ทางคลินิก | 临床显微镜"
    },
    {
        "id":4047,
        "name":"4049 (English Program)  :  Medical Imaging | การสร้างภาพทางการแพทย์ | 医学影像"
    },
    {
        "id":4048,
        "name":"4050 (English Program)  :  Rural Studies And Development | การศึกษาและการพัฒนาชนบท | 农村研究与发展"
    },
    {
        "id":4049,
        "name":"4051 (English Program)  :  Health Laboratory | ห้องปฏิบัติการสุขภาพ | 健康实验室"
    },
    {
        "id":4050,
        "name":"4052 (English Program)  :  Biology | ชีววิทยา | 生物学"
    },
    {
        "id":4051,
        "name":"4053 (English Program)  :  Cell And Molecular Biology | ชีววิทยาของเซลล์และโมเลกุล | 细胞和分子生物学"
    },
    {
        "id":4052,
        "name":"4054 (English Program)  :  Oral Biology | ชีววิทยาช่องปาก | 口腔生物学"
    },
    {
        "id":4053,
        "name":"4055 (English Program)  :  Fishery Biology | ชีววิทยาการประมง | 渔业生物学"
    },
    {
        "id":4054,
        "name":"4056 (English Program)  :  Applied Biology | ชีววิทยาประยุกต์ | 应用生物学"
    },
    {
        "id":4055,
        "name":"4057 (English Program)  :  Forest Biology | ชีววิทยาป่าไม้ | 森林生物学"
    },
    {
        "id":4056,
        "name":"4058 (English Program)  :  Biology Education | การศึกษาชีววิทยา | 生物教育"
    },
    {
        "id":4057,
        "name":"4059 (English Program)  :  Conservation Biology | ชีววิทยาการอนุรักษ์ | 保护生物学"
    },
    {
        "id":4058,
        "name":"4060 (English Program)  :  Biostatistics | ชีวสถิติ | 生物统计学"
    },
    {
        "id":4059,
        "name":"4061 (English Program)  :  Bioinformatics | ชีวสารสนเทศศาสตร์ | 生物信息学"
    },
    {
        "id":4060,
        "name":"4062 (English Program)  :  Biochemistry | ชีวเคมี | 生物化学"
    },
    {
        "id":4061,
        "name":"4063 (English Program)  :  Medical Biochemistry | ชีวเคมีการแพทย์ | 医学生物化学"
    },
    {
        "id":4062,
        "name":"4064 (English Program)  :  Biochemistry And Biochemical Technology | ชีวเคมีและเทคโนโลยีชีวเคมี | 生物化学与生化技术"
    },
    {
        "id":4063,
        "name":"4065 (English Program)  :  Biomedical Chemistry | เคมีชีวการแพทย์ | 生物医学化学"
    },
    {
        "id":4064,
        "name":"4066 (English Program)  :  Technicians | ช่างเทคนิค | 技术人员"
    },
    {
        "id":4065,
        "name":"4067 (English Program)  :  Civil Construction | การก่อสร้างโยธา | 土木建筑"
    },
    {
        "id":4066,
        "name":"4068 (English Program)  :  Dental Technician | ช่างทันตกรรม | 牙科技师"
    },
    {
        "id":4067,
        "name":"4069 (English Program)  :  Industrial Piping And Welding | ท่ออุตสาหกรรมและการเชื่อม | 工业管道和焊接"
    },
    {
        "id":4068,
        "name":"4070 (English Program)  :  Auto Mechanics | กลไกอัตโนมัติ | 汽车机械"
    },
    {
        "id":4069,
        "name":"4071 (English Program)  :  Electronic Mechanics | กลศาสตร์อิเล็กทรอนิกส์ | 电子机械"
    },
    {
        "id":4070,
        "name":"4072 (English Program)  :  Electronic Mechanics (Instrumentation And Control) | กลศาสตร์อิเล็กทรอนิกส์ (เครื่องมือและการควบคุม) | 电子机械（仪表与控制）"
    },
    {
        "id":4071,
        "name":"4073 (English Program)  :  Industrial Trade | การค้าอุตสาหกรรม | 工业贸易"
    },
    {
        "id":4072,
        "name":"4074 (English Program)  :  Medical Instrumental Technician | ช่างเทคนิคเครื่องมือแพทย์ | 医疗仪器技术员"
    },
    {
        "id":4073,
        "name":"4075 (English Program)  :  Mechanical Drafting | การร่างเครื่องกล | 机械制图"
    },
    {
        "id":4074,
        "name":"4076 (English Program)  :  Industrial Mechanics | กลศาสตร์อุตสาหกรรม | 工业机械"
    },
    {
        "id":4075,
        "name":"4077 (English Program)  :  Machine Wood Working Mechanics | กลไกการทำงานของเครื่องจักรไม้ | 机械木工机械"
    },
    {
        "id":4076,
        "name":"4078 (English Program)  :  Refrigeration And Air Conditioning Technology | เทคโนโลยีการทำความเย็นและการปรับอากาศ | 制冷与空调技术"
    },
    {
        "id":4077,
        "name":"4079 (English Program)  :  Furniture And Decoration | เฟอร์นิเจอร์และของตกแต่ง | 家具及装饰品"
    },
    {
        "id":4078,
        "name":"4080 (English Program)  :  Electrical Mechanics | เครื่องกลไฟฟ้า | 电气机械"
    },
    {
        "id":4079,
        "name":"4081 (English Program)  :  Industrial Electrical Mechanics | กลศาสตร์ไฟฟ้าอุตสาหกรรม | 工业电气机械"
    },
    {
        "id":4080,
        "name":"4082 (English Program)  :  Japanese Studies | การศึกษาภาษาญี่ปุ่น | 日本研究"
    },
    {
        "id":4081,
        "name":"4083 (English Program)  :  Jass | แจส | 贾斯"
    },
    {
        "id":4082,
        "name":"4084 (English Program)  :  Music Arts | ศิลปะดนตรี | 音乐艺术"
    },
    {
        "id":4083,
        "name":"4085 (English Program)  :  Western Instrumental Music | ดนตรีบรรเลงตะวันตก | 西方器乐"
    },
    {
        "id":4084,
        "name":"4086 (English Program)  :  Thai Instrumental Music | ดนตรีไทย | 泰国器乐"
    },
    {
        "id":4085,
        "name":"4087 (English Program)  :  Dermatology | โรคผิวหนัง | 皮肤科"
    },
    {
        "id":4086,
        "name":"4088 (English Program)  :  Agricultural Resources And Environment | ทรัพยากรการเกษตรและสิ่งแวดล้อม | 农业资源与环境"
    },
    {
        "id":4087,
        "name":"4089 (English Program)  :  Agro-Bioresources | ทรัพยากรชีวภาพเกษตร | 农业生物资源"
    },
    {
        "id":4088,
        "name":"4090 (English Program)  :  Art Theory | ทฤษฎีศิลปะ | 艺术理论"
    },
    {
        "id":4089,
        "name":"4091 (English Program)  :  Economic Theory | ทฤษฎีเศรษฐศาสตร์ | 经济理论"
    },
    {
        "id":4090,
        "name":"4092 (English Program)  :  Theories And Techniques In Political Science | ทฤษฎีและเทคนิคทางรัฐศาสตร์ | 政治学理论与技术"
    },
    {
        "id":4091,
        "name":"4093 (English Program)  :  Orthodontics | ทันตกรรมจัดฟัน | 正畸学"
    },
    {
        "id":4092,
        "name":"4094 (English Program)  :  General Dentistry | ทันตกรรมทั่วไป | 普通牙科"
    },
    {
        "id":4093,
        "name":"4095 (English Program)  :  Occlusion | การบดเคี้ยว | 遮挡"
    },
    {
        "id":4094,
        "name":"4096 (English Program)  :  Prosthodontics | ทันตกรรมประดิษฐ์ | 修复学"
    },
    {
        "id":4095,
        "name":"4097 (English Program)  :  Preventive Dentistry | ทันตกรรมป้องกัน | 预防性牙科"
    },
    {
        "id":4096,
        "name":"4098 (English Program)  :  Pedodontics | ทันตกรรมสำหรับเด็ก | 儿童牙科"
    },
    {
        "id":4097,
        "name":"4099 (English Program)  :  Operative Dentistry | ทันตกรรมหัตถการ | 牙科手术"
    },
    {
        "id":4098,
        "name":"4100 (English Program)  :  Dental Biomaterials Science | วิทยาศาสตร์ชีววัสดุทันตกรรม | 牙科生物材料科学"
    },
    {
        "id":4099,
        "name":"4101 (English Program)  :  Dental Radiology | รังสีวิทยาทันตกรรม | 牙科放射学"
    },
    {
        "id":4100,
        "name":"4102 (English Program)  :  Community Dental Health | สุขภาพฟันชุมชน | 社区牙科健康"
    },
    {
        "id":4101,
        "name":"4103 (English Program)  :  Dental Surgery | ศัลยกรรมทันตกรรม | 牙科手术"
    },
    {
        "id":4102,
        "name":"4104 (English Program)  :  Dentistry | ทันตกรรม | 牙科"
    },
    {
        "id":4103,
        "name":"4105 (English Program)  :  Visual Arts | ทัศนศิลป์ | 视觉艺术"
    },
    {
        "id":4104,
        "name":"4106 (English Program)  :  Geophysics | ธรณีฟิสิกส์ | 地球物理学"
    },
    {
        "id":4105,
        "name":"4107 (English Program)  :  Applied Geophysics | ธรณีฟิสิกส์ประยุกต์ | 应用地球物理学"
    },
    {
        "id":4106,
        "name":"4108 (English Program)  :  Geology | ธรณีวิทยา | 地质学"
    },
    {
        "id":4107,
        "name":"4109 (English Program)  :  Dhamma Communication | การสื่อสารธรรม | 佛法交流"
    },
    {
        "id":4108,
        "name":"4110 (English Program)  :  Maritime Management | การจัดการทางทะเล | 海事管理"
    },
    {
        "id":4109,
        "name":"4111 (English Program)  :  International Business | ธุรกิจระหว่างประเทศ | 国际业务"
    },
    {
        "id":4110,
        "name":"4112 (English Program)  :  Business Education | การศึกษาด้านธุรกิจ | 商业教育"
    },
    {
        "id":4111,
        "name":"4113 (English Program)  :  Real Estate Business | ธุรกิจอสังหาริมทรัพย์ | 房地产业务"
    },
    {
        "id":4112,
        "name":"4114 (English Program)  :  Gems And Jewelry Business | ธุรกิจอัญมณีและเครื่องประดับ | 宝石和珠宝业务"
    },
    {
        "id":4113,
        "name":"4115 (English Program)  :  Food Business | ธุรกิจอาหาร | 食品业务"
    },
    {
        "id":4114,
        "name":"4116 (English Program)  :  Industrial Business | ธุรกิจอุตสาหกรรม | 工业业务"
    },
    {
        "id":4115,
        "name":"4117 (English Program)  :  Agribusiness | ธุรกิจการเกษตร | 农业企业"
    },
    {
        "id":4116,
        "name":"4118 (English Program)  :  Creative Arts | ศิลปะสร้างสรรค์ | 创意艺术"
    },
    {
        "id":4117,
        "name":"4119 (English Program)  :  Recreation | นันทนาการ | 娱乐"
    },
    {
        "id":4118,
        "name":"4120 (English Program)  :  Dance | เต้นรำ | 舞蹈"
    },
    {
        "id":4119,
        "name":"4121 (English Program)  :  Dancing Arts | ศิลปะการเต้นรำ | 舞蹈艺术"
    },
    {
        "id":4120,
        "name":"4122 (English Program)  :  Thai Dance | รำไทย | 泰国舞蹈"
    },
    {
        "id":4121,
        "name":"4123 (English Program)  :  Thai Theater And Dance | ละครไทยและนาฏศิลป์ | 泰国戏剧和舞蹈"
    },
    {
        "id":4122,
        "name":"4124 (English Program)  :  Theater | โรงภาพยนตร์ | 剧院"
    },
    {
        "id":4123,
        "name":"4125 (English Program)  :  Ballet | บัลเล่ต์ | 芭蕾舞"
    },
    {
        "id":4124,
        "name":"4126 (English Program)  :  Thai Classical Dance | นาฏศิลป์ไทย | 泰国古典舞蹈"
    },
    {
        "id":4125,
        "name":"4127 (English Program)  :  Classical Dance And Drama | การเต้นรำคลาสสิกและละคร | 古典舞蹈和戏剧"
    },
    {
        "id":4126,
        "name":"4128 (English Program)  :  Thai Dramatic Arts | นาฏศิลป์ไทย | 泰国戏剧艺术"
    },
    {
        "id":4127,
        "name":"4129 (English Program)  :  Laws | กฎหมาย | 法律"
    },
    {
        "id":4128,
        "name":"4130 (English Program)  :  Forensic Medicine | นิติเวชศาสตร์ | 法医学"
    },
    {
        "id":4129,
        "name":"4131 (English Program)  :  Nuclear Technology | เทคโนโลยีนิวเคลียร์ | 核技术"
    },
    {
        "id":4130,
        "name":"4132 (English Program)  :  Supervision And Curriculum Development | การนิเทศและการพัฒนาหลักสูตร | 监督和课程开发"
    },
    {
        "id":4131,
        "name":"4133 (English Program)  :  Visual Communication Arts | ศิลปะการสื่อสารด้วยภาพ | 视觉传达艺术"
    },
    {
        "id":4132,
        "name":"4134 (English Program)  :  Ecology | นิเวศวิทยา | 生态"
    },
    {
        "id":4133,
        "name":"4135 (English Program)  :  Environmental Ecology | นิเวศวิทยาสิ่งแวดล้อม | 环境生态学"
    },
    {
        "id":4134,
        "name":"4136 (English Program)  :  Public Policy | นโยบายสาธารณะ | 公共政策"
    },
    {
        "id":4135,
        "name":"4137 (English Program)  :  Communication Policy And Planning | นโยบายและการวางแผนการสื่อสาร | 传播政策和规划"
    },
    {
        "id":4136,
        "name":"4138 (English Program)  :  Social Policy And Planning | นโยบายสังคมและการวางแผน | 社会政策与规划"
    },
    {
        "id":4137,
        "name":"4139 (English Program)  :  Library Science | วิทยาศาสตร์ห้องสมุด | 图书馆学"
    },
    {
        "id":4138,
        "name":"4140 (English Program)  :  Academic Support Services For Blindor Low Vision Persons | บริการสนับสนุนทางวิชาการสำหรับคนตาบอดหรือผู้มีสายตาเลือนราง | 为盲人低视力人士提供学术支持服务"
    },
    {
        "id":4139,
        "name":"4141 (English Program)  :  Public Health Law Administration | การบริหารกฎหมายสาธารณสุข | 公共卫生法管理局"
    },
    {
        "id":4140,
        "name":"4142 (English Program)  :  Agricultural And Forestry Administration | การบริหารการเกษตรและป่าไม้ | 农林管理局"
    },
    {
        "id":4141,
        "name":"4143 (English Program)  :  Agricultural Business Administration | การบริหารธุรกิจการเกษตร | 农业工商管理"
    },
    {
        "id":4142,
        "name":"4144 (English Program)  :  Vocational And Technical Education Management | การจัดการอาชีวศึกษาและเทคนิคการศึกษา | 职业技术教育管理"
    },
    {
        "id":4143,
        "name":"4145 (English Program)  :  Industrial And Operations Management | การจัดการอุตสาหกรรมและการปฏิบัติการ | 工业和运营管理"
    },
    {
        "id":4144,
        "name":"4146 (English Program)  :  Pharmacy Administration | การบริหารเภสัชกรรม | 药房管理"
    },
    {
        "id":4145,
        "name":"4147 (English Program)  :  Graduate Volunteer | อาสาสมัครระดับบัณฑิตศึกษา | 毕业生志愿者"
    },
    {
        "id":4146,
        "name":"4148 (English Program)  :  Rural Development Volunteer | อาสาสมัครพัฒนาชนบท | 农村发展志愿者"
    },
    {
        "id":4147,
        "name":"4149 (English Program)  :  Pali Buddhism | พุทธศาสนาบาลี | 巴利语佛教"
    },
    {
        "id":4148,
        "name":"4150 (English Program)  :  Home And Community | บ้านและชุมชน | 家庭和社区"
    },
    {
        "id":4149,
        "name":"4151 (English Program)  :  Soil Science And Conservation | วิทยาศาสตร์ดินและการอนุรักษ์ | 土壤科学与保护"
    },
    {
        "id":4150,
        "name":"4152 (English Program)  :  Parasitology | ปรสิตวิทยา | 寄生虫学"
    },
    {
        "id":4151,
        "name":"4153 (English Program)  :  Medical Parasitology | ปรสิตวิทยาทางการแพทย์ | 医学寄生虫学"
    },
    {
        "id":4152,
        "name":"4154 (English Program)  :  Population And The Environment | ประชากรและสิ่งแวดล้อม | 人口与环境"
    },
    {
        "id":4153,
        "name":"4155 (English Program)  :  Demography | ประชากรศาสตร์ | 人口统计"
    },
    {
        "id":4154,
        "name":"4156 (English Program)  :  Sociology In Demography | สังคมวิทยาทางประชากรศาสตร์ | 人口社会学"
    },
    {
        "id":4155,
        "name":"4157 (English Program)  :  Population Education | การศึกษาประชากร | 人口教育"
    },
    {
        "id":4156,
        "name":"4158 (English Program)  :  Population And Development | ประชากรและการพัฒนา | 人口与发展"
    },
    {
        "id":4157,
        "name":"4159 (English Program)  :  Population And Education | ประชากรและการศึกษา | 人口与教育"
    },
    {
        "id":4158,
        "name":"4160 (English Program)  :  Population And Agriculture | ประชากรและเกษตรกรรม | 人口与农业"
    },
    {
        "id":4159,
        "name":"4161 (English Program)  :  Population And Human Resources | ประชากรและทรัพยากรมนุษย์ | 人口和人力资源"
    },
    {
        "id":4160,
        "name":"4162 (English Program)  :  Population And Health | ประชากรและสุขภาพ | 人口与健康"
    },
    {
        "id":4161,
        "name":"4163 (English Program)  :  Sculpture | ประติมากรรม | 雕塑"
    },
    {
        "id":4162,
        "name":"4164 (English Program)  :  Inland Fisheries | การประมงน้ำจืด | 内陆渔业"
    },
    {
        "id":4163,
        "name":"4165 (English Program)  :  Applied Art Studies | การศึกษาศิลปะประยุกต์ | 应用艺术研究"
    },
    {
        "id":4164,
        "name":"4166 (English Program)  :  History | ประวัติศาสตร์ | 历史"
    },
    {
        "id":4165,
        "name":"4167 (English Program)  :  Art History | ประวัติศาสตร์ศิลปะ | 艺术史"
    },
    {
        "id":4166,
        "name":"4168 (English Program)  :  History Of Art | ประวัติศาสตร์ศิลปะ | 艺术史"
    },
    {
        "id":4167,
        "name":"4169 (English Program)  :  Thai Art History | ประวัติศาสตร์ศิลปะไทย | 泰国艺术史"
    },
    {
        "id":4168,
        "name":"4170 (English Program)  :  History Of Architecture | ประวัติศาสตร์สถาปัตยกรรม | 建筑史"
    },
    {
        "id":4169,
        "name":"4171 (English Program)  :  Economic History | ประวัติศาสตร์เศรษฐกิจ | 经济史"
    },
    {
        "id":4170,
        "name":"4172 (English Program)  :  History Of Southeast Asia. | ประวัติศาสตร์เอเชียตะวันออกเฉียงใต้ | 东南亚历史。"
    },
    {
        "id":4171,
        "name":"4173 (English Program)  :  Neurology | ประสาทวิทยา | 神经病学"
    },
    {
        "id":4172,
        "name":"4174 (English Program)  :  Neurosciences | ประสาทวิทยา | 神经科学"
    },
    {
        "id":4173,
        "name":"4175 (English Program)  :  Neurology Preventive Medicine Clinic | คลินิกเวชศาสตร์ป้องกันระบบประสาท | 神经内科预防医学诊所"
    },
    {
        "id":4174,
        "name":"4176 (English Program)  :  Neurological Surgery | ศัลยกรรมระบบประสาท | 神经外科"
    },
    {
        "id":4175,
        "name":"4177 (English Program)  :  Philosophy | ปรัชญา | 哲学"
    },
    {
        "id":4176,
        "name":"4178 (English Program)  :  Periodontology | ปริทันตวิทยา | 牙周病学"
    },
    {
        "id":4177,
        "name":"4179 (English Program)  :  Petrochemicals | ปิโตรเคมี | 石化产品"
    },
    {
        "id":4178,
        "name":"4180 (English Program)  :  Petrochemicals And Polymeric Materials | ปิโตรเคมีและวัสดุโพลีเมอร์ | 石油化工和高分子材料"
    },
    {
        "id":4179,
        "name":"4181 (English Program)  :  Petrochemistry And Polymer Science | วิทยาศาสตร์ปิโตรเคมีและโพลีเมอร์ | 石油化学和聚合物科学"
    },
    {
        "id":4180,
        "name":"4182 (English Program)  :  Petrochemicals And Hydrocarbon Chemistry | เคมีปิโตรเคมีและไฮโดรคาร์บอน | 石油化工和碳氢化合物化学"
    },
    {
        "id":4181,
        "name":"4183 (English Program)  :  Midwifery | การผดุงครรภ์ | 助产士"
    },
    {
        "id":4182,
        "name":"4184 (English Program)  :  Bioproduction | การผลิตทางชีวภาพ | 生物生产"
    },
    {
        "id":4183,
        "name":"4185 (English Program)  :  Fishery Products | ผลิตภัณฑ์ประมง | 水产品"
    },
    {
        "id":4184,
        "name":"4186 (English Program)  :  Dental Assistant | ผู้ช่วยทันตแพทย์ | 牙科助理"
    },
    {
        "id":4185,
        "name":"4187 (English Program)  :  Practical Nurse | พยาบาลวิชาชีพ | 实习护士"
    },
    {
        "id":4186,
        "name":"4188 (English Program)  :  Practical X-Rays Technician | ช่างเทคนิคเอ็กซเรย์เชิงปฏิบัติ | 实用 X 射线技术员"
    },
    {
        "id":4187,
        "name":"4189 (English Program)  :  Clothing And Design | เสื้อผ้าและการออกแบบ | 服装与设计"
    },
    {
        "id":4188,
        "name":"4190 (English Program)  :  French Studies | การศึกษาภาษาฝรั่งเศส | 法国研究"
    },
    {
        "id":4189,
        "name":"4191 (English Program)  :  Laboratory Technician | ช่างเทคนิคห้องปฏิบัติการ | 实验室技术员"
    },
    {
        "id":4190,
        "name":"4192 (English Program)  :  Cytology | สรีรวิทยา | 细胞学"
    },
    {
        "id":4191,
        "name":"4193 (English Program)  :  Medical Rehabilitation Worker | เจ้าหน้าที่ฟื้นฟูสมรรถภาพทางการแพทย์ | 医疗康复工作者"
    },
    {
        "id":4192,
        "name":"4194 (English Program)  :  Myanmar Studies | การศึกษาพม่า | 缅甸研究"
    },
    {
        "id":4193,
        "name":"4195 (English Program)  :  Pathobiology | พยาธิชีววิทยา | 病理学"
    },
    {
        "id":4194,
        "name":"4196 (English Program)  :  Veterinary Pathobiology | พยาธิชีววิทยาทางสัตวแพทย์ | 兽医病理学"
    },
    {
        "id":4195,
        "name":"4197 (English Program)  :  Pathology | พยาธิวิทยา | 病理"
    },
    {
        "id":4196,
        "name":"4198 (English Program)  :  Anatomy Pathology | พยาธิวิทยาทางกายวิภาค | 解剖病理学"
    },
    {
        "id":4197,
        "name":"4199 (English Program)  :  Clinical Pathology | พยาธิวิทยาทางคลินิก | 临床病理学"
    },
    {
        "id":4198,
        "name":"4200 (English Program)  :  General Pathology | พยาธิวิทยาทั่วไป | 一般病理学"
    },
    {
        "id":4199,
        "name":"4201 (English Program)  :  Veterinary Phathology | พยาธิวิทยาทางสัตวแพทย์ | 兽医病理学"
    },
    {
        "id":4200,
        "name":"4202 (English Program)  :  Abhidhamma Studies | อภิธรรมศึกษา | 阿毗达摩研究"
    },
    {
        "id":4201,
        "name":"4203 (English Program)  :  Botany | พฤกษศาสตร์ | 植物学"
    },
    {
        "id":4202,
        "name":"4204 (English Program)  :  Economic Botany | พฤกษศาสตร์ทางเศรษฐกิจ | 经济植物学"
    },
    {
        "id":4203,
        "name":"4205 (English Program)  :  Renewable Energy | พลังงานหมุนเวียน | 可再生能源"
    },
    {
        "id":4204,
        "name":"4206 (English Program)  :  Development Science | วิทยาศาสตร์การพัฒนา | 发展科学"
    },
    {
        "id":4205,
        "name":"4207 (English Program)  :  Tourism Development | การพัฒนาการท่องเที่ยว | 旅游业发展"
    },
    {
        "id":4206,
        "name":"4208 (English Program)  :  Human Development | การพัฒนามนุษย์ | 人类发展"
    },
    {
        "id":4207,
        "name":"4209 (English Program)  :  Agricultural Development | การพัฒนาการเกษตร | 农业发展"
    },
    {
        "id":4208,
        "name":"4210 (English Program)  :  Child And Family Development | การพัฒนาเด็กและครอบครัว | 儿童和家庭发展"
    },
    {
        "id":4209,
        "name":"4211 (English Program)  :  Rural Development Studies | การศึกษาการพัฒนาชนบท | 农村发展研究"
    },
    {
        "id":4210,
        "name":"4212 (Thai Program)  :  Agro-Industrial Product Development Technology | เทคโนโลยีการพัฒนาผลิตภัณฑ์อุตสาหกรรมเกษตร | 农工产品开发技术"
    },
    {
        "id":4211,
        "name":"4213 (English Program)  :  Agro-Industrial Product Development | การพัฒนาผลิตภัณฑ์อุตสาหกรรมเกษตร | 农工产品开发"
    },
    {
        "id":4212,
        "name":"4214 (English Program)  :  Human And Social Development | การพัฒนามนุษย์และสังคม | 人类和社会发展"
    },
    {
        "id":4213,
        "name":"4215 (English Program)  :  Health Information System Development | การพัฒนาระบบสารสนเทศด้านสุขภาพ | 健康信息系统开发"
    },
    {
        "id":4214,
        "name":"4216 (English Program)  :  Genetic Engineering | พันธุวิศวกรรม | 基因工程"
    },
    {
        "id":4215,
        "name":"4217 (English Program)  :  Genetics | พันธุศาสตร์ | 遗传学"
    },
    {
        "id":4216,
        "name":"4218 (English Program)  :  Merchant Marine Management | การจัดการการค้าทางทะเล | 商船管理"
    },
    {
        "id":4217,
        "name":"4219 (English Program)  :  Toxicology | พิษวิทยา | 毒理学"
    },
    {
        "id":4218,
        "name":"4220 (English Program)  :  Vegetable Crop Production | การผลิตพืชผัก | 蔬菜作物生产"
    },
    {
        "id":4219,
        "name":"4221 (English Program)  :  Plant Science-Horticulture | วิทยาศาสตร์พืช-พืชสวน | 植物科学-园艺"
    },
    {
        "id":4220,
        "name":"4222 (English Program)  :  Plant Science-Agronomy | วิทยาศาสตร์พืช-พืชไร่ | 植物科学农学"
    },
    {
        "id":4221,
        "name":"4223 (English Program)  :  Horticulture | พืชสวน | 园艺"
    },
    {
        "id":4222,
        "name":"4224 (English Program)  :  Ornamental Horticulture Technology | เทคโนโลยีพืชสวนประดับ | 观赏园艺技术"
    },
    {
        "id":4223,
        "name":"4225 (English Program)  :  Agronomy | พืชไร่ | 农艺学"
    },
    {
        "id":4224,
        "name":"4226 (English Program)  :  Foundation Of Education | รากฐานการศึกษา | 教育基金会"
    },
    {
        "id":4225,
        "name":"4227 (English Program)  :  Area Studies | การศึกษาในพื้นที่ | 区域研究"
    },
    {
        "id":4226,
        "name":"4228 (English Program)  :  Buddhist Psychology | จิตวิทยาพุทธศาสนา | 佛教心理学"
    },
    {
        "id":4227,
        "name":"4229 (English Program)  :  Buddhism And Philosophy | พุทธศาสนาและปรัชญา | 佛教与哲学"
    },
    {
        "id":4228,
        "name":"4230 (English Program)  :  Buddhist Religion Studies | ศึกษาศาสนาพุทธ | 佛教宗教研究"
    },
    {
        "id":4229,
        "name":"4231 (English Program)  :  Physics | ฟิสิกส์ | 物理"
    },
    {
        "id":4230,
        "name":"4232 (English Program)  :  Medical Physics | ฟิสิกส์การแพทย์ | 医学物理"
    },
    {
        "id":4231,
        "name":"4233 (English Program)  :  Applied Physics | ฟิสิกส์ประยุกต์ | 应用物理"
    },
    {
        "id":4232,
        "name":"4234 (English Program)  :  Applied Physics - Science And Industry Instrumention | ฟิสิกส์ประยุกต์ - เครื่องมือวิทยาศาสตร์และอุตสาหกรรม | 应用物理 - 科学和工业仪器"
    },
    {
        "id":4233,
        "name":"4235 (English Program)  :  Polymer Physics | ฟิสิกส์พอลิเมอร์ | 高分子物理"
    },
    {
        "id":4234,
        "name":"4236 (English Program)  :  Physics Education | การศึกษาฟิสิกส์ | 物理教育"
    },
    {
        "id":4235,
        "name":"4237 (English Program)  :  Electronics Physics | ฟิสิกส์อิเล็กทรอนิกส์ | 电子物理"
    },
    {
        "id":4236,
        "name":"4238 (English Program)  :  Industrial Physics And Medical Instrumentation | ฟิสิกส์อุตสาหกรรมและเครื่องมือแพทย์ | 工业物理与医疗仪器"
    },
    {
        "id":4237,
        "name":"4239 (English Program)  :  Physics Instruments | เครื่องมือฟิสิกส์ | 物理仪器"
    },
    {
        "id":4238,
        "name":"4240 (English Program)  :  Chemical Physics | ฟิสิกส์เคมี | 化学物理"
    },
    {
        "id":4239,
        "name":"4241 (English Program)  :  Printmaking | การพิมพ์ | 版画"
    },
    {
        "id":4240,
        "name":"4242 (English Program)  :  Cinema | โรงหนัง | 电影"
    },
    {
        "id":4241,
        "name":"4243 (English Program)  :  Film And Video | ภาพยนตร์และวิดีโอ | 电影和视频"
    },
    {
        "id":4242,
        "name":"4244 (English Program)  :  Chinese | ชาวจีน | 中国人"
    },
    {
        "id":4243,
        "name":"4245 (English Program)  :  Mandarin | ส้มแมนดาริน | 普通话"
    },
    {
        "id":4244,
        "name":"4246 (English Program)  :  Basic Chinese For Communication | ภาษาจีนขั้นพื้นฐานเพื่อการสื่อสาร | 基础汉语交流"
    },
    {
        "id":4245,
        "name":"4247 (English Program)  :  Japanese Language | ภาษาญี่ปุ่น | 日语"
    },
    {
        "id":4246,
        "name":"4248 (English Program)  :  Business Japanese | ธุรกิจภาษาญี่ปุ่น | 商务日语"
    },
    {
        "id":4247,
        "name":"4249 (English Program)  :  Oriental Languages | ภาษาตะวันออก | 东方语言"
    },
    {
        "id":4248,
        "name":"4250 (English Program)  :  Pali And Sanskrit | ภาษาบาลีและสันสกฤต | 巴利文和梵文"
    },
    {
        "id":4249,
        "name":"4251 (English Program)  :  Modern Languages Studies | การศึกษาภาษาสมัยใหม่ | 现代语言研究"
    },
    {
        "id":4250,
        "name":"4252 (English Program)  :  French | ภาษาฝรั่งเศส | 法语"
    },
    {
        "id":4251,
        "name":"4253 (English Program)  :  Business French | ภาษาฝรั่งเศสธุรกิจ | 商务法语"
    },
    {
        "id":4252,
        "name":"4254 (English Program)  :  Malay Language | ภาษามลายู | 马来语"
    },
    {
        "id":4253,
        "name":"4255 (English Program)  :  Thai Sign Language | ภาษามือไทย | 泰语手语"
    },
    {
        "id":4254,
        "name":"4256 (English Program)  :  Russian | รัสเซีย | 俄语"
    },
    {
        "id":4255,
        "name":"4257 (English Program)  :  Linguistics | ภาษาศาสตร์ | 语言学"
    },
    {
        "id":4256,
        "name":"4258 (English Program)  :  Educational Linguistics | ภาษาศาสตร์การศึกษา | 教育语言学"
    },
    {
        "id":4257,
        "name":"4259 (English Program)  :  Applied Linguistics | ภาษาศาสตร์ประยุกต์ | 应用语言学"
    },
    {
        "id":4258,
        "name":"4260 (English Program)  :  Applied Linguistics (Resource Based English Language Learning) | ภาษาศาสตร์ประยุกต์ (การเรียนรู้ภาษาอังกฤษตามทรัพยากร) | 应用语言学（基于资源的英语语言学习）"
    },
    {
        "id":4259,
        "name":"4261 (English Program)  :  Applied Linguistics-English For | ภาษาศาสตร์ประยุกต์-ภาษาอังกฤษสำหรับ | 应用语言学-英语"
    },
    {
        "id":4260,
        "name":"4262 (English Program)  :  Applied Linguistics For English | ภาษาศาสตร์ประยุกต์สำหรับภาษาอังกฤษ | 英语应用语言学"
    },
    {
        "id":4261,
        "name":"4263 (English Program)  :  Linguistics For Communication | ภาษาศาสตร์เพื่อการสื่อสาร | 交流语言学"
    },
    {
        "id":4262,
        "name":"4264 (English Program)  :  Southeast Asian Languages And Linguistics | ภาษาและภาษาศาสตร์เอเชียตะวันออกเฉียงใต้ | 东南亚语言和语言学"
    },
    {
        "id":4263,
        "name":"4265 (English Program)  :  Sanskrit | ภาษาสันสกฤต | 梵文"
    },
    {
        "id":4264,
        "name":"4266 (English Program)  :  Spanish | ภาษาสเปน | 西班牙语"
    },
    {
        "id":4265,
        "name":"4267 (English Program)  :  Language Teaching | การสอนภาษา | 语言教学"
    },
    {
        "id":4266,
        "name":"4268 (English Program)  :  Business English | ภาษาอังกฤษธุรกิจ | 商务英语"
    },
    {
        "id":4267,
        "name":"4269 (English Program)  :  Business English For International Communication | ภาษาอังกฤษธุรกิจเพื่อการสื่อสารระหว่างประเทศ | 国际交流商务英语"
    },
    {
        "id":4268,
        "name":"4270 (English Program)  :  English Language Studies | การศึกษาภาษาอังกฤษ | 英语语言学习"
    },
    {
        "id":4269,
        "name":"4271 (English Program)  :  English As An International Language | ภาษาอังกฤษเป็นภาษาสากล | 英语作为国际语言"
    },
    {
        "id":4270,
        "name":"4272 (English Program)  :  Communicative English | ภาษาอังกฤษเพื่อการสื่อสาร | 交际英语"
    },
    {
        "id":4271,
        "name":"4273 (English Program)  :  English For Business And Industry | ภาษาอังกฤษเพื่อธุรกิจและอุตสาหกรรม | 商业和工业英语"
    },
    {
        "id":4272,
        "name":"4274 (English Program)  :  English For Careers | ภาษาอังกฤษเพื่ออาชีพ | 职业英语"
    },
    {
        "id":4273,
        "name":"4275 (English Program)  :  English And Communication | ภาษาอังกฤษและการสื่อสาร | 英语和交流"
    },
    {
        "id":4274,
        "name":"4276 (English Program)  :  Arabic | ภาษาอาหรับ | 阿拉伯"
    },
    {
        "id":4275,
        "name":"4277 (English Program)  :  Italian | ภาษาอิตาลี | 意大利语"
    },
    {
        "id":4276,
        "name":"4278 (English Program)  :  Korean | เกาหลี | 韩国人"
    },
    {
        "id":4277,
        "name":"4279 (English Program)  :  Khmer Language | ภาษาเขมร | 高棉语"
    },
    {
        "id":4278,
        "name":"4280 (English Program)  :  Languages For Career | ภาษาเพื่ออาชีพ | 职业语言"
    },
    {
        "id":4279,
        "name":"4281 (English Program)  :  German | เยอรมัน | 德语"
    },
    {
        "id":4280,
        "name":"4282 (English Program)  :  German For International Communication | ภาษาเยอรมันเพื่อการสื่อสารระหว่างประเทศ | 国际交流德语"
    },
    {
        "id":4281,
        "name":"4283 (English Program)  :  German As A Foreign Language | ภาษาเยอรมันเป็นภาษาต่างประเทศ | 德语作为外语"
    },
    {
        "id":4282,
        "name":"4284 (English Program)  :  Language And Communication | ภาษาและการสื่อสาร | 语言和交流"
    },
    {
        "id":4283,
        "name":"4285 (English Program)  :  Lanna Language And Literature | ภาษาและวรรณคดีล้านนา | 兰纳语言和文学"
    },
    {
        "id":4284,
        "name":"4286 (English Program)  :  Japanese Language And Literature | ภาษาและวรรณคดีญี่ปุ่น | 日本语言和文学"
    },
    {
        "id":4285,
        "name":"4287 (English Program)  :  French Language And Literature | ภาษาและวรรณคดีฝรั่งเศส | 法国语言和文学"
    },
    {
        "id":4286,
        "name":"4288 (English Program)  :  English Language And Literature | ภาษาอังกฤษและวรรณคดี | 英语语言和文学"
    },
    {
        "id":4287,
        "name":"4289 (English Program)  :  Thai Language And Literature | ภาษาไทยและวรรณคดี | 泰国语言和文学"
    },
    {
        "id":4288,
        "name":"4290 (English Program)  :  Language And Culture For Communication | ภาษาและวัฒนธรรมเพื่อการสื่อสาร | 交流语言和文化"
    },
    {
        "id":4289,
        "name":"4291 (English Program)  :  Thai Language | ภาษาไทย | 泰语"
    },
    {
        "id":4290,
        "name":"4292 (English Program)  :  Thai Language For Communication | ภาษาไทยเพื่อการสื่อสาร | 泰语交流语言"
    },
    {
        "id":4291,
        "name":"4293 (English Program)  :  Regional Studies | การศึกษาระดับภูมิภาค | 区域研究"
    },
    {
        "id":4292,
        "name":"4294 (English Program)  :  Geography | ภูมิศาสตร์ | 地理"
    },
    {
        "id":4293,
        "name":"4295 (English Program)  :  Physical Geography And Environment | ภูมิศาสตร์กายภาพและสิ่งแวดล้อม | 自然地理与环境"
    },
    {
        "id":4294,
        "name":"4296 (English Program)  :  Human Settlement Planning Geography | ภูมิศาสตร์การวางแผนการตั้งถิ่นฐานของมนุษย์ | 人居环境规划地理"
    },
    {
        "id":4295,
        "name":"4297 (English Program)  :  Human Geography | ภูมิศาสตร์มนุษย์ | 人文地理学"
    },
    {
        "id":4296,
        "name":"4298 (English Program)  :  Industrial Geography | ภูมิศาสตร์อุตสาหกรรม | 工业地理"
    },
    {
        "id":4297,
        "name":"4299 (English Program)  :  Malay Studies | การศึกษาภาษามลายู | 马来语研究"
    },
    {
        "id":4298,
        "name":"4300 (English Program)  :  Metrological Science | วิทยาศาสตร์มาตรวิทยา | 计量科学"
    },
    {
        "id":4299,
        "name":"4301 (English Program)  :  Industrial Metrology | มาตรวิทยาอุตสาหกรรม | 工业计量"
    },
    {
        "id":4300,
        "name":"4302 (English Program)  :  Anthropology | มานุษยวิทยา | 人类学"
    },
    {
        "id":4301,
        "name":"4303 (English Program)  :  Applied Anthropology | มานุษยวิทยาประยุกต์ | 应用人类学"
    },
    {
        "id":4302,
        "name":"4304 (English Program)  :  Development Strategy | กลยุทธ์การพัฒนา | 发展战略"
    },
    {
        "id":4303,
        "name":"4305 (English Program)  :  European Studies | ยุโรปศึกษา | 欧洲研究"
    },
    {
        "id":4304,
        "name":"4306 (English Program)  :  Decision Support System | ระบบสนับสนุนการตัดสินใจ | 决策支持系统"
    },
    {
        "id":4305,
        "name":"4307 (English Program)  :  Accounting Information System | ระบบข้อมูลทางบัญชี | 会计信息系统"
    },
    {
        "id":4306,
        "name":"4308 (English Program)  :  Applied Information System | ระบบสารสนเทศประยุกต์ | 应用信息系统"
    },
    {
        "id":4307,
        "name":"4309 (English Program)  :  Spatial Information System In Engineering | ระบบสารสนเทศเชิงพื้นที่ทางวิศวกรรม | 工程空间信息系统"
    },
    {
        "id":4308,
        "name":"4310 (English Program)  :  Geographic Information System | ระบบสารสนเทศทางภูมิศาสตร์ | 地理信息系统"
    },
    {
        "id":4309,
        "name":"4311 (English Program)  :  Health Systems And Policy | ระบบและนโยบายด้านสุขภาพ | 卫生系统和政策"
    },
    {
        "id":4310,
        "name":"4312 (English Program)  :  Applied Radiation And Isotopes | การแผ่รังสีประยุกต์และไอโซโทป | 应用辐射和同位素"
    },
    {
        "id":4311,
        "name":"4313 (English Program)  :  Radiology | รังสีวิทยา | 放射学"
    },
    {
        "id":4312,
        "name":"4314 (English Program)  :  Oral And Maxillofacial Radiology | รังสีวิทยาช่องปากและแม็กซิลโลเฟเชียล | 口腔颌面放射学"
    },
    {
        "id":4313,
        "name":"4315 (English Program)  :  Radiotherapy-Nuclear Medicine | รังสีบำบัด-เวชศาสตร์นิวเคลียร์ | 放射治疗-核医学"
    },
    {
        "id":4314,
        "name":"4316 (English Program)  :  Radiodiagnosis | การวินิจฉัยด้วยวิทยุ | 放射诊断"
    },
    {
        "id":4315,
        "name":"4317 (English Program)  :  Radiological Technology | เทคโนโลยีรังสีวิทยา | 放射技术"
    },
    {
        "id":4316,
        "name":"4318 (English Program)  :  Technical Radiology | รังสีวิทยาทางเทคนิค | 放射技术"
    },
    {
        "id":4317,
        "name":"4319 (English Program)  :  X-Rays Technology | เทคโนโลยีเอ็กซ์เรย์ | X射线技术"
    },
    {
        "id":4318,
        "name":"4320 (English Program)  :  Political Science (Government) | รัฐศาสตร์ (รัฐบาล) | 政治学（政府）"
    },
    {
        "id":4319,
        "name":"4321 (English Program)  :  Forest Products | ผลิตภัณฑ์จากป่าไม้ | 林产品"
    },
    {
        "id":4320,
        "name":"4322 (English Program)  :  Silviculture | วนวัฒนวิทยา | 造林业"
    },
    {
        "id":4321,
        "name":"4323 (English Program)  :  Forestry | ป่าไม้ | 林业"
    },
    {
        "id":4322,
        "name":"4324 (English Program)  :  Social Forestry | สังคมป่าไม้ | 社会林业"
    },
    {
        "id":4323,
        "name":"4325 (English Program)  :  Tropical Forestry | ป่าไม้เขตร้อน | 热带林业"
    },
    {
        "id":4324,
        "name":"4326 (English Program)  :  Children'S Literature | วรรณกรรมเด็ก | 儿童文学"
    },
    {
        "id":4325,
        "name":"4327 (English Program)  :  English Literature | วรรณคดีอังกฤษ | 英国文学"
    },
    {
        "id":4326,
        "name":"4328 (English Program)  :  Comparative Literature | วรรณกรรมเปรียบเทียบ | 比较文献"
    },
    {
        "id":4327,
        "name":"4329 (English Program)  :  Literature And Comparative Literature | วรรณกรรมและวรรณกรรมเปรียบเทียบ | 文献和比较文献"
    },
    {
        "id":4328,
        "name":"4330 (English Program)  :  Thai Literature | วรรณคดีไทย | 泰国文学"
    },
    {
        "id":4329,
        "name":"4331 (English Program)  :  Cultural Studies | การศึกษาวัฒนธรรม | 文化研究"
    },
    {
        "id":4330,
        "name":"4332 (English Program)  :  Thai Cultural Studies | การศึกษาวัฒนธรรมไทย | 泰国文化研究"
    },
    {
        "id":4331,
        "name":"4333 (English Program)  :  Materials Science | วิทยาศาสตร์วัสดุ | 材料科学"
    },
    {
        "id":4332,
        "name":"4334 (English Program)  :  Material Science (Gems And Jewelry) | วัสดุศาสตร์ (อัญมณีและเครื่องประดับ) | 材料科学（宝石和珠宝）"
    },
    {
        "id":4333,
        "name":"4335 (English Program)  :  Material Science Gemological Technology | วัสดุศาสตร์เทคโนโลยีอัญมณีวิทยา | 材料科学 宝石技术"
    },
    {
        "id":4334,
        "name":"4336 (English Program)  :  Speech Communication | การสื่อสารด้วยคำพูด | 语音通讯"
    },
    {
        "id":4335,
        "name":"4337 (English Program)  :  Speech (Speech Therapy) | คำพูด (การบำบัดด้วยคำพูด) | 言语（言语治疗）"
    },
    {
        "id":4336,
        "name":"4338 (English Program)  :  Speech And Performance Studies | การศึกษาการพูดและการแสดง | 言语和表现研究"
    },
    {
        "id":4337,
        "name":"4339 (English Program)  :  Journalism And Public Relation | วารสารศาสตร์และการประชาสัมพันธ์ | 新闻与公共关系"
    },
    {
        "id":4338,
        "name":"4340 (English Program)  :  Aquatic Science | วิทยาศาสตร์ทางน้ำ | 水生科学"
    },
    {
        "id":4339,
        "name":"4341 (English Program)  :  Population And Reproductive Health Research | การวิจัยด้านสุขภาพประชากรและอนามัยการเจริญพันธุ์ | 人口与生殖健康研究"
    },
    {
        "id":4340,
        "name":"4342 (English Program)  :  Population And Family Planning Research | การวิจัยการวางแผนประชากรและครอบครัว | 人口与计划生育研究"
    },
    {
        "id":4341,
        "name":"4343 (English Program)  :  Population And Social Research | การวิจัยประชากรและสังคม | 人口与社会研究"
    },
    {
        "id":4342,
        "name":"4344 (English Program)  :  Farming Systems Research | การวิจัยระบบการเกษตร | 农业系统研究"
    },
    {
        "id":4343,
        "name":"4345 (English Program)  :  Mass Communication Research | การวิจัยการสื่อสารมวลชน | 大众传播研究"
    },
    {
        "id":4344,
        "name":"4346 (English Program)  :  Research And Development In Pharmaceuticals | การวิจัยและพัฒนาทางเภสัชกรรม | 药品研发"
    },
    {
        "id":4345,
        "name":"4347 (English Program)  :  Research And Statistics In Education | การวิจัยและสถิติทางการศึกษา | 教育研究和统计"
    },
    {
        "id":4346,
        "name":"4348 (English Program)  :  Teaching Profession | วิชาชีพครู | 教学专业"
    },
    {
        "id":4347,
        "name":"4349 (English Program)  :  Science Teaching Profession | วิชาชีพครูวิทยาศาสตร์ | 科学教学专业"
    },
    {
        "id":4348,
        "name":"4350 (English Program)  :  General Education | การศึกษาทั่วไป | 通识教育"
    },
    {
        "id":4349,
        "name":"4351 (English Program)  :  Applied Computer Science | วิทยาศาสตร์คอมพิวเตอร์ประยุกต์ | 应用计算机科学"
    },
    {
        "id":4350,
        "name":"4352 (English Program)  :  Applied Computer Science Multimedia | วิทยาศาสตร์คอมพิวเตอร์ประยุกต์ มัลติมีเดีย | 应用计算机科学多媒体"
    },
    {
        "id":4351,
        "name":"4353 (English Program)  :  Computer Science And Information Technology | วิทยาศาสตร์คอมพิวเตอร์และเทคโนโลยีสารสนเทศ | 计算机科学与信息技术"
    },
    {
        "id":4352,
        "name":"4354 (English Program)  :  Management Science | วิทยาศาสตร์การจัดการ | 管理科学"
    },
    {
        "id":4353,
        "name":"4355 (English Program)  :  Actuarial Science | คณิตศาสตร์ประกันภัย | 精算科学"
    },
    {
        "id":4354,
        "name":"4356 (English Program)  :  Medical Epidemiology | ระบาดวิทยาทางการแพทย์ | 医学流行病学"
    },
    {
        "id":4355,
        "name":"4357 (English Program)  :  Theriogenology | วิทยาพันธุศาสตร์ | 动物发生学"
    },
    {
        "id":4356,
        "name":"4358 (English Program)  :  Robotics And Automation | หุ่นยนต์และระบบอัตโนมัติ | 机器人与自动化"
    },
    {
        "id":4357,
        "name":"4359 (English Program)  :  Polymer Science And Engineering | วิทยาศาสตร์และวิศวกรรมศาสตร์โพลีเมอร์ | 高分子科学与工程"
    },
    {
        "id":4358,
        "name":"4360 (English Program)  :  Medical Laboratory Science | วิทยาศาสตร์ห้องปฏิบัติการทางการแพทย์ | 医学实验室科学"
    },
    {
        "id":4359,
        "name":"4361 (English Program)  :  Immunology | ภูมิคุ้มกันวิทยา | 免疫学"
    },
    {
        "id":4360,
        "name":"4362 (English Program)  :  Clinical Immunology | วิทยาภูมิคุ้มกันทางคลินิก | 临床免疫学"
    },
    {
        "id":4361,
        "name":"4363 (English Program)  :  Science | ศาสตร์ | 科学"
    },
    {
        "id":4362,
        "name":"4364 (English Program)  :  Science - Mathematics | วิทยาศาสตร์ - คณิตศาสตร์ | 科学 - 数学"
    },
    {
        "id":4363,
        "name":"4365 (English Program)  :  Science - Biology | วิทยาศาสตร์ - ชีววิทยา | 科学-生物学"
    },
    {
        "id":4364,
        "name":"4366 (English Program)  :  Science - Physics | วิทยาศาสตร์ - ฟิสิกส์ | 科学 - 物理"
    },
    {
        "id":4365,
        "name":"4367 (English Program)  :  Science - Chemistry | วิทยาศาสตร์ - เคมี | 科学-化学"
    },
    {
        "id":4366,
        "name":"4368 (English Program)  :  Science - Agriculture | วิทยาศาสตร์ - เกษตร | 科学-农业"
    },
    {
        "id":4367,
        "name":"4369 (English Program)  :  Physical And Biological Science | วิทยาศาสตร์กายภาพและชีววิทยา | 物理和生物科学"
    },
    {
        "id":4368,
        "name":"4370 (English Program)  :  Sports Science | วิทยาศาสตร์การกีฬา | 体育科学"
    },
    {
        "id":4369,
        "name":"4371 (English Program)  :  Sports Science-Sport Coaching And Management | การฝึกสอนและการจัดการกีฬาวิทยาศาสตร์การกีฬา | 体育科学-体育教练与管理"
    },
    {
        "id":4370,
        "name":"4372 (English Program)  :  Transfusion Science | วิทยาศาสตร์การถ่ายโอน | 输血科学"
    },
    {
        "id":4371,
        "name":"4373 (English Program)  :  Fisheries Science | วิทยาศาสตร์การประมง | 渔业科学"
    },
    {
        "id":4372,
        "name":"4374 (English Program)  :  Veterinary Sciences | สัตวแพทยศาสตร์ | 兽医科学"
    },
    {
        "id":4373,
        "name":"4375 (English Program)  :  Exercise And Sports Science | การออกกำลังกายและวิทยาศาสตร์การกีฬา | 锻炼和运动科学"
    },
    {
        "id":4374,
        "name":"4376 (English Program)  :  Food Science | วิทยาศาสตร์การอาหาร | 食品科学"
    },
    {
        "id":4375,
        "name":"4377 (English Program)  :  Food Science And Nutrition | วิทยาศาสตร์การอาหารและโภชนาการ | 食品科学与营养"
    },
    {
        "id":4376,
        "name":"4378 (English Program)  :  Aquaculture Science | วิทยาศาสตร์การเพาะเลี้ยงสัตว์น้ำ | 水产养殖科学"
    },
    {
        "id":4377,
        "name":"4379 (English Program)  :  Medical Science | วิทยาศาสตร์การแพทย์ | 医学"
    },
    {
        "id":4378,
        "name":"4380 (English Program)  :  Clinical Sciences | วิทยาศาสตร์คลินิก | 临床科学"
    },
    {
        "id":4379,
        "name":"4381 (English Program)  :  Biophysical Science | วิทยาศาสตร์ชีวฟิสิกส์ | 生物物理科学"
    },
    {
        "id":4380,
        "name":"4382 (English Program)  :  Biological Science | วิทยาศาสตร์ชีวภาพ | 生物科学"
    },
    {
        "id":4381,
        "name":"4383 (English Program)  :  Bioscience | วิทยาศาสตร์ชีวภาพ | 生物科学"
    },
    {
        "id":4382,
        "name":"4384 (English Program)  :  Forest Biological Sciences | วิทยาศาสตร์ชีวภาพป่าไม้ | 森林生物科学"
    },
    {
        "id":4383,
        "name":"4385 (English Program)  :  Biostatistical Science | วิทยาศาสตร์ทางชีวสถิติ | 生物统计科学"
    },
    {
        "id":4384,
        "name":"4386 (English Program)  :  General Science | วิทยาศาสตร์ทั่วไป | 普通科学"
    },
    {
        "id":4385,
        "name":"4387 (English Program)  :  Marine Science | วิทยาศาสตร์ทางทะเล | 海洋科学"
    },
    {
        "id":4386,
        "name":"4388 (English Program)  :  Polymer Science | วิทยาศาสตร์โพลีเมอร์ | 高分子科学"
    },
    {
        "id":4387,
        "name":"4389 (English Program)  :  Applied Polymer Science And Textile Technology | วิทยาศาสตร์พอลิเมอร์ประยุกต์และเทคโนโลยีสิ่งทอ | 应用高分子科学与纺织技术"
    },
    {
        "id":4388,
        "name":"4390 (English Program)  :  Earth Science | วิทยาศาสตร์โลก | 地球科学"
    },
    {
        "id":4389,
        "name":"4391 (English Program)  :  Macromolecular Science | วิทยาศาสตร์มหภาค | 高分子科学"
    },
    {
        "id":4390,
        "name":"4392 (English Program)  :  Radiological Science | วิทยาศาสตร์รังสี | 放射科学"
    },
    {
        "id":4391,
        "name":"4393 (English Program)  :  Science Studies-Biology | วิทยาศาสตร์ศึกษา-ชีววิทยา | 科学研究-生物学"
    },
    {
        "id":4392,
        "name":"4394 (English Program)  :  Science Studies - Physics | การศึกษาวิทยาศาสตร์ - ฟิสิกส์ | 科学研究 - 物理学"
    },
    {
        "id":4393,
        "name":"4395 (English Program)  :  Health Science-Childhood Promotion | การส่งเสริมวิทยาศาสตร์สุขภาพ-วัยเด็ก | 健康科学-儿童促进"
    },
    {
        "id":4394,
        "name":"4396 (English Program)  :  Oral Health Science | วิทยาศาสตร์สุขภาพช่องปาก | 口腔健康科学"
    },
    {
        "id":4395,
        "name":"4397 (English Program)  :  Animal Health Science | วิทยาศาสตร์สุขภาพสัตว์ | 动物健康科学"
    },
    {
        "id":4396,
        "name":"4398 (English Program)  :  Sanitary Science | วิทยาศาสตร์สุขาภิบาล | 卫生科学"
    },
    {
        "id":4397,
        "name":"4399 (English Program)  :  Environmental Health Sciences | วิทยาศาสตร์สุขภาพสิ่งแวดล้อม | 环境健康科学"
    },
    {
        "id":4398,
        "name":"4400 (English Program)  :  Cosmetic Sciences | วิทยาศาสตร์เครื่องสำอาง | 化妆品科学"
    },
    {
        "id":4399,
        "name":"4401 (English Program)  :  Wood Science And Technology | วิทยาศาสตร์และเทคโนโลยีไม้ | 木材科技"
    },
    {
        "id":4400,
        "name":"4402 (English Program)  :  Polymer Science And Technology | วิทยาศาสตร์และเทคโนโลยีโพลีเมอร์ | 高分子科学与技术"
    },
    {
        "id":4401,
        "name":"4403 (English Program)  :  Science And Technology Of Polymers | วิทยาศาสตร์และเทคโนโลยีของโพลีเมอร์ | 高分子科学与技术"
    },
    {
        "id":4402,
        "name":"4404 (English Program)  :  Textile Science And Technology | วิทยาศาสตร์และเทคโนโลยีสิ่งทอ | 纺织科技"
    },
    {
        "id":4403,
        "name":"4405 (English Program)  :  Environmental Science And Technology | วิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม | 环境科学与技术"
    },
    {
        "id":4404,
        "name":"4406 (English Program)  :  Endodontology | ทันตกรรมวิทยา | 牙髓病学"
    },
    {
        "id":4405,
        "name":"4407 (English Program)  :  Endodontics | เอ็นโดดอนต์ | 牙髓病学"
    },
    {
        "id":4406,
        "name":"4408 (English Program)  :  Radio And Television | วิทยุและโทรทัศน์ | 广播电视"
    },
    {
        "id":4407,
        "name":"4409 (English Program)  :  Research Methodology | ระเบียบวิธีวิจัย | 研究方法"
    },
    {
        "id":4408,
        "name":"4410 (English Program)  :  Educational Research Methodology | ระเบียบวิธีวิจัยทางการศึกษา | 教育研究方法"
    },
    {
        "id":4409,
        "name":"4411 (English Program)  :  Process Engineering | วิศวกรรมกระบวนการ | 工艺工程"
    },
    {
        "id":4410,
        "name":"4412 (English Program)  :  Industrial Management Engineering | วิศวกรรมการจัดการอุตสาหกรรม | 工业管理工程"
    },
    {
        "id":4411,
        "name":"4413 (English Program)  :  Aerospace Engineering | วิศวกรรมการบินและอวกาศ | 航空航天工程"
    },
    {
        "id":4412,
        "name":"4414 (English Program)  :  Manufacturing Engineering | วิศวกรรมการผลิต | 制造工程"
    },
    {
        "id":4413,
        "name":"4415 (English Program)  :  Instrumentation Engineering | วิศวกรรมเครื่องมือวัด | 仪器仪表工程"
    },
    {
        "id":4414,
        "name":"4416 (English Program)  :  Welding Engineering | วิศวกรรมการเชื่อม | 焊接工程"
    },
    {
        "id":4415,
        "name":"4417 (English Program)  :  Materials Handling Engineering | วิศวกรรมการจัดการวัสดุ | 物料搬运工程"
    },
    {
        "id":4416,
        "name":"4418 (English Program)  :  Transportation Engineering | วิศวกรรมการขนส่ง | 交通工程"
    },
    {
        "id":4417,
        "name":"4419 (English Program)  :  Safety Engineering | วิศวกรรมความปลอดภัย | 安全工程"
    },
    {
        "id":4418,
        "name":"4420 (English Program)  :  Precision Engineering | วิศวกรรมที่แม่นยำ | 精密工程"
    },
    {
        "id":4419,
        "name":"4421 (English Program)  :  Computer Engineering | วิศวกรรมคอมพิวเตอร์ | 计算机工程"
    },
    {
        "id":4420,
        "name":"4422 (English Program)  :  Irrigation Engineering | วิศวกรรมชลประทาน | 灌溉工程"
    },
    {
        "id":4421,
        "name":"4423 (English Program)  :  Software Engineering | วิศวกรรมซอฟต์แวร์ | 软件工程"
    },
    {
        "id":4422,
        "name":"4424 (English Program)  :  Soil And Water Engineering | วิศวกรรมดินและน้ำ | 土壤与水工程"
    },
    {
        "id":4423,
        "name":"4425 (English Program)  :  Georesources Engineering | วิศวกรรมธรณีวิทยา | 地质资源工程"
    },
    {
        "id":4424,
        "name":"4426 (English Program)  :  Nuclear Engineering | วิศวกรรมนิวเคลียร์ | 核工程"
    },
    {
        "id":4425,
        "name":"4427 (English Program)  :  Petrochemical Engineering | วิศวกรรมปิโตรเคมี | 石油化工工程"
    },
    {
        "id":4426,
        "name":"4428 (English Program)  :  Petroleum Engineering | วิศวกรรมปิโตรเลียม | 石油工程"
    },
    {
        "id":4427,
        "name":"4429 (English Program)  :  Forest Engineering | วิศวกรรมป่าไม้ | 森林工程"
    },
    {
        "id":4428,
        "name":"4430 (English Program)  :  Energy Engineering | วิศวกรรมพลังงาน | 能源工程"
    },
    {
        "id":4429,
        "name":"4431 (English Program)  :  Plastics Engineering | วิศวกรรมพลาสติก | 塑料工程"
    },
    {
        "id":4430,
        "name":"4432 (English Program)  :  Polymer Engineering | วิศวกรรมโพลีเมอร์ | 高分子工程"
    },
    {
        "id":4431,
        "name":"4433 (English Program)  :  Automotive Engineering | วิศวกรรมยานยนต์ | 汽车工程"
    },
    {
        "id":4432,
        "name":"4434 (English Program)  :  Manufacturing Systems Engineering | วิศวกรรมระบบการผลิต | 制造系统工程"
    },
    {
        "id":4433,
        "name":"4435 (English Program)  :  Control Engineering | วิศวกรรมควบคุม | 控制工程"
    },
    {
        "id":4434,
        "name":"4436 (English Program)  :  Control System And Instrumentation Engineering | ระบบควบคุมและวิศวกรรมเครื่องมือวัด | 控制系统与仪表工程"
    },
    {
        "id":4435,
        "name":"4437 (English Program)  :  Building Facilities Engineering | วิศวกรรมสิ่งอำนวยความสะดวกในอาคาร | 建筑设施工程"
    },
    {
        "id":4436,
        "name":"4438 (English Program)  :  Instrumentation System Engineering | วิศวกรรมระบบเครื่องมือวัด | 仪表系统工程"
    },
    {
        "id":4437,
        "name":"4439 (English Program)  :  Information Engineering | วิศวกรรมสารสนเทศ | 信息工程"
    },
    {
        "id":4438,
        "name":"4440 (English Program)  :  Survey Engineering | วิศวกรรมสำรวจ | 勘察工程"
    },
    {
        "id":4439,
        "name":"4441 (English Program)  :  Textile Engineering | วิศวกรรมสิ่งทอ | 纺织工程"
    },
    {
        "id":4440,
        "name":"4442 (English Program)  :  Environmental Engineering | วิศวกรรมสิ่งแวดล้อม | 环境工程"
    },
    {
        "id":4441,
        "name":"4443 (English Program)  :  Post-Harvest And Processing Engineering | วิศวกรรมหลังการเก็บเกี่ยวและการประมวลผล | 采后和加工工程"
    },
    {
        "id":4442,
        "name":"4444 (English Program)  :  Electronic Engineering | วิศวกรรมอิเล็กทรอนิกส์ | 电子工程"
    },
    {
        "id":4443,
        "name":"4445 (English Program)  :  Electronic And Telecommunication Engineering | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม | 电子与电信工程"
    },
    {
        "id":4444,
        "name":"4446 (English Program)  :  Agricultural Engineering | วิศวกรรมเกษตร | 农业工程"
    },
    {
        "id":4445,
        "name":"4447 (English Program)  :  Textile Chemistry Engineering | วิศวกรรมเคมีสิ่งทอ | 纺织化学工程"
    },
    {
        "id":4446,
        "name":"4448 (English Program)  :  Chemical And Biological Engineering | วิศวกรรมเคมีและชีววิทยา | 化学与生物工程"
    },
    {
        "id":4447,
        "name":"4449 (English Program)  :  Mechanical Engineering For Manufacturing | วิศวกรรมเครื่องกลเพื่อการผลิต | 制造机械工程"
    },
    {
        "id":4448,
        "name":"4450 (English Program)  :  Marine Engineering | วิศวกรรมทางทะเล | 海洋工程"
    },
    {
        "id":4449,
        "name":"4451 (English Program)  :  Agricultural Machinery Engineering | วิศวกรรมเครื่องจักรการเกษตร | 农业机械工程"
    },
    {
        "id":4450,
        "name":"4452 (English Program)  :  Garment Engineering | วิศวกรรมเครื่องนุ่งห่ม | 服装工程"
    },
    {
        "id":4451,
        "name":"4453 (English Program)  :  Tool Engineering | วิศวกรรมเครื่องมือ | 工具工程"
    },
    {
        "id":4452,
        "name":"4454 (English Program)  :  Ceramic Engineering | วิศวกรรมเซรามิก | 陶瓷工程"
    },
    {
        "id":4453,
        "name":"4455 (English Program)  :  Geotechnical Engineering | วิศวกรรมธรณีเทคนิค | 岩土工程"
    },
    {
        "id":4454,
        "name":"4456 (English Program)  :  Synthetic Fibers Engineering | วิศวกรรมเส้นใยสังเคราะห์ | 合成纤维工程"
    },
    {
        "id":4455,
        "name":"4457 (English Program)  :  Mining Engineering | วิศวกรรมเหมืองแร่ | 采矿工程"
    },
    {
        "id":4456,
        "name":"4458 (English Program)  :  Mining And Metallurgical Engineering | วิศวกรรมเหมืองแร่และโลหะวิทยา | 矿山冶金工程"
    },
    {
        "id":4457,
        "name":"4459 (English Program)  :  Telecommunication Engineering | วิศวกรรมโทรคมนาคม | 电信工程"
    },
    {
        "id":4458,
        "name":"4460 (English Program)  :  Civil Engineering | วิศวกรรมโยธา | 土木工程"
    },
    {
        "id":4459,
        "name":"4461 (English Program)  :  Civil Engineering For Building System | วิศวกรรมโยธาเพื่อระบบอาคาร | 建筑系统土木工程"
    },
    {
        "id":4460,
        "name":"4462 (English Program)  :  Civil Engineering For Rural Engineering | วิศวกรรมโยธาเพื่อวิศวกรรมชนบท | 农村工程土木工程"
    },
    {
        "id":4461,
        "name":"4463 (English Program)  :  Metallurgical Engineering | วิศวกรรมโลหการ | 冶金工程"
    },
    {
        "id":4462,
        "name":"4464 (English Program)  :  Metallurgical And Materials Engineering | วิศวกรรมโลหการและวัสดุ | 冶金与材料工程"
    },
    {
        "id":4463,
        "name":"4465 (English Program)  :  Electrical Engineering - Control | วิศวกรรมไฟฟ้า--การควบคุม | 电气工程 - 控制"
    },
    {
        "id":4464,
        "name":"4466 (English Program)  :  Electrical Engineering - Electronics | วิศวกรรมไฟฟ้า-อิเล็กทรอนิกส์ | 电气工程 - 电子"
    },
    {
        "id":4465,
        "name":"4467 (English Program)  :  Electrical Engineering - Telecommunication | วิศวกรรมไฟฟ้า-โทรคมนาคม | 电气工程-电信"
    },
    {
        "id":4466,
        "name":"4468 (English Program)  :  Electrical Engineering - Electrical Power | วิศวกรรมไฟฟ้า - กำลังไฟฟ้า | 电气工程 - 电力"
    },
    {
        "id":4467,
        "name":"4469 (English Program)  :  Electrical Communications Engineering | วิศวกรรมไฟฟ้าสื่อสาร | 电气通信工程"
    },
    {
        "id":4468,
        "name":"4470 (English Program)  :  Electromechanic Manufacturing Engineering | วิศวกรรมการผลิตเครื่องกลไฟฟ้า | 机电制造工程"
    },
    {
        "id":4469,
        "name":"4471 (English Program)  :  Electrical And Computer Engineering | วิศวกรรมไฟฟ้าและคอมพิวเตอร์ | 电气和计算机工程"
    },
    {
        "id":4470,
        "name":"4472 (English Program)  :  Electrical Engineering And Systems | วิศวกรรมไฟฟ้าและระบบ | 电气工程和系统"
    },
    {
        "id":4471,
        "name":"4473 (English Program)  :  Microelectronic Engineering | วิศวกรรมไมโครอิเล็กทรอนิกส์ | 微电子工程"
    },
    {
        "id":4472,
        "name":"4474 (English Program)  :  Nursing Anaesthetist | วิสัญญีพยาบาล | 护理麻醉师"
    },
    {
        "id":4473,
        "name":"4475 (English Program)  :  Anaesthesiology | วิสัญญีวิทยา | 麻醉学"
    },
    {
        "id":4474,
        "name":"4476 (English Program)  :  International Business (China) | ธุรกิจระหว่างประเทศ (จีน) | 国际业务（中国）"
    },
    {
        "id":4475,
        "name":"4477 (English Program)  :  Surgery | การผ่าตัด | 外科手术"
    },
    {
        "id":4476,
        "name":"4478 (English Program)  :  Oral Surgery | ศัลยกรรมช่องปาก | 口腔手术"
    },
    {
        "id":4477,
        "name":"4479 (English Program)  :  Oral And Maxillofacial Surgery | ศัลยกรรมช่องปากและขากรรไกร | 口腔颌面外科"
    },
    {
        "id":4478,
        "name":"4480 (English Program)  :  Plastic Surgery | ศัลยกรรมพลาสติก | 整形外科"
    },
    {
        "id":4479,
        "name":"4481 (English Program)  :  Cardio-Thoracic Surgery | ศัลยกรรมหัวใจและทรวงอก | 心胸外科"
    },
    {
        "id":4480,
        "name":"4482 (English Program)  :  Proctology | วิทยาศาสตรบัณฑิต | 直肠科"
    },
    {
        "id":4481,
        "name":"4483 (English Program)  :  Veterinary Surgery | สัตวแพทยศาสตร์ | 兽医外科"
    },
    {
        "id":4482,
        "name":"4484 (English Program)  :  Urological Surgery | ศัลยกรรมระบบทางเดินปัสสาวะ | 泌尿外科"
    },
    {
        "id":4483,
        "name":"4485 (English Program)  :  Orthopedic Surgery | ศัลยกรรมกระดูกและข้อ | 骨科手术"
    },
    {
        "id":4484,
        "name":"4486 (English Program)  :  Religious Studies | การศึกษาศาสนา | 宗教研究"
    },
    {
        "id":4485,
        "name":"4487 (English Program)  :  Religion | ศาสนา | 宗教"
    },
    {
        "id":4486,
        "name":"4488 (English Program)  :  Comparative Religion | ศาสนาเปรียบเทียบ | 比较宗教"
    },
    {
        "id":4487,
        "name":"4489 (English Program)  :  Religion And Philosophy | ศาสนาและปรัชญา | 宗教与哲学"
    },
    {
        "id":4488,
        "name":"4490 (English Program)  :  Dramatic Arts | นาฏศิลป์ | 戏剧艺术"
    },
    {
        "id":4489,
        "name":"4491 (English Program)  :  Communication And Advertising | การสื่อสารและการโฆษณา | 通讯和广告"
    },
    {
        "id":4490,
        "name":"4492 (English Program)  :  Applied Art | ศิลปะประยุกต์ | 应用艺术"
    },
    {
        "id":4491,
        "name":"4493 (English Program)  :  Art Education | การศึกษาด้านศิลปะ | 艺术教育"
    },
    {
        "id":4492,
        "name":"4494 (English Program)  :  Arts And Crafts | ศิลปะและงานฝีมือ | 工艺品"
    },
    {
        "id":4493,
        "name":"4495 (English Program)  :  Photographic Art | ศิลปะการถ่ายภาพ | 摄影艺术"
    },
    {
        "id":4494,
        "name":"4496 (English Program)  :  Textile, Costume, Garment And Fashion Designs | การออกแบบสิ่งทอ เครื่องแต่งกาย เครื่องแต่งกาย และแฟชั่น | 纺织品、服装、服装和时装设计"
    },
    {
        "id":4495,
        "name":"4497 (English Program)  :  Performing Arts | ศิลปะการแสดง | 表演艺术"
    },
    {
        "id":4496,
        "name":"4498 (English Program)  :  Handicrafts | หัตถกรรม | 手工艺品"
    },
    {
        "id":4497,
        "name":"4499 (English Program)  :  Applied Arts | ศิลปะประยุกต์ | 应用艺术"
    },
    {
        "id":4498,
        "name":"4500 (English Program)  :  Home Economic Education | การศึกษาเศรษฐศาสตร์ที่บ้าน | 家庭经济教育"
    },
    {
        "id":4499,
        "name":"4501 (English Program)  :  Agricultural Education | เกษตรศึกษา | 农业教育"
    },
    {
        "id":4500,
        "name":"4502 (English Program)  :  Community Development Education | การศึกษาการพัฒนาชุมชน | 社区发展教育"
    },
    {
        "id":4501,
        "name":"4503 (English Program)  :  Women'S Studies | การศึกษาของผู้หญิง | 女性研究"
    },
    {
        "id":4502,
        "name":"4504 (English Program)  :  Interior Architecture | สถาปัตยกรรมภายใน | 室内建筑"
    },
    {
        "id":4503,
        "name":"4505 (English Program)  :  Tropical Architecture | สถาปัตยกรรมเขตร้อน | 热带建筑"
    },
    {
        "id":4504,
        "name":"4506 (English Program)  :  City And Urban Design | การออกแบบเมืองและเมือง | 城市与城市设计"
    },
    {
        "id":4505,
        "name":"4507 (English Program)  :  Thai Architecture | สถาปัตยกรรมไทย | 泰国建筑"
    },
    {
        "id":4506,
        "name":"4508 (English Program)  :  Educational Statistics | สถิติการศึกษา | 教育统计"
    },
    {
        "id":4507,
        "name":"4509 (English Program)  :  Mathematical Statistics | สถิติทางคณิตศาสตร์ | 数理统计"
    },
    {
        "id":4508,
        "name":"4510 (English Program)  :  Applied Statistics | สถิติประยุกต์ | 应用统计"
    },
    {
        "id":4509,
        "name":"4511 (English Program)  :  Physiology | สรีรวิทยา | 生理"
    },
    {
        "id":4510,
        "name":"4512 (English Program)  :  Exercise Physiology | สรีรวิทยาการออกกำลังกาย | 运动生理学"
    },
    {
        "id":4511,
        "name":"4513 (English Program)  :  Medical Physiology | สรีรวิทยาการแพทย์ | 医学生理学"
    },
    {
        "id":4512,
        "name":"4514 (English Program)  :  Animal Physiology | สรีรวิทยาสัตว์ | 动物生理学"
    },
    {
        "id":4513,
        "name":"4515 (English Program)  :  Labor Welfare | สวัสดิการแรงงาน | 劳工福利"
    },
    {
        "id":4514,
        "name":"4516 (English Program)  :  Cooperatives | สหกรณ์ | 合作社"
    },
    {
        "id":4515,
        "name":"4517 (English Program)  :  Integrated Sciences | วิทยาศาสตร์บูรณาการ | 综合科学"
    },
    {
        "id":4516,
        "name":"4518 (English Program)  :  Interdisciplinary Studies Of Social Science | สหวิทยาการศึกษาสังคมศาสตร์ | 社会科学的跨学科研究"
    },
    {
        "id":4517,
        "name":"4519 (English Program)  :  Sociology | สังคมวิทยา | 社会学"
    },
    {
        "id":4518,
        "name":"4520 (English Program)  :  Development Sociology | สังคมวิทยาการพัฒนา | 发展社会学"
    },
    {
        "id":4519,
        "name":"4521 (English Program)  :  Applied Sociology | สังคมวิทยาประยุกต์ | 应用社会学"
    },
    {
        "id":4520,
        "name":"4522 (English Program)  :  Health Social Science | สังคมศาสตร์สุขภาพ | 健康社会科学"
    },
    {
        "id":4521,
        "name":"4523 (English Program)  :  Social Studies | สังคมศึกษา | 社会研究"
    },
    {
        "id":4522,
        "name":"4524 (English Program)  :  Social Work In Education | งานสังคมสงเคราะห์ในการศึกษา | 教育中的社会工作"
    },
    {
        "id":4523,
        "name":"4525 (English Program)  :  Medical Social Work | งานสังคมสงเคราะห์การแพทย์ | 医疗社会工作"
    },
    {
        "id":4524,
        "name":"4526 (English Program)  :  Social Work | งานสังคมสงเคราะห์ | 社会工作"
    },
    {
        "id":4525,
        "name":"4527 (English Program)  :  Social Work In Criminal Justice | งานสังคมสงเคราะห์ในกระบวนการยุติธรรมทางอาญา | 刑事司法中的社会工作"
    },
    {
        "id":4526,
        "name":"4528 (English Program)  :  Animal Husbandry | การเลี้ยงสัตว์ | 畜牧业"
    },
    {
        "id":4527,
        "name":"4529 (English Program)  :  Zoology | สัตววิทยา | 动物学"
    },
    {
        "id":4528,
        "name":"4530 (English Program)  :  Animal Science | วิทยาศาสตร์สัตว์ | 动物科学"
    },
    {
        "id":4529,
        "name":"4531 (English Program)  :  Poultry Technology | เทคโนโลยีสัตว์ปีก | 家禽技术"
    },
    {
        "id":4530,
        "name":"4532 (English Program)  :  General Information | ข้อมูลทั่วไป | 一般信息"
    },
    {
        "id":4531,
        "name":"4533 (English Program)  :  Information And Library Science | สารสนเทศและวิทยาศาสตร์ห้องสมุด | 信息与图书馆学"
    },
    {
        "id":4532,
        "name":"4534 (English Program)  :  Office Information | ข้อมูลสำนักงาน | 办公室信息"
    },
    {
        "id":4533,
        "name":"4535 (English Program)  :  Human Rights | สิทธิมนุษยชน | 人权"
    },
    {
        "id":4534,
        "name":"4536 (English Program)  :  Textile | สิ่งทอ | 纺织品"
    },
    {
        "id":4535,
        "name":"4537 (English Program)  :  Environment | สิ่งแวดล้อม | 环境"
    },
    {
        "id":4536,
        "name":"4538 (English Program)  :  Environmental Education | การศึกษาด้านสิ่งแวดล้อม | 环境教育"
    },
    {
        "id":4537,
        "name":"4539 (English Program)  :  Environment And Resource Studies | การศึกษาสิ่งแวดล้อมและทรัพยากร | 环境与资源研究"
    },
    {
        "id":4538,
        "name":"4540 (English Program)  :  Communication Performing Arts | ศิลปะการแสดงการสื่อสาร | 传播表演艺术"
    },
    {
        "id":4539,
        "name":"4541 (English Program)  :  Mental Health | สุขภาพจิต | 心理健康"
    },
    {
        "id":4540,
        "name":"4542 (English Program)  :  Psychiatric-Mental Health Nursing | การพยาบาลสุขภาพจิต-จิต | 精神心理健康护理"
    },
    {
        "id":4541,
        "name":"4543 (English Program)  :  Industrial Hygiene And Safety | สุขอนามัยและความปลอดภัยทางอุตสาหกรรม | 工业卫生与安全"
    },
    {
        "id":4542,
        "name":"4544 (English Program)  :  Health Education And Behavioral Science | การศึกษาด้านสุขภาพและพฤติกรรมศาสตร์ | 健康教育和行为科学"
    },
    {
        "id":4543,
        "name":"4545 (English Program)  :  Health Education And Health Behavior | การศึกษาด้านสุขภาพและพฤติกรรมสุขภาพ | 健康教育和健康行为"
    },
    {
        "id":4544,
        "name":"4546 (English Program)  :  Environmental Sanitation | สุขาภิบาลสิ่งแวดล้อม | 环境卫生"
    },
    {
        "id":4545,
        "name":"4547 (English Program)  :  Food Sanitation | สุขาภิบาลอาหาร | 食品卫生"
    },
    {
        "id":4546,
        "name":"4548 (English Program)  :  Obstetrics Gynaecology | สูติศาสตร์นรีเวชวิทยา | 妇产科"
    },
    {
        "id":4547,
        "name":"4549 (English Program)  :  Obstetrics And Gynaecology | สูติศาสตร์และนรีเวชวิทยา | 妇产科"
    },
    {
        "id":4548,
        "name":"4550 (English Program)  :  Forestry And Environmental Extension | การขยายป่าไม้และสิ่งแวดล้อม | 林业和环境推广"
    },
    {
        "id":4549,
        "name":"4551 (English Program)  :  Agricultural Extension And Cooperatives | การส่งเสริมและสหกรณ์การเกษตร | 农业推广和合作社"
    },
    {
        "id":4550,
        "name":"4552 (English Program)  :  Agricultural Extension And Communication | การส่งเสริมและการสื่อสารทางการเกษตร | 农业推广与交流"
    },
    {
        "id":4551,
        "name":"4553 (English Program)  :  Curriculum And Supervision | หลักสูตรและการนิเทศ | 课程与督导"
    },
    {
        "id":4552,
        "name":"4554 (English Program)  :  Curriculum And Instruction | หลักสูตรและการเรียนการสอน | 课程与教学"
    },
    {
        "id":4553,
        "name":"4555 (English Program)  :  Vocational Curriculum And Instruction | หลักสูตรอาชีวศึกษาและการสอน | 职业课程和教学"
    },
    {
        "id":4554,
        "name":"4556 (English Program)  :  Craft | งานฝีมือ | 工艺"
    },
    {
        "id":4555,
        "name":"4557 (English Program)  :  Crafts | งานฝีมือ | 工艺"
    },
    {
        "id":4556,
        "name":"4558 (English Program)  :  Deaf Studies | การศึกษาคนหูหนวก | 聋人研究"
    },
    {
        "id":4557,
        "name":"4559 (English Program)  :  School Library | ห้องสมุดโรงเรียน | 学校图书馆"
    },
    {
        "id":4558,
        "name":"4560 (English Program)  :  Social Organizations And Development | องค์กรทางสังคมและการพัฒนา | 社会组织与发展"
    },
    {
        "id":4559,
        "name":"4561 (English Program)  :  Molecular Biology | อณูชีววิทยา | 分子生物学"
    },
    {
        "id":4560,
        "name":"4562 (English Program)  :  Molecular Genetics And Genetic Engineering | อณูพันธุศาสตร์และวิศวกรรมพันธุศาสตร์ | 分子遗传学和基因工程"
    },
    {
        "id":4561,
        "name":"4563 (English Program)  :  Family Health | สุขภาพครอบครัว | 家庭健康"
    },
    {
        "id":4562,
        "name":"4564 (English Program)  :  Environmental Health | สุขภาพสิ่งแวดล้อม | 环境健康"
    },
    {
        "id":4563,
        "name":"4565 (English Program)  :  Applied Arts Design | การออกแบบศิลปะประยุกต์ | 应用艺术设计"
    },
    {
        "id":4564,
        "name":"4566 (English Program)  :  Industrial Product Design | การออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计"
    },
    {
        "id":4565,
        "name":"4567 (English Program)  :  Commercial Arts Design | การออกแบบศิลปะเชิงพาณิชย์ | 商业艺术设计"
    },
    {
        "id":4566,
        "name":"4568 (English Program)  :  Textile Design | การออกแบบสิ่งทอ | 纺织品设计"
    },
    {
        "id":4567,
        "name":"4569 (English Program)  :  Furniture Design | การออกแบบเฟอร์นิเจอร์ | 家具设计"
    },
    {
        "id":4568,
        "name":"4570 (English Program)  :  Ceramic Design | การออกแบบเซรามิก | 陶瓷设计"
    },
    {
        "id":4569,
        "name":"4571 (English Program)  :  Orthopedics | ศัลยกรรมกระดูก | 骨科"
    },
    {
        "id":4570,
        "name":"4572 (English Program)  :  Gemology | อัญมณีศาสตร์ | 宝石学"
    },
    {
        "id":4571,
        "name":"4573 (English Program)  :  Gems And Jewelry | เพชรพลอยและเครื่องประดับ | 宝石和珠宝"
    },
    {
        "id":4572,
        "name":"4574 (English Program)  :  Criminology Justice Administration And Society | การบริหารความยุติธรรมและสังคมอาชญวิทยา | 犯罪学司法行政与社会"
    },
    {
        "id":4573,
        "name":"4575 (English Program)  :  Criminology And Criminal Justice | อาชญาวิทยาและความยุติธรรมทางอาญา | 犯罪学和刑事司法"
    },
    {
        "id":4574,
        "name":"4576 (English Program)  :  Vocational Education | อาชีวศึกษา | 职业教育"
    },
    {
        "id":4575,
        "name":"4577 (English Program)  :  Occupational Health | อาชีวอนามัย | 职业健康"
    },
    {
        "id":4576,
        "name":"4578 (English Program)  :  Occupational Health And Safety | อาชีวอนามัยและความปลอดภัย | 职业健康与安全"
    },
    {
        "id":4577,
        "name":"4579 (English Program)  :  Occupational Medicine | อาชีวเวชศาสตร์ | 职业医学"
    },
    {
        "id":4578,
        "name":"4580 (English Program)  :  Internal Medicine | ยาภายใน | 内科"
    },
    {
        "id":4579,
        "name":"4581 (English Program)  :  Avian Medicine | ยารักษานก | 禽类医学"
    },
    {
        "id":4580,
        "name":"4582 (English Program)  :  Tropical Medicine | ยาเขตร้อน | 热带医学"
    },
    {
        "id":4581,
        "name":"4583 (English Program)  :  Clinical Tropical Medicine | คลินิกเวชศาสตร์เขตร้อน | 临床热带医学"
    },
    {
        "id":4582,
        "name":"4584 (English Program)  :  Animal Nutrition | โภชนาการสัตว์ | 动物营养"
    },
    {
        "id":4583,
        "name":"4585 (English Program)  :  Food Chemistry And Medical Nutrition | เคมีอาหารและโภชนาการทางการแพทย์ | 食品化学和医学营养"
    },
    {
        "id":4584,
        "name":"4586 (English Program)  :  Food And Nutrition | อาหารและโภชนาการ | 食品和营养"
    },
    {
        "id":4585,
        "name":"4587 (English Program)  :  Food And Nutrition For Development | อาหารและโภชนาการเพื่อการพัฒนา | 粮食和营养促进发展"
    },
    {
        "id":4586,
        "name":"4588 (English Program)  :  Islamic Studies | การศึกษาอิสลาม | 伊斯兰研究"
    },
    {
        "id":4587,
        "name":"4589 (English Program)  :  Electronics | อิเล็กทรอนิกส์ | 电子产品"
    },
    {
        "id":4588,
        "name":"4590 (English Program)  :  Services Industries | อุตสาหกรรมบริการ | 服务行业"
    },
    {
        "id":4589,
        "name":"4591 (English Program)  :  Fisheries Industry | อุตสาหกรรมประมง | 渔业"
    },
    {
        "id":4590,
        "name":"4592 (English Program)  :  Industrial Arts | ศิลปะอุตสาหกรรม | 工业艺术"
    },
    {
        "id":4591,
        "name":"4593 (English Program)  :  Industrial Arts Education | การศึกษาศิลปะอุตสาหกรรม | 工业艺术教育"
    },
    {
        "id":4592,
        "name":"4594 (English Program)  :  Industrial Education | การศึกษาอุตสาหกรรม | 工业教育"
    },
    {
        "id":4593,
        "name":"4595 (English Program)  :  Agricultural Industry | อุตสาหกรรมเกษตร | 农业产业"
    },
    {
        "id":4594,
        "name":"4596 (English Program)  :  Agro - Industry | เกษตร-อุตสาหกรรม | 农业-工业"
    },
    {
        "id":4595,
        "name":"4597 (English Program)  :  Parks And Recreation | สวนสาธารณะและสันทนาการ | 公园和休闲场所"
    },
    {
        "id":4596,
        "name":"4598 (English Program)  :  Medical Instrumentation | เครื่องมือแพทย์ | 医疗仪器"
    },
    {
        "id":4597,
        "name":"4599 (English Program)  :  Biomedical Instrumentation | เครื่องมือทางชีวการแพทย์ | 生物医学仪器"
    },
    {
        "id":4598,
        "name":"4600 (English Program)  :  Clinical Laboratory Instrumentation | เครื่องมือห้องปฏิบัติการทางคลินิก | 临床实验室仪器"
    },
    {
        "id":4599,
        "name":"4601 (English Program)  :  American Studies (American Literature) | อเมริกันศึกษา (วรรณกรรมอเมริกัน) | 美国研究（美国文学）"
    },
    {
        "id":4600,
        "name":"4602 (English Program)  :  Agriculture | เกษตรกรรม | 农业"
    },
    {
        "id":4601,
        "name":"4603 (English Program)  :  Agricultural Mechanization | เครื่องจักรกลการเกษตร | 农业机械化"
    },
    {
        "id":4602,
        "name":"4604 (English Program)  :  Integrated Farming | เกษตรกรรมแบบผสมผสาน | 综合农业"
    },
    {
        "id":4603,
        "name":"4605 (English Program)  :  Agricultural Systems | ระบบการเกษตร | 农业系统"
    },
    {
        "id":4604,
        "name":"4606 (English Program)  :  Tropical Agriculture | การเกษตรเขตร้อน | 热带农业"
    },
    {
        "id":4605,
        "name":"4607 (English Program)  :  Systems Agriculture | ระบบการเกษตร | 系统农业"
    },
    {
        "id":4606,
        "name":"4608 (English Program)  :  Agricultural And Environmental Education | การศึกษาเกษตรและสิ่งแวดล้อม | 农业与环境教育"
    },
    {
        "id":4607,
        "name":"4609 (English Program)  :  Chemistry | เคมี | 化学"
    },
    {
        "id":4608,
        "name":"4610 (English Program)  :  Chemistry-Biology | เคมี-ชีววิทยา | 化学生物学"
    },
    {
        "id":4609,
        "name":"4611 (English Program)  :  Agricultural Chemistry | เคมีเกษตร | 农业化学"
    },
    {
        "id":4610,
        "name":"4612 (English Program)  :  Clinical Chemistry | เคมีคลินิก | 临床化学"
    },
    {
        "id":4611,
        "name":"4613 (English Program)  :  Biological Chemistry | เคมีชีวภาพ | 生物化学"
    },
    {
        "id":4612,
        "name":"4614 (English Program)  :  Environmental Resource Chemistry | เคมีทรัพยากรสิ่งแวดล้อม | 环境资源化学"
    },
    {
        "id":4613,
        "name":"4615 (English Program)  :  Analytical Chemistry Training | การฝึกอบรมเคมีวิเคราะห์ | 分析化学培训"
    },
    {
        "id":4614,
        "name":"4616 (English Program)  :  Applied Chemistry | เคมีประยุกต์ | 应用化学"
    },
    {
        "id":4615,
        "name":"4617 (English Program)  :  Analytical Chemistry | เคมีวิเคราะห์ | 分析化学"
    },
    {
        "id":4616,
        "name":"4618 (English Program)  :  Applied Analytical And Inorganic Chemistry | เคมีวิเคราะห์และอนินทรีย์ประยุกต์ | 应用分析和无机化学"
    },
    {
        "id":4617,
        "name":"4619 (English Program)  :  Chemical Education | การศึกษาทางเคมี | 化学教育"
    },
    {
        "id":4618,
        "name":"4620 (English Program)  :  Chemistry Education | การศึกษาเคมี | 化学教育"
    },
    {
        "id":4619,
        "name":"4621 (English Program)  :  Environmental Chemistry | เคมีสิ่งแวดล้อม | 环境化学"
    },
    {
        "id":4620,
        "name":"4622 (English Program)  :  Inorganic Chemistry | เคมีอนินทรีย์ | 无机化学"
    },
    {
        "id":4621,
        "name":"4623 (English Program)  :  Organic Chemistry | เคมีอินทรีย์ | 有机化学"
    },
    {
        "id":4622,
        "name":"4624 (English Program)  :  Industrial Chemistry | เคมีอุตสาหกรรม | 工业化学"
    },
    {
        "id":4623,
        "name":"4625 (English Program)  :  Industrial Chemistry - Analytical Instrumentation | เคมีอุตสาหกรรม - เครื่องมือวิเคราะห์ | 工业化学 - 分析仪器"
    },
    {
        "id":4624,
        "name":"4626 (English Program)  :  Agricultural Machinery | เครื่องจักรการเกษตร | 农业机械"
    },
    {
        "id":4625,
        "name":"4627 (English Program)  :  Leatherwork | งานเครื่องหนัง | 皮革制品"
    },
    {
        "id":4626,
        "name":"4628 (English Program)  :  Industrial Furniture | เฟอร์นิเจอร์อุตสาหกรรม | 工业家具"
    },
    {
        "id":4627,
        "name":"4629 (English Program)  :  Metalwork And Jewelry | งานโลหะและเครื่องประดับ | 金属制品和珠宝"
    },
    {
        "id":4628,
        "name":"4630 (English Program)  :  Housing | ที่อยู่อาศัย | 住房"
    },
    {
        "id":4629,
        "name":"4631 (English Program)  :  Medical Laboratory Technician | ช่างเทคนิคห้องปฏิบัติการทางการแพทย์ | 医学实验室技术员"
    },
    {
        "id":4630,
        "name":"4632 (English Program)  :  Medical Cytology | เซลล์วิทยาทางการแพทย์ | 医学细胞学"
    },
    {
        "id":4631,
        "name":"4633 (English Program)  :  Prosthetic And Orthotic Technology | เทคโนโลยีด้านกายอุปกรณ์และกายอุปกรณ์ | 假肢和矫形技术"
    },
    {
        "id":4632,
        "name":"4634 (English Program)  :  Agricultural Techniques | เทคนิคการเกษตร | 农业技术"
    },
    {
        "id":4633,
        "name":"4635 (English Program)  :  Technical Education | การศึกษาด้านเทคนิค | 技术教育"
    },
    {
        "id":4634,
        "name":"4636 (English Program)  :  Metal Forming Technology | เทคโนโลยีการขึ้นรูปโลหะ | 金属成形技术"
    },
    {
        "id":4635,
        "name":"4637 (English Program)  :  Management Technology | เทคโนโลยีการจัดการ | 管理技术"
    },
    {
        "id":4636,
        "name":"4638 (English Program)  :  Technology For Marine And Coastal | เทคโนโลยีสำหรับการเดินเรือและชายฝั่ง | 海洋和沿海技术"
    },
    {
        "id":4637,
        "name":"4639 (English Program)  :  Energy Management Technology | เทคโนโลยีการจัดการพลังงาน | 能源管理技术"
    },
    {
        "id":4638,
        "name":"4640 (English Program)  :  Energy Management Technologys | เทคโนโลยีการจัดการพลังงาน | 能源管理技术"
    },
    {
        "id":4639,
        "name":"4641 (English Program)  :  Technology Of Information System Management | เทคโนโลยีการจัดการระบบสารสนเทศ | 信息系统管理技术"
    },
    {
        "id":4640,
        "name":"4642 (English Program)  :  Pest Management Technology | เทคโนโลยีการจัดการสัตว์รบกวน | 害虫防治技术"
    },
    {
        "id":4641,
        "name":"4643 (English Program)  :  Plant Pest Management Technology | เทคโนโลยีการจัดการศัตรูพืช | 植物害虫防治技术"
    },
    {
        "id":4642,
        "name":"4644 (English Program)  :  Industrial Management Technology | เทคโนโลยีการจัดการอุตสาหกรรม | 工业管理技术"
    },
    {
        "id":4643,
        "name":"4645 (English Program)  :  Administration Technology | เทคโนโลยีการบริหาร | 管理技术"
    },
    {
        "id":4644,
        "name":"4646 (English Program)  :  Fishery Technology | เทคโนโลยีการประมง | 渔业技术"
    },
    {
        "id":4645,
        "name":"4647 (English Program)  :  Production Technology | เทคโนโลยีการผลิต | 生产技术"
    },
    {
        "id":4646,
        "name":"4648 (English Program)  :  Crop Production Technology | เทคโนโลยีการผลิตพืชผล | 农作物生产技术"
    },
    {
        "id":4647,
        "name":"4649 (English Program)  :  Plant Production Technology | เทคโนโลยีการผลิตพืช | 植物生产技术"
    },
    {
        "id":4648,
        "name":"4650 (English Program)  :  Animal Production Technology | เทคโนโลยีการผลิตสัตว์ | 动物生产技术"
    },
    {
        "id":4649,
        "name":"4651 (English Program)  :  Technology Of Aquatic Animal Product | เทคโนโลยีผลิตภัณฑ์สัตว์น้ำ | 水产养殖技术"
    },
    {
        "id":4650,
        "name":"4652 (English Program)  :  Swine Production Technology | เทคโนโลยีการผลิตสุกร | 生猪生产技术"
    },
    {
        "id":4651,
        "name":"4653 (English Program)  :  Product Development Technology | เทคโนโลยีการพัฒนาผลิตภัณฑ์ | 产品开发技术"
    },
    {
        "id":4652,
        "name":"4654 (English Program)  :  Printing Technology | เทคโนโลยีการพิมพ์ | 印刷技术"
    },
    {
        "id":4653,
        "name":"4655 (English Program)  :  Printing Technology And Print Media | เทคโนโลยีการพิมพ์และสื่อสิ่งพิมพ์ | 印刷技术和印刷介质"
    },
    {
        "id":4654,
        "name":"4656 (English Program)  :  Industrial Instrument Technology | เทคโนโลยีเครื่องมือทางอุตสาหกรรม | 工业仪表技术"
    },
    {
        "id":4655,
        "name":"4657 (English Program)  :  Educational Measurement Technology | เทคโนโลยีการวัดทางการศึกษา | 教育测量技术"
    },
    {
        "id":4656,
        "name":"4658 (English Program)  :  Technology Of Educational Measurement And Evaluation | เทคโนโลยีการวัดและประเมินผลการศึกษา | 教育测量与评价技术"
    },
    {
        "id":4657,
        "name":"4659 (English Program)  :  Technology Of Environmental Planning For Rural Development | เทคโนโลยีการวางแผนสิ่งแวดล้อมเพื่อการพัฒนาชนบท | 农村发展环境规划技术"
    },
    {
        "id":4658,
        "name":"4660 (English Program)  :  Educational Technology In Vocational And Technical Education | เทคโนโลยีการศึกษาด้านอาชีวศึกษาและอาชีวศึกษา | 职业技术教育中的教育技术"
    },
    {
        "id":4659,
        "name":"4661 (English Program)  :  Fermentation Technology | เทคโนโลยีการหมัก | 发酵技术"
    },
    {
        "id":4660,
        "name":"4662 (English Program)  :  Food Technology And Nutrition | เทคโนโลยีอาหารและโภชนาการ | 食品技术和营养"
    },
    {
        "id":4661,
        "name":"4663 (English Program)  :  Agricultural Technology | เทคโนโลยีการเกษตร | 农业技术"
    },
    {
        "id":4662,
        "name":"4664 (English Program)  :  Agricultural Technology - Animal Production | เทคโนโลยีการเกษตร - การผลิตสัตว์ | 农业技术 - 动物生产"
    },
    {
        "id":4663,
        "name":"4665 (English Program)  :  Agricultural Technology - Plant Production | เทคโนโลยีการเกษตร - การผลิตพืช | 农业技术 - 植物生产"
    },
    {
        "id":4664,
        "name":"4666 (English Program)  :  Welding Technology | เทคโนโลยีการเชื่อม | 焊接技术"
    },
    {
        "id":4665,
        "name":"4667 (English Program)  :  Technology In Animal Production | เทคโนโลยีในการผลิตสัตว์ | 动物生产技术"
    },
    {
        "id":4666,
        "name":"4668 (English Program)  :  Marine Shrimp Culture Technology | เทคโนโลยีการเลี้ยงกุ้งทะเล | 海水虾养殖技术"
    },
    {
        "id":4667,
        "name":"4669 (English Program)  :  Advertising And Public Relations Technology | เทคโนโลยีการโฆษณาและการประชาสัมพันธ์ | 广告和公共关系技术"
    },
    {
        "id":4668,
        "name":"4670 (English Program)  :  Radio And Television Broadcasting Technology | เทคโนโลยีกระจายเสียงวิทยุและโทรทัศน์ | 广播电视传播技术"
    },
    {
        "id":4669,
        "name":"4671 (English Program)  :  Materials Handling Technology | เทคโนโลยีการจัดการวัสดุ | 物料搬运技术"
    },
    {
        "id":4670,
        "name":"4672 (English Program)  :  Sugar Technology | เทคโนโลยีน้ำตาล | 制糖技术"
    },
    {
        "id":4671,
        "name":"4673 (English Program)  :  Computer Technology | เทคโนโลยีคอมพิวเตอร์ | 计算机技术"
    },
    {
        "id":4672,
        "name":"4674 (English Program)  :  Industrial Computer Technology | เทคโนโลยีคอมพิวเตอร์อุตสาหกรรม | 工业计算机技术"
    },
    {
        "id":4673,
        "name":"4675 (English Program)  :  Computing Technology For Education | เทคโนโลยีคอมพิวเตอร์เพื่อการศึกษา | 教育计算技术"
    },
    {
        "id":4674,
        "name":"4676 (English Program)  :  Rural Technology | เทคโนโลยีชนบท | 农村科技"
    },
    {
        "id":4675,
        "name":"4677 (English Program)  :  Biotechnology | เทคโนโลยีชีวภาพ | 生物科技"
    },
    {
        "id":4676,
        "name":"4678 (English Program)  :  Agricultural Biotechnology | เทคโนโลยีชีวภาพเกษตร | 农业生物技术"
    },
    {
        "id":4677,
        "name":"4679 (English Program)  :  Agro-Industrial Biotechnology | เทคโนโลยีชีวภาพอุตสาหกรรมเกษตร | 农工生物技术"
    },
    {
        "id":4678,
        "name":"4680 (English Program)  :  Biotechnology In Plant Pathology | เทคโนโลยีชีวภาพทางพยาธิวิทยาของพืช | 植物病理学中的生物技术"
    },
    {
        "id":4679,
        "name":"4681 (English Program)  :  Biochemical Technology | เทคโนโลยีชีวเคมี | 生化技术"
    },
    {
        "id":4680,
        "name":"4682 (English Program)  :  Dental Technolgoy | เทคโนโลยีทันตกรรม | 牙科技术"
    },
    {
        "id":4681,
        "name":"4683 (English Program)  :  Physico-Chemical Processiong Technology | เทคโนโลยีกระบวนการทางเคมีกายภาพ | 物化处理技术"
    },
    {
        "id":4682,
        "name":"4684 (English Program)  :  Marine Technology | เทคโนโลยีทางทะเล | 海洋技术"
    },
    {
        "id":4683,
        "name":"4685 (English Program)  :  Imaging Technology | เทคโนโลยีการสร้างภาพ | 影像技术"
    },
    {
        "id":4684,
        "name":"4686 (English Program)  :  Imaging And Printing Technology | เทคโนโลยีการสร้างภาพและการพิมพ์ | 成像和打印技术"
    },
    {
        "id":4685,
        "name":"4687 (English Program)  :  Appropriate Technology For Resources And Environmental Development | เทคโนโลยีที่เหมาะสมสำหรับทรัพยากรและการพัฒนาสิ่งแวดล้อม | 资源和环境开发的适用技术"
    },
    {
        "id":4686,
        "name":"4688 (English Program)  :  Geotechnology | ธรณีวิทยา | 岩土技术"
    },
    {
        "id":4687,
        "name":"4689 (English Program)  :  Petrochemical Technology | เทคโนโลยีปิโตรเคมี | 石化技术"
    },
    {
        "id":4688,
        "name":"4690 (English Program)  :  Petroleum Technology | เทคโนโลยีปิโตรเลียม | 石油技术"
    },
    {
        "id":4689,
        "name":"4691 (English Program)  :  Fishery Products Technology | เทคโนโลยีผลิตภัณฑ์ประมง | 水产品技术"
    },
    {
        "id":4690,
        "name":"4692 (English Program)  :  Textile Product Technology | เทคโนโลยีผลิตภัณฑ์สิ่งทอ | 纺织产品技术"
    },
    {
        "id":4691,
        "name":"4693 (English Program)  :  Industrial Design Technology | เทคโนโลยีการออกแบบอุตสาหกรรม | 工业设计技术"
    },
    {
        "id":4692,
        "name":"4694 (English Program)  :  Energy Technology | เทคโนโลยีพลังงาน | 能源科技"
    },
    {
        "id":4693,
        "name":"4695 (English Program)  :  Polymer Technology | เทคโนโลยีโพลีเมอร์ | 聚合物技术"
    },
    {
        "id":4694,
        "name":"4696 (English Program)  :  Landscape Technology | เทคโนโลยีภูมิทัศน์ | 景观技术"
    },
    {
        "id":4695,
        "name":"4697 (English Program)  :  Geographical Technology | เทคโนโลยีทางภูมิศาสตร์ | 地理技术"
    },
    {
        "id":4696,
        "name":"4698 (English Program)  :  Geo-Informatic Technology | เทคโนโลยีภูมิสารสนเทศ | 地理信息技术"
    },
    {
        "id":4697,
        "name":"4699 (English Program)  :  Multimedia Technology | เทคโนโลยีมัลติมีเดีย | 多媒体技术"
    },
    {
        "id":4698,
        "name":"4700 (English Program)  :  Rubber And Polymer Technology | เทคโนโลยียางและโพลีเมอร์ | 橡胶和聚合物技术"
    },
    {
        "id":4699,
        "name":"4701 (English Program)  :  Materials Technology | เทคโนโลยีวัสดุ | 材料技术"
    },
    {
        "id":4700,
        "name":"4702 (English Program)  :  Material Product Technology | เทคโนโลยีผลิตภัณฑ์วัสดุ | 材料产品技术"
    },
    {
        "id":4701,
        "name":"4703 (English Program)  :  Educational Research Technology | เทคโนโลยีการวิจัยทางการศึกษา | 教育研究技术"
    },
    {
        "id":4702,
        "name":"4704 (English Program)  :  Refrigeration And Air-Conditioning Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องทำความเย็นและการปรับอากาศ | 制冷空调工程技术"
    },
    {
        "id":4703,
        "name":"4705 (English Program)  :  Machine Design And Manufacturing Technology | การออกแบบเครื่องจักรและเทคโนโลยีการผลิต | 机械设计与制造技术"
    },
    {
        "id":4704,
        "name":"4706 (English Program)  :  Welding Engineering Technology | เทคโนโลยีวิศวกรรมการเชื่อม | 焊接工程技术"
    },
    {
        "id":4705,
        "name":"4707 (English Program)  :  Automotive Engineering Technology | เทคโนโลยีวิศวกรรมยานยนต์ | 汽车工程技术"
    },
    {
        "id":4706,
        "name":"4708 (English Program)  :  Electronics Engineering Technology | เทคโนโลยีวิศวกรรมอิเล็กทรอนิกส์ | 电子工程技术"
    },
    {
        "id":4707,
        "name":"4709 (English Program)  :  Power Electronics Engineering Technology | เทคโนโลยีวิศวกรรมอิเล็กทรอนิกส์กำลัง | 电力电子工程技术"
    },
    {
        "id":4708,
        "name":"4710 (English Program)  :  Tool Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องมือ | 工具工程技术"
    },
    {
        "id":4709,
        "name":"4711 (English Program)  :  Civil Engineering Technology | เทคโนโลยีวิศวกรรมโยธา | 土木工程技术"
    },
    {
        "id":4710,
        "name":"4712 (English Program)  :  Wood Engineering Technology | เทคโนโลยีวิศวกรรมไม้ | 木材工程技术"
    },
    {
        "id":4711,
        "name":"4713 (English Program)  :  Industrial Art Technology | เทคโนโลยีศิลปะอุตสาหกรรม | 工业艺术技术"
    },
    {
        "id":4712,
        "name":"4714 (English Program)  :  Information Technology For Industry | เทคโนโลยีสารสนเทศสำหรับอุตสาหกรรม | 工业信息技术"
    },
    {
        "id":4713,
        "name":"4715 (English Program)  :  Information Technology And Management | เทคโนโลยีสารสนเทศและการจัดการ | 信息技术与管理"
    },
    {
        "id":4714,
        "name":"4716 (English Program)  :  Environmental Technology | เทคโนโลยีสิ่งแวดล้อม | 环保科技"
    },
    {
        "id":4715,
        "name":"4717 (English Program)  :  Educational Communication Technology | เทคโนโลยีการสื่อสารทางการศึกษา | 教育通讯技术"
    },
    {
        "id":4716,
        "name":"4718 (English Program)  :  Mass Communication Technology | เทคโนโลยีการสื่อสารมวลชน | 大众传播技术"
    },
    {
        "id":4717,
        "name":"4719 (English Program)  :  Postharvest Technology And Package | เทคโนโลยีและบรรจุภัณฑ์หลังการเก็บเกี่ยว | 采后技术和包装"
    },
    {
        "id":4718,
        "name":"4720 (English Program)  :  Cardio-Thoracic Technology | เทคโนโลยีหัวใจและทรวงอก | 心胸技术"
    },
    {
        "id":4719,
        "name":"4721 (English Program)  :  Gemological Technology | เทคโนโลยีอัญมณี | 宝石技术"
    },
    {
        "id":4720,
        "name":"4722 (English Program)  :  Building Technology | เทคโนโลยีการสร้าง | 建筑技术"
    },
    {
        "id":4721,
        "name":"4723 (English Program)  :  Internet And Information Technology | อินเทอร์เน็ตและเทคโนโลยีสารสนเทศ | 互联网与信息技术"
    },
    {
        "id":4722,
        "name":"4724 (English Program)  :  Electronic Technology | เทคโนโลยีอิเล็กทรอนิกส์ | 电子技术"
    },
    {
        "id":4723,
        "name":"4725 (English Program)  :  Industrial Electronics | อิเล็กทรอนิกส์อุตสาหกรรม | 工业电子"
    },
    {
        "id":4724,
        "name":"4726 (English Program)  :  Power Electronics Technology | เทคโนโลยีอิเล็กทรอนิกส์กำลัง | 电力电子技术"
    },
    {
        "id":4725,
        "name":"4727 (English Program)  :  Thermal Technology | เทคโนโลยีระบายความร้อน | 热技术"
    },
    {
        "id":4726,
        "name":"4728 (English Program)  :  Science Biotechnology | วิทยาศาสตร์เทคโนโลยีชีวภาพ | 科学生物技术"
    },
    {
        "id":4727,
        "name":"4729 (English Program)  :  Industrial Technology Education | การศึกษาเทคโนโลยีอุตสาหกรรม | 工业技术教育"
    },
    {
        "id":4728,
        "name":"4730 (English Program)  :  Agro-Industrial Technology | เทคโนโลยีอุตสาหกรรมเกษตร | 农工技术"
    },
    {
        "id":4729,
        "name":"4731 (English Program)  :  Ceramic Industrial Technology | เทคโนโลยีอุตสาหกรรมเซรามิก | 陶瓷工业技术"
    },
    {
        "id":4730,
        "name":"4732 (English Program)  :  Textile Chemistry Technology | เทคโนโลยีเคมีสิ่งทอ | 纺织化学技术"
    },
    {
        "id":4731,
        "name":"4733 (English Program)  :  Agricultural Machinery Technology | เทคโนโลยีเครื่องจักรการเกษตร | 农业机械技术"
    },
    {
        "id":4732,
        "name":"4734 (English Program)  :  Power Technology | เทคโนโลยีขุมพลัง | 电源技术"
    },
    {
        "id":4733,
        "name":"4735 (English Program)  :  Gems And Jewelry Of Technology | อัญมณีและเครื่องประดับแห่งเทคโนโลยี | 宝石和科技珠宝"
    },
    {
        "id":4734,
        "name":"4736 (English Program)  :  Technical Education Technology | เทคโนโลยีการศึกษาด้านเทคนิค | 技术教育技术"
    },
    {
        "id":4735,
        "name":"4737 (English Program)  :  Technology For Rural Development | เทคโนโลยีเพื่อการพัฒนาชนบท | 农村发展技术"
    },
    {
        "id":4736,
        "name":"4738 (English Program)  :  Seed Technology | เทคโนโลยีเมล็ดพันธุ์ | 种子技术"
    },
    {
        "id":4737,
        "name":"4739 (English Program)  :  Pulp And Paper Technology | เทคโนโลยีเยื่อและกระดาษ | 制浆造纸技术"
    },
    {
        "id":4738,
        "name":"4740 (English Program)  :  Laser Technology | เทคโนโลยีเลเซอร์ | 激光技术"
    },
    {
        "id":4739,
        "name":"4741 (English Program)  :  Garment Technology | เทคโนโลยีการ์เม้นท์ | 成衣技术"
    },
    {
        "id":4740,
        "name":"4742 (English Program)  :  Mining Technology | เทคโนโลยีการขุด | 采矿技术"
    },
    {
        "id":4741,
        "name":"4743 (English Program)  :  Jewelry Modeling Technology | เทคโนโลยีการสร้างแบบจำลองเครื่องประดับ | 珠宝造型技术"
    },
    {
        "id":4742,
        "name":"4744 (English Program)  :  Electricity Industry Management And Technology | การจัดการและเทคโนโลยีอุตสาหกรรมไฟฟ้า | 电力工业管理与技术"
    },
    {
        "id":4743,
        "name":"4745 (English Program)  :  Educational Technology And Innovation | เทคโนโลยีการศึกษาและนวัตกรรม | 教育技术与创新"
    },
    {
        "id":4744,
        "name":"4746 (English Program)  :  Educational Technology And Communication | เทคโนโลยีการศึกษาและการสื่อสาร | 教育技术与传播"
    },
    {
        "id":4745,
        "name":"4747 (English Program)  :  Structures Technology | เทคโนโลยีโครงสร้าง | 结构技术"
    },
    {
        "id":4746,
        "name":"4748 (English Program)  :  Telecommunication Technology | เทคโนโลยีโทรคมนาคม | 电信技术"
    },
    {
        "id":4747,
        "name":"4749 (English Program)  :  Industrial Electrical Technology | เทคโนโลยีไฟฟ้าอุตสาหกรรม | 工业电气技术"
    },
    {
        "id":4748,
        "name":"4750 (English Program)  :  Human Sexuality | เพศของมนุษย์ | 人类的性行为"
    },
    {
        "id":4749,
        "name":"4751 (English Program)  :  Aquaculture-Fisheries Engineering | วิศวกรรมการเพาะเลี้ยงสัตว์น้ำ-ประมง | 水产养殖-渔业工程"
    },
    {
        "id":4750,
        "name":"4752 (English Program)  :  Clinical Pharmacy | เภสัชคลินิก | 临床药房"
    },
    {
        "id":4751,
        "name":"4753 (English Program)  :  Clinical And Administrative Pharmacy | เภสัชคลินิกและบริหาร | 临床和行政药学"
    },
    {
        "id":4752,
        "name":"4754 (English Program)  :  Community Pharmacy | เภสัชชุมชน | 社区药房"
    },
    {
        "id":4753,
        "name":"4755 (English Program)  :  Hospital Pharmacy | เภสัชศาสตร์โรงพยาบาล | 医院药房"
    },
    {
        "id":4754,
        "name":"4756 (English Program)  :  Hospital And Clinical Pharmacy | เภสัชกรรมโรงพยาบาลและคลินิก | 医院和临床药房"
    },
    {
        "id":4755,
        "name":"4757 (English Program)  :  Pharmaceutical Botany | เภสัชพฤกษศาสตร์ | 药用植物学"
    },
    {
        "id":4756,
        "name":"4758 (English Program)  :  Pharmaceuticals | เภสัชกรรม | 医药品"
    },
    {
        "id":4757,
        "name":"4759 (English Program)  :  Pharmacology | เภสัชวิทยา | 药理"
    },
    {
        "id":4758,
        "name":"4760 (English Program)  :  Veterinary Pharmacology | เภสัชวิทยาสัตวแพทยศาสตร์ | 兽医药理学"
    },
    {
        "id":4759,
        "name":"4761 (English Program)  :  Pharmacognosy And Pharmaceutical Chemistry | เภสัชวิทยาและเคมีเภสัช | 药剂学和药物化学"
    },
    {
        "id":4760,
        "name":"4762 (English Program)  :  Biopharmaceutical Science | วิทยาศาสตร์ชีวเภสัชภัณฑ์ | 生物制药科学"
    },
    {
        "id":4761,
        "name":"4763 (English Program)  :  Industrial Pharmacy | เภสัชอุตสาหกรรม | 工业制药"
    },
    {
        "id":4762,
        "name":"4764 (English Program)  :  Pharmaceutical Chemistry | เภสัชเคมี | 药物化学"
    },
    {
        "id":4763,
        "name":"4765 (English Program)  :  Pharmaceutical Chemistry And Natural Products | เคมีเภสัชและผลิตภัณฑ์จากธรรมชาติ | 药物化学和天然产物"
    },
    {
        "id":4764,
        "name":"4766 (English Program)  :  Pharmaceutical Chemistry And Phytochemistry | เคมีเภสัชและพฤกษเคมี | 药物化学和植物化学"
    },
    {
        "id":4765,
        "name":"4767 (English Program)  :  Biomedical And Communications | ชีวการแพทย์และการสื่อสาร | 生物医学和通信"
    },
    {
        "id":4766,
        "name":"4768 (English Program)  :  Medical Arts & Communications | ศิลปะการแพทย์และการสื่อสาร | 医学艺术与传播"
    },
    {
        "id":4767,
        "name":"4769 (English Program)  :  Medical Illustration And Audio - Visual Technology | ภาพประกอบทางการแพทย์และเสียง - เทคโนโลยีภาพ | 医学插图和音频-视觉技术"
    },
    {
        "id":4768,
        "name":"4770 (English Program)  :  General Practice | การปฏิบัติทั่วไป | 一般做法"
    },
    {
        "id":4769,
        "name":"4771 (English Program)  :  General Practice \/ Family Practice | การปฏิบัติทั่วไป \/ การปฏิบัติของครอบครัว | 一般医疗\/家庭医疗"
    },
    {
        "id":4770,
        "name":"4772 (English Program)  :  Medical Record | บันทึกทางการแพทย์ | 医疗记录"
    },
    {
        "id":4771,
        "name":"4773 (English Program)  :  Sports Medicine | เวชศาสตร์การกีฬา | 运动医学"
    },
    {
        "id":4772,
        "name":"4774 (English Program)  :  Transfusion Medicine | ยาถ่ายเลือด | 输血医学"
    },
    {
        "id":4773,
        "name":"4775 (English Program)  :  Family Medicine | เวชศาสตร์ครอบครัว | 家庭医学"
    },
    {
        "id":4774,
        "name":"4776 (English Program)  :  Community Medicine | เวชศาสตร์ชุมชน | 社区医学"
    },
    {
        "id":4775,
        "name":"4777 (English Program)  :  Oral Medicine | ยารับประทาน | 口服药"
    },
    {
        "id":4776,
        "name":"4778 (English Program)  :  General Practice And Emergency Medicine | เวชปฏิบัติทั่วไปและเวชศาสตร์ฉุกเฉิน | 全科医学和急诊医学"
    },
    {
        "id":4777,
        "name":"4779 (English Program)  :  Preventive Medicine Surgery | การผ่าตัดเวชศาสตร์ป้องกัน | 预防医学外科"
    },
    {
        "id":4778,
        "name":"4780 (English Program)  :  Clinical Preventive Medicine | เวชศาสตร์ป้องกันทางคลินิก | 临床预防医学"
    },
    {
        "id":4779,
        "name":"4781 (English Program)  :  Rehabilitation Medicine | เวชศาสตร์ฟื้นฟู | 康复医学"
    },
    {
        "id":4780,
        "name":"4782 (English Program)  :  Econometrics | เศรษฐมิติ | 计量经济学"
    },
    {
        "id":4781,
        "name":"4783 (English Program)  :  Economics | เศรษฐศาสตร์ | 经济学"
    },
    {
        "id":4782,
        "name":"4784 (English Program)  :  Economics Of Public Finance | เศรษฐศาสตร์การคลังสาธารณะ | 公共财政经济学"
    },
    {
        "id":4783,
        "name":"4785 (English Program)  :  Economics Of Education | เศรษฐศาสตร์การศึกษา | 教育经济学"
    },
    {
        "id":4784,
        "name":"4786 (English Program)  :  Monetary Economics | เศรษฐศาสตร์การเงิน | 货币经济学"
    },
    {
        "id":4785,
        "name":"4787 (English Program)  :  Political Economy | เศรษฐศาสตร์การเมือง | 政治经济"
    },
    {
        "id":4786,
        "name":"4788 (English Program)  :  Natural Resource And Environmental Economics | เศรษฐศาสตร์ทรัพยากรธรรมชาติและสิ่งแวดล้อม | 自然资源与环境经济"
    },
    {
        "id":4787,
        "name":"4789 (English Program)  :  Economic Of Human Resource | เศรษฐศาสตร์ทรัพยากรมนุษย์ | 人力资源经济"
    },
    {
        "id":4788,
        "name":"4790 (English Program)  :  Business Economics | เศรษฐศาสตร์ธุรกิจ | 商业经济学"
    },
    {
        "id":4789,
        "name":"4791 (English Program)  :  Business And Managerial Economics | เศรษฐศาสตร์ธุรกิจและการจัดการ | 商业和管理经济学"
    },
    {
        "id":4790,
        "name":"4792 (English Program)  :  Economics Of Population And Human Resources | เศรษฐศาสตร์ประชากรและทรัพยากรมนุษย์ | 人口和人力资源经济学"
    },
    {
        "id":4791,
        "name":"4793 (English Program)  :  Cooperative Economics | เศรษฐศาสตร์สหกรณ์ | 合作经济"
    },
    {
        "id":4792,
        "name":"4794 (English Program)  :  Health Economics | เศรษฐศาสตร์สุขภาพ | 健康经济学"
    },
    {
        "id":4793,
        "name":"4795 (English Program)  :  Environmental Economics | เศรษฐศาสตร์สิ่งแวดล้อม | 环境经济学"
    },
    {
        "id":4794,
        "name":"4796 (English Program)  :  Environmental And Natural Resources Economics | เศรษฐศาสตร์สิ่งแวดล้อมและทรัพยากรธรรมชาติ | 环境和自然资源经济学"
    },
    {
        "id":4795,
        "name":"4797 (English Program)  :  Industrial Economics | เศรษฐศาสตร์อุตสาหกรรม | 产业经济"
    },
    {
        "id":4796,
        "name":"4798 (English Program)  :  Industrial And Labor Economics | เศรษฐศาสตร์อุตสาหกรรมและแรงงาน | 工业和劳动经济"
    },
    {
        "id":4797,
        "name":"4799 (English Program)  :  Agricultural Economics | เศรษฐศาสตร์เกษตร | 农业经济"
    },
    {
        "id":4798,
        "name":"4800 (English Program)  :  Quantitative Economics | เศรษฐศาสตร์เชิงปริมาณ | 数量经济学"
    },
    {
        "id":4799,
        "name":"4801 (English Program)  :  Labor Economics And Human | เศรษฐศาสตร์แรงงานและมนุษย์ | 劳动经济与人类"
    },
    {
        "id":4800,
        "name":"4802 (English Program)  :  Islamic Economics And Management | เศรษฐศาสตร์และการจัดการอิสลาม | 伊斯兰经济与管理"
    },
    {
        "id":4801,
        "name":"4803 (English Program)  :  International Economics And Finance | เศรษฐศาสตร์และการเงินระหว่างประเทศ | 国际经济与金融"
    },
    {
        "id":4802,
        "name":"4804 (English Program)  :  Cartography And Geographic Information Systems | การทำแผนที่และระบบสารสนเทศภูมิศาสตร์ | 制图和地理信息系统"
    },
    {
        "id":4803,
        "name":"4805 (English Program)  :  Maps And Geographical Technology | แผนที่และเทคโนโลยีทางภูมิศาสตร์ | 地图和地理技术"
    },
    {
        "id":4804,
        "name":"4806 (English Program)  :  Medicine (Mesrap) | ยา (Mesrap) | 医学（美斯拉普）"
    },
    {
        "id":4805,
        "name":"4807 (English Program)  :  Medicine (Ctpb) | ยา (Ctpb) | 医学（Ctpb）"
    },
    {
        "id":4806,
        "name":"4808 (English Program)  :  Thai Traditional Medicine | การแพทย์แผนไทย | 泰国传统医学"
    },
    {
        "id":4807,
        "name":"4809 (English Program)  :  Labor Relations And Development | แรงงานสัมพันธ์และการพัฒนา | 劳资关系与发展"
    },
    {
        "id":4808,
        "name":"4810 (English Program)  :  Dairy And Beef Cattle | โคนมและเนื้อวัว | 奶牛和肉牛"
    },
    {
        "id":4809,
        "name":"4811 (English Program)  :  Archaeology | โบราณคดี | 考古学"
    },
    {
        "id":4810,
        "name":"4812 (English Program)  :  Prehistoric Archaeology | โบราณคดียุคก่อนประวัติศาสตร์ | 史前考古学"
    },
    {
        "id":4811,
        "name":"4813 (English Program)  :  Historical Archaeology | โบราณคดีประวัติศาสตร์ | 历史考古学"
    },
    {
        "id":4812,
        "name":"4814 (English Program)  :  Therapeutic Nutrition | โภชนาการบำบัด | 治疗性营养"
    },
    {
        "id":4813,
        "name":"4815 (English Program)  :  Nutrition And Dietetics | โภชนาการและการควบคุมอาหาร | 营养与饮食"
    },
    {
        "id":4814,
        "name":"4816 (English Program)  :  Nutrition Education | การศึกษาด้านโภชนาการ | 营养教育"
    },
    {
        "id":4815,
        "name":"4817 (English Program)  :  Community Nutrition | โภชนาการชุมชน | 社区营养"
    },
    {
        "id":4816,
        "name":"4818 (English Program)  :  Public Health Nutrition | โภชนาการด้านสาธารณสุข | 公共卫生营养"
    },
    {
        "id":4817,
        "name":"4819 (English Program)  :  Infectious Diseases | โรคติดเชื้อ | 传染病"
    },
    {
        "id":4818,
        "name":"4820 (English Program)  :  Aquatic Animal Diseases | โรคสัตว์น้ำ | 水生动物疾病"
    },
    {
        "id":4819,
        "name":"4821 (English Program)  :  Small Animal Practice | การฝึกปฏิบัติกับสัตว์ขนาดเล็ก | 小动物练习"
    },
    {
        "id":4820,
        "name":"4822 (English Program)  :  Swine Diseases And Herd Health Management | โรคสุกรและการจัดการสุขภาพฝูง | 猪疾病和猪群健康管理"
    },
    {
        "id":4821,
        "name":"4823 (English Program)  :  Dairy Herd Health Management | การจัดการสุขภาพฝูงโคนม | 奶牛群健康管理"
    },
    {
        "id":4822,
        "name":"4824 (English Program)  :  Earth Sciences | วิทยาศาสตร์โลก | 地球科学"
    },
    {
        "id":4823,
        "name":"4825 (English Program)  :  Metal Trade | การค้าโลหะ | 金属贸易"
    },
    {
        "id":4824,
        "name":"4826 (English Program)  :  Hematology | โลหิตวิทยา | 血液学"
    },
    {
        "id":4825,
        "name":"4827 (English Program)  :  Otolaryngology | โสตศอนาสิกวิทยา | 耳鼻喉科"
    },
    {
        "id":4826,
        "name":"4828 (English Program)  :  Audio-Visual Communications | การสื่อสารด้วยเสียงและภาพ | 视听通讯"
    },
    {
        "id":4827,
        "name":"4829 (English Program)  :  Thai Studies For Development | ไทยศึกษาเพื่อการพัฒนา | 泰国发展研究"
    },
    {
        "id":4828,
        "name":"4830 (English Program)  :  Electrical And Electronics | ไฟฟ้าและอิเล็กทรอนิกส์ | 电气电子"
    },
    {
        "id":4829,
        "name":"4831 (English Program)  :  Pomology | วิทยา | 果树学"
    },
    {
        "id":4830,
        "name":"4832 (English Program)  :  Furniture Technology And Design | เทคโนโลยีเฟอร์นิเจอร์และการออกแบบ | 家具技术与设计"
    },
    {
        "id":4831,
        "name":"4833 (English Program)  :  Furniture Technology | เทคโนโลยีเฟอร์นิเจอร์ | 家具技术"
    },
    {
        "id":4832,
        "name":"4834 (English Program)  :  Industrial Engineering Production | การผลิตทางวิศวกรรมอุตสาหการ | 工业工程生产"
    },
    {
        "id":4833,
        "name":"4835 (English Program)  :  Industrial Engineering Machine Tools | เครื่องมือเครื่องจักรวิศวกรรมอุตสาหการ | 工业工程机床"
    },
    {
        "id":4834,
        "name":"4836 (English Program)  :  Industrial Engineering Welding And Fabrication | วิศวกรรมอุตสาหการ การเชื่อมและการผลิต | 工业工程焊接与制造"
    },
    {
        "id":4835,
        "name":"4837 (English Program)  :  Industrial Engineering Production Drawing And Design | วิศวกรรมอุตสาหการ การเขียนแบบและการออกแบบการผลิต | 工业工程生产绘图设计"
    },
    {
        "id":4836,
        "name":"4838 (English Program)  :  International Transportation | การขนส่งระหว่างประเทศ | 国际运输"
    },
    {
        "id":4837,
        "name":"4839 (English Program)  :  International Trade | การค้าระหว่างประเทศ | 国际贸易"
    },
    {
        "id":4838,
        "name":"4840 (English Program)  :  Finance-Banking | การเงินการธนาคาร | 金融银行"
    },
    {
        "id":4839,
        "name":"4841 (English Program)  :  International Banking And Finance | การธนาคารและการเงินระหว่างประเทศ | 国际银行和金融"
    },
    {
        "id":4840,
        "name":"4842 (English Program)  :  Finance And Investment | การเงินและการลงทุน | 金融与投资"
    },
    {
        "id":4841,
        "name":"4843 (English Program)  :  E-Commerce Management | การจัดการอีคอมเมิร์ซ | 电子商务管理"
    },
    {
        "id":4842,
        "name":"4844 (English Program)  :  Culinary And Restaurant Management | การจัดการอาหารและร้านอาหาร | 烹饪和餐厅管理"
    },
    {
        "id":4843,
        "name":"4845 (English Program)  :  Social Welfare Project Management | การจัดการโครงการสวัสดิการสังคม | 社会福利项目管理"
    },
    {
        "id":4844,
        "name":"4846 (English Program)  :  Advertising Management | การจัดการโฆษณา | 广告管理"
    },
    {
        "id":4845,
        "name":"4847 (English Program)  :  Computer And Engineering Management | การจัดการคอมพิวเตอร์และวิศวกรรม | 计算机和工程管理"
    },
    {
        "id":4846,
        "name":"4848 (English Program)  :  Engineering And Technology Management | การจัดการทางวิศวกรรมและเทคโนโลยี | 工程与技术管理"
    },
    {
        "id":4847,
        "name":"4849 (English Program)  :  Computer And Information Technology Management | การจัดการเทคโนโลยีคอมพิวเตอร์และสารสนเทศ | 计算机和信息技术管理"
    },
    {
        "id":4848,
        "name":"4850 (English Program)  :  Telecommunication Management | การจัดการโทรคมนาคม | 电信管理"
    },
    {
        "id":4849,
        "name":"4851 (English Program)  :  Labour And Social Welfare Management | การจัดการแรงงานและสวัสดิการสังคม | 劳动与社会福利管理"
    },
    {
        "id":4850,
        "name":"4852 (English Program)  :  Computer Information Management | การจัดการข้อมูลคอมพิวเตอร์ | 计算机信息管理"
    },
    {
        "id":4851,
        "name":"4853 (English Program)  :  Health Management | การจัดการสุขภาพ | 健康管理"
    },
    {
        "id":4852,
        "name":"4854 (English Program)  :  Organization Management | การจัดการองค์กร | 组织管理"
    },
    {
        "id":4853,
        "name":"4855 (English Program)  :  Industrial Production Management | การจัดการการผลิตทางอุตสาหกรรม | 工业生产管理"
    },
    {
        "id":4854,
        "name":"4856 (English Program)  :  Industrial And Technology Management | การจัดการอุตสาหกรรมและเทคโนโลยี | 工业和技术管理"
    },
    {
        "id":4855,
        "name":"4857 (English Program)  :  Tourist And Services | การท่องเที่ยวและบริการ | 旅游和服务"
    },
    {
        "id":4856,
        "name":"4858 (English Program)  :  Hotel Management And Tourism | การจัดการโรงแรมและการท่องเที่ยว | 酒店管理和旅游"
    },
    {
        "id":4857,
        "name":"4859 (English Program)  :  Communication Management | การจัดการการสื่อสาร | 通讯管理"
    },
    {
        "id":4858,
        "name":"4860 (English Program)  :  Life Assurance | การประกันชีวิต | 人寿保险"
    },
    {
        "id":4859,
        "name":"4861 (English Program)  :  General Lines Insurance | การประกันภัยสายทั่วไป | 一般线路保险"
    },
    {
        "id":4860,
        "name":"4862 (English Program)  :  Public Relations And Advertising | การประชาสัมพันธ์และการโฆษณา | 公共关系和广告"
    },
    {
        "id":4861,
        "name":"4863 (English Program)  :  Oriental Medicine | ยาตะวันออก | 东方医学"
    },
    {
        "id":4862,
        "name":"4864 (English Program)  :  Motion Picture And Video | ภาพเคลื่อนไหวและวิดีโอ | 电影和视频"
    },
    {
        "id":4863,
        "name":"4865 (English Program)  :  Taxation | การเก็บภาษี | 税收"
    },
    {
        "id":4864,
        "name":"4866 (English Program)  :  English Language Teaching | การสอนภาษาอังกฤษ | 英语语言教学"
    },
    {
        "id":4865,
        "name":"4867 (English Program)  :  Computer Information | ข้อมูลคอมพิวเตอร์ | 电脑信息"
    },
    {
        "id":4866,
        "name":"4868 (English Program)  :  Communication | การสื่อสาร | 沟通"
    },
    {
        "id":4867,
        "name":"4869 (English Program)  :  Communication Media | สื่อการสื่อสาร | 通讯媒体"
    },
    {
        "id":4868,
        "name":"4870 (English Program)  :  Business Communication | การสื่อสารทางธุรกิจ | 商务沟通"
    },
    {
        "id":4869,
        "name":"4871 (English Program)  :  International Business Communication | การสื่อสารธุรกิจระหว่างประเทศ | 国际商务交流"
    },
    {
        "id":4870,
        "name":"4872 (English Program)  :  Interpersonal Communication | การสื่อสารระหว่างบุคคล | 人际沟通"
    },
    {
        "id":4871,
        "name":"4873 (English Program)  :  Conservetion And Revitalization Of Architecture And Community | การอนุรักษ์และการฟื้นฟูสถาปัตยกรรมและชุมชน | 建筑和社区的保护和振兴"
    },
    {
        "id":4872,
        "name":"4874 (English Program)  :  Urban And Rural Design | การออกแบบในเมืองและชนบท | 城乡设计"
    },
    {
        "id":4873,
        "name":"4875 (English Program)  :  Interior Decoration And Design | การตกแต่งภายในและการออกแบบ | 室内装饰与设计"
    },
    {
        "id":4874,
        "name":"4876 (English Program)  :  Product And Packaging Design | การออกแบบผลิตภัณฑ์และบรรจุภัณฑ์ | 产品及包装设计"
    },
    {
        "id":4875,
        "name":"4877 (English Program)  :  Computational Mathematics | คณิตศาสตร์เชิงคำนวณ | 计算数学"
    },
    {
        "id":4876,
        "name":"4878 (English Program)  :  Christian Studies | คริสเตียนศึกษา | 基督教研究"
    },
    {
        "id":4877,
        "name":"4879 (English Program)  :  Computer Games Multimedia | เกมคอมพิวเตอร์มัลติมีเดีย | 电脑游戏多媒体"
    },
    {
        "id":4878,
        "name":"4880 (English Program)  :  Computer-Aided Architectural Design | การออกแบบสถาปัตยกรรมโดยใช้คอมพิวเตอร์ช่วย | 计算机辅助建筑设计"
    },
    {
        "id":4879,
        "name":"4881 (English Program)  :  Computer And Statistics | คอมพิวเตอร์และสถิติ | 计算机和统计"
    },
    {
        "id":4880,
        "name":"4882 (English Program)  :  Computer Arts | ศิลปะคอมพิวเตอร์ | 电脑艺术"
    },
    {
        "id":4881,
        "name":"4883 (English Program)  :  Telecommunications And Computer Networks | การสื่อสารโทรคมนาคมและเครือข่ายคอมพิวเตอร์ | 电信和计算机网络"
    },
    {
        "id":4882,
        "name":"4884 (English Program)  :  China In World Economic System | จีนในระบบเศรษฐกิจโลก | 中国在世界经济体系中的地位"
    },
    {
        "id":4883,
        "name":"4885 (English Program)  :  Computer And Information Management | การจัดการคอมพิวเตอร์และข้อมูล | 计算机和信息管理"
    },
    {
        "id":4884,
        "name":"4886 (English Program)  :  Human Resources | ทรัพยากรมนุษย์ | 人力资源"
    },
    {
        "id":4885,
        "name":"4887 (English Program)  :  Sports Technology - Health And Management | เทคโนโลยีการกีฬา - สุขภาพและการจัดการ | 运动技术 - 健康与管理"
    },
    {
        "id":4886,
        "name":"4888 (English Program)  :  Industrial Biotechnology | เทคโนโลยีชีวภาพอุตสาหกรรม | 工业生物技术"
    },
    {
        "id":4887,
        "name":"4889 (English Program)  :  Social Technology | เทคโนโลยีทางสังคม | 社会技术"
    },
    {
        "id":4888,
        "name":"4890 (English Program)  :  Food Industrial Technology | เทคโนโลยีอุตสาหกรรมอาหาร | 食品工业技术"
    },
    {
        "id":4889,
        "name":"4891 (English Program)  :  Music Business | ธุรกิจดนตรี | 音乐事业"
    },
    {
        "id":4890,
        "name":"4892 (English Program)  :  Resources And Environment Policy And Management | นโยบายและการจัดการทรัพยากรและสิ่งแวดล้อม | 资源环境政策与管理"
    },
    {
        "id":4891,
        "name":"4893 (English Program)  :  Science Policy And Planning | นโยบายและการวางแผนวิทยาศาสตร์ | 科学政策和规划"
    },
    {
        "id":4892,
        "name":"4894 (English Program)  :  Business Communications | การสื่อสารทางธุรกิจ | 商业通讯"
    },
    {
        "id":4893,
        "name":"4895 (English Program)  :  Business Administration And Environment | การบริหารธุรกิจและสิ่งแวดล้อม | 工商管理与环境"
    },
    {
        "id":4894,
        "name":"4896 (English Program)  :  Business Administration Program For Executive | โปรแกรมการบริหารธุรกิจสำหรับผู้บริหาร | 行政人员工商管理课程"
    },
    {
        "id":4895,
        "name":"4897 (English Program)  :  Accounting | การบัญชี | 会计"
    },
    {
        "id":4896,
        "name":"4898 (English Program)  :  Financial Accounting | การบัญชีการเงิน | 财务会计"
    },
    {
        "id":4897,
        "name":"4899 (English Program)  :  Cost Accounting | การบัญชีต้นทุน | 成本核算"
    },
    {
        "id":4898,
        "name":"4900 (English Program)  :  Social History | ประวัติศาสตร์สังคม | 社会史"
    },
    {
        "id":4899,
        "name":"4901 (English Program)  :  Philosophy, Politics And Economics | ปรัชญา การเมือง และเศรษฐศาสตร์ | 哲学、政治和经济学"
    },
    {
        "id":4900,
        "name":"4902 (English Program)  :  Leadership In Society, Business And Politics | ความเป็นผู้นำในสังคม ธุรกิจ และการเมือง | 社会、商业和政治领导力"
    },
    {
        "id":4901,
        "name":"4903 (English Program)  :  Behaviorel And Social Sciences (Psychology) | พฤติกรรมและสังคมศาสตร์ (จิตวิทยา) | 行为与社会科学（心理学）"
    },
    {
        "id":4902,
        "name":"4904 (English Program)  :  Maritime Commerce | การค้าทางทะเล | 海事商务"
    },
    {
        "id":4903,
        "name":"4905 (English Program)  :  Electronic Commerce | พาณิชย์อิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":4904,
        "name":"4906 (English Program)  :  Business Chinese | ธุรกิจจีน | 商务汉语"
    },
    {
        "id":4905,
        "name":"4907 (English Program)  :  Japanese | ญี่ปุ่น | 日本人"
    },
    {
        "id":4906,
        "name":"4908 (English Program)  :  Thai | แบบไทย | 泰国"
    },
    {
        "id":4907,
        "name":"4909 (English Program)  :  English For Business And Technology | ภาษาอังกฤษเพื่อธุรกิจและเทคโนโลยี | 商业和技术英语"
    },
    {
        "id":4908,
        "name":"4910 (English Program)  :  English Business Communication | การสื่อสารทางธุรกิจภาษาอังกฤษ | 英语商务沟通"
    },
    {
        "id":4909,
        "name":"4911 (English Program)  :  Humanities | มนุษยศาสตร์ | 人文学科"
    },
    {
        "id":4910,
        "name":"4912 (English Program)  :  Multimedia | มัลติมีเดีย | 多媒体"
    },
    {
        "id":4911,
        "name":"4913 (English Program)  :  Information System For Managemant | ระบบสารสนเทศสำหรับผู้บริหาร | 管理信息系统"
    },
    {
        "id":4912,
        "name":"4914 (English Program)  :  Broadband Telecommunications | การสื่อสารโทรคมนาคมบรอดแบนด์ | 宽带电信"
    },
    {
        "id":4913,
        "name":"4915 (English Program)  :  Literature And Language (Writing English As A Profession) | วรรณกรรมและภาษา (การเขียนภาษาอังกฤษเป็นอาชีพ) | 文学与语言（以英语写作为职业）"
    },
    {
        "id":4914,
        "name":"4916 (English Program)  :  Music Science | วิทยาศาสตร์ดนตรี | 音乐科学"
    },
    {
        "id":4915,
        "name":"4917 (English Program)  :  Telecommunication Science | วิทยาศาสตร์โทรคมนาคม | 电信科学"
    },
    {
        "id":4916,
        "name":"4918 (English Program)  :  Computer Information Science | วิทยาการสารสนเทศคอมพิวเตอร์ | 计算机信息科学"
    },
    {
        "id":4917,
        "name":"4919 (English Program)  :  Basic Science | วิทยาศาสตร์ขั้นพื้นฐาน | 基础科学"
    },
    {
        "id":4918,
        "name":"4920 (English Program)  :  Power | พลัง | 力量"
    },
    {
        "id":4919,
        "name":"4921 (English Program)  :  Information Systems Engineering | วิศวกรรมระบบสารสนเทศ | 信息系统工程"
    },
    {
        "id":4920,
        "name":"4922 (English Program)  :  Logistics Engineering | วิศวกรรมโลจิสติกส์ | 物流工程"
    },
    {
        "id":4921,
        "name":"4923 (English Program)  :  Arts Program In Photography | โปรแกรมศิลปะในการถ่ายภาพ | 摄影艺术课程"
    },
    {
        "id":4922,
        "name":"4924 (English Program)  :  Basic Arts | ศิลปะขั้นพื้นฐาน | 基础艺术"
    },
    {
        "id":4923,
        "name":"4925 (English Program)  :  Social Welfare | สวัสดิการสังคม | 社会福利"
    },
    {
        "id":4924,
        "name":"4926 (English Program)  :  Social Science | สังคมศาสตร์ | 社会科学"
    },
    {
        "id":4925,
        "name":"4927 (English Program)  :  English For Business And Technology | ภาษาอังกฤษเพื่อธุรกิจและเทคโนโลยี | 商业和技术英语"
    },
    {
        "id":4926,
        "name":"4928 (English Program)  :  Power Electronics | เพาเวอร์อิเล็กทรอนิกส์ | 电力电子"
    },
    {
        "id":4927,
        "name":"4929 (English Program)  :  Service Industry | อุตสาหกรรมการบริการ | 服务业"
    },
    {
        "id":4928,
        "name":"4930 (English Program)  :  Network And Mobile Technology | เทคโนโลยีเครือข่ายและมือถือ | 网络和移动技术"
    },
    {
        "id":4929,
        "name":"4931 (English Program)  :  System Administration | การบริหารระบบ | 系统管理"
    },
    {
        "id":4930,
        "name":"4932 (English Program)  :  Digital Arts | ศิลปะดิจิทัล | 数字艺术"
    },
    {
        "id":4931,
        "name":"4933 (English Program)  :  Facility Management | การจัดการสิ่งอำนวยความสะดวก | 设施管理"
    },
    {
        "id":4932,
        "name":"4934 (English Program)  :  Community Nurse Practitioner | ผู้ประกอบวิชาชีพพยาบาลชุมชน | 社区执业护士"
    },
    {
        "id":4933,
        "name":"4935 (English Program)  :  Project Management And Evaluation | การจัดการและการประเมินโครงการ | 项目管理和评估"
    },
    {
        "id":4934,
        "name":"4936 (English Program)  :  Biodiversity Conservation And Ecotourism | การอนุรักษ์ความหลากหลายทางชีวภาพและการท่องเที่ยวเชิงนิเวศ | 生物多样性保护和生态旅游"
    },
    {
        "id":4935,
        "name":"4937 (English Program)  :  Innovative Media Design | การออกแบบสื่อที่เป็นนวัตกรรมใหม่ | 创新媒体设计"
    },
    {
        "id":4936,
        "name":"4938 (English Program)  :  Space Technology And Geo-Informatics | เทคโนโลยีอวกาศและภูมิสารสนเทศ | 空间技术和地理信息学"
    },
    {
        "id":4937,
        "name":"4939 (English Program)  :  Information Sciences For Communication | วิทยาการสารสนเทศเพื่อการสื่อสาร | 通信信息科学"
    },
    {
        "id":4938,
        "name":"4940 (English Program)  :  Production Design | การออกแบบการผลิต | 生产设计"
    },
    {
        "id":4939,
        "name":"4941 (English Program)  :  Computer Information Systems - Information Systems Management | ระบบสารสนเทศคอมพิวเตอร์ - การจัดการระบบสารสนเทศ | 计算机信息系统 - 信息系统管理"
    },
    {
        "id":4940,
        "name":"4942 (English Program)  :  System And Network Administration | การบริหารระบบและเครือข่าย | 系统和网络管理"
    },
    {
        "id":4941,
        "name":"4943 (English Program)  :  Computer Graphics And Multimedia | คอมพิวเตอร์กราฟิกและมัลติมีเดีย | 计算机图形学和多媒体"
    },
    {
        "id":4942,
        "name":"4944 (English Program)  :  Law Of Intellectral Property | กฎหมายว่าด้วยทรัพย์สินทางปัญญา | 知识产权法"
    },
    {
        "id":4943,
        "name":"4945 (English Program)  :  Law Of International Business And Electronic Transactions | กฎหมายว่าด้วยธุรกิจระหว่างประเทศและธุรกรรมทางอิเล็กทรอนิกส์ | 国际商业和电子交易法"
    },
    {
        "id":4944,
        "name":"4946 (English Program)  :  Medical & Surgical Nurs | พยาบาลการแพทย์และศัลยกรรม | 医疗和外科护士"
    },
    {
        "id":4945,
        "name":"4947 (English Program)  :  Media Design | การออกแบบสื่อ | 媒体设计"
    },
    {
        "id":4946,
        "name":"4948 (English Program)  :  Biodiversity And Ethnobiology | ความหลากหลายทางชีวภาพและชาติพันธุ์วิทยา | 生物多样性和民族生物学"
    },
    {
        "id":4947,
        "name":"4949 (English Program)  :  Indust & Organiz Phycho | อุตสาหกรรมและองค์กร Phycho | 工业与组织 Phycho"
    },
    {
        "id":4948,
        "name":"4950 (English Program)  :  Restorative Dentistry | ทันตกรรมบูรณะ | 修复牙科"
    },
    {
        "id":4949,
        "name":"4951 (English Program)  :  Petroleum Geoscience | ธรณีศาสตร์ปิโตรเลียม | 石油地球科学"
    },
    {
        "id":4950,
        "name":"4952 (English Program)  :  Library & Information Sci | ห้องสมุดและนิเทศศาสตร์ | 图书馆与信息 Sci"
    },
    {
        "id":4951,
        "name":"4953 (English Program)  :  Geoinformatics | ภูมิสารสนเทศ | 地理信息学"
    },
    {
        "id":4952,
        "name":"4954 (English Program)  :  Movement And Exercise Sciences | วิทยาศาสตร์การเคลื่อนไหวและการออกกำลังกาย | 运动和锻炼科学"
    },
    {
        "id":4953,
        "name":"4955 (English Program)  :  Obstetrics And Gynecology | สูติศาสตร์และนรีเวชวิทยา | 妇产科"
    },
    {
        "id":4954,
        "name":"4956 (English Program)  :  Industrial Education | การศึกษาอุตสาหกรรม | 工业教育"
    },
    {
        "id":4955,
        "name":"4957 (English Program)  :  Theology | เทววิทยา | 神学"
    },
    {
        "id":4956,
        "name":"4958 (English Program)  :  Diploma In Medical Science(Radiological Technology) | อนุปริญญาสาขาวิทยาศาสตร์การแพทย์(เทคโนโลยีรังสี) | 医学文凭（放射技术）"
    },
    {
        "id":4957,
        "name":"4959 (English Program)  :  Diploma In Medical Science(Radiological Technology)(Ad Hoc) | อนุปริญญาสาขาวิทยาศาสตร์การแพทย์(เทคโนโลยีรังสี)(เฉพาะกิจ) | 医学文凭（放射技术）（特设）"
    },
    {
        "id":4958,
        "name":"4960 (English Program)  :  Cert.(Music) | ใบรับรอง(ดนตรี) | 证书（音乐）"
    },
    {
        "id":4959,
        "name":"4961 (English Program)  :  Public Health Science | วิทยาศาสตร์สาธารณสุข | 公共卫生科学"
    },
    {
        "id":4960,
        "name":"4962 (English Program)  :  Information & Communication Technology (International Programme) | เทคโนโลยีสารสนเทศและการสื่อสาร (หลักสูตรนานาชาติ) | 信息与通信技术（国际项目）"
    },
    {
        "id":4961,
        "name":"4963 (English Program)  :  Geoscience | ธรณีศาสตร์ | 地球科学"
    },
    {
        "id":4962,
        "name":"4964 (English Program)  :  Thai And Oriental Music | ดนตรีไทยและดนตรีตะวันออก | 泰国和东方音乐"
    },
    {
        "id":4963,
        "name":"4965 (English Program)  :  Music Entertainment | ความบันเทิงทางดนตรี | 音乐娱乐"
    },
    {
        "id":4964,
        "name":"4966 (English Program)  :  General Information Science | วิทยาศาสตร์สารสนเทศทั่วไป | 普通信息科学"
    },
    {
        "id":4965,
        "name":"4967 (English Program)  :  Office Information Science | วิทยาการสารสนเทศสำนักงาน | 办公信息科学"
    },
    {
        "id":4966,
        "name":"4968 (English Program)  :  English For Specific Careers | ภาษาอังกฤษสำหรับอาชีพเฉพาะ | 特定职业英语"
    },
    {
        "id":4967,
        "name":"4969 (English Program)  :  Information Work | งานข้อมูล | 信息工作"
    },
    {
        "id":4968,
        "name":"4970 (English Program)  :  Hotel And Restaurant Studies | การศึกษาการโรงแรมและร้านอาหาร | 酒店和餐厅研究"
    },
    {
        "id":4969,
        "name":"4971 (English Program)  :  International Relations And Comparative Governments And Politics | ความสัมพันธ์ระหว่างประเทศและรัฐบาลเปรียบเทียบและการเมือง | 国际关系以及比较政府和政治"
    },
    {
        "id":4970,
        "name":"4972 (English Program)  :  Political Communication | การสื่อสารทางการเมือง | 政治传播"
    },
    {
        "id":4971,
        "name":"4973 (English Program)  :  Tourism And Entertainment | การท่องเที่ยวและความบันเทิง | 旅游娱乐"
    },
    {
        "id":4972,
        "name":"4974 (English Program)  :  Hospitality Industry Management | การจัดการอุตสาหกรรมการบริการ | 酒店业管理"
    },
    {
        "id":4973,
        "name":"4975 (English Program)  :  Health Care Service | บริการดูแลสุขภาพ | 医疗保健服务"
    },
    {
        "id":4974,
        "name":"4976 (English Program)  :  Advanced Software Technology | เทคโนโลยีซอฟต์แวร์ขั้นสูง | 先进的软件技术"
    },
    {
        "id":4975,
        "name":"4977 (English Program)  :  Advanced Information Technology | เทคโนโลยีสารสนเทศขั้นสูง | 先进的信息技术"
    },
    {
        "id":4976,
        "name":"4978 (English Program)  :  Health Providers | ผู้ให้บริการด้านสุขภาพ | 健康提供者"
    },
    {
        "id":4977,
        "name":"4979 (English Program)  :  Product Development | การพัฒนาผลิตภัณฑ์ | 产品开发"
    },
    {
        "id":4978,
        "name":"4980 (English Program)  :  Construction Project Management | การจัดการโครงการก่อสร้าง | 建设项目管理"
    },
    {
        "id":4979,
        "name":"4981 (English Program)  :  Business Administration In Hospitality Management | การบริหารธุรกิจในการจัดการการบริการ | 酒店管理中的工商管理"
    },
    {
        "id":4980,
        "name":"4982 (English Program)  :  Lifelong Education | การศึกษาตลอดชีวิต | 终身教育"
    },
    {
        "id":4981,
        "name":"4983 (English Program)  :  Lifelong Education And Human Development | การศึกษาตลอดชีวิตและการพัฒนามนุษย์ | 终身教育与人类发展"
    },
    {
        "id":4982,
        "name":"4984 (English Program)  :  Performance | ผลงาน | 表现"
    },
    {
        "id":4983,
        "name":"4985 (English Program)  :  Fine Arts In Painting Conservation | วิจิตรศิลป์ในการอนุรักษ์จิตรกรรม | 绘画保护中的美术"
    },
    {
        "id":4984,
        "name":"4986 (English Program)  :  Multimedia Design | การออกแบบมัลติมีเดีย | 多媒体设计"
    },
    {
        "id":4985,
        "name":"4987 (English Program)  :  Khmer Studies | เขมรศึกษา | 高棉研究"
    },
    {
        "id":4986,
        "name":"4988 (English Program)  :  Mathematics And Information Technology | คณิตศาสตร์และเทคโนโลยีสารสนเทศ | 数学与信息技术"
    },
    {
        "id":4987,
        "name":"4989 (English Program)  :  Chemical Studies | การศึกษาทางเคมี | 化学研究"
    },
    {
        "id":4988,
        "name":"4990 (English Program)  :  Special Education Psychology | จิตวิทยาการศึกษาพิเศษ | 特殊教育心理学"
    },
    {
        "id":4989,
        "name":"4991 (English Program)  :  Commercial Music | เพลงเชิงพาณิชย์ | 商业音乐"
    },
    {
        "id":4990,
        "name":"4992 (English Program)  :  Information Technology For Design | เทคโนโลยีสารสนเทศเพื่อการออกแบบ | 设计信息技术"
    },
    {
        "id":4991,
        "name":"4993 (English Program)  :  Historical Studies | การศึกษาประวัติศาสตร์ | 历史研究"
    },
    {
        "id":4992,
        "name":"4994 (English Program)  :  Pharmaceutical | เภสัชกรรม | 医药"
    },
    {
        "id":4993,
        "name":"4995 (English Program)  :  Social And Health System Management | การจัดการระบบสังคมและสุขภาพ | 社会和卫生系统管理"
    },
    {
        "id":4994,
        "name":"4996 (English Program)  :  Vernacular Architecture | สถาปัตยกรรมพื้นถิ่น | 乡土建筑"
    },
    {
        "id":4995,
        "name":"4997 (English Program)  :  Asian Studies | เอเชียศึกษา | 亚洲研究"
    },
    {
        "id":4996,
        "name":"4998 (English Program)  :  National Of Art (English-Chinese) | ศิลปะแห่งชาติ (ภาษาอังกฤษ - จีน) | 艺术国家（英汉）"
    },
    {
        "id":4997,
        "name":"4999 (English Program)  :  National Of Science (Chinese Medical) | วิทยาศาสตร์แห่งชาติ (การแพทย์แผนจีน) | 科学国家（中医）"
    },
    {
        "id":4998,
        "name":"5000 (English Program)  :  Scriptural Languages And Literature | ภาษาและวรรณกรรมในพระคัมภีร์ | 圣经语言和文学"
    },
    {
        "id":4999,
        "name":"5001 (English Program)  :  Integral Development | การพัฒนาแบบครบวงจร | 整体发展"
    },
    {
        "id":5000,
        "name":"5002 (English Program)  :  Pharmaceutical And Natural Product | เภสัชกรรมและผลิตภัณฑ์จากธรรมชาติ | 药物和天然产品"
    },
    {
        "id":5001,
        "name":"5003 (English Program)  :  Vietnamese Language And Liturature | ภาษาและวรรณคดีเวียดนาม | 越南语言和文学"
    },
    {
        "id":5002,
        "name":"5004 (English Program)  :  Project Management Of Community Fund | การบริหารจัดการโครงการกองทุนชุมชน | 社区基金项目管理"
    },
    {
        "id":5003,
        "name":"5005 (English Program)  :  Agricultural Information Technology And Rural Development | เทคโนโลยีสารสนเทศการเกษตรและการพัฒนาชนบท | 农业信息技术与农村发展"
    },
    {
        "id":5004,
        "name":"5006 (English Program)  :  Property Valuation Management | การจัดการประเมินมูลค่าทรัพย์สิน | 物业估价管理"
    },
    {
        "id":5005,
        "name":"5007 (English Program)  :  Integrated Marketing Communications | การสื่อสารการตลาดแบบบูรณาการ | 整合营销传播"
    },
    {
        "id":5006,
        "name":"5008 (English Program)  :  Property And Casualty Insurance | การประกันภัยทรัพย์สินและวินาศภัย | 财产和意外伤害保险"
    },
    {
        "id":5007,
        "name":"5009 (English Program)  :  Marine And Aviation Insurance | การประกันภัยทางทะเลและการบิน | 海事及航空保险"
    },
    {
        "id":5008,
        "name":"5010 (English Program)  :  Personal Lines Insurance | การประกันภัยส่วนบุคคล | 个人保险"
    },
    {
        "id":5009,
        "name":"5011 (English Program)  :  Commercial Lines Insurance | การประกันภัยเชิงพาณิชย์ | 商业线路保险"
    },
    {
        "id":5010,
        "name":"5012 (English Program)  :  Insurance Management | การจัดการประกันภัย | 保险管理"
    },
    {
        "id":5011,
        "name":"5013 (English Program)  :  Business German | ธุรกิจเยอรมัน | 商务德语"
    },
    {
        "id":5012,
        "name":"5014 (English Program)  :  Contemporary Music Writing And Production | การเขียนและการผลิตเพลงร่วมสมัย | 当代音乐创作和制作"
    },
    {
        "id":5013,
        "name":"5015 (English Program)  :  Data Management And Analysis | การจัดการและการวิเคราะห์ข้อมูล | 数据管理和分析"
    },
    {
        "id":5014,
        "name":"5016 (English Program)  :  Maritime Industrial Management | การจัดการอุตสาหกรรมทางทะเล | 海事工业管理"
    },
    {
        "id":5015,
        "name":"5017 (English Program)  :  Art And Cultural Administration | การบริหารศิลปะและวัฒนธรรม | 艺术与文化行政"
    },
    {
        "id":5016,
        "name":"5018 (English Program)  :  Family Nurse Practitioner | ผู้ปฏิบัติการพยาบาลครอบครัว | 家庭执业护士"
    },
    {
        "id":5017,
        "name":"5019 (English Program)  :  Education And Social Development | การศึกษาและการพัฒนาสังคม | 教育与社会发展"
    },
    {
        "id":5018,
        "name":"5020 (English Program)  :  Music Education Teaching | การสอนดนตรีศึกษา | 音乐教育教学"
    },
    {
        "id":5019,
        "name":"5021 (English Program)  :  Chinese Language Teaching | การสอนภาษาจีน | 汉语教学"
    },
    {
        "id":5020,
        "name":"5022 (English Program)  :  Japanese Language Teaching | การสอนภาษาญี่ปุ่น | 日语教学"
    },
    {
        "id":5021,
        "name":"5023 (English Program)  :  Social Education Religion And Culture Teaching | สังคมศึกษา การสอนศาสนาและวัฒนธรรม | 社会教育宗教文化教学"
    },
    {
        "id":5022,
        "name":"5024 (English Program)  :  Health And Physical Education Teaching | การสอนสุขศึกษาและพลศึกษา | 健康与体育教学"
    },
    {
        "id":5023,
        "name":"5025 (English Program)  :  Geography And Geo-Informatics | ภูมิศาสตร์และภูมิศาสตร์สารสนเทศ | 地理和地理信息学"
    },
    {
        "id":5024,
        "name":"5026 (English Program)  :  Technology Computer Application In Architecture | การประยุกต์ใช้เทคโนโลยีคอมพิวเตอร์ในงานสถาปัตยกรรม | 计算机技术在建筑中的应用"
    },
    {
        "id":5025,
        "name":"5027 (English Program)  :  Hotel And Lodging Business Management | การจัดการธุรกิจโรงแรมและที่พัก | 酒店及住宿业务管理"
    },
    {
        "id":5026,
        "name":"5028 (English Program)  :  Mathematics And Educational Measurement | คณิตศาสตร์และการวัดผลการศึกษา | 数学与教育测量"
    },
    {
        "id":5027,
        "name":"5029 (English Program)  :  Cenima And Computer Technology | ภาพยนตร์และเทคโนโลยีคอมพิวเตอร์ | Cenima 和计算机技术"
    },
    {
        "id":5028,
        "name":"5030 (English Program)  :  Agricultural Information | ข้อมูลการเกษตร | 农业信息"
    },
    {
        "id":5029,
        "name":"5031 (English Program)  :  Geo-Information Technology | เทคโนโลยีสารสนเทศทางภูมิศาสตร์ | 地理信息技术"
    },
    {
        "id":5030,
        "name":"5032 (English Program)  :  Political Economy And Governance | เศรษฐศาสตร์การเมืองและการกำกับดูแล | 政治经济与治理"
    },
    {
        "id":5031,
        "name":"5033 (English Program)  :  Security Resurges Management | การจัดการความมั่นคงปลอดภัย | 安全重振管理"
    },
    {
        "id":5032,
        "name":"5034 (English Program)  :  Small And Medium Enterprises Management | การจัดการวิสาหกิจขนาดกลางและขนาดย่อม | 中小企业管理"
    },
    {
        "id":5033,
        "name":"5035 (English Program)  :  Business Finance | การเงินธุรกิจ | 商业金融"
    },
    {
        "id":5034,
        "name":"5036 (English Program)  :  Thai For Communication For Foreigners | ภาษาไทยเพื่อการสื่อสารสำหรับชาวต่างชาติ | 外国人泰语交流课程"
    },
    {
        "id":5035,
        "name":"5037 (English Program)  :  Vipassana Meditation | การทำสมาธิวิปัสสนา | 内观禅修"
    },
    {
        "id":5036,
        "name":"5038 (English Program)  :  Mahayana Studies | การศึกษามหายาน | 大乘研究"
    },
    {
        "id":5037,
        "name":"5039 (English Program)  :  Pali And Sanskrit Language And Literature | ภาษาและวรรณคดีภาษาบาลีและสันสกฤต | 巴利文和梵文语言和文学"
    },
    {
        "id":5038,
        "name":"5040 (English Program)  :  Buddhist Philosophy | ปรัชญาพุทธศาสนา | 佛教哲学"
    },
    {
        "id":5039,
        "name":"5041 (English Program)  :  Information And Communication Technology Management | การจัดการเทคโนโลยีสารสนเทศและการสื่อสาร | 信息和通信技术管理"
    },
    {
        "id":5040,
        "name":"5042 (English Program)  :  Communication Business Management | การจัดการธุรกิจการสื่อสาร | 通讯业务管理"
    },
    {
        "id":5041,
        "name":"5043 (English Program)  :  Entertainment Business Management | การจัดการธุรกิจบันเทิง | 娱乐业务管理"
    },
    {
        "id":5042,
        "name":"5044 (English Program)  :  Logistics Management | การจัดการโลจิสติกส์ | 物流管理"
    },
    {
        "id":5043,
        "name":"5045 (English Program)  :  Food Industry Management | การจัดการอุตสาหกรรมอาหาร | 食品工业管理"
    },
    {
        "id":5044,
        "name":"5046 (English Program)  :  Financial Mathematics | คณิตศาสตร์การเงิน | 金融数学"
    },
    {
        "id":5045,
        "name":"5047 (English Program)  :  Thai Language For Business Communication | ภาษาไทยเพื่อการสื่อสารทางธุรกิจ | 泰语商务交流"
    },
    {
        "id":5046,
        "name":"5048 (English Program)  :  International Business Economics | เศรษฐศาสตร์ธุรกิจระหว่างประเทศ | 国际商业经济学"
    },
    {
        "id":5047,
        "name":"5049 (English Program)  :  Informatics | สารสนเทศ | 信息学"
    },
    {
        "id":5048,
        "name":"5050 (English Program)  :  Health Services Management | การจัดการบริการด้านสุขภาพ | 卫生服务管理"
    },
    {
        "id":5049,
        "name":"5051 (English Program)  :  English As A Second Language | ภาษาอังกฤษเป็นภาษาที่สอง | 英语作为第二语言"
    },
    {
        "id":5050,
        "name":"5052 (English Program)  :  Mass Communication Management | การจัดการสื่อสารมวลชน | 大众传播管理"
    },
    {
        "id":5051,
        "name":"5053 (English Program)  :  Industrial Science | วิทยาศาสตร์อุตสาหกรรม | 工业科学"
    },
    {
        "id":5052,
        "name":"5054 (English Program)  :  Multimedia Journalism | วารสารศาสตร์มัลติมีเดีย | 多媒体新闻"
    },
    {
        "id":5053,
        "name":"5055 (English Program)  :  Thai Language For Business | ภาษาไทยเพื่อธุรกิจ | 商务泰语"
    },
    {
        "id":5054,
        "name":"5057 (English Program)  :  Computer Animation | แอนิเมชันคอมพิวเตอร์ | 电脑动画"
    },
    {
        "id":5055,
        "name":"5058 (English Program)  :  Industrial Food System | ระบบอาหารอุตสาหกรรม | 工业食品系统"
    },
    {
        "id":5056,
        "name":"5059 (English Program)  :  English And Translation | ภาษาอังกฤษและการแปล | 英语和翻译"
    },
    {
        "id":5057,
        "name":"5060 (English Program)  :  Business Public Relations | ประชาสัมพันธ์ธุรกิจ | 商业公共关系"
    },
    {
        "id":5058,
        "name":"5061 (English Program)  :  Hi-Tech Management | การจัดการไฮเทค | 高科技管理"
    },
    {
        "id":5059,
        "name":"5062 (English Program)  :  Chiness Business | ธุรกิจจีน | 中国业务"
    },
    {
        "id":5060,
        "name":"5063 (English Program)  :  E-Office Management | การจัดการสำนักงานอิเล็กทรอนิกส์ | 电子办公管理"
    },
    {
        "id":5061,
        "name":"5064 (English Program)  :  Measurement And Research | การวัดและการวิจัย | 测量与研究"
    },
    {
        "id":5062,
        "name":"5065 (English Program)  :  Construction Industrial Technology | เทคโนโลยีอุตสาหกรรมก่อสร้าง | 建筑工业技术"
    },
    {
        "id":5063,
        "name":"5066 (English Program)  :  Industrial Technology Architecture | สถาปัตยกรรมเทคโนโลยีอุตสาหกรรม | 工业技术架构"
    },
    {
        "id":5064,
        "name":"5067 (English Program)  :  Space Technology Management | การจัดการเทคโนโลยีอวกาศ | 空间技术管理"
    },
    {
        "id":5065,
        "name":"5068 (English Program)  :  Risk Management | การจัดการความเสี่ยง | 风险管理"
    },
    {
        "id":5066,
        "name":"5069 (English Program)  :  Development Social Science | การพัฒนาสังคมศาสตร์ | 发展社会科学"
    },
    {
        "id":5067,
        "name":"5070 (English Program)  :  Teaching French | การสอนภาษาฝรั่งเศส | 法语教学"
    },
    {
        "id":5068,
        "name":"5071 (English Program)  :  Teaching Science-Chemistry | การสอนวิทยาศาสตร์-เคมี | 教授科学化学"
    },
    {
        "id":5069,
        "name":"5072 (English Program)  :  Teaching Science-Biology | การสอนวิทยาศาสตร์-ชีววิทยา | 教授科学生物学"
    },
    {
        "id":5070,
        "name":"5073 (English Program)  :  Teaching Science-Physics | การสอนวิทยาศาสตร์-ฟิสิกส์ | 教授科学物理"
    },
    {
        "id":5071,
        "name":"5074 (English Program)  :  Teaching Science-Computer Science | การสอนวิทยาศาสตร์-วิทยาการคอมพิวเตอร์ | 科学教学-计算机科学"
    },
    {
        "id":5072,
        "name":"5075 (English Program)  :  Teaching Science-General Science | การสอนวิทยาศาสตร์-วิทยาศาสตร์ทั่วไป | 教授科学-普通科学"
    },
    {
        "id":5073,
        "name":"5076 (English Program)  :  Teaching Science-Environmental Science | การสอนวิทยาศาสตร์-วิทยาศาสตร์สิ่งแวดล้อม | 科学教学-环境科学"
    },
    {
        "id":5074,
        "name":"5077 (English Program)  :  Vocational Education Development | การพัฒนาอาชีวศึกษา | 职业教育发展"
    },
    {
        "id":5075,
        "name":"5078 (English Program)  :  Aviation Technology | เทคโนโลยีการบิน | 航空技术"
    },
    {
        "id":5076,
        "name":"5079 (English Program)  :  Aerospace Engineering And Business Administration | วิศวกรรมการบินและการบริหารธุรกิจ | 航空航天工程和工商管理"
    },
    {
        "id":5077,
        "name":"5080 (English Program)  :  Software And Knowledge Engineering | วิศวกรรมซอฟต์แวร์และความรู้ | 软件和知识工程"
    },
    {
        "id":5078,
        "name":"5081 (English Program)  :  Civil Engineering-Water Resources | วิศวกรรมโยธา-ทรัพยากรน้ำ | 土木工程-水资源"
    },
    {
        "id":5079,
        "name":"5082 (English Program)  :  Industrial Production Technology | เทคโนโลยีการผลิตทางอุตสาหกรรม | 工业生产技术"
    },
    {
        "id":5080,
        "name":"5083 (English Program)  :  Mechanical And Manufacturing Engineering | วิศวกรรมเครื่องกลและการผลิต | 机械与制造工程"
    },
    {
        "id":5081,
        "name":"5084 (English Program)  :  Civil And Environmental Engineering | วิศวกรรมโยธาและสิ่งแวดล้อม | 土木与环境工程"
    },
    {
        "id":5082,
        "name":"5085 (English Program)  :  Fire Protection Engineering | วิศวกรรมป้องกันอัคคีภัย | 消防工程"
    },
    {
        "id":5083,
        "name":"5086 (English Program)  :  Techmology And Environment Management | การจัดการเทคโนโลยีและสิ่งแวดล้อม | 技术与环境管理"
    },
    {
        "id":5084,
        "name":"5087 (English Program)  :  Plant Breeding | การปรับปรุงพันธุ์พืช | 植物育种"
    },
    {
        "id":5085,
        "name":"5088 (English Program)  :  Animal Nutrition And Feed Technology | โภชนาการสัตว์และเทคโนโลยีอาหารสัตว์ | 动物营养和饲料技术"
    },
    {
        "id":5086,
        "name":"5089 (English Program)  :  Food Safety | ความปลอดภัยของอาหาร | 食品安全"
    },
    {
        "id":5087,
        "name":"5090 (English Program)  :  Tropical Agriculture And International Trade | การเกษตรเขตร้อนและการค้าระหว่างประเทศ | 热带农业和国际贸易"
    },
    {
        "id":5088,
        "name":"5091 (English Program)  :  Sustainable Agriculture | การเกษตรที่ยั่งยืน | 可持续农业"
    },
    {
        "id":5089,
        "name":"5092 (English Program)  :  Agricultural Information Technology | เทคโนโลยีสารสนเทศการเกษตร | 农业信息技术"
    },
    {
        "id":5090,
        "name":"5093 (English Program)  :  Agricultural Research And Development | การวิจัยและพัฒนาการเกษตร | 农业研究与开发"
    },
    {
        "id":5091,
        "name":"5094 (English Program)  :  Agricultural Science | วิทยาศาสตร์การเกษตร | 农业科学"
    },
    {
        "id":5092,
        "name":"5095 (English Program)  :  Watershed And Environmental Management | การจัดการลุ่มน้ำและสิ่งแวดล้อม | 流域和环境管理"
    },
    {
        "id":5093,
        "name":"5096 (English Program)  :  Forestry-Social Forestry And Sociology And Anthropology | ป่าไม้-สังคมป่าไม้และสังคมวิทยาและมานุษยวิทยา | 林业-社会林业与社会学和人类学"
    },
    {
        "id":5094,
        "name":"5097 (English Program)  :  Building Innovation | นวัตกรรมอาคาร | 建设创新"
    },
    {
        "id":5095,
        "name":"5098 (English Program)  :  Veterinary Microbiology | จุลชีววิทยาทางสัตวแพทย์ | 兽医微生物学"
    },
    {
        "id":5096,
        "name":"5099 (English Program)  :  Veterinary Parasitology | ปรสิตวิทยาทางสัตวแพทย์ | 兽医寄生虫学"
    },
    {
        "id":5097,
        "name":"5100 (English Program)  :  Veterinary Pharmacology And Toxicology | เภสัชวิทยาและพิษวิทยาทางสัตวแพทย์ | 兽医药理学和毒理学"
    },
    {
        "id":5098,
        "name":"5101 (English Program)  :  Optology | ออพโทโลจี | 眼科"
    },
    {
        "id":5099,
        "name":"5102 (English Program)  :  Communication Arts New Media | ศิลปะการสื่อสารสื่อใหม่ | 传播艺术新媒体"
    },
    {
        "id":5100,
        "name":"5103 (English Program)  :  Ecotourism | การท่องเที่ยวเชิงนิเวศ | 生态旅游"
    },
    {
        "id":5101,
        "name":"5104 (English Program)  :  Theater Arts | ศิลปะการละคร | 戏剧艺术"
    },
    {
        "id":5102,
        "name":"5105 (English Program)  :  Informatics Mathematics | คณิตศาสตร์สารสนเทศ | 信息学 数学"
    },
    {
        "id":5103,
        "name":"5106 (English Program)  :  Safety Technology And Occupational Health | เทคโนโลยีความปลอดภัยและอาชีวอนามัย | 安全技术与职业健康"
    },
    {
        "id":5104,
        "name":"5107 (English Program)  :  Building Management | การจัดการอาคาร | 楼宇管理"
    },
    {
        "id":5105,
        "name":"5108 (English Program)  :  Grathic And Multimedia Design | การออกแบบกราฟิกและมัลติมีเดีย | 图形和多媒体设计"
    },
    {
        "id":5106,
        "name":"5109 (English Program)  :  Auto Machanics | เครื่องจักรกลอัตโนมัติ | 汽车机械"
    },
    {
        "id":5107,
        "name":"5110 (English Program)  :  Mechanical Engineer | วิศวกรเครื่องกล | 机械工程师"
    },
    {
        "id":5108,
        "name":"5111 (English Program)  :  Metal Work | งานโลหะ | 金属加工"
    },
    {
        "id":5109,
        "name":"5112 (English Program)  :  Building Construction Technology | เทคโนโลยีการก่อสร้างอาคาร | 建筑施工技术"
    },
    {
        "id":5110,
        "name":"5113 (English Program)  :  Selling | ขาย | 销售"
    },
    {
        "id":5111,
        "name":"5114 (English Program)  :  Secretarial Studies | การศึกษาด้านเลขานุการ | 秘书研究"
    },
    {
        "id":5112,
        "name":"5115 (English Program)  :  Metal Fabrication | การผลิตโลหะ | 金属加工"
    },
    {
        "id":5113,
        "name":"5116 (English Program)  :  Agriculture Extention And Communication | การส่งเสริมการเกษตรและการสื่อสาร | 农业推广与交流"
    },
    {
        "id":5114,
        "name":"5117 (English Program)  :  Community Design | การออกแบบชุมชน | 社区设计"
    },
    {
        "id":5115,
        "name":"5118 (English Program)  :  Agricultural Technology Management | การจัดการเทคโนโลยีการเกษตร | 农业技术管理"
    },
    {
        "id":5116,
        "name":"5119 (English Program)  :  Health Tecnology Management | การจัดการเทคโนโลยีสุขภาพ | 健康技术管理"
    },
    {
        "id":5117,
        "name":"5120 (English Program)  :  General Home | บ้านทั่วไป | 一般家居"
    },
    {
        "id":5118,
        "name":"5121 (English Program)  :  Trade And Industrial Education (Construction) | การศึกษาการค้าและอุตสาหกรรม (การก่อสร้าง) | 贸易和工业教育（建筑）"
    },
    {
        "id":5119,
        "name":"5122 (English Program)  :  Trade And Industrial Education (Electricity) | การค้าและการศึกษาอุตสาหกรรม (ไฟฟ้า) | 贸易和工业教育（电力）"
    },
    {
        "id":5120,
        "name":"5123 (English Program)  :  Trade And Industrial Education (Auto-Mechanics) | การศึกษาการค้าและอุตสาหกรรม (กลศาสตร์อัตโนมัติ) | 贸易和工业教育（汽车机械）"
    },
    {
        "id":5121,
        "name":"5124 (English Program)  :  Trade And Industrial Education (Metal) | การค้าและการศึกษาอุตสาหกรรม (โลหะ) | 贸易和工业教育（金属）"
    },
    {
        "id":5122,
        "name":"5125 (English Program)  :  Trade And Industrial Education (Architecture) | การศึกษาการค้าและอุตสาหกรรม (สถาปัตยกรรม) | 贸易和工业教育（建筑）"
    },
    {
        "id":5123,
        "name":"5126 (English Program)  :  Fine & Applied Arts (Communication Arts) | วิจิตรศิลป์และศิลปะประยุกต์ (ศิลปะการสื่อสาร) | 美术与应用艺术（传播艺术）"
    },
    {
        "id":5124,
        "name":"5127 (English Program)  :  Business Administration (Quality Management) | การบริหารธุรกิจ (การจัดการคุณภาพ) | 工商管理（质量管理）"
    },
    {
        "id":5125,
        "name":"5128 (English Program)  :  Business Administration (Marketing) | การบริหารธุรกิจ (การตลาด) | 工商管理（市场营销）"
    },
    {
        "id":5126,
        "name":"5129 (English Program)  :  Business Administration (Human Resource Management) | การบริหารธุรกิจ (การจัดการทรัพยากรมนุษย์) | 工商管理（人力资源管理）"
    },
    {
        "id":5127,
        "name":"5130 (English Program)  :  Business Administration (Accounting) | การบริหารธุรกิจ (การบัญชี) | 工商管理（会计）"
    },
    {
        "id":5128,
        "name":"5131 (English Program)  :  Business Administration (Business Computer ) | การบริหารธุรกิจ (คอมพิวเตอร์ธุรกิจ) | 工商管理（商业计算机）"
    },
    {
        "id":5129,
        "name":"5132 (English Program)  :  Business Administration (Service Business ) | การบริหารธุรกิจ (ธุรกิจบริการ) | 工商管理（服务业）"
    },
    {
        "id":5130,
        "name":"5133 (English Program)  :  Business Economics (International Business) | เศรษฐศาสตร์ธุรกิจ (ธุรกิจระหว่างประเทศ) | 商业经济学（国际商务）"
    },
    {
        "id":5131,
        "name":"5134 (English Program)  :  Business Economics (Money And Banking) | เศรษฐศาสตร์ธุรกิจ (เงินและการธนาคาร) | 商业经济学（货币与银行）"
    },
    {
        "id":5132,
        "name":"5135 (English Program)  :  Business Economics (Tourism) | เศรษฐศาสตร์ธุรกิจ (การท่องเที่ยว) | 商业经济学（旅游）"
    },
    {
        "id":5133,
        "name":"5136 (English Program)  :  Industrial Technology (Constructional Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีการก่อสร้าง) | 工业技术（建筑技术）"
    },
    {
        "id":5134,
        "name":"5137 (English Program)  :  Industrial Technology (Industrial Management) | เทคโนโลยีอุตสาหกรรม (การจัดการอุตสาหกรรม) | 工业技术（工业管理）"
    },
    {
        "id":5135,
        "name":"5138 (English Program)  :  Industrial Technology (Productional Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีการผลิต) | 工业技术（生产技术）"
    },
    {
        "id":5136,
        "name":"5139 (English Program)  :  Industrial Technology(Industrial Computer Technology) | เทคโนโลยีอุตสาหกรรม(เทคโนโลยีคอมพิวเตอร์อุตสาหกรรม) | 工业技术（工业计算机技术）"
    },
    {
        "id":5137,
        "name":"5140 (English Program)  :  Industrial Technology (Mechanical Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีเครื่องกล) | 工业技术（机械技术）"
    },
    {
        "id":5138,
        "name":"5141 (English Program)  :  Industrial Technology (Industrial Electricity Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีไฟฟ้าอุตสาหกรรม) | 工业技术（工业电力技术）"
    },
    {
        "id":5139,
        "name":"5142 (English Program)  :  Industrial Technology ( (Interior Architecture Design) | เทคโนโลยีอุตสาหกรรม ((การออกแบบสถาปัตยกรรมภายใน) | 工业技术（（室内建筑设计）"
    },
    {
        "id":5140,
        "name":"5143 (English Program)  :  Industrial Technology ( Architectural Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีสถาปัตยกรรม) | 工业技术（建筑技术）"
    },
    {
        "id":5141,
        "name":"5144 (English Program)  :  Industrial Technology (Industrial Design) | เทคโนโลยีอุตสาหกรรม (การออกแบบอุตสาหกรรม) | 工业技术（工业设计）"
    },
    {
        "id":5142,
        "name":"5145 (English Program)  :  Industrial Technology (Electronical Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีอิเล็กทรอนิกส์) | 工业技术（电子技术）"
    },
    {
        "id":5143,
        "name":"5146 (English Program)  :  Project Management And Project Evaluation | การจัดการโครงการและการประเมินโครงการ | 项目管理和项目评估"
    },
    {
        "id":5144,
        "name":"5147 (English Program)  :  Business Innovation Management | การจัดการนวัตกรรมทางธุรกิจ | 商业创新管理"
    },
    {
        "id":5145,
        "name":"5148 (English Program)  :  Enterprise Management | การจัดการองค์กร | 企业管理"
    },
    {
        "id":5146,
        "name":"5149 (English Program)  :  Private And Public Management | การจัดการภาครัฐและเอกชน | 私人和公共管理"
    },
    {
        "id":5147,
        "name":"5150 (English Program)  :  Early Childhood Education Management | การจัดการการศึกษาปฐมวัย | 幼儿教育管理"
    },
    {
        "id":5148,
        "name":"5151 (English Program)  :  Modern Management And Information Technology | การจัดการที่ทันสมัยและเทคโนโลยีสารสนเทศ | 现代管理与信息技术"
    },
    {
        "id":5149,
        "name":"5152 (English Program)  :  Animation | แอนิเมชั่น | 动画片"
    },
    {
        "id":5150,
        "name":"5153 (English Program)  :  Marine Product Technology | เทคโนโลยีผลิตภัณฑ์ทางทะเล | 海产品技术"
    },
    {
        "id":5151,
        "name":"5154 (English Program)  :  Retail Management | การจัดการการค้าปลีก | 零售管理"
    },
    {
        "id":5152,
        "name":"5155 (English Program)  :  Soil Resources And Environment Management | การจัดการทรัพยากรดินและสิ่งแวดล้อม | 土壤资源和环境管理"
    },
    {
        "id":5153,
        "name":"5156 (English Program)  :  Agricultural Management Technology | เทคโนโลยีการจัดการการเกษตร | 农业管理技术"
    },
    {
        "id":5154,
        "name":"5157 (English Program)  :  Information And Production Technology Management | การจัดการเทคโนโลยีสารสนเทศและการผลิต | 信息与生产技术管理"
    },
    {
        "id":5155,
        "name":"5158 (English Program)  :  Facility Technology Management | การจัดการเทคโนโลยีสิ่งอำนวยความสะดวก | 设施技术管理"
    },
    {
        "id":5156,
        "name":"5159 (English Program)  :  Aviation Business Management | การจัดการธุรกิจการบิน | 航空业务管理"
    },
    {
        "id":5157,
        "name":"5160 (English Program)  :  Energy Management | การจัดการพลังงาน | 能源管理"
    },
    {
        "id":5158,
        "name":"5161 (English Program)  :  Electronic Commerce Management | การจัดการพาณิชย์อิเล็กทรอนิกส์ | 电子商务管理"
    },
    {
        "id":5159,
        "name":"5162 (English Program)  :  Hotel And Lodging Management | การจัดการโรงแรมและที่พัก | 酒店及住宿管理"
    },
    {
        "id":5160,
        "name":"5163 (English Program)  :  Tourism And Hotel Industry Management | การจัดการอุตสาหกรรมการท่องเที่ยวและการโรงแรม | 旅游及酒店业管理"
    },
    {
        "id":5161,
        "name":"5164 (English Program)  :  Hospitality And Tourism | การต้อนรับและการท่องเที่ยว | 酒店业和旅游业"
    },
    {
        "id":5162,
        "name":"5165 (English Program)  :  Golf Management | การจัดการกอล์ฟ | 高尔夫管理"
    },
    {
        "id":5163,
        "name":"5166 (English Program)  :  Property Management | การจัดการทรัพย์สิน | 物业管理"
    },
    {
        "id":5164,
        "name":"5167 (English Program)  :  Politics And Government | การเมืองและการปกครอง | 政治与政府"
    },
    {
        "id":5165,
        "name":"5168 (English Program)  :  Entrepreneurship And Management | ผู้ประกอบการและการจัดการ | 创业与管理"
    },
    {
        "id":5166,
        "name":"5169 (English Program)  :  Entrepreneurship In Science And Technology | ผู้ประกอบการด้านวิทยาศาสตร์และเทคโนโลยี | 科技创业"
    },
    {
        "id":5167,
        "name":"5170 (English Program)  :  Thai Medicine | การแพทย์แผนไทย | 泰国医学"
    },
    {
        "id":5168,
        "name":"5171 (English Program)  :  General Science Teaching | การสอนวิทยาศาสตร์ทั่วไป | 普通科学教学"
    },
    {
        "id":5169,
        "name":"5172 (English Program)  :  Intergrated Communication Studies | การศึกษาการสื่อสารแบบผสมผสาน | 综合传播研究"
    },
    {
        "id":5170,
        "name":"5173 (English Program)  :  Applied Art Design | การออกแบบงานศิลปะประยุกต์ | 应用艺术设计"
    },
    {
        "id":5171,
        "name":"5174 (English Program)  :  Interactive Design And Game Development | การออกแบบเชิงโต้ตอบและการพัฒนาเกม | 交互设计和游戏开发"
    },
    {
        "id":5172,
        "name":"5175 (English Program)  :  Visual Design-Fashion Design | การออกแบบภาพ-การออกแบบแฟชั่น | 视觉设计-服装设计"
    },
    {
        "id":5173,
        "name":"5176 (English Program)  :  Visual Design-Communication Design | การออกแบบการมองเห็น-การออกแบบการสื่อสาร | 视觉设计-传达设计"
    },
    {
        "id":5174,
        "name":"5177 (English Program)  :  Visual - Jewelry Design | ภาพ - การออกแบบเครื่องประดับ | 视觉-珠宝设计"
    },
    {
        "id":5175,
        "name":"5178 (English Program)  :  Print Media Design | การออกแบบสื่อสิ่งพิมพ์ | 印刷媒体设计"
    },
    {
        "id":5176,
        "name":"5179 (English Program)  :  Food And Business Service | บริการอาหารและธุรกิจ | 食品和商业服务"
    },
    {
        "id":5177,
        "name":"5180 (English Program)  :  Mathematics And Information Systems | คณิตศาสตร์และระบบสารสนเทศ | 数学与信息系统"
    },
    {
        "id":5178,
        "name":"5181 (English Program)  :  Design Education | การศึกษาด้านการออกแบบ | 设计教育"
    },
    {
        "id":5179,
        "name":"5182 (English Program)  :  Engineering Education | การศึกษาด้านวิศวกรรม | 工程教育"
    },
    {
        "id":5180,
        "name":"5183 (English Program)  :  Interior Environmental Education | การศึกษาสิ่งแวดล้อมภายใน | 室内环境教育"
    },
    {
        "id":5181,
        "name":"5184 (English Program)  :  Computer And Cyber Security | ความปลอดภัยของคอมพิวเตอร์และไซเบอร์ | 计算机和网络安全"
    },
    {
        "id":5182,
        "name":"5185 (English Program)  :  Computer Graphic | คอมพิวเตอร์กราฟิก | 电脑绘图"
    },
    {
        "id":5183,
        "name":"5186 (English Program)  :  Computer Applications | การใช้งานคอมพิวเตอร์ | 计算机应用"
    },
    {
        "id":5184,
        "name":"5187 (English Program)  :  Product Design Computer | คอมพิวเตอร์ออกแบบผลิตภัณฑ์ | 产品设计电脑"
    },
    {
        "id":5185,
        "name":"5188 (English Program)  :  Industrial And Environmental Chemistry | เคมีอุตสาหกรรมและสิ่งแวดล้อม | 工业与环境化学"
    },
    {
        "id":5186,
        "name":"5189 (English Program)  :  Agricultural Mechanic | ช่างกลเกษตร | 农业机械师"
    },
    {
        "id":5187,
        "name":"5190 (English Program)  :  Civil Technology | เทคโนโลยีโยธา | 民用技术"
    },
    {
        "id":5188,
        "name":"5191 (English Program)  :  Inter-Ethnic Studics On Greater Mae Kong Subrcgion | การศึกษาระหว่างชาติพันธุ์เกี่ยวกับกลุ่มย่อยแม่กลองส่วนใหญ่ | 大湄公河次区域的跨种族研究"
    },
    {
        "id":5189,
        "name":"5192 (English Program)  :  Electrical Installation Specialization | ความเชี่ยวชาญด้านการติดตั้งระบบไฟฟ้า | 电气安装专业"
    },
    {
        "id":5190,
        "name":"5193 (English Program)  :  Land Resources And Environment | ทรัพยากรที่ดินและสิ่งแวดล้อม | 土地资源与环境"
    },
    {
        "id":5191,
        "name":"5194 (English Program)  :  Doctor Of Optometry | แพทย์สาขาทัศนมาตรศาสตร์ | 验光博士"
    },
    {
        "id":5192,
        "name":"5195 (English Program)  :  Visual Art-Ceramics | ทัศนศิลป์-เซรามิกส์ | 视觉艺术陶瓷"
    },
    {
        "id":5193,
        "name":"5196 (English Program)  :  Visual Art-Imaging Art | ทัศนศิลป์-การสร้างภาพ | 视觉艺术-影像艺术"
    },
    {
        "id":5194,
        "name":"5197 (English Program)  :  Industrial Welding Technology | เทคโนโลยีการเชื่อมอุตสาหกรรม | 工业焊接技术"
    },
    {
        "id":5195,
        "name":"5199 (English Program)  :  Printing Technique | เทคนิคการพิมพ์ | 印刷技术"
    },
    {
        "id":5196,
        "name":"5200 (English Program)  :  Auto-Mechanic Technology | เทคโนโลยีกลไกอัตโนมัติ | 汽车机械技术"
    },
    {
        "id":5197,
        "name":"5201 (English Program)  :  Construction Management Technology | เทคโนโลยีการจัดการการก่อสร้าง | 施工管理技术"
    },
    {
        "id":5198,
        "name":"5202 (English Program)  :  Construction Technology | เทคโนโลยีการก่อสร้าง | 建筑技术"
    },
    {
        "id":5199,
        "name":"5203 (English Program)  :  Industrial Business Technology | เทคโนโลยีธุรกิจอุตสาหกรรม | 工业商业技术"
    },
    {
        "id":5200,
        "name":"5204 (English Program)  :  Office Computer Technology | เทคโนโลยีคอมพิวเตอร์สำนักงาน | 办公电脑技术"
    },
    {
        "id":5201,
        "name":"5205 (English Program)  :  Computer Electronic Technology | เทคโนโลยีอิเล็กทรอนิกส์คอมพิวเตอร์ | 计算机电子技术"
    },
    {
        "id":5202,
        "name":"5206 (English Program)  :  Industrial Art Technology | เทคโนโลยีศิลปะอุตสาหกรรม | 工业艺术技术"
    },
    {
        "id":5203,
        "name":"5207 (English Program)  :  Technology Program | โปรแกรมเทคโนโลยี | 技术计划"
    },
    {
        "id":5204,
        "name":"5208 (English Program)  :  Department Of Journalism And Information Technology | สาขาวิชาวารสารศาสตร์และเทคโนโลยีสารสนเทศ | 新闻与信息技术系"
    },
    {
        "id":5205,
        "name":"5209 (English Program)  :  Environmental Geo-Informatic Technology | เทคโนโลยีภูมิสารสนเทศสิ่งแวดล้อม | 环境地理信息技术"
    },
    {
        "id":5206,
        "name":"5210 (English Program)  :  Industrial Product Design Technology | เทคโนโลยีการออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计技术"
    },
    {
        "id":5207,
        "name":"5211 (English Program)  :  Food Technology And Nutrition | เทคโนโลยีอาหารและโภชนาการ | 食品技术和营养"
    },
    {
        "id":5208,
        "name":"5212 (English Program)  :  Electronic And Telecommunication Technology | เทคโนโลยีอิเล็กทรอนิกส์และโทรคมนาคม | 电子和电信技术"
    },
    {
        "id":5209,
        "name":"5213 (English Program)  :  Service Business | ธุรกิจบริการ | 服务业务"
    },
    {
        "id":5210,
        "name":"5214 (English Program)  :  Aviation Pilot Development | การพัฒนานักบินการบิน | 航空飞行员发展"
    },
    {
        "id":5211,
        "name":"5215 (English Program)  :  Fine Arts Program In Performing Arts | โปรแกรมวิจิตรศิลป์ในศิลปะการแสดง | 表演艺术美术课程"
    },
    {
        "id":5212,
        "name":"5216 (English Program)  :  Agricultural Communication | การสื่อสารทางการเกษตร | 农业通讯"
    },
    {
        "id":5213,
        "name":"5217 (English Program)  :  Physical Education-Information Technology For Sports Media Reporter | เทคโนโลยีสารสนเทศพลศึกษาสำหรับนักข่าวกีฬา | 体育媒体记者的体育信息技术"
    },
    {
        "id":5214,
        "name":"5218 (English Program)  :  Physical Education And Recreation | พลศึกษาและนันทนาการ | 体育和娱乐"
    },
    {
        "id":5215,
        "name":"5219 (English Program)  :  Applied Thai Traditional Medicine | การแพทย์แผนไทยประยุกต์ | 应用泰国传统医学"
    },
    {
        "id":5216,
        "name":"5220 (English Program)  :  Applied Physics-Energy | ฟิสิกส์ประยุกต์-พลังงาน | 应用物理-能源"
    },
    {
        "id":5217,
        "name":"5221 (English Program)  :  Industrial Physics | ฟิสิกส์อุตสาหกรรม | 工业物理"
    },
    {
        "id":5218,
        "name":"5222 (English Program)  :  Electrical Communication | การสื่อสารทางไฟฟ้า | 电气通讯"
    },
    {
        "id":5219,
        "name":"5223 (English Program)  :  Industrial Electricity | ไฟฟ้าอุตสาหกรรม | 工业电力"
    },
    {
        "id":5220,
        "name":"5224 (English Program)  :  Department Of Film And Digital | สาขาวิชาภาพยนตร์และดิจิทัล | 电影与数字系"
    },
    {
        "id":5221,
        "name":"5225 (English Program)  :  Thai For Career | ภาษาไทยเพื่ออาชีพ | 泰国职业"
    },
    {
        "id":5222,
        "name":"5226 (English Program)  :  Education Program In Thai | โปรแกรมการศึกษาภาษาไทย | 泰语教育项目"
    },
    {
        "id":5223,
        "name":"5227 (English Program)  :  French For Communication | ภาษาฝรั่งเศสเพื่อการสื่อสาร | 交流法语"
    },
    {
        "id":5224,
        "name":"5228 (English Program)  :  Language For Printed Media Creation | ภาษาสำหรับการสร้างสื่อสิ่งพิมพ์ | 印刷媒体创作语言"
    },
    {
        "id":5225,
        "name":"5229 (English Program)  :  Laos | ลาว | 老挝"
    },
    {
        "id":5226,
        "name":"5230 (English Program)  :  Vietnamese | ชาวเวียดนาม | 越南语"
    },
    {
        "id":5227,
        "name":"5231 (English Program)  :  Business Communication International | การสื่อสารธุรกิจระหว่างประเทศ | 国际商业传播"
    },
    {
        "id":5228,
        "name":"5232 (English Program)  :  Geographical Informatics For Development | สารสนเทศภูมิศาสตร์เพื่อการพัฒนา | 地理信息学促进发展"
    },
    {
        "id":5229,
        "name":"5233 (English Program)  :  Nutrition And Food Safety Management | การจัดการด้านโภชนาการและความปลอดภัยของอาหาร | 营养与食品安全管理"
    },
    {
        "id":5230,
        "name":"5234 (English Program)  :  Business Information Systems | ระบบสารสนเทศทางธุรกิจ | 商业信息系统"
    },
    {
        "id":5231,
        "name":"5235 (English Program)  :  Secretarial | เลขานุการ | 秘书"
    },
    {
        "id":5232,
        "name":"5236 (English Program)  :  Logisgics | โลจิสติกส์ | 物流"
    },
    {
        "id":5233,
        "name":"5237 (English Program)  :  Intercultural Studies For Tourism | การศึกษาระหว่างวัฒนธรรมเพื่อการท่องเที่ยว | 旅游跨文化研究"
    },
    {
        "id":5234,
        "name":"5238 (English Program)  :  Materials And Nanotechnology | วัสดุและนาโนเทคโนโลยี | 材料和纳米技术"
    },
    {
        "id":5235,
        "name":"5239 (English Program)  :  Creative Media Technology | เทคโนโลยีสื่อสร้างสรรค์ | 创意媒体技术"
    },
    {
        "id":5236,
        "name":"5240 (English Program)  :  Computer Science-Mathematics | วิทยาศาสตร์คอมพิวเตอร์-คณิตศาสตร์ | 计算机科学-数学"
    },
    {
        "id":5237,
        "name":"5241 (English Program)  :  Food Science And Technology | วิทยาศาสตร์การอาหารและเทคโนโลยี | 食品科学与技术"
    },
    {
        "id":5238,
        "name":"5242 (English Program)  :  Broadcast Media Study | การศึกษาสื่อออกอากาศ | 广播媒体研究"
    },
    {
        "id":5239,
        "name":"5243 (English Program)  :  Safety Management Engineering | วิศวกรรมการจัดการความปลอดภัย | 安全管理工程"
    },
    {
        "id":5240,
        "name":"5244 (English Program)  :  Aviation Maintenance Engineering | วิศวกรรมการบำรุงรักษาการบิน | 航空维修工程"
    },
    {
        "id":5241,
        "name":"5245 (English Program)  :  Information And Communication Engineering | วิศวกรรมสารสนเทศและการสื่อสาร | 信息与通信工程"
    },
    {
        "id":5242,
        "name":"5246 (English Program)  :  Computer Anemation And Game Engineering | วิศวกรรมคอมพิวเตอร์และวิศวกรรมเกม | 计算机动画和游戏工程"
    },
    {
        "id":5243,
        "name":"5247 (English Program)  :  Mechatronics And Robotics Engineering | วิศวกรรมเมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人工程"
    },
    {
        "id":5244,
        "name":"5248 (English Program)  :  Arts Education : Music Education - Thai Music | การศึกษาศิลปะ : ดนตรีศึกษา - ดนตรีไทย | 艺术教育：音乐教育 - 泰国音乐"
    },
    {
        "id":5245,
        "name":"5249 (English Program)  :  Arts Education : Music Education-Western Music | การศึกษาศิลปะ : ดนตรีศึกษา-ดนตรีตะวันตก | 艺术教育：音乐教育-西方音乐"
    },
    {
        "id":5246,
        "name":"5250 (English Program)  :  Arts Education : Visual Art Education | การศึกษาศิลปะ : การศึกษาทัศนศิลป์ | 艺术教育：视觉艺术教育"
    },
    {
        "id":5247,
        "name":"5251 (English Program)  :  Arts Education : Performing Art Education | การศึกษาศิลปะ : การแสดงการศึกษาศิลปะ | 艺术教育：表演艺术教育"
    },
    {
        "id":5248,
        "name":"5252 (English Program)  :  Arts Of Music | ศิลปะแห่งดนตรี | 音乐艺术"
    },
    {
        "id":5249,
        "name":"5253 (English Program)  :  Performing Art-Acting And Directing | การแสดงศิลปะและการกำกับ | 表演艺术表演和导演"
    },
    {
        "id":5250,
        "name":"5254 (English Program)  :  Performing Art-Theatre Design | การแสดงการออกแบบโรงละครศิลปะ | 表演艺术剧院设计"
    },
    {
        "id":5251,
        "name":"5255 (English Program)  :  Performing Art-Thai Dance | การแสดงนาฏศิลป์ไทย | 表演艺术-泰国舞蹈"
    },
    {
        "id":5252,
        "name":"5256 (English Program)  :  Performing Art-Western Dance | การแสดงนาฏศิลป์ตะวันตก | 表演西方艺术舞蹈"
    },
    {
        "id":5253,
        "name":"5257 (English Program)  :  Applied Performing Arts | ศิลปะการแสดงประยุกต์ | 应用表演艺术"
    },
    {
        "id":5254,
        "name":"5258 (English Program)  :  Monetary And Plublic Economics | เศรษฐศาสตร์การเงินและสาธารณะ | 货币和公共经济学"
    },
    {
        "id":5255,
        "name":"5259 (English Program)  :  Economics Of Finance And Banking | เศรษฐศาสตร์การเงินและการธนาคาร | 金融与银行经济学"
    },
    {
        "id":5256,
        "name":"5260 (English Program)  :  Agricultural Extension Communication | การสื่อสารส่งเสริมการเกษตร | 农业推广通讯"
    },
    {
        "id":5257,
        "name":"5261 (English Program)  :  Business Statistics And Insurance | สถิติธุรกิจและการประกันภัย | 商业统计和保险"
    },
    {
        "id":5258,
        "name":"5262 (English Program)  :  Interdiscriplinary Study For Local Development | การศึกษาแบบสหวิทยาการเพื่อการพัฒนาท้องถิ่น | 地方发展的跨学科研究"
    },
    {
        "id":5259,
        "name":"5263 (English Program)  :  Animal Sciences And Agricultural Technology | วิทยาศาสตร์สัตว์และเทคโนโลยีการเกษตร | 动物科学与农业技术"
    },
    {
        "id":5260,
        "name":"5264 (English Program)  :  Survey And Geo-Informatics | การสำรวจและภูมิสารสนเทศ | 调查和地理信息学"
    },
    {
        "id":5261,
        "name":"5265 (English Program)  :  New Media | สื่อใหม่ | 新媒体"
    },
    {
        "id":5262,
        "name":"5266 (English Program)  :  Tourism Communication | การสื่อสารการท่องเที่ยว | 旅游通讯"
    },
    {
        "id":5263,
        "name":"5267 (English Program)  :  Department Of Performing Arts Communication And New Media | กรมสื่อสารศิลปะการแสดงและสื่อใหม่ | 演艺传播与新媒体系"
    },
    {
        "id":5264,
        "name":"5268 (English Program)  :  Usuluddin | อูซูลุดดิน | 乌苏鲁丁"
    },
    {
        "id":5265,
        "name":"5269 (English Program)  :  Fine Arts And Applied Fashion Design | วิจิตรศิลป์และการออกแบบแฟชั่นประยุกต์ | 美术与应用时装设计"
    },
    {
        "id":5266,
        "name":"5270 (English Program)  :  Electronics Engineering | วิศวกรรมอิเล็กทรอนิกส์ | 电子工程"
    },
    {
        "id":5267,
        "name":"5271 (English Program)  :  Management-Human Resource Management | การจัดการ-การจัดการทรัพยากรมนุษย์ | 管理-人力资源管理"
    },
    {
        "id":5268,
        "name":"5272 (English Program)  :  Management-General Management | การจัดการ-การจัดการทั่วไป | 管理层-综合管理"
    },
    {
        "id":5269,
        "name":"5273 (English Program)  :  Management-Office Management | การจัดการ-การจัดการสำนักงาน | 管理-办公室管理"
    },
    {
        "id":5270,
        "name":"5274 (English Program)  :  Communication Management | การจัดการการสื่อสาร | 通讯管理"
    },
    {
        "id":5271,
        "name":"5275 (English Program)  :  Agribusiness Management | การจัดการธุรกิจการเกษตร | 农业企业管理"
    },
    {
        "id":5272,
        "name":"5276 (English Program)  :  Risk Management And Industrial Services | การจัดการความเสี่ยงและบริการด้านอุตสาหกรรม | 风险管理和工业服务"
    },
    {
        "id":5273,
        "name":"5277 (English Program)  :  Hospitality Management | การจัดการการต้อนรับ | 酒店管理"
    },
    {
        "id":5274,
        "name":"5278 (English Program)  :  International Logistics Management | การจัดการโลจิสติกส์ระหว่างประเทศ | 国际物流管理"
    },
    {
        "id":5275,
        "name":"5279 (English Program)  :  Architectural Management | การจัดการสถาปัตยกรรม | 建筑管理"
    },
    {
        "id":5276,
        "name":"5280 (English Program)  :  Estate Management | การจัดการอสังหาริมทรัพย์ | 物业管理"
    },
    {
        "id":5277,
        "name":"5281 (English Program)  :  Building And Facility Management | การจัดการอาคารและสิ่งอำนวยความสะดวก | 建筑和设施管理"
    },
    {
        "id":5278,
        "name":"5282 (English Program)  :  Rubber Industry Management | การจัดการอุตสาหกรรมยาง | 橡胶工业管理"
    },
    {
        "id":5279,
        "name":"5283 (English Program)  :  Marketing-Marketing Management | การตลาด-การจัดการการตลาด | 营销-营销管理"
    },
    {
        "id":5280,
        "name":"5284 (English Program)  :  Marketing-Marketing Communication | การสื่อสารการตลาด-การตลาด | 营销-营销传播"
    },
    {
        "id":5281,
        "name":"5285 (English Program)  :  Sustainable Tourism | การท่องเที่ยวอย่างยั่งยืน | 可持续旅游"
    },
    {
        "id":5282,
        "name":"5286 (English Program)  :  Accounting-Financial Accounting | การบัญชี-การบัญชีการเงิน | 会计-财务会计"
    },
    {
        "id":5283,
        "name":"5287 (English Program)  :  Accounting-Managerial Accounting | การบัญชี-การบัญชีบริหาร | 会计-管理会计"
    },
    {
        "id":5284,
        "name":"5288 (English Program)  :  Television Production | การผลิตรายการโทรทัศน์ | 电视制作"
    },
    {
        "id":5285,
        "name":"5289 (English Program)  :  Film Production | การผลิตภาพยนตร์ | 电影制作"
    },
    {
        "id":5286,
        "name":"5290 (English Program)  :  Animation Production | การผลิตแอนิเมชั่น | 动画制作"
    },
    {
        "id":5287,
        "name":"5291 (English Program)  :  Software Development | การพัฒนาซอฟต์แวร์ | 软件开发"
    },
    {
        "id":5288,
        "name":"5292 (English Program)  :  Electronic Commerc | พาณิชย์อิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":5289,
        "name":"5293 (English Program)  :  Thai Traditional Medicine | การแพทย์แผนไทย | 泰国传统医学"
    },
    {
        "id":5290,
        "name":"5294 (English Program)  :  Teaching English To Speakers Of Other Language English Education | การสอนภาษาอังกฤษแก่ผู้พูดการศึกษาภาษาอังกฤษภาษาอื่น | 向其他语言的人教授英语 英语教育"
    },
    {
        "id":5291,
        "name":"5295 (English Program)  :  Integrated Marketing Communication For Development | การสื่อสารการตลาดแบบบูรณาการเพื่อการพัฒนา | 整合营销传播促进发展"
    },
    {
        "id":5292,
        "name":"5296 (English Program)  :  New Media Communication | การสื่อสารผ่านสื่อรูปแบบใหม่ | 新媒体传播"
    },
    {
        "id":5293,
        "name":"5297 (English Program)  :  English Communication | การสื่อสารภาษาอังกฤษ | 英语交流"
    },
    {
        "id":5294,
        "name":"5298 (English Program)  :  Visual Design-Product Design | การออกแบบภาพ-การออกแบบผลิตภัณฑ์ | 视觉设计-产品设计"
    },
    {
        "id":5295,
        "name":"5299 (English Program)  :  Tropical Agricultural And Environment | การเกษตรเขตร้อนและสิ่งแวดล้อม | 热带农业与环境"
    },
    {
        "id":5296,
        "name":"5300 (English Program)  :  Natural Farming | เกษตรกรรมตามธรรมชาติ | 自然农法"
    },
    {
        "id":5297,
        "name":"5301 (English Program)  :  Agro Forestry | วนเกษตร | 农林业"
    },
    {
        "id":5298,
        "name":"5302 (English Program)  :  Agriculture Education - Agronomy | การศึกษาการเกษตร - พืชไร่ | 农业教育 - 农学"
    },
    {
        "id":5299,
        "name":"5303 (English Program)  :  Agriculture Education - Horticulture | การศึกษาการเกษตร - พืชสวน | 农业教育 - 园艺"
    },
    {
        "id":5300,
        "name":"5304 (English Program)  :  Agriculture Education - Fisheries | การศึกษาการเกษตร - การประมง | 农业教育 - 渔业"
    },
    {
        "id":5301,
        "name":"5305 (English Program)  :  Agriculture Education-Animal Science | เกษตรศึกษา-วิทยาศาสตร์สัตว์ | 农业教育-动物科学"
    },
    {
        "id":5302,
        "name":"5306 (English Program)  :  Home Economics Education-General Home Economics | คหกรรมการศึกษา-คหกรรมศาสตร์ทั่วไป | 家庭经济学教育-普通家庭经济学"
    },
    {
        "id":5303,
        "name":"5307 (English Program)  :  Home Economics Education-Foods And Nutrition | การศึกษาเศรษฐศาสตร์บ้าน-อาหารและโภชนาการ | 家庭经济教育-食品和营养"
    },
    {
        "id":5304,
        "name":"5308 (English Program)  :  Home Economics Education - General Home Economics | การศึกษาเศรษฐศาสตร์มหภาค - เศรษฐศาสตร์มหกรรมทั่วไป | 家庭经济学教育 - 普通家庭经济学"
    },
    {
        "id":5305,
        "name":"5309 (English Program)  :  Home Economics Education - Textiles And Clothing | การศึกษาเศรษฐศาสตร์บ้าน - สิ่งทอและเสื้อผ้า | 家庭经济教育 - 纺织品和服装"
    },
    {
        "id":5306,
        "name":"5310 (English Program)  :  Thai Painting | จิตรกรรมไทย | 泰国绘画"
    },
    {
        "id":5307,
        "name":"5311 (English Program)  :  Agricultural Mechanic | ช่างกลเกษตร | 农业机械师"
    },
    {
        "id":5308,
        "name":"5312 (English Program)  :  Machine Tool Technology-Automatic Technology | เทคโนโลยีเครื่องมือกล-เทคโนโลยีอัตโนมัติ | 机床技术-自动化技术"
    },
    {
        "id":5309,
        "name":"5313 (English Program)  :  Machine Tool Technology-Mechanical Maintenance | เทคโนโลยีเครื่องมือเครื่องจักร-การบำรุงรักษาทางกล | 机床技术-机械维护"
    },
    {
        "id":5310,
        "name":"5314 (English Program)  :  Heavy Equipment Technology | เทคโนโลยีอุปกรณ์หนัก | 重型装备技术"
    },
    {
        "id":5311,
        "name":"5315 (English Program)  :  Computer Technics | เทคนิคคอมพิวเตอร์ | 计算机技术"
    },
    {
        "id":5312,
        "name":"5316 (English Program)  :  Electrical -Refrigeration And Air Condition | ไฟฟ้า - เครื่องทำความเย็นและเครื่องปรับอากาศ | 电气-制冷和空调"
    },
    {
        "id":5313,
        "name":"5317 (English Program)  :  Gems Modeling Technology | เทคโนโลยีการสร้างแบบจำลองอัญมณี | 宝石建模技术"
    },
    {
        "id":5314,
        "name":"5318 (English Program)  :  Metal | โลหะ | 金属"
    },
    {
        "id":5315,
        "name":"5319 (English Program)  :  Surveying | การสำรวจ | 测量"
    },
    {
        "id":5316,
        "name":"5320 (English Program)  :  Middle East Studies | การศึกษาตะวันออกกลาง | 中东研究"
    },
    {
        "id":5317,
        "name":"5321 (English Program)  :  Agricultural Technology (Plant Production Technology Program) | เทคโนโลยีการเกษตร (หลักสูตรเทคโนโลยีการผลิตพืช) | 农业技术（植物生产技术项目）"
    },
    {
        "id":5318,
        "name":"5322 (English Program)  :  Agricultural Technology (Animal Feeding Technology Program) | เทคโนโลยีการเกษตร (หลักสูตรเทคโนโลยีการเลี้ยงสัตว์) | 农业技术（动物饲养技术计划）"
    },
    {
        "id":5319,
        "name":"5323 (English Program)  :  Welding Technology | เทคโนโลยีการเชื่อม | 焊接技术"
    },
    {
        "id":5320,
        "name":"5324 (English Program)  :  Fishery Technology (Coastal Aquaculture Program) | เทคโนโลยีการประมง (โปรแกรมการเพาะเลี้ยงสัตว์น้ำชายฝั่ง) | 渔业技术（沿海水产养殖计划）"
    },
    {
        "id":5321,
        "name":"5325 (English Program)  :  Fishery Technology (Product Program) | เทคโนโลยีประมง (โปรแกรมผลิตภัณฑ์) | 渔业技术（产品计划）"
    },
    {
        "id":5322,
        "name":"5326 (English Program)  :  Bio-Processing Technology | เทคโนโลยีการประมวลผลทางชีวภาพ | 生物加工技术"
    },
    {
        "id":5323,
        "name":"5327 (English Program)  :  Logistics Technology And Transportation Management | เทคโนโลยีโลจิสติกส์และการจัดการการขนส่ง | 物流技术与运输管理"
    },
    {
        "id":5324,
        "name":"5328 (English Program)  :  Polymer Engineering Technology | เทคโนโลยีวิศวกรรมโพลีเมอร์ | 聚合物工程技术"
    },
    {
        "id":5325,
        "name":"5329 (English Program)  :  Information Technology And Evaluation In Education | เทคโนโลยีสารสนเทศและการประเมินผลทางการศึกษา | 教育信息技术与评价"
    },
    {
        "id":5326,
        "name":"5330 (English Program)  :  Information And Communication Technology For Management | เทคโนโลยีสารสนเทศและการสื่อสารเพื่อการจัดการ | 管理信息和通信技术"
    },
    {
        "id":5327,
        "name":"5331 (English Program)  :  Industrial Technology (Telecommunication Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีโทรคมนาคม) | 工业技术（电信技术）"
    },
    {
        "id":5328,
        "name":"5332 (English Program)  :  Information Technology Business | ธุรกิจเทคโนโลยีสารสนเทศ | 信息技术业务"
    },
    {
        "id":5329,
        "name":"5333 (English Program)  :  Business Education - Accounting | การศึกษาธุรกิจ - การบัญชี | 商业教育 - 会计"
    },
    {
        "id":5330,
        "name":"5334 (English Program)  :  Business Education - Secretarial Studies | การศึกษาธุรกิจ - การศึกษาด้านเลขานุการ | 商业教育 - 秘书研究"
    },
    {
        "id":5331,
        "name":"5335 (English Program)  :  Business Education - Computer | การศึกษาธุรกิจ - คอมพิวเตอร์ | 商业教育 - 计算机"
    },
    {
        "id":5332,
        "name":"5336 (English Program)  :  Media Design And Production Innovation | นวัตกรรมการออกแบบและการผลิตสื่อ | 媒体设计与制作创新"
    },
    {
        "id":5333,
        "name":"5337 (English Program)  :  Social Innovation | นวัตกรรมทางสังคม | 社会创新"
    },
    {
        "id":5334,
        "name":"5338 (English Program)  :  Integrated Communication | การสื่อสารแบบบูรณาการ | 综合通讯"
    },
    {
        "id":5335,
        "name":"5339 (English Program)  :  Home Economics Administration | การบริหารเศรษฐศาสตร์มหภาค | 家庭经济管理"
    },
    {
        "id":5336,
        "name":"5340 (English Program)  :  Management Of Home Economics Business | การจัดการธุรกิจคหกรรมศาสตร์ | 家庭经济业务管理"
    },
    {
        "id":5337,
        "name":"5341 (English Program)  :  Accounting-Auditing | การบัญชี-การตรวจสอบ | 会计审计"
    },
    {
        "id":5338,
        "name":"5342 (English Program)  :  Thai Sculpture | ประติมากรรมไทย | 泰国雕塑"
    },
    {
        "id":5339,
        "name":"5343 (English Program)  :  Textiles And Clothing - Clothing Technology | สิ่งทอและเสื้อผ้า - เทคโนโลยีเสื้อผ้า | 纺织品和服装 - 服装技术"
    },
    {
        "id":5340,
        "name":"5344 (English Program)  :  Plan Science-Agronomy | แผนวิทยาศาสตร์-พืชไร่ | 规划科学农学"
    },
    {
        "id":5341,
        "name":"5345 (English Program)  :  Buddhist Historical And Cultural Studies | การศึกษาประวัติศาสตร์และวัฒนธรรมพุทธศาสนา | 佛教历史文化研究"
    },
    {
        "id":5342,
        "name":"5346 (English Program)  :  Chinese For Communication | ภาษาจีนเพื่อการสื่อสาร | 交际汉语"
    },
    {
        "id":5343,
        "name":"5347 (English Program)  :  British And American Studies | การศึกษาของอังกฤษและอเมริกัน | 英国和美国研究"
    },
    {
        "id":5344,
        "name":"5348 (English Program)  :  English For Business Communication | ภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจ | 商务交流英语"
    },
    {
        "id":5345,
        "name":"5349 (English Program)  :  Geography And History For Tourism | ภูมิศาสตร์และประวัติศาสตร์เพื่อการท่องเที่ยว | 旅游地理和历史"
    },
    {
        "id":5346,
        "name":"5350 (English Program)  :  Nutrition And Dietitics | โภชนาการและการกำหนดอาหาร | 营养与营养学"
    },
    {
        "id":5347,
        "name":"5351 (English Program)  :  Instrumentation And Control Systems | ระบบควบคุมและเครื่องมือวัด | 仪表和控制系统"
    },
    {
        "id":5348,
        "name":"5352 (English Program)  :  Computer Information Systems-Business Computer | ระบบสารสนเทศคอมพิวเตอร์-คอมพิวเตอร์ธุรกิจ | 计算机信息系统-商用计算机"
    },
    {
        "id":5349,
        "name":"5353 (English Program)  :  Russian Studies | การศึกษาภาษารัสเซีย | 俄罗斯研究"
    },
    {
        "id":5350,
        "name":"5354 (English Program)  :  Journalism And Mass Communication | วารสารศาสตร์และการสื่อสารมวลชน | 新闻与大众传播"
    },
    {
        "id":5351,
        "name":"5355 (English Program)  :  Animal’S Production And Health Science | วิทยาศาสตร์การผลิตและสุขภาพสัตว์ | 动物生产与健康科学"
    },
    {
        "id":5352,
        "name":"5356 (English Program)  :  Communication Engineering | วิศวกรรมการสื่อสาร | 通信工程"
    },
    {
        "id":5353,
        "name":"5357 (English Program)  :  Automotive Design And Manufacturing Engineering | การออกแบบยานยนต์และวิศวกรรมการผลิต | 汽车设计与制造工程"
    },
    {
        "id":5354,
        "name":"5358 (English Program)  :  Nano-Engineering | นาโนวิศวกรรม | 纳米工程"
    },
    {
        "id":5355,
        "name":"5359 (English Program)  :  Electrical And Electronics Engineering | วิศวกรรมไฟฟ้าและอิเล็กทรอนิกส์ | 电气和电子工程"
    },
    {
        "id":5356,
        "name":"5360 (English Program)  :  Electronics And Telecommunication Engineering - Telecommunication | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม - โทรคมนาคม | 电子与电信工程 - 电信"
    },
    {
        "id":5357,
        "name":"5361 (English Program)  :  Industrial Engineering Management | การจัดการวิศวกรรมอุตสาหการ | 工业工程管理"
    },
    {
        "id":5358,
        "name":"5362 (English Program)  :  Industrial Engineering - Manufacturing | วิศวกรรมอุตสาหการ-การผลิต | 工业工程-制造"
    },
    {
        "id":5359,
        "name":"5363 (English Program)  :  Industrial Craft And Design | งานฝีมืออุตสาหกรรมและการออกแบบ | 工业工艺与设计"
    },
    {
        "id":5360,
        "name":"5364 (English Program)  :  Economics Of Agriculture And Agri-Business | เศรษฐศาสตร์เกษตรและธุรกิจเกษตร | 农业和农业企业经济学"
    },
    {
        "id":5361,
        "name":"5365 (English Program)  :  Economic Theory | ทฤษฎีเศรษฐศาสตร์ | 经济理论"
    },
    {
        "id":5362,
        "name":"5366 (English Program)  :  Quantitative Economics | เศรษฐศาสตร์เชิงปริมาณ | 数量经济学"
    },
    {
        "id":5363,
        "name":"5367 (English Program)  :  Economic Development | การพัฒนาเศรษฐกิจ | 经济发展"
    },
    {
        "id":5364,
        "name":"5368 (English Program)  :  Labour And Human Resource Economics | เศรษฐศาสตร์แรงงานและทรัพยากรมนุษย์ | 劳动和人力资源经济学"
    },
    {
        "id":5365,
        "name":"5369 (English Program)  :  Economics-Business Economics | เศรษฐศาสตร์-เศรษฐศาสตร์ธุรกิจ | 经济学-商业经济学"
    },
    {
        "id":5366,
        "name":"5370 (English Program)  :  Public Economics | เศรษฐศาสตร์สาธารณะ | 公共经济"
    },
    {
        "id":5367,
        "name":"5371 (English Program)  :  Agri-Estension And Business | การเกษตรกรรมและธุรกิจ | 农业活动与商业"
    },
    {
        "id":5368,
        "name":"5372 (English Program)  :  Agricultural Extension And Development | การขยายและพัฒนาการเกษตร | 农业推广与发展"
    },
    {
        "id":5369,
        "name":"5373 (English Program)  :  Urban Architecture | สถาปัตยกรรมเมือง | 城市建筑"
    },
    {
        "id":5370,
        "name":"5374 (English Program)  :  Social Work And Social Welfare | งานสังคมสงเคราะห์และสวัสดิการสังคม | 社会工作和社会福利"
    },
    {
        "id":5371,
        "name":"5375 (English Program)  :  Thai Art Crafts | หัตถกรรมศิลปะไทย | 泰国工艺品"
    },
    {
        "id":5372,
        "name":"5376 (English Program)  :  Communication Design-Photographic Art | การออกแบบการสื่อสาร-ศิลปะการถ่ายภาพ | 传播设计-摄影艺术"
    },
    {
        "id":5373,
        "name":"5377 (English Program)  :  Foods And Nutrition-Foods Business | อาหารและโภชนาการ-ธุรกิจอาหาร | 食品和营养食品业务"
    },
    {
        "id":5374,
        "name":"5378 (English Program)  :  Electronics Computer | คอมพิวเตอร์อิเล็กทรอนิกส์ | 电子电脑"
    },
    {
        "id":5375,
        "name":"5379 (English Program)  :  Electronics Communication | การสื่อสารทางอิเล็กทรอนิกส์ | 电子通讯"
    },
    {
        "id":5376,
        "name":"5380 (English Program)  :  Tourism Industry (Business Airline) | อุตสาหกรรมการท่องเที่ยว (ธุรกิจสายการบิน) | 旅游业（商务航空）"
    },
    {
        "id":5377,
        "name":"5381 (English Program)  :  Marketing-International Marketing | การตลาด-การตลาดระหว่างประเทศ | 营销-国际营销"
    },
    {
        "id":5378,
        "name":"5382 (English Program)  :  Sports Coaching | การฝึกสอนกีฬา | 运动教练"
    },
    {
        "id":5379,
        "name":"5383 (English Program)  :  Child Health Promotion | การส่งเสริมสุขภาพเด็ก | 儿童健康促进"
    },
    {
        "id":5380,
        "name":"5384 (English Program)  :  Elderly Health Promotion | การส่งเสริมสุขภาพผู้สูงอายุ | 老年人健康促进"
    },
    {
        "id":5381,
        "name":"5385 (English Program)  :  Health Business | ธุรกิจด้านสุขภาพ | 健康事业"
    },
    {
        "id":5382,
        "name":"5386 (English Program)  :  Commercial Recreation And Tourism | สันทนาการเชิงพาณิชย์และการท่องเที่ยว | 商业休闲和旅游"
    },
    {
        "id":5383,
        "name":"5387 (English Program)  :  Therapeutic Recreation | นันทนาการบำบัด | 治疗性休闲"
    },
    {
        "id":5384,
        "name":"5388 (English Program)  :  Recreation Leadership | ความเป็นผู้นำด้านนันทนาการ | 休闲领导力"
    },
    {
        "id":5385,
        "name":"5389 (English Program)  :  Physical Education For The Disabled | พลศึกษาสำหรับผู้พิการ | 残疾人体育"
    },
    {
        "id":5386,
        "name":"5390 (English Program)  :  Electronics And Telecommunication Engineering(Electronics) | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม (อิเล็กทรอนิกส์) | 电子与电信工程（电子）"
    },
    {
        "id":5387,
        "name":"5391 (English Program)  :  Sports Communication | การสื่อสารกีฬา | 体育通讯"
    },
    {
        "id":5388,
        "name":"5392 (English Program)  :  Aircraft Maintenance-Aircraft Instrument | เครื่องมือบำรุงรักษาอากาศยาน-อากาศยาน | 飞机维修-飞机仪表"
    },
    {
        "id":5389,
        "name":"5393 (English Program)  :  Sports Management | การจัดการกีฬา | 体育管理"
    },
    {
        "id":5390,
        "name":"5394 (English Program)  :  Communication Maintenance | การบำรุงรักษาการสื่อสาร | 通讯维护"
    },
    {
        "id":5391,
        "name":"5395 (English Program)  :  Aircraft Maintenance-Airframe And Powerplant | การบำรุงรักษาเครื่องบิน-โครงเครื่องบินและโรงไฟฟ้า | 飞机维修-机身和动力装置"
    },
    {
        "id":5392,
        "name":"5396 (English Program)  :  Public Administration (Organization And Management) | การบริหารสาธารณะ (องค์กรและการจัดการ) | 公共行政（组织和管理）"
    },
    {
        "id":5393,
        "name":"5397 (English Program)  :  Public Administration (Local Government) | การบริหารราชการแผ่นดิน (ราชการส่วนท้องถิ่น) | 公共行政（地方政府）"
    },
    {
        "id":5394,
        "name":"5398 (English Program)  :  Aviation Engineering | วิศวกรรมการบิน | 航空工程"
    },
    {
        "id":5395,
        "name":"5399 (English Program)  :  Engineering In Hydrographic | วิศวกรรมอุทกศาสตร์ | 水文工程"
    },
    {
        "id":5396,
        "name":"5400 (English Program)  :  Musics | เพลง | 音乐"
    },
    {
        "id":5397,
        "name":"5401 (English Program)  :  Diplomacy And International Studies | การทูตและการศึกษาระหว่างประเทศ | 外交和国际研究"
    },
    {
        "id":5398,
        "name":"5402 (English Program)  :  Entrepreneurship Management | การจัดการผู้ประกอบการ | 创业管理"
    },
    {
        "id":5399,
        "name":"5403 (English Program)  :  Environment Management And Local Resources | การจัดการสิ่งแวดล้อมและทรัพยากรท้องถิ่น | 环境管理和当地资源"
    },
    {
        "id":5400,
        "name":"5404 (English Program)  :  Thai As Foreign Language | ภาษาไทยเป็นภาษาต่างประเทศ | 泰语作为外语"
    },
    {
        "id":5401,
        "name":"5405 (English Program)  :  Human Rights Studies | การศึกษาด้านสิทธิมนุษยชน | 人权研究"
    },
    {
        "id":5402,
        "name":"5406 (English Program)  :  International Divinity | ความศักดิ์สิทธิ์ระดับนานาชาติ | 国际神性"
    },
    {
        "id":5403,
        "name":"5407 (English Program)  :  Divinity | ความศักดิ์สิทธิ์ | 神"
    },
    {
        "id":5404,
        "name":"5408 (English Program)  :  Thai Traditional Art | ศิลปะประเพณีไทย | 泰国传统艺术"
    },
    {
        "id":5405,
        "name":"5409 (English Program)  :  Thai Drama | ละครไทย | 泰剧"
    },
    {
        "id":5406,
        "name":"5410 (English Program)  :  Western Drama | ละครตะวันตก | 西剧"
    },
    {
        "id":5407,
        "name":"5411 (English Program)  :  Civil Engineering - Irrigation | วิศวกรรมโยธา-ชลประทาน | 土木工程 - 灌溉"
    },
    {
        "id":5408,
        "name":"5412 (English Program)  :  Mathematics-Science | คณิตศาสตร์-วิทยาศาสตร์ | 数学科学"
    },
    {
        "id":5409,
        "name":"5413 (English Program)  :  Human Resource Development For Industrial Business | การพัฒนาทรัพยากรมนุษย์เพื่อธุรกิจอุตสาหกรรม | 工业企业的人力资源开发"
    },
    {
        "id":5410,
        "name":"5414 (English Program)  :  Mechatronics Engineering Technology | เทคโนโลยีวิศวกรรมเมคคาทรอนิกส์ | 机电工程技术"
    },
    {
        "id":5411,
        "name":"5415 (English Program)  :  Translations For Education And Business | การแปลเพื่อการศึกษาและธุรกิจ | 教育和商业翻译"
    },
    {
        "id":5412,
        "name":"5416 (English Program)  :  Communication Engineering | วิศวกรรมการสื่อสาร | 通信工程"
    },
    {
        "id":5413,
        "name":"5417 (English Program)  :  Software Systems Engineering | วิศวกรรมระบบซอฟต์แวร์ | 软件系统工程"
    },
    {
        "id":5414,
        "name":"5418 (English Program)  :  Chemical And Process Engineering | วิศวกรรมเคมีและกระบวนการ | 化学与加工工程"
    },
    {
        "id":5415,
        "name":"5419 (English Program)  :  Bioindustrial Technology | เทคโนโลยีอุตสาหกรรมชีวภาพ | 生物工业技术"
    },
    {
        "id":5416,
        "name":"5420 (English Program)  :  Agro-Industry Technology And Management | เทคโนโลยีและการจัดการอุตสาหกรรมเกษตร | 农产品加工业技术与管理"
    },
    {
        "id":5417,
        "name":"5421 (English Program)  :  Civil Engineering Management | การจัดการวิศวกรรมโยธา | 土木工程管理"
    },
    {
        "id":5418,
        "name":"5422 (English Program)  :  Taxation Law | กฎหมายภาษีอากร | 税法"
    },
    {
        "id":5419,
        "name":"5423 (English Program)  :  Machatronic Engineering | วิศวกรรมเครื่องกล | 机电工程"
    },
    {
        "id":5420,
        "name":"5424 (English Program)  :  Organization Development | การพัฒนาองค์กร | 组织发展"
    },
    {
        "id":5421,
        "name":"5425 (English Program)  :  Local Development And Government | การพัฒนาท้องถิ่นและการปกครอง | 地方发展和政府"
    },
    {
        "id":5422,
        "name":"5426 (English Program)  :  Urban Environment Planning And Management | การวางแผนและการจัดการสิ่งแวดล้อมเมือง | 城市环境规划与管理"
    },
    {
        "id":5423,
        "name":"5427 (English Program)  :  Architecture And | สถาปัตยกรรมและ | 建筑和"
    },
    {
        "id":5424,
        "name":"5428 (English Program)  :  Electrical Education | การศึกษาไฟฟ้า | 电气教育"
    },
    {
        "id":5425,
        "name":"5429 (English Program)  :  Technical Pedagogic Research And Development | การวิจัยและพัฒนาครุศาสตร์ทางเทคนิค | 技术教学研究与开发"
    },
    {
        "id":5426,
        "name":"5430 (English Program)  :  Materials And Metallurgical Engineering | วัสดุและวิศวกรรมโลหะการ | 材料与冶金工程"
    },
    {
        "id":5427,
        "name":"5431 (English Program)  :  Bioprocessing Technology | เทคโนโลยีการประมวลผลทางชีวภาพ | 生物加工技术"
    },
    {
        "id":5428,
        "name":"5432 (English Program)  :  Science Informatics | สารสนเทศวิทยาศาสตร์ | 科学信息学"
    },
    {
        "id":5429,
        "name":"5433 (English Program)  :  Biomedical Science | วิทยาศาสตร์ชีวการแพทย์ | 生物医学科学"
    },
    {
        "id":5430,
        "name":"5434 (English Program)  :  Medical Sciences | วิทยาศาสตร์การแพทย์ | 医学科学"
    },
    {
        "id":5431,
        "name":"5435 (English Program)  :  Natural Resources And Environmental Management | ทรัพยากรธรรมชาติและการจัดการสิ่งแวดล้อม | 自然资源和环境管理"
    },
    {
        "id":5432,
        "name":"5436 (English Program)  :  Medical Education | การศึกษาด้านการแพทย์ | 医学教育"
    },
    {
        "id":5433,
        "name":"5437 (English Program)  :  Folklore | พื้นบ้าน | 民俗学"
    },
    {
        "id":5434,
        "name":"5438 (English Program)  :  Fishery | ประมง | 渔业"
    },
    {
        "id":5435,
        "name":"5439 (English Program)  :  Educational Technology And Communications | เทคโนโลยีการศึกษาและการสื่อสาร | 教育技术和通信"
    },
    {
        "id":5436,
        "name":"5440 (English Program)  :  Natural Resources And Environment | ทรัพยากรธรรมชาติและสิ่งแวดล้อม | 自然资源和环境"
    },
    {
        "id":5437,
        "name":"5441 (English Program)  :  Cultural Resources Management | การจัดการทรัพยากรวัฒนธรรม | 文化资源管理"
    },
    {
        "id":5438,
        "name":"5442 (English Program)  :  Manufacturing Systems Engineering And Automation | วิศวกรรมระบบการผลิตและระบบอัตโนมัติ | 制造系统工程与自动化"
    },
    {
        "id":5439,
        "name":"5443 (English Program)  :  Veterinary Clinical Studies | การศึกษาทางคลินิกสัตวแพทย์ | 兽医临床研究"
    },
    {
        "id":5440,
        "name":"5444 (English Program)  :  Parks,Recreation And Tourism | สวนสาธารณะ สันทนาการ และการท่องเที่ยว | 公园、休闲和旅游"
    },
    {
        "id":5441,
        "name":"5445 (English Program)  :  Veterinary Epidemiology | ระบาดวิทยาทางสัตวแพทย์ | 兽医流行病学"
    },
    {
        "id":5442,
        "name":"5446 (English Program)  :  Training And Development | การฝึกอบรมและการพัฒนา | 培训与发展"
    },
    {
        "id":5443,
        "name":"5447 (English Program)  :  Project Analysis | การวิเคราะห์โครงการ | 项目分析"
    },
    {
        "id":5444,
        "name":"5448 (English Program)  :  Decision Technology And Management | เทคโนโลยีการตัดสินใจและการจัดการ | 决策技术与管理"
    },
    {
        "id":5445,
        "name":"5449 (English Program)  :  Public Policy And Project Management | นโยบายสาธารณะและการจัดการโครงการ | 公共政策和项目管理"
    },
    {
        "id":5446,
        "name":"5450 (English Program)  :  Bioindustrail Management | การจัดการอุตสาหกรรมชีวภาพ | 生物产业管理"
    },
    {
        "id":5447,
        "name":"5451 (English Program)  :  Education Science | วิทยาศาสตร์การศึกษา | 教育科学"
    },
    {
        "id":5448,
        "name":"5452 (English Program)  :  Instructional Systems Design | การออกแบบระบบการเรียนการสอน | 教学系统设计"
    },
    {
        "id":5449,
        "name":"5453 (English Program)  :  Health Education And Safety Education | การศึกษาด้านสุขภาพและการศึกษาด้านความปลอดภัย | 健康教育和安全教育"
    },
    {
        "id":5450,
        "name":"5454 (English Program)  :  Physical Education And Sport Science | พลศึกษาและวิทยาศาสตร์การกีฬา | 体育与运动科学"
    },
    {
        "id":5451,
        "name":"5455 (English Program)  :  Education-Counseling Psychology And Guidance | จิตวิทยาการให้คำปรึกษาด้านการศึกษาและการแนะแนว | 教育咨询心理学和指导"
    },
    {
        "id":5452,
        "name":"5456 (English Program)  :  Physics-Mathematics | ฟิสิกส์-คณิตศาสตร์ | 物理数学"
    },
    {
        "id":5453,
        "name":"5457 (English Program)  :  Thai Language And Communication | ภาษาไทยและการสื่อสาร | 泰语和交流"
    },
    {
        "id":5454,
        "name":"5458 (English Program)  :  Agricultural Technology (Animal Feed Technology) | เทคโนโลยีการเกษตร (เทคโนโลยีอาหารสัตว์) | 农业技术（动物饲料技术）"
    },
    {
        "id":5455,
        "name":"5459 (English Program)  :  Agricultural Technology (Plant Production Technology) | เทคโนโลยีการเกษตร (เทคโนโลยีการผลิตพืช) | 农业技术（植物生产技术）"
    },
    {
        "id":5456,
        "name":"5460 (English Program)  :  Teaching Islamic Studies | การสอนการศึกษาอิสลาม | 教授伊斯兰研究"
    },
    {
        "id":5457,
        "name":"5461 (English Program)  :  Islamic Studies(Arabic Program) | อิสลามศึกษา(หลักสูตรภาษาอาหรับ) | 伊斯兰研究（阿拉伯语项目）"
    },
    {
        "id":5458,
        "name":"5462 (English Program)  :  Political Science(Government) | รัฐศาสตร์(รัฐบาล) | 政治学（政府）"
    },
    {
        "id":5459,
        "name":"5463 (English Program)  :  Leadership In Educational Administration | ความเป็นผู้นำในการบริหารการศึกษา | 教育行政领导"
    },
    {
        "id":5460,
        "name":"5464 (English Program)  :  Non-Profit Sector Management | การจัดการภาคส่วนที่ไม่แสวงหาผลกำไร | 非营利部门管理"
    },
    {
        "id":5461,
        "name":"5465 (English Program)  :  Labor And Human Capital Economics | เศรษฐศาสตร์แรงงานและทุนมนุษย์ | 劳动和人力资本经济学"
    },
    {
        "id":5462,
        "name":"5466 (English Program)  :  Economics Of Labor And Human Resource Management | เศรษฐศาสตร์การจัดการแรงงานและทรัพยากรมนุษย์ | 劳动经济学和人力资源管理"
    },
    {
        "id":5463,
        "name":"5467 (English Program)  :  Educational Leadership | ความเป็นผู้นำด้านการศึกษา | 教育领导力"
    },
    {
        "id":5464,
        "name":"5468 (English Program)  :  Public And Business Administration | การบริหารภาครัฐและธุรกิจ | 公共和商业管理"
    },
    {
        "id":5465,
        "name":"5469 (English Program)  :  Psychology For Special Education Teachers | จิตวิทยาสำหรับครูการศึกษาพิเศษ | 特殊教育教师心理学"
    },
    {
        "id":5466,
        "name":"5470 (English Program)  :  Optometry | ทัศนมาตรศาสตร์ | 验光"
    },
    {
        "id":5467,
        "name":"5471 (English Program)  :  Golf Management | การจัดการกอล์ฟ | 高尔夫管理"
    },
    {
        "id":5468,
        "name":"5472 (English Program)  :  English For Business And Management | ภาษาอังกฤษเพื่อธุรกิจและการจัดการ | 商业和管理英语"
    },
    {
        "id":5469,
        "name":"5473 (English Program)  :  Natural Resources And Environmental Low | ทรัพยากรธรรมชาติและสิ่งแวดล้อมต่ำ | 自然资源和环境低"
    },
    {
        "id":5470,
        "name":"5474 (English Program)  :  International Trade Requlation | ข้อกำหนดทางการค้าระหว่างประเทศ | 国际贸易规则"
    },
    {
        "id":5471,
        "name":"5475 (English Program)  :  Public Affairs | กิจการสาธารณะ | 公共事务"
    },
    {
        "id":5472,
        "name":"5476 (English Program)  :  Labour And Welfare Development | การพัฒนาแรงงานและสวัสดิการ | 劳动和福利发展"
    },
    {
        "id":5473,
        "name":"5477 (English Program)  :  Social Welfare Administration And Policy | การบริหารและนโยบายสวัสดิการสังคม | 社会福利管理与政策"
    },
    {
        "id":5474,
        "name":"5478 (English Program)  :  Social Administration | การบริหารสังคม | 社会行政"
    },
    {
        "id":5475,
        "name":"5479 (English Program)  :  Human Resource Development | การพัฒนาทรัพยากรมนุษย์ | 人力资源开发"
    },
    {
        "id":5476,
        "name":"5480 (English Program)  :  Advertising And Public Relations | การโฆษณาและการประชาสัมพันธ์ | 广告和公共关系"
    },
    {
        "id":5477,
        "name":"5481 (English Program)  :  Innnovation Management | การจัดการนวัตกรรม | 创新管理"
    },
    {
        "id":5478,
        "name":"5482 (English Program)  :  Home Economics For Community | เศรษฐศาสตร์บ้านเพื่อชุมชน | 社区家庭经济"
    },
    {
        "id":5479,
        "name":"5483 (English Program)  :  International Trade Negotiation | การเจรจาการค้าระหว่างประเทศ | 国际贸易谈判"
    },
    {
        "id":5480,
        "name":"5484 (English Program)  :  Lobbying | การล็อบบี้ | 游说"
    },
    {
        "id":5481,
        "name":"5485 (English Program)  :  Health System Management | การจัดการระบบสุขภาพ | 卫生系统管理"
    },
    {
        "id":5482,
        "name":"5486 (English Program)  :  Technology And Innovation Management | การจัดการเทคโนโลยีและนวัตกรรม | 技术与创新管理"
    },
    {
        "id":5483,
        "name":"5487 (English Program)  :  Development Of Industrial Competitiveness | การพัฒนาความสามารถในการแข่งขันทางอุตสาหกรรม | 产业竞争力的发展"
    },
    {
        "id":5484,
        "name":"5488 (English Program)  :  Integrated Product Design And Manufacturing | การออกแบบและการผลิตผลิตภัณฑ์แบบครบวงจร | 一体化产品设计与制造"
    },
    {
        "id":5485,
        "name":"5489 (English Program)  :  Human Centered Design | การออกแบบที่คำนึงถึงมนุษย์เป็นหลัก | 以人为本的设计"
    },
    {
        "id":5486,
        "name":"5490 (English Program)  :  Art Teaching | การสอนศิลปะ | 艺术教学"
    },
    {
        "id":5487,
        "name":"5491 (English Program)  :  Music And Dance Teaching | การสอนดนตรีและการเต้นรำ | 音乐和舞蹈教学"
    },
    {
        "id":5488,
        "name":"5492 (English Program)  :  Education Research, Measurement And Statistics | การวิจัยการศึกษา การวัด และสถิติ | 教育研究、测量和统计"
    },
    {
        "id":5489,
        "name":"5493 (English Program)  :  Hospitality Management Communication Skills For Human Resource Development | ทักษะการสื่อสารการจัดการการต้อนรับเพื่อการพัฒนาทรัพยากรมนุษย์ | 酒店管理人力资源开发的沟通技巧"
    },
    {
        "id":5490,
        "name":"5494 (English Program)  :  Business Computing | คอมพิวเตอร์ธุรกิจ | 商业计算"
    },
    {
        "id":5491,
        "name":"5495 (English Program)  :  Educational Studies | การศึกษาการศึกษา | 教育研究"
    },
    {
        "id":5492,
        "name":"5496 (English Program)  :  Interdisciplinary For Local Development | สหวิทยาการเพื่อการพัฒนาท้องถิ่น | 跨学科促进地方发展"
    },
    {
        "id":5493,
        "name":"5497 (English Program)  :  Management Information Systems | ระบบสารสนเทศเพื่อการจัดการ | 管理信息系统"
    },
    {
        "id":5494,
        "name":"5498 (English Program)  :  Teaching English As A Second Language | การสอนภาษาอังกฤษเป็นภาษาที่สอง | 英语作为第二语言教学"
    },
    {
        "id":5495,
        "name":"5499 (English Program)  :  Innovation Entrepreneurship | ผู้ประกอบการด้านนวัตกรรม | 创新创业"
    },
    {
        "id":5496,
        "name":"5500 (English Program)  :  Welding And Fabrication | การเชื่อมและการผลิต | 焊接和制造"
    },
    {
        "id":5497,
        "name":"5501 (English Program)  :  Literature | วรรณกรรม | 文学"
    },
    {
        "id":5498,
        "name":"5502 (English Program)  :  Exercise Science | วิทยาศาสตร์การออกกำลังกาย | 运动科学"
    },
    {
        "id":5499,
        "name":"5503 (English Program)  :  Musicology | ดนตรีวิทยา | 音乐学"
    },
    {
        "id":5500,
        "name":"5504 (English Program)  :  Interventional Neuro Radiology | รังสีวิทยาประสาทแบบแทรกแซง | 介入神经放射学"
    },
    {
        "id":5501,
        "name":"5505 (English Program)  :  Additionology | การเสพติดวิทยา | 附加学"
    },
    {
        "id":5502,
        "name":"5506 (English Program)  :  Health Business Management | การจัดการธุรกิจด้านสุขภาพ | 健康业务管理"
    },
    {
        "id":5503,
        "name":"5507 (English Program)  :  Computer Art And Design | ศิลปะคอมพิวเตอร์และการออกแบบ | 计算机艺术与设计"
    },
    {
        "id":5504,
        "name":"5508 (English Program)  :  Business(Human Resource Management) | ธุรกิจ(การจัดการทรัพยากรมนุษย์) | 业务（人力资源管理）"
    },
    {
        "id":5505,
        "name":"5509 (English Program)  :  Community Development Volunteer | อาสาสมัครพัฒนาชุมชน | 社区发展志愿者"
    },
    {
        "id":5506,
        "name":"5510 (English Program)  :  Industrial Technology(Electricity) | เทคโนโลยีอุตสาหกรรม(ไฟฟ้า) | 工业技术（电力）"
    },
    {
        "id":5507,
        "name":"5511 (English Program)  :  Thai Language For Education | ภาษาไทยเพื่อการศึกษา | 泰语教育"
    },
    {
        "id":5508,
        "name":"5512 (English Program)  :  Business(Marketing) | ธุรกิจ(การตลาด) | 商业（营销）"
    },
    {
        "id":5509,
        "name":"5513 (English Program)  :  Business(Accounting) | ธุรกิจ(การบัญชี) | 商业（会计）"
    },
    {
        "id":5510,
        "name":"5514 (English Program)  :  Industrial Technology(Computer) | เทคโนโลยีอุตสาหกรรม(คอมพิวเตอร์) | 工业技术（计算机）"
    },
    {
        "id":5511,
        "name":"5515 (English Program)  :  Industrial Technology(Architecture) | เทคโนโลยีอุตสาหกรรม(สถาปัตยกรรม) | 工业技术（建筑）"
    },
    {
        "id":5512,
        "name":"5516 (English Program)  :  Industrial Technology(Management) | เทคโนโลยีอุตสาหกรรม(การจัดการ) | 工业技术（管理）"
    },
    {
        "id":5513,
        "name":"5517 (English Program)  :  Health Science(Child Health Promotion) | วิทยาศาสตร์สุขภาพ(การส่งเสริมสุขภาพเด็ก) | 健康科学（儿童健康促进）"
    },
    {
        "id":5514,
        "name":"5518 (English Program)  :  Industrial Technology (Construction) | เทคโนโลยีอุตสาหกรรม (การก่อสร้าง) | 工业技术（建筑）"
    },
    {
        "id":5515,
        "name":"5519 (English Program)  :  Musics (Western) | ดนตรี (ตะวันตก) | 音乐（西方）"
    },
    {
        "id":5516,
        "name":"5520 (English Program)  :  Business(Business Computer) | ธุรกิจ(คอมพิวเตอร์ธุรกิจ) | 商业（商业计算机）"
    },
    {
        "id":5517,
        "name":"5521 (English Program)  :  Regional Development Strategies | กลยุทธ์การพัฒนาระดับภูมิภาค | 区域发展战略"
    },
    {
        "id":5518,
        "name":"5522 (English Program)  :  Social Research And Development(Focusing On Culture) | การวิจัยและพัฒนาทางสังคม (เน้นวัฒนธรรม) | 社会研究与发展（聚焦文化）"
    },
    {
        "id":5519,
        "name":"5523 (English Program)  :  Traditional And Alternative Medicine | การแพทย์แผนโบราณและการแพทย์ทางเลือก | 传统医学和替代医学"
    },
    {
        "id":5520,
        "name":"5524 (English Program)  :  Education Research And Evaluation | การวิจัยและประเมินผลการศึกษา | 教育研究与评估"
    },
    {
        "id":5521,
        "name":"5525 (English Program)  :  Research And Development Of Traditional Thai Pharma | การวิจัยและพัฒนายาไทยแผนโบราณ | 泰国传统医药的研发"
    },
    {
        "id":5522,
        "name":"5526 (English Program)  :  Maritime And International Trade Laws | กฎหมายการค้าทางทะเลและระหว่างประเทศ | 海事和国际贸易法"
    },
    {
        "id":5523,
        "name":"5527 (English Program)  :  Sociology Of Tourism | สังคมวิทยาการท่องเที่ยว | 旅游社会学"
    },
    {
        "id":5524,
        "name":"5528 (English Program)  :  Cultural Resource Management | การจัดการทรัพยากรวัฒนธรรม | 文化资源管理"
    },
    {
        "id":5525,
        "name":"5529 (English Program)  :  Goldsmith | ช่างทอง | 金匠"
    },
    {
        "id":5526,
        "name":"5530 (English Program)  :  Environmental Public Health | สาธารณสุขสิ่งแวดล้อม | 环境公共卫生"
    },
    {
        "id":5527,
        "name":"5531 (English Program)  :  Anatomy And Structural Biology | กายวิภาคศาสตร์และชีววิทยาโครงสร้าง | 解剖学和结构生物学"
    },
    {
        "id":5528,
        "name":"5532 (English Program)  :  Music And Performing Arts | ดนตรีและศิลปะการแสดง | 音乐和表演艺术"
    },
    {
        "id":5529,
        "name":"5533 (English Program)  :  Technology | เทคโนโลยี | 技术"
    },
    {
        "id":5530,
        "name":"5534 (English Program)  :  Mechanical-Automechanic | เครื่องกล-เครื่องกล | 机械-自动机械"
    },
    {
        "id":5531,
        "name":"5535 (English Program)  :  Knowledge Management | การจัดการความรู้ | 知识管理"
    },
    {
        "id":5532,
        "name":"5536 (English Program)  :  Advertising\/Marketing Communications | การโฆษณา\/การสื่อสารการตลาด | 广告\/营销传播"
    },
    {
        "id":5533,
        "name":"5537 (English Program)  :  Plant Protection | การป้องกันพืช | 植物保护"
    },
    {
        "id":5534,
        "name":"5538 (English Program)  :  Teaching Thai Sign Language | การสอนภาษามือไทย | 泰语手语教学"
    },
    {
        "id":5535,
        "name":"5539 (English Program)  :  Infectious Diseases And Epidemiology | โรคติดเชื้อและระบาดวิทยา | 传染病和流行病学"
    },
    {
        "id":5536,
        "name":"5540 (English Program)  :  Sustainable Environment Planning | การวางแผนสิ่งแวดล้อมที่ยั่งยืน | 可持续环境规划"
    },
    {
        "id":5537,
        "name":"5541 (English Program)  :  Industrial Ecology And Environment | นิเวศวิทยาอุตสาหกรรมและสิ่งแวดล้อม | 工业生态与环境"
    },
    {
        "id":5538,
        "name":"5542 (English Program)  :  Phytopharmaceutical Sciences | วิทยาศาสตร์ไฟโตเภสัช | 植物药学"
    },
    {
        "id":5539,
        "name":"5543 (English Program)  :  Maternal-Newborn And Woman'S Health Nursing | การพยาบาลสุขภาพมารดา-ทารกแรกเกิดและสตรี | 孕产妇、新生儿和妇女健康护理"
    },
    {
        "id":5540,
        "name":"5544 (English Program)  :  Maxillofacial Prosthetics | ศัลยกรรมกระดูกขากรรไกร | 颌面修复术"
    },
    {
        "id":5541,
        "name":"5545 (English Program)  :  Clinical Science | วิทยาศาสตร์คลินิก | 临床科学"
    },
    {
        "id":5542,
        "name":"5546 (English Program)  :  Oral Rehabilitation | การฟื้นฟูสมรรถภาพช่องปาก | 口腔康复"
    },
    {
        "id":5543,
        "name":"5547 (English Program)  :  Dental Implant Prosthodontics | ทันตกรรมรากเทียม | 种植牙修复"
    },
    {
        "id":5544,
        "name":"5548 (English Program)  :  Food And Nutrition Technology | เทคโนโลยีอาหารและโภชนาการ | 食品和营养技术"
    },
    {
        "id":5545,
        "name":"5549 (English Program)  :  Human Rights And Deace Studies | การศึกษาด้านสิทธิมนุษยชนและการเสียชีวิต | 人权与死亡研究"
    },
    {
        "id":5546,
        "name":"5550 (English Program)  :  Clinical Tropical Pediatrics | กุมารเวชศาสตร์เขตร้อนทางคลินิก | 临床热带儿科"
    },
    {
        "id":5547,
        "name":"5551 (English Program)  :  Computer Of Design | คอมพิวเตอร์แห่งการออกแบบ | 设计电脑"
    },
    {
        "id":5548,
        "name":"5552 (English Program)  :  Molecular Medicine | ยาโมเลกุล | 分子医学"
    },
    {
        "id":5549,
        "name":"5553 (English Program)  :  Television Production | การผลิตรายการโทรทัศน์ | 电视制作"
    },
    {
        "id":5550,
        "name":"5554 (English Program)  :  Advanced Adult Nursing | การพยาบาลผู้ใหญ่ขั้นสูง | 高级成人护理"
    },
    {
        "id":5551,
        "name":"5555 (English Program)  :  Family Practitioner | ผู้ประกอบวิชาชีพครอบครัว | 家庭医生"
    },
    {
        "id":5552,
        "name":"5556 (English Program)  :  Modern Business Management | การจัดการธุรกิจสมัยใหม่ | 现代企业管理"
    },
    {
        "id":5553,
        "name":"5557 (English Program)  :  Information And Communication Engineering | วิศวกรรมสารสนเทศและการสื่อสาร | 信息与通信工程"
    },
    {
        "id":5554,
        "name":"5558 (English Program)  :  Local Governing | การปกครองท้องถิ่น | 地方治理"
    },
    {
        "id":5555,
        "name":"5559 (English Program)  :  Auto-Mechanics Technology | เทคโนโลยีกลไกอัตโนมัติ | 汽车机械技术"
    },
    {
        "id":5556,
        "name":"5560 (English Program)  :  Business Service Management | การจัดการบริการธุรกิจ | 商业服务管理"
    },
    {
        "id":5557,
        "name":"5561 (English Program)  :  Renewable Energy Engineering | วิศวกรรมพลังงานทดแทน | 可再生能源工程"
    },
    {
        "id":5558,
        "name":"5562 (English Program)  :  E-Business | ธุรกิจอิเล็กทรอนิกส์ | 电子商务"
    },
    {
        "id":5559,
        "name":"5563 (English Program)  :  Innovation And Enterpreneurship | นวัตกรรมและการเป็นผู้ประกอบการ | 创新与创业"
    },
    {
        "id":5560,
        "name":"5564 (English Program)  :  Integrated Political Communication | การสื่อสารทางการเมืองแบบบูรณาการ | 综合政治传播"
    },
    {
        "id":5561,
        "name":"5565 (English Program)  :  Information And Communication Technology For Education | เทคโนโลยีสารสนเทศและการสื่อสารเพื่อการศึกษา | 教育信息和通信技术"
    },
    {
        "id":5562,
        "name":"5566 (English Program)  :  Aircraft Electronics | อิเล็กทรอนิกส์อากาศยาน | 飞机电子设备"
    },
    {
        "id":5563,
        "name":"5567 (English Program)  :  Local Government And Development | รัฐบาลท้องถิ่นและการพัฒนา | 地方政府与发展"
    },
    {
        "id":5564,
        "name":"5568 (English Program)  :  Buddhism Teaching | การสอนศาสนาพุทธ | 佛法教学"
    },
    {
        "id":5565,
        "name":"5569 (English Program)  :  Electronic | อิเล็กทรอนิกส์ | 电子的"
    },
    {
        "id":5566,
        "name":"5570 (English Program)  :  Pollution Control And Management | การควบคุมและการจัดการมลพิษ | 污染控制与管理"
    },
    {
        "id":5567,
        "name":"5571 (English Program)  :  Informatics Mathematics Education | การศึกษาคณิตศาสตร์สารสนเทศ | 信息学数学教育"
    },
    {
        "id":5568,
        "name":"5572 (English Program)  :  Technology Of Environment Management | เทคโนโลยีการจัดการสิ่งแวดล้อม | 环境管理技术"
    },
    {
        "id":5569,
        "name":"5573 (English Program)  :  Evaluation Methodology | วิธีการประเมิน | 评估方法"
    },
    {
        "id":5570,
        "name":"5574 (English Program)  :  Prarmacy Organization Management | การจัดการองค์กรเภสัชกรรม | 业务组织管理"
    },
    {
        "id":5571,
        "name":"5575 (English Program)  :  Design Innovation | นวัตกรรมการออกแบบ | 设计创新"
    },
    {
        "id":5572,
        "name":"5576 (English Program)  :  Arts And Culture Research | การวิจัยศิลปะและวัฒนธรรม | 艺术与文化研究"
    },
    {
        "id":5573,
        "name":"5577 (English Program)  :  Environmental Technology Management | การจัดการเทคโนโลยีสิ่งแวดล้อม | 环境技术管理"
    },
    {
        "id":5574,
        "name":"5578 (English Program)  :  Industrial Development | การพัฒนาอุตสาหกรรม | 工业发展"
    },
    {
        "id":5575,
        "name":"5579 (English Program)  :  Ceramics Design | การออกแบบเซรามิก | 陶瓷设计"
    },
    {
        "id":5576,
        "name":"5580 (English Program)  :  Tourism And Hotel Studies | การศึกษาการท่องเที่ยวและการโรงแรม | 旅游和酒店研究"
    },
    {
        "id":5577,
        "name":"5581 (English Program)  :  Social Innovation Management | การจัดการนวัตกรรมทางสังคม | 社会创新管理"
    },
    {
        "id":5578,
        "name":"5582 (English Program)  :  Aquacul Engineering | วิศวกรรมทางน้ำ | 水产工程"
    },
    {
        "id":5579,
        "name":"5583 (English Program)  :  Agricultural Machinery And Mechatronics | เครื่องจักรการเกษตรและเมคคาทรอนิกส์ | 农业机械及机电一体化"
    },
    {
        "id":5580,
        "name":"5584 (English Program)  :  Human And Community Resource Development | การพัฒนาทรัพยากรมนุษย์และชุมชน | 人力资源和社区资源开发"
    },
    {
        "id":5581,
        "name":"5585 (English Program)  :  Music (Western) | ดนตรี (ตะวันตก) | 音乐（西方）"
    },
    {
        "id":5582,
        "name":"5586 (English Program)  :  Industrial Desing | การออกแบบอุตสาหกรรม | 工业设计"
    },
    {
        "id":5583,
        "name":"5587 (English Program)  :  Agriculture (Agricultural Techonology) | การเกษตร (เทคโนโลยีการเกษตร) | 农业（农业技术）"
    },
    {
        "id":5584,
        "name":"5588 (English Program)  :  Agriculture (Animal Husbandry) | เกษตรกรรม (สัตวบาล) | 农业（畜牧业）"
    },
    {
        "id":5585,
        "name":"5589 (English Program)  :  Agriculture (Aquaculture) | เกษตร (เพาะเลี้ยงสัตว์น้ำ) | 农业（水产养殖）"
    },
    {
        "id":5586,
        "name":"5590 (English Program)  :  Integrated Tourism Management | การจัดการการท่องเที่ยวเชิงบูรณาการ | 旅游综合管理"
    },
    {
        "id":5587,
        "name":"5591 (English Program)  :  Bioscience And Biotechnology | วิทยาศาสตร์ชีวภาพและเทคโนโลยีชีวภาพ | 生物科学与生物技术"
    },
    {
        "id":5588,
        "name":"5592 (English Program)  :  Hospitality Industry | อุตสาหกรรมการบริการ | 酒店业"
    },
    {
        "id":5589,
        "name":"5593 (English Program)  :  English-Thai | ภาษาอังกฤษ-ไทย | 英语-泰语"
    },
    {
        "id":5590,
        "name":"5594 (English Program)  :  Chinese Application | ใบสมัครภาษาจีน | 中文应用"
    },
    {
        "id":5591,
        "name":"5595 (English Program)  :  Thai Folk Music And Performance Arts | ดนตรีพื้นบ้านและศิลปะการแสดง | 泰国民间音乐和表演艺术"
    },
    {
        "id":5592,
        "name":"5596 (English Program)  :  Sangha Administration | การบริหารคณะสงฆ์ | 僧伽管理"
    },
    {
        "id":5593,
        "name":"5597 (English Program)  :  Information Technology System | ระบบเทคโนโลยีสารสนเทศ | 信息技术系统"
    },
    {
        "id":5594,
        "name":"5598 (English Program)  :  Metallurgical Technology | เทคโนโลยีทางโลหะวิทยา | 冶金技术"
    },
    {
        "id":5595,
        "name":"5599 (English Program)  :  Community Studies | การศึกษาชุมชน | 社区研究"
    },
    {
        "id":5596,
        "name":"5600 (English Program)  :  Islamic Management | การจัดการอิสลาม | 伊斯兰管理"
    },
    {
        "id":5597,
        "name":"5601 (English Program)  :  Hotel And Restaurant Management | การจัดการโรงแรมและร้านอาหาร | 酒店和餐厅管理"
    },
    {
        "id":5598,
        "name":"5602 (English Program)  :  Engineering Physics | ฟิสิกส์วิศวกรรม | 工程物理"
    },
    {
        "id":5599,
        "name":"5603 (English Program)  :  Traditional Arts | ศิลปะแบบดั้งเดิม | 传统艺术"
    },
    {
        "id":5600,
        "name":"5604 (English Program)  :  Sufficiency Economy Under The Royal Initiative Of His Majesty The King | เศรษฐกิจพอเพียงตามพระราชดำริของพระบาทสมเด็จพระเจ้าอยู่หัว | 国王陛下皇家倡议下的自给自足经济"
    },
    {
        "id":5601,
        "name":"5605 (English Program)  :  Marketing-General Marketing | การตลาด-การตลาดทั่วไป | 营销-一般营销"
    },
    {
        "id":5602,
        "name":"5606 (English Program)  :  Home Economics Business Administration | การบริหารธุรกิจคหกรรมศาสตร์ | 家庭 经济 工商管理"
    },
    {
        "id":5603,
        "name":"5607 (English Program)  :  Fashion Clothing And Textile Design | เสื้อผ้าแฟชั่นและการออกแบบสิ่งทอ | 时装及纺织品设计"
    },
    {
        "id":5604,
        "name":"5608 (English Program)  :  Fashion Merchandising Technology | เทคโนโลยีการขายสินค้าแฟชั่น | 时尚营销技术"
    },
    {
        "id":5605,
        "name":"5609 (English Program)  :  Textile Product Design | การออกแบบผลิตภัณฑ์สิ่งทอ | 纺织产品设计"
    },
    {
        "id":5606,
        "name":"5610 (English Program)  :  Business Communication Arts | ศิลปะการสื่อสารทางธุรกิจ | 商业沟通艺术"
    },
    {
        "id":5607,
        "name":"5611 (English Program)  :  Domestic Animal Management | การจัดการสัตว์ในประเทศ | 家养动物管理"
    },
    {
        "id":5608,
        "name":"5612 (English Program)  :  Geographic Information System Technology | เทคโนโลยีระบบสารสนเทศทางภูมิศาสตร์ | 地理信息系统技术"
    },
    {
        "id":5609,
        "name":"5613 (English Program)  :  Electrical Engineering - Computer | วิศวกรรมไฟฟ้า-คอมพิวเตอร์ | 电气工程 - 计算机"
    },
    {
        "id":5610,
        "name":"5614 (English Program)  :  Business Administration (Community Business Management) | การบริหารธุรกิจ (การจัดการธุรกิจชุมชน) | 工商管理（社区商业管理）"
    },
    {
        "id":5611,
        "name":"5615 (English Program)  :  Animal Health | สุขภาพสัตว์ | 动物健康"
    },
    {
        "id":5612,
        "name":"5616 (English Program)  :  Interdisciplinary For Local Administration | สหวิทยาการเพื่อการบริหารท้องถิ่น | 地方管理跨学科"
    },
    {
        "id":5613,
        "name":"5617 (English Program)  :  Lanna Medicine | ยาล้านนา | 兰纳医药"
    },
    {
        "id":5614,
        "name":"5618 (English Program)  :  Philosophy Of Sufficiency Economy | ปรัชญาเศรษฐกิจพอเพียง | 自给自足经济的哲学"
    },
    {
        "id":5615,
        "name":"5619 (English Program)  :  Basic Education (Mathematics) | การศึกษาขั้นพื้นฐาน (คณิตศาสตร์) | 基础教育（数学）"
    },
    {
        "id":5616,
        "name":"5620 (English Program)  :  Basic Education (Physical Education) | การศึกษาขั้นพื้นฐาน (พลศึกษา) | 基础教育（体育）"
    },
    {
        "id":5617,
        "name":"5621 (English Program)  :  Basic Education (English) | การศึกษาขั้นพื้นฐาน (ภาษาอังกฤษ) | 基础教育（英语）"
    },
    {
        "id":5618,
        "name":"5622 (English Program)  :  Basic Education (Science) | การศึกษาขั้นพื้นฐาน (วิทยาศาสตร์) | 基础教育（科学）"
    },
    {
        "id":5619,
        "name":"5623 (English Program)  :  Basic Education (Fine And Applied Arts) | การศึกษาขั้นพื้นฐาน (วิจิตรศิลป์และศิลปะประยุกต์) | 基础教育（美术和应用艺术）"
    },
    {
        "id":5620,
        "name":"5624 (English Program)  :  Basic Education (Chinese) | การศึกษาขั้นพื้นฐาน (ภาษาจีน) | 基础教育（中文）"
    },
    {
        "id":5621,
        "name":"5625 (English Program)  :  Basic Education (Thai) | การศึกษาขั้นพื้นฐาน (ไทย) | 基础教育（泰语）"
    },
    {
        "id":5622,
        "name":"5626 (English Program)  :  Basic Education (Social Studies) | การศึกษาขั้นพื้นฐาน (สังคมศึกษา) | 基础教育（社会学）"
    },
    {
        "id":5623,
        "name":"5627 (English Program)  :  Basic Education (Elementary Education) | การศึกษาขั้นพื้นฐาน (ประถมศึกษา) | 基础教育（小学教育）"
    },
    {
        "id":5624,
        "name":"5628 (English Program)  :  Electrical And Electronics Technology | เทคโนโลยีไฟฟ้าและอิเล็กทรอนิกส์ | 电气电子技术"
    },
    {
        "id":5625,
        "name":"5629 (English Program)  :  Automotive And Automotive Parts Technology | เทคโนโลยียานยนต์และชิ้นส่วนยานยนต์ | 汽车及汽车零部件技术"
    },
    {
        "id":5626,
        "name":"5630 (English Program)  :  Law And Human Rights Studies | การศึกษากฎหมายและสิทธิมนุษยชน | 法律和人权研究"
    },
    {
        "id":5627,
        "name":"5631 (English Program)  :  Lanscape Innovation And Management | นวัตกรรมและการจัดการ Lanscape | 景观创新与管理"
    },
    {
        "id":5628,
        "name":"5632 (English Program)  :  Biological Engineering | วิศวกรรมชีวภาพ | 生物工程"
    },
    {
        "id":5629,
        "name":"5633 (English Program)  :  Environmental And Resource Management | การจัดการสิ่งแวดล้อมและทรัพยากร | 环境和资源管理"
    },
    {
        "id":5630,
        "name":"5634 (English Program)  :  Human Rights And Development | สิทธิมนุษยชนและการพัฒนา | 人权与发展"
    },
    {
        "id":5631,
        "name":"5635 (English Program)  :  Computer Control | การควบคุมคอมพิวเตอร์ | 电脑控制"
    },
    {
        "id":5632,
        "name":"5636 (English Program)  :  Architecture Design Computer | คอมพิวเตอร์ออกแบบสถาปัตยกรรม | 建筑设计计算机"
    },
    {
        "id":5633,
        "name":"5637 (English Program)  :  Computer Graphic And Printing | คอมพิวเตอร์กราฟิกและการพิมพ์ | 计算机图形和印刷"
    },
    {
        "id":5634,
        "name":"5638 (English Program)  :  Product Management And E-Commerce | การจัดการผลิตภัณฑ์และอีคอมเมิร์ซ | 产品管理和电子商务"
    },
    {
        "id":5635,
        "name":"5639 (English Program)  :  Computer And Biomedical Engineering | วิศวกรรมคอมพิวเตอร์และชีวการแพทย์ | 计算机与生物医学工程"
    },
    {
        "id":5636,
        "name":"5640 (English Program)  :  English For Professions | ภาษาอังกฤษเพื่อวิชาชีพ | 职业英语"
    },
    {
        "id":5637,
        "name":"5641 (English Program)  :  Computer-Aided Design | การออกแบบโดยใช้คอมพิวเตอร์ช่วย | 计算机辅助设计"
    },
    {
        "id":5638,
        "name":"5642 (English Program)  :  Communication Art-Digital Media | การสื่อสาร ศิลปะ-สื่อดิจิทัล | 传播艺术-数字媒体"
    },
    {
        "id":5639,
        "name":"5643 (English Program)  :  Communication Art Technology | เทคโนโลยีศิลปะการสื่อสาร | 传播艺术科技"
    },
    {
        "id":5640,
        "name":"5644 (English Program)  :  Analytical Science | วิทยาศาสตร์เชิงวิเคราะห์ | 分析科学"
    },
    {
        "id":5641,
        "name":"5645 (English Program)  :  Textiles And Garments | สิ่งทอและเสื้อผ้า | 纺织品和服装"
    },
    {
        "id":5642,
        "name":"5646 (English Program)  :  Security Management | การจัดการความปลอดภัย | 安全管理"
    },
    {
        "id":5643,
        "name":"5647 (English Program)  :  Chinese For Tourism And Hospitality | ภาษาจีนเพื่อการท่องเที่ยวและการบริการ | 旅游和酒店业汉语"
    },
    {
        "id":5644,
        "name":"5648 (English Program)  :  Entertainment Management And Production | การจัดการและการผลิตความบันเทิง | 娱乐管理和制作"
    },
    {
        "id":5645,
        "name":"5649 (English Program)  :  Thai For Communication | ภาษาไทยเพื่อการสื่อสาร | 泰语交流"
    },
    {
        "id":5646,
        "name":"5650 (English Program)  :  English For Tourism Business | ภาษาอังกฤษเพื่อธุรกิจการท่องเที่ยว | 旅游商务英语"
    },
    {
        "id":5647,
        "name":"5651 (English Program)  :  Statistics And Computer | สถิติและคอมพิวเตอร์ | 统计和计算机"
    },
    {
        "id":5648,
        "name":"5652 (English Program)  :  Food And Services | อาหารและบริการ | 食品和服务"
    },
    {
        "id":5649,
        "name":"5653 (English Program)  :  Civil Engineering And Technology | วิศวกรรมโยธาและเทคโนโลยี | 土木工程与技术"
    },
    {
        "id":5650,
        "name":"5654 (English Program)  :  English For Business And Industry Communication | ภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจและอุตสาหกรรม | 商业和工业交流英语"
    },
    {
        "id":5651,
        "name":"5655 (English Program)  :  Multidisciplinary Industrial Science | วิทยาศาสตร์อุตสาหกรรมสหวิทยาการ | 多学科工业科学"
    },
    {
        "id":5652,
        "name":"5656 (English Program)  :  Food Enterprise | วิสาหกิจด้านอาหาร | 食品企业"
    },
    {
        "id":5653,
        "name":"5657 (English Program)  :  Medical Educational Technology | เทคโนโลยีการศึกษาทางการแพทย์ | 医学教育技术"
    },
    {
        "id":5654,
        "name":"5658 (English Program)  :  Advanced Midwifery | การผดุงครรภ์ขั้นสูง | 先进助产学"
    },
    {
        "id":5655,
        "name":"5659 (English Program)  :  Computer Network Engineering | วิศวกรรมเครือข่ายคอมพิวเตอร์ | 计算机网络工程"
    },
    {
        "id":5656,
        "name":"5660 (English Program)  :  Industrial Technology (Productiontechnology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีการผลิต) | 工业技术（生产技术）"
    },
    {
        "id":5657,
        "name":"5661 (English Program)  :  Industrial Technology (Industrial Technology Construction) | เทคโนโลยีอุตสาหกรรม (การก่อสร้างเทคโนโลยีอุตสาหกรรม) | 工业技术（工业技术建设）"
    },
    {
        "id":5658,
        "name":"5662 (English Program)  :  Industrial Technology (Industrial Electrical Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีไฟฟ้าอุตสาหกรรม) | 工业技术（工业电气技术）"
    },
    {
        "id":5659,
        "name":"5663 (English Program)  :  Industrial Technology (Electronic Computer) | เทคโนโลยีอุตสาหกรรม (คอมพิวเตอร์อิเล็กทรอนิกส์) | 工业技术（电子计算机）"
    },
    {
        "id":5660,
        "name":"5664 (English Program)  :  Industrial Technology (Industrial Computer) | เทคโนโลยีอุตสาหกรรม (คอมพิวเตอร์อุตสาหกรรม) | 工业技术（工业计算机）"
    },
    {
        "id":5661,
        "name":"5665 (English Program)  :  Business And Public Sector Economics | เศรษฐศาสตร์ธุรกิจและภาครัฐ | 商业和公共部门经济学"
    },
    {
        "id":5662,
        "name":"5666 (English Program)  :  Business Management And English | การจัดการธุรกิจและภาษาอังกฤษ | 商业管理和英语"
    },
    {
        "id":5663,
        "name":"5667 (English Program)  :  Interdisciplinary Study For Local Development | การศึกษาแบบสหวิทยาการเพื่อการพัฒนาท้องถิ่น | 地方发展的跨学科研究"
    },
    {
        "id":5664,
        "name":"5668 (English Program)  :  Food Business Management | การจัดการธุรกิจอาหาร | 食品企业管理"
    },
    {
        "id":5665,
        "name":"5669 (English Program)  :  Digital Media Design | การออกแบบสื่อดิจิทัล | 数字媒体设计"
    },
    {
        "id":5666,
        "name":"5670 (English Program)  :  Multimedia Animation | แอนิเมชันมัลติมีเดีย | 多媒体动画"
    },
    {
        "id":5667,
        "name":"5671 (English Program)  :  Teaching Chinese Language | การสอนภาษาจีน | 汉语教学"
    },
    {
        "id":5668,
        "name":"5672 (English Program)  :  Business Administration (General Management) | การบริหารธุรกิจ (การจัดการทั่วไป) | 工商管理（综合管理）"
    },
    {
        "id":5669,
        "name":"5673 (English Program)  :  Business Administration (Financial And Banking) | การบริหารธุรกิจ (การเงินและการธนาคาร) | 工商管理（金融和银行）"
    },
    {
        "id":5670,
        "name":"5674 (English Program)  :  Industrial Technology (Industrial) | เทคโนโลยีอุตสาหกรรม (อุตสาหกรรม) | 工业技术（工业）"
    },
    {
        "id":5671,
        "name":"5675 (English Program)  :  Industrial Technology (Civil) | เทคโนโลยีอุตสาหกรรม (โยธา) | 工业技术（民用）"
    },
    {
        "id":5672,
        "name":"5676 (English Program)  :  Bioproducts Science | วิทยาศาสตร์ผลิตภัณฑ์ชีวภาพ | 生物产品科学"
    },
    {
        "id":5673,
        "name":"5677 (English Program)  :  Silviculture Technology | เทคโนโลยีวนวัฒนวิทยา | 造林技术"
    },
    {
        "id":5674,
        "name":"5678 (English Program)  :  Forest Conservation | การอนุรักษ์ป่าไม้ | 森林保护"
    },
    {
        "id":5675,
        "name":"5679 (English Program)  :  Built Environment | สภาพแวดล้อมที่สร้างขึ้น | 建筑环境"
    },
    {
        "id":5676,
        "name":"5680 (English Program)  :  Integrated Chemical Engineering | วิศวกรรมเคมีแบบบูรณาการ | 综合化学工程"
    },
    {
        "id":5677,
        "name":"5681 (English Program)  :  Interactive And Multimedia Design | การออกแบบเชิงโต้ตอบและมัลติมีเดีย | 互动和多媒体设计"
    },
    {
        "id":5678,
        "name":"5682 (English Program)  :  Cyber Business Management | การจัดการธุรกิจไซเบอร์ | 网络业务管理"
    },
    {
        "id":5679,
        "name":"5683 (English Program)  :  Computer Communication | การสื่อสารคอมพิวเตอร์ | 计算机通讯"
    },
    {
        "id":5680,
        "name":"5684 (English Program)  :  Social Communication Innovation | นวัตกรรมการสื่อสารทางสังคม | 社交传播创新"
    },
    {
        "id":5681,
        "name":"5685 (English Program)  :  Bechelor Of Technology | ปริญญาตรีสาขาเทคโนโลยี | 技术学士"
    },
    {
        "id":5682,
        "name":"5686 (English Program)  :  Sports And Recreation Management | การจัดการกีฬาและสันทนาการ | 体育和休闲管理"
    },
    {
        "id":5683,
        "name":"5687 (English Program)  :  Innovative Management | การจัดการที่เป็นนวัตกรรม | 创新管理"
    },
    {
        "id":5684,
        "name":"5688 (English Program)  :  Industrial Management And Logistics | การจัดการอุตสาหกรรมและโลจิสติกส์ | 工业管理与物流"
    },
    {
        "id":5685,
        "name":"5689 (English Program)  :  Financial Investment And Risk Management | การลงทุนทางการเงินและการบริหารความเสี่ยง | 金融投资与风险管理"
    },
    {
        "id":5686,
        "name":"5690 (English Program)  :  Aeronautical Engineering | วิศวกรรมการบิน | 航空工程"
    },
    {
        "id":5687,
        "name":"5691 (English Program)  :  Integrated Science - Mathematics | วิทยาศาสตร์บูรณาการ - คณิตศาสตร์ | 综合科学 - 数学"
    },
    {
        "id":5688,
        "name":"5692 (English Program)  :  Agricultural Extension And Rural Development | การขยายการเกษตรและการพัฒนาชนบท | 农业推广和农村发展"
    },
    {
        "id":5689,
        "name":"5693 (English Program)  :  Soil Science And Natural Resources Management | วิทยาศาสตร์ดินและการจัดการทรัพยากรธรรมชาติ | 土壤科学和自然资源管理"
    },
    {
        "id":5690,
        "name":"5694 (English Program)  :  Pharmacy Management | การจัดการเภสัชกรรม | 药房管理"
    },
    {
        "id":5691,
        "name":"5695 (English Program)  :  Orthopaedics | ศัลยกรรมกระดูก | 骨科"
    },
    {
        "id":5692,
        "name":"5696 (English Program)  :  Medical Radiotion Sciences | วิทยาศาสตร์รังสีการแพทย์ | 医学放射科学"
    },
    {
        "id":5693,
        "name":"5697 (English Program)  :  Communications Studies | การศึกษาการสื่อสาร | 传播学"
    },
    {
        "id":5694,
        "name":"5698 (English Program)  :  Media Arts And Design | สื่อศิลปะและการออกแบบ | 媒体艺术与设计"
    },
    {
        "id":5695,
        "name":"5699 (English Program)  :  Art Of Photography | ศิลปะแห่งการถ่ายภาพ | 摄影艺术"
    },
    {
        "id":5696,
        "name":"5700 (English Program)  :  Thai Crafts | หัตถกรรมไทย | 泰国工艺品"
    },
    {
        "id":5697,
        "name":"5701 (English Program)  :  Integrated Communication | การสื่อสารแบบบูรณาการ | 综合通讯"
    },
    {
        "id":5698,
        "name":"5702 (English Program)  :  Applied Biological Sciences | วิทยาศาสตร์ชีวภาพประยุกต์ | 应用生物科学"
    },
    {
        "id":5699,
        "name":"5703 (English Program)  :  Environmental Toxicology | พิษวิทยาสิ่งแวดล้อม | 环境毒理学"
    },
    {
        "id":5700,
        "name":"5704 (English Program)  :  Agricultural And Food Engineering | วิศวกรรมเกษตรและอาหาร | 农业与食品工程"
    },
    {
        "id":5701,
        "name":"5705 (English Program)  :  Multidisciplinary Design Research | การวิจัยการออกแบบแบบสหวิทยาการ | 多学科设计研究"
    },
    {
        "id":5702,
        "name":"5706 (English Program)  :  Educational Innovation Research | การวิจัยนวัตกรรมการศึกษา | 教育创新研究"
    },
    {
        "id":5703,
        "name":"5707 (English Program)  :  Technopreneurship And Innovation Management | การจัดการเทคโนโลยีและนวัตกรรม | 科技创业与创新管理"
    },
    {
        "id":5704,
        "name":"5708 (English Program)  :  Nanoscience And Technology | นาโนวิทยาศาสตร์และเทคโนโลยี | 纳米科学与技术"
    },
    {
        "id":5705,
        "name":"5709 (English Program)  :  International Development Studies | การศึกษาการพัฒนาระหว่างประเทศ | 国际发展研究"
    },
    {
        "id":5706,
        "name":"5710 (English Program)  :  Pediatric Hematology\/Oncology | โลหิตวิทยาในเด็ก\/เนื้องอกวิทยา | 儿科血液学\/肿瘤学"
    },
    {
        "id":5707,
        "name":"5711 (English Program)  :  Infrastructure In Civil Engineering | โครงสร้างพื้นฐานทางวิศวกรรมโยธา | 土木工程基础设施"
    },
    {
        "id":5708,
        "name":"5712 (English Program)  :  Japanese As A Foreign Language | ภาษาญี่ปุ่นเป็นภาษาต่างประเทศ | 日语作为外语"
    },
    {
        "id":5709,
        "name":"5713 (English Program)  :  Nuclear Medicine | เวชศาสตร์นิวเคลียร์ | 核医学"
    },
    {
        "id":5710,
        "name":"5714 (English Program)  :  French For The Business World | ภาษาฝรั่งเศสสำหรับโลกธุรกิจ | 商业法语"
    },
    {
        "id":5711,
        "name":"5715 (English Program)  :  Fuel Technology | เทคโนโลยีเชื้อเพลิง | 燃料技术"
    },
    {
        "id":5712,
        "name":"5716 (English Program)  :  Computer Science And Information | วิทยาศาสตร์คอมพิวเตอร์และข้อมูล | 计算机科学与信息"
    },
    {
        "id":5713,
        "name":"5717 (English Program)  :  Corporate Governance | การกำกับดูแลกิจการ | 公司治理"
    },
    {
        "id":5714,
        "name":"5718 (English Program)  :  Tools And Die Engineering | เครื่องมือและวิศวกรรมแม่พิมพ์ | 工具和模具工程"
    },
    {
        "id":5715,
        "name":"5719 (English Program)  :  Teaching Chinese As A Foreign Language | การสอนภาษาจีนเป็นภาษาต่างประเทศ | 对外汉语教学"
    },
    {
        "id":5716,
        "name":"5720 (English Program)  :  Folk Music And Performance | ดนตรีพื้นบ้านและการแสดง | 民间音乐和表演"
    },
    {
        "id":5717,
        "name":"5721 (English Program)  :  Design (Industrial Design) | การออกแบบ (การออกแบบอุตสาหกรรม) | 设计（工业设计）"
    },
    {
        "id":5718,
        "name":"5722 (English Program)  :  Design (Computer Graphic) | การออกแบบ (คอมพิวเตอร์กราฟิก) | 设计（计算机图形）"
    },
    {
        "id":5719,
        "name":"5723 (English Program)  :  Design (Packaging Design) | การออกแบบ (การออกแบบบรรจุภัณฑ์) | 设计（包装设计）"
    },
    {
        "id":5720,
        "name":"5724 (English Program)  :  Administrative Science | วิทยาศาสตร์การบริหาร | 行政科学"
    },
    {
        "id":5721,
        "name":"5725 (English Program)  :  Film | ฟิล์ม | 电影"
    },
    {
        "id":5722,
        "name":"5726 (English Program)  :  Pharmacology And Biomolecular Sciences | เภสัชวิทยาและวิทยาศาสตร์ชีวโมเลกุล | 药理学和生物分子科学"
    },
    {
        "id":5723,
        "name":"5727 (English Program)  :  Classical Music | ดนตรีคลาสสิก | 古典音乐"
    },
    {
        "id":5724,
        "name":"5728 (English Program)  :  Computer And Network Engineering | วิศวกรรมคอมพิวเตอร์และเครือข่าย | 计算机与网络工程"
    },
    {
        "id":5725,
        "name":"5729 (English Program)  :  Telecommunications And Electronics Engineering | วิศวกรรมโทรคมนาคมและอิเล็กทรอนิกส์ | 电信和电子工程"
    },
    {
        "id":5726,
        "name":"5730 (English Program)  :  Agriculture(Agro-Chemistry) | เกษตร(เคมีเกษตร) | 农业（农业化学）"
    },
    {
        "id":5727,
        "name":"5731 (English Program)  :  Agro-Process Engineering | วิศวกรรมเกษตรกระบวนการ | 农业加工工程"
    },
    {
        "id":5728,
        "name":"5732 (English Program)  :  Geosocial Based Sustainable Development | การพัฒนาอย่างยั่งยืนบนพื้นฐานภูมิศาสตร์สังคม | 基于地理社会的可持续发展"
    },
    {
        "id":5729,
        "name":"5733 (English Program)  :  Recreation And Tourism Management | การจัดการนันทนาการและการท่องเที่ยว | 休闲与旅游管理"
    },
    {
        "id":5730,
        "name":"5734 (English Program)  :  Materials Science(Rubber Industry) | วิทยาศาสตร์วัสดุ(อุตสาหกรรมยาง) | 材料科学（橡胶工业）"
    },
    {
        "id":5731,
        "name":"5735 (English Program)  :  Conflict Management | การจัดการความขัดแย้ง | 冲突管理"
    },
    {
        "id":5732,
        "name":"5736 (English Program)  :  Design And Planning | การออกแบบและการวางแผน | 设计与规划"
    },
    {
        "id":5733,
        "name":"5737 (English Program)  :  Electronic And Computer System Engineering | วิศวกรรมระบบอิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子与计算机系统工程"
    },
    {
        "id":5734,
        "name":"5738 (English Program)  :  Web Programming And Security | การเขียนโปรแกรมเว็บและความปลอดภัย | 网络编程和安全"
    },
    {
        "id":5735,
        "name":"5739 (English Program)  :  Tourism And Sufficiency Economy | การท่องเที่ยวและเศรษฐกิจพอเพียง | 旅游业与自给自足经济"
    },
    {
        "id":5736,
        "name":"5740 (English Program)  :  Strategic Management Information System | ระบบสารสนเทศการจัดการเชิงกลยุทธ์ | 战略管理信息系统"
    },
    {
        "id":5737,
        "name":"5741 (English Program)  :  Biotechnology Management | การจัดการเทคโนโลยีชีวภาพ | 生物技术管理"
    },
    {
        "id":5738,
        "name":"5742 (English Program)  :  Quality Of Educational Management | คุณภาพของการจัดการการศึกษา | 教育管理质量"
    },
    {
        "id":5739,
        "name":"5743 (English Program)  :  Mathematics-Educational Research And Evaluation | การวิจัยและประเมินผลคณิตศาสตร์-การศึกษา | 数学教育研究与评价"
    },
    {
        "id":5740,
        "name":"5744 (English Program)  :  Justice Administration And Society | การบริหารความยุติธรรมและสังคม | 司法行政与社会"
    },
    {
        "id":5741,
        "name":"5745 (English Program)  :  Biomedical Electronics | อิเล็กทรอนิกส์ชีวการแพทย์ | 生物医学电子"
    },
    {
        "id":5742,
        "name":"5746 (English Program)  :  Food Catering Technology | เทคโนโลยีการจัดเลี้ยงอาหาร | 食品餐饮技术"
    },
    {
        "id":5743,
        "name":"5747 (Thai Program)  :  Creative Media Technology | ครีเอทีฟมีเดียเทคโนโลยี | 创意媒体技术"
    },
    {
        "id":5744,
        "name":"5748 (English Program)  :  Strategic Logistics Management | การจัดการโลจิสติกส์เชิงกลยุทธ์ | 战略物流管理"
    },
    {
        "id":5745,
        "name":"5749 (English Program)  :  Business English Communication | การสื่อสารภาษาอังกฤษธุรกิจ | 商务英语交流"
    },
    {
        "id":5746,
        "name":"5750 (English Program)  :  New Technology Ventures | การลงทุนด้านเทคโนโลยีใหม่ | 新技术企业"
    },
    {
        "id":5747,
        "name":"5751 (English Program)  :  Educational Leadership And Innovation | ความเป็นผู้นำด้านการศึกษาและนวัตกรรม | 教育领导力和创新"
    },
    {
        "id":5748,
        "name":"5752 (English Program)  :  Science And Technology Education | การศึกษาวิทยาศาสตร์และเทคโนโลยี | 科技教育"
    },
    {
        "id":5749,
        "name":"5753 (English Program)  :  Continuing Program | โปรแกรมต่อเนื่อง | 继续课程"
    },
    {
        "id":5750,
        "name":"5754 (English Program)  :  Information And Computer Management | การจัดการข้อมูลและคอมพิวเตอร์ | 信息和计算机管理"
    },
    {
        "id":5751,
        "name":"5755 (English Program)  :  Molecular Biology And Bioinformatics | อณูชีววิทยาและชีวสารสนเทศศาสตร์ | 分子生物学和生物信息学"
    },
    {
        "id":5752,
        "name":"5756 (English Program)  :  Business Administration (Ceo) | การบริหารธุรกิจ (Ceo) | 工商管理（首席执行官）"
    },
    {
        "id":5753,
        "name":"5757 (English Program)  :  Automotive Industry Management | การจัดการอุตสาหกรรมยานยนต์ | 汽车行业管理"
    },
    {
        "id":5754,
        "name":"5758 (English Program)  :  Thai Performing Arts | ศิลปะการแสดงไทย | 泰国表演艺术"
    },
    {
        "id":5755,
        "name":"5759 (English Program)  :  Thai Popular Music (Luk Krung) | เพลงฮิตไทย (ลูกกรุง) | 泰国流行音乐（Luk Krung）"
    },
    {
        "id":5756,
        "name":"5760 (English Program)  :  Popular Music | เพลงยอดนิยม | 流行音乐"
    },
    {
        "id":5757,
        "name":"5761 (English Program)  :  Money And Banking | เงินและการธนาคาร | 货币与银行业"
    },
    {
        "id":5758,
        "name":"5762 (English Program)  :  Physical And Minor | ทางกายภาพและรอง | 身体和未成年人"
    },
    {
        "id":5759,
        "name":"5763 (English Program)  :  Educational Development | การพัฒนาการศึกษา | 教育发展"
    },
    {
        "id":5760,
        "name":"5764 (English Program)  :  Geographic Information For Local Development | ข้อมูลภูมิศาสตร์เพื่อการพัฒนาท้องถิ่น | 促进当地发展的地理信息"
    },
    {
        "id":5761,
        "name":"5765 (English Program)  :  Special Education Administration | การบริหารการศึกษาพิเศษ | 特殊教育管理局"
    },
    {
        "id":5762,
        "name":"5766 (English Program)  :  Textile Chemistry | เคมีสิ่งทอ | 纺织化学"
    },
    {
        "id":5763,
        "name":"5767 (English Program)  :  Language And Literature | ภาษาและวรรณคดี | 语言和文学"
    },
    {
        "id":5764,
        "name":"5768 (English Program)  :  Advanced Nursing | การพยาบาลขั้นสูง | 高级护理"
    },
    {
        "id":5765,
        "name":"5769 (English Program)  :  Electrical And Information Engineering | วิศวกรรมไฟฟ้าและสารสนเทศ | 电气与信息工程"
    },
    {
        "id":5766,
        "name":"5770 (English Program)  :  Primary Care System Development | การพัฒนาระบบการดูแลเบื้องต้น | 初级保健系统的发展"
    },
    {
        "id":5767,
        "name":"5771 (English Program)  :  Educational Leadership And Human Resource Development | ความเป็นผู้นำด้านการศึกษาและการพัฒนาทรัพยากรมนุษย์ | 教育领导力和人力资源开发"
    },
    {
        "id":5768,
        "name":"5772 (English Program)  :  Mekong And Salween River Basins Regional Studies | การศึกษาระดับภูมิภาคลุ่มแม่น้ำโขงและแม่น้ำสาละวิน | 湄公河和萨尔温江流域区域研究"
    },
    {
        "id":5769,
        "name":"5773 (English Program)  :  Applied Management | การจัดการประยุกต์ | 应用管理"
    },
    {
        "id":5770,
        "name":"5774 (English Program)  :  Research For Administration And Management | การวิจัยเพื่อการบริหารและการจัดการ | 行政管理研究"
    },
    {
        "id":5771,
        "name":"5775 (English Program)  :  Risk Management,Insurance And Actuarial Science | การจัดการความเสี่ยง ประกันภัย และคณิตศาสตร์ประกันภัย | 风险管理、保险和精算学"
    },
    {
        "id":5772,
        "name":"5776 (English Program)  :  Contemplative Education And Transformative Learning | การศึกษาแบบไตร่ตรองและการเรียนรู้เชิงเปลี่ยนแปลง | 沉思性教育和变革性学习"
    },
    {
        "id":5773,
        "name":"5777 (English Program)  :  Agriculture (Agricultural Extension) | การเกษตร (ส่วนขยายการเกษตร) | 农业（农业推广）"
    },
    {
        "id":5774,
        "name":"5778 (English Program)  :  Agriculture (Pomology) | การเกษตร (Pomology) | 农业（果树学）"
    },
    {
        "id":5775,
        "name":"5779 (English Program)  :  Agriculture (Beef Cattle And Dairy) | การเกษตร (โคเนื้อและผลิตภัณฑ์นม) | 农业（肉牛和乳制品）"
    },
    {
        "id":5776,
        "name":"5780 (English Program)  :  Tropical Agricultural Resource Management | การจัดการทรัพยากรเกษตรเขตร้อน | 热带农业资源管理"
    },
    {
        "id":5777,
        "name":"5781 (English Program)  :  Health Service Business Management | การจัดการธุรกิจบริการสุขภาพ | 健康服务业务管理"
    },
    {
        "id":5778,
        "name":"5782 (English Program)  :  Maharishi Vedic Science | วิทยาศาสตร์เวทมหาฤษี | 玛赫西吠陀科学"
    },
    {
        "id":5779,
        "name":"5783 (English Program)  :  Human Resource Administration | การบริหารทรัพยากรมนุษย์ | 人力资源管理"
    },
    {
        "id":5780,
        "name":"5784 (English Program)  :  Government And Administration | การปกครองและการบริหาร | 政府及行政部门"
    },
    {
        "id":5781,
        "name":"5785 (English Program)  :  Culture And Development | วัฒนธรรมและการพัฒนา | 文化与发展"
    },
    {
        "id":5782,
        "name":"5786 (English Program)  :  Public Organization | องค์การมหาชน | 公共组织"
    },
    {
        "id":5783,
        "name":"5787 (English Program)  :  Local Governance | การปกครองท้องถิ่น | 地方治理"
    },
    {
        "id":5784,
        "name":"5788 (English Program)  :  Business Modeling And Analysis | การสร้างแบบจำลองและการวิเคราะห์ธุรกิจ | 业务建模与分析"
    },
    {
        "id":5785,
        "name":"5789 (English Program)  :  Educational Administration And Leadership | การบริหารการศึกษาและการเป็นผู้นำ | 教育行政和领导"
    },
    {
        "id":5786,
        "name":"5790 (English Program)  :  Hotel Studies And Tourism | การศึกษาการโรงแรมและการท่องเที่ยว | 酒店研究和旅游"
    },
    {
        "id":5787,
        "name":"5791 (English Program)  :  Newspaper And Publications | หนังสือพิมพ์และสิ่งพิมพ์ | 报纸和出版物"
    },
    {
        "id":5788,
        "name":"5792 (English Program)  :  Digital Media | สื่อดิจิทัล | 数字媒体"
    },
    {
        "id":5789,
        "name":"5793 (English Program)  :  Aesthetic Sciences And Health | วิทยาศาสตร์ความงามและสุขภาพ | 美容科学与健康"
    },
    {
        "id":5790,
        "name":"5794 (English Program)  :  Holistic Education | การศึกษาแบบองค์รวม | 全人教育"
    },
    {
        "id":5791,
        "name":"5795 (English Program)  :  Community And Environmental Architecture | สถาปัตยกรรมชุมชนและสิ่งแวดล้อม | 社区与环境建筑"
    },
    {
        "id":5792,
        "name":"5796 (English Program)  :  Civil And System Engineering Management | การจัดการวิศวกรรมโยธาและระบบ | 土木及系统工程管理"
    },
    {
        "id":5793,
        "name":"5797 (English Program)  :  Educational And Learning Management | การจัดการศึกษาและการเรียนรู้ | 教育和学习管理"
    },
    {
        "id":5794,
        "name":"5798 (English Program)  :  Hospitality Industry And Tourism Management | อุตสาหกรรมการบริการและการจัดการการท่องเที่ยว | 酒店业和旅游管理"
    },
    {
        "id":5795,
        "name":"5799 (English Program)  :  Film - Video | ภาพยนตร์ - วิดีโอ | 电影-视频"
    },
    {
        "id":5796,
        "name":"5800 (English Program)  :  Muay Thai Study | มวยไทยศึกษา | 泰拳学习"
    },
    {
        "id":5797,
        "name":"5801 (English Program)  :  Technology Management Of Agricultural Produces And Packaging | การจัดการเทคโนโลยีผลิตผลทางการเกษตรและบรรจุภัณฑ์ | 农产品及包装技术管理"
    },
    {
        "id":5798,
        "name":"5802 (English Program)  :  Integrated Engineering Management | การจัดการวิศวกรรมบูรณาการ | 综合工程管理"
    },
    {
        "id":5799,
        "name":"5803 (English Program)  :  English-Thai Translation | การแปลภาษาอังกฤษเป็นภาษาไทย | 英泰翻译"
    },
    {
        "id":5800,
        "name":"5804 (English Program)  :  Clinical Laboratory Science | วิทยาศาสตร์ห้องปฏิบัติการทางคลินิก | 临床实验室科学"
    },
    {
        "id":5801,
        "name":"5805 (English Program)  :  Modern And Contemporary Chinese Literature | วรรณกรรมจีนสมัยใหม่และร่วมสมัย | 中国现当代文学"
    },
    {
        "id":5802,
        "name":"5806 (English Program)  :  Aviation | การบิน | 航空"
    },
    {
        "id":5803,
        "name":"5807 (English Program)  :  Media And Entertainment Management | การจัดการสื่อและความบันเทิง | 媒体和娱乐管理"
    },
    {
        "id":5804,
        "name":"5808 (English Program)  :  Administration Of Organization Development | การบริหารการพัฒนาองค์กร | 组织发展管理"
    },
    {
        "id":5805,
        "name":"5809 (English Program)  :  Computer Multimedia | คอมพิวเตอร์มัลติมีเดีย | 电脑多媒体"
    },
    {
        "id":5806,
        "name":"5810 (English Program)  :  Vietnamese Studies | การศึกษาภาษาเวียดนาม | 越南研究"
    },
    {
        "id":5807,
        "name":"5811 (English Program)  :  Food Safety Management | การจัดการความปลอดภัยของอาหาร | 食品安全管理"
    },
    {
        "id":5808,
        "name":"5812 (English Program)  :  Tai Studies | หรือการศึกษา | 太极研究"
    },
    {
        "id":5809,
        "name":"5813 (English Program)  :  Technology And Electronic Commerce Management | การจัดการเทคโนโลยีและพาณิชย์อิเล็กทรอนิกส์ | 技术与电子商务管理"
    },
    {
        "id":5810,
        "name":"5814 (English Program)  :  Management Of Learning Resources | การจัดการทรัพยากรการเรียนรู้ | 学习资源的管理"
    },
    {
        "id":5811,
        "name":"5815 (English Program)  :  Sport And Health Management | การจัดการกีฬาและสุขภาพ | 运动与健康管理"
    },
    {
        "id":5812,
        "name":"5816 (English Program)  :  Health Management For The Elderly | การจัดการสุขภาพสำหรับผู้สูงอายุ | 老年人健康管理"
    },
    {
        "id":5813,
        "name":"5817 (English Program)  :  Educational Administration And Development | การบริหารและพัฒนาการศึกษา | 教育管理与发展"
    },
    {
        "id":5814,
        "name":"5818 (English Program)  :  Administration And Management | การบริหารและการจัดการ | 行政与管理"
    },
    {
        "id":5815,
        "name":"5819 (English Program)  :  Biodiversity | ความหลากหลายทางชีวภาพ | 生物多样性"
    },
    {
        "id":5816,
        "name":"5820 (English Program)  :  Landscape Innovation And Management | นวัตกรรมภูมิทัศน์และการจัดการ | 景观创新与管理"
    },
    {
        "id":5817,
        "name":"5821 (English Program)  :  Palaeontology | บรรพชีวินวิทยา | 古生物学"
    },
    {
        "id":5818,
        "name":"5822 (English Program)  :  Public Administration And Public Affairs | การบริหารราชการและกิจการสาธารณะ | 公共管理和公共事务"
    },
    {
        "id":5819,
        "name":"5824 (English Program)  :  Thai As A Foreign Language | ภาษาไทยเป็นภาษาต่างประเทศ | 泰语作为外语"
    },
    {
        "id":5820,
        "name":"5825 (English Program)  :  Lao | ลาว | 老挝"
    },
    {
        "id":5821,
        "name":"5826 (English Program)  :  Geo-Informatics | ภูมิศาสตร์สารสนเทศ | 地理信息学"
    },
    {
        "id":5822,
        "name":"5827 (English Program)  :  Laos Studies | ลาวศึกษา | 老挝研究"
    },
    {
        "id":5823,
        "name":"5828 (English Program)  :  Cultural Science | วิทยาศาสตร์วัฒนธรรม | 文化科学"
    },
    {
        "id":5824,
        "name":"5829 (English Program)  :  General Sciences | วิทยาศาสตร์ทั่วไป | 普通科学"
    },
    {
        "id":5825,
        "name":"5830 (English Program)  :  Civil Engineering (Rural Engineering) | วิศวกรรมโยธา (วิศวกรรมชนบท) | 土木工程（农村工程）"
    },
    {
        "id":5826,
        "name":"5831 (English Program)  :  Building System Engineering | วิศวกรรมระบบอาคาร | 建筑系统工程"
    },
    {
        "id":5827,
        "name":"5832 (English Program)  :  Medicinal Plants And Natural Products | พืชสมุนไพรและผลิตภัณฑ์จากธรรมชาติ | 药用植物和天然产品"
    },
    {
        "id":5828,
        "name":"5833 (English Program)  :  Organization Development And Management | การพัฒนาและการจัดการองค์กร | 组织发展与管理"
    },
    {
        "id":5829,
        "name":"5834 (English Program)  :  Teacher Education | การศึกษาของครู | 教师教育"
    },
    {
        "id":5830,
        "name":"5835 (English Program)  :  Supply Chain ​​Management | การจัดการห่วงโซ่อุปทาน | 供应链管理"
    },
    {
        "id":5831,
        "name":"5836 (English Program)  :  Internet And E-Commerce Technology | เทคโนโลยีอินเทอร์เน็ตและอีคอมเมิร์ซ | 互联网与电子商务技术"
    },
    {
        "id":5832,
        "name":"5837 (English Program)  :  Individual And Family Studies | การศึกษารายบุคคลและครอบครัว | 个人和家庭研究"
    },
    {
        "id":5833,
        "name":"5838 (English Program)  :  Food Biotechnology | เทคโนโลยีชีวภาพอาหาร | 食品生物技术"
    },
    {
        "id":5834,
        "name":"5839 (English Program)  :  Applied Professional Studies | การศึกษาวิชาชีพประยุกต์ | 应用专业学习"
    },
    {
        "id":5835,
        "name":"5840 (English Program)  :  Chinese For Economic And Trade | ภาษาจีนเพื่อเศรษฐกิจและการค้า | 经贸汉语"
    },
    {
        "id":5836,
        "name":"5841 (English Program)  :  Forest Resource And Environmental Administration | การบริหารทรัพยากรป่าไม้และสิ่งแวดล้อม | 森林资源和环境管理"
    },
    {
        "id":5837,
        "name":"5842 (English Program)  :  Business Thai | ธุรกิจไทย | 商务泰语"
    },
    {
        "id":5838,
        "name":"5843 (English Program)  :  Food Business And Nutrition | ธุรกิจอาหารและโภชนาการ | 食品业务和营养"
    },
    {
        "id":5839,
        "name":"5844 (English Program)  :  Innovation And Computer Education | นวัตกรรมและการศึกษาคอมพิวเตอร์ | 创新与计算机教育"
    },
    {
        "id":5840,
        "name":"5845 (English Program)  :  Business Adminisatration (Human Resoure Management) | การบริหารธุรกิจ (การจัดการทรัพยากรมนุษย์) | 工商管理（人力资源管理）"
    },
    {
        "id":5841,
        "name":"5846 (English Program)  :  Public Administration (Public Management Administration) | การบริหารงานสาธารณะ (การบริหารงานสาธารณะ) | 公共管理（公共管理行政）"
    },
    {
        "id":5842,
        "name":"5847 (English Program)  :  Public Administration (Justice And Law Administration) | การบริหารสาธารณะ (ความยุติธรรมและการบริหารกฎหมาย) | 公共行政（司法和法律行政）"
    },
    {
        "id":5843,
        "name":"5848 (English Program)  :  Agriculture (Agricultural Resource And Evironmental Management) | การเกษตร (ทรัพยากรการเกษตรและการจัดการสิ่งแวดล้อม) | 农业（农业资源和环境管理）"
    },
    {
        "id":5844,
        "name":"5849 (English Program)  :  Agriculture (Information Technology And Agricultural Service) | การเกษตร (เทคโนโลยีสารสนเทศและบริการการเกษตร) | 农业（信息技术和农业服务）"
    },
    {
        "id":5845,
        "name":"5850 (English Program)  :  Agriculture (Food And Agricultural Business Management) | เกษตร (การจัดการอาหารและธุรกิจการเกษตร) | 农业（食品和农业商业管理）"
    },
    {
        "id":5846,
        "name":"5851 (English Program)  :  Agriculturre (Agro-Tourism) | การเกษตร (การท่องเที่ยวเชิงเกษตร) | 农业（农业旅游）"
    },
    {
        "id":5847,
        "name":"5852 (English Program)  :  Kitchen And Restaurant Management | การจัดการห้องครัวและร้านอาหาร | 厨房和餐厅管理"
    },
    {
        "id":5848,
        "name":"5853 (English Program)  :  Beauty Technology | เทคโนโลยีความงาม | 美容科技"
    },
    {
        "id":5849,
        "name":"5854 (English Program)  :  Information And Communication Technology For Embedded Systems | เทคโนโลยีสารสนเทศและการสื่อสารสำหรับระบบสมองกลฝังตัว | 嵌入式系统的信息和通信技术"
    },
    {
        "id":5850,
        "name":"5855 (English Program)  :  Engineering And Urban Management | วิศวกรรมศาสตร์และการจัดการเมือง | 工程与城市管理"
    },
    {
        "id":5851,
        "name":"5856 (English Program)  :  Tool And Die Technology | เทคโนโลยีเครื่องมือและแม่พิมพ์ | 工具和模具技术"
    },
    {
        "id":5852,
        "name":"5857 (English Program)  :  Information Technology Service Science | วิทยาการบริการเทคโนโลยีสารสนเทศ | 信息技术服务科学"
    },
    {
        "id":5853,
        "name":"5858 (English Program)  :  Physical Education And Health Promotion | พลศึกษาและการส่งเสริมสุขภาพ | 体育教育和健康促进"
    },
    {
        "id":5854,
        "name":"5859 (English Program)  :  Fine And Applied Arts (Digital Arts) | วิจิตรศิลป์และศิลปะประยุกต์ (Digital Arts) | 美术与应用艺术（数字艺术）"
    },
    {
        "id":5855,
        "name":"5860 (English Program)  :  Hospitality Industry For Tourism | อุตสาหกรรมการบริการเพื่อการท่องเที่ยว | 旅游业的接待业"
    },
    {
        "id":5856,
        "name":"5861 (English Program)  :  Arts Music Education | การศึกษาดนตรีศิลปะ | 艺术音乐教育"
    },
    {
        "id":5857,
        "name":"5862 (English Program)  :  Computer And Multimedia Engineering | วิศวกรรมคอมพิวเตอร์และมัลติมีเดีย | 计算机与多媒体工程"
    },
    {
        "id":5858,
        "name":"5863 (English Program)  :  Telecommunications Engineering | วิศวกรรมโทรคมนาคม | 电信工程"
    },
    {
        "id":5859,
        "name":"5864 (English Program)  :  Electrical And Energy Engineering | วิศวกรรมไฟฟ้าและพลังงาน | 电气与能源工程"
    },
    {
        "id":5860,
        "name":"5865 (English Program)  :  Public Policy And Strategic Management | นโยบายสาธารณะและการจัดการเชิงกลยุทธ์ | 公共政策和战略管理"
    },
    {
        "id":5861,
        "name":"5866 (English Program)  :  Human Capital Management | การจัดการทุนมนุษย์ | 人力资本管理"
    },
    {
        "id":5862,
        "name":"5867 (English Program)  :  Economics And Human Capital | เศรษฐศาสตร์และทุนมนุษย์ | 经济与人力资本"
    },
    {
        "id":5863,
        "name":"5868 (English Program)  :  Computer Game Multimedia | มัลติมีเดียเกมคอมพิวเตอร์ | 电脑游戏多媒体"
    },
    {
        "id":5864,
        "name":"5869 (English Program)  :  Internal Auditing | การตรวจสอบภายใน | 内部审计"
    },
    {
        "id":5865,
        "name":"5870 (English Program)  :  Financial Globalization Study | การศึกษาโลกาภิวัตน์ทางการเงิน | 金融全球化研究"
    },
    {
        "id":5866,
        "name":"5871 (English Program)  :  Construction Engineering Technology | เทคโนโลยีวิศวกรรมก่อสร้าง | 建筑工程技术"
    },
    {
        "id":5867,
        "name":"5872 (English Program)  :  Urban And Industrial Environmental Management | การจัดการสิ่งแวดล้อมในเมืองและอุตสาหกรรม | 城市和工业环境管理"
    },
    {
        "id":5868,
        "name":"5873 (English Program)  :  Cosmetic Science | วิทยาศาสตร์เครื่องสำอาง | 化妆品科学"
    },
    {
        "id":5869,
        "name":"5874 (English Program)  :  Event And Exhibition Design | การออกแบบงานอีเว้นท์และนิทรรศการ | 活动及展览设计"
    },
    {
        "id":5870,
        "name":"5875 (English Program)  :  Modern Analysis And Evaluation | การวิเคราะห์และการประเมินที่ทันสมัย | 现代分析与评价"
    },
    {
        "id":5871,
        "name":"5876 (English Program)  :  Tourism And Hospitality Industry | อุตสาหกรรมการท่องเที่ยวและการบริการ | 旅游和酒店业"
    },
    {
        "id":5872,
        "name":"5877 (English Program)  :  Media Arts | สื่อศิลปะ | 媒体艺术"
    },
    {
        "id":5873,
        "name":"5878 (English Program)  :  Media Technology | เทคโนโลยีมีเดีย | 媒体技术"
    },
    {
        "id":5874,
        "name":"5879 (English Program)  :  Multimedia And Graphic Design | มัลติมีเดียและการออกแบบกราฟิก | 多媒体和平面设计"
    },
    {
        "id":5875,
        "name":"5880 (English Program)  :  Bioprocess Engineering | วิศวกรรมกระบวนการชีวภาพ | 生物工艺工程"
    },
    {
        "id":5876,
        "name":"5881 (English Program)  :  Advanced Materials And Nanotechnology | วัสดุขั้นสูงและนาโนเทคโนโลยี | 先进材料和纳米技术"
    },
    {
        "id":5877,
        "name":"5882 (English Program)  :  Management Engineering And Logistics | วิศวกรรมการจัดการและโลจิสติกส์ | 管理工程和物流"
    },
    {
        "id":5878,
        "name":"5883 (English Program)  :  Environmental Science And Natural Resources | วิทยาศาสตร์สิ่งแวดล้อมและทรัพยากรธรรมชาติ | 环境科学和自然资源"
    },
    {
        "id":5879,
        "name":"5884 (English Program)  :  Strategies Of Learning Management | กลยุทธ์การจัดการเรียนรู้ | 学习管理策略"
    },
    {
        "id":5880,
        "name":"5885 (English Program)  :  Language And Intercultural Communication | ภาษาและการสื่อสารระหว่างวัฒนธรรม | 语言和跨文化交流"
    },
    {
        "id":5881,
        "name":"5886 (English Program)  :  French For Cultural Tourism | ภาษาฝรั่งเศสเพื่อการท่องเที่ยวเชิงวัฒนธรรม | 文化旅游法语"
    },
    {
        "id":5882,
        "name":"5887 (English Program)  :  Computer And Information Science | วิทยาศาสตร์คอมพิวเตอร์และสารสนเทศ | 计算机与信息科学"
    },
    {
        "id":5883,
        "name":"5888 (English Program)  :  Cultural Studies For Tourism | การศึกษาวัฒนธรรมเพื่อการท่องเที่ยว | 旅游文化研究"
    },
    {
        "id":5884,
        "name":"5889 (English Program)  :  Bioresource Development Science | วิทยาศาสตร์การพัฒนาทรัพยากรชีวภาพ | 生物资源开发科学"
    },
    {
        "id":5885,
        "name":"5890 (English Program)  :  Agriculture (Plant Science) | เกษตร (วิทยาศาสตร์พืช) | 农业（植物科学）"
    },
    {
        "id":5886,
        "name":"5891 (English Program)  :  Business Adminisatration (Marketing) | การบริหารธุรกิจ (การตลาด) | 工商管理（市场营销）"
    },
    {
        "id":5887,
        "name":"5892 (English Program)  :  Business Adminisatration (Business Computer) | การบริหารธุรกิจ (คอมพิวเตอร์ธุรกิจ) | 工商管理（商业计算机）"
    },
    {
        "id":5888,
        "name":"5893 (English Program)  :  Business Adminisatration (General Management) | การบริหารธุรกิจ (การจัดการทั่วไป) | 工商管理（综合管理）"
    },
    {
        "id":5889,
        "name":"5894 (English Program)  :  Business Adminisatration (Industrial Work Management) | การบริหารธุรกิจ (การจัดการงานอุตสาหกรรม) | 工商管理（工业工作管理）"
    },
    {
        "id":5890,
        "name":"5895 (English Program)  :  Business Adminisatration (International Business Practier) | การบริหารธุรกิจ (ผู้ประกอบธุรกิจระหว่างประเทศ) | 工商管理（国际商务执业者）"
    },
    {
        "id":5891,
        "name":"5896 (English Program)  :  Border Trade | การค้าชายแดน | 边境贸易"
    },
    {
        "id":5892,
        "name":"5897 (English Program)  :  Halal Food Business | ธุรกิจอาหารฮาลาล | 清真食品业务"
    },
    {
        "id":5893,
        "name":"5898 (English Program)  :  International Business In Indochina | ธุรกิจระหว่างประเทศในอินโดจีน | 印度支那的国际业务"
    },
    {
        "id":5894,
        "name":"5899 (English Program)  :  Accountancy | การบัญชี | 会计"
    },
    {
        "id":5895,
        "name":"5900 (English Program)  :  Information Communication Technology | เทคโนโลยีการสื่อสารข้อมูล | 信息通信技术"
    },
    {
        "id":5896,
        "name":"5901 (English Program)  :  Buddhism Education | การศึกษาพุทธศาสนา | 佛教教育"
    },
    {
        "id":5897,
        "name":"5902 (English Program)  :  Health Promotion For Older Adults | การส่งเสริมสุขภาพผู้สูงอายุ | 促进老年人健康"
    },
    {
        "id":5898,
        "name":"5903 (English Program)  :  Islamic Studies For Development | การศึกษาอิสลามเพื่อการพัฒนา | 伊斯兰发展研究"
    },
    {
        "id":5899,
        "name":"5904 (English Program)  :  Innovation In Management | นวัตกรรมในการจัดการ | 管理创新"
    },
    {
        "id":5900,
        "name":"5905 (English Program)  :  Entrepreneurship And Innovation | การเป็นผู้ประกอบการและนวัตกรรม | 创业与创新"
    },
    {
        "id":5901,
        "name":"5906 (English Program)  :  Human Capital And Organization Management | การบริหารทุนมนุษย์และองค์กร | 人力资本和组织管理"
    },
    {
        "id":5902,
        "name":"5907 (English Program)  :  Korean Studies | การศึกษาภาษาเกาหลี | 韩国学"
    },
    {
        "id":5903,
        "name":"5908 (English Program)  :  Environment, Development And Sustainability | สิ่งแวดล้อม การพัฒนา และความยั่งยืน | 环境、发展和可持续性"
    },
    {
        "id":5904,
        "name":"5909 (English Program)  :  Language And Culture | ภาษาและวัฒนธรรม | 语言和文化"
    },
    {
        "id":5905,
        "name":"5910 (English Program)  :  Quantitative Finance | การเงินเชิงปริมาณ | 量化金融"
    },
    {
        "id":5906,
        "name":"5911 (English Program)  :  Health Research And Management | การวิจัยและการจัดการด้านสุขภาพ | 健康研究与管理"
    },
    {
        "id":5907,
        "name":"5912 (English Program)  :  Applied Veterinary Anatomy | กายวิภาคศาสตร์สัตวแพทย์ประยุกต์ | 应用兽医解剖学"
    },
    {
        "id":5908,
        "name":"5913 (English Program)  :  Esthetic Restorative And Implant Dentistry | ทันตกรรมบูรณะเพื่อความสวยงามและทันตกรรมรากเทียม | 美容修复和种植牙科"
    },
    {
        "id":5909,
        "name":"5914 (English Program)  :  Full Mouth Rehabilitation | การฟื้นฟูสมรรถภาพช่องปากเต็มรูปแบบ | 全口康复"
    },
    {
        "id":5910,
        "name":"5915 (English Program)  :  Electronic And Computer | อิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子及电脑"
    },
    {
        "id":5911,
        "name":"5916 (English Program)  :  Industrial Technology (Electronics And Computer Technology) | เทคโนโลยีอุตสาหกรรม (อิเล็กทรอนิกส์และเทคโนโลยีคอมพิวเตอร์) | 工业技术（电子和计算机技术）"
    },
    {
        "id":5912,
        "name":"5917 (English Program)  :  Industrial Technology (Civil Technology) | เทคโนโลยีอุตสาหกรรม (เทคโนโลยีโยธา) | 工业技术（民用技术）"
    },
    {
        "id":5913,
        "name":"5918 (English Program)  :  Teaching Chinese | การสอนภาษาจีน | 中文教学"
    },
    {
        "id":5914,
        "name":"5919 (English Program)  :  Highland Agriculture | เกษตรบนที่สูง | 高原农业"
    },
    {
        "id":5915,
        "name":"5920 (English Program)  :  Logistics Engineering And Management | วิศวกรรมศาสตร์และการจัดการโลจิสติกส์ | 物流工程与管理"
    },
    {
        "id":5916,
        "name":"5921 (English Program)  :  Visual Art | ทัศนศิลป์ | 视觉艺术"
    },
    {
        "id":5917,
        "name":"5922 (English Program)  :  Chinese As A Foreign Language | ภาษาจีนเป็นภาษาต่างประเทศ | 汉语作为外语"
    },
    {
        "id":5918,
        "name":"5923 (English Program)  :  Fashion Business | ธุรกิจแฟชั่น | 时尚业务"
    },
    {
        "id":5919,
        "name":"5924 (English Program)  :  Organic Agriculture | เกษตรอินทรีย์ | 有机农业"
    },
    {
        "id":5920,
        "name":"5925 (English Program)  :  Tourism & Hospitality Management | การจัดการการท่องเที่ยวและการบริการ | 旅游与酒店管理"
    },
    {
        "id":5921,
        "name":"5926 (English Program)  :  Performing Arts Management | การจัดการศิลปะการแสดง | 表演艺术管理"
    },
    {
        "id":5922,
        "name":"5927 (English Program)  :  Tool And Die Design Engineering Technology | เทคโนโลยีวิศวกรรมการออกแบบเครื่องมือและแม่พิมพ์ | 工模具设计工程技术"
    },
    {
        "id":5923,
        "name":"5928 (English Program)  :  Thai Handicrafts | หัตถกรรมไทย | 泰国手工艺品"
    },
    {
        "id":5924,
        "name":"5929 (English Program)  :  Electrical Engineering Technology | เทคโนโลยีวิศวกรรมไฟฟ้า | 电气工程技术"
    },
    {
        "id":5925,
        "name":"5930 (English Program)  :  Animation And Game | แอนิเมชั่นและเกม | 动漫游戏"
    },
    {
        "id":5926,
        "name":"5931 (English Program)  :  Applied Communication | การสื่อสารประยุกต์ | 应用通讯"
    },
    {
        "id":5927,
        "name":"5932 (English Program)  :  Social Development Administration | การบริหารการพัฒนาสังคม | 社会发展管理局"
    },
    {
        "id":5928,
        "name":"5933 (English Program)  :  Health Security Financing And Management | การเงินและการจัดการด้านหลักประกันสุขภาพ | 健康保障融资和管理"
    },
    {
        "id":5929,
        "name":"5934 (English Program)  :  Music And Dance Studies | การศึกษาดนตรีและการเต้นรำ | 音乐和舞蹈研究"
    },
    {
        "id":5930,
        "name":"5935 (English Program)  :  Science And Technology In Sports | วิทยาศาสตร์และเทคโนโลยีในการกีฬา | 体育科技"
    },
    {
        "id":5931,
        "name":"5936 (English Program)  :  Management Engineering | วิศวกรรมการจัดการ | 管理工程"
    },
    {
        "id":5932,
        "name":"5937 (English Program)  :  Product And Package Design | การออกแบบผลิตภัณฑ์และบรรจุภัณฑ์ | 产品和包装设计"
    },
    {
        "id":5933,
        "name":"5938 (English Program)  :  Office Automation Management | การจัดการสำนักงานอัตโนมัติ | 办公自动化管理"
    },
    {
        "id":5934,
        "name":"5939 (English Program)  :  Teaching Mathematics And Science Education | การสอนคณิตศาสตร์และวิทยาศาสตร์ศึกษา | 数学和科学教育教学"
    },
    {
        "id":5935,
        "name":"5940 (English Program)  :  International Management Of Resources And Environment | การจัดการทรัพยากรและสิ่งแวดล้อมระหว่างประเทศ | 国际资源与环境管理"
    },
    {
        "id":5936,
        "name":"5941 (English Program)  :  Nanoscience And Nanotechnology | นาโนวิทยาศาสตร์และนาโนเทคโนโลยี | 纳米科学和纳米技术"
    },
    {
        "id":5937,
        "name":"5942 (English Program)  :  Provincial Government Administration | การบริหารราชการส่วนภูมิภาค | 省政府行政管理局"
    },
    {
        "id":5938,
        "name":"5943 (English Program)  :  Agricultural Management | การจัดการเกษตรกรรม | 农业管理"
    },
    {
        "id":5939,
        "name":"5944 (English Program)  :  Agricultural Resources Management | การจัดการทรัพยากรเกษตร | 农业资源管理"
    },
    {
        "id":5940,
        "name":"5945 (English Program)  :  Applied Statistics And Information Technology | สถิติประยุกต์และเทคโนโลยีสารสนเทศ | 应用统计和信息技术"
    },
    {
        "id":5941,
        "name":"5946 (English Program)  :  Oceanography | สมุทรศาสตร์ | 海洋学"
    },
    {
        "id":5942,
        "name":"5947 (English Program)  :  Logistics Technology | เทคโนโลยีโลจิสติกส์ | 物流技术"
    },
    {
        "id":5943,
        "name":"5948 (English Program)  :  Network Engineering | วิศวกรรมเครือข่าย | 网络工程"
    },
    {
        "id":5944,
        "name":"5949 (English Program)  :  Commerce | พาณิชย์ | 商业"
    },
    {
        "id":5945,
        "name":"5950 (English Program)  :  Mechanical Trade | การค้าเครื่องกล | 机械贸易"
    },
    {
        "id":5946,
        "name":"5951 (English Program)  :  Metallurgical Trade | การค้าโลหะวิทยา | 冶金贸易"
    },
    {
        "id":5947,
        "name":"5952 (English Program)  :  Electrical And Electronics Trade | การค้าไฟฟ้าและอิเล็กทรอนิกส์ | 电器电子贸易"
    },
    {
        "id":5948,
        "name":"5953 (English Program)  :  Business Computer Studies | การศึกษาคอมพิวเตอร์ธุรกิจ | 商业计算机研究"
    },
    {
        "id":5949,
        "name":"5954 (English Program)  :  Agricultural Process Engineering | วิศวกรรมกระบวนการทางการเกษตร | 农业加工工程"
    },
    {
        "id":5950,
        "name":"5955 (English Program)  :  Agriculture Education | เกษตรศึกษา | 农业教育"
    },
    {
        "id":5951,
        "name":"5956 (English Program)  :  Agriculture Industries | อุตสาหกรรมการเกษตร | 农业产业"
    },
    {
        "id":5952,
        "name":"5957 (English Program)  :  Applied Biochemistry | ชีวเคมีประยุกต์ | 应用生物化学"
    },
    {
        "id":5953,
        "name":"5958 (English Program)  :  Biological Systems Engineering | วิศวกรรมระบบชีวภาพ | 生物系统工程"
    },
    {
        "id":5954,
        "name":"5959 (English Program)  :  Food Toxicology | พิษวิทยาของอาหาร | 食品毒理学"
    },
    {
        "id":5955,
        "name":"5960 (English Program)  :  Forest Ecology | นิเวศวิทยาป่าไม้ | 森林生态"
    },
    {
        "id":5956,
        "name":"5961 (English Program)  :  General Agriculture Science | วิทยาศาสตร์การเกษตรทั่วไป | 普通农业科学"
    },
    {
        "id":5957,
        "name":"5962 (English Program)  :  Genetics And Cell Biology | พันธุศาสตร์และชีววิทยาของเซลล์ | 遗传学和细胞生物学"
    },
    {
        "id":5958,
        "name":"5963 (English Program)  :  International Development | การพัฒนาระหว่างประเทศ | 国际发展"
    },
    {
        "id":5959,
        "name":"5964 (English Program)  :  International Finance | การเงินระหว่างประเทศ | 国际金融"
    },
    {
        "id":5960,
        "name":"5965 (English Program)  :  Irrigation | การชลประทาน | 灌溉"
    },
    {
        "id":5961,
        "name":"5966 (English Program)  :  Language Studies | การศึกษาภาษา | 语言研究"
    },
    {
        "id":5962,
        "name":"5967 (English Program)  :  Marine And Fisheries Science | วิทยาศาสตร์ทางทะเลและการประมง | 海洋与渔业科学"
    },
    {
        "id":5963,
        "name":"5968 (English Program)  :  Modern Chinese Language | ภาษาจีนสมัยใหม่ | 现代汉语"
    },
    {
        "id":5964,
        "name":"5969 (English Program)  :  Mycology | วิทยาวิทยา | 真菌学"
    },
    {
        "id":5965,
        "name":"5970 (English Program)  :  Natural Resource Economics | เศรษฐศาสตร์ทรัพยากรธรรมชาติ | 自然资源经济学"
    },
    {
        "id":5966,
        "name":"5971 (English Program)  :  Plant Soil Science | วิทยาศาสตร์ดินพืช | 植物土壤科学"
    },
    {
        "id":5967,
        "name":"5972 (English Program)  :  Resource Economics | เศรษฐศาสตร์ทรัพยากร | 资源经济"
    },
    {
        "id":5968,
        "name":"5973 (English Program)  :  Soil Science And Land Evaluation | วิทยาศาสตร์ดินและการประเมินที่ดิน | 土壤科学和土地评估"
    },
    {
        "id":5969,
        "name":"5974 (English Program)  :  Teaching English For Specific Purpose | การสอนภาษาอังกฤษเพื่อวัตถุประสงค์เฉพาะ | 特定目的英语教学"
    },
    {
        "id":5970,
        "name":"5975 (English Program)  :  Technical Science | วิทยาศาสตร์เทคนิค | 技术科学"
    },
    {
        "id":5971,
        "name":"5976 (English Program)  :  Design Innovation & Technology | นวัตกรรมการออกแบบและเทคโนโลยี | 设计创新与技术"
    },
    {
        "id":5972,
        "name":"5977 (English Program)  :  Ornamental Horticulture Management | การจัดการพืชสวนประดับ | 观赏园艺管理"
    },
    {
        "id":5973,
        "name":"5978 (English Program)  :  Industrial Technology Management | การจัดการเทคโนโลยีอุตสาหกรรม | 工业技术管理"
    },
    {
        "id":5974,
        "name":"5979 (English Program)  :  Clothing Business | ธุรกิจเสื้อผ้า | 服装业务"
    },
    {
        "id":5975,
        "name":"5980 (English Program)  :  Fashion And Garment Technology | เทคโนโลยีแฟชั่นและเครื่องนุ่งห่ม | 时尚与成衣技术"
    },
    {
        "id":5976,
        "name":"5981 (English Program)  :  Thai Folk Wisdom Product Development | การพัฒนาผลิตภัณฑ์ภูมิปัญญาพื้นบ้านไทย | 泰国民间智慧产品开发"
    },
    {
        "id":5977,
        "name":"5982 (English Program)  :  Tourism And Hospitality | การท่องเที่ยวและการบริการ | 旅游和酒店业"
    },
    {
        "id":5978,
        "name":"5983 (English Program)  :  Food Safety Management And Technology | การจัดการความปลอดภัยด้านอาหารและเทคโนโลยี | 食品安全管理与技术"
    },
    {
        "id":5979,
        "name":"5984 (English Program)  :  Social Work And Social Development | งานสังคมสงเคราะห์และการพัฒนาสังคม | 社会工作和社会发展"
    },
    {
        "id":5980,
        "name":"5985 (English Program)  :  Gemological Sciences | วิทยาศาสตร์อัญมณี | 宝石科学"
    },
    {
        "id":5981,
        "name":"5986 (English Program)  :  Applied Psychology | จิตวิทยาประยุกต์ | 应用心理学"
    },
    {
        "id":5982,
        "name":"5987 (English Program)  :  Intellectual Property | ทรัพย์สินทางปัญญา | 知识产权"
    },
    {
        "id":5983,
        "name":"5988 (English Program)  :  Management Of Technology | การจัดการเทคโนโลยี | 技术管理"
    },
    {
        "id":5984,
        "name":"5989 (English Program)  :  Secretarial Science | วิทยาการเลขานุการ | 秘书科学"
    },
    {
        "id":5985,
        "name":"5990 (English Program)  :  Mechanical Technology Eduction | การศึกษาเทคโนโลยีเครื่องกล | 机械技术教育"
    },
    {
        "id":5986,
        "name":"5991 (English Program)  :  Electrical | ไฟฟ้า | 电气"
    },
    {
        "id":5987,
        "name":"5992 (English Program)  :  Applied Linguistics For English Language Teaching | ภาษาศาสตร์ประยุกต์สำหรับการสอนภาษาอังกฤษ | 英语教学应用语言学"
    },
    {
        "id":5988,
        "name":"5993 (English Program)  :  Biochemical Engineering | วิศวกรรมชีวเคมี | 生化工程"
    },
    {
        "id":5989,
        "name":"5994 (English Program)  :  Tool And Materials Engineering | วิศวกรรมเครื่องมือและวัสดุ | 工具和材料工程"
    },
    {
        "id":5990,
        "name":"5995 (English Program)  :  System Engineering | วิศวกรรมระบบ | 系统工程"
    },
    {
        "id":5991,
        "name":"5996 (English Program)  :  Sanitary Engineering | วิศวกรรมสุขาภิบาล | 卫浴工程"
    },
    {
        "id":5992,
        "name":"5997 (English Program)  :  Plant Physiology | สรีรวิทยาของพืช | 植物生理学"
    },
    {
        "id":5993,
        "name":"5998 (English Program)  :  Community Resource And Environment Development | การพัฒนาทรัพยากรชุมชนและสิ่งแวดล้อม | 社区资源与环境开发"
    },
    {
        "id":5994,
        "name":"5999 (English Program)  :  Energy Management Engineering | วิศวกรรมการจัดการพลังงาน | 能源管理工程"
    },
    {
        "id":5995,
        "name":"6000 (English Program)  :  Applied Electrical Engineering | วิศวกรรมไฟฟ้าประยุกต์ | 应用电气工程"
    },
    {
        "id":5996,
        "name":"6001 (English Program)  :  Asian Studies And Tourism | การศึกษาเอเชียและการท่องเที่ยว | 亚洲研究和旅游"
    },
    {
        "id":5997,
        "name":"6002 (English Program)  :  Computer Architectural Multimedia | มัลติมีเดียสถาปัตยกรรมคอมพิวเตอร์ | 计算机体系结构多媒体"
    },
    {
        "id":5998,
        "name":"6003 (English Program)  :  Mathematics And Computer Education | คณิตศาสตร์และการศึกษาคอมพิวเตอร์ | 数学和计算机教育"
    },
    {
        "id":5999,
        "name":"6004 (English Program)  :  Teaching English As An International Language | การสอนภาษาอังกฤษเป็นภาษาสากล | 英语作为国际语言的教学"
    },
    {
        "id":6000,
        "name":"6005 (English Program)  :  Management Of Home Business | การจัดการธุรกิจที่บ้าน | 家庭企业管理"
    },
    {
        "id":6001,
        "name":"6006 (English Program)  :  Farm Mechanics | กลศาสตร์ฟาร์ม | 农场机械"
    },
    {
        "id":6002,
        "name":"6007 (English Program)  :  English-Chinese | ภาษาอังกฤษ-จีน | 英汉"
    },
    {
        "id":6003,
        "name":"6008 (English Program)  :  Curriculum And Learning Management | การจัดการหลักสูตรและการเรียนรู้ | 课程和学习管理"
    },
    {
        "id":6004,
        "name":"6009 (English Program)  :  Integrated Social Welfare Policy | นโยบายสวัสดิการสังคมบูรณาการ | 综合社会福利政策"
    },
    {
        "id":6005,
        "name":"6010 (English Program)  :  Communicative Thai For Foreigners | การสื่อสารภาษาไทยสำหรับชาวต่างชาติ | 外国人泰语交流"
    },
    {
        "id":6006,
        "name":"6011 (English Program)  :  Business And Computer Education | การศึกษาธุรกิจและคอมพิวเตอร์ | 商业和计算机教育"
    },
    {
        "id":6007,
        "name":"6012 (English Program)  :  Agro - Resources | เกษตร-ทรัพยากร | 农业 - 资源"
    },
    {
        "id":6008,
        "name":"6013 (English Program)  :  Bio-Veterinary Sciences | วิทยาศาสตร์ชีวภาพสัตวแพทยศาสตร์ | 生物兽医科学"
    },
    {
        "id":6009,
        "name":"6014 (English Program)  :  Applied Food Science And Services | วิทยาศาสตร์การอาหารประยุกต์และบริการ | 应用食品科学与服务"
    },
    {
        "id":6010,
        "name":"6015 (English Program)  :  Business Administration (Finance) | การบริหารธุรกิจ (การเงิน) | 工商管理（金融）"
    },
    {
        "id":6011,
        "name":"6016 (English Program)  :  Philosophy And Ethics | ปรัชญาและจริยธรรม | 哲学与道德"
    },
    {
        "id":6012,
        "name":"6017 (English Program)  :  Industrial Crop Production | การผลิตพืชอุตสาหกรรม | 工业作物生产"
    },
    {
        "id":6013,
        "name":"6018 (English Program)  :  Homoepathy | โฮโมเอพาธี | 同势疗法"
    },
    {
        "id":6014,
        "name":"6019 (English Program)  :  Design Arts | ศิลปะการออกแบบ | 设计艺术"
    },
    {
        "id":6015,
        "name":"6020 (English Program)  :  Sustainable Tourism Management | การจัดการการท่องเที่ยวอย่างยั่งยืน | 可持续旅游管理"
    },
    {
        "id":6016,
        "name":"6021 (English Program)  :  Mathematics And Technology For Teaching | คณิตศาสตร์และเทคโนโลยีเพื่อการสอน | 数学与技术教学"
    },
    {
        "id":6017,
        "name":"6022 (English Program)  :  Civil Engineering And Construction Management | วิศวกรรมโยธาและการจัดการการก่อสร้าง | 土木工程和施工管理"
    },
    {
        "id":6018,
        "name":"6023 (English Program)  :  Culture For Tourism | วัฒนธรรมเพื่อการท่องเที่ยว | 旅游文化"
    },
    {
        "id":6019,
        "name":"6024 (English Program)  :  Accounting And Finance | การบัญชีและการเงิน | 会计与金融"
    },
    {
        "id":6020,
        "name":"6025 (English Program)  :  Aquaculture | การเพาะเลี้ยงสัตว์น้ำ | 水产养殖"
    },
    {
        "id":6021,
        "name":"6026 (English Program)  :  Architectural Technology | เทคโนโลยีสถาปัตยกรรม | 建筑技术"
    },
    {
        "id":6022,
        "name":"6027 (English Program)  :  Architecture | สถาปัตยกรรม | 建筑学"
    },
    {
        "id":6023,
        "name":"6028 (English Program)  :  Arts | ศิลปะ | 艺术"
    },
    {
        "id":6024,
        "name":"6029 (English Program)  :  Automotive Technology | เทคโนโลยียานยนต์ | 汽车技术"
    },
    {
        "id":6025,
        "name":"6030 (English Program)  :  Aviation Management | การจัดการการบิน | 航空管理"
    },
    {
        "id":6026,
        "name":"6031 (English Program)  :  Bilingual Education | การศึกษาสองภาษา | 双语教育"
    },
    {
        "id":6027,
        "name":"6032 (English Program)  :  Biological Sciences | วิทยาศาสตร์ชีวภาพ | 生物科学"
    },
    {
        "id":6028,
        "name":"6033 (English Program)  :  Biomedical Engineering | วิศวกรรมชีวการแพทย์ | 生物医学工程"
    },
    {
        "id":6029,
        "name":"6034 (English Program)  :  Biomedical Sciences | วิทยาศาสตร์ชีวการแพทย์ | 生物医学科学"
    },
    {
        "id":6030,
        "name":"6035 (English Program)  :  Biopharmacy | ชีวเภสัชศาสตร์ | 生物制药"
    },
    {
        "id":6031,
        "name":"6036 (English Program)  :  Brand Communications | การสื่อสารแบรนด์ | 品牌传播"
    },
    {
        "id":6032,
        "name":"6037 (English Program)  :  Broadcasting | การออกอากาศ | 广播"
    },
    {
        "id":6033,
        "name":"6038 (English Program)  :  Buddhism | พุทธศาสนา | 佛教"
    },
    {
        "id":6034,
        "name":"6039 (English Program)  :  Buddhist Studies | การศึกษาพุทธศาสนา | 佛学研究"
    },
    {
        "id":6035,
        "name":"6040 (English Program)  :  Home Economics Education | การศึกษาเศรษฐศาสตร์บ้าน | 家庭经济教育"
    },
    {
        "id":6036,
        "name":"6041 (English Program)  :  Hospital Management | การจัดการโรงพยาบาล | 医院管理"
    },
    {
        "id":6037,
        "name":"6042 (English Program)  :  Hospitality And Tourism Management | การจัดการการต้อนรับและการท่องเที่ยว | 酒店和旅游管理"
    },
    {
        "id":6038,
        "name":"6043 (English Program)  :  Hospitality Management | การจัดการการต้อนรับ | 酒店管理"
    },
    {
        "id":6039,
        "name":"6044 (English Program)  :  Hotel And Tourism | โรงแรมและการท่องเที่ยว | 酒店及旅游"
    },
    {
        "id":6040,
        "name":"6045 (English Program)  :  Hotel And Tourism Business | ธุรกิจโรงแรมและการท่องเที่ยว | 酒店及旅游业务"
    },
    {
        "id":6041,
        "name":"6046 (English Program)  :  Hotel And Tourism Management | การจัดการโรงแรมและการท่องเที่ยว | 酒店及旅游管理"
    },
    {
        "id":6042,
        "name":"6047 (English Program)  :  Hotel Business | ธุรกิจโรงแรม | 酒店业务"
    },
    {
        "id":6043,
        "name":"6048 (English Program)  :  Hotel Management | การจัดการโรงแรม | 酒店管理"
    },
    {
        "id":6044,
        "name":"6049 (English Program)  :  Human Resource Management | การจัดการทรัพยากรมนุษย์ | 人力资源管理"
    },
    {
        "id":6045,
        "name":"6050 (English Program)  :  Industrial And Technology Education | การศึกษาด้านอุตสาหกรรมและเทคโนโลยี | 工业和技术教育"
    },
    {
        "id":6046,
        "name":"6051 (English Program)  :  Industrial Automation And Power Electronics | ระบบอัตโนมัติทางอุตสาหกรรมและอิเล็กทรอนิกส์กำลัง | 工业自动化与电力电子"
    },
    {
        "id":6047,
        "name":"6052 (English Program)  :  Industrial Design | การออกแบบอุตสาหกรรม | 工业设计"
    },
    {
        "id":6048,
        "name":"6053 (English Program)  :  Industrial Engineering | วิศวกรรมอุตสาหการ | 工业工程"
    },
    {
        "id":6049,
        "name":"6054 (English Program)  :  Industrial Management | การจัดการอุตสาหกรรม | 工业管理"
    },
    {
        "id":6050,
        "name":"6055 (English Program)  :  Industrial Microbiology | จุลชีววิทยาอุตสาหกรรม | 工业微生物学"
    },
    {
        "id":6051,
        "name":"6056 (English Program)  :  Industrial Technology | เทคโนโลยีอุตสาหกรรม | 工业技术"
    },
    {
        "id":6052,
        "name":"6057 (English Program)  :  Information | ข้อมูล | 信息"
    },
    {
        "id":6053,
        "name":"6058 (English Program)  :  Information And Communication Technology | เทคโนโลยีสารสนเทศและการสื่อสาร | 信息与通信技术"
    },
    {
        "id":6054,
        "name":"6059 (English Program)  :  Information Management | การจัดการข้อมูล | 信息管理"
    },
    {
        "id":6055,
        "name":"6060 (English Program)  :  Information Management And Systems | การจัดการและระบบสารสนเทศ | 信息管理和系统"
    },
    {
        "id":6056,
        "name":"6061 (English Program)  :  Information Science | วิทยาการสารสนเทศ | 信息科学"
    },
    {
        "id":6057,
        "name":"6062 (English Program)  :  Information Studies | การศึกษาข้อมูล | 信息研究"
    },
    {
        "id":6058,
        "name":"6063 (English Program)  :  Information System | ระบบสารสนเทศ | 信息系统"
    },
    {
        "id":6059,
        "name":"6064 (English Program)  :  Information Technology | เทคโนโลยีสารสนเทศ | 信息技术"
    },
    {
        "id":6060,
        "name":"6065 (English Program)  :  Information Technology In Business | เทคโนโลยีสารสนเทศในธุรกิจ | 商业信息技术"
    },
    {
        "id":6061,
        "name":"6066 (English Program)  :  Information Technology Management | การจัดการเทคโนโลยีสารสนเทศ | 信息技术管理"
    },
    {
        "id":6062,
        "name":"6067 (English Program)  :  Infrastructure Engineering And Management | วิศวกรรมโครงสร้างพื้นฐานและการจัดการ | 基础设施工程与管理"
    },
    {
        "id":6063,
        "name":"6068 (English Program)  :  Insurance | ประกันภัย | 保险"
    },
    {
        "id":6064,
        "name":"6069 (English Program)  :  Interior Design | การออกแบบภายใน | 室内设计"
    },
    {
        "id":6065,
        "name":"6070 (English Program)  :  International Affairs | กิจการระหว่างประเทศ | 国际事务"
    },
    {
        "id":6066,
        "name":"6071 (English Program)  :  International Economics | เศรษฐศาสตร์ระหว่างประเทศ | 国际经济"
    },
    {
        "id":6067,
        "name":"6072 (English Program)  :  International Hospitality Management | การจัดการการต้อนรับระหว่างประเทศ | 国际酒店管理"
    },
    {
        "id":6068,
        "name":"6073 (English Program)  :  Jewelry Design | การออกแบบเครื่องประดับ | 珠宝设计"
    },
    {
        "id":6069,
        "name":"6074 (English Program)  :  Journalism | วารสารศาสตร์ | 新闻业"
    },
    {
        "id":6070,
        "name":"6075 (English Program)  :  Landscape Architecture | สถาปัตยกรรมภูมิทัศน์ | 景观建筑"
    },
    {
        "id":6071,
        "name":"6076 (English Program)  :  Language For Development | ภาษาเพื่อการพัฒนา | 语言促进发展"
    },
    {
        "id":6072,
        "name":"6077 (English Program)  :  Learning Management | การจัดการเรียนรู้ | 学习管理"
    },
    {
        "id":6073,
        "name":"6078 (English Program)  :  Library And Information Science | ห้องสมุดและวิทยาการสารสนเทศ | 图书馆与信息科学"
    },
    {
        "id":6074,
        "name":"6079 (English Program)  :  Local Administration | การบริหารท้องถิ่น | 地方行政"
    },
    {
        "id":6075,
        "name":"6080 (English Program)  :  Logistics And Supply Chain ​​Management | การจัดการโลจิสติกส์และห่วงโซ่อุปทาน | 物流与供应链管理"
    },
    {
        "id":6076,
        "name":"6081 (English Program)  :  Machine Mechanics | กลศาสตร์เครื่องจักร | 机器力学"
    },
    {
        "id":6077,
        "name":"6082 (English Program)  :  Management | การจัดการ | 管理"
    },
    {
        "id":6078,
        "name":"6083 (English Program)  :  Management-Industrial Management | การจัดการ-การจัดการอุตสาหกรรม | 管理-工业管理"
    },
    {
        "id":6079,
        "name":"6084 (English Program)  :  Management Information System | ระบบสารสนเทศเพื่อการจัดการ | 管理信息系统"
    },
    {
        "id":6080,
        "name":"6085 (English Program)  :  Managerial Accounting | การบัญชีบริหาร | 管理会计"
    },
    {
        "id":6081,
        "name":"6086 (English Program)  :  Manufacturing Technology | เทคโนโลยีการผลิต | 制造技术"
    },
    {
        "id":6082,
        "name":"6087 (English Program)  :  Marketing | การตลาด | 营销"
    },
    {
        "id":6083,
        "name":"6088 (English Program)  :  Marketing Communication | การสื่อสารการตลาด | 营销传播"
    },
    {
        "id":6084,
        "name":"6089 (English Program)  :  Marketing Management | การจัดการการตลาด | 营销管理"
    },
    {
        "id":6085,
        "name":"6090 (English Program)  :  Mass Communication | การสื่อสารมวลชน | 大众传播"
    },
    {
        "id":6086,
        "name":"6091 (English Program)  :  Materials Engineering | วิศวกรรมวัสดุ | 材料工程"
    },
    {
        "id":6087,
        "name":"6092 (English Program)  :  Materials Science And Engineering | วัสดุศาสตร์และวิศวกรรมศาสตร์ | 材料科学与工程"
    },
    {
        "id":6088,
        "name":"6093 (English Program)  :  Mathematics And Statistics | คณิตศาสตร์และสถิติ | 数学与统计学"
    },
    {
        "id":6089,
        "name":"6094 (English Program)  :  Mathematics Education | การศึกษาคณิตศาสตร์ | 数学教育"
    },
    {
        "id":6090,
        "name":"6095 (English Program)  :  Maxillofacial | แม็กซิลโลเฟเชียล | 颌面部"
    },
    {
        "id":6091,
        "name":"6096 (English Program)  :  Mechanical Engineering | วิศวกรรมเครื่องกล | 机械工业"
    },
    {
        "id":6092,
        "name":"6097 (English Program)  :  Mechanical Technology | เทคโนโลยีเครื่องกล | 机械技术"
    },
    {
        "id":6093,
        "name":"6098 (English Program)  :  Mechatronics | เมคคาทรอนิกส์ | 机电一体化"
    },
    {
        "id":6094,
        "name":"6099 (English Program)  :  Mechatronics Engineering | วิศวกรรมเมคคาทรอนิกส์ | 机电工程"
    },
    {
        "id":6095,
        "name":"6100 (English Program)  :  Medical And Health Social Sciences | สังคมศาสตร์การแพทย์และสุขภาพ | 医疗与健康社会科学"
    },
    {
        "id":6096,
        "name":"6101 (English Program)  :  Medical Laboratory Assistant | ผู้ช่วยห้องปฏิบัติการทางการแพทย์ | 医学实验室助理"
    },
    {
        "id":6097,
        "name":"6102 (English Program)  :  Medical Microbiology | จุลชีววิทยาทางการแพทย์ | 医学微生物学"
    },
    {
        "id":6098,
        "name":"6103 (English Program)  :  Medical Technology | เทคโนโลยีการแพทย์ | 医疗技术"
    },
    {
        "id":6099,
        "name":"6104 (English Program)  :  Medicine | ยา | 药品"
    },
    {
        "id":6100,
        "name":"6105 (English Program)  :  Mental Health And Psychiatric Nursing | การพยาบาลสุขภาพจิตและจิตเวช | 心理健康和精神病护理"
    },
    {
        "id":6101,
        "name":"6106 (English Program)  :  Multimedia And Animation Technology | เทคโนโลยีมัลติมีเดียและแอนิเมชั่น | 多媒体与动画技术"
    },
    {
        "id":6102,
        "name":"6107 (English Program)  :  Multimedia And Internet System Engineering | วิศวกรรมระบบมัลติมีเดียและอินเทอร์เน็ต | 多媒体与互联网系统工程"
    },
    {
        "id":6103,
        "name":"6108 (English Program)  :  Music | ดนตรี | 音乐"
    },
    {
        "id":6104,
        "name":"6109 (English Program)  :  Music Education | การศึกษาด้านดนตรี | 音乐教育"
    },
    {
        "id":6105,
        "name":"6110 (English Program)  :  Music Performance | การแสดงดนตรี | 音乐表演"
    },
    {
        "id":6106,
        "name":"6111 (English Program)  :  Music Technology | เทคโนโลยีดนตรี | 音乐科技"
    },
    {
        "id":6107,
        "name":"6112 (English Program)  :  Natural Resource Management | การจัดการทรัพยากรธรรมชาติ | 自然资源管理"
    },
    {
        "id":6108,
        "name":"6113 (English Program)  :  Nautical Science | วิทยาศาสตร์การเดินเรือ | 航海科学"
    },
    {
        "id":6109,
        "name":"6114 (English Program)  :  Naval Architecture And Marine Engineering | สถาปัตยกรรมกองทัพเรือและวิศวกรรมทางทะเล | 船舶与海洋工程"
    },
    {
        "id":6110,
        "name":"6115 (English Program)  :  Non-Formal Education | การศึกษานอกระบบ | 非正规教育"
    },
    {
        "id":6111,
        "name":"6116 (English Program)  :  Nursing And Midwifery | การพยาบาลและการผดุงครรภ์ | 护理和助产士"
    },
    {
        "id":6112,
        "name":"6117 (English Program)  :  Nursing Education | การศึกษาการพยาบาล | 护理教育"
    },
    {
        "id":6113,
        "name":"6118 (English Program)  :  Nursing Practitioner | ผู้ประกอบวิชาชีพพยาบาล | 护理人员"
    },
    {
        "id":6114,
        "name":"6119 (English Program)  :  Nursing Science | วิทยาศาสตร์การพยาบาล | 护理科学"
    },
    {
        "id":6115,
        "name":"6120 (English Program)  :  Nutrition | โภชนาการ | 营养"
    },
    {
        "id":6116,
        "name":"6121 (English Program)  :  Office Management | การจัดการสำนักงาน | 办公室管理"
    },
    {
        "id":6117,
        "name":"6122 (English Program)  :  Operations Management | การจัดการการดำเนินงาน | 运营管理"
    },
    {
        "id":6118,
        "name":"6123 (English Program)  :  Organization And Human Resource Management | องค์กรและการจัดการทรัพยากรมนุษย์ | 组织和人力资源管理"
    },
    {
        "id":6119,
        "name":"6124 (English Program)  :  Otoraryngology | โสตนาสิกวิทยา | 耳鼻喉科"
    },
    {
        "id":6120,
        "name":"6125 (English Program)  :  Packaging Design | การออกแบบบรรจุภัณฑ์ | 包装设计"
    },
    {
        "id":6121,
        "name":"6126 (English Program)  :  Packaging Technology | เทคโนโลยีบรรจุภัณฑ์ | 包装技术"
    },
    {
        "id":6122,
        "name":"6127 (English Program)  :  Pali | มี | 巴利语"
    },
    {
        "id":6123,
        "name":"6128 (English Program)  :  Pediatric Dentistry | ทันตกรรมสำหรับเด็ก | 儿童牙科"
    },
    {
        "id":6124,
        "name":"6129 (English Program)  :  Pediatric Nursing | การพยาบาลเด็ก | 儿科护理"
    },
    {
        "id":6125,
        "name":"6130 (English Program)  :  Periodontics | ปริทันต์ | 牙周病学"
    },
    {
        "id":6126,
        "name":"6131 (English Program)  :  Pharmaceutical Care | การดูแลทางเภสัชกรรม | 药物治疗"
    },
    {
        "id":6127,
        "name":"6132 (English Program)  :  Pharmaceutical Sciences | วิทยาศาสตร์เภสัช | 药物科学"
    },
    {
        "id":6128,
        "name":"6133 (English Program)  :  Pharmaceutical Technology | เทคโนโลยีทางเภสัชกรรม | 制药技术"
    },
    {
        "id":6129,
        "name":"6134 (English Program)  :  Pharmaceutics | เภสัชกรรม | 药剂学"
    },
    {
        "id":6130,
        "name":"6135 (English Program)  :  Pharmacognosy | เภสัชวิทยา | 生药学"
    },
    {
        "id":6131,
        "name":"6136 (English Program)  :  Pharmacy | เภสัชกรรม | 药店"
    },
    {
        "id":6132,
        "name":"6137 (English Program)  :  Philosophy And Religion | ปรัชญาและศาสนา | 哲学与宗教"
    },
    {
        "id":6133,
        "name":"6138 (English Program)  :  Photography | การถ่ายภาพ | 摄影"
    },
    {
        "id":6134,
        "name":"6139 (English Program)  :  Photography And Cinematography Technology | เทคโนโลยีการถ่ายภาพและภาพยนตร์ | 摄影和电影技术"
    },
    {
        "id":6135,
        "name":"6140 (English Program)  :  Physical Chemistry | เคมีกายภาพ | 物理化学"
    },
    {
        "id":6136,
        "name":"6141 (English Program)  :  Physical Education | พลศึกษา | 体育"
    },
    {
        "id":6137,
        "name":"6142 (English Program)  :  Plant Pathology | พยาธิวิทยาของพืช | 植物病理学"
    },
    {
        "id":6138,
        "name":"6143 (English Program)  :  Plant Production And Management Of Urban Community | การผลิตและการจัดการโรงงานของชุมชนเมือง | 城市社区植物生产与管理"
    },
    {
        "id":6139,
        "name":"6144 (English Program)  :  Plant Science | วิทยาศาสตร์พืช | 植物科学"
    },
    {
        "id":6140,
        "name":"6145 (English Program)  :  Political Science | รัฐศาสตร์ | 政治学"
    },
    {
        "id":6141,
        "name":"6146 (English Program)  :  Politics And Government | การเมืองและการปกครอง | 政治与政府"
    },
    {
        "id":6142,
        "name":"6147 (English Program)  :  Postharvest Technology | เทคโนโลยีหลังการเก็บเกี่ยว | 采后技术"
    },
    {
        "id":6143,
        "name":"6148 (English Program)  :  Pre-School Education | การศึกษาก่อนวัยเรียน | 幼儿教育"
    },
    {
        "id":6144,
        "name":"6149 (English Program)  :  Product Design | การออกแบบผลิตภัณฑ์ | 产品设计"
    },
    {
        "id":6145,
        "name":"6150 (English Program)  :  Production Engineering | วิศวกรรมการผลิต | 生产工程"
    },
    {
        "id":6146,
        "name":"6151 (English Program)  :  Professional Accounting | การบัญชีระดับมืออาชีพ | 专业会计"
    },
    {
        "id":6147,
        "name":"6152 (English Program)  :  Professional Music | ดนตรีมืออาชีพ | 专业音乐"
    },
    {
        "id":6148,
        "name":"6153 (English Program)  :  Psychology Of Counseling And Guidance | จิตวิทยาการให้คำปรึกษาและการแนะแนว | 咨询和指导心理学"
    },
    {
        "id":6149,
        "name":"6154 (English Program)  :  Public Administration | การบริหารสาธารณะ | 公共行政"
    },
    {
        "id":6150,
        "name":"6155 (English Program)  :  Public And Private Management | การจัดการภาครัฐและเอกชน | 公共和私人管理"
    },
    {
        "id":6151,
        "name":"6156 (English Program)  :  Public Health | สาธารณสุข | 公共卫生"
    },
    {
        "id":6152,
        "name":"6157 (English Program)  :  Public Health Administration | การบริหารงานสาธารณสุข | 公共卫生管理"
    },
    {
        "id":6153,
        "name":"6158 (English Program)  :  Public Health Nursing | การพยาบาลสาธารณสุข | 公共卫生护理"
    },
    {
        "id":6154,
        "name":"6159 (English Program)  :  Public Management | การจัดการสาธารณะ | 公共管理"
    },
    {
        "id":6155,
        "name":"6160 (English Program)  :  Recreation Management | การจัดการนันทนาการ | 康乐管理"
    },
    {
        "id":6156,
        "name":"6161 (English Program)  :  Resort And Spa Management | การจัดการรีสอร์ทและสปา | 度假村和水疗中心管理"
    },
    {
        "id":6157,
        "name":"6162 (English Program)  :  Resource Management | การจัดการทรัพยากร | 资源管理"
    },
    {
        "id":6158,
        "name":"6163 (English Program)  :  Retail Business Management | การจัดการธุรกิจค้าปลีก | 零售业务管理"
    },
    {
        "id":6159,
        "name":"6164 (English Program)  :  Rubber Technology | เทคโนโลยียาง | 橡胶技术"
    },
    {
        "id":6160,
        "name":"6165 (English Program)  :  Safety Science | วิทยาศาสตร์ความปลอดภัย | 安全科学"
    },
    {
        "id":6161,
        "name":"6166 (English Program)  :  Science And Technology | วิทยาศาสตร์และเทคโนโลยี | 科学技术"
    },
    {
        "id":6162,
        "name":"6167 (English Program)  :  Science Education | การศึกษาวิทยาศาสตร์ | 科学教育"
    },
    {
        "id":6163,
        "name":"6168 (English Program)  :  Secondary Education | มัธยมศึกษา | 中学教育"
    },
    {
        "id":6164,
        "name":"6169 (English Program)  :  Social And Administrative Pharmacy | เภสัชศาสตร์สังคมและการบริหาร | 社会和行政药房"
    },
    {
        "id":6165,
        "name":"6170 (English Program)  :  Social Development | การพัฒนาสังคม | 社会发展"
    },
    {
        "id":6166,
        "name":"6171 (English Program)  :  Social Research | การวิจัยทางสังคม | 社会研究"
    },
    {
        "id":6167,
        "name":"6172 (English Program)  :  Social Science For Development | สังคมศาสตร์เพื่อการพัฒนา | 社会科学促进发展"
    },
    {
        "id":6168,
        "name":"6173 (English Program)  :  Sociology And Anthropology | สังคมวิทยาและมานุษยวิทยา | 社会学和人类学"
    },
    {
        "id":6169,
        "name":"6174 (English Program)  :  Soil Science | วิทยาศาสตร์ดิน | 土壤科学"
    },
    {
        "id":6170,
        "name":"6175 (English Program)  :  Southeast Asian Studies | การศึกษาเอเชียตะวันออกเฉียงใต้ | 东南亚研究"
    },
    {
        "id":6171,
        "name":"6176 (English Program)  :  Sport Management | การจัดการกีฬา | 运动管理"
    },
    {
        "id":6172,
        "name":"6177 (English Program)  :  Statistical Information Technology | เทคโนโลยีสารสนเทศทางสถิติ | 统计信息技术"
    },
    {
        "id":6173,
        "name":"6178 (English Program)  :  Statistics | สถิติ | 统计数据"
    },
    {
        "id":6174,
        "name":"6179 (English Program)  :  Strategic Management | การจัดการเชิงกลยุทธ์ | 战略管理"
    },
    {
        "id":6175,
        "name":"6180 (English Program)  :  Sustainable Land Use And Natural Resource Management | การใช้ที่ดินอย่างยั่งยืนและการจัดการทรัพยากรธรรมชาติ | 可持续土地利用和自然资源管理"
    },
    {
        "id":6176,
        "name":"6181 (English Program)  :  Teaching | การสอน | 教学"
    },
    {
        "id":6177,
        "name":"6182 (English Program)  :  Teaching English As A Foreign Language | การสอนภาษาอังกฤษเป็นภาษาต่างประเทศ | 英语作为外语教学"
    },
    {
        "id":6178,
        "name":"6183 (English Program)  :  Technology Management | การจัดการเทคโนโลยี | 技术管理"
    },
    {
        "id":6179,
        "name":"6184 (English Program)  :  Technology Multimedia And Animation | เทคโนโลยีมัลติมีเดียและแอนิเมชั่น | 科技多媒体和动画"
    },
    {
        "id":6180,
        "name":"6185 (English Program)  :  Technology Of Environmental Management | เทคโนโลยีการจัดการสิ่งแวดล้อม | 环境管理技术"
    },
    {
        "id":6181,
        "name":"6186 (English Program)  :  Textiles And Clothing | สิ่งทอและเสื้อผ้า | 纺织品和服装"
    },
    {
        "id":6182,
        "name":"6187 (English Program)  :  Thai Arts | ศิลปะไทย | 泰国艺术"
    },
    {
        "id":6183,
        "name":"6188 (English Program)  :  Thai Language And Culture | ภาษาและวัฒนธรรมไทย | 泰国语言和文化"
    },
    {
        "id":6184,
        "name":"6189 (English Program)  :  Thai Music | ดนตรีไทย | 泰国音乐"
    },
    {
        "id":6185,
        "name":"6190 (English Program)  :  Thai Studies | ไทยศึกษา | 泰国研究"
    },
    {
        "id":6186,
        "name":"6191 (English Program)  :  Tourism | การท่องเที่ยว | 旅游"
    },
    {
        "id":6187,
        "name":"6192 (English Program)  :  Tourism And Hospitality Management | การจัดการการท่องเที่ยวและการบริการ | 旅游和酒店管理"
    },
    {
        "id":6188,
        "name":"6193 (English Program)  :  Tourism And Hotel | การท่องเที่ยวและการโรงแรม | 旅游及酒店"
    },
    {
        "id":6189,
        "name":"6194 (English Program)  :  Tourism And Hotel Management | การจัดการการท่องเที่ยวและการโรงแรม | 旅游和酒店管理"
    },
    {
        "id":6190,
        "name":"6195 (English Program)  :  Tourism Industry | อุตสาหกรรมการท่องเที่ยว | 旅游产业"
    },
    {
        "id":6191,
        "name":"6196 (English Program)  :  Tourism Management | การจัดการการท่องเที่ยว | 旅游管理"
    },
    {
        "id":6192,
        "name":"6197 (English Program)  :  Travel Industry Management | การจัดการอุตสาหกรรมการท่องเที่ยว | 旅游业管理"
    },
    {
        "id":6193,
        "name":"6198 (English Program)  :  Tropical Medicine And Hygiene | ยาเขตร้อนและสุขอนามัย | 热带医学和卫生"
    },
    {
        "id":6194,
        "name":"6199 (English Program)  :  Urban Administration And Development | การบริหารและการพัฒนาเมือง | 城市管理与发展"
    },
    {
        "id":6195,
        "name":"6200 (English Program)  :  Urban And Environmental Planning | การวางแผนเมืองและสิ่งแวดล้อม | 城市与环境规划"
    },
    {
        "id":6196,
        "name":"6201 (English Program)  :  Urban Design | การออกแบบในเมือง | 城市设计"
    },
    {
        "id":6197,
        "name":"6202 (English Program)  :  Veterinary Medicine | สัตวแพทยศาสตร์ | 兽药"
    },
    {
        "id":6198,
        "name":"6203 (English Program)  :  Veterinary Public Health | สัตวแพทยศาสตร์สาธารณสุข | 兽医公共卫生"
    },
    {
        "id":6199,
        "name":"6204 (English Program)  :  Veterinary Technology | เทคโนโลยีสัตวแพทย์ | 兽医技术"
    },
    {
        "id":6200,
        "name":"6205 (English Program)  :  Visual Communication Design | การออกแบบการสื่อสารด้วยภาพ | 视觉传达设计"
    },
    {
        "id":6201,
        "name":"6206 (English Program)  :  Visual Design | การออกแบบภาพ | 视觉设计"
    },
    {
        "id":6202,
        "name":"6207 (English Program)  :  Water Resources Engineering | วิศวกรรมทรัพยากรน้ำ | 水资源工程"
    },
    {
        "id":6203,
        "name":"6208 (English Program)  :  Western Music | ดนตรีตะวันตก | 西方音乐"
    },
    {
        "id":6204,
        "name":"6209 (English Program)  :  Visual Art Innovation Design | การออกแบบนวัตกรรมทัศนศิลป์ | 视觉艺术创新设计"
    },
    {
        "id":6205,
        "name":"6210 (English Program)  :  Integration Of Health And Beauty | การบูรณาการด้านสุขภาพและความงาม | 健康与美丽的融合"
    },
    {
        "id":6206,
        "name":"6211 (English Program)  :  Tourism Business Management | การจัดการธุรกิจการท่องเที่ยว | 旅游商业管理"
    },
    {
        "id":6207,
        "name":"6212 (English Program)  :  Performance Communication | การสื่อสารที่มีประสิทธิภาพ | 绩效沟通"
    },
    {
        "id":6208,
        "name":"6213 (English Program)  :  Elearning Methodology | วิธีการเรียนรู้ | 电子学习方法"
    },
    {
        "id":6209,
        "name":"6214 (English Program)  :  Communicative Thai Language For Foreigners | ภาษาไทยเพื่อการสื่อสารสำหรับชาวต่างชาติ | 外国人泰语交流"
    },
    {
        "id":6210,
        "name":"6215 (English Program)  :  Restaurant And Lodging Business | ธุรกิจร้านอาหารและที่พัก | 餐饮及住宿业"
    },
    {
        "id":6211,
        "name":"6216 (English Program)  :  Airline Business | ธุรกิจการบิน | 航空业务"
    },
    {
        "id":6212,
        "name":"6217 (English Program)  :  Financial Engineering | วิศวกรรมการเงิน | 金融工程"
    },
    {
        "id":6213,
        "name":"6218 (English Program)  :  Computer Graphics And Animation | กราฟิกคอมพิวเตอร์และแอนิเมชั่น | 计算机图形和动画"
    },
    {
        "id":6214,
        "name":"6219 (English Program)  :  Visual Art And Design | ทัศนศิลป์และการออกแบบ | 视觉艺术与设计"
    },
    {
        "id":6215,
        "name":"6220 (English Program)  :  Administration Of Innovation For Development | การบริหารนวัตกรรมเพื่อการพัฒนา | 创新促进发展管理局"
    },
    {
        "id":6216,
        "name":"6221 (English Program)  :  Thai For Business Communication | ภาษาไทยเพื่อการสื่อสารทางธุรกิจ | 泰语商务沟通"
    },
    {
        "id":6217,
        "name":"6222 (English Program)  :  Professional English | ภาษาอังกฤษระดับมืออาชีพ | 专业英语"
    },
    {
        "id":6218,
        "name":"6223 (English Program)  :  Investment Analysis And Management | การวิเคราะห์และการจัดการการลงทุน | 投资分析与管理"
    },
    {
        "id":6219,
        "name":"6224 (Thai Program)  :  Educational Technology And Mass Communication | เทคโนโลยีการศึกษาและสื่อสารมวลชน | 教育技术和大众传播"
    },
    {
        "id":6220,
        "name":"6225 (Thai Program)  :  Chinese For International Business | ภาษาจีนเพื่อธุรกิจระหว่างประเทศ | 国际商务汉语"
    },
    {
        "id":6221,
        "name":"6226 (Thai Program)  :  Hotel Management | การจัดการการโรงแรม | 酒店管理"
    },
    {
        "id":6222,
        "name":"6227 (Thai Program)  :  Industrial Computer | คอมพิวเตอร์อุตสาหกรรม | 工业计算机"
    },
    {
        "id":6223,
        "name":"6228 (Thai Program)  :  Biomedical Technology | เทคโนโลยีชีวการแพทย์ | 生物医学技术"
    },
    {
        "id":6224,
        "name":"6229 (Thai Program)  :  International Marketing | การตลาดระหว่างประเทศ | 国际营销"
    },
    {
        "id":6225,
        "name":"6230 (Thai Program)  :  Online Communication Design | การออกแบบสื่อสารออนไลน์ | 在线传播设计"
    },
    {
        "id":6226,
        "name":"6231 (Thai Program)  :  Hotel Management Spa And Tourism | การจัดการโรงแรม สปาและการท่องเที่ยว | 酒店管理水疗和旅游"
    },
    {
        "id":6227,
        "name":"6232 (Thai Program)  :  Food Management | การจัดการอาหาร | 食品管理"
    },
    {
        "id":6228,
        "name":"6233 (Thai Program)  :  Retail And Franchise Management | การจัดการธุรกิจค้าปลีกและแฟรนไชส์ | 零售和特许经营管理"
    },
    {
        "id":6229,
        "name":"6234 (Thai Program)  :  Games And Animations | เกมและแอนิเมชัน | 游戏和动画"
    },
    {
        "id":6230,
        "name":"6235 (Thai Program)  :  Earth Science And Technology | วิทยาศาสตร์และเทคโนโลยีพื้นพิภพ | 地球科学与技术"
    },
    {
        "id":6231,
        "name":"6236 (Thai Program)  :  Communication Arts And Information | นิเทศศาสตร์และสารสนเทศ | 传播艺术与信息"
    },
    {
        "id":6232,
        "name":"6237 (Thai Program)  :  Aeronautical Science | วิทยาศาสตร์การบิน | 航空科学"
    },
    {
        "id":6233,
        "name":"6238 (English Program)  :  Teaching English | การสอนภาษาอังกฤษ | 英语教学"
    },
    {
        "id":6234,
        "name":"6239 (Thai Program)  :  Globalization Studies | โลกาภิวัฒน์ศึกษา | 全球化研究"
    },
    {
        "id":6235,
        "name":"6240 (Thai Program)  :  Entrepreneurial Economics | เศรษฐศาสตร์การประกอบการ | 创业经济学"
    },
    {
        "id":6236,
        "name":"6241 (English Program)  :  Educational Technology And Mass Communication | เทคโนโลยีการศึกษาและการสื่อสารมวลชน | 教育技术和大众传播"
    },
    {
        "id":6237,
        "name":"6242 (English Program)  :  Chinese For International Business | ภาษาจีนเพื่อธุรกิจระหว่างประเทศ | 国际商务汉语"
    },
    {
        "id":6238,
        "name":"6243 (English Program)  :  Industrial Computer | คอมพิวเตอร์อุตสาหกรรม | 工业电脑"
    },
    {
        "id":6239,
        "name":"6244 (English Program)  :  Biomedical Technology | เทคโนโลยีชีวการแพทย์ | 生物医学技术"
    },
    {
        "id":6240,
        "name":"6245 (English Program)  :  Digital Communication Design | การออกแบบการสื่อสารดิจิทัล | 数字通信设计"
    },
    {
        "id":6241,
        "name":"6246 (English Program)  :  Hotel, Spa And Tourism Management | การจัดการโรงแรม สปา และการท่องเที่ยว | 酒店、水疗和旅游管理"
    },
    {
        "id":6242,
        "name":"6247 (English Program)  :  Food Management | การจัดการอาหาร | 食品管理"
    },
    {
        "id":6243,
        "name":"6248 (English Program)  :  Retail And Franchise Business Management | การจัดการธุรกิจค้าปลีกและแฟรนไชส์ | 零售及特许经营业务管理"
    },
    {
        "id":6244,
        "name":"6249 (English Program)  :  Game And Animation | เกมและแอนิเมชั่น | 游戏与动画"
    },
    {
        "id":6245,
        "name":"6250 (English Program)  :  Earth Science And Technology | วิทยาศาสตร์โลกและเทคโนโลยี | 地球科学与技术"
    },
    {
        "id":6246,
        "name":"6251 (English Program)  :  Communication Arts And Information | ศิลปะการสื่อสารและข้อมูล | 传播艺术与信息"
    },
    {
        "id":6247,
        "name":"6252 (English Program)  :  Globalization Studies | การศึกษาโลกาภิวัตน์ | 全球化研究"
    },
    {
        "id":6248,
        "name":"6253 (English Program)  :  Entrepreneurial Economics | เศรษฐศาสตร์ผู้ประกอบการ | 创业经济学"
    },
    {
        "id":6249,
        "name":"6254 (English Program)  :  Journalism And Information Technology | วารสารศาสตร์และเทคโนโลยีสารสนเทศ | 新闻与信息技术"
    },
    {
        "id":6250,
        "name":"6255 (English Program)  :  Multimedia Technology And Animation | เทคโนโลยีมัลติมีเดียและแอนิเมชั่น | 多媒体技术与动画"
    },
    {
        "id":6251,
        "name":"6256 (Thai Program)  :  Food Industry Management Technology | เทคโนโลยีการจัดการอุตสาหกรรมอาหาร | 食品工业管理技术"
    },
    {
        "id":6252,
        "name":"6257 (English Program)  :  Food Industry Management Tecnology | เทคโนโลยีการจัดการอุตสาหกรรมอาหาร | 食品工业管理技术"
    },
    {
        "id":6253,
        "name":"6258 (Thai Program)  :  Computer Engineering Technology | เทคโนโลยีวิศวกรรมคอมพิวเตอร์ | 计算机工程技术"
    },
    {
        "id":6254,
        "name":"6259 (English Program)  :  Computer Engineering Technology | เทคโนโลยีวิศวกรรมคอมพิวเตอร์ | 计算机工程技术"
    },
    {
        "id":6255,
        "name":"6260 (Thai Program)  :  Architecture And Urban Design | สถาปัตยกรรมและการออกแบบชุมชนเมือง | 建筑与城市设计"
    },
    {
        "id":6256,
        "name":"6261 (English Program)  :  Architecture And Urban Design | สถาปัตยกรรมและการออกแบบเมือง | 建筑与城市设计"
    },
    {
        "id":6257,
        "name":"6262 (Thai Program)  :  Plant Health | สุขภาพพืช | 植物健康"
    },
    {
        "id":6258,
        "name":"6263 (English Program)  :  Plant Health | สุขภาพพืช | 植物健康"
    },
    {
        "id":6259,
        "name":"6264 (Thai Program)  :  Soil Management Science And Technology | วิทยาศาสตร์และเทคโนโลยีการจัดการทางดิน | 土壤管理科学与技术"
    },
    {
        "id":6260,
        "name":"6265 (English Program)  :  Soil Science And Management Technology | วิทยาศาสตร์ดินและเทคโนโลยีการจัดการ | 土壤科学与管理技术"
    },
    {
        "id":6261,
        "name":"6266 (Thai Program)  :  English For Business And Careers | ภาษาอังกฤษเพื่อธุรกิจและอาชีพ | 商业和职业英语"
    },
    {
        "id":6262,
        "name":"6267 (English Program)  :  English For Business And Professions | ภาษาอังกฤษเพื่อธุรกิจและวิชาชีพ | 商业和职业英语"
    },
    {
        "id":6263,
        "name":"6268 (Thai Program)  :  Primary Health Service Management | การจัดการบริการสุขภาพปฐมภูมิ | 初级卫生服务管理"
    },
    {
        "id":6264,
        "name":"6269 (Thai Program)  :  Educational Technology And Computer Studies | เทคโนโลยีการศึกษาและคอมพิวเตอร์ศึกษา | 教育技术和计算机研究"
    },
    {
        "id":6265,
        "name":"6270 (English Program)  :  Educational Technology And Computer Education | เทคโนโลยีการศึกษาและการศึกษาคอมพิวเตอร์ | 教育技术和计算机教育"
    },
    {
        "id":6266,
        "name":"6271 (Thai Program)  :  Art And Design | ศิลปะและการออกแบบ | 艺术与设计"
    },
    {
        "id":6267,
        "name":"6272 (English Program)  :  Art And Design | ศิลปะและการออกแบบ | 艺术与设计"
    },
    {
        "id":6268,
        "name":"6273 (Thai Program)  :  Industrial Production Technology | เทคโนโลยีการผลิตอุตสาหกรรม | 工业生产技术"
    },
    {
        "id":6269,
        "name":"6274 (Thai Program)  :  Sports And Entertainment Business | ธุรกิจการกีฬาและการบันเทิง | 体育及娱乐业务"
    },
    {
        "id":6270,
        "name":"6275 (English Program)  :  Sports And Entertainment Business | ธุรกิจกีฬาและความบันเทิง | 体育及娱乐业务"
    },
    {
        "id":6271,
        "name":"6276 (Thai Program)  :  Social Landscape Management | การจัดการภูมิสังคม | 社会景观管理"
    },
    {
        "id":6272,
        "name":"6277 (English Program)  :  Socio-Geographic Management | การจัดการทางสังคมและภูมิศาสตร์ | 社会地理管理"
    },
    {
        "id":6273,
        "name":"6278 (Thai Program)  :  Computer Engineering And Information Science | วิศวกรรมคอมพิวเตอร์และสนเทศศาสตร์ | 计算机工程与信息科学"
    },
    {
        "id":6274,
        "name":"6279 (English Program)  :  Computer Engineering And Informatics | วิศวกรรมคอมพิวเตอร์และสารสนเทศ | 计算机工程和信息学"
    },
    {
        "id":6275,
        "name":"6280 (Thai Program)  :  Logistics Management | การจัดการด้านโลจิสติกส์ | 物流管理"
    },
    {
        "id":6276,
        "name":"6281 (Thai Program)  :  Energy Technology And Management | เทคโนโลยีและการจัดการพลังงาน | 能源技术与管理"
    },
    {
        "id":6277,
        "name":"6282 (English Program)  :  Energy Technology And Management | เทคโนโลยีและการจัดการพลังงาน | 能源技术与管理"
    },
    {
        "id":6278,
        "name":"6283 (Thai Program)  :  Maritime Affairs Management | การบริหารกิจการทางทะเล | 海事管理"
    },
    {
        "id":6279,
        "name":"6284 (English Program)  :  Maritime Administration | การบริหารการเดินเรือ | 海事管理局"
    },
    {
        "id":6280,
        "name":"6285 (Thai Program)  :  Health Education And Physical Education | สุขศึกษาและพลศึกษา | 健康教育与体育"
    },
    {
        "id":6281,
        "name":"6286 (English Program)  :  Health And Physical Education | สุขภาพและพลศึกษา | 健康与体育"
    },
    {
        "id":6282,
        "name":"6287 (Thai Program)  :  Counseling Psychology Guidance And Special Education | จิตวิทยาการปรึกษา การแนะแนวและการศึกษาพิเศษ | 咨询心理学指导和特殊教育"
    },
    {
        "id":6283,
        "name":"6288 (English Program)  :  Counseling Psychology,Guidance And Special Education | จิตวิทยาการให้คำปรึกษา การแนะแนว และการศึกษาพิเศษ | 咨询心理学、指导和特殊教育"
    },
    {
        "id":6284,
        "name":"6289 (Thai Program)  :  Colorectal Surgery | ศัลยศาสตร์ลำไส้ใหญ่และทวารหนัก | 结直肠手术"
    },
    {
        "id":6285,
        "name":"6290 (English Program)  :  Colorectal Surgery | ศัลยกรรมลำไส้ใหญ่และทวารหนัก | 结直肠外科"
    },
    {
        "id":6286,
        "name":"6291 (Thai Program)  :  Veterinary Biosciences | ชีวศาสตร์ทางสัตวแพทย์ | 兽医生物科学"
    },
    {
        "id":6287,
        "name":"6292 (Thai Program)  :  Financial And Tax Law | กฎหมายการเงินและภาษีอากร | 金融税法"
    },
    {
        "id":6288,
        "name":"6293 (English Program)  :  Finance And Tax Laws | กฎหมายการเงินและภาษี | 金融和税法"
    },
    {
        "id":6289,
        "name":"6294 (Thai Program)  :  Clinical Biochemistry And Molecular Medicine | ชีวเคมีคลินิกและอณูทางการแพทย์ | 临床生物化学和分子医学"
    },
    {
        "id":6290,
        "name":"6295 (English Program)  :  Clinical Biochemistry And Molecular Medicine | ชีวเคมีคลินิกและอณูการแพทย์ | 临床生物化学和分子医学"
    },
    {
        "id":6291,
        "name":"6296 (Thai Program)  :  Clinical Hematology Science | วิทยาศาสตร์โลหิตวิทยาคลินิก | 临床血液学"
    },
    {
        "id":6292,
        "name":"6297 (English Program)  :  Clinical Hematology Sciences | วิทยาศาสตร์โลหิตวิทยาคลินิก | 临床血液学科学"
    },
    {
        "id":6293,
        "name":"6298 (Thai Program)  :  Management Of Information Systems For Business | การจัดการระบบสารสนเทศเพื่อธุรกิจ | 商业信息系统管理"
    },
    {
        "id":6294,
        "name":"6299 (English Program)  :  Management Information System For Business | ระบบสารสนเทศเพื่อการจัดการธุรกิจ | 企业管理信息系统"
    },
    {
        "id":6295,
        "name":"6300 (Thai Program)  :  Animation And Mixed Media | ภาพเคลื่อนไหวและสื่อผสม | 动画和混合媒体"
    },
    {
        "id":6296,
        "name":"6301 (English Program)  :  Animation And Multimedia | แอนิเมชั่นและมัลติมีเดีย | 动画和多媒体"
    },
    {
        "id":6297,
        "name":"6302 (Thai Program)  :  Broadcasting Images And Sound Through New Media | การแพร่ภาพและเสียงผ่านสื่อใหม่ | 通过新媒体传播图像和声音"
    },
    {
        "id":6298,
        "name":"6303 (English Program)  :  New Media Broadcasting | การออกอากาศสื่อใหม่ | 新媒体传播"
    },
    {
        "id":6299,
        "name":"6304 (Thai Program)  :  Materials Engineering And Metallurgy | วิศวกรรมวัสดุและโลหะการ | 材料工程与冶金"
    },
    {
        "id":6300,
        "name":"6305 (Thai Program)  :  Industrial Business Administration | บริหารธุรกิจอุตสาหกรรม | 工业企业管理"
    },
    {
        "id":6301,
        "name":"6306 (English Program)  :  Industrial Business Administration | การบริหารธุรกิจอุตสาหกรรม | 工业企业管理"
    },
    {
        "id":6302,
        "name":"6307 (Thai Program)  :  Mold And Tool Engineering Technology | เทคโนโลยีวิศวกรรมแม่พิมพ์และเครื่องมือ | 模具及工具工程技术"
    },
    {
        "id":6303,
        "name":"6308 (English Program)  :  Tools And Dies Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องมือและแม่พิมพ์ | 工具和模具工程技术"
    },
    {
        "id":6304,
        "name":"6309 (Thai Program)  :  Computer Aided Design And Construction Management | คอมพิวเตอร์ช่วยออกแบบและบริหารงานก่อสร้าง | 计算机辅助设计与施工管理"
    },
    {
        "id":6305,
        "name":"6310 (English Program)  :  Computer-Aided Design And Construction Management | การออกแบบโดยใช้คอมพิวเตอร์ช่วยและการจัดการการก่อสร้าง | 计算机辅助设计和施工管理"
    },
    {
        "id":6306,
        "name":"6311 (Thai Program)  :  Mathematics And Computational Science | คณิตศาสตร์และวิทยาการคำนวณ | 数学和计算科学"
    },
    {
        "id":6307,
        "name":"6312 (English Program)  :  Applied Mathematics And Computational Science | คณิตศาสตร์ประยุกต์และวิทยาศาสตร์คอมพิวเตอร์ | 应用数学和计算科学"
    },
    {
        "id":6308,
        "name":"6313 (Thai Program)  :  Research For Health Development | วิจัยเพื่อการพัฒนาสุขภาพ | 健康发展研究"
    },
    {
        "id":6309,
        "name":"6314 (English Program)  :  Research For Health Development | การวิจัยเพื่อการพัฒนาสุขภาพ | 健康发展研究"
    },
    {
        "id":6310,
        "name":"6315 (Thai Program)  :  Health Economics And Health Service Management | เศรษฐศาสตร์สาธารณสุขและการจัดการบริการสุขภาพ | 卫生经济学和卫生服务管理"
    },
    {
        "id":6311,
        "name":"6316 (English Program)  :  Health Economics And Health Care Management | เศรษฐศาสตร์สุขภาพและการจัดการดูแลสุขภาพ | 卫生经济学和卫生保健管理"
    },
    {
        "id":6312,
        "name":"6317 (Thai Program)  :  Teaching Chinese As A Foreign Language | การสอนภาษาจีนเป็นภาษาต่างประเทศ | 对外汉语教学"
    },
    {
        "id":6313,
        "name":"6318 (Thai Program)  :  Animal Biotechnology | เทคโนโลยีชีวภาพสัตว์ | 动物生物技术"
    },
    {
        "id":6314,
        "name":"6319 (English Program)  :  Animal Biotechnology | เทคโนโลยีชีวภาพสัตว์ | 动物生物技术"
    },
    {
        "id":6315,
        "name":"6320 (Thai Program)  :  Information System Security | ความมั่นคงทางระบบสารสนเทศ | 信息系统安全"
    },
    {
        "id":6316,
        "name":"6321 (English Program)  :  Information Systems Security | ความปลอดภัยของระบบสารสนเทศ | 信息系统安全"
    },
    {
        "id":6317,
        "name":"6322 (Thai Program)  :  Automation Engineering | วิศวกรรมอัตโนมัติ | 自动化工程"
    },
    {
        "id":6318,
        "name":"6323 (English Program)  :  Automation Engineering | วิศวกรรมอัตโนมัติ | 自动化工程"
    },
    {
        "id":6319,
        "name":"6324 (English Program)  :  Geographic Information Science | วิทยาศาสตร์สารสนเทศภูมิศาสตร์ | 地理信息科学"
    },
    {
        "id":6320,
        "name":"6325 (Thai Program)  :  Industrial Product Design Technology | เทคโนโลยีการออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计技术"
    },
    {
        "id":6321,
        "name":"6326 (English Program)  :  Technology Of Industrial Product Design | เทคโนโลยีการออกแบบผลิตภัณฑ์อุตสาหกรรม | 工业产品设计技术"
    },
    {
        "id":6322,
        "name":"6327 (Thai Program)  :  Data Recording Technology | เทคโนโลยีการบันทึกข้อมูล | 数据记录技术"
    },
    {
        "id":6323,
        "name":"6328 (English Program)  :  Data Storage Technology | เทคโนโลยีการจัดเก็บข้อมูล | 数据存储技术"
    },
    {
        "id":6324,
        "name":"6329 (Thai Program)  :  Infrastructure Management And Urban Development | การจัดการโครงสร้างพื้นฐานและการพัฒนาเมือง | 基础设施管理和城市发展"
    },
    {
        "id":6325,
        "name":"6330 (English Program)  :  Infrastructure Management And Urban Development | การจัดการโครงสร้างพื้นฐานและการพัฒนาเมือง | 基础设施管理和城市发展"
    },
    {
        "id":6326,
        "name":"6331 (English Program)  :  Visual Art Design | การออกแบบทัศนศิลป์ | 视觉艺术设计"
    },
    {
        "id":6327,
        "name":"6332 (Thai Program)  :  Educational Research And Evaluation | การวิจัยและประเมินผลทางการศึกษา | 教育研究与评估"
    },
    {
        "id":6328,
        "name":"6333 (English Program)  :  Research And Evaluation In Education | การวิจัยและประเมินผลทางการศึกษา | 教育研究与评估"
    },
    {
        "id":6329,
        "name":"6334 (Thai Program)  :  Media And Strategic Communications | สื่อและการสื่อสารเชิงกลยุทธ์ | 媒体和战略传播"
    },
    {
        "id":6330,
        "name":"6335 (English Program)  :  Media And Strategic Communication | สื่อและการสื่อสารเชิงกลยุทธ์ | 媒体和战略传播"
    },
    {
        "id":6331,
        "name":"6336 (Thai Program)  :  Management Of Public And Private Organizations | การบริหารองค์การภาครัฐและเอกชน | 公共和私人组织的管理"
    },
    {
        "id":6332,
        "name":"6337 (English Program)  :  Public And Private Organization Administration | การบริหารงานภาครัฐและเอกชน | 公共和私人组织管理"
    },
    {
        "id":6333,
        "name":"6338 (Thai Program)  :  Agricultural Economics Resources And Environment | เศรษฐศาสตร์เกษตร ทรัพยากรและสิ่งแวดล้อม | 农业经济学资源环境"
    },
    {
        "id":6334,
        "name":"6339 (English Program)  :  Agricultural Natural Resources And Environmental Economics | ทรัพยากรธรรมชาติเกษตรกรรมและเศรษฐศาสตร์สิ่งแวดล้อม | 农业自然资源与环境经济"
    },
    {
        "id":6335,
        "name":"6340 (Thai Program)  :  Digital Communication | การสื่อสารดิจิทัล | 数字通讯"
    },
    {
        "id":6336,
        "name":"6341 (English Program)  :  Digital Communication | การสื่อสารดิจิทัล | 数字通讯"
    },
    {
        "id":6337,
        "name":"6342 (Thai Program)  :  Interior Design Management | การจัดการออกแบบภายใน | 室内设计管理"
    },
    {
        "id":6338,
        "name":"6343 (English Program)  :  Interior Design Management | การจัดการออกแบบตกแต่งภายใน | 室内设计管理"
    },
    {
        "id":6339,
        "name":"6344 (Thai Program)  :  Hotel Business | ธุรกิจโรงแรม | 酒店业务"
    },
    {
        "id":6340,
        "name":"6345 (Thai Program)  :  Dairy Technology | เทคโนโลยีโคนม | 乳制品技术"
    },
    {
        "id":6341,
        "name":"6346 (Thai Program)  :  Business Administration And Management | บริหารธุรกิจและการจัดการ | 工商管理"
    },
    {
        "id":6342,
        "name":"6347 (English Program)  :  Molecular Genetics | อณูพันธุศาสตร์ | 分子遗传学"
    },
    {
        "id":6343,
        "name":"6348 (Thai Program)  :  Development Planning Geography | ภูมิศาสตร์การวางแผนพัฒนา | 发展规划地理"
    },
    {
        "id":6344,
        "name":"6349 (English Program)  :  Development Planning Geography | ภูมิศาสตร์การวางแผนพัฒนา | 发展规划地理"
    },
    {
        "id":6345,
        "name":"6350 (Thai Program)  :  Service Industry Management | การจัดการอุตสาหกรรมบริการ | 服务业管理"
    },
    {
        "id":6346,
        "name":"6351 (Thai Program)  :  Health Communication | การสื่อสารสุขภาพ | 健康传播"
    },
    {
        "id":6347,
        "name":"6352 (English Program)  :  Health Communication | การสื่อสารด้านสุขภาพ | 健康传播"
    },
    {
        "id":6348,
        "name":"6353 (English Program)  :  Organization Development And Human Capability Management | การพัฒนาองค์กรและการจัดการขีดความสามารถของมนุษย์ | 组织发展和人力资源管理"
    },
    {
        "id":6349,
        "name":"6354 (Thai Program)  :  Organizational Development And Human Performance Management | การพัฒนาองค์การและการจัดการสมรรถนะของมนุษย์ | 组织发展和人力绩效管理"
    },
    {
        "id":6350,
        "name":"6355 (Thai Program)  :  Science Communication | การสื่อสารวิทยาศาสตร์ | 科学传播"
    },
    {
        "id":6351,
        "name":"6356 (English Program)  :  Science Communication | การสื่อสารทางวิทยาศาสตร์ | 科学传播"
    },
    {
        "id":6352,
        "name":"6357 (Thai Program)  :  Thai Classical Dance | นาฏดุริยางคศิลป์ไทย | 泰国古典舞"
    },
    {
        "id":6353,
        "name":"6358 (English Program)  :  Thai Music And Dramatic Arts | ดนตรีไทยและนาฏศิลป์ | 泰国音乐和戏剧艺术"
    },
    {
        "id":6354,
        "name":"6359 (Thai Program)  :  Sustainable Pest Management | การบริหารศัตรูพืชอย่างยั่งยืน | 可持续害虫管理"
    },
    {
        "id":6355,
        "name":"6360 (English Program)  :  Sustainable Pest Management | การจัดการสัตว์รบกวนอย่างยั่งยืน | 可持续害虫管理"
    },
    {
        "id":6356,
        "name":"6361 (Thai Program)  :  Crop Production | การผลิตพืช | 农作物生产"
    },
    {
        "id":6357,
        "name":"6362 (English Program)  :  Crop Production | การผลิตพืชผล | 农作物生产"
    },
    {
        "id":6358,
        "name":"6363 (Thai Program)  :  Integrated Animal Production | การผลิตสัตว์เชิงบูรณาการ | 综合畜牧生产"
    },
    {
        "id":6359,
        "name":"6364 (English Program)  :  Integrated Animal Production | การผลิตสัตว์แบบบูรณาการ | 综合动物生产"
    },
    {
        "id":6360,
        "name":"6365 (Thai Program)  :  Fashion Design And Textile Arts | การออกแบบแฟชั่นและศิลปะสิ่งทอ | 时装设计与纺织艺术"
    },
    {
        "id":6361,
        "name":"6366 (English Program)  :  Fashion Design And Textile Art | การออกแบบแฟชั่นและศิลปะสิ่งทอ | 时装设计与纺织艺术"
    },
    {
        "id":6362,
        "name":"6367 (Thai Program)  :  Educational Administration Technology | เทคโนโลยีการบริหารการศึกษา | 教育行政技术"
    },
    {
        "id":6363,
        "name":"6368 (English Program)  :  Education Administration Technology | เทคโนโลยีการบริหารการศึกษา | 教育管理技术"
    },
    {
        "id":6364,
        "name":"6369 (Thai Program)  :  Technology Research And Development Curriculum | เทคโนโลยีการวิจัยและพัฒนาหลักสูตร | 技术研发课程"
    },
    {
        "id":6365,
        "name":"6370 (English Program)  :  Technology In Curriculum Research And Development | เทคโนโลยีในการวิจัยและพัฒนาหลักสูตร | 课程研发技术"
    },
    {
        "id":6366,
        "name":"6371 (Thai Program)  :  Information Technologyeducation | เทคโนโลยีสารสนเทศการศึกษา | 信息技术教育"
    },
    {
        "id":6367,
        "name":"6372 (English Program)  :  Educational Information Technology | เทคโนโลยีสารสนเทศทางการศึกษา | 教育信息技术"
    },
    {
        "id":6368,
        "name":"6373 (Thai Program)  :  Post-Harvest And Processing Technology | เทคโนโลยีหลังการเก็บเกี่ยวและแปรสภาพ | 采后及加工技术"
    },
    {
        "id":6369,
        "name":"6374 (English Program)  :  Post-Harvest And Processing Technology | เทคโนโลยีหลังการเก็บเกี่ยวและการแปรรูป | 采后和加工技术"
    },
    {
        "id":6370,
        "name":"6375 (English Program)  :  Media Studies | สื่อศึกษา | 媒体研究"
    },
    {
        "id":6371,
        "name":"6376 (English Program)  :  Structural Engineering | วิศวกรรมโครงสร้าง | 结构工程"
    },
    {
        "id":6372,
        "name":"6377 (English Program)  :  International And Multicultural Education | การศึกษานานาชาติและพหุวัฒนธรรม | 国际和多元文化教育"
    },
    {
        "id":6373,
        "name":"6378 (English Program)  :  Ceramic And Materials Engineering | วิศวกรรมเซรามิกและวัสดุ | 陶瓷与材料工程"
    },
    {
        "id":6374,
        "name":"6379 (English Program)  :  International Environmental Policy | นโยบายสิ่งแวดล้อมระหว่างประเทศ | 国际环境政策"
    },
    {
        "id":6375,
        "name":"6380 (Thai Program)  :  Small And Medium Business Management | การจัดการธุรกิจขนาดกลางและขนาดย่อม | 中小企业管理"
    },
    {
        "id":6376,
        "name":"6381 (English Program)  :  Sme Management | การจัดการเอสเอ็มอี | 中小企业管理"
    },
    {
        "id":6377,
        "name":"6382 (Thai Program)  :  Organized Mathematics And Optimization | คณิตศาสตร์เชิงการจัดและการหาค่าเหมาะที่สุด | 组织数学和优化"
    },
    {
        "id":6378,
        "name":"6383 (Thai Program)  :  Inspection And Engineering Law | การตรวจสอบและกฎหมายวิศวกรรม | 检验与工程法"
    },
    {
        "id":6379,
        "name":"6384 (English Program)  :  Inspection And Engineering Law | กฎหมายการตรวจสอบและวิศวกรรม | 检验与工程法"
    },
    {
        "id":6380,
        "name":"6385 (Thai Program)  :  Product Design And Development Management | การจัดการการออกแบบและพัฒนาผลิตภัณฑ์ | 产品设计与开发管理"
    },
    {
        "id":6381,
        "name":"6386 (English Program)  :  Management Of Product Design And Development | การจัดการการออกแบบและพัฒนาผลิตภัณฑ์ | 产品设计和开发管理"
    },
    {
        "id":6382,
        "name":"6387 (Thai Program)  :  Public Health Administration | การบริหารงานสาธารณสุข | 公共卫生管理"
    },
    {
        "id":6383,
        "name":"6388 (Thai Program)  :  History For Tourism | ประวัติศาสตร์เพื่อการท่องเที่ยว | 旅游业的历史"
    },
    {
        "id":6384,
        "name":"6389 (English Program)  :  History For Tourism | ประวัติศาสตร์เพื่อการท่องเที่ยว | 旅游业的历史"
    },
    {
        "id":6385,
        "name":"6390 (Thai Program)  :  Public Administration And Law | การบริหารรัฐกิจและกฎหมาย | 公共行政和法律"
    },
    {
        "id":6386,
        "name":"6391 (English Program)  :  Public Administration And Law | การบริหารราชการและกฎหมาย | 公共行政和法律"
    },
    {
        "id":6387,
        "name":"6392 (Thai Program)  :  Recreation Leadership And Management | การเป็นผู้นำและการบริหารจัดการนันทนาการ | 娱乐领导与管理"
    },
    {
        "id":6388,
        "name":"6393 (English Program)  :  Recreational Leadership And Management | ความเป็นผู้นำและการจัดการด้านสันทนาการ | 娱乐领导和管理"
    },
    {
        "id":6389,
        "name":"6394 (Thai Program)  :  Cultural Tourism | การท่องเที่ยวเชิงวัฒนธรรม | 文化旅游"
    },
    {
        "id":6390,
        "name":"6395 (English Program)  :  Cultural Tourism | การท่องเที่ยวเชิงวัฒนธรรม | 文化旅游"
    },
    {
        "id":6391,
        "name":"6396 (Thai Program)  :  Popular Thai Music | ดนตรีไทยสมัยนิยม | 流行泰国音乐"
    },
    {
        "id":6392,
        "name":"6397 (English Program)  :  Thai Popular Music | ดนตรีไทยยอดนิยม | 泰国流行音乐"
    },
    {
        "id":6393,
        "name":"6398 (Thai Program)  :  Media Arts | มีเดียอาตส์ | 媒体艺术"
    },
    {
        "id":6394,
        "name":"6399 (Thai Program)  :  Technology And Innovation For Educational Administration | เทคโนโลยีและนวัตกรรมเพื่อการบริหารการศึกษา | 教育管理的技术与创新"
    },
    {
        "id":6395,
        "name":"6400 (English Program)  :  Technology And Innovation For Educational Administration | เทคโนโลยีและนวัตกรรมเพื่อการบริหารการศึกษา | 教育管理的技术与创新"
    },
    {
        "id":6396,
        "name":"6401 (English Program)  :  Freie Kunst | ศิลปะฟรี | 自由艺术"
    },
    {
        "id":6397,
        "name":"6402 (English Program)  :  Annual Conbocation | การประชุมประจำปี | 年度组合"
    },
    {
        "id":6398,
        "name":"6403 (Thai Program)  :  Pharmaceutical Management | การจัดการทางเภสัชกรรม | 药品管理"
    },
    {
        "id":6399,
        "name":"6404 (Thai Program)  :  Health Informatics | สารสนเทศศาสตร์ทางสุขภาพ | 健康信息学"
    },
    {
        "id":6400,
        "name":"6405 (Thai Program)  :  Hotel And Accommodation Business | ธุรกิจโรงแรมและที่พัก | 酒店及住宿业务"
    },
    {
        "id":6401,
        "name":"6406 (English Program)  :  Hotel And Lodging Business | ธุรกิจโรงแรมและที่พัก | 酒店及住宿业务"
    },
    {
        "id":6402,
        "name":"6407 (Thai Program)  :  Engineering Business | ธุรกิจวิศวกรรม | 工程业务"
    },
    {
        "id":6403,
        "name":"6408 (English Program)  :  Engineering Business | ธุรกิจวิศวกรรม | 工程业务"
    },
    {
        "id":6404,
        "name":"6409 (Thai Program)  :  Thai Language For Career Development | ภาษาไทยเพื่อการพัฒนาอาชีพ | 泰语有助于职业发展"
    },
    {
        "id":6405,
        "name":"6410 (English Program)  :  Thai For Career Development | ภาษาไทยเพื่อการพัฒนาอาชีพ | 泰语职业发展"
    },
    {
        "id":6406,
        "name":"6411 (Thai Program)  :  Anti-Aging Medicine And Health Restoration | เวชศาสตร์ชะลอวัยและฟื้นฟูสุขภาพ | 抗衰老医学和健康恢复"
    },
    {
        "id":6407,
        "name":"6412 (English Program)  :  Anti-Aging And Regenerative Medicine | ยาต่อต้านวัยและฟื้นฟู | 抗衰老和再生医学"
    },
    {
        "id":6408,
        "name":"6413 (Thai Program)  :  Science Slows Aging And Restores Health. | วิทยาศาสตร์ชะลอวัยและฟื้นฟูสุขภาพ | 科学可以延缓衰老、恢复健康。"
    },
    {
        "id":6409,
        "name":"6414 (English Program)  :  Anti-Aging And Regenerative Science | วิทยาศาสตร์การต่อต้านวัยและการฟื้นฟู | 抗衰老和再生科学"
    },
    {
        "id":6410,
        "name":"6415 (Thai Program)  :  Measurement And Cognitive Science Technology | การวัดและเทคโนโลยีทางวิทยาการปัญญา | 测量与认知科学技术"
    },
    {
        "id":6411,
        "name":"6416 (English Program)  :  Measurement And Technology In Cognitive Science | การวัดและเทคโนโลยีในองค์ความรู้วิทยาศาสตร์ | 认知科学中的测量和技术"
    },
    {
        "id":6412,
        "name":"6417 (Thai Program)  :  Cognitive Science Research And Statistics | การวิจัยและสถิติทางวิทยาการปัญญา | 认知科学研究与统计"
    },
    {
        "id":6413,
        "name":"6418 (English Program)  :  Research And Statistics In Cognitive Science | การวิจัยและสถิติทางวิทยาศาสตร์เกี่ยวกับความรู้ความเข้าใจ | 认知科学的研究和统计"
    },
    {
        "id":6414,
        "name":"6419 (Thai Program)  :  Teacher Education Development | การพัฒนาครุศึกษา | 教师教育发展"
    },
    {
        "id":6415,
        "name":"6420 (English Program)  :  Teacher Education Development | การพัฒนาการศึกษาครู | 教师教育发展"
    },
    {
        "id":6416,
        "name":"6421 (Thai Program)  :  Automotive Mechanical Engineering | วิศวกรรมเครื่องกลยานยนต์ | 汽车机械工程"
    },
    {
        "id":6417,
        "name":"6422 (English Program)  :  Automotive Mechanical Engineering | วิศวกรรมเครื่องกลยานยนต์ | 汽车机械工程"
    },
    {
        "id":6418,
        "name":"6423 (English Program)  :  Human Performance | ประสิทธิภาพของมนุษย์ | 人类表现"
    },
    {
        "id":6419,
        "name":"6424 (English Program)  :  Shipping Management | การจัดการการจัดส่งสินค้า | 运输管理"
    },
    {
        "id":6420,
        "name":"6425 (English Program)  :  Optical Science | วิทยาศาสตร์แสง | 光学科学"
    },
    {
        "id":6421,
        "name":"6426 (Thai Program)  :  Communication Skills For Human Resource Development | ทักษะการติดต่อสื่อสารเพื่อการพัฒนาทรัพยากรมนุษย์ | 人力资源开发的沟通技巧"
    },
    {
        "id":6422,
        "name":"6427 (English Program)  :  Communication Skills For Human Resource Development | ทักษะการสื่อสารเพื่อการพัฒนาทรัพยากรมนุษย์ | 人力资源开发的沟通技巧"
    },
    {
        "id":6423,
        "name":"6428 (Thai Program)  :  Management And Development Strategy | ยุทธศาสตร์การบริหารและการพัฒนา | 管理与发展战略"
    },
    {
        "id":6424,
        "name":"6429 (English Program)  :  Administration And Development Strategy | ยุทธศาสตร์การบริหารและพัฒนา | 行政与发展策略"
    },
    {
        "id":6425,
        "name":"6430 (Thai Program)  :  Criminology And Administration Of Justice | อาชญาวิทยาและการบริหารงานยุติธรรม | 犯罪学和司法行政"
    },
    {
        "id":6426,
        "name":"6431 (Thai Program)  :  Innovation | นวัตกรรม | 创新"
    },
    {
        "id":6427,
        "name":"6432 (Thai Program)  :  Entrepreneurial Business Innovation | นวัตกรรมธุรกิจผู้ประกอบการ | 创业型企业创新"
    },
    {
        "id":6428,
        "name":"6433 (Thai Program)  :  Nutrition And Dietetics | โภชนาการและการกำหนดอาหาร | 营养与饮食学"
    },
    {
        "id":6429,
        "name":"6434 (Thai Program)  :  Development Strategy Based On The Sufficiency Economy Philosophy | ยุทธศาสตร์การพัฒนาตามหลักปรัชญาเศรษฐกิจพอเพียง | 基于充足经济理念的发展战略"
    },
    {
        "id":6430,
        "name":"6435 (English Program)  :  Philosophy Of Sufficiency Economy For Strategy | ปรัชญาเศรษฐกิจพอเพียงเพื่อยุทธศาสตร์ | 充足经济战略哲学"
    },
    {
        "id":6431,
        "name":"6436 (Thai Program)  :  Industrial Administration And Development | การบริหารและพัฒนาอุตสาหกรรม | 工业管理与发展"
    },
    {
        "id":6432,
        "name":"6437 (English Program)  :  Industrial Administration And Development | การบริหารและการพัฒนาอุตสาหกรรม | 工业管理与发展"
    },
    {
        "id":6433,
        "name":"6438 (Thai Program)  :  Agricultural System Technology | เทคโนโลยีระบบเกษตร | 农业系统技术"
    },
    {
        "id":6434,
        "name":"6439 (English Program)  :  Agricultural Systems Technology | เทคโนโลยีระบบการเกษตร | 农业系统技术"
    },
    {
        "id":6435,
        "name":"6440 (Thai Program)  :  Structural Technology For The Built Environment | เทคโนโลยีโครงสร้างเพื่อสิ่งแวดล้อมสรรค์สร้าง | 建筑环境的结构技术"
    },
    {
        "id":6436,
        "name":"6441 (English Program)  :  Structural Technology For The Built Environment | เทคโนโลยีโครงสร้างสำหรับสภาพแวดล้อมที่สร้างขึ้น | 建筑环境的结构技术"
    },
    {
        "id":6437,
        "name":"6442 (Thai Program)  :  Horticulture | วิทยาการพืชสวน | 园艺"
    },
    {
        "id":6438,
        "name":"6443 (English Program)  :  Horticultural Scicence | วิทยาศาสตร์พืชสวน | 园艺科学"
    },
    {
        "id":6439,
        "name":"6444 (Thai Program)  :  Educational Innovation And Technology | นวัตกรรมและเทคโนโลยีทางการศึกษา | 教育创新与科技"
    },
    {
        "id":6440,
        "name":"6445 (English Program)  :  Educational Innovation And Technology | นวัตกรรมและเทคโนโลยีทางการศึกษา | 教育创新与科技"
    },
    {
        "id":6441,
        "name":"6446 (Thai Program)  :  Media And Communication Technology | เทคโนโลยีสื่อและการสื่อสาร | 媒体和通信技术"
    },
    {
        "id":6442,
        "name":"6447 (English Program)  :  Media And Communication Technology | เทคโนโลยีสื่อและการสื่อสาร | 媒体和通信技术"
    },
    {
        "id":6443,
        "name":"6448 (Thai Program)  :  Thai Language For Innovative Communication | ภาษาไทยเพื่อนวัตกรรมการสื่อสาร | 用于创新沟通的泰语"
    },
    {
        "id":6444,
        "name":"6449 (English Program)  :  Thai Language For Communicative Innovation | ภาษาไทยเพื่อนวัตกรรมการสื่อสาร | 泰语的交流创新"
    },
    {
        "id":6445,
        "name":"6450 (Thai Program)  :  Three Dimensional Information Design | การออกแบบสนเทศสามมิติ | 三维信息设计"
    },
    {
        "id":6446,
        "name":"6451 (English Program)  :  3D-Based Communication Design | การออกแบบการสื่อสารแบบ 3 มิติ | 基于 3D 的通信设计"
    },
    {
        "id":6447,
        "name":"6452 (Thai Program)  :  Civil Engineering And Education | วิศวกรรมโยธาและการศึกษา | 土木工程与教育"
    },
    {
        "id":6448,
        "name":"6453 (English Program)  :  Civil Engineering And Education | วิศวกรรมโยธาและการศึกษา | 土木工程和教育"
    },
    {
        "id":6449,
        "name":"6454 (English Program)  :  Tool And Dies Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องมือและแม่พิมพ์ | 工具和模具工程技术"
    },
    {
        "id":6450,
        "name":"6455 (Thai Program)  :  Visual Effects | วิชวลเอฟเฟค | 视觉效果"
    },
    {
        "id":6451,
        "name":"6456 (English Program)  :  Visual Effects | เอฟเฟ็กต์ภาพ | 视觉效果"
    },
    {
        "id":6452,
        "name":"6457 (Thai Program)  :  Commercial Pilot | นักบินพาณิชย์ | 商业飞行员"
    },
    {
        "id":6453,
        "name":"6458 (English Program)  :  Commercial Pilot | นักบินพาณิชย์ | 商业飞行员"
    },
    {
        "id":6454,
        "name":"6459 (Thai Program)  :  International Relations And Development | ความสัมพันธ์และการพัฒนาระหว่างประเทศ | 国际关系与发展"
    },
    {
        "id":6455,
        "name":"6460 (English Program)  :  International Relations And Development | ความสัมพันธ์ระหว่างประเทศและการพัฒนา | 国际关系与发展"
    },
    {
        "id":6456,
        "name":"6461 (Thai Program)  :  Enterprise Software | ซอฟต์แวร์วิสาหกิจ | 企业软件"
    },
    {
        "id":6457,
        "name":"6462 (English Program)  :  Enterprise Software | ซอฟต์แวร์ระดับองค์กร | 企业软件"
    },
    {
        "id":6458,
        "name":"6463 (Thai Program)  :  Marketing Techniques | เทคนิคทางการตลาด | 营销技巧"
    },
    {
        "id":6459,
        "name":"6464 (English Program)  :  Marketing Technique | เทคนิคการตลาด | 营销技巧"
    },
    {
        "id":6460,
        "name":"6465 (Thai Program)  :  Entrepreneurial Management | การจัดการผู้ประกอบการ | 创业管理"
    },
    {
        "id":6461,
        "name":"6466 (English Program)  :  Entrepreneurial Management | การจัดการผู้ประกอบการ | 创业管理"
    },
    {
        "id":6462,
        "name":"6467 (Thai Program)  :  Psychological Science | วิทยาศาสตร์จิตวิทยา | 心理科学"
    },
    {
        "id":6463,
        "name":"6468 (English Program)  :  Psychological Science | วิทยาศาสตร์จิตวิทยา | 心理科学"
    },
    {
        "id":6464,
        "name":"6469 (Thai Program)  :  Manage Agricultural Resources | บริหารจัดการทรัพยากรการเกษตร | 管理农业资源"
    },
    {
        "id":6465,
        "name":"6470 (English Program)  :  Agricultural Resources Administrstration | การบริหารทรัพยากรเกษตร | 农业资源管理局"
    },
    {
        "id":6466,
        "name":"6471 (Thai Program)  :  Hotel And Resort Management | การจัดการโรงแรมและรีสอร์ท | 酒店及度假村管理"
    },
    {
        "id":6467,
        "name":"6472 (English Program)  :  Hotel And Resort Management | การจัดการโรงแรมและรีสอร์ท | 酒店和度假村管理"
    },
    {
        "id":6468,
        "name":"6473 (Thai Program)  :  Hotel And Mice Management | การจัดการโรงแรมและไมซ์ | 酒店及会展管理"
    },
    {
        "id":6469,
        "name":"6474 (English Program)  :  Mice And Events Management | การจัดการไมซ์และกิจกรรม | 会议及活动管理"
    },
    {
        "id":6470,
        "name":"6475 (Thai Program)  :  Kitchen Management And Culinary Arts | การจัดการครัวและศิลปะการประกอบอาหาร | 厨房管理和烹饪艺术"
    },
    {
        "id":6471,
        "name":"6476 (English Program)  :  Culinary Arts And Kitchen Management | ศิลปะการทำอาหารและการจัดการครัว | 烹饪艺术和厨房管理"
    },
    {
        "id":6472,
        "name":"6477 (Thai Program)  :  Spa Management | การจัดการสปา | 水疗管理"
    },
    {
        "id":6473,
        "name":"6478 (English Program)  :  Spa Management | การจัดการสปา | 水疗管理"
    },
    {
        "id":6474,
        "name":"6479 (English Program)  :  Health And Psysical Education | การศึกษาด้านสุขภาพและจิตวิทยา | 健康与体育教育"
    },
    {
        "id":6475,
        "name":"6480 (English Program)  :  Counseling Psychology Guidance And Special Education | การให้คำปรึกษาด้านจิตวิทยาและการศึกษาพิเศษ | 咨询心理指导及特殊教育"
    },
    {
        "id":6476,
        "name":"6481 (Thai Program)  :  Airline Business Management | การจัดการธุรกิจสายการบิน | 航空公司业务管理"
    },
    {
        "id":6477,
        "name":"6482 (English Program)  :  Airline Business Management | การจัดการธุรกิจสายการบิน | 航空业务管理"
    },
    {
        "id":6478,
        "name":"6483 (Thai Program)  :  Industrial Pipe Technology | เทคโนโลยีท่ออุตสาหกรรม | 工业管道技术"
    },
    {
        "id":6479,
        "name":"6484 (English Program)  :  Industrial Piping Technology | เทคโนโลยีท่ออุตสาหกรรม | 工业管道技术"
    },
    {
        "id":6480,
        "name":"6485 (Thai Program)  :  Agricultural Resource Management | การบริหารจัดการทรัพยากรการเกษตร | 农业资源管理"
    },
    {
        "id":6481,
        "name":"6486 (English Program)  :  Agricultural Resources Administration | การบริหารทรัพยากรเกษตร | 农业资源管理局"
    },
    {
        "id":6482,
        "name":"6487 (Thai Program)  :  Electrical Communication And Electronics Engineering | วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ | 电气通信与电子工程"
    },
    {
        "id":6483,
        "name":"6488 (Thai Program)  :  Medical And Scientific Media | มีเดียทางการแพทย์และวิทยาศาสตร์ | 医学和科学媒体"
    },
    {
        "id":6484,
        "name":"6489 (Thai Program)  :  Thai Sign Language Interpreter | ล่ามภาษามือไทย | 泰语手语翻译"
    },
    {
        "id":6485,
        "name":"6490 (Thai Program)  :  Management Of Science And Technology Teaching | การจัดการการเรียนการสอนวิทยาศาสตร์และเทคโนโลยี | 科技教学管理"
    },
    {
        "id":6486,
        "name":"6491 (Thai Program)  :  Textile And Fashion Design | ออกแบบสิ่งทอและแฟชั่น | 纺织及时装设计"
    },
    {
        "id":6487,
        "name":"6492 (Thai Program)  :  German For Travel | ภาษาเยอรมันเพื่อการท่องเที่ยว | 旅行德语"
    },
    {
        "id":6488,
        "name":"6493 (Thai Program)  :  Chinese Language And Culture | ภาษาและวัฒนธรรมจีน | 中国语言和文化"
    },
    {
        "id":6489,
        "name":"6494 (Thai Program)  :  Architectural Management | การจัดการงานสถาปัตยกรรม | 建筑管理"
    },
    {
        "id":6490,
        "name":"6495 (Thai Program)  :  Tourism And Service Management | การจัดการการท่องเที่ยวและบริการ | 旅游与服务管理"
    },
    {
        "id":6491,
        "name":"6496 (Thai Program)  :  Environmental And Biological Health | อนามัยสิ่งแวดล้อมและชีวอนามัย | 环境和生物健康"
    },
    {
        "id":6492,
        "name":"6497 (Thai Program)  :  Aviation Business Management | การจัดการธุรกิจการบิน | 航空业务管理"
    },
    {
        "id":6493,
        "name":"6498 (Thai Program)  :  Hotel Business Management | การจัดการธุรกิจโรงแรม | 酒店经营管理"
    },
    {
        "id":6494,
        "name":"6499 (Thai Program)  :  Mice Business Management | การจัดการธุรกิจไมซ์ | 会展商务管理"
    },
    {
        "id":6495,
        "name":"6500 (Thai Program)  :  Management Of Agricultural Resources For Tourism | การจัดการทรัพยากรเกษตรเพื่อการท่องเที่ยว | 旅游农业资源管理"
    },
    {
        "id":6496,
        "name":"6501 (Thai Program)  :  Internet Technology | เทคโนโลยีอินเทอร์เน็ต | 互联网技术"
    },
    {
        "id":6497,
        "name":"6502 (Thai Program)  :  Industrial Technology And Textile Product Management | เทคโนโลยีอุตสาหกรรมและการจัดการสินค้าสิ่งทอ | 工业技术和纺织产品管理"
    },
    {
        "id":6498,
        "name":"6503 (Thai Program)  :  International Business In Indochina Group | ธุรกิจระหว่างประเทศในกลุ่มอินโดจีน | 印度支那集团国际业务"
    },
    {
        "id":6499,
        "name":"6504 (Thai Program)  :  Engineering Technology Management | การจัดการเทคโนโลยีวิศวกรรม | 工程技术管理"
    },
    {
        "id":6500,
        "name":"6505 (Thai Program)  :  Computer Science Mathematics | คณิตศาสตร์เชิงวิทยาการคอมพิวเตอร์ | 计算机科学 数学"
    },
    {
        "id":6501,
        "name":"6506 (Thai Program)  :  Industrial Management Engineering For Sustainability | วิศวกรรมการจัดการอุตสาหกรรมเพื่อความยั่งยืน | 可持续发展的工业管理工程"
    },
    {
        "id":6502,
        "name":"6507 (Thai Program)  :  Nanomaterials Science | วิทยาการวัสดุนาโน | 纳米材料科学"
    },
    {
        "id":6503,
        "name":"6508 (Thai Program)  :  English Is An International Language. | ภาษาอังกฤษเป็นภาษาสากล | 英语是一种国际语言。"
    },
    {
        "id":6504,
        "name":"6509 (English Program)  :  Electrical Communication And Electronic Engineering | การสื่อสารไฟฟ้าและวิศวกรรมอิเล็กทรอนิกส์ | 电气通信和电子工程"
    },
    {
        "id":6505,
        "name":"6510 (Thai Program)  :  Aviation Technology Management | การจัดการเทคโนโลยีการบิน | 航空技术管理"
    },
    {
        "id":6506,
        "name":"6511 (English Program)  :  Aviation Technology Management | การจัดการเทคโนโลยีการบิน | 航空技术管理"
    },
    {
        "id":6507,
        "name":"6512 (English Program)  :  Nanomaterials Science | วิทยาศาสตร์วัสดุนาโน | 纳米材料科学"
    },
    {
        "id":6508,
        "name":"6513 (English Program)  :  Engineering Technology Management | การจัดการเทคโนโลยีทางวิศวกรรม | 工程技术管理"
    },
    {
        "id":6509,
        "name":"6514 (English Program)  :  Mathematics With Computer Science | คณิตศาสตร์กับวิทยาการคอมพิวเตอร์ | 数学与计算机科学"
    },
    {
        "id":6510,
        "name":"6515 (English Program)  :  Entreprenenrial Economices | เศรษฐศาสตร์ผู้ประกอบการ | 创业经济"
    },
    {
        "id":6511,
        "name":"6516 (Thai Program)  :  Simplified Thai Language | ภาษาไทยประยุกต์ | 简体泰语"
    },
    {
        "id":6512,
        "name":"6517 (English Program)  :  Applied Thai | ประยุกต์ไทย | 应用泰语"
    },
    {
        "id":6513,
        "name":"6518 (Thai Program)  :  Business Home Economics | คหกรรมศาสตร์ธุรกิจ | 商业家政"
    },
    {
        "id":6514,
        "name":"6519 (Thai Program)  :  Food Science And Nutrition | วิทยาการอาหารและโภชนาการ | 食品科学与营养"
    },
    {
        "id":6515,
        "name":"6520 (Thai Program)  :  Commercial Technology | เทคโนโลยีพณิชยกรรม | 商业技术"
    },
    {
        "id":6516,
        "name":"6521 (Thai Program)  :  Finance And Banking Business | ธุรกิจการเงินและการธนาคาร | 金融银行业务"
    },
    {
        "id":6517,
        "name":"6522 (English Program)  :  Finance And Banking Business | ธุรกิจการเงินและการธนาคาร | 金融银行业务"
    },
    {
        "id":6518,
        "name":"6523 (Thai Program)  :  Print And Packaging Design | ออกแบบสิ่งพิมพ์และบรรจุภัณฑ์ | 印刷和包装设计"
    },
    {
        "id":6519,
        "name":"6524 (English Program)  :  Printing And Packaging Dising | การพิมพ์และการบรรจุภัณฑ์ | 印刷和包装Dising"
    },
    {
        "id":6520,
        "name":"6525 (Thai Program)  :  Interior Design And Exhibitions | การออกแบบตกแต่งภายในและนิทรรศการ | 室内设计及展览"
    },
    {
        "id":6521,
        "name":"6526 (English Program)  :  Interior And Exhibition Design | การออกแบบภายในและนิทรรศการ | 室内及展览设计"
    },
    {
        "id":6522,
        "name":"6527 (English Program)  :  Aesthetic Health Science | วิทยาศาสตร์สุขภาพความงาม | 美容健康科学"
    },
    {
        "id":6523,
        "name":"6528 (Thai Program)  :  Integrative Medicine | การแพทย์บูรณาการ | 中西医结合"
    },
    {
        "id":6524,
        "name":"6529 (English Program)  :  Integrative Medicine | การแพทย์บูรณาการ | 中西医结合"
    },
    {
        "id":6525,
        "name":"6530 (Thai Program)  :  Sports Science And Health | วิทยาศาสตร์การกีฬาและสุขภาพ | 运动科学与健康"
    },
    {
        "id":6526,
        "name":"6531 (English Program)  :  Sports And Health Science | วิทยาศาสตร์การกีฬาและสุขภาพ | 运动与健康科学"
    },
    {
        "id":6527,
        "name":"6532 (Thai Program)  :  Industrial Occupational Management | การจัดการอาชีวอุตสาหกรรม | 工业职业管理"
    },
    {
        "id":6528,
        "name":"6533 (English Program)  :  Industrial-Vocational Management | การจัดการอุตสาหกรรม-อาชีวศึกษา | 工业职业管理"
    },
    {
        "id":6529,
        "name":"6534 (Thai Program)  :  Politics | การเมือง | 政治"
    },
    {
        "id":6530,
        "name":"6535 (English Program)  :  Polities | การเมือง | 政治"
    },
    {
        "id":6531,
        "name":"6536 (Thai Program)  :  Technology For Social Development | เทคโนโลยีเพื่อการพัฒนาสังคม | 科技促进社会发展"
    },
    {
        "id":6532,
        "name":"6537 (English Program)  :  Technology For Social Development | เทคโนโลยีเพื่อการพัฒนาสังคม | 科技促进社会发展"
    },
    {
        "id":6533,
        "name":"6538 (Thai Program)  :  Construction And Public Utilities Management | การบริหารงานก่อสร้างและสาธารณูปโภค | 建筑及公用事业管理"
    },
    {
        "id":6534,
        "name":"6539 (Thai Program)  :  Environment And Development | สิ่งแวดล้อมกับการพัฒนา | 环境与发展"
    },
    {
        "id":6535,
        "name":"6540 (Thai Program)  :  Interpreting For The Community | การล่ามเพื่อชุมชน | 为社区提供口译服务"
    },
    {
        "id":6536,
        "name":"6541 (English Program)  :  Community Interpreting | การตีความชุมชน | 社区口译"
    },
    {
        "id":6537,
        "name":"6542 (English Program)  :  Epilepsy | โรคลมบ้าหมู | 癫痫"
    },
    {
        "id":6538,
        "name":"6543 (Thai Program)  :  Epilepsy | โรคลมชัก | 癫痫"
    },
    {
        "id":6539,
        "name":"6544 (Thai Program)  :  Molecular Science In Medical Microbiology And Immunology | วิทยาศาสตร์ระดับโมเลกุลทางจุลชีววิทยาทางการแพทย์และวิทยาภูมิคุ้มกัน | 医学微生物学和免疫学中的分子科学"
    },
    {
        "id":6540,
        "name":"6545 (English Program)  :  Molecula Science Of Medical Microbiology And Immunology | วิทยาศาสตร์โมเลกุลของจุลชีววิทยาทางการแพทย์และภูมิคุ้มกันวิทยา | 医学微生物学和免疫学分子科学"
    },
    {
        "id":6541,
        "name":"6546 (Thai Program)  :  Sports, Recreation And Tourism | การกีฬานันทนาการและการท่องเที่ยว | 体育、休闲和旅游"
    },
    {
        "id":6542,
        "name":"6547 (English Program)  :  Sport,Leisure And Tourism | กีฬา การพักผ่อน และการท่องเที่ยว | 运动、休闲和旅游"
    },
    {
        "id":6543,
        "name":"6548 (Thai Program)  :  Environmental Geoinformatics | ภูมิสารสนเทศสิ่งแวดล้อม | 环境地理信息学"
    },
    {
        "id":6544,
        "name":"6549 (English Program)  :  Environmental Geoinformatics | ภูมิสารสนเทศสิ่งแวดล้อม | 环境地理信息学"
    },
    {
        "id":6545,
        "name":"6550 (Thai Program)  :  Community Economic And Technological Development | การพัฒนาเศรษฐกิจและเทคโนโลยีชุมชน | 社区经济技术发展"
    },
    {
        "id":6546,
        "name":"6551 (English Program)  :  Community Economy And Technology Development | การพัฒนาเศรษฐกิจและเทคโนโลยีของชุมชน | 社区经济与科技发展"
    },
    {
        "id":6547,
        "name":"6552 (Thai Program)  :  Content Management And Value Creation | การจัดการสาระและการสร้างคุณค่า | 内容管理和价值创造"
    },
    {
        "id":6548,
        "name":"6553 (English Program)  :  Content Management And Value Creation | การจัดการเนื้อหาและการสร้างมูลค่า | 内容管理和价值创造"
    },
    {
        "id":6549,
        "name":"6554 (Thai Program)  :  Recreational Sports And Tourism | การกีฬานันทนาการ และการท่องเที่ยว | 休闲运动和旅游业"
    },
    {
        "id":6550,
        "name":"6555 (English Program)  :  Philoosophy Program In Sport ,Leisure And Tourism | สาขาวิชาปรัชญาด้านกีฬา การพักผ่อน และการท่องเที่ยว | 体育、休闲和旅游哲学课程"
    },
    {
        "id":6551,
        "name":"6556 (Thai Program)  :  Advanced Child And Adolescent Psychiatry | จิตเวชศาสตร์เด็กและวัยรุ่นขั้นสูง | 高级儿童和青少年精神病学"
    },
    {
        "id":6552,
        "name":"6557 (English Program)  :  Advanced Child And Adolescent Psychiatry | จิตเวชศาสตร์เด็กและวัยรุ่นขั้นสูง | 高级儿童和青少年精神病学"
    },
    {
        "id":6553,
        "name":"6558 (Thai Program)  :  Research Curriculum And Teaching | วิจัยหลักสูตรและการสอน | 研究课程与教学"
    },
    {
        "id":6554,
        "name":"6559 (English Program)  :  Research Of Curriculum And Instruction | การวิจัยหลักสูตรและการสอน | 课程与教学研究"
    },
    {
        "id":6555,
        "name":"6560 (Thai Program)  :  Enterprise Management Architecture | สถาปัตยกรรมการจัดการองค์กร | 企业管理架构"
    },
    {
        "id":6556,
        "name":"6561 (English Program)  :  Enterprise Architecture | สถาปัตยกรรมองค์กร | 企业架构"
    },
    {
        "id":6557,
        "name":"6562 (Thai Program)  :  Project Management | การจัดการโครงการ | 项目管理"
    },
    {
        "id":6558,
        "name":"6563 (English Program)  :  Project Management | การจัดการโครงการ | 项目管理"
    },
    {
        "id":6559,
        "name":"6564 (Thai Program)  :  Economic And Social Development Policy | นโยบายการพัฒนาเศรษฐกิจและสังคม | 经济社会发展政策"
    },
    {
        "id":6560,
        "name":"6565 (English Program)  :  Economic And Social Development Policy | นโยบายการพัฒนาเศรษฐกิจและสังคม | 经济和社会发展政策"
    },
    {
        "id":6561,
        "name":"6566 (Thai Program)  :  Health Promotion | การสร้างเสริมสุขภาพ | 健康促进"
    },
    {
        "id":6562,
        "name":"6567 (Thai Program)  :  Social Service Management | การจัดการบริการสังคม | 社会服务管理"
    },
    {
        "id":6563,
        "name":"6568 (English Program)  :  Social Service Management | การจัดการบริการสังคม | 社会服务管理"
    },
    {
        "id":6564,
        "name":"6569 (English Program)  :  Thai Sign Language Interpreting | ล่ามภาษามือไทย | 泰语手语翻译"
    },
    {
        "id":6565,
        "name":"6570 (Thai Program)  :  Geographic Information Technology | เทคโนโลยีสารสนเทศภูมิศาสตร์ | 地理信息技术"
    },
    {
        "id":6566,
        "name":"6571 (English Program)  :  Geographical Information Technology | เทคโนโลยีสารสนเทศทางภูมิศาสตร์ | 地理信息技术"
    },
    {
        "id":6567,
        "name":"6572 (Thai Program)  :  Innovation In Educational Management | นวัตกรรมการบริหารจัดการการศึกษา | 教育管理创新"
    },
    {
        "id":6568,
        "name":"6573 (English Program)  :  Educational Management Innovation | นวัตกรรมการจัดการการศึกษา | 教育管理创新"
    },
    {
        "id":6569,
        "name":"6574 (Thai Program)  :  Communication In Thai As A Second Language | การสื่อสารภาษาไทยเป็นภาษาที่สอง | 以泰语作为第二语言进行交流"
    },
    {
        "id":6570,
        "name":"6575 (English Program)  :  Communicative Thai As A Second Language | การสื่อสารภาษาไทยเป็นภาษาที่สอง | 泰语作为第二语言的交流"
    },
    {
        "id":6571,
        "name":"6576 (Thai Program)  :  Computer Graphics And Animation | คอมพิวเตอร์กราฟิกและแอนิเมชัน | 计算机图形学和动画"
    },
    {
        "id":6572,
        "name":"6577 (Thai Program)  :  Wood And Paper Industry Technology | เทคโนโลยีอุตสาหกรรมไม้และกระดาษ | 木材和造纸工业技术"
    },
    {
        "id":6573,
        "name":"6578 (English Program)  :  Wood And Paper Industrial Technology | เทคโนโลยีอุตสาหกรรมไม้และกระดาษ | 木材和造纸工业技术"
    },
    {
        "id":6574,
        "name":"6579 (English Program)  :  Educational Communications And Technology | การสื่อสารและเทคโนโลยีการศึกษา | 教育通信和技术"
    },
    {
        "id":6575,
        "name":"6580 (Thai Program)  :  Social Administration And Development | การบริหารและพัฒนาสังคม | 社会管理与发展"
    },
    {
        "id":6576,
        "name":"6581 (English Program)  :  Social Development And Administration | การพัฒนาและการบริหารสังคม | 社会发展与管理"
    },
    {
        "id":6577,
        "name":"6582 (Thai Program)  :  Animal Breeding And Production | การปรับปรุงพันธุ์และการผลิตสัตว์ | 动物养殖及生产"
    },
    {
        "id":6578,
        "name":"6583 (English Program)  :  Animal Breeding And Production | การปรับปรุงพันธุ์และการผลิตสัตว์ | 动物饲养及生产"
    },
    {
        "id":6579,
        "name":"6584 (Thai Program)  :  International Business English | ภาษาอังกฤษธุรกิจระหว่างประเทศ | 国际商务英语"
    },
    {
        "id":6580,
        "name":"6585 (English Program)  :  International Business Englush | ภาษาอังกฤษธุรกิจระหว่างประเทศ | 国际商务英语"
    },
    {
        "id":6581,
        "name":"6586 (Thai Program)  :  Thai Language And Business Communication For International Students | ภาษาไทยและการสื่อสารทางธุรกิจสำหรับนักศึกษานานาชาติ | 国际学生泰语和商务沟通"
    },
    {
        "id":6582,
        "name":"6587 (English Program)  :  Thai Language And Business Communication For International Students | ภาษาไทยและการสื่อสารทางธุรกิจสำหรับนักศึกษาต่างชาติ | 国际学生的泰语和商务交流"
    },
    {
        "id":6583,
        "name":"6588 (Thai Program)  :  Sustainable Energy And Environmental Technology And Management | เทคโนโลยีและการจัดการพลังงานและสิ่งแวดล้อมอย่างยั่งยืน | 可持续能源和环境技术与管理"
    },
    {
        "id":6584,
        "name":"6589 (English Program)  :  Sustainable Energy And Environmemt Technology And Management | เทคโนโลยีและการจัดการพลังงานและสิ่งแวดล้อมที่ยั่งยืน | 可持续能源与环境技术与管理"
    },
    {
        "id":6585,
        "name":"6590 (Thai Program)  :  Agricultural Resources And Production Management | ทรัพยากรเกษตรและการจัดการการผลิต | 农业资源与生产管理"
    },
    {
        "id":6586,
        "name":"6591 (English Program)  :  Agricultural Resources And Production Management | ทรัพยากรการเกษตรและการจัดการการผลิต | 农业资源和生产管理"
    },
    {
        "id":6587,
        "name":"6592 (Thai Program)  :  Food Safety And Nutrition | อาหารปลอดภัยและโภชนาการ | 食品安全和营养"
    },
    {
        "id":6588,
        "name":"6593 (English Program)  :  Food Safety And Nutrition | ความปลอดภัยด้านอาหารและโภชนาการ | 食品安全和营养"
    },
    {
        "id":6589,
        "name":"6594 (Thai Program)  :  Veterinary Microbiology | จุลชีววิทยาทางการสัตวแพทย์ | 兽医微生物学"
    },
    {
        "id":6590,
        "name":"6595 (Thai Program)  :  Agricultural And Resource Economics | เศรษฐศาสตร์เกษตรและทรัพยากร | 农业与资源经济学"
    },
    {
        "id":6591,
        "name":"6596 (English Program)  :  Agricultural And Resource Economics | เศรษฐศาสตร์เกษตรและทรัพยากร | 农业和资源经济"
    },
    {
        "id":6592,
        "name":"6597 (Thai Program)  :  Mass Communication Technology | เทคโนโลยีการสื่อสารมวลชน | 大众传播技术"
    },
    {
        "id":6593,
        "name":"6598 (Thai Program)  :  Gem And Jewelry Technology | เทคโนโลยีอัญมณีและเครื่องประดับ | 宝石和珠宝技术"
    },
    {
        "id":6594,
        "name":"6599 (English Program)  :  Gems And Jewelry Technology | เทคโนโลยีอัญมณีและเครื่องประดับ | 宝石和珠宝技术"
    },
    {
        "id":6595,
        "name":"7000 (Thai Program)  :  Dental Clinic | ทันตกรรมคลินิก | 牙科诊所"
    },
    {
        "id":6596,
        "name":"7001 (English Program)  :  Clinical Dentistry | คลินิกทันตกรรม | 临床牙科"
    },
    {
        "id":6597,
        "name":"7002 (Thai Program)  :  Agricultural Economics Environmental Resources | เศรษฐศาสตร์เกษตร ทรัพยากรสิ่งแวดล้อม | 农业经济学环境资源"
    },
    {
        "id":6598,
        "name":"7003 (English Program)  :  Agricultural Natural Resources And Environmental | ทรัพยากรธรรมชาติเกษตรกรรมและสิ่งแวดล้อม | 农业自然资源与环境"
    },
    {
        "id":6599,
        "name":"7004 (English Program)  :  Medical And Science Media | สื่อการแพทย์และวิทยาศาสตร์ | 医疗和科学媒体"
    },
    {
        "id":6600,
        "name":"7005 (Thai Program)  :  Laws For Service Workers | กฎหมายสำหรับนักบริการ | 针对服务人员的法律"
    },
    {
        "id":6601,
        "name":"7006 (English Program)  :  Law For Executives | กฎหมายสำหรับผู้บริหาร | 高管法律"
    },
    {
        "id":6602,
        "name":"7007 (Thai Program)  :  Advanced Mass Communication English | การสื่อสารมวลชนขั้นสูงภาษาอังกฤษ | 高级大众传播英语"
    },
    {
        "id":6603,
        "name":"7008 (English Program)  :  Professional English Media Studies | การศึกษาสื่อภาษาอังกฤษระดับมืออาชีพ | 专业英语媒体研究"
    },
    {
        "id":6604,
        "name":"7009 (Thai Program)  :  Advanced English For Communication | ภาษาอังกฤษระดับสูงเพื่อการสื่อสาร | 高级沟通英语"
    },
    {
        "id":6605,
        "name":"7010 (English Program)  :  English For Professional Communication | ภาษาอังกฤษเพื่อการสื่อสารอย่างมืออาชีพ | 专业交流英语"
    },
    {
        "id":6606,
        "name":"7011 (Thai Program)  :  Mechanical Engineering, Simulation And Design | วิศวกรรมเครื่องกลการจำลองและการออกแบบ | 机械工程、仿真与设计"
    },
    {
        "id":6607,
        "name":"7012 (English Program)  :  Mechanical Engineering Simulation And Design | การจำลองและการออกแบบวิศวกรรมเครื่องกล | 机械工程仿真与设计"
    },
    {
        "id":6608,
        "name":"7013 (Thai Program)  :  Electrical Power And Energy Engineering | วิศวกรรมไฟฟ้ากำลังและพลังงาน | 电力与能源工程"
    },
    {
        "id":6609,
        "name":"7014 (English Program)  :  Electrical Power And Energy Engineering | วิศวกรรมไฟฟ้ากำลังและพลังงาน | 电力与能源工程"
    },
    {
        "id":6610,
        "name":"7015 (Thai Program)  :  Applied Arts And Product Design | ศิลปประยุกต์และการออกแบบผลิตภัณฑ์ | 应用艺术和产品设计"
    },
    {
        "id":6611,
        "name":"7016 (English Program)  :  Applied Art And Product Design | ศิลปะประยุกต์และการออกแบบผลิตภัณฑ์ | 应用艺术和产品设计"
    },
    {
        "id":6612,
        "name":"7017 (Thai Program)  :  Public Policy And Public Sector Management | นโยบายสาธารณะและการจัดการภาครัฐ | 公共政策和公共部门管理"
    },
    {
        "id":6613,
        "name":"7018 (English Program)  :  Public Policy And Public Management | นโยบายสาธารณะและการจัดการสาธารณะ | 公共政策和公共管理"
    },
    {
        "id":6614,
        "name":"7019 (Thai Program)  :  Sports Management | การจัดการการกีฬา | 体育管理"
    },
    {
        "id":6615,
        "name":"7021 (Thai Program)  :  Logistics And Engineering Management | การจัดการโลจิสติกส์และวิศวกรรม | 物流与工程管理"
    },
    {
        "id":6616,
        "name":"7022 (English Program)  :  Logistics And Engineering Management | การจัดการโลจิสติกส์และวิศวกรรม | 物流与工程管理"
    },
    {
        "id":6617,
        "name":"7023 (Thai Program)  :  Human Rights And Democratic Development | สิทธิมนุษยชนและการพัฒนาประชาธิปไตย | 人权与民主发展"
    },
    {
        "id":6618,
        "name":"7024 (English Program)  :  Human Rights And Democratisation | สิทธิมนุษยชนและการทำให้เป็นประชาธิปไตย | 人权与民主化"
    },
    {
        "id":6619,
        "name":"7025 (Thai Program)  :  Demographic And Social Physiology | พฤฒิวิทยาเชิงประชากรและสังคม | 人口统计和社会生理学"
    },
    {
        "id":6620,
        "name":"7026 (English Program)  :  Population And Social Gerontology | ประชากรและสังคมผู้สูงอายุ | 人口与社会老年学"
    },
    {
        "id":6621,
        "name":"7027 (Thai Program)  :  Public Health Microbiology | จุลชีววิทยาสาธารณสุข | 公共卫生微生物学"
    },
    {
        "id":6622,
        "name":"7028 (English Program)  :  Public Health Microbiology | จุลชีววิทยาสาธารณสุข | 公共卫生微生物学"
    },
    {
        "id":6623,
        "name":"7029 (Thai Program)  :  Contemplative Education | จิตตปัญญาศึกษา | 沉思教育"
    },
    {
        "id":6624,
        "name":"7030 (English Program)  :  Contemplative Education | การศึกษาแบบมีวิจารณญาณ | 沉思教育"
    },
    {
        "id":6625,
        "name":"7031 (English Program)  :  Textile Design And Fashion | การออกแบบสิ่งทอและแฟชั่น | 纺织品设计与时尚"
    },
    {
        "id":6626,
        "name":"7032 (Thai Program)  :  Film And Digital Media | ภาพยนตร์และสื่อดิจิตอล | 电影和数字媒体"
    },
    {
        "id":6627,
        "name":"7033 (English Program)  :  Cinema And Digital Media | ภาพยนตร์และสื่อดิจิทัล | 电影和数字媒体"
    },
    {
        "id":6628,
        "name":"7034 (Thai Program)  :  Local Development Strategy | ยุทธศาสตร์การพัฒนาท้องถิ่น | 地方发展战略"
    },
    {
        "id":6629,
        "name":"7035 (English Program)  :  Exercise Science And Sport Science | วิทยาศาสตร์การออกกำลังกายและวิทยาศาสตร์การกีฬา | 运动科学和运动科学"
    },
    {
        "id":6630,
        "name":"7036 (Thai Program)  :  Computer Graphics And Multimedia | คอมพิวเตอร์กราฟิกส์และมัลติมีเดีย | 计算机图形学和多媒体"
    },
    {
        "id":6631,
        "name":"7037 (Thai Program)  :  International Tourism Management | การจัดการท่องเที่ยวนานาชาติ | 国际旅游管理"
    },
    {
        "id":6632,
        "name":"7038 (English Program)  :  International Tourism Management | การจัดการการท่องเที่ยวระหว่างประเทศ | 国际旅游管理"
    },
    {
        "id":6633,
        "name":"7039 (Thai Program)  :  Knowledge Management And Innovation | การจัดการความรู้และนวัตกรรม | 知识管理与创新"
    },
    {
        "id":6634,
        "name":"7040 (English Program)  :  Knowledge And Innovament Management | การจัดการความรู้และนวัตกรรม | 知识与创新管理"
    },
    {
        "id":6635,
        "name":"7041 (Thai Program)  :  Aircraft Maintenance Management | การจัดการซ่อมบำรุงอากาศยาน | 飞机维修管理"
    },
    {
        "id":6636,
        "name":"7042 (Thai Program)  :  Animal Feed Science And Technology | วิทยาศาสตร์และเทคโนโลยีอาหารสัตว์ | 动物饲料科学与技术"
    },
    {
        "id":6637,
        "name":"7043 (English Program)  :  Feed Science And Technology | วิทยาศาสตร์และเทคโนโลยีอาหารสัตว์ | 饲料科学与技术"
    },
    {
        "id":6638,
        "name":"7044 (Thai Program)  :  Health, Beauty And Spa | สุขภาพความงามและสปา | 健康、美容和水疗"
    },
    {
        "id":6639,
        "name":"7045 (Thai Program)  :  Fashion Design And Product Management | ออกแบบแฟชั่นและการจัดการสินค้า | 时装设计和产品管理"
    },
    {
        "id":6640,
        "name":"7046 (Thai Program)  :  Dance And Performance | นาฏศิลป์และการแสดง | 舞蹈及表演"
    },
    {
        "id":6641,
        "name":"7047 (Thai Program)  :  Network And Internet Engineering | วิศวกรรมเครือข่ายและอินเตอร์เน็ต | 网络与互联网工程"
    },
    {
        "id":6642,
        "name":"7048 (English Program)  :  Network Engineering And Internet | วิศวกรรมเครือข่ายและอินเทอร์เน็ต | 网络工程与互联网"
    },
    {
        "id":6643,
        "name":"7049 (Thai Program)  :  Computer Art Technology | เทคโนโลยีคอมพิวเตอร์อารต์ | 计算机艺术技术"
    },
    {
        "id":6644,
        "name":"7050 (Thai Program)  :  East Asian Languages | ภาษาเอเชียตะวันออก | 东亚语言"
    },
    {
        "id":6645,
        "name":"7051 (English Program)  :  Eastern Asian Languages | ภาษาเอเชียตะวันออก | 东亚语言"
    },
    {
        "id":6646,
        "name":"7052 (Thai Program)  :  Drama | การละคร | 戏剧"
    },
    {
        "id":6647,
        "name":"7053 (Thai Program)  :  Aviation And Tourism Business | ธุรกิจการบินและการท่องเที่ยว | 航空及旅游业务"
    },
    {
        "id":6648,
        "name":"7054 (English Program)  :  Airline Business And Tourism | ธุรกิจการบินและการท่องเที่ยว | 航空商务和旅游"
    },
    {
        "id":6649,
        "name":"7055 (Thai Program)  :  Japanese For Communication | ภาษาญี่ปุ่นเพื่อการสื่อสาร | 日语用于交流"
    },
    {
        "id":6650,
        "name":"7056 (English Program)  :  Japanese For Communication | ภาษาญี่ปุ่นเพื่อการสื่อสาร | 交流日语"
    },
    {
        "id":6651,
        "name":"7057 (Thai Program)  :  Printing Engineering | วิศวกรรมการพิมพ์ | 印刷工程"
    },
    {
        "id":6652,
        "name":"7058 (English Program)  :  Printing Engineering | วิศวกรรมการพิมพ์ | 印刷工程"
    },
    {
        "id":6653,
        "name":"7059 (Thai Program)  :  Advertising And Marketing Communications | การโฆษณาและสื่อสารการตลาด | 广告和营销传播"
    },
    {
        "id":6654,
        "name":"7060 (English Program)  :  Advertising And Marketing Communication | การโฆษณาและการสื่อสารการตลาด | 广告和营销传播"
    },
    {
        "id":6655,
        "name":"7061 (Thai Program)  :  Maritime Business Management | การจัดการธุรกิจพาณิชยนาวี | 海事业务管理"
    },
    {
        "id":6656,
        "name":"7062 (Thai Program)  :  Tourism And Service Industry Management | การจัดการอุตสาหกรรมท่องเที่ยวและบริการ | 旅游与服务业管理"
    },
    {
        "id":6657,
        "name":"7063 (English Program)  :  Tourism Industry And Hospitality Management | การจัดการอุตสาหกรรมการท่องเที่ยวและการบริการ | 旅游业和酒店管理"
    },
    {
        "id":6658,
        "name":"7064 (Thai Program)  :  Public Relations And Corporate Communications | การประชาสัมพันธ์และการสื่อสารองค์กร | 公共关系和企业传播"
    },
    {
        "id":6659,
        "name":"7065 (English Program)  :  Public Relations And Corporate Communication | การประชาสัมพันธ์และการสื่อสารองค์กร | 公共关系和企业传播"
    },
    {
        "id":6660,
        "name":"7066 (Thai Program)  :  Film And Performance Communication | การภาพยนต์และการสื่อสารการแสดง | 电影与表演交流"
    },
    {
        "id":6661,
        "name":"7067 (English Program)  :  Film And Performing Arts | ภาพยนตร์และศิลปะการแสดง | 电影和表演艺术"
    },
    {
        "id":6662,
        "name":"7068 (Thai Program)  :  Innovation And Educational Technology | นวัตกรรมและเทคโนโลยีการศึกษา | 创新与教育技术"
    },
    {
        "id":6663,
        "name":"7069 (Thai Program)  :  Television Radio | วิทยุโทรทัศน์ | 电视广播"
    },
    {
        "id":6664,
        "name":"7070 (English Program)  :  Television Broadcasting | การแพร่ภาพโทรทัศน์ | 电视广播"
    },
    {
        "id":6665,
        "name":"7071 (Thai Program)  :  Web Design And Content | การออกแบบเว็บและเนื้อหา | 网页设计和内容"
    },
    {
        "id":6666,
        "name":"7072 (English Program)  :  Web And Content Design | การออกแบบเว็บและเนื้อหา | 网页和内容设计"
    },
    {
        "id":6667,
        "name":"7073 (Thai Program)  :  Herbalism | วิทยาการสมุนไพร | 草药学"
    },
    {
        "id":6668,
        "name":"7074 (English Program)  :  Medicinal Plant Science | วิทยาศาสตร์พืชสมุนไพร | 药用植物科学"
    },
    {
        "id":6669,
        "name":"7075 (Thai Program)  :  Airline Electronic Engineering | วิศวกรรมอิเล็กทรอนิกสายการบิน | 航空电子工程"
    },
    {
        "id":6670,
        "name":"7076 (English Program)  :  Avionic Engineering | วิศวกรรมการบินและอวกาศ | 航空电子工程"
    },
    {
        "id":6671,
        "name":"7077 (Thai Program)  :  Film And Animation Production | การผลิตภาพยนต์และแอินิเมชั่น | 电影和动画制作"
    },
    {
        "id":6672,
        "name":"7078 (English Program)  :  Film And Animation Producion | การผลิตภาพยนตร์และแอนิเมชั่น | 电影和动画制作"
    },
    {
        "id":6673,
        "name":"7079 (Thai Program)  :  Public Administration And Enterprise Management | การจัดการบริหารรัฐกิจและวิสาหกิจ | 公共行政和企业管理"
    },
    {
        "id":6674,
        "name":"7080 (English Program)  :  Public And Enterprise Management | การจัดการสาธารณะและองค์กร | 公共与企业管理"
    },
    {
        "id":6675,
        "name":"7081 (Thai Program)  :  Aeronautical Engineering | วิศวกรรมการบิน | 航空工程"
    },
    {
        "id":6676,
        "name":"7082 (Thai Program)  :  Industrial Arts And Technology | อุตสาหกรรมศิลป์และเทคโนโลยี | 工艺美术与技术"
    },
    {
        "id":6677,
        "name":"7083 (Thai Program)  :  Aircraft Maintenance Technician | นายช่างบำรุงรักษาอากาศยาน | 飞机维修技术员"
    },
    {
        "id":6678,
        "name":"7084 (English Program)  :  Aircraft Maintenance Engineer License | ใบอนุญาตวิศวกรซ่อมบำรุงอากาศยาน | 飞机维修工程师执照"
    },
    {
        "id":6679,
        "name":"7085 (Thai Program)  :  Graphic Design | การออกแบบกราฟิก | 平面设计"
    },
    {
        "id":6680,
        "name":"7086 (Thai Program)  :  Family And Community Health Nursing | การพยาบาลครอบครัวและอนามัยชุมชน | 家庭及社区健康护理"
    },
    {
        "id":6681,
        "name":"7087 (Thai Program)  :  Business Administration Studies | บริหารธุรกิจศึกษา | 工商管理研究"
    },
    {
        "id":6682,
        "name":"7088 (Thai Program)  :  Mechanical And Energy Engineering | วิศวกรรมเครื่องกลและพลังงาน | 机械与能源工程"
    },
    {
        "id":6683,
        "name":"7089 (Thai Program)  :  Pest And Animal Management | การจัดการศัตรูพืชและสัตว์ | 害虫和动物管理"
    },
    {
        "id":6684,
        "name":"7090 (Thai Program)  :  Non-Formal Education For Social Development | การศึกษานอกระบบเพื่อพัฒนาสังคม | 非正规教育促进社会发展"
    },
    {
        "id":6685,
        "name":"7091 (Thai Program)  :  Information And Communication Technology For Education | เทคโนโลยีสารสนเทศและการสื่อสารเพื่อการศึกษา | 教育信息和通信技术"
    },
    {
        "id":6686,
        "name":"7092 (Thai Program)  :  Industrial Business Development And Human Resources | การพัฒนาธุรกิจอุตสาหกรรมและทรัพยากรมนุษย์ | 工业业务发展和人力资源"
    },
    {
        "id":6687,
        "name":"7093 (Thai Program)  :  Electrical Engineering Studies | วิศวกรรมไฟฟ้าศึกษา | 电气工程研究"
    },
    {
        "id":6688,
        "name":"7094 (Thai Program)  :  Veterinary Anatomical Science | วิทยาศาสตร์กายวิภาคทางสัตวแพทย์ | 兽医解剖学"
    },
    {
        "id":6689,
        "name":"7095 (Thai Program)  :  Watershed And Forest Environment Management | การจัดการลุ่มน้ำและสิ่งแวดล้อมป่าไม้ | 流域和森林环境管理"
    },
    {
        "id":6690,
        "name":"7096 (Thai Program)  :  Fishery Product Science And Technology | วิทยาศาสตร์และเทคโนโลยีผลิตภัณฑ์ประมง | 水产品科学与技术"
    },
    {
        "id":6691,
        "name":"7097 (Thai Program)  :  Food Safety In Animal Products | ความปลอดภัยของอาหารในผลิตผลจากสัตว์ | 动物产品的食品安全"
    },
    {
        "id":6692,
        "name":"7098 (Thai Program)  :  Logistics And Border Trade Management | การจัดการโลจิสติกส์และการค้าชายแดน | 物流及边境贸易管理"
    },
    {
        "id":6693,
        "name":"7099 (Thai Program)  :  International Tourism Management | การจัดการการท่องเที่ยวระหว่างประเทศ | 国际旅游管理"
    },
    {
        "id":6694,
        "name":"7100 (Thai Program)  :  Visual Communication And Design | นิเทศศิลป์และการออกแบบ | 视觉传达与设计"
    },
    {
        "id":6695,
        "name":"7101 (Thai Program)  :  Building And Building Resource Management | การจัดการอาคารและทรัพยากรอาคาร | 建筑和建筑资源管理"
    },
    {
        "id":6696,
        "name":"7102 (Thai Program)  :  Human And Family Development | พัฒนาการมนุษย์และครอบครัว | 人类和家庭发展"
    },
    {
        "id":6697,
        "name":"7103 (Thai Program)  :  Public Administration And Enterprise Management | การจัดการรัฐกิจและวิสาหกิจ | 公共行政和企业管理"
    },
    {
        "id":6698,
        "name":"7104 (Thai Program)  :  Applied Home Economics | คหกรรมศาสตร์ประยุกต์ | 应用家政学"
    },
    {
        "id":6699,
        "name":"7105 (English Program)  :  Applied Home Economics | เศรษฐศาสตร์บ้านประยุกต์ | 应用家庭经济学"
    },
    {
        "id":6700,
        "name":"7106 (Thai Program)  :  Pharmacology And Toxicology | เภสัชวิทยาและพิษวิทยา | 药理学和毒理学"
    },
    {
        "id":6701,
        "name":"7107 (Thai Program)  :  Integrated Business Accounting | การบัญชีธุรกิจแบบบูรณาการ | 综合商业会计"
    },
    {
        "id":6702,
        "name":"7108 (English Program)  :  Integrative Business Accounting | การบัญชีธุรกิจเชิงบูรณาการ | 综合商业会计"
    },
    {
        "id":6703,
        "name":"7109 (Thai Program)  :  Integrated Business Management | การจัดการธุรกิจแบบบูรณาการ | 综合业务管理"
    },
    {
        "id":6704,
        "name":"7110 (English Program)  :  Integrative Business Management | การจัดการธุรกิจเชิงบูรณาการ | 综合业务管理"
    },
    {
        "id":6705,
        "name":"7111 (Thai Program)  :  International Entrepreneur | ผู้ประกอบการสากล | 国际企业家"
    },
    {
        "id":6706,
        "name":"7112 (English Program)  :  Global Enterprise | องค์กรระดับโลก | 全球企业"
    },
    {
        "id":6707,
        "name":"7113 (Thai Program)  :  Logistics And Operations Management | การบริหารโลจิสติกส์และการปฏิบัติการ | 物流和运营管理"
    },
    {
        "id":6708,
        "name":"7114 (English Program)  :  Logistics And Operations Management | การจัดการโลจิสติกส์และการดำเนินงาน | 物流和运营管理"
    },
    {
        "id":6709,
        "name":"7115 (Thai Program)  :  Integrated Thai Studies | ไทยศึกษาบูรณาการ | 综合泰国研究"
    },
    {
        "id":6710,
        "name":"7116 (English Program)  :  Politic And International Relations | ความสัมพันธ์ทางการเมืองและระหว่างประเทศ | 政治和国际关系"
    },
    {
        "id":6711,
        "name":"7117 (Thai Program)  :  English-American Studies | อังกฤษ-อเมริกันศึกษา | 英美研究"
    },
    {
        "id":6712,
        "name":"7118 (Thai Program)  :  Corporate Communication Management | การจัดการสื่อสารองค์กร | 企业传播管理"
    },
    {
        "id":6713,
        "name":"7119 (English Program)  :  Corporate Communication Management | การจัดการการสื่อสารองค์กร | 企业传播管理"
    },
    {
        "id":6714,
        "name":"7120 (Thai Program)  :  Media Studies | สื่อมวลชนศึกษา | 媒体研究"
    },
    {
        "id":6715,
        "name":"7121 (English Program)  :  Mass Media Studies | การศึกษาด้านสื่อมวลชน | 大众传媒研究"
    },
    {
        "id":6716,
        "name":"7122 (Thai Program)  :  Technology For Sustainable Development | เทคโนโลยีเพื่อการพัฒนาที่ยั่งยืน | 可持续发展技术"
    },
    {
        "id":6717,
        "name":"7123 (English Program)  :  Sustainable Development Technology | เทคโนโลยีการพัฒนาที่ยั่งยืน | 可持续发展技术"
    },
    {
        "id":6718,
        "name":"7124 (Thai Program)  :  Organic Farming Management | การจัดการเกษตรอินทรีย์ | 有机农业管理"
    },
    {
        "id":6719,
        "name":"7125 (English Program)  :  Organic Farming Management | การจัดการเกษตรอินทรีย์ | 有机农业管理"
    },
    {
        "id":6720,
        "name":"7126 (Thai Program)  :  Engineering And Business Management | วิศวกรรมศาสตร์และการจัดการเชิงธุรกิจ | 工程与商业管理"
    },
    {
        "id":6721,
        "name":"7127 (English Program)  :  Engineering And Business Management | วิศวกรรมศาสตร์และการจัดการธุรกิจ | 工程和商业管理"
    },
    {
        "id":6722,
        "name":"7128 (Thai Program)  :  Community Medicine And Family Medicine | เวชศาสตร์ชุมชนและเวชศาสตร์ครอบครัว | 社区医学和家庭医学"
    },
    {
        "id":6723,
        "name":"7129 (English Program)  :  Community And Family Medicine | การแพทย์ชุมชนและครอบครัว | 社区和家庭医学"
    },
    {
        "id":6724,
        "name":"7130 (Thai Program)  :  Real Estate Development Innovation | นวัตกรรมการพัฒนาอสังหาริมทรัพย์ | 房地产开发创新"
    },
    {
        "id":6725,
        "name":"7131 (English Program)  :  Innovative Real Estate Development | นวัตกรรมการพัฒนาอสังหาริมทรัพย์ | 创新房地产开发"
    },
    {
        "id":6726,
        "name":"7132 (Thai Program)  :  Global Public Health | การสาธารณสุขโลก | 全球公共卫生"
    },
    {
        "id":6727,
        "name":"7133 (English Program)  :  Global Health | สุขภาพโลก | 全球健康"
    },
    {
        "id":6728,
        "name":"7134 (Thai Program)  :  Service Innovation | นวัตกรรมการบริการ | 服务创新"
    },
    {
        "id":6729,
        "name":"7135 (English Program)  :  Service Innovative | นวัตกรรมการบริการ | 服务创新"
    },
    {
        "id":6730,
        "name":"7136 (Thai Program)  :  Medical Engineering | วิศวกรรมทางการแพทย์ | 医学工程"
    },
    {
        "id":6731,
        "name":"7137 (English Program)  :  Medical Engineering | วิศวกรรมการแพทย์ | 医学工程"
    },
    {
        "id":6732,
        "name":"7138 (English Program)  :  Computer Information System | ระบบสารสนเทศคอมพิวเตอร์ | 计算机信息系统"
    },
    {
        "id":6733,
        "name":"7139 (Thai Program)  :  Agricultural Information Technology | เทคโนโลยีสารสนเทศการเกษตร | 农业信息化"
    },
    {
        "id":6734,
        "name":"7140 (Thai Program)  :  Animal Nursing | การพยาบาลสัตว์ | 动物护理"
    },
    {
        "id":6735,
        "name":"7141 (English Program)  :  Animal Nurse | พยาบาลสัตว์ | 动物护士"
    },
    {
        "id":6736,
        "name":"7142 (Thai Program)  :  Non-Formal And Informal Education | การศึกษานอกระบบและการศึกษาตามอัธยาศัย | 非正规和非正式教育"
    },
    {
        "id":6737,
        "name":"7143 (English Program)  :  Nonformal And Informal Education | การศึกษานอกระบบและนอกระบบ | 非正规和非正式教育"
    },
    {
        "id":6738,
        "name":"7144 (Thai Program)  :  Psychological Guidance And Counseling | การแนะแนวและการปรึกษาเชิงจิตวิทยา | 心理辅导与辅导"
    },
    {
        "id":6739,
        "name":"7145 (English Program)  :  Guidance And Psychological Counselong | การแนะแนวและการให้คำปรึกษาด้านจิตวิทยา | 指导和心理咨询"
    },
    {
        "id":6740,
        "name":"7146 (Thai Program)  :  Electronics And Communication Engineering | วิศวกรรมอิเลคทรอนิคส์และการสื่อสาร | 电子与通信工程"
    },
    {
        "id":6741,
        "name":"7147 (English Program)  :  Electronics And Communication Engineering | วิศวกรรมอิเล็กทรอนิกส์และการสื่อสาร | 电子与通信工程"
    },
    {
        "id":6742,
        "name":"7148 (Thai Program)  :  Information Technology For Embedded Systems | เทคโนโลยีสารสนเทศสำหรับระบบฝังตัว | 嵌入式系统信息技术"
    },
    {
        "id":6743,
        "name":"7149 (Thai Program)  :  Integrated Tourism Management | การจัดการการท่องเที่ยวแบบบูรณาการ | 旅游综合管理"
    },
    {
        "id":6744,
        "name":"7150 (Thai Program)  :  Social Development And Environmental Management | พัฒนาสังคมและการจัดการสิ่งแวดล้อม | 社会发展和环境管理"
    },
    {
        "id":6745,
        "name":"7151 (English Program)  :  Social Development And Environmental Management | การพัฒนาสังคมและการจัดการสิ่งแวดล้อม | 社会发展与环境管理"
    },
    {
        "id":6746,
        "name":"7152 (Thai Program)  :  Agriculture And Food | เกษตรและอาหาร | 农业和食品"
    },
    {
        "id":6747,
        "name":"7153 (English Program)  :  Agriculture And Food | เกษตรกรรมและอาหาร | 农业和食品"
    },
    {
        "id":6748,
        "name":"7154 (Thai Program)  :  Tourism And Hospitality Business Management | การจัดการธุรกิจการท่องเที่ยวและการบริการ | 旅游与酒店业务管理"
    },
    {
        "id":6749,
        "name":"7155 (English Program)  :  Tourism And Hospitality Business Management | การจัดการธุรกิจการท่องเที่ยวและการบริการ | 旅游和酒店业务管理"
    },
    {
        "id":6750,
        "name":"7156 (Thai Program)  :  Peace Studies And Diplomacy | สันติภาพศึกษาและการฑูต | 和平研究与外交"
    },
    {
        "id":6751,
        "name":"7157 (English Program)  :  Peace Studies And Diplomacy | การศึกษาสันติภาพและการทูต | 和平研究与外交"
    },
    {
        "id":6752,
        "name":"7158 (Thai Program)  :  Community Energy And Environment | พลังงานชุมชนและสิ่งแวดล้อม | 社区能源与环境"
    },
    {
        "id":6753,
        "name":"7159 (Thai Program)  :  Information Technology For Business And Education | เทคโนโลยีสารสนเทศเพื่อธุรกิจและการศึกษา | 商业和教育信息技术"
    },
    {
        "id":6754,
        "name":"7160 (Thai Program)  :  Agricultural Development And Agribusiness Management | พัฒนาการเกษตรและการจัดการธุรกิจเกษตร | 农业发展和农业企业管理"
    },
    {
        "id":6755,
        "name":"7161 (Thai Program)  :  Educational Administration And Management | การบริหารและการจัดการการศึกษา | 教育行政与管理"
    },
    {
        "id":6756,
        "name":"7162 (English Program)  :  Educational Administration & Management | การบริหารและการจัดการการศึกษา | 教育行政与管理"
    },
    {
        "id":6757,
        "name":"7163 (Thai Program)  :  Research And Development Of Human Potential | การวิจัยและพัฒนาศักยภาพมนุษย์ | 人类潜能的研究与开发"
    },
    {
        "id":6758,
        "name":"7164 (Thai Program)  :  Educational Science And Learning Management | วิทยาการทางการศึกษาและการจัดการเรียนรู้ | 教育科学和学习管理"
    },
    {
        "id":6759,
        "name":"7165 (English Program)  :  Educational Science & Learning Management | วิทยาศาสตร์การศึกษาและการจัดการการเรียนรู้ | 教育科学与学习管理"
    },
    {
        "id":6760,
        "name":"7166 (Thai Program)  :  Pharmaceutical Science | วิทยาการเภสัชภัณฑ์ | 药学"
    },
    {
        "id":6761,
        "name":"7167 (English Program)  :  Pharmaceutical Product Development | การพัฒนาผลิตภัณฑ์ทางเภสัชกรรม | 药品开发"
    },
    {
        "id":6762,
        "name":"7168 (English Program)  :  Sport Leisure And Tourism | กีฬาเพื่อการพักผ่อนและการท่องเที่ยว | 运动休闲旅游"
    },
    {
        "id":6763,
        "name":"7169 (Thai Program)  :  Polymer Material Technology | เทคโนโลยีวัสดุพอลิเมอร์ | 高分子材料技术"
    },
    {
        "id":6764,
        "name":"7170 (Thai Program)  :  Communication Innovation | นวัตกรรมการสื่อสาร | 沟通创新"
    },
    {
        "id":6765,
        "name":"7171 (Thai Program)  :  Management Of The Animal Production Industry | การบริหารจัดการอุตสาหกรรมการผลิตสัตว์ | 畜牧业生产管理"
    },
    {
        "id":6766,
        "name":"7172 (English Program)  :  Administration And Management In Animal Production Indusries | การบริหารและการจัดการในอุตสาหกรรมการผลิตสัตว์ | 畜牧业生产管理"
    },
    {
        "id":6767,
        "name":"7173 (Thai Program)  :  Pig Production | การผลิตสุกร | 生猪生产"
    },
    {
        "id":6768,
        "name":"7174 (Thai Program)  :  Palm Oil And Oleochemical Technology | เทคโนโลยีน้ำมันปาล์มและโอลิโอเคมี | 棕榈油和油脂化学技术"
    },
    {
        "id":6769,
        "name":"7175 (English Program)  :  Plam Oil And Oleochemical Technology | น้ำมันปาล์มและเทคโนโลยีโอลีโอเคมี | 棕榈油和油脂化学技术"
    },
    {
        "id":6770,
        "name":"7176 (English Program)  :  Agricultural Development And Agribusiness Management | การพัฒนาการเกษตรและการจัดการธุรกิจการเกษตร | 农业发展和农业企业管理"
    },
    {
        "id":6771,
        "name":"7177 (Thai Program)  :  Social Sciences For Tour Guides And Tourism | สังคมศาสตร์เพื่อมัคคุเทศก์และการท่องเที่ยว | 导游和旅游社会科学"
    },
    {
        "id":6772,
        "name":"7178 (English Program)  :  Social Sciences For Tourist Guide And Tourism | สังคมศาสตร์เพื่อการท่องเที่ยวและการท่องเที่ยว | 导游和旅游社会科学"
    },
    {
        "id":6773,
        "name":"7179 (Thai Program)  :  Communication For Innovation Management | การสื่อสารเพื่อการจัดการนวัตกรรม | 创新管理沟通"
    },
    {
        "id":6774,
        "name":"7180 (English Program)  :  Innovative Management Communication | การสื่อสารการจัดการที่เป็นนวัตกรรม | 创新管理沟通"
    },
    {
        "id":6775,
        "name":"7181 (Thai Program)  :  Communication For Tourism | การสื่อสารเพื่อการท่องเที่ยว | 旅游通讯"
    },
    {
        "id":6776,
        "name":"7182 (English Program)  :  Tourism Communication | การสื่อสารการท่องเที่ยว | 旅游通讯"
    },
    {
        "id":6777,
        "name":"7183 (Thai Program)  :  Food Industry | อุตสาหกรรมอาหาร | 食品工业"
    },
    {
        "id":6778,
        "name":"7284 (English Program)  :  Food Industry | อุตสาหกรรมอาหาร | 食品工业"
    },
    {
        "id":6779,
        "name":"7285 (Thai Program)  :  Air Traffic | การจราจรทางอากาศ | 空中交通"
    },
    {
        "id":6780,
        "name":"7286 (Thai Program)  :  Air Freight | การขนส่งสินค้าทางอากาศ | 空运"
    },
    {
        "id":6781,
        "name":"7287 (Thai Program)  :  Community Health Management | การจัดการสุขภาพชุมชน | 社区健康管理"
    },
    {
        "id":6782,
        "name":"7288 (Thai Program)  :  Training Technology For Human Resource Development | เทคโนโลยีการฝึกอบรมเพื่อการพัฒนาทรัพยากรมนุษย์ | 人力资源开发培训技术"
    },
    {
        "id":6783,
        "name":"7289 (Thai Program)  :  Chemical And Environmental Engineering | วิศวกรรมเคมีและสิ่งแวดล้อม | 化学与环境工程"
    },
    {
        "id":6784,
        "name":"7290 (Thai Program)  :  Wildlife And Grassland Management | การจัดการสัตว์ป่าและทุ่งหญ้า | 野生动物和草原管理"
    },
    {
        "id":6785,
        "name":"7291 (Thai Program)  :  Curriculum Innovation And Learning Management | นวัตกรรมหลักสูตรและการจัดการเรียนรู้ | 课程创新与学习管理"
    },
    {
        "id":6786,
        "name":"7292 (Thai Program)  :  Senior Management | การจัดการงานบริหารระดับสูง | 高级管理人员"
    },
    {
        "id":6787,
        "name":"7293 (Thai Program)  :  International Trade Economics Law | นิติเศรษฐศาสตร์การค้าระหว่างประเทศ | 国际贸易经济法"
    },
    {
        "id":6788,
        "name":"7294 (Thai Program)  :  Environmental And Safety Management | การจัดการสิ่งแวดล้อมและความปลอดภัย | 环境与安全管理"
    },
    {
        "id":6789,
        "name":"7295 (Thai Program)  :  Chinese For Business Communication | ภาษาจีนเพื่อการสื่อสารเชิงธุรกิจ | 商务沟通汉语"
    },
    {
        "id":6790,
        "name":"7296 (Thai Program)  :  Service Business Communication | การสื่อสารธุรกิจบริการ | 服务商务沟通"
    },
    {
        "id":6791,
        "name":"7297 (English Program)  :  Intercultural Communication | การสื่อสารระหว่างวัฒนธรรม | 跨文化交流"
    },
    {
        "id":6792,
        "name":"7298 (Thai Program)  :  Marine And Coastal Resource Management | การจัดการทรัพยากรทะเลและชายฝั่ง | 海洋和沿海资源管理"
    },
    {
        "id":6793,
        "name":"7299 (English Program)  :  Sound Studies | การศึกษาด้านเสียง | 声音研究"
    },
    {
        "id":6794,
        "name":"7300 (Thai Program)  :  Conflict And Peace Studies | ความขัดแย้งและสันติศึกษา | 冲突与和平研究"
    },
    {
        "id":6795,
        "name":"7301 (Thai Program)  :  Politics And Administration | การเมืองและการจัดการปกครอง | 政治与行政"
    },
    {
        "id":6796,
        "name":"7302 (English Program)  :  Industrial Design And Multimedia Communication | การออกแบบอุตสาหกรรมและการสื่อสารมัลติมีเดีย | 工业设计与多媒体通讯"
    },
    {
        "id":6797,
        "name":"7303 (English Program)  :  Politics Studying | การศึกษาการเมือง | 政治学习"
    },
    {
        "id":6798,
        "name":"7304 (English Program)  :  Plant Resource Production | การผลิตทรัพยากรพืช | 植物资源生产"
    },
    {
        "id":6799,
        "name":"7305 (English Program)  :  Networks And Communications | เครือข่ายและการสื่อสาร | 网络和通信"
    },
    {
        "id":6800,
        "name":"7306 (English Program)  :  Mechanical Engineering | วิศวกรรมเครื่องกล | 机械工业"
    },
    {
        "id":6801,
        "name":"7307 (English Program)  :  Elictrical Engineering And Computer Science | วิศวกรรมไฟฟ้าและวิทยาศาสตร์คอมพิวเตอร์ | 电气工程和计算机科学"
    },
    {
        "id":6802,
        "name":"7308 (Thai Program)  :  Health System Research And Development | การวิจัยและพัฒนาระบบสุขภาพ | 卫生系统研究与开发"
    },
    {
        "id":6803,
        "name":"7309 (Thai Program)  :  Industrial And Systems Engineering | วิศวกรรมอุตสาหการและระบบ | 工业和系统工程"
    },
    {
        "id":6804,
        "name":"7310 (Thai Program)  :  Herbal Science | วิทยาศาสตร์สมุนไพร | 草药科学"
    },
    {
        "id":6805,
        "name":"7311 (Thai Program)  :  Healthy Food And Nutrition | อาหารเพื่อสุขภาพและโภชนาการ | 健康食品和营养"
    },
    {
        "id":6806,
        "name":"7312 (Thai Program)  :  Police Administration And Justice Process | การบริหารงานตำรวจและกระบวนการยุติธรรม | 警察行政和司法程序"
    },
    {
        "id":6807,
        "name":"7313 (Thai Program)  :  Sustainable Management Of Agricultural Resources | การจัดการทรัพยากรการเกษตรอย่างยั่งยืน | 农业资源的可持续管理"
    },
    {
        "id":6808,
        "name":"7314 (English Program)  :  Sustainable Agricultural Resources Management | การจัดการทรัพยากรเกษตรยั่งยืน | 可持续农业资源管理"
    },
    {
        "id":6809,
        "name":"7315 (Thai Program)  :  Integrated Vegetable Technology | เทคโนโลยีพืชผักแบบบูรณาการ | 蔬菜综合技术"
    },
    {
        "id":6810,
        "name":"7316 (Thai Program)  :  Natural Product Chemistry | เคมีผลิตภัณฑ์ธรรมชาติ | 天然产物化学"
    },
    {
        "id":6811,
        "name":"7317 (Thai Program)  :  Administration Of Buddhist Affairs | การบริหารกิจการพระพุทธศาสนา | 佛教事务管理"
    },
    {
        "id":6812,
        "name":"7318 (Thai Program)  :  Interactive And Game Design | การออกแบบอินเทอร์แอคทีฟและเกม | 互动和游戏设计"
    },
    {
        "id":6813,
        "name":"7319 (Thai Program)  :  Sufficiency Economy Philosophy Management | การบริหารปรัชญาเศรษฐกิจพอเพียง | 自给自足经济理念管理"
    },
    {
        "id":6814,
        "name":"7320 (English Program)  :  Philosophy Of Sufficicncy Economy Management | ปรัชญาการจัดการเศรษฐกิจพอเพียง | 充足性经济管理哲学"
    },
    {
        "id":6815,
        "name":"7321 (Thai Program)  :  International Law And Diplomacy | กฎหมายระหว่างประเทศและการฑูต | 国际法和外交"
    },
    {
        "id":6816,
        "name":"7322 (English Program)  :  Internatinal Law And Diplomacy | กฎหมายระหว่างประเทศและการทูต | 国际法与外交"
    },
    {
        "id":6817,
        "name":"7323 (Thai Program)  :  Develop Agriculture And Coastal Resources | พัฒนาการเกษตรและทรัพยากรชายฝั่ง | 开发农业和沿海资源"
    },
    {
        "id":6818,
        "name":"7324 (English Program)  :  Agricultural And Coastal Resources Development | การพัฒนาทรัพยากรการเกษตรและชายฝั่ง | 农业和沿海资源开发"
    },
    {
        "id":6819,
        "name":"7325 (Thai Program)  :  Oral Internal Medicine | อายุรศาสตร์ช่องปาก | 口腔内科"
    },
    {
        "id":6820,
        "name":"7326 (Thai Program)  :  Public Policy And Planning | นโยบายสาธารณะและการวางแผน | 公共政策和规划"
    },
    {
        "id":6821,
        "name":"7327 (English Program)  :  Public Policy And Planning | นโยบายสาธารณะและการวางแผน | 公共政策和规划"
    },
    {
        "id":6822,
        "name":"7328 (Thai Program)  :  Organization And Management | องค์การและการจัดการ | 组织与管理"
    },
    {
        "id":6823,
        "name":"7329 (Thai Program)  :  Local Management And Government | การจัดการและการปกครองท้องถิ่น | 地方管理和政府"
    },
    {
        "id":6824,
        "name":"7330 (English Program)  :  Management And Local Administration | การจัดการและการบริหารท้องถิ่น | 管理和地方行政"
    },
    {
        "id":6825,
        "name":"7331 (Thai Program)  :  Digital Media Engineering And Game Systems | วิศวกรรมดิจิทัลมีเดียและระบบเกม | 数字媒体工程和游戏系统"
    },
    {
        "id":6826,
        "name":"7332 (English Program)  :  Digital Media And Game System Engineering | วิศวกรรมระบบสื่อดิจิทัลและเกม | 数字媒体和游戏系统工程"
    },
    {
        "id":6827,
        "name":"7333 (Thai Program)  :  Cultural Landscape Management | การจัดการภูมิวัฒนธรรม | 文化景观管理"
    },
    {
        "id":6828,
        "name":"7334 (English Program)  :  Geo-Cultural Management | การจัดการภูมิศาสตร์วัฒนธรรม | 地缘文化管理"
    },
    {
        "id":6829,
        "name":"7335 (Thai Program)  :  Strategy And Security | ยุทธศาสตร์และความมั่นคง | 战略与安全"
    },
    {
        "id":6830,
        "name":"7336 (Thai Program)  :  Handicraft Product Design | การออกแบบผลิตภัณฑ์หัตถกรรม | 工艺品产品设计"
    },
    {
        "id":6831,
        "name":"7337 (English Program)  :  Crafts Product Design | การออกแบบผลิตภัณฑ์งานฝีมือ | 工艺品产品设计"
    },
    {
        "id":6832,
        "name":"7338 (Thai Program)  :  Metrology And Quality Systems | มาตรวิทยาและระบบคุณภาพ | 计量和质量体系"
    },
    {
        "id":6833,
        "name":"7339 (English Program)  :  Metrology And Quality System | มาตรวิทยาและระบบคุณภาพ | 计量和质量体系"
    },
    {
        "id":6834,
        "name":"7340 (Thai Program)  :  Mechatronics Technology | เทคโนโลยีแมคคาทรอนิกส์ | 机电一体化技术"
    },
    {
        "id":6835,
        "name":"7341 (English Program)  :  Mechatronics Technology | เทคโนโลยีเมคคาทรอนิกส์ | 机电一体化技术"
    },
    {
        "id":6836,
        "name":"7342 (Thai Program)  :  Robotics And Automation Engineering | วิศวกรรมหุ่นยนต์และระบบอัตโนมัติ | 机器人与自动化工程"
    },
    {
        "id":6837,
        "name":"7343 (English Program)  :  Robotics Engineering And Automation System | วิศวกรรมหุ่นยนต์และระบบอัตโนมัติ | 机器人工程及自动化系统"
    },
    {
        "id":6838,
        "name":"7344 (Thai Program)  :  Industrial Engineering Technology | เทคโนโลยีวิศวกรรมอุตสาหการ | 工业工程技术"
    },
    {
        "id":6839,
        "name":"7345 (English Program)  :  Industnal Engineering Technology | เทคโนโลยีวิศวกรรมอุตสาหการ | 工业工程技术"
    },
    {
        "id":6840,
        "name":"7346 (Thai Program)  :  Production And Industrial Engineering | วิศวกรรมการผลิตและอุตสาหการ | 生产与工业工程"
    },
    {
        "id":6841,
        "name":"7347 (English Program)  :  Production And Industrial Engineering | วิศวกรรมการผลิตและอุตสาหการ | 生产和工业工程"
    },
    {
        "id":6842,
        "name":"7348 (Thai Program)  :  Integrated Tourism Management | การจัดการการท่องเที่ยวเชิงบูรณาการ | 旅游综合管理"
    },
    {
        "id":6843,
        "name":"7349 (Thai Program)  :  Transportation And Logistics Engineering | วิศวกรรมขนส่งและโลจิสติกส์ | 交通运输与物流工程"
    },
    {
        "id":6844,
        "name":"7350 (English Program)  :  Transportation Engineering And Logistics | วิศวกรรมการขนส่งและโลจิสติกส์ | 交通工程与物流"
    },
    {
        "id":6845,
        "name":"7351 (Thai Program)  :  Textiles And Design | สิ่งทอและการออกแบบ | 纺织与设计"
    },
    {
        "id":6846,
        "name":"7352 (English Program)  :  Textile And Design | สิ่งทอและการออกแบบ | 纺织与设计"
    },
    {
        "id":6847,
        "name":"7353 (Thai Program)  :  Railway Engineering | วิศวกรรมระบบราง | 铁路工程"
    },
    {
        "id":6848,
        "name":"7354 (Thai Program)  :  Material Forming Technology And Manufacturing Innovation | เทคโนโลยีการขึ้นรูปวัสดุและนวัตกรรมการผลิต | 材料成型技术与制造创新"
    },
    {
        "id":6849,
        "name":"7355 (English Program)  :  Materials Processing Technology And Manufacturing Innovation | เทคโนโลยีการแปรรูปวัสดุและนวัตกรรมการผลิต | 材料加工技术与制造创新"
    },
    {
        "id":6850,
        "name":"7356 (Thai Program)  :  Industrial Engineering And Production Systems | วิศวกรรมอุตสาหการและระบบการผลิต | 工业工程和生产系统"
    },
    {
        "id":6851,
        "name":"7357 (English Program)  :  Industrial And Manufacturing Systems Engineering | วิศวกรรมระบบอุตสาหกรรมและการผลิต | 工业和制造系统工程"
    },
    {
        "id":6852,
        "name":"7358 (Thai Program)  :  Technology Business | ธุรกิจเทคโนโลยี | 科技业务"
    },
    {
        "id":6853,
        "name":"7359 (English Program)  :  Technopreneurship | ความเป็นผู้นำด้านเทคโนโลยี | 科技创业"
    },
    {
        "id":6854,
        "name":"7360 (Thai Program)  :  Manufacturing Industry | อุตสาหกรรมการผลิต | 制造业"
    },
    {
        "id":6855,
        "name":"7361 (English Program)  :  Industrial Production | การผลิตภาคอุตสาหกรรม | 工业生产"
    },
    {
        "id":6856,
        "name":"7362 (Thai Program)  :  Agricultural Product Processing Engineering | วิศวกรรมแปรรูปผลิตผลเกษตร | 农产品加工工程"
    },
    {
        "id":6857,
        "name":"7363 (English Program)  :  Agricultural Products Processing Engineering | วิศวกรรมแปรรูปผลิตภัณฑ์เกษตร | 农产品加工工程"
    },
    {
        "id":6858,
        "name":"7364 (Thai Program)  :  Interdisciplinary Arts | สหศาสตร์ศิลป์ | 跨学科艺术"
    },
    {
        "id":6859,
        "name":"7365 (English Program)  :  Multidisciplinary Art | ศิลปะสหวิทยาการ | 多学科艺术"
    },
    {
        "id":6860,
        "name":"7366 (Thai Program)  :  Christian Theology | คริสต์ศาสนศาสตร์ | 基督教神学"
    },
    {
        "id":6861,
        "name":"7367 (English Program)  :  Christian Theology | เทววิทยาคริสเตียน | 基督教神学"
    },
    {
        "id":6862,
        "name":"7368 (Thai Program)  :  Japanese Language And Culture | ภาษาและวัฒนธรรมญี่ปุ่น | 日本语言和文化"
    },
    {
        "id":6863,
        "name":"7369 (English Program)  :  Japanese Language And Culture | ภาษาและวัฒนธรรมญี่ปุ่น | 日本语言和文化"
    },
    {
        "id":6864,
        "name":"7370 (Thai Program)  :  Information Science And Technology | วิทยาการสารสนเทศและเทคโนโลยี | 信息科学与技术"
    },
    {
        "id":6865,
        "name":"7371 (English Program)  :  Information Science And Technology | วิทยาศาสตร์และเทคโนโลยีสารสนเทศ | 信息科学与技术"
    },
    {
        "id":6866,
        "name":"7372 (Thai Program)  :  Enterprise Management For Executives | การจัดการวิสาหกิจสำหรับผู้บริหาร | 企业高管管理"
    },
    {
        "id":6867,
        "name":"7373 (Thai Program)  :  Service And Tourism Industry | อุตสาหกรรมบริการและการท่องเที่ยว | 服务业和旅游业"
    },
    {
        "id":6868,
        "name":"7374 (Thai Program)  :  Community Administration And Development | การบริหารและการพัฒนาชุมชน | 社区管理和发展"
    },
    {
        "id":6869,
        "name":"7375 (English Program)  :  Administrator And Community Development | ผู้บริหารและการพัฒนาชุมชน | 管理员和社区发展"
    },
    {
        "id":6870,
        "name":"7376 (Thai Program)  :  Educational Technology And Computers | เทคโนโลยีการศึกษาและคอมพิวเตอร์ | 教育技术和计算机"
    },
    {
        "id":6871,
        "name":"7377 (English Program)  :  Educational Technology And Computer | เทคโนโลยีการศึกษาและคอมพิวเตอร์ | 教育技术和计算机"
    },
    {
        "id":6872,
        "name":"7378 (Thai Program)  :  Medical Secretary | เลขานุการทางการแพทย์ | 医务秘书"
    },
    {
        "id":6873,
        "name":"7379 (English Program)  :  Medical Secretary | เลขาธิการการแพทย์ | 医务秘书"
    },
    {
        "id":6874,
        "name":"7380 (Thai Program)  :  Service Management | การจัดการงานบริการ | 服务管理"
    },
    {
        "id":6875,
        "name":"7381 (Thai Program)  :  Cooking Technology And Services | เทคโนโลยีการประกอบอาหารและการบริการ | 烹饪技术与服务"
    },
    {
        "id":6876,
        "name":"7382 (English Program)  :  Culinary Technology And Service | เทคโนโลยีและบริการด้านอาหาร | 烹饪技术与服务"
    },
    {
        "id":6877,
        "name":"7383 (Thai Program)  :  Nutrition And Cooking | โภชนาการและการประกอบอาหาร | 营养与烹饪"
    },
    {
        "id":6878,
        "name":"7384 (English Program)  :  Nutrition And Culinary | โภชนาการและการทำอาหาร | 营养与烹饪"
    },
    {
        "id":6879,
        "name":"7385 (Thai Program)  :  Urban And Industrial Environment | สิ่งแวดล้อมเมืองและอุตสาหกรรม | 城市和工业环境"
    },
    {
        "id":6880,
        "name":"7386 (English Program)  :  Urban And Industrial Environment | สภาพแวดล้อมในเมืองและอุตสาหกรรม | 城市和工业环境"
    },
    {
        "id":6881,
        "name":"7387 (Thai Program)  :  Food Processing Technology | เทคโนโลยีการแปรรูปอาหาร | 食品加工技术"
    },
    {
        "id":6882,
        "name":"7388 (Thai Program)  :  Communication And Business Language | ภาษาการสื่อสารและธุรกิจ | 沟通和商务语言"
    },
    {
        "id":6883,
        "name":"7389 (Thai Program)  :  Political Economy And Administration | เศรษฐศาสตร์การเมืองและการบริหาร | 政治经济学与行政管理"
    },
    {
        "id":6884,
        "name":"7390 (Thai Program)  :  Modern Public Policy And Management | นโยบายสาธารณะและการจัดการสมัยใหม่ | 现代公共政策与管理"
    },
    {
        "id":6885,
        "name":"7391 (Thai Program)  :  Thai Pharmacy | เภสัชกรรมไทย | 泰国药房"
    },
    {
        "id":6886,
        "name":"7392 (Thai Program)  :  Photo Art | ศิลปะภาพถ่าย | 摄影艺术"
    },
    {
        "id":6887,
        "name":"7393 (Thai Program)  :  Islamic Studies And Arabic Language | อิสลามศึกษาและภาษาอาหรับ | 伊斯兰研究和阿拉伯语言"
    },
    {
        "id":6888,
        "name":"7394 (English Program)  :  Islamic Studies And Arabic Language | การศึกษาอิสลามและภาษาอาหรับ | 伊斯兰研究和阿拉伯语言"
    },
    {
        "id":6889,
        "name":"7395 (Thai Program)  :  Asian Business Management | การจัดการธุรกิจเอเชีย | 亚洲企业管理"
    },
    {
        "id":6890,
        "name":"7396 (English Program)  :  Asian Business Management | การจัดการธุรกิจในเอเชีย | 亚洲商业管理"
    },
    {
        "id":6891,
        "name":"7397 (Thai Program)  :  Service Science | วิทยาการบริการ | 服务科学"
    },
    {
        "id":6892,
        "name":"7398 (English Program)  :  Service Science | วิทยาศาสตร์การบริการ | 服务科学"
    },
    {
        "id":6893,
        "name":"7399 (Thai Program)  :  Industrial Chemistry And Textile Technology | เคมีอุตสาหกรรมและเทคโนโลยีสิ่งทอ | 工业化学与纺织技术"
    },
    {
        "id":6894,
        "name":"7400 (English Program)  :  Industrial Chemistry And Textile Technology | เคมีอุตสาหกรรมและเทคโนโลยีสิ่งทอ | 工业化学和纺织技术"
    },
    {
        "id":6895,
        "name":"7401 (Thai Program)  :  Owning A Modern Business | การเป็นเจ้าของธุรกิจสมัยใหม่ | 拥有现代企业"
    },
    {
        "id":6896,
        "name":"7402 (Thai Program)  :  Ceramics Engineering Technology | เทคโนโลยีวิศวกรรมเซรามิกส์ | 陶瓷工程技术"
    },
    {
        "id":6897,
        "name":"7403 (English Program)  :  Ceramics Engineering Technology | เทคโนโลยีวิศวกรรมเซรามิกส์ | 陶瓷工程技术"
    },
    {
        "id":6898,
        "name":"7404 (Thai Program)  :  Sports And Exercise Science | วิทยาศาสตร์การกีฬาและการออกกำลังกาย | 运动与运动科学"
    },
    {
        "id":6899,
        "name":"7405 (Thai Program)  :  Health Technology | เทคโนโลยีสุขภาพ | 健康科技"
    },
    {
        "id":6900,
        "name":"7406 (Thai Program)  :  Tourism And Aviation | การท่องเที่ยวและการบิน | 旅游和航空"
    },
    {
        "id":6901,
        "name":"7407 (Thai Program)  :  Graphic Arts And Graphic Media | กราฟิกอาร์ต และกราฟิกมีเดีย | 图形艺术和图形媒体"
    },
    {
        "id":6902,
        "name":"7408 (Thai Program)  :  Civil Engineering And Architectural Technology | เทคโนโลยีวิศวกรรมโยธาและสถาปัตยกรรม | 土木工程和建筑技术"
    },
    {
        "id":6903,
        "name":"7409 (Thai Program)  :  Electronic And Information Technology | เทคโนโลยีอิเล็กทรอนิกส์และสารสนเทศ | 电子信息技术"
    },
    {
        "id":6904,
        "name":"7410 (Thai Program)  :  Conference And Exhibition Business Management | การจัดการธุรกิจการประชุมและนิทรรศการ | 会议展览业务管理"
    },
    {
        "id":6905,
        "name":"7411 (Thai Program)  :  Management Of The International Tourism And Hospitality Industry | การจัดการอุตสาหกรรมท่องเที่ยวและการบริการระหว่างประเทศ | 国际旅游和酒店业管理"
    },
    {
        "id":6906,
        "name":"7412 (Thai Program)  :  Nanomaterials Engineering | วิศวกรรมวัสดุนาโน | 纳米材料工程"
    },
    {
        "id":6907,
        "name":"7413 (Thai Program)  :  Interior Environment Design | การออกแบบสภาพแวดล้อมภายใน | 室内环境设计"
    },
    {
        "id":6908,
        "name":"7414 (Thai Program)  :  Aquaculture Technology | เทคโนโลยีเพาะเลี้ยงสัตว์น้ำ | 水产养殖技术"
    },
    {
        "id":6909,
        "name":"7415 (Thai Program)  :  Computer Network Engineering | วิศวกรรมเครือข่ายคอมพิวเตอร์ | 计算机网络工程"
    },
    {
        "id":6910,
        "name":"7416 (Thai Program)  :  Promoting The Health Of The Elderly In The Community | การส่งเสริมสุขภาพผู้สูงอายุชุมชน | 促进社区老年人健康"
    },
    {
        "id":6911,
        "name":"7417 (English Program)  :  Community Health Promotion For Elderly People | การส่งเสริมสุขภาพชุมชนสำหรับผู้สูงอายุ | 老年人社区健康促进"
    },
    {
        "id":6912,
        "name":"7418 (Thai Program)  :  Sangeet Research And Development | สังคีตวิจัยและพัฒนา | 桑吉特研究与开发"
    },
    {
        "id":6913,
        "name":"7419 (Thai Program)  :  Finance And Economics | การเงินและเศรษฐศาสตร์ | 财经"
    },
    {
        "id":6914,
        "name":"7420 (Thai Program)  :  Computer Imagery Process | กระบวนการจินตภาพคอมพิวเตอร์ | 计算机图像处理"
    },
    {
        "id":6915,
        "name":"7421 (Thai Program)  :  Buddhist Arts | พุทธศิลปกรรม | 佛教艺术"
    },
    {
        "id":6916,
        "name":"7422 (Thai Program)  :  Aquaculture And Fisheries Resource Management | การเพาะเลี้ยงสัตว์น้ำและการจัดการทรัพยากรประมง | 水产养殖和渔业资源管理"
    },
    {
        "id":6917,
        "name":"7423 (Thai Program)  :  Environmental Design And Planning | การออกแบบและวางแผนสิ่งแวดล้อม | 环境设计与规划"
    },
    {
        "id":6918,
        "name":"7424 (Thai Program)  :  Social And Human Development | พัฒนาสังคมและมนุษย์ | 社会和人类发展"
    },
    {
        "id":6919,
        "name":"7425 (Thai Program)  :  Fisheries Technology And Aquatic Resources | เทคโนโลยีการประมงและทรัพยากรทางน้ำ | 渔业技术和水产资源"
    },
    {
        "id":6920,
        "name":"7426 (Thai Program)  :  Scouting Management | การบริหารจัดการกิจการลูกสือ | 球探管理"
    },
    {
        "id":6921,
        "name":"7427 (English Program)  :  Scouting Admintration | การบริหารงานลูกเสือ | 童子军管理局"
    },
    {
        "id":6922,
        "name":"7428 (Thai Program)  :  Development Of Community Sports And Recreation | การพัฒนากีฬาและนันทนาการชุมชน | 发展社区体育休闲"
    },
    {
        "id":6923,
        "name":"7429 (English Program)  :  Education Administration | การบริหารการศึกษา | 教育行政部门"
    },
    {
        "id":6924,
        "name":"7430 (English Program)  :  Biochemistry Biochemical | ชีวเคมี ชีวเคมี | 生物化学 生物化学"
    },
    {
        "id":6925,
        "name":"7431 (Thai Program)  :  Agricultural Industry | อุตสาหกรรมการเกษตร | 农业工业"
    },
    {
        "id":6926,
        "name":"7432 (Thai Program)  :  Biological Agricultural System | ระบบเกษตรเชิงชีวภาพ | 生物农业系统"
    },
    {
        "id":6927,
        "name":"7433 (Thai Program)  :  German For Careers | ภาษาเยอรมันเพื่ออาชีพ | 德语职业"
    },
    {
        "id":6928,
        "name":"7434 (English Program)  :  Logistics And Supply Chain ​​Systems Engineering | วิศวกรรมระบบโลจิสติกส์และโซ่อุปทาน | 物流与供应链系统工程"
    },
    {
        "id":6929,
        "name":"7435 (English Program)  :  Electrical Power Engineering | วิศวกรรมไฟฟ้ากำลัง | 电力工程"
    },
    {
        "id":6930,
        "name":"7436 (English Program)  :  Engineering Technology | เทคโนโลยีทางวิศวกรรม | 工程技术"
    },
    {
        "id":6931,
        "name":"7437 (Thai Program)  :  Customer Service | การบริการลูกค้า | 客户服务"
    },
    {
        "id":6932,
        "name":"7438 (English Program)  :  Customer Service | การบริการลูกค้า | 客户服务"
    },
    {
        "id":6933,
        "name":"7439 (English Program)  :  Bachelor Of Interior Architecture | ปริญญาตรีสาขาสถาปัตยกรรมภายใน | 室内建筑学学士"
    },
    {
        "id":6934,
        "name":"7440 (English Program)  :  Master Of Urban Environmental Planning And Development | ปริญญาโทสาขาการวางแผนและพัฒนาสิ่งแวดล้อมเมือง | 城市环境规划与发展硕士"
    },
    {
        "id":6935,
        "name":"7441 (English Program)  :  Criminal Justice Administration And Society | การบริหารความยุติธรรมทางอาญาและสังคม | 刑事司法行政与社会"
    },
    {
        "id":6936,
        "name":"7442 (English Program)  :  Social Policy And Administration | นโยบายสังคมและการบริหาร | 社会政策与行政"
    },
    {
        "id":6937,
        "name":"7443 (English Program)  :  Biochemistry And Molecular Biology | ชีวเคมีและอณูชีววิทยา | 生物化学和分子生物学"
    },
    {
        "id":6938,
        "name":"7444 (Thai Program)  :  English For Business And Management | ภาษาอังกฤษสำหรับธุรกิจและการจัดการ | 商业和管理英语"
    },
    {
        "id":6939,
        "name":"7445 (Thai Program)  :  Strategic Logistics And Supply Chain Management | การจัดการโลจิสติกส์และซัพพลายเชนเชิงยุทธศาสตร์ | 战略物流和供应链管理"
    },
    {
        "id":6940,
        "name":"7446 (Thai Program)  :  Office Automation Design And Business Management | การออกแบบสำนักงานอัตโนมัติและการจัดการธุรกิจ | 办公自动化设计与企业管理"
    },
    {
        "id":6941,
        "name":"7447 (English Program)  :  Office Automation Design And Business Management | การออกแบบสำนักงานอัตโนมัติและการจัดการธุรกิจ | 办公自动化设计与企业管理"
    },
    {
        "id":6942,
        "name":"7448 (Thai Program)  :  Public And Private Sector Administration | การบริหารภาครัฐและภาคเอกชน | 公共和私营部门管理"
    },
    {
        "id":6943,
        "name":"7449 (English Program)  :  Public And Private Sectors Management | การจัดการภาครัฐและเอกชน | 公共和私营部门管理"
    },
    {
        "id":6944,
        "name":"7450 (Thai Program)  :  Rubber Science And Technology | วิทยาศาสตร์และเทคโนโลยีการยาง | 橡胶科学与技术"
    },
    {
        "id":6945,
        "name":"7451 (English Program)  :  Rubber Science And Technology | วิทยาศาสตร์และเทคโนโลยียาง | 橡胶科技"
    },
    {
        "id":6946,
        "name":"7452 (Thai Program)  :  Thai Language And Communication | ภาษาไทยและการสื่อสาร | 泰语和交流"
    },
    {
        "id":6947,
        "name":"7453 (Thai Program)  :  Chinese Language And Communication | ภาษาจีนและการสื่อสาร | 汉语与传播"
    },
    {
        "id":6948,
        "name":"7454 (English Program)  :  Thai And Communication | ภาษาไทยและการสื่อสาร | 泰语和通讯"
    },
    {
        "id":6949,
        "name":"7455 (English Program)  :  Chinese And Communication | ภาษาจีนและการสื่อสาร | 中文与传播"
    },
    {
        "id":6950,
        "name":"7456 (Thai Program)  :  Japanese Language And Communication | ภาษาญี่ปุ่นและการสื่อสาร | 日语和交流"
    },
    {
        "id":6951,
        "name":"7457 (English Program)  :  Japanese And Communication | ภาษาญี่ปุ่นและการสื่อสาร | 日语和交流"
    },
    {
        "id":6952,
        "name":"7458 (Thai Program)  :  Language And Culture Of The Mekong Basin Region | ภาษาและวัฒนธรรมภูมิภาคลุ่มน้ำโขง | 湄公河流域地区的语言和文化"
    },
    {
        "id":6953,
        "name":"7459 (English Program)  :  Mekong Region Languages And Cultures | ภาษาและวัฒนธรรมของภูมิภาคลุ่มน้ำโขง | 湄公河地区的语言和文化"
    },
    {
        "id":6954,
        "name":"7460 (Thai Program)  :  Career And Technology | การงานอาชีพและเทคโนโลยี | 职业与技术"
    },
    {
        "id":6955,
        "name":"7461 (English Program)  :  Occupation And Technology | อาชีพและเทคโนโลยี | 职业与技术"
    },
    {
        "id":6956,
        "name":"7462 (Thai Program)  :  Management Mathematics | คณิตศาสตร์การจัดการ | 管理数学"
    },
    {
        "id":6957,
        "name":"7463 (English Program)  :  Management Mathematics | คณิตศาสตร์การจัดการ | 管理数学"
    },
    {
        "id":6958,
        "name":"7464 (Thai Program)  :  Visual Effects | วิชวลเอฟเฟกต์ | 视觉效果"
    },
    {
        "id":6959,
        "name":"7465 (English Program)  :  Modern Business Owner | เจ้าของธุรกิจสมัยใหม่ | 现代企业主"
    },
    {
        "id":6960,
        "name":"7466 (English Program)  :  Interactive And Game | โต้ตอบและเกม | 互动与游戏"
    },
    {
        "id":6961,
        "name":"7467 (English Program)  :  Bachelor Of Fine And Applied Arts | ปริญญาตรีสาขาวิจิตรศิลป์และประยุกต์ | 美术与应用艺术学士"
    },
    {
        "id":6962,
        "name":"7468 (Thai Program)  :  The Science Of Creative Wisdom For Management | ศาสตร์แห่งภูมิปัญญาสร้างสรรค์เพื่อการจัดการ | 管理创造性智慧的科学"
    },
    {
        "id":6963,
        "name":"7469 (English Program)  :  Science Of Creative Intelligence For Management | ศาสตร์แห่งความฉลาดเชิงสร้างสรรค์เพื่อการจัดการ | 管理创意智慧科学"
    },
    {
        "id":6964,
        "name":"7470 (Thai Program)  :  Management Arts | ศิลปการจัดการ | 管理艺术"
    },
    {
        "id":6965,
        "name":"7471 (English Program)  :  Art Of Management | ศิลปะแห่งการจัดการ | 管理艺术"
    },
    {
        "id":6966,
        "name":"7472 (Thai Program)  :  English For Service Work | ภาษาอังกฤษเพื่องานบริการ | 服务工作英语"
    },
    {
        "id":6967,
        "name":"7473 (English Program)  :  English For Service Sectors | ภาษาอังกฤษสำหรับภาคบริการ | 服务业英语"
    },
    {
        "id":6968,
        "name":"7474 (Thai Program)  :  Rangsan Dance | นาฏยรังสรรค์ | 郎山舞"
    },
    {
        "id":6969,
        "name":"7475 (Thai Program)  :  Food Product Management Technology | เทคโนโลยีการจัดการผลิตภัณฑ์อาหาร | 食品产品管理技术"
    },
    {
        "id":6970,
        "name":"7476 (Thai Program)  :  Management Of Wisdom And Cultural Resources | การจัดการภูมิปัญญาและทรัพยากรทางวัฒนธรรม | 智慧文化资源管理"
    },
    {
        "id":6971,
        "name":"7477 (English Program)  :  Wisdom And Cultural Resources Management | การจัดการทรัพยากรภูมิปัญญาและวัฒนธรรม | 智慧与文化资源管理"
    },
    {
        "id":6972,
        "name":"7478 (Thai Program)  :  Radio-Television-Movies | วิทยุ-โทรทัศน์-ภาพยนต์ | 广播电视电影"
    },
    {
        "id":6973,
        "name":"7479 (English Program)  :  Radio-Television-Film | วิทยุ-โทรทัศน์-ภาพยนตร์ | 广播电视电影"
    },
    {
        "id":6974,
        "name":"7480 (Thai Program)  :  Electronic And Computer Technology | เทคโนโลยีอิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子和计算机技术"
    },
    {
        "id":6975,
        "name":"7481 (Thai Program)  :  Educational Evaluation And Research | การประเมินผลและวิจัยทางการศึกษา | 教育评估与研究"
    },
    {
        "id":6976,
        "name":"7482 (Thai Program)  :  Information Technology For Industrial Logistics | เทคโนโลยีสารสนเทศเพื่อโลจิสติกส์อุตสาหกรรม | 工业物流信息技术"
    },
    {
        "id":6977,
        "name":"7483 (English Program)  :  Maritime Business | ธุรกิจการเดินเรือ | 海事业务"
    },
    {
        "id":6978,
        "name":"7484 (Thai Program)  :  Thai Music For Careers | ดนตรีไทยเพื่อการอาชีพ | 泰国音乐的职业生涯"
    },
    {
        "id":6979,
        "name":"7485 (Thai Program)  :  Advertising And Entertainment Business | การโฆษณาและธุรกิจบันเทิง | 广告及娱乐业务"
    },
    {
        "id":6980,
        "name":"7486 (Thai Program)  :  Agricultural Management Innovation | นวัตกรรมการจัดการเกษตร | 农业管理创新"
    },
    {
        "id":6981,
        "name":"7487 (English Program)  :  Innovative Agriculture Management | การจัดการเกษตรเชิงนวัตกรรม | 创新农业管理"
    },
    {
        "id":6982,
        "name":"7488 (English Program)  :  Chinese Language And Culture | ภาษาและวัฒนธรรมจีน | 中国语言与文化"
    },
    {
        "id":6983,
        "name":"7489 (Thai Program)  :  Design And Develop Industrial Products | ออกแบบและพัฒนาผลิตภัณฑ์อุตสาหกรรม | 设计和开发工业产品"
    },
    {
        "id":6984,
        "name":"7490 (English Program)  :  Industrial Product Design And Development | การออกแบบและพัฒนาผลิตภัณฑ์อุตสาหกรรม | 工业产品设计与开发"
    },
    {
        "id":6985,
        "name":"7491 (Thai Program)  :  Islamic History And Civilization | ประวัติศาสตร์และอารยธรรมอิสลาม | 伊斯兰历史和文明"
    },
    {
        "id":6986,
        "name":"7492 (Thai Program)  :  Air Mechanic Engineering | วิศวกรรมช่างอากาศ | 空气机械工程"
    },
    {
        "id":6987,
        "name":"7493 (Thai Program)  :  Public Management For Modern Executives | การจัดการสาธารณะสำหรับผู้บริหารยุคใหม่ | 现代高管的公共管理"
    },
    {
        "id":6988,
        "name":"7494 (Thai Program)  :  Mobile Computing Technology | เทคโนโลยีคอมพิวเตอร์เคลื่อนที่ | 移动计算技术"
    },
    {
        "id":6989,
        "name":"7495 (Thai Program)  :  Environmental Engineering And Disaster Management | วิศวกรรมสิ่งแวดล้อมและการจัดการภัยพิบัติ | 环境工程与灾害管理"
    },
    {
        "id":6990,
        "name":"7496 (Thai Program)  :  Mass Communication Innovation | นวัตกรรมสื่อสารมวลชน | 大众传播创新"
    },
    {
        "id":6991,
        "name":"7497 (English Program)  :  Innovative Mass Communication | นวัตกรรมการสื่อสารมวลชน | 创新大众传播"
    },
    {
        "id":6992,
        "name":"7498 (Thai Program)  :  Industrial Engineering And Service Systems | วิศวกรรมอุตสาหการและระบบบริการ | 工业工程和服务系统"
    },
    {
        "id":6993,
        "name":"7499 (Thai Program)  :  Biotechnology And Agricultural Products | เทคโนโลยีชีวภาพและผลิตภัณฑ์การเกษตร | 生物技术和农产品"
    },
    {
        "id":6994,
        "name":"7500 (Thai Program)  :  Performing Arts And Management | ศิลปะการแสดงและการจัดการ | 表演艺术与管理"
    },
    {
        "id":6995,
        "name":"7501 (Thai Program)  :  Industrial Education | ครุศาสตร์อุตสาหกรรม | 工业教育"
    },
    {
        "id":6996,
        "name":"7502 (Thai Program)  :  Maritime Logistics Management | การจัดการโลจิสติกส์พาณิชย์นาวี | 海运物流管理"
    },
    {
        "id":6997,
        "name":"7503 (English Program)  :  Maritime Logistics Management | การจัดการโลจิสติกส์ทางทะเล | 海运物流管理"
    },
    {
        "id":6998,
        "name":"7504 (Thai Program)  :  Vocational Education And Careers | อาชีวศึกษาและการงานอาชีพ | 职业教育和职业"
    },
    {
        "id":6999,
        "name":"7505 (Thai Program)  :  Radiological Biological Sciences | วิทยาศาสตร์ชีวภาพรังสี | 放射生物科学"
    },
    {
        "id":7000,
        "name":"7506 (Thai Program)  :  Waterworks System | ระบบงานประปา | 自来水厂系统"
    },
    {
        "id":7001,
        "name":"7507 (English Program)  :  Waterworks System | ระบบประปา | 水务系统"
    },
    {
        "id":7002,
        "name":"7508 (Thai Program)  :  Building Resource Management | การจัดการทรัพยากรอาคาร | 建筑资源管理"
    },
    {
        "id":7003,
        "name":"7509 (Thai Program)  :  Computer And Electronic Engineering | วิศวกรรมคอมพิวเตอร์และอิเล็กทรอนิกส์ | 计算机与电子工程"
    },
    {
        "id":7004,
        "name":"7510 (Thai Program)  :  Industrial Engineering-Logistics | วิศวกรรมอุตสาหการ-โลจิสติกส์ | 工业工程-物流"
    },
    {
        "id":7005,
        "name":"7511 (Thai Program)  :  International Studies | วิเทศศึกษา | 国际研究"
    },
    {
        "id":7006,
        "name":"7512 (Thai Program)  :  Food And Service | อาหารและบริการ | 食物和服务"
    },
    {
        "id":7007,
        "name":"7513 (Thai Program)  :  Aviation Business Administration | บริหารกิจการการบิน | 航空工商管理"
    },
    {
        "id":7008,
        "name":"7514 (Thai Program)  :  Nutrition And Nutritional Therapy | โภชนาการและโภชนบำบัด | 营养与营养治疗"
    },
    {
        "id":7009,
        "name":"7515 (Thai Program)  :  Industrial Engineering And Production Innovation Management | วิศวกรรมอุตสาหการและการจัดการนวัตกรรมการผลิต | 工业工程与生产创新管理"
    },
    {
        "id":7010,
        "name":"7516 (Thai Program)  :  Industrial Electronic Engineering | วิศวกรรมอิเล็กทรอนิกส์เพื่ออุตสาหกรรม | 工业电子工程"
    },
    {
        "id":7011,
        "name":"7517 (Thai Program)  :  Web And Mobile Technology | เว็บและโมบายเทคโนโลยี | 网络和移动技术"
    },
    {
        "id":7012,
        "name":"7518 (Thai Program)  :  Natural Product Technology | เทคโนโลยีผลิตภัณฑ์ธรรมชาติ | 天然产物技术"
    },
    {
        "id":7013,
        "name":"7519 (English Program)  :  Natural Product Technology | เทคโนโลยีผลิตภัณฑ์จากธรรมชาติ | 天然产品技术"
    },
    {
        "id":7014,
        "name":"7520 (Thai Program)  :  Making Movies | การสร้างภาพยนต์ | 拍电影"
    },
    {
        "id":7015,
        "name":"7521 (Thai Program)  :  Hotel And Restaurant Business | ธุรกิจโรงแรมและภัตราคาร | 酒店及餐饮业"
    },
    {
        "id":7016,
        "name":"7522 (Thai Program)  :  Information And Communication Technology For Marketing | เทคโนโลยีสารสนเทศและการสื่อสารเพื่อการตลาด | 营销信息和通信技术"
    },
    {
        "id":7017,
        "name":"7523 (Thai Program)  :  Information And Technology Management | การจัดการสารสนเทศและเทคโนโลยี | 信息和技术管理"
    },
    {
        "id":7018,
        "name":"7524 (Thai Program)  :  Airplane Mechanic | ช่างเครื่องบิน | 飞机机械师"
    },
    {
        "id":7019,
        "name":"7525 (English Program)  :  Airplanes | เครื่องบิน | 飞机"
    },
    {
        "id":7020,
        "name":"7526 (Thai Program)  :  Organizing Conferences, Exhibitions And Incentive Travel | การจัดการประชุมนิทรรศการและการท่องเที่ยวเพื่อเป็นรางวัล | 组织会议、展览和奖励旅游"
    },
    {
        "id":7021,
        "name":"7527 (Thai Program)  :  Aviation Industry Management | การจัดการอุตสาหกรรมการบิน | 航空业管理"
    },
    {
        "id":7022,
        "name":"7528 (Thai Program)  :  Digital Art Design | ออกแบบดิจิทัลอาร์ต | 数字艺术设计"
    },
    {
        "id":7023,
        "name":"7529 (English Program)  :  Digital Art Design | การออกแบบงานศิลปะดิจิทัล | 数字艺术设计"
    },
    {
        "id":7024,
        "name":"7530 (Thai Program)  :  Construction Management Technology | เทคโนโลยีการจัดการงานก่อสร้าง | 施工管理技术"
    },
    {
        "id":7025,
        "name":"7531 (English Program)  :  Technology Construction Management | การจัดการการก่อสร้างเทคโนโลยี | 技术 施工 管理"
    },
    {
        "id":7026,
        "name":"7532 (Thai Program)  :  Computer Technology Product Design | เทคโนโลยีคอมพิวเตอร์ออกแบบผลิตภัณฑ์ | 计算机技术产品设计"
    },
    {
        "id":7027,
        "name":"7533 (English Program)  :  Computer Technology Production Design | การออกแบบการผลิตเทคโนโลยีคอมพิวเตอร์ | 计算机技术生产设计"
    },
    {
        "id":7028,
        "name":"7534 (Thai Program)  :  Computer And Communication Technology | เทคโนโลยีคอมพิวเตอร์และการสื่อสาร | 计算机和通信技术"
    },
    {
        "id":7029,
        "name":"7535 (English Program)  :  Computer Technology And Communication | เทคโนโลยีคอมพิวเตอร์และการสื่อสาร | 计算机技术与通信"
    },
    {
        "id":7030,
        "name":"7536 (Thai Program)  :  Flight Instrument | เครื่องวัดประกอบการบิน | 飞行仪表"
    },
    {
        "id":7031,
        "name":"7537 (Thai Program)  :  Administrative Economics | เศรษฐศาสตร์เพื่อการบริหาร | 行政经济学"
    },
    {
        "id":7032,
        "name":"7538 (Thai Program)  :  Vietnamese Language And Communication | ภาษาเวียดนามและการสื่อสาร | 越南语和交流"
    },
    {
        "id":7033,
        "name":"7539 (English Program)  :  Vietnamese And Communication | ภาษาเวียดนามและการสื่อสาร | 越南语和交流"
    },
    {
        "id":7034,
        "name":"7540 (Thai Program)  :  Maintenance Of Aviation Communications Equipment | บำรุงรักษาเครื่องสื่อสารการบิน | 航空通讯设备维修"
    },
    {
        "id":7035,
        "name":"7541 (Thai Program)  :  Insurance And Risk Management | การประกันภัยและการจัดการความเสี่ยง | 保险与风险管理"
    },
    {
        "id":7036,
        "name":"7542 (Thai Program)  :  Development, Promotion And Agricultural Communication | การพัฒนาส่งเสริมและนิเทศศาสตร์เกษตร | 开发、推广和农业传播"
    },
    {
        "id":7037,
        "name":"7543 (English Program)  :  Agricultaral Development Extension And Communications | การขยายผลการพัฒนาการเกษตรและการสื่อสาร | 农业发展推广和交流"
    },
    {
        "id":7038,
        "name":"7544 (Thai Program)  :  Aquaculture Technology | เทคโนโลยีการเพาะเลี้ยงสัตว์น้ำ | 水产养殖技术"
    },
    {
        "id":7039,
        "name":"7545 (Thai Program)  :  Integrated Coastal Management | การจัดการชายฝั่งแบบบูรณาการ | 沿海综合管理"
    },
    {
        "id":7040,
        "name":"7546 (Thai Program)  :  Environmental Technology And Resource Management | เทคโนโลยีสิ่งแวดล้อมและการจัดการทรัพยากร | 环境技术和资源管理"
    },
    {
        "id":7041,
        "name":"7547 (Thai Program)  :  Politics And Development Strategy | การเมืองและยุทธศาสตร์การพัฒนา | 政治与发展战略"
    },
    {
        "id":7042,
        "name":"7548 (Thai Program)  :  Communication Arts And Innovation | นิเทศศาสตร์และนวัตกรรม | 传播艺术与创新"
    },
    {
        "id":7043,
        "name":"7549 (Thai Program)  :  Peace Studies | สันติศึกษา | 和平研究"
    },
    {
        "id":7044,
        "name":"7550 (Thai Program)  :  Buddhist Educational Administration | พุทธบริหารการศึกษา | 佛教教育行政"
    },
    {
        "id":7045,
        "name":"7551 (Thai Program)  :  Tripitaka Studies | พระไตรปิฎกศึกษา | 三藏研究"
    },
    {
        "id":7046,
        "name":"7552 (Thai Program)  :  Buddhism And The Art Of Life | พุทธศาสตร์และศิลปะแห่งชีวิต | 佛教与生活的艺术"
    },
    {
        "id":7047,
        "name":"7553 (Thai Program)  :  International Trade Business In The Indochina Group | ธุรกิจการค้าระหว่างประเทศในกลุ่มอินโดจีน | 印度支那集团的国际贸易业务"
    },
    {
        "id":7048,
        "name":"7554 (Thai Program)  :  Life And Death | ชีวิตและความตาย | 生死"
    },
    {
        "id":7049,
        "name":"7555 (Thai Program)  :  Animal Health And Biomedical Sciences | วิทยาศาสตร์สุขภาพสัตว์และชีวเวชศาสตร์ | 动物健康和生物医学科学"
    },
    {
        "id":7050,
        "name":"7556 (English Program)  :  Animal Health And Biomedical Sciences | สุขภาพสัตว์และวิทยาศาสตร์ชีวการแพทย์ | 动物健康和生物医学科学"
    },
    {
        "id":7051,
        "name":"7557 (Thai Program)  :  Applied Finance | การเงินประยุกต์ | 应用金融"
    },
    {
        "id":7052,
        "name":"7558 (English Program)  :  Applied Finance | การเงินที่ใช้แล้ว | 应用金融"
    },
    {
        "id":7053,
        "name":"7559 (Thai Program)  :  Social Entrepreneur | ผู้ประกอบการสังคม | 社会企业家"
    },
    {
        "id":7054,
        "name":"7560 (English Program)  :  Social Entrepreneur | ผู้ประกอบการเพื่อสังคม | 社会企业家"
    },
    {
        "id":7055,
        "name":"7561 (Thai Program)  :  Retail Marketing Management | การจัดการการตลาดค้าปลีก | 零售营销管理"
    },
    {
        "id":7056,
        "name":"7562 (English Program)  :  Retail Marketing Management | การจัดการการตลาดค้าปลีก | 零售营销管理"
    },
    {
        "id":7057,
        "name":"7563 (Thai Program)  :  Strategic Communication | การสื่อสารเชิงกลยุทธ์ | 战略沟通"
    },
    {
        "id":7058,
        "name":"7564 (English Program)  :  Strategic Communication | การสื่อสารเชิงกลยุทธ์ | 战略沟通"
    },
    {
        "id":7059,
        "name":"7565 (Thai Program)  :  Film And Performing Arts | ภาพยนตร์และศิลปะการแสดง | 电影和表演艺术"
    },
    {
        "id":7060,
        "name":"7566 (Thai Program)  :  Interdisciplinary Music | สหวิทยาการดนตรี | 跨学科音乐"
    },
    {
        "id":7061,
        "name":"7567 (English Program)  :  Music Interdisciplinary | ดนตรีสหวิทยาการ | 音乐跨学科"
    },
    {
        "id":7062,
        "name":"7568 (Thai Program)  :  Business Entrepreneurial Psychology | จิตวิทยาการประกอบการธุรกิจ | 商业创业心理学"
    },
    {
        "id":7063,
        "name":"7569 (Thai Program)  :  Business Development | พัฒนาธุรกิจ | 业务发展"
    },
    {
        "id":7064,
        "name":"7570 (English Program)  :  Business Development | การพัฒนาธุรกิจ | 业务发展"
    },
    {
        "id":7065,
        "name":"7571 (Thai Program)  :  Statistical Information Science | สถิติสารสนเทศศาสตร์ | 统计信息科学"
    },
    {
        "id":7066,
        "name":"7572 (Thai Program)  :  Agricultural Science And Technology | วิทยาศาสตร์และเทคโนโลยีการเกษตร | 农业科技"
    },
    {
        "id":7067,
        "name":"7573 (Thai Program)  :  International Health | สุขภาพระหว่างประเทศ | 国际卫生"
    },
    {
        "id":7068,
        "name":"7574 (English Program)  :  International Health | สุขภาพระหว่างประเทศ | 国际健康"
    },
    {
        "id":7069,
        "name":"7575 (Thai Program)  :  Intelligent Information Integration | การบูรณาการสารสนเทศอัจฉริยะ | 智能信息集成"
    },
    {
        "id":7070,
        "name":"7576 (English Program)  :  Intelligent Information Integration | การบูรณาการข้อมูลอัจฉริยะ | 智能信息整合"
    },
    {
        "id":7071,
        "name":"7577 (Thai Program)  :  Environmental Social Science | สังคมศาสตร์สิ่งแวดล้อม | 环境社会科学"
    },
    {
        "id":7072,
        "name":"7578 (Thai Program)  :  Thai Language And Applied Language | ภาษาและภาษาไทยประยุกต์ | 泰语及应用语言"
    },
    {
        "id":7073,
        "name":"7579 (English Program)  :  Language And Applied Thai | ภาษาและภาษาไทยประยุกต์ | 语言与应用泰语"
    },
    {
        "id":7074,
        "name":"7580 (Thai Program)  :  Applied Oral Health Science | วิทยาการสุขภาพช่องปากประยุกต์ | 应用口腔健康科学"
    },
    {
        "id":7075,
        "name":"7581 (English Program)  :  Applied Oral Health Sciences | วิทยาศาสตร์สุขภาพช่องปากประยุกต์ | 应用口腔健康科学"
    },
    {
        "id":7076,
        "name":"7582 (Thai Program)  :  English And Chinese For Business Communication | ภาษาอังกฤษและภาษาจีนเพื่อการสื่อสารธุรกิจ | 商务沟通用英语和中文"
    },
    {
        "id":7077,
        "name":"7583 (English Program)  :  English And Chinese For Business Communication | ภาษาอังกฤษและภาษาจีนเพื่อการสื่อสารทางธุรกิจ | 商务沟通英语和汉语"
    },
    {
        "id":7078,
        "name":"7584 (Thai Program)  :  Journalism Through New Media | วารสารศาสตร์ผ่านสื่อใหม่ | 新媒体新闻学"
    },
    {
        "id":7079,
        "name":"7585 (Thai Program)  :  Media And Marketing Communications | สื่อและการสื่อสารการตลาด | 媒体和营销传播"
    },
    {
        "id":7080,
        "name":"7586 (Thai Program)  :  Public Relations And Marketing Communications | การประชาสัมพันธ์และสื่อสารการตลาด | 公共关系和营销传播"
    },
    {
        "id":7081,
        "name":"7587 (English Program)  :  Pubiic Relations And Marketing Communcation | ความสัมพันธ์สาธารณะและการสื่อสารการตลาด | 公共关系和营销传播"
    },
    {
        "id":7082,
        "name":"7588 (Thai Program)  :  Energy And Environmental Management | การจัดการพลังงานและสิ่งแวดล้อม | 能源与环境管理"
    },
    {
        "id":7083,
        "name":"7589 (Thai Program)  :  Legal Affairs And Administration | นิติรัฐกิจและการบริหาร | 法律事务与行政"
    },
    {
        "id":7084,
        "name":"7590 (Thai Program)  :  Chinese Business Communication | ภาษาจีนสื่อสารธุรกิจ | 中国商务沟通"
    },
    {
        "id":7085,
        "name":"7591 (Thai Program)  :  Fisheries Management And Aquatic Animal Business | การจัดการประมงและธุรกิจสัตว์น้ำ | 渔业管理和水生动物业务"
    },
    {
        "id":7086,
        "name":"7593 (Thai Program)  :  Aircraft Maintenance Engineering Technology | เทคโนโลยีวิศวกรรมซ่อมบำรุงอากาศยาน | 飞机维修工程技术"
    },
    {
        "id":7087,
        "name":"7594 (English Program)  :  Aircraft Maintenance Engineering Technology | เทคโนโลยีวิศวกรรมการบำรุงรักษาอากาศยาน | 飞机维修工程技术"
    },
    {
        "id":7088,
        "name":"7595 (Thai Program)  :  Industrial Electrical And Energy Engineering | วิศวกรรมไฟฟ้าอุตสาหกรรมและพลังงาน | 工业电气与能源工程"
    },
    {
        "id":7089,
        "name":"7596 (English Program)  :  Industrial Electrical And Energy Engineering | วิศวกรรมไฟฟ้าอุตสาหกรรมและพลังงาน | 工业电气与能源工程"
    },
    {
        "id":7090,
        "name":"7597 (Thai Program)  :  Engineering And Technology Management | การจัดการวิศวกรรมและเทคโนโลยี | 工程技术管理"
    },
    {
        "id":7091,
        "name":"7598 (Thai Program)  :  Business Management Strategy | ยุทธศาสตร์การจัดการธุรกิจ | 企业管理策略"
    },
    {
        "id":7092,
        "name":"7599 (English Program)  :  Business Management Strategy | กลยุทธ์การจัดการธุรกิจ | 企业管理策略"
    },
    {
        "id":7093,
        "name":"7600 (Thai Program)  :  Communication Technology And Computer Networks | เทคโนโลยีการสื่อสารและเครือข่ายคอมพิวเตอร์ | 通信技术和计算机网络"
    },
    {
        "id":7094,
        "name":"7601 (Thai Program)  :  Teaching And Technology | การสอนและเทคโนโลยี | 教学与技术"
    },
    {
        "id":7095,
        "name":"7602 (Thai Program)  :  Fashion Design And Business | การออกแบบและธุรกิจแฟชั่น | 时装设计与商业"
    },
    {
        "id":7096,
        "name":"7603 (Thai Program)  :  Botanicals | พฤกษโษสถ | 植物药"
    },
    {
        "id":7097,
        "name":"7604 (Thai Program)  :  Defense Engineering | วิศวกรรมป้องกันประเทศ | 国防工程"
    },
    {
        "id":7098,
        "name":"7605 (Thai Program)  :  Calculation In Engineering Systems | การคำนวณในระบบวิศวกรรม | 工程系统计算"
    },
    {
        "id":7099,
        "name":"7606 (Thai Program)  :  Rail Transport Engineering | วิศวกรรมขนส่งทางราง | 轨道交通工程"
    },
    {
        "id":7100,
        "name":"7607 (Thai Program)  :  Environmental And Community Health Management | การจัดการอนามัยสิ่งแวดล้อมและสุขภาพชุมชน | 环境与社区健康管理"
    },
    {
        "id":7101,
        "name":"7608 (Thai Program)  :  Law And Management | กฎหมายและการจัดการ | 法律与管理"
    },
    {
        "id":7102,
        "name":"7609 (Thai Program)  :  Industrial Engineering And Logistics Technology | เทคโนโลยีวิศวกรรมอุตสาหการและโลจิสติกส์ | 工业工程与物流技术"
    },
    {
        "id":7103,
        "name":"7610 (English Program)  :  Industrial And Logistics Engineering Technology | เทคโนโลยีวิศวกรรมอุตสาหการและโลจิสติกส์ | 工业与物流工程技术"
    },
    {
        "id":7104,
        "name":"7611 (Thai Program)  :  Mechanical And Automotive Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องกลและยานยนต์ | 机械与汽车工程技术"
    },
    {
        "id":7105,
        "name":"7612 (English Program)  :  Mechanical And Automotive Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องกลและยานยนต์ | 机械和汽车工程技术"
    },
    {
        "id":7106,
        "name":"7613 (Thai Program)  :  Entertainment Media Management | การจัดการสื่อบันเทิง | 娱乐媒体管理"
    },
    {
        "id":7107,
        "name":"7614 (English Program)  :  Entertainment Media Management | การจัดการสื่อบันเทิง | 娱乐媒体管理"
    },
    {
        "id":7108,
        "name":"7615 (Thai Program)  :  Japanese Human Resource Management | การจัดการทรัพยากรมนุษย์แบบญี่ปุ่น | 日本人力资源管理"
    },
    {
        "id":7109,
        "name":"7616 (English Program)  :  Japanese Human Resources Management | การจัดการทรัพยากรมนุษย์ของญี่ปุ่น | 日本人力资源管理"
    },
    {
        "id":7110,
        "name":"7617 (English Program)  :  Japanese Business Administration | การบริหารธุรกิจของญี่ปุ่น | 日本工商行政管理局"
    },
    {
        "id":7111,
        "name":"7618 (Thai Program)  :  Fine Arts Research | การวิจัยทางศิลปกรรมศาสตร์ | 美术研究"
    },
    {
        "id":7112,
        "name":"7619 (Thai Program)  :  International Service And Tourism Business | ธุรกิจบริการและการท่องเที่ยวระหว่างประเทศ | 国际服务及旅游业务"
    },
    {
        "id":7113,
        "name":"7620 (English Program)  :  International Hospitality And Tourism | การต้อนรับระหว่างประเทศและการท่องเที่ยว | 国际酒店和旅游业"
    },
    {
        "id":7114,
        "name":"7621 (Thai Program)  :  Enterprise Information Systems | ระบบสารสนเทศเอ็นเทอร์ไพรส์ | 企业信息系统"
    },
    {
        "id":7115,
        "name":"7622 (English Program)  :  Enterprise Information Systems | ระบบสารสนเทศองค์กร | 企业信息系统"
    },
    {
        "id":7116,
        "name":"7623 (Thai Program)  :  Community Health Worker | พนักงานสุขภาพชุมชน | 社区卫生工作者"
    },
    {
        "id":7117,
        "name":"7624 (Thai Program)  :  Wood Product Entrepreneur | ผู้ประกอบการผลิตภัณฑ์ไม้ | 木制品企业家"
    },
    {
        "id":7118,
        "name":"7625 (English Program)  :  Wood Products Entrepreneur | ผู้ประกอบการผลิตภัณฑ์ไม้ | 木制品企业家"
    },
    {
        "id":7119,
        "name":"7626 (Thai Program)  :  Restaurant Operator | ผู้ประกอบการร้านอาหาร | 餐馆经营者"
    },
    {
        "id":7120,
        "name":"7627 (English Program)  :  Restaurant Entrepreneur | ผู้ประกอบการร้านอาหาร | 餐厅企业家"
    },
    {
        "id":7121,
        "name":"7628 (Thai Program)  :  Creating Added Value In Textile And Clothing Products | การสร้างมูลค่าเพิ่มสินค้าสิ่งทอและเครื่องนุ่งห่ม | 创造纺织服装产品附加值"
    },
    {
        "id":7122,
        "name":"7629 (English Program)  :  Value Added Creation Of Woven Textiles | การสร้างมูลค่าเพิ่มจากสิ่งทอทอ | 机织纺织品的增值创造"
    },
    {
        "id":7123,
        "name":"7630 (English Program)  :  Community Entrepreneur Information Technology | เทคโนโลยีสารสนเทศผู้ประกอบการชุมชน | 社区企业家信息技术"
    },
    {
        "id":7124,
        "name":"7631 (Thai Program)  :  Community Business Entrepreneurs In Information Technology | ผู้ประกอบการธุรกิจชุมชนด้านเทคโนโลยีสารสนเทศ | 信息技术领域的社区企业企业家"
    },
    {
        "id":7125,
        "name":"7632 (Thai Program)  :  Industrial Chemicals | เคมีเพื่ออุตสาหกรรม | 工业化学品"
    },
    {
        "id":7126,
        "name":"7633 (Thai Program)  :  Material Engineering Technology And Production Processes | เทคโนโลยีวิศวกรรมวัสดุและกระบวนการผลิต | 材料工程技术和生产工艺"
    },
    {
        "id":7127,
        "name":"7634 (English Program)  :  Material And Process Engineering Technology | เทคโนโลยีวิศวกรรมวัสดุและกระบวนการ | 材料与工艺工程技术"
    },
    {
        "id":7128,
        "name":"7635 (Thai Program)  :  Safety Engineering And Environmental Management | วิศวกรรมความปลอดภัยและการจัดการสิ่งแวดล้อม | 安全工程与环境管理"
    },
    {
        "id":7129,
        "name":"7636 (Thai Program)  :  Special Education And Computers | การศึกษาพิเศษแลคอมพิวเตอร์ | 特殊教育和计算机"
    },
    {
        "id":7130,
        "name":"7637 (English Program)  :  Special Education And Computer | การศึกษาพิเศษและคอมพิวเตอร์ | 特殊教育和计算机"
    },
    {
        "id":7131,
        "name":"7638 (Thai Program)  :  Construction Technology | เทคโนโลยีการก่อสร้าง | 施工技术"
    },
    {
        "id":7132,
        "name":"7639 (English Program)  :  Construction Technology | เทคโนโลยีการก่อสร้าง | 建筑技术"
    },
    {
        "id":7133,
        "name":"7640 (Thai Program)  :  Computer Technology For Design | เทคโนโลยีคอมพิวเตอร์เพื่อการออกแบบ | 计算机设计技术"
    },
    {
        "id":7134,
        "name":"7641 (English Program)  :  Computer Technology For Design | เทคโนโลยีคอมพิวเตอร์เพื่อการออกแบบ | 计算机设计技术"
    },
    {
        "id":7135,
        "name":"7642 (Thai Program)  :  Modern Business Management | การจัดการธุรกิจการค้าสมัยใหม่ | 现代企业管理"
    },
    {
        "id":7136,
        "name":"7643 (English Program)  :  Modern Trade Business Management | การจัดการธุรกิจการค้าสมัยใหม่ | 现代贸易企业管理"
    },
    {
        "id":7137,
        "name":"7644 (Thai Program)  :  Automotive Manufacturing Engineering | วิศวกรรมการผลิตยานยนต์ | 汽车制造工程"
    },
    {
        "id":7138,
        "name":"7645 (English Program)  :  Automotive Manufacturing Engineering | วิศวกรรมการผลิตยานยนต์ | 汽车制造工程"
    },
    {
        "id":7139,
        "name":"7646 (Thai Program)  :  Food Technology Innovation | นวัตกรรมเทคโนโลยีอาหาร | 食品科技创新"
    },
    {
        "id":7140,
        "name":"7647 (English Program)  :  Innovation In Food Technology | นวัตกรรมด้านเทคโนโลยีอาหาร | 食品技术创新"
    },
    {
        "id":7141,
        "name":"7648 (Thai Program)  :  Animation And Multimedia | แอนิเมชันและมัลติมีเดีย | 动画和多媒体"
    },
    {
        "id":7142,
        "name":"7649 (Thai Program)  :  Teaching Arabic | การสอนภาษาอาหรับ | 阿拉伯语教学"
    },
    {
        "id":7143,
        "name":"7650 (English Program)  :  Teaching Arabic Language | การสอนภาษาอาหรับ | 阿拉伯语教学"
    },
    {
        "id":7144,
        "name":"7651 (Thai Program)  :  Research And Develop Halal Products | วิจัยและพัฒนาผลิตภัณฑ์ฮาลาล | 研发清真产品"
    },
    {
        "id":7145,
        "name":"7652 (English Program)  :  Research And Development Of Halal Product | การวิจัยและพัฒนาผลิตภัณฑ์ฮาลาล | 清真产品研发"
    },
    {
        "id":7146,
        "name":"7653 (Thai Program)  :  International Hotel Management | การจัดการโรงแรมนานาชาติ | 国际酒店管理"
    },
    {
        "id":7147,
        "name":"7654 (Thai Program)  :  Organizing Conferences, Exhibitions And Special Events | การจัดการประชุม นิทรรศการ และกิจกรรมพิเศษ | 组织会议、展览和特别活动"
    },
    {
        "id":7148,
        "name":"7655 (English Program)  :  Convention Exhibition And Event Management | นิทรรศการอนุสัญญาและการจัดการกิจกรรม | 会议展览及活动管理"
    },
    {
        "id":7149,
        "name":"7656 (Thai Program)  :  Business Management Engineering Related To Railway Systems | วิศวกรรมการจัดการธุรกิจเกี่ยวเนื่องกับระบบราง | 铁路系统相关业务管理工程"
    },
    {
        "id":7150,
        "name":"7657 (English Program)  :  Rail And Emerging Business Management Engineering | วิศวกรรมการจัดการระบบรางและธุรกิจเกิดใหม่ | 铁路和新兴业务管理工程"
    },
    {
        "id":7151,
        "name":"7658 (Thai Program)  :  Business Information Science | สารสนเทศศาสตร์เชิงธุรกิจ | 商业信息科学"
    },
    {
        "id":7152,
        "name":"7659 (Thai Program)  :  Tool And Mold Manufacturing Engineering | วิศวกรรมการผลิตเครื่องมือและแม่พิมพ์ | 工模具制造工程"
    },
    {
        "id":7153,
        "name":"7660 (Thai Program)  :  Three-Dimensional Information Creative Design | การออกแบบสร้างสรรค์สารสนเทศสามมิติ | 三维信息创意设计"
    },
    {
        "id":7154,
        "name":"7661 (Thai Program)  :  Mechanical Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องกล | 机械工程技术"
    },
    {
        "id":7155,
        "name":"7662 (English Program)  :  Mechanical Engineering Technology | เทคโนโลยีวิศวกรรมเครื่องกล | 机械工程技术"
    },
    {
        "id":7156,
        "name":"7663 (Thai Program)  :  Industrial Business Management And Logistics | บริหารธุรกิจอุตสาหกรรมและโลจิสติกส์ | 工业企业管理和物流"
    },
    {
        "id":7157,
        "name":"7664 (English Program)  :  Industrial Business And Logistic Administration | ธุรกิจอุตสาหกรรมและการบริหารลอจิสติกส์ | 工业商业和物流管理"
    },
    {
        "id":7158,
        "name":"7665 (Thai Program)  :  Instrumentation And Automation Engineering Technology | เทคโนโลยีวิศวกรรมการวัดคุมและอัตโนมัติ | 仪器仪表及自动化工程技术"
    },
    {
        "id":7159,
        "name":"7666 (English Program)  :  Instrumentation And Automation Engineering Technology | เครื่องมือวัดและเทคโนโลยีวิศวกรรมอัตโนมัติ | 仪器仪表及自动化工程技术"
    },
    {
        "id":7160,
        "name":"7667 (Thai Program)  :  Energy Technology And Management | เทคโนโลยีพลังงานและการจัดการ | 能源技术与管理"
    },
    {
        "id":7161,
        "name":"7668 (Thai Program)  :  Chemical Industry Processes And The Environment | กระบวนการอุตสาหกรรมเคมีและสิ่งแวดล้อม | 化学工业过程和环境"
    },
    {
        "id":7162,
        "name":"7669 (English Program)  :  Industrial Chemical Process And Environment | กระบวนการเคมีอุตสาหกรรมและสิ่งแวดล้อม | 工业化学过程和环境"
    },
    {
        "id":7163,
        "name":"7670 (Thai Program)  :  Chemical Process Engineering Technology | เทคโนโลยีวิศวกรรมกระบวนการเคมี | 化学过程工程技术"
    },
    {
        "id":7164,
        "name":"7671 (Thai Program)  :  Culinary Technology And Arts | เทคโนโลยีและศิลปะการประกอบอาหาร | 烹饪技术与艺术"
    },
    {
        "id":7165,
        "name":"7672 (English Program)  :  Culinary Art And Technology | ศิลปะการทำอาหารและเทคโนโลยี | 烹饪艺术与技术"
    },
    {
        "id":7166,
        "name":"7673 (Thai Program)  :  Product Design Engineering | วิศวกรรมออกแบบผลิตภัณฑ์ | 产品设计工程"
    },
    {
        "id":7167,
        "name":"7674 (English Program)  :  Product Design Engineering | วิศวกรรมการออกแบบผลิตภัณฑ์ | 产品设计工程"
    },
    {
        "id":7168,
        "name":"7675 (Thai Program)  :  Retail Business And Franchise | ธุรกิจค้าปลีกและแฟรนไชส์ | 零售业务及特许经营"
    },
    {
        "id":7169,
        "name":"7676 (English Program)  :  Retail And Franchise Business | ธุรกิจค้าปลีกและแฟรนไชส์ | 零售及特许经营业务"
    },
    {
        "id":7170,
        "name":"7677 (Thai Program)  :  Industrial Materials Science | วัสดุศาสตร์อุตสาหกรรม | 工业材料科学"
    },
    {
        "id":7171,
        "name":"7678 (English Program)  :  Industrial Materials Science | วิทยาศาสตร์วัสดุอุตสาหกรรม | 工业材料科学"
    },
    {
        "id":7172,
        "name":"7679 (Thai Program)  :  English Language And Educational Technology | ภาษาอังกฤษและเทคโนโลยีการศึกษา | 英语语言和教育技术"
    },
    {
        "id":7173,
        "name":"7680 (English Program)  :  English And Educational Technology | เทคโนโลยีภาษาอังกฤษและการศึกษา | 英语和教育技术"
    },
    {
        "id":7174,
        "name":"7681 (Thai Program)  :  Industrial And Enterprise Management Technology | เทคโนโลยีการจัดการอุตสาหกรรมและวิสาหกิจ | 工业企业管理技术"
    },
    {
        "id":7175,
        "name":"7682 (English Program)  :  Industrial Management And Enterprise Technology | การจัดการอุตสาหกรรมและเทคโนโลยีระดับองค์กร | 工业管理与企业技术"
    },
    {
        "id":7176,
        "name":"7683 (Thai Program)  :  Materials Science And Nanotechnology | วัสดุศาสตร์และนาโนเทคโนโลยี | 材料科学与纳米技术"
    },
    {
        "id":7177,
        "name":"7684 (English Program)  :  Materials Science And Nanotechnology | วิทยาศาสตร์วัสดุและนาโนเทคโนโลยี | 材料科学与纳米技术"
    },
    {
        "id":7178,
        "name":"7685 (Thai Program)  :  Teaching Science, Mathematics And Computers | การสอนวิทยาศาสตร์ คณิตศาสตร์ และคอมพิวเตอร์ | 教授科学、数学和计算机"
    },
    {
        "id":7179,
        "name":"7686 (English Program)  :  Teaching Science, Mathematics And Computer | การสอนวิทยาศาสตร์ คณิตศาสตร์ และคอมพิวเตอร์ | 教授科学、数学和计算机"
    },
    {
        "id":7180,
        "name":"7687 (Thai Program)  :  Leadership Development For Sustainable Organizations | การพัฒนาภาวะผู้นำเพื่อองค์การที่ยั่งยืน | 可持续组织的领导力发展"
    },
    {
        "id":7181,
        "name":"7688 (Thai Program)  :  Sea ​​Transportation | การขนส่งทางทะเล | 海上运输"
    },
    {
        "id":7182,
        "name":"7689 (Thai Program)  :  Mechanical Engineering And Design | วิศวกรรมเครื่องกลและการออกแบบ | 机械工程与设计"
    },
    {
        "id":7183,
        "name":"7690 (Thai Program)  :  Interdisciplinary Built Environment | สหวิทยาการสภาพแวดล้อมสรรค์สร้าง | 跨学科的建筑环境"
    },
    {
        "id":7184,
        "name":"7691 (Thai Program)  :  International Studies | วิเทศคดีศึกษา | 国际研究"
    },
    {
        "id":7185,
        "name":"7692 (English Program)  :  International Studies | การศึกษานานาชาติ | 国际研究"
    },
    {
        "id":7186,
        "name":"7693 (Thai Program)  :  Creative Digital Technology | เทคโนโลยีดิจิทัลแนวสร้างสรรค์ | 创意数码科技"
    },
    {
        "id":7187,
        "name":"7694 (English Program)  :  Creative Digital Technology | เทคโนโลยีดิจิทัลที่สร้างสรรค์ | 创意数字技术"
    },
    {
        "id":7188,
        "name":"7695 (Thai Program)  :  Microbiology And Microbial Technology | จุลชีววิทยาและเทคโนโลยีจุลินทรีย์ | 微生物学和微生物技术"
    },
    {
        "id":7189,
        "name":"7696 (Thai Program)  :  Strategic Leadership Excellence | ภาวะผู้นำเชิงยุทธศาสตร์ความเป็นเลิศ | 卓越战略领导力"
    },
    {
        "id":7190,
        "name":"7697 (English Program)  :  Strategic Leadership Supremacy | ความเป็นผู้นำเชิงกลยุทธ์ที่มีอำนาจสูงสุด | 战略领导力至上"
    },
    {
        "id":7191,
        "name":"7698 (Thai Program)  :  New Government Management | การจัดการภาครัฐแนวใหม่ | 新政府管理"
    },
    {
        "id":7192,
        "name":"7699 (Thai Program)  :  Sanskrit Studies | สันสกฤตศึกษา | 梵文研究"
    },
    {
        "id":7193,
        "name":"7700 (English Program)  :  Sanskrit Studies | การศึกษาภาษาสันสกฤต | 梵文研究"
    },
    {
        "id":7194,
        "name":"7701 (Thai Program)  :  Mold Technology | เทคโนโลยีแม่พิมพ์ | 模具技术"
    },
    {
        "id":7195,
        "name":"7702 (Thai Program)  :  Business Innovation | นวัตกรรมธุรกิจ | 商业创新"
    },
    {
        "id":7196,
        "name":"7703 (Thai Program)  :  Design Management, Business And Technology | การจัดการออกแบบ ธุรกิจ และเทคโนโลยี | 设计管理、商业和技术"
    },
    {
        "id":7197,
        "name":"7704 (Thai Program)  :  Global Business Management | การจัดการธุรกิจโลก | 全球业务管理"
    },
    {
        "id":7198,
        "name":"7705 (Thai Program)  :  Public Relations And Mass Media Management | การบริหารการประชาสัมพันธ์และสื่อมวลชน | 公共关系和大众媒体管理"
    },
    {
        "id":7199,
        "name":"7706 (Thai Program)  :  Geriatric Dentistry | ทันตกรรมผู้สูงอายุ | 老年牙科"
    },
    {
        "id":7200,
        "name":"7707 (Thai Program)  :  Architecture For Real Estate Development | สถาปัตยกรรม เพื่อการพัฒนาอสังหาริมทรัพย์ | 房地产开发建筑"
    },
    {
        "id":7201,
        "name":"7708 (Thai Program)  :  Business Automation Information | สารสนเทศอัตโนมัติเชิงธุรกิจ | 商业自动化信息"
    },
    {
        "id":7202,
        "name":"7709 (Thai Program)  :  Computer And Telecommunications Engineering | วิศวกรรมคอมพิวเตอร์และโทรคมนาคม | 计算机与电信工程"
    },
    {
        "id":7203,
        "name":"7710 (Thai Program)  :  Forensic Bones | นิติวิทยากระดูก | 法医骨头"
    },
    {
        "id":7204,
        "name":"7711 (Thai Program)  :  Agroforestry | วนเกษตร | 农林业"
    },
    {
        "id":7205,
        "name":"7712 (Thai Program)  :  Asia Pacific Studies | เอเชียแปซิฟิกศึกษา | 亚太研究"
    },
    {
        "id":7206,
        "name":"7713 (Thai Program)  :  Leadership For Professional Development | ภาวะผู้นำเพื่อพัฒนาวิชาชีพ | 专业发展的领导力"
    },
    {
        "id":7207,
        "name":"7714 (Thai Program)  :  Exhibition And Event Management | การจัดการงานนิทรรศการและงานอีเว้นท์ | 展览及活动管理"
    },
    {
        "id":7208,
        "name":"7715 (Thai Program)  :  Women'S Studies And Gender Studies | สตรีศึกษาและเพศภาวะศึกษา | 妇女研究和性别研究"
    },
    {
        "id":7209,
        "name":"7716 (English Program)  :  Women'S And Gender Studies | การศึกษาสตรีและเพศ | 妇女和性别研究"
    },
    {
        "id":7210,
        "name":"7717 (Thai Program)  :  Biomolecular Science And Engineering | วิทยาศาสตร์และวิศวกรรมชีวโมเลกุล | 生物分子科学与工程"
    },
    {
        "id":7211,
        "name":"7718 (English Program)  :  Biomolecular Science And Engineering | วิทยาศาสตร์ชีวโมเลกุลและวิศวกรรมศาสตร์ | 生物分子科学与工程"
    },
    {
        "id":7212,
        "name":"7719 (Thai Program)  :  Science And Information Technology | วิทยาศาสตร์และเทคโนโลยีสารสนเทศ | 科学与信息技术"
    },
    {
        "id":7213,
        "name":"7720 (Thai Program)  :  Social Phytology | พฤฒาวิทยาสังคม | 社会植物学"
    },
    {
        "id":7214,
        "name":"7721 (English Program)  :  Social Gerontology | ผู้สูงอายุทางสังคม | 社会老年学"
    },
    {
        "id":7215,
        "name":"7722 (Thai Program)  :  Luxury Brand Management | การจัดการตราสินค้าหรูหรา | 奢侈品牌管理"
    },
    {
        "id":7216,
        "name":"7723 (English Program)  :  Luxury Brand Management | การจัดการแบรนด์หรู | 奢侈品牌管理"
    },
    {
        "id":7217,
        "name":"7724 (English Program)  :  Mold And Die Technology | เทคโนโลยีแม่พิมพ์และแม่พิมพ์ | 模具技术"
    },
    {
        "id":7218,
        "name":"7725 (Thai Program)  :  Asean Studies | อาเซียนศึกษา | 东盟研究"
    },
    {
        "id":7219,
        "name":"7726 (English Program)  :  Asean Studies | อาเซียนศึกษา | 东盟研究"
    },
    {
        "id":7220,
        "name":"7727 (Thai Program)  :  Astronomy | ดาราศาสตร์ | 天文学"
    },
    {
        "id":7221,
        "name":"7728 (Thai Program)  :  Intellectual Property And Innovation Management | การจัดการทรัพย์สินทางปัญญาและนวัตกรรม | 知识产权与创新管理"
    },
    {
        "id":7222,
        "name":"7729 (English Program)  :  Intellectual Property And Innovation Management | การจัดการทรัพย์สินทางปัญญาและนวัตกรรม | 知识产权与创新管理"
    },
    {
        "id":7223,
        "name":"7730 (Thai Program)  :  Preserve Fine Arts | อนุรักษ์ศิลปกรรม | 保护美术"
    },
    {
        "id":7224,
        "name":"7731 (Thai Program)  :  High School | มัธยมศึกษาตอนปลาย | 中学"
    },
    {
        "id":7225,
        "name":"7732 (Thai Program)  :  Junior High School | มัธยมศึกษาตอนต้น | 初中"
    },
    {
        "id":7226,
        "name":"7733 (Thai Program)  :  Industrial Electrical Engineering | วิศวกรรมไฟฟ้าอุตสาหการ | 工业电气工程"
    },
    {
        "id":7227,
        "name":"7734 (Thai Program)  :  Digital Innovation | นวัตกรรมดิจิทัล | 数字创新"
    },
    {
        "id":7228,
        "name":"7735 (Thai Program)  :  Digital Business Technology | เทคโนโลยีธุรกิจดิจิทัล | 数字商业技术"
    },
    {
        "id":7229,
        "name":"7736 (Thai Program)  :  Smart Grid Technology | สมาร์ตกริดเทคโนโลยี | 智能电网技术"
    },
    {
        "id":7230,
        "name":"7737 (English Program)  :  Smart Grid Technology | เทคโนโลยีสมาร์ทกริด | 智能电网技术"
    },
    {
        "id":7231,
        "name":"7738 (English Program)  :  Communication Innovation | นวัตกรรมการสื่อสาร | 通讯创新"
    },
    {
        "id":7232,
        "name":"7739 (Thai Program)  :  Smart Farm Engineering | วิศวกรรมฟาร์มอัจฉริยะ | 智慧农场工程"
    },
    {
        "id":7233,
        "name":"7740 (English Program)  :  Smart Farm Engineering | วิศวกรรมฟาร์มอัจฉริยะ | 智能农场工程"
    },
    {
        "id":7234,
        "name":"7741 (Thai Program)  :  Digital Content Creation | การสร้างสรรค์คอนเทนต์ดิจิทัล | 数字内容创作"
    },
    {
        "id":7235,
        "name":"7742 (English Program)  :  Digital Content Creation | การสร้างเนื้อหาดิจิทัล | 数字内容创作"
    },
    {
        "id":7236,
        "name":"7743 (Thai Program)  :  Integrating The Digital Industry | บูรณาการอุตสาหกรรมดิจิทัล | 整合数字产业"
    },
    {
        "id":7237,
        "name":"7744 (English Program)  :  Digital Industry Integration | การบูรณาการอุตสาหกรรมดิจิทัล | 数字产业整合"
    },
    {
        "id":7238,
        "name":"7745 (Thai Program)  :  Digital Innovation And Financial Technology | นวัตกรรมดิจิทัลและเทคโนโลยีการเงิน | 数字创新与金融科技"
    },
    {
        "id":7239,
        "name":"7746 (English Program)  :  Digital Innovation And Financial Technology | นวัตกรรมดิจิทัลและเทคโนโลยีทางการเงิน | 数字创新与金融科技"
    },
    {
        "id":7240,
        "name":"7747 (English Program)  :  Tipitaka Studies | การศึกษาพระไตรปิฎก | 三藏研究"
    },
    {
        "id":7241,
        "name":"7748 (Thai Program)  :  International Medicine | เวชศาสตร์ปริวรรต | 国际医学"
    },
    {
        "id":7242,
        "name":"7749 (English Program)  :  Translational Medicine | ยาแปล | 转化医学"
    },
    {
        "id":7243,
        "name":"7750 (Thai Program)  :  Color Technology And Design | เทคโนโลยีสีและการออกแบบ | 色彩技术与设计"
    },
    {
        "id":7244,
        "name":"7751 (English Program)  :  Color Technology And Design | เทคโนโลยีสีและการออกแบบ | 色彩技术与设计"
    },
    {
        "id":7245,
        "name":"7752 (Thai Program)  :  Human Resource Development And Innovative Food Products | การพัฒนาทรัพยากรมนุษย์และผลิตภัณฑ์นวัตกรรมอาหาร | 人力资源开发和创新食品"
    },
    {
        "id":7246,
        "name":"7753 (English Program)  :  Human Resources Development And Food Innovation Products | การพัฒนาทรัพยากรมนุษย์และผลิตภัณฑ์นวัตกรรมอาหาร | 人力资源开发和食品创新产品"
    },
    {
        "id":7247,
        "name":"7754 (Thai Program)  :  Social Innovation And Sustainability | นวัตกรรมทางสังคมและความยั่งยืน | 社会创新和可持续发展"
    },
    {
        "id":7248,
        "name":"7755 (English Program)  :  Social Innovation And Sustainability | นวัตกรรมทางสังคมและความยั่งยืน | 社会创新与可持续发展"
    },
    {
        "id":7249,
        "name":"7756 (Thai Program)  :  Trade Innovation Management | การจัดการนวัตกรรมการค้า | 贸易创新管理"
    },
    {
        "id":7250,
        "name":"7757 (English Program)  :  Trading Innovation Management | การจัดการนวัตกรรมการซื้อขาย | 贸易创新管理"
    },
    {
        "id":7251,
        "name":"7758 (Thai Program)  :  Materials Science And Innovation | วิทยาการวัสดุและนวัตกรรม | 材料科学与创新"
    },
    {
        "id":7252,
        "name":"7759 (English Program)  :  Materials Science And Innovation | วัสดุศาสตร์และนวัตกรรม | 材料科学与创新"
    },
    {
        "id":7253,
        "name":"7760 (Thai Program)  :  Multimedia Architecture | มัลติมีเดียสถาปัตยกรรม | 多媒体架构"
    },
    {
        "id":7254,
        "name":"7761 (English Program)  :  Multimedia Architecture | สถาปัตยกรรมมัลติมีเดีย | 多媒体架构"
    },
    {
        "id":7255,
        "name":"7762 (Thai Program)  :  Managing Business Innovation And Modern Technology | การจัดการนวัตกรรมธุรกิจและเทคโนโลยีสมัยใหม่ | 管理业务创新和现代技术"
    },
    {
        "id":7256,
        "name":"7763 (English Program)  :  Modern Business Innovation And Technology Management | นวัตกรรมธุรกิจสมัยใหม่และการจัดการเทคโนโลยี | 现代商业创新与技术管理"
    },
    {
        "id":7257,
        "name":"7764 (Thai Program)  :  Logistics And Supply Chain | โลจิสติกส์และโซ่อุปทาน | 物流与供应链"
    },
    {
        "id":7258,
        "name":"7765 (English Program)  :  Logistics And Supply Chain | โลจิสติกส์และห่วงโซ่อุปทาน | 物流和供应链"
    },
    {
        "id":7259,
        "name":"7766 (Thai Program)  :  Biotechnology For Aquatic Animal Production | เทคโนโลยีชีวภาพสำหรับการผลิตสัตว์น้ำ | 水产动物生产生物技术"
    },
    {
        "id":7260,
        "name":"7767 (English Program)  :  Biotechnology For Aquaculture | เทคโนโลยีชีวภาพเพื่อการเพาะเลี้ยงสัตว์น้ำ | 水产养殖生物技术"
    },
    {
        "id":7261,
        "name":"7768 (Thai Program)  :  Sustainable Architecture And The Environment | สถาปัตยกรรมยั่งยืนและสิ่งแวดล้อม | 可持续建筑与环境"
    },
    {
        "id":7262,
        "name":"7769 (English Program)  :  Sustainable Architecture And Environment | สถาปัตยกรรมและสิ่งแวดล้อมที่ยั่งยืน | 可持续建筑与环境"
    },
    {
        "id":7263,
        "name":"7770 (Thai Program)  :  Corporate Finance Investment And Risk Management | การเงินองค์กร การลงทุนและการบริหารความเสี่ยง | 企业融资投资与风险管理"
    },
    {
        "id":7264,
        "name":"7771 (English Program)  :  Corporate Finance, And Risk Management | การเงินองค์กรและการบริหารความเสี่ยง | 公司财务和风险管理"
    },
    {
        "id":7265,
        "name":"7772 (Thai Program)  :  Pharmaceutical And Health Sciences | วิทยาศาสตร์เภสัชกรรมและสุขภาพ | 制药与健康科学"
    },
    {
        "id":7266,
        "name":"7773 (English Program)  :  Pharmaceutical And Health Sciences | เภสัชศาสตร์และวิทยาศาสตร์สุขภาพ | 制药和健康科学"
    },
    {
        "id":7267,
        "name":"7774 (Thai Program)  :  Concert And Multimedia Engineering | วิศวกรรมคอนเสิร์ตและมัลติมีเดีย | 音乐会和多媒体工程"
    },
    {
        "id":7268,
        "name":"7775 (English Program)  :  Concert Engineering And Multimedia | วิศวกรรมคอนเสิร์ตและมัลติมีเดีย | 音乐会工程和多媒体"
    },
    {
        "id":7269,
        "name":"7776 (Thai Program)  :  Data Science And Artificial Intelligence | วิทยาศาสตร์ข้อมูลและปัญญาประดิษฐ์ | 数据科学与人工智能"
    },
    {
        "id":7270,
        "name":"7777 (English Program)  :  Data Science And Artificial Intelligence | วิทยาศาสตร์ข้อมูลและปัญญาประดิษฐ์ | 数据科学和人工智能"
    },
    {
        "id":7271,
        "name":"7778 (Thai Program)  :  The Science Of Anti-Aging And Restoring Health | วิทยาการชะลอวัยและฟื้นฟูสุขภาพ | 抗衰老和恢复健康的科学"
    },
    {
        "id":7272,
        "name":"7779 (Thai Program)  :  Agricultural Innovation And Management | นวัตกรรมการเกษตรและการจัดการ | 农业创新与管理"
    },
    {
        "id":7273,
        "name":"7780 (English Program)  :  Agricultural Innovation And Management | นวัตกรรมและการจัดการการเกษตร | 农业创新与管理"
    },
    {
        "id":7274,
        "name":"7781 (Thai Program)  :  Mechanical Engineering And Robotics | วิศวกรรมเครื่องกลและหุ่นยนต์ | 机械工程和机器人"
    },
    {
        "id":7275,
        "name":"7782 (English Program)  :  Mechanical And Robotic Engineering | วิศวกรรมเครื่องกลและหุ่นยนต์ | 机械和机器人工程"
    },
    {
        "id":7276,
        "name":"7783 (English Program)  :  Educational Administrative Innovation | นวัตกรรมการบริหารการศึกษา | 教育行政创新"
    },
    {
        "id":7277,
        "name":"7784 (Thai Program)  :  Educational Administration Innovation | นวัตกรรมการบริหารการศึกษา | 教育行政创新"
    },
    {
        "id":7278,
        "name":"7785 (Thai Program)  :  Digital Communication Arts | นิเทศศาสตร์ดิจิทัล | 数字传播艺术"
    },
    {
        "id":7279,
        "name":"7786 (Thai Program)  :  Digital Content Creation Management | การจัดการสร้างสรรค์ดิจิทัลคอนเทนต์ | 数字内容创作管理"
    },
    {
        "id":7280,
        "name":"7787 (English Program)  :  Digital Content Creation Management | การจัดการการสร้างเนื้อหาดิจิทัล | 数字内容创建管理"
    },
    {
        "id":7281,
        "name":"7788 (Thai Program)  :  Administrative Law And Public Administration | กฎหมายปกครองและการบริหารงานภาครัฐ | 行政法和公共行政"
    },
    {
        "id":7282,
        "name":"7789 (English Program)  :  Administrative Law And Public Administration | กฎหมายปกครองและการบริหารราชการ | 行政法和公共行政"
    },
    {
        "id":7283,
        "name":"7790 (Thai Program)  :  Computer Engineering And Financial Technology | วิศวกรรมคอมพิวเตอร์และเทคโนโลยีการเงิน | 计算机工程与金融技术"
    },
    {
        "id":7284,
        "name":"7791 (English Program)  :  Computer Engineering And Financial Technology | วิศวกรรมคอมพิวเตอร์และเทคโนโลยีทางการเงิน | 计算机工程和金融技术"
    },
    {
        "id":7285,
        "name":"7792 (Thai Program)  :  Business Administration And Digital Innovation | บริหารธุรกิจและนวัตกรรมดิจิทัล | 工商管理和数字创新"
    },
    {
        "id":7286,
        "name":"7793 (English Program)  :  Business Administration And Digital | การบริหารธุรกิจและดิจิทัล | 工商管理和数字化"
    },
    {
        "id":7287,
        "name":"7794 (Thai Program)  :  Interdisciplinary Technology And Innovation | สหวิทยาการ เทคโนโลยีและนวัตกรรม | 跨学科技术与创新"
    },
    {
        "id":7288,
        "name":"7795 (English Program)  :  Interdisciplinary Technology And Innovation | เทคโนโลยีและนวัตกรรมแบบสหวิทยาการ | 跨学科技术与创新"
    },
    {
        "id":7289,
        "name":"7796 (Thai Program)  :  Digital Governance For Sustainability | ธรรมาภิบาลดิจิทัลเพื่อความยั่งยืน | 可持续发展的数字治理"
    },
    {
        "id":7290,
        "name":"7797 (English Program)  :  Digital Governance For Sustainability | ธรรมาภิบาลดิจิทัลเพื่อความยั่งยืน | 可持续发展的数字治理"
    },
    {
        "id":7291,
        "name":"7798 (English Program)  :  Industrial Electrical Engineering | วิศวกรรมไฟฟ้าอุตสาหกรรม | 工业电气工程"
    },
    {
        "id":7292,
        "name":"7799 (Thai Program)  :  Industrial Electrical Engineering | วิศวกรรมไฟฟ้าอุตสาหกรรม | 工业电气工程"
    },
    {
        "id":7293,
        "name":"7800 (English Program)  :  Traditional Chinese Medicine Internal Medicine | อายุรกรรมการแพทย์แผนจีน | 中医内科"
    },
    {
        "id":7294,
        "name":"7801 (English Program)  :  Psychiatric And Mental Health Nursing | การพยาบาลจิตเวชและสุขภาพจิต | 精神科和心理健康护理"
    },
    {
        "id":7295,
        "name":"7802 (Thai Program)  :  Philosophy, Religion And Culture | ปรัชญา ศาสนาและวัฒนธรรม | 哲学、宗教与文化"
    },
    {
        "id":7296,
        "name":"7803 (English Program)  :  Philosophy, Religions And Cultures | ปรัชญา ศาสนา และวัฒนธรรม | 哲学、宗教和文化"
    },
    {
        "id":7297,
        "name":"7804 (Thai Program)  :  Creative Industry Management | การจัดการอุตสาหกรรมสร้างสรรค์ | 创意产业管理"
    },
    {
        "id":7298,
        "name":"7805 (English Program)  :  Creative Industries Management | การจัดการอุตสาหกรรมสร้างสรรค์ | 创意产业管理"
    },
    {
        "id":7299,
        "name":"7806 (Thai Program)  :  Sociology According To Buddhist Principles | สังคมวิทยาตามแนวพุทธศาสตร์ | 根据佛教原理的社会学"
    },
    {
        "id":7300,
        "name":"7807 (English Program)  :  Buddhistic Sociology | สังคมวิทยาพุทธศาสนา | 佛教社会学"
    },
    {
        "id":7301,
        "name":"7808 (English Program)  :  Teaching Buddhism | การสอนพุทธศาสนา | 传授佛法"
    },
    {
        "id":7302,
        "name":"7809 (Thai Program)  :  Educational Quality Management And Development | การบริหารและพัฒนาคุณภาพการศึกษา | 教育质量管理与发展"
    },
    {
        "id":7303,
        "name":"7810 (English Program)  :  Educational Administration And Quality Development | การบริหารการศึกษาและการพัฒนาคุณภาพ | 教育管理和质量发展"
    },
    {
        "id":7304,
        "name":"7811 (Thai Program)  :  Coastal Aquaculture | การเพาะเลี้ยงสัตว์น้ำชายฝั่ง | 沿海水产养殖"
    },
    {
        "id":7305,
        "name":"7812 (English Program)  :  Coastal Aquaculture | การเพาะเลี้ยงสัตว์น้ำชายฝั่ง | 沿海水产养殖"
    },
    {
        "id":7306,
        "name":"7813 (Thai Program)  :  Integrated Tourism | การท่องเที่ยวเชิงบูรณาการ | 综合旅游"
    },
    {
        "id":7307,
        "name":"7814 (English Program)  :  Integrated Tourism | การท่องเที่ยวเชิงบูรณาการ | 综合旅游"
    },
    {
        "id":7308,
        "name":"7815 (Thai Program)  :  Fashion Business Entrepreneur | ผู้ประกอบการธุรกิจแฟชั่น | 时尚商业企业家"
    },
    {
        "id":7309,
        "name":"7816 (Thai Program)  :  Artistic Arrangement | การจัดการทางศิลปะ | 艺术布置"
    },
    {
        "id":7310,
        "name":"7817 (Thai Program)  :  Smart City Management And Digital Innovation | การจัดการสมาร์ตซิตี้และนวัตกรรมดิจิทัล | 智慧城市管理与数字创新"
    },
    {
        "id":7311,
        "name":"7818 (English Program)  :  Smart City Management And Digital Innovation | การจัดการเมืองอัจฉริยะและนวัตกรรมดิจิทัล | 智慧城市管理与数字创新"
    },
    {
        "id":7312,
        "name":"7819 (Thai Program)  :  Aircraft Maintenance Engineering | วิศวกรรมซ่อมบำรุงอากาศยาน | 飞机维修工程"
    },
    {
        "id":7313,
        "name":"7820 (English Program)  :  Aircraft Maintenance Engineering | วิศวกรรมการบำรุงรักษาอากาศยาน | 飞机维修工程"
    },
    {
        "id":7314,
        "name":"7821 (Thai Program)  :  Agriculture And Processing | เกษตรและการแปรรูป | 农业及加工"
    },
    {
        "id":7315,
        "name":"7822 (English Program)  :  Agriculture And Product Processing | การเกษตรและการแปรรูปผลิตภัณฑ์ | 农业和产品加工"
    },
    {
        "id":7316,
        "name":"7823 (Thai Program)  :  Organic Agriculture Innovation | นวัตกรรมเกษตรอินทรีย์ | 有机农业创新"
    },
    {
        "id":7317,
        "name":"7824 (English Program)  :  Organic Agriculture Innovation | นวัตกรรมเกษตรอินทรีย์ | 有机农业创新"
    },
    {
        "id":7318,
        "name":"7825 (Thai Program)  :  Sports Coaching Science | วิทยาศาสตร์การฝึกสอนกีฬา | 运动训练科学"
    },
    {
        "id":7319,
        "name":"7826 (English Program)  :  Sports Coaching Science | วิทยาศาสตร์การฝึกสอนกีฬา | 运动教练科学"
    },
    {
        "id":7320,
        "name":"7827 (English Program)  :  Sports And Exercise Science | วิทยาศาสตร์การกีฬาและการออกกำลังกาย | 运动与运动科学"
    },
    {
        "id":7321,
        "name":"7828 (Thai Program)  :  Producing Creative Content And Digital Experiences | การผลิตเนื้อหาสร้างสรรค์และประสบการณ์ดิจิทัล | 制作创意内容和数字体验"
    },
    {
        "id":7322,
        "name":"7829 (English Program)  :  Creative Content Production And Digital Experience | การผลิตเนื้อหาที่สร้างสรรค์และประสบการณ์ดิจิทัล | 创意内容制作和数字体验"
    },
    {
        "id":7323,
        "name":"7830 (Thai Program)  :  Industrial Toxicology And Risk Assessment | พิษวิทยาอุตสาหกรรมและการประเมินความเสี่ยง | 工业毒理学和风险评估"
    },
    {
        "id":7324,
        "name":"7831 (English Program)  :  Industrial Toxicology And Risk Assessment | พิษวิทยาทางอุตสาหกรรมและการประเมินความเสี่ยง | 工业毒理学和风险评估"
    },
    {
        "id":7325,
        "name":"7832 (Thai Program)  :  Robotics Engineering And Artificial Intelligence | วิศวกรรมหุ่นยนต์และปัญญาประดิษฐ์ | 机器人工程与人工智能"
    },
    {
        "id":7326,
        "name":"7833 (English Program)  :  Robotics And Artificial Intelligence Engineering | วิศวกรรมหุ่นยนต์และปัญญาประดิษฐ์ | 机器人与人工智能工程"
    },
    {
        "id":7327,
        "name":"7834 (Thai Program)  :  Innovation Engineering And Management | วิศวกรรมและการจัดการนวัตกรรม | 创新工程与管理"
    },
    {
        "id":7328,
        "name":"7835 (English Program)  :  Innovation Engineering And Management | วิศวกรรมนวัตกรรมและการจัดการ | 创新工程与管理"
    },
    {
        "id":7329,
        "name":"7836 (Thai Program)  :  Social Media Technology | เทคโนโลยีสื่อสังคม | 社交媒体技术"
    },
    {
        "id":7330,
        "name":"7837 (English Program)  :  Social Media Technology | เทคโนโลยีโซเชียลมีเดีย | 社交媒体技术"
    },
    {
        "id":7331,
        "name":"7838 (Thai Program)  :  Science And Technology Learning Management Science | วิทยาการจัดการเรียนรู้วิทยาศาสตร์และเทคโนโลยี | 科技学习管理科学"
    },
    {
        "id":7332,
        "name":"7839 (English Program)  :  Teaching Science And Technology | การสอนวิทยาศาสตร์และเทคโนโลยี | 科学技术教学"
    },
    {
        "id":7333,
        "name":"7840 (Thai Program)  :  Automated Agricultural Machinery Technology | เทคโนโลยีเครื่องจักรกลการเกษตรอัตโนมัติ | 自动化农机技术"
    },
    {
        "id":7334,
        "name":"7841 (English Program)  :  Automatic Agricultural Machinery Technology | เทคโนโลยีเครื่องจักรการเกษตรอัตโนมัติ | 自动化农业机械技术"
    },
    {
        "id":7335,
        "name":"7842 (Thai Program)  :  Applied Science | วิทยาศาสตร์ประยุกต์ | 应用科学"
    },
    {
        "id":7336,
        "name":"7843 (English Program)  :  Applied Sciences | วิทยาศาสตร์ประยุกต์ | 应用科学"
    },
    {
        "id":7337,
        "name":"7844 (Thai Program)  :  Digital Economy | เศรษฐกิจดิจิทัล | 数字经济"
    },
    {
        "id":7338,
        "name":"7845 (English Program)  :  Digital Economy | เศรษฐกิจดิจิทัล | 数字经济"
    },
    {
        "id":7339,
        "name":"7846 (English Program)  :  Business Administration And Digital Innovation | การบริหารธุรกิจและนวัตกรรมดิจิทัล | 工商管理和数字创新"
    },
    {
        "id":7340,
        "name":"7847 (Thai Program)  :  Digital Media Technology | เทคโนโลยีดิจิทัลมีเดีย | 数字媒体技术"
    },
    {
        "id":7341,
        "name":"7848 (English Program)  :  Digital Media Technology | เทคโนโลยีสื่อดิจิทัล | 数字媒体技术"
    },
    {
        "id":7342,
        "name":"7849 (Thai Program)  :  Nutrition Therapy And Dietetics | โภชนบำบัดและการกำหนดอาหาร | 营养治疗和饮食学"
    },
    {
        "id":7343,
        "name":"7850 (English Program)  :  Nutritional Therapy And Dietetics | การบำบัดทางโภชนาการและการควบคุมอาหาร | 营养治疗和饮食学"
    },
    {
        "id":7344,
        "name":"7851 (Thai Program)  :  Mechanical Engineeringmanufacturing | วิศวกรรมเครื่องกลการผลิต | 机械工程制造"
    },
    {
        "id":7345,
        "name":"7852 (English Program)  :  Mechanical-Manufacturing Engineering | วิศวกรรมเครื่องกล-การผลิต | 机械制造工程"
    },
    {
        "id":7346,
        "name":"7853 (Thai Program)  :  Urban Strategy | ยุทธศาสตร์เมือง | 城市战略"
    },
    {
        "id":7347,
        "name":"7854 (English Program)  :  Urban Strategies | กลยุทธ์เมือง | 城市战略"
    },
    {
        "id":7348,
        "name":"7855 (Thai Program)  :  Automation Technology And Robots | เทคโนโลยีอัตโนมัติและหุ่นยนต์ | 自动化技术和机器人"
    },
    {
        "id":7349,
        "name":"7856 (English Program)  :  Automation And Robotics Technologies | เทคโนโลยีอัตโนมัติและหุ่นยนต์ | 自动化和机器人技术"
    },
    {
        "id":7350,
        "name":"7857 (Thai Program)  :  Service Business Innovation | นวัตกรรมธุรกิจบริการ | 服务业创新"
    },
    {
        "id":7351,
        "name":"7858 (English Program)  :  Service Business Innovation | นวัตกรรมธุรกิจบริการ | 服务商业创新"
    },
    {
        "id":7352,
        "name":"7859 (Thai Program)  :  Artificial Intelligence Engineering And Data Science | วิศวกรรมปัญญาประดิษฐ์และวิทยาการข้อมูล | 人工智能工程与数据科学"
    },
    {
        "id":7353,
        "name":"7860 (English Program)  :  Artificial Intelligence Engineering And Data Science | วิศวกรรมปัญญาประดิษฐ์และวิทยาศาสตร์ข้อมูล | 人工智能工程和数据科学"
    },
    {
        "id":7354,
        "name":"7861 (English Program)  :  Applied Artificial Intelligence And Smart Technology | ปัญญาประดิษฐ์ประยุกต์และเทคโนโลยีอัจฉริยะ | 应用人工智能与智能技术"
    },
    {
        "id":7355,
        "name":"7862 (Thai Program)  :  Applied Artificial Intelligence And Intelligent Technology | ปัญญาประดิษฐ์ประยุกต์และเทคโนโลยีอัจฉริยะ | 应用人工智能和智能技术"
    },
    {
        "id":7356,
        "name":"7863 (Thai Program)  :  Halal Cooking | การประกอบอาหารฮาลาล | 清真烹饪"
    },
    {
        "id":7357,
        "name":"7864 (English Program)  :  Halal Culinary | การทำอาหารฮาลาล | 清真美食"
    },
    {
        "id":7358,
        "name":"7865 (English Program)  :  Innovative Trading Management | การจัดการการซื้อขายที่เป็นนวัตกรรมใหม่ | 创新的交易管理"
    },
    {
        "id":7359,
        "name":"7866 (English Program)  :  Elementary Education – Psychology And Guidance | การศึกษาระดับประถมศึกษา – จิตวิทยาและการแนะแนว | 基础教育——心理学和指导"
    },
    {
        "id":7360,
        "name":"7867 (Thai Program)  :  Primary Education – Psychology And Guidance | การประถมศึกษา – จิตวิทยาและการแนะแนว | 初等教育——心理学和指导"
    },
    {
        "id":7361,
        "name":"7868 (Thai Program)  :  Applied Mathematics And Computational Science | คณิตศาสตร์ประยุกต์และวิทยาการคำนวณ | 应用数学与计算科学"
    },
    {
        "id":7362,
        "name":"7869 (English Program)  :  Applied Mathematics And Computing Science | คณิตศาสตร์ประยุกต์และวิทยาศาสตร์คอมพิวเตอร์ | 应用数学和计算科学"
    },
    {
        "id":7363,
        "name":"7870 (Thai Program)  :  Automation Engineering, Robotics And Artificial Intelligence | วิศวกรรมระบบอัตโนมัติ หุ่นยนต์ และปัญญาประดิษฐ์ | 自动化工程、机器人与人工智能"
    },
    {
        "id":7364,
        "name":"7871 (English Program)  :  Automation Robotics And Intelligent System Engineering | หุ่นยนต์อัตโนมัติและวิศวกรรมระบบอัจฉริยะ | 自动化机器人与智能系统工程"
    },
    {
        "id":7365,
        "name":"7872 (Thai Program)  :  Automated Production Engineering | วิศวกรรมการผลิตอัตโนมัติ | 自动化生产工程"
    },
    {
        "id":7366,
        "name":"7873 (English Program)  :  Automated Manufacturing Engineering | วิศวกรรมการผลิตอัตโนมัติ | 自动化制造工程"
    },
    {
        "id":7367,
        "name":"7874 (Thai Program)  :  Interdisciplinary Veterinary Medicine | สหวิทยาการสัตวแพทย์ | 跨学科兽医学"
    },
    {
        "id":7368,
        "name":"7875 (Thai Program)  :  Food Safety And Quality Management | ความปลอดภัยและการจัดการคุณภาพของอาหาร | 食品安全和质量管理"
    },
    {
        "id":7369,
        "name":"7876 (English Program)  :  Food Safety And Quality Management | ความปลอดภัยด้านอาหารและการจัดการคุณภาพ | 食品安全和质量管理"
    },
    {
        "id":7370,
        "name":"7877 (Thai Program)  :  Veterinary Biomedicine | ชีวเวชศาสตร์ทางสัตวแพทย์ | 兽医生物医学"
    },
    {
        "id":7371,
        "name":"7878 (English Program)  :  Veterinary Biomedcal Sciences | วิทยาศาสตร์ชีวการแพทย์ทางสัตวแพทย์ | 兽医生物医学科学"
    },
    {
        "id":7372,
        "name":"7879 (Thai Program)  :  Product Design And Development | การออกแบบและพัฒนาผลิตภัณฑ์ | 产品设计与开发"
    },
    {
        "id":7373,
        "name":"7880 (English Program)  :  Product Design And Development | การออกแบบและพัฒนาผลิตภัณฑ์ | 产品设计与开发"
    },
    {
        "id":7374,
        "name":"7881 (Thai Program)  :  Pharmaceutical And Cosmetic Innovation | นวัตกรรมยาและเครื่องสำอาง | 制药和化妆品创新"
    },
    {
        "id":7375,
        "name":"7882 (English Program)  :  Drug And Cosmetic Innovation | นวัตกรรมยาและเครื่องสำอาง | 药品和化妆品创新"
    },
    {
        "id":7376,
        "name":"7883 (Thai Program)  :  Pharmacy And Technology | เภสัชศาสตร์และเทคโนโลยี | 药学与技术"
    },
    {
        "id":7377,
        "name":"7884 (English Program)  :  Pharmaceutical Sciences And Technology | วิทยาศาสตร์และเทคโนโลยีเภสัชกรรม | 医药科技"
    },
    {
        "id":7378,
        "name":"7885 (Thai Program)  :  Creative Business And Digital Technology | ธุรกิจสร้างสรรค์และเทคโนโลยีดิจิทัล | 创意商业和数字技术"
    },
    {
        "id":7379,
        "name":"7886 (English Program)  :  Creative Business And Digital Technology | ธุรกิจสร้างสรรค์และเทคโนโลยีดิจิทัล | 创意商业和数字技术"
    },
    {
        "id":7380,
        "name":"7887 (Thai Program)  :  Smart City Engineering | วิศวกรรมระบบเมืองอัจฉริยะ | 智慧城市工程"
    },
    {
        "id":7381,
        "name":"7888 (English Program)  :  Smart Urban Systems Engineering | วิศวกรรมระบบเมืองอัจฉริยะ | 智能城市系统工程"
    },
    {
        "id":7382,
        "name":"7889 (Thai Program)  :  Rail Transport System | ระบบขนส่งทางราง | 轨道交通系统"
    },
    {
        "id":7383,
        "name":"7890 (English Program)  :  Railway Transportation System | ระบบขนส่งทางราง | 铁路运输系统"
    },
    {
        "id":7384,
        "name":"7891 (Thai Program)  :  Artificial Intelligence Engineering | วิศวกรรมปัญญาประดิษฐ์ | 人工智能工程"
    },
    {
        "id":7385,
        "name":"7892 (English Program)  :  Artificial Intelligence Engineering | วิศวกรรมปัญญาประดิษฐ์ | 人工智能工程"
    },
    {
        "id":7386,
        "name":"7893 (Thai Program)  :  Industrial Engineering And Management Systems | วิศวกรรมอุตสาหการและระบบการจัดการ | 工业工程和管理系统"
    },
    {
        "id":7387,
        "name":"7894 (English Program)  :  Industrial And Management Systems Engineering | วิศวกรรมระบบอุตสาหกรรมและการจัดการ | 工业与管理系统工程"
    },
    {
        "id":7388,
        "name":"7895 (Thai Program)  :  Conservation And Management Of Cultural Heritage | การอนุรักษ์และการจัดการมรดกทางวัฒนธรรม | 文化遗产的保护和管理"
    },
    {
        "id":7389,
        "name":"7896 (English Program)  :  Cultural Heritage Conservation And Management | การอนุรักษ์และการจัดการมรดกทางวัฒนธรรม | 文化遗产保护与管理"
    },
    {
        "id":7390,
        "name":"7897 (Thai Program)  :  Professional Culinary Arts | ศิลปะการประกอบอาหารอย่างมืออาชีพ | 专业烹饪艺术"
    },
    {
        "id":7391,
        "name":"7898 (English Program)  :  Professional Culinary Arts | ศิลปะการประกอบอาหารระดับมืออาชีพ | 专业烹饪艺术"
    },
    {
        "id":7392,
        "name":"7899 (Thai Program)  :  Innovation In Primary Education Management | นวัตกรรมการจัดการเรียนรู้ประถมศึกษา | 初等教育管理创新"
    },
    {
        "id":7393,
        "name":"7900 (English Program)  :  Learning Management Innovation For Elementary Education | นวัตกรรมการจัดการเรียนรู้สำหรับประถมศึกษา | 基础教育学习管理创新"
    },
    {
        "id":7394,
        "name":"7901 (Thai Program)  :  Sustainable Local Development Management | การบริหารการพัฒนาท้องถิ่นอย่างยั่งยืน | 可持续地方发展管理"
    },
    {
        "id":7395,
        "name":"7902 (English Program)  :  Sustainable Local Development | การพัฒนาท้องถิ่นอย่างยั่งยืน | 当地可持续发展"
    },
    {
        "id":7396,
        "name":"7903 (Thai Program)  :  Managing The Health Of The Elderly In The Community | การจัดการสุขภาวะผู้สูงอายุในชุมชน | 管理社区老年人的健康"
    },
    {
        "id":7397,
        "name":"7904 (English Program)  :  Elderly Health Care Management In Community | การจัดการดูแลสุขภาพผู้สูงอายุในชุมชน | 社区老年人保健管理"
    },
    {
        "id":7398,
        "name":"7905 (Thai Program)  :  Public Innovation Management | การจัดการนวัตกรรมสาธารณะ | 公共创新管理"
    },
    {
        "id":7399,
        "name":"7906 (English Program)  :  Public Innovation Management | การจัดการนวัตกรรมสาธารณะ | 公共创新管理"
    },
    {
        "id":7400,
        "name":"7907 (Thai Program)  :  Chinese For Careers | ภาษาจีนเพื่ออาชีพ | 职业汉语"
    },
    {
        "id":7401,
        "name":"7908 (English Program)  :  Chinese For Careers | ภาษาจีนเพื่ออาชีพ | 职业汉语"
    },
    {
        "id":7402,
        "name":"7909 (Thai Program)  :  Digital Innovation Engineering | วิศวกรรมนวัตกรรมดิจิทัล | 数字化创新工程"
    },
    {
        "id":7403,
        "name":"7910 (English Program)  :  Digital Innovation Engineering | วิศวกรรมนวัตกรรมดิจิทัล | 数字创新工程"
    },
    {
        "id":7404,
        "name":"7911 (Thai Program)  :  Electronic Systems Engineering | วิศวกรรมระบบอิเล็กทรอนิกส์ | 电子系统工程"
    },
    {
        "id":7405,
        "name":"7912 (English Program)  :  Electronic Systems Engineering | วิศวกรรมระบบอิเล็กทรอนิกส์ | 电子系统工程"
    },
    {
        "id":7406,
        "name":"7913 (Thai Program)  :  Research Methodology And Evaluation | วิธีวิทยาการวิจัยและการประเมิน | 研究方法和评估"
    },
    {
        "id":7407,
        "name":"7914 (English Program)  :  Research Methodology And Evaluation | ระเบียบวิธีวิจัยและการประเมินผล | 研究方法与评估"
    },
    {
        "id":7408,
        "name":"7915 (Thai Program)  :  Sign Language Interpreter | ล่ามภาษามือ | 手语翻译员"
    },
    {
        "id":7409,
        "name":"7916 (English Program)  :  Sign Language Interpreter | ล่ามภาษามือ | 手语翻译员"
    },
    {
        "id":7410,
        "name":"7917 (Thai Program)  :  Religion And Wisdom For Development | ศาสนาและภูมิปัญญาเพื่อการพัฒนา | 宗教与发展智慧"
    },
    {
        "id":7411,
        "name":"7918 (English Program)  :  Religion And Wisdom For Development | ศาสนาและภูมิปัญญาเพื่อการพัฒนา | 宗教与发展智慧"
    },
    {
        "id":7412,
        "name":"7919 (Thai Program)  :  Chinese For Industry | ภาษาจีนเพื่ออุตสาหกรรม | 工业汉语"
    },
    {
        "id":7413,
        "name":"7920 (English Program)  :  Chinese For Industry | จีนเพื่ออุตสาหกรรม | 工业汉语"
    },
    {
        "id":7414,
        "name":"7921 (Thai Program)  :  Agricultural And Biotechnology Industries | อุตสาหกรรมเกษตรและเทคโนโลยีชีวภาพ | 农业和生物技术产业"
    },
    {
        "id":7415,
        "name":"7922 (English Program)  :  Agro-Industry And Biotechnology | อุตสาหกรรมเกษตรและเทคโนโลยีชีวภาพ | 农业工业和生物技术"
    },
    {
        "id":7416,
        "name":"7923 (Thai Program)  :  Business And Human Capital Development | การพัฒนาธุรกิจและทุนมนุษย์ | 商业和人力资本发展"
    },
    {
        "id":7417,
        "name":"7924 (English Program)  :  Business And Human Capital Development | การพัฒนาธุรกิจและทุนมนุษย์ | 商业和人力资本发展"
    },
    {
        "id":7418,
        "name":"7925 (Thai Program)  :  Islamic Business Administration | บริหารธุรกิจอิสลาม | 伊斯兰企业管理"
    },
    {
        "id":7419,
        "name":"7926 (English Program)  :  Islamic Business | ธุรกิจอิสลาม | 伊斯兰商业"
    },
    {
        "id":7420,
        "name":"7927 (Thai Program)  :  Molecular Genetics | พันธุศาสตร์โมเลกุล | 分子遗传学"
    },
    {
        "id":7421,
        "name":"7928 (Thai Program)  :  Digital Technology | เทคโนโลยีดิจิทัล | 数字技术"
    },
    {
        "id":7422,
        "name":"7929 (English Program)  :  Digital Technology | เทคโนโลยีดิจิทัล | 数字技术"
    },
    {
        "id":7423,
        "name":"7930 (Thai Program)  :  Chinese For Service Work | ภาษาจีนเพื่องานบริการ | 服务类工作汉语"
    },
    {
        "id":7424,
        "name":"7931 (English Program)  :  Chinese For Service Career | ภาษาจีนเพื่ออาชีพการบริการ | 服务职业汉语"
    },
    {
        "id":7425,
        "name":"7932 (Thai Program)  :  Digital Marketing | การตลาดดิจิทัล | 数字营销"
    },
    {
        "id":7426,
        "name":"7933 (English Program)  :  Digital Marketing | การตลาดดิจิทัล | 数字营销"
    },
    {
        "id":7427,
        "name":"7934 (Thai Program)  :  Communication Management Through Data Analysis | การจัดการการสื่อสารด้วยการวิเคราะห์ข้อมูล | 通过数据分析进行沟通管理"
    },
    {
        "id":7428,
        "name":"7935 (English Program)  :  Communication Management With Data Analytics | การจัดการการสื่อสารด้วยการวิเคราะห์ข้อมูล | 通过数据分析进行通信管理"
    },
    {
        "id":7429,
        "name":"7936 (Thai Program)  :  Science For Industry | วิทยาศาสตร์เพื่ออุตสาหกรรม | 工业科学"
    },
    {
        "id":7430,
        "name":"7937 (English Program)  :  Science For Industry | วิทยาศาสตร์เพื่ออุตสาหกรรม | 科学促进工业"
    },
    {
        "id":7431,
        "name":"7938 (Thai Program)  :  Research And Learning Management Technology | วิจัยและเทคโนโลยีการจัดการเรียนรู้ | 研究和学习管理技术"
    },
    {
        "id":7432,
        "name":"7939 (English Program)  :  Research And Technology In Learning Management | การวิจัยและเทคโนโลยีในการจัดการเรียนรู้ | 学习管理的研究和技术"
    },
    {
        "id":7433,
        "name":"7940 (Thai Program)  :  Management Of Health, Nature And Cultural Tourism | การจัดการการท่องเที่ยวเชิงสุขภาพ ธรรมชาติ และวัฒนธรรม | 健康、自然和文化旅游管理"
    },
    {
        "id":7434,
        "name":"7941 (English Program)  :  Health, Nature, And Cultural Tourism Management | การจัดการการท่องเที่ยวด้านสุขภาพ ธรรมชาติ และวัฒนธรรม | 健康、自然和文化旅游管理"
    },
    {
        "id":7435,
        "name":"7942 (Thai Program)  :  Biomedical Design | ชีวการออกแบบทางการแพทย์ | 生物医学设计"
    },
    {
        "id":7436,
        "name":"7943 (English Program)  :  Biodesign In Medicine | การออกแบบทางชีวภาพในการแพทย์ | 医学生物设计"
    },
    {
        "id":7437,
        "name":"7944 (Thai Program)  :  Management For Entrepreneurs | การจัดการสำหรับผู้ประกอบการ | 企业家管理"
    },
    {
        "id":7438,
        "name":"7945 (Thai Program)  :  Trade Innovation Management | การจัดการนวัตกรรมทางการค้า | 贸易创新管理"
    },
    {
        "id":7439,
        "name":"7946 (English Program)  :  Strategy And Security | กลยุทธ์และความปลอดภัย | 策略与安全"
    },
    {
        "id":7440,
        "name":"7947 (Thai Program)  :  Global Health | สุขภาพโลก | 全球健康"
    },
    {
        "id":7441,
        "name":"7948 (Thai Program)  :  Medical Cannabis | กัญชาเวชศาสตร์ | 医用大麻"
    },
    {
        "id":7442,
        "name":"7949 (English Program)  :  Cannabis Health Science | วิทยาศาสตร์สุขภาพกัญชา | 大麻健康科学"
    },
    {
        "id":7443,
        "name":"7950 (Thai Program)  :  Mathematics And English | คณิตศาสตร์และภาษาอังกฤษ | 数学和英语"
    },
    {
        "id":7444,
        "name":"7951 (English Program)  :  Mathematics And English | คณิตศาสตร์และภาษาอังกฤษ | 数学和英语"
    },
    {
        "id":7445,
        "name":"7952 (English Program)  :  Buddhist Educational Administration | การบริหารการศึกษาพุทธศาสนา | 佛教教育行政机构"
    },
    {
        "id":7446,
        "name":"7953 (Thai Program)  :  Sustainable Leadership | ภาวะผู้นำอย่างยั่งยืน | 可持续领导力"
    },
    {
        "id":7447,
        "name":"7954 (English Program)  :  Sustainable Leadership | ความเป็นผู้นำที่ยั่งยืน | 可持续的领导力"
    },
    {
        "id":7448,
        "name":"7955 (Thai Program)  :  Smart Application | สมาร์ตแอ็ปพลิเคชัน | 智能应用"
    },
    {
        "id":7449,
        "name":"7956 (English Program)  :  Smart Application | แอปพลิเคชันอัจฉริยะ | 智能应用"
    },
    {
        "id":7450,
        "name":"7957 (English Program)  :  Aquaculture Technology | เทคโนโลยีการเพาะเลี้ยงสัตว์น้ำ | 水产养殖技术"
    },
    {
        "id":7451,
        "name":"7958 (Thai Program)  :  Logistics Management And Innovation | การจัดการโลจิสติกส์และนวัตกรรม | 物流管理与创新"
    },
    {
        "id":7452,
        "name":"7959 (English Program)  :  Logistics Management And Innovation | การจัดการโลจิสติกส์และนวัตกรรม | 物流管理与创新"
    },
    {
        "id":7453,
        "name":"7960 (Thai Program)  :  Integrated Marketing Communications | การสื่อสารการตลาดเชิงบูรณาการ | 整合营销传播"
    },
    {
        "id":7454,
        "name":"7961 (Thai Program)  :  Data Science And Applications | วิทยาการข้อมูลและการประยุกต์ | 数据科学与应用"
    },
    {
        "id":7455,
        "name":"7962 (English Program)  :  Data Science And Application | วิทยาศาสตร์ข้อมูลและการประยุกต์ใช้ | 数据科学与应用"
    },
    {
        "id":7456,
        "name":"7963 (Thai Program)  :  Production | การผลิต | 生产"
    },
    {
        "id":7457,
        "name":"7964 (Thai Program)  :  Pharmacotherapy | เภสัชบำบัด | 药物治疗"
    },
    {
        "id":7458,
        "name":"7965 (English Program)  :  Pharmacotherapy | เภสัชบำบัด | 药物治疗"
    },
    {
        "id":7459,
        "name":"7966 (Thai Program)  :  Science Of The Land For Sustainable Development | ศาสตร์แห่งแผ่นดินเพื่อการพัฒนาที่ยั่งยืน | 土地科学促进可持续发展"
    },
    {
        "id":7460,
        "name":"7967 (English Program)  :  Knowledge Of The Land For Sustainable Development | ความรู้เรื่องที่ดินเพื่อการพัฒนาที่ยั่งยืน | 可持续发展的土地知识"
    },
    {
        "id":7461,
        "name":"7968 (Thai Program)  :  Lifelong Learning | การเรียนรู้ตลอดชีวิต | 终身学习"
    },
    {
        "id":7462,
        "name":"7969 (English Program)  :  Lifelong Learning | การเรียนรู้ตลอดชีวิต | 终身学习"
    },
    {
        "id":7463,
        "name":"7970 (Thai Program)  :  Mechatronics And Robotics | เมคคาทรอนิกส์และวิทยาการหุ่นยนต์ | 机电一体化和机器人技术"
    },
    {
        "id":7464,
        "name":"7971 (Thai Program)  :  Electrical System Maintenance Technician In Rail Transportation Systems | ช่างบำรุงรักษาระบบไฟฟ้าในระบบขนส่งทางราง | 轨道交通系统电气系统维护技术员"
    },
    {
        "id":7465,
        "name":"7972 (Thai Program)  :  Rail Transport Technician | ช่างเทคนิคระบบขนส่งทางราง | 轨道交通技术员"
    },
    {
        "id":7466,
        "name":"7973 (Thai Program)  :  Business Management And Sports Technology | การจัดการธุรกิจและเทคโนโลยีการกีฬา | 商业管理和体育技术"
    },
    {
        "id":7467,
        "name":"7974 (English Program)  :  Sport Business And Technology Management | การจัดการธุรกิจกีฬาและเทคโนโลยี | 体育商业与技术管理"
    },
    {
        "id":7468,
        "name":"7975 (Thai Program)  :  Innovation In Learning Measurement | นวัตกรรมทางการวัดผลการเรียนรู้ | 学习测量的创新"
    },
    {
        "id":7469,
        "name":"7976 (English Program)  :  Innovation Of Learning Measurement | นวัตกรรมการวัดการเรียนรู้ | 学习测量的创新"
    },
    {
        "id":7470,
        "name":"7977 (English Program)  :  Factory Mechanic | ช่างโรงงาน | 工厂机械师"
    },
    {
        "id":7471,
        "name":"7978 (Thai Program)  :  Embedded System Technology | เทคโนโลยีระบบสมองกลฝังตัว | 嵌入式系统技术"
    },
    {
        "id":7472,
        "name":"7979 (English Program)  :  Embedded System | ระบบฝังตัว | 嵌入式系统"
    },
    {
        "id":7473,
        "name":"7980 (English Program)  :  Production Techniques | เทคนิคการผลิต | 生产技术"
    },
    {
        "id":7474,
        "name":"7981 (English Program)  :  Mechatronics And Robotics | เมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人"
    },
    {
        "id":7475,
        "name":"7982 (English Program)  :  Power Electrics | ไฟฟ้ากำลัง | 电力电气"
    },
    {
        "id":7476,
        "name":"7983 (English Program)  :  Thai For Foreigners | ภาษาไทยสำหรับชาวต่างชาติ | 外国人泰语"
    },
    {
        "id":7477,
        "name":"7984 (Thai Program)  :  Digital Innovation And Media Arts | นวัตกรรมดิจิทัลและสื่อศิลป์ | 数字创新和媒体艺术"
    },
    {
        "id":7478,
        "name":"7985 (English Program)  :  Digital Innovation And Media Arts | นวัตกรรมดิจิทัลและศิลปะมีเดีย | 数字创新和媒体艺术"
    },
    {
        "id":7479,
        "name":"7986 (Thai Program)  :  Educational Innovation | นวัตกรรมการศึกษา | 教育创新"
    },
    {
        "id":7480,
        "name":"7987 (English Program)  :  Educational Innovation | นวัตกรรมการศึกษา | 教育创新"
    },
    {
        "id":7481,
        "name":"7988 (Thai Program)  :  Managing Digital Innovation And Technology | การจัดการนวัตกรรมดิจิทัลและเทคโนโลยี | 管理数字创新和技术"
    },
    {
        "id":7482,
        "name":"7989 (English Program)  :  Digital Innovation And Technology Management | นวัตกรรมดิจิทัลและการจัดการเทคโนโลยี | 数字创新与技术管理"
    },
    {
        "id":7483,
        "name":"7990 (Thai Program)  :  Science Innovation | นวัตกรรมวิทยาศาสตร์ | 科学创新"
    },
    {
        "id":7484,
        "name":"7991 (English Program)  :  Science Innovation | นวัตกรรมทางวิทยาศาสตร์ | 科学创新"
    },
    {
        "id":7485,
        "name":"7992 (Thai Program)  :  Managerial Economics And Strategy | เศรษฐศาสตร์การจัดการและกลยุทธ์ | 管理经济学与战略"
    },
    {
        "id":7486,
        "name":"7993 (English Program)  :  Managerial And Strategy Economics | เศรษฐศาสตร์การจัดการและกลยุทธ์ | 管理与战略经济学"
    },
    {
        "id":7487,
        "name":"7994 (Thai Program)  :  Information Technology And Digital Innovation | เทคโนโลยีสารสนเทศและนวัตกรรมดิจิทัล | 信息技术和数字创新"
    },
    {
        "id":7488,
        "name":"7995 (English Program)  :  Information Technology And Digital Innovation | เทคโนโลยีสารสนเทศและนวัตกรรมดิจิทัล | 信息技术和数字创新"
    },
    {
        "id":7489,
        "name":"7996 (Thai Program)  :  Creating Thai Musical Instruments | การสร้างเครื่องดนตรีไทย | 创作泰国乐器"
    },
    {
        "id":7490,
        "name":"7997 (English Program)  :  Thai Instrument Craftsman Course | หลักสูตรช่างฝีมือเครื่องดนตรีไทย | 泰国乐器工匠课程"
    },
    {
        "id":7491,
        "name":"7998 (Thai Program)  :  Agricultural Innovation | เกษตรนวัต | 农业创新"
    },
    {
        "id":7492,
        "name":"7999 (English Program)  :  Innovative Agriculture | นวัตกรรมการเกษตร | 创新农业"
    },
    {
        "id":7493,
        "name":"8000 (Thai Program)  :  Education Of The Deaf | การศึกษาของคนหูหนวก | 聋人教育"
    },
    {
        "id":7494,
        "name":"8001 (English Program)  :  Deaf Education | การศึกษาคนหูหนวก | 聋人教育"
    },
    {
        "id":7495,
        "name":"8002 (English Program)  :  Mechanical Power Technology | เทคโนโลยีกำลังทางกล | 机械动力技术"
    },
    {
        "id":7496,
        "name":"8003 (Thai Program)  :  Automotive Body And Paint Repair Techniques | เทคนิคซ่อมตัวถังและสียานยนต์ | 汽车车身及油漆修复技术"
    },
    {
        "id":7497,
        "name":"8004 (English Program)  :  Automotive Body And Painting Technology | เทคโนโลยีตัวถังและสีรถยนต์ | 汽车车身及涂装技术"
    },
    {
        "id":7498,
        "name":"8005 (Thai Program)  :  Industrial Electronics | อิเล็กทรอนิกส์อุตสาหกรรม | 工业电子"
    },
    {
        "id":7499,
        "name":"8006 (Thai Program)  :  Mechanical Production Techniques | เทคนิคการผลิตงานเครื่องกล | 机械生产技术"
    },
    {
        "id":7500,
        "name":"8007 (English Program)  :  Mechanical Production Techniques | เทคนิคการผลิตทางกล | 机械生产技术"
    },
    {
        "id":7501,
        "name":"8008 (Thai Program)  :  Techniques For Controlling And Maintaining Rail Transport Systems | เทคนิคควบคุมแล่ะซ่อมบำรุงระบบขนส่งทางราง | 铁路运输系统控制和维护技术"
    },
    {
        "id":7502,
        "name":"8009 (English Program)  :  Technical Control And Maintenance Of Rail Transportation Systems | การควบคุมทางเทคนิคและการบำรุงรักษาระบบขนส่งทางราง | 轨道交通系统的技术控制和维护"
    },
    {
        "id":7503,
        "name":"8010 (Thai Program)  :  International Food Chef | เชฟอาหารนานาชาติ | 国际美食厨师"
    },
    {
        "id":7504,
        "name":"8011 (English Program)  :  International Chef | เชฟนานาชาติ | 国际厨师"
    },
    {
        "id":7505,
        "name":"8012 (Thai Program)  :  Thai Food Chef | เชฟอาหารไทย | 泰国菜厨师"
    },
    {
        "id":7506,
        "name":"8013 (English Program)  :  Thai Chef | หัวหน้าไทย | 泰国厨师"
    },
    {
        "id":7507,
        "name":"8014 (Thai Program)  :  Mechanical Techniques | เทคนิคเครื่องกล | 机械技术"
    },
    {
        "id":7508,
        "name":"8015 (Thai Program)  :  Entrepreneurial Economics | เศรษฐศาสตร์ผู้ประกอบการ | 创业经济学"
    },
    {
        "id":7509,
        "name":"8016 (Thai Program)  :  Health And Beauty Business Management | การจัดการธุรกิจสุขภาพและความงาม | 健康与美容企业管理"
    },
    {
        "id":7510,
        "name":"8017 (English Program)  :  Health And Aesthetic Business Management | การจัดการธุรกิจด้านสุขภาพและความงาม | 健康美容商业管理"
    },
    {
        "id":7511,
        "name":"8018 (Thai Program)  :  Digital Information Management | การจัดการข้อมูลดิจิทัล | 数字信息管理"
    },
    {
        "id":7512,
        "name":"8019 (English Program)  :  Digital Data Management | การจัดการข้อมูลดิจิทัล | 数字数据管理"
    },
    {
        "id":7513,
        "name":"8020 (Thai Program)  :  Cooking And Kitchen Management | การประกอบอาหารและการจัดการงานครัว | 烹饪和厨房管理"
    },
    {
        "id":7514,
        "name":"8021 (English Program)  :  Culinary Art And Kitchen Management | ศิลปะการทำอาหารและการจัดการครัว | 烹饪艺术和厨房管理"
    },
    {
        "id":7515,
        "name":"8022 (Thai Program)  :  Medical Health | สัทภาพการแพทย์ | 医疗健康"
    },
    {
        "id":7516,
        "name":"8023 (English Program)  :  Medical Sonography | โซโนกราฟีทางการแพทย์ | 医学超声检查"
    },
    {
        "id":7517,
        "name":"8024 (Thai Program)  :  Oral Cytology And Biomaterials Science | เซลล์วิทยาช่องปากและวิทยาศาสตร์ชีววัสดุ | 口腔细胞学和生物材料科学"
    },
    {
        "id":7518,
        "name":"8025 (English Program)  :  Oral Cell Biology And Biomaterials Science | ชีววิทยาของเซลล์ในช่องปากและวิทยาศาสตร์วัสดุชีวภาพ | 口腔细胞生物学和生物材料科学"
    },
    {
        "id":7519,
        "name":"8026 (Thai Program)  :  Aviation Services | การบริการการบิน | 航空服务"
    },
    {
        "id":7520,
        "name":"8027 (English Program)  :  Aviation Services | บริการด้านการบิน | 航空服务"
    },
    {
        "id":7521,
        "name":"8028 (Thai Program)  :  Logistics And Digital Supply Chain | โลจิสติกส์และดิจิทัลซัพพลายเชน | 物流与数字供应链"
    },
    {
        "id":7522,
        "name":"8029 (English Program)  :  Logistics And Digital Supply Chain | โลจิสติกส์และห่วงโซ่อุปทานดิจิทัล | 物流和数字供应链"
    },
    {
        "id":7523,
        "name":"8030 (Thai Program)  :  Social Entrepreneurs In The Digital Age | ผู้ประกอบการทางสังคมยุคดิจิทัล | 数字时代的社会企业家"
    },
    {
        "id":7524,
        "name":"8031 (English Program)  :  Social Entrepreneur In Digital Age | ผู้ประกอบการเพื่อสังคมในยุคดิจิทัล | 数字时代的社会企业家"
    },
    {
        "id":7525,
        "name":"8032 (English Program)  :  Electricity | ไฟฟ้า | 电"
    },
    {
        "id":7526,
        "name":"8033 (Thai Program)  :  English For Business Management | ภาษาอังกฤษเพื่อการจัดการทางธุรกิจ | 企业管理英语"
    },
    {
        "id":7527,
        "name":"8034 (Thai Program)  :  Electronics And Telecommunications Industry Education | ครุศาสตร์อุตสาหกรรมอิเล็กทรอนิกส์และโทรคมนาคม | 电子及通讯行业教育"
    },
    {
        "id":7528,
        "name":"8035 (English Program)  :  Electronics And Telecommunication Industrial Education | การศึกษาอุตสาหกรรมอิเล็กทรอนิกส์และโทรคมนาคม | 电子与电信工业教育"
    },
    {
        "id":7529,
        "name":"8036 (English Program)  :  Computer And Electronics Technology Engineering | วิศวกรรมเทคโนโลยีคอมพิวเตอร์และอิเล็กทรอนิกส์ | 计算机与电子技术工程"
    },
    {
        "id":7530,
        "name":"8037 (Thai Program)  :  Automotive Parts Production Technology | เทคโนโลยีการผลิตชิ้นส่วนยานยนต์ | 汽车零部件生产技术"
    },
    {
        "id":7531,
        "name":"8038 (English Program)  :  Automotive Parts Manufacturing Technology | เทคโนโลยีการผลิตชิ้นส่วนยานยนต์ | 汽车零部件制造技术"
    },
    {
        "id":7532,
        "name":"8039 (Thai Program)  :  Medical Physics Materials And Equipment | วัสดุและอุปกรณ์ฟิสิกส์การแพทย์ | 医学物理材料与设备"
    },
    {
        "id":7533,
        "name":"8040 (English Program)  :  Materials And Medical Physics Equpment | วัสดุและอุปกรณ์ฟิสิกส์การแพทย์ | 材料及医疗物理设备"
    },
    {
        "id":7534,
        "name":"8041 (English Program)  :  Interdisciplinary Studies | การศึกษาแบบสหวิทยาการ | 跨学科研究"
    },
    {
        "id":7535,
        "name":"8042 (Thai Program)  :  Innovative Science | วิทยาศาสตร์นวัตกรรม | 创新科学"
    },
    {
        "id":7536,
        "name":"8043 (English Program)  :  Innovation Of Science | นวัตกรรมทางวิทยาศาสตร์ | 科学创新"
    },
    {
        "id":7537,
        "name":"8044 (Thai Program)  :  Data Science And Digital Industry | วิทยาการข้อมูลและอุตสาหกรรมดิจิทัล | 数据科学与数字产业"
    },
    {
        "id":7538,
        "name":"8045 (English Program)  :  Data Science And Digital Industry | วิทยาศาสตร์ข้อมูลและอุตสาหกรรมดิจิทัล | 数据科学和数字产业"
    },
    {
        "id":7539,
        "name":"8046 (Thai Program)  :  Modern Technology In The Sugar Cane And Sugar Industry | เทคโนโลยีสมัยใหม่ทางอุตสาหกรรมอ้อยและน้ำตาล | 甘蔗和制糖工业的现代技术"
    },
    {
        "id":7540,
        "name":"8047 (English Program)  :  Modern Technology Of Sugarcane And Sugar Industry | เทคโนโลยีสมัยใหม่ของอุตสาหกรรมอ้อยและน้ำตาล | 甘蔗和制糖工业的现代技术"
    },
    {
        "id":7541,
        "name":"8048 (Thai Program)  :  Computer Science And Artificial Intelligence | วิทยาการคอมพิวเตอร์และปัญญาประดิษฐ์ | 计算机科学与人工智能"
    },
    {
        "id":7542,
        "name":"8049 (English Program)  :  Computer Science And Artificial Intelligence | วิทยาศาสตร์คอมพิวเตอร์และปัญญาประดิษฐ์ | 计算机科学与人工智能"
    },
    {
        "id":7543,
        "name":"8050 (Thai Program)  :  Multimedia And Esports | มัลติมีเดียและอีสปอร์ต | 多媒体和电子竞技"
    },
    {
        "id":7544,
        "name":"8051 (English Program)  :  Multimedia And E-Sports | มัลติมีเดียและอีสปอร์ต | 多媒体和电子竞技"
    },
    {
        "id":7545,
        "name":"8052 (Thai Program)  :  Food Technology And Innovation | เทคโนโลยีและนวัตกรรมอาหาร | 食品技术与创新"
    },
    {
        "id":7546,
        "name":"8053 (English Program)  :  Food Technology And Innovation | เทคโนโลยีอาหารและนวัตกรรม | 食品技术与创新"
    },
    {
        "id":7547,
        "name":"8054 (Thai Program)  :  International Relations And Global Affairs | ความสัมพันธ์ระหว่างประเทศและกิจการทั่วโลก | 国际关系和全球事务"
    },
    {
        "id":7548,
        "name":"8055 (English Program)  :  International Relations And Global Affairs | ความสัมพันธ์ระหว่างประเทศและกิจการระดับโลก | 国际关系和全球事务"
    },
    {
        "id":7549,
        "name":"8056 (Thai Program)  :  International Hospitality Management | การจัดการการบริการนานาชาติ | 国际酒店管理"
    },
    {
        "id":7550,
        "name":"8057 (Thai Program)  :  Biomedical Physics | ฟิสิกส์ชีวการแพทย์ | 生物医学物理"
    },
    {
        "id":7551,
        "name":"8058 (English Program)  :  Business Information Technology Management | การจัดการเทคโนโลยีสารสนเทศทางธุรกิจ | 商业信息技术管理"
    },
    {
        "id":7552,
        "name":"8059 (Thai Program)  :  Business Information Technology Management | การจัดการเทคโนโลยีสารสนเทศทางธุรกิจ | 商业信息技术管理"
    },
    {
        "id":7553,
        "name":"8060 (English Program)  :  Biomedical Physics | ฟิสิกส์ชีวการแพทย์ | 生物医学物理"
    },
    {
        "id":7554,
        "name":"8061 (Thai Program)  :  Innovative Communications For Modern Organizations | การสื่อสารเชิงนวัตกรรมเพื่อองค์กรสมัยใหม่ | 现代组织的创新沟通"
    },
    {
        "id":7555,
        "name":"8062 (English Program)  :  Innovative Communication For Modern Organization | การสื่อสารที่เป็นนวัตกรรมสำหรับองค์กรสมัยใหม่ | 现代组织的创新沟通"
    },
    {
        "id":7556,
        "name":"8063 (Thai Program)  :  Sustainability Science And Management | ศาสตร์และการจัดการความยั่งยืน | 可持续发展科学与管理"
    },
    {
        "id":7557,
        "name":"8064 (English Program)  :  Sustainability Science And Management | วิทยาศาสตร์และการจัดการความยั่งยืน | 可持续发展科学与管理"
    },
    {
        "id":7558,
        "name":"8065 (Thai Program)  :  Educational Measurement, Evaluation, And Research | การวัดผล การประเมินผล และการวิจัยทางการศึกษา | 教育测量、评估和研究"
    },
    {
        "id":7559,
        "name":"8066 (Thai Program)  :  Industrial Technology And Agricultural Studies | เทคโนโลยีอุตสาหกรรมและเกษตรศึกษา | 工业技术和农业研究"
    },
    {
        "id":7560,
        "name":"8067 (Thai Program)  :  Agricultural Innovation For Sustainability | นวัตกรรมการเกษตรเพื่อความยั่งยืน | 农业创新促进可持续发展"
    },
    {
        "id":7561,
        "name":"8068 (English Program)  :  Agricultural Innovation For Sustainability | นวัตกรรมการเกษตรเพื่อความยั่งยืน | 农业创新促进可持续发展"
    },
    {
        "id":7562,
        "name":"8069 (Thai Program)  :  Data Science | วิทยาการข้อมูล | 数据科学"
    },
    {
        "id":7563,
        "name":"8070 (English Program)  :  Data Science | วิทยาศาสตร์ข้อมูล | 数据科学"
    },
    {
        "id":7564,
        "name":"8071 (Thai Program)  :  Digital Business | ธุรกิจดิจิทัล | 数字化业务"
    },
    {
        "id":7565,
        "name":"8072 (English Program)  :  Digital Business | ธุรกิจดิจิทัล | 数字化业务"
    },
    {
        "id":7566,
        "name":"8073 (Thai Program)  :  Communication Innovation Management | การจัดการนวัตกรรมการสื่อสาร | 沟通创新管理"
    },
    {
        "id":7567,
        "name":"8074 (English Program)  :  Communication Innovation Management | การจัดการนวัตกรรมการสื่อสาร | 传播创新管理"
    },
    {
        "id":7568,
        "name":"8075 (Thai Program)  :  Digital Technology For Business And Service Management | เทคโนโลยีดิจิทัลเพื่อการจัดการธุรกิจและบริการ | 用于业务和服务管理的数字技术"
    },
    {
        "id":7569,
        "name":"8076 (English Program)  :  Digital Technology For Bussiness And Service Management | เทคโนโลยีดิจิทัลเพื่อการจัดการธุรกิจและการบริการ | 商业和服务管理的数字技术"
    },
    {
        "id":7570,
        "name":"8077 (Thai Program)  :  Information Systems And Digital Business Innovation | ระบบสารสนเทศและนวัตกรรมธุรกิจดิจิทัล | 信息系统和数字业务创新"
    },
    {
        "id":7571,
        "name":"8078 (English Program)  :  Information System And Digital Business Innovation | ระบบสารสนเทศและนวัตกรรมธุรกิจดิจิทัล | 信息系统与数字商业创新"
    },
    {
        "id":7572,
        "name":"8079 (Thai Program)  :  Information System For Digital Business | ระบบสารสนเทศเพื่อธุรกิจดิจิทัล | 数字化商业信息系统"
    },
    {
        "id":7573,
        "name":"8080 (English Program)  :  Information Systems For Digital Business | ระบบสารสนเทศสำหรับธุรกิจดิจิทัล | 数字业务信息系统"
    },
    {
        "id":7574,
        "name":"8081 (Thai Program)  :  Semiotics And Cultural Studies | สัญศาสตร์และวัฒนธรรมศึกษา | 符号学与文化研究"
    },
    {
        "id":7575,
        "name":"8082 (English Program)  :  Semiotics And Cultural Studies | สัญศาสตร์และการศึกษาวัฒนธรรม | 符号学和文化研究"
    },
    {
        "id":7576,
        "name":"8083 (English Program)  :  Robotics Engineering And Artificial Intelligence | วิศวกรรมหุ่นยนต์และปัญญาประดิษฐ์ | 机器人工程与人工智能"
    },
    {
        "id":7577,
        "name":"8084 (English Program)  :  Buddhist Management | การบริหารจัดการพุทธศาสนา | 佛系管理"
    },
    {
        "id":7578,
        "name":"8085 (Thai Program)  :  Tropical Agricultural Innovation | นวัตเกษตรเขตร้อน | 热带农业创新"
    },
    {
        "id":7579,
        "name":"8086 (English Program)  :  Innovative Tropical Agricultures | นวัตกรรมการเกษตรเขตร้อน | 创新热带农业"
    },
    {
        "id":7580,
        "name":"8087 (Thai Program)  :  Stem Education | สะเต็มศึกษา | Stem教育"
    },
    {
        "id":7581,
        "name":"8088 (English Program)  :  Stem Education | การศึกษาต้นกำเนิด | 干教育"
    },
    {
        "id":7582,
        "name":"8089 (Thai Program)  :  Educational Innovator | นวัตกรทางการศึกษา | 教育创新者"
    },
    {
        "id":7583,
        "name":"8090 (English Program)  :  Educational Innovators | ผู้สร้างนวัตกรรมทางการศึกษา | 教育创新者"
    },
    {
        "id":7584,
        "name":"8091 (Thai Program)  :  Beverage Technology And Management | เทคโนโลยีเครื่องดื่มและการจัดการ | 饮料技术与管理"
    },
    {
        "id":7585,
        "name":"8092 (English Program)  :  Beverage Technology And Management | เทคโนโลยีและการจัดการเครื่องดื่ม | 饮料技术与管理"
    },
    {
        "id":7586,
        "name":"8093 (Thai Program)  :  Innovation And Digital Transformation | นวัตกรรมและการแปรรูปทางดิจิทัล | 创新和数字化转型"
    },
    {
        "id":7587,
        "name":"8094 (English Program)  :  Digital Transformation And Innovation | การเปลี่ยนแปลงทางดิจิทัลและนวัตกรรม | 数字化转型与创新"
    },
    {
        "id":7588,
        "name":"8095 (Thai Program)  :  Performing Arts Communication | การสื่อสารด้านศิลปะการแสดง | 表演艺术传播"
    },
    {
        "id":7589,
        "name":"8096 (English Program)  :  Arts Performance Communication | การสื่อสารการแสดงศิลปะ | 艺术表演传播"
    },
    {
        "id":7590,
        "name":"8097 (Thai Program)  :  Energy Conservation Engineering | วิศวกรรมการอนุรักษ์พลังงาน | 节能工程"
    },
    {
        "id":7591,
        "name":"8098 (English Program)  :  Energy Conservation Engineering | วิศวกรรมการอนุรักษ์พลังงาน | 节能工程"
    },
    {
        "id":7592,
        "name":"8099 (Thai Program)  :  Agro-Industrial Systems Engineering | วิศวกรรมระบบอุตสาหกรรมการเกษตร | 农工系统工程"
    },
    {
        "id":7593,
        "name":"8100 (English Program)  :  Agro-Industrial Systems Engineering | วิศวกรรมระบบอุตสาหกรรมเกษตร | 农业工业系统工程"
    },
    {
        "id":7594,
        "name":"8101 (Thai Program)  :  Sports Management Media And Entertainment | การจัดการกีฬา สื่อและบันเทิง | 体育管理媒体和娱乐"
    },
    {
        "id":7595,
        "name":"8102 (English Program)  :  Sport, Media And Entertainment Management | การจัดการกีฬา สื่อ และความบันเทิง | 体育、媒体和娱乐管理"
    },
    {
        "id":7596,
        "name":"8103 (Thai Program)  :  Creative Food Innovation And Nutrition | นวัตกรรมอาหารสร้างสรรค์และโภชนาการ | 创意食品创新与营养"
    },
    {
        "id":7597,
        "name":"8104 (English Program)  :  Creative Food Innovation And Nutrition | นวัตกรรมอาหารที่สร้างสรรค์และโภชนาการ | 创意食品创新与营养"
    },
    {
        "id":7598,
        "name":"8105 (Thai Program)  :  Social Development And Mission Relations | พัฒนาสังคมและพันธกิจสัมพันธ์ | 社会发展与宣教关系"
    },
    {
        "id":7599,
        "name":"8106 (English Program)  :  Social Development And Engagement | การพัฒนาสังคมและการมีส่วนร่วม | 社会发展和参与"
    },
    {
        "id":7600,
        "name":"8107 (Thai Program)  :  Network Management And Information Security | การบริหารเครือข่ายและความมั่นคงปลอดภัยสารสนเทศ | 网络管理与信息安全"
    },
    {
        "id":7601,
        "name":"8108 (English Program)  :  Network And Information Security Management | การจัดการความปลอดภัยของเครือข่ายและข้อมูล | 网络与信息安全管理"
    },
    {
        "id":7602,
        "name":"8109 (Thai Program)  :  Innovation In Agricultural And Food Enterprise Management | นวัตกรรมการจัดการวิสาหกิจการเกษตรและอาหาร | 农业食品企业管理创新"
    },
    {
        "id":7603,
        "name":"8110 (English Program)  :  Management Innovation In Agricultural And Food Enterprise | นวัตกรรมการจัดการในวิสาหกิจเกษตรและอาหาร | 农业食品企业管理创新"
    },
    {
        "id":7604,
        "name":"8111 (Thai Program)  :  Agricultural Technology And Innovation | เทคโนโลยีและนวัตกรรมการเกษตร | 农业技术与创新"
    },
    {
        "id":7605,
        "name":"8112 (English Program)  :  Agricultural Technology And Innovation | เทคโนโลยีการเกษตรและนวัตกรรม | 农业科技与创新"
    },
    {
        "id":7606,
        "name":"8113 (English Program)  :  Law For Development | กฎหมายเพื่อการพัฒนา | 发展法"
    },
    {
        "id":7607,
        "name":"8114 (Thai Program)  :  Applied Biological Resource Science | วิทยาศาสตร์ทรัพยากรชีวภาพประยุกต์ | 应用生物资源科学"
    },
    {
        "id":7608,
        "name":"8115 (English Program)  :  Applied Bioresource Science | วิทยาศาสตร์ทรัพยากรชีวภาพประยุกต์ | 应用生物资源科学"
    },
    {
        "id":7609,
        "name":"8116 (Thai Program)  :  Data Science And Innovation | วิทยาศาสตร์และนวัตกรรมข้อมูล | 数据科学与创新"
    },
    {
        "id":7610,
        "name":"8117 (English Program)  :  Data Science And Innovation | วิทยาศาสตร์ข้อมูลและนวัตกรรม | 数据科学与创新"
    },
    {
        "id":7611,
        "name":"8118 (Thai Program)  :  Quantum Science And Technology | วิทยาศาสตร์และเทคโนโลยีควอนตัม | 量子科学与技术"
    },
    {
        "id":7612,
        "name":"8119 (English Program)  :  Quantum Science And Technology | วิทยาศาสตร์และเทคโนโลยีควอนตัม | 量子科学与技术"
    },
    {
        "id":7613,
        "name":"8120 (English Program)  :  Technology And Innovation Agriculture | เทคโนโลยีและนวัตกรรมการเกษตร | 科技创新农业"
    },
    {
        "id":7614,
        "name":"8121 (Thai Program)  :  Athletic Training And Movement Science | แอทเลติกเทรนนิงและวิทยาศาสตร์การเคลื่อนไหว | 运动训练和运动科学"
    },
    {
        "id":7615,
        "name":"8122 (English Program)  :  Athletic Training And Movement Science | วิทยาศาสตร์การฝึกซ้อมกีฬาและการเคลื่อนไหว | 运动训练和运动科学"
    },
    {
        "id":7616,
        "name":"8123 (Thai Program)  :  Educational Management And Learning Management Innovation | การจัดการศึกษาและนวัตกรรมการจัดการเรียนรู้ | 教育管理与学习管理创新"
    },
    {
        "id":7617,
        "name":"8124 (English Program)  :  Educational Management And Learning Management Innovation | นวัตกรรมการจัดการการศึกษาและการจัดการเรียนรู้ | 教育管理与学习管理创新"
    },
    {
        "id":7618,
        "name":"8125 (Thai Program)  :  Public Health And Sustainable Development | สาธารณสุขและการพัฒนาอย่างยั่งยืน | 公共卫生与可持续发展"
    },
    {
        "id":7619,
        "name":"8126 (English Program)  :  Public Health And Sustainable Development | การสาธารณสุขและการพัฒนาที่ยั่งยืน | 公共卫生与可持续发展"
    },
    {
        "id":7620,
        "name":"8127 (Thai Program)  :  Humanities And Sustainability | มนุษยศาสตร์และความยั่งยืน | 人文与可持续发展"
    },
    {
        "id":7621,
        "name":"8128 (English Program)  :  Humanities And Sustainability | มนุษยศาสตร์และความยั่งยืน | 人文与可持续发展"
    },
    {
        "id":7622,
        "name":"8129 (Thai Program)  :  Big Data Analysis And Management | การวิเคราะห์และจัดการข้อมูลขนาดใหญ่ | 大数据分析与管理"
    },
    {
        "id":7623,
        "name":"8130 (English Program)  :  Big Data Management And Analytics | การจัดการและการวิเคราะห์ข้อมูลขนาดใหญ่ | 大数据管理和分析"
    },
    {
        "id":7624,
        "name":"8131 (Thai Program)  :  Animal Conservation Technology | เทคโนโลยีสัตวรักษ์ | 动物保护技术"
    },
    {
        "id":7625,
        "name":"8132 (English Program)  :  Veterinary Nurse Technology | เทคโนโลยีพยาบาลสัตวแพทย์ | 兽医护士技术"
    },
    {
        "id":7626,
        "name":"8133 (Thai Program)  :  Applied Geoinformatics | ภูมิสารสนเทศประยุกต์ | 应用地理信息学"
    },
    {
        "id":7627,
        "name":"8134 (English Program)  :  Applied Geoinformatics | ภูมิศาสตร์สารสนเทศประยุกต์ | 应用地理信息学"
    },
    {
        "id":7628,
        "name":"8135 (Thai Program)  :  Technology And Innovation Management | การบริหารเทคโนโลยีและนวัตกรรม | 技术与创新管理"
    },
    {
        "id":7629,
        "name":"8136 (Thai Program)  :  Energy Management And Innovation | การจัดการพลังงานและนวัตกรรม | 能源管理与创新"
    },
    {
        "id":7630,
        "name":"8137 (English Program)  :  Energy Management And Innovation | การจัดการพลังงานและนวัตกรรม | 能源管理与创新"
    },
    {
        "id":7631,
        "name":"8138 (Thai Program)  :  Innovative Cultural Heritage Management | นวัตกรรมการจัดการมรดกทางวัฒนธรรม | 创新文化遗产管理"
    },
    {
        "id":7632,
        "name":"8139 (English Program)  :  Innovation In Cultural Heritage Management | นวัตกรรมในการจัดการมรดกวัฒนธรรม | 文化遗产管理创新"
    },
    {
        "id":7633,
        "name":"8140 (Thai Program)  :  Food, Nutrition And Dietetics | อาหาร โภชนาการ และการกำหนดอาหาร | 食品、营养和饮食学"
    },
    {
        "id":7634,
        "name":"8141 (English Program)  :  Food, Nutrition And Dietetics | อาหาร โภชนาการ และการควบคุมอาหาร | 食品、营养和饮食"
    },
    {
        "id":7635,
        "name":"8142 (Thai Program)  :  Food And Applied Nutrition | อาหารและโภชนาการประยุกต์ | 食品与应用营养"
    },
    {
        "id":7636,
        "name":"8143 (Thai Program)  :  Learning Innovation And Information Technology | นวัตกรรมการเรียนรู้และเทคโนโลยีสารสนเทศ | 学习创新和信息技术"
    },
    {
        "id":7637,
        "name":"8144 (English Program)  :  Learning Innovation And Information Technology | การเรียนรู้นวัตกรรมและเทคโนโลยีสารสนเทศ | 学习创新和信息技术"
    },
    {
        "id":7638,
        "name":"8145 (Thai Program)  :  Intelligent Systems Engineering | วิศวกรรมระบบอัจฉริยะ | 智能系统工程"
    },
    {
        "id":7639,
        "name":"8146 (English Program)  :  Intelligent Systems Engineering | วิศวกรรมระบบอัจฉริยะ | 智能系统工程"
    },
    {
        "id":7640,
        "name":"8147 (Thai Program)  :  Health Science Research | การวิจัยวิทยาศาสตร์สุขภาพ | 健康科学研究"
    },
    {
        "id":7641,
        "name":"8148 (English Program)  :  Health Sciences Research | การวิจัยวิทยาศาสตร์สุขภาพ | 健康科学研究"
    },
    {
        "id":7642,
        "name":"8149 (Thai Program)  :  Gaming And E-Sports Business | ธุรกิจเกมและอีสปอร์ต | 游戏及电子竞技业务"
    },
    {
        "id":7643,
        "name":"8150 (English Program)  :  Game And Esports Business | ธุรกิจเกมและอีสปอร์ต | 游戏及电竞业务"
    },
    {
        "id":7644,
        "name":"8151 (Thai Program)  :  Innovative Mechanical Technology | นวัตกรรมเทคโนโลยีเครื่องจักรกล | 创新机械技术"
    },
    {
        "id":7645,
        "name":"8152 (English Program)  :  Innovative Technology Machinery | เครื่องจักรเทคโนโลยีที่เป็นนวัตกรรม | 创新科技机械"
    },
    {
        "id":7646,
        "name":"8153 (English Program)  :  Leadership, Management And Innovation | ความเป็นผู้นำ การจัดการ และนวัตกรรม | 领导力、管理和创新"
    },
    {
        "id":7647,
        "name":"8154 (Thai Program)  :  Leadership, Management And Innovation | ภาวะผู้นำ การจัดการ และนวัตกรรม | 领导力、管理与创新"
    },
    {
        "id":7648,
        "name":"8155 (Thai Program)  :  Modern Advertising And Public Relations | การโฆษณาและการประชาสัมพันธ์สมัยใหม่ | 现代广告和公共关系"
    },
    {
        "id":7649,
        "name":"8156 (Thai Program)  :  Environmental Engineering For Sustainable Development | วิศวกรรมสิ่งแวดล้อมเพื่อการพัฒนาอย่างยั่งยืน | 环境工程促进可持续发展"
    },
    {
        "id":7650,
        "name":"8157 (Thai Program)  :  Ground Technician | นายช่างภาคพื้นดิน | 地面技术员"
    },
    {
        "id":7651,
        "name":"8158 (English Program)  :  Aircraft Maintenance Engineer License Course | หลักสูตรใบอนุญาตวิศวกรซ่อมบำรุงอากาศยาน | 飞机维修工程师执照课程"
    },
    {
        "id":7652,
        "name":"8159 (Thai Program)  :  Holistic Health Promotion And Medical Big Data | การส่งเสริมสุขภาพองค์รวมและข้อมูลขนาดใหญ่ทางการแพทย์ | 整体健康促进与医疗大数据"
    },
    {
        "id":7653,
        "name":"8160 (English Program)  :  Big Health Promotion And Medical Bid Data | การส่งเสริมสุขภาพครั้งใหญ่และข้อมูลการประมูลทางการแพทย์ | 健康促进和医疗投标大数据"
    },
    {
        "id":7654,
        "name":"8161 (Thai Program)  :  Intelligent Electronics | อิเล็กทรอนิกส์อัจฉริยะ | 智能电子"
    },
    {
        "id":7655,
        "name":"8162 (English Program)  :  Smart Electronics | สมาร์ทอิเล็กทรอนิกส์ | 智能电子"
    },
    {
        "id":7656,
        "name":"8163 (Thai Program)  :  Dance Studies | นาฏศิลป์ศึกษา | 舞蹈研究"
    },
    {
        "id":7657,
        "name":"8164 (English Program)  :  Arts Education | การศึกษาศิลปะ | 艺术教育"
    },
    {
        "id":7658,
        "name":"8165 (Thai Program)  :  Biochemistry And Biochemistry Technology | ชีวเคมีและเทคโนโลยีชีวเคมี | 生物化学与生物化学技术"
    },
    {
        "id":7659,
        "name":"8166 (Thai Program)  :  Entrepreneurship Science | วิทยาการประกอบการ | 创业科学"
    },
    {
        "id":7660,
        "name":"8167 (English Program)  :  Entrepreneurial Science | วิทยาศาสตร์การประกอบการ | 创业科学"
    },
    {
        "id":7661,
        "name":"8168 (Thai Program)  :  Integrating Innovation For Products And Services | บูรณาการนวัตกรรมเพื่อสินค้าและบริการ | 整合产品和服务创新"
    },
    {
        "id":7662,
        "name":"8169 (English Program)  :  Integrated Innovation For Products And Service | นวัตกรรมบูรณาการสำหรับผลิตภัณฑ์และบริการ | 产品与服务的集成创新"
    },
    {
        "id":7663,
        "name":"8170 (Thai Program)  :  Digital Entrepreneur | ผู้ประกอบการดิจิทัล | 数字企业家"
    },
    {
        "id":7664,
        "name":"8171 (English Program)  :  Digital Entrepreneur | ผู้ประกอบการดิจิทัล | 数字化企业家"
    },
    {
        "id":7665,
        "name":"8172 (Thai Program)  :  Isaan Art | ศิลปะอีสาน | 伊桑艺术"
    },
    {
        "id":7666,
        "name":"8173 (Thai Program)  :  Emergency Medical Operations | ปฏิบัติการฉุกเฉินการแพทย์ | 紧急医疗行动"
    },
    {
        "id":7667,
        "name":"8174 (English Program)  :  Emergency Medical Operation | ปฏิบัติการทางการแพทย์ฉุกเฉิน | 紧急医疗手术"
    },
    {
        "id":7668,
        "name":"8175 (Thai Program)  :  Digital Technology And Innovation | เทคโนโลยีดิจิทัลและนวัตกรรม | 数字技术与创新"
    },
    {
        "id":7669,
        "name":"8176 (English Program)  :  Digital Technology And Innovation | เทคโนโลยีดิจิทัลและนวัตกรรม | 数字技术与创新"
    },
    {
        "id":7670,
        "name":"8177 (Thai Program)  :  Creative Design | การออกแบบเชิงสร้างสรรค์ | 创意设计"
    },
    {
        "id":7671,
        "name":"8178 (English Program)  :  Creative Design | การออกแบบที่สร้างสรรค์ | 创意设计"
    },
    {
        "id":7672,
        "name":"8179 (Thai Program)  :  English For Business In The Digital Age | ภาษาอังกฤษเพื่อธุรกิจในยุคดิจิทัล | 数字时代的商务英语"
    },
    {
        "id":7673,
        "name":"8180 (English Program)  :  English For Digital Age Business | ภาษาอังกฤษสำหรับธุรกิจยุคดิจิทัล | 数字时代商务英语"
    },
    {
        "id":7674,
        "name":"8181 (Thai Program)  :  Rice Innovation | นวัตกรรมข้าว | 水稻创新"
    },
    {
        "id":7675,
        "name":"8182 (English Program)  :  Rice Innovation | นวัตกรรมข้าว | 水稻创新"
    },
    {
        "id":7676,
        "name":"8183 (Thai Program)  :  Optometry Clinic | ทัศนมาตรคลินิก | 验光诊所"
    },
    {
        "id":7677,
        "name":"8184 (English Program)  :  Clinical Optometry | จักษุคลินิก | 临床验光"
    },
    {
        "id":7678,
        "name":"8185 (Thai Program)  :  Biotechnology For Industry, Agriculture And The Environment | เทคโนโลยีชีวภาพเพื่ออุตสาหกรรมเกษตรและสิ่งแวดล้อม | 工业、农业和环境生物技术"
    },
    {
        "id":7679,
        "name":"8186 (English Program)  :  Biotechnology For Agro-Industry And Environment | เทคโนโลยีชีวภาพเพื่ออุตสาหกรรมเกษตรและสิ่งแวดล้อม | 农业工业和环境生物技术"
    },
    {
        "id":7680,
        "name":"8187 (Thai Program)  :  Food Science And Management | วิทยาศาสตร์การอาหารและการจัดการ | 食品科学与管理"
    },
    {
        "id":7681,
        "name":"8188 (English Program)  :  Food Science And Management | วิทยาศาสตร์การอาหารและการจัดการ | 食品科学与管理"
    },
    {
        "id":7682,
        "name":"8189 (Thai Program)  :  Smart Agricultural Engineering | วิศวกรรมเกษตรอัจฉริยะ | 智慧农业工程"
    },
    {
        "id":7683,
        "name":"8190 (English Program)  :  Smart Agricultural Engineering | วิศวกรรมเกษตรอัจฉริยะ | 智慧农业工程"
    },
    {
        "id":7684,
        "name":"8191 (Thai Program)  :  Exercise Science And Sports Performance | วิทยาศาสตร์การออกกำลังกายและสมรรถภาพทางการกีฬา | 运动科学与运动表现"
    },
    {
        "id":7685,
        "name":"8192 (English Program)  :  Exercise Science And Sports Performance | การออกกำลังกายทางวิทยาศาสตร์และประสิทธิภาพการกีฬา | 运动科学和运动表现"
    },
    {
        "id":7686,
        "name":"8193 (Thai Program)  :  Medical Equipment Physics | ฟิสิกส์อุปกรณ์การแพทย์ | 医疗设备物理"
    },
    {
        "id":7687,
        "name":"8194 (English Program)  :  Medical Instrumentation Physics | ฟิสิกส์เครื่องมือแพทย์ | 医疗仪器物理"
    },
    {
        "id":7688,
        "name":"8195 (Thai Program)  :  Entrepreneurship, Innovation And Business Design | การประกอบการธุรกิจนวัตกรรมและการออกแบบธุรกิจ | 创业、创新与商业设计"
    },
    {
        "id":7689,
        "name":"8196 (English Program)  :  Innopreneurship And Business Design | ความเป็นผู้ประกอบการและการออกแบบธุรกิจ | 创新创业和商业设计"
    },
    {
        "id":7690,
        "name":"8197 (Thai Program)  :  Physical Education And Exercise Science | พลศึกษาและวิทยาศาสตร์การออกกำลังกาย | 体育与运动科学"
    },
    {
        "id":7691,
        "name":"8198 (English Program)  :  Physical Education And Exrecise Science | พลศึกษาและวิทยาศาสตร์การออกกำลังกาย | 体育与运动科学"
    },
    {
        "id":7692,
        "name":"8199 (Thai Program)  :  Creative And Innovative Ceramics | เซรามิกส์สร้างสรรค์และนวัตกรรม | 创意创新陶瓷"
    },
    {
        "id":7693,
        "name":"8200 (English Program)  :  Creative And Innovative Ceramics | เซรามิกที่สร้างสรรค์และล้ำสมัย | 创意创新陶瓷"
    },
    {
        "id":7694,
        "name":"8201 (Thai Program)  :  Modern Retail Business Innovation | นวัตกรรมธุรกิจค้าปลีกสมัยใหม่ | 现代零售业创新"
    },
    {
        "id":7695,
        "name":"8202 (English Program)  :  Modern Retail Business Innovation | นวัตกรรมธุรกิจค้าปลีกสมัยใหม่ | 现代零售业务创新"
    },
    {
        "id":7696,
        "name":"8203 (Thai Program)  :  Cosmetic Chemistry And Natural Products | เคมีเครื่องสำอางและผลิตภัณฑ์ธรรมชาติ | 化妆品化学和天然产物"
    },
    {
        "id":7697,
        "name":"8204 (English Program)  :  Cosmetic Chemistry And Natural Products | เคมีเครื่องสำอางและผลิตภัณฑ์จากธรรมชาติ | 化妆品化学和天然产品"
    },
    {
        "id":7698,
        "name":"8205 (Thai Program)  :  Data Science And Business And Industrial Computing | วิทยาการข้อมูลและการคำนวณเชิงธุรกิจและอุตสาหกรรม | 数据科学与商业和工业计算"
    },
    {
        "id":7699,
        "name":"8206 (English Program)  :  Data Science And Computation For Business And Industry | วิทยาศาสตร์ข้อมูลและการคำนวณสำหรับธุรกิจและอุตสาหกรรม | 商业和工业数据科学和计算"
    },
    {
        "id":7700,
        "name":"8207 (Thai Program)  :  Creative Gems | อัญมณีรังสรรค์ | 创意宝石"
    },
    {
        "id":7701,
        "name":"8208 (English Program)  :  Creative Jewelry | เครื่องประดับที่สร้างสรรค์ | 创意首饰"
    },
    {
        "id":7702,
        "name":"8209 (Thai Program)  :  Forest Industry Technology | เทคโนโลยีอุตสาหกรรมป่าไม้ | 林业技术"
    },
    {
        "id":7703,
        "name":"8210 (English Program)  :  Forest Industry Technology | เทคโนโลยีอุตสาหกรรมป่าไม้ | 林业技术"
    },
    {
        "id":7704,
        "name":"8211 (Thai Program)  :  Computer And Technology | คอมพิวเตอร์และเทคโนโลยี | 计算机和技术"
    },
    {
        "id":7705,
        "name":"8212 (English Program)  :  Computer And Technology | คอมพิวเตอร์และเทคโนโลยี | 计算机与技术"
    },
    {
        "id":7706,
        "name":"8213 (Thai Program)  :  Fishery Technology And Innovation | เทคโนโลยีและนวัตกรรมการประมง | 渔业技术与创新"
    },
    {
        "id":7707,
        "name":"8214 (English Program)  :  Fisheries Technology And Innovation | เทคโนโลยีและนวัตกรรมการประมง | 渔业技术与创新"
    },
    {
        "id":7708,
        "name":"8215 (Thai Program)  :  Data Science And Artificial Intelligence | วิทยาการข้อมูลและปัญญาประดิษฐ์ | 数据科学与人工智能"
    },
    {
        "id":7709,
        "name":"8216 (Thai Program)  :  Innovation Biomedical Engineering | นวัตกรรม วิศวชีวการแพทย์ | 创新生物医学工程"
    },
    {
        "id":7710,
        "name":"8217 (English Program)  :  Biomedical Innovation Engineering | วิศวกรรมนวัตกรรมชีวการแพทย์ | 生物医学创新工程"
    },
    {
        "id":7711,
        "name":"8218 (Thai Program)  :  Aviation Service Industry | อุตสาหกรรมการบริการการบิน | 航空服务业"
    },
    {
        "id":7712,
        "name":"8219 (English Program)  :  Aviation Service Industry | อุตสาหกรรมบริการการบิน | 航空服务业"
    },
    {
        "id":7713,
        "name":"8220 (Thai Program)  :  Industrial Innovation And Technology | นวัตกรรมและเทคโนโลยีอุตสาหกรรม | 工业创新与技术"
    },
    {
        "id":7714,
        "name":"8221 (English Program)  :  Innovation And Industrial Technology | นวัตกรรมและเทคโนโลยีอุตสาหกรรม | 创新与工业技术"
    },
    {
        "id":7715,
        "name":"8222 (Thai Program)  :  Entrepreneurship And Business Innovation | การเป็นผู้ประกอบการและนวัตกรรมทางธุรกิจ | 创业与商业创新"
    },
    {
        "id":7716,
        "name":"8223 (English Program)  :  Entrepreneurship And Business Innovation | นวัตกรรมการเป็นผู้ประกอบการและธุรกิจ | 创业与商业创新"
    },
    {
        "id":7717,
        "name":"8224 (Thai Program)  :  Renewable Energy And Environmental Engineering | วิศวกรรมพลังงานทดแทนและสิ่งแวดล้อม | 可再生能源与环境工程"
    },
    {
        "id":7718,
        "name":"8225 (English Program)  :  Renewable Energy And Environmental Engineering | พลังงานทดแทนและวิศวกรรมสิ่งแวดล้อม | 可再生能源与环境工程"
    },
    {
        "id":7719,
        "name":"8226 (Thai Program)  :  Marketing Innovation | นวัตกรรมการตลาด | 营销创新"
    },
    {
        "id":7720,
        "name":"8227 (English Program)  :  Marketing Innovation | นวัตกรรมทางการตลาด | 营销创新"
    },
    {
        "id":7721,
        "name":"8228 (Thai Program)  :  Environmental Technology Safety And Health | เทคโนโลยีสิ่งแวดล้อม ความปลอดภัยและสุขภาพ | 环保技术安全健康"
    },
    {
        "id":7722,
        "name":"8229 (English Program)  :  Environmental, Safety Technology And Health | สิ่งแวดล้อม เทคโนโลยีความปลอดภัย และสุขภาพ | 环境、安全技术与健康"
    },
    {
        "id":7723,
        "name":"8230 (Thai Program)  :  Innovative Agriculture | เกษตรนวัตกรรม | 创新农业"
    },
    {
        "id":7724,
        "name":"8231 (Thai Program)  :  Modern Management | การจัดการสมัยใหม่ | 现代管理"
    },
    {
        "id":7725,
        "name":"8232 (English Program)  :  Modern Management | การจัดการที่ทันสมัย | 现代管理"
    },
    {
        "id":7726,
        "name":"8233 (Thai Program)  :  Multicultural Psychology | จิตวิทยาพหุวัฒนธรรม | 多元文化心理学"
    },
    {
        "id":7727,
        "name":"8234 (Thai Program)  :  Integrated Business Management For Entrepreneurship | การบริหารธุรกิจแบบบูรณาการเพื่อความเป็นผู้ประกอบการ | 创业综合业务管理"
    },
    {
        "id":7728,
        "name":"8235 (English Program)  :  Integrative Business Entrepreneurship | การเป็นผู้ประกอบการธุรกิจเชิงบูรณาการ | 综合创业"
    },
    {
        "id":7729,
        "name":"8236 (Thai Program)  :  Digital Design And Technology | การออกแบบดิจิทัลและเทคโนโลยี | 数字设计与技术"
    },
    {
        "id":7730,
        "name":"8237 (English Program)  :  Digital Design And Technology | การออกแบบและเทคโนโลยีดิจิทัล | 数字设计与技术"
    },
    {
        "id":7731,
        "name":"8238 (Thai Program)  :  Bioenergy Technology And Biochemical Processing | เทคโนโลยีพลังงานชีวภาพและการแปรรูปเคมีชีวภาพ | 生物能源技术和生化加工"
    },
    {
        "id":7732,
        "name":"8239 (Thai Program)  :  Event Management Exhibitions And Conferences | การจัดการงานอีเวนต์ นิทรรศการและการประชุม | 活动管理展览及会议"
    },
    {
        "id":7733,
        "name":"8240 (English Program)  :  Event, Exhibition, And Convention Management | การจัดการงานนิทรรศการและการประชุม | 活动、展览和会议管理"
    },
    {
        "id":7734,
        "name":"8241 (Thai Program)  :  Leadership Innovation | นวัตกรรมภาวะผู้นำ | 领导创新"
    },
    {
        "id":7735,
        "name":"8242 (English Program)  :  Leadership Innovation | นวัตกรรมความเป็นผู้นำ | 领导力创新"
    },
    {
        "id":7736,
        "name":"8243 (Thai Program)  :  Food Science And Innovation | วิทยาศาสตร์และนวัตกรรมทางอาหาร | 食品科学与创新"
    },
    {
        "id":7737,
        "name":"8244 (Thai Program)  :  Automotive Technology Engineering | วิศวกรรมเทคโนโลยียานยนต์ | 汽车技术工程"
    },
    {
        "id":7738,
        "name":"8245 (Thai Program)  :  Spanish And Latin American Studies | สเปนและลาตินอเมริกันศึกษา | 西班牙和拉丁美洲研究"
    },
    {
        "id":7739,
        "name":"8246 (Thai Program)  :  Digital Engineering | วิศวกรรมดิจิทัล | 数字工程"
    },
    {
        "id":7740,
        "name":"8247 (Thai Program)  :  Occupational Health Nursing Practice | การพยาบาลเวชปฏิบัติอาชีวอนามัย | 职业健康护理实践"
    },
    {
        "id":7741,
        "name":"8248 (English Program)  :  Health Promotion And Development | การส่งเสริมและพัฒนาสุขภาพ | 健康促进与发展"
    },
    {
        "id":7742,
        "name":"8249 (Thai Program)  :  Sound Design And Art | การออกแบบและศิลปะเสียง | 声音设计和艺术"
    },
    {
        "id":7743,
        "name":"8250 (Thai Program)  :  Cultural Design Art | ศิลปะการออกแบบเชิงวัฒนธรรม | 文化设计艺术"
    },
    {
        "id":7744,
        "name":"8251 (Thai Program)  :  Tourism And Recreation | การท่องเที่ยวและนันทนาการ | 旅游和休闲"
    },
    {
        "id":7745,
        "name":"8252 (English Program)  :  Tourism And Recreation | การท่องเที่ยวและสันทนาการ | 旅游休闲"
    },
    {
        "id":7746,
        "name":"8253 (Thai Program)  :  Food And Business Innovation | นวัตกรรมอาหารและธุรกิจ | 食品和商业创新"
    },
    {
        "id":7747,
        "name":"8254 (Thai Program)  :  Political And World Relations Studies | การเมืองและโลกสัมพันธ์ศึกษา | 政治与世界关系研究"
    },
    {
        "id":7748,
        "name":"8255 (English Program)  :  Political And Global Studies | การศึกษาทางการเมืองและระดับโลก | 政治和全球研究"
    },
    {
        "id":7749,
        "name":"8256 (Thai Program)  :  Cultural Anthropology And Tourism | มานุษยวิทยาวัฒนธรรมและการท่องเที่ยว | 文化人类学与旅游"
    },
    {
        "id":7750,
        "name":"8257 (English Program)  :  Cultural And Tourism Anthropology | มานุษยวิทยาวัฒนธรรมและการท่องเที่ยว | 文化与旅游人类学"
    },
    {
        "id":7751,
        "name":"8258 (Thai Program)  :  Arabic Language And Literature | ภาษาและวรรณคดีอาหรับ | 阿拉伯语言和文学"
    },
    {
        "id":7752,
        "name":"8259 (English Program)  :  Arabic Language And Literature | ภาษาอาหรับและวรรณคดี | 阿拉伯语言和文学"
    },
    {
        "id":7753,
        "name":"8260 (Thai Program)  :  Agricultural And Community Management | การจัดการเกษตรและชุมชน | 农业和社区管理"
    },
    {
        "id":7754,
        "name":"8261 (English Program)  :  Agriculture And Community Management | การจัดการเกษตรและชุมชน | 农业和社区管理"
    },
    {
        "id":7755,
        "name":"8262 (Thai Program)  :  Buddhist Abhidhamma Science | พุทธอภิธัมมศาสตร์ | 佛教阿毗达摩科学"
    },
    {
        "id":7756,
        "name":"8263 (English Program)  :  Buddhist Abhidhamma Science | พุทธศาสตร์อภิธรรม | 佛教阿毗达摩科学"
    },
    {
        "id":7757,
        "name":"8264 (Thai Program)  :  Applied Chemistry And Industrial Microbiology | เคมีประยุกต์และจุลชีววิทยาอุตสาหกรรม | 应用化学和工业微生物学"
    },
    {
        "id":7758,
        "name":"8265 (English Program)  :  Applied Chemistry And Industrial Microbiology | เคมีประยุกต์และจุลชีววิทยาอุตสาหกรรม | 应用化学和工业微生物学"
    },
    {
        "id":7759,
        "name":"8266 (Thai Program)  :  Languages ​​For International Business Communication | ภาษาเพื่อการสื่อสารทางธุรกิจระหว่างประเทศ | 国际商务交流语言"
    },
    {
        "id":7760,
        "name":"8267 (Thai Program)  :  Innovation For Local Development | นวัตกรรมเพื่อการพัฒนาท้องถิ่น | 创新促进地方发展"
    },
    {
        "id":7761,
        "name":"8268 (English Program)  :  Innovation For Local Development | นวัตกรรมเพื่อการพัฒนาท้องถิ่น | 创新促进当地发展"
    },
    {
        "id":7762,
        "name":"8269 (Thai Program)  :  Educational Administration And Strategy | บริหารการศึกษาและกลยุทธ์ | 教育管理与策略"
    },
    {
        "id":7763,
        "name":"8270 (English Program)  :  Educational Administration And Strategies | การบริหารการศึกษาและยุทธศาสตร์ | 教育管理和策略"
    },
    {
        "id":7764,
        "name":"8271 (Thai Program)  :  Product Innovation And Technology | นวัตกรรมและเทคโนโลยีผลิตภัณฑ์ | 产品创新与技术"
    },
    {
        "id":7765,
        "name":"8272 (English Program)  :  Product Innovation And Technolog | นวัตกรรมผลิตภัณฑ์และเทคโนโลยี | 产品创新与技术"
    },
    {
        "id":7766,
        "name":"8273 (Thai Program)  :  Security System Management | การจัดการระบบรักษาความมั่นคงปลอดภัย | 安全系统管理"
    },
    {
        "id":7767,
        "name":"8274 (English Program)  :  Security System Management | การจัดการระบบรักษาความปลอดภัย | 安全系统管理"
    },
    {
        "id":7768,
        "name":"8275 (Thai Program)  :  Entrepreneurship And Innovation In Tourism Management | ผู้ประกอบการและนวัตกรรมการจัดการการท่องเที่ยว | 旅游管理创业创新"
    },
    {
        "id":7769,
        "name":"8276 (English Program)  :  Entrepreneur And Tourism Management | ผู้ประกอบการและการจัดการการท่องเที่ยว | 企业家和旅游管理"
    },
    {
        "id":7770,
        "name":"8277 (Thai Program)  :  Research And Development Of Teaching Technical Education | การวิจัยและพัฒนาการสอนเทคนิคศึกษา | 教学技术教育研究与发展"
    },
    {
        "id":7771,
        "name":"8278 (Thai Program)  :  Ecosystem Innovation Management For Sustainable Tourism | การจัดการนวัตกรรมระบบนิเวศเพื่อการท่องเที่ยวอย่างยั่งยืน | 可持续旅游业的生态系统创新管理"
    },
    {
        "id":7772,
        "name":"8279 (English Program)  :  Ecosystem Innovation Management For Sustainable Tourism | การจัดการนวัตกรรมระบบนิเวศเพื่อการท่องเที่ยวอย่างยั่งยืน | 可持续旅游业的生态系统创新管理"
    },
    {
        "id":7773,
        "name":"8280 (Thai Program)  :  Design Art And Digital Media | ศิลปะการออกแบบ และสื่อดิจิทัล | 设计艺术和数字媒体"
    },
    {
        "id":7774,
        "name":"8281 (English Program)  :  Art Design And Digital Media | การออกแบบงานศิลปะและสื่อดิจิทัล | 艺术设计与数字媒体"
    },
    {
        "id":7775,
        "name":"8282 (Thai Program)  :  Robot Engineering | วิศวกรรมหุ่นยนต์ | 机器人工程"
    },
    {
        "id":7776,
        "name":"8283 (English Program)  :  Robotics Engineering | วิศวกรรมหุ่นยนต์ | 机器人工程"
    },
    {
        "id":7777,
        "name":"8284 (Thai Program)  :  History For Social Communication | ประวัติศาสตร์เพื่อการสื่อสารสังคม | 社会传播史"
    },
    {
        "id":7778,
        "name":"8285 (English Program)  :  History For Social Communication | ประวัติศาสตร์เพื่อการสื่อสารทางสังคม | 社交传播的历史"
    },
    {
        "id":7779,
        "name":"8286 (Thai Program)  :  Integrated Engineering | วิศวกรรมบูรณาการ | 综合工程"
    },
    {
        "id":7780,
        "name":"8287 (English Program)  :  Integrated Engineering | วิศวกรรมบูรณาการ | 综合工程"
    },
    {
        "id":7781,
        "name":"8288 (English Program)  :  Game And E-Sports Business Management | การจัดการธุรกิจเกมและอีสปอร์ต | 游戏及电子竞技业务管理"
    },
    {
        "id":7782,
        "name":"8289 (Thai Program)  :  Digital Games | ดิจิทัลเกม | 数字游戏"
    },
    {
        "id":7783,
        "name":"8290 (English Program)  :  Digital Game | เกมดิจิทัล | 数字游戏"
    },
    {
        "id":7784,
        "name":"8291 (Thai Program)  :  Marine Science And Coastal Management | วิทยาศาสตร์ทางทะเลและการจัดการชายฝั่ง | 海洋科学与海岸管理"
    },
    {
        "id":7785,
        "name":"8292 (English Program)  :  Marine Science And Coastal Management | วิทยาศาสตร์ทางทะเลและการจัดการชายฝั่ง | 海洋科学和海岸管理"
    },
    {
        "id":7786,
        "name":"8293 (Thai Program)  :  Innovation In Human And Organizational Development | นวัตกรรมการพัฒนามนุษย์และองค์การ | 人力和组织发展的创新"
    },
    {
        "id":7787,
        "name":"8294 (English Program)  :  Human And Organization Development Innovation | นวัตกรรมการพัฒนามนุษย์และองค์กร | 人类和组织发展创新"
    },
    {
        "id":7788,
        "name":"8295 (Thai Program)  :  Earth System Science | วิทยาศาสตร์ระบบโลก | 地球系统科学"
    },
    {
        "id":7789,
        "name":"8296 (English Program)  :  Earth System Science | วิทยาศาสตร์ระบบโลก | 地球系统科学"
    },
    {
        "id":7790,
        "name":"8297 (Thai Program)  :  Modern Administration And Management | การบริหารและการจัดการสมัยใหม่ | 现代行政管理"
    },
    {
        "id":7791,
        "name":"8298 (English Program)  :  Modern Administration And Management | การบริหารและการจัดการที่ทันสมัย | 现代行政管理"
    },
    {
        "id":7792,
        "name":"8299 (Thai Program)  :  Creative Industries Music And Performing Arts | อุตสาหกรรมสร้างสรรค์ การดนตรีและศิลปะการแสดง | 创意产业音乐和表演艺术"
    },
    {
        "id":7793,
        "name":"8300 (English Program)  :  Music And Performing Arts Creative Industry | อุตสาหกรรมสร้างสรรค์ดนตรีและศิลปะการแสดง | 音乐及演艺创意产业"
    },
    {
        "id":7794,
        "name":"8301 (Thai Program)  :  Innovative Engineering Technology For Sustainability | เทคโนโลยีวิศวกรรมนวัตกรรมเพื่อความยั่งยืน | 可持续发展的创新工程技术"
    },
    {
        "id":7795,
        "name":"8302 (Thai Program)  :  Technology For Producing Local Community Products | วิทยาการการผลิตผลิตภัณฑ์ชุมชนท้องถิ่น | 生产当地社区产品的技术"
    },
    {
        "id":7796,
        "name":"8303 (English Program)  :  Production Of Local Community Products Science | วิทยาศาสตร์การผลิตผลิตภัณฑ์ชุมชนท้องถิ่น | 当地社区产品科学生产"
    },
    {
        "id":7797,
        "name":"8304 (Thai Program)  :  Computer Science And Software Development Innovation | วิทยาการคอมพิวเตอร์และนวัตกรรมการพัฒนาซอฟต์แวร์ | 计算机科学与软件开发创新"
    },
    {
        "id":7798,
        "name":"8305 (English Program)  :  Computer Science And Software Development Innovation | นวัตกรรมวิทยาศาสตร์คอมพิวเตอร์และการพัฒนาซอฟต์แวร์ | 计算机科学和软件开发创新"
    },
    {
        "id":7799,
        "name":"8306 (Thai Program)  :  Primary Health System Management | การจัดการระบบสุขภาพปฐมภูมิ | 初级卫生系统管理"
    },
    {
        "id":7800,
        "name":"8307 (English Program)  :  Primary Care System Management | การจัดการระบบการดูแลเบื้องต้น | 初级保健系统管理"
    },
    {
        "id":7801,
        "name":"8308 (Thai Program)  :  Creative Service Business Management | การจัดการธุรกิจบริการเชิงสร้างสรรค์ | 创意服务企业管理"
    },
    {
        "id":7802,
        "name":"8309 (English Program)  :  Creative Service-Business Management | การบริหารธุรกิจบริการเชิงสร้างสรรค์ | 创意服务-商业管理"
    },
    {
        "id":7803,
        "name":"8310 (Thai Program)  :  Business Analysis And Data Science | การวิเคราะห์ธุรกิจและวิทยาการข้อมูล | 商业分析和数据科学"
    },
    {
        "id":7804,
        "name":"8311 (English Program)  :  Business Analytics And Data Science | การวิเคราะห์ธุรกิจและวิทยาศาสตร์ข้อมูล | 商业分析和数据科学"
    },
    {
        "id":7805,
        "name":"8312 (Thai Program)  :  Thai Massage | การนวดไทย | 泰式按摩"
    },
    {
        "id":7806,
        "name":"8313 (English Program)  :  Thai Massage | นวดแผนไทย | 泰式按摩"
    },
    {
        "id":7807,
        "name":"8314 (English Program)  :  Eastern Languages | ภาษาตะวันออก | 东方语言"
    },
    {
        "id":7808,
        "name":"8315 (Thai Program)  :  Golf Industry Management | การบริหารอุตสาหกรรมกอล์ฟ | 高尔夫产业管理"
    },
    {
        "id":7809,
        "name":"8316 (English Program)  :  Golf Industry Administration | การบริหารอุตสาหกรรมกอล์ฟ | 高尔夫行业管理局"
    },
    {
        "id":7810,
        "name":"8317 (Thai Program)  :  Golf | กีฬากอล์ฟ | 高尔夫球"
    },
    {
        "id":7811,
        "name":"8318 (English Program)  :  Golf | กอล์ฟ | 高尔夫球"
    },
    {
        "id":7812,
        "name":"8319 (Thai Program)  :  Electrical Technology Engineering | วิศวกรรมเทคโนโลยีไฟฟ้า | 电气技术工程"
    },
    {
        "id":7813,
        "name":"8320 (Thai Program)  :  Electronic Engineering And Photonics | วิศวกรรมอิเล็กทรอนิกส์และโฟตอนนิกส์ | 电子工程和光子学"
    },
    {
        "id":7814,
        "name":"8321 (English Program)  :  Electronic And Photonic Engineering | วิศวกรรมอิเล็กทรอนิกส์และโฟโตนิก | 电子与光子工程"
    },
    {
        "id":7815,
        "name":"8322 (Thai Program)  :  Business Management And Innovation | การจัดการธุรกิจและนวัตกรรม | 企业管理与创新"
    },
    {
        "id":7816,
        "name":"8323 (English Program)  :  Business And Innovation Management | การจัดการธุรกิจและนวัตกรรม | 商业与创新管理"
    },
    {
        "id":7817,
        "name":"8324 (Thai Program)  :  Smart Material Technology | เทคโนโลยีวัสดุชาญฉลาด | 智能材料技术"
    },
    {
        "id":7818,
        "name":"8325 (English Program)  :  Smart Materials Technology | เทคโนโลยีวัสดุอัจฉริยะ | 智能材料技术"
    },
    {
        "id":7819,
        "name":"8326 (Thai Program)  :  Digital Business Management | การจัดการธุรกิจดิจิทัล | 数字化企业管理"
    },
    {
        "id":7820,
        "name":"8327 (English Program)  :  Digital Business Management | การจัดการธุรกิจดิจิทัล | 数字化业务管理"
    },
    {
        "id":7821,
        "name":"8328 (Thai Program)  :  Hospital Service Management | การจัดการงานบริการสถานพยาบาล | 医院服务管理"
    },
    {
        "id":7822,
        "name":"8329 (English Program)  :  Hospital Service Management | การจัดการบริการโรงพยาบาล | 医院服务管理"
    },
    {
        "id":7823,
        "name":"8330 (Thai Program)  :  Herbal Products Hemp And Cannabis | ผลิตภัณฑ์สมุนไพร กัญชงและกัญชา | 草药产品大麻和大麻"
    },
    {
        "id":7824,
        "name":"8331 (English Program)  :  Herb, Hemp And Cannabis Products | ผลิตภัณฑ์สมุนไพร กัญชง และกัญชา | 药草、大麻和大麻产品"
    },
    {
        "id":7825,
        "name":"8332 (Thai Program)  :  Innovation And Security Technology | นวัตกรรมและเทคโนโลยีความมั่นคง | 创新与安全技术"
    },
    {
        "id":7826,
        "name":"8333 (English Program)  :  Security Innovation And Technology | นวัตกรรมและเทคโนโลยีด้านความปลอดภัย | 安全创新与技术"
    },
    {
        "id":7827,
        "name":"8334 (Thai Program)  :  Innovative Plants | พฤกษนวัตกรรม | 创新植物"
    },
    {
        "id":7828,
        "name":"8335 (English Program)  :  Innovative Botany | นวัตกรรมพฤกษศาสตร์ | 创新植物学"
    },
    {
        "id":7829,
        "name":"8336 (English Program)  :  Energy | พลังงาน | 活力"
    },
    {
        "id":7830,
        "name":"8337 (Thai Program)  :  Energy | พลังงาน | 活力"
    },
    {
        "id":7831,
        "name":"8338 (Thai Program)  :  Integrated Product Design Innovation | นวัตกรรมการออกแบบผลิตภัณฑ์เชิงบูรณาการ | 集成产品设计创新"
    },
    {
        "id":7832,
        "name":"8339 (English Program)  :  Integrated Product Design Innovation | นวัตกรรมการออกแบบผลิตภัณฑ์แบบบูรณาการ | 综合产品设计创新"
    },
    {
        "id":7833,
        "name":"8340 (Thai Program)  :  Petroleum And Natural Gas Engineering | วิศวกรรมปิโตรเลียมและก๊าซธรรมชาติ | 石油天然气工程"
    },
    {
        "id":7834,
        "name":"8341 (English Program)  :  Petroleum And Natural Gas Engineering | วิศวกรรมปิโตรเลียมและก๊าซธรรมชาติ | 石油天然气工程"
    },
    {
        "id":7835,
        "name":"8342 (Thai Program)  :  Creative Products | ผลิตภัณฑ์สร้างสรรค์ | 创意产品"
    },
    {
        "id":7836,
        "name":"8343 (English Program)  :  Creative Products | ผลิตภัณฑ์ที่สร้างสรรค์ | 创意产品"
    },
    {
        "id":7837,
        "name":"8344 (Thai Program)  :  Fashion, Textiles And Decorations | แฟชั่น สิ่งทอ และเครื่องตกแต่ง | 时装、纺织品和装饰品"
    },
    {
        "id":7838,
        "name":"8345 (English Program)  :  Fashion, Textiles And Accessories | แฟชั่น สิ่งทอ และเครื่องประดับ | 时装、纺织品及配饰"
    },
    {
        "id":7839,
        "name":"8346 (Thai Program)  :  Innovation In Arts And Culture Management | นวัตกรรมการจัดการศิลปวัฒนธรรม | 艺术文化管理创新"
    },
    {
        "id":7840,
        "name":"8347 (English Program)  :  Arts And Cultural Management Innovation | นวัตกรรมการจัดการศิลปะและวัฒนธรรม | 艺术文化管理创新"
    },
    {
        "id":7841,
        "name":"8348 (Thai Program)  :  Social Management | การจัดการทางสังคม | 社会管理"
    },
    {
        "id":7842,
        "name":"8349 (English Program)  :  Social Management | การจัดการทางสังคม | 社会管理"
    },
    {
        "id":7843,
        "name":"8350 (English Program)  :  Science Of Pharmaceutical Products | วิทยาศาสตร์ของผลิตภัณฑ์เภสัชกรรม | 药品科学"
    },
    {
        "id":7844,
        "name":"8351 (Thai Program)  :  Creative Brand Management | การจัดการตราสินค้าสร้างสรรค์ | 创意品牌管理"
    },
    {
        "id":7845,
        "name":"8352 (English Program)  :  Creative Brand Management | การจัดการแบรนด์ที่สร้างสรรค์ | 创意品牌管理"
    },
    {
        "id":7846,
        "name":"8353 (Thai Program)  :  Innovation In Anatomy | นวัตกรรมทางกายวิภาคศาสตร์ | 解剖学创新"
    },
    {
        "id":7847,
        "name":"8354 (English Program)  :  Innovative Anatomy | นวัตกรรมกายวิภาคศาสตร์ | 创新解剖学"
    },
    {
        "id":7848,
        "name":"8355 (Thai Program)  :  Safety Engineering And Computer Forensics | วิศวกรรมด้านความปลอดภัย และการพิสูจน์หลักฐานทางคอมพิวเตอร์ | 安全工程和计算机取证"
    },
    {
        "id":7849,
        "name":"8356 (English Program)  :  Computer Security And Forensics Computing Engineering | ความปลอดภัยทางคอมพิวเตอร์และวิศวกรรมคอมพิวเตอร์นิติวิทยาศาสตร์ | 计算机安全和取证计算工程"
    },
    {
        "id":7850,
        "name":"8357 (Thai Program)  :  Service Innovation Management | การจัดการนวัตกรรมการบริการ | 服务创新管理"
    },
    {
        "id":7851,
        "name":"8358 (Thai Program)  :  Medical Services | การบริการทางการแพทย์ | 医疗服务"
    },
    {
        "id":7852,
        "name":"8359 (English Program)  :  Medical Services | บริการทางการแพทย์ | 医疗服务"
    },
    {
        "id":7853,
        "name":"8360 (English Program)  :  Thai Traditional Pharmacy | ร้านขายยาแผนไทย | 泰国传统药房"
    },
    {
        "id":7854,
        "name":"8361 (Thai Program)  :  Vietnamese And English | ภาษาเวียดนามและภาษาอังกฤษ | 越南语和英语"
    },
    {
        "id":7855,
        "name":"8362 (English Program)  :  Vietnamese And English | ภาษาเวียดนามและภาษาอังกฤษ | 越南语和英语"
    },
    {
        "id":7856,
        "name":"8363 (Thai Program)  :  Learning Management Science | วิทยาการจัดการเรียนรู้ | 学习管理科学"
    },
    {
        "id":7857,
        "name":"8364 (English Program)  :  Learning Management Science | วิทยาศาสตร์การจัดการการเรียนรู้ | 学习管理科学"
    },
    {
        "id":7858,
        "name":"8365 (Thai Program)  :  Product Design And Graphic Design | ออกแบบผลิตภัณฑ์และกราฟิกดีไซน์ | 产品设计和平面设计"
    },
    {
        "id":7859,
        "name":"8366 (English Program)  :  Industrial Education Program In Product And Graphic Design | โปรแกรมการศึกษาอุตสาหกรรมด้านผลิตภัณฑ์และการออกแบบกราฟิก | 产品和平面设计工业教育课程"
    },
    {
        "id":7860,
        "name":"8367 (Thai Program)  :  Creative Product Innovation | นวัตกรรมผลิตภัณฑ์สร้างสรรค์ | 创意产品创新"
    },
    {
        "id":7861,
        "name":"8368 (English Program)  :  Creative Product Innovation | นวัตกรรมผลิตภัณฑ์ที่สร้างสรรค์ | 创意产品创新"
    },
    {
        "id":7862,
        "name":"8369 (Thai Program)  :  Communication And Innovation Strategies | กลยุทธ์การสื่อสารและการคิดค้นสิ่งใหม่ | 沟通和创新策略"
    },
    {
        "id":7863,
        "name":"8370 (English Program)  :  Communication Strategy And Ideation | กลยุทธ์การสื่อสารและความคิด | 沟通策略和创意"
    },
    {
        "id":7864,
        "name":"8371 (Thai Program)  :  Modern Vehicles And Automation | ยานยานยนต์สมัยใหม่และระบบอัตโนมัติ | 现代车辆和自动化"
    },
    {
        "id":7865,
        "name":"8372 (English Program)  :  Next Generation Automotive And Automation System Technology | เทคโนโลยีระบบยานยนต์และระบบอัตโนมัติแห่งอนาคต | 下一代汽车和自动化系统技术"
    },
    {
        "id":7866,
        "name":"8373 (Thai Program)  :  Communication Arts, Innovation And Entrepreneurship | นิเทศศาสตร์นวัตกรรมและผู้ประกอบการธุรกิจ | 传播艺术、创新创业"
    },
    {
        "id":7867,
        "name":"8374 (English Program)  :  Innovative Communication Arts And Entrepreneurs | นวัตกรรมศิลปะการสื่อสารและผู้ประกอบการ | 创新传播艺术与企业家"
    },
    {
        "id":7868,
        "name":"8375 (Thai Program)  :  Government And Private Sector Communication Innovations | นวัตกรรมการสื่อสารภาครัฐและภาคเอกชน | 政府和私营部门的沟通创新"
    },
    {
        "id":7869,
        "name":"8376 (English Program)  :  Innovative Communication For Public And Private Sectors | นวัตกรรมการสื่อสารสำหรับภาครัฐและเอกชน | 公共和私营部门的创新通信"
    },
    {
        "id":7870,
        "name":"8377 (Thai Program)  :  Trade Management | การจัดการการค้า | 贸易管理"
    },
    {
        "id":7871,
        "name":"8378 (English Program)  :  Trade Management | การจัดการการค้า | 贸易管理"
    },
    {
        "id":7872,
        "name":"8379 (Thai Program)  :  Esports Management | การจัดการอีสปอร์ต | 电竞管理"
    },
    {
        "id":7873,
        "name":"8380 (English Program)  :  Esports Management | การจัดการอีสปอร์ต | 电子竞技管理"
    },
    {
        "id":7874,
        "name":"8381 (Thai Program)  :  Logistics Management For Online Businesses | การจัดการโลจิสติกส์สำหรับธุรกิจออนไลน์ | 在线业务的物流管理"
    },
    {
        "id":7875,
        "name":"8382 (English Program)  :  Logistics Management For Online Business | การจัดการโลจิสติกส์สำหรับธุรกิจออนไลน์ | 在线业务的物流管理"
    },
    {
        "id":7876,
        "name":"8383 (Thai Program)  :  Digital Business And Financial Technology | ธุรกิจดิจิทัลและเทคโนโลยีทางการเงิน | 数字商业和金融技术"
    },
    {
        "id":7877,
        "name":"8384 (English Program)  :  Digital Business And Financial Technology | ธุรกิจดิจิทัลและเทคโนโลยีทางการเงิน | 数字商业和金融技术"
    },
    {
        "id":7878,
        "name":"8385 (Thai Program)  :  Innovation And Design Base Entrepreneur | ผู้ประกอบการฐานนวัตกรรมและการออกแบบ | 创新设计基地企业家"
    },
    {
        "id":7879,
        "name":"8386 (English Program)  :  Innovative And Design Entrepreneur | ผู้ประกอบการด้านนวัตกรรมและการออกแบบ | 创新和设计企业家"
    },
    {
        "id":7880,
        "name":"8387 (Thai Program)  :  Aviation And Air Transportation Business | ธุรกิจการบินและการขนส่งทางอากาศ | 航空及航空运输业务"
    },
    {
        "id":7881,
        "name":"8388 (English Program)  :  Aviation Business And Air Transportation | ธุรกิจการบินและการขนส่งทางอากาศ | 航空商务和航空运输"
    },
    {
        "id":7882,
        "name":"8389 (Thai Program)  :  International Business China-Asean Business | ธุรกิจระหว่างประเทศ ธุรกิจจีน-อาเซียน | 国际业务中国-东盟业务"
    },
    {
        "id":7883,
        "name":"8390 (English Program)  :  Lnternational Business China-Asean Business | ธุรกิจระหว่างประเทศ ธุรกิจจีน-อาเซียน | 国际业务 中国-东盟业务"
    },
    {
        "id":7884,
        "name":"8391 (Thai Program)  :  Law And Administration | กฎหมายกับการบริหาร | 法律与行政"
    },
    {
        "id":7885,
        "name":"8392 (English Program)  :  Law And Administration | กฎหมายและการบริหาร | 法律与行政"
    },
    {
        "id":7886,
        "name":"8393 (Thai Program)  :  Mechanical Engineering Studies | วิศวกรรมเครื่องกลศึกษา | 机械工程研究"
    },
    {
        "id":7887,
        "name":"8394 (English Program)  :  Mechanical Engineering Education | การศึกษาวิศวกรรมเครื่องกล | 机械工程教育"
    },
    {
        "id":7888,
        "name":"8395 (Thai Program)  :  Innovation And Industrial Management | การจัดการนวัตกรรมและอุตสาหกรรม | 创新与产业管理"
    },
    {
        "id":7889,
        "name":"8396 (English Program)  :  Innovation And Industrial Management | นวัตกรรมและการจัดการอุตสาหกรรม | 创新与产业管理"
    },
    {
        "id":7890,
        "name":"8397 (Thai Program)  :  Human Resource Development And Management | การพัฒนาทรัพยากรมนุษย์และการจัดการ | 人力资源开发与管理"
    },
    {
        "id":7891,
        "name":"8398 (English Program)  :  Human Resource Development And Management | การพัฒนาและการจัดการทรัพยากรมนุษย์ | 人力资源开发与管理"
    },
    {
        "id":7892,
        "name":"8399 (Thai Program)  :  Politics And Local Government | การเมืองและการปกครองท้องถิ่น | 政治和地方政府"
    },
    {
        "id":7893,
        "name":"8400 (English Program)  :  Politics And Local Governance | การเมืองและการปกครองท้องถิ่น | 政治和地方治理"
    },
    {
        "id":7894,
        "name":"8401 (Thai Program)  :  Government And Public Law | การปกครองและกฎหมายมหาชน | 政府和公法"
    },
    {
        "id":7895,
        "name":"8402 (English Program)  :  Government And Public Law | รัฐบาลและกฎหมายมหาชน | 政府和公法"
    },
    {
        "id":7896,
        "name":"8403 (Thai Program)  :  Precision Agriculture | เกษตรแม่นยำ | 精准农业"
    },
    {
        "id":7897,
        "name":"8404 (English Program)  :  Precision Agriculture | การเกษตรที่แม่นยำ | 精准农业"
    },
    {
        "id":7898,
        "name":"8405 (Thai Program)  :  Medical Emergency | ฉุกเฉินการแพทย์ | 医疗紧急情况"
    },
    {
        "id":7899,
        "name":"8406 (English Program)  :  Paramedicine | แพทย์ | 辅助医学"
    },
    {
        "id":7900,
        "name":"8407 (Thai Program)  :  Medical Equipment And Operating Room Technology | เทคโนโลยีเครื่องมือแพทย์และห้องผ่าตัด | 医疗设备和手术室技术"
    },
    {
        "id":7901,
        "name":"8408 (English Program)  :  Medical Instruments And Operating Room Technology | เครื่องมือแพทย์และเทคโนโลยีห้องผ่าตัด | 医疗器械和手术室技术"
    },
    {
        "id":7902,
        "name":"8409 (Thai Program)  :  Disaster Management | การจัดการสาธารณภัย | 灾害管理"
    },
    {
        "id":7903,
        "name":"8410 (English Program)  :  Disaster Management | การจัดการภัยพิบัติ | 灾害管理"
    },
    {
        "id":7904,
        "name":"8411 (Thai Program)  :  Mechanical Technology And Production Processes | เทคโนโลยีเครื่องกลและกระบวนการผลิต | 机械技术和生产工艺"
    },
    {
        "id":7905,
        "name":"8412 (English Program)  :  Mechanical And Manufacturing Technology | เทคโนโลยีเครื่องกลและการผลิต | 机械和制造技术"
    },
    {
        "id":7906,
        "name":"8413 (Thai Program)  :  Electrical Engineering And Energy Management | วิศวกรรมไฟฟ้าและการจัดการพลังงาน | 电气工程和能源管理"
    },
    {
        "id":7907,
        "name":"8414 (English Program)  :  Electrical Engineering And Energy Management | วิศวกรรมไฟฟ้าและการจัดการพลังงาน | 电气工程和能源管理"
    },
    {
        "id":7908,
        "name":"8415 (Thai Program)  :  Digital Innovation And Intelligent Control System | นวัตกรรมดิจิทัลและระบบควบคุมอัจฉริยะ | 数字化创新与智能控制系统"
    },
    {
        "id":7909,
        "name":"8416 (English Program)  :  Innovation Digital And Intelligence Control System | นวัตกรรมระบบควบคุมดิจิทัลและอัจฉริยะ | 创新数字化智能控制系统"
    },
    {
        "id":7910,
        "name":"8417 (English Program)  :  Renewable Energy Technology | เทคโนโลยีพลังงานทดแทน | 可再生能源技术"
    },
    {
        "id":7911,
        "name":"8418 (Thai Program)  :  Renewable Energy Technology | เทคโนโลยีพลังงานทดแทน | 可再生能源技术"
    },
    {
        "id":7912,
        "name":"8419 (Thai Program)  :  Cosmetic Technology And Dietary Supplements | เทคโนโลยีเครื่องสำอางและผลิตภัณฑ์เสริมอาหาร | 化妆品技术和膳食补充剂"
    },
    {
        "id":7913,
        "name":"8420 (English Program)  :  Cosmetic Technology And Dietary Supplement Products | เทคโนโลยีเครื่องสำอางและผลิตภัณฑ์เสริมอาหาร | 美容技术和膳食补充剂产品"
    },
    {
        "id":7914,
        "name":"8421 (English Program)  :  Innovation Technology For Modern Business | เทคโนโลยีนวัตกรรมเพื่อธุรกิจยุคใหม่ | 现代商业的创新技术"
    },
    {
        "id":7915,
        "name":"8422 (Thai Program)  :  Innovative Technology For Modern Business | เทคโนโลยีนวัตกรรมสำหรับธุรกิจสมัยใหม่ | 现代商业的创新技术"
    },
    {
        "id":7916,
        "name":"8423 (Thai Program)  :  Agro-Industrial Technology And Innovation | เทคโนโลยีอุตสาหกรรมเกษตรและนวัตกรรม | 农业工业技术与创新"
    },
    {
        "id":7917,
        "name":"8424 (English Program)  :  Agro-Industrial Technology And Innovation | เทคโนโลยีและนวัตกรรมอุตสาหกรรมเกษตร | 农业工业技术与创新"
    },
    {
        "id":7918,
        "name":"8425 (Thai Program)  :  Innovation And Creative Marketing | นวัตกรรมและการตลาดเชิงสร้างสรรค์ | 创新和创意营销"
    },
    {
        "id":7919,
        "name":"8426 (English Program)  :  Innovation And Creative Marketing | นวัตกรรมและการตลาดเชิงสร้างสรรค์ | 创新与创意营销"
    },
    {
        "id":7920,
        "name":"8427 (English Program)  :  Food Innovation | นวัตกรรมอาหาร | 食品创新"
    },
    {
        "id":7921,
        "name":"8428 (Thai Program)  :  Food Innovation | นวัตกรรมอาหาร | 食品创新"
    },
    {
        "id":7922,
        "name":"8429 (English Program)  :  Artificial Intelligence | ปัญญาประดิษฐ์ | 人工智能"
    },
    {
        "id":7923,
        "name":"8430 (Thai Program)  :  Innovation And Food Business | นวัตกรรมและธุรกิจอาหาร | 创新与食品业务"
    },
    {
        "id":7924,
        "name":"8431 (English Program)  :  Food Innovation And Business | นวัตกรรมอาหารและธุรกิจ | 食品创新与商业"
    },
    {
        "id":7925,
        "name":"8432 (Thai Program)  :  Nutrition And Cooking For Enhancing Performance And Delaying Aging. | โภชนาการและการประกอบอาหารเพื่อการสร้างเสริมสมรรถภาพและการชะลอวัย | 提高性能和延缓衰老的营养和烹饪。"
    },
    {
        "id":7926,
        "name":"8433 (English Program)  :  Nutrition And Culinary Arts For Health Capability And Anti-Aging Wellness | โภชนาการและศิลปะการประกอบอาหารเพื่อสุขภาพที่ดีและการชะลอวัย | 营养和烹饪艺术促进健康能力和抗衰老健康"
    },
    {
        "id":7927,
        "name":"8434 (Thai Program)  :  Health And Beauty Products | ผลิตภัณฑ์เพื่อสุขภาพและความงาม | 健康及美容产品"
    },
    {
        "id":7928,
        "name":"8435 (English Program)  :  Products For Health And Beauty | ผลิตภัณฑ์เพื่อสุขภาพและความงาม | 健康与美丽产品"
    },
    {
        "id":7929,
        "name":"8436 (Thai Program)  :  Innovative Materials For Industry | นวัตกรรมวัสดุเพื่ออุตสาหกรรม | 工业创新材料"
    },
    {
        "id":7930,
        "name":"8437 (English Program)  :  Materials Innovation For Industry | นวัตกรรมวัสดุเพื่ออุตสาหกรรม | 工业材料创新"
    },
    {
        "id":7931,
        "name":"8438 (Thai Program)  :  Data Science And Analytics | วิทยาการข้อมูลและการวิเคราะห์ | 数据科学与分析"
    },
    {
        "id":7932,
        "name":"8439 (English Program)  :  Data Science And Analytics | วิทยาศาสตร์ข้อมูลและการวิเคราะห์ | 数据科学与分析"
    },
    {
        "id":7933,
        "name":"8440 (Thai Program)  :  Data Science And Information Management | วิทยาการข้อมูลและการจัดการสารสนเทศ | 数据科学与信息管理"
    },
    {
        "id":7934,
        "name":"8441 (English Program)  :  Data Science And Information Management | วิทยาศาสตร์ข้อมูลและการจัดการสารสนเทศ | 数据科学和信息管理"
    },
    {
        "id":7935,
        "name":"8442 (Thai Program)  :  Sports Science And Health Promotion | วิทยาศาสตร์การกีฬาและส่งเสริมสุขภาพ | 运动科学与健康促进"
    },
    {
        "id":7936,
        "name":"8443 (English Program)  :  Sports Science And Health Promotion | วิทยาศาสตร์การกีฬาและการส่งเสริมสุขภาพ | 体育科学与健康促进"
    },
    {
        "id":7937,
        "name":"8444 (Thai Program)  :  Data Science And Information Technology | วิทยาการข้อมูลและเทคโนโลยีสารสนเทศ | 数据科学与信息技术"
    },
    {
        "id":7938,
        "name":"8445 (English Program)  :  Data Science And Information Technology | วิทยาศาสตร์ข้อมูลและเทคโนโลยีสารสนเทศ | 数据科学与信息技术"
    },
    {
        "id":7939,
        "name":"8446 (Thai Program)  :  Food Processing And Cooking Science | วิทยาการแปรรูปและการประกอบอาหาร | 食品加工和烹饪科学"
    },
    {
        "id":7940,
        "name":"8447 (English Program)  :  Food Processing And Culinary Scienc | การแปรรูปอาหารและวิทยาศาสตร์การประกอบอาหาร | 食品加工和烹饪科学"
    },
    {
        "id":7941,
        "name":"8448 (Thai Program)  :  Data Management Science | วิทยาการการจัดการข้อมูล | 数据管理科学"
    },
    {
        "id":7942,
        "name":"8449 (English Program)  :  Data Science Management | การจัดการวิทยาศาสตร์ข้อมูล | 数据科学管理"
    },
    {
        "id":7943,
        "name":"8450 (Thai Program)  :  Movement Science And Health | วิทยาศาสตร์การเคลื่อนไหวและสุขภาพ | 运动科学与健康"
    },
    {
        "id":7944,
        "name":"8451 (English Program)  :  Human Kinetics And Health | จลนศาสตร์ของมนุษย์และสุขภาพ | 人体动力学与健康"
    },
    {
        "id":7945,
        "name":"8452 (Thai Program)  :  Computer Science And Technology | วิทยาศาสตร์และเทคโนโลยีคอมพิวเตอร์ | 计算机科学与技术"
    },
    {
        "id":7946,
        "name":"8453 (Thai Program)  :  Data Science And Statistical Analysis | วิทยาศาสตร์ข้อมูลและการวิเคราะห์เชิงสถิติ | 数据科学与统计分析"
    },
    {
        "id":7947,
        "name":"8454 (English Program)  :  Statistical Data Science And Analytics | วิทยาศาสตร์ข้อมูลทางสถิติและการวิเคราะห์ | 统计数据科学与分析"
    },
    {
        "id":7948,
        "name":"8455 (Thai Program)  :  Culinary Science And Food Service Management | วิทยาศาสตร์การประกอบอาหารและการจัดการการบริการอาหาร | 烹饪科学和餐饮服务管理"
    },
    {
        "id":7949,
        "name":"8456 (English Program)  :  Culinary Science And Foodservice Management | วิทยาศาสตร์การทำอาหารและการจัดการบริการอาหาร | 烹饪科学和餐饮服务管理"
    },
    {
        "id":7950,
        "name":"8457 (Thai Program)  :  Cosmetic And Beauty Science | วิทยาศาสตร์เครื่องสำอางและความงาม | 化妆品与美容科学"
    },
    {
        "id":7951,
        "name":"8458 (Thai Program)  :  Cooking Industry | อุตสาหกรรมการประกอบอาหาร | 烹饪业"
    },
    {
        "id":7952,
        "name":"8459 (English Program)  :  Culinary Industry | อุตสาหกรรมการทำอาหาร | 烹饪业"
    },
    {
        "id":7953,
        "name":"8460 (Thai Program)  :  Civil Engineering And Construction Management | วิศวกรรมโยธาและบริหารงานก่อสร้าง | 土木工程与施工管理"
    },
    {
        "id":7954,
        "name":"8461 (English Program)  :  Civil And Construction Management Engineering | วิศวกรรมโยธาและการจัดการการก่อสร้าง | 土木与建筑管理工程"
    },
    {
        "id":7955,
        "name":"8462 (Thai Program)  :  Health Data Science | วิทยาศาสตร์ข้อมูลสุขภาพ | 健康数据科学"
    },
    {
        "id":7956,
        "name":"8463 (English Program)  :  Health Data Science | วิทยาศาสตร์ข้อมูลสุขภาพ | 健康数据科学"
    },
    {
        "id":7957,
        "name":"8464 (Thai Program)  :  Occupational Health And Safety In Healthcare Facilities | อาชีวอนามัยและความปลอดภัยในสถานพยาบาล | 医疗机构的职业健康和安全"
    },
    {
        "id":7958,
        "name":"8465 (English Program)  :  Occupational Health And Hospital Safety | อาชีวอนามัยและความปลอดภัยในโรงพยาบาล | 职业健康和医院安全"
    },
    {
        "id":7959,
        "name":"8466 (Thai Program)  :  Technology, Entrepreneurship And Innovation Management | เทคโนโลยีผู้ประกอบการและการจัดการนวัตกรรม | 技术、创业与创新管理"
    },
    {
        "id":7960,
        "name":"8467 (English Program)  :  Entrepreneur Technology And Innovation Management | เทคโนโลยีผู้ประกอบการและการจัดการนวัตกรรม | 企业家技术与创新管理"
    },
    {
        "id":7961,
        "name":"8468 (Thai Program)  :  Dermatology And Dermatology | ตจวิทยาและตจศัลยศาสตร์ | 皮肤科和皮肤科"
    },
    {
        "id":7962,
        "name":"8469 (English Program)  :  Dermatology And Dermatosurgery | โรคผิวหนังและศัลยกรรมผิวหนัง | 皮肤病学和皮肤外科"
    },
    {
        "id":7963,
        "name":"8470 (Thai Program)  :  Automotive And Energy Engineering Technology | เทคโนโลยีวิศวกรรมยานยนต์และพลังงาน | 汽车与能源工程技术"
    },
    {
        "id":7964,
        "name":"8471 (English Program)  :  Automotive And Energy Engineering Technology | เทคโนโลยีวิศวกรรมยานยนต์และพลังงาน | 汽车与能源工程技术"
    },
    {
        "id":7965,
        "name":"8472 (Thai Program)  :  Technology For Learning And Innovation | เทคโนโลยีเพื่อการเรียนรู้และนวัตกรรม | 用于学习和创新的技术"
    },
    {
        "id":7966,
        "name":"8473 (English Program)  :  Technology-Enhanced Learning And Innovation | การเรียนรู้และนวัตกรรมที่เสริมด้วยเทคโนโลยี | 技术增强学习和创新"
    },
    {
        "id":7967,
        "name":"8474 (Thai Program)  :  High Precision Manufacturing Engineering | วิศวกรรมการผลิตความแม่นยำสูง | 高精密制造工程"
    },
    {
        "id":7968,
        "name":"8475 (English Program)  :  High Precision Manufacturing Engineering | วิศวกรรมการผลิตที่มีความแม่นยำสูง | 高精度制造工程"
    },
    {
        "id":7969,
        "name":"8476 (Thai Program)  :  Information And Network Engineering | วิศวกรรมสารสนเทศและเครือข่าย | 信息与网络工程"
    },
    {
        "id":7970,
        "name":"8477 (English Program)  :  Information And Network Engineering | วิศวกรรมสารสนเทศและเครือข่าย | 信息与网络工程"
    },
    {
        "id":7971,
        "name":"8478 (Thai Program)  :  Electrical Engineering And Education | วิศวกรรมไฟฟ้าและการศึกษา | 电气工程与教育"
    },
    {
        "id":7972,
        "name":"8479 (English Program)  :  Electrical Engineering And Education | วิศวกรรมไฟฟ้าและการศึกษา | 电气工程与教育"
    },
    {
        "id":7973,
        "name":"8480 (Thai Program)  :  Precision Engineering | วิศวกรรมพรีซิชั่น | 精密工程"
    },
    {
        "id":7974,
        "name":"8481 (Thai Program)  :  Mechatronics And Robotics Engineering | วิศวกรรมแมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人工程"
    },
    {
        "id":7975,
        "name":"8482 (Thai Program)  :  Management Of Creative Media And Cultural Production | การจัดการผลิตสื่อและวัฒนธรรมสร้างสรรค์ | 创意媒体和文化生产管理"
    },
    {
        "id":7976,
        "name":"8483 (English Program)  :  Media Production And Creative Culture Management | การผลิตสื่อและการจัดการวัฒนธรรมเชิงสร้างสรรค์ | 媒体制作与创意文化管理"
    },
    {
        "id":7977,
        "name":"8484 (Thai Program)  :  Digital Content Design | การออกแบบดิจิทัลคอนเทนต์ | 数字内容设计"
    },
    {
        "id":7978,
        "name":"8485 (English Program)  :  Digital Content Design | การออกแบบเนื้อหาดิจิทัล | 数字内容设计"
    },
    {
        "id":7979,
        "name":"8486 (Thai Program)  :  Industrial Engineering And Automation | วิศวกรรมอุตสาหการและระบบอัตโนมัติ | 工业工程与自动化"
    },
    {
        "id":7980,
        "name":"8487 (English Program)  :  Industrial Engineering And Automation System | วิศวกรรมอุตสาหการและระบบอัตโนมัติ | 工业工程及自动化系统"
    },
    {
        "id":7981,
        "name":"8488 (Thai Program)  :  Dance And Performing Arts | นาฏศิลป์และศิลปะการแสดง | 舞蹈和表演艺术"
    },
    {
        "id":7982,
        "name":"8489 (English Program)  :  Dancing And Performing Arts | การเต้นรำและศิลปะการแสดง | 舞蹈和表演艺术"
    },
    {
        "id":7983,
        "name":"8490 (Thai Program)  :  Robotics Engineering And Intelligent Electronics | วิศวกรรมหุ่นยนต์และอิเล็กทรอนิกส์อัจฉริยะ | 机器人工程与智能电子"
    },
    {
        "id":7984,
        "name":"8491 (English Program)  :  Robots And Smart Electronics Engineering | วิศวกรรมหุ่นยนต์และอิเล็กทรอนิกส์อัจฉริยะ | 机器人和智能电子工程"
    },
    {
        "id":7985,
        "name":"8492 (Thai Program)  :  Aviation Business Services | การบริการธุรกิจการบิน | 航空商务服务"
    },
    {
        "id":7986,
        "name":"8493 (English Program)  :  Aviation Business Servicesg | ธุรกิจบริการการบินจี | 航空商业服务Sg"
    },
    {
        "id":7987,
        "name":"8494 (Thai Program)  :  Early Childhood Development | การพัฒนาเด็กปฐมวัย | 儿童早期发展"
    },
    {
        "id":7988,
        "name":"8495 (Thai Program)  :  Digital Service Innovation | นวัตกรรมบริการดิจิทัล | 数字化服务创新"
    },
    {
        "id":7989,
        "name":"8496 (English Program)  :  Digital Service Innovation | นวัตกรรมการบริการดิจิทัล | 数字服务创新"
    },
    {
        "id":7990,
        "name":"8497 (Thai Program)  :  Tourism And Service Innovation | นวัตกรรมการท่องเที่ยวและการบริการ | 旅游与服务创新"
    },
    {
        "id":7991,
        "name":"8498 (English Program)  :  Tourism And Service Innovation | นวัตกรรมการท่องเที่ยวและการบริการ | 旅游与服务创新"
    },
    {
        "id":7992,
        "name":"8499 (Thai Program)  :  Social Entrepreneurship Innovation | นวัตกรรมการประกอบการทางสังคม | 社会创业创新"
    },
    {
        "id":7993,
        "name":"8500 (English Program)  :  Social Enterprise Innovation | นวัตกรรมองค์กรเพื่อสังคม | 社会企业创新"
    },
    {
        "id":7994,
        "name":"8501 (Thai Program)  :  Integrating Health, Beauty And Spa | บูรณาการสุขภาพ ความงาม และสปา | 集健康、美容、水疗于一体"
    },
    {
        "id":7995,
        "name":"8502 (English Program)  :  Integration Of Health, Aesthetics And Spa | การบูรณาการด้านสุขภาพ ความสวยงาม และสปา | 健康、美学与水疗的融合"
    },
    {
        "id":7996,
        "name":"8503 (Thai Program)  :  Chinese For Business | ภาษาจีนเพื่อธุรกิจ | 商务汉语"
    },
    {
        "id":7997,
        "name":"8504 (Thai Program)  :  Quran And As-Sunnah | อัลกุรอานและอัสสุนนะฮฺ | 《古兰经》和《圣训》"
    },
    {
        "id":7998,
        "name":"8505 (English Program)  :  Al-Quran And Al-Sunnah | อัลกุรอานและอัลซุนนะฮฺ | 《古兰经》和《圣行》"
    },
    {
        "id":7999,
        "name":"8506 (Thai Program)  :  Aviation Industry English | ภาษาอังกฤษอุตสาหกรรมการบิน | 航空工业英语"
    },
    {
        "id":8000,
        "name":"8507 (English Program)  :  Aviation Industry English | ภาษาอังกฤษอุตสาหกรรมการบิน | 航空业英语"
    },
    {
        "id":8001,
        "name":"8508 (Thai Program)  :  English For International Business | ภาษาอังกฤษเพื่อธุรกิจระหว่างประเทศ | 国际商务英语"
    },
    {
        "id":8002,
        "name":"8509 (English Program)  :  English For International Business | ภาษาอังกฤษเพื่อธุรกิจระหว่างประเทศ | 国际商务英语"
    },
    {
        "id":8003,
        "name":"8510 (Thai Program)  :  Teaching Islam | การสอนอิสลาม | 教导伊斯兰教"
    },
    {
        "id":8004,
        "name":"8511 (English Program)  :  Islamic Teaching | การสอนอิสลาม | 伊斯兰教义"
    },
    {
        "id":8005,
        "name":"8512 (Thai Program)  :  Educational Science And Innovation In Learning Management | วิทยาการทางการศึกษาและนวัตกรรมการจัดการเรียนรู้ | 教育科学与学习管理创新"
    },
    {
        "id":8006,
        "name":"8513 (English Program)  :  Educational Sciences And Innovation For Learning Management | วิทยาศาสตร์การศึกษาและนวัตกรรมเพื่อการจัดการเรียนรู้ | 教育科学与学习管理创新"
    },
    {
        "id":8007,
        "name":"8514 (Thai Program)  :  Modern Economics, Analysis And Evaluation | เศรษฐศาสตร์การวิเคราะห์และการประเมินสมัยใหม่ | 现代经济学、分析与评价"
    },
    {
        "id":8008,
        "name":"8515 (English Program)  :  Economics Of Modern Analysis And Evaluation | เศรษฐศาสตร์ของการวิเคราะห์และการประเมินสมัยใหม่ | 现代分析与评价经济学"
    },
    {
        "id":8009,
        "name":"8516 (Thai Program)  :  Industrial Innovation Management For The Environment | การจัดการนวัตกรรมอุตสาหกรรมเพื่อสิ่งแวดล้อม | 环境工业创新管理"
    },
    {
        "id":8010,
        "name":"8517 (English Program)  :  Industrial Innovation Management For Environment | การจัดการนวัตกรรมอุตสาหกรรมเพื่อสิ่งแวดล้อม | 环境工业创新管理"
    },
    {
        "id":8011,
        "name":"8518 (Thai Program)  :  Tourism, Hotel And Service Business Management | การจัดการการท่องเที่ยว โรงแรม และธุรกิจบริการ | 旅游、酒店及服务业管理"
    },
    {
        "id":8012,
        "name":"8519 (English Program)  :  Tourism, Hotel, And Service Business Management | การจัดการการท่องเที่ยว โรงแรม และธุรกิจบริการ | 旅游、酒店和服务业管理"
    },
    {
        "id":8013,
        "name":"8520 (Thai Program)  :  Learning Science | วิทยาการเรียนรู้ | 学习科学"
    },
    {
        "id":8014,
        "name":"8521 (English Program)  :  Learning Sciences | การเรียนรู้วิทยาศาสตร์ | 学习科学"
    },
    {
        "id":8015,
        "name":"8522 (Thai Program)  :  Management Of Creative Arts And Culture | การจัดการศิลปะและวัฒนธรรมสร้างสรรค์ | 创意艺术和文化管理"
    },
    {
        "id":8016,
        "name":"8523 (English Program)  :  Creative Arts And Cultural Management | ศิลปะสร้างสรรค์และการจัดการวัฒนธรรม | 创意艺术与文化管理"
    },
    {
        "id":8017,
        "name":"8524 (Thai Program)  :  Creative Science And Technology Innovation | นวัตกรรมวิทยาศาสตร์และเทคโนโลยีสร้างสรรค์ | 创意科技创新"
    },
    {
        "id":8018,
        "name":"8525 (English Program)  :  Creative Innovation In Science And Technology | นวัตกรรมที่สร้างสรรค์ในด้านวิทยาศาสตร์และเทคโนโลยี | 科技创意创新"
    },
    {
        "id":8019,
        "name":"8526 (Thai Program)  :  Mechatronics And Robotics Technology | เทคโนโลยีเมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人技术"
    },
    {
        "id":8020,
        "name":"8527 (English Program)  :  Mechatronics And Robotic Technology | เมคคาทรอนิกส์และเทคโนโลยีหุ่นยนต์ | 机电一体化和机器人技术"
    },
    {
        "id":8021,
        "name":"8528 (Thai Program)  :  Management Of Service Business And Mice Industry | การจัดการธุรกิจบริการและอุตสาหกรรมไมซ์ | 服务业及会展业管理"
    },
    {
        "id":8022,
        "name":"8529 (English Program)  :  Hospitality Business And Mice Industry Management | ธุรกิจการบริการและการจัดการอุตสาหกรรมไมซ์ | 酒店业和会展业管理"
    },
    {
        "id":8023,
        "name":"8530 (Thai Program)  :  Electrical Engineering And Artificial Intelligence | วิศวกรรมไฟฟ้าและปัญญาประดิษฐ์ | 电气工程和人工智能"
    },
    {
        "id":8024,
        "name":"8531 (English Program)  :  Electrical Engineering And Artificial Intelligence | วิศวกรรมไฟฟ้าและปัญญาประดิษฐ์ | 电气工程和人工智能"
    },
    {
        "id":8025,
        "name":"8532 (Thai Program)  :  Science For Local Industry | วิทยาศาสตร์สำหรับอุตสาหกรรมท้องถิ่น | 当地工业科学"
    },
    {
        "id":8026,
        "name":"8533 (English Program)  :  Science For Local Industry | วิทยาศาสตร์เพื่ออุตสาหกรรมท้องถิ่น | 当地工业科学"
    },
    {
        "id":8027,
        "name":"8534 (Thai Program)  :  Integrative Chemistry | เคมีบูรณาการ | 综合化学"
    },
    {
        "id":8028,
        "name":"8535 (Thai Program)  :  Natural Product Science And Technology | วิทยาศาสตร์และเทคโนโลยีผลิตภัณฑ์ธรรมชาติ | 天然产物科学与技术"
    },
    {
        "id":8029,
        "name":"8536 (Thai Program)  :  Applied Electrical Engineering Technology | เทคโนโลยีวิศวกรรมไฟฟ้าประยุกต์ | 应用电气工程技术"
    },
    {
        "id":8030,
        "name":"8537 (Thai Program)  :  Language Integration Business Management | การจัดการธุรกิจบูรณาการภาษา | 语言整合业务管理"
    },
    {
        "id":8031,
        "name":"8538 (English Program)  :  Business Management Integrating Language | การจัดการธุรกิจบูรณาการภาษา | 企业管理整合语言"
    },
    {
        "id":8032,
        "name":"8539 (Thai Program)  :  Governance And Sustainable Development | การจัดการปกครองและการพัฒนาที่ยั่งยืน | 治理和可持续发展"
    },
    {
        "id":8033,
        "name":"8540 (English Program)  :  Governance And Sustainable Development | การกำกับดูแลและการพัฒนาที่ยั่งยืน | 治理与可持续发展"
    },
    {
        "id":8034,
        "name":"8541 (Thai Program)  :  Brain, Mind And Learning | สมอง จิตใจและการเรียนรู้ | 大脑、思想和学习"
    },
    {
        "id":8035,
        "name":"8542 (English Program)  :  Brain, Mind And Learning | สมอง จิตใจ และการเรียนรู้ | 大脑、思维和学习"
    },
    {
        "id":8036,
        "name":"8543 (Thai Program)  :  Digital Manufacturing Systems Engineering | วิศวกรรมระบบการผลิตดิจิทัล | 数字化制造系统工程"
    },
    {
        "id":8037,
        "name":"8544 (English Program)  :  Digital Manufacturing System Engineering | วิศวกรรมระบบการผลิตดิจิทัล | 数字化制造系统工程"
    },
    {
        "id":8038,
        "name":"8545 (Thai Program)  :  Innovation In Physical Education And Sports | นวัตกรรมทางพลศึกษาและกีฬา | 体育教育和体育运动的创新"
    },
    {
        "id":8039,
        "name":"8546 (English Program)  :  Innovation Of Physical Education And Sport | นวัตกรรมด้านพลศึกษาและการกีฬา | 体育创新"
    },
    {
        "id":8040,
        "name":"8547 (Thai Program)  :  Business Korean | ภาษาเกาหลีธุรกิจ | 商务韩语"
    },
    {
        "id":8041,
        "name":"8548 (English Program)  :  Business Korean | ธุรกิจเกาหลี | 商务韩语"
    },
    {
        "id":8042,
        "name":"8549 (Thai Program)  :  Electrical Engineering And Automation Control Systems | วิศวกรรมไฟฟ้าและระบบควบคุมอัตโนมัติ | 电气工程与自动化控制系统"
    },
    {
        "id":8043,
        "name":"8550 (English Program)  :  Electrical Engineering And Automation Control Systems | วิศวกรรมไฟฟ้าและระบบควบคุมอัตโนมัติ | 电气工程及自动化控制系统"
    },
    {
        "id":8044,
        "name":"8551 (Thai Program)  :  Supply Chain Engineering | วิศวกรรมโซ่อุปทาน | 供应链工程"
    },
    {
        "id":8045,
        "name":"8552 (English Program)  :  Supply Chain ​​Engineering | วิศวกรรมห่วงโซ่อุปทาน | 供应链工程"
    },
    {
        "id":8046,
        "name":"8553 (Thai Program)  :  Innovative Engineering | วิศวกรรมนวัตกรรม | 创新工程"
    },
    {
        "id":8047,
        "name":"8554 (English Program)  :  Innovation Engineering | วิศวกรรมนวัตกรรม | 创新工程"
    },
    {
        "id":8048,
        "name":"8555 (Thai Program)  :  Pali, Sanskrit And Tripitaka Studies | ภาษาบาลีสันสกฤตและพระไตรปิฎกศึกษา | 巴利文、梵文和三藏研究"
    },
    {
        "id":8049,
        "name":"8556 (English Program)  :  Pali, Sanskrit And Tripitaka Studies | การศึกษาภาษาบาลี สันสกฤต และพระไตรปิฎก | 巴利文、梵文和三藏研究"
    },
    {
        "id":8050,
        "name":"8557 (Thai Program)  :  Rail Transport Engineering Technology | เทคโนโลยีวิศวกรรมขนส่งทางราง | 轨道交通工程技术"
    },
    {
        "id":8051,
        "name":"8558 (English Program)  :  Rail Transportation Engineering Technology | เทคโนโลยีวิศวกรรมการขนส่งทางราง | 轨道交通工程技术"
    },
    {
        "id":8052,
        "name":"8559 (Thai Program)  :  Water Resources Engineering And Information Innovation | วิศวกรรมทรัพยากรน้ำและนวัตกรรมสารสนเทศ | 水利工程与信息创新"
    },
    {
        "id":8053,
        "name":"8560 (English Program)  :  Information Innovation And Water Resources Engineering | นวัตกรรมสารสนเทศและวิศวกรรมทรัพยากรน้ำ | 信息创新与水资源工程"
    },
    {
        "id":8054,
        "name":"8561 (Thai Program)  :  Health And Beauty Business Science | วิทยาการธุรกิจสุขภาพและความงาม | 健康与美容商业科学"
    },
    {
        "id":8055,
        "name":"8562 (English Program)  :  Beauty And Wellness Business Science | วิทยาศาสตร์ธุรกิจความงามและสุขภาพ | 美容与健康商业科学"
    },
    {
        "id":8056,
        "name":"8563 (Thai Program)  :  Leadership In Educational System Administration | ภาวะผู้นำการบริหารระบบการศึกษา | 教育系统管理的领导"
    },
    {
        "id":8057,
        "name":"8564 (English Program)  :  Educational System Management Leadership | ภาวะผู้นำด้านการจัดการระบบการศึกษา | 教育系统管理领导"
    },
    {
        "id":8058,
        "name":"8565 (Thai Program)  :  Beauty Medicine | เวชศาสตร์ความงาม | 美容医学"
    },
    {
        "id":8059,
        "name":"8566 (English Program)  :  Aesthetic Medicine | ยาเพื่อความงาม | 美容医学"
    },
    {
        "id":8060,
        "name":"8567 (Thai Program)  :  Shipbuilding Engineering And Oceanographic Engineering | วิศวกรรมต่อเรือและวิศวกรรมสมุทรศาสตร์ | 造船工程与海洋工程"
    },
    {
        "id":8061,
        "name":"8568 (English Program)  :  Naval Architecture And Ocean Engineering | สถาปัตยกรรมกองทัพเรือและวิศวกรรมมหาสมุทร | 船舶与海洋工程"
    },
    {
        "id":8062,
        "name":"8569 (English Program)  :  Management Of Digital Information Technology | การจัดการเทคโนโลยีสารสนเทศดิจิทัล | 数字信息技术管理"
    },
    {
        "id":8063,
        "name":"8570 (Thai Program)  :  Digital Information Technology Management | การจัดการเทคโนโลยีสารสนเทศดิจิทัล | 数字信息技术管理"
    },
    {
        "id":8064,
        "name":"8571 (Thai Program)  :  Digital Innovation Management | การจัดการนวัตกรรมดิจิทัล | 数字化创新管理"
    },
    {
        "id":8065,
        "name":"8572 (English Program)  :  Management Of Digital Innovation | การจัดการนวัตกรรมดิจิทัล | 数字创新管理"
    },
    {
        "id":8066,
        "name":"8573 (English Program)  :  Dance Education | การศึกษาด้านการเต้นรำ | 舞蹈教育"
    },
    {
        "id":8067,
        "name":"8574 (Thai Program)  :  Intelligent Electrical Power Engineering | วิศวกรรมพลังงานไฟฟ้าอัจฉริยะ | 智能电力工程"
    },
    {
        "id":8068,
        "name":"8575 (English Program)  :  Smart Electrical Energy Engineering | วิศวกรรมพลังงานไฟฟ้าอัจฉริยะ | 智能电力能源工程"
    },
    {
        "id":8069,
        "name":"8576 (Thai Program)  :  Resource Management And Development | การจัดการและพัฒนาทรัพยากร | 资源管理与开发"
    },
    {
        "id":8070,
        "name":"8577 (English Program)  :  Resources Management And Development | การจัดการทรัพยากรและการพัฒนา | 资源管理和开发"
    },
    {
        "id":8071,
        "name":"8578 (Thai Program)  :  Organic Science | วิทยาศาสตร์เกษตรอินทรีย์ | 有机科学"
    },
    {
        "id":8072,
        "name":"8579 (English Program)  :  Organic Agriculture Science | วิทยาศาสตร์เกษตรอินทรีย์ | 有机农业科学"
    },
    {
        "id":8073,
        "name":"8580 (Thai Program)  :  Built Environment Innovation | นวัตกรรมสิ่งแวดล้อมสรรค์สร้าง | 建筑环境创新"
    },
    {
        "id":8074,
        "name":"8581 (English Program)  :  Innovative Built Environment | สภาพแวดล้อมที่สร้างขึ้นอย่างสร้างสรรค์ | 创新的建筑环境"
    },
    {
        "id":8075,
        "name":"8582 (Thai Program)  :  Industrial Animal Nutrition | โภชนศาสตร์สัตว์อุตสาหกรรม | 工业动物营养"
    },
    {
        "id":8076,
        "name":"8583 (English Program)  :  Industrial Animal Nutrition | โภชนาการสัตว์อุตสาหกรรม | 工业动物营养"
    },
    {
        "id":8077,
        "name":"8584 (Thai Program)  :  National Defense Technology | เทคโนโลยีป้องกันประเทศ | 国防科技"
    },
    {
        "id":8078,
        "name":"8585 (English Program)  :  Defense Technology | เทคโนโลยีการป้องกัน | 国防科技"
    },
    {
        "id":8079,
        "name":"8586 (English Program)  :  Technology Of Industrial Design | เทคโนโลยีการออกแบบอุตสาหกรรม | 工业设计技术"
    },
    {
        "id":8080,
        "name":"8587 (Thai Program)  :  Innovation In Governance And Social Entrepreneurship | นวัตกรรมการบริหารปกครองและการประกอบการเพื่อสังคม | 治理和社会创业创新"
    },
    {
        "id":8081,
        "name":"8588 (English Program)  :  Innovative Governance And Social Entrepreneurship | นวัตกรรมการกำกับดูแลและการประกอบการทางสังคม | 创新治理与社会创业"
    },
    {
        "id":8082,
        "name":"8589 (Thai Program)  :  Cosmetic Science And Technology | วิทยาศาสตร์และเทคโนโลยีเครื่องสำอาง | 化妆品科学与技术"
    },
    {
        "id":8083,
        "name":"8590 (English Program)  :  Cosmetic Science And Technology | วิทยาศาสตร์และเทคโนโลยีเครื่องสำอาง | 化妆品科技"
    },
    {
        "id":8084,
        "name":"8591 (Thai Program)  :  Philosophy And Buddhism | ปรัชญาและพระพุทธศาสนา | 哲学与佛教"
    },
    {
        "id":8085,
        "name":"8592 (English Program)  :  Philosophy And Buddhism | ปรัชญาและพุทธศาสนา | 哲学与佛教"
    },
    {
        "id":8086,
        "name":"8593 (Thai Program)  :  Integrating Health And Beauty Promotion | บูรณาการส่งเสริมสุขภาพและความงาม | 整合健康与美丽推广"
    },
    {
        "id":8087,
        "name":"8594 (English Program)  :  Integrated Wellness And Beauty | สุขภาพและความงามแบบผสมผสาน | 综合健康与美容"
    },
    {
        "id":8088,
        "name":"8595 (Thai Program)  :  Digital Business Transformation | การแปรรูปธุรกิจทางดิจิทัล | 数字化业务转型"
    },
    {
        "id":8089,
        "name":"8596 (English Program)  :  Digital Business Transformation | การเปลี่ยนแปลงธุรกิจดิจิทัล | 数字化业务转型"
    },
    {
        "id":8090,
        "name":"8597 (Thai Program)  :  Foreign Language For Communication | ภาษาต่างประเทศเพื่อการสื่อสาร | 用于交流的外语"
    },
    {
        "id":8091,
        "name":"8598 (English Program)  :  Foreign Languages For Communication | ภาษาต่างประเทศเพื่อการสื่อสาร | 交流外语"
    },
    {
        "id":8092,
        "name":"8599 (Thai Program)  :  Digital Technology Innovation | นวัตกรรมเทคโนโลยีดิจิทัล | 数字技术创新"
    },
    {
        "id":8093,
        "name":"8600 (English Program)  :  Digital Technology Innovation | นวัตกรรมเทคโนโลยีดิจิทัล | 数字技术创新"
    },
    {
        "id":8094,
        "name":"8601 (Thai Program)  :  Indonesia-Malaysia Study For International Work | อินโดนีเซีย-มาเลเซียศึกษาเพื่องานระหว่างประเทศ | 印度尼西亚-马来西亚国际工作研究"
    },
    {
        "id":8095,
        "name":"8602 (English Program)  :  Indonesia-Malaysia Studies For International Jobs | อินโดนีเซีย-มาเลเซียศึกษาสำหรับงานระหว่างประเทศ | 印度尼西亚-马来西亚国际就业研究"
    },
    {
        "id":8096,
        "name":"8603 (Thai Program)  :  Creative Performing Arts | ศิลปะการแสดงสร้างสรรค์ | 创意表演艺术"
    },
    {
        "id":8097,
        "name":"8604 (English Program)  :  Creative Performing Arts | ศิลปะการแสดงเชิงสร้างสรรค์ | 创意表演艺术"
    },
    {
        "id":8098,
        "name":"8605 (English Program)  :  Community Public Health | สาธารณสุขชุมชน | 社区公共卫生"
    },
    {
        "id":8099,
        "name":"8606 (Thai Program)  :  Microbiology And Immunology | จุลชีววิทยาและวิทยาภูมิคุ้มกัน | 微生物学和免疫学"
    },
    {
        "id":8100,
        "name":"8607 (Thai Program)  :  Creative Music | ดนตรีสร้างสรรค์ | 创意音乐"
    },
    {
        "id":8101,
        "name":"8608 (English Program)  :  Creative Music | เพลงสร้างสรรค์ | 创意音乐"
    },
    {
        "id":8102,
        "name":"8609 (Thai Program)  :  Management Of Digital Technology For Education | การจัดการเทคโนโลยีดิจิทัลเพื่อการศึกษา | 教育数字技术管理"
    },
    {
        "id":8103,
        "name":"8610 (English Program)  :  Digital Technology Management For Education | การจัดการเทคโนโลยีดิจิทัลเพื่อการศึกษา | 教育数字技术管理"
    },
    {
        "id":8104,
        "name":"8611 (Thai Program)  :  Technology And Innovation In Music Production | เทคโนโลยีและนวัตกรรมการผลิตดนตรี | 音乐制作中的技术和创新"
    },
    {
        "id":8105,
        "name":"8612 (Thai Program)  :  Infrastructure Engineering And Construction Management | วิศวกรรมโครงสร้างพื้นฐานและบริหารงานก่อสร้าง | 基础设施工程与施工管理"
    },
    {
        "id":8106,
        "name":"8613 (English Program)  :  Infrastructure Engineering And Construction Management | วิศวกรรมโครงสร้างพื้นฐานและการจัดการการก่อสร้าง | 基础设施工程与施工管理"
    },
    {
        "id":8107,
        "name":"8614 (Thai Program)  :  Western Language | ภาษาตะวันตก | 西语"
    },
    {
        "id":8108,
        "name":"8615 (English Program)  :  Western Languages | ภาษาตะวันตก | 西方语言"
    },
    {
        "id":8109,
        "name":"8616 (Thai Program)  :  Dance Sangeet | นาฏยสังคีต | 桑吉特舞"
    },
    {
        "id":8110,
        "name":"8617 (English Program)  :  Drama And Music | ละครและดนตรี | 戏剧和音乐"
    },
    {
        "id":8111,
        "name":"8618 (Thai Program)  :  Agricultural Leadership And Communication | ภาวะผู้นำและการสื่อสารทางการเกษตร | 农业领导与沟通"
    },
    {
        "id":8112,
        "name":"8619 (English Program)  :  Agricultural Leadership And Communications | ภาวะผู้นำทางการเกษตรและการสื่อสาร | 农业领导和沟通"
    },
    {
        "id":8113,
        "name":"8620 (English Program)  :  International Logistics Management | การจัดการโลจิสติกส์ระหว่างประเทศ | 国际物流管理"
    },
    {
        "id":8114,
        "name":"8621 (Thai Program)  :  Digital Technology Innovation Management | การจัดการนวัตกรรมเทคโนโลยีดิจิทัล | 数字技术创新管理"
    },
    {
        "id":8115,
        "name":"8622 (English Program)  :  Management Of Digital Technology Innovation | การจัดการนวัตกรรมเทคโนโลยีดิจิทัล | 数字技术创新管理"
    },
    {
        "id":8116,
        "name":"8623 (Thai Program)  :  Business And Technology | ธุรกิจและเทคโนโลยี | 商业和技术"
    },
    {
        "id":8117,
        "name":"8624 (English Program)  :  Business And Technology | ธุรกิจและเทคโนโลยี | 商业与科技"
    },
    {
        "id":8118,
        "name":"8625 (Thai Program)  :  Korean Language And Culture | ภาษาและวัฒนธรรมเกาหลี | 韩国语言和文化"
    },
    {
        "id":8119,
        "name":"8626 (English Program)  :  Korean Language And Culture | ภาษาและวัฒนธรรมเกาหลี | 韩国语言和文化"
    },
    {
        "id":8120,
        "name":"8627 (English Program)  :  Technology And Innovation Of Music Production | เทคโนโลยีและนวัตกรรมการผลิตเพลง | 音乐制作的技术与创新"
    },
    {
        "id":8121,
        "name":"8628 (Thai Program)  :  Digital Health | สุขภาพดิจิทัล | 数字健康"
    },
    {
        "id":8122,
        "name":"8629 (English Program)  :  Digital Health | สุขภาพดิจิทัล | 数字健康"
    },
    {
        "id":8123,
        "name":"8630 (Thai Program)  :  Medical Physics And Medical Engineering | ฟิสิกส์การแพทย์และวิศวกรรมการแพทย์ | 医学物理与医学工程"
    },
    {
        "id":8124,
        "name":"8631 (English Program)  :  Medical Physics And Medical Engineering | ฟิสิกส์การแพทย์และวิศวกรรมการแพทย์ | 医学物理与医学工程"
    },
    {
        "id":8125,
        "name":"8632 (Thai Program)  :  Creative Science And Innovation | วิทยาศาสตร์เชิงสร้างสรรค์และนวัตกรรม | 创意科学与创新"
    },
    {
        "id":8126,
        "name":"8633 (English Program)  :  Creative Science And Innovation | วิทยาศาสตร์เชิงสร้างสรรค์และนวัตกรรม | 创意科学与创新"
    },
    {
        "id":8127,
        "name":"8634 (Thai Program)  :  Digital Technology For Training Human Resources In Organizations | เทคโนโลยีดิจิทัลเพื่อการฝึกอบรมทรัพยากรมนุษย์ในองค์กร | 用于培训组织人力资源的数字技术"
    },
    {
        "id":8128,
        "name":"8635 (English Program)  :  Digital Technology For Human Resource Training In The Organization | เทคโนโลยีดิจิทัลเพื่อการฝึกอบรมทรัพยากรมนุษย์ในองค์กร | 用于组织人力资源培训的数字技术"
    },
    {
        "id":8129,
        "name":"8636 (Thai Program)  :  Sports Management Innovation | นวัตกรรมการจัดการการกีฬา | 体育管理创新"
    },
    {
        "id":8130,
        "name":"8637 (English Program)  :  Innovation Sport Management | นวัตกรรมการจัดการกีฬา | 创新体育管理"
    },
    {
        "id":8131,
        "name":"8638 (Thai Program)  :  Tourism, Hotel And Event Management | การจัดการการท่องเที่ยว โรงแรม และอีเวนต์ | 旅游、酒店和活动管理"
    },
    {
        "id":8132,
        "name":"8639 (English Program)  :  Tourism, Hotel And Event Management | การจัดการการท่องเที่ยว โรงแรม และกิจกรรม | 旅游、酒店和活动管理"
    },
    {
        "id":8133,
        "name":"8640 (English Program)  :  Music Research And Development | การวิจัยและพัฒนาดนตรี | 音乐研究与开发"
    },
    {
        "id":8134,
        "name":"8641 (Thai Program)  :  Border Trade Management | การจัดการการค้าชายแดน | 边境贸易管理"
    },
    {
        "id":8135,
        "name":"8642 (English Program)  :  Border Trade Management | การจัดการการค้าชายแดน | 边境贸易管理"
    },
    {
        "id":8136,
        "name":"8643 (Thai Program)  :  Science For Sustainable Local Development | ศาสตร์เพื่อการพัฒนาท้องถิ่นที่ยั่งยืน | 科学促进地方可持续发展"
    },
    {
        "id":8137,
        "name":"8644 (English Program)  :  Science For Sustainable Local Development | วิทยาศาสตร์เพื่อการพัฒนาท้องถิ่นอย่างยั่งยืน | 科学促进当地可持续发展"
    },
    {
        "id":8138,
        "name":"8645 (English Program)  :  Holistic Health And Wellness Management | การจัดการสุขภาพและความเป็นอยู่ที่ดีแบบองค์รวม | 整体健康与保健管理"
    },
    {
        "id":8139,
        "name":"8646 (Thai Program)  :  Holistic Health Management | การจัดการสุขภาพแบบองค์รวม | 整体健康管理"
    },
    {
        "id":8140,
        "name":"8647 (English Program)  :  Service Business Management | การจัดการธุรกิจบริการ | 服务业务管理"
    },
    {
        "id":8141,
        "name":"8648 (Thai Program)  :  Data Science And Digital Innovation | วิทยาการข้อมูลและนวัตกรรมดิจิทัล | 数据科学和数字创新"
    },
    {
        "id":8142,
        "name":"8649 (English Program)  :  Data Science And Digital Innovation | วิทยาศาสตร์ข้อมูลและนวัตกรรมดิจิทัล | 数据科学和数字创新"
    },
    {
        "id":8143,
        "name":"8650 (Thai Program)  :  Tourism And Service Business | ธุรกิจท่องเที่ยวและบริการ | 旅游及服务业"
    },
    {
        "id":8144,
        "name":"8651 (English Program)  :  Tourism Business And Services | ธุรกิจการท่องเที่ยวและบริการ | 旅游业务与服务"
    },
    {
        "id":8145,
        "name":"8652 (Thai Program)  :  Public Law And Administration Of Justice | กฎหมายมหาชนและการบริหารงานยุติธรรม | 公法和司法"
    },
    {
        "id":8146,
        "name":"8653 (English Program)  :  Public Law And Justice Administration | กฎหมายมหาชนและการบริหารงานยุติธรรม | 公法和司法行政"
    },
    {
        "id":8147,
        "name":"8654 (Thai Program)  :  Environmental Health And Disasters | อนามัยสิ่งแวดล้อมและสาธารณภัย | 环境健康与灾害"
    },
    {
        "id":8148,
        "name":"8655 (English Program)  :  Environmental Health And Disaster | สุขภาพสิ่งแวดล้อมและภัยพิบัติ | 环境健康与灾难"
    },
    {
        "id":8149,
        "name":"8656 (Thai Program)  :  Interdisciplinary Tourism | สหวิทยาการการท่องเที่ยว | 跨学科旅游"
    },
    {
        "id":8150,
        "name":"8657 (English Program)  :  Interdisciplinary Studies Of Tourism | สหวิทยาการศึกษาการท่องเที่ยว | 旅游跨学科研究"
    },
    {
        "id":8151,
        "name":"8658 (Thai Program)  :  Service And Tourism Business Operators | ผู้ประกอบการธุรกิจบริการและการท่องเที่ยว | 服务业和旅游业经营者"
    },
    {
        "id":8152,
        "name":"8659 (English Program)  :  Entrepreneur In Hospitality And Tourism Business | ผู้ประกอบการในธุรกิจการบริการและการท่องเที่ยว | 酒店和旅游业务企业家"
    },
    {
        "id":8153,
        "name":"8660 (Thai Program)  :  Elementary English | ภาษาอังกฤษระดับประถมศึกษา | 初级英语"
    },
    {
        "id":8154,
        "name":"8661 (English Program)  :  Teaching English At Primary Education Level | การสอนภาษาอังกฤษในระดับประถมศึกษา | 小学英语教学"
    },
    {
        "id":8155,
        "name":"8662 (Thai Program)  :  Management Of Early Childhood And Primary Education | การจัดการการศึกษาปฐมวัยและประถมศึกษา | 幼儿教育和初等教育管理"
    },
    {
        "id":8156,
        "name":"8663 (English Program)  :  Early Childhood And Primary Education Management | การจัดการศึกษาปฐมวัยและประถมศึกษา | 幼儿和小学教育管理"
    },
    {
        "id":8157,
        "name":"8664 (Thai Program)  :  Elementary English Teaching | การสอนภาษาอังกฤษระดับประถมศึกษา | 小学英语教学"
    },
    {
        "id":8158,
        "name":"8665 (Thai Program)  :  Health And Safety Technology | เทคโนโลยีทางสุขภาพและความปลอดภัย | 健康与安全技术"
    },
    {
        "id":8159,
        "name":"8666 (English Program)  :  Health And Safety Technology | เทคโนโลยีด้านสุขภาพและความปลอดภัย | 健康与安全技术"
    },
    {
        "id":8160,
        "name":"8667 (Thai Program)  :  Energy And Automation Control | พลังงานและการควบคุมระบบอัตโนมัติ | 能源与自动化控制"
    },
    {
        "id":8161,
        "name":"8668 (English Program)  :  Energy And Automatic Control Systems | ระบบควบคุมพลังงานและอัตโนมัติ | 能源和自动控制系统"
    },
    {
        "id":8162,
        "name":"8669 (Thai Program)  :  Innovation In Veterinary Science | นวัตกรรมวิทยาศาสตร์การสัตวแพทย์ | 兽医科学的创新"
    },
    {
        "id":8163,
        "name":"8670 (English Program)  :  Innovation In Veterinary Science | นวัตกรรมทางสัตวแพทยศาสตร์ | 兽医科学的创新"
    },
    {
        "id":8164,
        "name":"8671 (Thai Program)  :  Energy Technology For The Environment | เทคโนโลยีพลังงานเพื่อสิ่งแวดล้อม | 环境能源技术"
    },
    {
        "id":8165,
        "name":"8672 (Thai Program)  :  Logistics Technology Management | การจัดการเทคโนโลยีโลจิสติกส์ | 物流技术管理"
    },
    {
        "id":8166,
        "name":"8673 (English Program)  :  Logistics Technology Management | การจัดการเทคโนโลยีโลจิสติกส์ | 物流技术管理"
    },
    {
        "id":8167,
        "name":"8674 (English Program)  :  Energy Technology For Environment | เทคโนโลยีพลังงานเพื่อสิ่งแวดล้อม | 环境能源技术"
    },
    {
        "id":8168,
        "name":"8675 (Thai Program)  :  Computer Engineering And Iot Systems | วิศวกรรมคอมพิวเตอร์และระบบไอโอที | 计算机工程和物联网系统"
    },
    {
        "id":8169,
        "name":"8676 (English Program)  :  Computer Engineering And Iot System | วิศวกรรมคอมพิวเตอร์และระบบ Iot | 计算机工程和物联网系统"
    },
    {
        "id":8170,
        "name":"8677 (Thai Program)  :  Education And Society | การศึกษาและสังคม | 教育与社会"
    },
    {
        "id":8171,
        "name":"8678 (English Program)  :  Education And Society | การศึกษาและสังคม | 教育与社会"
    },
    {
        "id":8172,
        "name":"8679 (Thai Program)  :  Buddhism In The World | พุทธศาสนาในโลก | 佛教在世界上"
    },
    {
        "id":8173,
        "name":"8680 (English Program)  :  Global Buddhism | พุทธศาสนาทั่วโลก | 全球佛教"
    },
    {
        "id":8174,
        "name":"8681 (Thai Program)  :  Pharmaceutical Innovation | นวัตกรรมทางเภสัชศาสตร์ | 医药创新"
    },
    {
        "id":8175,
        "name":"8682 (English Program)  :  Pharmaceutical Innovation | นวัตกรรมทางเภสัชกรรม | 医药创新"
    },
    {
        "id":8176,
        "name":"8683 (Thai Program)  :  International Business And Digital Marketing | ธุรกิจระหว่างประเทศและการตลาดดิจิทัล | 国际商务和数字营销"
    },
    {
        "id":8177,
        "name":"8684 (English Program)  :  International Business And Digital Marketing | ธุรกิจระหว่างประเทศและการตลาดดิจิทัล | 国际商务和数字营销"
    },
    {
        "id":8178,
        "name":"8685 (Thai Program)  :  Health Management Science | วิทยาการจัดการสุขภาพ | 健康管理科学"
    },
    {
        "id":8179,
        "name":"8686 (English Program)  :  Health Science Management | การจัดการวิทยาศาสตร์สุขภาพ | 健康科学管理"
    },
    {
        "id":8180,
        "name":"8687 (Thai Program)  :  Curriculum And Learning Science Development | การพัฒนาหลักสูตรและวิทยาการเรียนรู้ | 课程和学习科学发展"
    },
    {
        "id":8181,
        "name":"8688 (English Program)  :  Curriculum Development And Learning Science | การพัฒนาหลักสูตรและการเรียนรู้วิทยาศาสตร์ | 课程开发和学习科学"
    },
    {
        "id":8182,
        "name":"8689 (Thai Program)  :  Learning Management Innovation | นวัตกรรมการจัดการเรียนรู้ | 学习管理创新"
    },
    {
        "id":8183,
        "name":"8690 (English Program)  :  Learning Management Innovation | นวัตกรรมการจัดการการเรียนรู้ | 学习管理创新"
    },
    {
        "id":8184,
        "name":"8691 (Thai Program)  :  Computer Engineering And Automation | วิศวกรรมคอมพิวเตอร์และระบบอัตโนมัติ | 计算机工程与自动化"
    },
    {
        "id":8185,
        "name":"8692 (English Program)  :  Computer And Automation Engineering | วิศวกรรมคอมพิวเตอร์และระบบอัตโนมัติ | 计算机与自动化工程"
    },
    {
        "id":8186,
        "name":"8693 (Thai Program)  :  Heavy Equipment Engineering | วิศวกรรมเครื่องจักรกลหนัก | 重型装备工程"
    },
    {
        "id":8187,
        "name":"8694 (English Program)  :  Architectural Technicians | ช่างเทคนิคสถาปัตยกรรม | 建筑技术人员"
    },
    {
        "id":8188,
        "name":"8695 (Thai Program)  :  Digital Graphics | ดิจิทัลกราฟิก | 数字图形"
    },
    {
        "id":8189,
        "name":"8696 (English Program)  :  Digital Graphics | กราฟิกดิจิทัล | 数字图形"
    },
    {
        "id":8190,
        "name":"8697 (Thai Program)  :  Agricultural Machinery | เครื่องกลเกษตร | 农业机械"
    },
    {
        "id":8191,
        "name":"8698 (English Program)  :  Automotive Technique | เทคนิคยานยนต์ | 汽车技术"
    },
    {
        "id":8192,
        "name":"8699 (Thai Program)  :  Innovations In Environmental Technology And Energy Management | นวัตกรรมทางเทคโนโลยีสิ่งแวดล้อมและการจัดการพลังงาน | 环境技术和能源管理创新"
    },
    {
        "id":8193,
        "name":"8700 (English Program)  :  Innovation For Environmental Technology And Energy | นวัตกรรมสำหรับเทคโนโลยีสิ่งแวดล้อมและพลังงาน | 环境技术和能源创新"
    },
    {
        "id":8194,
        "name":"8701 (Thai Program)  :  Aircraft Electronics Engineering | วิศวกรรมอิเล็กทรอนิกส์อากาศยาน | 飞机电子工程"
    },
    {
        "id":8195,
        "name":"8702 (Thai Program)  :  Disease Prevention And Control In Urban Areas | การป้องกันควบคุมโรคเขตเมือง | 城市疾病预防控制"
    },
    {
        "id":8196,
        "name":"8703 (English Program)  :  Urban Disease Control And Prevention | การควบคุมและป้องกันโรคในเมือง | 城市疾病预防控制"
    },
    {
        "id":8197,
        "name":"8704 (Thai Program)  :  Digital Entrepreneurship | การเป็นผู้ประกอบการดิจิทัล | 数字化创业"
    },
    {
        "id":8198,
        "name":"8705 (English Program)  :  Digital Entrepreneurship | ผู้ประกอบการดิจิทัล | 数字化创业"
    },
    {
        "id":8199,
        "name":"8706 (Thai Program)  :  Diplomacy And International Relations | การทูตและความสัมพันธ์ระหว่างประเทศ | 外交与国际关系"
    },
    {
        "id":8200,
        "name":"8707 (English Program)  :  Diplomacy And International Relations | การทูตและความสัมพันธ์ระหว่างประเทศ | 外交与国际关系"
    },
    {
        "id":8201,
        "name":"8708 (Thai Program)  :  Salon And Beauty Business Management | การจัดการธุรกิจเสริมสวยและความงาม | 沙龙和美容业务管理"
    },
    {
        "id":8202,
        "name":"8709 (English Program)  :  Beauty Business Management | การจัดการธุรกิจความงาม | 美容商业管理"
    },
    {
        "id":8203,
        "name":"8710 (Thai Program)  :  Service Innovation And Intercultural Communication | นวัตกรรมบริการและการสื่อสารระหว่างวัฒนธรรม | 服务创新与跨文化交流"
    },
    {
        "id":8204,
        "name":"8711 (English Program)  :  Service Innovation And Intercultural Communication | นวัตกรรมการบริการและการสื่อสารระหว่างวัฒนธรรม | 服务创新与跨文化交流"
    },
    {
        "id":8205,
        "name":"8712 (Thai Program)  :  Thai And International Culinary Arts | ศิลปะการประกอบอาหารไทยและอาหารนานาชาติ | 泰国和国际烹饪艺术"
    },
    {
        "id":8206,
        "name":"8713 (English Program)  :  Thai And International Culinary Arts | ศิลปะการประกอบอาหารไทยและนานาชาติ | 泰国和国际烹饪艺术"
    },
    {
        "id":8207,
        "name":"8714 (Thai Program)  :  Smart Agriculture | เกษตรอัจฉริยะ | 智慧农业"
    },
    {
        "id":8208,
        "name":"8715 (English Program)  :  Smart Agriculture | การเกษตรอัจฉริยะ | 智慧农业"
    },
    {
        "id":8209,
        "name":"8716 (Thai Program)  :  Innovative Renewable Energy Technology | นวัตกรรมเทคโนโลยีพลังงานทดแทน | 创新的可再生能源技术"
    },
    {
        "id":8210,
        "name":"8717 (English Program)  :  Innovation In Renewable Energy Technology | นวัตกรรมด้านเทคโนโลยีพลังงานทดแทน | 可再生能源技术创新"
    },
    {
        "id":8211,
        "name":"8718 (English Program)  :  Elderly Health Management | การจัดการสุขภาพผู้สูงอายุ | 长者健康管理"
    },
    {
        "id":8212,
        "name":"8719 (Thai Program)  :  Food Business Innovation Management | การจัดการนวัตกรรมธุรกิจอาหาร | 食品企业创新管理"
    },
    {
        "id":8213,
        "name":"8720 (English Program)  :  Innovative Food Business Management | การจัดการธุรกิจอาหารเชิงนวัตกรรม | 创新食品业务管理"
    },
    {
        "id":8214,
        "name":"8721 (Thai Program)  :  Financial And Investment Management | การบริหารการเงินและการลงทุน | 财务与投资管理"
    },
    {
        "id":8215,
        "name":"8722 (English Program)  :  Financial Management And Investment | การจัดการทางการเงินและการลงทุน | 财务管理与投资"
    },
    {
        "id":8216,
        "name":"8723 (Thai Program)  :  Cannabis Science And Medicinal Plants For Local Development | กัญชาศาสตร์และพืชสมุนไพรเพื่อการพัฒนาท้องถิ่น | 大麻科学和药用植物促进当地发展"
    },
    {
        "id":8217,
        "name":"8724 (English Program)  :  Cannabis And Medicinal Plants For Local Development | กัญชาและพืชสมุนไพรเพื่อการพัฒนาท้องถิ่น | 大麻和药用植物促进当地发展"
    },
    {
        "id":8218,
        "name":"8725 (Thai Program)  :  Measurement Technology And Intelligent Systems | เทคโนโลยีการวัดและระบบอัจฉริยะ | 测量技术与智能系统"
    },
    {
        "id":8219,
        "name":"8726 (English Program)  :  Measurement Technology And Smart Systems | เทคโนโลยีการวัดและระบบอัจฉริยะ | 测量技术和智能系统"
    },
    {
        "id":8220,
        "name":"8727 (Thai Program)  :  Innovative Technology, Energy And Environment | เทคโนโลยีนวัตกรรมพลังงานและสิ่งแวดล้อม | 创新技术、能源与环境"
    },
    {
        "id":8221,
        "name":"8728 (English Program)  :  Innovative Energy Technology And Environment | นวัตกรรมเทคโนโลยีพลังงานและสิ่งแวดล้อม | 创新能源技术与环境"
    },
    {
        "id":8222,
        "name":"8729 (Thai Program)  :  Intelligent Innovation Engineering | วิศวกรรมนวัตกรรมอัจฉริยะ | 智能创新工程"
    },
    {
        "id":8223,
        "name":"8730 (English Program)  :  Intelligent Innovation Engineering | วิศวกรรมนวัตกรรมอัจฉริยะ | 智能创新工程"
    },
    {
        "id":8224,
        "name":"8731 (Thai Program)  :  Physical Education And Science Exercise | พลศึกษาและวิทยาศาสตร์ การออกกำลังกาย | 体育与科学锻炼"
    },
    {
        "id":8225,
        "name":"8732 (English Program)  :  Physical Education And Exercise Sciences | พลศึกษาและวิทยาศาสตร์การออกกำลังกาย | 体育和运动科学"
    },
    {
        "id":8226,
        "name":"8733 (English Program)  :  Veterinary Nursing | การพยาบาลสัตวแพทย์ | 兽医护理"
    },
    {
        "id":8227,
        "name":"8734 (Thai Program)  :  Content And Digital Media | คอนเทนต์และสื่อดิจิทัล | 内容和数字媒体"
    },
    {
        "id":8228,
        "name":"8735 (English Program)  :  Content And Digital Media | เนื้อหาและสื่อดิจิทัล | 内容和数字媒体"
    },
    {
        "id":8229,
        "name":"8736 (Thai Program)  :  Innovation In Learning And Teaching | นวัตกรรมการเรียนรู้และการสอน | 学习和教学的创新"
    },
    {
        "id":8230,
        "name":"8737 (English Program)  :  Innovations In Learning And Teaching | นวัตกรรมในการเรียนรู้และการสอน | 学习和教学的创新"
    },
    {
        "id":8231,
        "name":"8738 (Thai Program)  :  Educational Management Innovation | นวัตกรรมการจัดการการศึกษา | 教育管理创新"
    },
    {
        "id":8232,
        "name":"8739 (Thai Program)  :  Energy Management And Logistics Engineering | วิศวกรรมการจัดการพลังงานและโลจิสติกส์ | 能源管理与物流工程"
    },
    {
        "id":8233,
        "name":"8740 (English Program)  :  Energy And Logistics Management Engineering | วิศวกรรมการจัดการพลังงานและโลจิสติกส์ | 能源与物流管理工程"
    },
    {
        "id":8234,
        "name":"8741 (Thai Program)  :  Digital Transformation And Business Innovation | การเปลี่ยนแปลงเชิงดิจิทัลและนวัตกรรมทางธุรกิจ | 数字化转型与业务创新"
    },
    {
        "id":8235,
        "name":"8742 (English Program)  :  Digital Transformation And Business Innovation | การเปลี่ยนแปลงทางดิจิทัลและนวัตกรรมทางธุรกิจ | 数字化转型和业务创新"
    },
    {
        "id":8236,
        "name":"8743 (Thai Program)  :  Integrated Architecture And Management | สถาปัตยกรรมและการจัดการเชิงบูรณาการ | 集成架构和管理"
    },
    {
        "id":8237,
        "name":"8744 (English Program)  :  Architecture And Integrated Management | สถาปัตยกรรมและการจัดการแบบบูรณาการ | 架构与综合管理"
    },
    {
        "id":8238,
        "name":"8745 (Thai Program)  :  Health Service Business For Tourism | ธุรกิจบริการสุขภาพเพื่อการท่องเที่ยว | 旅游健康服务业务"
    },
    {
        "id":8239,
        "name":"8746 (English Program)  :  Health Service For Tourism | บริการด้านสุขภาพเพื่อการท่องเที่ยว | 旅游健康服务"
    },
    {
        "id":8240,
        "name":"8747 (Thai Program)  :  English For The Service Industry | ภาษาอังกฤษเพื่ออุตสาหกรรมธุรกิจบริการ | 服务业英语"
    },
    {
        "id":8241,
        "name":"8748 (English Program)  :  English For Service Business Industry | ภาษาอังกฤษสำหรับอุตสาหกรรมธุรกิจบริการ | 服务商业英语"
    },
    {
        "id":8242,
        "name":"8749 (Thai Program)  :  Digital Agriculture Business | ธุรกิจเกษตรดิจิทัล | 数字农业业务"
    },
    {
        "id":8243,
        "name":"8750 (English Program)  :  Digital Agricultural Businesses | ธุรกิจเกษตรดิจิทัล | 数字农业业务"
    },
    {
        "id":8244,
        "name":"8751 (English Program)  :  Information Technology Digital Media | เทคโนโลยีสารสนเทศ สื่อดิจิทัล | 信息技术 数字媒体"
    },
    {
        "id":8245,
        "name":"8752 (Thai Program)  :  Information Technology Digital Media | เทคโนโลยีสารสนเทศสื่อดิจิทัล | 信息技术数字媒体"
    },
    {
        "id":8246,
        "name":"8753 (Thai Program)  :  State Administration | การบริหารแห่งรัฐ | 国家行政管理局"
    },
    {
        "id":8247,
        "name":"8754 (English Program)  :  State Administration | การบริหารงานของรัฐ | 国家行政部门"
    },
    {
        "id":8248,
        "name":"8755 (Thai Program)  :  Guidance Psychology And Librarianship | จิตวิทยาการแนะแนวและบรรณารักษศาสตร์ | 指导心理学和图书馆学"
    },
    {
        "id":8249,
        "name":"8756 (English Program)  :  Guidance Psychology And Library | จิตวิทยาการแนะแนวและห้องสมุด | 指导心理学和图书馆"
    },
    {
        "id":8250,
        "name":"8757 (English Program)  :  Thai For Innovative Communication And Career | ภาษาไทยเพื่อการสื่อสารและอาชีพที่เป็นนวัตกรรมใหม่ | 泰语创新沟通和职业"
    },
    {
        "id":8251,
        "name":"8758 (Thai Program)  :  Thai Language For Communication And Career Innovation | ภาษาไทยเพื่อนวัตกรรมการสื่อสารและอาชีพ | 泰语用于沟通和职业创新"
    },
    {
        "id":8252,
        "name":"8759 (Thai Program)  :  Beauty Product Technology | เทคโนโลยีผลิตภัณฑ์ความงาม | 美容产品技术"
    },
    {
        "id":8253,
        "name":"8760 (English Program)  :  Beauty Product Technology | เทคโนโลยีผลิตภัณฑ์ความงาม | 美容产品技术"
    },
    {
        "id":8254,
        "name":"8761 (Thai Program)  :  Health And Beauty Technology | เทคโนโลยีสุขภาพและความงาม | 健康与美容科技"
    },
    {
        "id":8255,
        "name":"8762 (English Program)  :  Health And Beauty Technology | เทคโนโลยีด้านสุขภาพและความงาม | 健康美容科技"
    },
    {
        "id":8256,
        "name":"8763 (Thai Program)  :  Construction Management Technology | เทคโนโลยีบริหารงานก่อสร้าง | 施工管理技术"
    },
    {
        "id":8257,
        "name":"8764 (English Program)  :  English For International Professions | ภาษาอังกฤษเพื่อวิชาชีพระหว่างประเทศ | 国际职业英语"
    },
    {
        "id":8258,
        "name":"8765 (Thai Program)  :  English For International Careers | ภาษาอังกฤษเพื่ออาชีพนานาชาติ | 国际职业英语"
    },
    {
        "id":8259,
        "name":"8766 (Thai Program)  :  Health Product Innovation | นวัตกรรมผลิตภัณฑ์สุขภาพ | 健康产品创新"
    },
    {
        "id":8260,
        "name":"8767 (English Program)  :  Innovation Of Health Products | นวัตกรรมผลิตภัณฑ์เพื่อสุขภาพ | 保健品创新"
    },
    {
        "id":8261,
        "name":"8768 (Thai Program)  :  Food Science And Technology Management | วิทยาศาสตร์และการจัดการเทคโนโลยีอาหาร | 食品科学技术管理"
    },
    {
        "id":8262,
        "name":"8769 (English Program)  :  Food Science And Technology Management | การจัดการวิทยาศาสตร์การอาหารและเทคโนโลยี | 食品科学与技术管理"
    },
    {
        "id":8263,
        "name":"8770 (Thai Program)  :  Alternative Medicine | การแพทย์ทางเลือก | 替代医学"
    },
    {
        "id":8264,
        "name":"8771 (English Program)  :  Complementary And Alternative Medicine | ยาเสริมและยาทางเลือก | 补充和替代医学"
    },
    {
        "id":8265,
        "name":"8772 (Thai Program)  :  Agricultural Innovation And Technology | นวัตกรรมและเทคโนโลยีการเกษตร | 农业创新与技术"
    },
    {
        "id":8266,
        "name":"8773 (English Program)  :  Agricultural Innovation And Technology | นวัตกรรมและเทคโนโลยีการเกษตร | 农业创新与科技"
    },
    {
        "id":8267,
        "name":"8774 (Thai Program)  :  Public Sector Management Innovation | นวัตกรรมการจัดการภาครัฐ | 公共部门管理创新"
    },
    {
        "id":8268,
        "name":"8775 (English Program)  :  Public Management Innovation | นวัตกรรมการจัดการสาธารณะ | 公共管理创新"
    },
    {
        "id":8269,
        "name":"8776 (Thai Program)  :  Material Technology And Innovation | เทคโนโลยีวัสดุและนวัตกรรม | 材料技术与创新"
    },
    {
        "id":8270,
        "name":"8777 (English Program)  :  Materials Technology And Innovation | เทคโนโลยีวัสดุและนวัตกรรม | 材料技术与创新"
    },
    {
        "id":8271,
        "name":"8778 (Thai Program)  :  Administration Of Justice | การบริหารกระบวนการยุติธรรม | 司法行政"
    },
    {
        "id":8272,
        "name":"8779 (English Program)  :  Justice Administration | การบริหารความยุติธรรม | 司法行政"
    },
    {
        "id":8273,
        "name":"8780 (Thai Program)  :  Aviation And Hospitality Industry Management | การจัดการอุตสาหกรรมการบินและการบริการ | 航空和酒店业管理"
    },
    {
        "id":8274,
        "name":"8781 (English Program)  :  Aviation Industry And Hospitality Management | การจัดการอุตสาหกรรมการบินและการบริการ | 航空业和酒店管理"
    },
    {
        "id":8275,
        "name":"8782 (English Program)  :  Digital Science And Technology | วิทยาศาสตร์และเทคโนโลยีดิจิทัล | 数字科学与技术"
    },
    {
        "id":8276,
        "name":"8783 (Thai Program)  :  Data Science And Insights | วิทยาการข้อมูลและการวิเคราะห์เชิงลึก | 数据科学和见解"
    },
    {
        "id":8277,
        "name":"8784 (English Program)  :  Digital Engineering | วิศวกรรมดิจิทัล | 数字工程"
    },
    {
        "id":8278,
        "name":"8785 (Thai Program)  :  Industrial Management And Innovation | การจัดการอุตสาหกรรมและนวัตกรรม | 工业管理与创新"
    },
    {
        "id":8279,
        "name":"8786 (Thai Program)  :  Innovation In Computer Education | นวัตกรรมทางคอมพิวเตอร์ศึกษา | 计算机教育创新"
    },
    {
        "id":8280,
        "name":"8787 (English Program)  :  Innovations In Computer Science | นวัตกรรมทางวิทยาการคอมพิวเตอร์ | 计算机科学的创新"
    },
    {
        "id":8281,
        "name":"8788 (Thai Program)  :  Local Arts | ศิลปกรรมพื้นถิ่น | 地方艺术"
    },
    {
        "id":8282,
        "name":"8789 (English Program)  :  Local Arts | ศิลปะท้องถิ่น | 当地艺术"
    },
    {
        "id":8283,
        "name":"8790 (Thai Program)  :  Petrochemical And Polymer Engineering | วิศวกรรมปิโตรเคมีและพอลิเมอร์ | 石油化工与高分子工程"
    },
    {
        "id":8284,
        "name":"8791 (English Program)  :  Petrochemical And Polymer Engineering | วิศวกรรมปิโตรเคมีและโพลีเมอร์ | 石油化工与高分子工程"
    },
    {
        "id":8285,
        "name":"8792 (Thai Program)  :  Industrial And Environmental Systems Engineering | วิศวกรรมระบบอุตสาหกรรมและสิ่งแวดล้อม | 工业与环境系统工程"
    },
    {
        "id":8286,
        "name":"8793 (English Program)  :  Industrial Systems And Environmental Engineering | ระบบอุตสาหกรรมและวิศวกรรมสิ่งแวดล้อม | 工业系统和环境工程"
    },
    {
        "id":8287,
        "name":"8794 (Thai Program)  :  Telecommunications And Computer Engineering | วิศวกรรมโทรคมนาคมและคอมพิวเตอร์ | 电信和计算机工程"
    },
    {
        "id":8288,
        "name":"8795 (English Program)  :  Telecommunication And Computer Engineering | โทรคมนาคมและวิศวกรรมคอมพิวเตอร์ | 电信和计算机工程"
    },
    {
        "id":8289,
        "name":"8796 (Thai Program)  :  International Digital Business | ธุรกิจดิจิทัลระหว่างประเทศ | 国际数字业务"
    },
    {
        "id":8290,
        "name":"8797 (English Program)  :  International Digital Business | ธุรกิจดิจิทัลระหว่างประเทศ | 国际数字业务"
    },
    {
        "id":8291,
        "name":"8798 (Thai Program)  :  Japanese For International Business | ภาษาญี่ปุ่นเพื่อธุรกิจระหว่างประเทศ | 国际商务日语"
    },
    {
        "id":8292,
        "name":"8799 (English Program)  :  Japanese For International Business | ภาษาญี่ปุ่นเพื่อธุรกิจระหว่างประเทศ | 国际商务日语"
    },
    {
        "id":8293,
        "name":"8800 (Thai Program)  :  Business And Vocational Education | ธุรกิจและอาชีวศึกษา | 商业和职业教育"
    },
    {
        "id":8294,
        "name":"8801 (English Program)  :  Business And Vocational Education | ธุรกิจและอาชีวศึกษา | 商业和职业教育"
    },
    {
        "id":8295,
        "name":"8802 (Thai Program)  :  Physical Systems Connected By Cyber Networks | ระบบกายภาพที่เชื่อมประสานด้วยเครือข่ายไซเบอร์ | 通过网络连接的物理系统"
    },
    {
        "id":8296,
        "name":"8803 (English Program)  :  Cyber-Physical System | ระบบไซเบอร์-กายภาพ | 信息物理系统"
    },
    {
        "id":8297,
        "name":"8804 (Thai Program)  :  Computer Graphics And Creative Media | คอมพิวเตอร์กราฟิกและสื่อสร้างสรรค์ | 计算机图形学和创意媒体"
    },
    {
        "id":8298,
        "name":"8805 (English Program)  :  Computer Graphic And Creative Media Design | คอมพิวเตอร์กราฟิกและการออกแบบสื่อสร้างสรรค์ | 计算机图形和创意媒体设计"
    },
    {
        "id":8299,
        "name":"8806 (Thai Program)  :  Communication Arts, Imagination, Media Engineering And Entrepreneurship | นิเทศศาสตร์จินตวิศวกรรมสื่อและการเป็นผู้ประกอบการ | 传播艺术、想象力、媒体工程和创业"
    },
    {
        "id":8300,
        "name":"8807 (English Program)  :  Imagineer Media Entrepreneurship | ผู้ประกอบการสื่อแห่งจินตนาการ | 想象者媒体创业"
    },
    {
        "id":8301,
        "name":"8808 (Thai Program)  :  Computer Animation And Visual Effects | คอมพิวเตอร์แอนิเมชันและวิชวลเอฟเฟกต์ | 计算机动画和视觉效果"
    },
    {
        "id":8302,
        "name":"8809 (English Program)  :  Computer Animation And Visual Effects | แอนิเมชันคอมพิวเตอร์และเอฟเฟ็กต์ภาพ | 电脑动画和视觉效果"
    },
    {
        "id":8303,
        "name":"8810 (Thai Program)  :  English-Chinese For Digital Communication | ภาษาอังกฤษ-จีนเพื่อการสื่อสารดิจิทัล | 英汉数字通讯"
    },
    {
        "id":8304,
        "name":"8811 (English Program)  :  English-Chinese For Digital Communication | ภาษาอังกฤษ-จีนเพื่อการสื่อสารดิจิทัล | 数字通讯英汉双语"
    },
    {
        "id":8305,
        "name":"8812 (Thai Program)  :  Herbal And Cannabis Science | สมุนไพรและกัญชาศาสตร์ | 草药和大麻科学"
    },
    {
        "id":8306,
        "name":"8813 (English Program)  :  Herbal And Cannabis Science | วิทยาศาสตร์สมุนไพรและกัญชา | 草药和大麻科学"
    },
    {
        "id":8307,
        "name":"8814 (Thai Program)  :  Data Engineering | วิศวกรรมข้อมูล | 数据工程"
    },
    {
        "id":8308,
        "name":"8815 (English Program)  :  Data Engineering | วิศวกรรมข้อมูล | 数据工程"
    },
    {
        "id":8309,
        "name":"8816 (Thai Program)  :  Global Citizenship Studies | พลเมืองโลกศึกษา | 全球公民研究"
    },
    {
        "id":8310,
        "name":"8817 (English Program)  :  Global Citizenship Education | การศึกษาความเป็นพลเมืองโลก | 全球公民教育"
    },
    {
        "id":8311,
        "name":"8818 (Thai Program)  :  Food Innovation And Entrepreneurship | นวัตกรรมอาหารและการเป็นผู้ประกอบการ | 食品创新创业"
    },
    {
        "id":8312,
        "name":"8819 (English Program)  :  Food Innovation And Entrepreneurship | นวัตกรรมด้านอาหารและการเป็นผู้ประกอบการ | 食品创新与创业"
    },
    {
        "id":8313,
        "name":"8820 (Thai Program)  :  Asean Languages ​​And Cultures | ภาษาและวัฒนธรรมอาเซียน | 东盟语言和文化"
    },
    {
        "id":8314,
        "name":"8821 (English Program)  :  Asean Languages And Cultures | ภาษาและวัฒนธรรมอาเซียน | 东盟语言和文化"
    },
    {
        "id":8315,
        "name":"8822 (Thai Program)  :  Agricultural Innovation And Sustainable River Basin Management | นวัตกรรมเกษตรและการจัดการลุ่มน้ำอย่างยั่งยืน | 农业创新与可持续流域管理"
    },
    {
        "id":8316,
        "name":"8823 (English Program)  :  Innovative Agriculture And Sustainable Watershed Management | นวัตกรรมการเกษตรและการจัดการลุ่มน้ำอย่างยั่งยืน | 创新农业和可持续流域管理"
    },
    {
        "id":8317,
        "name":"8824 (Thai Program)  :  Creative Arts And Curatorial Studies | ศิลปะสร้างสรรค์และภัณฑารักษ์ศึกษา | 创意艺术与策展研究"
    },
    {
        "id":8318,
        "name":"8825 (English Program)  :  Creative Arts And Curatorial Studies | ศิลปะสร้างสรรค์และการศึกษาภัณฑารักษ์ | 创意艺术和策展研究"
    },
    {
        "id":8319,
        "name":"8826 (Thai Program)  :  Innovation And Industrial Business Information Management | นวัตกรรมและการจัดการข้อมูลธุรกิจอุตสาหกรรม | 创新与产业商业信息管理"
    },
    {
        "id":8320,
        "name":"8827 (English Program)  :  Innovation And Data Management Of Industrial Business | นวัตกรรมและการจัดการข้อมูลของธุรกิจอุตสาหกรรม | 工业企业的创新和数据管理"
    },
    {
        "id":8321,
        "name":"8828 (English Program)  :  Digital Business Technology | เทคโนโลยีธุรกิจดิจิทัล | 数字商业技术"
    },
    {
        "id":8322,
        "name":"8829 (Thai Program)  :  Innovation In Public Administration | นวัตกรรมการบริหารงานภาครัฐ | 公共行政创新"
    },
    {
        "id":8323,
        "name":"8830 (English Program)  :  Innovative Public Administration | การบริหารสาธารณะที่เป็นนวัตกรรมใหม่ | 创新公共管理"
    },
    {
        "id":8324,
        "name":"8831 (English Program)  :  Liberal Arts | ศิลปศาสตร์ | 文科"
    },
    {
        "id":8325,
        "name":"8832 (Thai Program)  :  Innovation In Educational Administration For The Progress Of Humanity | นวัตกรรมการบริหารการศึกษาเพื่อความก้าวหน้าของมนุษยชาติ | 教育管理创新促进人类进步"
    },
    {
        "id":8326,
        "name":"8833 (English Program)  :  Educational Administration Innovation For Humankind Advancement | นวัตกรรมการบริหารการศึกษาเพื่อความก้าวหน้าของมนุษยชาติ | 教育管理创新促进人类进步"
    },
    {
        "id":8327,
        "name":"8834 (Thai Program)  :  Social Sciences And Development | สังคมศาสตร์และการพัฒนา | 社会科学与发展"
    },
    {
        "id":8328,
        "name":"8835 (English Program)  :  Social Science And Development | สังคมศาสตร์และการพัฒนา | 社会科学与发展"
    },
    {
        "id":8329,
        "name":"8836 (English Program)  :  Electrical Communication Engineering | วิศวกรรมไฟฟ้าสื่อสาร | 电气通信工程"
    },
    {
        "id":8330,
        "name":"8837 (Thai Program)  :  Map Engineering | วิศวกรรมแผนที่ | 地图工程"
    },
    {
        "id":8331,
        "name":"8838 (English Program)  :  Surveying And Mapping | การสำรวจและการทำแผนที่ | 测绘"
    },
    {
        "id":8332,
        "name":"8839 (Thai Program)  :  Cyber Security | ความมั่นคงปลอดภัยทางไซเบอร์ | 网络安全"
    },
    {
        "id":8333,
        "name":"8840 (English Program)  :  Cyber Security | การรักษาความปลอดภัยทางไซเบอร์ | 网络安全"
    },
    {
        "id":8334,
        "name":"8841 (English Program)  :  Social Sciences For Development | สังคมศาสตร์เพื่อการพัฒนา | 社会科学促进发展"
    },
    {
        "id":8335,
        "name":"8842 (Thai Program)  :  Information Technology And Data Science | เทคโนโลยีสารสนเทศและวิทยาการข้อมูล | 信息技术和数据科学"
    },
    {
        "id":8336,
        "name":"8843 (English Program)  :  Information Technology And Data Science | เทคโนโลยีสารสนเทศและวิทยาศาสตร์ข้อมูล | 信息技术和数据科学"
    },
    {
        "id":8337,
        "name":"8844 (Thai Program)  :  Life Science | วิทยาศาสตร์เพื่อชีวิต | 生命科学"
    },
    {
        "id":8338,
        "name":"8845 (English Program)  :  Life Sciences | วิทยาศาสตร์ชีวภาพ | 生命科学"
    },
    {
        "id":8339,
        "name":"8846 (Thai Program)  :  Population Policy And Human Development | นโยบายประชากรกับการพัฒนามนุษย์ | 人口政策和人类发展"
    },
    {
        "id":8340,
        "name":"8847 (English Program)  :  Population Policy And Human Development | นโยบายประชากรและการพัฒนามนุษย์ | 人口政策与人类发展"
    },
    {
        "id":8341,
        "name":"8848 (English Program)  :  Innovation And Agricultural Technology | นวัตกรรมและเทคโนโลยีการเกษตร | 创新与农业技术"
    },
    {
        "id":8342,
        "name":"8849 (Thai Program)  :  English For The Service Industry | ภาษาอังกฤษเพื่ออุตสาหกรรมบริการ | 服务业英语"
    },
    {
        "id":8343,
        "name":"8850 (English Program)  :  English For Service Industry | ภาษาอังกฤษสำหรับอุตสาหกรรมบริการ | 服务业英语"
    },
    {
        "id":8344,
        "name":"8851 (Thai Program)  :  Green Logistics And Supply Chain Management | การจัดการโลจิสติกส์และโซ่อุปทานสีเขียว | 绿色物流与供应链管理"
    },
    {
        "id":8345,
        "name":"8852 (English Program)  :  Green Logistics And Supply Chain ​​Management | การจัดการโลจิสติกส์ที่เป็นมิตรต่อสิ่งแวดล้อมและห่วงโซ่อุปทาน | 绿色物流与供应链管理"
    },
    {
        "id":8346,
        "name":"8853 (Thai Program)  :  Educational Management For Sustainable Development | การจัดการศึกษาเพื่อการพัฒนาที่ยั่งยืน | 可持续发展的教育管理"
    },
    {
        "id":8347,
        "name":"8854 (English Program)  :  Educational Management For Sustainable Development | การจัดการศึกษาเพื่อการพัฒนาที่ยั่งยืน | 可持续发展的教育管理"
    },
    {
        "id":8348,
        "name":"8855 (English Program)  :  Royal Goldsmith | รอยัลโกลด์สมิธ | 皇家金匠"
    },
    {
        "id":8349,
        "name":"8856 (Thai Program)  :  Business Law And Communication In Chinese | กฎหมายธุรกิจและการสื่อสารด้วยภาษาจีน | 中文商法与传播"
    },
    {
        "id":8350,
        "name":"8857 (English Program)  :  Business Law And Chinese Communication | กฎหมายธุรกิจและการสื่อสารของจีน | 商法与汉语传播"
    },
    {
        "id":8351,
        "name":"8859 (English Program)  :  Faculty Of Industrial Education And Technology | คณะครุศาสตร์อุตสาหกรรมและเทคโนโลยี | 工业教育与技术学院"
    },
    {
        "id":8352,
        "name":"8860 (English Program)  :  Electronic Engineering And Telecommunication | วิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคม | 电子工程和电信"
    },
    {
        "id":8353,
        "name":"8861 (Thai Program)  :  Elderly Care Science | วิทยาการการดูแลผู้สูงอายุ | 养老科学"
    },
    {
        "id":8354,
        "name":"8862 (English Program)  :  Geriatric Dentistry | ทันตกรรมผู้สูงอายุ | 老年牙科"
    },
    {
        "id":8355,
        "name":"8863 (Thai Program)  :  Public Health Research | วิจัยการสาธารณสุข | 公共卫生研究"
    },
    {
        "id":8356,
        "name":"8864 (English Program)  :  Public Health Research | การวิจัยด้านสาธารณสุข | 公共卫生研究"
    },
    {
        "id":8357,
        "name":"8865 (English Program)  :  Elderly Care Science | วิทยาศาสตร์การดูแลผู้สูงอายุ | 养老科学"
    },
    {
        "id":8358,
        "name":"8866 (Thai Program)  :  Creative Technology | เทคโนโลยีแนวสร้างสรรค์ | 创意科技"
    },
    {
        "id":8359,
        "name":"8867 (English Program)  :  Creative Technology | เทคโนโลยีสร้างสรรค์ | 创意科技"
    },
    {
        "id":8360,
        "name":"8868 (Thai Program)  :  Textile Innovation And Technology | นวัตกรรมและเทคโนโลยีสิ่งทอ | 纺织创新与技术"
    },
    {
        "id":8361,
        "name":"8869 (English Program)  :  Textile Innovation And Technology | นวัตกรรมสิ่งทอและเทคโนโลยี | 纺织创新与技术"
    },
    {
        "id":8362,
        "name":"8870 (Thai Program)  :  Clothing Technology And Fashion Business Management | เทคโนโลยีเสื้อผ้าและการจัดการธุรกิจแฟชั่น | 服装科技与时尚企业管理"
    },
    {
        "id":8363,
        "name":"8871 (English Program)  :  Garment Technology And Fashion Business Management | เทคโนโลยีเครื่องนุ่งห่มและการจัดการธุรกิจแฟชั่น | 服装技术与时尚商业管理"
    },
    {
        "id":8364,
        "name":"8872 (Thai Program)  :  Industrial Engineering And Manufacturing | วิศวกรรมอุตสาหการและการผลิต | 工业工程与制造"
    },
    {
        "id":8365,
        "name":"8873 (English Program)  :  Industrial And Production Engineering | วิศวกรรมอุตสาหการและการผลิต | 工业和生产工程"
    },
    {
        "id":8366,
        "name":"8874 (Thai Program)  :  Automated Production Systems Operations Engineering And Maintenance | วิศวกรรมปฏิบัติการระบบการผลิตอัตโนมัติและการซ่อมบำรุง | 自动化生产系统运营工程和维护"
    },
    {
        "id":8367,
        "name":"8875 (English Program)  :  Practical Engineering In Automated Manufacturing System And Maintenance | วิศวกรรมเชิงปฏิบัติในระบบการผลิตอัตโนมัติและการบำรุงรักษา | 自动化制造系统与维护实用工程"
    },
    {
        "id":8368,
        "name":"8876 (Thai Program)  :  Railway Operations Management | การจัดการการปฏิบัติการรถไฟ | 铁路运营管理"
    },
    {
        "id":8369,
        "name":"8877 (English Program)  :  Railway Operations Management | การจัดการประกอบกิจการรถไฟ | 铁路运营管理"
    },
    {
        "id":8370,
        "name":"8878 (Thai Program)  :  Innovation In The Development Of Cities And Areas Around Mass Transit Stations | นวัตกรรมการพัฒนาเมืองและพื้นที่รอบสถานีขนส่งมวลชน | 公共交通站点周边城市和地区的发展创新"
    },
    {
        "id":8371,
        "name":"8879 (English Program)  :  Innovation Of Urban And Transit-Oriented Development | นวัตกรรมการพัฒนาเมืองและการขนส่งสาธารณะ | 城市和交通导向型发展的创新"
    },
    {
        "id":8372,
        "name":"8880 (Thai Program)  :  Creative Cosmetic Science Innovation | นวัตกรรมวิทยาศาสตร์เครื่องสำอางเชิงสร้างสรรค์ | 创意化妆品科学创新"
    },
    {
        "id":8373,
        "name":"8881 (English Program)  :  Creative Innovation In Cosmetic Science | นวัตกรรมที่สร้างสรรค์ในวิทยาศาสตร์เครื่องสำอาง | 化妆品科学的创意创新"
    },
    {
        "id":8374,
        "name":"8882 (Thai Program)  :  Tourism And Service Businesses | การท่องเที่ยวและธุรกิจบริการ | 旅游及服务业"
    },
    {
        "id":8375,
        "name":"8883 (English Program)  :  Tourism And Hospitality Business | ธุรกิจการท่องเที่ยวและการบริการ | 旅游和酒店业务"
    },
    {
        "id":8376,
        "name":"8884 (Thai Program)  :  Agriculture And Innovation | เกษตรศาสตร์และนวัตกรรม | 农业与创新"
    },
    {
        "id":8377,
        "name":"8885 (English Program)  :  Agriculture And Innovation | การเกษตรและนวัตกรรม | 农业与创新"
    },
    {
        "id":8378,
        "name":"8886 (English Program)  :  Communication And Information Engineering | วิศวกรรมการสื่อสารและสารสนเทศ | 通信与信息工程"
    },
    {
        "id":8379,
        "name":"8887 (English Program)  :  Digital Communication Arts | ศิลปะการสื่อสารดิจิทัล | 数字传播艺术"
    },
    {
        "id":8380,
        "name":"8888 (Thai Program)  :  Fisheries Science And Aquatic Resources | วิทยาศาสตร์การประมงและทรัพยากรทางน้ำ | 渔业科学与水产资源"
    },
    {
        "id":8381,
        "name":"8889 (English Program)  :  Fisheries Science And Aquatic Resources | วิทยาศาสตร์การประมงและทรัพยากรทางน้ำ | 渔业科学和水产资源"
    },
    {
        "id":8382,
        "name":"8890 (English Program)  :  Robotics And Intelligent Electronics Engineering | วิศวกรรมหุ่นยนต์และอิเล็กทรอนิกส์อัจฉริยะ | 机器人与智能电子工程"
    },
    {
        "id":8383,
        "name":"8891 (Thai Program)  :  Fisheries And Aquatic Products | การประมงและผลิตภัณฑ์สัตว์น้ำ | 渔业及水产品"
    },
    {
        "id":8384,
        "name":"8892 (English Program)  :  Fisheries And Fishery Products | การประมงและผลิตภัณฑ์ประมง | 渔业和水产品"
    },
    {
        "id":8385,
        "name":"8893 (Thai Program)  :  Thai Language And Literature | ภาษาและวรรณกรรมไทย | 泰国语言和文学"
    },
    {
        "id":8386,
        "name":"8894 (Thai Program)  :  Digital Economics And Innovation Management | เศรษฐศาสตร์ดิจิทัลและนวัตกรรมการจัดการ | 数字经济与创新管理"
    },
    {
        "id":8387,
        "name":"8895 (English Program)  :  Digital Economics And Management Innovation | เศรษฐศาสตร์ดิจิทัลและนวัตกรรมการจัดการ | 数字经济与管理创新"
    },
    {
        "id":8388,
        "name":"8896 (Thai Program)  :  Digital Communication Innovation | นวัตกรรมการสื่อสารดิจิทัล | 数字通信创新"
    },
    {
        "id":8389,
        "name":"8897 (English Program)  :  Digital Communication Innovation | นวัตกรรมการสื่อสารดิจิทัล | 数字通信创新"
    },
    {
        "id":8390,
        "name":"8898 (Thai Program)  :  Digital Film And Creative Media | ภาพยนตร์ดิจิทัลและสื่อสร้างสรรค์ | 数字电影和创意媒体"
    },
    {
        "id":8391,
        "name":"8899 (English Program)  :  Digital Film And Creative Media | ภาพยนตร์ดิจิทัลและสื่อสร้างสรรค์ | 数字电影和创意媒体"
    },
    {
        "id":8392,
        "name":"8900 (Thai Program)  :  Learning Innovation | นวัตกรรมการเรียนรู้ | 学习创新"
    },
    {
        "id":8393,
        "name":"8901 (English Program)  :  Learning Innovation | นวัตกรรมการเรียนรู้ | 学习创新"
    },
    {
        "id":8394,
        "name":"8902 (Thai Program)  :  Modern Organization Management | การจัดการองค์การยุคใหม่ | 现代组织管理"
    },
    {
        "id":8395,
        "name":"8903 (English Program)  :  Modern Organizational Management | การจัดการองค์กรสมัยใหม่ | 现代组织管理"
    },
    {
        "id":8396,
        "name":"8904 (Thai Program)  :  Electronic Engineering And Automation Control Systems | วิศวกรรมอิเล็กทรอนิกส์และระบบควบคุมอัตโนมัติ | 电子工程与自动化控制系统"
    },
    {
        "id":8397,
        "name":"8905 (English Program)  :  Electronics Engineering And Automatic Control System | วิศวกรรมอิเล็กทรอนิกส์และระบบควบคุมอัตโนมัติ | 电子工程及自动控制系统"
    },
    {
        "id":8398,
        "name":"8906 (Thai Program)  :  Safety Engineering Occupational Health And Environment | วิศวกรรมความปลอดภัย อาชีวอนามัยและสิ่งแวดล้อม | 安全工程职业健康与环境"
    },
    {
        "id":8399,
        "name":"8907 (English Program)  :  Safety, Occupation Health And Environmental Engineering | ความปลอดภัย อาชีวอนามัย และวิศวกรรมสิ่งแวดล้อม | 安全、职业健康与环境工程"
    },
    {
        "id":8400,
        "name":"8908 (Thai Program)  :  International Technology And Innovation Management | การจัดการเทคโนโลยีและนวัตกรรมระหว่างประเทศ | 国际技术与创新管理"
    },
    {
        "id":8401,
        "name":"8909 (English Program)  :  International Technology And Innovation Management | การจัดการเทคโนโลยีและนวัตกรรมระหว่างประเทศ | 国际技术与创新管理"
    },
    {
        "id":8402,
        "name":"8910 (Thai Program)  :  Smart Agricultural Engineering | เกษตรวิศว์อัจฉริยะ | 智慧农业工程"
    },
    {
        "id":8403,
        "name":"8911 (English Program)  :  Smart Engineering Agriculture | เกษตรวิศวกรรมอัจฉริยะ | 智慧工程农业"
    },
    {
        "id":8404,
        "name":"8912 (Thai Program)  :  Natural Resource Management And Sustainability | การจัดการทรัพยากรธรรมชาติและความยั่งยืน | 自然资源管理和可持续性"
    },
    {
        "id":8405,
        "name":"8913 (English Program)  :  Natural Resource Management And Sustainability | การจัดการทรัพยากรธรรมชาติและความยั่งยืน | 自然资源管理和可持续性"
    },
    {
        "id":8406,
        "name":"8914 (Thai Program)  :  Community And Social Development | การพัฒนาชุมชนและสังคม | 社区和社会发展"
    },
    {
        "id":8407,
        "name":"8915 (English Program)  :  Community And Social Development | การพัฒนาชุมชนและสังคม | 社区和社会发展"
    },
    {
        "id":8408,
        "name":"8916 (Thai Program)  :  Strategy For Local Development | ยุทธศาสตร์เพื่อการพัฒนาท้องถิ่น | 地方发展战略"
    },
    {
        "id":8409,
        "name":"8917 (English Program)  :  Local Development Strategy | ยุทธศาสตร์การพัฒนาท้องถิ่น | 本地发展策略"
    },
    {
        "id":8410,
        "name":"8918 (Thai Program)  :  Innovative Material Technology | นวัตกรรมเทคโนโลยีวัสดุ | 创新材料技术"
    },
    {
        "id":8411,
        "name":"8919 (English Program)  :  Innovative Materials Technology | เทคโนโลยีวัสดุที่เป็นนวัตกรรม | 创新材料技术"
    },
    {
        "id":8412,
        "name":"8920 (Thai Program)  :  Integrating Design With Multiple Intelligences | การบูรณาการการออกแบบด้วยพหุปัญญา | 将设计与多元智能融为一体"
    },
    {
        "id":8413,
        "name":"8921 (English Program)  :  Multiple Intelligence For Design Integration | ความฉลาดหลายประการสำหรับการบูรณาการการออกแบบ | 设计集成的多元智能"
    },
    {
        "id":8414,
        "name":"8922 (Thai Program)  :  Clinical Veterinary Science | วิทยาศาสตร์การสัตวแพทย์คลินิก | 临床兽医学"
    },
    {
        "id":8415,
        "name":"8923 (English Program)  :  Veterinary Clinical Sciences | วิทยาศาสตร์คลินิกสัตวแพทย์ | 兽医临床科学"
    },
    {
        "id":8416,
        "name":"8924 (Thai Program)  :  Education For Entrepreneurial Development | การศึกษาเพื่อพัฒนาความเป็นผู้ประกอบการ | 创业发展教育"
    },
    {
        "id":8417,
        "name":"8925 (English Program)  :  Entrepreneurship Education | การศึกษาการเป็นผู้ประกอบการ | 创业教育"
    },
    {
        "id":8418,
        "name":"8926 (Thai Program)  :  Social Innovation For Sustainable Development | นวัตกรรมสังคมเพื่อการพัฒนาที่ยั่งยืน | 社会创新促进可持续发展"
    },
    {
        "id":8419,
        "name":"8927 (English Program)  :  Social Innovation For Sustainable Development | นวัตกรรมทางสังคมเพื่อการพัฒนาที่ยั่งยืน | 社会创新促进可持续发展"
    },
    {
        "id":8420,
        "name":"8928 (Thai Program)  :  Digital Design | การออกแบบดิจิทัล | 数字化设计"
    },
    {
        "id":8421,
        "name":"8929 (English Program)  :  Digital Design | การออกแบบดิจิทัล | 数字化设计"
    },
    {
        "id":8422,
        "name":"8930 (Thai Program)  :  Interactive Digital Art | อินเทอร์แอคทีฟดิจิทัลอาร์ต | 互动数字艺术"
    },
    {
        "id":8423,
        "name":"8931 (English Program)  :  Interactive Digital Arts | ศิลปะดิจิทัลเชิงโต้ตอบ | 互动数字艺术"
    },
    {
        "id":8424,
        "name":"8932 (Thai Program)  :  Advanced Education Innovation | นวัตกรรมการศึกษาขั้นสูง | 先进教育创新"
    },
    {
        "id":8425,
        "name":"8933 (English Program)  :  Innovation Advanced Education | นวัตกรรมการศึกษาขั้นสูง | 创新高等教育"
    },
    {
        "id":8426,
        "name":"8934 (Thai Program)  :  Community Health Development | การพัฒนาสุขภาพชุมชน | 社区卫生发展"
    },
    {
        "id":8427,
        "name":"8935 (English Program)  :  Community Health Development | การพัฒนาสุขภาพชุมชน | 社区健康发展"
    },
    {
        "id":8428,
        "name":"8936 (Thai Program)  :  Smart Farm Engineering And Agricultural Innovation | วิศวกรรมฟาร์มอัจฉริยะและนวัตกรรมเกษตร | 智慧农场工程与农业创新"
    },
    {
        "id":8429,
        "name":"8937 (English Program)  :  Smart Farm And Agricultural Innovation Engineering | ฟาร์มอัจฉริยะและวิศวกรรมนวัตกรรมการเกษตร | 智慧农场与农业创新工程"
    },
    {
        "id":8430,
        "name":"8938 (English Program)  :  Smart Farming | การทำฟาร์มอัจฉริยะ | 智慧农业"
    },
    {
        "id":8431,
        "name":"8939 (English Program)  :  Development Of Justice System | การพัฒนาระบบยุติธรรม | 司法系统的发展"
    },
    {
        "id":8432,
        "name":"8940 (Thai Program)  :  Development Of The Justice Process | การพัฒนากระบวนการยุติธรรม | 司法程序的发展"
    },
    {
        "id":8433,
        "name":"8941 (Thai Program)  :  Veterinary Pharmacology And Toxicology | เภสัชวิทยาและพิษวิทยาทางการสัตวแพทย์ | 兽医药理学和毒理学"
    },
    {
        "id":8434,
        "name":"8942 (English Program)  :  Technology Of Health Management | เทคโนโลยีการจัดการสุขภาพ | 健康管理科技"
    },
    {
        "id":8435,
        "name":"8943 (Thai Program)  :  Cyber Security | ความมั่นคงปลอดภัยไซเบอร์ | 网络安全"
    },
    {
        "id":8436,
        "name":"8944 (Thai Program)  :  Cyber ​​Security Management | การจัดการความมั่นคงปลอดภัยไซเบอร์ | 网络安全管理"
    },
    {
        "id":8437,
        "name":"8945 (English Program)  :  Cybersecurity | ความปลอดภัยทางไซเบอร์ | 网络安全"
    },
    {
        "id":8438,
        "name":"8946 (English Program)  :  Cybersecurity Management | การจัดการความปลอดภัยทางไซเบอร์ | 网络安全管理"
    },
    {
        "id":8439,
        "name":"8947 (English Program)  :  College Of Digital Innovation Technology | วิทยาลัยเทคโนโลยีนวัตกรรมดิจิทัล | 数字创新技术学院"
    },
    {
        "id":8440,
        "name":"8948 (English Program)  :  Visual Arts And Design | ทัศนศิลป์และการออกแบบ | 视觉艺术与设计"
    },
    {
        "id":8441,
        "name":"8949 (English Program)  :  Arts Managemen | การจัดการศิลปะ | 艺术管理人员"
    },
    {
        "id":8442,
        "name":"8950 (Thai Program)  :  Teaching Chinese To Speakers Of English | การสอนภาษาจีนแก่ผู้พูดภาษาอี่น | 向说英语的人教授汉语"
    },
    {
        "id":8443,
        "name":"8951 (English Program)  :  Teaching Chinese To Speakers Of Other Languages | การสอนภาษาจีนให้กับผู้พูดภาษาอื่น | 向其他语言的人教授汉语"
    },
    {
        "id":8444,
        "name":"8952 (Thai Program)  :  Cultural And Creative Industry Management | การจัดการอุตสาหกรรมเชิงวัฒนธรรมและสร้างสรรค์ | 文化创意产业管理"
    },
    {
        "id":8445,
        "name":"8953 (English Program)  :  Cultural And Creative Industry Management | การจัดการอุตสาหกรรมวัฒนธรรมและสร้างสรรค์ | 文化创意产业管理"
    },
    {
        "id":8446,
        "name":"8954 (Thai Program)  :  Innovation And Entrepreneurial Technology | นวัตกรรมและเทคโนโลยีผู้ประกอบการ | 创新创业科技"
    },
    {
        "id":8447,
        "name":"8955 (English Program)  :  Innovation And Entrepreneurial Technology | นวัตกรรมและเทคโนโลยีผู้ประกอบการ | 创新创业科技"
    },
    {
        "id":8448,
        "name":"8956 (Thai Program)  :  Science And Business Innovation | นวัตกรรมวิทยาศาสตร์และธุรกิจ | 科学与商业创新"
    },
    {
        "id":8449,
        "name":"8957 (English Program)  :  Science And Business Innovation | นวัตกรรมทางวิทยาศาสตร์และธุรกิจ | 科学与商业创新"
    },
    {
        "id":8450,
        "name":"8958 (Thai Program)  :  High Speed Rail Engineering | วิศวกรรมรถไฟความเร็วสูง | 高铁工程"
    },
    {
        "id":8451,
        "name":"8959 (English Program)  :  High Speed Train Engineering | วิศวกรรมรถไฟความเร็วสูง | 高速列车工程"
    },
    {
        "id":8452,
        "name":"8960 (Thai Program)  :  Industrial Engineering And Logistics | วิศวกรรมอุตสาหการและโลจิสติกส์ | 工业工程与物流"
    },
    {
        "id":8453,
        "name":"8961 (English Program)  :  Industrial Engineering And Logistics | วิศวกรรมอุตสาหการและโลจิสติกส์ | 工业工程与物流"
    },
    {
        "id":8454,
        "name":"8962 (Thai Program)  :  Construction And Railway Engineering | วิศวกรรมการก่อสร้างและระบบราง | 建筑及铁路工程"
    },
    {
        "id":8455,
        "name":"8963 (English Program)  :  Construction And Railway System Engineering | วิศวกรรมการก่อสร้างและระบบรถไฟ | 建筑和铁路系统工程"
    },
    {
        "id":8456,
        "name":"8964 (Thai Program)  :  Leadership And Policy Innovation | ภาวะผู้นำและนวัตกรรมนโยบาย | 领导力和政策创新"
    },
    {
        "id":8457,
        "name":"8965 (English Program)  :  Leadership And Policy Innovation | ความเป็นผู้นำและนวัตกรรมด้านนโยบาย | 领导力和政策创新"
    },
    {
        "id":8458,
        "name":"8966 (Thai Program)  :  Urban Development Strategy | ยุทธศาสตร์การพัฒนาเมือง | 城市发展战略"
    },
    {
        "id":8459,
        "name":"8967 (English Program)  :  Urban Development Strategy | ยุทธศาสตร์การพัฒนาเมือง | 城市发展战略"
    },
    {
        "id":8460,
        "name":"8968 (Thai Program)  :  Innovative Hotel And Real Estate Design And Management | นวัตกรรมการออกแบบและการจัดการโรงแรมและอสังหาริมทรัพย์ | 创新的酒店和房地产设计与管理"
    },
    {
        "id":8461,
        "name":"8969 (English Program)  :  Design Innovation And Hotel And Real Estate Management | นวัตกรรมการออกแบบและการจัดการโรงแรมและอสังหาริมทรัพย์ | 设计创新与酒店和房地产管理"
    },
    {
        "id":8462,
        "name":"8970 (Thai Program)  :  Service Industry Technology Innovation | นวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ | 服务业技术创新"
    },
    {
        "id":8463,
        "name":"8971 (English Program)  :  Hospitality Technology Innovation | นวัตกรรมเทคโนโลยีการต้อนรับ | 酒店科技创新"
    },
    {
        "id":8464,
        "name":"8972 (English Program)  :  Master Of Industrial Science | วิทยาศาสตรมหาบัณฑิต | 工业科学硕士"
    },
    {
        "id":8465,
        "name":"8973 (Thai Program)  :  Industrial Robots And Automation | หุ่นยนต์อุตสาหกรรมและระบบอัตโนมัติ | 工业机器人和自动化"
    },
    {
        "id":8466,
        "name":"8974 (English Program)  :  Industrial Robotics And Automatic Systems | หุ่นยนต์อุตสาหกรรมและระบบอัตโนมัติ | 工业机器人和自动化系统"
    },
    {
        "id":8467,
        "name":"8975 (English Program)  :  Health Science Business | ธุรกิจวิทยาศาสตร์สุขภาพ | 健康科学业务"
    },
    {
        "id":8468,
        "name":"8976 (Thai Program)  :  Health Business Science | วิทยาการธุรกิจสุขภาพ | 健康商业科学"
    },
    {
        "id":8469,
        "name":"8977 (English Program)  :  Agriculture Sciences | วิทยาศาสตร์การเกษตร | 农业科学"
    },
    {
        "id":8470,
        "name":"8978 (Thai Program)  :  Aircraft Technician | ช่างเทคนิคอากาศยาน | 飞机技术员"
    },
    {
        "id":8471,
        "name":"8979 (English Program)  :  Aircraft Technician | ช่างอากาศยาน | 飞机技术员"
    },
    {
        "id":8472,
        "name":"8980 (English Program)  :  Mechanical Technique | เทคนิคทางกล | 机械技术"
    },
    {
        "id":8473,
        "name":"8981 (English Program)  :  Metal Technical | เทคนิคโลหะ | 金属技术"
    },
    {
        "id":8474,
        "name":"8982 (Thai Program)  :  Digital Business Computer | คอมพิวเตอร์ธุรกิจดิจิทัล | 数字商务计算机"
    },
    {
        "id":8475,
        "name":"8983 (Thai Program)  :  International Political Economy And Development | เศรษฐศาสตร์การเมืองระหว่างประเทศและการพัฒนา | 国际政治经济与发展"
    },
    {
        "id":8476,
        "name":"8984 (English Program)  :  International Political Economy And Development | เศรษฐกิจและการพัฒนาการเมืองระหว่างประเทศ | 国际政治经济与发展"
    },
    {
        "id":8477,
        "name":"8985 (English Program)  :  Industrial Management And Innovation | การจัดการอุตสาหกรรมและนวัตกรรม | 产业管理与创新"
    },
    {
        "id":8478,
        "name":"8986 (English Program)  :  Islamic Business Administration | การบริหารธุรกิจอิสลาม | 伊斯兰工商管理"
    },
    {
        "id":8479,
        "name":"8987 (Thai Program)  :  Food Processing Business | ธุรกิจการแปรรูปอาหาร | 食品加工业务"
    },
    {
        "id":8480,
        "name":"8988 (English Program)  :  Food Processing Business | ธุรกิจแปรรูปอาหาร | 食品加工业务"
    },
    {
        "id":8481,
        "name":"8989 (Thai Program)  :  Insurance And Risk Management | การประกันภัยและการบริหารความเสี่ยง | 保险与风险管理"
    },
    {
        "id":8482,
        "name":"8990 (English Program)  :  Insurance And Risk Management | การประกันภัยและการจัดการความเสี่ยง | 保险和风险管理"
    },
    {
        "id":8483,
        "name":"8991 (English Program)  :  Manufacturing System Engineering | วิศวกรรมระบบการผลิต | 制造系统工程"
    },
    {
        "id":8484,
        "name":"8992 (Thai Program)  :  Intelligent Computers And Electronics | คอมพิวเตอร์และอิเล็กทรอนิกส์อัจฉริยะ | 智能计算机和电子产品"
    },
    {
        "id":8485,
        "name":"8993 (English Program)  :  Computer And Smart Electronics | คอมพิวเตอร์และอิเล็กทรอนิกส์อัจฉริยะ | 计算机和智能电子产品"
    },
    {
        "id":8486,
        "name":"8994 (English Program)  :  Mechanicals | กลศาสตร์ | 机械原理"
    },
    {
        "id":8487,
        "name":"8995 (Thai Program)  :  Interdisciplinarity For Development | สหวิทยาการเพื่อการพัฒนา | 跨学科促进发展"
    },
    {
        "id":8488,
        "name":"8996 (English Program)  :  Interdisciplinary For Development | สหวิทยาการเพื่อการพัฒนา | 跨学科促进发展"
    },
    {
        "id":8489,
        "name":"8997 (Thai Program)  :  Real Estate Management And Building Technology | การจัดการอสังหาริมทรัพย์และเทคโนโลยีอาคาร | 房地产管理和建筑技术"
    },
    {
        "id":8490,
        "name":"8998 (English Program)  :  Real Estate Management And Building Technology | การจัดการอสังหาริมทรัพย์และเทคโนโลยีการสร้าง | 房地产管理和建筑技术"
    },
    {
        "id":8491,
        "name":"8999 (Thai Program)  :  Jewelry Manufacturing Engineering | วิศวกรรมการผลิตเครื่องประดับ | 珠宝制造工程"
    },
    {
        "id":8492,
        "name":"9000 (English Program)  :  Jewelry Production Engineering | วิศวกรรมการผลิตเครื่องประดับ | 珠宝生产工程"
    },
    {
        "id":8493,
        "name":"9001 (English Program)  :  Industrials | ทางอุตสาหกรรม | 工业"
    },
    {
        "id":8494,
        "name":"9002 (English Program)  :  Interdisciplinary Studies For Development | การศึกษาแบบสหวิทยาการเพื่อการพัฒนา | 跨学科发展研究"
    },
    {
        "id":8495,
        "name":"9003 (Thai Program)  :  Health Promotion Management | การจัดการสร้างเสริมสุขภาพ | 健康促进管理"
    },
    {
        "id":8496,
        "name":"9004 (Thai Program)  :  Promoting Health Of The Elderly | การสร้างเสริมสุขภาพผู้สูงวัย | 促进老年人健康"
    },
    {
        "id":8497,
        "name":"9005 (Thai Program)  :  Practical Engineering | วิศวกรรมปฏิบัติ | 实用工程"
    },
    {
        "id":8498,
        "name":"9006 (English Program)  :  Practical Engineering | วิศวกรรมเชิงปฏิบัติ | 实用工程"
    },
    {
        "id":8499,
        "name":"9007 (Thai Program)  :  Intelligent Robot | หุ่นยนต์อัจฉริยะ | 智能机器人"
    },
    {
        "id":8500,
        "name":"9008 (English Program)  :  Intelligent Robotics | หุ่นยนต์อัจฉริยะ | 智能机器人"
    },
    {
        "id":8501,
        "name":"9009 (Thai Program)  :  Aircraft Maintenance Engineering | วิศวกรรมซ่อมบำรุงรักษาอากาศยาน | 飞机维修工程"
    },
    {
        "id":8502,
        "name":"9010 (Thai Program)  :  Information Systems And Digital Innovation | ระบบสารสนเทศและนวัตกรรมดิจิทัล | 信息系统和数字创新"
    },
    {
        "id":8503,
        "name":"9011 (English Program)  :  Information System And Digital Innovation | ระบบสารสนเทศและนวัตกรรมดิจิทัล | 信息系统与数字创新"
    },
    {
        "id":8504,
        "name":"9012 (Thai Program)  :  Digital Business Management And Innovation | การจัดการธุรกิจดิจิทัลและนวัตกรรม | 数字化企业管理与创新"
    },
    {
        "id":8505,
        "name":"9013 (English Program)  :  Digital Business Management And Innovation | การจัดการธุรกิจดิจิทัลและนวัตกรรม | 数字业务管理与创新"
    },
    {
        "id":8506,
        "name":"9014 (Thai Program)  :  Chemistry Science | วิทยาการเคมี | 化学科学"
    },
    {
        "id":8507,
        "name":"9015 (English Program)  :  Chemical Science | วิทยาศาสตร์เคมี | 化学科学"
    },
    {
        "id":8508,
        "name":"9016 (Thai Program)  :  Aircraft Technology | เทคโนโลยีอากาศยาน | 飞机技术"
    },
    {
        "id":8509,
        "name":"9017 (English Program)  :  Aircraft Technology | เทคโนโลยีอากาศยาน | 飞机技术"
    },
    {
        "id":8510,
        "name":"9018 (Thai Program)  :  Integrated Hospitality And Tourism Management | การจัดการการบริการและการท่องเที่ยวแบบบูรณาการ | 综合酒店及旅游管理"
    },
    {
        "id":8511,
        "name":"9019 (English Program)  :  Integrated Hospitality And Tourism Management | การจัดการการต้อนรับและการท่องเที่ยวแบบบูรณาการ | 综合酒店和旅游管理"
    },
    {
        "id":8512,
        "name":"9020 (Thai Program)  :  Mechatronics And Robotics | เมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人技术"
    },
    {
        "id":8513,
        "name":"9021 (Thai Program)  :  The Art Of Cooking And Managing Service With Hospitality. | ศิลปะการปรุงอาหารและการจัดการบริการด้วยไมตรีจิต | 烹饪和热情好客的服务管理艺术。"
    },
    {
        "id":8514,
        "name":"9022 (English Program)  :  Culinary Arts And Hospitality Management | ศิลปะการประกอบอาหารและการจัดการการต้อนรับ | 烹饪艺术和酒店管理"
    },
    {
        "id":8515,
        "name":"9023 (Thai Program)  :  Eastern Language And Culture | ภาษาและวัฒนธรรมตะวันออก | 东方语言和文化"
    },
    {
        "id":8516,
        "name":"9024 (English Program)  :  Oriental Languages And Cultures | ภาษาและวัฒนธรรมตะวันออก | 东方语言和文化"
    },
    {
        "id":8517,
        "name":"9025 (Thai Program)  :  Railway Management Engineering | วิศวกรรมการจัดการระบบราง | 铁路管理工程"
    },
    {
        "id":8518,
        "name":"9026 (English Program)  :  Railway System Management Engineering | วิศวกรรมการจัดการระบบรถไฟ | 铁路系统管理工程"
    },
    {
        "id":8519,
        "name":"9027 (Thai Program)  :  Integrated Innovation | นวัตกรรมบูรณาการ | 集成创新"
    },
    {
        "id":8520,
        "name":"9028 (English Program)  :  Integrated Innovation | นวัตกรรมบูรณาการ | 综合创新"
    },
    {
        "id":8521,
        "name":"9029 (English Program)  :  Security Innovation Management | การจัดการนวัตกรรมด้านความปลอดภัย | 安全创新管理"
    },
    {
        "id":8522,
        "name":"9030 (Thai Program)  :  Health And Biomedical Analysis Science | วิทยาการวิเคราะห์ทางสุขภาพและชีวการแพทย์ | 健康与生物医学分析科学"
    },
    {
        "id":8523,
        "name":"9031 (English Program)  :  Health And Biomedical Analytics | การวิเคราะห์ด้านสุขภาพและชีวการแพทย์ | 健康和生物医学分析"
    },
    {
        "id":8524,
        "name":"9032 (Thai Program)  :  Crop Production Technology Using Royal Science | เทคโนโลยีการผลิตพืชด้วยศาสตร์พระราชา | 采用皇家科学的农作物生产技术"
    },
    {
        "id":8525,
        "name":"9033 (English Program)  :  Plant Production Technology With The King’S Philosophy | เทคโนโลยีการผลิตพืชตามปรัชญาของกษัตริย์ | 具有王者哲学的植物生产技术"
    },
    {
        "id":8526,
        "name":"9034 (Thai Program)  :  Logistics Management And Maritime Business | การจัดการโลจิสติกส์และธุรกิจพาณิชย์นาวี | 物流管理及海运业务"
    },
    {
        "id":8527,
        "name":"9035 (English Program)  :  Logistics Management And Maritime Business | การจัดการโลจิสติกส์และธุรกิจการเดินเรือ | 物流管理及海事业务"
    },
    {
        "id":8528,
        "name":"9036 (English Program)  :  Digital Business Computer | คอมพิวเตอร์ธุรกิจดิจิทัล | 数字商务计算机"
    },
    {
        "id":8529,
        "name":"9037 (Thai Program)  :  Finance And Insurance Business | ธุรกิจการเงินและประกันภัย | 金融保险业务"
    },
    {
        "id":8530,
        "name":"9038 (English Program)  :  Finance And Insurance Business | ธุรกิจการเงินและการประกันภัย | 金融保险业务"
    },
    {
        "id":8531,
        "name":"9039 (Thai Program)  :  Hotel And Event Management | การจัดการโรงแรมและอีเว้นท์ | 酒店和活动管理"
    },
    {
        "id":8532,
        "name":"9040 (Thai Program)  :  Integrated Tourism Management Innovation | นวัตกรรมการจัดการการท่องเที่ยวแบบบูรณาการ | 旅游综合管理创新"
    },
    {
        "id":8533,
        "name":"9041 (English Program)  :  Integrated Tourism Management Innovation | นวัตกรรมการจัดการการท่องเที่ยวเชิงบูรณาการ | 旅游综合管理创新"
    },
    {
        "id":8534,
        "name":"9042 (Thai Program)  :  Management Of The Sports And Health Services Industry | การจัดการอุตสาหกรรมบริการด้านการกีฬาและสุขภาพ | 体育与健康服务业管理"
    },
    {
        "id":8535,
        "name":"9043 (English Program)  :  Sports And Wellness Services Industry Management | การจัดการอุตสาหกรรมบริการกีฬาและสุขภาพ | 体育和健康服务行业管理"
    },
    {
        "id":8536,
        "name":"9044 (Thai Program)  :  Digital Technology For Education | เทคโนโลยีดิจิทัลเพื่อการศึกษา | 教育数字技术"
    },
    {
        "id":8537,
        "name":"9045 (English Program)  :  Digital Technology For Education | เทคโนโลยีดิจิทัลเพื่อการศึกษา | 教育数字技术"
    },
    {
        "id":8538,
        "name":"9046 (Thai Program)  :  Culinary Arts And Restaurant Management | ศิลปะการประกอบอาหารและการจัดการภัตตาคาร | 烹饪艺术和餐厅管理"
    },
    {
        "id":8539,
        "name":"9047 (English Program)  :  Culinary Arts And Restaurant Management | ศิลปะการทำอาหารและการจัดการร้านอาหาร | 烹饪艺术和餐厅管理"
    },
    {
        "id":8540,
        "name":"9048 (Thai Program)  :  Modern Business Organization Management | การจัดการองค์กรธุรกิจสมัยใหม่ | 现代企业组织管理"
    },
    {
        "id":8541,
        "name":"9049 (English Program)  :  Modern Business Organization Management | การจัดการองค์กรธุรกิจสมัยใหม่ | 现代企业组织管理"
    },
    {
        "id":8542,
        "name":"9050 (Thai Program)  :  Information Technology For Business Management | เทคโนโลยีสารสนเทศเพื่อการจัดการธุรกิจ | 企业管理信息技术"
    },
    {
        "id":8543,
        "name":"9051 (English Program)  :  Information Technology For Business Management | เทคโนโลยีสารสนเทศเพื่อการจัดการธุรกิจ | 企业管理信息技术"
    },
    {
        "id":8544,
        "name":"9052 (Thai Program)  :  Computer And Information Engineering | วิศวกรรมคอมพิวเตอร์และสารสนเทศ | 计算机与信息工程"
    },
    {
        "id":8545,
        "name":"9053 (English Program)  :  Computer Engineering And Information | วิศวกรรมคอมพิวเตอร์และข้อมูล | 计算机工程与信息"
    },
    {
        "id":8546,
        "name":"9054 (Thai Program)  :  Digital Radio And Television Media | สื่อวิทยุและโทรทัศน์ดิจิทัล | 数字广播电视媒体"
    },
    {
        "id":8547,
        "name":"9055 (English Program)  :  Digital Media And Broadcasting | สื่อดิจิทัลและการแพร่ภาพกระจายเสียง | 数字媒体和广播"
    },
    {
        "id":8548,
        "name":"9056 (Thai Program)  :  Packaging And Printing Technology | เทคโนโลยีบรรจุภัณฑ์และการพิมพ์ | 包装印刷技术"
    },
    {
        "id":8549,
        "name":"9057 (English Program)  :  Packaging And Printing Technology | เทคโนโลยีการบรรจุและการพิมพ์ | 包装印刷技术"
    },
    {
        "id":8550,
        "name":"9058 (Thai Program)  :  Packaging Technology And Printing Innovations | เทคโนโลยีบรรจุภัณฑ์และนวัตกรรมทางการพิมพ์ | 包装技术和印刷创新"
    },
    {
        "id":8551,
        "name":"9059 (English Program)  :  Packaging Technology And Printing Innovation | เทคโนโลยีบรรจุภัณฑ์และนวัตกรรมการพิมพ์ | 包装技术与印刷创新"
    },
    {
        "id":8552,
        "name":"9060 (Thai Program)  :  Digital Business Information System | ระบบสารสนเทศทางธุรกิจดิจิทัล | 数字化商业信息系统"
    },
    {
        "id":8553,
        "name":"9061 (English Program)  :  Digital Business Information System | ระบบสารสนเทศธุรกิจดิจิทัล | 数字商业信息系统"
    },
    {
        "id":8554,
        "name":"9062 (Thai Program)  :  Software Engineering For Data Science | วิศวกรรมซอฟต์แวร์เพื่อวิทยาการข้อมูล | 数据科学软件工程"
    },
    {
        "id":8555,
        "name":"9063 (English Program)  :  Software Engineering For Data Science | วิศวกรรมซอฟต์แวร์สำหรับวิทยาศาสตร์ข้อมูล | 数据科学软件工程"
    },
    {
        "id":8556,
        "name":"9064 (Thai Program)  :  Statistics And Data Science | สถิติและวิทยาการข้อมูล | 统计和数据科学"
    },
    {
        "id":8557,
        "name":"9065 (English Program)  :  Statistics And Data Sciences | สถิติและวิทยาศาสตร์ข้อมูล | 统计和数据科学"
    },
    {
        "id":8558,
        "name":"9066 (Thai Program)  :  Modern Automotive And Aircraft Parts Manufacturing Engineering | วิศวกรรมการผลิตชิ้นส่วนยานยนต์และอากาศยานสมัยใหม่ | 现代汽车及飞机零部件制造工程"
    },
    {
        "id":8559,
        "name":"9067 (English Program)  :  Modern Automotive And Aerospace Parts Manufacturing Engineering | วิศวกรรมการผลิตชิ้นส่วนยานยนต์และอวกาศสมัยใหม่ | 现代汽车与航空航天零部件制造工程"
    },
    {
        "id":8560,
        "name":"9068 (Thai Program)  :  Advanced Automotive And Transportation Engineering | วิศวกรรมยานยนต์และการขนส่งขั้นสูง | 先进的汽车和运输工程"
    },
    {
        "id":8561,
        "name":"9069 (English Program)  :  Automotive And Advanced Transportation | การขนส่งยานยนต์และขั้นสูง | 汽车和先进交通"
    },
    {
        "id":8562,
        "name":"9070 (Thai Program)  :  Integrated Innovation Management | การจัดการนวัตกรรมเชิงบูรณาการ | 集成创新管理"
    },
    {
        "id":8563,
        "name":"9071 (English Program)  :  Integrated Innovation Management | การจัดการนวัตกรรมแบบบูรณาการ | 综合创新管理"
    },
    {
        "id":8564,
        "name":"9072 (Thai Program)  :  Tourism And Hospitality Industry | อุตสาหกรรมการท่องเที่ยวและการบริการ | 旅游及酒店业"
    },
    {
        "id":8565,
        "name":"9073 (Thai Program)  :  Information And Digital Technology | เทคโนโลยีสารสนเทศและดิจิทัล | 信息和数字技术"
    },
    {
        "id":8566,
        "name":"9074 (English Program)  :  Information Technology And Digital | เทคโนโลยีสารสนเทศและดิจิทัล | 信息技术和数字"
    },
    {
        "id":8567,
        "name":"9075 (Thai Program)  :  Aviation And Transportation Business Management | การจัดการธุรกิจการบินและการขนส่ง | 航空运输业务管理"
    },
    {
        "id":8568,
        "name":"9076 (English Program)  :  Aviation Business And Transport Management | ธุรกิจการบินและการจัดการการขนส่ง | 航空业务和运输管理"
    },
    {
        "id":8569,
        "name":"9077 (English Program)  :  Digital Innovation | นวัตกรรมดิจิทัล | 数字化创新"
    },
    {
        "id":8570,
        "name":"9078 (Thai Program)  :  Computer Games And Esports | คอมพิวเตอร์เกมและอีสปอร์ต | 电脑游戏和电子竞技"
    },
    {
        "id":8571,
        "name":"9079 (English Program)  :  Computer Game And Esport | เกมคอมพิวเตอร์และอีสปอร์ต | 电脑游戏和电子竞技"
    },
    {
        "id":8572,
        "name":"9080 (Thai Program)  :  Public Relations And Corporate Communications | การประชาสัมพันธ์และสื่อสารองค์กร | 公共关系和企业传播"
    },
    {
        "id":8573,
        "name":"9081 (Thai Program)  :  Multi-Platform Radio And Television | วิทยุและโทรทัศน์มัลติแพลตฟอร์ม | 多平台广播电视"
    },
    {
        "id":8574,
        "name":"9082 (English Program)  :  Arts Program In Multi-Platform Radio And Television | โปรแกรมศิลปะในวิทยุและโทรทัศน์หลายแพลตฟอร์ม | 多平台广播电视艺术节目"
    },
    {
        "id":8575,
        "name":"9083 (Thai Program)  :  Digital Marketing And Retail Innovation | การตลาดดิจิทัลและนวัตกรรมการค้าปลีก | 数字营销和零售创新"
    },
    {
        "id":8576,
        "name":"9084 (English Program)  :  Digital Marketing And Retail Innovations | การตลาดดิจิทัลและนวัตกรรมการค้าปลีก | 数字营销和零售创新"
    },
    {
        "id":8577,
        "name":"9085 (Thai Program)  :  Energy And Environmental Engineering | วิศวกรรมพลังงานและสิ่งแวดล้อม | 能源与环境工程"
    },
    {
        "id":8578,
        "name":"9086 (English Program)  :  Energy And Environmental Engineering | วิศวกรรมพลังงานและสิ่งแวดล้อม | 能源与环境工程"
    },
    {
        "id":8579,
        "name":"9087 (Thai Program)  :  Digital Marketing Communications And Branding | การสื่อสารการตลาดดิจิทัลและแบรนด์ดิ้ง | 数字营销传播和品牌"
    },
    {
        "id":8580,
        "name":"9088 (English Program)  :  Digital Marketing Communication And Branding | การสื่อสารการตลาดดิจิทัลและการสร้างแบรนด์ | 数字营销传播和品牌"
    },
    {
        "id":8581,
        "name":"9089 (Thai Program)  :  Digital Film | การภาพยนตร์ดิจิทัล | 数字电影"
    },
    {
        "id":8582,
        "name":"9090 (English Program)  :  Digital Film | ดิจิทัลฟิล์ม | 数码胶片"
    },
    {
        "id":8583,
        "name":"9091 (Thai Program)  :  Sports Communication | นิเทศศาสตร์การกีฬา | 体育传播"
    },
    {
        "id":8584,
        "name":"9092 (Thai Program)  :  Advertising And Creative Media | การโฆษณาและสื่อสร้างสรรค์ | 广告和创意媒体"
    },
    {
        "id":8585,
        "name":"9093 (English Program)  :  Advertising And Creative Media | การโฆษณาและสื่อสร้างสรรค์ | 广告和创意媒体"
    },
    {
        "id":8586,
        "name":"9094 (Thai Program)  :  International Relations And Development | ความสัมพันธ์ระหว่างประเทศและการพัฒนา | 国际关系与发展"
    },
    {
        "id":8587,
        "name":"9095 (Thai Program)  :  Photographic Art And Visual Media | ศิลปะภาพถ่ายและสื่อทัศนภาพ | 摄影艺术和视觉媒体"
    },
    {
        "id":8588,
        "name":"9096 (English Program)  :  Photography And Visual Media | การถ่ายภาพและสื่อภาพ | 摄影和视觉媒体"
    },
    {
        "id":8589,
        "name":"9097 (Thai Program)  :  Innovation In Health Management In The Digital Age | นวัตกรรมการจัดการสุขภาพยุคดิจิทัล | 数字时代健康管理创新"
    },
    {
        "id":8590,
        "name":"9098 (English Program)  :  Health Innovation In Digital Age | นวัตกรรมด้านสุขภาพในยุคดิจิทัล | 数字时代的健康创新"
    },
    {
        "id":8591,
        "name":"9099 (Thai Program)  :  Artificial Intelligence For Business Analysis | ปัญญาประดิษฐ์เพื่อการวิเคราะห์เชิงธุรกิจ | 商业分析人工智能"
    },
    {
        "id":8592,
        "name":"9100 (English Program)  :  Artificial Intelligence For Business Analytics | ปัญญาประดิษฐ์สำหรับการวิเคราะห์ธุรกิจ | 商业分析的人工智能"
    },
    {
        "id":8593,
        "name":"9101 (English Program)  :  Environmental Health And Disasters | สุขภาพสิ่งแวดล้อมและภัยพิบัติ | 环境健康与灾害"
    },
    {
        "id":8594,
        "name":"9102 (English Program)  :  Innovative Technology For Renewable Energy | เทคโนโลยีที่เป็นนวัตกรรมเพื่อพลังงานทดแทน | 可再生能源创新技术"
    },
    {
        "id":8595,
        "name":"9103 (Thai Program)  :  Theoretical Physics And Natural Philosophy | ฟิสิกส์ทฤษฎีและปรัชญาธรรมชาติ | 理论物理与自然哲学"
    },
    {
        "id":8596,
        "name":"9104 (English Program)  :  Theoretical Physics And Natural Philosophy | ฟิสิกส์เชิงทฤษฎีและปรัชญาธรรมชาติ | 理论物理学和自然哲学"
    },
    {
        "id":8597,
        "name":"9105 (Thai Program)  :  Medical Technology Innovation | นวัตกรรมเทคโนโลยีทางการแพทย์ | 医疗技术创新"
    },
    {
        "id":8598,
        "name":"9106 (Thai Program)  :  Medical Innovation And Technology | นวัตกรรมและเทคโนโลยีทางการแพทย์ | 医疗创新与技术"
    },
    {
        "id":8599,
        "name":"9107 (English Program)  :  Medical Innovation And Technology | นวัตกรรมและเทคโนโลยีทางการแพทย์ | 医疗创新与技术"
    },
    {
        "id":8600,
        "name":"9108 (Thai Program)  :  Process Engineering | วิศวกรรมกระบวนการผลิต | 工艺工程"
    },
    {
        "id":8601,
        "name":"9109 (English Program)  :  Manufacturing Process | กระบวนการผลิต | 制造流程"
    },
    {
        "id":8602,
        "name":"9110 (Thai Program)  :  Computer Science And Technology | วิทยาการคอมพิวเตอร์และเทคโนโลยี | 计算机科学与技术"
    },
    {
        "id":8603,
        "name":"9111 (Thai Program)  :  Healthcare Data Science | วิทยาศาสตร์ข้อมูลการดูแลสุขภาพ | 医疗保健数据科学"
    },
    {
        "id":8604,
        "name":"9112 (English Program)  :  Data Science For Health Care | วิทยาศาสตร์ข้อมูลเพื่อการดูแลสุขภาพ | 医疗保健数据科学"
    },
    {
        "id":8605,
        "name":"9113 (Thai Program)  :  Design Exhibitions And Displays | ออกแบบนิทรรศการและการจัดแสดง | 设计展览和展示"
    },
    {
        "id":8606,
        "name":"9114 (Thai Program)  :  Digital Design And Innovation | การออกแบบและนวัตกรรมดิจิทัล | 数字化设计与创新"
    },
    {
        "id":8607,
        "name":"9115 (English Program)  :  Design And Digital Innovation | การออกแบบและนวัตกรรมดิจิทัล | 设计和数字创新"
    },
    {
        "id":8608,
        "name":"9116 (Thai Program)  :  Business And Economics | ธุรกิจและเศรษฐศาสตร์ | 商业与经济"
    },
    {
        "id":8609,
        "name":"9117 (English Program)  :  Business And Economics | ธุรกิจและเศรษฐศาสตร์ | 商业与经济"
    },
    {
        "id":8610,
        "name":"9118 (Thai Program)  :  Mechatronics Engineering And Artificial Intelligence | วิศวกรรมเมคคาทรอนิกส์และปัญญาประดิษฐ์ | 机电工程与人工智能"
    },
    {
        "id":8611,
        "name":"9119 (English Program)  :  Mechatronics Engineering And Artificial Intelligence | วิศวกรรมเมคคาทรอนิกส์และปัญญาประดิษฐ์ | 机电工程与人工智能"
    },
    {
        "id":8612,
        "name":"9120 (Thai Program)  :  Creative Commercial Communication | การสื่อสารเชิงพาณิชย์อย่างสร้างสรรค์ | 创意商业传播"
    },
    {
        "id":8613,
        "name":"9121 (English Program)  :  Creative Commercial Communication | การสื่อสารเชิงพาณิชย์ที่สร้างสรรค์ | 创意商业传播"
    },
    {
        "id":8614,
        "name":"9122 (Thai Program)  :  Creative Communication Design | การออกแบบสื่อสารสร้างสรรค์ | 创意传播设计"
    },
    {
        "id":8615,
        "name":"9123 (English Program)  :  Creative Communication Design | การออกแบบการสื่อสารที่สร้างสรรค์ | 创意传播设计"
    },
    {
        "id":8616,
        "name":"9124 (Thai Program)  :  Trade And Investment Law | กฎหมายการค้าและการลงทุน | 贸易和投资法"
    },
    {
        "id":8617,
        "name":"9125 (English Program)  :  Trade And Investment Law | กฎหมายการค้าและการลงทุน | 贸易和投资法"
    },
    {
        "id":8618,
        "name":"9126 (Thai Program)  :  Music Entrepreneurship | การเป็นผู้ประกอบการทางดนตรี | 音乐创业"
    },
    {
        "id":8619,
        "name":"9127 (English Program)  :  Music Entrepreneurship | ผู้ประกอบการด้านดนตรี | 音乐创业"
    },
    {
        "id":8620,
        "name":"9128 (Thai Program)  :  Innovative Technology Management | การจัดการเทคโนโลยีแห่งนวัตกรรม | 创新技术管理"
    },
    {
        "id":8621,
        "name":"9129 (English Program)  :  Innovative Technology Management | การจัดการเทคโนโลยีที่เป็นนวัตกรรม | 创新技术管理"
    },
    {
        "id":8622,
        "name":"9130 (Thai Program)  :  Technology, Education And Management | เทคโนโลยี การศึกษา และการจัดการ | 技术、教育和管理"
    },
    {
        "id":8623,
        "name":"9131 (English Program)  :  Technology, Education And Management | เทคโนโลยี การศึกษา และการจัดการ | 科技、教育、管理"
    },
    {
        "id":8624,
        "name":"9132 (English Program)  :  Teaching And Technology | การสอนและเทคโนโลยี | 教学与技术"
    },
    {
        "id":8625,
        "name":"9133 (Thai Program)  :  Educational Administration And Leadership | การบริหารและภาวะผู้นำทางการศึกษา | 教育行政与领导"
    },
    {
        "id":8626,
        "name":"9134 (English Program)  :  Computer For Education | คอมพิวเตอร์เพื่อการศึกษา | 教育计算机"
    },
    {
        "id":8627,
        "name":"9135 (Thai Program)  :  Computers For Education | คอมพิวเตอร์เพื่อการศึกษา | 教育计算机"
    },
    {
        "id":8628,
        "name":"9136 (Thai Program)  :  Management For Innovative Entrepreneurship | การจัดการสำหรับการเป็นผู้ประกอบการเชิงนวัตกรรม | 创新创业管理"
    },
    {
        "id":8629,
        "name":"9137 (English Program)  :  Innovative Entrepreneurship Management | การจัดการผู้ประกอบการที่เป็นนวัตกรรมใหม่ | 创新创业管理"
    },
    {
        "id":8630,
        "name":"9138 (English Program)  :  Auto Electronics | ออโต้อิเล็กทรอนิกส์ | 汽车电子"
    },
    {
        "id":8631,
        "name":"9139 (Thai Program)  :  Auto Electronics | อิเล็กทรอนิกส์อัตโนมัติ | 汽车电子"
    },
    {
        "id":8632,
        "name":"9140 (Thai Program)  :  Social And Management Studies | การศึกษาด้านสังคมและการจัดการ | 社会与管理研究"
    },
    {
        "id":8633,
        "name":"9141 (English Program)  :  Social Education And Management | สังคมศึกษาและการจัดการ | 社会教育与管理"
    },
    {
        "id":8634,
        "name":"9142 (Thai Program)  :  Innovation In Art And Culture | นวัตกรรมทางศิลปะและวัฒนธรรม | 艺术与文化的创新"
    },
    {
        "id":8635,
        "name":"9143 (English Program)  :  Arts And Cultural Innovation | นวัตกรรมด้านศิลปะและวัฒนธรรม | 艺术与文化创新"
    },
    {
        "id":8636,
        "name":"9144 (Thai Program)  :  Physical Education, Health Education And Sports | พลศึกษา สุขศึกษาและกีฬา | 体育、健康教育与运动"
    },
    {
        "id":8637,
        "name":"9145 (English Program)  :  Physical Education, Health Education And Sports | พลศึกษา สุขศึกษา และการกีฬา | 体育、健康教育和运动"
    },
    {
        "id":8638,
        "name":"9146 (Thai Program)  :  Mechatronics Engineering And Smart Technology | วิศวกรรมเมคคาทรอนิกส์และเทคโนโลยีอัจฉริยะ | 机电工程与智能技术"
    },
    {
        "id":8639,
        "name":"9147 (English Program)  :  Mechatronics And Smart Technology Engineering | วิศวกรรมเมคคาทรอนิกส์และเทคโนโลยีอัจฉริยะ | 机电一体化与智能技术工程"
    },
    {
        "id":8640,
        "name":"9148 (Thai Program)  :  Artificial Intelligence Technology | เทคโนโลยีปัญญาประดิษฐ์ | 人工智能技术"
    },
    {
        "id":8641,
        "name":"9149 (English Program)  :  Artificial Intelligence Technology | เทคโนโลยีปัญญาประดิษฐ์ | 人工智能技术"
    },
    {
        "id":8642,
        "name":"9150 (Thai Program)  :  Health Robotics | วิทยาการหุ่นยนต์สุขภาพ | 健康机器人"
    },
    {
        "id":8643,
        "name":"9151 (English Program)  :  Health Robotics | หุ่นยนต์เพื่อสุขภาพ | 健康机器人"
    },
    {
        "id":8644,
        "name":"9152 (Thai Program)  :  Modern Organization And Community Management | การจัดการองค์การและชุมชนยุคใหม่ | 现代组织和社区管理"
    },
    {
        "id":8645,
        "name":"9153 (English Program)  :  Modern Organization And Community Management | องค์กรสมัยใหม่และการจัดการชุมชน | 现代组织和社区管理"
    },
    {
        "id":8646,
        "name":"9154 (Thai Program)  :  Business Management In The Digital Age | การจัดการธุรกิจยุคดิจิทัล | 数字时代的企业管理"
    },
    {
        "id":8647,
        "name":"9155 (English Program)  :  Business Management In Digital Era | การจัดการธุรกิจในยุคดิจิทัล | 数字时代的企业管理"
    },
    {
        "id":8648,
        "name":"9156 (Thai Program)  :  Rehabilitation And Health Management Of The Elderly | การฟื้นฟูและการจัดการสุขภาพผู้สูงอายุ | 老年人康复与健康管理"
    },
    {
        "id":8649,
        "name":"9157 (English Program)  :  Rehabilitation And Health Management For Elderly | การฟื้นฟูและการจัดการสุขภาพผู้สูงอายุ | 老年人康复与健康管理"
    },
    {
        "id":8650,
        "name":"9158 (Thai Program)  :  Restaurant Business Management | การจัดการธุรกิจร้านอาหาร | 餐厅经营管理"
    },
    {
        "id":8651,
        "name":"9159 (English Program)  :  Restaurant Business Management | การจัดการธุรกิจร้านอาหาร | 餐厅经营管理"
    },
    {
        "id":8652,
        "name":"9160 (Thai Program)  :  Industrial Engineering And Automated Production | วิศวกรรมอุตสาหการและการผลิตอัตโนมัติ | 工业工程与自动化生产"
    },
    {
        "id":8653,
        "name":"9161 (English Program)  :  Industrial And Manufacturing Automation Engineering | วิศวกรรมระบบอัตโนมัติอุตสาหกรรมและการผลิต | 工业与制造自动化工程"
    },
    {
        "id":8654,
        "name":"9162 (Thai Program)  :  Tourism, Service And Event Management | การจัดการการท่องเที่ยว การบริการ และอีเว้นท์ | 旅游、服务和活动管理"
    },
    {
        "id":8655,
        "name":"9163 (English Program)  :  Tourism, Hospitality And Event Management | การท่องเที่ยว การต้อนรับ และการจัดการกิจกรรม | 旅游、酒店和活动管理"
    },
    {
        "id":8656,
        "name":"9164 (Thai Program)  :  Digital Technology And Integrated Innovation | เทคโนโลยีดิจิทัลและนวัตกรรมเชิงบูรณาการ | 数字技术与集成创新"
    },
    {
        "id":8657,
        "name":"9165 (English Program)  :  Digital Technology And Integrated Innovation | เทคโนโลยีดิจิทัลและนวัตกรรมบูรณาการ | 数字技术与集成创新"
    },
    {
        "id":8658,
        "name":"9166 (Thai Program)  :  Digital Management And Innovation | การจัดการและนวัตกรรมดิจิทัล | 数字化管理与创新"
    },
    {
        "id":8659,
        "name":"9167 (English Program)  :  Management And Digital Innovation | การจัดการและนวัตกรรมดิจิทัล | 管理与数字创新"
    },
    {
        "id":8660,
        "name":"9168 (Thai Program)  :  Environmental Studies And Agricultural Studies | สิ่งแวดล้อมศึกษาและเกษตรศึกษา | 环境研究和农业研究"
    },
    {
        "id":8661,
        "name":"9169 (English Program)  :  Environmental Education And Agricultural Education | การศึกษาสิ่งแวดล้อมและการศึกษาเกษตร | 环境教育与农业教育"
    },
    {
        "id":8662,
        "name":"9170 (English Program)  :  Civil Engineering–Infrastructure | วิศวกรรมโยธา-โครงสร้างพื้นฐาน | 土木工程-基础设施"
    },
    {
        "id":8663,
        "name":"9171 (Thai Program)  :  Intelligent Systems Engineering And High-Frequency Electronics | วิศวกรรมระบบสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง | 智能系统工程和高频电子学"
    },
    {
        "id":8664,
        "name":"9172 (English Program)  :  Intelligent Embedded Systems And High Frequency Electronic Engineering | ระบบฝังตัวอัจฉริยะและวิศวกรรมอิเล็กทรอนิกส์ความถี่สูง | 智能嵌入式系统和高频电子工程"
    },
    {
        "id":8665,
        "name":"9173 (Thai Program)  :  Computer Engineering And Digital Innovation | วิศวกรรมคอมพิวเตอร์และนวัตกรรมทางดิจิทัล | 计算机工程和数字创新"
    },
    {
        "id":8666,
        "name":"9174 (English Program)  :  Computer Engineering And Digital Innovation | วิศวกรรมคอมพิวเตอร์และนวัตกรรมดิจิทัล | 计算机工程和数字创新"
    },
    {
        "id":8667,
        "name":"9175 (Thai Program)  :  Digital Engineering And Intelligent Electronics | วิศวกรรมดิจิทัลและอิเล็กทรอนิกส์อัจฉริยะ | 数字工程与智能电子"
    },
    {
        "id":8668,
        "name":"9176 (English Program)  :  Digital And Smart Electronics Engineering | วิศวกรรมอิเล็กทรอนิกส์ดิจิทัลและสมาร์ท | 数字和智能电子工程"
    },
    {
        "id":8669,
        "name":"9177 (English Program)  :  Guidance And Counseling Psychology | จิตวิทยาการแนะแนวและการให้คำปรึกษา | 指导和咨询心理学"
    },
    {
        "id":8670,
        "name":"9178 (English Program)  :  Communications And Electronics Engineering | วิศวกรรมการสื่อสารและอิเล็กทรอนิกส์ | 通信与电子工程"
    },
    {
        "id":8671,
        "name":"9179 (Thai Program)  :  Digital Media Design | ดิจิทัลมีเดียดีไซน์ | 数字媒体设计"
    },
    {
        "id":8672,
        "name":"9180 (Thai Program)  :  Integrated Science | บูรณาการศาสตร์ | 综合科学"
    },
    {
        "id":8673,
        "name":"9181 (Thai Program)  :  Arts, Music, Sports And Entertainment Management | การจัดการศิลปะ ดนตรี กีฬา และความบันเทิง | 艺术、音乐、体育和娱乐管理"
    },
    {
        "id":8674,
        "name":"9182 (English Program)  :  Arts, Music, Sports And Entertainment Management | การจัดการศิลปะ ดนตรี กีฬา และความบันเทิง | 艺术、音乐、体育和娱乐管理"
    },
    {
        "id":8675,
        "name":"9183 (English Program)  :  Innovative Curriculum And Learning Management | หลักสูตรนวัตกรรมและการจัดการการเรียนรู้ | 创新的课程和学习管理"
    },
    {
        "id":8676,
        "name":"9184 (Thai Program)  :  Environmental Landscape Design And Management | การออกแบบและการจัดการภูมิทัศน์เพื่อสิ่งแวดล้อม | 环境景观设计与管理"
    },
    {
        "id":8677,
        "name":"9185 (English Program)  :  Landscape Design And Management For Environment | การออกแบบภูมิทัศน์และการจัดการสิ่งแวดล้อม | 环境景观设计与管理"
    },
    {
        "id":8678,
        "name":"9186 (Thai Program)  :  Multimedia Arts And Animation | มัลติมีเดียอาร์ตและแอนิเมชัน | 多媒体艺术与动画"
    },
    {
        "id":8679,
        "name":"9187 (English Program)  :  Multimedia Art And Animation | ศิลปะมัลติมีเดียและแอนิเมชั่น | 多媒体艺术与动画"
    },
    {
        "id":8680,
        "name":"9188 (Thai Program)  :  Digital Media And Film Design | การออกแบบสื่อดิจิทัลและการภาพยนตร์ | 数字媒体和电影设计"
    },
    {
        "id":8681,
        "name":"9189 (English Program)  :  Digital Media Design And Motion Pictures | การออกแบบสื่อดิจิทัลและภาพเคลื่อนไหว | 数字媒体设计和电影"
    },
    {
        "id":8682,
        "name":"9190 (Thai Program)  :  Biomedical Data Science | วิทยาศาสตร์ข้อมูลชีวการแพทย์ | 生物医学数据科学"
    },
    {
        "id":8683,
        "name":"9191 (Thai Program)  :  Smart Farm Management | การจัดการสมาร์ตฟาร์ม | 智慧农场管理"
    },
    {
        "id":8684,
        "name":"9192 (English Program)  :  Smart Farm Management | การจัดการฟาร์มอัจฉริยะ | 智能农场管理"
    },
    {
        "id":8685,
        "name":"9193 (Thai Program)  :  Environment Design | การออกแบบสภาพแวดล้อม | 环境设计"
    },
    {
        "id":8686,
        "name":"9194 (Thai Program)  :  Computer Science And Data Innovation | วิทยาการคอมพิวเตอร์และนวัตกรรมข้อมูล | 计算机科学与数据创新"
    },
    {
        "id":8687,
        "name":"9195 (English Program)  :  Computer Science And Data Innovation | วิทยาศาสตร์คอมพิวเตอร์และนวัตกรรมข้อมูล | 计算机科学和数据创新"
    },
    {
        "id":8688,
        "name":"9196 (Thai Program)  :  Local Government According To Buddhist Principles | การปกครองท้องถิ่นตามแนวพุทธศาสตร์ | 根据佛教原则的地方政府"
    },
    {
        "id":8689,
        "name":"9197 (English Program)  :  Buddhistic Local Government | การปกครองท้องถิ่นของชาวพุทธ | 佛教地方政府"
    },
    {
        "id":8690,
        "name":"9198 (Thai Program)  :  Tourism And Service Industries | อุตสาหกรรมการท่องเที่ยวและบริการ | 旅游及服务业"
    },
    {
        "id":8691,
        "name":"9199 (English Program)  :  Tourism And Service Industry | อุตสาหกรรมการท่องเที่ยวและการบริการ | 旅游及服务业"
    },
    {
        "id":8692,
        "name":"9200 (Thai Program)  :  Food Innovation And Bio-Industry | นวัตกรรมอาหารและอุตสาหกรรมชีวภาพ | 食品创新和生物产业"
    },
    {
        "id":8693,
        "name":"9201 (English Program)  :  Food Innovation And Bioindustry | นวัตกรรมอาหารและอุตสาหกรรมชีวภาพ | 食品创新和生物工业"
    },
    {
        "id":8694,
        "name":"9202 (Thai Program)  :  Food Science And Food Safety Management | วิทยาศาสตร์การอาหารและการจัดการความปลอดภัยทางอาหาร | 食品科学与食品安全管理"
    },
    {
        "id":8695,
        "name":"9203 (English Program)  :  Food Science And Food Safety Management | วิทยาศาสตร์การอาหารและการจัดการความปลอดภัยของอาหาร | 食品科学与食品安全管理"
    },
    {
        "id":8696,
        "name":"9204 (Thai Program)  :  Teaching Contemporary Chinese | การสอนภาษาจีนร่วมสมัย | 现代汉语教学"
    },
    {
        "id":8697,
        "name":"9205 (English Program)  :  Contemporary Chinese Teaching | การสอนภาษาจีนร่วมสมัย | 当代汉语教学"
    },
    {
        "id":8698,
        "name":"9206 (Thai Program)  :  Design And Manufacturing Engineering | วิศวกรรมการออกแบบและผลิต | 设计与制造工程"
    },
    {
        "id":8699,
        "name":"9207 (English Program)  :  Design And Production Engineering | วิศวกรรมการออกแบบและการผลิต | 设计与生产工程"
    },
    {
        "id":8700,
        "name":"9208 (English Program)  :  Business Computer Of Digital | คอมพิวเตอร์ธุรกิจแห่งดิจิทัล | 数字商务电脑"
    },
    {
        "id":8701,
        "name":"9209 (Thai Program)  :  Computer Innovation Engineering | วิศวกรรมนวัตกรรมคอมพิวเตอร์ | 计算机创新工程"
    },
    {
        "id":8702,
        "name":"9210 (English Program)  :  Computer Innovation Engineering | วิศวกรรมนวัตกรรมคอมพิวเตอร์ | 计算机创新工程"
    },
    {
        "id":8703,
        "name":"9211 (Thai Program)  :  Educational Administration And Leadership | การบริหารการศึกษาและภาวะผู้นำ | 教育行政与领导"
    },
    {
        "id":8704,
        "name":"9212 (Thai Program)  :  Physical Education And Sports | พลศึกษาและการกีฬา | 体育与运动"
    },
    {
        "id":8705,
        "name":"9213 (English Program)  :  Physical Education And Sports | พลศึกษาและการกีฬา | 体育运动"
    },
    {
        "id":8706,
        "name":"9214 (Thai Program)  :  Nutrition And Dietetics | โภชนวิทยาและการกำหนดอาหาร | 营养与饮食学"
    },
    {
        "id":8707,
        "name":"9215 (Thai Program)  :  Maintaining Data And Information | การดูแลรักษาข้อมูลและสารสนเทศ | 维护数据和信息"
    },
    {
        "id":8708,
        "name":"9216 (English Program)  :  Data And Information Curation | การจัดการข้อมูลและสารสนเทศ | 数据和信息管理"
    },
    {
        "id":8709,
        "name":"9217 (English Program)  :  Buddhist Pali Studies | การศึกษาภาษาบาลีพุทธศาสนา | 佛教巴利文研究"
    },
    {
        "id":8710,
        "name":"9218 (Thai Program)  :  Materials And Manufacturing Engineering | วิศวกรรมวัสดุและการผลิต | 材料与制造工程"
    },
    {
        "id":8711,
        "name":"9219 (English Program)  :  Materials And Production Engineering | วัสดุและวิศวกรรมการผลิต | 材料和生产工程"
    },
    {
        "id":8712,
        "name":"9220 (Thai Program)  :  Communication Management Innovation | นวัตกรรมการจัดการการสื่อสาร | 沟通管理创新"
    },
    {
        "id":8713,
        "name":"9221 (English Program)  :  Innovation Communication Management | การจัดการการสื่อสารนวัตกรรม | 创新传播管理"
    },
    {
        "id":8714,
        "name":"9222 (Thai Program)  :  Computer Programmer | คอมพิวเตอร์โปรแกรมเมอร์ | 计算机程序员"
    },
    {
        "id":8715,
        "name":"9223 (English Program)  :  Computer Programmer | โปรแกรมคอมพิวเตอร์ | 电脑程序员"
    },
    {
        "id":8716,
        "name":"9224 (English Program)  :  Psysical Education And Sport | การศึกษาทางจิตและการกีฬา | 体育教育"
    },
    {
        "id":8717,
        "name":"9225 (Thai Program)  :  Prescribing Healthy Food And Nutrition | การกำหนดอาหารและโภชนาการเพื่อสุขภาพ | 制定健康食品和营养方案"
    },
    {
        "id":8718,
        "name":"9226 (English Program)  :  Dietetics And Nutrition For Health | การควบคุมอาหารและโภชนาการเพื่อสุขภาพ | 营养学和营养促进健康"
    },
    {
        "id":8719,
        "name":"9227 (Thai Program)  :  Thai Traditional Medicine And Alternative Medicine | การแพทย์แผนไทยและแพทย์ทางเลือก | 泰国传统医学和替代医学"
    },
    {
        "id":8720,
        "name":"9228 (English Program)  :  Thai Traditional And Alternative Medicine | การแพทย์แผนไทยและการแพทย์ทางเลือก | 泰国传统医学和替代医学"
    },
    {
        "id":8721,
        "name":"9229 (Thai Program)  :  Health Technology Development | การพัฒนาเทคโนโลยีสุขภาพ | 健康科技发展"
    },
    {
        "id":8722,
        "name":"9230 (English Program)  :  Health Technology Development | การพัฒนาเทคโนโลยีด้านสุขภาพ | 健康科技发展"
    },
    {
        "id":8723,
        "name":"9231 (Thai Program)  :  Psychology Of Life And Death | จิตวิทยาชีวิตและความตาย | 生死心理学"
    },
    {
        "id":8724,
        "name":"9232 (English Program)  :  Psychology Of Life And Death | จิตวิทยาแห่งชีวิตและความตาย | 生死心理学"
    },
    {
        "id":8725,
        "name":"9233 (Thai Program)  :  Information Studies And Digital Media Management | สารสนเทศศึกษาและการจัดการสื่อดิจิทัล | 信息研究和数字媒体管理"
    },
    {
        "id":8726,
        "name":"9234 (English Program)  :  Information Studies And Digital Media Management | การศึกษาสารสนเทศและการจัดการสื่อดิจิทัล | 信息研究和数字媒体管理"
    },
    {
        "id":8727,
        "name":"9235 (Thai Program)  :  Gaming And Esports Business Management | การจัดการธุรกิจเกมและอีสปอร์ต | 游戏和电子竞技业务管理"
    },
    {
        "id":8728,
        "name":"9236 (English Program)  :  Game And Esports Business Management | การจัดการธุรกิจเกมและกีฬา | 游戏和电子竞技业务管理"
    },
    {
        "id":8729,
        "name":"9237 (English Program)  :  Biomedical Data Science | วิทยาศาสตร์ข้อมูลชีวการแพทย์ | 生物医学数据科学"
    },
    {
        "id":8730,
        "name":"9238 (Thai Program)  :  Manufacturing Engineering And Materials Innovation | วิศวกรรมการผลิตและนวัตกรรมวัสดุ | 制造工程与材料创新"
    },
    {
        "id":8731,
        "name":"9239 (English Program)  :  Manufacturing Engineering And Materials Innovation | นวัตกรรมทางวิศวกรรมการผลิตและวัสดุ | 制造工程和材料创新"
    },
    {
        "id":8732,
        "name":"9240 (Thai Program)  :  Intelligent Electronic Engineering And Modern Technology | วิศวกรรมอิเล็กทรอนิกส์อัจฉริยะและเทคโนโลยีสมัยใหม่ | 智能电子工程与现代技术"
    },
    {
        "id":8733,
        "name":"9241 (English Program)  :  Smart Electronics And Modern Technology Engineering | อิเล็กทรอนิกส์อัจฉริยะและวิศวกรรมเทคโนโลยีสมัยใหม่ | 智能电子与现代技术工程"
    },
    {
        "id":8734,
        "name":"9242 (Thai Program)  :  Learning To Integrate The Brain | การเรียนรู้บูรณาการสมอง | 学习整合大脑"
    },
    {
        "id":8735,
        "name":"9243 (English Program)  :  Functional Brain Integrated Learning | การเรียนรู้แบบบูรณาการสมองตามหน้าที่ | 功能性大脑整合学习"
    },
    {
        "id":8736,
        "name":"9244 (Thai Program)  :  Digital Innovation Management Science | วิทยาการจัดการนวัตกรรมดิจิทัล | 数字化创新管理科学"
    },
    {
        "id":8737,
        "name":"9245 (English Program)  :  Digital Innovation Management Science | วิทยาศาสตร์การจัดการนวัตกรรมดิจิทัล | 数字创新管理科学"
    },
    {
        "id":8738,
        "name":"9246 (Thai Program)  :  Mineral Resources And Petroleum Engineering | วิศวกรรมทรัพยากรธรณีและปิโตรเลียม | 矿产资源与石油工程"
    },
    {
        "id":8739,
        "name":"9247 (English Program)  :  Georesources And Petroleum Engineering | ภูมิศาสตร์และวิศวกรรมปิโตรเลียม | 地质资源和石油工程"
    },
    {
        "id":8740,
        "name":"9248 (English Program)  :  Civil And Infrastructure Engineering | วิศวกรรมโยธาและโครงสร้างพื้นฐาน | 土木及基础设施工程"
    },
    {
        "id":8741,
        "name":"9249 (Thai Program)  :  Innovative Health Promotion Technology | นวัตกรรมเทคโนโลยีส่งเสริมสุขภาพ | 创新健康促进技术"
    },
    {
        "id":8742,
        "name":"9250 (English Program)  :  Health Promotion Innovation Technology | เทคโนโลยีนวัตกรรมการส่งเสริมสุขภาพ | 健康促进创新技术"
    },
    {
        "id":8743,
        "name":"9251 (Thai Program)  :  Industrial Engineering And Logistics Management | วิศวกรรมอุตสาหการและการจัดการโลจิสติกส์ | 工业工程与物流管理"
    },
    {
        "id":8744,
        "name":"9252 (English Program)  :  Industrial Engineering And Logistics Management | วิศวกรรมอุตสาหการและการจัดการโลจิสติกส์ | 工业工程与物流管理"
    },
    {
        "id":8745,
        "name":"9253 (Thai Program)  :  Digital Technology And Educational Communications | เทคโนโลยีดิจิทัลและสื่อสารการศึกษา | 数字技术和教育传播"
    },
    {
        "id":8746,
        "name":"9254 (English Program)  :  Educational Digital Technology And Communications | เทคโนโลยีดิจิทัลและการสื่อสารทางการศึกษา | 教育数字技术和通信"
    },
    {
        "id":8747,
        "name":"9255 (Thai Program)  :  Digital Art And Design | ดิจิทัลอาร์ตและการออกแบบ | 数字艺术与设计"
    },
    {
        "id":8748,
        "name":"9256 (English Program)  :  Digital Art And Design | ศิลปะดิจิทัลและการออกแบบ | 数字艺术与设计"
    },
    {
        "id":8749,
        "name":"9257 (Thai Program)  :  Data Science And Software Innovation | วิทยาการข้อมูลและนวัตกรรมซอฟต์แวร์ | 数据科学与软件创新"
    },
    {
        "id":8750,
        "name":"9258 (English Program)  :  Data Science And Software Innovation | นวัตกรรมด้านวิทยาศาสตร์ข้อมูลและซอฟต์แวร์ | 数据科学和软件创新"
    },
    {
        "id":8751,
        "name":"9259 (Thai Program)  :  Materials And Biomedical Physics | ฟิสิกส์วัสดุและชีวการแพทย์ | 材料与生物医学物理"
    },
    {
        "id":8752,
        "name":"9260 (English Program)  :  Materials And Biomedical Physics | วัสดุและฟิสิกส์ชีวการแพทย์ | 材料和生物医学物理学"
    },
    {
        "id":8753,
        "name":"9261 (Thai Program)  :  Social Development Innovation | นวัตกรรมการพัฒนาสังคม | 社会发展创新"
    },
    {
        "id":8754,
        "name":"9262 (English Program)  :  Social Development Innovation | นวัตกรรมการพัฒนาสังคม | 社会发展创新"
    },
    {
        "id":8755,
        "name":"9263 (Thai Program)  :  Innovation In Hotel And Service Management | นวัตกรรมการจัดการโรงแรมและการบริการ | 酒店和服务管理创新"
    },
    {
        "id":8756,
        "name":"9264 (English Program)  :  Hotel And Service Innovation Management | การจัดการนวัตกรรมโรงแรมและการบริการ | 酒店和服务创新管理"
    },
    {
        "id":8757,
        "name":"9265 (Thai Program)  :  Tourism Management Innovation Service And Contemporary Thai Culture | นวัตกรรมการจัดการการท่องเที่ยว การบริการและวัฒนธรรมไทยร่วมสมัย | 旅游管理创新服务和当代泰国文化"
    },
    {
        "id":8758,
        "name":"9266 (English Program)  :  Tourism Hospitality And Contemporary Thai Culture Innovation Management | การบริการการท่องเที่ยวและการจัดการนวัตกรรมวัฒนธรรมไทยร่วมสมัย | 旅游接待与当代泰国文化创新管理"
    },
    {
        "id":8759,
        "name":"9267 (English Program)  :  Digital Design And Innovation | การออกแบบดิจิทัลและนวัตกรรม | 数字设计与创新"
    },
    {
        "id":8760,
        "name":"9268 (Thai Program)  :  Accounting And Information Technology | การบัญชีและเทคโนโลยีสารสนเทศ | 会计和信息技术"
    },
    {
        "id":8761,
        "name":"9269 (English Program)  :  Accounting And Information Technology | เทคโนโลยีการบัญชีและสารสนเทศ | 会计与信息技术"
    },
    {
        "id":8762,
        "name":"9270 (Thai Program)  :  Nursing Adults And The Elderly | การพยาบาลผู้ใหญ่และผู้สูงอายุ | 护理成人和老年人"
    },
    {
        "id":8763,
        "name":"9271 (English Program)  :  Adult And Gerontological Nursing | การพยาบาลผู้ใหญ่และผู้สูงอายุ | 成人和老年护理"
    },
    {
        "id":8764,
        "name":"9272 (Thai Program)  :  Health Technology Cosmetics And Anti-Aging | เทคโนโลยีสุขภาพ เครื่องสำอางและการชะลอวัย | 健康科技化妆品和抗衰老"
    },
    {
        "id":8765,
        "name":"9273 (English Program)  :  Health, Cosmetic And Anti-Aging Technology | เทคโนโลยีด้านสุขภาพ เครื่องสำอาง และการชะลอวัย | 健康、美容和抗衰老技术"
    },
    {
        "id":8766,
        "name":"9274 (English Program)  :  Community Health Nurse Practitioner | ผู้ปฏิบัติการพยาบาลสุขภาพชุมชน | 社区健康护士执业者"
    },
    {
        "id":8767,
        "name":"9275 (Thai Program)  :  Politics For Local Development | การเมืองเพื่อการพัฒนาท้องถิ่น | 地方发展的政治"
    },
    {
        "id":8768,
        "name":"9276 (English Program)  :  Politics For Local Development | การเมืองเพื่อการพัฒนาท้องถิ่น | 促进地方发展的政治"
    },
    {
        "id":8769,
        "name":"9277 (Thai Program)  :  Construction Management Engineering | วิศวกรรมบริหารงานก่อสร้าง | 施工管理工程"
    },
    {
        "id":8770,
        "name":"9278 (English Program)  :  Construction Management Engineering | วิศวกรรมการจัดการการก่อสร้าง | 施工管理工程"
    },
    {
        "id":8771,
        "name":"9279 (Thai Program)  :  Green Chemistry And Sustainability | เคมีสีเขียวและความยั่งยืน | 绿色化学与可持续发展"
    },
    {
        "id":8772,
        "name":"9280 (English Program)  :  Green Chemistry And Sustainability | เคมีสีเขียวและความยั่งยืน | 绿色化学与可持续发展"
    },
    {
        "id":8773,
        "name":"9281 (Thai Program)  :  Innovation And Cooking Technology | นวัตกรรมและเทคโนโลยีการประกอบอาหาร | 创新和烹饪技术"
    },
    {
        "id":8774,
        "name":"9282 (English Program)  :  Innovation And Technology In Culinary | นวัตกรรมและเทคโนโลยีในการทำอาหาร | 烹饪创新与科技"
    },
    {
        "id":8775,
        "name":"9283 (Thai Program)  :  Herbal Technology And Health Supplements | เทคโนโลยีสมุนไพรและผลิตภัณฑ์เสริมสุขภาพ | 草药技术和保健品"
    },
    {
        "id":8776,
        "name":"9284 (English Program)  :  Technology Of Herbs And Health Claims Products | เทคโนโลยีสมุนไพรและผลิตภัณฑ์กล่าวอ้างด้านสุขภาพ | 草药技术和保健产品"
    },
    {
        "id":8777,
        "name":"9285 (Thai Program)  :  Health Communication Innovation | นวัตกรรมการสื่อสารสุขภาพ | 健康传播创新"
    },
    {
        "id":8778,
        "name":"9286 (English Program)  :  Health Communication Innovation | นวัตกรรมการสื่อสารด้านสุขภาพ | 健康传播创新"
    },
    {
        "id":8779,
        "name":"9287 (English Program)  :  Management Of Analytics And Data Technologies | การจัดการการวิเคราะห์และเทคโนโลยีข้อมูล | 分析和数据技术的管理"
    },
    {
        "id":8780,
        "name":"9288 (Thai Program)  :  Dermatology | ตจศัลยศาสตร์ | 皮肤科"
    },
    {
        "id":8781,
        "name":"9289 (Thai Program)  :  Health Science Education | การศึกษาวิทยาศาสตร์สุขภาพ | 健康科学教育"
    },
    {
        "id":8782,
        "name":"9290 (English Program)  :  Health Science Education | การศึกษาวิทยาศาสตร์สุขภาพ | 健康科学教育"
    },
    {
        "id":8783,
        "name":"9291 (Thai Program)  :  Innovative Physics | ฟิสิกส์เชิงนวัตกรรม | 创新物理学"
    },
    {
        "id":8784,
        "name":"9292 (English Program)  :  Innovative Physics | ฟิสิกส์ที่เป็นนวัตกรรมใหม่ | 创新物理学"
    },
    {
        "id":8785,
        "name":"9293 (Thai Program)  :  Engineering And Industrial Chemistry | เคมีวิศวกรรมและอุตสาหกรรม | 工程与工业化学"
    },
    {
        "id":8786,
        "name":"9294 (English Program)  :  Engineering Chemistry | เคมีวิศวกรรม | 工程化学"
    },
    {
        "id":8787,
        "name":"9295 (Thai Program)  :  Innovation In Financial Management And Debt Management | นวัตกรรมการบริหารการเงินและการบริหารหนี้ | 财务管理和债务管理创新"
    },
    {
        "id":8788,
        "name":"9296 (English Program)  :  Financial And Debt Administration Innovation | นวัตกรรมการบริหารการเงินและหนี้ | 金融和债务管理创新"
    },
    {
        "id":8789,
        "name":"9297 (Thai Program)  :  Chinese For The Service Industry | ภาษาจีนเพื่ออุตสาหกรรมบริการ | 服务业汉语"
    },
    {
        "id":8790,
        "name":"9298 (English Program)  :  Chinese For Service Industry | ภาษาจีนสำหรับอุตสาหกรรมบริการ | 服务业汉语"
    },
    {
        "id":8791,
        "name":"9299 (Thai Program)  :  Cultural And Health Tourism Management | การจัดการท่องเที่ยวเชิงวัฒนธรรมและสุขภาพ | 文化健康旅游管理"
    },
    {
        "id":8792,
        "name":"9300 (English Program)  :  Cultural And Health Tourism Management | การจัดการการท่องเที่ยวเชิงวัฒนธรรมและสุขภาพ | 文化与健康旅游管理"
    },
    {
        "id":8793,
        "name":"9301 (English Program)  :  Intelligence Systems Engineering | วิศวกรรมระบบอัจฉริยะ | 智能系统工程"
    },
    {
        "id":8794,
        "name":"9302 (Thai Program)  :  Local Entrepreneurs | ผู้ประกอบการท้องถิ่น | 当地企业家"
    },
    {
        "id":8795,
        "name":"9303 (English Program)  :  Local Entrepreneur | ผู้ประกอบการในท้องถิ่น | 本地企业家"
    },
    {
        "id":8796,
        "name":"9304 (English Program)  :  English For Education, Religion, And Culture | ภาษาอังกฤษเพื่อการศึกษา ศาสนา และวัฒนธรรม | 教育、宗教和文化英语"
    },
    {
        "id":8797,
        "name":"9305 (Thai Program)  :  English For Education, Religion And Culture | ภาษาอังกฤษเพื่อการศึกษา ศาสนา และวัฒนธรรม | 教育、宗教和文化英语"
    },
    {
        "id":8798,
        "name":"9306 (English Program)  :  Intelligent Agricultural Engineering | วิศวกรรมเกษตรอัจฉริยะ | 智慧农业工程"
    },
    {
        "id":8799,
        "name":"9307 (Thai Program)  :  Electric Vehicle Engineering | วิศวกรรมยานยนต์ไฟฟ้า | 电动汽车工程"
    },
    {
        "id":8800,
        "name":"9308 (English Program)  :  Electric Vehicle Engineering | วิศวกรรมยานยนต์ไฟฟ้า | 电动汽车工程"
    },
    {
        "id":8801,
        "name":"9309 (Thai Program)  :  Museum | พิพิธภัณฑศึกษา | 博物馆"
    },
    {
        "id":8802,
        "name":"9310 (English Program)  :  Educational Museum | พิพิธภัณฑ์การศึกษา | 教育博物馆"
    },
    {
        "id":8803,
        "name":"9311 (Thai Program)  :  Innovation For Local Development | นวัตกรรมเพื่อพัฒนาท้องถิ่น | 创新促进地方发展"
    },
    {
        "id":8804,
        "name":"9312 (Thai Program)  :  Environmental Agricultural Technology | เทคโนโลยีเกษตรสิ่งแวดล้อม | 环境农业技术"
    },
    {
        "id":8805,
        "name":"9313 (English Program)  :  Environmental Agriculture Technology | เทคโนโลยีการเกษตรสิ่งแวดล้อม | 环保农业技术"
    },
    {
        "id":8806,
        "name":"9314 (Thai Program)  :  Evaluation Of Social Projects | การประเมินโครงการทางสังคม | 社会项目评估"
    },
    {
        "id":8807,
        "name":"9315 (English Program)  :  Assessment Of Social Projects | การประเมินโครงการทางสังคม | 社会项目评估"
    },
    {
        "id":8808,
        "name":"9316 (Thai Program)  :  Railway Electrician | ช่างไฟฟ้าระบบราง | 铁路电工"
    },
    {
        "id":8809,
        "name":"9317 (English Program)  :  Railway | รถไฟ | 铁路"
    },
    {
        "id":8810,
        "name":"9318 (English Program)  :  Industrial Techniques | เทคนิคทางอุตสาหกรรม | 工业技术"
    },
    {
        "id":8811,
        "name":"9319 (Thai Program)  :  Modern Marketing Technology | เทคโนโลยีการตลาดสมัยใหม่ | 现代营销技术"
    },
    {
        "id":8812,
        "name":"9320 (English Program)  :  Modern Marketing Technology | เทคโนโลยีการตลาดสมัยใหม่ | 现代营销技术"
    },
    {
        "id":8813,
        "name":"9321 (Thai Program)  :  English For Professional Communication | ภาษาอังกฤษเพื่อการสื่อสารในการประกอบอาชีพ | 专业沟通英语"
    },
    {
        "id":8814,
        "name":"9322 (English Program)  :  Occupational Communication English | ภาษาอังกฤษเพื่อการสื่อสารอาชีพ | 职业交流英语"
    },
    {
        "id":8815,
        "name":"9323 (Thai Program)  :  Innovative Mechanical Design | การออกแบบนวัตกรรมเครื่องจักรกล | 创新机械设计"
    },
    {
        "id":8816,
        "name":"9324 (English Program)  :  Mechine Innovation Design | การออกแบบนวัตกรรมเครื่องจักร | 机械创新设计"
    },
    {
        "id":8817,
        "name":"9325 (Thai Program)  :  Medical Electronics | อิเล็กทรอนิกส์การแพทย์ | 医疗电子"
    },
    {
        "id":8818,
        "name":"9326 (English Program)  :  Medical Electronics | อิเล็กทรอนิกส์ทางการแพทย์ | 医疗电子"
    },
    {
        "id":8819,
        "name":"9327 (Thai Program)  :  Manage The Business Of Healthcare Facilities And Integrated Health | บริหารธุรกิจสถานพยาบาลและบูรณาการสุขภาพ | 管理医疗机构和综合健康业务"
    },
    {
        "id":8820,
        "name":"9328 (English Program)  :  Business Administration In Hospital And Health Integration | การบริหารธุรกิจบูรณาการด้านโรงพยาบาลและสุขภาพ | 医院和健康一体化工商管理"
    },
    {
        "id":8821,
        "name":"9329 (Thai Program)  :  Water Resources Management | การจัดการทรัพยากรน้ำ | 水资源管理"
    },
    {
        "id":8822,
        "name":"9330 (Thai Program)  :  Music Therapy | ดนตรีบำบัด | 音乐疗法"
    },
    {
        "id":8823,
        "name":"9331 (English Program)  :  Music Therapy | ดนตรีบำบัด | 音乐疗法"
    },
    {
        "id":8824,
        "name":"9332 (Thai Program)  :  Curatorial Operation | ปฏิบัติการภัณฑารักษ์ | 策展运作"
    },
    {
        "id":8825,
        "name":"9333 (English Program)  :  Curatorial Operations | การดำเนินงานภัณฑารักษ์ | 策展运作"
    },
    {
        "id":8826,
        "name":"9334 (Thai Program)  :  Health Professions Education | การศึกษาวิชาชีพสุขภาพ | 卫生专业教育"
    },
    {
        "id":8827,
        "name":"9335 (English Program)  :  Health Profession Studies | การศึกษาวิชาชีพด้านสุขภาพ | 健康专业研究"
    },
    {
        "id":8828,
        "name":"9336 (Thai Program)  :  Sustainable Materials And Technology For Industry | วัสดุและเทคโนโลยียั่งยืนเพื่ออุตสาหกรรม | 工业可持续材料和技术"
    },
    {
        "id":8829,
        "name":"9337 (English Program)  :  Sustainable Materials And Technologies For Industry | วัสดุและเทคโนโลยีที่ยั่งยืนสำหรับอุตสาหกรรม | 工业可持续材料和技术"
    },
    {
        "id":8830,
        "name":"9338 (Thai Program)  :  Digital Technology For Business Innovation | เทคโนโลยีดิจิทัลเพื่อนวัตกรรมทางธุรกิจ | 数字技术促进业务创新"
    },
    {
        "id":8831,
        "name":"9339 (English Program)  :  Digital Technology For Business Innovation | เทคโนโลยีดิจิทัลเพื่อนวัตกรรมทางธุรกิจ | 数字技术促进业务创新"
    },
    {
        "id":8832,
        "name":"9340 (Thai Program)  :  Post-Harvest Technology And Logistics | เทคโนโลยีหลังการเก็บเกี่ยวและโลจิสติกส์ | 收获后技术和物流"
    },
    {
        "id":8833,
        "name":"9341 (English Program)  :  Postharvest Technology And Logistics | เทคโนโลยีหลังการเก็บเกี่ยวและโลจิสติกส์ | 采后技术和物流"
    },
    {
        "id":8834,
        "name":"9342 (English Program)  :  English For Professional Development | ภาษาอังกฤษเพื่อการพัฒนาวิชาชีพ | 职业发展英语"
    },
    {
        "id":8835,
        "name":"9343 (Thai Program)  :  English For Professional Development | ภาษาอังกฤษเพื่อการพัฒนาวิชาชีพ | 专业发展英语"
    },
    {
        "id":8836,
        "name":"9344 (Thai Program)  :  Innovative Materials For Sustainability | นวัตกรรมวัสดุเพื่อความยั่งยืน | 可持续发展的创新材料"
    },
    {
        "id":8837,
        "name":"9345 (English Program)  :  Materials Innovation For Sustainability | นวัตกรรมวัสดุเพื่อความยั่งยืน | 材料创新促进可持续发展"
    },
    {
        "id":8838,
        "name":"9346 (Thai Program)  :  Innovative Materials | นวัตกรรมวัสดุ | 创新材料"
    },
    {
        "id":8839,
        "name":"9347 (English Program)  :  Materials Innovation | นวัตกรรมวัสดุ | 材料创新"
    },
    {
        "id":8840,
        "name":"9348 (Thai Program)  :  Computer Science And Innovation | วิทยาการคอมพิวเตอร์และนวัตกรรม | 计算机科学与创新"
    },
    {
        "id":8841,
        "name":"9349 (English Program)  :  Computer Science And Innovation | วิทยาศาสตร์คอมพิวเตอร์และนวัตกรรม | 计算机科学与创新"
    },
    {
        "id":8842,
        "name":"9350 (Thai Program)  :  Digital And Communication Engineering | วิศวกรรมดิจิทัลและการสื่อสาร | 数字与通信工程"
    },
    {
        "id":8843,
        "name":"9351 (English Program)  :  Digital And Communication Engineering | วิศวกรรมดิจิทัลและการสื่อสาร | 数字与通信工程"
    },
    {
        "id":8844,
        "name":"9352 (Thai Program)  :  Post-Harvest Technology And Innovation | เทคโนโลยีและนวัตกรรมหลังการเก็บเกี่ยว | 收获后技术和创新"
    },
    {
        "id":8845,
        "name":"9353 (English Program)  :  Postharvest Technology And Innovation | เทคโนโลยีและนวัตกรรมหลังการเก็บเกี่ยว | 采后技术与创新"
    },
    {
        "id":8846,
        "name":"9354 (Thai Program)  :  Computational Science | วิทยาการเชิงคำนวณ | 计算科学"
    },
    {
        "id":8847,
        "name":"9355 (Thai Program)  :  Computational And Data Science | วิทยาการเชิงคำนวณและข้อมูล | 计算和数据科学"
    },
    {
        "id":8848,
        "name":"9356 (English Program)  :  Computational And Data Science | วิทยาศาสตร์คอมพิวเตอร์และข้อมูล | 计算和数据科学"
    },
    {
        "id":8849,
        "name":"9357 (Thai Program)  :  Thai Language And Culture For Foreigners | ภาษาและวัฒนธรรมไทยสำหรับชาวต่างประเทศ | 面向外国人的泰国语言和文化"
    },
    {
        "id":8850,
        "name":"9358 (English Program)  :  Thai Language And Culture For Foreigners | ภาษาและวัฒนธรรมไทยสำหรับชาวต่างชาติ | 外国人的泰国语言和文化"
    },
    {
        "id":8851,
        "name":"9359 (English Program)  :  Criminology,Justice Administration And Society | อาชญวิทยา การบริหารความยุติธรรม และสังคม | 犯罪学、司法行政和社会"
    },
    {
        "id":8852,
        "name":"9360 (English Program)  :  Hotel Business Management | การจัดการธุรกิจโรงแรม | 酒店商务管理"
    },
    {
        "id":8853,
        "name":"9361 (Thai Program)  :  Bioinformatics And Computational Biology | ชีวสารสนเทศศาสตร์และชีววิทยาเชิงคอมพิวเตอร์ | 生物信息学和计算生物学"
    },
    {
        "id":8854,
        "name":"9362 (English Program)  :  Bioinformatics And Computational Biology | ชีวสารสนเทศศาสตร์และชีววิทยาเชิงคอมพิวเตอร์ | 生物信息学和计算生物学"
    },
    {
        "id":8855,
        "name":"9363 (Thai Program)  :  Innovation In Political Communication And Local Government | นวัตกรรมการสื่อสารทางการเมืองและการปกครองท้องถิ่น | 政治沟通和地方政府的创新"
    },
    {
        "id":8856,
        "name":"9364 (English Program)  :  Communication Innovation For Political And Local Administration | นวัตกรรมการสื่อสารเพื่อการบริหารการเมืองและท้องถิ่น | 政治和地方管理的通信创新"
    },
    {
        "id":8857,
        "name":"9365 (Thai Program)  :  Innovation In Food Science And Technology | นวัตกรรมวิทยาศาสตร์และเทคโนโลยีอาหาร | 食品科技创新"
    },
    {
        "id":8858,
        "name":"9366 (English Program)  :  Innovative Food Science And Technology | นวัตกรรมวิทยาศาสตร์การอาหารและเทคโนโลยี | 创新食品科技"
    },
    {
        "id":8859,
        "name":"9367 (Thai Program)  :  International Logistics And Supply Chain Management | การจัดการโลจิสติกส์และโซ่อุปทานระหว่างประเทศ | 国际物流与供应链管理"
    },
    {
        "id":8860,
        "name":"9368 (English Program)  :  International Logistics And Supply Chain ​​Management | โลจิสติกส์ระหว่างประเทศและการจัดการห่วงโซ่อุปทาน | 国际物流与供应链管理"
    },
    {
        "id":8861,
        "name":"9369 (English Program)  :  Digital Transformation Technology | เทคโนโลยีการเปลี่ยนแปลงทางดิจิทัล | 数字化转型技术"
    },
    {
        "id":8862,
        "name":"9370 (Thai Program)  :  Digitization Technology | เทคโนโลยีการแปลงเป็นดิจิทัล | 数字化技术"
    },
    {
        "id":8863,
        "name":"9371 (Thai Program)  :  Border Health Management | การจัดการสุขภาพชายแดน | 边境卫生管理"
    },
    {
        "id":8864,
        "name":"9372 (English Program)  :  Border Health Management | การจัดการสุขภาพชายแดน | 边境卫生管理"
    },
    {
        "id":8865,
        "name":"9373 (Thai Program)  :  Life Development And Community Entrepreneurship | การพัฒนาชีวิตและประกอบการชุมชน | 生命发展与社区创业"
    },
    {
        "id":8866,
        "name":"9374 (English Program)  :  Community Entrepreneurship And Life Development | ผู้ประกอบการชุมชนและการพัฒนาชีวิต | 社区创业与生活发展"
    },
    {
        "id":8867,
        "name":"9375 (Thai Program)  :  Integrated Local Development | การพัฒนาท้องถิ่นแบบบูรณาการ | 地方综合发展"
    },
    {
        "id":8868,
        "name":"9376 (English Program)  :  Integrated Local Development | การพัฒนาท้องถิ่นแบบบูรณาการ | 本地综合发展"
    },
    {
        "id":8869,
        "name":"9377 (Thai Program)  :  Applied English Studies | ภาษาอังกฤษศึกษาเชิงประยุกต์ | 应用英语研究"
    },
    {
        "id":8870,
        "name":"9378 (English Program)  :  Agricultural Extension And Development | การขยายและพัฒนาการเกษตร | 农业推广与发展"
    },
    {
        "id":8871,
        "name":"9379 (Thai Program)  :  Agriculture And Cooperatives | เกษตรศาสตร์และสหกรณ์ | 农业与合作社"
    },
    {
        "id":8872,
        "name":"9380 (Thai Program)  :  Cooperatives And Community Businesses | สหกรณ์และธุรกิจชุมชน | 合作社和社区企业"
    },
    {
        "id":8873,
        "name":"9381 (English Program)  :  Co-Operatives And Community Business | สหกรณ์และธุรกิจชุมชน | 合作社和社区企业"
    },
    {
        "id":8874,
        "name":"9382 (Thai Program)  :  Nutritional Food System Management | การจัดการระบบอาหารเพื่อโภชนาการ | 营养食品系统管理"
    },
    {
        "id":8875,
        "name":"9383 (English Program)  :  Food System Management For Nutrition | การจัดการระบบอาหารเพื่อโภชนาการ | 食品系统营养管理"
    },
    {
        "id":8876,
        "name":"9384 (English Program)  :  Guidance And Psychological Counseling | การแนะแนวและการให้คำปรึกษาด้านจิตวิทยา | 指导和心理咨询"
    },
    {
        "id":8877,
        "name":"9385 (Thai Program)  :  Food, Nutrition And Applications | อาหาร โภชนาการ และการประยุกต์ | 食品、营养和应用"
    },
    {
        "id":8878,
        "name":"9386 (English Program)  :  Food, Nutrition And Applications | อาหาร โภชนาการ และการประยุกต์ใช้งาน | 食品、营养和应用"
    },
    {
        "id":8879,
        "name":"9387 (Thai Program)  :  Business And Service Management | การจัดการธุรกิจและการบริการ | 商业和服务管理"
    },
    {
        "id":8880,
        "name":"9388 (English Program)  :  Business And Hospitality Management | การจัดการธุรกิจและการบริการ | 商业和酒店管理"
    },
    {
        "id":8881,
        "name":"9389 (Thai Program)  :  Engineering Management Technology | เทคโนโลยีการจัดการทางวิศวกรรม | 工程管理技术"
    },
    {
        "id":8882,
        "name":"9390 (English Program)  :  Engineering Management Technology | เทคโนโลยีการจัดการทางวิศวกรรม | 工程管理技术"
    },
    {
        "id":8883,
        "name":"9391 (Thai Program)  :  Nursing Administration | การบริหารทางการพยาบาล | 护理管理"
    },
    {
        "id":8884,
        "name":"9392 (Thai Program)  :  Crop Production Management And Development | การจัดการการผลิตพืชและการพัฒนา | 农作物生产管理与发展"
    },
    {
        "id":8885,
        "name":"9393 (English Program)  :  Crop Production Management And Development | การจัดการและการพัฒนาการผลิตพืชผล | 农作物生产管理与开发"
    },
    {
        "id":8886,
        "name":"9394 (English Program)  :  Social Programs Evaluation | การประเมินโปรแกรมทางสังคม | 社会项目评估"
    },
    {
        "id":8887,
        "name":"9395 (Thai Program)  :  Acoustics And Multimedia Technology | อะคูสติกส์และเทคโนโลยีสื่อประสม | 声学和多媒体技术"
    },
    {
        "id":8888,
        "name":"9396 (English Program)  :  Acoustics And Multimedia Technology | เทคโนโลยีอะคูสติกและมัลติมีเดีย | 声学和多媒体技术"
    },
    {
        "id":8889,
        "name":"9397 (Thai Program)  :  Agricultural Innovation | นวัตกรรมทางการเกษตร | 农业创新"
    },
    {
        "id":8890,
        "name":"9398 (English Program)  :  Agricultural Innovations | นวัตกรรมทางการเกษตร | 农业创新"
    },
    {
        "id":8891,
        "name":"9399 (Thai Program)  :  Robotics Engineering And Lean Automation | วิศวกรรมหุ่นยนต์และระบบอัตโนมัติแบบลีน | 机器人工程和精益自动化"
    },
    {
        "id":8892,
        "name":"9400 (English Program)  :  Robotics And Lean Automation Engineering | วิทยาการหุ่นยนต์และวิศวกรรมระบบอัตโนมัติแบบลีน | 机器人和精益自动化工程"
    },
    {
        "id":8893,
        "name":"9401 (Thai Program)  :  Computer Engineering And Artificial Intelligence | วิศวกรรมคอมพิวเตอร์และปัญญาประดิษฐ์ | 计算机工程与人工智能"
    },
    {
        "id":8894,
        "name":"9402 (English Program)  :  Computer Engineering And Artificial Intelligenc | วิศวกรรมคอมพิวเตอร์และปัญญาประดิษฐ์ | 计算机工程与人工智能"
    },
    {
        "id":8895,
        "name":"9403 (Thai Program)  :  Business Development And Startups | การพัฒนาธุรกิจและสตาร์ตอัป | 业务发展和初创公司"
    },
    {
        "id":8896,
        "name":"9404 (English Program)  :  Development Of Business And Start-Up | การพัฒนาธุรกิจและการเริ่มต้น | 业务发展和初创企业"
    },
    {
        "id":8897,
        "name":"9405 (Thai Program)  :  International Business And Entrepreneurship | ธุรกิจระหว่างประเทศและการเป็นผู้ประกอบการ | 国际商务与创业"
    },
    {
        "id":8898,
        "name":"9406 (English Program)  :  International Business And Entrepreneurship | ธุรกิจระหว่างประเทศและการเป็นผู้ประกอบการ | 国际商务和创业"
    },
    {
        "id":8899,
        "name":"9407 (Thai Program)  :  Digital Business Information Technology | เทคโนโลยีสารสนเทศทางธุรกิจดิจิทัล | 数字商业信息技术"
    },
    {
        "id":8900,
        "name":"9408 (English Program)  :  Digital Business Information Technology | เทคโนโลยีสารสนเทศทางธุรกิจดิจิทัล | 数字商业信息技术"
    },
    {
        "id":8901,
        "name":"9409 (Thai Program)  :  Lean Production And Logistics Management | การจัดการระบบการผลิตและโลจิสติกส์แบบลีน | 精益生产和物流管理"
    },
    {
        "id":8902,
        "name":"9410 (English Program)  :  Lean Manufacturing System And Logistics Management | ระบบการผลิตแบบลีนและการจัดการโลจิสติกส์ | 精益制造系统与物流管理"
    },
    {
        "id":8903,
        "name":"9411 (Thai Program)  :  Innovation In Business And Industrial Management | นวัตกรรมการจัดการธุรกิจและอุตสาหกรรม | 工商管理创新"
    },
    {
        "id":8904,
        "name":"9412 (English Program)  :  Innovation Of Business And Industrial Management | นวัตกรรมการจัดการธุรกิจและอุตสาหกรรม | 工商管理创新"
    },
    {
        "id":8905,
        "name":"9413 (Thai Program)  :  Art And Design Innovation | ศิลปะและนวัตกรรมการออกแบบ | 艺术与设计创新"
    },
    {
        "id":8906,
        "name":"9414 (English Program)  :  Arts And Design Innovation | นวัตกรรมด้านศิลปะและการออกแบบ | 艺术与设计创新"
    },
    {
        "id":8907,
        "name":"9415 (Thai Program)  :  Manufacturing Engineering And Automation | วิศวกรรมการผลิตและระบบอัตโนมัติ | 制造工程与自动化"
    },
    {
        "id":8908,
        "name":"9416 (English Program)  :  Production Engineering And Automation System | วิศวกรรมการผลิตและระบบอัตโนมัติ | 生产工程及自动化系统"
    },
    {
        "id":8909,
        "name":"9417 (English Program)  :  Teaching Of Chinese | การสอนภาษาจีน | 汉语教学"
    },
    {
        "id":8910,
        "name":"9418 (Thai Program)  :  Logistics And International Business Management | การจัดการโลจิสติกส์และธุรกิจระหว่างประเทศ | 物流与国际商务管理"
    },
    {
        "id":8911,
        "name":"9419 (English Program)  :  Logistics And International Business Management | โลจิสติกส์และการจัดการธุรกิจระหว่างประเทศ | 物流和国际商业管理"
    },
    {
        "id":8912,
        "name":"9420 (English Program)  :  Tourism And Service Business | ธุรกิจการท่องเที่ยวและบริการ | 旅游及服务业"
    },
    {
        "id":8913,
        "name":"9421 (Thai Program)  :  Innovation In Ceramics Production And Design | นวัตกรรมการผลิตและการออกแบบเซรามิกส์ | 陶瓷生产和设计的创新"
    },
    {
        "id":8914,
        "name":"9422 (English Program)  :  Production Innovation And Ceramics Design | นวัตกรรมการผลิตและการออกแบบเซรามิกส์ | 生产创新与陶瓷设计"
    },
    {
        "id":8915,
        "name":"9423 (English Program)  :  Environmental Innovation | นวัตกรรมด้านสิ่งแวดล้อม | 环保创新"
    },
    {
        "id":8916,
        "name":"9424 (Thai Program)  :  Environmental Innovation | นวัตกรรมสิ่งแวดล้อม | 环境创新"
    },
    {
        "id":8917,
        "name":"9425 (Thai Program)  :  Health Food Technology | เทคโนโลยีอาหารสุขภาพ | 保健食品技术"
    },
    {
        "id":8918,
        "name":"9426 (English Program)  :  Health Food Technology | เทคโนโลยีอาหารเพื่อสุขภาพ | 保健食品技术"
    },
    {
        "id":8919,
        "name":"9427 (Thai Program)  :  Creative Design | การออกแบบสร้างสรรค์ | 创意设计"
    },
    {
        "id":8920,
        "name":"9428 (Thai Program)  :  Food Production And Innovation | การผลิตและนวัตกรรมอาหาร | 食品生产与创新"
    },
    {
        "id":8921,
        "name":"9429 (Thai Program)  :  Food Engineering And Innovation | วิศวกรรมและนวัตกรรมการผลิตอาหาร | 食品工程与创新"
    },
    {
        "id":8922,
        "name":"9430 (English Program)  :  Food Production Engineering And Innovation | วิศวกรรมการผลิตอาหารและนวัตกรรม | 食品生产工程与创新"
    },
    {
        "id":8923,
        "name":"9431 (Thai Program)  :  Digital Print Media | สื่อสิ่งพิมพ์ดิจิทัล | 数字印刷媒体"
    },
    {
        "id":8924,
        "name":"9432 (English Program)  :  Digital Print Media | สื่อสิ่งพิมพ์ดิจิทัล | 数字印刷媒体"
    },
    {
        "id":8925,
        "name":"9433 (Thai Program)  :  Fashion, Textile And Jewelry Design | ออกแบบแฟชั่น สิ่งทอ และเครื่องประดับ | 时装、纺织和珠宝设计"
    },
    {
        "id":8926,
        "name":"9434 (English Program)  :  Fashion Textile And Jewelry Design | การออกแบบสิ่งทอและเครื่องประดับแฟชั่น | 时尚纺织品和珠宝设计"
    },
    {
        "id":8927,
        "name":"9435 (Thai Program)  :  Mold And Tooling Engineering | วิศวกรรมแม่พิมพ์และเครื่องมือ | 模具及工装工程"
    },
    {
        "id":8928,
        "name":"9436 (Thai Program)  :  Agricultural Innovation Business | ธุรกิจนวัตกรรมการเกษตร | 农业创新业务"
    },
    {
        "id":8929,
        "name":"9437 (English Program)  :  Agribusiness Innovation | นวัตกรรมด้านการเกษตร | 农业企业创新"
    },
    {
        "id":8930,
        "name":"9438 (English Program)  :  Heavy Equipment Engineering | วิศวกรรมอุปกรณ์หนัก | 重型设备工程"
    },
    {
        "id":8931,
        "name":"9439 (English Program)  :  Railway Systems Engineering | วิศวกรรมระบบรถไฟ | 铁路系统工程"
    },
    {
        "id":8932,
        "name":"9440 (English Program)  :  Curatorial Practice | การปฏิบัติของภัณฑารักษ์ | 策展实践"
    },
    {
        "id":8933,
        "name":"9441 (Thai Program)  :  Technology And Innovation In Logistics And Digital Management | เทคโนโลยีและนวัตกรรมการจัดการโลจิสติกส์และดิจิทัล | 物流和数字化管理的技术和创新"
    },
    {
        "id":8934,
        "name":"9442 (English Program)  :  Technology And Innovation Of Logistic And Digital Management | เทคโนโลยีและนวัตกรรมการจัดการโลจิสติกส์และดิจิทัล | 物流与数字化管理的技术与创新"
    },
    {
        "id":8935,
        "name":"9443 (Thai Program)  :  Electrical And Electronic Technology And Innovation | เทคโนโลยีและนวัตกรรมไฟฟ้าและอิเล็กทรอนิกส์ | 电气电子技术与创新"
    },
    {
        "id":8936,
        "name":"9444 (English Program)  :  Technology And Innovation Of Electrics And Electronics | เทคโนโลยีและนวัตกรรมไฟฟ้าและอิเล็กทรอนิกส์ | 电子电气技术与创新"
    },
    {
        "id":8937,
        "name":"9445 (Thai Program)  :  Production Design Technology | เทคโนโลยีออกแบบการผลิต | 生产设计技术"
    },
    {
        "id":8938,
        "name":"9446 (Thai Program)  :  Entrepreneurship, Creative Design Business | การเป็นผู้ประกอบการธุรกิจการออกแบบสร้างสรรค์ | 创业、创意设计业务"
    },
    {
        "id":8939,
        "name":"9447 (English Program)  :  Production Design Technology | เทคโนโลยีการออกแบบการผลิต | 生产设计技术"
    },
    {
        "id":8940,
        "name":"9448 (English Program)  :  Creative Design Entrepreneurship | ผู้ประกอบการออกแบบสร้างสรรค์ | 创意设计创业"
    },
    {
        "id":8941,
        "name":"9449 (English Program)  :  Mechatronics And Robotics Technology | เทคโนโลยีเมคคาทรอนิกส์และหุ่นยนต์ | 机电一体化和机器人技术"
    },
    {
        "id":8942,
        "name":"9450 (Thai Program)  :  Elderly Health Care And Anti-Aging | การดูแลสุขภาพผู้สูงอายุและการชะลอวัย | 老年保健与抗衰老"
    },
    {
        "id":8943,
        "name":"9451 (English Program)  :  Gerontological Health Care And Anti-Aging | การดูแลสุขภาพผู้สูงอายุและการต่อต้านวัย | 老年保健和抗衰老"
    },
    {
        "id":8944,
        "name":"9452 (Thai Program)  :  Landscape Design And Gardening | การออกแบบภูมิทัศน์และการจัดสวน | 景观设计和园艺"
    },
    {
        "id":8945,
        "name":"9453 (English Program)  :  Landscape Design And Gardening | การออกแบบภูมิทัศน์และการจัดสวน | 景观设计和园艺"
    },
    {
        "id":8946,
        "name":"9454 (Thai Program)  :  Agricultural Biotechnology | เทคโนโลยีชีวภาพการเกษตร | 农业生物技术"
    },
    {
        "id":8947,
        "name":"9455 (Thai Program)  :  Information Statistics | สถิติสารสนเทศ | 信息统计"
    },
    {
        "id":8948,
        "name":"9456 (English Program)  :  Information Statistics | สถิติข้อมูล | 信息统计"
    },
    {
        "id":8949,
        "name":"9457 (English Program)  :  Railway System Engineering | วิศวกรรมระบบรถไฟ | 铁路系统工程"
    },
    {
        "id":8950,
        "name":"9458 (Thai Program)  :  Textile Technology And Fashion Design | เทคโนโลยีสิ่งทอและการออกแบบแฟชั่น | 纺织技术与服装设计"
    },
    {
        "id":8951,
        "name":"9459 (English Program)  :  Textile Technology And Fashion Design | เทคโนโลยีสิ่งทอและการออกแบบแฟชั่น | 纺织科技与时尚设计"
    },
    {
        "id":8952,
        "name":"9460 (Thai Program)  :  Modern Technology And Mechanical Innovation | เทคโนโลยีและนวัตกรรมเครื่องกลสมัยใหม่ | 现代技术和机械创新"
    },
    {
        "id":8953,
        "name":"9461 (English Program)  :  Technology And Innovation Of Modern Mechanics | เทคโนโลยีและนวัตกรรมของกลไกสมัยใหม่ | 现代机械技术与创新"
    },
    {
        "id":8954,
        "name":"9462 (Thai Program)  :  Electrical Industry Education | ครุศาสตร์อุตสาหกรรมไฟฟ้า | 电气行业教育"
    },
    {
        "id":8955,
        "name":"9463 (English Program)  :  Electrical Technical Education | การศึกษาด้านเทคนิคไฟฟ้า | 电气技术教育"
    },
    {
        "id":8956,
        "name":"9464 (Thai Program)  :  Industrial Education | ครุศาสตร์อุตสาหกรรมอุตสาหการ | 工业教育"
    },
    {
        "id":8957,
        "name":"9465 (English Program)  :  Industrial Technical Education | การศึกษาด้านเทคนิคอุตสาหกรรม | 工业技术教育"
    },
    {
        "id":8958,
        "name":"9466 (English Program)  :  Electronics And Telecommunication | อิเล็กทรอนิกส์และโทรคมนาคม | 电子和电信"
    },
    {
        "id":8959,
        "name":"9467 (Thai Program)  :  Electronics And Telecommunications | อิเล็กทรอนิกส์และโทรคมนาคม | 电子和电信"
    },
    {
        "id":8960,
        "name":"9468 (Thai Program)  :  Mechanical Industry Education | ครุศาสตร์อุตสาหกรรมเครื่องกล | 机械工业教育"
    },
    {
        "id":8961,
        "name":"9469 (English Program)  :  Mechanical Technical Education | การศึกษาด้านเทคนิคเครื่องกล | 机械技术教育"
    },
    {
        "id":8962,
        "name":"9470 (Thai Program)  :  Electronics And Information Communication Engineering | วิศวกรรมอิเล็กทรอนิกส์และสารสนเทศสื่อสาร | 电子信息通信工程"
    },
    {
        "id":8963,
        "name":"9471 (English Program)  :  Electronic And Infocommunication Engineering | วิศวกรรมอิเล็กทรอนิกส์และสารสนเทศ | 电子与信息通信工程"
    },
    {
        "id":8964,
        "name":"9472 (Thai Program)  :  Welding Industry Education | ครุศาสตร์อุตสาหกรรมการเชื่อม | 焊接行业教育"
    },
    {
        "id":8965,
        "name":"9473 (English Program)  :  Welding Technical Education | การศึกษาด้านเทคนิคการเชื่อม | 焊接技术教育"
    },
    {
        "id":8966,
        "name":"9474 (Thai Program)  :  Civil Industry Education | ครุศาสตร์อุตสาหกรรมโยธา | 民用工业教育"
    },
    {
        "id":8967,
        "name":"9475 (English Program)  :  Civil Technical Education | การศึกษาเทคนิคโยธา | 民事技术教育"
    },
    {
        "id":8968,
        "name":"9476 (English Program)  :  Health Sciences And Aesthetics | วิทยาศาสตร์สุขภาพและสุนทรียภาพ | 健康科学与美学"
    },
    {
        "id":8969,
        "name":"9477 (Thai Program)  :  Tourism And Hospitality Startups | สตาร์ทอัพการท่องเที่ยวและการบริการ | 旅游和酒店初创公司"
    },
    {
        "id":8970,
        "name":"9478 (English Program)  :  Tourism And Hospitality Start-Up | การเริ่มต้นการท่องเที่ยวและการบริการ | 旅游和酒店业初创企业"
    },
    {
        "id":8971,
        "name":"9479 (Thai Program)  :  Materials Physics For Rail And Aircraft Systems | ฟิสิกส์วัสดุสำหรับระบบรางและอากาศยาน | 铁路和飞机系统的材料物理"
    },
    {
        "id":8972,
        "name":"9480 (English Program)  :  Materials Physics For Rail And Aircraft | ฟิสิกส์ของวัสดุสำหรับระบบรางและเครื่องบิน | 铁路和飞机材料物理"
    },
    {
        "id":8973,
        "name":"9481 (English Program)  :  Bioproduct Technology | เทคโนโลยีผลิตภัณฑ์ชีวภาพ | 生物产品技术"
    },
    {
        "id":8974,
        "name":"9482 (Thai Program)  :  Applied Information And Communications Technology | เทคโนโลยีสารสนเทศและการสื่อสารประยุกต์ | 应用信息和通信技术"
    },
    {
        "id":8975,
        "name":"9483 (English Program)  :  Applied Information And Communication Technology | เทคโนโลยีสารสนเทศและการสื่อสารที่ประยุกต์ใช้ | 应用信息与通信技术"
    },
    {
        "id":8976,
        "name":"9484 (Thai Program)  :  Applied Biology In Animal Production | ชีววิทยาประยุกต์ในการผลิตสัตว์ | 动物生产中的应用生物学"
    },
    {
        "id":8977,
        "name":"9485 (English Program)  :  Applied Biology In Animal Production | ชีววิทยาประยุกต์ในการผลิตสัตว์ | 动物生产中的应用生物学"
    },
    {
        "id":8978,
        "name":"9486 (Thai Program)  :  Food And Post-Harvest Engineering | วิศวกรรมอาหารและหลังการเก็บเกี่ยว | 食品和收获后工程"
    },
    {
        "id":8979,
        "name":"9487 (English Program)  :  Food And Postharvest Engineering | วิศวกรรมอาหารและหลังการเก็บเกี่ยว | 食品和采后工程"
    },
    {
        "id":8980,
        "name":"9488 (Thai Program)  :  Surveying And Geoinformatics Engineering | วิศวกรรมสำรวจและภูมิสารสนเทศ | 测绘与地理信息工程"
    },
    {
        "id":8981,
        "name":"9489 (English Program)  :  Survey Engineering And Geomatics | วิศวกรรมสำรวจและธรณีวิทยา | 测量工程和测绘"
    },
    {
        "id":8982,
        "name":"9490 (Thai Program)  :  Tool And Mold Engineering | วิศวกรรมเครื่องมือและแม่พิมพ์ | 工具和模具工程"
    },
    {
        "id":8983,
        "name":"9491 (English Program)  :  Tool And Die Engineering | วิศวกรรมเครื่องมือและแม่พิมพ์ | 工具和模具工程"
    },
    {
        "id":8984,
        "name":"9492 (Thai Program)  :  Industrial Technology And Production | เทคโนโลยีอุตสาหการและการผลิต | 工业技术与生产"
    },
    {
        "id":8985,
        "name":"9493 (English Program)  :  Industrial Technology And Manufacturing | เทคโนโลยีอุตสาหกรรมและการผลิต | 工业技术与制造"
    },
    {
        "id":8986,
        "name":"9494 (English Program)  :  Civil Technician | ช่างโยธา | 土木技术员"
    },
    {
        "id":8987,
        "name":"9495 (English Program)  :  Metal Technician | ช่างโลหะ | 金属技师"
    },
    {
        "id":8988,
        "name":"9496 (English Program)  :  Machine Tool Technology | เทคโนโลยีเครื่องมือกล | 机床技术"
    },
    {
        "id":8989,
        "name":"9497 (English Program)  :  Computer Technical | เทคนิคคอมพิวเตอร์ | 计算机技术"
    },
    {
        "id":8990,
        "name":"9498 (English Program)  :  Industrial Plumbing | ประปาอุตสาหกรรม | 工业管道"
    },
    {
        "id":8991,
        "name":"9499 (English Program)  :  Civil Technique | เทคนิคโยธา | 民用技术"
    },
    {
        "id":8992,
        "name":"9500 (English Program)  :  Mechanical Drawing Technology | เทคโนโลยีการเขียนแบบเครื่องกล | 机械绘图技术"
    },
    {
        "id":8993,
        "name":"9501 (Thai Program)  :  Automotive Engineering And Motorsport | วิศวกรรมยานยนต์และมอเตอร์สปอร์ต | 汽车工程和赛车运动"
    },
    {
        "id":8994,
        "name":"9502 (English Program)  :  Automotive And Motorsport Engineering | วิศวกรรมยานยนต์และมอเตอร์สปอร์ต | 汽车和赛车工程"
    },
    {
        "id":8995,
        "name":"9503 (Thai Program)  :  Railway Technology Engineering | วิศวกรรมเทคโนโลยีระบบราง | 铁路技术工程"
    },
    {
        "id":8996,
        "name":"9504 (English Program)  :  Railway System Technology Engineering | วิศวกรรมเทคโนโลยีระบบรถไฟ | 铁路系统技术工程"
    },
    {
        "id":8997,
        "name":"9505 (Thai Program)  :  Cyber ​​Security And Technology Management | การจัดการความมั่นคงไซเบอร์และเทคโนโลยี | 网络安全和技术管理"
    },
    {
        "id":8998,
        "name":"9506 (English Program)  :  Cyber Security Management And Technology | การจัดการความปลอดภัยทางไซเบอร์และเทคโนโลยี | 网络安全管理和技术"
    },
    {
        "id":8999,
        "name":"9507 (Thai Program)  :  Tourism, Hospitality And Sports | การท่องเที่ยว การบริการ และกีฬา | 旅游、酒店和体育"
    },
    {
        "id":9000,
        "name":"9508 (English Program)  :  Tourism, Hospitality And Sports | การท่องเที่ยว การต้อนรับ และการกีฬา | 旅游、酒店和体育"
    },
    {
        "id":9001,
        "name":"9509 (English Program)  :  Tropical Health Innovation | นวัตกรรมด้านสุขภาพเขตร้อน | 热带健康创新"
    },
    {
        "id":9002,
        "name":"9510 (Thai Program)  :  Robotics Engineering And Computational Intelligence | วิศวกรรมหุ่นยนต์และระบบอัจฉริยะเชิงคำนวณ | 机器人工程与计算智能"
    },
    {
        "id":9003,
        "name":"9511 (English Program)  :  Robotics And Computational Intelligence Systems | หุ่นยนต์และระบบอัจฉริยะเชิงคำนวณ | 机器人和计算智能系统"
    },
    {
        "id":9004,
        "name":"9512 (Thai Program)  :  Marine Tourism Management | การจัดการท่องเที่ยวทางทะเล | 海洋旅游管理"
    },
    {
        "id":9005,
        "name":"9513 (English Program)  :  Marine Tourism Management | การจัดการการท่องเที่ยวทางทะเล | 海洋旅游管理"
    },
    {
        "id":9006,
        "name":"9514 (Thai Program)  :  Tourism And Service Business Management | การจัดการธุรกิจการท่องเที่ยวและบริการ | 旅游与服务业管理"
    },
    {
        "id":9007,
        "name":"9515 (Thai Program)  :  Science And Mathematics | วิทยาศาสตร์และคณิตศาสตร์ | 科学与数学"
    },
    {
        "id":9008,
        "name":"9516 (Thai Program)  :  Agricultural Innovation For Sustainability | นวัตกรรมเกษตรเพื่อความยั่งยืน | 农业创新促进可持续发展"
    },
    {
        "id":9009,
        "name":"9517 (English Program)  :  Sustainable Agriculture Innovation | นวัตกรรมการเกษตรที่ยั่งยืน | 可持续农业创新"
    },
    {
        "id":9010,
        "name":"9518 (English Program)  :  English For Service Industries | ภาษาอังกฤษสำหรับอุตสาหกรรมบริการ | 服务业英语"
    },
    {
        "id":9011,
        "name":"9519 (Thai Program)  :  Hotels, Restaurants And Events | การโรงแรม ภัตตาคาร และอีเว้นท์ | 酒店、餐厅和活动"
    },
    {
        "id":9012,
        "name":"9520 (English Program)  :  Hotel, Restaurant, And Events | โรงแรม ร้านอาหาร และกิจกรรมต่างๆ | 酒店、餐厅和活动"
    },
    {
        "id":9013,
        "name":"9521 (Thai Program)  :  Tourism And Service Industries | การท่องเที่ยวและอุตสาหกรรมบริการ | 旅游及服务业"
    },
    {
        "id":9014,
        "name":"9522 (Thai Program)  :  Investigative Communication Innovation | นวัตกรรมการสื่อสารการสืบสวนสอบสวน | 调查传播创新"
    },
    {
        "id":9015,
        "name":"9523 (English Program)  :  Investigative Communication Innovation | นวัตกรรมการสื่อสารเชิงสืบสวน | 调查性传播创新"
    },
    {
        "id":9016,
        "name":"9524 (Thai Program)  :  Business Innovation In Thailand, China, Asean | นวัตกรรมธุรกิจไทย จีน อาเซียน | 泰国、中国、东盟的商业创新"
    },
    {
        "id":9017,
        "name":"9525 (English Program)  :  Thai, Chinese, Asean Business Innovation | นวัตกรรมธุรกิจไทย จีน และอาเซียน | 泰国、中国、东盟商业创新"
    },
    {
        "id":9018,
        "name":"9526 (English Program)  :  Investigative Communication | การสื่อสารเชิงสืบสวน | 调查性沟通"
    },
    {
        "id":9019,
        "name":"9527 (Thai Program)  :  Business And Technology Law | กฎหมายธุรกิจและเทคโนโลยี | 商业和技术法"
    },
    {
        "id":9020,
        "name":"9528 (English Program)  :  Business And Technology Law | กฎหมายธุรกิจและเทคโนโลยี | 商业和技术法"
    },
    {
        "id":9021,
        "name":"9529 (Thai Program)  :  Textile Technology Apparel And Fashion | เทคโนโลยีสิ่งทอ เครื่องนุ่งห่มและแฟชั่น | 纺织技术服装和时尚"
    },
    {
        "id":9022,
        "name":"9530 (English Program)  :  Textile, Clothing And Fashion Technology | เทคโนโลยีสิ่งทอ เสื้อผ้า และแฟชั่น | 纺织、服装和时尚技术"
    },
    {
        "id":9023,
        "name":"9531 (English Program)  :  Physical Education And Health Education | พลศึกษาและสุขศึกษา | 体育与健康教育"
    },
    {
        "id":9024,
        "name":"9532 (Thai Program)  :  Creative Technology | เทคโนโลยีสร้างสรรค์ | 创意科技"
    },
    {
        "id":9025,
        "name":"9533 (English Program)  :  Electrical Industrial Technology | เทคโนโลยีอุตสาหกรรมไฟฟ้า | 电气工业技术"
    },
    {
        "id":9026,
        "name":"9534 (English Program)  :  Agri-Intelligence | เกษตรอัจฉริยะ | 农业情报"
    },
    {
        "id":9027,
        "name":"9535 (English Program)  :  Food Innovation And Technology | นวัตกรรมและเทคโนโลยีด้านอาหาร | 食品创新与科技"
    },
    {
        "id":9028,
        "name":"9536 (Thai Program)  :  Service And Event Business Management | การจัดการธุรกิจบริการและอีเว้นท์ | 服务和活动业务管理"
    },
    {
        "id":9029,
        "name":"9537 (English Program)  :  Hospitality And Event Management | การจัดการการต้อนรับและการจัดงาน | 酒店和活动管理"
    },
    {
        "id":9030,
        "name":"9538 (Thai Program)  :  Battery Science And New Energy | วิทยาศาสตร์แบตเตอรี่และพลังงานใหม่ | 电池科学与新能源"
    },
    {
        "id":9031,
        "name":"9539 (English Program)  :  Battery And New Energy Science | วิทยาศาสตร์แบตเตอรี่และพลังงานใหม่ | 电池与新能源科学"
    },
    {
        "id":9032,
        "name":"9540 (Thai Program)  :  Digital Start-Up | ดิจิทัลสตาร์ตอัป | 数字化初创公司"
    },
    {
        "id":9033,
        "name":"9541 (English Program)  :  Digital Startup | สตาร์ทอัพดิจิทัล | 数字化创业"
    },
    {
        "id":9034,
        "name":"9542 (Thai Program)  :  Human Capital Management And Social Innovation | การจัดการทุนมนุษย์และนวัตกรรมสังคม | 人力资本管理与社会创新"
    },
    {
        "id":9035,
        "name":"9543 (English Program)  :  Human Capital Management And Social Innovation | การจัดการทุนมนุษย์และนวัตกรรมทางสังคม | 人力资本管理和社会创新"
    },
    {
        "id":9036,
        "name":"9544 (Thai Program)  :  Advertising And Public Relations Content | คอนเทนต์การโฆษณาและการประชาสัมพันธ์ | 广告和公共关系内容"
    },
    {
        "id":9037,
        "name":"9545 (English Program)  :  Contents : Advertising And Public Relations | สารบัญ : การโฆษณาและการประชาสัมพันธ์ | 内容：广告和公共关系"
    },
    {
        "id":9038,
        "name":"9546 (Thai Program)  :  Modern Automotive Engineering | วิศวกรรมยานยนต์สมัยใหม่ | 现代汽车工程"
    },
    {
        "id":9039,
        "name":"9547 (English Program)  :  Modern Automotive Engineering | วิศวกรรมยานยนต์สมัยใหม่ | 现代汽车工程"
    },
    {
        "id":9040,
        "name":"9548 (English Program)  :  Robotics And Automation System Engineering | วิศวกรรมหุ่นยนต์และระบบอัตโนมัติ | 机器人与自动化系统工程"
    },
    {
        "id":9041,
        "name":"9549 (English Program)  :  Social Innovation | นวัตกรรมทางสังคม | 社会创新"
    },
    {
        "id":9042,
        "name":"9550 (English Program)  :  Teacher Profession | วิชาชีพครู | 教师职业"
    },
    {
        "id":9043,
        "name":"9551 (English Program)  :  Chinese Business | ธุรกิจจีน | 中国业务"
    },
    {
        "id":9044,
        "name":"9552 (Thai Program)  :  Integrated Manufacturing Engineering | วิศวกรรมการผลิตเชิงบูรณาการ | 集成制造工程"
    },
    {
        "id":9045,
        "name":"9553 (Thai Program)  :  Digital Technology For Business | เทคโนโลยีดิจิทัลเพื่อธุรกิจ | 商业数字技术"
    },
    {
        "id":9046,
        "name":"9554 (English Program)  :  Digital Technology For Business | เทคโนโลยีดิจิทัลสำหรับธุรกิจ | 商业数字技术"
    },
    {
        "id":9047,
        "name":"9555 (English Program)  :  Integrated Production Engineering | วิศวกรรมการผลิตแบบครบวงจร | 综合生产工程"
    },
    {
        "id":9048,
        "name":"9556 (English Program)  :  Science And Mathematics | วิทยาศาสตร์และคณิตศาสตร์ | 科学与数学"
    },
    {
        "id":9049,
        "name":"9557 (English Program)  :  Fisheries Technology | เทคโนโลยีการประมง | 渔业技术"
    },
    {
        "id":9050,
        "name":"9558 (Thai Program)  :  Organizational Management And Development | การจัดการและพัฒนาองค์การ | 组织管理与发展"
    },
    {
        "id":9051,
        "name":"9559 (English Program)  :  Organization Management And Development | การจัดการและการพัฒนาองค์กร | 组织管理与发展"
    },
    {
        "id":9052,
        "name":"9560 (English Program)  :  Teaching Thai Language | การสอนภาษาไทย | 泰语教学"
    },
    {
        "id":9053,
        "name":"9561 (Thai Program)  :  Automation Engineering And Robotics | วิศวกรรมอัตโนมัติและหุ่นยนต์ | 自动化工程与机器人"
    },
    {
        "id":9054,
        "name":"9562 (English Program)  :  Automation And Robotics Engineering | วิศวกรรมระบบอัตโนมัติและหุ่นยนต์ | 自动化和机器人工程"
    },
    {
        "id":9055,
        "name":"9563 (Thai Program)  :  Science For Health And Beauty | วิทยาศาสตร์เพื่อสุขภาพและความงาม | 科学促进健康与美丽"
    },
    {
        "id":9056,
        "name":"9564 (English Program)  :  Health Science And Aesthetic | วิทยาศาสตร์สุขภาพและสุนทรียภาพ | 健康科学与美学"
    },
    {
        "id":9057,
        "name":"9565 (Thai Program)  :  Curriculum And Teaching | หลักสูตรและการเรียนการสอน | 课程与教学"
    },
    {
        "id":9058,
        "name":"9566 (Thai Program)  :  Digital Printing Technology And Packaging Design | เทคโนโลยีการพิมพ์ดิจิทัลและออกแบบบรรจุภัณฑ์ | 数码印刷技术与包装设计"
    },
    {
        "id":9059,
        "name":"9567 (English Program)  :  Digital Printing Technology And Packaging Design | เทคโนโลยีการพิมพ์ดิจิทัลและการออกแบบบรรจุภัณฑ์ | 数码印刷技术与包装设计"
    },
    {
        "id":9060,
        "name":"9568 (Thai Program)  :  Digital Media Technology And Mass Communication | เทคโนโลยีสื่อดิจิทัลและสื่อสารมวลชน | 数字媒体技术和大众传播"
    },
    {
        "id":9061,
        "name":"9569 (English Program)  :  Digital Media And Mass Communication Technology | สื่อดิจิทัลและเทคโนโลยีการสื่อสารมวลชน | 数字媒体和大众传播技术"
    },
    {
        "id":9062,
        "name":"9570 (Thai Program)  :  Finance And Financial Innovation | การเงินและนวัตกรรมทางการเงิน | 金融与金融创新"
    },
    {
        "id":9063,
        "name":"9571 (English Program)  :  Finance And Financial Innovations | นวัตกรรมทางการเงินและการเงิน | 金融与金融创新"
    },
    {
        "id":9064,
        "name":"9572 (English Program)  :  Digital Technology In Business | เทคโนโลยีดิจิทัลในธุรกิจ | 商业数字技术"
    },
    {
        "id":9065,
        "name":"9573 (Thai Program)  :  Business Digital Technology | เทคโนโลยีดิจิทัลทางธุรกิจ | 商业数字技术"
    },
    {
        "id":9066,
        "name":"9574 (Thai Program)  :  Information System Innovation | นวัตกรรมระบบสารสนเทศ | 信息系统创新"
    },
    {
        "id":9067,
        "name":"9575 (English Program)  :  Innovation Information Systems | ระบบสารสนเทศนวัตกรรม | 创新信息系统"
    },
    {
        "id":9068,
        "name":"9576 (Thai Program)  :  Innovative Design Of Thai Wisdom Products | การออกแบบนวัตกรรมผลิตภัณฑ์ภูมิปัญญาไทย | 泰国智慧产品创新设计"
    },
    {
        "id":9069,
        "name":"9577 (English Program)  :  Thai Wisdom Product Innovation Design | การออกแบบนวัตกรรมผลิตภัณฑ์ภูมิปัญญาไทย | 泰智产品创新设计"
    },
    {
        "id":9070,
        "name":"9578 (Thai Program)  :  Modern Industrial Engineering Technology | เทคโนโลยีวิศวกรรมอุตสาหการสมัยใหม่ | 现代工业工程技术"
    },
    {
        "id":9071,
        "name":"9579 (English Program)  :  Modern Industrial Engineering Technologies | เทคโนโลยีวิศวกรรมอุตสาหการที่ทันสมัย | 现代工业工程技术"
    },
    {
        "id":9072,
        "name":"9580 (Thai Program)  :  Food And Product Development | อาหารและการพัฒนาผลิตภัณฑ์ | 食品和产品开发"
    },
    {
        "id":9073,
        "name":"9581 (English Program)  :  Food And Product Development | การพัฒนาอาหารและผลิตภัณฑ์ | 食品和产品开发"
    },
    {
        "id":9074,
        "name":"9582 (Thai Program)  :  International Tourism And Service Management | การจัดการการท่องเที่ยวและบริการนานาชาติ | 国际旅游与服务管理"
    },
    {
        "id":9075,
        "name":"9583 (English Program)  :  International Tourism And Hospitality Management | การจัดการการท่องเที่ยวและการบริการระหว่างประเทศ | 国际旅游和酒店管理"
    },
    {
        "id":9076,
        "name":"9584 (English Program)  :  Social Welfare Administration | การบริหารสวัสดิการสังคม | 社会福利署"
    },
    {
        "id":9077,
        "name":"9585 (English Program)  :  Traditional Chinese Medicine | การแพทย์แผนจีน | 中药"
    },
    {
        "id":9078,
        "name":"9586 (Thai Program)  :  English And Chinese | ภาษาอังกฤษและภาษาจีน | 英语和中文"
    },
    {
        "id":9079,
        "name":"9587 (English Program)  :  English And Chinese | ภาษาอังกฤษและภาษาจีน | 英语和中文"
    },
    {
        "id":9080,
        "name":"9588 (Thai Program)  :  Curriculum And Learning Management | หลักสูตรและการจัดการเรียนรู้ | 课程和学习管理"
    },
    {
        "id":9081,
        "name":"9589 (Thai Program)  :  Service And Tourism Innovation | นวัตกรรมการบริการและการท่องเที่ยว | 服务和旅游创新"
    },
    {
        "id":9082,
        "name":"9590 (English Program)  :  Innovation In Services And Tourism | นวัตกรรมด้านบริการและการท่องเที่ยว | 服务和旅游业的创新"
    },
    {
        "id":9083,
        "name":"9591 (Thai Program)  :  Innovation In Communication And Information Management | นวัตกรรมการสื่อสารและการจัดการสารสนเทศ | 通信和信息管理创新"
    },
    {
        "id":9084,
        "name":"9592 (English Program)  :  Innovative Communications And Information Management | นวัตกรรมการสื่อสารและการจัดการข้อมูล | 创新的通信和信息管理"
    },
    {
        "id":9085,
        "name":"9593 (English Program)  :  Innovative Science And Business | นวัตกรรมวิทยาศาสตร์และธุรกิจ | 创新科学与商业"
    },
    {
        "id":9086,
        "name":"9594 (Thai Program)  :  Applied Science For Industry | วิทยาศาสตร์ประยุกต์เพื่ออุตสาหกรรม | 工业应用科学"
    },
    {
        "id":9087,
        "name":"9595 (English Program)  :  Applied Science For Industry | วิทยาศาสตร์ประยุกต์สำหรับอุตสาหกรรม | 工业应用科学"
    },
    {
        "id":9088,
        "name":"9596 (Thai Program)  :  Bioproduct Technology | เทคโนโลยีชีวผลิตภัณฑ์ | 生物制品技术"
    },
    {
        "id":9089,
        "name":"9597 (Thai Program)  :  Dairy And Beverage Technology | เทคโนโลยีผลิตภัณฑ์นมและเครื่องดื่ม | 乳制品和饮料技术"
    },
    {
        "id":9090,
        "name":"9598 (English Program)  :  Dairy And Beverage Technology | เทคโนโลยีผลิตภัณฑ์นมและเครื่องดื่ม | 乳制品和饮料技术"
    },
    {
        "id":9091,
        "name":"9599 (English Program)  :  Electrical Engineering Education | การศึกษาวิศวกรรมไฟฟ้า | 电气工程教育"
    },
    {
        "id":9092,
        "name":"9600 (Thai Program)  :  A Wise Farmer | เกษตรกรปราชญ์เปรื่อง | 聪明的农民"
    },
    {
        "id":9093,
        "name":"9601 (English Program)  :  Smart Farmer | สมาร์ทฟาร์มเมอร์ | 聪明的农民"
    },
    {
        "id":9094,
        "name":"9602 (Thai Program)  :  Sustainable Service Business Innovation | นวัตกรรมธุรกิจบริการยั่งยืน | 可持续服务业务创新"
    },
    {
        "id":9095,
        "name":"9603 (English Program)  :  Sustainable Service Business Innovation | นวัตกรรมธุรกิจบริการที่ยั่งยืน | 可持续服务业务创新"
    },
    {
        "id":9096,
        "name":"9604 (Thai Program)  :  Natural Products For Health And Beauty | ผลิตภัณฑ์ธรรมชาติเพื่อสุขภาพและความงาม | 健康和美容的天然产品"
    },
    {
        "id":9097,
        "name":"9605 (Thai Program)  :  Refrigeration And Air Conditioning Engineering | วิศวกรรมการทำความเย็นและการปรับอากาศ | 制冷空调工程"
    },
    {
        "id":9098,
        "name":"9606 (English Program)  :  Refrigeration And Air Conditioning Engineering | วิศวกรรมเครื่องทำความเย็นและการปรับอากาศ | 制冷空调工程"
    },
    {
        "id":9099,
        "name":"9607 (Thai Program)  :  Content Creation And Digital Media Innovation | การสร้างสรรค์คอนเทนต์และนวัตกรรมสื่อดิจิทัล | 内容创作和数字媒体创新"
    },
    {
        "id":9100,
        "name":"9608 (English Program)  :  Content Creation And Digital Media Innovation | การสร้างเนื้อหาและนวัตกรรมสื่อดิจิทัล | 内容创作和数字媒体创新"
    },
    {
        "id":9101,
        "name":"9609 (Thai Program)  :  Business Economics And Business Innovation | เศรษฐศาสตร์ธุรกิจและนวัตกรรมทางธุรกิจ | 商业经济学和商业创新"
    },
    {
        "id":9102,
        "name":"9610 (English Program)  :  Business Economics And Business Innovation | เศรษฐศาสตร์ธุรกิจและนวัตกรรมทางธุรกิจ | 商业经济与商业创新"
    },
    {
        "id":9103,
        "name":"9611 (Thai Program)  :  Modern Marketing Management Innovation | นวัตกรรมการจัดการการตลาดสมัยใหม่ | 现代营销管理创新"
    },
    {
        "id":9104,
        "name":"9612 (English Program)  :  Innovation Of Modern Marketing Management | นวัตกรรมการจัดการการตลาดสมัยใหม่ | 现代营销管理的创新"
    },
    {
        "id":9105,
        "name":"9613 (Thai Program)  :  Educational Quality Measurement And Assurance | การวัดผลและประกันคุณภาพการศึกษา | 教育质量衡量与保证"
    },
    {
        "id":9106,
        "name":"9614 (English Program)  :  Educational Measurement And Quality Assurance | การวัดผลทางการศึกษาและการประกันคุณภาพ | 教育衡量和质量保证"
    },
    {
        "id":9107,
        "name":"9615 (Thai Program)  :  Research And Creativity In Fine Arts | การวิจัยและสร้างสรรค์ศิลปกรรมศาสตร์ | 美术研究与创造力"
    },
    {
        "id":9108,
        "name":"9616 (English Program)  :  Fine And Applied Arts Research And Creation | การวิจัยและสร้างสรรค์ศิลปกรรมประยุกต์และวิจิตรศิลป์ | 美术与应用艺术研究与创作"
    },
    {
        "id":9109,
        "name":"9617 (Thai Program)  :  Digital Business And Information Systems | ธุรกิจดิจิทัลและระบบสารสนเทศ | 数字业务和信息系统"
    },
    {
        "id":9110,
        "name":"9618 (English Program)  :  Digital Business And Information Systems | ธุรกิจดิจิทัลและระบบสารสนเทศ | 数字商业和信息系统"
    },
    {
        "id":9111,
        "name":"9619 (Thai Program)  :  Hotel And Service Management | การจัดการโรงแรมและบริการ | 酒店及服务管理"
    },
    {
        "id":9112,
        "name":"9620 (English Program)  :  Hotel And Hospitality Management | การจัดการโรงแรมและการบริการ | 酒店及酒店管理"
    },
    {
        "id":9113,
        "name":"9621 (Thai Program)  :  Biotechnology And Bioindustry | เทคโนโลยีชีวภาพและอุตสาหกรรมชีวภาพ | 生物技术和生物产业"
    },
    {
        "id":9114,
        "name":"9622 (English Program)  :  Biotechnology And Bio-Industry | เทคโนโลยีชีวภาพและอุตสาหกรรมชีวภาพ | 生物技术和生物工业"
    },
    {
        "id":9115,
        "name":"9623 (Thai Program)  :  Biological And Food Engineering | วิศวกรรมชีวภาพและอาหาร | 生物与食品工程"
    },
    {
        "id":9116,
        "name":"9624 (English Program)  :  Biological And Food Engineering | วิศวกรรมชีวภาพและอาหาร | 生物与食品工程"
    },
    {
        "id":9117,
        "name":"9625 (Thai Program)  :  Sustainable Environmental Management | การจัดการสิ่งแวดล้อมอย่างยั่งยืน | 可持续环境管理"
    },
    {
        "id":9118,
        "name":"9626 (English Program)  :  Sustainable Environmental Management | การจัดการสิ่งแวดล้อมอย่างยั่งยืน | 可持续环境管理"
    },
    {
        "id":9119,
        "name":"9627 (Thai Program)  :  Herbs And Traditional Thai Medicine | สมุนไพรและการแพทย์แผนไทย | 草药和传统泰国医学"
    },
    {
        "id":9120,
        "name":"9628 (English Program)  :  Herbals And Thai Traditional Medicines | สมุนไพรและการแพทย์แผนไทย | 草药和泰国传统药物"
    },
    {
        "id":9121,
        "name":"9629 (English Program)  :  Creative Media | สื่อสร้างสรรค์ | 创意媒体"
    },
    {
        "id":9122,
        "name":"9630 (Thai Program)  :  Biotechnology Innovation For Business | นวัตกรรมเทคโนโลยีชีวภาพเพื่อธุรกิจ | 商业生物技术创新"
    },
    {
        "id":9123,
        "name":"9631 (English Program)  :  Biotechnology Innovation For Business | นวัตกรรมเทคโนโลยีชีวภาพเพื่อธุรกิจ | 商业生物技术创新"
    },
    {
        "id":9124,
        "name":"9632 (Thai Program)  :  Interdisciplinary Statistics Management | สหวิทยาการจัดการสถิติ | 跨学科统计管理"
    },
    {
        "id":9125,
        "name":"9633 (English Program)  :  Interdisciplinary Statistical Management | การจัดการสถิติแบบสหวิทยาการ | 跨学科统计管理"
    },
    {
        "id":9126,
        "name":"9634 (English Program)  :  Statistical Management Science | วิทยาศาสตร์การจัดการทางสถิติ | 统计管理科学"
    },
    {
        "id":9127,
        "name":"9635 (Thai Program)  :  Social Policy And Development | นโยบายสังคมและการพัฒนา | 社会政策与发展"
    },
    {
        "id":9128,
        "name":"9636 (English Program)  :  Social Policy And Development | นโยบายสังคมและการพัฒนา | 社会政策与发展"
    },
    {
        "id":9129,
        "name":"9637 (English Program)  :  Metal Technique | เทคนิคโลหะ | 金属工艺"
    },
    {
        "id":9130,
        "name":"9638 (English Program)  :  High-Speed Rail Engineering | วิศวกรรมรถไฟความเร็วสูง | 高铁工程"
    },
    {
        "id":9131,
        "name":"9639 (Thai Program)  :  Civil Engineering–Infrastructure | วิศวกรรมโยธา–โครงสร้างพื้นฐาน | 土木工程-基础设施"
    },
    {
        "id":9132,
        "name":"9640 (Thai Program)  :  Digital Media And Design | สื่อดิจิทัลและการออกแบบ | 数字媒体和设计"
    },
    {
        "id":9133,
        "name":"9641 (English Program)  :  Digital Media And Design | สื่อดิจิทัลและการออกแบบ | 数字媒体与设计"
    },
    {
        "id":9134,
        "name":"9642 (Thai Program)  :  Teaching English To Speakers Of Other Languages | การสอนภาษาอังกฤษแก่ผู้พูดภาษาอื่น | 向说其他语言的人教授英语"
    },
    {
        "id":9135,
        "name":"9643 (Thai Program)  :  Applied Statistics For Business And Industrial Analysis. | สถิติประยุกต์สําหรับวิทยาการวิเคราะห์ธุรกิจและอุตสาหกรรม | 用于商业和工业分析的应用统计。"
    },
    {
        "id":9136,
        "name":"9644 (Thai Program)  :  Creative Communication Design | การออกแบบนิเทศศิลป์เชิงสร้างสรรค์ | 创意传达设计"
    },
    {
        "id":9137,
        "name":"9645 (English Program)  :  Applied Statistics For Business And Industrial Analytics | สถิติประยุกต์สำหรับการวิเคราะห์ธุรกิจและอุตสาหกรรม | 商业和工业分析应用统计"
    },
    {
        "id":9138,
        "name":"9646 (Thai Program)  :  Study Area | อาณาบริเวณศึกษา | 研究区"
    },
    {
        "id":9139,
        "name":"9647 (Thai Program)  :  Intelligent Industrial Engineering And Logistics | วิศวกรรมอุตสาหการและโลจิสติกส์อัจฉริยะ | 智能工业工程与物流"
    },
    {
        "id":9140,
        "name":"9648 (English Program)  :  Industrial Engineering And Smart Logistics | วิศวกรรมอุตสาหการและโลจิสติกส์อัจฉริยะ | 工业工程与智能物流"
    },
    {
        "id":9141,
        "name":"9649 (Thai Program)  :  Business And Supply Chain Analysis | การวิเคราะห์ธุรกิจและโซ่อุปทาน | 业务和供应链分析"
    },
    {
        "id":9142,
        "name":"9650 (English Program)  :  Business And Supply Chain ​​Analytics | การวิเคราะห์ธุรกิจและห่วงโซ่อุปทาน | 业务和供应链分析"
    },
    {
        "id":9143,
        "name":"9651 (Thai Program)  :  Chemical Engineering And Management | วิศวกรรมเคมีและการจัดการ | 化学工程与管理"
    },
    {
        "id":9144,
        "name":"9652 (English Program)  :  Chemical Engineering And Management | วิศวกรรมเคมีและการจัดการ | 化学工程与管理"
    },
    {
        "id":9145,
        "name":"9653 (Thai Program)  :  Civil Engineering And Real Estate Development | วิศวกรรมโยธาและการพัฒนาอสังหาริมทรัพย์ | 土木工程和房地产开发"
    },
    {
        "id":9146,
        "name":"9654 (English Program)  :  Civil Engineering And Real Estate Development | วิศวกรรมโยธาและการพัฒนาอสังหาริมทรัพย์ | 土木工程和房地产开发"
    },
    {
        "id":9147,
        "name":"9655 (Thai Program)  :  Mechanical Engineering And Industrial Management | วิศวกรรมเครื่องกลและการจัดการอุตสาหกรรม | 机械工程与工业管理"
    },
    {
        "id":9148,
        "name":"9656 (English Program)  :  Mechanical Engineering And Industrial Management | วิศวกรรมเครื่องกลและการจัดการอุตสาหกรรม | 机械工程与工业管理"
    },
    {
        "id":9149,
        "name":"9657 (Thai Program)  :  Electrical And Information Engineering | วิศวกรรมไฟฟ้าและข้อมูล | 电气与信息工程"
    },
    {
        "id":9150,
        "name":"9658 (English Program)  :  Electrical And Data Engineering | วิศวกรรมไฟฟ้าและข้อมูล | 电气和数据工程"
    },
    {
        "id":9151,
        "name":"9659 (Thai Program)  :  Innovative Health Promotion | การสร้างเสริมสุขภาพเชิงนวัตกรรม | 创新健康促进"
    },
    {
        "id":9152,
        "name":"9660 (English Program)  :  Innovative Health Promotion | นวัตกรรมส่งเสริมสุขภาพ | 创新健康促进"
    },
    {
        "id":9153,
        "name":"9661 (Thai Program)  :  Business Communication | การสื่อสารเชิงธุรกิจ | 商务沟通"
    },
    {
        "id":9154,
        "name":"9662 (Thai Program)  :  Electrical Engineering And Industrial Management | วิศวกรรมไฟฟ้าและการจัดการอุตสาหกรรม | 电气工程与工业管理"
    },
    {
        "id":9155,
        "name":"9663 (English Program)  :  Electrical Engineering And Industrial Management | วิศวกรรมไฟฟ้าและการจัดการอุตสาหกรรม | 电气工程与工业管理"
    },
    {
        "id":9156,
        "name":"9664 (English Program)  :  Design, Business And Technology Management | การออกแบบ การจัดการธุรกิจและเทคโนโลยี | 设计、商业和技术管理"
    },
    {
        "id":9157,
        "name":"9665 (Thai Program)  :  Translation And Interpreting In The Digital Age | การแปลและล่ามในยุคดิจิทัล | 数字时代的笔译和口译"
    },
    {
        "id":9158,
        "name":"9666 (English Program)  :  Translation And Interpretation In The Digital Age | การแปลและการตีความในยุคดิจิทัล | 数字时代的翻译和口译"
    },
    {
        "id":9159,
        "name":"9667 (Thai Program)  :  Digital Technology And Innovation | เทคโนโลยีและนวัตกรรมดิจิทัล | 数字技术与创新"
    },
    {
        "id":9160,
        "name":"9668 (English Program)  :  Buddhist Art | ศิลปะพุทธศาสนา | 佛教艺术"
    },
    {
        "id":9161,
        "name":"9669 (Thai Program)  :  Business Management And Languages | การจัดการธุรกิจและภาษา | 商业管理和语言"
    },
    {
        "id":9162,
        "name":"9670 (English Program)  :  Business Management And Languages | การจัดการธุรกิจและภาษา | 商业管理和语言"
    },
    {
        "id":9163,
        "name":"9671 (Thai Program)  :  Digital Technology Business | เทคโนโลยีดิจิทัลธุรกิจ | 数字技术业务"
    },
    {
        "id":9164,
        "name":"9672 (English Program)  :  Business Digital Technology | เทคโนโลยีดิจิทัลทางธุรกิจ | 商业数字技术"
    },
    {
        "id":9165,
        "name":"9673 (Thai Program)  :  Tourism And Mice Business Management | การจัดการธุรกิจท่องเที่ยวและไมซ์ | 旅游及会展商务管理"
    },
    {
        "id":9166,
        "name":"9674 (English Program)  :  Tourism Business And Mice Management | ธุรกิจการท่องเที่ยวและการจัดการหนู | 旅游商务及会展管理"
    },
    {
        "id":9167,
        "name":"9675 (Thai Program)  :  Health Tourism Technology | เทคโนโลยีการท่องเที่ยวเชิงสุขภาพ | 健康旅游技术"
    },
    {
        "id":9168,
        "name":"9676 (English Program)  :  Technology Of Wellness Tourism | เทคโนโลยีการท่องเที่ยวเพื่อสุขภาพ | 健康旅游技术"
    },
    {
        "id":9169,
        "name":"9677 (Thai Program)  :  Arts And Show Business | ศิลปะและธุรกิจการแสดง | 艺术和演艺事业"
    },
    {
        "id":9170,
        "name":"9678 (Thai Program)  :  Applied Economics And Agribusiness | เศรษฐศาสตร์ประยุกต์และธุรกิจเกษตร | 应用经济学和农业综合企业"
    },
    {
        "id":9171,
        "name":"9679 (English Program)  :  Applied Economics And Agribusiness | เศรษฐศาสตร์ประยุกต์และธุรกิจการเกษตร | 应用经济学和农业企业"
    },
    {
        "id":9172,
        "name":"9680 (Thai Program)  :  Early Childhood Education | วิทยาการปฐมวัยศึกษา | 幼儿教育"
    },
    {
        "id":9173,
        "name":"9681 (English Program)  :  Early Childhood Education Science | วิทยาศาสตร์การศึกษาปฐมวัย | 幼儿教育科学"
    },
    {
        "id":9174,
        "name":"9682 (English Program)  :  Mechanical And Energy Engineering | วิศวกรรมเครื่องกลและพลังงาน | 机械与能源工程"
    },
    {
        "id":9175,
        "name":"9683 (Thai Program)  :  Textile Technology And Fashion | เทคโนโลยีสิ่งทอและแฟชั่น | 纺织科技与时尚"
    },
    {
        "id":9176,
        "name":"9684 (English Program)  :  Textile And Fashion Technology | เทคโนโลยีสิ่งทอและแฟชั่น | 纺织与时尚技术"
    },
    {
        "id":9177,
        "name":"9685 (Thai Program)  :  Geography And Geoinformatics | ภูมิศาสตร์และภูมิสารสนเทศศาสตร์ | 地理和地理信息学"
    },
    {
        "id":9178,
        "name":"9686 (English Program)  :  Geography And Geoinformatics | ภูมิศาสตร์และภูมิสารสนเทศ | 地理和地理信息学"
    },
    {
        "id":9179,
        "name":"9687 (Thai Program)  :  Digital Manufacturing Engineering And Robot Integration | วิศวกรรมการผลิตดิจิทัลและการบูรณาการหุ่นยนต์ | 数字化制造工程与机器人集成"
    },
    {
        "id":9180,
        "name":"9688 (English Program)  :  Digital Manufacturing And Robotics Integration Engineering | วิศวกรรมบูรณาการการผลิตดิจิทัลและหุ่นยนต์ | 数字化制造与机器人集成工程"
    },
    {
        "id":9181,
        "name":"9689 (Thai Program)  :  Operations And Technology Management | การจัดการการปฏิบัติการและเทคโนโลยี | 运营和技术管理"
    },
    {
        "id":9182,
        "name":"9690 (English Program)  :  Operations And Technology Management | การดำเนินงานและการจัดการเทคโนโลยี | 运营和技术管理"
    },
    {
        "id":9183,
        "name":"9691 (Thai Program)  :  Innovation And Management Of The Agricultural Industry | นวัตกรรมและการจัดการอุตสาหกรรมเกษตร | 农业产业创新与管理"
    },
    {
        "id":9184,
        "name":"9692 (English Program)  :  Agro-Industrial Innovation And Management | นวัตกรรมและการจัดการอุตสาหกรรมเกษตร | 农业工业创新与管理"
    },
    {
        "id":9185,
        "name":"9693 (Thai Program)  :  Human Resource Management And Organization Management | การบริหารทรัพยากรมนุษย์และการจัดการองค์การ | 人力资源管理和组织管理"
    },
    {
        "id":9186,
        "name":"9694 (English Program)  :  Farm Technology Management | การจัดการเทคโนโลยีฟาร์ม | 农业技术管理"
    },
    {
        "id":9187,
        "name":"9695 (Thai Program)  :  Farm Technology Management | การจัดการเทคโนโลยีฟาร์ม | 农业技术管理"
    },
    {
        "id":9188,
        "name":"9696 (English Program)  :  Computer Engineering And Artificial Intelligence | วิศวกรรมคอมพิวเตอร์และปัญญาประดิษฐ์ | 计算机工程和人工智能"
    },
    {
        "id":9189,
        "name":"9697 (Thai Program)  :  Real Estate And Building Property Management | การจัดการอสังหาริมทรัพย์และทรัพย์สินอาคาร | 房地产及楼宇物业管理"
    },
    {
        "id":9190,
        "name":"9698 (English Program)  :  Real Estate And Property Management | อสังหาริมทรัพย์และการจัดการทรัพย์สิน | 房地产及物业管理"
    },
    {
        "id":9191,
        "name":"9699 (Thai Program)  :  Food Processing Technology Management | การจัดการเทคโนโลยีแปรรูปอาหาร | 食品加工技术管理"
    },
    {
        "id":9192,
        "name":"9700 (Thai Program)  :  Hospitality And Tourism Industry | อุตสาหกรรมการบริการและการท่องเที่ยว | 酒店和旅游业"
    },
    {
        "id":9193,
        "name":"9701 (English Program)  :  Hospitality Industry And Tourism | อุตสาหกรรมการบริการและการท่องเที่ยว | 酒店业和旅游业"
    },
    {
        "id":9194,
        "name":"9702 (Thai Program)  :  Industrial Engineering And Smart Manufacturing | วิศวกรรมอุตสาหการและการผลิตอัจฉริยะ | 工业工程与智能制造"
    },
    {
        "id":9195,
        "name":"9703 (English Program)  :  Industrial Engineering And Intelligent Manufacturing | วิศวกรรมอุตสาหการและการผลิตอัจฉริยะ | 工业工程与智能制造"
    },
    {
        "id":9196,
        "name":"9704 (Thai Program)  :  Digital And Information Technology | เทคโนโลยีดิจิทัลและสารสนเทศ | 数字和信息技术"
    },
    {
        "id":9197,
        "name":"9705 (English Program)  :  Digital And Information Technology | เทคโนโลยีดิจิทัลและสารสนเทศ | 数字和信息技术"
    },
    {
        "id":9198,
        "name":"9706 (Thai Program)  :  Educational Management And Leadership | การจัดการการศึกษาและความเป็นผู้นำ | 教育管理与领导"
    },
    {
        "id":9199,
        "name":"9707 (English Program)  :  Educational Management And Leadership | การจัดการการศึกษาและความเป็นผู้นำ | 教育管理和领导"
    },
    {
        "id":9200,
        "name":"9708 (Thai Program)  :  Engineering And Technology | วิศวกรรมศาสตร์และเทคโนโลยี | 工程技术"
    },
    {
        "id":9201,
        "name":"9709 (English Program)  :  Engineering And Technology | วิศวกรรมศาสตร์และเทคโนโลยี | 工程与技术"
    },
    {
        "id":9202,
        "name":"9710 (Thai Program)  :  Professional Cyber Security | ความมั่นคงปลอดภัยไซเบอร์อย่างมืออาชีพ | 专业网络安全"
    },
    {
        "id":9203,
        "name":"9711 (Thai Program)  :  Modern Agricultural Technology | เทคโนโลยีการเกษตรสมัยใหม่ | 现代农业技术"
    },
    {
        "id":9204,
        "name":"9712 (English Program)  :  Modern Agricultural Technology | เทคโนโลยีการเกษตรสมัยใหม่ | 现代农业技术"
    },
    {
        "id":9205,
        "name":"9713 (English Program)  :  Aeronautic Engineering | วิศวกรรมการบิน | 航空工程"
    },
    {
        "id":9206,
        "name":"9714 (Thai Program)  :  Law, Management And Information Technology | กฎหมาย การจัดการและเทคโนโลยีสารสนเทศ | 法律、管理和信息技术"
    },
    {
        "id":9207,
        "name":"9715 (English Program)  :  Law, Management And Information Technology | กฎหมาย การจัดการ และเทคโนโลยีสารสนเทศ | 法律、管理和信息技术"
    },
    {
        "id":9208,
        "name":"9716 (Thai Program)  :  Innovative Agricultural Industry Products | นวัตกรรมผลิตภัณฑ์อุตสาหกรรมเกษตร | 创新农业产业产品"
    },
    {
        "id":9209,
        "name":"9717 (English Program)  :  Agro-Industrial Product Innovation | นวัตกรรมผลิตภัณฑ์อุตสาหกรรมเกษตร | 农工产品创新"
    },
    {
        "id":9210,
        "name":"9718 (Thai Program)  :  Energy Technology Management | การจัดการเทคโนโลยีพลังงาน | 能源技术管理"
    },
    {
        "id":9211,
        "name":"9719 (English Program)  :  Energy Technology Management | การจัดการเทคโนโลยีพลังงาน | 能源技术管理"
    },
    {
        "id":9212,
        "name":"9720 (Thai Program)  :  Sustainable Agriculture For Health And Entrepreneurship | เกษตรยั่งยืนเพื่อสุขภาพและการประกอบการ | 可持续农业促进健康和创业"
    },
    {
        "id":9213,
        "name":"9721 (English Program)  :  Sustainable Agriculture For Health And Entrepreneurship | เกษตรยั่งยืนเพื่อสุขภาพและผู้ประกอบการ | 可持续农业促进健康和创业"
    },
    {
        "id":9214,
        "name":"9722 (Thai Program)  :  Educational Measurement, Evaluation, And Research | การวัด ประเมิน และวิจัยการศึกษา | 教育测量、评估和研究"
    },
    {
        "id":9215,
        "name":"9723 (English Program)  :  Educational Measurement, Evaluation, And Research | การวัดผลการศึกษา การประเมิน และการวิจัย | 教育测量、评估和研究"
    },
    {
        "id":9216,
        "name":"9724 (Thai Program)  :  Innovation In Natural Resource Productivity And Management | นวัตกรรมผลิตภาพทางทรัพยากรธรรมชาติและการจัดการ | 自然资源生产力和管理创新"
    },
    {
        "id":9217,
        "name":"9725 (English Program)  :  Natural Resource Productivity Innovation And Management | นวัตกรรมการผลิตและการจัดการทรัพยากรธรรมชาติ | 自然资源生产力创新与管理"
    },
    {
        "id":9218,
        "name":"9726 (Thai Program)  :  Advanced Computational Engineering And Design | วิศวกรรมเชิงคำนวณขั้นสูงและการออกแบบ | 先进的计算工程和设计"
    },
    {
        "id":9219,
        "name":"9727 (English Program)  :  Advanced Computational Engineering And Design | วิศวกรรมคอมพิวเตอร์ขั้นสูงและการออกแบบ | 高级计算工程与设计"
    },
    {
        "id":9220,
        "name":"9728 (English Program)  :  Physical Education, Health Education, And Sports | พลศึกษา, สุขศึกษา และกีฬา | 体育、健康教育和运动"
    },
    {
        "id":9221,
        "name":"9729 (Thai Program)  :  Textile Innovation | นวัตกรรมสิ่งทอ | 纺织创新"
    },
    {
        "id":9222,
        "name":"9730 (English Program)  :  Textile Innovation | นวัตกรรมสิ่งทอ | 纺织创新"
    },
    {
        "id":9223,
        "name":"9731 (Thai Program)  :  Textile Technology | เทคโนโลยีสิ่งทอ | 纺织技术"
    },
    {
        "id":9224,
        "name":"9732 (English Program)  :  Textile Technology | เทคโนโลยีสิ่งทอ | 纺织技术"
    },
    {
        "id":9225,
        "name":"9733 (Thai Program)  :  Biological Innovation And Being An Entrepreneur | นวัตกรรมชีวภาพ และการเป็นผู้ประกอบการ | 生物创新并成为一名企业家"
    },
    {
        "id":9226,
        "name":"9734 (English Program)  :  Bioinnovation And Entrepreneurship | นวัตกรรมชีวภาพและการเป็นผู้ประกอบการ | 生物创新与创业"
    },
    {
        "id":9227,
        "name":"9735 (Thai Program)  :  Modern Developments In Sports | พัฒนาการสมัยใหม่ทางการกีฬา | 现代体育运动的发展"
    },
    {
        "id":9228,
        "name":"9736 (English Program)  :  Modern Development In Sport | การพัฒนาที่ทันสมัยในด้านกีฬา | 体育运动的现代发展"
    },
    {
        "id":9229,
        "name":"9737 (Thai Program)  :  Art, Design And The Creative Economy | ศิลปะ การออกแบบ และเศรษฐกิจสร้างสรรค์ | 艺术、设计和创意经济"
    },
    {
        "id":9230,
        "name":"9738 (English Program)  :  Art, Design And Creative Economy | ศิลปะ การออกแบบ และเศรษฐกิจเชิงสร้างสรรค์ | 艺术、设计和创意经济"
    },
    {
        "id":9231,
        "name":"9739 (Thai Program)  :  Applied Life Sciences | ชีววิทยาศาสตร์ประยุกต์ | 应用生命科学"
    },
    {
        "id":9232,
        "name":"9740 (Thai Program)  :  Industrial Mathematics And Data Science | คณิตศาสตร์อุตสาหการและวิทยาการข้อมูล | 工业数学和数据科学"
    },
    {
        "id":9233,
        "name":"9741 (English Program)  :  Industrial Mathematics And Data Science | คณิตศาสตร์อุตสาหกรรมและวิทยาศาสตร์ข้อมูล | 工业数学和数据科学"
    },
    {
        "id":9234,
        "name":"9742 (Thai Program)  :  Entrepreneurs In The Travel And Service Business | ผู้ประกอบการด้านธุรกิจการเดินทางและธุรกิจบริการ | 旅游和服务业的企业家"
    },
    {
        "id":9235,
        "name":"9743 (English Program)  :  Travel And Service Business Entrepreneurship | ประกอบกิจการธุรกิจท่องเที่ยวและบริการ | 旅游和服务业创业"
    },
    {
        "id":9236,
        "name":"9744 (Thai Program)  :  Management And Entrepreneurship | การจัดการและการเป็นผู้ประกอบการ | 管理与创业"
    },
    {
        "id":9237,
        "name":"9745 (English Program)  :  Management And Entrepreneurship | การจัดการและการเป็นผู้ประกอบการ | 管理与创业"
    },
    {
        "id":9238,
        "name":"9746 (Thai Program)  :  Modern International Business Management | การจัดการธุรกิจระหว่างประเทศสมัยใหม่ | 现代国际企业管理"
    },
    {
        "id":9239,
        "name":"9747 (English Program)  :  Modern International Business Management | การจัดการธุรกิจระหว่างประเทศสมัยใหม่ | 现代国际企业管理"
    },
    {
        "id":9240,
        "name":"9748 (Thai Program)  :  Hospital Medical Records And Medical Statistics Management | การจัดการเวชระเบียนและเวชสถิติโรงพยาบาล | 医院病历及医疗统计管理"
    },
    {
        "id":9241,
        "name":"9749 (English Program)  :  Hospital Medical Records And Medical Statistics Management | เวชระเบียนของโรงพยาบาลและการจัดการสถิติทางการแพทย์ | 医院病历和医疗统计管理"
    },
    {
        "id":9242,
        "name":"9750 (Thai Program)  :  Curriculum And Learning Management Innovations | หลักสูตรและนวัตกรรมการจัดการเรียนรู้ | 课程和学习管理创新"
    },
    {
        "id":9243,
        "name":"9751 (Thai Program)  :  Surgery Research | การวิจัยศัลยศาสตร์ | 外科研究"
    },
    {
        "id":9244,
        "name":"9752 (English Program)  :  Surgery Research | การวิจัยศัลยกรรม | 外科研究"
    },
    {
        "id":9245,
        "name":"9753 (English Program)  :  Gerodontology | ทันตกรรมวิทยา | 老年牙科"
    },
    {
        "id":9246,
        "name":"9754 (Thai Program)  :  Science And Mathematics Studies | วิทยาศาสตร์และคณิตศาสตร์ศึกษา | 科学与数学研究"
    },
    {
        "id":9247,
        "name":"9755 (English Program)  :  Science And Mathematics Education | การศึกษาวิทยาศาสตร์และคณิตศาสตร์ | 科学和数学教育"
    },
    {
        "id":9248,
        "name":"9756 (Thai Program)  :  Innovation In Social And Environmental Management | นวัตกรรมการจัดการสังคมและสิ่งแวดล้อม | 社会和环境管理创新"
    },
    {
        "id":9249,
        "name":"9757 (English Program)  :  Innovation For Social And Environmental Management | นวัตกรรมเพื่อการจัดการสังคมและสิ่งแวดล้อม | 社会和环境管理创新"
    },
    {
        "id":9250,
        "name":"9758 (English Program)  :  Mechanical | เครื่องกล | 机械的"
    },
    {
        "id":9251,
        "name":"9759 (Thai Program)  :  Social Sciences, Environment And Sustainable Development | สังคมศาสตร์สิ่งแวดล้อมและการพัฒนาที่ยั่งยืน | 社会科学、环境与可持续发展"
    },
    {
        "id":9252,
        "name":"9760 (English Program)  :  Environmental Social Sciences And Sustainable Development | สังคมศาสตร์สิ่งแวดล้อมและการพัฒนาที่ยั่งยืน | 环境社会科学与可持续发展"
    },
    {
        "id":9253,
        "name":"9761 (English Program)  :  Human And Family Development | การพัฒนามนุษย์และครอบครัว | 人类和家庭发展"
    },
    {
        "id":9254,
        "name":"9762 (Thai Program)  :  Materials Physics And Nanotechnology | ฟิสิกส์วัสดุและนาโนเทคโนโลยี | 材料物理与纳米技术"
    },
    {
        "id":9255,
        "name":"9763 (English Program)  :  Material Physics And Nanotechnology | ฟิสิกส์ของวัสดุและนาโนเทคโนโลยี | 材料物理和纳米技术"
    },
    {
        "id":9256,
        "name":"9764 (Thai Program)  :  Rubber And Polymer Engineering | วิศวกรรมยางและพอลิเมอร์ | 橡胶与聚合物工程"
    },
    {
        "id":9257,
        "name":"9765 (Thai Program)  :  Plant Production Technology And Innovation | เทคโนโลยีและนวัตกรรมการผลิตพืช | 植物生产技术与创新"
    },
    {
        "id":9258,
        "name":"9766 (English Program)  :  Technology And Innovation Plant Production | เทคโนโลยีและนวัตกรรมการผลิตโรงงาน | 科技创新工厂生产"
    },
    {
        "id":9259,
        "name":"9767 (Thai Program)  :  Promote Agriculture And Community Development | ส่งเสริมการเกษตรและพัฒนาชุมชน | 促进农业和社区发展"
    },
    {
        "id":9260,
        "name":"9768 (English Program)  :  Agricultural Extension And Community Development | การส่งเสริมการเกษตรและการพัฒนาชุมชน | 农业推广和社区发展"
    },
    {
        "id":9261,
        "name":"9769 (English Program)  :  Entrepreneurship And Management | ผู้ประกอบการและการจัดการ | 创业与管理"
    },
    {
        "id":9262,
        "name":"9770 (Thai Program)  :  Educational Measurement And Evaluation | การวัดและประเมินทางการศึกษา | 教育测量与评价"
    },
    {
        "id":9263,
        "name":"9771 (English Program)  :  Measurement And Evaluation In Education | การวัดและประเมินผลทางการศึกษา | 教育测量和评估"
    },
    {
        "id":9264,
        "name":"9772 (English Program)  :  Sport And Recreation Management | การจัดการกีฬาและสันทนาการ | 体育和娱乐管理"
    },
    {
        "id":9265,
        "name":"9773 (Thai Program)  :  Tourism Management Exhibitions And Conferences | การจัดการการท่องเที่ยว นิทรรศการและการประชุม | 旅游管理展览及会议"
    },
    {
        "id":9266,
        "name":"9774 (English Program)  :  Tourism And Mice Management | การท่องเที่ยวและการจัดการหนู | 旅游及会展管理"
    },
    {
        "id":9267,
        "name":"9775 (Thai Program)  :  Food Assembly Art And Design | ศิลปะการประกอบและออกแบบอาหาร | 食品装配艺术与设计"
    },
    {
        "id":9268,
        "name":"9776 (English Program)  :  Culinary Arts And Design | ศิลปะการทำอาหารและการออกแบบ | 烹饪艺术与设计"
    },
    {
        "id":9269,
        "name":"9777 (English Program)  :  Innovative Media Design And Media Production | นวัตกรรมการออกแบบสื่อและการผลิตสื่อ | 创新媒体设计和媒体制作"
    },
    {
        "id":9270,
        "name":"9778 (Thai Program)  :  Service Industry Tourism And Hospitality | อุตสาหกรรมการบริการ การท่องเที่ยวและการโรงแรม | 服务业旅游与酒店业"
    },
    {
        "id":9271,
        "name":"9779 (English Program)  :  Service Industry - Tourism And Hotel | อุตสาหกรรมบริการ - การท่องเที่ยวและการโรงแรม | 服务业-旅游和酒店"
    },
    {
        "id":9272,
        "name":"9780 (Thai Program)  :  Graphic And Multimedia Design | การออกแบบกราฟิกและมัลติมีเดีย | 图形和多媒体设计"
    },
    {
        "id":9273,
        "name":"9781 (English Program)  :  Graphic And Multimedia Design | การออกแบบกราฟิกและมัลติมีเดีย | 图形和多媒体设计"
    },
    {
        "id":9274,
        "name":"9782 (Thai Program)  :  Healthy Cooking | การประกอบอาหารเพื่อสุขภาพ | 健康烹饪"
    },
    {
        "id":9275,
        "name":"9783 (English Program)  :  Culinary For Health | อาหารเพื่อสุขภาพ | 烹饪促进健康"
    },
    {
        "id":9276,
        "name":"9784 (English Program)  :  Major In Creative Digital Design | สาขาวิชาเอกในการออกแบบดิจิทัลเชิงสร้างสรรค์ | 主修创意数字设计"
    },
    {
        "id":9277,
        "name":"9785 (Thai Program)  :  Creative Digital Design | การออกแบบดิจิทัลเชิงสร้างสรรค์ | 创意数字设计"
    },
    {
        "id":9278,
        "name":"9786 (Thai Program)  :  Hospitality And Culinary Industry | อุตสาหกรรมการบริการและการประกอบอาหาร | 酒店及烹饪业"
    },
    {
        "id":9279,
        "name":"9787 (English Program)  :  Hospitality And Culinary Industry | การบริการและอุตสาหกรรมการทำอาหาร | 酒店和烹饪业"
    },
    {
        "id":9280,
        "name":"9788 (Thai Program)  :  Creative Media Design | การออกแบบสื่อสร้างสรรค์ | 创意媒体设计"
    },
    {
        "id":9281,
        "name":"9789 (English Program)  :  Creative Media Design | การออกแบบสื่อสร้างสรรค์ | 创意媒体设计"
    },
    {
        "id":9282,
        "name":"9790 (Thai Program)  :  Local And Community Health Management | การจัดการสุขภาพท้องถิ่นและชุมชน | 地方和社区健康管理"
    },
    {
        "id":9283,
        "name":"9791 (English Program)  :  Local And Community Health Management | การจัดการสุขภาพท้องถิ่นและชุมชน | 当地和社区健康管理"
    },
    {
        "id":9284,
        "name":"9792 (Thai Program)  :  Research And Buddhist Wisdom In Education | การวิจัยและพุทธปัญญาวิทยาทางการศึกษา | 教育研究与佛教智慧"
    },
    {
        "id":9285,
        "name":"9793 (English Program)  :  Research And Buddhist Wisdom In Education | การวิจัยและภูมิปัญญาทางพุทธศาสนาในด้านการศึกษา | 教育研究与佛教智慧"
    },
    {
        "id":9286,
        "name":"9794 (Thai Program)  :  Digital Logistics And Supply Chain Management | การจัดการโลจิสติกส์และซัพพลายเชนดิจิทัล | 数字物流和供应链管理"
    },
    {
        "id":9287,
        "name":"9795 (English Program)  :  Digital Logistics And Supply Chain ​​Management | โลจิสติกส์ดิจิทัลและการจัดการห่วงโซ่อุปทาน | 数字物流和供应链管理"
    },
    {
        "id":9288,
        "name":"9796 (English Program)  :  Textile Industrial Technology And Merchandising | เทคโนโลยีอุตสาหกรรมสิ่งทอและการจำหน่ายสินค้า | 纺织工业技术与营销"
    },
    {
        "id":9289,
        "name":"9797 (Thai Program)  :  Genetic Engineering And Bioinformatics | พันธุวิศวกรรมและชีวสารสนเทศ | 基因工程与生物信息学"
    },
    {
        "id":9290,
        "name":"9798 (English Program)  :  Genetic Engineering And Bioinformatics | พันธุวิศวกรรมและชีวสารสนเทศศาสตร์ | 基因工程和生物信息学"
    },
    {
        "id":9291,
        "name":"9799 (Thai Program)  :  Modern Technology For Plant Management | เทคโนโลยีสมัยใหม่เพื่อการจัดการพืช | 工厂管理的现代技术"
    },
    {
        "id":9292,
        "name":"9800 (English Program)  :  Modern Technology For Crop Management | เทคโนโลยีสมัยใหม่สำหรับการจัดการพืชผล | 现代作物管理技术"
    },
    {
        "id":9293,
        "name":"9801 (English Program)  :  Cosmetic And Beauty Sciences | วิทยาศาสตร์เครื่องสำอางและความงาม | 化妆品与美容科学"
    },
    {
        "id":9294,
        "name":"9802 (Thai Program)  :  Social Innovation For Community Development | นวัตกรรมสังคมเพื่อการพัฒนาชุมชน | 社会创新促进社区发展"
    },
    {
        "id":9295,
        "name":"9803 (English Program)  :  Social Innovation For Community Development | นวัตกรรมทางสังคมเพื่อการพัฒนาชุมชน | 社会创新促进社区发展"
    },
    {
        "id":9296,
        "name":"9804 (Thai Program)  :  Thai Language For Careers | ภาษาไทยเพื่อการอาชีพ | 泰语职业"
    },
    {
        "id":9297,
        "name":"9805 (Thai Program)  :  Modern Marketing | การตลาดสมัยใหม่ | 现代营销"
    },
    {
        "id":9298,
        "name":"9806 (English Program)  :  Modern Marketing | การตลาดสมัยใหม่ | 现代营销"
    },
    {
        "id":9299,
        "name":"9807 (Thai Program)  :  New Media And Multimedia | สื่อใหม่และมัลติมีเดีย | 新媒体与多媒体"
    },
    {
        "id":9300,
        "name":"9808 (English Program)  :  New Media And Multimedia | สื่อใหม่และมัลติมีเดีย | 新媒体和多媒体"
    },
    {
        "id":9301,
        "name":"9809 (Thai Program)  :  Creative Tourism | การท่องเที่่ยวเชิงสร้างสรรค์ | 创意旅游"
    },
    {
        "id":9302,
        "name":"9810 (English Program)  :  Creative Tourism | การท่องเที่ยวเชิงสร้างสรรค์ | 创意旅游"
    },
    {
        "id":9303,
        "name":"9811 (Thai Program)  :  Architecture And Design | สถาปัตยกรรมและการออกแบบ | 建筑与设计"
    },
    {
        "id":9304,
        "name":"9812 (English Program)  :  Architecture And Design | สถาปัตยกรรมและการออกแบบ | 建筑与设计"
    },
    {
        "id":9305,
        "name":"9813 (English Program)  :  Agricultural Resources | ทรัพยากรเกษตร | 农业资源"
    },
    {
        "id":9306,
        "name":"9814 (Thai Program)  :  Creating Services For The Tourism Business | การสร้างสรรค์การบริการเพื่อธุรกิจการท่องเที่ยว | 为旅游企业创造服务"
    },
    {
        "id":9307,
        "name":"9815 (English Program)  :  Service Creation For Tourism Business | การสร้างบริการสำหรับธุรกิจการท่องเที่ยว | 为旅游业务创造服务"
    },
    {
        "id":9308,
        "name":"9816 (English Program)  :  Tourism Innovation | นวัตกรรมการท่องเที่ยว | 旅游创新"
    },
    {
        "id":9309,
        "name":"9817 (Thai Program)  :  Tourism Innovation | นวัตกรรมการท่องเที่ยว | 旅游创新"
    },
    {
        "id":9310,
        "name":"9818 (Thai Program)  :  Mechanical Engineering - Agriculture | วิศวกรรมเครื่องกล - เกษตร | 机械工程-农业"
    },
    {
        "id":9311,
        "name":"9819 (English Program)  :  Mechanical Engineering - Agriculture | วิศวกรรมเครื่องกล-เกษตร | 机械工程-农业"
    },
    {
        "id":9312,
        "name":"9820 (English Program)  :  Radiation Biosciences | ชีววิทยาศาสตร์การแผ่รังสี | 辐射生物科学"
    },
    {
        "id":9313,
        "name":"9821 (Thai Program)  :  Computer Engineering And Information Science | วิศวกรรมคอมพิวเตอร์และสารสนเทศศาสตร์ | 计算机工程与信息科学"
    },
    {
        "id":9314,
        "name":"9822 (Thai Program)  :  Wood And Paper Product Technology | เทคโนโลยีผลิตภัณฑ์ไม้และกระดาษ | 木材和纸制品技术"
    },
    {
        "id":9315,
        "name":"9823 (English Program)  :  Wood And Paper Products Technology | เทคโนโลยีผลิตภัณฑ์ไม้และกระดาษ | 木材和纸制品技术"
    },
    {
        "id":9316,
        "name":"9824 (English Program)  :  Safety Engineering And Environmental Management | วิศวกรรมความปลอดภัยและการจัดการสิ่งแวดล้อม | 安全工程与环境管理"
    },
    {
        "id":9317,
        "name":"9825 (Thai Program)  :  Promote And Manage Agricultural Innovation | ส่งเสริมและการจัดการนวัตกรรมเกษตร | 促进和管理农业创新"
    },
    {
        "id":9318,
        "name":"9826 (English Program)  :  Agricultural Extension And Innovation Management | การส่งเสริมการเกษตรและการจัดการนวัตกรรม | 农业推广与创新管理"
    },
    {
        "id":9319,
        "name":"9827 (English Program)  :  Electrical-Mechanical Manufacturing Engineering | วิศวกรรมการผลิตไฟฟ้า-เครื่องกล | 机电制造工程"
    },
    {
        "id":9320,
        "name":"9828 (Thai Program)  :  Animal Health Technology | เทคโนโลยีสุขภาพสัตว์ | 动物保健技术"
    },
    {
        "id":9321,
        "name":"9829 (English Program)  :  Animal Health Technology | เทคโนโลยีด้านสุขภาพสัตว์ | 动物保健技术"
    },
    {
        "id":9322,
        "name":"9830 (Thai Program)  :  Nuclear Science | วิทยาศาสตร์นิวเคลียร์ | 核科学"
    },
    {
        "id":9323,
        "name":"9831 (English Program)  :  Nuclear Science | วิทยาศาสตร์นิวเคลียร์ | 核科学"
    },
    {
        "id":9324,
        "name":"9832 (Thai Program)  :  Energy And Resource Engineering For Sustainability | วิศวกรรมพลังงานและทรัพยากรเพื่อความยั่งยืน | 可持续发展的能源和资源工程"
    },
    {
        "id":9325,
        "name":"9833 (English Program)  :  Sustainable Energy And Resources Engineering | วิศวกรรมพลังงานและทรัพยากรที่ยั่งยืน | 可持续能源和资源工程"
    },
    {
        "id":9326,
        "name":"9834 (Thai Program)  :  Industrial Engineering And Engineering Management | วิศวกรรมอุตสาหการและการจัดการวิศวกรรม | 工业工程与工程管理"
    },
    {
        "id":9327,
        "name":"9835 (English Program)  :  Industrial Engineering And Engineering Management | วิศวกรรมอุตสาหการและการจัดการทางวิศวกรรม | 工业工程与工程管理"
    },
    {
        "id":9328,
        "name":"9836 (Thai Program)  :  Digital Marketing And Retail Innovation | การตลาดดิจิทัลและนวัตกรรมค้าปลีก | 数字营销和零售创新"
    },
    {
        "id":9329,
        "name":"9837 (Thai Program)  :  Science Of Finding Optimum Conditions In Industry | วิทยาการการหาภาวะที่เหมาะสมทางอุตสาหกรรม | 寻找工业最佳条件的科学"
    },
    {
        "id":9330,
        "name":"9838 (English Program)  :  Industrial Optimisation And Applications | การเพิ่มประสิทธิภาพและการใช้งานทางอุตสาหกรรม | 工业优化与应用"
    },
    {
        "id":9331,
        "name":"9839 (Thai Program)  :  Global Studies Community | ประชาคมโลกศึกษา | 全球研究社区"
    },
    {
        "id":9332,
        "name":"9840 (English Program)  :  Global Studies | การศึกษาระดับโลก | 全球研究"
    },
    {
        "id":9333,
        "name":"9841 (Thai Program)  :  Global Media And Communication Innovation | สื่อและนวัตกรรมการสื่อสารระดับโลก | 全球媒体和传播创新"
    },
    {
        "id":9334,
        "name":"9842 (English Program)  :  Media And Global Innovative Communication | สื่อและการสื่อสารที่เป็นนวัตกรรมระดับโลก | 媒体与全球创新传播"
    },
    {
        "id":9335,
        "name":"9843 (English Program)  :  Pre Education | ก่อนการศึกษา | 学前教育"
    },
    {
        "id":9336,
        "name":"9844 (Thai Program)  :  Modern Community Business Management | การจัดการธุรกิจชุมชนสมัยใหม่ | 现代社区商业管理"
    },
    {
        "id":9337,
        "name":"9845 (English Program)  :  Modern Community Business Management | การจัดการธุรกิจชุมชนสมัยใหม่ | 现代社区商业管理"
    },
    {
        "id":9338,
        "name":"9846 (Thai Program)  :  Information Technology And Iot | เทคโนโลยีสารสนเทศและไอโอที | 信息技术与物联网"
    },
    {
        "id":9339,
        "name":"9847 (English Program)  :  Information Technology And Iot | เทคโนโลยีสารสนเทศและ Iot | 信息技术与物联网"
    },
    {
        "id":9340,
        "name":"9848 (Thai Program)  :  Design Intelligence For The Creative Economy | ปัญญาออกแบบเพื่อเศรษฐกิจสร้างสรรค์ | 创意经济的设计智能"
    },
    {
        "id":9341,
        "name":"9849 (English Program)  :  Design Intelligence For Creative Economy | การออกแบบอันชาญฉลาดเพื่อเศรษฐกิจเชิงสร้างสรรค์ | 创意经济的设计智慧"
    },
    {
        "id":9342,
        "name":"9850 (Thai Program)  :  Innovation In Medical Science | นวัตกรรมวิทยาศาสตร์การแพทย์ | 医学科学创新"
    },
    {
        "id":9343,
        "name":"9851 (English Program)  :  Innovative Medical Sciences | นวัตกรรมวิทยาศาสตร์การแพทย์ | 创新医学"
    },
    {
        "id":9344,
        "name":"9852 (Thai Program)  :  Cooking Science And Technology | วิทยาศาสตร์และเทคโนโลยีการประกอบอาหาร | 烹饪科学与技术"
    },
    {
        "id":9345,
        "name":"9853 (English Program)  :  Culinary Science And Technology | วิทยาศาสตร์และเทคโนโลยีการทำอาหาร | 烹饪科学与技术"
    },
    {
        "id":9346,
        "name":"9854 (English Program)  :  Health And Beauty Science | วิทยาศาสตร์สุขภาพและความงาม | 健康与美容科学"
    },
    {
        "id":9347,
        "name":"9855 (Thai Program)  :  Entrepreneurship With Digital Technology | การประกอบการด้วยเทคโนโลยีดิจิทัล | 数字技术创业"
    },
    {
        "id":9348,
        "name":"9856 (English Program)  :  Digital Technology Entrepreneurship | ผู้ประกอบการด้านเทคโนโลยีดิจิทัล | 数字技术创业"
    },
    {
        "id":9349,
        "name":"9857 (Thai Program)  :  Advanced Innovative Engineering | วิศวกรรมนวัตกรรมขั้นสูง | 先进的创新工程"
    },
    {
        "id":9350,
        "name":"9858 (English Program)  :  Advanced Innovative Engineering | วิศวกรรมนวัตกรรมขั้นสูง | 先进的创新工程"
    },
    {
        "id":9351,
        "name":"9859 (English Program)  :  Electrical Automotive Engineering | วิศวกรรมยานยนต์ไฟฟ้า | 电气汽车工程"
    },
    {
        "id":9352,
        "name":"9860 (Thai Program)  :  Industrial Engineering And Information Management | วิศวกรรมอุตสาหการและการจัดการข้อมูล | 工业工程与信息管理"
    },
    {
        "id":9353,
        "name":"9861 (English Program)  :  Industrial Engineering And Data Management | วิศวกรรมอุตสาหการและการจัดการข้อมูล | 工业工程和数据管理"
    },
    {
        "id":9354,
        "name":"9862 (Thai Program)  :  Technology And Creative Arts | เทคโนโลยีและศิลปะสร้างสรรค์ | 科技与创意艺术"
    },
    {
        "id":9355,
        "name":"9863 (English Program)  :  Creative Arts And Technology | ศิลปะสร้างสรรค์และเทคโนโลยี | 创意艺术与科技"
    },
    {
        "id":9356,
        "name":"9864 (Thai Program)  :  Integrated Agricultural Technology | เทคโนโลยีการเกษตรผสมผสาน | 综合农业技术"
    },
    {
        "id":9357,
        "name":"9865 (English Program)  :  Integrated Agricultural Technology | เทคโนโลยีการเกษตรแบบผสมผสาน | 综合农业技术"
    },
    {
        "id":9358,
        "name":"9866 (Thai Program)  :  Real Estate And Building Resource Management | การจัดการอสังหาริมทรัพย์และทรัพยากรอาคาร | 房地产和建筑资源管理"
    },
    {
        "id":9359,
        "name":"9867 (English Program)  :  Real Estate And Facility Management | การจัดการอสังหาริมทรัพย์และสิ่งอำนวยความสะดวก | 房地产和设施管理"
    },
    {
        "id":9360,
        "name":"9868 (English Program)  :  Cybersecurity Risk Management | การจัดการความเสี่ยงด้านความปลอดภัยทางไซเบอร์ | 网络安全风险管理"
    },
    {
        "id":9361,
        "name":"9869 (Thai Program)  :  Artificial Intelligence And The Internet Of Things | ปัญญาประดิษฐ์และอินเทอร์เน็ตของสรรพสิ่ง | 人工智能和物联网"
    },
    {
        "id":9362,
        "name":"9870 (English Program)  :  Artificial Intelligence And Internet Of Things | ปัญญาประดิษฐ์และอินเทอร์เน็ตของสรรพสิ่ง | 人工智能与物联网"
    },
    {
        "id":9363,
        "name":"9871 (English Program)  :  Education Management | การจัดการศึกษา | 教育管理"
    },
    {
        "id":9364,
        "name":"9872 (Thai Program)  :  Culture Management | การจัดการวัฒนธรรม | 文化管理"
    },
    {
        "id":9365,
        "name":"9873 (English Program)  :  Culture Management | การจัดการวัฒนธรรม | 文化管理"
    },
    {
        "id":9366,
        "name":"9874 (English Program)  :  Mass Communication Technology And Communication Innovation | เทคโนโลยีการสื่อสารมวลชนและนวัตกรรมการสื่อสาร | 大众传播技术与传播创新"
    },
    {
        "id":9367,
        "name":"9875 (Thai Program)  :  Mass Media Technology And Communication Innovation | เทคโนโลยีสื่อสารมวลชนและนวัตกรรมการสื่อสาร | 大众传媒技术与传播创新"
    },
    {
        "id":9368,
        "name":"9876 (Thai Program)  :  Electrical Communication Engineering And Intelligent Electronics | วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์อัจฉริยะ | 电气通信工程与智能电子"
    },
    {
        "id":9369,
        "name":"9877 (English Program)  :  Electrical Communication And Smart Electronics Engineering | การสื่อสารไฟฟ้าและวิศวกรรมอิเล็กทรอนิกส์อัจฉริยะ | 电气通信与智能电子工程"
    },
    {
        "id":9370,
        "name":"9878 (Thai Program)  :  Construction Management And Building Innovation | การจัดการงานก่อสร้างและนวัตกรรมอาคาร | 施工管理和建筑创新"
    },
    {
        "id":9371,
        "name":"9879 (English Program)  :  Management Of Construction And Building Innovation | การจัดการนวัตกรรมการก่อสร้างและอาคาร | 建筑管理和建筑创新"
    },
    {
        "id":9372,
        "name":"9880 (Thai Program)  :  Product Design And Innovation | ออกแบบผลิตภัณฑ์และนวัตกรรม | 产品设计与创新"
    },
    {
        "id":9373,
        "name":"9881 (English Program)  :  Product Design And Innovation | การออกแบบผลิตภัณฑ์และนวัตกรรม | 产品设计与创新"
    },
    {
        "id":9374,
        "name":"9882 (Thai Program)  :  Tourism Innovation And Tour Guides | นวัตกรรมการท่องเที่ยวและมัคคุเทศก์ | 旅游创新与导游"
    },
    {
        "id":9375,
        "name":"9883 (English Program)  :  Tourism And Tour Guide Innovation | นวัตกรรมการท่องเที่ยวและไกด์นำเที่ยว | 旅游和导游创新"
    },
    {
        "id":9376,
        "name":"9884 (English Program)  :  Delicate Handicrafts | งานฝีมือที่ละเอียดอ่อน | 精致的手工艺品"
    },
    {
        "id":9377,
        "name":"9885 (English Program)  :  Management Innovation | นวัตกรรมการจัดการ | 管理创新"
    },
    {
        "id":9378,
        "name":"9886 (Thai Program)  :  Digital Business Technology | เทคโนโลยีทางธุรกิจดิจิทัล | 数字商业技术"
    },
    {
        "id":9379,
        "name":"9887 (Thai Program)  :  Arts And Crafts Design | ออกแบบศิลปหัตถกรรม | 工艺美术设计"
    },
    {
        "id":9380,
        "name":"9888 (English Program)  :  Art And Crafts Design | การออกแบบงานศิลปะและงานฝีมือ | 工艺品设计"
    },
    {
        "id":9381,
        "name":"9889 (English Program)  :  Food Processing And Culinary Science | การแปรรูปอาหารและวิทยาศาสตร์การทำอาหาร | 食品加工和烹饪科学"
    },
    {
        "id":9382,
        "name":"9890 (Thai Program)  :  Smart Energy And Environmental Management | การจัดการพลังงานและสิ่งแวดล้อมอัจฉริยะ | 智慧能源与环境管理"
    },
    {
        "id":9383,
        "name":"9891 (English Program)  :  Smart Energy And Environmental Management | การจัดการพลังงานอัจฉริยะและสิ่งแวดล้อม | 智能能源和环境管理"
    },
    {
        "id":9384,
        "name":"9892 (Thai Program)  :  Being An International Creative Industry Entrepreneur | การเป็นผู้ประกอบการอุตสาหกรรมสร้างสรรค์สากล | 成为国际创意产业企业家"
    },
    {
        "id":9385,
        "name":"9893 (English Program)  :  International Creative Industry Entrepreneurship | ผู้ประกอบการอุตสาหกรรมสร้างสรรค์ระดับนานาชาติ | 国际创意产业创业"
    },
    {
        "id":9386,
        "name":"9894 (Thai Program)  :  Thai Language For International Communication | ภาษาไทยเพื่อการสื่อสารสากล | 国际交流泰语"
    },
    {
        "id":9387,
        "name":"9895 (English Program)  :  Thai Language For International Communication | ภาษาไทยเพื่อการสื่อสารระหว่างประเทศ | 国际交流泰语"
    },
    {
        "id":9388,
        "name":"9896 (Thai Program)  :  Innovation In Entrepreneurship In The Cooking Business | นวัตกรรมการเป็นผู้ประกอบการธุรกิจการประกอบอาหาร | 烹饪行业的创业创新"
    },
    {
        "id":9389,
        "name":"9897 (English Program)  :  Culinary Entrepreneurship Innovation | นวัตกรรมการประกอบการด้านอาหาร | 烹饪创业创新"
    },
    {
        "id":9390,
        "name":"9898 (English Program)  :  Innovation In Mice | นวัตกรรมในหนู | 小鼠创新"
    },
    {
        "id":9391,
        "name":"9899 (Thai Program)  :  Vocational Education For Human Resource Development | อาชีวศึกษาเพื่อพัฒนาทรัพยากรมนุษย์ | 人力资源开发的职业教育"
    },
    {
        "id":9392,
        "name":"9900 (English Program)  :  Vocational Education For Human Resource Development | อาชีวศึกษาเพื่อการพัฒนาทรัพยากรมนุษย์ | 人力资源开发的职业教育"
    },
    {
        "id":9393,
        "name":"9901 (English Program)  :  Mechanical Engineering And Production System | วิศวกรรมเครื่องกลและระบบการผลิต | 机械工程及生产系统"
    },
    {
        "id":9394,
        "name":"9902 (English Program)  :  Agricultural Produce Food Safety | ความปลอดภัยทางอาหารของผลิตผลทางการเกษตร | 农产品食品安全"
    },
    {
        "id":9395,
        "name":"9903 (English Program)  :  Mechanical And Design Engineering | วิศวกรรมเครื่องกลและการออกแบบ | 机械和设计工程"
    },
    {
        "id":9396,
        "name":"9904 (Thai Program)  :  Livestock Science | วิทยาการปศุสัตว์ | 畜牧科学"
    },
    {
        "id":9397,
        "name":"9905 (English Program)  :  Livestock Sciences | วิทยาศาสตร์ปศุสัตว์ | 畜牧科学"
    },
    {
        "id":9398,
        "name":"9906 (English Program)  :  Cellular Biology And Anatomical Sciences | ชีววิทยาของเซลล์และวิทยาศาสตร์กายวิภาค | 细胞生物学和解剖科学"
    },
    {
        "id":9399,
        "name":"9907 (Thai Program)  :  Cell Biology And Anatomical Science | ชีววิทยาของเซลล์และวิทยาศาสตร์กายวิภาค | 细胞生物学和解剖科学"
    },
    {
        "id":9400,
        "name":"9908 (English Program)  :  Watershed And Forest Environmental Management | การจัดการสิ่งแวดล้อมลุ่มน้ำและป่าไม้ | 流域和森林环境管理"
    },
    {
        "id":9401,
        "name":"9909 (Thai Program)  :  Zoology And Integrated Biology | สัตววิทยาและชีววิทยาบูรณาการ | 动物学和综合生物学"
    },
    {
        "id":9402,
        "name":"9910 (English Program)  :  Integrative Zoology And Biology | สัตววิทยาและชีววิทยาเชิงบูรณาการ | 综合动物学和生物学"
    },
    {
        "id":9403,
        "name":"9911 (Thai Program)  :  Health Promotion And Health Education | การส่งเสริมสุขภาพและสุขศึกษา | 健康促进和健康教育"
    },
    {
        "id":9404,
        "name":"9912 (English Program)  :  Health Promotion And Health Education | การส่งเสริมสุขภาพและการศึกษาด้านสุขภาพ | 健康促进和健康教育"
    },
    {
        "id":9405,
        "name":"9913 (Thai Program)  :  Promoting Lifelong Learning For Social Development | การส่งเสริมการเรียนรู้ตลอดชีวิตเพื่อพัฒนาสังคม | 促进终身学习促进社会发展"
    },
    {
        "id":9406,
        "name":"9914 (English Program)  :  Lifelong Learning Promotion For Social Development | การส่งเสริมการเรียนรู้ตลอดชีวิตเพื่อการพัฒนาสังคม | 促进社会发展的终身学习"
    },
    {
        "id":9407,
        "name":"9915 (Thai Program)  :  Research And Evaluation Methods | วิธีวิทยาการวิจัยและประเมิน | 研究与评价方法"
    },
    {
        "id":9408,
        "name":"9916 (English Program)  :  Research And Evaluation Methodology | วิธีการวิจัยและประเมินผล | 研究与评估方法"
    },
    {
        "id":9409,
        "name":"9917 (English Program)  :  Hotel | โรงแรม | 酒店"
    },
    {
        "id":9410,
        "name":"9918 (Thai Program)  :  Manage Logistics And Supply Chain Business | บริหารธุรกิจโลจิสติกส์และโซ่อุปทาน | 管理物流和供应链业务"
    },
    {
        "id":9411,
        "name":"9919 (English Program)  :  Logistics And Supply Chain ​​Business Administration | การบริหารธุรกิจโลจิสติกส์และซัพพลายเชน | 物流与供应链工商管理"
    },
    {
        "id":9412,
        "name":"9920 (Thai Program)  :  Business Engineering And Innovation | วิศวกรรมธุรกิจและนวัตกรรม | 商业工程与创新"
    },
    {
        "id":9413,
        "name":"9921 (English Program)  :  Business Engineering And Innovation | วิศวกรรมธุรกิจและนวัตกรรม | 商业工程与创新"
    },
    {
        "id":9414,
        "name":"9922 (Thai Program)  :  Thai Boxing | มวยไทย | 泰拳"
    },
    {
        "id":9415,
        "name":"9923 (English Program)  :  Muaythai | มวยไทย | 泰拳"
    },
    {
        "id":9416,
        "name":"9924 (Thai Program)  :  Health Systems Science | วิทยาระบบสุขภาพ | 卫生系统科学"
    },
    {
        "id":9417,
        "name":"9925 (English Program)  :  Health Systems Science | วิทยาศาสตร์ระบบสุขภาพ | 健康系统科学"
    },
    {
        "id":9418,
        "name":"9926 (Thai Program)  :  Art Therapy | ศิลปะบำบัด | 艺术治疗"
    },
    {
        "id":9419,
        "name":"9927 (English Program)  :  Expressive Arts Therapy | การบำบัดด้วยศิลปะการแสดงออก | 表达艺术治疗"
    },
    {
        "id":9420,
        "name":"9928 (Thai Program)  :  High Technology Entrepreneurship | การประกอบการเทคโนโลยีขั้นสูง | 高科技创业"
    },
    {
        "id":9421,
        "name":"9929 (English Program)  :  High-Tech Entrepreneurship | ผู้ประกอบการที่มีเทคโนโลยีสูง | 高科技创业"
    },
    {
        "id":9422,
        "name":"9930 (Thai Program)  :  Industrial Engineering And Aviation Management | วิศวกรรมอุตสาหการและการจัดการการบิน | 工业工程和航空管理"
    },
    {
        "id":9423,
        "name":"9931 (English Program)  :  Industrial Engineering And Aviation Management | วิศวกรรมอุตสาหการและการจัดการการบิน | 工业工程和航空管理"
    },
    {
        "id":9424,
        "name":"9932 (Thai Program)  :  Military And Aerospace Materials Science | วัสดุศาสตร์ทางการทหารและอากาศยาน | 军事与航天材料科学"
    },
    {
        "id":9425,
        "name":"9933 (English Program)  :  Military And Aerospace Materials | วัสดุทางทหารและการบินและอวกาศ | 军工航天材料"
    },
    {
        "id":9426,
        "name":"9934 (Thai Program)  :  Energy Technology For Sustainability | เทคโนโลยีพลังงานเพื่อความยั่งยืน | 能源技术促进可持续发展"
    },
    {
        "id":9427,
        "name":"9935 (English Program)  :  Energy Technology For Sustainability | เทคโนโลยีพลังงานเพื่อความยั่งยืน | 能源技术促进可持续发展"
    },
    {
        "id":9428,
        "name":"9936 (Thai Program)  :  Innovative Food And Professional Chefs | นวัตกรรมอาหารและเชฟมืออาชีพ | 创新食品和专业厨师"
    },
    {
        "id":9429,
        "name":"9937 (English Program)  :  Food Innovation And Professional Chef | นวัตกรรมอาหารและเชฟมืออาชีพ | 食品创新与专业厨师"
    },
    {
        "id":9430,
        "name":"9938 (Thai Program)  :  Aerospace And Geoinformatics Engineering | วิศวกรรมอวกาศและภูมิสารสนเทศ | 航空航天与地理信息工程"
    },
    {
        "id":9431,
        "name":"9939 (English Program)  :  Space And Geospatial Engineering | วิศวกรรมอวกาศและภูมิสารสนเทศ | 空间与地理空间工程"
    },
    {
        "id":9432,
        "name":"9940 (Thai Program)  :  Culinary Arts | ศิลปะการประกอบอาหาร | 烹饪艺术"
    },
    {
        "id":9433,
        "name":"9941 (English Program)  :  Culinary Arts | ศิลปะการทำอาหาร | 烹饪艺术"
    },
    {
        "id":9434,
        "name":"9942 (Thai Program)  :  Business Management For Sustainability | การบริหารธุรกิจเพื่อความยั่งยืน | 可持续发展的企业管理"
    },
    {
        "id":9435,
        "name":"9943 (English Program)  :  Sustainable Business Management | การจัดการธุรกิจที่ยั่งยืน | 可持续经营管理"
    },
    {
        "id":9436,
        "name":"9944 (Thai Program)  :  Disaster Management And Relief | การจัดการและบรรเทาสาธารณภัย | 灾害管理和救援"
    },
    {
        "id":9437,
        "name":"9945 (English Program)  :  Disaster Management And Mitigation | การจัดการและการบรรเทาภัยพิบัติ | 灾害管理和减灾"
    },
    {
        "id":9438,
        "name":"9946 (English Program)  :  Chinese For Business Communication | ภาษาจีนเพื่อการสื่อสารทางธุรกิจ | 商务沟通汉语"
    },
    {
        "id":9439,
        "name":"9947 (Thai Program)  :  Electrical Engineering And Smart Grid Technology | วิศวกรรมไฟฟ้าและเทคโนโลยีโครงข่ายไฟฟ้าอัจฉริยะ | 电气工程与智能电网技术"
    },
    {
        "id":9440,
        "name":"9948 (English Program)  :  Electrical Engineering And Smart Grid Technology | วิศวกรรมไฟฟ้าและเทคโนโลยีสมาร์ทกริด | 电气工程和智能电网技术"
    },
    {
        "id":9441,
        "name":"9949 (Thai Program)  :  Artificial Intelligence Engineering And Digital Innovation | วิศวกรรมปัญญาประดิษฐ์และนวัตกรรมดิจิทัล | 人工智能工程与数字创新"
    },
    {
        "id":9442,
        "name":"9950 (English Program)  :  Artificial Intelligence Engineering And Digital Innovation | วิศวกรรมปัญญาประดิษฐ์และนวัตกรรมดิจิทัล | 人工智能工程与数字创新"
    },
    {
        "id":9443,
        "name":"9951 (Thai Program)  :  Electronic Engineering And Automation | วิศวกรรมอิเล็กทรอนิกส์และระบบอัตโนมัติ | 电子工程及其自动化"
    },
    {
        "id":9444,
        "name":"9952 (English Program)  :  Electronics And Automation Systems Engineering | วิศวกรรมอิเล็กทรอนิกส์และระบบอัตโนมัติ | 电子与自动化系统工程"
    },
    {
        "id":9445,
        "name":"9953 (Thai Program)  :  Teaching Mathematics, Science And Technology | การสอนคณิตศาสตร์ วิทยาศาสตร์ และเทคโนโลยี | 教授数学、科学和技术"
    },
    {
        "id":9446,
        "name":"9954 (English Program)  :  Teaching Mathematics Science And Technology | การสอนคณิตศาสตร์วิทยาศาสตร์และเทคโนโลยี | 数学科学与技术教学"
    },
    {
        "id":9447,
        "name":"9955 (English Program)  :  Early Childhood Education Dance Education And Art Education | การศึกษาปฐมวัย การศึกษาการเต้นรำ และการศึกษาศิลปะ | 幼儿教育 舞蹈教育和艺术教育"
    },
    {
        "id":9448,
        "name":"9956 (Thai Program)  :  Early Childhood Education Dance Education And Art Education | การศึกษาปฐมวัย นาฏศิลป์ศึกษา และศิลปศึกษา | 幼儿教育舞蹈教育与艺术教育"
    },
    {
        "id":9449,
        "name":"9957 (Thai Program)  :  Teaching Language And Social Studies | การสอนภาษาและสังคมศึกษา | 教授语言和社会研究"
    },
    {
        "id":9450,
        "name":"9958 (English Program)  :  Language Teaching And Social Studies | การสอนภาษาและสังคมศึกษา | 语言教学和社会研究"
    },
    {
        "id":9451,
        "name":"9959 (Thai Program)  :  Computers And Digital Technology For Education | คอมพิวเตอร์และเทคโนโลยีดิจิทัลเพื่อการศึกษา | 用于教育的计算机和数字技术"
    },
    {
        "id":9452,
        "name":"9960 (English Program)  :  Computer And Digital Technology For Education | คอมพิวเตอร์และเทคโนโลยีดิจิทัลเพื่อการศึกษา | 教育领域的计算机和数字技术"
    },
    {
        "id":9453,
        "name":"9961 (Thai Program)  :  English And Librarian Studies | ภาษาอังกฤษและบรรณารักษ์ศึกษา | 英语和图书馆员研究"
    },
    {
        "id":9454,
        "name":"9962 (English Program)  :  English And Library Studies | การศึกษาภาษาอังกฤษและห้องสมุด | 英语和图书馆研究"
    },
    {
        "id":9455,
        "name":"9963 (Thai Program)  :  Hotel Business Management And Travel Experience Design | การจัดการธุรกิจโรงแรม และการออกแบบประสบการณ์ท่องเที่ยว | 酒店经营管理及旅游体验设计"
    },
    {
        "id":9456,
        "name":"9964 (English Program)  :  Hotel Business Management And Tourist Experience Design | การจัดการธุรกิจโรงแรมและการออกแบบประสบการณ์การท่องเที่ยว | 酒店商务管理与旅游体验设计"
    },
    {
        "id":9457,
        "name":"9965 (Thai Program)  :  Industrial Studies - Electrical | อุตสาหกรรมศึกษา - ไฟฟ้า | 工业研究 - 电气"
    },
    {
        "id":9458,
        "name":"9966 (English Program)  :  Industrial Studies - Electrical | การศึกษาอุตสาหกรรม - ไฟฟ้า | 工业研究 - 电气"
    },
    {
        "id":9459,
        "name":"9967 (Thai Program)  :  Chemical Science | วิทยาศาสตร์เคมี | 化学科学"
    },
    {
        "id":9460,
        "name":"9968 (English Program)  :  Chemical Sciences | วิทยาศาสตร์เคมี | 化学科学"
    },
    {
        "id":9461,
        "name":"9969 (English Program)  :  Hotel And Event Management | การจัดการโรงแรมและกิจกรรม | 酒店和活动管理"
    },
    {
        "id":9462,
        "name":"9970 (Thai Program)  :  Data Science And Machine Learning | วิทยาการข้อมูลและการเรียนรู้ของเครื่อง | 数据科学和机器学习"
    },
    {
        "id":9463,
        "name":"9971 (English Program)  :  Data Science And Machine Learning | วิทยาศาสตร์ข้อมูลและการเรียนรู้ของเครื่อง | 数据科学和机器学习"
    },
    {
        "id":9464,
        "name":"9972 (Thai Program)  :  Innovation In Tourism And Service Management | นวัตกรรมการจัดการการท่องเที่ยวและการบริการ | 旅游与服务管理创新"
    },
    {
        "id":9465,
        "name":"9973 (English Program)  :  Tourism And Hospitality Innovation Management | การจัดการนวัตกรรมการท่องเที่ยวและการบริการ | 旅游和酒店创新管理"
    },
    {
        "id":9466,
        "name":"9974 (Thai Program)  :  Management Of Logistics Technology For Product Distribution | การจัดการเทคโนโลยีโลจิสติกส์เพื่อการกระจายสินค้า | 产品配送物流技术管理"
    },
    {
        "id":9467,
        "name":"9975 (English Program)  :  Technological Logistics For Distribution Management System | โลจิสติกเทคโนโลยีสำหรับระบบการจัดการการกระจายสินค้า | 配送管理系统的技术物流"
    },
    {
        "id":9468,
        "name":"9976 (Thai Program)  :  Innovative Architecture For Sustainability | สถาปัตยกรรมนวัตกรรมสร้างสรรค์เพื่อความยั่งยืน | 可持续发展的创新架构"
    },
    {
        "id":9469,
        "name":"9977 (English Program)  :  Creative Innovation Architecture For Sustainability | สถาปัตยกรรมนวัตกรรมที่สร้างสรรค์เพื่อความยั่งยืน | 可持续发展的创意创新架构"
    },
    {
        "id":9470,
        "name":"9978 (English Program)  :  Curriculum And Learning Management Innovation | นวัตกรรมการจัดการหลักสูตรและการเรียนรู้ | 课程和学习管理创新"
    },
    {
        "id":9471,
        "name":"9979 (English Program)  :  Housing And Real Estate Development | ที่อยู่อาศัยและการพัฒนาอสังหาริมทรัพย์ | 住房和房地产开发"
    },
    {
        "id":9472,
        "name":"9980 (Thai Program)  :  Housing And Real Estate Development | การพัฒนาที่อยู่อาศัยและอสังหาริมทรัพย์ | 住房和房地产开发"
    },
    {
        "id":9473,
        "name":"9981 (Thai Program)  :  Medical Cannabis And Medical Herbs | กัญชาเวชศาสตร์และสมุนไพรทางการแพทย์ | 医用大麻和药草"
    },
    {
        "id":9474,
        "name":"9982 (Thai Program)  :  Human Capital Management Innovation | นวัตกรรมการจัดการทุนมนุษย์ | 人力资本管理创新"
    },
    {
        "id":9475,
        "name":"9983 (Thai Program)  :  Public Health Technology Innovation | นวัตกรรมเทคโนโลยีสาธารณสุข | 公共卫生科技创新"
    },
    {
        "id":9476,
        "name":"9984 (English Program)  :  Public Health Technology Innovation | นวัตกรรมเทคโนโลยีสาธารณสุข | 公共卫生技术创新"
    },
    {
        "id":9477,
        "name":"9985 (Thai Program)  :  Sustainable Local Development Strategy | ยุทธศาสตร์การพัฒนาท้องถิ่นที่ยั่งยืน | 当地可持续发展战略"
    },
    {
        "id":9478,
        "name":"9986 (English Program)  :  Sustainable Local Development Strategy | ยุทธศาสตร์การพัฒนาท้องถิ่นอย่างยั่งยืน | 当地可持续发展战略"
    },
    {
        "id":9479,
        "name":"9987 (Thai Program)  :  Policy Administration And Public Law | การบริหารนโยบายและกฎหมายมหาชน | 政策管理和公法"
    },
    {
        "id":9480,
        "name":"9988 (English Program)  :  Policy Management And Public Law | การจัดการนโยบายและกฎหมายมหาชน | 政策管理和公法"
    },
    {
        "id":9481,
        "name":"9989 (Thai Program)  :  Modern Sports Business Management | การจัดการธุรกิจการกีฬาสมัยใหม่ | 现代体育企业管理"
    },
    {
        "id":9482,
        "name":"9990 (English Program)  :  Modern Sports Business Management | การจัดการธุรกิจกีฬาสมัยใหม่ | 现代体育商业管理"
    },
    {
        "id":9483,
        "name":"9991 (Thai Program)  :  Human Potential Development | การพัฒนาศักยภาพมนุษย์ | 人类潜能开发"
    },
    {
        "id":9484,
        "name":"9992 (English Program)  :  Human Potential Development | การพัฒนาศักยภาพของมนุษย์ | 人类潜能开发"
    },
    {
        "id":9485,
        "name":"9993 (Thai Program)  :  Industrial Pharmaceutical | เภสัชกรรมอุตสาหการ | 工业制药"
    },
    {
        "id":9486,
        "name":"9994 (Thai Program)  :  Curriculum And Learning Innovations | หลักสูตรและนวัตกรรมการเรียนรู้ | 课程和学习创新"
    },
    {
        "id":9487,
        "name":"9995 (Thai Program)  :  Bioclinical Sciences | วิทยาศาสตร์ชีวคลินิก | 生物临床科学"
    },
    {
        "id":9488,
        "name":"9996 (English Program)  :  Bioclinical Science | วิทยาศาสตร์ชีวภาพ | 生物临床科学"
    },
    {
        "id":9489,
        "name":"9997 (Thai Program)  :  Interdisciplinary Creative Architecture | สหวิทยาการสถาปัตยกรรมสร้างสรรค์ | 跨学科创意建筑"
    },
    {
        "id":9490,
        "name":"9998 (English Program)  :  Interdiscliplinary Creative Architecture | สถาปัตยกรรมสร้างสรรค์แบบสหวิทยาการ | 跨学科创意建筑"
    },
    {
        "id":9491,
        "name":"9999 (English Program)  :  Contemporary Chinese Language Teaching | การสอนภาษาจีนร่วมสมัย | 当代汉语教学"
    },
    {
        "id":9492,
        "name":"10000 (Thai Program)  :  Vehicle And Rail Infrastructure Engineering | วิศวกรรมยานพาหนะและโครงสร้างพื้นฐานระบบราง | 车辆和轨道基础设施工程"
    },
    {
        "id":9493,
        "name":"10001 (English Program)  :  Railway Vehicles And Infrastructure Engineering | ยานพาหนะรถไฟและวิศวกรรมโครงสร้างพื้นฐาน | 铁路车辆及基础设施工程"
    },
    {
        "id":9494,
        "name":"10002 (English Program)  :  Health Professions Education | การศึกษาวิชาชีพด้านสุขภาพ | 卫生专业教育"
    },
    {
        "id":9495,
        "name":"10003 (Thai Program)  :  Applied Sports Science And Technology | วิทยาศาสตร์และเทคโนโลยีการกีฬาประยุกต์ | 应用体育科学与技术"
    },
    {
        "id":9496,
        "name":"10004 (English Program)  :  Applied Sports Science And Technology | วิทยาศาสตร์และเทคโนโลยีการกีฬาประยุกต์ | 应用体育科学与技术"
    },
    {
        "id":9497,
        "name":"10005 (Thai Program)  :  Dhammaduta | พระธรรมทูต | 法义"
    },
    {
        "id":9498,
        "name":"10006 (Thai Program)  :  Applied Economics For Agriculture And The Environment | เศรษฐศาสตร์ประยุกต์สำหรับการเกษตรและสิ่งแวดล้อม | 农业与环境应用经济学"
    },
    {
        "id":9499,
        "name":"10007 (English Program)  :  Applied Economics For Agriculture And Environment | เศรษฐศาสตร์ประยุกต์เพื่อการเกษตรและสิ่งแวดล้อม | 农业与环境应用经济学"
    },
    {
        "id":9500,
        "name":"10008 (English Program)  :  Data And Analytics | ข้อมูลและการวิเคราะห์ | 数据与分析"
    },
    {
        "id":9501,
        "name":"10009 (Thai Program)  :  Data And Analysis | ข้อมูลและการวิเคราะห์ | 数据与分析"
    },
    {
        "id":9502,
        "name":"10010 (Thai Program)  :  Digital Marketing And Branding | การตลาดดิจิทัลและการสร้างตรา | 数字营销和品牌"
    },
    {
        "id":9503,
        "name":"10011 (English Program)  :  Digital Marketing And Branding | การตลาดดิจิทัลและการสร้างแบรนด์ | 数字营销和品牌"
    },
    {
        "id":9504,
        "name":"10012 (Thai Program)  :  Industrial Animal Science | สัตวศาสตร์อุตสาหกรรม | 工业动物科学"
    },
    {
        "id":9505,
        "name":"10013 (English Program)  :  Industrial Animal Science | วิทยาศาสตร์สัตว์อุตสาหกรรม | 工业动物科学"
    },
    {
        "id":9506,
        "name":"10014 (Thai Program)  :  Fisheries Science And Technology | วิทยาศาสตร์การประมงและเทคโนโลยี | 水产科技"
    },
    {
        "id":9507,
        "name":"10015 (English Program)  :  Fishery Science And Technology | วิทยาศาสตร์และเทคโนโลยีการประมง | 渔业科技"
    },
    {
        "id":9508,
        "name":"10016 (Thai Program)  :  Biological Sciences And Technology | วิทยาศาสตร์ชีวภาพและเทคโนโลยี | 生物科学与技术"
    },
    {
        "id":9509,
        "name":"10017 (English Program)  :  Bioscience And Technology | ชีววิทยาศาสตร์และเทคโนโลยี | 生物科学与技术"
    },
    {
        "id":9510,
        "name":"10018 (Thai Program)  :  Develop Products And Innovations | พัฒนาผลิตภัณฑ์และนวัตกรรม | 开发产品和创新"
    },
    {
        "id":9511,
        "name":"10019 (English Program)  :  Product Development And Innovation | การพัฒนาผลิตภัณฑ์และนวัตกรรม | 产品开发与创新"
    },
    {
        "id":9512,
        "name":"10020 (Thai Program)  :  Sociology And Applied Anthropology | สังคมวิทยาและมานุษยวิทยาประยุกต์ | 社会学和应用人类学"
    },
    {
        "id":9513,
        "name":"10021 (English Program)  :  Applied Sociology And Anthropology | สังคมวิทยาและมานุษยวิทยาประยุกต์ | 应用社会学和人类学"
    },
    {
        "id":9514,
        "name":"10022 (Thai Program)  :  Creative Development | การพัฒนาเชิงสร้างสรรค์ | 创意发展"
    },
    {
        "id":9515,
        "name":"10023 (English Program)  :  Creative Development | การพัฒนาความคิดสร้างสรรค์ | 创意发展"
    },
    {
        "id":9516,
        "name":"10024 (Thai Program)  :  Contemporary Development And Development Practice | การพัฒนาร่วมสมัยและปฏิบัติการพัฒนา | 当代发展与发展实践"
    },
    {
        "id":9517,
        "name":"10025 (English Program)  :  Development And Development Practice | การพัฒนาและการปฏิบัติในการพัฒนา | 发展与发展实践"
    },
    {
        "id":9518,
        "name":"10026 (Thai Program)  :  Modern Retail Business Management | การจัดการธุรกิจค้าปลีกสมัยใหม่ | 现代零售企业管理"
    },
    {
        "id":9519,
        "name":"10027 (English Program)  :  Modern Retail Business Management | การจัดการธุรกิจค้าปลีกสมัยใหม่ | 现代零售商业管理"
    },
    {
        "id":9520,
        "name":"10028 (Thai Program)  :  Curriculum And Teaching Innovations | หลักสูตรและนวัตกรรมการเรียนการสอน | 课程与教学创新"
    },
    {
        "id":9521,
        "name":"10029 (English Program)  :  Curriculum And Instruction Innovations | นวัตกรรมหลักสูตรและการเรียนการสอน | 课程和教学创新"
    },
    {
        "id":9522,
        "name":"10030 (English Program)  :  Digital Business And Innovation | ธุรกิจดิจิทัลและนวัตกรรม | 数字商业与创新"
    },
    {
        "id":9523,
        "name":"10031 (English Program)  :  Buddhist Intellectual Science Research In Education | การวิจัยวิทยาศาสตร์ทางปัญญาเชิงพุทธในด้านการศึกษา | 佛教智理科学研究教育"
    },
    {
        "id":9524,
        "name":"10032 (Thai Program)  :  Fine Arts And Design | วิจิตรศิลป์และการออกแบบ | 美术与设计"
    },
    {
        "id":9525,
        "name":"10033 (Thai Program)  :  Occupational Health And Toxicology | อาชีวอนามัยและพิษวิทยา | 职业健康与毒理学"
    },
    {
        "id":9526,
        "name":"10034 (English Program)  :  Occupational Health And Toxicology | อาชีวอนามัยและพิษวิทยา | 职业健康和毒理学"
    },
    {
        "id":9527,
        "name":"10035 (Thai Program)  :  Medical Bioinformatics | ชีวสารสนเทศทางการแพทย์ | 医学生物信息学"
    },
    {
        "id":9528,
        "name":"10036 (English Program)  :  Medical Bioinformatics | ชีวสารสนเทศศาสตร์ทางการแพทย์ | 医学生物信息学"
    },
    {
        "id":9529,
        "name":"10037 (Thai Program)  :  Clinical Veterinary Science | วิทยาศาสตร์ทางการสัตวแพทย์คลินิก | 临床兽医学"
    },
    {
        "id":9530,
        "name":"10038 (English Program)  :  Clinical Veterinary Science | คลินิกสัตวแพทยศาสตร์ | 临床兽医科学"
    },
    {
        "id":9531,
        "name":"10039 (English Program)  :  Bioinnovation | นวัตกรรมชีวภาพ | 生物创新"
    },
    {
        "id":9532,
        "name":"10040 (Thai Program)  :  Nursing Practice For The Elderly | การพยาบาลเวชปฏิบัติผู้สูงอายุ | 老年人护理实践"
    },
    {
        "id":9533,
        "name":"10041 (English Program)  :  Gerontological Nurse Practitioner | ผู้ประกอบวิชาชีพพยาบาลผู้สูงอายุ | 老年科执业护士"
    },
    {
        "id":9534,
        "name":"10042 (English Program)  :  Medical And Public Health Social Sciences | สังคมศาสตร์การแพทย์และสาธารณสุข | 医学和公共卫生社会科学"
    },
    {
        "id":9535,
        "name":"10043 (Thai Program)  :  Food Science For Nutrition | วิทยาศาสตร์การอาหารเพื่อโภชนาการ | 营养食品科学"
    },
    {
        "id":9536,
        "name":"10044 (English Program)  :  Food Science For Nutrition | วิทยาศาสตร์การอาหารเพื่อโภชนาการ | 营养食品科学"
    },
    {
        "id":9537,
        "name":"10045 (Thai Program)  :  Sustainability Of Food Resources And Ecosystems | ความยั่งยืนทางทรัพยากรอาหารและระบบนิเวศ | 粮食资源和生态系统的可持续性"
    },
    {
        "id":9538,
        "name":"10046 (Thai Program)  :  Engineering And Business Management | การจัดการวิศวกรรมและธุรกิจ | 工程和商业管理"
    },
    {
        "id":9539,
        "name":"10047 (Thai Program)  :  Regulatory Science Of Pharmaceuticals And Health Products | วิทยาการกำกับดูแลเภสัชภัณฑ์และผลิตภัณฑ์สุขภาพ | 药品和保健品监管科学"
    },
    {
        "id":9540,
        "name":"10048 (Thai Program)  :  Medical Information Innovation | นวัตกรรมสารสนเทศทางการแพทย์ | 医疗信息化创新"
    },
    {
        "id":9541,
        "name":"10049 (Thai Program)  :  Cellular And Molecular Science For Biomedical Applications | วิทยาศาสตร์ระดับเซลล์และโมเลกุลสำหรับประยุกต์ทางชีวการแพทย์ | 生物医学应用的细胞和分子科学"
    },
    {
        "id":9542,
        "name":"10050 (Thai Program)  :  Innovation For Child Development And Protection | นวัตกรรมเพื่อการพัฒนาและคุ้มครองเด็ก | 儿童发展和保护的创新"
    },
    {
        "id":9543,
        "name":"10051 (Thai Program)  :  Integrating Science And Innovation | บูรณาการด้านวิทยาศาสตร์และนวัตกรรม | 融合科学与创新"
    },
    {
        "id":9544,
        "name":"10052 (Thai Program)  :  Medical Technology And Technical Management | เทคโนโลยีและการจัดการทางเทคนิคการแพทย์ | 医疗技术与技术管理"
    },
    {
        "id":9545,
        "name":"10053 (English Program)  :  Foreign Languages | ภาษาต่างประเทศ | 外语"
    },
    {
        "id":9546,
        "name":"10054 (English Program)  :  Computing | คอมพิวเตอร์ | 电脑"
    },
    {
        "id":9547,
        "name":"10055 (Thai Program)  :  Sports, Physical Education And Recreation | กีฬา พลศึกษา และนันทนาการ | 运动、体育教育和娱乐"
    },
    {
        "id":9548,
        "name":"10056 (English Program)  :  Sports, Physical Education And Recreation | กีฬา พลศึกษา และสันทนาการ | 运动、体育和娱乐"
    },
    {
        "id":9549,
        "name":"10057 (Thai Program)  :  Psychiatric Social Work | สังคมสงเคราะห์จิตเวช | 精神科社会工作"
    },
    {
        "id":9550,
        "name":"10058 (English Program)  :  Psychiatric Social Work | งานสังคมสงเคราะห์จิตเวช | 精神科社会工作"
    },
    {
        "id":9551,
        "name":"10059 (English Program)  :  Technology And Innovation In Education | เทคโนโลยีและนวัตกรรมทางการศึกษา | 教育科技与创新"
    },
    {
        "id":9552,
        "name":"10060 (English Program)  :  Information Management For Public And Private Sectors | การจัดการข้อมูลสำหรับภาครัฐและเอกชน | 公共和私营部门的信息管理"
    },
    {
        "id":9553,
        "name":"10061 (Thai Program)  :  Public And Private Information Management | การจัดการสารสนเทศภาครัฐและเอกชน | 公共和私人信息管理"
    },
    {
        "id":9554,
        "name":"10062 (Thai Program)  :  Modern Business Entrepreneurship | การเป็นผู้ประกอบการธุรกิจสมัยใหม่ | 现代商业创业"
    },
    {
        "id":9555,
        "name":"10063 (English Program)  :  Modern Entrepreneurship | ผู้ประกอบการสมัยใหม่ | 现代创业"
    },
    {
        "id":9556,
        "name":"10064 (Thai Program)  :  English And Librarianship | ภาษาอังกฤษและบรรณารักษศาสตร์ | 英语和图书馆学"
    },
    {
        "id":9557,
        "name":"10065 (English Program)  :  English And Library Science | ภาษาอังกฤษและวิทยาศาสตร์ห้องสมุด | 英语和图书馆学"
    },
    {
        "id":9558,
        "name":"10066 (Thai Program)  :  Chemical And Technological Innovation | นวัตกรรมเคมีและเทคโนโลยี | 化学与技术创新"
    },
    {
        "id":9559,
        "name":"10067 (English Program)  :  Chemical Innovation And Technology | นวัตกรรมและเทคโนโลยีทางเคมี | 化学创新与技术"
    },
    {
        "id":9560,
        "name":"10068 (Thai Program)  :  Mechanical Engineering And Production Systems | วิศวกรรมเครื่องกลและระบบผลิต | 机械工程和生产系统"
    },
    {
        "id":9561,
        "name":"10069 (Thai Program)  :  Innovative Agricultural Technology | เทคโนโลยีเกษตรนวัต | 创新农业技术"
    },
    {
        "id":9562,
        "name":"10070 (English Program)  :  Innovative Agricultural Technology | นวัตกรรมเทคโนโลยีการเกษตร | 创新农业技术"
    },
    {
        "id":9563,
        "name":"10071 (Thai Program)  :  Halal Food Management | การจัดการอาหารฮาลาล | 清真食品管理"
    },
    {
        "id":9564,
        "name":"10072 (English Program)  :  Halal Food Management | การจัดการอาหารฮาลาล | 清真食品管理"
    },
    {
        "id":9565,
        "name":"10073 (Thai Program)  :  Hotel And Tourism Business Management | การจัดการธุรกิจการโรงแรมและการท่องเที่ยว | 酒店及旅游企业管理"
    },
    {
        "id":9566,
        "name":"10074 (English Program)  :  Hotels And Tourism Business Management | การจัดการโรงแรมและธุรกิจการท่องเที่ยว | 酒店和旅游业务管理"
    },
    {
        "id":9567,
        "name":"10075 (Thai Program)  :  Electronic Engineering And Robotics | วิศวกรรมอิเล็กทรอนิกส์และหุ่นยนต์ | 电子工程与机器人"
    },
    {
        "id":9568,
        "name":"10076 (English Program)  :  Electronic Engineering And Robotics | วิศวกรรมอิเล็กทรอนิกส์และหุ่นยนต์ | 电子工程和机器人"
    },
    {
        "id":9569,
        "name":"10077 (Thai Program)  :  Tourism And Service Business | ธุรกิจการท่องเที่ยวและบริการ | 旅游及服务业"
    },
    {
        "id":9570,
        "name":"10078 (Thai Program)  :  Data And Computer Science | วิทยาการข้อมูลและคอมพิวเตอร์ | 数据与计算机科学"
    },
    {
        "id":9571,
        "name":"10079 (English Program)  :  Computer And Data Science | คอมพิวเตอร์และวิทยาศาสตร์ข้อมูล | 计算机和数据科学"
    },
    {
        "id":9572,
        "name":"10080 (Thai Program)  :  Industrial And Chemical Process Engineering | วิศวกรรมอุตสาหการและกระบวนการเคมี | 工业与化学过程工程"
    },
    {
        "id":9573,
        "name":"10081 (English Program)  :  Industrial And Chemical Process Engineering | วิศวกรรมกระบวนการอุตสาหกรรมและเคมี | 工业和化学过程工程"
    },
    {
        "id":9574,
        "name":"10082 (Thai Program)  :  Mining And Petroleum Engineering | วิศวกรรมเหมืองแร่และปิโตรเลียม | 采矿与石油工程"
    },
    {
        "id":9575,
        "name":"10083 (English Program)  :  Mining And Petroleum Engineering | วิศวกรรมเหมืองแร่และปิโตรเลียม | 采矿和石油工程"
    },
    {
        "id":9576,
        "name":"10084 (Thai Program)  :  Librarianship And Knowledge Management | บรรณารักษศาสตร์และการจัดการความรู้ | 图书馆学和知识管理"
    },
    {
        "id":9577,
        "name":"10085 (English Program)  :  Library Science And Knowledge Management | ห้องสมุดวิทยาศาสตร์และการจัดการความรู้ | 图书馆科学与知识管理"
    },
    {
        "id":9578,
        "name":"10086 (Thai Program)  :  Aircraft Parts Production Technology | เทคโนโลยีการผลิตชิ้นส่วนอากาศยาน | 飞机零部件生产技术"
    },
    {
        "id":9579,
        "name":"10087 (English Program)  :  Aircraft Part Manufacturing Technology | เทคโนโลยีการผลิตชิ้นส่วนเครื่องบิน | 飞机零部件制造技术"
    },
    {
        "id":9580,
        "name":"10088 (Thai Program)  :  Production Engineering And Quality Management | วิศวกรรมการผลิตและการจัดการคุณภาพ | 生产工程和质量管理"
    },
    {
        "id":9581,
        "name":"10089 (English Program)  :  Production Engineering And Quality Management | วิศวกรรมการผลิตและการจัดการคุณภาพ | 生产工程和质量管理"
    },
    {
        "id":9582,
        "name":"10090 (English Program)  :  Management And Logistics Engineering | วิศวกรรมการจัดการและโลจิสติกส์ | 管理与物流工程"
    },
    {
        "id":9583,
        "name":"10091 (Thai Program)  :  Border Trade And Logistics Management | การจัดการการค้าชายแดนและโลจิสติกส์ | 边境贸易与物流管理"
    },
    {
        "id":9584,
        "name":"10092 (English Program)  :  Cross-Border Trade And Logistics Management | การค้าข้ามพรมแดนและการจัดการโลจิสติกส์ | 跨境贸易及物流管理"
    },
    {
        "id":9585,
        "name":"10093 (Thai Program)  :  Tourism And Cruise Management | การจัดการการท่องเที่ยวและเรือสำราญ | 旅游和邮轮管理"
    },
    {
        "id":9586,
        "name":"10094 (English Program)  :  Tourism And Cruise Management | การจัดการการท่องเที่ยวและการล่องเรือ | 旅游和邮轮管理"
    },
    {
        "id":9587,
        "name":"10095 (Thai Program)  :  Business Management And Logistics Industry | การจัดการธุรกิจและอุตสาหกรรมโลจิสติกส์ | 商业管理及物流行业"
    },
    {
        "id":9588,
        "name":"10096 (English Program)  :  Business And Industrial Logistics Management | การจัดการธุรกิจและโลจิสติกส์อุตสาหกรรม | 商业和工业物流管理"
    },
    {
        "id":9589,
        "name":"10097 (English Program)  :  Modern Business Entrepreneurship | การเป็นผู้ประกอบการธุรกิจสมัยใหม่ | 现代企业创业"
    },
    {
        "id":9590,
        "name":"10098 (Thai Program)  :  Global Business And Digital Communications | ธุรกิจระดับโลกและการสื่อสารดิจิทัล | 全球商业和数字通信"
    },
    {
        "id":9591,
        "name":"10099 (English Program)  :  Global Business And Digital Communications | ธุรกิจระดับโลกและการสื่อสารดิจิทัล | 全球商业和数字通信"
    },
    {
        "id":9592,
        "name":"10100 (Thai Program)  :  Global Business And Entrepreneurship In The Digital Age | ธุรกิจระดับโลกและความเป็นผู้ประกอบการในยุคดิจิทัล | 数字时代的全球商业和创业精神"
    },
    {
        "id":9593,
        "name":"10101 (English Program)  :  Global Business And Digital Age Entrepreneurship | ธุรกิจระดับโลกและผู้ประกอบการยุคดิจิทัล | 全球商业和数字时代创业"
    },
    {
        "id":9594,
        "name":"10102 (Thai Program)  :  Communication And New Media | การสื่อสารและสื่อใหม่ | 传播与新媒体"
    },
    {
        "id":9595,
        "name":"10103 (English Program)  :  Communications And New Media | การสื่อสารและสื่อใหม่ | 传播与新媒体"
    },
    {
        "id":9596,
        "name":"10104 (Thai Program)  :  Public Relations, Advertising, Journalism And Creative Branding. | การประชาสัมพันธ์ การโฆษณา วารสารศาสตร์ และการสร้างตราสร้างสรรค์ | 公共关系、广告、新闻和创意品牌。"
    },
    {
        "id":9597,
        "name":"10105 (English Program)  :  Public Relations, Advertising, Journalism And Creative Branding | การประชาสัมพันธ์ การโฆษณา การทำข่าว และการสร้างแบรนด์เชิงสร้างสรรค์ | 公共关系、广告、新闻和创意品牌"
    },
    {
        "id":9598,
        "name":"10106 (Thai Program)  :  Western Music Studies | ดนตรีตะวันตกศึกษา | 西方音乐研究"
    },
    {
        "id":9599,
        "name":"10107 (English Program)  :  Western Music Education | การศึกษาดนตรีตะวันตก | 西方音乐教育"
    },
    {
        "id":9600,
        "name":"10108 (Thai Program)  :  Thai Music Studies | ดนตรีไทยศึกษา | 泰国音乐研究"
    },
    {
        "id":9601,
        "name":"10109 (English Program)  :  Thai Music Education | การศึกษาดนตรีไทย | 泰国音乐教育"
    },
    {
        "id":9602,
        "name":"10110 (English Program)  :  Event Production And Mice Management | การผลิตงานอีเว้นท์และการจัดการหนู | 活动制作和会展管理"
    },
    {
        "id":9603,
        "name":"10111 (Thai Program)  :  Event Production And Organizing Exhibitions And Conferences. | การผลิตอีเว้นท์ และการจัดการนิทรรศการและการประชุม | 活动制作以及组织展览和会议。"
    },
    {
        "id":9604,
        "name":"10112 (Thai Program)  :  Innovative Media Production | การผลิตสื่อนวัตกรรม | 创新媒体制作"
    },
    {
        "id":9605,
        "name":"10113 (English Program)  :  Innovative Media Production | นวัตกรรมการผลิตสื่อ | 创新媒体制作"
    },
    {
        "id":9606,
        "name":"10114 (Thai Program)  :  Universal Communication | การสื่อสารสากล | 通用通讯"
    },
    {
        "id":9607,
        "name":"10115 (English Program)  :  Global Communication | การสื่อสารระดับโลก | 全球传播"
    },
    {
        "id":9608,
        "name":"10116 (Thai Program)  :  Multimedia And Entertainment Engineering | วิศวกรรมมัลติมีเดียและเอ็นเตอร์เทนเมนต์ | 多媒体与娱乐工程"
    },
    {
        "id":9609,
        "name":"10117 (English Program)  :  Multimedia And Entertainment Engineering | วิศวกรรมมัลติมีเดียและความบันเทิง | 多媒体和娱乐工程"
    },
    {
        "id":9610,
        "name":"10118 (English Program)  :  Digital Marketing Communications | การสื่อสารการตลาดดิจิทัล | 数字营销传播"
    },
    {
        "id":9611,
        "name":"10119 (Thai Program)  :  Digital Marketing Communications | การสื่อสารการตลาดดิจิทัล | 数字营销传播"
    },
    {
        "id":9612,
        "name":"10120 (Thai Program)  :  Financial Planning And Investment | การวางแผนการเงินและการลงทุน | 财务规划和投资"
    },
    {
        "id":9613,
        "name":"10121 (English Program)  :  Financial And Investment Planning | การวางแผนทางการเงินและการลงทุน | 财务和投资规划"
    },
    {
        "id":9614,
        "name":"10122 (Thai Program)  :  Games And Interactive Media | เกมและสื่อเชิงโต้ตอบ | 游戏和互动媒体"
    },
    {
        "id":9615,
        "name":"10123 (English Program)  :  Games And Interactive Media | เกมและสื่อโต้ตอบ | 游戏和互动媒体"
    },
    {
        "id":9616,
        "name":"10124 (Thai Program)  :  International Tourism And Hospitality Management | การจัดการท่องเที่ยวและการบริการนานาชาติ | 国际旅游和酒店管理"
    },
    {
        "id":9617,
        "name":"10125 (English Program)  :  Business Innovation | นวัตกรรมทางธุรกิจ | 商业创新"
    },
    {
        "id":9618,
        "name":"10126 (Thai Program)  :  Radio Broadcasting Radio, Television And Streaming Media Production | วิทยุกระจายเสียง วิทยุโทรทัศน์ และ การผลิตสื่อสตรีมมิ่ง | 无线电广播广播、电视及流媒体制作"
    },
    {
        "id":9619,
        "name":"10127 (English Program)  :  Broadcasting And Streaming Media Production | การผลิตสื่อกระจายเสียงและสตรีมมิ่ง | 广播和流媒体制作"
    },
    {
        "id":9620,
        "name":"10128 (English Program)  :  Knowledge Management And Innovation Management | การจัดการความรู้และการจัดการนวัตกรรม | 知识管理和创新管理"
    },
    {
        "id":9621,
        "name":"10129 (Thai Program)  :  Computer Engineering And Robotics | วิศวกรรมคอมพิวเตอร์และหุ่นยนต์ | 计算机工程和机器人技术"
    },
    {
        "id":9622,
        "name":"10130 (English Program)  :  Computer And Robotics Engineering | วิศวกรรมคอมพิวเตอร์และหุ่นยนต์ | 计算机和机器人工程"
    },
    {
        "id":9623,
        "name":"10131 (Thai Program)  :  Pali-Sanskrit Language And Buddhist Studies | ภาษาบาลี-สันสกฤต และพุทธศาสน์ศึกษา | 巴利梵语和佛学研究"
    },
    {
        "id":9624,
        "name":"10132 (English Program)  :  Pali-Sanskrit And Buddhist Studies | การศึกษาภาษาบาลี-สันสกฤตและพุทธศาสนา | 巴利梵语和佛教研究"
    },
    {
        "id":9625,
        "name":"10133 (English Program)  :  Hazardous Substance And Environmental Management | การจัดการสารอันตรายและสิ่งแวดล้อม | 有害物质和环境管理"
    },
    {
        "id":9626,
        "name":"10134 (Thai Program)  :  Hazardous Substance And Environmental Management | การจัดการสารอันตรายและสิ่งแวดล้อม | 有害物质与环境管理"
    },
    {
        "id":9627,
        "name":"10135 (English Program)  :  Occlusion And Orofacial Pain | การบดเคี้ยวและความเจ็บปวดจากช่องปาก | 闭塞和口面部疼痛"
    },
    {
        "id":9628,
        "name":"10136 (Thai Program)  :  Dental Chewing And Oral And Facial Pain | ทันตกรรมบดเคี้ยวและความเจ็บปวดช่องปากและใบหน้า | 牙齿咀嚼和口腔和面部疼痛"
    },
    {
        "id":9629,
        "name":"10137 (Thai Program)  :  Applied Mathematics And Computational Science | คณิตศาสตร์ประยุกต์และวิทยาการคณนา | 应用数学与计算科学"
    },
    {
        "id":9630,
        "name":"10138 (Thai Program)  :  Japanese Culture And Literature | วัฒนธรรมและวรรณคดีญี่ปุ่น | 日本文化和文学"
    },
    {
        "id":9631,
        "name":"10139 (English Program)  :  Japanese Culture And Literature | วัฒนธรรมและวรรณคดีญี่ปุ่น | 日本文化和文学"
    },
    {
        "id":9632,
        "name":"10140 (Thai Program)  :  Clinical Medicine | เวชศาสตร์คลินิก | 临床医学"
    },
    {
        "id":9633,
        "name":"10141 (Thai Program)  :  Applied Animal Science | สัตวศาสตร์ประยุกต์ | 应用动物科学"
    },
    {
        "id":9634,
        "name":"10142 (English Program)  :  Applied Animal Science | วิทยาศาสตร์สัตว์ประยุกต์ | 应用动物科学"
    },
    {
        "id":9635,
        "name":"10143 (Thai Program)  :  Veterinary Science And Technology | วิทยาศาสตร์ทางการสัตวแพทย์และเทคโนโลยี | 兽医科学与技术"
    },
    {
        "id":9636,
        "name":"10144 (English Program)  :  Veterinary Science And Technology | วิทยาศาสตร์และเทคโนโลยีสัตวแพทยศาสตร์ | 兽医科技"
    },
    {
        "id":9637,
        "name":"10145 (Thai Program)  :  Nuclear And Radiological Engineering | วิศวกรรมนิวเคลียร์และรังสี | 核与放射工程"
    },
    {
        "id":9638,
        "name":"10146 (English Program)  :  Nuclear And Radiological Engineering | วิศวกรรมนิวเคลียร์และรังสีวิทยา | 核与放射工程"
    },
    {
        "id":9639,
        "name":"10147 (Thai Program)  :  Geriatric Dentistry And Special Patient Care | ทันตกรรมผู้สูงอายุและการดูแลผู้ป่วยพิเศษ | 老年牙科和特殊患者护理"
    },
    {
        "id":9640,
        "name":"10148 (English Program)  :  Geriatric Dentistry And Special Patients Care | ทันตกรรมผู้สูงอายุและการดูแลผู้ป่วยพิเศษ | 老年牙科和特殊患者护理"
    },
    {
        "id":9641,
        "name":"10149 (Thai Program)  :  Strategic Communication Management | การจัดการการสื่อสารเชิงกลยุทธ์ | 战略沟通管理"
    },
    {
        "id":9642,
        "name":"10150 (English Program)  :  Strategic Communication Management | การจัดการการสื่อสารเชิงกลยุทธ์ | 战略传播管理"
    },
    {
        "id":9643,
        "name":"10151 (Thai Program)  :  Soil And Environmental Sciences | ปฐพีศาสตร์และสิ่งแวดล้อม | 土壤与环境科学"
    },
    {
        "id":9644,
        "name":"10152 (English Program)  :  Soil Science And Environment | วิทยาศาสตร์ดินและสิ่งแวดล้อม | 土壤科学与环境"
    },
    {
        "id":9645,
        "name":"10153 (Thai Program)  :  Teaching English To People Who Have A Background In Languages ​​Other Than English | การสอนภาษาอังกฤษให้ผู้มีพื้นฐานภาษาอื่นนอกจากภาษาอังกฤษ | 向具有英语以外语言背景的人教授英语"
    },
    {
        "id":9646,
        "name":"10154 (Thai Program)  :  Medical Biochemistry And Molecular Biology | ชีวเคมีทางการแพทย์และชีววิทยาโมเลกุล | 医学生物化学与分子生物学"
    },
    {
        "id":9647,
        "name":"10155 (English Program)  :  Medical Biochemistry And Molecular Biology | ชีวเคมีการแพทย์และอณูชีววิทยา | 医学生物化学和分子生物学"
    },
    {
        "id":9648,
        "name":"10156 (Thai Program)  :  Educational Psychology And Counseling | จิตวิทยาการศึกษาและการให้คำปรึกษา | 教育心理学与咨询"
    },
    {
        "id":9649,
        "name":"10157 (English Program)  :  Educational Psychology And Counseling | จิตวิทยาการศึกษาและการให้คำปรึกษา | 教育心理学与咨询"
    },
    {
        "id":9650,
        "name":"10158 (Thai Program)  :  Statistical Information | สารสนเทศสถิติ | 统计信息"
    },
    {
        "id":9651,
        "name":"10159 (English Program)  :  Statistical Information | ข้อมูลทางสถิติ | 统计信息"
    },
    {
        "id":9652,
        "name":"10160 (Thai Program)  :  Environmental Health Occupational Health And Safety | อนามัยสิ่งแวดล้อม อาชีวอนามัยและความปลอดภัย | 环境健康职业健康与安全"
    },
    {
        "id":9653,
        "name":"10161 (English Program)  :  Environmental Health, Occupational Health And Safety | อนามัยสิ่งแวดล้อม อาชีวอนามัย และความปลอดภัย | 环境健康、职业健康与安全"
    },
    {
        "id":9654,
        "name":"10162 (Thai Program)  :  Health Nutrition | โภชนศาสตร์เพื่อสุขภาพ | 健康营养"
    },
    {
        "id":9655,
        "name":"10163 (English Program)  :  Nutrition For Health | โภชนาการเพื่อสุขภาพ | 营养促进健康"
    },
    {
        "id":9656,
        "name":"10164 (English Program)  :  Anatomical Pathology | พยาธิวิทยาทางกายวิภาค | 解剖病理学"
    },
    {
        "id":9657,
        "name":"10165 (Thai Program)  :  Mekong River Basin Studies | ลุ่มน้ำโขงศึกษา | 湄公河流域研究"
    },
    {
        "id":9658,
        "name":"10166 (English Program)  :  Mekong Studies | แม่โขงศึกษา | 湄公河研究"
    },
    {
        "id":9659,
        "name":"10167 (Thai Program)  :  Cultural Research Fine Arts And Design | วิจัยวัฒนธรรม ศิลปกรรมและการออกแบบ | 文化研究美术与设计"
    },
    {
        "id":9660,
        "name":"10168 (English Program)  :  Culture, Fine Arts And Design Research | การวิจัยวัฒนธรรม วิจิตรศิลป์ และการออกแบบ | 文化、美术与设计研究"
    },
    {
        "id":9661,
        "name":"10169 (Thai Program)  :  Public Affairs Administration | การบริหารกิจการสาธารณะ | 公共事务管理"
    },
    {
        "id":9662,
        "name":"10170 (English Program)  :  Public Affairs Management | การจัดการกิจการสาธารณะ | 公共事务管理"
    },
    {
        "id":9663,
        "name":"10171 (Thai Program)  :  Industrial Management Engineering And Logistics | วิศวกรรมการจัดการอุตสาหกรรมและโลจิสติกส์ | 工业管理工程与物流"
    },
    {
        "id":9664,
        "name":"10172 (English Program)  :  Industrial And Logistics Engineering Management | การจัดการวิศวกรรมอุตสาหการและโลจิสติกส์ | 工业与物流工程管理"
    },
    {
        "id":9665,
        "name":"10173 (Thai Program)  :  Science And Technology Education | การศึกษาวิทยาศาสตร์และเทคโนโลยี | 科技教育"
    },
    {
        "id":9666,
        "name":"10174 (Thai Program)  :  Thai Traditional Medicine | เภสัชกรรมแผนไทย | 泰国传统医学"
    },
    {
        "id":9667,
        "name":"10175 (Thai Program)  :  Innovative Agricultural Entrepreneurs | ผู้ประกอบการเกษตรเชิงนวัตกรรม | 创新型农业企业家"
    },
    {
        "id":9668,
        "name":"10176 (English Program)  :  Innovative Agripreneur | นวัตกรรมเกษตรกรรม | 创新农业企业家"
    },
    {
        "id":9669,
        "name":"10177 (Thai Program)  :  Corporate And Brand Communication Innovations | นวัตกรรมการสื่อสารองค์กรและแบรนด์ | 企业和品牌传播创新"
    },
    {
        "id":9670,
        "name":"10178 (English Program)  :  Innovative Organizational Communication And Brand | นวัตกรรมการสื่อสารและแบรนด์ขององค์กร | 创新的组织沟通和品牌"
    },
    {
        "id":9671,
        "name":"10179 (Thai Program)  :  Film And Digital Media | การภาพยนตร์และสื่อดิจิทัล | 电影和数字媒体"
    },
    {
        "id":9672,
        "name":"10180 (English Program)  :  Film And Digital Media | ภาพยนตร์และสื่อดิจิทัล | 电影和数字媒体"
    },
    {
        "id":9673,
        "name":"10181 (Thai Program)  :  Modern Business Innovation | นวัตกรรมธุรกิจการค้าสมัยใหม่ | 现代商业创新"
    },
    {
        "id":9674,
        "name":"10182 (English Program)  :  Modern Trade Business Innovation | นวัตกรรมธุรกิจการค้าสมัยใหม่ | 现代贸易商业创新"
    },
    {
        "id":9675,
        "name":"10183 (Thai Program)  :  Psychology For The Development Of Human Potential | จิตวิทยาเพื่อการพัฒนาศักยภาพมนุษย์ | 开发人类潜能的心理学"
    },
    {
        "id":9676,
        "name":"10184 (English Program)  :  Psychology For Developing Human Potentials | จิตวิทยาเพื่อการพัฒนาศักยภาพของมนุษย์ | 开发人类潜能的心理学"
    },
    {
        "id":9677,
        "name":"10185 (Thai Program)  :  Agro-Industrial Product Development | การพัฒนาผลิตภัณฑ์อุตสาหกรรมเกษตร | 农工产品开发"
    },
    {
        "id":9678,
        "name":"10186 (Thai Program)  :  Nano Science And Nano Technology | วิทยาศาสตร์นาโนและเทคโนโลยีนาโน | 纳米科学与纳米技术"
    },
    {
        "id":9679,
        "name":"10187 (Thai Program)  :  Integrated Design, New Architecture | การออกแบบเชิงบูรณาการสถาปัตยกรรมแนวใหม่ | 一体化设计，全新架构"
    },
    {
        "id":9680,
        "name":"10188 (English Program)  :  Integrated Design In Emerging Architecture | การออกแบบที่บูรณาการในสถาปัตยกรรมเกิดใหม่ | 新兴建筑中的集成设计"
    },
    {
        "id":9681,
        "name":"10189 (Thai Program)  :  Agricultural System Management | การจัดการระบบเกษตร | 农业系统管理"
    },
    {
        "id":9682,
        "name":"10190 (Thai Program)  :  Burmese Language And Culture | ภาษาและวัฒนธรรมพม่า | 缅甸语言和文化"
    },
    {
        "id":9683,
        "name":"10191 (English Program)  :  Myanmar Language And Culture | ภาษาและวัฒนธรรมพม่า | 缅甸语言和文化"
    },
    {
        "id":9684,
        "name":"10192 (English Program)  :  Lanna Studies | ศึกษาต่อ | 兰纳研究"
    },
    {
        "id":9685,
        "name":"10193 (Thai Program)  :  Early Childhood Education-Special Education | การศึกษาปฐมวัย-การศึกษาพิเศษ | 幼儿教育-特殊教育"
    },
    {
        "id":9686,
        "name":"10194 (English Program)  :  Early Childhood Education-Special Education | การศึกษาปฐมวัย-การศึกษาพิเศษ | 幼儿教育-特殊教育"
    },
    {
        "id":9687,
        "name":"10195 (Thai Program)  :  Radio, Television And Digital Media | วิทยุ โทรทัศน์ และสื่อดิจิทัล | 广播、电视和数字媒体"
    },
    {
        "id":9688,
        "name":"10196 (English Program)  :  Broadcasting And Digital Media | การออกอากาศและสื่อดิจิทัล | 广播和数字媒体"
    },
    {
        "id":9689,
        "name":"10197 (Thai Program)  :  Social Media And Digital Information | สื่อสังคมออนไลน์และสารสนเทศดิจิทัล | 社交媒体和数字信息"
    },
    {
        "id":9690,
        "name":"10198 (English Program)  :  Social Media And Digital Content | โซเชียลมีเดียและเนื้อหาดิจิทัล | 社交媒体和数字内容"
    },
    {
        "id":9691,
        "name":"10199 (Thai Program)  :  Contemporary Performance Communication | สื่อสารการแสดงร่วมสมัย | 当代表演传播"
    },
    {
        "id":9692,
        "name":"10200 (English Program)  :  Contemporary Performing Arts Communication | การสื่อสารศิลปะการแสดงร่วมสมัย | 当代表演艺术传播"
    },
    {
        "id":9693,
        "name":"10201 (English Program)  :  Innovative Communication Administration | การบริหารการสื่อสารที่เป็นนวัตกรรมใหม่ | 创新通讯管理"
    },
    {
        "id":9694,
        "name":"10202 (Thai Program)  :  Communication Innovation Management | การบริหารนวัตกรรมการสื่อสาร | 沟通创新管理"
    },
    {
        "id":9695,
        "name":"10203 (English Program)  :  Aviation Industry Management | การจัดการอุตสาหกรรมการบิน | 航空业管理"
    },
    {
        "id":9696,
        "name":"10204 (Thai Program)  :  Public Policy And Management | นโยบายสาธารณะและการจัดการ | 公共政策与管理"
    },
    {
        "id":9697,
        "name":"10205 (English Program)  :  Public Policy And Management | นโยบายสาธารณะและการจัดการ | 公共政策与管理"
    },
    {
        "id":9698,
        "name":"10206 (English Program)  :  Industrial Engineering Technology | เทคโนโลยีวิศวกรรมอุตสาหการ | 工业工程技术"
    },
    {
        "id":9699,
        "name":"10207 (Thai Program)  :  Thai Language For Modern Communication | ภาษาไทยเพื่อการสื่อสารสมัยใหม่ | 用于现代交流的泰语"
    },
    {
        "id":9700,
        "name":"10208 (English Program)  :  Thai Language To Modern Communication | ภาษาไทยกับการสื่อสารสมัยใหม่ | 泰语到现代交流"
    },
    {
        "id":9701,
        "name":"10209 (Thai Program)  :  Real Estate Business Management | การจัดการธุรกิจอสังหาริมทรัพย์ | 房地产经营管理"
    },
    {
        "id":9702,
        "name":"10210 (English Program)  :  Real Estate Business Management | การจัดการธุรกิจอสังหาริมทรัพย์ | 房地产业务管理"
    },
    {
        "id":9703,
        "name":"10211 (English Program)  :  Thai Language For Foreigners | ภาษาไทยสำหรับชาวต่างชาติ | 外国人泰语"
    },
    {
        "id":9704,
        "name":"10212 (Thai Program)  :  Entrepreneurship Management | การจัดการการเป็นผู้ประกอบการ | 创业管理"
    },
    {
        "id":9705,
        "name":"10213 (Thai Program)  :  Innovative Product Design | นวัตกรรมการออกแบบผลิตภัณฑ์ | 创新产品设计"
    },
    {
        "id":9706,
        "name":"10214 (English Program)  :  Innovative Product Design | การออกแบบผลิตภัณฑ์ที่เป็นนวัตกรรมใหม่ | 创新的产品设计"
    },
    {
        "id":9707,
        "name":"10215 (English Program)  :  Law For Management | กฎหมายเพื่อการจัดการ | 管理法"
    },
    {
        "id":9708,
        "name":"10216 (Thai Program)  :  Administrative Law | กฎหมายเพื่อการบริหาร | 行政法"
    },
    {
        "id":9709,
        "name":"10217 (Thai Program)  :  Computer Science And Information Systems | วิทยาการคอมพิวเตอร์และระบบสารสนเทศ | 计算机科学与信息系统"
    },
    {
        "id":9710,
        "name":"10218 (English Program)  :  Computer Science And Information Systems | วิทยาการคอมพิวเตอร์และระบบสารสนเทศ | 计算机科学与信息系统"
    },
    {
        "id":9711,
        "name":"10219 (Thai Program)  :  Integrated Tourism And Service Management | การจัดการการท่องเที่ยวและบริการแบบบูรณาการ | 综合旅游与服务管理"
    },
    {
        "id":9712,
        "name":"10220 (English Program)  :  Integrated Tourism And Hospitality Management | การจัดการการท่องเที่ยวและการบริการแบบบูรณาการ | 综合旅游和酒店管理"
    },
    {
        "id":9713,
        "name":"10221 (Thai Program)  :  Promote Agriculture And Rural Development | ส่งเสริมการเกษตรและการพัฒนาชนบท | 促进农业农村发展"
    },
    {
        "id":9714,
        "name":"10222 (Thai Program)  :  Agricultural Promotion And Communication | การส่งเสริมและสื่อสารเกษตร | 农业推广与交流"
    },
    {
        "id":9715,
        "name":"10223 (Thai Program)  :  Interdisciplinary Agriculture | สหวิทยาการเกษตร | 跨学科农业"
    },
    {
        "id":9716,
        "name":"10224 (English Program)  :  Interdisciplinary Agriculture | เกษตรสหวิทยาการ | 跨学科农业"
    },
    {
        "id":9717,
        "name":"10225 (Thai Program)  :  Innovation In Fishing Business Management | นวัตกรรมการจัดการธุรกิจประมง | 渔业企业管理创新"
    },
    {
        "id":9718,
        "name":"10226 (English Program)  :  Innovative Fisheries Business Management | นวัตกรรมการจัดการธุรกิจประมง | 创新渔业业务管理"
    },
    {
        "id":9719,
        "name":"10227 (Thai Program)  :  Public Administration | การบริหารสาธารณะ | 公共行政"
    },
    {
        "id":9720,
        "name":"10228 (Thai Program)  :  Digital Business Innovation | นวัตกรรมธุรกิจดิจิทัล | 数字化业务创新"
    },
    {
        "id":9721,
        "name":"10229 (English Program)  :  Digital Business Innovation | นวัตกรรมธุรกิจดิจิทัล | 数字商业创新"
    },
    {
        "id":9722,
        "name":"10230 (Thai Program)  :  Agricultural Technology And Community Development | เทคโนโลยีการเกษตรและการพัฒนาชุมชน | 农业技术和社区发展"
    },
    {
        "id":9723,
        "name":"10231 (English Program)  :  Agricultural Technology And Community Development | เทคโนโลยีการเกษตรและการพัฒนาชุมชน | 农业技术和社区发展"
    },
    {
        "id":9724,
        "name":"10232 (Thai Program)  :  English For Professional And International Communication | ภาษาอังกฤษเพื่อการสื่อสารในวิชาชีพและนานาชาติ | 专业和国际交流英语"
    },
    {
        "id":9725,
        "name":"10233 (English Program)  :  English For Professional And International Communication | ภาษาอังกฤษเพื่อการสื่อสารระดับมืออาชีพและระหว่างประเทศ | 专业和国际交流英语"
    },
    {
        "id":9726,
        "name":"10234 (Thai Program)  :  Agricultural Science And Technology (Post-Harvest Science) | วิทยาศาสตร์เกษตรและเทคโนโลยี (วิทยาการหลังการเก็บเกี่ยว) | 农业科技（收获后科学）"
    },
    {
        "id":9727,
        "name":"10235 (English Program)  :  Agriscience And Technology (Postharvest) | การเกษตรและเทคโนโลยี (หลังเก็บเกี่ยว) | 农业科学与技术（采后）"
    },
    {
        "id":9728,
        "name":"10236 (Thai Program)  :  Electrical And Information Engineering Technology | เทคโนโลยีวิศวกรรมไฟฟ้าและสารสนเทศ | 电气与信息工程技术"
    },
    {
        "id":9729,
        "name":"10237 (English Program)  :  Electrical And Information Engineering Technology | เทคโนโลยีวิศวกรรมไฟฟ้าและสารสนเทศ | 电气与信息工程技术"
    },
    {
        "id":9730,
        "name":"10238 (Thai Program)  :  Tourism And Service Innovation | นวัตกรรมการท่องเที่ยวและบริการ | 旅游与服务创新"
    },
    {
        "id":9731,
        "name":"10239 (English Program)  :  Tourism And Hospitality Innovation | นวัตกรรมการท่องเที่ยวและการบริการ | 旅游和酒店创新"
    },
    {
        "id":9732,
        "name":"10240 (Thai Program)  :  Asean Communication Arts | นิเทศศาสตร์อาเซียน | 东盟传播艺术"
    },
    {
        "id":9733,
        "name":"10241 (English Program)  :  Communication Arts For Asean | ศิลปะการสื่อสารสำหรับอาเซียน | 东盟传播艺术"
    },
    {
        "id":9734,
        "name":"10242 (Thai Program)  :  Communication Business Management | การบริหารกิจการสื่อสาร | 通讯业务管理"
    },
    {
        "id":9735,
        "name":"10243 (English Program)  :  Media Management | การจัดการสื่อ | 媒体管理"
    },
    {
        "id":9736,
        "name":"10244 (Thai Program)  :  Politics And International Affairs | การเมืองและการระหว่างประเทศ | 政治与国际事务"
    },
    {
        "id":9737,
        "name":"10245 (English Program)  :  Politics And International Relations | การเมืองและความสัมพันธ์ระหว่างประเทศ | 政治与国际关系"
    },
    {
        "id":9738,
        "name":"10246 (English Program)  :  Global Business Management | การจัดการธุรกิจระดับโลก | 全球商业管理"
    },
    {
        "id":9739,
        "name":"10247 (Thai Program)  :  International Business Management | การจัดการธุรกิจสากล | 国际商业管理"
    },
    {
        "id":9740,
        "name":"10248 (Thai Program)  :  Stem Cell Biology And Technology | ชีววิทยาและเทคโนโลยีเซลล์ต้นกำเนิด | 干细胞生物学与技术"
    },
    {
        "id":9741,
        "name":"10249 (English Program)  :  Stem Cell Biology And Technology | ชีววิทยาและเทคโนโลยีสเต็มเซลล์ | 干细胞生物学和技术"
    },
    {
        "id":9742,
        "name":"10250 (Thai Program)  :  Social Policy | นโยบายสังคม | 社会政策"
    },
    {
        "id":9743,
        "name":"10251 (English Program)  :  Social Policy | นโยบายทางสังคม | 社会政策"
    },
    {
        "id":9744,
        "name":"10252 (Thai Program)  :  Occupational And Environmental Health | อาชีวอนามัยและอนามัยสิ่งแวดล้อม | 职业与环境健康"
    },
    {
        "id":9745,
        "name":"10253 (English Program)  :  Occupational And Environmental Health | อาชีวอนามัยและสิ่งแวดล้อม | 职业与环境健康"
    },
    {
        "id":9746,
        "name":"10254 (Thai Program)  :  Politics And Management For Executives | การเมืองและการจัดการ สำหรับนักบริหาร | 政治与管理对于高管"
    },
    {
        "id":9747,
        "name":"10255 (English Program)  :  Politics And Management For Executive | การเมืองและการจัดการสำหรับผู้บริหาร | 行政人员的政治与管理"
    },
    {
        "id":9748,
        "name":"10256 (Thai Program)  :  Public Administration And Public Affairs For Executives | บริหารรัฐกิจและกิจการสาธารณะ สำหรับนักบริหาร | 公共行政和公共事务对于高管"
    },
    {
        "id":9749,
        "name":"10257 (Thai Program)  :  Corporate Communications Management | การจัดการการสื่อสารองค์กร | 企业传播管理"
    },
    {
        "id":9750,
        "name":"10258 (Thai Program)  :  Innovative Digital Design | การออกแบบเชิงนวัตกรรมดิจิทัล | 创新的数字化设计"
    },
    {
        "id":9751,
        "name":"10259 (English Program)  :  Innovative Digital Design | นวัตกรรมการออกแบบดิจิทัล | 创新的数字设计"
    },
    {
        "id":9752,
        "name":"10260 (Thai Program)  :  Service Management Design | การออกแบบการจัดการบริการ | 服务管理设计"
    },
    {
        "id":9753,
        "name":"10261 (Thai Program)  :  Dental Implants | ทันตกรรมรากเทียม | 种植牙"
    },
    {
        "id":9754,
        "name":"10262 (English Program)  :  Dental Implantology | ทันตกรรมรากเทียม | 牙科种植学"
    },
    {
        "id":9755,
        "name":"10263 (Thai Program)  :  Technology For Sustainable Development | เทคโนโลยีเพื่อการพัฒนายั่งยืน | 可持续发展技术"
    },
    {
        "id":9756,
        "name":"10264 (Thai Program)  :  Innovation And Material Technology | นวัตกรรมและเทคโนโลยีวัสดุ | 创新与材料技术"
    },
    {
        "id":9757,
        "name":"10265 (English Program)  :  Materials Innovation And Technology | นวัตกรรมวัสดุและเทคโนโลยี | 材料创新与技术"
    },
    {
        "id":9758,
        "name":"10266 (Thai Program)  :  Cultural Heritage Management And Creative Industries | การจัดการมรดกวัฒนธรรมและอุตสาหกรรมสร้างสรรค์ | 文化遗产管理与创意产业"
    },
    {
        "id":9759,
        "name":"10267 (English Program)  :  Management Of Cultural Heritage And Creative Industries | การจัดการมรดกทางวัฒนธรรมและอุตสาหกรรมสร้างสรรค์ | 文化遗产和创意产业管理"
    },
    {
        "id":9760,
        "name":"10268 (Thai Program)  :  World Case Studies And Social Entrepreneurship | โลกคดีศึกษาและการประกอบการสังคม | 世界案例研究和社会创业"
    },
    {
        "id":9761,
        "name":"10269 (English Program)  :  Global Studies And Social Entrepreneurship | การศึกษาระดับโลกและการประกอบการทางสังคม | 全球研究和社会创业"
    },
    {
        "id":9762,
        "name":"10270 (Thai Program)  :  Indian Studies | อินเดียศึกษา | 印度研究"
    },
    {
        "id":9763,
        "name":"10271 (English Program)  :  Indian Studies | การศึกษาอินเดีย | 印度研究"
    },
    {
        "id":9764,
        "name":"10272 (Thai Program)  :  Entrepreneurship With Advanced Technology | การประกอบการด้วยเทคโนโลยีขั้นสูง | 以先进技术创业"
    },
    {
        "id":9765,
        "name":"10273 (Thai Program)  :  Interaction Design | การออกแบบปฏิสัมพันธ์ | 交互设计"
    },
    {
        "id":9766,
        "name":"10274 (English Program)  :  Interaction Design | การออกแบบปฏิสัมพันธ์ | 交互设计"
    },
    {
        "id":9767,
        "name":"10275 (Thai Program)  :  Computer Science And Digital Technology | วิทยาการคอมพิวเตอร์และเทคโนโลยีดิจิทัล | 计算机科学与数字技术"
    },
    {
        "id":9768,
        "name":"10276 (English Program)  :  Computer Science And Digital Technology | วิทยาศาสตร์คอมพิวเตอร์และเทคโนโลยีดิจิทัล | 计算机科学与数字技术"
    },
    {
        "id":9769,
        "name":"10277 (Thai Program)  :  Cyber Security | ความปลอดภัยทางไซเบอร์ | 网络安全"
    },
    {
        "id":9770,
        "name":"10278 (English Program)  :  Product Management For Technology Business | การจัดการผลิตภัณฑ์สำหรับธุรกิจเทคโนโลยี | 技术业务的产品管理"
    },
    {
        "id":9771,
        "name":"10279 (Thai Program)  :  Product Management For Technology Businesses | การจัดการผลิตภัณฑ์สำหรับธุรกิจเทคโนโลยี | 技术企业的产品管理"
    },
    {
        "id":9772,
        "name":"10280 (Thai Program)  :  Artificial Intelligence And Intelligent Systems Engineering | วิศวกรรมปัญญาประดิษฐ์และระบบอัจฉริยะ | 人工智能与智能系统工程"
    },
    {
        "id":9773,
        "name":"10281 (English Program)  :  Artificial Intelligence And System Engineering | ปัญญาประดิษฐ์และวิศวกรรมระบบ | 人工智能与系统工程"
    },
    {
        "id":9774,
        "name":"10282 (Thai Program)  :  Computer Engineering And Digital Technology | วิศวกรรมคอมพิวเตอร์และเทคโนโลยีดิจิทัล | 计算机工程与数字技术"
    },
    {
        "id":9775,
        "name":"10283 (English Program)  :  Computer Engineering And Digital Technology | วิศวกรรมคอมพิวเตอร์และเทคโนโลยีดิจิทัล | 计算机工程和数字技术"
    },
    {
        "id":9776,
        "name":"10284 (Thai Program)  :  International Aviation Business Management | การจัดการธุรกิจการบินนานาชาติ | 国际航空业务管理"
    },
    {
        "id":9777,
        "name":"10285 (English Program)  :  International Airline Business Management | การจัดการธุรกิจสายการบินระหว่างประเทศ | 国际航空业务管理"
    },
    {
        "id":9778,
        "name":"10286 (Thai Program)  :  Innovative Entrepreneurship | การเป็นผู้ประกอบการเชิงนวัตกรรม | 创新创业"
    },
    {
        "id":9779,
        "name":"10287 (English Program)  :  Innovative Entrepreneurship | ผู้ประกอบการที่เป็นนวัตกรรมใหม่ | 创新创业"
    },
    {
        "id":9780,
        "name":"10288 (Thai Program)  :  Creative Health Business Leader | ผู้นำธุรกิจสุขภาพเชิงสร้างสรรค์ | 创意健康商业领袖"
    },
    {
        "id":9781,
        "name":"10289 (English Program)  :  Creative Wellness Business Leadership | ความเป็นผู้นำทางธุรกิจด้านสุขภาพที่สร้างสรรค์ | 创意健康商业领导力"
    },
    {
        "id":9782,
        "name":"10290 (Thai Program)  :  Research Arts And Culture For The Creative Economy | วิจัยศิลปวัฒนธรรมเพื่อเศรษฐกิจสร้างสรรค์ | 研究创意经济的艺术和文化"
    },
    {
        "id":9783,
        "name":"10291 (English Program)  :  Arts And Culture Research For Creative Economy | การวิจัยศิลปะและวัฒนธรรมเพื่อเศรษฐกิจเชิงสร้างสรรค์ | 创意经济的艺术和文化研究"
    },
    {
        "id":9784,
        "name":"10292 (Thai Program)  :  Women, Gender And Sexuality Education | สตรี เพศสถานะ และเพศวิถีศึกษา | 妇女、性别和性教育"
    },
    {
        "id":9785,
        "name":"10293 (English Program)  :  Women, Gender And Sexuality Studies | ผู้หญิง เพศสภาพและการศึกษาเรื่องเพศ | 妇女、性别和性行为研究"
    },
    {
        "id":9786,
        "name":"10294 (Thai Program)  :  Professional English For International Communication | ภาษาอังกฤษเชิงอาชีพเพื่อการสื่อสารนานาชาติ | 国际交流专业英语"
    },
    {
        "id":9787,
        "name":"10295 (English Program)  :  Career English For International Communication | อาชีพภาษาอังกฤษเพื่อการสื่อสารระหว่างประเทศ | 国际交流职业英语"
    },
    {
        "id":9788,
        "name":"10296 (Thai Program)  :  Policy And Administration Of Justice | นโยบายและการบริหารงานยุติธรรม | 政策和司法行政"
    },
    {
        "id":9789,
        "name":"10297 (English Program)  :  Justice Policy And Administration | นโยบายความยุติธรรมและการบริหาร | 司法政策和行政"
    },
    {
        "id":9790,
        "name":"10298 (Thai Program)  :  Media And Communication | สื่อและการสื่อสาร | 媒体与传播"
    },
    {
        "id":9791,
        "name":"10299 (Thai Program)  :  Medical Anatomy | กายวิภาคศาสตร์การแพทย์ | 医学解剖学"
    },
    {
        "id":9792,
        "name":"10300 (English Program)  :  Medical Anatomy | กายวิภาคศาสตร์การแพทย์ | 医学解剖学"
    },
    {
        "id":9793,
        "name":"10301 (Thai Program)  :  Health Technology Assessment | การประเมินเทคโนโลยีด้านสุขภาพ | 卫生技术评估"
    },
    {
        "id":9794,
        "name":"10302 (Thai Program)  :  Improving The Quality Of Life Of People With Disabilities | การพัฒนาคุณภาพชีวิตคนพิการ | 提高残疾人的生活质量"
    },
    {
        "id":9795,
        "name":"10303 (English Program)  :  Quality Of Life Development For Persons With Disabilities | การพัฒนาคุณภาพชีวิตคนพิการ | 残疾人的生活质量发展"
    },
    {
        "id":9796,
        "name":"10304 (Thai Program)  :  Biochemistry And Medical Molecular Biology | ชีวเคมีและชีววิทยาโมเลกุลทางการแพทย์ | 生物化学与医学分子生物学"
    },
    {
        "id":9797,
        "name":"10305 (Thai Program)  :  Molecular Genetics And Genetic Engineering | พันธุศาสตร์ระดับโมเลกุลและพันธุวิศวกรรมศาสตร์ | 分子遗传学和基因工程"
    },
    {
        "id":9798,
        "name":"10306 (Thai Program)  :  Environmental And Water Resources Engineering | วิศวกรรมสิ่งแวดล้อมและทรัพยากรน้ำ | 环境与水资源工程"
    },
    {
        "id":9799,
        "name":"10307 (English Program)  :  Environmental And Water Resources Engineering | วิศวกรรมสิ่งแวดล้อมและทรัพยากรน้ำ | 环境与水资源工程"
    },
    {
        "id":9800,
        "name":"10308 (Thai Program)  :  Religion And Development | ศาสนากับการพัฒนา | 宗教与发展"
    },
    {
        "id":9801,
        "name":"10309 (English Program)  :  Religion And Development | ศาสนาและการพัฒนา | 宗教与发展"
    },
    {
        "id":9802,
        "name":"10310 (Thai Program)  :  Biological Resources And Environmental Biology | ทรัพยากรชีวภาพและชีววิทยาสภาวะแวดล้อม | 生物资源与环境生物学"
    },
    {
        "id":9803,
        "name":"10311 (English Program)  :  Bioresources And Environmental Biology | ทรัพยากรชีวภาพและชีววิทยาสิ่งแวดล้อม | 生物资源和环境生物学"
    },
    {
        "id":9804,
        "name":"10312 (Thai Program)  :  Measuring Education And Teaching Mathematics | วัดผลการศึกษาและการสอนคณิตศาสตร์ | 衡量教育和数学教学"
    },
    {
        "id":9805,
        "name":"10313 (English Program)  :  Measuring Education And Teaching Mathematics | การวัดผลการศึกษาและการสอนคณิตศาสตร์ | 测量教育和教学数学"
    },
    {
        "id":9806,
        "name":"10314 (Thai Program)  :  Electronics And Mechatronics | อิเล็กทรอนิกส์และเมคคาทรอนิกส์ | 电子与机电一体化"
    },
    {
        "id":9807,
        "name":"10315 (English Program)  :  Electronics And Mechatronics | อิเล็กทรอนิกส์และเมคคาทรอนิกส์ | 电子和机电一体化"
    },
    {
        "id":9808,
        "name":"10316 (Thai Program)  :  Ship Mechanical Technology | เทคโนโลยีเครื่องกลเรือ | 船舶机械技术"
    },
    {
        "id":9809,
        "name":"10317 (English Program)  :  Marine Mechanical Technology | เทคโนโลยีเครื่องกลทางทะเล | 海洋机械技术"
    },
    {
        "id":9810,
        "name":"10318 (Thai Program)  :  Film And Radio And Television Production Technology | เทคโนโลยีการผลิตภาพยนตร์และวิทยุโทรทัศน์ | 电影广播电视制作技术"
    },
    {
        "id":9811,
        "name":"10319 (English Program)  :  Film And Television Production Technology | เทคโนโลยีการผลิตภาพยนตร์และโทรทัศน์ | 影视制作技术"
    },
    {
        "id":9812,
        "name":"10320 (Thai Program)  :  Management And Entrepreneurship | การจัดการและการประกอบการ | 管理与创业"
    },
    {
        "id":9813,
        "name":"10321 (Thai Program)  :  International Tourism, Hospitality, Events And Restaurant Management | การท่องเที่ยว การบริการ อีเวนท์ และ การจัดการภัตตาคาร นานาชาติ | 国际旅游、酒店、活动和餐厅管理"
    },
    {
        "id":9814,
        "name":"10322 (English Program)  :  International Tourism, Hospitality Events And Restaurant Management | การท่องเที่ยวระหว่างประเทศ กิจกรรมด้านการบริการ และการจัดการร้านอาหาร | 国际旅游、酒店活动和餐厅管理"
    },
    {
        "id":9815,
        "name":"10323 (Thai Program)  :  Fine Arts Studies | ศิลปกรรมศึกษา | 美术研究"
    },
    {
        "id":9816,
        "name":"10324 (English Program)  :  Fine Arts Education | การศึกษาวิจิตรศิลป์ | 美术教育"
    },
    {
        "id":9817,
        "name":"10325 (Thai Program)  :  Alternative Energy And Environmental Management | การจัดการพลังงานทางเลือกและสิ่งแวดล้อม | 替代能源和环境管理"
    },
    {
        "id":9818,
        "name":"10326 (English Program)  :  Alternative Energy And Environmental Management | การจัดการพลังงานทางเลือกและสิ่งแวดล้อม | 替代能源和环境管理"
    },
    {
        "id":9819,
        "name":"10327 (Thai Program)  :  English For Career Development | ภาษาอังกฤษเพื่อการพัฒนาอาชีพ | 职业发展英语"
    },
    {
        "id":9820,
        "name":"10328 (English Program)  :  English For Career Development | ภาษาอังกฤษเพื่อการพัฒนาอาชีพ | 职业发展英语"
    },
    {
        "id":9821,
        "name":"10329 (Thai Program)  :  Forestry | การป่าไม้ | 林业"
    },
    {
        "id":9822,
        "name":"10330 (Thai Program)  :  Chemical Products And Cosmetic Business | เคมีผลิตภัณฑ์และธุรกิจเครื่องสำอาง | 化工产品及化妆品业务"
    },
    {
        "id":9823,
        "name":"10331 (English Program)  :  Chemical Products And Cosmetic Business | ธุรกิจผลิตภัณฑ์เคมีภัณฑ์และเครื่องสำอาง | 化工及化妆品业务"
    },
    {
        "id":9824,
        "name":"10332 (Thai Program)  :  Electronic Computer | คอมพิวเตอร์อิเล็กทรอนิกส์ | 电子计算机"
    },
    {
        "id":9825,
        "name":"10333 (English Program)  :  Medical Biology | ชีววิทยาการแพทย์ | 医学生物学"
    },
    {
        "id":9826,
        "name":"10334 (Thai Program)  :  Engineering The Production Of Sustainable Textile Materials | วิศวกรรมการผลิตวัสดุสิ่งทอที่ยั่งยืน | 可持续纺织材料的工程设计生产"
    },
    {
        "id":9827,
        "name":"10335 (English Program)  :  Production Engineering In Sustainable Textile Materials | วิศวกรรมการผลิตในวัสดุสิ่งทอที่ยั่งยืน | 可持续纺织材料的生产工程"
    },
    {
        "id":9828,
        "name":"10336 (English Program)  :  Thai Classical Music | ดนตรีคลาสสิกไทย | 泰国古典音乐"
    },
    {
        "id":9829,
        "name":"10337 (Thai Program)  :  International Music Studies | ดนตรีสากลศึกษา | 国际音乐研究"
    },
    {
        "id":9830,
        "name":"10338 (Thai Program)  :  Tourism And Event Management | การจัดการการท่องเที่ยวและอีเวนต์ | 旅游和活动管理"
    },
    {
        "id":9831,
        "name":"10339 (English Program)  :  Tourism And Event Management | การท่องเที่ยวและการจัดการกิจกรรม | 旅游和活动管理"
    },
    {
        "id":9832,
        "name":"10340 (Thai Program)  :  Innovation In Tourism And Entertainment Business Management | นวัตกรรมการจัดการธุรกิจท่องเที่ยวและบันเทิง | 旅游娱乐业经营管理创新"
    },
    {
        "id":9833,
        "name":"10341 (English Program)  :  Tourism And Entertainment Business Management Innovation | นวัตกรรมการจัดการธุรกิจการท่องเที่ยวและความบันเทิง | 旅游娱乐业务管理创新"
    },
    {
        "id":9834,
        "name":"10342 (Thai Program)  :  Thai And Chinese For The Service Industry | ภาษาไทยและภาษาจีนเพื่ออุตสาหกรรมการบริการ | 服务业的泰语和汉语"
    },
    {
        "id":9835,
        "name":"10343 (English Program)  :  Thai And Chinese For Service Industry | ไทยและจีนเพื่ออุตสาหกรรมบริการ | 服务业的泰语和汉语"
    },
    {
        "id":9836,
        "name":"10344 (English Program)  :  Fine Arts And Design | วิจิตรศิลป์และการออกแบบ | 美术与设计"
    },
    {
        "id":9837,
        "name":"10345 (Thai Program)  :  Agricultural And Food Technology | เทคโนโลยีการเกษตรและอาหาร | 农业和食品技术"
    },
    {
        "id":9838,
        "name":"10346 (English Program)  :  Agricultural And Food Technology | เทคโนโลยีการเกษตรและอาหาร | 农业和食品技术"
    },
    {
        "id":9839,
        "name":"10347 (English Program)  :  Technology And Digital Innovation | เทคโนโลยีและนวัตกรรมดิจิทัล | 技术与数字创新"
    },
    {
        "id":9840,
        "name":"10348 (Thai Program)  :  Materials Science And Nano Engineering | วัสดุศาสตร์และวิศวกรรมนาโน | 材料科学与纳米工程"
    },
    {
        "id":9841,
        "name":"10349 (English Program)  :  Materials Science And Nanoengineering | วิทยาศาสตร์วัสดุและนาโนวิศวกรรม | 材料科学与纳米工程"
    },
    {
        "id":9842,
        "name":"10350 (Thai Program)  :  Managing Livable Cities And Sustainable Environments | การจัดการเมืองน่าอยู่และสิ่งแวดล้อมที่ยั่งยืน | 管理宜居城市和可持续环境"
    },
    {
        "id":9843,
        "name":"10351 (English Program)  :  Livable City Management And Sustainable Environment | การจัดการเมืองที่น่าอยู่และสิ่งแวดล้อมที่ยั่งยืน | 宜居城市管理与可持续环境"
    },
    {
        "id":9844,
        "name":"10352 (Thai Program)  :  Environmental Management And Technology | การจัดการสิ่งแวดล้อมและเทคโนโลยี | 环境管理与技术"
    },
    {
        "id":9845,
        "name":"10353 (English Program)  :  Environmental Management And Technology | การจัดการสิ่งแวดล้อมและเทคโนโลยี | 环境管理与技术"
    },
    {
        "id":9846,
        "name":"10354 (Thai Program)  :  Cyber ​​Security And Information Assurance | ความมั่นคงไซเบอร์และการประกันสารสนเทศ | 网络安全与信息保障"
    },
    {
        "id":9847,
        "name":"10355 (English Program)  :  Cyber Security And Information Assurance | ความปลอดภัยทางไซเบอร์และการประกันข้อมูล | 网络安全与信息保障"
    },
    {
        "id":9848,
        "name":"10356 (Thai Program)  :  Clinical Microbiology And Laboratory Management | จุลชีววิทยาคลินิกและการจัดการทางห้องปฏิบัติการ | 临床微生物学和实验室管理"
    },
    {
        "id":9849,
        "name":"10357 (English Program)  :  Clinical Microbiology And Laboratory Management | จุลชีววิทยาคลินิกและการจัดการห้องปฏิบัติการ | 临床微生物学和实验室管理"
    },
    {
        "id":9850,
        "name":"10358 (English Program)  :  Implant Dentistry | ทันตกรรมรากเทียม | 种植牙"
    },
    {
        "id":9851,
        "name":"10359 (Thai Program)  :  Game Technology And Gamification | เทคโนโลยีเกมและเกมมิฟิเคชัน | 游戏技术和游戏化"
    },
    {
        "id":9852,
        "name":"10360 (English Program)  :  Game Technology And Gamification | เทคโนโลยีเกมและการเล่นเกม | 游戏技术和游戏化"
    },
    {
        "id":9853,
        "name":"10361 (English Program)  :  Nutraceuticals And Functional Foods | โภชนเภสัชและอาหารเพื่อสุขภาพ | 营养保健品和功能性食品"
    },
    {
        "id":9854,
        "name":"10362 (Thai Program)  :  Dietary Supplements And Health Foods | ผลิตภัณฑ์เสริมอาหารและอาหารเพื่อสุขภาพ | 膳食补充剂和保健食品"
    },
    {
        "id":9855,
        "name":"10363 (Thai Program)  :  Infectious Diseases And Public Health Epidemiology | โรคติดเชื้อและวิทยาการระบาดทางการสาธารณสุข | 传染病和公共卫生流行病学"
    },
    {
        "id":9856,
        "name":"10364 (English Program)  :  Public Health Infectious Diseases And Epidemiology | โรคติดเชื้อและระบาดวิทยาด้านสาธารณสุข | 公共卫生传染病和流行病学"
    },
    {
        "id":9857,
        "name":"10365 (Thai Program)  :  Ecocultural Entrepreneurship | การประกอบการเชิงนิเวศวัฒนธรรม | 生态文化创业"
    },
    {
        "id":9858,
        "name":"10366 (English Program)  :  Ecocultural Entrepreneurship | ผู้ประกอบการเชิงนิเวศน์ | 生态文化创业"
    },
    {
        "id":9859,
        "name":"10367 (Thai Program)  :  International Cultural Studies And Languages | วัฒนธรรมนานาชาติศึกษาและภาษา | 国际文化研究和语言"
    },
    {
        "id":9860,
        "name":"10368 (English Program)  :  Intercultural Studies And Languages | การศึกษาระหว่างวัฒนธรรมและภาษา | 跨文化研究和语言"
    },
    {
        "id":9861,
        "name":"10369 (Thai Program)  :  Education For Individuals With Special Needs | การศึกษาสำหรับบุคคลที่มีความต้องการพิเศษ | 对有特殊需要的人的教育"
    },
    {
        "id":9862,
        "name":"10370 (English Program)  :  Education For Persons With Special Needs | การศึกษาสำหรับบุคคลที่มีความต้องการพิเศษ | 有特殊需要的人的教育"
    },
    {
        "id":9863,
        "name":"10371 (English Program)  :  Health Technology Assessment | การประเมินเทคโนโลยีด้านสุขภาพ | 卫生技术评估"
    },
    {
        "id":9864,
        "name":"10372 (Thai Program)  :  Artificial Intelligence And Computer Engineering | วิศวกรรมปัญญาประดิษฐ์และคอมพิวเตอร์ | 人工智能与计算机工程"
    },
    {
        "id":9865,
        "name":"10373 (English Program)  :  Artificial Intelligence And Computer Engineering | ปัญญาประดิษฐ์และวิศวกรรมคอมพิวเตอร์ | 人工智能和计算机工程"
    },
    {
        "id":9866,
        "name":"10374 (English Program)  :  Management And Business Development | การจัดการและการพัฒนาธุรกิจ | 管理和业务发展"
    },
    {
        "id":9867,
        "name":"10375 (Thai Program)  :  Modern Automotive System Technology | เทคโนโลยีระบบยานยนต์สมัยใหม่ | 现代汽车系统技术"
    },
    {
        "id":9868,
        "name":"10376 (English Program)  :  Modern Automotive System Technology | เทคโนโลยีระบบยานยนต์สมัยใหม่ | 现代汽车系统技术"
    },
    {
        "id":9869,
        "name":"10377 (Thai Program)  :  Esports Business | ธุรกิจอีสปอร์ต | 电竞业务"
    },
    {
        "id":9870,
        "name":"10378 (English Program)  :  Esports Business | ธุรกิจอีสปอร์ต | 电竞业务"
    },
    {
        "id":9871,
        "name":"10379 (Thai Program)  :  Communication Arts And Digital Media | นิเทศศาสตร์และดิจิทัลมีเดีย | 传播艺术和数字媒体"
    },
    {
        "id":9872,
        "name":"10380 (English Program)  :  Communication Arts And Digital Media | ศิลปะการสื่อสารและสื่อดิจิทัล | 传播艺术和数字媒体"
    },
    {
        "id":9873,
        "name":"10381 (Thai Program)  :  Medical Materials And Equipment | วัสดุและอุปกรณ์การแพทย์ | 医疗物资及设备"
    },
    {
        "id":9874,
        "name":"10382 (English Program)  :  Medical Material And Equipment | วัสดุและอุปกรณ์ทางการแพทย์ | 医疗材料及设备"
    },
    {
        "id":9875,
        "name":"10383 (Thai Program)  :  Data Science And Statistics | วิทยาการข้อมูลและสถิติ | 数据科学与统计学"
    },
    {
        "id":9876,
        "name":"10384 (English Program)  :  Data Science And Statistics | วิทยาศาสตร์ข้อมูลและสถิติ | 数据科学和统计学"
    },
    {
        "id":9877,
        "name":"10385 (Thai Program)  :  Science And Innovation For Development | วิทยาศาสตร์และนวัตกรรมเพื่อการพัฒนา | 科学与创新促进发展"
    },
    {
        "id":9878,
        "name":"10386 (English Program)  :  Science And Innovation For Development | วิทยาศาสตร์และนวัตกรรมเพื่อการพัฒนา | 科学与创新促进发展"
    },
    {
        "id":9879,
        "name":"10387 (Thai Program)  :  Sustainable Environmental Technology And Management | เทคโนโลยีและการจัดการสิ่งแวดล้อมอย่างยั่งยืน | 可持续环境技术与管理"
    },
    {
        "id":9880,
        "name":"10388 (English Program)  :  Technology And Sustainable Environmental Management | เทคโนโลยีและการจัดการสิ่งแวดล้อมอย่างยั่งยืน | 技术与可持续环境管理"
    },
    {
        "id":9881,
        "name":"10389 (Thai Program)  :  Entrepreneurship And Innovation | การเป็นผู้ประกอบการและนวัตกรรม | 创业创新"
    },
    {
        "id":9882,
        "name":"10390 (Thai Program)  :  Eastern Philosophy And Religion | ปรัชญาและศาสนาตะวันออก | 东方哲学与宗教"
    },
    {
        "id":9883,
        "name":"10391 (English Program)  :  Eastern Philosophy And Religion | ปรัชญาและศาสนาตะวันออก | 东方哲学与宗教"
    },
    {
        "id":9884,
        "name":"10392 (English Program)  :  Aviation Science | วิทยาศาสตร์การบิน | 航空科学"
    },
    {
        "id":9885,
        "name":"10393 (Thai Program)  :  Aviation Electronics Engineering | วิศวกรรมอิเล็กทรอนิกส์การบิน | 航空电子工程"
    },
    {
        "id":9886,
        "name":"10394 (English Program)  :  Avionics Engineering | วิศวกรรมการบินและอวกาศ | 航空电子工程"
    },
    {
        "id":9887,
        "name":"10395 (Thai Program)  :  Avionics Technician | ช่างเอวิโอนิกส์ | 航空电子技术员"
    },
    {
        "id":9888,
        "name":"10396 (English Program)  :  Avionic Mechanic | ช่างเครื่องเอวิโอนิค | 航空电子机械师"
    },
    {
        "id":9889,
        "name":"10397 (English Program)  :  Aeroplane Mechanic | ช่างเครื่องเครื่องบิน | 飞机机械师"
    },
    {
        "id":9890,
        "name":"10398 (English Program)  :  Practcal Nursing | การพยาบาลเชิงปฏิบัติ | 实用护理"
    },
    {
        "id":9891,
        "name":"10399 (Thai Program)  :  Logistics And Supply Chain Management For Sustainability | การจัดการโลจิสติกส์และโซ่อุปทานเพื่อความยั่งยืน | 可持续发展的物流和供应链管理"
    },
    {
        "id":9892,
        "name":"10400 (English Program)  :  Sustainable Logistics And Supply Chain ​​Management | การจัดการโลจิสติกส์และห่วงโซ่อุปทานที่ยั่งยืน | 可持续物流和供应链管理"
    },
    {
        "id":9893,
        "name":"10401 (English Program)  :  Dhammaduta | ตอนจบ | 正法度塔"
    },
    {
        "id":9894,
        "name":"10402 (Thai Program)  :  Social Welfare Administration | การบริหารสวัสดิการสังคม | 社会福利管理"
    },
    {
        "id":9895,
        "name":"10403 (Thai Program)  :  Automated And Robotic Production Technology | เทคโนโลยีการผลิตอัตโนมัติและหุ่นยนต์ | 自动化和机器人生产技术"
    },
    {
        "id":9896,
        "name":"10404 (English Program)  :  Manufacturing Automation And Robotics Technology | เทคโนโลยีการผลิตอัตโนมัติและหุ่นยนต์ | 制造自动化和机器人技术"
    },
    {
        "id":9897,
        "name":"10405 (English Program)  :  Hotel And Hospitality | โรงแรมและการต้อนรับ | 酒店与招待"
    },
    {
        "id":9898,
        "name":"10406 (English Program)  :  Sustainable Materials And Technology For Industries | วัสดุและเทคโนโลยีที่ยั่งยืนสำหรับอุตสาหกรรม | 工业可持续材料和技术"
    },
    {
        "id":9899,
        "name":"10407 (English Program)  :  Curriculum And Learning Innovation | หลักสูตรและนวัตกรรมการเรียนรู้ | 课程和学习创新"
    },
    {
        "id":9900,
        "name":"10408 (Thai Program)  :  New Era Women Leaders | สตรีผู้นำยุคใหม่ | 新时代女性领袖"
    },
    {
        "id":9901,
        "name":"10409 (English Program)  :  New Generation Woman Leaders | ผู้นำสตรีรุ่นใหม่ | 新一代女性领袖"
    },
    {
        "id":9902,
        "name":"10410 (Thai Program)  :  Sports Science And Health Promotion | วิทยาศาสตร์การกีฬาและการส่งเสริมสุขภาพ | 运动科学与健康促进"
    },
    {
        "id":9903,
        "name":"10411 (Thai Program)  :  Maintenance Engineering And Production Automation | วิศวกรรมซ่อมบำรุงและระบบการผลิตอัตโนมัติ | 维护工程和生产自动化"
    },
    {
        "id":9904,
        "name":"10412 (English Program)  :  Maintenance And Automation Manufacturing System | การบำรุงรักษาและระบบการผลิตอัตโนมัติ | 维护及自动化制造系统"
    },
    {
        "id":9905,
        "name":"10413 (Thai Program)  :  Mechatronics And Automation Engineering | วิศวกรรมเมคคาทรอนิกส์และระบบอัตโนมัติ | 机电一体化与自动化工程"
    },
    {
        "id":9906,
        "name":"10414 (English Program)  :  Mechatronics And Automation Engineering | วิศวกรรมเมคคาทรอนิกส์และออโตเมชั่น | 机电与自动化工程"
    },
    {
        "id":9907,
        "name":"10415 (Thai Program)  :  Data Analysis Science And Digital Technology | วิทยาการการวิเคราะห์ข้อมูลและเทคโนโลยีดิจิทัล | 数据分析科学与数字技术"
    },
    {
        "id":9908,
        "name":"10416 (English Program)  :  Data Analysis Science And Digital Technology | วิทยาศาสตร์การวิเคราะห์ข้อมูลและเทคโนโลยีดิจิทัล | 数据分析科学与数字技术"
    },
    {
        "id":9909,
        "name":"10417 (Thai Program)  :  Innovative Engineering For Agriculture And Industry | วิศวกรรมนวัตกรรมเพื่อการเกษตรและอุตสาหกรรม | 农业和工业创新工程"
    },
    {
        "id":9910,
        "name":"10418 (English Program)  :  Innovative Engineering For Agriculture And Industry | วิศวกรรมนวัตกรรมเพื่อการเกษตรและอุตสาหกรรม | 农业和工业创新工程"
    },
    {
        "id":9911,
        "name":"10419 (Thai Program)  :  Interdisciplinary Studies For Halal Management | สหวิทยาการเพื่อการจัดการฮาลาล | 清真管理的跨学科研究"
    },
    {
        "id":9912,
        "name":"10420 (English Program)  :  Interdisciplinary For Halal Management | สหวิทยาการเพื่อการจัดการฮาลาล | 清真管理跨学科"
    },
    {
        "id":9913,
        "name":"10421 (Thai Program)  :  Electronics And Computer Industry Education | ครุศาสตร์อุตสาหกรรมอิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子计算机行业教育"
    },
    {
        "id":9914,
        "name":"10422 (English Program)  :  Electronics And Computers Technical Education | การศึกษาด้านเทคนิคอิเล็กทรอนิกส์และคอมพิวเตอร์ | 电子和计算机技术教育"
    },
    {
        "id":9915,
        "name":"10423 (Thai Program)  :  Industrial Pipe Engineering | วิศวกรรมท่ออุตสาหกรรม | 工业管道工程"
    },
    {
        "id":9916,
        "name":"10424 (English Program)  :  Industrial Piping Engineering | วิศวกรรมระบบท่ออุตสาหกรรม | 工业管道工程"
    },
    {
        "id":9917,
        "name":"10425 (Thai Program)  :  Intelligent Agricultural Machinery Engineering | วิศวกรรมเครื่องจักรกลเกษตรอัจฉริยะ | 智能农机工程"
    },
    {
        "id":9918,
        "name":"10426 (English Program)  :  Smart Agricultural Machinery Engineering | วิศวกรรมเครื่องจักรการเกษตรอัจฉริยะ | 智能农业机械工程"
    },
    {
        "id":9919,
        "name":"10427 (English Program)  :  Health And Aesthetic Technology | เทคโนโลยีด้านสุขภาพและความงาม | 健康与美容科技"
    },
    {
        "id":9920,
        "name":"10428 (Thai Program)  :  Prepare Engineering | เตรียมวิศวกรรมศาสตร์ | 准备工程"
    },
    {
        "id":9921,
        "name":"10429 (English Program)  :  Engineering Preparation | การเตรียมการทางวิศวกรรม | 工程准备"
    },
    {
        "id":9922,
        "name":"10430 (English Program)  :  Practical Nursing | การพยาบาลวิชาชีพ | 实用护理"
    },
    {
        "id":9923,
        "name":"10431 (English Program)  :  Peace Studies | การศึกษาสันติภาพ | 和平研究"
    },
    {
        "id":9924,
        "name":"10432 (Thai Program)  :  Social Innovation And Creative Culture | นวัตกรรมสังคมและวัฒนธรรมสร้างสรรค์ | 社会创新与创意文化"
    },
    {
        "id":9925,
        "name":"10433 (Thai Program)  :  Theravada Tripitaka | พระไตรปิฎกเถรวาท | 南传大藏经"
    },
    {
        "id":9926,
        "name":"10434 (Thai Program)  :  World Studies | โลกศึกษา | 世界研究"
    },
    {
        "id":9927,
        "name":"10435 (Thai Program)  :  Buddhist Communication Innovation | พุทธนวัตกรรมการสื่อสาร | 佛教传播创新"
    },
    {
        "id":9928,
        "name":"10436 (Thai Program)  :  Innovation Management And Business Development | การจัดการนวัตกรรมและการพัฒนาธุรกิจ | 创新管理和业务发展"
    },
    {
        "id":9929,
        "name":"10437 (English Program)  :  Innovation Management And Business Development | การจัดการนวัตกรรมและการพัฒนาธุรกิจ | 创新管理和业务发展"
    },
    {
        "id":9930,
        "name":"10438 (Thai Program)  :  Business And Financial Management In The Digital Age | การจัดการธุรกิจและการเงินยุคดิจิทัล | 数字时代的商业和财务管理"
    },
    {
        "id":9931,
        "name":"10439 (English Program)  :  Business Management And Finance In The Digital Era | การจัดการธุรกิจและการเงินในยุคดิจิทัล | 数字时代的企业管理和财务"
    },
    {
        "id":9932,
        "name":"10440 (Thai Program)  :  Tourism And Service Management In The Digital Age | การจัดการการท่องเที่ยวและการบริการยุคดิจิทัล | 数字时代的旅游和服务管理"
    },
    {
        "id":9933,
        "name":"10441 (English Program)  :  Tourism And Hospitality Management In Digital Era | การจัดการการท่องเที่ยวและการบริการในยุคดิจิทัล | 数字时代的旅游和酒店管理"
    },
    {
        "id":9934,
        "name":"10442 (English Program)  :  Communication And Innovation | การสื่อสารและนวัตกรรม | 沟通与创新"
    },
    {
        "id":9935,
        "name":"10443 (English Program)  :  Governance And Development | การกำกับดูแลและการพัฒนา | 治理与发展"
    },
    {
        "id":9936,
        "name":"10444 (Thai Program)  :  Administration And Development | การบริหารและการพัฒนา | 管理与发展"
    },
    {
        "id":9937,
        "name":"10445 (English Program)  :  Japanese Language, Culture And Communication | ภาษาญี่ปุ่น วัฒนธรรม และการสื่อสาร | 日语、文化与交流"
    },
    {
        "id":9938,
        "name":"10446 (Thai Program)  :  Communication, Culture And Japanese Language | การสื่อสาร วัฒนธรรม และภาษาญี่ปุ่น | 交流、文化和日语"
    },
    {
        "id":9939,
        "name":"10447 (Thai Program)  :  English Studies And English Teaching | ภาษาอังกฤษศึกษาและการสอนภาษาอังกฤษ | 英语研究与英语教学"
    },
    {
        "id":9940,
        "name":"10448 (English Program)  :  English Language Studies And Teaching | การศึกษาและการสอนภาษาอังกฤษ | 英语语言研究与教学"
    },
    {
        "id":9941,
        "name":"10449 (English Program)  :  Politics And Development Strategy | การเมืองและยุทธศาสตร์การพัฒนา | 政治与发展战略"
    },
    {
        "id":9942,
        "name":"10450 (English Program)  :  Economics And Management | เศรษฐศาสตร์และการจัดการ | 经济与管理"
    },
    {
        "id":9943,
        "name":"10451 (Thai Program)  :  Economics And Administration | เศรษฐศาสตร์และการบริหาร | 经济与管理"
    },
    {
        "id":9944,
        "name":"10452 (Thai Program)  :  Health, Environment And Safety | สุขภาพ สิ่งแวดล้อม และความปลอดภัย | 健康、环境和安全"
    },
    {
        "id":9945,
        "name":"10453 (English Program)  :  Health, Environment And Safety | สุขภาพ สิ่งแวดล้อม และความปลอดภัย | 健康、环境和安全"
    },
    {
        "id":9946,
        "name":"10454 (Thai Program)  :  Multimedia, Animation And Gaming Technology | เทคโนโลยีมัลติมีเดีย แอนิเมชัน และเกม | 多媒体、动画和游戏技术"
    },
    {
        "id":9947,
        "name":"10455 (English Program)  :  Multimedia Technology, Animation And Game | เทคโนโลยีมัลติมีเดีย แอนิเมชัน และเกม | 多媒体技术、动画与游戏"
    },
    {
        "id":9948,
        "name":"10456 (English Program)  :  Agriculture And Innovative | การเกษตรและนวัตกรรม | 农业与创新"
    },
    {
        "id":9949,
        "name":"10457 (Thai Program)  :  Food Science And Innovation | วิทยาศาสตร์อาหารและนวัตกรรม | 食品科学与创新"
    },
    {
        "id":9950,
        "name":"10458 (English Program)  :  Food Science And Innovation | วิทยาศาสตร์การอาหารและนวัตกรรม | 食品科学与创新"
    },
    {
        "id":9951,
        "name":"10459 (Thai Program)  :  Petrochemicals And Polymers | ปิโตรเคมีและพอลิเมอร์ | 石化和聚合物"
    },
    {
        "id":9952,
        "name":"10460 (English Program)  :  Petrochemical And Polymer | ปิโตรเคมีและโพลีเมอร์ | 石化和聚合物"
    },
    {
        "id":9953,
        "name":"10461 (Thai Program)  :  Industrial Design, Products, Furniture And Packaging | ออกแบบอุตสาหกรรม ผลิตภัณฑ์ เฟอร์นิเจอร์และบรรจุภัณฑ์ | 工业设计、产品、家具和包装"
    },
    {
        "id":9954,
        "name":"10462 (English Program)  :  Industrial, Product, Furniture And Packaging Design | การออกแบบอุตสาหกรรม ผลิตภัณฑ์ เฟอร์นิเจอร์ และบรรจุภัณฑ์ | 工业、产品、家具和包装设计"
    },
    {
        "id":9955,
        "name":"10463 (Thai Program)  :  Digital Content And Media | ดิจิทัลคอนเทนต์และสื่อ | 数字内容和媒体"
    },
    {
        "id":9956,
        "name":"10464 (English Program)  :  Digital Content And Media | เนื้อหาดิจิทัลและสื่อ | 数字内容和媒体"
    },
    {
        "id":9957,
        "name":"10465 (Thai Program)  :  Community Public Health | การสาธารณสุขชุมชน | 社区公共卫生"
    },
    {
        "id":9958,
        "name":"10466 (Thai Program)  :  Information Technology Innovation Management | การจัดการนวัตกรรมเทคโนโลยีสารสนเทศ | 信息技术创新管理"
    },
    {
        "id":9959,
        "name":"10467 (English Program)  :  Management Of Information Technology Innovation | การจัดการนวัตกรรมเทคโนโลยีสารสนเทศ | 信息技术创新管理"
    },
    {
        "id":9960,
        "name":"10469 (Thai Program)  :  Materials Science And Innovation | วัสดุศาสตร์และนวัตกรรม | 材料科学与创新"
    },
    {
        "id":9961,
        "name":"10470 (Thai Program)  :  Innovative Engineering For Sustainability | นวัตวิศวกรรมเพื่อความยั่งยืน | 可持续发展的创新工程"
    },
    {
        "id":9962,
        "name":"10471 (English Program)  :  Innovative Engineering For Sustainability | วิศวกรรมที่เป็นนวัตกรรมเพื่อความยั่งยืน | 可持续发展的创新工程"
    },
    {
        "id":9963,
        "name":"10472 (English Program)  :  Innovation For Child Development And Protection | นวัตกรรมเพื่อการพัฒนาและปกป้องเด็ก | 儿童发展和保护的创新"
    },
    {
        "id":9964,
        "name":"10473 (Thai Program)  :  Islamic Educational Administration | การบริหารการศึกษาอิสลาม | 伊斯兰教育管理"
    },
    {
        "id":9965,
        "name":"10474 (English Program)  :  Islamic Education Administration | การบริหารการศึกษาอิสลาม | 伊斯兰教育管理局"
    },
    {
        "id":9966,
        "name":"10475 (Thai Program)  :  Plant Production Management Technology | เทคโนโลยีการจัดการผลิตพืช | 工厂生产管理技术"
    },
    {
        "id":9967,
        "name":"10476 (English Program)  :  Management Technology For Plant Production | เทคโนโลยีการจัดการเพื่อการผลิตในโรงงาน | 植物生产管理技术"
    },
    {
        "id":9968,
        "name":"10477 (English Program)  :  Agri-Intelligence Engineering | วิศวกรรมเกษตรอัจฉริยะ | 农业智能工程"
    },
    {
        "id":9969,
        "name":"10478 (English Program)  :  3D-Based Communication Design And Integrated | การออกแบบการสื่อสารแบบ 3 มิติและบูรณาการ | 基于 3D 的通信设计与集成"
    },
    {
        "id":9970,
        "name":"10479 (Thai Program)  :  Three-Dimensional Information Design And Integrated Media | การออกแบบสนเทศสามมิติและสื่อบูรณาการ | 三维信息设计与整合媒体"
    },
    {
        "id":9971,
        "name":"10480 (English Program)  :  Fishery Science And Aquatic Resources | วิทยาศาสตร์การประมงและทรัพยากรทางน้ำ | 渔业科学和水产资源"
    },
    {
        "id":9972,
        "name":"10481 (Thai Program)  :  Health Science And Spa | วิทยาศาสตร์สุขภาพและสปา | 健康科学与水疗"
    },
    {
        "id":9973,
        "name":"10482 (English Program)  :  Health Science And Spa | วิทยาศาสตร์สุขภาพและสปา | 健康科学与水疗"
    },
    {
        "id":9974,
        "name":"10483 (Thai Program)  :  Special Education-Thai Language | การศึกษาพิเศษ-ภาษาไทย | 特殊教育-泰语"
    },
    {
        "id":9975,
        "name":"10484 (English Program)  :  Special Education And Thai Language | การศึกษาพิเศษและภาษาไทย | 特殊教育和泰语"
    },
    {
        "id":9976,
        "name":"10485 (Thai Program)  :  Tourism Industry Management | การจัดการอุตสาหกรรมท่องเที่ยว | 旅游产业管理"
    },
    {
        "id":9977,
        "name":"10486 (English Program)  :  Food Product Management Technology | เทคโนโลยีการจัดการผลิตภัณฑ์อาหาร | 食品管理技术"
    },
    {
        "id":9978,
        "name":"10487 (Thai Program)  :  English For Service Businesses | ภาษาอังกฤษเพื่อธุรกิจบริการ | 服务业英语"
    },
    {
        "id":9979,
        "name":"10488 (Thai Program)  :  Industrial Applied Science | วิทยาศาสตร์ประยุกต์เชิงอุตสาหกรรม | 工业应用科学"
    },
    {
        "id":9980,
        "name":"10489 (English Program)  :  Industrial Applied Science | วิทยาศาสตร์ประยุกต์อุตสาหกรรม | 工业应用科学"
    },
    {
        "id":9981,
        "name":"10490 (English Program)  :  Thai Traditional And Folk Music | ดนตรีไทยและดนตรีพื้นบ้าน | 泰国传统和民间音乐"
    },
    {
        "id":9982,
        "name":"10491 (Thai Program)  :  Thai Music And Folk Music | ดนตรีไทยและดนตรีพื้นบ้าน | 泰国音乐和民间音乐"
    },
    {
        "id":9983,
        "name":"10492 (English Program)  :  Language Literacy And Communication | ความรู้ทางภาษาและการสื่อสาร | 语言素养和沟通"
    },
    {
        "id":9984,
        "name":"10493 (Thai Program)  :  Animation And Creative Media | แอนิเมชันและสื่อสร้างสรรค์ | 动画和创意媒体"
    },
    {
        "id":9985,
        "name":"10494 (English Program)  :  Animation And Creative Media | แอนิเมชั่นและสื่อสร้างสรรค์ | 动画与创意媒体"
    },
    {
        "id":9986,
        "name":"10495 (Thai Program)  :  Leadership And Innovation In Educational Administration | ภาวะผู้นำและนวัตกรรมการบริหารการศึกษา | 教育管理的领导力和创新"
    },
    {
        "id":9987,
        "name":"10496 (English Program)  :  Leadership And Innovation In Educational Administration | ความเป็นผู้นำและนวัตกรรมในการบริหารการศึกษา | 教育管理的领导力和创新"
    },
    {
        "id":9988,
        "name":"10497 (English Program)  :  Educational Administration Innovation | นวัตกรรมการบริหารการศึกษา | 教育管理创新"
    },
    {
        "id":9989,
        "name":"10498 (English Program)  :  Food Industry Technology | เทคโนโลยีอุตสาหกรรมอาหาร | 食品工业技术"
    },
    {
        "id":9990,
        "name":"10499 (Thai Program)  :  Music And Performing Arts | ดนตรีและศิลปะการแสดง | 音乐和表演艺术"
    },
    {
        "id":9991,
        "name":"10500 (Thai Program)  :  General Management And Entrepreneurship | การจัดการทั่วไปและการประกอบการ | 一般管理和创业"
    },
    {
        "id":9992,
        "name":"10501 (English Program)  :  General Management And Entrepreneurship | การจัดการทั่วไปและการเป็นผู้ประกอบการ | 一般管理和创业"
    },
    {
        "id":9993,
        "name":"10502 (Thai Program)  :  English For Careers And International Communication | ภาษาอังกฤษเพื่ออาชีพและการสื่อสารนานาชาติ | 职业和国际交流英语"
    },
    {
        "id":9994,
        "name":"10503 (Thai Program)  :  Digital Game Simulation | ดิจิทัลเกมซิมูเลชัน | 数字游戏模拟"
    },
    {
        "id":9995,
        "name":"10504 (English Program)  :  Digital Game Simulation | การจำลองเกมดิจิทัล | 数字游戏模拟"
    },
    {
        "id":9996,
        "name":"10505 (English Program)  :  Tourism Management And Service Innovation | การจัดการการท่องเที่ยวและนวัตกรรมการบริการ | 旅游管理与服务创新"
    },
    {
        "id":9997,
        "name":"10506 (Thai Program)  :  Tourism Management And Service Innovation | การจัดการการท่องเที่ยวและนวัตกรรมบริการ | 旅游管理与服务创新"
    },
    {
        "id":9998,
        "name":"10507 (Thai Program)  :  Food Technology And Innovation | เทคโนโลยีอาหารและนวัตกรรม | 食品技术与创新"
    },
    {
        "id":9999,
        "name":"10508 (Thai Program)  :  Event Production And Management | การผลิตและการจัดการอีเว้นท์ | 活动制作和管理"
    },
    {
        "id":10000,
        "name":"10509 (English Program)  :  Event Production And Management | การผลิตและการจัดการงานอีเว้นท์ | 活动制作和管理"
    },
    {
        "id":10001,
        "name":"10510 (Thai Program)  :  Railway Business Innovation Engineering | วิศวกรรมนวัตกรรมธุรกิจระบบราง | 铁路业务创新工程"
    },
    {
        "id":10002,
        "name":"10511 (English Program)  :  Rail Business Innovation Engineering | วิศวกรรมนวัตกรรมธุรกิจระบบราง | 铁路业务创新工程"
    },
    {
        "id":10003,
        "name":"10512 (English Program)  :  City And Infrastructure Management | การจัดการเมืองและโครงสร้างพื้นฐาน | 城市和基础设施管理"
    },
    {
        "id":10004,
        "name":"10513 (Thai Program)  :  Urban And Infrastructure Management | การจัดการเมืองและโครงสร้างพื้นฐาน | 城市和基础设施管理"
    },
    {
        "id":10005,
        "name":"10514 (English Program)  :  Exercise And Sport Sciences | การออกกำลังกายและวิทยาศาสตร์การกีฬา | 锻炼和运动科学"
    },
    {
        "id":10006,
        "name":"10515 (English Program)  :  Agricultural And Environmental Science | วิทยาศาสตร์เกษตรและสิ่งแวดล้อม | 农业与环境科学"
    },
    {
        "id":10007,
        "name":"10516 (Thai Program)  :  Agricultural And Environmental Sciences | วิทยาศาสตร์การเกษตรและสิ่งแวดล้อม | 农业与环境科学"
    },
    {
        "id":10008,
        "name":"10517 (English Program)  :  Chemistry For Teacher | เคมีสำหรับครู | 教师化学"
    },
    {
        "id":10009,
        "name":"10518 (English Program)  :  Health Education And Health Promotion | การศึกษาด้านสุขภาพและการส่งเสริมสุขภาพ | 健康教育和健康促进"
    },
    {
        "id":10010,
        "name":"10519 (English Program)  :  Urban And Regional Planning | การวางผังเมืองและระดับภูมิภาค | 城市和区域规划"
    },
    {
        "id":10011,
        "name":"10520 (Thai Program)  :  Agricultural Promotion And Development | การส่งเสริมและพัฒนาการเกษตร | 农业推广与发展"
    },
    {
        "id":10012,
        "name":"10521 (Thai Program)  :  Digital Media Engineering | วิศวกรรมสื่อดิจิทัล | 数字媒体工程"
    },
    {
        "id":10013,
        "name":"10522 (English Program)  :  Digital Media Engineering | วิศวกรรมสื่อดิจิทัล | 数字媒体工程"
    },
    {
        "id":10014,
        "name":"10523 (Thai Program)  :  International Economics, Innovation And Sustainability | เศรษฐศาสตร์ระหว่างประเทศ นวัตกรรม และความยั่งยืน | 国际经济、创新和可持续发展"
    },
    {
        "id":10015,
        "name":"10524 (English Program)  :  International Economics, Innovation And Sustainability | เศรษฐศาสตร์ระหว่างประเทศ นวัตกรรม และความยั่งยืน | 国际经济、创新与可持续发展"
    },
    {
        "id":10016,
        "name":"10525 (English Program)  :  Oral Sciences | วิทยาศาสตร์ช่องปาก | 口腔科学"
    },
    {
        "id":10017,
        "name":"10526 (Thai Program)  :  Oral Science | วิทยาศาสตร์ช่องปาก | 口腔科学"
    },
    {
        "id":10018,
        "name":"10527 (Thai Program)  :  Integrated Research For Design, Architecture, And Planning Of Regions And Cities | วิจัยบูรณาการเพื่อการออกแบบ สถาปัตยกรรม และวางแผนภาคและเมือง | 区域和城市的设计、建筑和规划的综合研究"
    },
    {
        "id":10019,
        "name":"10528 (English Program)  :  Integrated Research For Design, Architecture, Regional And City Planning | การวิจัยเชิงบูรณาการเพื่อการออกแบบ สถาปัตยกรรม การวางผังภูมิภาคและเมือง | 设计、建筑、区域和城市规划的综合研究"
    },
    {
        "id":10020,
        "name":"10529 (English Program)  :  Human Movement Sciences | วิทยาศาสตร์การเคลื่อนไหวของมนุษย์ | 人体运动科学"
    },
    {
        "id":10021,
        "name":"10530 (Thai Program)  :  Human Movement Science | วิทยาศาสตร์การเคลื่อนไหวของมนุษย์ | 人体运动科学"
    },
    {
        "id":10022,
        "name":"10531 (English Program)  :  Aquatic Animal Production Technology | เทคโนโลยีการผลิตสัตว์น้ำ | 水产动物生产技术"
    },
    {
        "id":10023,
        "name":"10532 (English Program)  :  Biology For Teachers | ชีววิทยาสำหรับครู | 教师生物学"
    },
    {
        "id":10024,
        "name":"10533 (Thai Program)  :  English For Business Management | ภาษาอังกฤษเพื่อการจัดการธุรกิจ | 商业管理英语"
    },
    {
        "id":10025,
        "name":"10534 (English Program)  :  English For Business Management | ภาษาอังกฤษเพื่อการจัดการธุรกิจ | 商业管理英语"
    },
    {
        "id":10026,
        "name":"10535 (Thai Program)  :  Innovation, Technology And Learning Science | นวัตกรรม เทคโนโลยีและวิทยาการเรียนรู้ | 创新、技术和学习科学"
    },
    {
        "id":10027,
        "name":"10536 (English Program)  :  Innovation, Technology, And Learning Sciences | นวัตกรรม เทคโนโลยี และการเรียนรู้วิทยาศาสตร์ | 创新、技术和学习科学"
    },
    {
        "id":10028,
        "name":"10537 (English Program)  :  Tourism, Mice And Hospitality Innovation Management | การจัดการนวัตกรรมการท่องเที่ยว ไมซ์ และการบริการ | 旅游、会展和酒店业创新管理"
    },
    {
        "id":10029,
        "name":"10538 (Thai Program)  :  Management Of Tourism, Mice, And Service Innovations | การจัดการนวัตกรรมการท่องเที่ยว ไมซ์ และบริการ | 旅游管理、会奖旅游和服务创新"
    },
    {
        "id":10030,
        "name":"10539 (English Program)  :  Fiscal Management | การจัดการทางการคลัง | 财政管理"
    },
    {
        "id":10031,
        "name":"10540 (Thai Program)  :  Agricultural Economics And Agribusiness | เศรษฐศาสตร์เกษตรและธุรกิจเกษตร | 农业经济学和农业综合企业"
    },
    {
        "id":10032,
        "name":"10541 (English Program)  :  Agricultural Economics And Agribusiness | เศรษฐศาสตร์เกษตรและธุรกิจการเกษตร | 农业经济和农业企业"
    },
    {
        "id":10033,
        "name":"10542 (Thai Program)  :  Environmental Science And Natural Resources | วิทยาศาสตร์สิ่งแวดล้อมและทรัพยากรธรรมชาติ | 环境科学与自然资源"
    },
    {
        "id":10034,
        "name":"10543 (Thai Program)  :  Performance | การแสดง | 表现"
    },
    {
        "id":10035,
        "name":"10544 (English Program)  :  Performance Practice | การปฏิบัติด้านประสิทธิภาพ | 表现练习"
    },
    {
        "id":10036,
        "name":"10545 (Thai Program)  :  Production System Technology And Industrial Management | เทคโนโลยีระบบการผลิตและการจัดการอุตสาหกรรม | 生产系统技术与工业管理"
    },
    {
        "id":10037,
        "name":"10546 (English Program)  :  Production System Technology And Industrial Managemen | เทคโนโลยีระบบการผลิตและการจัดการอุตสาหกรรม | 生产系统技术与产业管理"
    },
    {
        "id":10038,
        "name":"10547 (Thai Program)  :  Tourism Innovation Management | การจัดการนวัตกรรมการท่องเที่ยว | 旅游创新管理"
    },
    {
        "id":10039,
        "name":"10548 (English Program)  :  Tourism Innovation Management | การจัดการนวัตกรรมการท่องเที่ยว | 旅游创新管理"
    },
    {
        "id":10040,
        "name":"10549 (Thai Program)  :  Consumer Protection And Health Management | การคุ้มครองผู้บริโภคและการจัดการด้านสุขภาพ | 消费者保护与健康管理"
    },
    {
        "id":10041,
        "name":"10550 (English Program)  :  Health Consumer Protection And Health Management | การคุ้มครองผู้บริโภคด้านสุขภาพและการจัดการสุขภาพ | 健康消费者保护与健康管理"
    },
    {
        "id":10042,
        "name":"10551 (Thai Program)  :  Beauty And Health Science | วิทยาศาสตร์ความงามและสุขภาพ | 美容与健康科学"
    },
    {
        "id":10043,
        "name":"10552 (Thai Program)  :  Pharmacy And Health Systems | เภสัชกรรมและระบบสุขภาพ | 药房和卫生系统"
    },
    {
        "id":10044,
        "name":"10553 (English Program)  :  Pharmacy And Health System | เภสัชศาสตร์และระบบสุขภาพ | 药房和卫生系统"
    },
    {
        "id":10045,
        "name":"10554 (Thai Program)  :  Sports Science Innovation And Health | วิทยาศาสตร์การกีฬา นวัตกรรมและสุขภาพ | 运动科学创新与健康"
    },
    {
        "id":10046,
        "name":"10555 (English Program)  :  Sports Innovation And Health Science | นวัตกรรมการกีฬาและวิทยาศาสตร์สุขภาพ | 体育创新与健康科学"
    },
    {
        "id":10047,
        "name":"10556 (Thai Program)  :  Systematic Agriculture For Sustainable Development | เกษตรเชิงระบบเพื่อการพัฒนาที่ยั่งยืน | 系统农业促进可持续发展"
    },
    {
        "id":10048,
        "name":"10557 (English Program)  :  System Approaches In Agriculture For Sustainable Development | แนวทางระบบเกษตรเพื่อการพัฒนาที่ยั่งยืน | 农业可持续发展的系统方法"
    },
    {
        "id":10049,
        "name":"10558 (Thai Program)  :  Clinical Pathology And Management | พยาธิวิทยาคลินิกและการจัดการ | 临床病理学与管理"
    },
    {
        "id":10050,
        "name":"10559 (English Program)  :  Clinical Pathology And Management | พยาธิวิทยาทางคลินิกและการจัดการ | 临床病理学和治疗"
    },
    {
        "id":10051,
        "name":"10560 (English Program)  :  Anesthesiology | วิสัญญีวิทยา | 麻醉学"
    },
    {
        "id":10052,
        "name":"10561 (Thai Program)  :  Holistic Health Tourism Management | การจัดการการท่องเที่ยวเชิงสุขภาพแบบองค์รวม | 整体健康旅游管理"
    },
    {
        "id":10053,
        "name":"10562 (English Program)  :  Holistic Health Tourism Management | การจัดการการท่องเที่ยวเชิงสุขภาพแบบองค์รวม | 整体健康旅游管理"
    },
    {
        "id":10054,
        "name":"10563 (Thai Program)  :  Production System Integration Engineering | วิศวกรรมบูรณาการระบบการผลิต | 生产系统集成工程"
    },
    {
        "id":10055,
        "name":"10564 (English Program)  :  Manufacturing System Integration Engineering | วิศวกรรมบูรณาการระบบการผลิต | 制造系统集成工程"
    },
    {
        "id":10056,
        "name":"10565 (English Program)  :  Risk And Disaster Management | การจัดการความเสี่ยงและภัยพิบัติ | 风险和灾害管理"
    },
    {
        "id":10057,
        "name":"10566 (Thai Program)  :  Risk And Disaster Management | การจัดการความเสี่ยงและภัยพิบัติ | 风险和灾害管理"
    },
    {
        "id":10058,
        "name":"10567 (Thai Program)  :  Petroleum And Energy Technology | เทคโนโลยีปิโตรเลียมและพลังงาน | 石油与能源技术"
    },
    {
        "id":10059,
        "name":"10568 (English Program)  :  Petroleum And Energy Technology | เทคโนโลยีปิโตรเลียมและพลังงาน | 石油和能源技术"
    },
    {
        "id":10060,
        "name":"10569 (English Program)  :  Politics And Governance | การเมืองและการปกครอง | 政治与治理"
    },
    {
        "id":10061,
        "name":"10570 (English Program)  :  Architectural Design | การออกแบบสถาปัตยกรรม | 建筑设计"
    },
    {
        "id":10062,
        "name":"10571 (English Program)  :  Molecular Science Of Medical Microbiology And Immunology | วิทยาศาสตร์ระดับโมเลกุลของจุลชีววิทยาทางการแพทย์และภูมิคุ้มกันวิทยา | 医学微生物学和免疫学的分子科学"
    },
    {
        "id":10063,
        "name":"10572 (English Program)  :  Automotive Design And Manufacturing Engineering | การออกแบบยานยนต์และวิศวกรรมการผลิต | 汽车设计与制造工程"
    },
    {
        "id":10064,
        "name":"10573 (Thai Program)  :  Materials Science And Technology | วัสดุศาสตร์และเทคโนโลยี | 材料科学与技术"
    },
    {
        "id":10065,
        "name":"10574 (English Program)  :  Materials Science And Technology | วัสดุ วิทยาศาสตร์และเทคโนโลยี | 材料科学与技术"
    },
    {
        "id":10066,
        "name":"10575 (English Program)  :  Biomedical Sciences And Biotechnology | วิทยาศาสตร์ชีวการแพทย์และเทคโนโลยีชีวภาพ | 生物医学科学和生物技术"
    },
    {
        "id":10067,
        "name":"10576 (Thai Program)  :  Biomedicine And Biotechnology | ชีวเวชศาสตร์และชีวเทคโนโลยี | 生物医学和生物技术"
    },
    {
        "id":10068,
        "name":"10577 (English Program)  :  Microbiology And Microbial Technology | จุลชีววิทยาและเทคโนโลยีจุลินทรีย์ | 微生物学和微生物技术"
    },
    {
        "id":10069,
        "name":"10578 (Thai Program)  :  Technology Management And Entrepreneurial Innovation | การจัดการเทคโนโลยีและนวัตกรรมผู้ประกอบการ | 技术管理与创业创新"
    },
    {
        "id":10070,
        "name":"10579 (English Program)  :  Technology Management And Innopreneurship | การจัดการเทคโนโลยีและการไม่ประกอบอาชีพ | 技术管理和创新创业"
    },
    {
        "id":10071,
        "name":"10580 (Thai Program)  :  Brand And Marketing Management | การจัดการแบรนด์และการตลาด | 品牌与营销管理"
    },
    {
        "id":10072,
        "name":"10581 (English Program)  :  Brand And Marketing Management | การจัดการแบรนด์และการตลาด | 品牌与营销管理"
    },
    {
        "id":10073,
        "name":"10582 (English Program)  :  Defense Engineering And Technology | วิศวกรรมการป้องกันและเทคโนโลยี | 国防工程与技术"
    },
    {
        "id":10074,
        "name":"10583 (Thai Program)  :  Education Statistics And Information | สถิติและสารสนเทศการศึกษา | 教育统计与信息"
    },
    {
        "id":10075,
        "name":"10584 (English Program)  :  Educational Statistics And Information | สถิติและข้อมูลการศึกษา | 教育统计和信息"
    },
    {
        "id":10076,
        "name":"10585 (English Program)  :  Urban Planning And Design | การวางแผนและการออกแบบเมือง | 城市规划与设计"
    },
    {
        "id":10077,
        "name":"10586 (Thai Program)  :  Urban Planning And Design | การวางผังและออกแบบเมือง | 城市规划与设计"
    },
    {
        "id":10078,
        "name":"10587 (Thai Program)  :  Methodology For Developing Educational Innovations | วิธีวิทยาการพัฒนานวัตกรรมทางการศึกษา | 发展教育创新的方法论"
    },
    {
        "id":10079,
        "name":"10588 (English Program)  :  Methodology For Innovation Development In Education | ระเบียบวิธีเพื่อการพัฒนานวัตกรรมทางการศึกษา | 教育创新发展方法"
    },
    {
        "id":10080,
        "name":"10589 (Thai Program)  :  Retail Business And Online Market | ธุรกิจค้าปลีกและตลาดออนไลน์ | 零售业务和网上市场"
    },
    {
        "id":10081,
        "name":"10590 (English Program)  :  Retail Business And Online Marketing | ธุรกิจค้าปลีกและการตลาดออนไลน์ | 零售业务和在线营销"
    },
    {
        "id":10082,
        "name":"10591 (Thai Program)  :  Community Ecotourism Management | การจัดการท่องเที่ยวเชิงนิเวศชุมชน | 社区生态旅游管理"
    },
    {
        "id":10083,
        "name":"10592 (English Program)  :  Community Ecotourism Management | การจัดการการท่องเที่ยวเชิงนิเวศชุมชน | 社区生态旅游管理"
    },
    {
        "id":10084,
        "name":"10593 (Thai Program)  :  Healthy Food And Nutrition | อาหารสุขภาพและโภชนาการ | 健康食品和营养"
    },
    {
        "id":10085,
        "name":"10594 (English Program)  :  Functional Food And Nutrition | อาหารที่มีประโยชน์และโภชนาการ | 功能性食品和营养"
    },
    {
        "id":10086,
        "name":"10595 (Thai Program)  :  Fishery Innovation | นวัตกรรมการประมง | 渔业创新"
    },
    {
        "id":10087,
        "name":"10596 (English Program)  :  Innovative Fisheries | นวัตกรรมการประมง | 创新渔业"
    },
    {
        "id":10088,
        "name":"10597 (Thai Program)  :  Rubber Industry Engineering And Management | วิศวกรรมและการจัดการอุตสาหกรรมยาง | 橡胶工业工程与管理"
    },
    {
        "id":10089,
        "name":"10598 (English Program)  :  Rubber Industry Engineering And Management | วิศวกรรมและการจัดการอุตสาหกรรมยาง | 橡胶工业工程与管理"
    },
    {
        "id":10090,
        "name":"10599 (Thai Program)  :  Health Sciences And Clinical Research | วิทยาศาสตร์สุขภาพและการวิจัยทางคลินิก | 健康科学和临床研究"
    },
    {
        "id":10091,
        "name":"10600 (English Program)  :  Health Sciences And Clinical Research | วิทยาศาสตร์สุขภาพและการวิจัยทางคลินิก | 健康科学和临床研究"
    },
    {
        "id":10092,
        "name":"10601 (Thai Program)  :  Computer And Information Science For Management | คอมพิวเตอร์และวิทยาการสารสนเทศเพื่อการจัดการ | 管理计算机与信息科学"
    },
    {
        "id":10093,
        "name":"10602 (English Program)  :  Computer And Informatics For Management | คอมพิวเตอร์และสารสนเทศเพื่อการจัดการ | 管理计算机和信息学"
    },
    {
        "id":10094,
        "name":"10603 (Thai Program)  :  Technology And Innovation For Learning | เทคโนโลยีและนวัตกรรมเพื่อการเรียนรู้ | 技术和创新促进学习"
    },
    {
        "id":10095,
        "name":"10604 (English Program)  :  Technology And Innovation For Learning | เทคโนโลยีและนวัตกรรมเพื่อการเรียนรู้ | 学习的技术和创新"
    },
    {
        "id":10096,
        "name":"10605 (Thai Program)  :  Administration And Management Of Islamic Education | การบริหารและการจัดการการศึกษาอิสลาม | 伊斯兰教育的行政和管理"
    },
    {
        "id":10097,
        "name":"10606 (English Program)  :  Islamic Educational Administration And Management | การบริหารและการจัดการการศึกษาอิสลาม | 伊斯兰教育行政和管理"
    },
    {
        "id":10098,
        "name":"10607 (English Program)  :  Environmental Management Technology | เทคโนโลยีการจัดการสิ่งแวดล้อม | 环境管理技术"
    },
    {
        "id":10099,
        "name":"10608 (Thai Program)  :  Research And Evaluation | การวิจัยและประเมิน | 研究与评估"
    },
    {
        "id":10100,
        "name":"10609 (English Program)  :  Research And Evaluation | การวิจัยและการประเมินผล | 研究与评估"
    },
    {
        "id":10101,
        "name":"10610 (Thai Program)  :  Environment For Sustainability | สิ่งแวดล้อมเพื่อความยั่งยืน | 可持续发展环境"
    },
    {
        "id":10102,
        "name":"10611 (English Program)  :  Environment For Sustainability | สิ่งแวดล้อมเพื่อความยั่งยืน | 可持续发展环境"
    },
    {
        "id":10103,
        "name":"10612 (Thai Program)  :  Fishery Science And Technology | วิทยาศาสตร์และเทคโนโลยีประมง | 水产科学与技术"
    },
    {
        "id":10104,
        "name":"10613 (English Program)  :  Arts Design And Innovation | การออกแบบศิลปะและนวัตกรรม | 艺术设计与创新"
    },
    {
        "id":10105,
        "name":"10614 (Thai Program)  :  Performance Art Design And Innovation | การออกแบบศิลปะการแสดงและนวัตกรรม | 行为艺术设计与创新"
    },
    {
        "id":10106,
        "name":"10615 (Thai Program)  :  Information Management And Digital Technology | การจัดการสารสนเทศและเทคโนโลยีดิจิทัล | 信息管理和数字技术"
    },
    {
        "id":10107,
        "name":"10616 (English Program)  :  Information And Digitial Technology Management | การจัดการข้อมูลและเทคโนโลยีดิจิทัล | 信息和数字技术管理"
    },
    {
        "id":10108,
        "name":"10617 (Thai Program)  :  Service Management | การจัดการการบริการ | 服务管理"
    },
    {
        "id":10109,
        "name":"10618 (Thai Program)  :  Public Administration | การจัดการรัฐกิจ | 公共行政"
    },
    {
        "id":10110,
        "name":"10619 (English Program)  :  Finance, Insurance And Risk Management | การเงิน การประกันภัย และการจัดการความเสี่ยง | 金融、保险和风险管理"
    },
    {
        "id":10111,
        "name":"10620 (Thai Program)  :  Finance, Insurance And Risk Management | การเงิน ประกันภัยและการจัดการความเสี่ยง | 金融、保险和风险管理"
    },
    {
        "id":10112,
        "name":"10621 (Thai Program)  :  Environmental Geo-Informatics Technology | เทคโนโลยีภูมิสารสนเทศสิ่งแวดล้อม | 环境地理信息技术"
    },
    {
        "id":10113,
        "name":"10622 (English Program)  :  Environmental Geoinformatics Technology | เทคโนโลยีภูมิสารสนเทศสิ่งแวดล้อม | 环境地理信息技术"
    },
    {
        "id":10114,
        "name":"10623 (Thai Program)  :  International Studies | นานาชาติศึกษา | 国际研究"
    },
    {
        "id":10115,
        "name":"10624 (Thai Program)  :  Creative Media And Digital Technology | สื่อสร้างสรรค์และเทคโนโลยีดิจิทัล | 创意媒体和数字技术"
    },
    {
        "id":10116,
        "name":"10625 (English Program)  :  Creative Media And Digital Technologie | สื่อสร้างสรรค์และเทคโนโลยีดิจิทัล | 创意媒体和数字技术"
    },
    {
        "id":10117,
        "name":"10626 (Thai Program)  :  Community Studies For Sustainable Development | ชุมชนศึกษาเพื่อการพัฒนาที่ยั่งยืน | 可持续发展的社区研究"
    },
    {
        "id":10118,
        "name":"10627 (English Program)  :  Community Studies For Sustainable Development | การศึกษาชุมชนเพื่อการพัฒนาที่ยั่งยืน | 可持续发展社区研究"
    },
    {
        "id":10119,
        "name":"10628 (Thai Program)  :  Agricultural Business Economics And Management | เศรษฐศาสตร์ธุรกิจเกษตรและการจัดการ | 农业企业经济与管理"
    },
    {
        "id":10120,
        "name":"10629 (English Program)  :  Agribusiness Economics And Management | เศรษฐศาสตร์ธุรกิจการเกษตรและการจัดการ | 农业企业经济与管理"
    },
    {
        "id":10121,
        "name":"10630 (Thai Program)  :  Mining And Materials Engineering | วิศวกรรมเหมืองแร่และวัสดุ | 采矿与材料工程"
    },
    {
        "id":10122,
        "name":"10631 (English Program)  :  Mining And Materials Engineering | วิศวกรรมเหมืองแร่และวัสดุ | 采矿和材料工程"
    },
    {
        "id":10123,
        "name":"10632 (Thai Program)  :  Management And Entrepreneurship | การจัดการและความเป็นผู้ประกอบการ | 管理与创业"
    },
    {
        "id":10124,
        "name":"10633 (Thai Program)  :  Computer | การคอมพิวเตอร์ | 电脑"
    },
    {
        "id":10125,
        "name":"10634 (Thai Program)  :  Malay Language And Malay Studies | ภาษามลายูและมลายูศึกษา | 马来语言和马来研究"
    },
    {
        "id":10126,
        "name":"10635 (English Program)  :  Malay Language And Malay Studies | ภาษามลายูและการศึกษาภาษามลายู | 马来语和马来语研究"
    },
    {
        "id":10127,
        "name":"10636 (Thai Program)  :  Arabic For Business | ภาษาอาหรับเพื่อธุรกิจ | 商务阿拉伯语"
    },
    {
        "id":10128,
        "name":"10637 (English Program)  :  Arabic For Business | ภาษาอาหรับเพื่อธุรกิจ | 商务阿拉伯语"
    },
    {
        "id":10129,
        "name":"10638 (Thai Program)  :  European Languages ​​For International Communication | ภาษายุโรปเพื่อการสื่อสารสากล | 用于国际交流的欧洲语言"
    },
    {
        "id":10130,
        "name":"10639 (English Program)  :  European Languages For International Communication | ภาษายุโรปเพื่อการสื่อสารระหว่างประเทศ | 国际交流欧洲语言"
    },
    {
        "id":10131,
        "name":"10640 (Thai Program)  :  Food Industry Technology And Management | เทคโนโลยีและการจัดการอุตสาหกรรมอาหาร | 食品工业技术与管理"
    },
    {
        "id":10132,
        "name":"10641 (English Program)  :  Food Industrial Technology And Management | เทคโนโลยีและการจัดการอุตสาหกรรมอาหาร | 食品工业技术与管理"
    },
    {
        "id":10133,
        "name":"10642 (Thai Program)  :  Applied Chemistry-Biology | เคมี-ชีววิทยาประยุกต์ | 应用化学-生物学"
    },
    {
        "id":10134,
        "name":"10643 (English Program)  :  Applied Chemistry-Biology | เคมีประยุกต์-ชีววิทยา | 应用化学生物学"
    },
    {
        "id":10135,
        "name":"10644 (Thai Program)  :  Packaging Technology And Materials | เทคโนโลยีบรรจุภัณฑ์และวัสดุ | 封装技术与材料"
    },
    {
        "id":10136,
        "name":"10645 (English Program)  :  Packaging And Materials Technology | เทคโนโลยีบรรจุภัณฑ์และวัสดุ | 包装和材料技术"
    },
    {
        "id":10137,
        "name":"10646 (Thai Program)  :  Material Industry Management Technology | เทคโนโลยีการจัดการอุตสาหกรรมวัสดุ | 材料工业管理技术"
    },
    {
        "id":10138,
        "name":"10647 (English Program)  :  Material Technology And Industrial Management | เทคโนโลยีวัสดุและการจัดการอุตสาหกรรม | 材料技术与工业管理"
    },
    {
        "id":10139,
        "name":"10648 (Thai Program)  :  Nutrition And Dietetics | โภชนศาสตร์และการกำหนดอาหาร | 营养与饮食学"
    },
    {
        "id":10140,
        "name":"10649 (Thai Program)  :  Islamic Business Innovation | นวัตกรรมธุรกิจอิสลาม | 伊斯兰商业创新"
    },
    {
        "id":10141,
        "name":"10650 (English Program)  :  Islamic Business Innovation | นวัตกรรมธุรกิจอิสลาม | 伊斯兰商业创新"
    },
    {
        "id":10142,
        "name":"10651 (Thai Program)  :  Islamic Studies And Islamic Law | อิสลามศึกษาและกฎหมายอิสลาม | 伊斯兰研究和伊斯兰法"
    },
    {
        "id":10143,
        "name":"10652 (English Program)  :  Islamic Studies And Islamic Laws | การศึกษาอิสลามและกฎหมายอิสลาม | 伊斯兰研究和伊斯兰法"
    },
    {
        "id":10144,
        "name":"10653 (Thai Program)  :  The Art Of Thinking For Human Development | ศิลปะการคิดเพื่อการพัฒนามนุษย์ | 人类发展的思维艺术"
    },
    {
        "id":10145,
        "name":"10654 (English Program)  :  Art Of Thinking For Human Development | ศิลปะแห่งการคิดเพื่อการพัฒนามนุษย์ | 人类发展的思维艺术"
    },
    {
        "id":10146,
        "name":"10655 (English Program)  :  Innovation Management For Business Development | การจัดการนวัตกรรมเพื่อการพัฒนาธุรกิจ | 业务发展的创新管理"
    },
    {
        "id":10147,
        "name":"10656 (Thai Program)  :  One Health Science | วิทยาศาสตร์สุขภาพหนึ่งเดียว | 一门健康科学"
    },
    {
        "id":10148,
        "name":"10657 (English Program)  :  One Health Sciences | วิทยาศาสตร์สุขภาพหนึ่งเดียว | 一健康科学"
    },
    {
        "id":10149,
        "name":"10658 (Thai Program)  :  Science And Innovation For Animal Health | วิทยาศาสตร์และนวัตกรรมเพื่อสุขภาพสัตว์ | 动物健康的科学与创新"
    },
    {
        "id":10150,
        "name":"10659 (English Program)  :  Science And Innovation For Animal Health | วิทยาศาสตร์และนวัตกรรมเพื่อสุขภาพสัตว์ | 动物健康的科学与创新"
    },
    {
        "id":10151,
        "name":"10660 (Thai Program)  :  Information Technology And Educational Assessment | เทคโนโลยีสารสนเทศและการประเมินทางการศึกษา | 信息技术和教育评估"
    },
    {
        "id":10152,
        "name":"10661 (English Program)  :  Information Technology And Educational Evaluation | เทคโนโลยีสารสนเทศและการประเมินการศึกษา | 信息技术与教育评估"
    },
    {
        "id":10153,
        "name":"10662 (Thai Program)  :  Green Industrial Chemicals | เคมีอุตสาหกรรมสีเขียว | 绿色工业化学品"
    },
    {
        "id":10154,
        "name":"10663 (English Program)  :  Green Industrial Chemistry | เคมีอุตสาหกรรมสีเขียว | 绿色工业化学"
    },
    {
        "id":10155,
        "name":"10664 (Thai Program)  :  Science-Mathematics Learning Management | การจัดการเรียนรู้วิทยาศาสตร์-คณิตศาสตร์ | 科学数学学习管理"
    },
    {
        "id":10156,
        "name":"10665 (English Program)  :  Science-Mathematics Learning Management | การจัดการเรียนรู้วิทยาศาสตร์-คณิตศาสตร์ | 科学数学学习管理"
    },
    {
        "id":10157,
        "name":"10666 (Thai Program)  :  Mathematics And Computer Science | คณิตศาสตร์และวิทยาการคอมพิวเตอร์ | 数学与计算机科学"
    },
    {
        "id":10158,
        "name":"10667 (English Program)  :  Mathematics And Computer Science | คณิตศาสตร์และวิทยาศาสตร์คอมพิวเตอร์ | 数学和计算机科学"
    },
    {
        "id":10159,
        "name":"10668 (Thai Program)  :  Fishery Technology And Innovation | เทคโนโลยีและนวัตกรรมประมง | 渔业技术与创新"
    },
    {
        "id":10160,
        "name":"10669 (English Program)  :  Fishery Technology And Innovation | เทคโนโลยีและนวัตกรรมการประมง | 渔业技术与创新"
    },
    {
        "id":10161,
        "name":"10670 (Thai Program)  :  Language Teaching | การสอนภาษา | 语言教学"
    },
    {
        "id":10162,
        "name":"10671 (Thai Program)  :  Applied Mathematics And Mathematics Teaching Innovations | คณิตศาสตร์ประยุกต์และนวัตกรรมการสอนคณิตศาสตร์ | 应用数学与数学教学创新"
    },
    {
        "id":10163,
        "name":"10672 (English Program)  :  Applied Mathematics And Innovation In Mathematics Teaching | คณิตศาสตร์ประยุกต์และนวัตกรรมการสอนคณิตศาสตร์ | 应用数学与数学教学创新"
    },
    {
        "id":10164,
        "name":"10673 (Thai Program)  :  Research Methodology And Data Analysis | วิธีวิทยาการวิจัยและการวิเคราะห์ข้อมูล | 研究方法和数据分析"
    },
    {
        "id":10165,
        "name":"10674 (English Program)  :  Research Methodology And Data Analytics | วิธีการวิจัยและการวิเคราะห์ข้อมูล | 研究方法和数据分析"
    },
    {
        "id":10166,
        "name":"10675 (Thai Program)  :  Food Industry Technology Management | การจัดการเทคโนโลยีอุตสาหกรรมอาหาร | 食品工业技术管理"
    },
    {
        "id":10167,
        "name":"10676 (English Program)  :  Food Industry Technology Management | การจัดการเทคโนโลยีอุตสาหกรรมอาหาร | 食品工业技术管理"
    },
    {
        "id":10168,
        "name":"10677 (Thai Program)  :  Innovative Food Science And Nutrition | วิทยาศาสตร์การอาหารและโภชนาการเชิงนวัตกรรม | 创新食品科学和营养"
    },
    {
        "id":10169,
        "name":"10678 (English Program)  :  Innovative Food Science And Nutrition | นวัตกรรมวิทยาศาสตร์การอาหารและโภชนาการ | 创新食品科学和营养"
    },
    {
        "id":10170,
        "name":"10679 (Thai Program)  :  Islamic Studies And Muslim Studies | อิสลามศึกษาและมุสลิมศึกษา | 伊斯兰研究和穆斯林研究"
    },
    {
        "id":10171,
        "name":"10680 (English Program)  :  Islamic And Muslim Studies | การศึกษาอิสลามและมุสลิม | 伊斯兰和穆斯林研究"
    },
    {
        "id":10172,
        "name":"10681 (English Program)  :  Marine And Coastal Resources Management | การจัดการทรัพยากรทางทะเลและชายฝั่ง | 海洋和沿海资源管理"
    },
    {
        "id":10173,
        "name":"10682 (Thai Program)  :  Innovation And Transformation Into The Digital Age | นวัตกรรมและการเปลี่ยนแปลงสู่ยุคดิจิทัล | 数字时代的创新与转型"
    },
    {
        "id":10174,
        "name":"10683 (English Program)  :  Innovation And Digital Transformation | นวัตกรรมและการเปลี่ยนแปลงทางดิจิทัล | 创新与数字化转型"
    },
    {
        "id":10175,
        "name":"10684 (English Program)  :  Industrial And Systems Engineering | วิศวกรรมอุตสาหการและระบบ | 工业与系统工程"
    },
    {
        "id":10176,
        "name":"10685 (English Program)  :  Soil Resource Management | การจัดการทรัพยากรดิน | 土壤资源管理"
    },
    {
        "id":10177,
        "name":"10686 (English Program)  :  Technology And Environmental Management | การจัดการเทคโนโลยีและสิ่งแวดล้อม | 技术与环境管理"
    },
    {
        "id":10178,
        "name":"10687 (Thai Program)  :  Thai Language And Simplified Thai Language | ภาษาไทยและภาษาไทยประยุกต์ | 泰语和简体泰语"
    },
    {
        "id":10179,
        "name":"10688 (English Program)  :  Thai And Applied Thai | ไทยและไทยประยุกต์ | 泰语和应用泰语"
    },
    {
        "id":10180,
        "name":"10689 (English Program)  :  Agricultural Science And Technology | วิทยาศาสตร์และเทคโนโลยีการเกษตร | 农业科技"
    },
    {
        "id":10181,
        "name":"10690 (Thai Program)  :  Applied English Studies | ภาษาอังกฤษประยุกต์ศึกษา | 应用英语研究"
    },
    {
        "id":10182,
        "name":"10691 (English Program)  :  Applied English Language Studies | การศึกษาภาษาอังกฤษประยุกต์ | 应用英语语言研究"
    },
    {
        "id":10183,
        "name":"10692 (English Program)  :  Conflict And Peace Studies | การศึกษาความขัดแย้งและสันติภาพ | 冲突与和平研究"
    },
    {
        "id":10184,
        "name":"10693 (Thai Program)  :  Fishery Resources | ทรัพยากรประมง | 渔业资源"
    },
    {
        "id":10185,
        "name":"10694 (English Program)  :  Fishery Resources | ทรัพยากรประมง | 渔业资源"
    },
    {
        "id":10186,
        "name":"10695 (Thai Program)  :  Sustainable Energy Management | การจัดการพลังงานอย่างยั่งยืน | 可持续能源管理"
    },
    {
        "id":10187,
        "name":"10696 (English Program)  :  Sustainable Energy Management | การจัดการพลังงานอย่างยั่งยืน | 可持续能源管理"
    }
];

module.exports = programs;